
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire64bc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire64bc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iny3D", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d614cb1a4ab1a89d$export$ffb0004e005737fa, (v) => $d614cb1a4ab1a89d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d614cb1a4ab1a89d$export$34b9dba7ce09269b, (v) => $d614cb1a4ab1a89d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d614cb1a4ab1a89d$export$25062201e9e25d76, (v) => $d614cb1a4ab1a89d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d614cb1a4ab1a89d$export$ffb0004e005737fa;
var $d614cb1a4ab1a89d$export$34b9dba7ce09269b;
var $d614cb1a4ab1a89d$export$25062201e9e25d76;
"use strict";
var $d614cb1a4ab1a89d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d614cb1a4ab1a89d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $d614cb1a4ab1a89d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $d614cb1a4ab1a89d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$d614cb1a4ab1a89d$export$ffb0004e005737fa = $d614cb1a4ab1a89d$var$REACT_FRAGMENT_TYPE;
$d614cb1a4ab1a89d$export$34b9dba7ce09269b = $d614cb1a4ab1a89d$var$jsxProd;
$d614cb1a4ab1a89d$export$25062201e9e25d76 = $d614cb1a4ab1a89d$var$jsxProd;

});

parcelRegister("dPQG5", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $a128e67978253198$export$9c16c1426311996d, (v) => $a128e67978253198$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $a128e67978253198$export$dca3b0875bd9a954, (v) => $a128e67978253198$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $a128e67978253198$export$16fa2f45be04daa8, (v) => $a128e67978253198$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $a128e67978253198$export$ffb0004e005737fa, (v) => $a128e67978253198$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $a128e67978253198$export$e2c29f18771995cb, (v) => $a128e67978253198$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $a128e67978253198$export$221d75b3f55bb0bd, (v) => $a128e67978253198$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $a128e67978253198$export$5f8d39834fd61797, (v) => $a128e67978253198$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a128e67978253198$export$74bf444e3cd11ea5, (v) => $a128e67978253198$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $a128e67978253198$export$1ced07cd6b1985ce, (v) => $a128e67978253198$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $a128e67978253198$export$abd8e32b826d7ea7, (v) => $a128e67978253198$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $a128e67978253198$export$69a3209f1a06c04d, (v) => $a128e67978253198$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $a128e67978253198$export$8c538325882c7eec, (v) => $a128e67978253198$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $a128e67978253198$export$e530037191fcd5d7, (v) => $a128e67978253198$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $a128e67978253198$export$fd42f52fd3ae1109, (v) => $a128e67978253198$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $a128e67978253198$export$c8a8987d4410bf2d, (v) => $a128e67978253198$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $a128e67978253198$export$7d1e3a5e95ceca43, (v) => $a128e67978253198$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $a128e67978253198$export$257a8862b851cb5b, (v) => $a128e67978253198$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $a128e67978253198$export$a8257692ac88316c, (v) => $a128e67978253198$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $a128e67978253198$export$488013bae63b21da, (v) => $a128e67978253198$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $a128e67978253198$export$7c73462e0d25e514, (v) => $a128e67978253198$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $a128e67978253198$export$7568632d0d33d16d, (v) => $a128e67978253198$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $a128e67978253198$export$f93f40ac0ca7e3a8, (v) => $a128e67978253198$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $a128e67978253198$export$1f96ae73734a86cc, (v) => $a128e67978253198$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $a128e67978253198$export$9a47ced3238df325, (v) => $a128e67978253198$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $a128e67978253198$export$35808ee640e87ca7, (v) => $a128e67978253198$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $a128e67978253198$export$fae74005e78b1a27, (v) => $a128e67978253198$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $a128e67978253198$export$dc8fbce3eb94dc1e, (v) => $a128e67978253198$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $a128e67978253198$export$6a7bc4e911dc01cf, (v) => $a128e67978253198$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $a128e67978253198$export$6d9c69b0de29b591, (v) => $a128e67978253198$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $a128e67978253198$export$7f54fc3180508a52, (v) => $a128e67978253198$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $a128e67978253198$export$f680877a34711e37, (v) => $a128e67978253198$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $a128e67978253198$export$d5a552a76deda3c2, (v) => $a128e67978253198$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $a128e67978253198$export$aaabe4eda9ed9969, (v) => $a128e67978253198$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $a128e67978253198$export$e5c5a5f917a5871c, (v) => $a128e67978253198$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $a128e67978253198$export$1538c33de8887b59, (v) => $a128e67978253198$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $a128e67978253198$export$fca7f784ae7a249a, (v) => $a128e67978253198$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $a128e67978253198$export$13e3392192263954, (v) => $a128e67978253198$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $a128e67978253198$export$b8f5890fc79d6aca, (v) => $a128e67978253198$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $a128e67978253198$export$60241385465d0a34, (v) => $a128e67978253198$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $a128e67978253198$export$306c0aa65ff9ec16, (v) => $a128e67978253198$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $a128e67978253198$export$7b286972b8d8ccbf, (v) => $a128e67978253198$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $a128e67978253198$export$83d89fbfd8236492, (v) => $a128e67978253198$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a128e67978253198$export$9c16c1426311996d;
var $a128e67978253198$export$dca3b0875bd9a954;
var $a128e67978253198$export$16fa2f45be04daa8;
var $a128e67978253198$export$ffb0004e005737fa;
var $a128e67978253198$export$e2c29f18771995cb;
var $a128e67978253198$export$221d75b3f55bb0bd;
var $a128e67978253198$export$5f8d39834fd61797;
var $a128e67978253198$export$74bf444e3cd11ea5;
var $a128e67978253198$export$1ced07cd6b1985ce;
var $a128e67978253198$export$abd8e32b826d7ea7;
var $a128e67978253198$export$69a3209f1a06c04d;
var $a128e67978253198$export$8c538325882c7eec;
var $a128e67978253198$export$e530037191fcd5d7;
var $a128e67978253198$export$fd42f52fd3ae1109;
var $a128e67978253198$export$c8a8987d4410bf2d;
var $a128e67978253198$export$7d1e3a5e95ceca43;
var $a128e67978253198$export$257a8862b851cb5b;
var $a128e67978253198$export$a8257692ac88316c;
var $a128e67978253198$export$488013bae63b21da;
var $a128e67978253198$export$7c73462e0d25e514;
var $a128e67978253198$export$7568632d0d33d16d;
var $a128e67978253198$export$f93f40ac0ca7e3a8;
var $a128e67978253198$export$1f96ae73734a86cc;
var $a128e67978253198$export$9a47ced3238df325;
var $a128e67978253198$export$35808ee640e87ca7;
var $a128e67978253198$export$fae74005e78b1a27;
var $a128e67978253198$export$dc8fbce3eb94dc1e;
var $a128e67978253198$export$6a7bc4e911dc01cf;
var $a128e67978253198$export$6d9c69b0de29b591;
var $a128e67978253198$export$7f54fc3180508a52;
var $a128e67978253198$export$f680877a34711e37;
var $a128e67978253198$export$d5a552a76deda3c2;
var $a128e67978253198$export$aaabe4eda9ed9969;
var $a128e67978253198$export$e5c5a5f917a5871c;
var $a128e67978253198$export$1538c33de8887b59;
var $a128e67978253198$export$fca7f784ae7a249a;
var $a128e67978253198$export$13e3392192263954;
var $a128e67978253198$export$b8f5890fc79d6aca;
var $a128e67978253198$export$60241385465d0a34;
var $a128e67978253198$export$306c0aa65ff9ec16;
var $a128e67978253198$export$7b286972b8d8ccbf;
var $a128e67978253198$export$83d89fbfd8236492;
"use strict";
var $a128e67978253198$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $a128e67978253198$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $a128e67978253198$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $a128e67978253198$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $a128e67978253198$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $a128e67978253198$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $a128e67978253198$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $a128e67978253198$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $a128e67978253198$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $a128e67978253198$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $a128e67978253198$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $a128e67978253198$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $a128e67978253198$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $a128e67978253198$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $a128e67978253198$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$a128e67978253198$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $a128e67978253198$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $a128e67978253198$var$assign = Object.assign, $a128e67978253198$var$emptyObject = {};
function $a128e67978253198$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $a128e67978253198$var$emptyObject;
    this.updater = updater || $a128e67978253198$var$ReactNoopUpdateQueue;
}
$a128e67978253198$var$Component.prototype.isReactComponent = {};
$a128e67978253198$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$a128e67978253198$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $a128e67978253198$var$ComponentDummy() {}
$a128e67978253198$var$ComponentDummy.prototype = $a128e67978253198$var$Component.prototype;
function $a128e67978253198$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $a128e67978253198$var$emptyObject;
    this.updater = updater || $a128e67978253198$var$ReactNoopUpdateQueue;
}
var $a128e67978253198$var$pureComponentPrototype = $a128e67978253198$var$PureComponent.prototype = new $a128e67978253198$var$ComponentDummy();
$a128e67978253198$var$pureComponentPrototype.constructor = $a128e67978253198$var$PureComponent;
$a128e67978253198$var$assign($a128e67978253198$var$pureComponentPrototype, $a128e67978253198$var$Component.prototype);
$a128e67978253198$var$pureComponentPrototype.isPureReactComponent = !0;
var $a128e67978253198$var$isArrayImpl = Array.isArray;
function $a128e67978253198$var$noop() {}
var $a128e67978253198$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $a128e67978253198$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $a128e67978253198$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $a128e67978253198$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $a128e67978253198$var$cloneAndReplaceKey(oldElement, newKey) {
    return $a128e67978253198$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $a128e67978253198$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $a128e67978253198$var$REACT_ELEMENT_TYPE;
}
function $a128e67978253198$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $a128e67978253198$var$userProvidedKeyEscapeRegex = /\/+/g;
function $a128e67978253198$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $a128e67978253198$var$escape("" + element.key) : index.toString(36);
}
function $a128e67978253198$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($a128e67978253198$var$noop, $a128e67978253198$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $a128e67978253198$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $a128e67978253198$var$REACT_ELEMENT_TYPE:
                case $a128e67978253198$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $a128e67978253198$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $a128e67978253198$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $a128e67978253198$var$getElementKey(children, 0) : nameSoFar, $a128e67978253198$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($a128e67978253198$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $a128e67978253198$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($a128e67978253198$var$isValidElement(callback) && (callback = $a128e67978253198$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($a128e67978253198$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($a128e67978253198$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $a128e67978253198$var$getElementKey(nameSoFar, i), invokeCallback += $a128e67978253198$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $a128e67978253198$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $a128e67978253198$var$getElementKey(nameSoFar, i++), invokeCallback += $a128e67978253198$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $a128e67978253198$var$mapIntoArray($a128e67978253198$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $a128e67978253198$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $a128e67978253198$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $a128e67978253198$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $a128e67978253198$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $a128e67978253198$var$Children = {
    map: $a128e67978253198$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $a128e67978253198$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $a128e67978253198$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $a128e67978253198$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$a128e67978253198$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$a128e67978253198$export$9c16c1426311996d = $a128e67978253198$var$REACT_ACTIVITY_TYPE;
$a128e67978253198$export$dca3b0875bd9a954 = $a128e67978253198$var$Children;
$a128e67978253198$export$16fa2f45be04daa8 = $a128e67978253198$var$Component;
$a128e67978253198$export$ffb0004e005737fa = $a128e67978253198$var$REACT_FRAGMENT_TYPE;
$a128e67978253198$export$e2c29f18771995cb = $a128e67978253198$var$REACT_PROFILER_TYPE;
$a128e67978253198$export$221d75b3f55bb0bd = $a128e67978253198$var$PureComponent;
$a128e67978253198$export$5f8d39834fd61797 = $a128e67978253198$var$REACT_STRICT_MODE_TYPE;
$a128e67978253198$export$74bf444e3cd11ea5 = $a128e67978253198$var$REACT_SUSPENSE_TYPE;
$a128e67978253198$export$1ced07cd6b1985ce = $a128e67978253198$var$ReactSharedInternals;
$a128e67978253198$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $a128e67978253198$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$a128e67978253198$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$a128e67978253198$export$8c538325882c7eec = function() {
    return null;
};
$a128e67978253198$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $a128e67978253198$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$a128e67978253198$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $a128e67978253198$var$ReactElement(element.type, key, props);
};
$a128e67978253198$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $a128e67978253198$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $a128e67978253198$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$a128e67978253198$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$a128e67978253198$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $a128e67978253198$var$ReactElement(type, key, props);
};
$a128e67978253198$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$a128e67978253198$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $a128e67978253198$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$a128e67978253198$export$a8257692ac88316c = $a128e67978253198$var$isValidElement;
$a128e67978253198$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $a128e67978253198$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $a128e67978253198$var$lazyInitializer
    };
};
$a128e67978253198$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $a128e67978253198$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$a128e67978253198$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $a128e67978253198$var$ReactSharedInternals.T, currentTransition = {};
    $a128e67978253198$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $a128e67978253198$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($a128e67978253198$var$noop, $a128e67978253198$var$reportGlobalError);
    } catch (error) {
        $a128e67978253198$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $a128e67978253198$var$ReactSharedInternals.T = prevTransition;
    }
};
$a128e67978253198$export$f93f40ac0ca7e3a8 = function() {
    return $a128e67978253198$var$ReactSharedInternals.H.useCacheRefresh();
};
$a128e67978253198$export$1f96ae73734a86cc = function(usable) {
    return $a128e67978253198$var$ReactSharedInternals.H.use(usable);
};
$a128e67978253198$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $a128e67978253198$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$a128e67978253198$export$35808ee640e87ca7 = function(callback, deps) {
    return $a128e67978253198$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$a128e67978253198$export$fae74005e78b1a27 = function(Context) {
    return $a128e67978253198$var$ReactSharedInternals.H.useContext(Context);
};
$a128e67978253198$export$dc8fbce3eb94dc1e = function() {};
$a128e67978253198$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $a128e67978253198$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$a128e67978253198$export$6d9c69b0de29b591 = function(create, deps) {
    return $a128e67978253198$var$ReactSharedInternals.H.useEffect(create, deps);
};
$a128e67978253198$export$7f54fc3180508a52 = function(callback) {
    return $a128e67978253198$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$a128e67978253198$export$f680877a34711e37 = function() {
    return $a128e67978253198$var$ReactSharedInternals.H.useId();
};
$a128e67978253198$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $a128e67978253198$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$a128e67978253198$export$aaabe4eda9ed9969 = function(create, deps) {
    return $a128e67978253198$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$a128e67978253198$export$e5c5a5f917a5871c = function(create, deps) {
    return $a128e67978253198$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$a128e67978253198$export$1538c33de8887b59 = function(create, deps) {
    return $a128e67978253198$var$ReactSharedInternals.H.useMemo(create, deps);
};
$a128e67978253198$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $a128e67978253198$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$a128e67978253198$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $a128e67978253198$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$a128e67978253198$export$b8f5890fc79d6aca = function(initialValue) {
    return $a128e67978253198$var$ReactSharedInternals.H.useRef(initialValue);
};
$a128e67978253198$export$60241385465d0a34 = function(initialState) {
    return $a128e67978253198$var$ReactSharedInternals.H.useState(initialState);
};
$a128e67978253198$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $a128e67978253198$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$a128e67978253198$export$7b286972b8d8ccbf = function() {
    return $a128e67978253198$var$ReactSharedInternals.H.useTransition();
};
$a128e67978253198$export$83d89fbfd8236492 = "19.2.8";

});

parcelRegister("dflA0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lNqgI = parcelRequire("lNqgI");
function $9a4d6a57aaaab11e$var$emptyFunction() {}
function $9a4d6a57aaaab11e$var$emptyFunctionWithReset() {}
$9a4d6a57aaaab11e$var$emptyFunctionWithReset.resetWarningCache = $9a4d6a57aaaab11e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lNqgI) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9a4d6a57aaaab11e$var$emptyFunctionWithReset,
        resetWarningCache: $9a4d6a57aaaab11e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lNqgI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fde28cfe61c36500$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fde28cfe61c36500$var$ReactPropTypesSecret;

});


parcelRegister("iSm9w", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $dbde7433bdfc5c25$export$69ce8ef3fe5cead0, (v) => $dbde7433bdfc5c25$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $dbde7433bdfc5c25$export$d39a5bbd09211389, (v) => $dbde7433bdfc5c25$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $dbde7433bdfc5c25$export$cd75ccfd720a3cd4, (v) => $dbde7433bdfc5c25$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $dbde7433bdfc5c25$export$a0816fa17a9e79be, (v) => $dbde7433bdfc5c25$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $dbde7433bdfc5c25$export$7292efcadded39f3, (v) => $dbde7433bdfc5c25$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $dbde7433bdfc5c25$export$da407abadb9b8f86, (v) => $dbde7433bdfc5c25$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $dbde7433bdfc5c25$export$314cfea32580671c, (v) => $dbde7433bdfc5c25$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $dbde7433bdfc5c25$export$513ccb98c53b8039, (v) => $dbde7433bdfc5c25$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $dbde7433bdfc5c25$export$dbca993bc2d264a, (v) => $dbde7433bdfc5c25$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $dbde7433bdfc5c25$export$4797a8006f0655d0, (v) => $dbde7433bdfc5c25$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $dbde7433bdfc5c25$export$c78a37762a8d58e1, (v) => $dbde7433bdfc5c25$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $dbde7433bdfc5c25$export$606f11b2eb45ecc6, (v) => $dbde7433bdfc5c25$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $dbde7433bdfc5c25$export$f7e8a0bf92324b1e, (v) => $dbde7433bdfc5c25$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $dbde7433bdfc5c25$export$83d89fbfd8236492, (v) => $dbde7433bdfc5c25$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dbde7433bdfc5c25$export$69ce8ef3fe5cead0;
var $dbde7433bdfc5c25$export$d39a5bbd09211389;
var $dbde7433bdfc5c25$export$cd75ccfd720a3cd4;
var $dbde7433bdfc5c25$export$a0816fa17a9e79be;
var $dbde7433bdfc5c25$export$7292efcadded39f3;
var $dbde7433bdfc5c25$export$da407abadb9b8f86;
var $dbde7433bdfc5c25$export$314cfea32580671c;
var $dbde7433bdfc5c25$export$513ccb98c53b8039;
var $dbde7433bdfc5c25$export$dbca993bc2d264a;
var $dbde7433bdfc5c25$export$4797a8006f0655d0;
var $dbde7433bdfc5c25$export$c78a37762a8d58e1;
var $dbde7433bdfc5c25$export$606f11b2eb45ecc6;
var $dbde7433bdfc5c25$export$f7e8a0bf92324b1e;
var $dbde7433bdfc5c25$export$83d89fbfd8236492;
"use strict";

var $7DB8U = parcelRequire("7DB8U");
function $dbde7433bdfc5c25$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dbde7433bdfc5c25$var$noop() {}
var $dbde7433bdfc5c25$var$Internals = {
    d: {
        f: $dbde7433bdfc5c25$var$noop,
        r: function() {
            throw Error($dbde7433bdfc5c25$var$formatProdErrorMessage(522));
        },
        D: $dbde7433bdfc5c25$var$noop,
        C: $dbde7433bdfc5c25$var$noop,
        L: $dbde7433bdfc5c25$var$noop,
        m: $dbde7433bdfc5c25$var$noop,
        X: $dbde7433bdfc5c25$var$noop,
        S: $dbde7433bdfc5c25$var$noop,
        M: $dbde7433bdfc5c25$var$noop
    },
    p: 0,
    findDOMNode: null
}, $dbde7433bdfc5c25$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $dbde7433bdfc5c25$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $dbde7433bdfc5c25$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $dbde7433bdfc5c25$var$ReactSharedInternals = $7DB8U.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $dbde7433bdfc5c25$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$dbde7433bdfc5c25$export$69ce8ef3fe5cead0 = $dbde7433bdfc5c25$var$Internals;
$dbde7433bdfc5c25$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($dbde7433bdfc5c25$var$formatProdErrorMessage(299));
    return $dbde7433bdfc5c25$var$createPortal$1(children, container, null, key);
};
$dbde7433bdfc5c25$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $dbde7433bdfc5c25$var$ReactSharedInternals.T, previousUpdatePriority = $dbde7433bdfc5c25$var$Internals.p;
    try {
        if ($dbde7433bdfc5c25$var$ReactSharedInternals.T = null, $dbde7433bdfc5c25$var$Internals.p = 2, fn) return fn();
    } finally{
        $dbde7433bdfc5c25$var$ReactSharedInternals.T = previousTransition, $dbde7433bdfc5c25$var$Internals.p = previousUpdatePriority, $dbde7433bdfc5c25$var$Internals.d.f();
    }
};
$dbde7433bdfc5c25$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $dbde7433bdfc5c25$var$Internals.d.C(href, options));
};
$dbde7433bdfc5c25$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $dbde7433bdfc5c25$var$Internals.d.D(href);
};
$dbde7433bdfc5c25$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $dbde7433bdfc5c25$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $dbde7433bdfc5c25$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $dbde7433bdfc5c25$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$dbde7433bdfc5c25$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $dbde7433bdfc5c25$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $dbde7433bdfc5c25$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $dbde7433bdfc5c25$var$Internals.d.M(href);
    }
};
$dbde7433bdfc5c25$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $dbde7433bdfc5c25$var$getCrossOriginStringAs(as, options.crossOrigin);
        $dbde7433bdfc5c25$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$dbde7433bdfc5c25$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $dbde7433bdfc5c25$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $dbde7433bdfc5c25$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $dbde7433bdfc5c25$var$Internals.d.m(href);
    }
};
$dbde7433bdfc5c25$export$4797a8006f0655d0 = function(form) {
    $dbde7433bdfc5c25$var$Internals.d.r(form);
};
$dbde7433bdfc5c25$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$dbde7433bdfc5c25$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $dbde7433bdfc5c25$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$dbde7433bdfc5c25$export$f7e8a0bf92324b1e = function() {
    return $dbde7433bdfc5c25$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$dbde7433bdfc5c25$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("7DB8U", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dPQG5"));

});


parcelRegister("40IcI", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $2eb97388ec83477c$export$882461b6382ed46c, (v) => $2eb97388ec83477c$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $2eb97388ec83477c$export$757ceba2d55c277e, (v) => $2eb97388ec83477c$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $2eb97388ec83477c$export$83d89fbfd8236492, (v) => $2eb97388ec83477c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $2eb97388ec83477c$export$882461b6382ed46c;
var $2eb97388ec83477c$export$757ceba2d55c277e;
var $2eb97388ec83477c$export$83d89fbfd8236492;
"use strict";

var $bIbqH = parcelRequire("bIbqH");

var $7DB8U = parcelRequire("7DB8U");

var $9lImh = parcelRequire("9lImh");
function $2eb97388ec83477c$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $2eb97388ec83477c$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $2eb97388ec83477c$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $2eb97388ec83477c$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $2eb97388ec83477c$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $2eb97388ec83477c$var$assertIsMounted(fiber) {
    if ($2eb97388ec83477c$var$getNearestMountedFiber(fiber) !== fiber) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(188));
}
function $2eb97388ec83477c$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $2eb97388ec83477c$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $2eb97388ec83477c$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $2eb97388ec83477c$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($2eb97388ec83477c$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $2eb97388ec83477c$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $2eb97388ec83477c$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $2eb97388ec83477c$var$assign = Object.assign, $2eb97388ec83477c$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $2eb97388ec83477c$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $2eb97388ec83477c$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $2eb97388ec83477c$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $2eb97388ec83477c$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $2eb97388ec83477c$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $2eb97388ec83477c$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $2eb97388ec83477c$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $2eb97388ec83477c$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $2eb97388ec83477c$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $2eb97388ec83477c$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $2eb97388ec83477c$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $2eb97388ec83477c$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $2eb97388ec83477c$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $2eb97388ec83477c$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $2eb97388ec83477c$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $2eb97388ec83477c$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $2eb97388ec83477c$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$2eb97388ec83477c$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $2eb97388ec83477c$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $2eb97388ec83477c$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $2eb97388ec83477c$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $2eb97388ec83477c$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $2eb97388ec83477c$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $2eb97388ec83477c$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $2eb97388ec83477c$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $2eb97388ec83477c$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $2eb97388ec83477c$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $2eb97388ec83477c$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $2eb97388ec83477c$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $2eb97388ec83477c$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $2eb97388ec83477c$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $2eb97388ec83477c$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $2eb97388ec83477c$var$getComponentNameFromType(type.type) || "Memo";
        case $2eb97388ec83477c$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $2eb97388ec83477c$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $2eb97388ec83477c$var$isArrayImpl = Array.isArray, $2eb97388ec83477c$var$ReactSharedInternals = $7DB8U.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $2eb97388ec83477c$var$ReactDOMSharedInternals = $9lImh.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $2eb97388ec83477c$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $2eb97388ec83477c$var$valueStack = [], $2eb97388ec83477c$var$index = -1;
function $2eb97388ec83477c$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $2eb97388ec83477c$var$pop(cursor) {
    0 > $2eb97388ec83477c$var$index || (cursor.current = $2eb97388ec83477c$var$valueStack[$2eb97388ec83477c$var$index], $2eb97388ec83477c$var$valueStack[$2eb97388ec83477c$var$index] = null, $2eb97388ec83477c$var$index--);
}
function $2eb97388ec83477c$var$push(cursor, value) {
    $2eb97388ec83477c$var$index++;
    $2eb97388ec83477c$var$valueStack[$2eb97388ec83477c$var$index] = cursor.current;
    cursor.current = value;
}
var $2eb97388ec83477c$var$contextStackCursor = $2eb97388ec83477c$var$createCursor(null), $2eb97388ec83477c$var$contextFiberStackCursor = $2eb97388ec83477c$var$createCursor(null), $2eb97388ec83477c$var$rootInstanceStackCursor = $2eb97388ec83477c$var$createCursor(null), $2eb97388ec83477c$var$hostTransitionProviderCursor = $2eb97388ec83477c$var$createCursor(null);
function $2eb97388ec83477c$var$pushHostContainer(fiber, nextRootInstance) {
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$rootInstanceStackCursor, nextRootInstance);
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$contextFiberStackCursor, fiber);
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $2eb97388ec83477c$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $2eb97388ec83477c$var$getOwnHostContext(nextRootInstance), fiber = $2eb97388ec83477c$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$contextStackCursor);
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$contextStackCursor, fiber);
}
function $2eb97388ec83477c$var$popHostContainer() {
    $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$contextStackCursor);
    $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$contextFiberStackCursor);
    $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$rootInstanceStackCursor);
}
function $2eb97388ec83477c$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $2eb97388ec83477c$var$push($2eb97388ec83477c$var$hostTransitionProviderCursor, fiber);
    var context = $2eb97388ec83477c$var$contextStackCursor.current;
    var JSCompiler_inline_result = $2eb97388ec83477c$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($2eb97388ec83477c$var$push($2eb97388ec83477c$var$contextFiberStackCursor, fiber), $2eb97388ec83477c$var$push($2eb97388ec83477c$var$contextStackCursor, JSCompiler_inline_result));
}
function $2eb97388ec83477c$var$popHostContext(fiber) {
    $2eb97388ec83477c$var$contextFiberStackCursor.current === fiber && ($2eb97388ec83477c$var$pop($2eb97388ec83477c$var$contextStackCursor), $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$contextFiberStackCursor));
    $2eb97388ec83477c$var$hostTransitionProviderCursor.current === fiber && ($2eb97388ec83477c$var$pop($2eb97388ec83477c$var$hostTransitionProviderCursor), $2eb97388ec83477c$var$HostTransitionContext._currentValue = $2eb97388ec83477c$var$sharedNotPendingObject);
}
var $2eb97388ec83477c$var$prefix, $2eb97388ec83477c$var$suffix;
function $2eb97388ec83477c$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $2eb97388ec83477c$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $2eb97388ec83477c$var$prefix = match && match[1] || "";
        $2eb97388ec83477c$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $2eb97388ec83477c$var$prefix + name + $2eb97388ec83477c$var$suffix;
}
var $2eb97388ec83477c$var$reentry = !1;
function $2eb97388ec83477c$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $2eb97388ec83477c$var$reentry) return "";
    $2eb97388ec83477c$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $2eb97388ec83477c$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $2eb97388ec83477c$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $2eb97388ec83477c$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $2eb97388ec83477c$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $2eb97388ec83477c$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $2eb97388ec83477c$var$describeBuiltInComponentFrame("Suspense Fallback") : $2eb97388ec83477c$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $2eb97388ec83477c$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $2eb97388ec83477c$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $2eb97388ec83477c$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $2eb97388ec83477c$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $2eb97388ec83477c$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $2eb97388ec83477c$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $2eb97388ec83477c$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $2eb97388ec83477c$var$hasOwnProperty = Object.prototype.hasOwnProperty, $2eb97388ec83477c$var$scheduleCallback$3 = $bIbqH.unstable_scheduleCallback, $2eb97388ec83477c$var$cancelCallback$1 = $bIbqH.unstable_cancelCallback, $2eb97388ec83477c$var$shouldYield = $bIbqH.unstable_shouldYield, $2eb97388ec83477c$var$requestPaint = $bIbqH.unstable_requestPaint, $2eb97388ec83477c$var$now = $bIbqH.unstable_now, $2eb97388ec83477c$var$getCurrentPriorityLevel = $bIbqH.unstable_getCurrentPriorityLevel, $2eb97388ec83477c$var$ImmediatePriority = $bIbqH.unstable_ImmediatePriority, $2eb97388ec83477c$var$UserBlockingPriority = $bIbqH.unstable_UserBlockingPriority, $2eb97388ec83477c$var$NormalPriority$1 = $bIbqH.unstable_NormalPriority, $2eb97388ec83477c$var$LowPriority = $bIbqH.unstable_LowPriority, $2eb97388ec83477c$var$IdlePriority = $bIbqH.unstable_IdlePriority, $2eb97388ec83477c$var$log$1 = $bIbqH.log, $2eb97388ec83477c$var$unstable_setDisableYieldValue = $bIbqH.unstable_setDisableYieldValue, $2eb97388ec83477c$var$rendererID = null, $2eb97388ec83477c$var$injectedHook = null;
function $2eb97388ec83477c$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $2eb97388ec83477c$var$log$1 && $2eb97388ec83477c$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($2eb97388ec83477c$var$injectedHook && "function" === typeof $2eb97388ec83477c$var$injectedHook.setStrictMode) try {
        $2eb97388ec83477c$var$injectedHook.setStrictMode($2eb97388ec83477c$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $2eb97388ec83477c$var$clz32 = Math.clz32 ? Math.clz32 : $2eb97388ec83477c$var$clz32Fallback, $2eb97388ec83477c$var$log = Math.log, $2eb97388ec83477c$var$LN2 = Math.LN2;
function $2eb97388ec83477c$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($2eb97388ec83477c$var$log(x) / $2eb97388ec83477c$var$LN2 | 0) | 0;
}
var $2eb97388ec83477c$var$nextTransitionUpdateLane = 256, $2eb97388ec83477c$var$nextTransitionDeferredLane = 262144, $2eb97388ec83477c$var$nextRetryLane = 4194304;
function $2eb97388ec83477c$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $2eb97388ec83477c$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $2eb97388ec83477c$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $2eb97388ec83477c$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $2eb97388ec83477c$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $2eb97388ec83477c$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $2eb97388ec83477c$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $2eb97388ec83477c$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $2eb97388ec83477c$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $2eb97388ec83477c$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $2eb97388ec83477c$var$claimNextRetryLane() {
    var lane = $2eb97388ec83477c$var$nextRetryLane;
    $2eb97388ec83477c$var$nextRetryLane <<= 1;
    0 === ($2eb97388ec83477c$var$nextRetryLane & 62914560) && ($2eb97388ec83477c$var$nextRetryLane = 4194304);
    return lane;
}
function $2eb97388ec83477c$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $2eb97388ec83477c$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $2eb97388ec83477c$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $2eb97388ec83477c$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $2eb97388ec83477c$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $2eb97388ec83477c$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $2eb97388ec83477c$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $2eb97388ec83477c$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $2eb97388ec83477c$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $2eb97388ec83477c$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $2eb97388ec83477c$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $2eb97388ec83477c$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $2eb97388ec83477c$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $2eb97388ec83477c$var$resolveUpdatePriority() {
    var updatePriority = $2eb97388ec83477c$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $2eb97388ec83477c$var$getEventPriority(updatePriority.type);
}
function $2eb97388ec83477c$var$runWithPriority(priority, fn) {
    var previousPriority = $2eb97388ec83477c$var$ReactDOMSharedInternals.p;
    try {
        return $2eb97388ec83477c$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $2eb97388ec83477c$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $2eb97388ec83477c$var$randomKey = Math.random().toString(36).slice(2), $2eb97388ec83477c$var$internalInstanceKey = "__reactFiber$" + $2eb97388ec83477c$var$randomKey, $2eb97388ec83477c$var$internalPropsKey = "__reactProps$" + $2eb97388ec83477c$var$randomKey, $2eb97388ec83477c$var$internalContainerInstanceKey = "__reactContainer$" + $2eb97388ec83477c$var$randomKey, $2eb97388ec83477c$var$internalEventHandlersKey = "__reactEvents$" + $2eb97388ec83477c$var$randomKey, $2eb97388ec83477c$var$internalEventHandlerListenersKey = "__reactListeners$" + $2eb97388ec83477c$var$randomKey, $2eb97388ec83477c$var$internalEventHandlesSetKey = "__reactHandles$" + $2eb97388ec83477c$var$randomKey, $2eb97388ec83477c$var$internalRootNodeResourcesKey = "__reactResources$" + $2eb97388ec83477c$var$randomKey, $2eb97388ec83477c$var$internalHoistableMarker = "__reactMarker$" + $2eb97388ec83477c$var$randomKey;
function $2eb97388ec83477c$var$detachDeletedInstance(node) {
    delete node[$2eb97388ec83477c$var$internalInstanceKey];
    delete node[$2eb97388ec83477c$var$internalPropsKey];
    delete node[$2eb97388ec83477c$var$internalEventHandlersKey];
    delete node[$2eb97388ec83477c$var$internalEventHandlerListenersKey];
    delete node[$2eb97388ec83477c$var$internalEventHandlesSetKey];
}
function $2eb97388ec83477c$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$2eb97388ec83477c$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$2eb97388ec83477c$var$internalContainerInstanceKey] || parentNode[$2eb97388ec83477c$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $2eb97388ec83477c$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$2eb97388ec83477c$var$internalInstanceKey]) return parentNode;
                targetNode = $2eb97388ec83477c$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $2eb97388ec83477c$var$getInstanceFromNode(node) {
    if (node = node[$2eb97388ec83477c$var$internalInstanceKey] || node[$2eb97388ec83477c$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $2eb97388ec83477c$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($2eb97388ec83477c$var$formatProdErrorMessage(33));
}
function $2eb97388ec83477c$var$getResourcesFromRoot(root) {
    var resources = root[$2eb97388ec83477c$var$internalRootNodeResourcesKey];
    resources || (resources = root[$2eb97388ec83477c$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $2eb97388ec83477c$var$markNodeAsHoistable(node) {
    node[$2eb97388ec83477c$var$internalHoistableMarker] = !0;
}
var $2eb97388ec83477c$var$allNativeEvents = new Set(), $2eb97388ec83477c$var$registrationNameDependencies = {};
function $2eb97388ec83477c$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $2eb97388ec83477c$var$registerDirectEvent(registrationName, dependencies);
    $2eb97388ec83477c$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $2eb97388ec83477c$var$registerDirectEvent(registrationName, dependencies) {
    $2eb97388ec83477c$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$2eb97388ec83477c$var$allNativeEvents.add(dependencies[registrationName]);
}
var $2eb97388ec83477c$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $2eb97388ec83477c$var$illegalAttributeNameCache = {}, $2eb97388ec83477c$var$validatedAttributeNameCache = {};
function $2eb97388ec83477c$var$isAttributeNameSafe(attributeName) {
    if ($2eb97388ec83477c$var$hasOwnProperty.call($2eb97388ec83477c$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($2eb97388ec83477c$var$hasOwnProperty.call($2eb97388ec83477c$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($2eb97388ec83477c$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $2eb97388ec83477c$var$validatedAttributeNameCache[attributeName] = !0;
    $2eb97388ec83477c$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $2eb97388ec83477c$var$setValueForAttribute(node, name, value) {
    if ($2eb97388ec83477c$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $2eb97388ec83477c$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $2eb97388ec83477c$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $2eb97388ec83477c$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $2eb97388ec83477c$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $2eb97388ec83477c$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $2eb97388ec83477c$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $2eb97388ec83477c$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $2eb97388ec83477c$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $2eb97388ec83477c$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $2eb97388ec83477c$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $2eb97388ec83477c$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $2eb97388ec83477c$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $2eb97388ec83477c$var$getToStringValue(value);
        } else element.value !== "" + $2eb97388ec83477c$var$getToStringValue(value) && (element.value = "" + $2eb97388ec83477c$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $2eb97388ec83477c$var$setDefaultValue(element, type, $2eb97388ec83477c$var$getToStringValue(value)) : null != defaultValue ? $2eb97388ec83477c$var$setDefaultValue(element, type, $2eb97388ec83477c$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $2eb97388ec83477c$var$getToStringValue(name) : element.removeAttribute("name");
}
function $2eb97388ec83477c$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $2eb97388ec83477c$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $2eb97388ec83477c$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $2eb97388ec83477c$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $2eb97388ec83477c$var$track(element);
}
function $2eb97388ec83477c$var$setDefaultValue(node, type, value) {
    "number" === type && $2eb97388ec83477c$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $2eb97388ec83477c$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $2eb97388ec83477c$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $2eb97388ec83477c$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $2eb97388ec83477c$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $2eb97388ec83477c$var$getToStringValue(defaultValue) : "";
}
function $2eb97388ec83477c$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(92));
            if ($2eb97388ec83477c$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $2eb97388ec83477c$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $2eb97388ec83477c$var$track(element);
}
function $2eb97388ec83477c$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $2eb97388ec83477c$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $2eb97388ec83477c$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $2eb97388ec83477c$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $2eb97388ec83477c$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $2eb97388ec83477c$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $2eb97388ec83477c$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $2eb97388ec83477c$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $2eb97388ec83477c$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $2eb97388ec83477c$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $2eb97388ec83477c$var$sanitizeURL(url) {
    return $2eb97388ec83477c$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $2eb97388ec83477c$var$noop$1() {}
var $2eb97388ec83477c$var$currentReplayingEvent = null;
function $2eb97388ec83477c$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $2eb97388ec83477c$var$restoreTarget = null, $2eb97388ec83477c$var$restoreQueue = null;
function $2eb97388ec83477c$var$restoreStateOfTarget(target) {
    var internalInstance = $2eb97388ec83477c$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$2eb97388ec83477c$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $2eb97388ec83477c$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$2eb97388ec83477c$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(90));
                            $2eb97388ec83477c$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $2eb97388ec83477c$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $2eb97388ec83477c$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $2eb97388ec83477c$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $2eb97388ec83477c$var$isInsideEventHandler = !1;
function $2eb97388ec83477c$var$batchedUpdates$1(fn, a, b) {
    if ($2eb97388ec83477c$var$isInsideEventHandler) return fn(a, b);
    $2eb97388ec83477c$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($2eb97388ec83477c$var$isInsideEventHandler = !1, null !== $2eb97388ec83477c$var$restoreTarget || null !== $2eb97388ec83477c$var$restoreQueue) {
            if ($2eb97388ec83477c$var$flushSyncWork$1(), $2eb97388ec83477c$var$restoreTarget && (a = $2eb97388ec83477c$var$restoreTarget, fn = $2eb97388ec83477c$var$restoreQueue, $2eb97388ec83477c$var$restoreQueue = $2eb97388ec83477c$var$restoreTarget = null, $2eb97388ec83477c$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$2eb97388ec83477c$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $2eb97388ec83477c$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$2eb97388ec83477c$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $2eb97388ec83477c$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $2eb97388ec83477c$var$passiveBrowserEventsSupported = !1;
if ($2eb97388ec83477c$var$canUseDOM) try {
    var $2eb97388ec83477c$var$options = {};
    Object.defineProperty($2eb97388ec83477c$var$options, "passive", {
        get: function() {
            $2eb97388ec83477c$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $2eb97388ec83477c$var$options, $2eb97388ec83477c$var$options);
    window.removeEventListener("test", $2eb97388ec83477c$var$options, $2eb97388ec83477c$var$options);
} catch (e) {
    $2eb97388ec83477c$var$passiveBrowserEventsSupported = !1;
}
var $2eb97388ec83477c$var$root = null, $2eb97388ec83477c$var$startText = null, $2eb97388ec83477c$var$fallbackText = null;
function $2eb97388ec83477c$var$getData() {
    if ($2eb97388ec83477c$var$fallbackText) return $2eb97388ec83477c$var$fallbackText;
    var start, startValue = $2eb97388ec83477c$var$startText, startLength = startValue.length, end, endValue = "value" in $2eb97388ec83477c$var$root ? $2eb97388ec83477c$var$root.value : $2eb97388ec83477c$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $2eb97388ec83477c$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $2eb97388ec83477c$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $2eb97388ec83477c$var$functionThatReturnsTrue() {
    return !0;
}
function $2eb97388ec83477c$var$functionThatReturnsFalse() {
    return !1;
}
function $2eb97388ec83477c$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $2eb97388ec83477c$var$functionThatReturnsTrue : $2eb97388ec83477c$var$functionThatReturnsFalse;
        this.isPropagationStopped = $2eb97388ec83477c$var$functionThatReturnsFalse;
        return this;
    }
    $2eb97388ec83477c$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $2eb97388ec83477c$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $2eb97388ec83477c$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $2eb97388ec83477c$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $2eb97388ec83477c$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $2eb97388ec83477c$var$SyntheticEvent = $2eb97388ec83477c$var$createSyntheticEvent($2eb97388ec83477c$var$EventInterface), $2eb97388ec83477c$var$UIEventInterface = $2eb97388ec83477c$var$assign({}, $2eb97388ec83477c$var$EventInterface, {
    view: 0,
    detail: 0
}), $2eb97388ec83477c$var$SyntheticUIEvent = $2eb97388ec83477c$var$createSyntheticEvent($2eb97388ec83477c$var$UIEventInterface), $2eb97388ec83477c$var$lastMovementX, $2eb97388ec83477c$var$lastMovementY, $2eb97388ec83477c$var$lastMouseEvent, $2eb97388ec83477c$var$MouseEventInterface = $2eb97388ec83477c$var$assign({}, $2eb97388ec83477c$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $2eb97388ec83477c$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $2eb97388ec83477c$var$lastMouseEvent && ($2eb97388ec83477c$var$lastMouseEvent && "mousemove" === event.type ? ($2eb97388ec83477c$var$lastMovementX = event.screenX - $2eb97388ec83477c$var$lastMouseEvent.screenX, $2eb97388ec83477c$var$lastMovementY = event.screenY - $2eb97388ec83477c$var$lastMouseEvent.screenY) : $2eb97388ec83477c$var$lastMovementY = $2eb97388ec83477c$var$lastMovementX = 0, $2eb97388ec83477c$var$lastMouseEvent = event);
        return $2eb97388ec83477c$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $2eb97388ec83477c$var$lastMovementY;
    }
}), $2eb97388ec83477c$var$SyntheticMouseEvent = $2eb97388ec83477c$var$createSyntheticEvent($2eb97388ec83477c$var$MouseEventInterface), $2eb97388ec83477c$var$DragEventInterface = $2eb97388ec83477c$var$assign({}, $2eb97388ec83477c$var$MouseEventInterface, {
    dataTransfer: 0
}), $2eb97388ec83477c$var$SyntheticDragEvent = $2eb97388ec83477c$var$createSyntheticEvent($2eb97388ec83477c$var$DragEventInterface), $2eb97388ec83477c$var$FocusEventInterface = $2eb97388ec83477c$var$assign({}, $2eb97388ec83477c$var$UIEventInterface, {
    relatedTarget: 0
}), $2eb97388ec83477c$var$SyntheticFocusEvent = $2eb97388ec83477c$var$createSyntheticEvent($2eb97388ec83477c$var$FocusEventInterface), $2eb97388ec83477c$var$AnimationEventInterface = $2eb97388ec83477c$var$assign({}, $2eb97388ec83477c$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2eb97388ec83477c$var$SyntheticAnimationEvent = $2eb97388ec83477c$var$createSyntheticEvent($2eb97388ec83477c$var$AnimationEventInterface), $2eb97388ec83477c$var$ClipboardEventInterface = $2eb97388ec83477c$var$assign({}, $2eb97388ec83477c$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $2eb97388ec83477c$var$SyntheticClipboardEvent = $2eb97388ec83477c$var$createSyntheticEvent($2eb97388ec83477c$var$ClipboardEventInterface), $2eb97388ec83477c$var$CompositionEventInterface = $2eb97388ec83477c$var$assign({}, $2eb97388ec83477c$var$EventInterface, {
    data: 0
}), $2eb97388ec83477c$var$SyntheticCompositionEvent = $2eb97388ec83477c$var$createSyntheticEvent($2eb97388ec83477c$var$CompositionEventInterface), $2eb97388ec83477c$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $2eb97388ec83477c$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $2eb97388ec83477c$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $2eb97388ec83477c$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $2eb97388ec83477c$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $2eb97388ec83477c$var$getEventModifierState() {
    return $2eb97388ec83477c$var$modifierStateGetter;
}
var $2eb97388ec83477c$var$KeyboardEventInterface = $2eb97388ec83477c$var$assign({}, $2eb97388ec83477c$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $2eb97388ec83477c$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $2eb97388ec83477c$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $2eb97388ec83477c$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $2eb97388ec83477c$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $2eb97388ec83477c$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $2eb97388ec83477c$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $2eb97388ec83477c$var$SyntheticKeyboardEvent = $2eb97388ec83477c$var$createSyntheticEvent($2eb97388ec83477c$var$KeyboardEventInterface), $2eb97388ec83477c$var$PointerEventInterface = $2eb97388ec83477c$var$assign({}, $2eb97388ec83477c$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $2eb97388ec83477c$var$SyntheticPointerEvent = $2eb97388ec83477c$var$createSyntheticEvent($2eb97388ec83477c$var$PointerEventInterface), $2eb97388ec83477c$var$TouchEventInterface = $2eb97388ec83477c$var$assign({}, $2eb97388ec83477c$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $2eb97388ec83477c$var$getEventModifierState
}), $2eb97388ec83477c$var$SyntheticTouchEvent = $2eb97388ec83477c$var$createSyntheticEvent($2eb97388ec83477c$var$TouchEventInterface), $2eb97388ec83477c$var$TransitionEventInterface = $2eb97388ec83477c$var$assign({}, $2eb97388ec83477c$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2eb97388ec83477c$var$SyntheticTransitionEvent = $2eb97388ec83477c$var$createSyntheticEvent($2eb97388ec83477c$var$TransitionEventInterface), $2eb97388ec83477c$var$WheelEventInterface = $2eb97388ec83477c$var$assign({}, $2eb97388ec83477c$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $2eb97388ec83477c$var$SyntheticWheelEvent = $2eb97388ec83477c$var$createSyntheticEvent($2eb97388ec83477c$var$WheelEventInterface), $2eb97388ec83477c$var$ToggleEventInterface = $2eb97388ec83477c$var$assign({}, $2eb97388ec83477c$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $2eb97388ec83477c$var$SyntheticToggleEvent = $2eb97388ec83477c$var$createSyntheticEvent($2eb97388ec83477c$var$ToggleEventInterface), $2eb97388ec83477c$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $2eb97388ec83477c$var$canUseCompositionEvent = $2eb97388ec83477c$var$canUseDOM && "CompositionEvent" in window, $2eb97388ec83477c$var$documentMode = null;
$2eb97388ec83477c$var$canUseDOM && "documentMode" in document && ($2eb97388ec83477c$var$documentMode = document.documentMode);
var $2eb97388ec83477c$var$canUseTextInputEvent = $2eb97388ec83477c$var$canUseDOM && "TextEvent" in window && !$2eb97388ec83477c$var$documentMode, $2eb97388ec83477c$var$useFallbackCompositionData = $2eb97388ec83477c$var$canUseDOM && (!$2eb97388ec83477c$var$canUseCompositionEvent || $2eb97388ec83477c$var$documentMode && 8 < $2eb97388ec83477c$var$documentMode && 11 >= $2eb97388ec83477c$var$documentMode), $2eb97388ec83477c$var$SPACEBAR_CHAR = String.fromCharCode(32), $2eb97388ec83477c$var$hasSpaceKeypress = !1;
function $2eb97388ec83477c$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $2eb97388ec83477c$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $2eb97388ec83477c$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $2eb97388ec83477c$var$isComposing = !1;
function $2eb97388ec83477c$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $2eb97388ec83477c$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $2eb97388ec83477c$var$hasSpaceKeypress = !0;
            return $2eb97388ec83477c$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $2eb97388ec83477c$var$SPACEBAR_CHAR && $2eb97388ec83477c$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $2eb97388ec83477c$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($2eb97388ec83477c$var$isComposing) return "compositionend" === domEventName || !$2eb97388ec83477c$var$canUseCompositionEvent && $2eb97388ec83477c$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $2eb97388ec83477c$var$getData(), $2eb97388ec83477c$var$fallbackText = $2eb97388ec83477c$var$startText = $2eb97388ec83477c$var$root = null, $2eb97388ec83477c$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $2eb97388ec83477c$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $2eb97388ec83477c$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $2eb97388ec83477c$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$2eb97388ec83477c$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $2eb97388ec83477c$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $2eb97388ec83477c$var$restoreTarget ? $2eb97388ec83477c$var$restoreQueue ? $2eb97388ec83477c$var$restoreQueue.push(target) : $2eb97388ec83477c$var$restoreQueue = [
        target
    ] : $2eb97388ec83477c$var$restoreTarget = target;
    inst = $2eb97388ec83477c$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $2eb97388ec83477c$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $2eb97388ec83477c$var$activeElement$1 = null, $2eb97388ec83477c$var$activeElementInst$1 = null;
function $2eb97388ec83477c$var$runEventInBatch(dispatchQueue) {
    $2eb97388ec83477c$var$processDispatchQueue(dispatchQueue, 0);
}
function $2eb97388ec83477c$var$getInstIfValueChanged(targetInst) {
    var targetNode = $2eb97388ec83477c$var$getNodeFromInstance(targetInst);
    if ($2eb97388ec83477c$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $2eb97388ec83477c$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $2eb97388ec83477c$var$isInputEventSupported = !1;
if ($2eb97388ec83477c$var$canUseDOM) {
    var $2eb97388ec83477c$var$JSCompiler_inline_result$jscomp$286;
    if ($2eb97388ec83477c$var$canUseDOM) {
        var $2eb97388ec83477c$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$2eb97388ec83477c$var$isSupported$jscomp$inline_427) {
            var $2eb97388ec83477c$var$element$jscomp$inline_428 = document.createElement("div");
            $2eb97388ec83477c$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $2eb97388ec83477c$var$isSupported$jscomp$inline_427 = "function" === typeof $2eb97388ec83477c$var$element$jscomp$inline_428.oninput;
        }
        $2eb97388ec83477c$var$JSCompiler_inline_result$jscomp$286 = $2eb97388ec83477c$var$isSupported$jscomp$inline_427;
    } else $2eb97388ec83477c$var$JSCompiler_inline_result$jscomp$286 = !1;
    $2eb97388ec83477c$var$isInputEventSupported = $2eb97388ec83477c$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $2eb97388ec83477c$var$stopWatchingForValueChange() {
    $2eb97388ec83477c$var$activeElement$1 && ($2eb97388ec83477c$var$activeElement$1.detachEvent("onpropertychange", $2eb97388ec83477c$var$handlePropertyChange), $2eb97388ec83477c$var$activeElementInst$1 = $2eb97388ec83477c$var$activeElement$1 = null);
}
function $2eb97388ec83477c$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $2eb97388ec83477c$var$getInstIfValueChanged($2eb97388ec83477c$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $2eb97388ec83477c$var$createAndAccumulateChangeEvent(dispatchQueue, $2eb97388ec83477c$var$activeElementInst$1, nativeEvent, $2eb97388ec83477c$var$getEventTarget(nativeEvent));
        $2eb97388ec83477c$var$batchedUpdates$1($2eb97388ec83477c$var$runEventInBatch, dispatchQueue);
    }
}
function $2eb97388ec83477c$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($2eb97388ec83477c$var$stopWatchingForValueChange(), $2eb97388ec83477c$var$activeElement$1 = target, $2eb97388ec83477c$var$activeElementInst$1 = targetInst, $2eb97388ec83477c$var$activeElement$1.attachEvent("onpropertychange", $2eb97388ec83477c$var$handlePropertyChange)) : "focusout" === domEventName && $2eb97388ec83477c$var$stopWatchingForValueChange();
}
function $2eb97388ec83477c$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $2eb97388ec83477c$var$getInstIfValueChanged($2eb97388ec83477c$var$activeElementInst$1);
}
function $2eb97388ec83477c$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $2eb97388ec83477c$var$getInstIfValueChanged(targetInst);
}
function $2eb97388ec83477c$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $2eb97388ec83477c$var$getInstIfValueChanged(targetInst);
}
function $2eb97388ec83477c$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $2eb97388ec83477c$var$objectIs = "function" === typeof Object.is ? Object.is : $2eb97388ec83477c$var$is;
function $2eb97388ec83477c$var$shallowEqual(objA, objB) {
    if ($2eb97388ec83477c$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$2eb97388ec83477c$var$hasOwnProperty.call(objB, currentKey) || !$2eb97388ec83477c$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $2eb97388ec83477c$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $2eb97388ec83477c$var$getNodeForCharacterOffset(root, offset) {
    var node = $2eb97388ec83477c$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $2eb97388ec83477c$var$getLeafNode(node);
    }
}
function $2eb97388ec83477c$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $2eb97388ec83477c$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $2eb97388ec83477c$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $2eb97388ec83477c$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $2eb97388ec83477c$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $2eb97388ec83477c$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $2eb97388ec83477c$var$skipSelectionChangeEvent = $2eb97388ec83477c$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $2eb97388ec83477c$var$activeElement = null, $2eb97388ec83477c$var$activeElementInst = null, $2eb97388ec83477c$var$lastSelection = null, $2eb97388ec83477c$var$mouseDown = !1;
function $2eb97388ec83477c$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $2eb97388ec83477c$var$mouseDown || null == $2eb97388ec83477c$var$activeElement || $2eb97388ec83477c$var$activeElement !== $2eb97388ec83477c$var$getActiveElement(doc) || (doc = $2eb97388ec83477c$var$activeElement, "selectionStart" in doc && $2eb97388ec83477c$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $2eb97388ec83477c$var$lastSelection && $2eb97388ec83477c$var$shallowEqual($2eb97388ec83477c$var$lastSelection, doc) || ($2eb97388ec83477c$var$lastSelection = doc, doc = $2eb97388ec83477c$var$accumulateTwoPhaseListeners($2eb97388ec83477c$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $2eb97388ec83477c$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $2eb97388ec83477c$var$activeElement)));
}
function $2eb97388ec83477c$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $2eb97388ec83477c$var$vendorPrefixes = {
    animationend: $2eb97388ec83477c$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $2eb97388ec83477c$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $2eb97388ec83477c$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $2eb97388ec83477c$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $2eb97388ec83477c$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $2eb97388ec83477c$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $2eb97388ec83477c$var$makePrefixMap("Transition", "TransitionEnd")
}, $2eb97388ec83477c$var$prefixedEventNames = {}, $2eb97388ec83477c$var$style = {};
$2eb97388ec83477c$var$canUseDOM && ($2eb97388ec83477c$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $2eb97388ec83477c$var$vendorPrefixes.animationend.animation, delete $2eb97388ec83477c$var$vendorPrefixes.animationiteration.animation, delete $2eb97388ec83477c$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $2eb97388ec83477c$var$vendorPrefixes.transitionend.transition);
function $2eb97388ec83477c$var$getVendorPrefixedEventName(eventName) {
    if ($2eb97388ec83477c$var$prefixedEventNames[eventName]) return $2eb97388ec83477c$var$prefixedEventNames[eventName];
    if (!$2eb97388ec83477c$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $2eb97388ec83477c$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $2eb97388ec83477c$var$style) return $2eb97388ec83477c$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $2eb97388ec83477c$var$ANIMATION_END = $2eb97388ec83477c$var$getVendorPrefixedEventName("animationend"), $2eb97388ec83477c$var$ANIMATION_ITERATION = $2eb97388ec83477c$var$getVendorPrefixedEventName("animationiteration"), $2eb97388ec83477c$var$ANIMATION_START = $2eb97388ec83477c$var$getVendorPrefixedEventName("animationstart"), $2eb97388ec83477c$var$TRANSITION_RUN = $2eb97388ec83477c$var$getVendorPrefixedEventName("transitionrun"), $2eb97388ec83477c$var$TRANSITION_START = $2eb97388ec83477c$var$getVendorPrefixedEventName("transitionstart"), $2eb97388ec83477c$var$TRANSITION_CANCEL = $2eb97388ec83477c$var$getVendorPrefixedEventName("transitioncancel"), $2eb97388ec83477c$var$TRANSITION_END = $2eb97388ec83477c$var$getVendorPrefixedEventName("transitionend"), $2eb97388ec83477c$var$topLevelEventsToReactNames = new Map(), $2eb97388ec83477c$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$2eb97388ec83477c$var$simpleEventPluginEvents.push("scrollEnd");
function $2eb97388ec83477c$var$registerSimpleEvent(domEventName, reactName) {
    $2eb97388ec83477c$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $2eb97388ec83477c$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $2eb97388ec83477c$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $2eb97388ec83477c$var$concurrentQueues = [], $2eb97388ec83477c$var$concurrentQueuesIndex = 0, $2eb97388ec83477c$var$concurrentlyUpdatedLanes = 0;
function $2eb97388ec83477c$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $2eb97388ec83477c$var$concurrentQueuesIndex, i = $2eb97388ec83477c$var$concurrentlyUpdatedLanes = $2eb97388ec83477c$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $2eb97388ec83477c$var$concurrentQueues[i];
        $2eb97388ec83477c$var$concurrentQueues[i++] = null;
        var queue = $2eb97388ec83477c$var$concurrentQueues[i];
        $2eb97388ec83477c$var$concurrentQueues[i++] = null;
        var update = $2eb97388ec83477c$var$concurrentQueues[i];
        $2eb97388ec83477c$var$concurrentQueues[i++] = null;
        var lane = $2eb97388ec83477c$var$concurrentQueues[i];
        $2eb97388ec83477c$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $2eb97388ec83477c$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $2eb97388ec83477c$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $2eb97388ec83477c$var$concurrentQueues[$2eb97388ec83477c$var$concurrentQueuesIndex++] = fiber;
    $2eb97388ec83477c$var$concurrentQueues[$2eb97388ec83477c$var$concurrentQueuesIndex++] = queue;
    $2eb97388ec83477c$var$concurrentQueues[$2eb97388ec83477c$var$concurrentQueuesIndex++] = update;
    $2eb97388ec83477c$var$concurrentQueues[$2eb97388ec83477c$var$concurrentQueuesIndex++] = lane;
    $2eb97388ec83477c$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $2eb97388ec83477c$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $2eb97388ec83477c$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $2eb97388ec83477c$var$getRootForUpdatedFiber(fiber);
}
function $2eb97388ec83477c$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $2eb97388ec83477c$var$enqueueUpdate$1(fiber, null, null, lane);
    return $2eb97388ec83477c$var$getRootForUpdatedFiber(fiber);
}
function $2eb97388ec83477c$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $2eb97388ec83477c$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $2eb97388ec83477c$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $2eb97388ec83477c$var$nestedUpdateCount) throw $2eb97388ec83477c$var$nestedUpdateCount = 0, $2eb97388ec83477c$var$rootWithNestedUpdates = null, Error($2eb97388ec83477c$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $2eb97388ec83477c$var$emptyContextObject = {};
function $2eb97388ec83477c$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $2eb97388ec83477c$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $2eb97388ec83477c$var$FiberNode(tag, pendingProps, key, mode);
}
function $2eb97388ec83477c$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $2eb97388ec83477c$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $2eb97388ec83477c$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $2eb97388ec83477c$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $2eb97388ec83477c$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $2eb97388ec83477c$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $2eb97388ec83477c$var$isHostHoistableType(type, pendingProps, $2eb97388ec83477c$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $2eb97388ec83477c$var$REACT_ACTIVITY_TYPE:
            return type = $2eb97388ec83477c$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $2eb97388ec83477c$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $2eb97388ec83477c$var$REACT_FRAGMENT_TYPE:
            return $2eb97388ec83477c$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $2eb97388ec83477c$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $2eb97388ec83477c$var$REACT_PROFILER_TYPE:
            return type = $2eb97388ec83477c$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $2eb97388ec83477c$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $2eb97388ec83477c$var$REACT_SUSPENSE_TYPE:
            return type = $2eb97388ec83477c$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $2eb97388ec83477c$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $2eb97388ec83477c$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $2eb97388ec83477c$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $2eb97388ec83477c$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $2eb97388ec83477c$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $2eb97388ec83477c$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $2eb97388ec83477c$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $2eb97388ec83477c$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $2eb97388ec83477c$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($2eb97388ec83477c$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $2eb97388ec83477c$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $2eb97388ec83477c$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $2eb97388ec83477c$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $2eb97388ec83477c$var$createFiberFromText(content, mode, lanes) {
    content = $2eb97388ec83477c$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $2eb97388ec83477c$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $2eb97388ec83477c$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $2eb97388ec83477c$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $2eb97388ec83477c$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $2eb97388ec83477c$var$CapturedStacks = new WeakMap();
function $2eb97388ec83477c$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $2eb97388ec83477c$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $2eb97388ec83477c$var$getStackByFiberInDevAndProd(source)
        };
        $2eb97388ec83477c$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $2eb97388ec83477c$var$getStackByFiberInDevAndProd(source)
    };
}
var $2eb97388ec83477c$var$forkStack = [], $2eb97388ec83477c$var$forkStackIndex = 0, $2eb97388ec83477c$var$treeForkProvider = null, $2eb97388ec83477c$var$treeForkCount = 0, $2eb97388ec83477c$var$idStack = [], $2eb97388ec83477c$var$idStackIndex = 0, $2eb97388ec83477c$var$treeContextProvider = null, $2eb97388ec83477c$var$treeContextId = 1, $2eb97388ec83477c$var$treeContextOverflow = "";
function $2eb97388ec83477c$var$pushTreeFork(workInProgress, totalChildren) {
    $2eb97388ec83477c$var$forkStack[$2eb97388ec83477c$var$forkStackIndex++] = $2eb97388ec83477c$var$treeForkCount;
    $2eb97388ec83477c$var$forkStack[$2eb97388ec83477c$var$forkStackIndex++] = $2eb97388ec83477c$var$treeForkProvider;
    $2eb97388ec83477c$var$treeForkProvider = workInProgress;
    $2eb97388ec83477c$var$treeForkCount = totalChildren;
}
function $2eb97388ec83477c$var$pushTreeId(workInProgress, totalChildren, index) {
    $2eb97388ec83477c$var$idStack[$2eb97388ec83477c$var$idStackIndex++] = $2eb97388ec83477c$var$treeContextId;
    $2eb97388ec83477c$var$idStack[$2eb97388ec83477c$var$idStackIndex++] = $2eb97388ec83477c$var$treeContextOverflow;
    $2eb97388ec83477c$var$idStack[$2eb97388ec83477c$var$idStackIndex++] = $2eb97388ec83477c$var$treeContextProvider;
    $2eb97388ec83477c$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $2eb97388ec83477c$var$treeContextId;
    workInProgress = $2eb97388ec83477c$var$treeContextOverflow;
    var baseLength = 32 - $2eb97388ec83477c$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $2eb97388ec83477c$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $2eb97388ec83477c$var$treeContextId = 1 << 32 - $2eb97388ec83477c$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $2eb97388ec83477c$var$treeContextOverflow = length + workInProgress;
    } else $2eb97388ec83477c$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $2eb97388ec83477c$var$treeContextOverflow = workInProgress;
}
function $2eb97388ec83477c$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($2eb97388ec83477c$var$pushTreeFork(workInProgress, 1), $2eb97388ec83477c$var$pushTreeId(workInProgress, 1, 0));
}
function $2eb97388ec83477c$var$popTreeContext(workInProgress) {
    for(; workInProgress === $2eb97388ec83477c$var$treeForkProvider;)$2eb97388ec83477c$var$treeForkProvider = $2eb97388ec83477c$var$forkStack[--$2eb97388ec83477c$var$forkStackIndex], $2eb97388ec83477c$var$forkStack[$2eb97388ec83477c$var$forkStackIndex] = null, $2eb97388ec83477c$var$treeForkCount = $2eb97388ec83477c$var$forkStack[--$2eb97388ec83477c$var$forkStackIndex], $2eb97388ec83477c$var$forkStack[$2eb97388ec83477c$var$forkStackIndex] = null;
    for(; workInProgress === $2eb97388ec83477c$var$treeContextProvider;)$2eb97388ec83477c$var$treeContextProvider = $2eb97388ec83477c$var$idStack[--$2eb97388ec83477c$var$idStackIndex], $2eb97388ec83477c$var$idStack[$2eb97388ec83477c$var$idStackIndex] = null, $2eb97388ec83477c$var$treeContextOverflow = $2eb97388ec83477c$var$idStack[--$2eb97388ec83477c$var$idStackIndex], $2eb97388ec83477c$var$idStack[$2eb97388ec83477c$var$idStackIndex] = null, $2eb97388ec83477c$var$treeContextId = $2eb97388ec83477c$var$idStack[--$2eb97388ec83477c$var$idStackIndex], $2eb97388ec83477c$var$idStack[$2eb97388ec83477c$var$idStackIndex] = null;
}
function $2eb97388ec83477c$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $2eb97388ec83477c$var$idStack[$2eb97388ec83477c$var$idStackIndex++] = $2eb97388ec83477c$var$treeContextId;
    $2eb97388ec83477c$var$idStack[$2eb97388ec83477c$var$idStackIndex++] = $2eb97388ec83477c$var$treeContextOverflow;
    $2eb97388ec83477c$var$idStack[$2eb97388ec83477c$var$idStackIndex++] = $2eb97388ec83477c$var$treeContextProvider;
    $2eb97388ec83477c$var$treeContextId = suspendedContext.id;
    $2eb97388ec83477c$var$treeContextOverflow = suspendedContext.overflow;
    $2eb97388ec83477c$var$treeContextProvider = workInProgress;
}
var $2eb97388ec83477c$var$hydrationParentFiber = null, $2eb97388ec83477c$var$nextHydratableInstance = null, $2eb97388ec83477c$var$isHydrating = !1, $2eb97388ec83477c$var$hydrationErrors = null, $2eb97388ec83477c$var$rootOrSingletonContext = !1, $2eb97388ec83477c$var$HydrationMismatchException = Error($2eb97388ec83477c$var$formatProdErrorMessage(519));
function $2eb97388ec83477c$var$throwOnHydrationMismatch(fiber) {
    var error = Error($2eb97388ec83477c$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $2eb97388ec83477c$var$queueHydrationError($2eb97388ec83477c$var$createCapturedValueAtFiber(error, fiber));
    throw $2eb97388ec83477c$var$HydrationMismatchException;
}
function $2eb97388ec83477c$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$2eb97388ec83477c$var$internalInstanceKey] = fiber;
    instance[$2eb97388ec83477c$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("cancel", instance);
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $2eb97388ec83477c$var$mediaEventTypes.length; type++)$2eb97388ec83477c$var$listenToNonDelegatedEvent($2eb97388ec83477c$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("error", instance);
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("invalid", instance);
            $2eb97388ec83477c$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("invalid", instance), $2eb97388ec83477c$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $2eb97388ec83477c$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($2eb97388ec83477c$var$listenToNonDelegatedEvent("beforetoggle", instance), $2eb97388ec83477c$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $2eb97388ec83477c$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $2eb97388ec83477c$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $2eb97388ec83477c$var$noop$1), instance = !0) : instance = !1;
    instance || $2eb97388ec83477c$var$throwOnHydrationMismatch(fiber, !0);
}
function $2eb97388ec83477c$var$popToNextHostParent(fiber) {
    for($2eb97388ec83477c$var$hydrationParentFiber = fiber.return; $2eb97388ec83477c$var$hydrationParentFiber;)switch($2eb97388ec83477c$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $2eb97388ec83477c$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $2eb97388ec83477c$var$rootOrSingletonContext = !0;
            return;
        default:
            $2eb97388ec83477c$var$hydrationParentFiber = $2eb97388ec83477c$var$hydrationParentFiber.return;
    }
}
function $2eb97388ec83477c$var$popHydrationState(fiber) {
    if (fiber !== $2eb97388ec83477c$var$hydrationParentFiber) return !1;
    if (!$2eb97388ec83477c$var$isHydrating) return $2eb97388ec83477c$var$popToNextHostParent(fiber), $2eb97388ec83477c$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $2eb97388ec83477c$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $2eb97388ec83477c$var$nextHydratableInstance && $2eb97388ec83477c$var$throwOnHydrationMismatch(fiber);
    $2eb97388ec83477c$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(317));
        $2eb97388ec83477c$var$nextHydratableInstance = $2eb97388ec83477c$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(317));
        $2eb97388ec83477c$var$nextHydratableInstance = $2eb97388ec83477c$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $2eb97388ec83477c$var$nextHydratableInstance, $2eb97388ec83477c$var$isSingletonScope(fiber.type) ? (fiber = $2eb97388ec83477c$var$previousHydratableOnEnteringScopedSingleton, $2eb97388ec83477c$var$previousHydratableOnEnteringScopedSingleton = null, $2eb97388ec83477c$var$nextHydratableInstance = fiber) : $2eb97388ec83477c$var$nextHydratableInstance = tag) : $2eb97388ec83477c$var$nextHydratableInstance = $2eb97388ec83477c$var$hydrationParentFiber ? $2eb97388ec83477c$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $2eb97388ec83477c$var$resetHydrationState() {
    $2eb97388ec83477c$var$nextHydratableInstance = $2eb97388ec83477c$var$hydrationParentFiber = null;
    $2eb97388ec83477c$var$isHydrating = !1;
}
function $2eb97388ec83477c$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $2eb97388ec83477c$var$hydrationErrors;
    null !== queuedErrors && (null === $2eb97388ec83477c$var$workInProgressRootRecoverableErrors ? $2eb97388ec83477c$var$workInProgressRootRecoverableErrors = queuedErrors : $2eb97388ec83477c$var$workInProgressRootRecoverableErrors.push.apply($2eb97388ec83477c$var$workInProgressRootRecoverableErrors, queuedErrors), $2eb97388ec83477c$var$hydrationErrors = null);
    return queuedErrors;
}
function $2eb97388ec83477c$var$queueHydrationError(error) {
    null === $2eb97388ec83477c$var$hydrationErrors ? $2eb97388ec83477c$var$hydrationErrors = [
        error
    ] : $2eb97388ec83477c$var$hydrationErrors.push(error);
}
var $2eb97388ec83477c$var$valueCursor = $2eb97388ec83477c$var$createCursor(null), $2eb97388ec83477c$var$currentlyRenderingFiber$1 = null, $2eb97388ec83477c$var$lastContextDependency = null;
function $2eb97388ec83477c$var$pushProvider(providerFiber, context, nextValue) {
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $2eb97388ec83477c$var$popProvider(context) {
    context._currentValue = $2eb97388ec83477c$var$valueCursor.current;
    $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$valueCursor);
}
function $2eb97388ec83477c$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $2eb97388ec83477c$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $2eb97388ec83477c$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $2eb97388ec83477c$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $2eb97388ec83477c$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $2eb97388ec83477c$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $2eb97388ec83477c$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($2eb97388ec83477c$var$HostTransitionContext) : current = [
                $2eb97388ec83477c$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $2eb97388ec83477c$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $2eb97388ec83477c$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$2eb97388ec83477c$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $2eb97388ec83477c$var$prepareToReadContext(workInProgress) {
    $2eb97388ec83477c$var$currentlyRenderingFiber$1 = workInProgress;
    $2eb97388ec83477c$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $2eb97388ec83477c$var$readContext(context) {
    return $2eb97388ec83477c$var$readContextForConsumer($2eb97388ec83477c$var$currentlyRenderingFiber$1, context);
}
function $2eb97388ec83477c$var$readContextDuringReconciliation(consumer, context) {
    null === $2eb97388ec83477c$var$currentlyRenderingFiber$1 && $2eb97388ec83477c$var$prepareToReadContext(consumer);
    return $2eb97388ec83477c$var$readContextForConsumer(consumer, context);
}
function $2eb97388ec83477c$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $2eb97388ec83477c$var$lastContextDependency) {
        if (null === consumer) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(308));
        $2eb97388ec83477c$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $2eb97388ec83477c$var$lastContextDependency = $2eb97388ec83477c$var$lastContextDependency.next = context;
    return value;
}
var $2eb97388ec83477c$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $2eb97388ec83477c$var$scheduleCallback$2 = $bIbqH.unstable_scheduleCallback, $2eb97388ec83477c$var$NormalPriority = $bIbqH.unstable_NormalPriority, $2eb97388ec83477c$var$CacheContext = {
    $$typeof: $2eb97388ec83477c$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $2eb97388ec83477c$var$createCache() {
    return {
        controller: new $2eb97388ec83477c$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $2eb97388ec83477c$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $2eb97388ec83477c$var$scheduleCallback$2($2eb97388ec83477c$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $2eb97388ec83477c$var$currentEntangledListeners = null, $2eb97388ec83477c$var$currentEntangledPendingCount = 0, $2eb97388ec83477c$var$currentEntangledLane = 0, $2eb97388ec83477c$var$currentEntangledActionThenable = null;
function $2eb97388ec83477c$var$entangleAsyncAction(transition, thenable) {
    if (null === $2eb97388ec83477c$var$currentEntangledListeners) {
        var entangledListeners = $2eb97388ec83477c$var$currentEntangledListeners = [];
        $2eb97388ec83477c$var$currentEntangledPendingCount = 0;
        $2eb97388ec83477c$var$currentEntangledLane = $2eb97388ec83477c$var$requestTransitionLane();
        $2eb97388ec83477c$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $2eb97388ec83477c$var$currentEntangledPendingCount++;
    thenable.then($2eb97388ec83477c$var$pingEngtangledActionScope, $2eb97388ec83477c$var$pingEngtangledActionScope);
    return thenable;
}
function $2eb97388ec83477c$var$pingEngtangledActionScope() {
    if (0 === --$2eb97388ec83477c$var$currentEntangledPendingCount && null !== $2eb97388ec83477c$var$currentEntangledListeners) {
        null !== $2eb97388ec83477c$var$currentEntangledActionThenable && ($2eb97388ec83477c$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $2eb97388ec83477c$var$currentEntangledListeners;
        $2eb97388ec83477c$var$currentEntangledListeners = null;
        $2eb97388ec83477c$var$currentEntangledLane = 0;
        $2eb97388ec83477c$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $2eb97388ec83477c$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $2eb97388ec83477c$var$prevOnStartTransitionFinish = $2eb97388ec83477c$var$ReactSharedInternals.S;
$2eb97388ec83477c$var$ReactSharedInternals.S = function(transition, returnValue) {
    $2eb97388ec83477c$var$globalMostRecentTransitionTime = $2eb97388ec83477c$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $2eb97388ec83477c$var$entangleAsyncAction(transition, returnValue);
    null !== $2eb97388ec83477c$var$prevOnStartTransitionFinish && $2eb97388ec83477c$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $2eb97388ec83477c$var$resumedCache = $2eb97388ec83477c$var$createCursor(null);
function $2eb97388ec83477c$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $2eb97388ec83477c$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $2eb97388ec83477c$var$workInProgressRoot.pooledCache;
}
function $2eb97388ec83477c$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $2eb97388ec83477c$var$push($2eb97388ec83477c$var$resumedCache, $2eb97388ec83477c$var$resumedCache.current) : $2eb97388ec83477c$var$push($2eb97388ec83477c$var$resumedCache, prevCachePool.pool);
}
function $2eb97388ec83477c$var$getSuspendedCache() {
    var cacheFromPool = $2eb97388ec83477c$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $2eb97388ec83477c$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $2eb97388ec83477c$var$SuspenseException = Error($2eb97388ec83477c$var$formatProdErrorMessage(460)), $2eb97388ec83477c$var$SuspenseyCommitException = Error($2eb97388ec83477c$var$formatProdErrorMessage(474)), $2eb97388ec83477c$var$SuspenseActionException = Error($2eb97388ec83477c$var$formatProdErrorMessage(542)), $2eb97388ec83477c$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $2eb97388ec83477c$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $2eb97388ec83477c$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($2eb97388ec83477c$var$noop$1, $2eb97388ec83477c$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $2eb97388ec83477c$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($2eb97388ec83477c$var$noop$1, $2eb97388ec83477c$var$noop$1);
            else {
                thenableState = $2eb97388ec83477c$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $2eb97388ec83477c$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $2eb97388ec83477c$var$suspendedThenable = thenable;
            throw $2eb97388ec83477c$var$SuspenseException;
    }
}
function $2eb97388ec83477c$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $2eb97388ec83477c$var$suspendedThenable = x, $2eb97388ec83477c$var$SuspenseException;
        throw x;
    }
}
var $2eb97388ec83477c$var$suspendedThenable = null;
function $2eb97388ec83477c$var$getSuspendedThenable() {
    if (null === $2eb97388ec83477c$var$suspendedThenable) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(459));
    var thenable = $2eb97388ec83477c$var$suspendedThenable;
    $2eb97388ec83477c$var$suspendedThenable = null;
    return thenable;
}
function $2eb97388ec83477c$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $2eb97388ec83477c$var$SuspenseException || rejectedReason === $2eb97388ec83477c$var$SuspenseActionException) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(483));
}
var $2eb97388ec83477c$var$thenableState$1 = null, $2eb97388ec83477c$var$thenableIndexCounter$1 = 0;
function $2eb97388ec83477c$var$unwrapThenable(thenable) {
    var index = $2eb97388ec83477c$var$thenableIndexCounter$1;
    $2eb97388ec83477c$var$thenableIndexCounter$1 += 1;
    null === $2eb97388ec83477c$var$thenableState$1 && ($2eb97388ec83477c$var$thenableState$1 = []);
    return $2eb97388ec83477c$var$trackUsedThenable($2eb97388ec83477c$var$thenableState$1, thenable, index);
}
function $2eb97388ec83477c$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $2eb97388ec83477c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $2eb97388ec83477c$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($2eb97388ec83477c$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $2eb97388ec83477c$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $2eb97388ec83477c$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $2eb97388ec83477c$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $2eb97388ec83477c$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $2eb97388ec83477c$var$REACT_LAZY_TYPE && $2eb97388ec83477c$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $2eb97388ec83477c$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $2eb97388ec83477c$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $2eb97388ec83477c$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $2eb97388ec83477c$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $2eb97388ec83477c$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $2eb97388ec83477c$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2eb97388ec83477c$var$REACT_ELEMENT_TYPE:
                    return lanes = $2eb97388ec83477c$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $2eb97388ec83477c$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $2eb97388ec83477c$var$REACT_PORTAL_TYPE:
                    return newChild = $2eb97388ec83477c$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $2eb97388ec83477c$var$REACT_LAZY_TYPE:
                    return newChild = $2eb97388ec83477c$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($2eb97388ec83477c$var$isArrayImpl(newChild) || $2eb97388ec83477c$var$getIteratorFn(newChild)) return newChild = $2eb97388ec83477c$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $2eb97388ec83477c$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2eb97388ec83477c$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $2eb97388ec83477c$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2eb97388ec83477c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2eb97388ec83477c$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $2eb97388ec83477c$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $2eb97388ec83477c$var$REACT_LAZY_TYPE:
                    return newChild = $2eb97388ec83477c$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($2eb97388ec83477c$var$isArrayImpl(newChild) || $2eb97388ec83477c$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $2eb97388ec83477c$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2eb97388ec83477c$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $2eb97388ec83477c$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2eb97388ec83477c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2eb97388ec83477c$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $2eb97388ec83477c$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $2eb97388ec83477c$var$REACT_LAZY_TYPE:
                    return newChild = $2eb97388ec83477c$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($2eb97388ec83477c$var$isArrayImpl(newChild) || $2eb97388ec83477c$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $2eb97388ec83477c$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2eb97388ec83477c$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $2eb97388ec83477c$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2eb97388ec83477c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $2eb97388ec83477c$var$isHydrating && $2eb97388ec83477c$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $2eb97388ec83477c$var$isHydrating && $2eb97388ec83477c$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $2eb97388ec83477c$var$isHydrating && $2eb97388ec83477c$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $2eb97388ec83477c$var$isHydrating && $2eb97388ec83477c$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $2eb97388ec83477c$var$isHydrating && $2eb97388ec83477c$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $2eb97388ec83477c$var$isHydrating && $2eb97388ec83477c$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $2eb97388ec83477c$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2eb97388ec83477c$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $2eb97388ec83477c$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $2eb97388ec83477c$var$REACT_LAZY_TYPE && $2eb97388ec83477c$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $2eb97388ec83477c$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $2eb97388ec83477c$var$REACT_FRAGMENT_TYPE ? (lanes = $2eb97388ec83477c$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $2eb97388ec83477c$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $2eb97388ec83477c$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $2eb97388ec83477c$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $2eb97388ec83477c$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $2eb97388ec83477c$var$REACT_LAZY_TYPE:
                    return newChild = $2eb97388ec83477c$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($2eb97388ec83477c$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($2eb97388ec83477c$var$getIteratorFn(newChild)) {
                key = $2eb97388ec83477c$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $2eb97388ec83477c$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2eb97388ec83477c$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $2eb97388ec83477c$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2eb97388ec83477c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $2eb97388ec83477c$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $2eb97388ec83477c$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $2eb97388ec83477c$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $2eb97388ec83477c$var$SuspenseException || x === $2eb97388ec83477c$var$SuspenseActionException) throw x;
            var fiber = $2eb97388ec83477c$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $2eb97388ec83477c$var$reconcileChildFibers = $2eb97388ec83477c$var$createChildReconciler(!0), $2eb97388ec83477c$var$mountChildFibers = $2eb97388ec83477c$var$createChildReconciler(!1), $2eb97388ec83477c$var$hasForceUpdate = !1;
function $2eb97388ec83477c$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $2eb97388ec83477c$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $2eb97388ec83477c$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $2eb97388ec83477c$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($2eb97388ec83477c$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $2eb97388ec83477c$var$getRootForUpdatedFiber(fiber);
        $2eb97388ec83477c$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $2eb97388ec83477c$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $2eb97388ec83477c$var$getRootForUpdatedFiber(fiber);
}
function $2eb97388ec83477c$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $2eb97388ec83477c$var$markRootEntangled(root, lane);
    }
}
function $2eb97388ec83477c$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $2eb97388ec83477c$var$didReadFromEntangledAsyncAction = !1;
function $2eb97388ec83477c$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($2eb97388ec83477c$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $2eb97388ec83477c$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $2eb97388ec83477c$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $2eb97388ec83477c$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $2eb97388ec83477c$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($2eb97388ec83477c$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $2eb97388ec83477c$var$currentEntangledLane && ($2eb97388ec83477c$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $2eb97388ec83477c$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $2eb97388ec83477c$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $2eb97388ec83477c$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $2eb97388ec83477c$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $2eb97388ec83477c$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$2eb97388ec83477c$var$callCallback(callbacks[updateQueue], context);
}
var $2eb97388ec83477c$var$currentTreeHiddenStackCursor = $2eb97388ec83477c$var$createCursor(null), $2eb97388ec83477c$var$prevEntangledRenderLanesCursor = $2eb97388ec83477c$var$createCursor(0);
function $2eb97388ec83477c$var$pushHiddenContext(fiber, context) {
    fiber = $2eb97388ec83477c$var$entangledRenderLanes;
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$prevEntangledRenderLanesCursor, fiber);
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$currentTreeHiddenStackCursor, context);
    $2eb97388ec83477c$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $2eb97388ec83477c$var$reuseHiddenContextOnStack() {
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$prevEntangledRenderLanesCursor, $2eb97388ec83477c$var$entangledRenderLanes);
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$currentTreeHiddenStackCursor, $2eb97388ec83477c$var$currentTreeHiddenStackCursor.current);
}
function $2eb97388ec83477c$var$popHiddenContext() {
    $2eb97388ec83477c$var$entangledRenderLanes = $2eb97388ec83477c$var$prevEntangledRenderLanesCursor.current;
    $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$currentTreeHiddenStackCursor);
    $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$prevEntangledRenderLanesCursor);
}
var $2eb97388ec83477c$var$suspenseHandlerStackCursor = $2eb97388ec83477c$var$createCursor(null), $2eb97388ec83477c$var$shellBoundary = null;
function $2eb97388ec83477c$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$suspenseStackCursor, $2eb97388ec83477c$var$suspenseStackCursor.current & 1);
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$suspenseHandlerStackCursor, handler);
    null === $2eb97388ec83477c$var$shellBoundary && (null === current || null !== $2eb97388ec83477c$var$currentTreeHiddenStackCursor.current ? $2eb97388ec83477c$var$shellBoundary = handler : null !== current.memoizedState && ($2eb97388ec83477c$var$shellBoundary = handler));
}
function $2eb97388ec83477c$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$suspenseStackCursor, $2eb97388ec83477c$var$suspenseStackCursor.current);
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$suspenseHandlerStackCursor, fiber);
    null === $2eb97388ec83477c$var$shellBoundary && ($2eb97388ec83477c$var$shellBoundary = fiber);
}
function $2eb97388ec83477c$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($2eb97388ec83477c$var$push($2eb97388ec83477c$var$suspenseStackCursor, $2eb97388ec83477c$var$suspenseStackCursor.current), $2eb97388ec83477c$var$push($2eb97388ec83477c$var$suspenseHandlerStackCursor, fiber), null === $2eb97388ec83477c$var$shellBoundary && ($2eb97388ec83477c$var$shellBoundary = fiber)) : $2eb97388ec83477c$var$reuseSuspenseHandlerOnStack(fiber);
}
function $2eb97388ec83477c$var$reuseSuspenseHandlerOnStack() {
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$suspenseStackCursor, $2eb97388ec83477c$var$suspenseStackCursor.current);
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$suspenseHandlerStackCursor, $2eb97388ec83477c$var$suspenseHandlerStackCursor.current);
}
function $2eb97388ec83477c$var$popSuspenseHandler(fiber) {
    $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$suspenseHandlerStackCursor);
    $2eb97388ec83477c$var$shellBoundary === fiber && ($2eb97388ec83477c$var$shellBoundary = null);
    $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$suspenseStackCursor);
}
var $2eb97388ec83477c$var$suspenseStackCursor = $2eb97388ec83477c$var$createCursor(0);
function $2eb97388ec83477c$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $2eb97388ec83477c$var$isSuspenseInstancePending(state) || $2eb97388ec83477c$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $2eb97388ec83477c$var$renderLanes = 0, $2eb97388ec83477c$var$currentlyRenderingFiber = null, $2eb97388ec83477c$var$currentHook = null, $2eb97388ec83477c$var$workInProgressHook = null, $2eb97388ec83477c$var$didScheduleRenderPhaseUpdate = !1, $2eb97388ec83477c$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $2eb97388ec83477c$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $2eb97388ec83477c$var$localIdCounter = 0, $2eb97388ec83477c$var$thenableIndexCounter = 0, $2eb97388ec83477c$var$thenableState = null, $2eb97388ec83477c$var$globalClientIdCounter = 0;
function $2eb97388ec83477c$var$throwInvalidHookError() {
    throw Error($2eb97388ec83477c$var$formatProdErrorMessage(321));
}
function $2eb97388ec83477c$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$2eb97388ec83477c$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $2eb97388ec83477c$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $2eb97388ec83477c$var$renderLanes = nextRenderLanes;
    $2eb97388ec83477c$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $2eb97388ec83477c$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $2eb97388ec83477c$var$HooksDispatcherOnMount : $2eb97388ec83477c$var$HooksDispatcherOnUpdate;
    $2eb97388ec83477c$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $2eb97388ec83477c$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $2eb97388ec83477c$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $2eb97388ec83477c$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $2eb97388ec83477c$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $2eb97388ec83477c$var$finishRenderingHooks(current) {
    $2eb97388ec83477c$var$ReactSharedInternals.H = $2eb97388ec83477c$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $2eb97388ec83477c$var$currentHook && null !== $2eb97388ec83477c$var$currentHook.next;
    $2eb97388ec83477c$var$renderLanes = 0;
    $2eb97388ec83477c$var$workInProgressHook = $2eb97388ec83477c$var$currentHook = $2eb97388ec83477c$var$currentlyRenderingFiber = null;
    $2eb97388ec83477c$var$didScheduleRenderPhaseUpdate = !1;
    $2eb97388ec83477c$var$thenableIndexCounter = 0;
    $2eb97388ec83477c$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(300));
    null === current || $2eb97388ec83477c$var$didReceiveUpdate || (current = current.dependencies, null !== current && $2eb97388ec83477c$var$checkIfContextChanged(current) && ($2eb97388ec83477c$var$didReceiveUpdate = !0));
}
function $2eb97388ec83477c$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $2eb97388ec83477c$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $2eb97388ec83477c$var$didScheduleRenderPhaseUpdateDuringThisPass && ($2eb97388ec83477c$var$thenableState = null);
        $2eb97388ec83477c$var$thenableIndexCounter = 0;
        $2eb97388ec83477c$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $2eb97388ec83477c$var$workInProgressHook = $2eb97388ec83477c$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $2eb97388ec83477c$var$ReactSharedInternals.H = $2eb97388ec83477c$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($2eb97388ec83477c$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $2eb97388ec83477c$var$TransitionAwareHostComponent() {
    var dispatcher = $2eb97388ec83477c$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $2eb97388ec83477c$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $2eb97388ec83477c$var$currentHook ? $2eb97388ec83477c$var$currentHook.memoizedState : null) !== dispatcher && ($2eb97388ec83477c$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $2eb97388ec83477c$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $2eb97388ec83477c$var$localIdCounter;
    $2eb97388ec83477c$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $2eb97388ec83477c$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $2eb97388ec83477c$var$resetHooksOnUnwind(workInProgress) {
    if ($2eb97388ec83477c$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $2eb97388ec83477c$var$didScheduleRenderPhaseUpdate = !1;
    }
    $2eb97388ec83477c$var$renderLanes = 0;
    $2eb97388ec83477c$var$workInProgressHook = $2eb97388ec83477c$var$currentHook = $2eb97388ec83477c$var$currentlyRenderingFiber = null;
    $2eb97388ec83477c$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $2eb97388ec83477c$var$thenableIndexCounter = $2eb97388ec83477c$var$localIdCounter = 0;
    $2eb97388ec83477c$var$thenableState = null;
}
function $2eb97388ec83477c$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $2eb97388ec83477c$var$workInProgressHook ? $2eb97388ec83477c$var$currentlyRenderingFiber.memoizedState = $2eb97388ec83477c$var$workInProgressHook = hook : $2eb97388ec83477c$var$workInProgressHook = $2eb97388ec83477c$var$workInProgressHook.next = hook;
    return $2eb97388ec83477c$var$workInProgressHook;
}
function $2eb97388ec83477c$var$updateWorkInProgressHook() {
    if (null === $2eb97388ec83477c$var$currentHook) {
        var nextCurrentHook = $2eb97388ec83477c$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $2eb97388ec83477c$var$currentHook.next;
    var nextWorkInProgressHook = null === $2eb97388ec83477c$var$workInProgressHook ? $2eb97388ec83477c$var$currentlyRenderingFiber.memoizedState : $2eb97388ec83477c$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $2eb97388ec83477c$var$workInProgressHook = nextWorkInProgressHook, $2eb97388ec83477c$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $2eb97388ec83477c$var$currentlyRenderingFiber.alternate) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(467));
            throw Error($2eb97388ec83477c$var$formatProdErrorMessage(310));
        }
        $2eb97388ec83477c$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $2eb97388ec83477c$var$currentHook.memoizedState,
            baseState: $2eb97388ec83477c$var$currentHook.baseState,
            baseQueue: $2eb97388ec83477c$var$currentHook.baseQueue,
            queue: $2eb97388ec83477c$var$currentHook.queue,
            next: null
        };
        null === $2eb97388ec83477c$var$workInProgressHook ? $2eb97388ec83477c$var$currentlyRenderingFiber.memoizedState = $2eb97388ec83477c$var$workInProgressHook = nextCurrentHook : $2eb97388ec83477c$var$workInProgressHook = $2eb97388ec83477c$var$workInProgressHook.next = nextCurrentHook;
    }
    return $2eb97388ec83477c$var$workInProgressHook;
}
function $2eb97388ec83477c$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $2eb97388ec83477c$var$useThenable(thenable) {
    var index = $2eb97388ec83477c$var$thenableIndexCounter;
    $2eb97388ec83477c$var$thenableIndexCounter += 1;
    null === $2eb97388ec83477c$var$thenableState && ($2eb97388ec83477c$var$thenableState = []);
    thenable = $2eb97388ec83477c$var$trackUsedThenable($2eb97388ec83477c$var$thenableState, thenable, index);
    index = $2eb97388ec83477c$var$currentlyRenderingFiber;
    null === (null === $2eb97388ec83477c$var$workInProgressHook ? index.memoizedState : $2eb97388ec83477c$var$workInProgressHook.next) && (index = index.alternate, $2eb97388ec83477c$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $2eb97388ec83477c$var$HooksDispatcherOnMount : $2eb97388ec83477c$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $2eb97388ec83477c$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $2eb97388ec83477c$var$useThenable(usable);
        if (usable.$$typeof === $2eb97388ec83477c$var$REACT_CONTEXT_TYPE) return $2eb97388ec83477c$var$readContext(usable);
    }
    throw Error($2eb97388ec83477c$var$formatProdErrorMessage(438, String(usable)));
}
function $2eb97388ec83477c$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $2eb97388ec83477c$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $2eb97388ec83477c$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $2eb97388ec83477c$var$createFunctionComponentUpdateQueue(), $2eb97388ec83477c$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $2eb97388ec83477c$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $2eb97388ec83477c$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $2eb97388ec83477c$var$updateReducer(reducer) {
    var hook = $2eb97388ec83477c$var$updateWorkInProgressHook();
    return $2eb97388ec83477c$var$updateReducerImpl(hook, $2eb97388ec83477c$var$currentHook, reducer);
}
function $2eb97388ec83477c$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($2eb97388ec83477c$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($2eb97388ec83477c$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $2eb97388ec83477c$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($2eb97388ec83477c$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $2eb97388ec83477c$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $2eb97388ec83477c$var$currentlyRenderingFiber.lanes |= revertLane, $2eb97388ec83477c$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $2eb97388ec83477c$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $2eb97388ec83477c$var$currentlyRenderingFiber.lanes |= updateLane, $2eb97388ec83477c$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$2eb97388ec83477c$var$objectIs(pendingQueue, hook.memoizedState) && ($2eb97388ec83477c$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $2eb97388ec83477c$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $2eb97388ec83477c$var$rerenderReducer(reducer) {
    var hook = $2eb97388ec83477c$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $2eb97388ec83477c$var$objectIs(newState, hook.memoizedState) || ($2eb97388ec83477c$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $2eb97388ec83477c$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $2eb97388ec83477c$var$currentlyRenderingFiber, hook = $2eb97388ec83477c$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $2eb97388ec83477c$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$2eb97388ec83477c$var$objectIs(($2eb97388ec83477c$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $2eb97388ec83477c$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $2eb97388ec83477c$var$updateEffect($2eb97388ec83477c$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $2eb97388ec83477c$var$workInProgressHook && $2eb97388ec83477c$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $2eb97388ec83477c$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $2eb97388ec83477c$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $2eb97388ec83477c$var$workInProgressRoot) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($2eb97388ec83477c$var$renderLanes & 127) || $2eb97388ec83477c$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $2eb97388ec83477c$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $2eb97388ec83477c$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $2eb97388ec83477c$var$createFunctionComponentUpdateQueue(), $2eb97388ec83477c$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $2eb97388ec83477c$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $2eb97388ec83477c$var$checkIfSnapshotChanged(inst) && $2eb97388ec83477c$var$forceStoreRerender(fiber);
}
function $2eb97388ec83477c$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $2eb97388ec83477c$var$checkIfSnapshotChanged(inst) && $2eb97388ec83477c$var$forceStoreRerender(fiber);
    });
}
function $2eb97388ec83477c$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$2eb97388ec83477c$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $2eb97388ec83477c$var$forceStoreRerender(fiber) {
    var root = $2eb97388ec83477c$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $2eb97388ec83477c$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $2eb97388ec83477c$var$mountStateImpl(initialState) {
    var hook = $2eb97388ec83477c$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($2eb97388ec83477c$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $2eb97388ec83477c$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $2eb97388ec83477c$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2eb97388ec83477c$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $2eb97388ec83477c$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $2eb97388ec83477c$var$updateReducerImpl(hook, $2eb97388ec83477c$var$currentHook, "function" === typeof reducer ? reducer : $2eb97388ec83477c$var$basicStateReducer);
}
function $2eb97388ec83477c$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($2eb97388ec83477c$var$isRenderPhaseUpdate(fiber)) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $2eb97388ec83477c$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $2eb97388ec83477c$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $2eb97388ec83477c$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $2eb97388ec83477c$var$ReactSharedInternals.T, currentTransition = {};
        $2eb97388ec83477c$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $2eb97388ec83477c$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $2eb97388ec83477c$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $2eb97388ec83477c$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $2eb97388ec83477c$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $2eb97388ec83477c$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $2eb97388ec83477c$var$onActionError(actionQueue, node, error$66);
    }
}
function $2eb97388ec83477c$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $2eb97388ec83477c$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $2eb97388ec83477c$var$onActionError(actionQueue, node, error);
    }) : $2eb97388ec83477c$var$onActionSuccess(actionQueue, node, returnValue);
}
function $2eb97388ec83477c$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $2eb97388ec83477c$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $2eb97388ec83477c$var$runActionStateAction(actionQueue, nextState)));
}
function $2eb97388ec83477c$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $2eb97388ec83477c$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $2eb97388ec83477c$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $2eb97388ec83477c$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $2eb97388ec83477c$var$mountActionState(action, initialStateProp) {
    if ($2eb97388ec83477c$var$isHydrating) {
        var ssrFormState = $2eb97388ec83477c$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $2eb97388ec83477c$var$currentlyRenderingFiber;
                if ($2eb97388ec83477c$var$isHydrating) {
                    if ($2eb97388ec83477c$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $2eb97388ec83477c$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $2eb97388ec83477c$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $2eb97388ec83477c$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $2eb97388ec83477c$var$nextHydratableInstance = $2eb97388ec83477c$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $2eb97388ec83477c$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $2eb97388ec83477c$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2eb97388ec83477c$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $2eb97388ec83477c$var$dispatchSetState.bind(null, $2eb97388ec83477c$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $2eb97388ec83477c$var$mountStateImpl(!1);
    inRootOrSingleton = $2eb97388ec83477c$var$dispatchOptimisticSetState.bind(null, $2eb97388ec83477c$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $2eb97388ec83477c$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $2eb97388ec83477c$var$dispatchActionState.bind(null, $2eb97388ec83477c$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $2eb97388ec83477c$var$updateActionState(action) {
    var stateHook = $2eb97388ec83477c$var$updateWorkInProgressHook();
    return $2eb97388ec83477c$var$updateActionStateImpl(stateHook, $2eb97388ec83477c$var$currentHook, action);
}
function $2eb97388ec83477c$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $2eb97388ec83477c$var$updateReducerImpl(stateHook, currentStateHook, $2eb97388ec83477c$var$actionStateReducer)[0];
    stateHook = $2eb97388ec83477c$var$updateReducer($2eb97388ec83477c$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $2eb97388ec83477c$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $2eb97388ec83477c$var$SuspenseException) throw $2eb97388ec83477c$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $2eb97388ec83477c$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($2eb97388ec83477c$var$currentlyRenderingFiber.flags |= 2048, $2eb97388ec83477c$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $2eb97388ec83477c$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $2eb97388ec83477c$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $2eb97388ec83477c$var$rerenderActionState(action) {
    var stateHook = $2eb97388ec83477c$var$updateWorkInProgressHook(), currentStateHook = $2eb97388ec83477c$var$currentHook;
    if (null !== currentStateHook) return $2eb97388ec83477c$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $2eb97388ec83477c$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $2eb97388ec83477c$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $2eb97388ec83477c$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $2eb97388ec83477c$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $2eb97388ec83477c$var$createFunctionComponentUpdateQueue(), $2eb97388ec83477c$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $2eb97388ec83477c$var$updateRef() {
    return $2eb97388ec83477c$var$updateWorkInProgressHook().memoizedState;
}
function $2eb97388ec83477c$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $2eb97388ec83477c$var$mountWorkInProgressHook();
    $2eb97388ec83477c$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $2eb97388ec83477c$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $2eb97388ec83477c$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $2eb97388ec83477c$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $2eb97388ec83477c$var$currentHook && null !== deps && $2eb97388ec83477c$var$areHookInputsEqual(deps, $2eb97388ec83477c$var$currentHook.memoizedState.deps) ? hook.memoizedState = $2eb97388ec83477c$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($2eb97388ec83477c$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $2eb97388ec83477c$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $2eb97388ec83477c$var$mountEffect(create, deps) {
    $2eb97388ec83477c$var$mountEffectImpl(8390656, 8, create, deps);
}
function $2eb97388ec83477c$var$updateEffect(create, deps) {
    $2eb97388ec83477c$var$updateEffectImpl(2048, 8, create, deps);
}
function $2eb97388ec83477c$var$useEffectEventImpl(payload) {
    $2eb97388ec83477c$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $2eb97388ec83477c$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $2eb97388ec83477c$var$createFunctionComponentUpdateQueue(), $2eb97388ec83477c$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $2eb97388ec83477c$var$updateEvent(callback) {
    var ref = $2eb97388ec83477c$var$updateWorkInProgressHook().memoizedState;
    $2eb97388ec83477c$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($2eb97388ec83477c$var$executionContext & 2)) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $2eb97388ec83477c$var$updateInsertionEffect(create, deps) {
    return $2eb97388ec83477c$var$updateEffectImpl(4, 2, create, deps);
}
function $2eb97388ec83477c$var$updateLayoutEffect(create, deps) {
    return $2eb97388ec83477c$var$updateEffectImpl(4, 4, create, deps);
}
function $2eb97388ec83477c$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $2eb97388ec83477c$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $2eb97388ec83477c$var$updateEffectImpl(4, 4, $2eb97388ec83477c$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $2eb97388ec83477c$var$mountDebugValue() {}
function $2eb97388ec83477c$var$updateCallback(callback, deps) {
    var hook = $2eb97388ec83477c$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $2eb97388ec83477c$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $2eb97388ec83477c$var$updateMemo(nextCreate, deps) {
    var hook = $2eb97388ec83477c$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $2eb97388ec83477c$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($2eb97388ec83477c$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $2eb97388ec83477c$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $2eb97388ec83477c$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $2eb97388ec83477c$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($2eb97388ec83477c$var$renderLanes & 1073741824) && 0 === ($2eb97388ec83477c$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $2eb97388ec83477c$var$requestDeferredLane();
    $2eb97388ec83477c$var$currentlyRenderingFiber.lanes |= hook;
    $2eb97388ec83477c$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $2eb97388ec83477c$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($2eb97388ec83477c$var$objectIs(value, prevValue)) return value;
    if (null !== $2eb97388ec83477c$var$currentTreeHiddenStackCursor.current) return hook = $2eb97388ec83477c$var$mountDeferredValueImpl(hook, value, initialValue), $2eb97388ec83477c$var$objectIs(hook, prevValue) || ($2eb97388ec83477c$var$didReceiveUpdate = !0), hook;
    if (0 === ($2eb97388ec83477c$var$renderLanes & 42) || 0 !== ($2eb97388ec83477c$var$renderLanes & 1073741824) && 0 === ($2eb97388ec83477c$var$workInProgressRootRenderLanes & 261930)) return $2eb97388ec83477c$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $2eb97388ec83477c$var$requestDeferredLane();
    $2eb97388ec83477c$var$currentlyRenderingFiber.lanes |= hook;
    $2eb97388ec83477c$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $2eb97388ec83477c$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $2eb97388ec83477c$var$ReactDOMSharedInternals.p;
    $2eb97388ec83477c$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $2eb97388ec83477c$var$ReactSharedInternals.T, currentTransition = {};
    $2eb97388ec83477c$var$ReactSharedInternals.T = currentTransition;
    $2eb97388ec83477c$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $2eb97388ec83477c$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $2eb97388ec83477c$var$chainThenableValue(returnValue, finishedState);
            $2eb97388ec83477c$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $2eb97388ec83477c$var$requestUpdateLane(fiber));
        } else $2eb97388ec83477c$var$dispatchSetStateInternal(fiber, queue, finishedState, $2eb97388ec83477c$var$requestUpdateLane(fiber));
    } catch (error) {
        $2eb97388ec83477c$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $2eb97388ec83477c$var$requestUpdateLane());
    } finally{
        $2eb97388ec83477c$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $2eb97388ec83477c$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2eb97388ec83477c$var$noop() {}
function $2eb97388ec83477c$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(476));
    var queue = $2eb97388ec83477c$var$ensureFormComponentIsStateful(formFiber).queue;
    $2eb97388ec83477c$var$startTransition(formFiber, queue, pendingState, $2eb97388ec83477c$var$sharedNotPendingObject, null === action ? $2eb97388ec83477c$var$noop : function() {
        $2eb97388ec83477c$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $2eb97388ec83477c$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $2eb97388ec83477c$var$sharedNotPendingObject,
        baseState: $2eb97388ec83477c$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $2eb97388ec83477c$var$basicStateReducer,
            lastRenderedState: $2eb97388ec83477c$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $2eb97388ec83477c$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $2eb97388ec83477c$var$requestFormReset$1(formFiber) {
    var stateHook = $2eb97388ec83477c$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $2eb97388ec83477c$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $2eb97388ec83477c$var$requestUpdateLane());
}
function $2eb97388ec83477c$var$useHostTransitionStatus() {
    return $2eb97388ec83477c$var$readContext($2eb97388ec83477c$var$HostTransitionContext);
}
function $2eb97388ec83477c$var$updateId() {
    return $2eb97388ec83477c$var$updateWorkInProgressHook().memoizedState;
}
function $2eb97388ec83477c$var$updateRefresh() {
    return $2eb97388ec83477c$var$updateWorkInProgressHook().memoizedState;
}
function $2eb97388ec83477c$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $2eb97388ec83477c$var$requestUpdateLane();
                fiber = $2eb97388ec83477c$var$createUpdate(lane);
                var root$69 = $2eb97388ec83477c$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($2eb97388ec83477c$var$scheduleUpdateOnFiber(root$69, provider, lane), $2eb97388ec83477c$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $2eb97388ec83477c$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $2eb97388ec83477c$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $2eb97388ec83477c$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $2eb97388ec83477c$var$isRenderPhaseUpdate(fiber) ? $2eb97388ec83477c$var$enqueueRenderPhaseUpdate(queue, action) : (action = $2eb97388ec83477c$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($2eb97388ec83477c$var$scheduleUpdateOnFiber(action, fiber, lane), $2eb97388ec83477c$var$entangleTransitionUpdate(action, queue, lane)));
}
function $2eb97388ec83477c$var$dispatchSetState(fiber, queue, action) {
    var lane = $2eb97388ec83477c$var$requestUpdateLane();
    $2eb97388ec83477c$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $2eb97388ec83477c$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2eb97388ec83477c$var$isRenderPhaseUpdate(fiber)) $2eb97388ec83477c$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($2eb97388ec83477c$var$objectIs(eagerState, currentState)) return $2eb97388ec83477c$var$enqueueUpdate$1(fiber, queue, update, 0), null === $2eb97388ec83477c$var$workInProgressRoot && $2eb97388ec83477c$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $2eb97388ec83477c$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $2eb97388ec83477c$var$scheduleUpdateOnFiber(action, fiber, lane), $2eb97388ec83477c$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $2eb97388ec83477c$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $2eb97388ec83477c$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2eb97388ec83477c$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $2eb97388ec83477c$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $2eb97388ec83477c$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $2eb97388ec83477c$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $2eb97388ec83477c$var$currentlyRenderingFiber || null !== alternate && alternate === $2eb97388ec83477c$var$currentlyRenderingFiber;
}
function $2eb97388ec83477c$var$enqueueRenderPhaseUpdate(queue, update) {
    $2eb97388ec83477c$var$didScheduleRenderPhaseUpdateDuringThisPass = $2eb97388ec83477c$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $2eb97388ec83477c$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $2eb97388ec83477c$var$markRootEntangled(root, lane);
    }
}
var $2eb97388ec83477c$var$ContextOnlyDispatcher = {
    readContext: $2eb97388ec83477c$var$readContext,
    use: $2eb97388ec83477c$var$use,
    useCallback: $2eb97388ec83477c$var$throwInvalidHookError,
    useContext: $2eb97388ec83477c$var$throwInvalidHookError,
    useEffect: $2eb97388ec83477c$var$throwInvalidHookError,
    useImperativeHandle: $2eb97388ec83477c$var$throwInvalidHookError,
    useLayoutEffect: $2eb97388ec83477c$var$throwInvalidHookError,
    useInsertionEffect: $2eb97388ec83477c$var$throwInvalidHookError,
    useMemo: $2eb97388ec83477c$var$throwInvalidHookError,
    useReducer: $2eb97388ec83477c$var$throwInvalidHookError,
    useRef: $2eb97388ec83477c$var$throwInvalidHookError,
    useState: $2eb97388ec83477c$var$throwInvalidHookError,
    useDebugValue: $2eb97388ec83477c$var$throwInvalidHookError,
    useDeferredValue: $2eb97388ec83477c$var$throwInvalidHookError,
    useTransition: $2eb97388ec83477c$var$throwInvalidHookError,
    useSyncExternalStore: $2eb97388ec83477c$var$throwInvalidHookError,
    useId: $2eb97388ec83477c$var$throwInvalidHookError,
    useHostTransitionStatus: $2eb97388ec83477c$var$throwInvalidHookError,
    useFormState: $2eb97388ec83477c$var$throwInvalidHookError,
    useActionState: $2eb97388ec83477c$var$throwInvalidHookError,
    useOptimistic: $2eb97388ec83477c$var$throwInvalidHookError,
    useMemoCache: $2eb97388ec83477c$var$throwInvalidHookError,
    useCacheRefresh: $2eb97388ec83477c$var$throwInvalidHookError
};
$2eb97388ec83477c$var$ContextOnlyDispatcher.useEffectEvent = $2eb97388ec83477c$var$throwInvalidHookError;
var $2eb97388ec83477c$var$HooksDispatcherOnMount = {
    readContext: $2eb97388ec83477c$var$readContext,
    use: $2eb97388ec83477c$var$use,
    useCallback: function(callback, deps) {
        $2eb97388ec83477c$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $2eb97388ec83477c$var$readContext,
    useEffect: $2eb97388ec83477c$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $2eb97388ec83477c$var$mountEffectImpl(4194308, 4, $2eb97388ec83477c$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $2eb97388ec83477c$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $2eb97388ec83477c$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $2eb97388ec83477c$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($2eb97388ec83477c$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $2eb97388ec83477c$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $2eb97388ec83477c$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $2eb97388ec83477c$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($2eb97388ec83477c$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $2eb97388ec83477c$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $2eb97388ec83477c$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $2eb97388ec83477c$var$dispatchReducerAction.bind(null, $2eb97388ec83477c$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $2eb97388ec83477c$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $2eb97388ec83477c$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $2eb97388ec83477c$var$dispatchSetState.bind(null, $2eb97388ec83477c$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $2eb97388ec83477c$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $2eb97388ec83477c$var$mountWorkInProgressHook();
        return $2eb97388ec83477c$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $2eb97388ec83477c$var$mountStateImpl(!1);
        stateHook = $2eb97388ec83477c$var$startTransition.bind(null, $2eb97388ec83477c$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $2eb97388ec83477c$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $2eb97388ec83477c$var$currentlyRenderingFiber, hook = $2eb97388ec83477c$var$mountWorkInProgressHook();
        if ($2eb97388ec83477c$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $2eb97388ec83477c$var$workInProgressRoot) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(349));
            0 !== ($2eb97388ec83477c$var$workInProgressRootRenderLanes & 127) || $2eb97388ec83477c$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $2eb97388ec83477c$var$mountEffect($2eb97388ec83477c$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $2eb97388ec83477c$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $2eb97388ec83477c$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $2eb97388ec83477c$var$mountWorkInProgressHook(), identifierPrefix = $2eb97388ec83477c$var$workInProgressRoot.identifierPrefix;
        if ($2eb97388ec83477c$var$isHydrating) {
            var JSCompiler_inline_result = $2eb97388ec83477c$var$treeContextOverflow;
            var idWithLeadingBit = $2eb97388ec83477c$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $2eb97388ec83477c$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $2eb97388ec83477c$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $2eb97388ec83477c$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $2eb97388ec83477c$var$useHostTransitionStatus,
    useFormState: $2eb97388ec83477c$var$mountActionState,
    useActionState: $2eb97388ec83477c$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $2eb97388ec83477c$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $2eb97388ec83477c$var$dispatchOptimisticSetState.bind(null, $2eb97388ec83477c$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $2eb97388ec83477c$var$useMemoCache,
    useCacheRefresh: function() {
        return $2eb97388ec83477c$var$mountWorkInProgressHook().memoizedState = $2eb97388ec83477c$var$refreshCache.bind(null, $2eb97388ec83477c$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $2eb97388ec83477c$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($2eb97388ec83477c$var$executionContext & 2)) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $2eb97388ec83477c$var$HooksDispatcherOnUpdate = {
    readContext: $2eb97388ec83477c$var$readContext,
    use: $2eb97388ec83477c$var$use,
    useCallback: $2eb97388ec83477c$var$updateCallback,
    useContext: $2eb97388ec83477c$var$readContext,
    useEffect: $2eb97388ec83477c$var$updateEffect,
    useImperativeHandle: $2eb97388ec83477c$var$updateImperativeHandle,
    useInsertionEffect: $2eb97388ec83477c$var$updateInsertionEffect,
    useLayoutEffect: $2eb97388ec83477c$var$updateLayoutEffect,
    useMemo: $2eb97388ec83477c$var$updateMemo,
    useReducer: $2eb97388ec83477c$var$updateReducer,
    useRef: $2eb97388ec83477c$var$updateRef,
    useState: function() {
        return $2eb97388ec83477c$var$updateReducer($2eb97388ec83477c$var$basicStateReducer);
    },
    useDebugValue: $2eb97388ec83477c$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $2eb97388ec83477c$var$updateWorkInProgressHook();
        return $2eb97388ec83477c$var$updateDeferredValueImpl(hook, $2eb97388ec83477c$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $2eb97388ec83477c$var$updateReducer($2eb97388ec83477c$var$basicStateReducer)[0], start = $2eb97388ec83477c$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $2eb97388ec83477c$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $2eb97388ec83477c$var$updateSyncExternalStore,
    useId: $2eb97388ec83477c$var$updateId,
    useHostTransitionStatus: $2eb97388ec83477c$var$useHostTransitionStatus,
    useFormState: $2eb97388ec83477c$var$updateActionState,
    useActionState: $2eb97388ec83477c$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $2eb97388ec83477c$var$updateWorkInProgressHook();
        return $2eb97388ec83477c$var$updateOptimisticImpl(hook, $2eb97388ec83477c$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $2eb97388ec83477c$var$useMemoCache,
    useCacheRefresh: $2eb97388ec83477c$var$updateRefresh
};
$2eb97388ec83477c$var$HooksDispatcherOnUpdate.useEffectEvent = $2eb97388ec83477c$var$updateEvent;
var $2eb97388ec83477c$var$HooksDispatcherOnRerender = {
    readContext: $2eb97388ec83477c$var$readContext,
    use: $2eb97388ec83477c$var$use,
    useCallback: $2eb97388ec83477c$var$updateCallback,
    useContext: $2eb97388ec83477c$var$readContext,
    useEffect: $2eb97388ec83477c$var$updateEffect,
    useImperativeHandle: $2eb97388ec83477c$var$updateImperativeHandle,
    useInsertionEffect: $2eb97388ec83477c$var$updateInsertionEffect,
    useLayoutEffect: $2eb97388ec83477c$var$updateLayoutEffect,
    useMemo: $2eb97388ec83477c$var$updateMemo,
    useReducer: $2eb97388ec83477c$var$rerenderReducer,
    useRef: $2eb97388ec83477c$var$updateRef,
    useState: function() {
        return $2eb97388ec83477c$var$rerenderReducer($2eb97388ec83477c$var$basicStateReducer);
    },
    useDebugValue: $2eb97388ec83477c$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $2eb97388ec83477c$var$updateWorkInProgressHook();
        return null === $2eb97388ec83477c$var$currentHook ? $2eb97388ec83477c$var$mountDeferredValueImpl(hook, value, initialValue) : $2eb97388ec83477c$var$updateDeferredValueImpl(hook, $2eb97388ec83477c$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $2eb97388ec83477c$var$rerenderReducer($2eb97388ec83477c$var$basicStateReducer)[0], start = $2eb97388ec83477c$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $2eb97388ec83477c$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $2eb97388ec83477c$var$updateSyncExternalStore,
    useId: $2eb97388ec83477c$var$updateId,
    useHostTransitionStatus: $2eb97388ec83477c$var$useHostTransitionStatus,
    useFormState: $2eb97388ec83477c$var$rerenderActionState,
    useActionState: $2eb97388ec83477c$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $2eb97388ec83477c$var$updateWorkInProgressHook();
        if (null !== $2eb97388ec83477c$var$currentHook) return $2eb97388ec83477c$var$updateOptimisticImpl(hook, $2eb97388ec83477c$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $2eb97388ec83477c$var$useMemoCache,
    useCacheRefresh: $2eb97388ec83477c$var$updateRefresh
};
$2eb97388ec83477c$var$HooksDispatcherOnRerender.useEffectEvent = $2eb97388ec83477c$var$updateEvent;
function $2eb97388ec83477c$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $2eb97388ec83477c$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $2eb97388ec83477c$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $2eb97388ec83477c$var$requestUpdateLane(), update = $2eb97388ec83477c$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $2eb97388ec83477c$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($2eb97388ec83477c$var$scheduleUpdateOnFiber(payload, inst, lane), $2eb97388ec83477c$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $2eb97388ec83477c$var$requestUpdateLane(), update = $2eb97388ec83477c$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $2eb97388ec83477c$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($2eb97388ec83477c$var$scheduleUpdateOnFiber(payload, inst, lane), $2eb97388ec83477c$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $2eb97388ec83477c$var$requestUpdateLane(), update = $2eb97388ec83477c$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $2eb97388ec83477c$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($2eb97388ec83477c$var$scheduleUpdateOnFiber(callback, inst, lane), $2eb97388ec83477c$var$entangleTransitions(callback, inst, lane));
    }
};
function $2eb97388ec83477c$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$2eb97388ec83477c$var$shallowEqual(oldProps, newProps) || !$2eb97388ec83477c$var$shallowEqual(oldState, newState) : !0;
}
function $2eb97388ec83477c$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $2eb97388ec83477c$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $2eb97388ec83477c$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $2eb97388ec83477c$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $2eb97388ec83477c$var$defaultOnUncaughtError(error) {
    $2eb97388ec83477c$var$reportGlobalError(error);
}
function $2eb97388ec83477c$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $2eb97388ec83477c$var$defaultOnRecoverableError(error) {
    $2eb97388ec83477c$var$reportGlobalError(error);
}
function $2eb97388ec83477c$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $2eb97388ec83477c$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $2eb97388ec83477c$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $2eb97388ec83477c$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $2eb97388ec83477c$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $2eb97388ec83477c$var$createClassErrorUpdate(lane) {
    lane = $2eb97388ec83477c$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $2eb97388ec83477c$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $2eb97388ec83477c$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $2eb97388ec83477c$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $2eb97388ec83477c$var$legacyErrorBoundariesThatAlreadyFailed ? $2eb97388ec83477c$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $2eb97388ec83477c$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $2eb97388ec83477c$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $2eb97388ec83477c$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $2eb97388ec83477c$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $2eb97388ec83477c$var$shellBoundary ? $2eb97388ec83477c$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $2eb97388ec83477c$var$workInProgressRootExitStatus && ($2eb97388ec83477c$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $2eb97388ec83477c$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $2eb97388ec83477c$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $2eb97388ec83477c$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $2eb97388ec83477c$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($2eb97388ec83477c$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $2eb97388ec83477c$var$attachPingListener(root, value, rootRenderLanes);
        $2eb97388ec83477c$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($2eb97388ec83477c$var$isHydrating) return returnFiber = $2eb97388ec83477c$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $2eb97388ec83477c$var$HydrationMismatchException && (root = Error($2eb97388ec83477c$var$formatProdErrorMessage(422), {
        cause: value
    }), $2eb97388ec83477c$var$queueHydrationError($2eb97388ec83477c$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $2eb97388ec83477c$var$HydrationMismatchException && (returnFiber = Error($2eb97388ec83477c$var$formatProdErrorMessage(423), {
        cause: value
    }), $2eb97388ec83477c$var$queueHydrationError($2eb97388ec83477c$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $2eb97388ec83477c$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $2eb97388ec83477c$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $2eb97388ec83477c$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $2eb97388ec83477c$var$workInProgressRootExitStatus && ($2eb97388ec83477c$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($2eb97388ec83477c$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $2eb97388ec83477c$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $2eb97388ec83477c$var$workInProgressRootConcurrentErrors ? $2eb97388ec83477c$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $2eb97388ec83477c$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $2eb97388ec83477c$var$workInProgressRootExitStatus && ($2eb97388ec83477c$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $2eb97388ec83477c$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $2eb97388ec83477c$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $2eb97388ec83477c$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $2eb97388ec83477c$var$legacyErrorBoundariesThatAlreadyFailed || !$2eb97388ec83477c$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $2eb97388ec83477c$var$createClassErrorUpdate(rootRenderLanes), $2eb97388ec83477c$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $2eb97388ec83477c$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $2eb97388ec83477c$var$SelectiveHydrationException = Error($2eb97388ec83477c$var$formatProdErrorMessage(461)), $2eb97388ec83477c$var$didReceiveUpdate = !1;
function $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $2eb97388ec83477c$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $2eb97388ec83477c$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $2eb97388ec83477c$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $2eb97388ec83477c$var$prepareToReadContext(workInProgress);
    nextProps = $2eb97388ec83477c$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $2eb97388ec83477c$var$checkDidRenderIdHook();
    if (null !== current && !$2eb97388ec83477c$var$didReceiveUpdate) return $2eb97388ec83477c$var$bailoutHooks(current, workInProgress, renderLanes), $2eb97388ec83477c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2eb97388ec83477c$var$isHydrating && key && $2eb97388ec83477c$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $2eb97388ec83477c$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$2eb97388ec83477c$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $2eb97388ec83477c$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $2eb97388ec83477c$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$2eb97388ec83477c$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $2eb97388ec83477c$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $2eb97388ec83477c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $2eb97388ec83477c$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $2eb97388ec83477c$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($2eb97388ec83477c$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($2eb97388ec83477c$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $2eb97388ec83477c$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($2eb97388ec83477c$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $2eb97388ec83477c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $2eb97388ec83477c$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $2eb97388ec83477c$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $2eb97388ec83477c$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $2eb97388ec83477c$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $2eb97388ec83477c$var$pushHiddenContext(workInProgress, prevState) : $2eb97388ec83477c$var$reuseHiddenContextOnStack(), $2eb97388ec83477c$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $2eb97388ec83477c$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($2eb97388ec83477c$var$pushTransition(workInProgress, prevState.cachePool), $2eb97388ec83477c$var$pushHiddenContext(workInProgress, prevState), $2eb97388ec83477c$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $2eb97388ec83477c$var$pushTransition(workInProgress, null), $2eb97388ec83477c$var$reuseHiddenContextOnStack(), $2eb97388ec83477c$var$reuseSuspenseHandlerOnStack(workInProgress));
    $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $2eb97388ec83477c$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $2eb97388ec83477c$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $2eb97388ec83477c$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $2eb97388ec83477c$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $2eb97388ec83477c$var$pushTransition(workInProgress, null);
    $2eb97388ec83477c$var$reuseHiddenContextOnStack();
    $2eb97388ec83477c$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $2eb97388ec83477c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $2eb97388ec83477c$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $2eb97388ec83477c$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $2eb97388ec83477c$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $2eb97388ec83477c$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $2eb97388ec83477c$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $2eb97388ec83477c$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $2eb97388ec83477c$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($2eb97388ec83477c$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $2eb97388ec83477c$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $2eb97388ec83477c$var$bailoutOffscreenComponent(null, current);
            $2eb97388ec83477c$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $2eb97388ec83477c$var$nextHydratableInstance) ? (current = $2eb97388ec83477c$var$canHydrateHydrationBoundary(current, $2eb97388ec83477c$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $2eb97388ec83477c$var$treeContextProvider ? {
                    id: $2eb97388ec83477c$var$treeContextId,
                    overflow: $2eb97388ec83477c$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $2eb97388ec83477c$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $2eb97388ec83477c$var$hydrationParentFiber = workInProgress, $2eb97388ec83477c$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $2eb97388ec83477c$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $2eb97388ec83477c$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $2eb97388ec83477c$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $2eb97388ec83477c$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($2eb97388ec83477c$var$formatProdErrorMessage(558));
        } else if ($2eb97388ec83477c$var$didReceiveUpdate || $2eb97388ec83477c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $2eb97388ec83477c$var$didReceiveUpdate || didSuspend) {
            nextProps = $2eb97388ec83477c$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $2eb97388ec83477c$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $2eb97388ec83477c$var$enqueueConcurrentRenderForLane(current, dehydrated), $2eb97388ec83477c$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $2eb97388ec83477c$var$SelectiveHydrationException;
            $2eb97388ec83477c$var$renderDidSuspendDelayIfPossible();
            workInProgress = $2eb97388ec83477c$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $2eb97388ec83477c$var$nextHydratableInstance = $2eb97388ec83477c$var$getNextHydratable(dehydrated.nextSibling), $2eb97388ec83477c$var$hydrationParentFiber = workInProgress, $2eb97388ec83477c$var$isHydrating = !0, $2eb97388ec83477c$var$hydrationErrors = null, $2eb97388ec83477c$var$rootOrSingletonContext = !1, null !== current && $2eb97388ec83477c$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $2eb97388ec83477c$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $2eb97388ec83477c$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $2eb97388ec83477c$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $2eb97388ec83477c$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $2eb97388ec83477c$var$prepareToReadContext(workInProgress);
    Component = $2eb97388ec83477c$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $2eb97388ec83477c$var$checkDidRenderIdHook();
    if (null !== current && !$2eb97388ec83477c$var$didReceiveUpdate) return $2eb97388ec83477c$var$bailoutHooks(current, workInProgress, renderLanes), $2eb97388ec83477c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2eb97388ec83477c$var$isHydrating && nextProps && $2eb97388ec83477c$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $2eb97388ec83477c$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $2eb97388ec83477c$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $2eb97388ec83477c$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $2eb97388ec83477c$var$finishRenderingHooks(current);
    Component = $2eb97388ec83477c$var$checkDidRenderIdHook();
    if (null !== current && !$2eb97388ec83477c$var$didReceiveUpdate) return $2eb97388ec83477c$var$bailoutHooks(current, workInProgress, renderLanes), $2eb97388ec83477c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2eb97388ec83477c$var$isHydrating && Component && $2eb97388ec83477c$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $2eb97388ec83477c$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $2eb97388ec83477c$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $2eb97388ec83477c$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $2eb97388ec83477c$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $2eb97388ec83477c$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $2eb97388ec83477c$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $2eb97388ec83477c$var$readContext(contextType) : $2eb97388ec83477c$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($2eb97388ec83477c$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $2eb97388ec83477c$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $2eb97388ec83477c$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $2eb97388ec83477c$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $2eb97388ec83477c$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $2eb97388ec83477c$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $2eb97388ec83477c$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $2eb97388ec83477c$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $2eb97388ec83477c$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $2eb97388ec83477c$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $2eb97388ec83477c$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $2eb97388ec83477c$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($2eb97388ec83477c$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $2eb97388ec83477c$var$hasForceUpdate || $2eb97388ec83477c$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $2eb97388ec83477c$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $2eb97388ec83477c$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $2eb97388ec83477c$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $2eb97388ec83477c$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $2eb97388ec83477c$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $2eb97388ec83477c$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $2eb97388ec83477c$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $2eb97388ec83477c$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $2eb97388ec83477c$var$hasForceUpdate || null !== current && null !== current.dependencies && $2eb97388ec83477c$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($2eb97388ec83477c$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $2eb97388ec83477c$var$hasForceUpdate || $2eb97388ec83477c$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $2eb97388ec83477c$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $2eb97388ec83477c$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $2eb97388ec83477c$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $2eb97388ec83477c$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $2eb97388ec83477c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $2eb97388ec83477c$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $2eb97388ec83477c$var$resetHydrationState();
    workInProgress.flags |= 256;
    $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $2eb97388ec83477c$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $2eb97388ec83477c$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $2eb97388ec83477c$var$getSuspendedCache()
    };
}
function $2eb97388ec83477c$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $2eb97388ec83477c$var$workInProgressDeferredLane);
    return current;
}
function $2eb97388ec83477c$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($2eb97388ec83477c$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($2eb97388ec83477c$var$isHydrating) {
            showFallback ? $2eb97388ec83477c$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $2eb97388ec83477c$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $2eb97388ec83477c$var$nextHydratableInstance) ? (current = $2eb97388ec83477c$var$canHydrateHydrationBoundary(current, $2eb97388ec83477c$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $2eb97388ec83477c$var$treeContextProvider ? {
                    id: $2eb97388ec83477c$var$treeContextId,
                    overflow: $2eb97388ec83477c$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $2eb97388ec83477c$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $2eb97388ec83477c$var$hydrationParentFiber = workInProgress, $2eb97388ec83477c$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $2eb97388ec83477c$var$throwOnHydrationMismatch(workInProgress);
            $2eb97388ec83477c$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $2eb97388ec83477c$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $2eb97388ec83477c$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $2eb97388ec83477c$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $2eb97388ec83477c$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $2eb97388ec83477c$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2eb97388ec83477c$var$SUSPENDED_MARKER, $2eb97388ec83477c$var$bailoutOffscreenComponent(null, nextProps);
        $2eb97388ec83477c$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $2eb97388ec83477c$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($2eb97388ec83477c$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $2eb97388ec83477c$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($2eb97388ec83477c$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($2eb97388ec83477c$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $2eb97388ec83477c$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $2eb97388ec83477c$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $2eb97388ec83477c$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $2eb97388ec83477c$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $2eb97388ec83477c$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2eb97388ec83477c$var$SUSPENDED_MARKER, workInProgress = $2eb97388ec83477c$var$bailoutOffscreenComponent(null, nextProps));
        else if ($2eb97388ec83477c$var$pushPrimaryTreeSuspenseHandler(workInProgress), $2eb97388ec83477c$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($2eb97388ec83477c$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $2eb97388ec83477c$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $2eb97388ec83477c$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($2eb97388ec83477c$var$didReceiveUpdate || $2eb97388ec83477c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $2eb97388ec83477c$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $2eb97388ec83477c$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $2eb97388ec83477c$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $2eb97388ec83477c$var$enqueueConcurrentRenderForLane(current, nextProps), $2eb97388ec83477c$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $2eb97388ec83477c$var$SelectiveHydrationException;
            $2eb97388ec83477c$var$isSuspenseInstancePending(nextPrimaryChildren) || $2eb97388ec83477c$var$renderDidSuspendDelayIfPossible();
            workInProgress = $2eb97388ec83477c$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $2eb97388ec83477c$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $2eb97388ec83477c$var$nextHydratableInstance = $2eb97388ec83477c$var$getNextHydratable(nextPrimaryChildren.nextSibling), $2eb97388ec83477c$var$hydrationParentFiber = workInProgress, $2eb97388ec83477c$var$isHydrating = !0, $2eb97388ec83477c$var$hydrationErrors = null, $2eb97388ec83477c$var$rootOrSingletonContext = !1, null !== current && $2eb97388ec83477c$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $2eb97388ec83477c$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $2eb97388ec83477c$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $2eb97388ec83477c$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $2eb97388ec83477c$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $2eb97388ec83477c$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $2eb97388ec83477c$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $2eb97388ec83477c$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $2eb97388ec83477c$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $2eb97388ec83477c$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $2eb97388ec83477c$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2eb97388ec83477c$var$SUSPENDED_MARKER, $2eb97388ec83477c$var$bailoutOffscreenComponent(current.child, nextProps);
    $2eb97388ec83477c$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $2eb97388ec83477c$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $2eb97388ec83477c$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $2eb97388ec83477c$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $2eb97388ec83477c$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $2eb97388ec83477c$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $2eb97388ec83477c$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $2eb97388ec83477c$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $2eb97388ec83477c$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $2eb97388ec83477c$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $2eb97388ec83477c$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $2eb97388ec83477c$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $2eb97388ec83477c$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $2eb97388ec83477c$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $2eb97388ec83477c$var$push($2eb97388ec83477c$var$suspenseStackCursor, suspenseContext);
    $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $2eb97388ec83477c$var$isHydrating ? $2eb97388ec83477c$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $2eb97388ec83477c$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $2eb97388ec83477c$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $2eb97388ec83477c$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $2eb97388ec83477c$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $2eb97388ec83477c$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $2eb97388ec83477c$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $2eb97388ec83477c$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $2eb97388ec83477c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $2eb97388ec83477c$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($2eb97388ec83477c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $2eb97388ec83477c$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $2eb97388ec83477c$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $2eb97388ec83477c$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $2eb97388ec83477c$var$checkIfContextChanged(current) ? !0 : !1;
}
function $2eb97388ec83477c$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $2eb97388ec83477c$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $2eb97388ec83477c$var$pushProvider(workInProgress, $2eb97388ec83477c$var$CacheContext, current.memoizedState.cache);
            $2eb97388ec83477c$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $2eb97388ec83477c$var$pushHostContext(workInProgress);
            break;
        case 4:
            $2eb97388ec83477c$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $2eb97388ec83477c$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $2eb97388ec83477c$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $2eb97388ec83477c$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $2eb97388ec83477c$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $2eb97388ec83477c$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $2eb97388ec83477c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $2eb97388ec83477c$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($2eb97388ec83477c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $2eb97388ec83477c$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $2eb97388ec83477c$var$push($2eb97388ec83477c$var$suspenseStackCursor, $2eb97388ec83477c$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $2eb97388ec83477c$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $2eb97388ec83477c$var$pushProvider(workInProgress, $2eb97388ec83477c$var$CacheContext, current.memoizedState.cache);
    }
    return $2eb97388ec83477c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $2eb97388ec83477c$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $2eb97388ec83477c$var$didReceiveUpdate = !0;
        else {
            if (!$2eb97388ec83477c$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $2eb97388ec83477c$var$didReceiveUpdate = !1, $2eb97388ec83477c$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $2eb97388ec83477c$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $2eb97388ec83477c$var$didReceiveUpdate = !1, $2eb97388ec83477c$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $2eb97388ec83477c$var$pushTreeId(workInProgress, $2eb97388ec83477c$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $2eb97388ec83477c$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $2eb97388ec83477c$var$shouldConstruct(current) ? (props = $2eb97388ec83477c$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $2eb97388ec83477c$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $2eb97388ec83477c$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $2eb97388ec83477c$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $2eb97388ec83477c$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $2eb97388ec83477c$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $2eb97388ec83477c$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $2eb97388ec83477c$var$getComponentNameFromType(current) || current;
                    throw Error($2eb97388ec83477c$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $2eb97388ec83477c$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $2eb97388ec83477c$var$resolveClassComponentProps(props, workInProgress.pendingProps), $2eb97388ec83477c$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $2eb97388ec83477c$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $2eb97388ec83477c$var$cloneUpdateQueue(current, workInProgress);
                $2eb97388ec83477c$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $2eb97388ec83477c$var$pushProvider(workInProgress, $2eb97388ec83477c$var$CacheContext, props);
                props !== prevState.cache && $2eb97388ec83477c$var$propagateContextChanges(workInProgress, [
                    $2eb97388ec83477c$var$CacheContext
                ], renderLanes, !0);
                $2eb97388ec83477c$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $2eb97388ec83477c$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $2eb97388ec83477c$var$createCapturedValueAtFiber(Error($2eb97388ec83477c$var$formatProdErrorMessage(424)), workInProgress);
                        $2eb97388ec83477c$var$queueHydrationError($$typeof);
                        workInProgress = $2eb97388ec83477c$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $2eb97388ec83477c$var$nextHydratableInstance = $2eb97388ec83477c$var$getNextHydratable(current.firstChild);
                        $2eb97388ec83477c$var$hydrationParentFiber = workInProgress;
                        $2eb97388ec83477c$var$isHydrating = !0;
                        $2eb97388ec83477c$var$hydrationErrors = null;
                        $2eb97388ec83477c$var$rootOrSingletonContext = !0;
                        renderLanes = $2eb97388ec83477c$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $2eb97388ec83477c$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $2eb97388ec83477c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $2eb97388ec83477c$var$markRef(current, workInProgress), null === current ? (renderLanes = $2eb97388ec83477c$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $2eb97388ec83477c$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $2eb97388ec83477c$var$getOwnerDocumentFromRootContainer($2eb97388ec83477c$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$2eb97388ec83477c$var$internalInstanceKey] = workInProgress, props[$2eb97388ec83477c$var$internalPropsKey] = current, $2eb97388ec83477c$var$setInitialProperties(props, renderLanes, current), $2eb97388ec83477c$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $2eb97388ec83477c$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $2eb97388ec83477c$var$pushHostContext(workInProgress), null === current && $2eb97388ec83477c$var$isHydrating && (props = workInProgress.stateNode = $2eb97388ec83477c$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $2eb97388ec83477c$var$rootInstanceStackCursor.current), $2eb97388ec83477c$var$hydrationParentFiber = workInProgress, $2eb97388ec83477c$var$rootOrSingletonContext = !0, $$typeof = $2eb97388ec83477c$var$nextHydratableInstance, $2eb97388ec83477c$var$isSingletonScope(workInProgress.type) ? ($2eb97388ec83477c$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $2eb97388ec83477c$var$nextHydratableInstance = $2eb97388ec83477c$var$getNextHydratable(props.firstChild)) : $2eb97388ec83477c$var$nextHydratableInstance = $$typeof), $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $2eb97388ec83477c$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $2eb97388ec83477c$var$isHydrating) {
                if ($$typeof = props = $2eb97388ec83477c$var$nextHydratableInstance) props = $2eb97388ec83477c$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $2eb97388ec83477c$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $2eb97388ec83477c$var$hydrationParentFiber = workInProgress, $2eb97388ec83477c$var$nextHydratableInstance = $2eb97388ec83477c$var$getNextHydratable(props.firstChild), $2eb97388ec83477c$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $2eb97388ec83477c$var$throwOnHydrationMismatch(workInProgress);
            }
            $2eb97388ec83477c$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $2eb97388ec83477c$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $2eb97388ec83477c$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $2eb97388ec83477c$var$renderWithHooks(current, workInProgress, $2eb97388ec83477c$var$TransitionAwareHostComponent, null, null, renderLanes), $2eb97388ec83477c$var$HostTransitionContext._currentValue = $$typeof);
            $2eb97388ec83477c$var$markRef(current, workInProgress);
            $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $2eb97388ec83477c$var$isHydrating) {
                if (current = renderLanes = $2eb97388ec83477c$var$nextHydratableInstance) renderLanes = $2eb97388ec83477c$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $2eb97388ec83477c$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $2eb97388ec83477c$var$hydrationParentFiber = workInProgress, $2eb97388ec83477c$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $2eb97388ec83477c$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $2eb97388ec83477c$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $2eb97388ec83477c$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $2eb97388ec83477c$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $2eb97388ec83477c$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $2eb97388ec83477c$var$pushProvider(workInProgress, workInProgress.type, props.value), $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $2eb97388ec83477c$var$prepareToReadContext(workInProgress), $$typeof = $2eb97388ec83477c$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $2eb97388ec83477c$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $2eb97388ec83477c$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $2eb97388ec83477c$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $2eb97388ec83477c$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $2eb97388ec83477c$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $2eb97388ec83477c$var$prepareToReadContext(workInProgress), props = $2eb97388ec83477c$var$readContext($2eb97388ec83477c$var$CacheContext), null === current ? ($$typeof = $2eb97388ec83477c$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $2eb97388ec83477c$var$workInProgressRoot, prevState = $2eb97388ec83477c$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $2eb97388ec83477c$var$initializeUpdateQueue(workInProgress), $2eb97388ec83477c$var$pushProvider(workInProgress, $2eb97388ec83477c$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($2eb97388ec83477c$var$cloneUpdateQueue(current, workInProgress), $2eb97388ec83477c$var$processUpdateQueue(workInProgress, null, null, renderLanes), $2eb97388ec83477c$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $2eb97388ec83477c$var$pushProvider(workInProgress, $2eb97388ec83477c$var$CacheContext, props)) : (props = prevState.cache, $2eb97388ec83477c$var$pushProvider(workInProgress, $2eb97388ec83477c$var$CacheContext, props), props !== $$typeof.cache && $2eb97388ec83477c$var$propagateContextChanges(workInProgress, [
                $2eb97388ec83477c$var$CacheContext
            ], renderLanes, !0))), $2eb97388ec83477c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($2eb97388ec83477c$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $2eb97388ec83477c$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $2eb97388ec83477c$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($2eb97388ec83477c$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $2eb97388ec83477c$var$suspendedThenable = $2eb97388ec83477c$var$noopSuspenseyCommitThenable, $2eb97388ec83477c$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $2eb97388ec83477c$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$2eb97388ec83477c$var$preloadResource(resource)) {
        if ($2eb97388ec83477c$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $2eb97388ec83477c$var$suspendedThenable = $2eb97388ec83477c$var$noopSuspenseyCommitThenable, $2eb97388ec83477c$var$SuspenseyCommitException;
    }
}
function $2eb97388ec83477c$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $2eb97388ec83477c$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $2eb97388ec83477c$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $2eb97388ec83477c$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$2eb97388ec83477c$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $2eb97388ec83477c$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $2eb97388ec83477c$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $2eb97388ec83477c$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $2eb97388ec83477c$var$bubbleProperties(workInProgress), null;
        case 1:
            return $2eb97388ec83477c$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $2eb97388ec83477c$var$popProvider($2eb97388ec83477c$var$CacheContext);
            $2eb97388ec83477c$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $2eb97388ec83477c$var$popHydrationState(workInProgress) ? $2eb97388ec83477c$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $2eb97388ec83477c$var$upgradeHydrationErrorsToRecoverable());
            $2eb97388ec83477c$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($2eb97388ec83477c$var$markUpdate(workInProgress), null !== nextResource ? ($2eb97388ec83477c$var$bubbleProperties(workInProgress), $2eb97388ec83477c$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($2eb97388ec83477c$var$bubbleProperties(workInProgress), $2eb97388ec83477c$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($2eb97388ec83477c$var$markUpdate(workInProgress), $2eb97388ec83477c$var$bubbleProperties(workInProgress), $2eb97388ec83477c$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($2eb97388ec83477c$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $2eb97388ec83477c$var$markUpdate(workInProgress), $2eb97388ec83477c$var$bubbleProperties(workInProgress), $2eb97388ec83477c$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $2eb97388ec83477c$var$popHostContext(workInProgress);
            renderLanes = $2eb97388ec83477c$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2eb97388ec83477c$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(166));
                    $2eb97388ec83477c$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $2eb97388ec83477c$var$contextStackCursor.current;
                $2eb97388ec83477c$var$popHydrationState(workInProgress) ? $2eb97388ec83477c$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $2eb97388ec83477c$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $2eb97388ec83477c$var$markUpdate(workInProgress));
            }
            $2eb97388ec83477c$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $2eb97388ec83477c$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2eb97388ec83477c$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(166));
                    $2eb97388ec83477c$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $2eb97388ec83477c$var$contextStackCursor.current;
                if ($2eb97388ec83477c$var$popHydrationState(workInProgress)) $2eb97388ec83477c$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $2eb97388ec83477c$var$getOwnerDocumentFromRootContainer($2eb97388ec83477c$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$2eb97388ec83477c$var$internalInstanceKey] = workInProgress;
                    nextResource[$2eb97388ec83477c$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($2eb97388ec83477c$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $2eb97388ec83477c$var$markUpdate(workInProgress);
                }
            }
            $2eb97388ec83477c$var$bubbleProperties(workInProgress);
            $2eb97388ec83477c$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2eb97388ec83477c$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(166));
                current = $2eb97388ec83477c$var$rootInstanceStackCursor.current;
                if ($2eb97388ec83477c$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $2eb97388ec83477c$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$2eb97388ec83477c$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $2eb97388ec83477c$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $2eb97388ec83477c$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $2eb97388ec83477c$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$2eb97388ec83477c$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $2eb97388ec83477c$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $2eb97388ec83477c$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(557));
                        current[$2eb97388ec83477c$var$internalInstanceKey] = workInProgress;
                    } else $2eb97388ec83477c$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $2eb97388ec83477c$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $2eb97388ec83477c$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $2eb97388ec83477c$var$popSuspenseHandler(workInProgress), workInProgress;
                    $2eb97388ec83477c$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(558));
            }
            $2eb97388ec83477c$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $2eb97388ec83477c$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(317));
                        type[$2eb97388ec83477c$var$internalInstanceKey] = workInProgress;
                    } else $2eb97388ec83477c$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $2eb97388ec83477c$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $2eb97388ec83477c$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $2eb97388ec83477c$var$popSuspenseHandler(workInProgress), workInProgress;
                    $2eb97388ec83477c$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $2eb97388ec83477c$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $2eb97388ec83477c$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $2eb97388ec83477c$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $2eb97388ec83477c$var$popHostContainer(), null === current && $2eb97388ec83477c$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $2eb97388ec83477c$var$bubbleProperties(workInProgress), null;
        case 10:
            return $2eb97388ec83477c$var$popProvider(workInProgress.type), $2eb97388ec83477c$var$bubbleProperties(workInProgress), null;
        case 19:
            $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $2eb97388ec83477c$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $2eb97388ec83477c$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $2eb97388ec83477c$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $2eb97388ec83477c$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $2eb97388ec83477c$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $2eb97388ec83477c$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$2eb97388ec83477c$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $2eb97388ec83477c$var$push($2eb97388ec83477c$var$suspenseStackCursor, $2eb97388ec83477c$var$suspenseStackCursor.current & 1 | 2);
                            $2eb97388ec83477c$var$isHydrating && $2eb97388ec83477c$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $2eb97388ec83477c$var$now() > $2eb97388ec83477c$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $2eb97388ec83477c$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $2eb97388ec83477c$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $2eb97388ec83477c$var$scheduleRetryEffect(workInProgress, current), $2eb97388ec83477c$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$2eb97388ec83477c$var$isHydrating) return $2eb97388ec83477c$var$bubbleProperties(workInProgress), null;
                    } else 2 * $2eb97388ec83477c$var$now() - newProps.renderingStartTime > $2eb97388ec83477c$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $2eb97388ec83477c$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $2eb97388ec83477c$var$now(), current.sibling = null, renderLanes = $2eb97388ec83477c$var$suspenseStackCursor.current, $2eb97388ec83477c$var$push($2eb97388ec83477c$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $2eb97388ec83477c$var$isHydrating && $2eb97388ec83477c$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $2eb97388ec83477c$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $2eb97388ec83477c$var$popSuspenseHandler(workInProgress), $2eb97388ec83477c$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($2eb97388ec83477c$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $2eb97388ec83477c$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $2eb97388ec83477c$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $2eb97388ec83477c$var$popProvider($2eb97388ec83477c$var$CacheContext), $2eb97388ec83477c$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($2eb97388ec83477c$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $2eb97388ec83477c$var$unwindWork(current, workInProgress) {
    $2eb97388ec83477c$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $2eb97388ec83477c$var$popProvider($2eb97388ec83477c$var$CacheContext), $2eb97388ec83477c$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $2eb97388ec83477c$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $2eb97388ec83477c$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(340));
                $2eb97388ec83477c$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $2eb97388ec83477c$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(340));
                $2eb97388ec83477c$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$suspenseStackCursor), null;
        case 4:
            return $2eb97388ec83477c$var$popHostContainer(), null;
        case 10:
            return $2eb97388ec83477c$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $2eb97388ec83477c$var$popSuspenseHandler(workInProgress), $2eb97388ec83477c$var$popHiddenContext(), null !== current && $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $2eb97388ec83477c$var$popProvider($2eb97388ec83477c$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $2eb97388ec83477c$var$unwindInterruptedWork(current, interruptedWork) {
    $2eb97388ec83477c$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $2eb97388ec83477c$var$popProvider($2eb97388ec83477c$var$CacheContext);
            $2eb97388ec83477c$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $2eb97388ec83477c$var$popHostContext(interruptedWork);
            break;
        case 4:
            $2eb97388ec83477c$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $2eb97388ec83477c$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $2eb97388ec83477c$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$suspenseStackCursor);
            break;
        case 10:
            $2eb97388ec83477c$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $2eb97388ec83477c$var$popSuspenseHandler(interruptedWork);
            $2eb97388ec83477c$var$popHiddenContext();
            null !== current && $2eb97388ec83477c$var$pop($2eb97388ec83477c$var$resumedCache);
            break;
        case 24:
            $2eb97388ec83477c$var$popProvider($2eb97388ec83477c$var$CacheContext);
    }
}
function $2eb97388ec83477c$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2eb97388ec83477c$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $2eb97388ec83477c$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2eb97388ec83477c$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $2eb97388ec83477c$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $2eb97388ec83477c$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $2eb97388ec83477c$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $2eb97388ec83477c$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $2eb97388ec83477c$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $2eb97388ec83477c$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $2eb97388ec83477c$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $2eb97388ec83477c$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $2eb97388ec83477c$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $2eb97388ec83477c$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2eb97388ec83477c$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $2eb97388ec83477c$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$2eb97388ec83477c$var$internalPropsKey] = newProps;
    } catch (error) {
        $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2eb97388ec83477c$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $2eb97388ec83477c$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $2eb97388ec83477c$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $2eb97388ec83477c$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $2eb97388ec83477c$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $2eb97388ec83477c$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $2eb97388ec83477c$var$noop$1));
    else if (4 !== tag && (27 === tag && $2eb97388ec83477c$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($2eb97388ec83477c$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$2eb97388ec83477c$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $2eb97388ec83477c$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $2eb97388ec83477c$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($2eb97388ec83477c$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$2eb97388ec83477c$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $2eb97388ec83477c$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $2eb97388ec83477c$var$setInitialProperties(singleton, type, props);
        singleton[$2eb97388ec83477c$var$internalInstanceKey] = finishedWork;
        singleton[$2eb97388ec83477c$var$internalPropsKey] = props;
    } catch (error) {
        $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $2eb97388ec83477c$var$offscreenSubtreeIsHidden = !1, $2eb97388ec83477c$var$offscreenSubtreeWasHidden = !1, $2eb97388ec83477c$var$needsFormReset = !1, $2eb97388ec83477c$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $2eb97388ec83477c$var$nextEffect = null;
function $2eb97388ec83477c$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $2eb97388ec83477c$var$eventsEnabled = $2eb97388ec83477c$var$_enabled;
    root = $2eb97388ec83477c$var$getActiveElementDeep(root);
    if ($2eb97388ec83477c$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $2eb97388ec83477c$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $2eb97388ec83477c$var$_enabled = !1;
    for($2eb97388ec83477c$var$nextEffect = firstChild; null !== $2eb97388ec83477c$var$nextEffect;)if (firstChild = $2eb97388ec83477c$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $2eb97388ec83477c$var$nextEffect = root;
    else for(; null !== $2eb97388ec83477c$var$nextEffect;){
        firstChild = $2eb97388ec83477c$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $2eb97388ec83477c$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $2eb97388ec83477c$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $2eb97388ec83477c$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $2eb97388ec83477c$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $2eb97388ec83477c$var$nextEffect = root;
            break;
        }
        $2eb97388ec83477c$var$nextEffect = firstChild.return;
    }
}
function $2eb97388ec83477c$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2eb97388ec83477c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $2eb97388ec83477c$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $2eb97388ec83477c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $2eb97388ec83477c$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $2eb97388ec83477c$var$commitClassCallbacks(finishedWork);
            flags & 512 && $2eb97388ec83477c$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $2eb97388ec83477c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $2eb97388ec83477c$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $2eb97388ec83477c$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $2eb97388ec83477c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $2eb97388ec83477c$var$commitHostMount(finishedWork);
            flags & 512 && $2eb97388ec83477c$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $2eb97388ec83477c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $2eb97388ec83477c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $2eb97388ec83477c$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $2eb97388ec83477c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $2eb97388ec83477c$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $2eb97388ec83477c$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $2eb97388ec83477c$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $2eb97388ec83477c$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $2eb97388ec83477c$var$offscreenSubtreeWasHidden;
                prevProps = $2eb97388ec83477c$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $2eb97388ec83477c$var$offscreenSubtreeWasHidden;
                $2eb97388ec83477c$var$offscreenSubtreeIsHidden = flags;
                ($2eb97388ec83477c$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $2eb97388ec83477c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $2eb97388ec83477c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $2eb97388ec83477c$var$offscreenSubtreeIsHidden = prevProps;
                $2eb97388ec83477c$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $2eb97388ec83477c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $2eb97388ec83477c$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $2eb97388ec83477c$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $2eb97388ec83477c$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $2eb97388ec83477c$var$hostParent = null, $2eb97388ec83477c$var$hostParentIsContainer = !1;
function $2eb97388ec83477c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$2eb97388ec83477c$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $2eb97388ec83477c$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($2eb97388ec83477c$var$injectedHook && "function" === typeof $2eb97388ec83477c$var$injectedHook.onCommitFiberUnmount) try {
        $2eb97388ec83477c$var$injectedHook.onCommitFiberUnmount($2eb97388ec83477c$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $2eb97388ec83477c$var$offscreenSubtreeWasHidden || $2eb97388ec83477c$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $2eb97388ec83477c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $2eb97388ec83477c$var$offscreenSubtreeWasHidden || $2eb97388ec83477c$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $2eb97388ec83477c$var$hostParent, prevHostParentIsContainer = $2eb97388ec83477c$var$hostParentIsContainer;
            $2eb97388ec83477c$var$isSingletonScope(deletedFiber.type) && ($2eb97388ec83477c$var$hostParent = deletedFiber.stateNode, $2eb97388ec83477c$var$hostParentIsContainer = !1);
            $2eb97388ec83477c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2eb97388ec83477c$var$releaseSingletonInstance(deletedFiber.stateNode);
            $2eb97388ec83477c$var$hostParent = prevHostParent;
            $2eb97388ec83477c$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $2eb97388ec83477c$var$offscreenSubtreeWasHidden || $2eb97388ec83477c$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $2eb97388ec83477c$var$hostParent;
            prevHostParentIsContainer = $2eb97388ec83477c$var$hostParentIsContainer;
            $2eb97388ec83477c$var$hostParent = null;
            $2eb97388ec83477c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2eb97388ec83477c$var$hostParent = prevHostParent;
            $2eb97388ec83477c$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $2eb97388ec83477c$var$hostParent) {
                if ($2eb97388ec83477c$var$hostParentIsContainer) try {
                    (9 === $2eb97388ec83477c$var$hostParent.nodeType ? $2eb97388ec83477c$var$hostParent.body : "HTML" === $2eb97388ec83477c$var$hostParent.nodeName ? $2eb97388ec83477c$var$hostParent.ownerDocument.body : $2eb97388ec83477c$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $2eb97388ec83477c$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $2eb97388ec83477c$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $2eb97388ec83477c$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $2eb97388ec83477c$var$hostParent && ($2eb97388ec83477c$var$hostParentIsContainer ? (finishedRoot = $2eb97388ec83477c$var$hostParent, $2eb97388ec83477c$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $2eb97388ec83477c$var$retryIfBlockedOn(finishedRoot)) : $2eb97388ec83477c$var$clearHydrationBoundary($2eb97388ec83477c$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $2eb97388ec83477c$var$hostParent;
            prevHostParentIsContainer = $2eb97388ec83477c$var$hostParentIsContainer;
            $2eb97388ec83477c$var$hostParent = deletedFiber.stateNode.containerInfo;
            $2eb97388ec83477c$var$hostParentIsContainer = !0;
            $2eb97388ec83477c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2eb97388ec83477c$var$hostParent = prevHostParent;
            $2eb97388ec83477c$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $2eb97388ec83477c$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $2eb97388ec83477c$var$offscreenSubtreeWasHidden || $2eb97388ec83477c$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $2eb97388ec83477c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $2eb97388ec83477c$var$offscreenSubtreeWasHidden || ($2eb97388ec83477c$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $2eb97388ec83477c$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $2eb97388ec83477c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $2eb97388ec83477c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $2eb97388ec83477c$var$offscreenSubtreeWasHidden = (prevHostParent = $2eb97388ec83477c$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $2eb97388ec83477c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2eb97388ec83477c$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $2eb97388ec83477c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $2eb97388ec83477c$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $2eb97388ec83477c$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $2eb97388ec83477c$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $2eb97388ec83477c$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2eb97388ec83477c$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $2eb97388ec83477c$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $2eb97388ec83477c$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($2eb97388ec83477c$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $2eb97388ec83477c$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $2eb97388ec83477c$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $2eb97388ec83477c$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($2eb97388ec83477c$var$isSingletonScope(parent.type)) {
                        $2eb97388ec83477c$var$hostParent = parent.stateNode;
                        $2eb97388ec83477c$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $2eb97388ec83477c$var$hostParent = parent.stateNode;
                    $2eb97388ec83477c$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $2eb97388ec83477c$var$hostParent = parent.stateNode.containerInfo;
                    $2eb97388ec83477c$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $2eb97388ec83477c$var$hostParent) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(160));
        $2eb97388ec83477c$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $2eb97388ec83477c$var$hostParent = null;
        $2eb97388ec83477c$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$2eb97388ec83477c$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $2eb97388ec83477c$var$currentHoistableRoot = null;
function $2eb97388ec83477c$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($2eb97388ec83477c$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $2eb97388ec83477c$var$commitHookEffectListMount(3, finishedWork), $2eb97388ec83477c$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2eb97388ec83477c$var$offscreenSubtreeWasHidden || null === current || $2eb97388ec83477c$var$safelyDetachRef(current, current.return));
            flags & 64 && $2eb97388ec83477c$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $2eb97388ec83477c$var$currentHoistableRoot;
            $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2eb97388ec83477c$var$offscreenSubtreeWasHidden || null === current || $2eb97388ec83477c$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$2eb97388ec83477c$var$internalHoistableMarker] || currentResource[$2eb97388ec83477c$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $2eb97388ec83477c$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$2eb97388ec83477c$var$internalInstanceKey] = finishedWork;
                                        $2eb97388ec83477c$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $2eb97388ec83477c$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $2eb97388ec83477c$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $2eb97388ec83477c$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $2eb97388ec83477c$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($2eb97388ec83477c$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$2eb97388ec83477c$var$internalInstanceKey] = finishedWork;
                                $2eb97388ec83477c$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $2eb97388ec83477c$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $2eb97388ec83477c$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $2eb97388ec83477c$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $2eb97388ec83477c$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $2eb97388ec83477c$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2eb97388ec83477c$var$offscreenSubtreeWasHidden || null === current || $2eb97388ec83477c$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $2eb97388ec83477c$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2eb97388ec83477c$var$offscreenSubtreeWasHidden || null === current || $2eb97388ec83477c$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $2eb97388ec83477c$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $2eb97388ec83477c$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($2eb97388ec83477c$var$needsFormReset = !0);
            break;
        case 6:
            $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $2eb97388ec83477c$var$tagCaches = null;
            hoistableRoot = $2eb97388ec83477c$var$currentHoistableRoot;
            $2eb97388ec83477c$var$currentHoistableRoot = $2eb97388ec83477c$var$getHoistableRoot(root.containerInfo);
            $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2eb97388ec83477c$var$currentHoistableRoot = hoistableRoot;
            $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $2eb97388ec83477c$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $2eb97388ec83477c$var$needsFormReset && ($2eb97388ec83477c$var$needsFormReset = !1, $2eb97388ec83477c$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $2eb97388ec83477c$var$currentHoistableRoot;
            $2eb97388ec83477c$var$currentHoistableRoot = $2eb97388ec83477c$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork);
            $2eb97388ec83477c$var$currentHoistableRoot = flags;
            break;
        case 12:
            $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $2eb97388ec83477c$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($2eb97388ec83477c$var$globalMostRecentFallbackTime = $2eb97388ec83477c$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $2eb97388ec83477c$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $2eb97388ec83477c$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $2eb97388ec83477c$var$offscreenSubtreeWasHidden;
            $2eb97388ec83477c$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $2eb97388ec83477c$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2eb97388ec83477c$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $2eb97388ec83477c$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $2eb97388ec83477c$var$offscreenSubtreeIsHidden || $2eb97388ec83477c$var$offscreenSubtreeWasHidden || $2eb97388ec83477c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $2eb97388ec83477c$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $2eb97388ec83477c$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $2eb97388ec83477c$var$hideOrUnhideDehydratedBoundary(instance, !0) : $2eb97388ec83477c$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $2eb97388ec83477c$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $2eb97388ec83477c$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $2eb97388ec83477c$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $2eb97388ec83477c$var$recursivelyTraverseMutationEffects(root, finishedWork), $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork);
    }
}
function $2eb97388ec83477c$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($2eb97388ec83477c$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $2eb97388ec83477c$var$getHostSibling(finishedWork);
                    $2eb97388ec83477c$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($2eb97388ec83477c$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $2eb97388ec83477c$var$getHostSibling(finishedWork);
                    $2eb97388ec83477c$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $2eb97388ec83477c$var$getHostSibling(finishedWork);
                    $2eb97388ec83477c$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($2eb97388ec83477c$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $2eb97388ec83477c$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $2eb97388ec83477c$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $2eb97388ec83477c$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$2eb97388ec83477c$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $2eb97388ec83477c$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $2eb97388ec83477c$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $2eb97388ec83477c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $2eb97388ec83477c$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $2eb97388ec83477c$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $2eb97388ec83477c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $2eb97388ec83477c$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $2eb97388ec83477c$var$safelyDetachRef(finishedWork, finishedWork.return);
                $2eb97388ec83477c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $2eb97388ec83477c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $2eb97388ec83477c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $2eb97388ec83477c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2eb97388ec83477c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $2eb97388ec83477c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $2eb97388ec83477c$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $2eb97388ec83477c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $2eb97388ec83477c$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$2eb97388ec83477c$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $2eb97388ec83477c$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $2eb97388ec83477c$var$commitClassCallbacks(finishedWork);
                $2eb97388ec83477c$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $2eb97388ec83477c$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $2eb97388ec83477c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $2eb97388ec83477c$var$commitHostMount(finishedWork);
                $2eb97388ec83477c$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $2eb97388ec83477c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $2eb97388ec83477c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $2eb97388ec83477c$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $2eb97388ec83477c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $2eb97388ec83477c$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $2eb97388ec83477c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $2eb97388ec83477c$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $2eb97388ec83477c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2eb97388ec83477c$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $2eb97388ec83477c$var$releaseCache(previousCache));
}
function $2eb97388ec83477c$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $2eb97388ec83477c$var$releaseCache(current));
}
function $2eb97388ec83477c$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$2eb97388ec83477c$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $2eb97388ec83477c$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2eb97388ec83477c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $2eb97388ec83477c$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $2eb97388ec83477c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $2eb97388ec83477c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $2eb97388ec83477c$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $2eb97388ec83477c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $2eb97388ec83477c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $2eb97388ec83477c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $2eb97388ec83477c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $2eb97388ec83477c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $2eb97388ec83477c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $2eb97388ec83477c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $2eb97388ec83477c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $2eb97388ec83477c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $2eb97388ec83477c$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $2eb97388ec83477c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $2eb97388ec83477c$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $2eb97388ec83477c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $2eb97388ec83477c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $2eb97388ec83477c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $2eb97388ec83477c$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $2eb97388ec83477c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $2eb97388ec83477c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $2eb97388ec83477c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $2eb97388ec83477c$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $2eb97388ec83477c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $2eb97388ec83477c$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $2eb97388ec83477c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2eb97388ec83477c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $2eb97388ec83477c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $2eb97388ec83477c$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $2eb97388ec83477c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $2eb97388ec83477c$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $2eb97388ec83477c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $2eb97388ec83477c$var$suspenseyCommitFlag = 8192;
function $2eb97388ec83477c$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $2eb97388ec83477c$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$2eb97388ec83477c$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $2eb97388ec83477c$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $2eb97388ec83477c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $2eb97388ec83477c$var$suspenseyCommitFlag && null !== fiber.memoizedState && $2eb97388ec83477c$var$suspendResource(suspendedState, $2eb97388ec83477c$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $2eb97388ec83477c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $2eb97388ec83477c$var$currentHoistableRoot;
            $2eb97388ec83477c$var$currentHoistableRoot = $2eb97388ec83477c$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $2eb97388ec83477c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $2eb97388ec83477c$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $2eb97388ec83477c$var$suspenseyCommitFlag, $2eb97388ec83477c$var$suspenseyCommitFlag = 16777216, $2eb97388ec83477c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $2eb97388ec83477c$var$suspenseyCommitFlag = previousHoistableRoot) : $2eb97388ec83477c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $2eb97388ec83477c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $2eb97388ec83477c$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $2eb97388ec83477c$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $2eb97388ec83477c$var$nextEffect = childToDelete;
            $2eb97388ec83477c$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $2eb97388ec83477c$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$2eb97388ec83477c$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $2eb97388ec83477c$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2eb97388ec83477c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $2eb97388ec83477c$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $2eb97388ec83477c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $2eb97388ec83477c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $2eb97388ec83477c$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $2eb97388ec83477c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $2eb97388ec83477c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $2eb97388ec83477c$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $2eb97388ec83477c$var$nextEffect = childToDelete;
            $2eb97388ec83477c$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $2eb97388ec83477c$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $2eb97388ec83477c$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $2eb97388ec83477c$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $2eb97388ec83477c$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $2eb97388ec83477c$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2eb97388ec83477c$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $2eb97388ec83477c$var$nextEffect;){
        var fiber = $2eb97388ec83477c$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $2eb97388ec83477c$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $2eb97388ec83477c$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $2eb97388ec83477c$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $2eb97388ec83477c$var$nextEffect;){
            cache = $2eb97388ec83477c$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $2eb97388ec83477c$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $2eb97388ec83477c$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $2eb97388ec83477c$var$nextEffect = sibling;
                break a;
            }
            $2eb97388ec83477c$var$nextEffect = returnFiber;
        }
    }
}
var $2eb97388ec83477c$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $2eb97388ec83477c$var$readContext($2eb97388ec83477c$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $2eb97388ec83477c$var$readContext($2eb97388ec83477c$var$CacheContext).controller.signal;
    }
}, $2eb97388ec83477c$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $2eb97388ec83477c$var$executionContext = 0, $2eb97388ec83477c$var$workInProgressRoot = null, $2eb97388ec83477c$var$workInProgress = null, $2eb97388ec83477c$var$workInProgressRootRenderLanes = 0, $2eb97388ec83477c$var$workInProgressSuspendedReason = 0, $2eb97388ec83477c$var$workInProgressThrownValue = null, $2eb97388ec83477c$var$workInProgressRootDidSkipSuspendedSiblings = !1, $2eb97388ec83477c$var$workInProgressRootIsPrerendering = !1, $2eb97388ec83477c$var$workInProgressRootDidAttachPingListener = !1, $2eb97388ec83477c$var$entangledRenderLanes = 0, $2eb97388ec83477c$var$workInProgressRootExitStatus = 0, $2eb97388ec83477c$var$workInProgressRootSkippedLanes = 0, $2eb97388ec83477c$var$workInProgressRootInterleavedUpdatedLanes = 0, $2eb97388ec83477c$var$workInProgressRootPingedLanes = 0, $2eb97388ec83477c$var$workInProgressDeferredLane = 0, $2eb97388ec83477c$var$workInProgressSuspendedRetryLanes = 0, $2eb97388ec83477c$var$workInProgressRootConcurrentErrors = null, $2eb97388ec83477c$var$workInProgressRootRecoverableErrors = null, $2eb97388ec83477c$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $2eb97388ec83477c$var$globalMostRecentFallbackTime = 0, $2eb97388ec83477c$var$globalMostRecentTransitionTime = 0, $2eb97388ec83477c$var$workInProgressRootRenderTargetTime = Infinity, $2eb97388ec83477c$var$workInProgressTransitions = null, $2eb97388ec83477c$var$legacyErrorBoundariesThatAlreadyFailed = null, $2eb97388ec83477c$var$pendingEffectsStatus = 0, $2eb97388ec83477c$var$pendingEffectsRoot = null, $2eb97388ec83477c$var$pendingFinishedWork = null, $2eb97388ec83477c$var$pendingEffectsLanes = 0, $2eb97388ec83477c$var$pendingEffectsRemainingLanes = 0, $2eb97388ec83477c$var$pendingPassiveTransitions = null, $2eb97388ec83477c$var$pendingRecoverableErrors = null, $2eb97388ec83477c$var$nestedUpdateCount = 0, $2eb97388ec83477c$var$rootWithNestedUpdates = null;
function $2eb97388ec83477c$var$requestUpdateLane() {
    return 0 !== ($2eb97388ec83477c$var$executionContext & 2) && 0 !== $2eb97388ec83477c$var$workInProgressRootRenderLanes ? $2eb97388ec83477c$var$workInProgressRootRenderLanes & -$2eb97388ec83477c$var$workInProgressRootRenderLanes : null !== $2eb97388ec83477c$var$ReactSharedInternals.T ? $2eb97388ec83477c$var$requestTransitionLane() : $2eb97388ec83477c$var$resolveUpdatePriority();
}
function $2eb97388ec83477c$var$requestDeferredLane() {
    if (0 === $2eb97388ec83477c$var$workInProgressDeferredLane) {
        if (0 === ($2eb97388ec83477c$var$workInProgressRootRenderLanes & 536870912) || $2eb97388ec83477c$var$isHydrating) {
            var lane = $2eb97388ec83477c$var$nextTransitionDeferredLane;
            $2eb97388ec83477c$var$nextTransitionDeferredLane <<= 1;
            0 === ($2eb97388ec83477c$var$nextTransitionDeferredLane & 3932160) && ($2eb97388ec83477c$var$nextTransitionDeferredLane = 262144);
            $2eb97388ec83477c$var$workInProgressDeferredLane = lane;
        } else $2eb97388ec83477c$var$workInProgressDeferredLane = 536870912;
    }
    lane = $2eb97388ec83477c$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $2eb97388ec83477c$var$workInProgressDeferredLane;
}
function $2eb97388ec83477c$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $2eb97388ec83477c$var$workInProgressRoot && (2 === $2eb97388ec83477c$var$workInProgressSuspendedReason || 9 === $2eb97388ec83477c$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $2eb97388ec83477c$var$prepareFreshStack(root, 0), $2eb97388ec83477c$var$markRootSuspended(root, $2eb97388ec83477c$var$workInProgressRootRenderLanes, $2eb97388ec83477c$var$workInProgressDeferredLane, !1);
    $2eb97388ec83477c$var$markRootUpdated$1(root, lane);
    if (0 === ($2eb97388ec83477c$var$executionContext & 2) || root !== $2eb97388ec83477c$var$workInProgressRoot) root === $2eb97388ec83477c$var$workInProgressRoot && (0 === ($2eb97388ec83477c$var$executionContext & 2) && ($2eb97388ec83477c$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $2eb97388ec83477c$var$workInProgressRootExitStatus && $2eb97388ec83477c$var$markRootSuspended(root, $2eb97388ec83477c$var$workInProgressRootRenderLanes, $2eb97388ec83477c$var$workInProgressDeferredLane, !1)), $2eb97388ec83477c$var$ensureRootIsScheduled(root);
}
function $2eb97388ec83477c$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($2eb97388ec83477c$var$executionContext & 6)) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $2eb97388ec83477c$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $2eb97388ec83477c$var$renderRootConcurrent(root$jscomp$0, lanes) : $2eb97388ec83477c$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $2eb97388ec83477c$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $2eb97388ec83477c$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$2eb97388ec83477c$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $2eb97388ec83477c$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $2eb97388ec83477c$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($2eb97388ec83477c$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $2eb97388ec83477c$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($2eb97388ec83477c$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $2eb97388ec83477c$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $2eb97388ec83477c$var$workInProgressRootRecoverableErrors;
                            $2eb97388ec83477c$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $2eb97388ec83477c$var$workInProgressRootRecoverableErrors ? $2eb97388ec83477c$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $2eb97388ec83477c$var$workInProgressRootRecoverableErrors.push.apply($2eb97388ec83477c$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $2eb97388ec83477c$var$prepareFreshStack(root$jscomp$0, 0);
                $2eb97388ec83477c$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($2eb97388ec83477c$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $2eb97388ec83477c$var$markRootSuspended(shouldTimeSlice, lanes, $2eb97388ec83477c$var$workInProgressDeferredLane, !$2eb97388ec83477c$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $2eb97388ec83477c$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($2eb97388ec83477c$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $2eb97388ec83477c$var$globalMostRecentFallbackTime + 300 - $2eb97388ec83477c$var$now(), 10 < exitStatus)) {
                    $2eb97388ec83477c$var$markRootSuspended(shouldTimeSlice, lanes, $2eb97388ec83477c$var$workInProgressDeferredLane, !$2eb97388ec83477c$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $2eb97388ec83477c$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $2eb97388ec83477c$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $2eb97388ec83477c$var$scheduleTimeout($2eb97388ec83477c$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $2eb97388ec83477c$var$workInProgressRootRecoverableErrors, $2eb97388ec83477c$var$workInProgressTransitions, $2eb97388ec83477c$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $2eb97388ec83477c$var$workInProgressDeferredLane, $2eb97388ec83477c$var$workInProgressRootInterleavedUpdatedLanes, $2eb97388ec83477c$var$workInProgressSuspendedRetryLanes, $2eb97388ec83477c$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $2eb97388ec83477c$var$commitRootWhenReady(shouldTimeSlice, forceSync, $2eb97388ec83477c$var$workInProgressRootRecoverableErrors, $2eb97388ec83477c$var$workInProgressTransitions, $2eb97388ec83477c$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $2eb97388ec83477c$var$workInProgressDeferredLane, $2eb97388ec83477c$var$workInProgressRootInterleavedUpdatedLanes, $2eb97388ec83477c$var$workInProgressSuspendedRetryLanes, $2eb97388ec83477c$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $2eb97388ec83477c$var$ensureRootIsScheduled(root$jscomp$0);
}
function $2eb97388ec83477c$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $2eb97388ec83477c$var$noop$1
        };
        $2eb97388ec83477c$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $2eb97388ec83477c$var$globalMostRecentFallbackTime - $2eb97388ec83477c$var$now() : (lanes & 4194048) === lanes ? $2eb97388ec83477c$var$globalMostRecentTransitionTime - $2eb97388ec83477c$var$now() : 0;
        timeoutOffset = $2eb97388ec83477c$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $2eb97388ec83477c$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($2eb97388ec83477c$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $2eb97388ec83477c$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $2eb97388ec83477c$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $2eb97388ec83477c$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$2eb97388ec83477c$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $2eb97388ec83477c$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$2eb97388ec83477c$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$2eb97388ec83477c$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $2eb97388ec83477c$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $2eb97388ec83477c$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $2eb97388ec83477c$var$flushSyncWork$1() {
    return 0 === ($2eb97388ec83477c$var$executionContext & 6) ? ($2eb97388ec83477c$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $2eb97388ec83477c$var$resetWorkInProgressStack() {
    if (null !== $2eb97388ec83477c$var$workInProgress) {
        if (0 === $2eb97388ec83477c$var$workInProgressSuspendedReason) var interruptedWork = $2eb97388ec83477c$var$workInProgress.return;
        else interruptedWork = $2eb97388ec83477c$var$workInProgress, $2eb97388ec83477c$var$lastContextDependency = $2eb97388ec83477c$var$currentlyRenderingFiber$1 = null, $2eb97388ec83477c$var$resetHooksOnUnwind(interruptedWork), $2eb97388ec83477c$var$thenableState$1 = null, $2eb97388ec83477c$var$thenableIndexCounter$1 = 0, interruptedWork = $2eb97388ec83477c$var$workInProgress;
        for(; null !== interruptedWork;)$2eb97388ec83477c$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $2eb97388ec83477c$var$workInProgress = null;
    }
}
function $2eb97388ec83477c$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $2eb97388ec83477c$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $2eb97388ec83477c$var$pendingEffectsLanes = 0;
    $2eb97388ec83477c$var$resetWorkInProgressStack();
    $2eb97388ec83477c$var$workInProgressRoot = root;
    $2eb97388ec83477c$var$workInProgress = timeoutHandle = $2eb97388ec83477c$var$createWorkInProgress(root.current, null);
    $2eb97388ec83477c$var$workInProgressRootRenderLanes = lanes;
    $2eb97388ec83477c$var$workInProgressSuspendedReason = 0;
    $2eb97388ec83477c$var$workInProgressThrownValue = null;
    $2eb97388ec83477c$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $2eb97388ec83477c$var$workInProgressRootIsPrerendering = $2eb97388ec83477c$var$checkIfRootIsPrerendering(root, lanes);
    $2eb97388ec83477c$var$workInProgressRootDidAttachPingListener = !1;
    $2eb97388ec83477c$var$workInProgressSuspendedRetryLanes = $2eb97388ec83477c$var$workInProgressDeferredLane = $2eb97388ec83477c$var$workInProgressRootPingedLanes = $2eb97388ec83477c$var$workInProgressRootInterleavedUpdatedLanes = $2eb97388ec83477c$var$workInProgressRootSkippedLanes = $2eb97388ec83477c$var$workInProgressRootExitStatus = 0;
    $2eb97388ec83477c$var$workInProgressRootRecoverableErrors = $2eb97388ec83477c$var$workInProgressRootConcurrentErrors = null;
    $2eb97388ec83477c$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $2eb97388ec83477c$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $2eb97388ec83477c$var$entangledRenderLanes = lanes;
    $2eb97388ec83477c$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $2eb97388ec83477c$var$handleThrow(root, thrownValue) {
    $2eb97388ec83477c$var$currentlyRenderingFiber = null;
    $2eb97388ec83477c$var$ReactSharedInternals.H = $2eb97388ec83477c$var$ContextOnlyDispatcher;
    thrownValue === $2eb97388ec83477c$var$SuspenseException || thrownValue === $2eb97388ec83477c$var$SuspenseActionException ? (thrownValue = $2eb97388ec83477c$var$getSuspendedThenable(), $2eb97388ec83477c$var$workInProgressSuspendedReason = 3) : thrownValue === $2eb97388ec83477c$var$SuspenseyCommitException ? (thrownValue = $2eb97388ec83477c$var$getSuspendedThenable(), $2eb97388ec83477c$var$workInProgressSuspendedReason = 4) : $2eb97388ec83477c$var$workInProgressSuspendedReason = thrownValue === $2eb97388ec83477c$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $2eb97388ec83477c$var$workInProgressThrownValue = thrownValue;
    null === $2eb97388ec83477c$var$workInProgress && ($2eb97388ec83477c$var$workInProgressRootExitStatus = 1, $2eb97388ec83477c$var$logUncaughtError(root, $2eb97388ec83477c$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $2eb97388ec83477c$var$shouldRemainOnPreviousScreen() {
    var handler = $2eb97388ec83477c$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($2eb97388ec83477c$var$workInProgressRootRenderLanes & 4194048) === $2eb97388ec83477c$var$workInProgressRootRenderLanes ? null === $2eb97388ec83477c$var$shellBoundary ? !0 : !1 : ($2eb97388ec83477c$var$workInProgressRootRenderLanes & 62914560) === $2eb97388ec83477c$var$workInProgressRootRenderLanes || 0 !== ($2eb97388ec83477c$var$workInProgressRootRenderLanes & 536870912) ? handler === $2eb97388ec83477c$var$shellBoundary : !1;
}
function $2eb97388ec83477c$var$pushDispatcher() {
    var prevDispatcher = $2eb97388ec83477c$var$ReactSharedInternals.H;
    $2eb97388ec83477c$var$ReactSharedInternals.H = $2eb97388ec83477c$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $2eb97388ec83477c$var$ContextOnlyDispatcher : prevDispatcher;
}
function $2eb97388ec83477c$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $2eb97388ec83477c$var$ReactSharedInternals.A;
    $2eb97388ec83477c$var$ReactSharedInternals.A = $2eb97388ec83477c$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $2eb97388ec83477c$var$renderDidSuspendDelayIfPossible() {
    $2eb97388ec83477c$var$workInProgressRootExitStatus = 4;
    $2eb97388ec83477c$var$workInProgressRootDidSkipSuspendedSiblings || ($2eb97388ec83477c$var$workInProgressRootRenderLanes & 4194048) !== $2eb97388ec83477c$var$workInProgressRootRenderLanes && null !== $2eb97388ec83477c$var$suspenseHandlerStackCursor.current || ($2eb97388ec83477c$var$workInProgressRootIsPrerendering = !0);
    0 === ($2eb97388ec83477c$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($2eb97388ec83477c$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $2eb97388ec83477c$var$workInProgressRoot || $2eb97388ec83477c$var$markRootSuspended($2eb97388ec83477c$var$workInProgressRoot, $2eb97388ec83477c$var$workInProgressRootRenderLanes, $2eb97388ec83477c$var$workInProgressDeferredLane, !1);
}
function $2eb97388ec83477c$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $2eb97388ec83477c$var$executionContext;
    $2eb97388ec83477c$var$executionContext |= 2;
    var prevDispatcher = $2eb97388ec83477c$var$pushDispatcher(), prevAsyncDispatcher = $2eb97388ec83477c$var$pushAsyncDispatcher();
    if ($2eb97388ec83477c$var$workInProgressRoot !== root || $2eb97388ec83477c$var$workInProgressRootRenderLanes !== lanes) $2eb97388ec83477c$var$workInProgressTransitions = null, $2eb97388ec83477c$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $2eb97388ec83477c$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $2eb97388ec83477c$var$workInProgressSuspendedReason && null !== $2eb97388ec83477c$var$workInProgress) {
            var unitOfWork = $2eb97388ec83477c$var$workInProgress, thrownValue = $2eb97388ec83477c$var$workInProgressThrownValue;
            switch($2eb97388ec83477c$var$workInProgressSuspendedReason){
                case 8:
                    $2eb97388ec83477c$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $2eb97388ec83477c$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $2eb97388ec83477c$var$workInProgressSuspendedReason;
                    $2eb97388ec83477c$var$workInProgressSuspendedReason = 0;
                    $2eb97388ec83477c$var$workInProgressThrownValue = null;
                    $2eb97388ec83477c$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $2eb97388ec83477c$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $2eb97388ec83477c$var$workInProgressSuspendedReason, $2eb97388ec83477c$var$workInProgressSuspendedReason = 0, $2eb97388ec83477c$var$workInProgressThrownValue = null, $2eb97388ec83477c$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $2eb97388ec83477c$var$workLoopSync();
        exitStatus = $2eb97388ec83477c$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $2eb97388ec83477c$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $2eb97388ec83477c$var$lastContextDependency = $2eb97388ec83477c$var$currentlyRenderingFiber$1 = null;
    $2eb97388ec83477c$var$executionContext = prevExecutionContext;
    $2eb97388ec83477c$var$ReactSharedInternals.H = prevDispatcher;
    $2eb97388ec83477c$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $2eb97388ec83477c$var$workInProgress && ($2eb97388ec83477c$var$workInProgressRoot = null, $2eb97388ec83477c$var$workInProgressRootRenderLanes = 0, $2eb97388ec83477c$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $2eb97388ec83477c$var$workLoopSync() {
    for(; null !== $2eb97388ec83477c$var$workInProgress;)$2eb97388ec83477c$var$performUnitOfWork($2eb97388ec83477c$var$workInProgress);
}
function $2eb97388ec83477c$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $2eb97388ec83477c$var$executionContext;
    $2eb97388ec83477c$var$executionContext |= 2;
    var prevDispatcher = $2eb97388ec83477c$var$pushDispatcher(), prevAsyncDispatcher = $2eb97388ec83477c$var$pushAsyncDispatcher();
    $2eb97388ec83477c$var$workInProgressRoot !== root || $2eb97388ec83477c$var$workInProgressRootRenderLanes !== lanes ? ($2eb97388ec83477c$var$workInProgressTransitions = null, $2eb97388ec83477c$var$workInProgressRootRenderTargetTime = $2eb97388ec83477c$var$now() + 500, $2eb97388ec83477c$var$prepareFreshStack(root, lanes)) : $2eb97388ec83477c$var$workInProgressRootIsPrerendering = $2eb97388ec83477c$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $2eb97388ec83477c$var$workInProgressSuspendedReason && null !== $2eb97388ec83477c$var$workInProgress) {
            lanes = $2eb97388ec83477c$var$workInProgress;
            var thrownValue = $2eb97388ec83477c$var$workInProgressThrownValue;
            b: switch($2eb97388ec83477c$var$workInProgressSuspendedReason){
                case 1:
                    $2eb97388ec83477c$var$workInProgressSuspendedReason = 0;
                    $2eb97388ec83477c$var$workInProgressThrownValue = null;
                    $2eb97388ec83477c$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($2eb97388ec83477c$var$isThenableResolved(thrownValue)) {
                        $2eb97388ec83477c$var$workInProgressSuspendedReason = 0;
                        $2eb97388ec83477c$var$workInProgressThrownValue = null;
                        $2eb97388ec83477c$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $2eb97388ec83477c$var$workInProgressSuspendedReason && 9 !== $2eb97388ec83477c$var$workInProgressSuspendedReason || $2eb97388ec83477c$var$workInProgressRoot !== root || ($2eb97388ec83477c$var$workInProgressSuspendedReason = 7);
                        $2eb97388ec83477c$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $2eb97388ec83477c$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $2eb97388ec83477c$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $2eb97388ec83477c$var$isThenableResolved(thrownValue) ? ($2eb97388ec83477c$var$workInProgressSuspendedReason = 0, $2eb97388ec83477c$var$workInProgressThrownValue = null, $2eb97388ec83477c$var$replaySuspendedUnitOfWork(lanes)) : ($2eb97388ec83477c$var$workInProgressSuspendedReason = 0, $2eb97388ec83477c$var$workInProgressThrownValue = null, $2eb97388ec83477c$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($2eb97388ec83477c$var$workInProgress.tag){
                        case 26:
                            resource = $2eb97388ec83477c$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $2eb97388ec83477c$var$workInProgress;
                            if (resource ? $2eb97388ec83477c$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $2eb97388ec83477c$var$workInProgressSuspendedReason = 0;
                                $2eb97388ec83477c$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $2eb97388ec83477c$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($2eb97388ec83477c$var$workInProgress = returnFiber, $2eb97388ec83477c$var$completeUnitOfWork(returnFiber)) : $2eb97388ec83477c$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $2eb97388ec83477c$var$workInProgressSuspendedReason = 0;
                    $2eb97388ec83477c$var$workInProgressThrownValue = null;
                    $2eb97388ec83477c$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $2eb97388ec83477c$var$workInProgressSuspendedReason = 0;
                    $2eb97388ec83477c$var$workInProgressThrownValue = null;
                    $2eb97388ec83477c$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $2eb97388ec83477c$var$resetWorkInProgressStack();
                    $2eb97388ec83477c$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($2eb97388ec83477c$var$formatProdErrorMessage(462));
            }
        }
        $2eb97388ec83477c$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $2eb97388ec83477c$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $2eb97388ec83477c$var$lastContextDependency = $2eb97388ec83477c$var$currentlyRenderingFiber$1 = null;
    $2eb97388ec83477c$var$ReactSharedInternals.H = prevDispatcher;
    $2eb97388ec83477c$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $2eb97388ec83477c$var$executionContext = prevExecutionContext;
    if (null !== $2eb97388ec83477c$var$workInProgress) return 0;
    $2eb97388ec83477c$var$workInProgressRoot = null;
    $2eb97388ec83477c$var$workInProgressRootRenderLanes = 0;
    $2eb97388ec83477c$var$finishQueueingConcurrentUpdates();
    return $2eb97388ec83477c$var$workInProgressRootExitStatus;
}
function $2eb97388ec83477c$var$workLoopConcurrentByScheduler() {
    for(; null !== $2eb97388ec83477c$var$workInProgress && !$2eb97388ec83477c$var$shouldYield();)$2eb97388ec83477c$var$performUnitOfWork($2eb97388ec83477c$var$workInProgress);
}
function $2eb97388ec83477c$var$performUnitOfWork(unitOfWork) {
    var next = $2eb97388ec83477c$var$beginWork(unitOfWork.alternate, unitOfWork, $2eb97388ec83477c$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $2eb97388ec83477c$var$completeUnitOfWork(unitOfWork) : $2eb97388ec83477c$var$workInProgress = next;
}
function $2eb97388ec83477c$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $2eb97388ec83477c$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $2eb97388ec83477c$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $2eb97388ec83477c$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $2eb97388ec83477c$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $2eb97388ec83477c$var$resetHooksOnUnwind(next);
        default:
            $2eb97388ec83477c$var$unwindInterruptedWork(current, next), next = $2eb97388ec83477c$var$workInProgress = $2eb97388ec83477c$var$resetWorkInProgress(next, $2eb97388ec83477c$var$entangledRenderLanes), next = $2eb97388ec83477c$var$beginWork(current, next, $2eb97388ec83477c$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $2eb97388ec83477c$var$completeUnitOfWork(unitOfWork) : $2eb97388ec83477c$var$workInProgress = next;
}
function $2eb97388ec83477c$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $2eb97388ec83477c$var$lastContextDependency = $2eb97388ec83477c$var$currentlyRenderingFiber$1 = null;
    $2eb97388ec83477c$var$resetHooksOnUnwind(unitOfWork);
    $2eb97388ec83477c$var$thenableState$1 = null;
    $2eb97388ec83477c$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($2eb97388ec83477c$var$throwException(root, returnFiber, unitOfWork, thrownValue, $2eb97388ec83477c$var$workInProgressRootRenderLanes)) {
            $2eb97388ec83477c$var$workInProgressRootExitStatus = 1;
            $2eb97388ec83477c$var$logUncaughtError(root, $2eb97388ec83477c$var$createCapturedValueAtFiber(thrownValue, root.current));
            $2eb97388ec83477c$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $2eb97388ec83477c$var$workInProgress = returnFiber, error;
        $2eb97388ec83477c$var$workInProgressRootExitStatus = 1;
        $2eb97388ec83477c$var$logUncaughtError(root, $2eb97388ec83477c$var$createCapturedValueAtFiber(thrownValue, root.current));
        $2eb97388ec83477c$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($2eb97388ec83477c$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($2eb97388ec83477c$var$workInProgressRootIsPrerendering || 0 !== ($2eb97388ec83477c$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($2eb97388ec83477c$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $2eb97388ec83477c$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $2eb97388ec83477c$var$unwindUnitOfWork(unitOfWork, root);
    } else $2eb97388ec83477c$var$completeUnitOfWork(unitOfWork);
}
function $2eb97388ec83477c$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $2eb97388ec83477c$var$unwindUnitOfWork(completedWork, $2eb97388ec83477c$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $2eb97388ec83477c$var$completeWork(completedWork.alternate, completedWork, $2eb97388ec83477c$var$entangledRenderLanes);
        if (null !== next) {
            $2eb97388ec83477c$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $2eb97388ec83477c$var$workInProgress = completedWork;
            return;
        }
        $2eb97388ec83477c$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $2eb97388ec83477c$var$workInProgressRootExitStatus && ($2eb97388ec83477c$var$workInProgressRootExitStatus = 5);
}
function $2eb97388ec83477c$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $2eb97388ec83477c$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $2eb97388ec83477c$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $2eb97388ec83477c$var$workInProgress = unitOfWork;
            return;
        }
        $2eb97388ec83477c$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $2eb97388ec83477c$var$workInProgressRootExitStatus = 6;
    $2eb97388ec83477c$var$workInProgress = null;
}
function $2eb97388ec83477c$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $2eb97388ec83477c$var$flushPendingEffects();
    while (0 !== $2eb97388ec83477c$var$pendingEffectsStatus);
    if (0 !== ($2eb97388ec83477c$var$executionContext & 6)) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $2eb97388ec83477c$var$concurrentlyUpdatedLanes;
        $2eb97388ec83477c$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $2eb97388ec83477c$var$workInProgressRoot && ($2eb97388ec83477c$var$workInProgress = $2eb97388ec83477c$var$workInProgressRoot = null, $2eb97388ec83477c$var$workInProgressRootRenderLanes = 0);
        $2eb97388ec83477c$var$pendingFinishedWork = finishedWork;
        $2eb97388ec83477c$var$pendingEffectsRoot = root;
        $2eb97388ec83477c$var$pendingEffectsLanes = lanes;
        $2eb97388ec83477c$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $2eb97388ec83477c$var$pendingPassiveTransitions = transitions;
        $2eb97388ec83477c$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $2eb97388ec83477c$var$scheduleCallback$1($2eb97388ec83477c$var$NormalPriority$1, function() {
            $2eb97388ec83477c$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $2eb97388ec83477c$var$ReactSharedInternals.T;
            $2eb97388ec83477c$var$ReactSharedInternals.T = null;
            transitions = $2eb97388ec83477c$var$ReactDOMSharedInternals.p;
            $2eb97388ec83477c$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $2eb97388ec83477c$var$executionContext;
            $2eb97388ec83477c$var$executionContext |= 4;
            try {
                $2eb97388ec83477c$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $2eb97388ec83477c$var$executionContext = spawnedLane, $2eb97388ec83477c$var$ReactDOMSharedInternals.p = transitions, $2eb97388ec83477c$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $2eb97388ec83477c$var$pendingEffectsStatus = 1;
        $2eb97388ec83477c$var$flushMutationEffects();
        $2eb97388ec83477c$var$flushLayoutEffects();
        $2eb97388ec83477c$var$flushSpawnedWork();
    }
}
function $2eb97388ec83477c$var$flushMutationEffects() {
    if (1 === $2eb97388ec83477c$var$pendingEffectsStatus) {
        $2eb97388ec83477c$var$pendingEffectsStatus = 0;
        var root = $2eb97388ec83477c$var$pendingEffectsRoot, finishedWork = $2eb97388ec83477c$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $2eb97388ec83477c$var$ReactSharedInternals.T;
            $2eb97388ec83477c$var$ReactSharedInternals.T = null;
            var previousPriority = $2eb97388ec83477c$var$ReactDOMSharedInternals.p;
            $2eb97388ec83477c$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $2eb97388ec83477c$var$executionContext;
            $2eb97388ec83477c$var$executionContext |= 4;
            try {
                $2eb97388ec83477c$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $2eb97388ec83477c$var$selectionInformation, curFocusedElem = $2eb97388ec83477c$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $2eb97388ec83477c$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $2eb97388ec83477c$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $2eb97388ec83477c$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $2eb97388ec83477c$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $2eb97388ec83477c$var$_enabled = !!$2eb97388ec83477c$var$eventsEnabled;
                $2eb97388ec83477c$var$selectionInformation = $2eb97388ec83477c$var$eventsEnabled = null;
            } finally{
                $2eb97388ec83477c$var$executionContext = prevExecutionContext, $2eb97388ec83477c$var$ReactDOMSharedInternals.p = previousPriority, $2eb97388ec83477c$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $2eb97388ec83477c$var$pendingEffectsStatus = 2;
    }
}
function $2eb97388ec83477c$var$flushLayoutEffects() {
    if (2 === $2eb97388ec83477c$var$pendingEffectsStatus) {
        $2eb97388ec83477c$var$pendingEffectsStatus = 0;
        var root = $2eb97388ec83477c$var$pendingEffectsRoot, finishedWork = $2eb97388ec83477c$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $2eb97388ec83477c$var$ReactSharedInternals.T;
            $2eb97388ec83477c$var$ReactSharedInternals.T = null;
            var previousPriority = $2eb97388ec83477c$var$ReactDOMSharedInternals.p;
            $2eb97388ec83477c$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $2eb97388ec83477c$var$executionContext;
            $2eb97388ec83477c$var$executionContext |= 4;
            try {
                $2eb97388ec83477c$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $2eb97388ec83477c$var$executionContext = prevExecutionContext, $2eb97388ec83477c$var$ReactDOMSharedInternals.p = previousPriority, $2eb97388ec83477c$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $2eb97388ec83477c$var$pendingEffectsStatus = 3;
    }
}
function $2eb97388ec83477c$var$flushSpawnedWork() {
    if (4 === $2eb97388ec83477c$var$pendingEffectsStatus || 3 === $2eb97388ec83477c$var$pendingEffectsStatus) {
        $2eb97388ec83477c$var$pendingEffectsStatus = 0;
        $2eb97388ec83477c$var$requestPaint();
        var root = $2eb97388ec83477c$var$pendingEffectsRoot, finishedWork = $2eb97388ec83477c$var$pendingFinishedWork, lanes = $2eb97388ec83477c$var$pendingEffectsLanes, recoverableErrors = $2eb97388ec83477c$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $2eb97388ec83477c$var$pendingEffectsStatus = 5 : ($2eb97388ec83477c$var$pendingEffectsStatus = 0, $2eb97388ec83477c$var$pendingFinishedWork = $2eb97388ec83477c$var$pendingEffectsRoot = null, $2eb97388ec83477c$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($2eb97388ec83477c$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $2eb97388ec83477c$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($2eb97388ec83477c$var$injectedHook && "function" === typeof $2eb97388ec83477c$var$injectedHook.onCommitFiberRoot) try {
            $2eb97388ec83477c$var$injectedHook.onCommitFiberRoot($2eb97388ec83477c$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $2eb97388ec83477c$var$ReactSharedInternals.T;
            remainingLanes = $2eb97388ec83477c$var$ReactDOMSharedInternals.p;
            $2eb97388ec83477c$var$ReactDOMSharedInternals.p = 2;
            $2eb97388ec83477c$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $2eb97388ec83477c$var$ReactSharedInternals.T = finishedWork, $2eb97388ec83477c$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($2eb97388ec83477c$var$pendingEffectsLanes & 3) && $2eb97388ec83477c$var$flushPendingEffects();
        $2eb97388ec83477c$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $2eb97388ec83477c$var$rootWithNestedUpdates ? $2eb97388ec83477c$var$nestedUpdateCount++ : ($2eb97388ec83477c$var$nestedUpdateCount = 0, $2eb97388ec83477c$var$rootWithNestedUpdates = root) : $2eb97388ec83477c$var$nestedUpdateCount = 0;
        $2eb97388ec83477c$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $2eb97388ec83477c$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $2eb97388ec83477c$var$releaseCache(remainingLanes)));
}
function $2eb97388ec83477c$var$flushPendingEffects() {
    $2eb97388ec83477c$var$flushMutationEffects();
    $2eb97388ec83477c$var$flushLayoutEffects();
    $2eb97388ec83477c$var$flushSpawnedWork();
    return $2eb97388ec83477c$var$flushPassiveEffects();
}
function $2eb97388ec83477c$var$flushPassiveEffects() {
    if (5 !== $2eb97388ec83477c$var$pendingEffectsStatus) return !1;
    var root = $2eb97388ec83477c$var$pendingEffectsRoot, remainingLanes = $2eb97388ec83477c$var$pendingEffectsRemainingLanes;
    $2eb97388ec83477c$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $2eb97388ec83477c$var$lanesToEventPriority($2eb97388ec83477c$var$pendingEffectsLanes), prevTransition = $2eb97388ec83477c$var$ReactSharedInternals.T, previousPriority = $2eb97388ec83477c$var$ReactDOMSharedInternals.p;
    try {
        $2eb97388ec83477c$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $2eb97388ec83477c$var$ReactSharedInternals.T = null;
        renderPriority = $2eb97388ec83477c$var$pendingPassiveTransitions;
        $2eb97388ec83477c$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $2eb97388ec83477c$var$pendingEffectsRoot, lanes = $2eb97388ec83477c$var$pendingEffectsLanes;
        $2eb97388ec83477c$var$pendingEffectsStatus = 0;
        $2eb97388ec83477c$var$pendingFinishedWork = $2eb97388ec83477c$var$pendingEffectsRoot = null;
        $2eb97388ec83477c$var$pendingEffectsLanes = 0;
        if (0 !== ($2eb97388ec83477c$var$executionContext & 6)) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(331));
        var prevExecutionContext = $2eb97388ec83477c$var$executionContext;
        $2eb97388ec83477c$var$executionContext |= 4;
        $2eb97388ec83477c$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $2eb97388ec83477c$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $2eb97388ec83477c$var$executionContext = prevExecutionContext;
        $2eb97388ec83477c$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($2eb97388ec83477c$var$injectedHook && "function" === typeof $2eb97388ec83477c$var$injectedHook.onPostCommitFiberRoot) try {
            $2eb97388ec83477c$var$injectedHook.onPostCommitFiberRoot($2eb97388ec83477c$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $2eb97388ec83477c$var$ReactDOMSharedInternals.p = previousPriority, $2eb97388ec83477c$var$ReactSharedInternals.T = prevTransition, $2eb97388ec83477c$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $2eb97388ec83477c$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $2eb97388ec83477c$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $2eb97388ec83477c$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $2eb97388ec83477c$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($2eb97388ec83477c$var$markRootUpdated$1(rootFiber, 2), $2eb97388ec83477c$var$ensureRootIsScheduled(rootFiber));
}
function $2eb97388ec83477c$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $2eb97388ec83477c$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $2eb97388ec83477c$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $2eb97388ec83477c$var$legacyErrorBoundariesThatAlreadyFailed || !$2eb97388ec83477c$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $2eb97388ec83477c$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $2eb97388ec83477c$var$createClassErrorUpdate(2);
                instance = $2eb97388ec83477c$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($2eb97388ec83477c$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $2eb97388ec83477c$var$markRootUpdated$1(instance, 2), $2eb97388ec83477c$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $2eb97388ec83477c$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $2eb97388ec83477c$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($2eb97388ec83477c$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $2eb97388ec83477c$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $2eb97388ec83477c$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $2eb97388ec83477c$var$workInProgressRoot === root && ($2eb97388ec83477c$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $2eb97388ec83477c$var$workInProgressRootExitStatus || 3 === $2eb97388ec83477c$var$workInProgressRootExitStatus && ($2eb97388ec83477c$var$workInProgressRootRenderLanes & 62914560) === $2eb97388ec83477c$var$workInProgressRootRenderLanes && 300 > $2eb97388ec83477c$var$now() - $2eb97388ec83477c$var$globalMostRecentFallbackTime ? 0 === ($2eb97388ec83477c$var$executionContext & 2) && $2eb97388ec83477c$var$prepareFreshStack(root, 0) : $2eb97388ec83477c$var$workInProgressRootPingedLanes |= pingedLanes, $2eb97388ec83477c$var$workInProgressSuspendedRetryLanes === $2eb97388ec83477c$var$workInProgressRootRenderLanes && ($2eb97388ec83477c$var$workInProgressSuspendedRetryLanes = 0));
    $2eb97388ec83477c$var$ensureRootIsScheduled(root);
}
function $2eb97388ec83477c$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $2eb97388ec83477c$var$claimNextRetryLane());
    boundaryFiber = $2eb97388ec83477c$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($2eb97388ec83477c$var$markRootUpdated$1(boundaryFiber, retryLane), $2eb97388ec83477c$var$ensureRootIsScheduled(boundaryFiber));
}
function $2eb97388ec83477c$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $2eb97388ec83477c$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $2eb97388ec83477c$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($2eb97388ec83477c$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $2eb97388ec83477c$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $2eb97388ec83477c$var$scheduleCallback$1(priorityLevel, callback) {
    return $2eb97388ec83477c$var$scheduleCallback$3(priorityLevel, callback);
}
var $2eb97388ec83477c$var$firstScheduledRoot = null, $2eb97388ec83477c$var$lastScheduledRoot = null, $2eb97388ec83477c$var$didScheduleMicrotask = !1, $2eb97388ec83477c$var$mightHavePendingSyncWork = !1, $2eb97388ec83477c$var$isFlushingWork = !1, $2eb97388ec83477c$var$currentEventTransitionLane = 0;
function $2eb97388ec83477c$var$ensureRootIsScheduled(root) {
    root !== $2eb97388ec83477c$var$lastScheduledRoot && null === root.next && (null === $2eb97388ec83477c$var$lastScheduledRoot ? $2eb97388ec83477c$var$firstScheduledRoot = $2eb97388ec83477c$var$lastScheduledRoot = root : $2eb97388ec83477c$var$lastScheduledRoot = $2eb97388ec83477c$var$lastScheduledRoot.next = root);
    $2eb97388ec83477c$var$mightHavePendingSyncWork = !0;
    $2eb97388ec83477c$var$didScheduleMicrotask || ($2eb97388ec83477c$var$didScheduleMicrotask = !0, $2eb97388ec83477c$var$scheduleImmediateRootScheduleTask());
}
function $2eb97388ec83477c$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$2eb97388ec83477c$var$isFlushingWork && $2eb97388ec83477c$var$mightHavePendingSyncWork) {
        $2eb97388ec83477c$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $2eb97388ec83477c$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $2eb97388ec83477c$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $2eb97388ec83477c$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $2eb97388ec83477c$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $2eb97388ec83477c$var$getNextLanes(root$170, root$170 === $2eb97388ec83477c$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $2eb97388ec83477c$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $2eb97388ec83477c$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $2eb97388ec83477c$var$isFlushingWork = !1;
    }
}
function $2eb97388ec83477c$var$processRootScheduleInImmediateTask() {
    $2eb97388ec83477c$var$processRootScheduleInMicrotask();
}
function $2eb97388ec83477c$var$processRootScheduleInMicrotask() {
    $2eb97388ec83477c$var$mightHavePendingSyncWork = $2eb97388ec83477c$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $2eb97388ec83477c$var$currentEventTransitionLane && $2eb97388ec83477c$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $2eb97388ec83477c$var$currentEventTransitionLane);
    for(var currentTime = $2eb97388ec83477c$var$now(), prev = null, root = $2eb97388ec83477c$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $2eb97388ec83477c$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $2eb97388ec83477c$var$firstScheduledRoot = next : prev.next = next, null === next && ($2eb97388ec83477c$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $2eb97388ec83477c$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $2eb97388ec83477c$var$pendingEffectsStatus && 5 !== $2eb97388ec83477c$var$pendingEffectsStatus || $2eb97388ec83477c$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $2eb97388ec83477c$var$currentEventTransitionLane && ($2eb97388ec83477c$var$currentEventTransitionLane = 0);
}
function $2eb97388ec83477c$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $2eb97388ec83477c$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $2eb97388ec83477c$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $2eb97388ec83477c$var$workInProgressRoot;
    suspendedLanes = $2eb97388ec83477c$var$workInProgressRootRenderLanes;
    suspendedLanes = $2eb97388ec83477c$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $2eb97388ec83477c$var$workInProgressSuspendedReason || 9 === $2eb97388ec83477c$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $2eb97388ec83477c$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $2eb97388ec83477c$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $2eb97388ec83477c$var$cancelCallback$1(pingedLanes);
        switch($2eb97388ec83477c$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $2eb97388ec83477c$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $2eb97388ec83477c$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $2eb97388ec83477c$var$IdlePriority;
                break;
            default:
                suspendedLanes = $2eb97388ec83477c$var$NormalPriority$1;
        }
        pingedLanes = $2eb97388ec83477c$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $2eb97388ec83477c$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $2eb97388ec83477c$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $2eb97388ec83477c$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $2eb97388ec83477c$var$pendingEffectsStatus && 5 !== $2eb97388ec83477c$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($2eb97388ec83477c$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $2eb97388ec83477c$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $2eb97388ec83477c$var$getNextLanes(root, root === $2eb97388ec83477c$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $2eb97388ec83477c$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $2eb97388ec83477c$var$scheduleTaskForRootDuringMicrotask(root, $2eb97388ec83477c$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $2eb97388ec83477c$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $2eb97388ec83477c$var$performSyncWorkOnRoot(root, lanes) {
    if ($2eb97388ec83477c$var$flushPendingEffects()) return null;
    $2eb97388ec83477c$var$performWorkOnRoot(root, lanes, !0);
}
function $2eb97388ec83477c$var$scheduleImmediateRootScheduleTask() {
    $2eb97388ec83477c$var$scheduleMicrotask(function() {
        0 !== ($2eb97388ec83477c$var$executionContext & 6) ? $2eb97388ec83477c$var$scheduleCallback$3($2eb97388ec83477c$var$ImmediatePriority, $2eb97388ec83477c$var$processRootScheduleInImmediateTask) : $2eb97388ec83477c$var$processRootScheduleInMicrotask();
    });
}
function $2eb97388ec83477c$var$requestTransitionLane() {
    if (0 === $2eb97388ec83477c$var$currentEventTransitionLane) {
        var actionScopeLane = $2eb97388ec83477c$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $2eb97388ec83477c$var$nextTransitionUpdateLane, $2eb97388ec83477c$var$nextTransitionUpdateLane <<= 1, 0 === ($2eb97388ec83477c$var$nextTransitionUpdateLane & 261888) && ($2eb97388ec83477c$var$nextTransitionUpdateLane = 256));
        $2eb97388ec83477c$var$currentEventTransitionLane = actionScopeLane;
    }
    return $2eb97388ec83477c$var$currentEventTransitionLane;
}
function $2eb97388ec83477c$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $2eb97388ec83477c$var$sanitizeURL("" + actionProp);
}
function $2eb97388ec83477c$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $2eb97388ec83477c$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $2eb97388ec83477c$var$coerceFormActionProp((nativeEventTarget[$2eb97388ec83477c$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$2eb97388ec83477c$var$internalPropsKey] || null) ? $2eb97388ec83477c$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $2eb97388ec83477c$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $2eb97388ec83477c$var$currentEventTransitionLane) {
                                var formData = submitter ? $2eb97388ec83477c$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $2eb97388ec83477c$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $2eb97388ec83477c$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $2eb97388ec83477c$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $2eb97388ec83477c$var$i$jscomp$inline_1577 = 0; $2eb97388ec83477c$var$i$jscomp$inline_1577 < $2eb97388ec83477c$var$simpleEventPluginEvents.length; $2eb97388ec83477c$var$i$jscomp$inline_1577++){
    var $2eb97388ec83477c$var$eventName$jscomp$inline_1578 = $2eb97388ec83477c$var$simpleEventPluginEvents[$2eb97388ec83477c$var$i$jscomp$inline_1577], $2eb97388ec83477c$var$domEventName$jscomp$inline_1579 = $2eb97388ec83477c$var$eventName$jscomp$inline_1578.toLowerCase(), $2eb97388ec83477c$var$capitalizedEvent$jscomp$inline_1580 = $2eb97388ec83477c$var$eventName$jscomp$inline_1578[0].toUpperCase() + $2eb97388ec83477c$var$eventName$jscomp$inline_1578.slice(1);
    $2eb97388ec83477c$var$registerSimpleEvent($2eb97388ec83477c$var$domEventName$jscomp$inline_1579, "on" + $2eb97388ec83477c$var$capitalizedEvent$jscomp$inline_1580);
}
$2eb97388ec83477c$var$registerSimpleEvent($2eb97388ec83477c$var$ANIMATION_END, "onAnimationEnd");
$2eb97388ec83477c$var$registerSimpleEvent($2eb97388ec83477c$var$ANIMATION_ITERATION, "onAnimationIteration");
$2eb97388ec83477c$var$registerSimpleEvent($2eb97388ec83477c$var$ANIMATION_START, "onAnimationStart");
$2eb97388ec83477c$var$registerSimpleEvent("dblclick", "onDoubleClick");
$2eb97388ec83477c$var$registerSimpleEvent("focusin", "onFocus");
$2eb97388ec83477c$var$registerSimpleEvent("focusout", "onBlur");
$2eb97388ec83477c$var$registerSimpleEvent($2eb97388ec83477c$var$TRANSITION_RUN, "onTransitionRun");
$2eb97388ec83477c$var$registerSimpleEvent($2eb97388ec83477c$var$TRANSITION_START, "onTransitionStart");
$2eb97388ec83477c$var$registerSimpleEvent($2eb97388ec83477c$var$TRANSITION_CANCEL, "onTransitionCancel");
$2eb97388ec83477c$var$registerSimpleEvent($2eb97388ec83477c$var$TRANSITION_END, "onTransitionEnd");
$2eb97388ec83477c$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$2eb97388ec83477c$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$2eb97388ec83477c$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$2eb97388ec83477c$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$2eb97388ec83477c$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$2eb97388ec83477c$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$2eb97388ec83477c$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$2eb97388ec83477c$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$2eb97388ec83477c$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$2eb97388ec83477c$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $2eb97388ec83477c$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $2eb97388ec83477c$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($2eb97388ec83477c$var$mediaEventTypes));
function $2eb97388ec83477c$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $2eb97388ec83477c$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $2eb97388ec83477c$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $2eb97388ec83477c$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$2eb97388ec83477c$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$2eb97388ec83477c$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($2eb97388ec83477c$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $2eb97388ec83477c$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $2eb97388ec83477c$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $2eb97388ec83477c$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $2eb97388ec83477c$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$2eb97388ec83477c$var$listeningMarker]) {
        rootContainerElement[$2eb97388ec83477c$var$listeningMarker] = !0;
        $2eb97388ec83477c$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($2eb97388ec83477c$var$nonDelegatedEvents.has(domEventName) || $2eb97388ec83477c$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $2eb97388ec83477c$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$2eb97388ec83477c$var$listeningMarker] || (ownerDocument[$2eb97388ec83477c$var$listeningMarker] = !0, $2eb97388ec83477c$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $2eb97388ec83477c$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($2eb97388ec83477c$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $2eb97388ec83477c$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $2eb97388ec83477c$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $2eb97388ec83477c$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$2eb97388ec83477c$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $2eb97388ec83477c$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $2eb97388ec83477c$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $2eb97388ec83477c$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $2eb97388ec83477c$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $2eb97388ec83477c$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $2eb97388ec83477c$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticTouchEvent;
                        break;
                    case $2eb97388ec83477c$var$ANIMATION_END:
                    case $2eb97388ec83477c$var$ANIMATION_ITERATION:
                    case $2eb97388ec83477c$var$ANIMATION_START:
                        SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticAnimationEvent;
                        break;
                    case $2eb97388ec83477c$var$TRANSITION_END:
                        SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $2eb97388ec83477c$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $2eb97388ec83477c$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($2eb97388ec83477c$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $2eb97388ec83477c$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($2eb97388ec83477c$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$2eb97388ec83477c$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $2eb97388ec83477c$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $2eb97388ec83477c$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $2eb97388ec83477c$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $2eb97388ec83477c$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $2eb97388ec83477c$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $2eb97388ec83477c$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $2eb97388ec83477c$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $2eb97388ec83477c$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $2eb97388ec83477c$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $2eb97388ec83477c$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $2eb97388ec83477c$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $2eb97388ec83477c$var$getTargetInstForChangeEvent;
                else if ($2eb97388ec83477c$var$isTextInputElement(reactName)) {
                    if ($2eb97388ec83477c$var$isInputEventSupported) getTargetInstFunc = $2eb97388ec83477c$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $2eb97388ec83477c$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $2eb97388ec83477c$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $2eb97388ec83477c$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $2eb97388ec83477c$var$getTargetInstForChangeEvent) : getTargetInstFunc = $2eb97388ec83477c$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $2eb97388ec83477c$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $2eb97388ec83477c$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $2eb97388ec83477c$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($2eb97388ec83477c$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $2eb97388ec83477c$var$activeElement = handleEventFunc, $2eb97388ec83477c$var$activeElementInst = targetInst, $2eb97388ec83477c$var$lastSelection = null;
                    break;
                case "focusout":
                    $2eb97388ec83477c$var$lastSelection = $2eb97388ec83477c$var$activeElementInst = $2eb97388ec83477c$var$activeElement = null;
                    break;
                case "mousedown":
                    $2eb97388ec83477c$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $2eb97388ec83477c$var$mouseDown = !1;
                    $2eb97388ec83477c$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($2eb97388ec83477c$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $2eb97388ec83477c$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($2eb97388ec83477c$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $2eb97388ec83477c$var$isComposing ? $2eb97388ec83477c$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($2eb97388ec83477c$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($2eb97388ec83477c$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $2eb97388ec83477c$var$isComposing && (fallbackData = $2eb97388ec83477c$var$getData()) : ($2eb97388ec83477c$var$root = nativeEventTarget, $2eb97388ec83477c$var$startText = "value" in $2eb97388ec83477c$var$root ? $2eb97388ec83477c$var$root.value : $2eb97388ec83477c$var$root.textContent, $2eb97388ec83477c$var$isComposing = !0)), handleEventFunc = $2eb97388ec83477c$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $2eb97388ec83477c$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $2eb97388ec83477c$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $2eb97388ec83477c$var$canUseTextInputEvent ? $2eb97388ec83477c$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $2eb97388ec83477c$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $2eb97388ec83477c$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $2eb97388ec83477c$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $2eb97388ec83477c$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $2eb97388ec83477c$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $2eb97388ec83477c$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $2eb97388ec83477c$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $2eb97388ec83477c$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($2eb97388ec83477c$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $2eb97388ec83477c$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($2eb97388ec83477c$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $2eb97388ec83477c$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $2eb97388ec83477c$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $2eb97388ec83477c$var$getListener(target, registrationName), null != stateNode && listeners.unshift($2eb97388ec83477c$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $2eb97388ec83477c$var$getListener(target, registrationName), null != stateNode && listeners.push($2eb97388ec83477c$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $2eb97388ec83477c$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $2eb97388ec83477c$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $2eb97388ec83477c$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($2eb97388ec83477c$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($2eb97388ec83477c$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $2eb97388ec83477c$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $2eb97388ec83477c$var$normalizeMarkupForTextOrAttribute(clientText);
    return $2eb97388ec83477c$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $2eb97388ec83477c$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $2eb97388ec83477c$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $2eb97388ec83477c$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $2eb97388ec83477c$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $2eb97388ec83477c$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $2eb97388ec83477c$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $2eb97388ec83477c$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $2eb97388ec83477c$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $2eb97388ec83477c$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $2eb97388ec83477c$var$setProp(domElement, tag, "name", props.name, props, null), $2eb97388ec83477c$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $2eb97388ec83477c$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $2eb97388ec83477c$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($2eb97388ec83477c$var$setProp(domElement, tag, "encType", props.encType, props, null), $2eb97388ec83477c$var$setProp(domElement, tag, "method", props.method, props, null), $2eb97388ec83477c$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $2eb97388ec83477c$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $2eb97388ec83477c$var$noop$1);
            break;
        case "onScroll":
            null != value && $2eb97388ec83477c$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $2eb97388ec83477c$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $2eb97388ec83477c$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("toggle", domElement);
            $2eb97388ec83477c$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $2eb97388ec83477c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $2eb97388ec83477c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $2eb97388ec83477c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $2eb97388ec83477c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $2eb97388ec83477c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $2eb97388ec83477c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $2eb97388ec83477c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $2eb97388ec83477c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $2eb97388ec83477c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $2eb97388ec83477c$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $2eb97388ec83477c$var$aliases.get(key) || key, $2eb97388ec83477c$var$setValueForAttribute(domElement, key, value);
    }
}
function $2eb97388ec83477c$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $2eb97388ec83477c$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $2eb97388ec83477c$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $2eb97388ec83477c$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $2eb97388ec83477c$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $2eb97388ec83477c$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $2eb97388ec83477c$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$2eb97388ec83477c$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$2eb97388ec83477c$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $2eb97388ec83477c$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $2eb97388ec83477c$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("error", domElement);
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($2eb97388ec83477c$var$formatProdErrorMessage(137, tag));
                    default:
                        $2eb97388ec83477c$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $2eb97388ec83477c$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $2eb97388ec83477c$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $2eb97388ec83477c$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $2eb97388ec83477c$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $2eb97388ec83477c$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $2eb97388ec83477c$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $2eb97388ec83477c$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(91));
                    break;
                default:
                    $2eb97388ec83477c$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $2eb97388ec83477c$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $2eb97388ec83477c$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("toggle", domElement);
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("cancel", domElement);
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $2eb97388ec83477c$var$mediaEventTypes.length; hasSrc++)$2eb97388ec83477c$var$listenToNonDelegatedEvent($2eb97388ec83477c$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("error", domElement);
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $2eb97388ec83477c$var$listenToNonDelegatedEvent("error", domElement), $2eb97388ec83477c$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($2eb97388ec83477c$var$formatProdErrorMessage(137, tag));
                default:
                    $2eb97388ec83477c$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($2eb97388ec83477c$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $2eb97388ec83477c$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $2eb97388ec83477c$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $2eb97388ec83477c$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $2eb97388ec83477c$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $2eb97388ec83477c$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $2eb97388ec83477c$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $2eb97388ec83477c$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $2eb97388ec83477c$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $2eb97388ec83477c$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $2eb97388ec83477c$var$updateOptions(domElement, !!lastProps, tag, !0) : $2eb97388ec83477c$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $2eb97388ec83477c$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $2eb97388ec83477c$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $2eb97388ec83477c$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $2eb97388ec83477c$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $2eb97388ec83477c$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $2eb97388ec83477c$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $2eb97388ec83477c$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($2eb97388ec83477c$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $2eb97388ec83477c$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $2eb97388ec83477c$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $2eb97388ec83477c$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $2eb97388ec83477c$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $2eb97388ec83477c$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $2eb97388ec83477c$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $2eb97388ec83477c$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $2eb97388ec83477c$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $2eb97388ec83477c$var$eventsEnabled = null, $2eb97388ec83477c$var$selectionInformation = null;
function $2eb97388ec83477c$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $2eb97388ec83477c$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $2eb97388ec83477c$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $2eb97388ec83477c$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $2eb97388ec83477c$var$currentPopstateTransitionEvent = null;
function $2eb97388ec83477c$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $2eb97388ec83477c$var$currentPopstateTransitionEvent) return !1;
        $2eb97388ec83477c$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $2eb97388ec83477c$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $2eb97388ec83477c$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $2eb97388ec83477c$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $2eb97388ec83477c$var$localPromise = "function" === typeof Promise ? Promise : void 0, $2eb97388ec83477c$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $2eb97388ec83477c$var$localPromise ? function(callback) {
    return $2eb97388ec83477c$var$localPromise.resolve(null).then(callback).catch($2eb97388ec83477c$var$handleErrorInNextTick);
} : $2eb97388ec83477c$var$scheduleTimeout;
function $2eb97388ec83477c$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $2eb97388ec83477c$var$isSingletonScope(type) {
    return "head" === type;
}
function $2eb97388ec83477c$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $2eb97388ec83477c$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $2eb97388ec83477c$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $2eb97388ec83477c$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$2eb97388ec83477c$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $2eb97388ec83477c$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $2eb97388ec83477c$var$retryIfBlockedOn(hydrationInstance);
}
function $2eb97388ec83477c$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $2eb97388ec83477c$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $2eb97388ec83477c$var$clearContainerSparingly(node);
                $2eb97388ec83477c$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $2eb97388ec83477c$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$2eb97388ec83477c$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $2eb97388ec83477c$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $2eb97388ec83477c$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $2eb97388ec83477c$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $2eb97388ec83477c$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $2eb97388ec83477c$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $2eb97388ec83477c$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $2eb97388ec83477c$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $2eb97388ec83477c$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $2eb97388ec83477c$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $2eb97388ec83477c$var$previousHydratableOnEnteringScopedSingleton = null;
function $2eb97388ec83477c$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $2eb97388ec83477c$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $2eb97388ec83477c$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $2eb97388ec83477c$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $2eb97388ec83477c$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($2eb97388ec83477c$var$formatProdErrorMessage(451));
    }
}
function $2eb97388ec83477c$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $2eb97388ec83477c$var$detachDeletedInstance(instance);
}
var $2eb97388ec83477c$var$preloadPropsMap = new Map(), $2eb97388ec83477c$var$preconnectsSet = new Set();
function $2eb97388ec83477c$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $2eb97388ec83477c$var$previousDispatcher = $2eb97388ec83477c$var$ReactDOMSharedInternals.d;
$2eb97388ec83477c$var$ReactDOMSharedInternals.d = {
    f: $2eb97388ec83477c$var$flushSyncWork,
    r: $2eb97388ec83477c$var$requestFormReset,
    D: $2eb97388ec83477c$var$prefetchDNS,
    C: $2eb97388ec83477c$var$preconnect,
    L: $2eb97388ec83477c$var$preload,
    m: $2eb97388ec83477c$var$preloadModule,
    X: $2eb97388ec83477c$var$preinitScript,
    S: $2eb97388ec83477c$var$preinitStyle,
    M: $2eb97388ec83477c$var$preinitModuleScript
};
function $2eb97388ec83477c$var$flushSyncWork() {
    var previousWasRendering = $2eb97388ec83477c$var$previousDispatcher.f(), wasRendering = $2eb97388ec83477c$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $2eb97388ec83477c$var$requestFormReset(form) {
    var formInst = $2eb97388ec83477c$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $2eb97388ec83477c$var$requestFormReset$1(formInst) : $2eb97388ec83477c$var$previousDispatcher.r(form);
}
var $2eb97388ec83477c$var$globalDocument = "undefined" === typeof document ? null : document;
function $2eb97388ec83477c$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $2eb97388ec83477c$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $2eb97388ec83477c$var$preconnectsSet.has(limitedEscapedHref) || ($2eb97388ec83477c$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $2eb97388ec83477c$var$setInitialProperties(href, "link", rel), $2eb97388ec83477c$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $2eb97388ec83477c$var$prefetchDNS(href) {
    $2eb97388ec83477c$var$previousDispatcher.D(href);
    $2eb97388ec83477c$var$preconnectAs("dns-prefetch", href, null);
}
function $2eb97388ec83477c$var$preconnect(href, crossOrigin) {
    $2eb97388ec83477c$var$previousDispatcher.C(href, crossOrigin);
    $2eb97388ec83477c$var$preconnectAs("preconnect", href, crossOrigin);
}
function $2eb97388ec83477c$var$preload(href, as, options) {
    $2eb97388ec83477c$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $2eb97388ec83477c$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $2eb97388ec83477c$var$getStyleKey(href);
                break;
            case "script":
                key = $2eb97388ec83477c$var$getScriptKey(href);
        }
        $2eb97388ec83477c$var$preloadPropsMap.has(key) || (href = $2eb97388ec83477c$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $2eb97388ec83477c$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($2eb97388ec83477c$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($2eb97388ec83477c$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $2eb97388ec83477c$var$setInitialProperties(as, "link", href), $2eb97388ec83477c$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $2eb97388ec83477c$var$preloadModule(href, options) {
    $2eb97388ec83477c$var$previousDispatcher.m(href, options);
    var ownerDocument = $2eb97388ec83477c$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $2eb97388ec83477c$var$getScriptKey(href);
        }
        if (!$2eb97388ec83477c$var$preloadPropsMap.has(key) && (href = $2eb97388ec83477c$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $2eb97388ec83477c$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($2eb97388ec83477c$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $2eb97388ec83477c$var$setInitialProperties(as, "link", href);
            $2eb97388ec83477c$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $2eb97388ec83477c$var$preinitStyle(href, precedence, options) {
    $2eb97388ec83477c$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $2eb97388ec83477c$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $2eb97388ec83477c$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $2eb97388ec83477c$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($2eb97388ec83477c$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $2eb97388ec83477c$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $2eb97388ec83477c$var$preloadPropsMap.get(key)) && $2eb97388ec83477c$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $2eb97388ec83477c$var$markNodeAsHoistable(link);
                $2eb97388ec83477c$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $2eb97388ec83477c$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $2eb97388ec83477c$var$preinitScript(src, options) {
    $2eb97388ec83477c$var$previousDispatcher.X(src, options);
    var ownerDocument = $2eb97388ec83477c$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $2eb97388ec83477c$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $2eb97388ec83477c$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($2eb97388ec83477c$var$getScriptSelectorFromKey(key)), resource || (src = $2eb97388ec83477c$var$assign({
            src: src,
            async: !0
        }, options), (options = $2eb97388ec83477c$var$preloadPropsMap.get(key)) && $2eb97388ec83477c$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $2eb97388ec83477c$var$markNodeAsHoistable(resource), $2eb97388ec83477c$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $2eb97388ec83477c$var$preinitModuleScript(src, options) {
    $2eb97388ec83477c$var$previousDispatcher.M(src, options);
    var ownerDocument = $2eb97388ec83477c$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $2eb97388ec83477c$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $2eb97388ec83477c$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($2eb97388ec83477c$var$getScriptSelectorFromKey(key)), resource || (src = $2eb97388ec83477c$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $2eb97388ec83477c$var$preloadPropsMap.get(key)) && $2eb97388ec83477c$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $2eb97388ec83477c$var$markNodeAsHoistable(resource), $2eb97388ec83477c$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $2eb97388ec83477c$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $2eb97388ec83477c$var$rootInstanceStackCursor.current) ? $2eb97388ec83477c$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $2eb97388ec83477c$var$getStyleKey(pendingProps.href), pendingProps = $2eb97388ec83477c$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $2eb97388ec83477c$var$getStyleKey(pendingProps.href);
                var styles$243 = $2eb97388ec83477c$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($2eb97388ec83477c$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $2eb97388ec83477c$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $2eb97388ec83477c$var$preloadPropsMap.set(type, pendingProps), styles$243 || $2eb97388ec83477c$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $2eb97388ec83477c$var$getScriptKey(pendingProps), pendingProps = $2eb97388ec83477c$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($2eb97388ec83477c$var$formatProdErrorMessage(444, type));
    }
}
function $2eb97388ec83477c$var$getStyleKey(href) {
    return 'href="' + $2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $2eb97388ec83477c$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $2eb97388ec83477c$var$stylesheetPropsFromRawProps(rawProps) {
    return $2eb97388ec83477c$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $2eb97388ec83477c$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $2eb97388ec83477c$var$setInitialProperties(key, "link", preloadProps), $2eb97388ec83477c$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $2eb97388ec83477c$var$getScriptKey(src) {
    return '[src="' + $2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $2eb97388ec83477c$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $2eb97388ec83477c$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $2eb97388ec83477c$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $2eb97388ec83477c$var$markNodeAsHoistable(instance), instance;
            var styleProps = $2eb97388ec83477c$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $2eb97388ec83477c$var$markNodeAsHoistable(instance);
            $2eb97388ec83477c$var$setInitialProperties(instance, "style", styleProps);
            $2eb97388ec83477c$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $2eb97388ec83477c$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($2eb97388ec83477c$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $2eb97388ec83477c$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $2eb97388ec83477c$var$stylesheetPropsFromRawProps(props);
            (styleProps = $2eb97388ec83477c$var$preloadPropsMap.get(styleProps)) && $2eb97388ec83477c$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $2eb97388ec83477c$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $2eb97388ec83477c$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $2eb97388ec83477c$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $2eb97388ec83477c$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($2eb97388ec83477c$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $2eb97388ec83477c$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $2eb97388ec83477c$var$preloadPropsMap.get(instance$249)) instance = $2eb97388ec83477c$var$assign({}, props), $2eb97388ec83477c$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $2eb97388ec83477c$var$markNodeAsHoistable(styleProps);
            $2eb97388ec83477c$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($2eb97388ec83477c$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $2eb97388ec83477c$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $2eb97388ec83477c$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $2eb97388ec83477c$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $2eb97388ec83477c$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $2eb97388ec83477c$var$tagCaches = null;
function $2eb97388ec83477c$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $2eb97388ec83477c$var$tagCaches) {
        var cache = new Map();
        var caches = $2eb97388ec83477c$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $2eb97388ec83477c$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$2eb97388ec83477c$var$internalHoistableMarker] || node[$2eb97388ec83477c$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $2eb97388ec83477c$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $2eb97388ec83477c$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $2eb97388ec83477c$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $2eb97388ec83477c$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $2eb97388ec83477c$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($2eb97388ec83477c$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $2eb97388ec83477c$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $2eb97388ec83477c$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $2eb97388ec83477c$var$stylesheetPropsFromRawProps(props);
            (key = $2eb97388ec83477c$var$preloadPropsMap.get(key)) && $2eb97388ec83477c$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $2eb97388ec83477c$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $2eb97388ec83477c$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $2eb97388ec83477c$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $2eb97388ec83477c$var$estimatedBytesWithinLimit = 0;
function $2eb97388ec83477c$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $2eb97388ec83477c$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $2eb97388ec83477c$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $2eb97388ec83477c$var$estimatedBytesWithinLimit && ($2eb97388ec83477c$var$estimatedBytesWithinLimit = 62500 * $2eb97388ec83477c$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $2eb97388ec83477c$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $2eb97388ec83477c$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $2eb97388ec83477c$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $2eb97388ec83477c$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $2eb97388ec83477c$var$precedencesByRoot = null;
function $2eb97388ec83477c$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $2eb97388ec83477c$var$precedencesByRoot = new Map(), resources.forEach($2eb97388ec83477c$var$insertStylesheetIntoRoot, state), $2eb97388ec83477c$var$precedencesByRoot = null, $2eb97388ec83477c$var$onUnsuspend.call(state));
}
function $2eb97388ec83477c$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $2eb97388ec83477c$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $2eb97388ec83477c$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $2eb97388ec83477c$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $2eb97388ec83477c$var$HostTransitionContext = {
    $$typeof: $2eb97388ec83477c$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $2eb97388ec83477c$var$sharedNotPendingObject,
    _currentValue2: $2eb97388ec83477c$var$sharedNotPendingObject,
    _threadCount: 0
};
function $2eb97388ec83477c$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $2eb97388ec83477c$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $2eb97388ec83477c$var$createLaneMap(0);
    this.hiddenUpdates = $2eb97388ec83477c$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $2eb97388ec83477c$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $2eb97388ec83477c$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $2eb97388ec83477c$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $2eb97388ec83477c$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $2eb97388ec83477c$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $2eb97388ec83477c$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $2eb97388ec83477c$var$emptyContextObject;
    parentComponent = $2eb97388ec83477c$var$emptyContextObject;
    return parentComponent;
}
function $2eb97388ec83477c$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $2eb97388ec83477c$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $2eb97388ec83477c$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $2eb97388ec83477c$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($2eb97388ec83477c$var$scheduleUpdateOnFiber(element, rootFiber, lane), $2eb97388ec83477c$var$entangleTransitions(element, rootFiber, lane));
}
function $2eb97388ec83477c$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $2eb97388ec83477c$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $2eb97388ec83477c$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $2eb97388ec83477c$var$markRetryLaneImpl(fiber, retryLane);
}
function $2eb97388ec83477c$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $2eb97388ec83477c$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $2eb97388ec83477c$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $2eb97388ec83477c$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $2eb97388ec83477c$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $2eb97388ec83477c$var$requestUpdateLane();
        lane = $2eb97388ec83477c$var$getBumpedLaneForHydrationByLane(lane);
        var root = $2eb97388ec83477c$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $2eb97388ec83477c$var$scheduleUpdateOnFiber(root, fiber, lane);
        $2eb97388ec83477c$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $2eb97388ec83477c$var$_enabled = !0;
function $2eb97388ec83477c$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $2eb97388ec83477c$var$ReactSharedInternals.T;
    $2eb97388ec83477c$var$ReactSharedInternals.T = null;
    var previousPriority = $2eb97388ec83477c$var$ReactDOMSharedInternals.p;
    try {
        $2eb97388ec83477c$var$ReactDOMSharedInternals.p = 2, $2eb97388ec83477c$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $2eb97388ec83477c$var$ReactDOMSharedInternals.p = previousPriority, $2eb97388ec83477c$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2eb97388ec83477c$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $2eb97388ec83477c$var$ReactSharedInternals.T;
    $2eb97388ec83477c$var$ReactSharedInternals.T = null;
    var previousPriority = $2eb97388ec83477c$var$ReactDOMSharedInternals.p;
    try {
        $2eb97388ec83477c$var$ReactDOMSharedInternals.p = 8, $2eb97388ec83477c$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $2eb97388ec83477c$var$ReactDOMSharedInternals.p = previousPriority, $2eb97388ec83477c$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2eb97388ec83477c$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($2eb97388ec83477c$var$_enabled) {
        var blockedOn = $2eb97388ec83477c$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $2eb97388ec83477c$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $2eb97388ec83477c$var$return_targetInst, targetContainer), $2eb97388ec83477c$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($2eb97388ec83477c$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($2eb97388ec83477c$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $2eb97388ec83477c$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $2eb97388ec83477c$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $2eb97388ec83477c$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $2eb97388ec83477c$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $2eb97388ec83477c$var$ensureRootIsScheduled(fiber);
                                0 === ($2eb97388ec83477c$var$executionContext & 6) && ($2eb97388ec83477c$var$workInProgressRootRenderTargetTime = $2eb97388ec83477c$var$now() + 500, $2eb97388ec83477c$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $2eb97388ec83477c$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $2eb97388ec83477c$var$scheduleUpdateOnFiber(root, fiber, 2), $2eb97388ec83477c$var$flushSyncWork$1(), $2eb97388ec83477c$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $2eb97388ec83477c$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $2eb97388ec83477c$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $2eb97388ec83477c$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $2eb97388ec83477c$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $2eb97388ec83477c$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $2eb97388ec83477c$var$getEventTarget(nativeEvent);
    return $2eb97388ec83477c$var$findInstanceBlockingTarget(nativeEvent);
}
var $2eb97388ec83477c$var$return_targetInst = null;
function $2eb97388ec83477c$var$findInstanceBlockingTarget(targetNode) {
    $2eb97388ec83477c$var$return_targetInst = null;
    targetNode = $2eb97388ec83477c$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $2eb97388ec83477c$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $2eb97388ec83477c$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $2eb97388ec83477c$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $2eb97388ec83477c$var$return_targetInst = targetNode;
    return null;
}
function $2eb97388ec83477c$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($2eb97388ec83477c$var$getCurrentPriorityLevel()){
                case $2eb97388ec83477c$var$ImmediatePriority:
                    return 2;
                case $2eb97388ec83477c$var$UserBlockingPriority:
                    return 8;
                case $2eb97388ec83477c$var$NormalPriority$1:
                case $2eb97388ec83477c$var$LowPriority:
                    return 32;
                case $2eb97388ec83477c$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $2eb97388ec83477c$var$hasScheduledReplayAttempt = !1, $2eb97388ec83477c$var$queuedFocus = null, $2eb97388ec83477c$var$queuedDrag = null, $2eb97388ec83477c$var$queuedMouse = null, $2eb97388ec83477c$var$queuedPointers = new Map(), $2eb97388ec83477c$var$queuedPointerCaptures = new Map(), $2eb97388ec83477c$var$queuedExplicitHydrationTargets = [], $2eb97388ec83477c$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $2eb97388ec83477c$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $2eb97388ec83477c$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $2eb97388ec83477c$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $2eb97388ec83477c$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $2eb97388ec83477c$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $2eb97388ec83477c$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $2eb97388ec83477c$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $2eb97388ec83477c$var$getInstanceFromNode(blockedOn), null !== blockedOn && $2eb97388ec83477c$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $2eb97388ec83477c$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $2eb97388ec83477c$var$queuedFocus = $2eb97388ec83477c$var$accumulateOrCreateContinuousQueuedReplayableEvent($2eb97388ec83477c$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $2eb97388ec83477c$var$queuedDrag = $2eb97388ec83477c$var$accumulateOrCreateContinuousQueuedReplayableEvent($2eb97388ec83477c$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $2eb97388ec83477c$var$queuedMouse = $2eb97388ec83477c$var$accumulateOrCreateContinuousQueuedReplayableEvent($2eb97388ec83477c$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $2eb97388ec83477c$var$queuedPointers.set(pointerId, $2eb97388ec83477c$var$accumulateOrCreateContinuousQueuedReplayableEvent($2eb97388ec83477c$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $2eb97388ec83477c$var$queuedPointerCaptures.set(pointerId, $2eb97388ec83477c$var$accumulateOrCreateContinuousQueuedReplayableEvent($2eb97388ec83477c$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $2eb97388ec83477c$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $2eb97388ec83477c$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $2eb97388ec83477c$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $2eb97388ec83477c$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $2eb97388ec83477c$var$runWithPriority(queuedTarget.priority, function() {
                        $2eb97388ec83477c$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $2eb97388ec83477c$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $2eb97388ec83477c$var$runWithPriority(queuedTarget.priority, function() {
                        $2eb97388ec83477c$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $2eb97388ec83477c$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $2eb97388ec83477c$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $2eb97388ec83477c$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $2eb97388ec83477c$var$currentReplayingEvent = null;
        } else return targetContainers = $2eb97388ec83477c$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $2eb97388ec83477c$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $2eb97388ec83477c$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $2eb97388ec83477c$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $2eb97388ec83477c$var$replayUnblockedEvents() {
    $2eb97388ec83477c$var$hasScheduledReplayAttempt = !1;
    null !== $2eb97388ec83477c$var$queuedFocus && $2eb97388ec83477c$var$attemptReplayContinuousQueuedEvent($2eb97388ec83477c$var$queuedFocus) && ($2eb97388ec83477c$var$queuedFocus = null);
    null !== $2eb97388ec83477c$var$queuedDrag && $2eb97388ec83477c$var$attemptReplayContinuousQueuedEvent($2eb97388ec83477c$var$queuedDrag) && ($2eb97388ec83477c$var$queuedDrag = null);
    null !== $2eb97388ec83477c$var$queuedMouse && $2eb97388ec83477c$var$attemptReplayContinuousQueuedEvent($2eb97388ec83477c$var$queuedMouse) && ($2eb97388ec83477c$var$queuedMouse = null);
    $2eb97388ec83477c$var$queuedPointers.forEach($2eb97388ec83477c$var$attemptReplayContinuousQueuedEventInMap);
    $2eb97388ec83477c$var$queuedPointerCaptures.forEach($2eb97388ec83477c$var$attemptReplayContinuousQueuedEventInMap);
}
function $2eb97388ec83477c$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $2eb97388ec83477c$var$hasScheduledReplayAttempt || ($2eb97388ec83477c$var$hasScheduledReplayAttempt = !0, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, $2eb97388ec83477c$var$replayUnblockedEvents)));
}
var $2eb97388ec83477c$var$lastScheduledReplayQueue = null;
function $2eb97388ec83477c$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $2eb97388ec83477c$var$lastScheduledReplayQueue !== formReplayingQueue && ($2eb97388ec83477c$var$lastScheduledReplayQueue = formReplayingQueue, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, function() {
        $2eb97388ec83477c$var$lastScheduledReplayQueue === formReplayingQueue && ($2eb97388ec83477c$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $2eb97388ec83477c$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $2eb97388ec83477c$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $2eb97388ec83477c$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $2eb97388ec83477c$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $2eb97388ec83477c$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $2eb97388ec83477c$var$queuedFocus && $2eb97388ec83477c$var$scheduleCallbackIfUnblocked($2eb97388ec83477c$var$queuedFocus, unblocked);
    null !== $2eb97388ec83477c$var$queuedDrag && $2eb97388ec83477c$var$scheduleCallbackIfUnblocked($2eb97388ec83477c$var$queuedDrag, unblocked);
    null !== $2eb97388ec83477c$var$queuedMouse && $2eb97388ec83477c$var$scheduleCallbackIfUnblocked($2eb97388ec83477c$var$queuedMouse, unblocked);
    $2eb97388ec83477c$var$queuedPointers.forEach(unblock);
    $2eb97388ec83477c$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $2eb97388ec83477c$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $2eb97388ec83477c$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $2eb97388ec83477c$var$queuedExplicitHydrationTargets.length && (i = $2eb97388ec83477c$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$2eb97388ec83477c$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $2eb97388ec83477c$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$2eb97388ec83477c$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $2eb97388ec83477c$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$2eb97388ec83477c$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $2eb97388ec83477c$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $2eb97388ec83477c$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $2eb97388ec83477c$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $2eb97388ec83477c$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$2eb97388ec83477c$var$ReactDOMHydrationRoot.prototype.render = $2eb97388ec83477c$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(409));
    var current = root.current, lane = $2eb97388ec83477c$var$requestUpdateLane();
    $2eb97388ec83477c$var$updateContainerImpl(current, lane, children, root, null, null);
};
$2eb97388ec83477c$var$ReactDOMHydrationRoot.prototype.unmount = $2eb97388ec83477c$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $2eb97388ec83477c$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $2eb97388ec83477c$var$flushSyncWork$1();
        container[$2eb97388ec83477c$var$internalContainerInstanceKey] = null;
    }
};
function $2eb97388ec83477c$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$2eb97388ec83477c$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $2eb97388ec83477c$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $2eb97388ec83477c$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $2eb97388ec83477c$var$queuedExplicitHydrationTargets[i].priority; i++);
        $2eb97388ec83477c$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $2eb97388ec83477c$var$attemptExplicitHydrationTarget(target);
    }
};
var $2eb97388ec83477c$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $7DB8U.version;
if ("19.2.8" !== $2eb97388ec83477c$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(527, $2eb97388ec83477c$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$2eb97388ec83477c$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($2eb97388ec83477c$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $2eb97388ec83477c$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $2eb97388ec83477c$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $2eb97388ec83477c$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $2eb97388ec83477c$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $2eb97388ec83477c$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$2eb97388ec83477c$var$hook$jscomp$inline_2348.isDisabled && $2eb97388ec83477c$var$hook$jscomp$inline_2348.supportsFiber) try {
        $2eb97388ec83477c$var$rendererID = $2eb97388ec83477c$var$hook$jscomp$inline_2348.inject($2eb97388ec83477c$var$internals$jscomp$inline_2347), $2eb97388ec83477c$var$injectedHook = $2eb97388ec83477c$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$2eb97388ec83477c$export$882461b6382ed46c = function(container, options) {
    if (!$2eb97388ec83477c$var$isValidContainer(container)) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $2eb97388ec83477c$var$defaultOnUncaughtError, onCaughtError = $2eb97388ec83477c$var$defaultOnCaughtError, onRecoverableError = $2eb97388ec83477c$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $2eb97388ec83477c$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $2eb97388ec83477c$var$defaultOnDefaultTransitionIndicator);
    container[$2eb97388ec83477c$var$internalContainerInstanceKey] = options.current;
    $2eb97388ec83477c$var$listenToAllSupportedEvents(container);
    return new $2eb97388ec83477c$var$ReactDOMRoot(options);
};
$2eb97388ec83477c$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$2eb97388ec83477c$var$isValidContainer(container)) throw Error($2eb97388ec83477c$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $2eb97388ec83477c$var$defaultOnUncaughtError, onCaughtError = $2eb97388ec83477c$var$defaultOnCaughtError, onRecoverableError = $2eb97388ec83477c$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $2eb97388ec83477c$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $2eb97388ec83477c$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $2eb97388ec83477c$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $2eb97388ec83477c$var$requestUpdateLane();
    isStrictMode = $2eb97388ec83477c$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $2eb97388ec83477c$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $2eb97388ec83477c$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $2eb97388ec83477c$var$markRootUpdated$1(initialChildren, options);
    $2eb97388ec83477c$var$ensureRootIsScheduled(initialChildren);
    container[$2eb97388ec83477c$var$internalContainerInstanceKey] = initialChildren.current;
    $2eb97388ec83477c$var$listenToAllSupportedEvents(container);
    return new $2eb97388ec83477c$var$ReactDOMHydrationRoot(initialChildren);
};
$2eb97388ec83477c$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("bIbqH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hvKuw"));

});
parcelRegister("hvKuw", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $cbf9651fe4890f47$export$c4744153514ff05d, (v) => $cbf9651fe4890f47$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7, (v) => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $cbf9651fe4890f47$export$e26fe2ed2fa76875, (v) => $cbf9651fe4890f47$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $cbf9651fe4890f47$export$502329bbf4b505b1, (v) => $cbf9651fe4890f47$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $cbf9651fe4890f47$export$6e3807111c4874c4, (v) => $cbf9651fe4890f47$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $cbf9651fe4890f47$export$c27134553091fb3a, (v) => $cbf9651fe4890f47$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $cbf9651fe4890f47$export$33ee1acdc04fd2a2, (v) => $cbf9651fe4890f47$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $cbf9651fe4890f47$export$b00a404bbd5edef2, (v) => $cbf9651fe4890f47$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $cbf9651fe4890f47$export$d66a1c1c77bd778b, (v) => $cbf9651fe4890f47$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $cbf9651fe4890f47$export$d3dfb8e4810cb555, (v) => $cbf9651fe4890f47$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $cbf9651fe4890f47$export$72fdf0e06517287b, (v) => $cbf9651fe4890f47$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $cbf9651fe4890f47$export$816d2913ae6b83b1, (v) => $cbf9651fe4890f47$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $cbf9651fe4890f47$export$61bcfe829111a1d0, (v) => $cbf9651fe4890f47$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $cbf9651fe4890f47$export$7ee8c9beb337bc3f, (v) => $cbf9651fe4890f47$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $cbf9651fe4890f47$export$b5836b71941fa3ed, (v) => $cbf9651fe4890f47$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $cbf9651fe4890f47$export$cf845f2c119da08a, (v) => $cbf9651fe4890f47$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cbf9651fe4890f47$export$c4744153514ff05d;
var $cbf9651fe4890f47$export$3e506c1ccc9cc1a7;
var $cbf9651fe4890f47$export$e26fe2ed2fa76875;
var $cbf9651fe4890f47$export$502329bbf4b505b1;
var $cbf9651fe4890f47$export$6e3807111c4874c4;
var $cbf9651fe4890f47$export$c27134553091fb3a;
var $cbf9651fe4890f47$export$33ee1acdc04fd2a2;
var $cbf9651fe4890f47$export$b00a404bbd5edef2;
var $cbf9651fe4890f47$export$d66a1c1c77bd778b;
var $cbf9651fe4890f47$export$d3dfb8e4810cb555;
var $cbf9651fe4890f47$export$72fdf0e06517287b;
var $cbf9651fe4890f47$export$816d2913ae6b83b1;
var $cbf9651fe4890f47$export$61bcfe829111a1d0;
var $cbf9651fe4890f47$export$7ee8c9beb337bc3f;
var $cbf9651fe4890f47$export$b5836b71941fa3ed;
var $cbf9651fe4890f47$export$cf845f2c119da08a;
"use strict";
function $cbf9651fe4890f47$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $cbf9651fe4890f47$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $cbf9651fe4890f47$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $cbf9651fe4890f47$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $cbf9651fe4890f47$var$compare(left, last)) rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $cbf9651fe4890f47$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$cbf9651fe4890f47$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $cbf9651fe4890f47$var$localPerformance = performance;
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localPerformance.now();
    };
} else {
    var $cbf9651fe4890f47$var$localDate = Date, $cbf9651fe4890f47$var$initialTime = $cbf9651fe4890f47$var$localDate.now();
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localDate.now() - $cbf9651fe4890f47$var$initialTime;
    };
}
var $cbf9651fe4890f47$var$taskQueue = [], $cbf9651fe4890f47$var$timerQueue = [], $cbf9651fe4890f47$var$taskIdCounter = 1, $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = 3, $cbf9651fe4890f47$var$isPerformingWork = !1, $cbf9651fe4890f47$var$isHostCallbackScheduled = !1, $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$needsPaint = !1, $cbf9651fe4890f47$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $cbf9651fe4890f47$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $cbf9651fe4890f47$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $cbf9651fe4890f47$var$advanceTimers(currentTime) {
    for(var timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue); null !== timer;){
        if (null === timer.callback) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue);
        else if (timer.startTime <= currentTime) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue), timer.sortIndex = timer.expirationTime, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, timer);
        else break;
        timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
    }
}
function $cbf9651fe4890f47$var$handleTimeout(currentTime) {
    $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1;
    $cbf9651fe4890f47$var$advanceTimers(currentTime);
    if (!$cbf9651fe4890f47$var$isHostCallbackScheduled) {
        if (null !== $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue)) $cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $cbf9651fe4890f47$var$isMessageLoopRunning = !1, $cbf9651fe4890f47$var$taskTimeoutID = -1, $cbf9651fe4890f47$var$frameInterval = 5, $cbf9651fe4890f47$var$startTime = -1;
function $cbf9651fe4890f47$var$shouldYieldToHost() {
    return $cbf9651fe4890f47$var$needsPaint ? !0 : $cbf9651fe4890f47$export$c4744153514ff05d() - $cbf9651fe4890f47$var$startTime < $cbf9651fe4890f47$var$frameInterval ? !1 : !0;
}
function $cbf9651fe4890f47$var$performWorkUntilDeadline() {
    $cbf9651fe4890f47$var$needsPaint = !1;
    if ($cbf9651fe4890f47$var$isMessageLoopRunning) {
        var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
        $cbf9651fe4890f47$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $cbf9651fe4890f47$var$isHostCallbackScheduled = !1;
                $cbf9651fe4890f47$var$isHostTimeoutScheduled && ($cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1);
                $cbf9651fe4890f47$var$isPerformingWork = !0;
                var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
                try {
                    b: {
                        $cbf9651fe4890f47$var$advanceTimers(currentTime);
                        for($cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue); null !== $cbf9651fe4890f47$var$currentTask && !($cbf9651fe4890f47$var$currentTask.expirationTime > currentTime && $cbf9651fe4890f47$var$shouldYieldToHost());){
                            var callback = $cbf9651fe4890f47$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $cbf9651fe4890f47$var$currentTask.callback = null;
                                $cbf9651fe4890f47$var$currentPriorityLevel = $cbf9651fe4890f47$var$currentTask.priorityLevel;
                                var continuationCallback = callback($cbf9651fe4890f47$var$currentTask.expirationTime <= currentTime);
                                currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $cbf9651fe4890f47$var$currentTask.callback = continuationCallback;
                                    $cbf9651fe4890f47$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $cbf9651fe4890f47$var$currentTask === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                                $cbf9651fe4890f47$var$advanceTimers(currentTime);
                            } else $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                            $cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue);
                        }
                        if (null !== $cbf9651fe4890f47$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
                            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel, $cbf9651fe4890f47$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline() : $cbf9651fe4890f47$var$isMessageLoopRunning = !1;
        }
    }
}
var $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $cbf9651fe4890f47$var$localSetImmediate) $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetImmediate($cbf9651fe4890f47$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $cbf9651fe4890f47$var$channel = new MessageChannel(), $cbf9651fe4890f47$var$port = $cbf9651fe4890f47$var$channel.port2;
    $cbf9651fe4890f47$var$channel.port1.onmessage = $cbf9651fe4890f47$var$performWorkUntilDeadline;
    $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
        $cbf9651fe4890f47$var$port.postMessage(null);
    };
} else $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetTimeout($cbf9651fe4890f47$var$performWorkUntilDeadline, 0);
};
function $cbf9651fe4890f47$var$requestHostTimeout(callback, ms) {
    $cbf9651fe4890f47$var$taskTimeoutID = $cbf9651fe4890f47$var$localSetTimeout(function() {
        callback($cbf9651fe4890f47$export$c4744153514ff05d());
    }, ms);
}
$cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = 5;
$cbf9651fe4890f47$export$e26fe2ed2fa76875 = 1;
$cbf9651fe4890f47$export$502329bbf4b505b1 = 4;
$cbf9651fe4890f47$export$6e3807111c4874c4 = 3;
$cbf9651fe4890f47$export$c27134553091fb3a = null;
$cbf9651fe4890f47$export$33ee1acdc04fd2a2 = 2;
$cbf9651fe4890f47$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$cbf9651fe4890f47$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $cbf9651fe4890f47$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$cbf9651fe4890f47$export$d3dfb8e4810cb555 = function() {
    return $cbf9651fe4890f47$var$currentPriorityLevel;
};
$cbf9651fe4890f47$export$72fdf0e06517287b = function(eventHandler) {
    switch($cbf9651fe4890f47$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$816d2913ae6b83b1 = function() {
    $cbf9651fe4890f47$var$needsPaint = !0;
};
$cbf9651fe4890f47$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $cbf9651fe4890f47$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$timerQueue, priorityLevel), null === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && priorityLevel === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue) && ($cbf9651fe4890f47$var$isHostTimeoutScheduled ? ($cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1) : $cbf9651fe4890f47$var$isHostTimeoutScheduled = !0, $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, priorityLevel), $cbf9651fe4890f47$var$isHostCallbackScheduled || $cbf9651fe4890f47$var$isPerformingWork || ($cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$cbf9651fe4890f47$export$b5836b71941fa3ed = $cbf9651fe4890f47$var$shouldYieldToHost;
$cbf9651fe4890f47$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
        $cbf9651fe4890f47$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("9lImh", function(module, exports) {
'use strict';
function $6ce87be38eba84a6$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6ce87be38eba84a6$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6ce87be38eba84a6$var$checkDCE();

module.exports = (parcelRequire("iSm9w"));

});


parcelRegister("dhnve", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $9aaf1809a83fe6d0$export$2b8d127b894957b9, (v) => $9aaf1809a83fe6d0$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $9aaf1809a83fe6d0$export$cea3a54a6425200c, (v) => $9aaf1809a83fe6d0$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $9aaf1809a83fe6d0$export$a7c73072b1a182ae, (v) => $9aaf1809a83fe6d0$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9aaf1809a83fe6d0$export$9f27bc3417b4524d, (v) => $9aaf1809a83fe6d0$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac, (v) => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35, (v) => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9aaf1809a83fe6d0$export$ffb0004e005737fa, (v) => $9aaf1809a83fe6d0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9aaf1809a83fe6d0$export$b624eff549462981, (v) => $9aaf1809a83fe6d0$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9aaf1809a83fe6d0$export$7897aa7841a5380c, (v) => $9aaf1809a83fe6d0$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9aaf1809a83fe6d0$export$602eac185826482c, (v) => $9aaf1809a83fe6d0$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9aaf1809a83fe6d0$export$e2c29f18771995cb, (v) => $9aaf1809a83fe6d0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9aaf1809a83fe6d0$export$5f8d39834fd61797, (v) => $9aaf1809a83fe6d0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5, (v) => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9aaf1809a83fe6d0$export$92387174baf9b227, (v) => $9aaf1809a83fe6d0$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9aaf1809a83fe6d0$export$ec112efeb987d9c6, (v) => $9aaf1809a83fe6d0$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9aaf1809a83fe6d0$export$b706b080d889d2c9, (v) => $9aaf1809a83fe6d0$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9aaf1809a83fe6d0$export$5be5a87408f70ddc, (v) => $9aaf1809a83fe6d0$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d, (v) => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9aaf1809a83fe6d0$export$455c2e768291efa6, (v) => $9aaf1809a83fe6d0$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9aaf1809a83fe6d0$export$9522e17588c12572, (v) => $9aaf1809a83fe6d0$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9aaf1809a83fe6d0$export$2110ac352bb060b9, (v) => $9aaf1809a83fe6d0$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9aaf1809a83fe6d0$export$56885ab8b9c456ab, (v) => $9aaf1809a83fe6d0$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de, (v) => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9aaf1809a83fe6d0$export$b82d16f27459e05a, (v) => $9aaf1809a83fe6d0$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9aaf1809a83fe6d0$export$522c17b4f5e123e8, (v) => $9aaf1809a83fe6d0$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6, (v) => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $9aaf1809a83fe6d0$export$9b621391a187a31a, (v) => $9aaf1809a83fe6d0$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f, (v) => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9aaf1809a83fe6d0$export$2b8d127b894957b9;
var $9aaf1809a83fe6d0$export$cea3a54a6425200c;
var $9aaf1809a83fe6d0$export$a7c73072b1a182ae;
var $9aaf1809a83fe6d0$export$9f27bc3417b4524d;
var $9aaf1809a83fe6d0$export$db77ccec0bb4ccac;
var $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35;
var $9aaf1809a83fe6d0$export$ffb0004e005737fa;
var $9aaf1809a83fe6d0$export$b624eff549462981;
var $9aaf1809a83fe6d0$export$7897aa7841a5380c;
var $9aaf1809a83fe6d0$export$602eac185826482c;
var $9aaf1809a83fe6d0$export$e2c29f18771995cb;
var $9aaf1809a83fe6d0$export$5f8d39834fd61797;
var $9aaf1809a83fe6d0$export$74bf444e3cd11ea5;
var $9aaf1809a83fe6d0$export$92387174baf9b227;
var $9aaf1809a83fe6d0$export$ec112efeb987d9c6;
var $9aaf1809a83fe6d0$export$b706b080d889d2c9;
var $9aaf1809a83fe6d0$export$5be5a87408f70ddc;
var $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d;
var $9aaf1809a83fe6d0$export$455c2e768291efa6;
var $9aaf1809a83fe6d0$export$9522e17588c12572;
var $9aaf1809a83fe6d0$export$2110ac352bb060b9;
var $9aaf1809a83fe6d0$export$56885ab8b9c456ab;
var $9aaf1809a83fe6d0$export$d927fcb6adf8f9de;
var $9aaf1809a83fe6d0$export$b82d16f27459e05a;
var $9aaf1809a83fe6d0$export$522c17b4f5e123e8;
var $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6;
var $9aaf1809a83fe6d0$export$9b621391a187a31a;
var $9aaf1809a83fe6d0$export$f5bbd400c2f4426f;
'use strict';
var $9aaf1809a83fe6d0$var$b = "function" === typeof Symbol && Symbol.for, $9aaf1809a83fe6d0$var$c = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.element") : 60103, $9aaf1809a83fe6d0$var$d = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.portal") : 60106, $9aaf1809a83fe6d0$var$e = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fragment") : 60107, $9aaf1809a83fe6d0$var$f = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.strict_mode") : 60108, $9aaf1809a83fe6d0$var$g = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.profiler") : 60114, $9aaf1809a83fe6d0$var$h = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.provider") : 60109, $9aaf1809a83fe6d0$var$k = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.context") : 60110, $9aaf1809a83fe6d0$var$l = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.async_mode") : 60111, $9aaf1809a83fe6d0$var$m = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.concurrent_mode") : 60111, $9aaf1809a83fe6d0$var$n = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.forward_ref") : 60112, $9aaf1809a83fe6d0$var$p = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense") : 60113, $9aaf1809a83fe6d0$var$q = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense_list") : 60120, $9aaf1809a83fe6d0$var$r = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.memo") : 60115, $9aaf1809a83fe6d0$var$t = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.lazy") : 60116, $9aaf1809a83fe6d0$var$v = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.block") : 60121, $9aaf1809a83fe6d0$var$w = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fundamental") : 60117, $9aaf1809a83fe6d0$var$x = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.responder") : 60118, $9aaf1809a83fe6d0$var$y = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.scope") : 60119;
function $9aaf1809a83fe6d0$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $9aaf1809a83fe6d0$var$c:
                switch(a = a.type, a){
                    case $9aaf1809a83fe6d0$var$l:
                    case $9aaf1809a83fe6d0$var$m:
                    case $9aaf1809a83fe6d0$var$e:
                    case $9aaf1809a83fe6d0$var$g:
                    case $9aaf1809a83fe6d0$var$f:
                    case $9aaf1809a83fe6d0$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9aaf1809a83fe6d0$var$k:
                            case $9aaf1809a83fe6d0$var$n:
                            case $9aaf1809a83fe6d0$var$t:
                            case $9aaf1809a83fe6d0$var$r:
                            case $9aaf1809a83fe6d0$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $9aaf1809a83fe6d0$var$d:
                return u;
        }
    }
}
function $9aaf1809a83fe6d0$var$A(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$m;
}
$9aaf1809a83fe6d0$export$2b8d127b894957b9 = $9aaf1809a83fe6d0$var$l;
$9aaf1809a83fe6d0$export$cea3a54a6425200c = $9aaf1809a83fe6d0$var$m;
$9aaf1809a83fe6d0$export$a7c73072b1a182ae = $9aaf1809a83fe6d0$var$k;
$9aaf1809a83fe6d0$export$9f27bc3417b4524d = $9aaf1809a83fe6d0$var$h;
$9aaf1809a83fe6d0$export$db77ccec0bb4ccac = $9aaf1809a83fe6d0$var$c;
$9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = $9aaf1809a83fe6d0$var$n;
$9aaf1809a83fe6d0$export$ffb0004e005737fa = $9aaf1809a83fe6d0$var$e;
$9aaf1809a83fe6d0$export$b624eff549462981 = $9aaf1809a83fe6d0$var$t;
$9aaf1809a83fe6d0$export$7897aa7841a5380c = $9aaf1809a83fe6d0$var$r;
$9aaf1809a83fe6d0$export$602eac185826482c = $9aaf1809a83fe6d0$var$d;
$9aaf1809a83fe6d0$export$e2c29f18771995cb = $9aaf1809a83fe6d0$var$g;
$9aaf1809a83fe6d0$export$5f8d39834fd61797 = $9aaf1809a83fe6d0$var$f;
$9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = $9aaf1809a83fe6d0$var$p;
$9aaf1809a83fe6d0$export$92387174baf9b227 = function(a) {
    return $9aaf1809a83fe6d0$var$A(a) || $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$l;
};
$9aaf1809a83fe6d0$export$ec112efeb987d9c6 = $9aaf1809a83fe6d0$var$A;
$9aaf1809a83fe6d0$export$b706b080d889d2c9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$k;
};
$9aaf1809a83fe6d0$export$5be5a87408f70ddc = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$h;
};
$9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9aaf1809a83fe6d0$var$c;
};
$9aaf1809a83fe6d0$export$455c2e768291efa6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$n;
};
$9aaf1809a83fe6d0$export$9522e17588c12572 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$e;
};
$9aaf1809a83fe6d0$export$2110ac352bb060b9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$t;
};
$9aaf1809a83fe6d0$export$56885ab8b9c456ab = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$r;
};
$9aaf1809a83fe6d0$export$d927fcb6adf8f9de = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$d;
};
$9aaf1809a83fe6d0$export$b82d16f27459e05a = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$g;
};
$9aaf1809a83fe6d0$export$522c17b4f5e123e8 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$f;
};
$9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$p;
};
$9aaf1809a83fe6d0$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9aaf1809a83fe6d0$var$e || a === $9aaf1809a83fe6d0$var$m || a === $9aaf1809a83fe6d0$var$g || a === $9aaf1809a83fe6d0$var$f || a === $9aaf1809a83fe6d0$var$p || a === $9aaf1809a83fe6d0$var$q || "object" === typeof a && null !== a && (a.$$typeof === $9aaf1809a83fe6d0$var$t || a.$$typeof === $9aaf1809a83fe6d0$var$r || a.$$typeof === $9aaf1809a83fe6d0$var$h || a.$$typeof === $9aaf1809a83fe6d0$var$k || a.$$typeof === $9aaf1809a83fe6d0$var$n || a.$$typeof === $9aaf1809a83fe6d0$var$w || a.$$typeof === $9aaf1809a83fe6d0$var$x || a.$$typeof === $9aaf1809a83fe6d0$var$y || a.$$typeof === $9aaf1809a83fe6d0$var$v);
};
$9aaf1809a83fe6d0$export$f5bbd400c2f4426f = $9aaf1809a83fe6d0$var$z;

});

parcelRegister("dYe7D", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function isEqualWith(value, other, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = isEqualWith;

});

parcelRegister("14lt5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0c76d148e5be5c52$export$2e2bcd8739ae039);

var $7DB8U = parcelRequire("7DB8U");

var $2d4js = parcelRequire("2d4js");

var $62bxO = parcelRequire("62bxO");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $0c76d148e5be5c52$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $0c76d148e5be5c52$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $0c76d148e5be5c52$var$ReactEditorJS(_a) {
    var { factory: factory, holder: holder, defaultValue: defaultValue, children: children, value: value, onInitialize: onInitialize } = _a, restProps = $0c76d148e5be5c52$var$__rest(_a, [
        "factory",
        "holder",
        "defaultValue",
        "children",
        "value",
        "onInitialize"
    ]);
    const memoizedHolder = (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).useRef(holder !== null && holder !== void 0 ? holder : `react-editor-js-${Date.now().toString(16)}`);
    const editorJS = (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).useEffect(()=>{
        editorJS.current = factory(Object.assign(Object.assign({
            holder: memoizedHolder.current
        }, defaultValue && {
            data: defaultValue
        }), restProps));
        onInitialize === null || onInitialize === void 0 || onInitialize(editorJS.current);
        return ()=>{
            var _a;
            (_a = editorJS.current) === null || _a === void 0 || _a.destroy();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).useEffect(()=>{
        var _a;
        if (value) (_a = editorJS.current) === null || _a === void 0 || _a.render(value);
    }, [
        value
    ]);
    return children || (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).createElement("div", {
        id: memoizedHolder.current
    });
}
class $0c76d148e5be5c52$var$ClientEditorCore {
    constructor(_a){
        var { tools: tools } = _a, config = $0c76d148e5be5c52$var$__rest(_a, [
            "tools"
        ]);
        const extendTools = Object.assign({
            // default tools
            paragraph: {
                class: (0, $62bxO.default),
                inlineToolbar: true
            }
        }, tools);
        this._editorJS = new (0, $2d4js.default)(Object.assign({
            tools: extendTools
        }, config));
    }
    get dangerouslyLowLevelInstance() {
        return this._editorJS;
    }
    clear() {
        return $0c76d148e5be5c52$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.clear();
        });
    }
    save() {
        return $0c76d148e5be5c52$var$__awaiter(this, void 0, void 0, function*() {
            return this._editorJS.save();
        });
    }
    destroy() {
        return $0c76d148e5be5c52$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.isReady;
            yield this._editorJS.destroy();
        });
    }
    render(data) {
        return $0c76d148e5be5c52$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.render(data);
        });
    }
}
function $0c76d148e5be5c52$export$2e2bcd8739ae039(props) {
    const factory = (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).useCallback((config)=>new $0c76d148e5be5c52$var$ClientEditorCore(config), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).createElement($0c76d148e5be5c52$var$ReactEditorJS, Object.assign({
        factory: factory
    }, props));
}

});
parcelRegister("2d4js", function(module, exports) {

$parcel$export(module.exports, "default", () => $6813aa9d7dc8ab1a$export$2e2bcd8739ae039);
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-hint--align-start{text-align:left}.ce-hint--align-center{text-align:center}.ce-hint__description{opacity:.6;margin-top:3px}")), document.head.appendChild(e);
        }
    } catch (t1) {
        console.error("vite-plugin-css-injected-by-js", t1);
    }
})();
var $6813aa9d7dc8ab1a$var$Ce = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $6813aa9d7dc8ab1a$var$Ke(n) {
    return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function $6813aa9d7dc8ab1a$var$Xn(n) {
    if (n.__esModule) return n;
    var e = n.default;
    if (typeof e == "function") {
        var t1 = function o() {
            return this instanceof o ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
        };
        t1.prototype = e.prototype;
    } else t1 = {};
    return Object.defineProperty(t1, "__esModule", {
        value: !0
    }), Object.keys(n).forEach(function(o) {
        var i = Object.getOwnPropertyDescriptor(n, o);
        Object.defineProperty(t1, o, i.get ? i : {
            enumerable: !0,
            get: function() {
                return n[o];
            }
        });
    }), t1;
}
function $6813aa9d7dc8ab1a$var$ot() {}
Object.assign($6813aa9d7dc8ab1a$var$ot, {
    default: $6813aa9d7dc8ab1a$var$ot,
    register: $6813aa9d7dc8ab1a$var$ot,
    revert: function() {},
    __esModule: !0
});
Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(n) {
    const e = (this.document || this.ownerDocument).querySelectorAll(n);
    let t1 = e.length;
    for(; --t1 >= 0 && e.item(t1) !== this;);
    return t1 > -1;
});
Element.prototype.closest || (Element.prototype.closest = function(n) {
    let e = this;
    if (!document.documentElement.contains(e)) return null;
    do {
        if (e.matches(n)) return e;
        e = e.parentElement || e.parentNode;
    }while (e !== null);
    return null;
});
Element.prototype.prepend || (Element.prototype.prepend = function(e) {
    const t1 = document.createDocumentFragment();
    Array.isArray(e) || (e = [
        e
    ]), e.forEach((o)=>{
        const i = o instanceof Node;
        t1.appendChild(i ? o : document.createTextNode(o));
    }), this.insertBefore(t1, this.firstChild);
});
Element.prototype.scrollIntoViewIfNeeded || (Element.prototype.scrollIntoViewIfNeeded = function(n) {
    n = arguments.length === 0 ? !0 : !!n;
    const e = this.parentNode, t1 = window.getComputedStyle(e, null), o = parseInt(t1.getPropertyValue("border-top-width")), i = parseInt(t1.getPropertyValue("border-left-width")), s = this.offsetTop - e.offsetTop < e.scrollTop, r = this.offsetTop - e.offsetTop + this.clientHeight - o > e.scrollTop + e.clientHeight, a = this.offsetLeft - e.offsetLeft < e.scrollLeft, l = this.offsetLeft - e.offsetLeft + this.clientWidth - i > e.scrollLeft + e.clientWidth, c = s && !r;
    (s || r) && n && (e.scrollTop = this.offsetTop - e.offsetTop - e.clientHeight / 2 - o + this.clientHeight / 2), (a || l) && n && (e.scrollLeft = this.offsetLeft - e.offsetLeft - e.clientWidth / 2 - i + this.clientWidth / 2), (s || r || a || l) && !n && this.scrollIntoView(c);
});
window.requestIdleCallback = window.requestIdleCallback || function(n) {
    const e = Date.now();
    return setTimeout(function() {
        n({
            didTimeout: !1,
            timeRemaining: function() {
                return Math.max(0, 50 - (Date.now() - e));
            }
        });
    }, 1);
};
window.cancelIdleCallback = window.cancelIdleCallback || function(n) {
    clearTimeout(n);
};
let $6813aa9d7dc8ab1a$var$Vn = (n = 21)=>crypto.getRandomValues(new Uint8Array(n)).reduce((e, t1)=>(t1 &= 63, t1 < 36 ? e += t1.toString(36) : t1 < 62 ? e += (t1 - 26).toString(36).toUpperCase() : t1 > 62 ? e += "-" : e += "_", e), "");
var $6813aa9d7dc8ab1a$var$Lo = /* @__PURE__ */ ((n)=>(n.VERBOSE = "VERBOSE", n.INFO = "INFO", n.WARN = "WARN", n.ERROR = "ERROR", n))($6813aa9d7dc8ab1a$var$Lo || {});
const $6813aa9d7dc8ab1a$var$y = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $6813aa9d7dc8ab1a$var$qn = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
function $6813aa9d7dc8ab1a$var$Ie(n, e, t1 = "log", o, i = "color: inherit") {
    if (!("console" in window) || !window.console[t1]) return;
    const s = [
        "info",
        "log",
        "warn",
        "error"
    ].includes(t1), r = [];
    switch($6813aa9d7dc8ab1a$var$Ie.logLevel){
        case "ERROR":
            if (t1 !== "error") return;
            break;
        case "WARN":
            if (![
                "error",
                "warn"
            ].includes(t1)) return;
            break;
        case "INFO":
            if (!s || n) return;
            break;
    }
    o && r.push(o);
    const a = "Editor.js 2.31.6", l = `line-height: 1em;
            color: #006FEA;
            display: inline-block;
            font-size: 11px;
            line-height: 1em;
            background-color: #fff;
            padding: 4px 9px;
            border-radius: 30px;
            border: 1px solid rgba(56, 138, 229, 0.16);
            margin: 4px 5px 4px 0;`;
    n && (s ? (r.unshift(l, i), e = `%c${a}%c ${e}`) : e = `( ${a} )${e}`);
    try {
        s ? o ? console[t1](`${e} %o`, ...r) : console[t1](e, ...r) : console[t1](e);
    } catch  {}
}
$6813aa9d7dc8ab1a$var$Ie.logLevel = "VERBOSE";
function $6813aa9d7dc8ab1a$var$Zn(n) {
    $6813aa9d7dc8ab1a$var$Ie.logLevel = n;
}
const $6813aa9d7dc8ab1a$var$S = $6813aa9d7dc8ab1a$var$Ie.bind(window, !1), $6813aa9d7dc8ab1a$var$X = $6813aa9d7dc8ab1a$var$Ie.bind(window, !0);
function $6813aa9d7dc8ab1a$var$le(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $6813aa9d7dc8ab1a$var$A(n) {
    return $6813aa9d7dc8ab1a$var$le(n) === "function" || $6813aa9d7dc8ab1a$var$le(n) === "asyncfunction";
}
function $6813aa9d7dc8ab1a$var$D(n) {
    return $6813aa9d7dc8ab1a$var$le(n) === "object";
}
function $6813aa9d7dc8ab1a$var$te(n) {
    return $6813aa9d7dc8ab1a$var$le(n) === "string";
}
function $6813aa9d7dc8ab1a$var$Gn(n) {
    return $6813aa9d7dc8ab1a$var$le(n) === "boolean";
}
function $6813aa9d7dc8ab1a$var$yo(n) {
    return $6813aa9d7dc8ab1a$var$le(n) === "number";
}
function $6813aa9d7dc8ab1a$var$wo(n) {
    return $6813aa9d7dc8ab1a$var$le(n) === "undefined";
}
function $6813aa9d7dc8ab1a$var$V(n) {
    return n ? Object.keys(n).length === 0 && n.constructor === Object : !0;
}
function $6813aa9d7dc8ab1a$var$Po(n) {
    return n > 47 && n < 58 || // number keys
    n === 32 || n === 13 || // Space bar & return key(s)
    n === 229 || // processing key input for certain languages — Chinese, Japanese, etc.
    n > 64 && n < 91 || // letter keys
    n > 95 && n < 112 || // Numpad keys
    n > 185 && n < 193 || // ;=,-./` (in order)
    n > 218 && n < 223;
}
async function $6813aa9d7dc8ab1a$var$Qn(n, e = ()=>{}, t1 = ()=>{}) {
    async function o(i, s, r) {
        try {
            await i.function(i.data), await s($6813aa9d7dc8ab1a$var$wo(i.data) ? {} : i.data);
        } catch  {
            r($6813aa9d7dc8ab1a$var$wo(i.data) ? {} : i.data);
        }
    }
    return n.reduce(async (i, s)=>(await i, o(s, e, t1)), Promise.resolve());
}
function $6813aa9d7dc8ab1a$var$No(n) {
    return Array.prototype.slice.call(n);
}
function $6813aa9d7dc8ab1a$var$Fe(n, e) {
    return function() {
        const t1 = this, o = arguments;
        window.setTimeout(()=>n.apply(t1, o), e);
    };
}
function $6813aa9d7dc8ab1a$var$Jn(n) {
    return n.name.split(".").pop();
}
function $6813aa9d7dc8ab1a$var$ei(n) {
    return /^[-\w]+\/([-+\w]+|\*)$/.test(n);
}
function $6813aa9d7dc8ab1a$var$Eo(n, e, t1) {
    let o;
    return (...i)=>{
        const s = this, r = ()=>{
            o = null, t1 || n.apply(s, i);
        }, a = t1 && !o;
        window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
    };
}
function $6813aa9d7dc8ab1a$var$dt(n, e, t1) {
    let o, i, s, r = null, a = 0;
    t1 || (t1 = {});
    const l = function() {
        a = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r || (o = i = null);
    };
    return function() {
        const c = Date.now();
        !a && t1.leading === !1 && (a = c);
        const d = e - (c - a);
        return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r || (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(l, d)), s;
    };
}
function $6813aa9d7dc8ab1a$var$ti() {
    const n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find((t1)=>window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1);
    return e && (n[e] = !0), n;
}
function $6813aa9d7dc8ab1a$var$je(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $6813aa9d7dc8ab1a$var$ut(n, ...e) {
    if (!e.length) return n;
    const t1 = e.shift();
    if ($6813aa9d7dc8ab1a$var$D(n) && $6813aa9d7dc8ab1a$var$D(t1)) for(const o in t1)$6813aa9d7dc8ab1a$var$D(t1[o]) ? (n[o] || Object.assign(n, {
        [o]: {}
    }), $6813aa9d7dc8ab1a$var$ut(n[o], t1[o])) : Object.assign(n, {
        [o]: t1[o]
    });
    return $6813aa9d7dc8ab1a$var$ut(n, ...e);
}
function $6813aa9d7dc8ab1a$var$vt(n) {
    const e = $6813aa9d7dc8ab1a$var$ti();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, " + "), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $6813aa9d7dc8ab1a$var$oi(n) {
    try {
        return new URL(n).href;
    } catch  {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $6813aa9d7dc8ab1a$var$ni() {
    return $6813aa9d7dc8ab1a$var$Vn(10);
}
function $6813aa9d7dc8ab1a$var$ii(n) {
    window.open(n, "_blank");
}
function $6813aa9d7dc8ab1a$var$si(n = "") {
    return `${n}${Math.floor(Math.random() * 1e8).toString(16)}`;
}
function $6813aa9d7dc8ab1a$var$ht(n, e, t1) {
    const o = `\xab${e}\xbb is deprecated and will be removed in the next major release. Please use the \xab${t1}\xbb instead.`;
    n && $6813aa9d7dc8ab1a$var$X(o, "warn");
}
function $6813aa9d7dc8ab1a$var$me(n, e, t1) {
    const o = t1.value ? "value" : "get", i = t1[o], s = `#${e}Cache`;
    if (t1[o] = function(...r) {
        return this[s] === void 0 && (this[s] = i.apply(this, ...r)), this[s];
    }, o === "get" && t1.set) {
        const r = t1.set;
        t1.set = function(a) {
            delete n[s], r.apply(this, a);
        };
    }
    return t1;
}
const $6813aa9d7dc8ab1a$var$Ro = 650;
function $6813aa9d7dc8ab1a$var$be() {
    return window.matchMedia(`(max-width: ${$6813aa9d7dc8ab1a$var$Ro}px)`).matches;
}
const $6813aa9d7dc8ab1a$var$pt = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $6813aa9d7dc8ab1a$var$ri(n, e) {
    const t1 = Array.isArray(n) || $6813aa9d7dc8ab1a$var$D(n), o = Array.isArray(e) || $6813aa9d7dc8ab1a$var$D(e);
    return t1 || o ? JSON.stringify(n) === JSON.stringify(e) : n === e;
}
class $6813aa9d7dc8ab1a$var$u {
    /**
   * Check if passed tag has no closed tag
   *
   * @param {HTMLElement} tag - element to check
   * @returns {boolean}
   */ static isSingleTag(e) {
        return e.tagName && [
            "AREA",
            "BASE",
            "BR",
            "COL",
            "COMMAND",
            "EMBED",
            "HR",
            "IMG",
            "INPUT",
            "KEYGEN",
            "LINK",
            "META",
            "PARAM",
            "SOURCE",
            "TRACK",
            "WBR"
        ].includes(e.tagName);
    }
    /**
   * Check if element is BR or WBR
   *
   * @param {HTMLElement} element - element to check
   * @returns {boolean}
   */ static isLineBreakTag(e) {
        return e && e.tagName && [
            "BR",
            "WBR"
        ].includes(e.tagName);
    }
    /**
   * Helper for making Elements with class name and attributes
   *
   * @param  {string} tagName - new Element tag name
   * @param  {string[]|string} [classNames] - list or name of CSS class name(s)
   * @param  {object} [attributes] - any attributes
   * @returns {HTMLElement}
   */ static make(e, t1 = null, o = {}) {
        const i = document.createElement(e);
        if (Array.isArray(t1)) {
            const s = t1.filter((r)=>r !== void 0);
            i.classList.add(...s);
        } else t1 && i.classList.add(t1);
        for(const s in o)Object.prototype.hasOwnProperty.call(o, s) && (i[s] = o[s]);
        return i;
    }
    /**
   * Creates Text Node with the passed content
   *
   * @param {string} content - text content
   * @returns {Text}
   */ static text(e) {
        return document.createTextNode(e);
    }
    /**
   * Append one or several elements to the parent
   *
   * @param  {Element|DocumentFragment} parent - where to append
   * @param  {Element|Element[]|DocumentFragment|Text|Text[]} elements - element or elements list
   */ static append(e, t1) {
        Array.isArray(t1) ? t1.forEach((o)=>e.appendChild(o)) : e.appendChild(t1);
    }
    /**
   * Append element or a couple to the beginning of the parent elements
   *
   * @param {Element} parent - where to append
   * @param {Element|Element[]} elements - element or elements list
   */ static prepend(e, t1) {
        Array.isArray(t1) ? (t1 = t1.reverse(), t1.forEach((o)=>e.prepend(o))) : e.prepend(t1);
    }
    /**
   * Swap two elements in parent
   *
   * @param {HTMLElement} el1 - from
   * @param {HTMLElement} el2 - to
   * @deprecated
   */ static swap(e, t1) {
        const o = document.createElement("div"), i = e.parentNode;
        i.insertBefore(o, e), i.insertBefore(e, t1), i.insertBefore(t1, o), i.removeChild(o);
    }
    /**
   * Selector Decorator
   *
   * Returns first match
   *
   * @param {Element} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {Element}
   */ static find(e = document, t1) {
        return e.querySelector(t1);
    }
    /**
   * Get Element by Id
   *
   * @param {string} id - id to find
   * @returns {HTMLElement | null}
   */ static get(e) {
        return document.getElementById(e);
    }
    /**
   * Selector Decorator.
   *
   * Returns all matches
   *
   * @param {Element|Document} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {NodeList}
   */ static findAll(e = document, t1) {
        return e.querySelectorAll(t1);
    }
    /**
   * Returns CSS selector for all text inputs
   */ static get allInputsSelector() {
        return "[contenteditable=true], textarea, input:not([type]), " + [
            "text",
            "password",
            "email",
            "number",
            "search",
            "tel",
            "url"
        ].map((t1)=>`input[type="${t1}"]`).join(", ");
    }
    /**
   * Find all contenteditable, textarea and editable input elements passed holder contains
   *
   * @param holder - element where to find inputs
   */ static findAllInputs(e) {
        return $6813aa9d7dc8ab1a$var$No(e.querySelectorAll($6813aa9d7dc8ab1a$var$u.allInputsSelector)).reduce((t1, o)=>$6813aa9d7dc8ab1a$var$u.isNativeInput(o) || $6813aa9d7dc8ab1a$var$u.containsOnlyInlineElements(o) ? [
                ...t1,
                o
            ] : [
                ...t1,
                ...$6813aa9d7dc8ab1a$var$u.getDeepestBlockElements(o)
            ], []);
    }
    /**
   * Search for deepest node which is Leaf.
   * Leaf is the vertex that doesn't have any child nodes
   *
   * @description Method recursively goes throw the all Node until it finds the Leaf
   * @param {Node} node - root Node. From this vertex we start Deep-first search
   *                      {@link https://en.wikipedia.org/wiki/Depth-first_search}
   * @param {boolean} [atLast] - find last text node
   * @returns - it can be text Node or Element Node, so that caret will able to work with it
   *            Can return null if node is Document or DocumentFragment, or node is not attached to the DOM
   */ static getDeepestNode(e, t1 = !1) {
        const o = t1 ? "lastChild" : "firstChild", i = t1 ? "previousSibling" : "nextSibling";
        if (e && e.nodeType === Node.ELEMENT_NODE && e[o]) {
            let s = e[o];
            if ($6813aa9d7dc8ab1a$var$u.isSingleTag(s) && !$6813aa9d7dc8ab1a$var$u.isNativeInput(s) && !$6813aa9d7dc8ab1a$var$u.isLineBreakTag(s)) {
                if (s[i]) s = s[i];
                else if (s.parentNode[i]) s = s.parentNode[i];
                else return s.parentNode;
            }
            return this.getDeepestNode(s, t1);
        }
        return e;
    }
    /**
   * Check if object is DOM node
   *
   * @param {*} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isElement(e) {
        return $6813aa9d7dc8ab1a$var$yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.ELEMENT_NODE;
    }
    /**
   * Check if object is DocumentFragment node
   *
   * @param {object} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isFragment(e) {
        return $6813aa9d7dc8ab1a$var$yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
    }
    /**
   * Check if passed element is contenteditable
   *
   * @param {HTMLElement} element - html element to check
   * @returns {boolean}
   */ static isContentEditable(e) {
        return e.contentEditable === "true";
    }
    /**
   * Checks target if it is native input
   *
   * @param {*} target - HTML element or string
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isNativeInput(e) {
        const t1 = [
            "INPUT",
            "TEXTAREA"
        ];
        return e && e.tagName ? t1.includes(e.tagName) : !1;
    }
    /**
   * Checks if we can set caret
   *
   * @param {HTMLElement} target - target to check
   * @returns {boolean}
   */ static canSetCaret(e) {
        let t1 = !0;
        if ($6813aa9d7dc8ab1a$var$u.isNativeInput(e)) switch(e.type){
            case "file":
            case "checkbox":
            case "radio":
            case "hidden":
            case "submit":
            case "button":
            case "image":
            case "reset":
                t1 = !1;
                break;
        }
        else t1 = $6813aa9d7dc8ab1a$var$u.isContentEditable(e);
        return t1;
    }
    /**
   * Checks node if it is empty
   *
   * @description Method checks simple Node without any childs for emptiness
   * If you have Node with 2 or more children id depth, you better use {@link Dom#isEmpty} method
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean} true if it is empty
   */ static isNodeEmpty(e, t1) {
        let o;
        return this.isSingleTag(e) && !this.isLineBreakTag(e) ? !1 : (this.isElement(e) && this.isNativeInput(e) ? o = e.value : o = e.textContent.replace("\u200B", ""), t1 && (o = o.replace(new RegExp(t1, "g"), "")), o.length === 0);
    }
    /**
   * checks node if it is doesn't have any child nodes
   *
   * @param {Node} node - node to check
   * @returns {boolean}
   */ static isLeaf(e) {
        return e ? e.childNodes.length === 0 : !1;
    }
    /**
   * breadth-first search (BFS)
   * {@link https://en.wikipedia.org/wiki/Breadth-first_search}
   *
   * @description Pushes to stack all DOM leafs and checks for emptiness
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean}
   */ static isEmpty(e, t1) {
        const o = [
            e
        ];
        for(; o.length > 0;)if (e = o.shift(), !!e) {
            if (this.isLeaf(e) && !this.isNodeEmpty(e, t1)) return !1;
            e.childNodes && o.push(...Array.from(e.childNodes));
        }
        return !0;
    }
    /**
   * Check if string contains html elements
   *
   * @param {string} str - string to check
   * @returns {boolean}
   */ static isHTMLString(e) {
        const t1 = $6813aa9d7dc8ab1a$var$u.make("div");
        return t1.innerHTML = e, t1.childElementCount > 0;
    }
    /**
   * Return length of node`s text content
   *
   * @param {Node} node - node with content
   * @returns {number}
   */ static getContentLength(e) {
        return $6813aa9d7dc8ab1a$var$u.isNativeInput(e) ? e.value.length : e.nodeType === Node.TEXT_NODE ? e.length : e.textContent.length;
    }
    /**
   * Return array of names of block html elements
   *
   * @returns {string[]}
   */ static get blockElements() {
        return [
            "address",
            "article",
            "aside",
            "blockquote",
            "canvas",
            "div",
            "dl",
            "dt",
            "fieldset",
            "figcaption",
            "figure",
            "footer",
            "form",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "header",
            "hgroup",
            "hr",
            "li",
            "main",
            "nav",
            "noscript",
            "ol",
            "output",
            "p",
            "pre",
            "ruby",
            "section",
            "table",
            "tbody",
            "thead",
            "tr",
            "tfoot",
            "ul",
            "video"
        ];
    }
    /**
   * Check if passed content includes only inline elements
   *
   * @param {string|HTMLElement} data - element or html string
   * @returns {boolean}
   */ static containsOnlyInlineElements(e) {
        let t1;
        $6813aa9d7dc8ab1a$var$te(e) ? (t1 = document.createElement("div"), t1.innerHTML = e) : t1 = e;
        const o = (i)=>!$6813aa9d7dc8ab1a$var$u.blockElements.includes(i.tagName.toLowerCase()) && Array.from(i.children).every(o);
        return Array.from(t1.children).every(o);
    }
    /**
   * Find and return all block elements in the passed parent (including subtree)
   *
   * @param {HTMLElement} parent - root element
   * @returns {HTMLElement[]}
   */ static getDeepestBlockElements(e) {
        return $6813aa9d7dc8ab1a$var$u.containsOnlyInlineElements(e) ? [
            e
        ] : Array.from(e.children).reduce((t1, o)=>[
                ...t1,
                ...$6813aa9d7dc8ab1a$var$u.getDeepestBlockElements(o)
            ], []);
    }
    /**
   * Helper for get holder from {string} or return HTMLElement
   *
   * @param {string | HTMLElement} element - holder's id or holder's HTML Element
   * @returns {HTMLElement}
   */ static getHolder(e) {
        return $6813aa9d7dc8ab1a$var$te(e) ? document.getElementById(e) : e;
    }
    /**
   * Returns true if element is anchor (is A tag)
   *
   * @param {Element} element - element to check
   * @returns {boolean}
   */ static isAnchor(e) {
        return e.tagName.toLowerCase() === "a";
    }
    /**
   * Returns the closest ancestor anchor (A tag) of the given element (including itself)
   * 
   * @param element - element to check
   * @returns {HTMLAnchorElement | null}
   */ static getClosestAnchor(e) {
        return e.closest("a");
    }
    /**
   * Return element's offset related to the document
   *
   * @todo handle case when editor initialized in scrollable popup
   * @param el - element to compute offset
   */ static offset(e) {
        const t1 = e.getBoundingClientRect(), o = window.pageXOffset || document.documentElement.scrollLeft, i = window.pageYOffset || document.documentElement.scrollTop, s = t1.top + i, r = t1.left + o;
        return {
            top: s,
            left: r,
            bottom: s + t1.height,
            right: r + t1.width
        };
    }
    /**
   * Find text node and offset by total content offset
   *
   * @param {Node} root - root node to start search from
   * @param {number} totalOffset - offset relative to the root node content
   * @returns {{node: Node | null, offset: number}} - node and offset inside node
   */ static getNodeByOffset(e, t1) {
        let o = 0, i = null;
        const s = document.createTreeWalker(e, NodeFilter.SHOW_TEXT, null);
        let r = s.nextNode();
        for(; r;){
            const c = r.textContent, d = c === null ? 0 : c.length;
            if (i = r, o + d >= t1) break;
            o += d, r = s.nextNode();
        }
        if (!i) return {
            node: null,
            offset: 0
        };
        const a = i.textContent;
        if (a === null || a.length === 0) return {
            node: null,
            offset: 0
        };
        const l = Math.min(t1 - o, a.length);
        return {
            node: i,
            offset: l
        };
    }
}
function $6813aa9d7dc8ab1a$var$ai(n) {
    return !/[^\t\n\r ]/.test(n);
}
function $6813aa9d7dc8ab1a$var$li(n) {
    const e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), a = t1 * 0.8, l = (o - t1) / 2;
    return r + s + i + l + a;
}
function $6813aa9d7dc8ab1a$var$Do(n) {
    n.dataset.empty = $6813aa9d7dc8ab1a$var$u.isEmpty(n) ? "true" : "false";
}
const $6813aa9d7dc8ab1a$var$ci = {
    blockTunes: {
        toggler: {
            "Click to tune": "",
            "or drag to move": ""
        }
    },
    inlineToolbar: {
        converter: {
            "Convert to": ""
        }
    },
    toolbar: {
        toolbox: {
            Add: ""
        }
    },
    popover: {
        Filter: "",
        "Nothing found": "",
        "Convert to": ""
    }
}, $6813aa9d7dc8ab1a$var$di = {
    Text: "",
    Link: "",
    Bold: "",
    Italic: ""
}, $6813aa9d7dc8ab1a$var$ui = {
    link: {
        "Add a link": ""
    },
    stub: {
        "The block can not be displayed correctly.": ""
    }
}, $6813aa9d7dc8ab1a$var$hi = {
    delete: {
        Delete: "",
        "Click to delete": ""
    },
    moveUp: {
        "Move up": ""
    },
    moveDown: {
        "Move down": ""
    }
}, $6813aa9d7dc8ab1a$var$Fo = {
    ui: $6813aa9d7dc8ab1a$var$ci,
    toolNames: $6813aa9d7dc8ab1a$var$di,
    tools: $6813aa9d7dc8ab1a$var$ui,
    blockTunes: $6813aa9d7dc8ab1a$var$hi
}, $6813aa9d7dc8ab1a$var$jo = class he {
    /**
   * Type-safe translation for internal UI texts:
   * Perform translation of the string by namespace and a key
   *
   * @example I18n.ui(I18nInternalNS.ui.blockTunes.toggler, 'Click to tune')
   * @param internalNamespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static ui(e, t1) {
        return he._t(e, t1);
    }
    /**
   * Translate for external strings that is not presented in default dictionary.
   * For example, for user-specified tool names
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static t(e, t1) {
        return he._t(e, t1);
    }
    /**
   * Adjust module for using external dictionary
   *
   * @param dictionary - new messages list to override default
   */ static setDictionary(e) {
        he.currentDictionary = e;
    }
    /**
   * Perform translation both for internal and external namespaces
   * If there is no translation found, returns passed key as a translated message
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static _t(e, t1) {
        const o = he.getNamespace(e);
        return !o || !o[t1] ? t1 : o[t1];
    }
    /**
   * Find messages section by namespace path
   *
   * @param namespace - path to section
   */ static getNamespace(e) {
        return e.split(".").reduce((o, i)=>!o || !Object.keys(o).length ? {} : o[i], he.currentDictionary);
    }
};
$6813aa9d7dc8ab1a$var$jo.currentDictionary = $6813aa9d7dc8ab1a$var$Fo;
let $6813aa9d7dc8ab1a$var$z = $6813aa9d7dc8ab1a$var$jo;
class $6813aa9d7dc8ab1a$var$Ho extends Error {
}
class $6813aa9d7dc8ab1a$var$Oe {
    constructor(){
        this.subscribers = {};
    }
    /**
   * Subscribe any event on callback
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ on(e, t1) {
        e in this.subscribers || (this.subscribers[e] = []), this.subscribers[e].push(t1);
    }
    /**
   * Subscribe any event on callback. Callback will be called once and be removed from subscribers array after call.
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ once(e, t1) {
        e in this.subscribers || (this.subscribers[e] = []);
        const o = (i)=>{
            const s = t1(i), r = this.subscribers[e].indexOf(o);
            return r !== -1 && this.subscribers[e].splice(r, 1), s;
        };
        this.subscribers[e].push(o);
    }
    /**
   * Emit callbacks with passed data
   *
   * @param eventName - event name
   * @param data - subscribers get this data when they were fired
   */ emit(e, t1) {
        $6813aa9d7dc8ab1a$var$V(this.subscribers) || !this.subscribers[e] || this.subscribers[e].reduce((o, i)=>{
            const s = i(o);
            return s !== void 0 ? s : o;
        }, t1);
    }
    /**
   * Unsubscribe callback from event
   *
   * @param eventName - event name
   * @param callback - event handler
   */ off(e, t1) {
        if (this.subscribers[e] === void 0) {
            console.warn(`EventDispatcher .off(): there is no subscribers for event "${e.toString()}". Probably, .off() called before .on()`);
            return;
        }
        for(let o = 0; o < this.subscribers[e].length; o++)if (this.subscribers[e][o] === t1) {
            delete this.subscribers[e][o];
            break;
        }
    }
    /**
   * Destroyer
   * clears subscribers list
   */ destroy() {
        this.subscribers = {};
    }
}
function $6813aa9d7dc8ab1a$var$J(n) {
    Object.setPrototypeOf(this, {
        /**
     * Block id
     *
     * @returns {string}
     */ get id () {
            return n.id;
        },
        /**
     * Tool name
     *
     * @returns {string}
     */ get name () {
            return n.name;
        },
        /**
     * Tool config passed on Editor's initialization
     *
     * @returns {ToolConfig}
     */ get config () {
            return n.config;
        },
        /**
     * .ce-block element, that wraps plugin contents
     *
     * @returns {HTMLElement}
     */ get holder () {
            return n.holder;
        },
        /**
     * True if Block content is empty
     *
     * @returns {boolean}
     */ get isEmpty () {
            return n.isEmpty;
        },
        /**
     * True if Block is selected with Cross-Block selection
     *
     * @returns {boolean}
     */ get selected () {
            return n.selected;
        },
        /**
     * Set Block's stretch state
     *
     * @param {boolean} state — state to set
     */ set stretched (t){
            n.stretched = t;
        },
        /**
     * True if Block is stretched
     *
     * @returns {boolean}
     */ get stretched () {
            return n.stretched;
        },
        /**
     * True if Block has inputs to be focused
     */ get focusable () {
            return n.focusable;
        },
        /**
     * Call Tool method with errors handler under-the-hood
     *
     * @param {string} methodName - method to call
     * @param {object} param - object with parameters
     * @returns {unknown}
     */ call (t1, o) {
            return n.call(t1, o);
        },
        /**
     * Save Block content
     *
     * @returns {Promise<void|SavedData>}
     */ save () {
            return n.save();
        },
        /**
     * Validate Block data
     *
     * @param {BlockToolData} data - data to validate
     * @returns {Promise<boolean>}
     */ validate (t1) {
            return n.validate(t1);
        },
        /**
     * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
     * Can be useful for block changes invisible for editor core.
     */ dispatchChange () {
            n.dispatchChange();
        },
        /**
     * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
     * This method returns the entry that is related to the Block (depended on the Block data)
     */ getActiveToolboxEntry () {
            return n.getActiveToolboxEntry();
        }
    });
}
class $6813aa9d7dc8ab1a$var$_e {
    constructor(){
        this.allListeners = [];
    }
    /**
   * Assigns event listener on element and returns unique identifier
   *
   * @param {EventTarget} element - DOM element that needs to be listened
   * @param {string} eventType - event type
   * @param {Function} handler - method that will be fired on event
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ on(e, t1, o, i = !1) {
        const s = $6813aa9d7dc8ab1a$var$si("l"), r = {
            id: s,
            element: e,
            eventType: t1,
            handler: o,
            options: i
        };
        if (!this.findOne(e, t1, o)) return this.allListeners.push(r), e.addEventListener(t1, o, i), s;
    }
    /**
   * Removes event listener from element
   *
   * @param {EventTarget} element - DOM element that we removing listener
   * @param {string} eventType - event type
   * @param {Function} handler - remove handler, if element listens several handlers on the same event type
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ off(e, t1, o, i) {
        const s = this.findAll(e, t1, o);
        s.forEach((r, a)=>{
            const l = this.allListeners.indexOf(s[a]);
            l > -1 && (this.allListeners.splice(l, 1), r.element.removeEventListener(r.eventType, r.handler, r.options));
        });
    }
    /**
   * Removes listener by id
   *
   * @param {string} id - listener identifier
   */ offById(e) {
        const t1 = this.findById(e);
        t1 && t1.element.removeEventListener(t1.eventType, t1.handler, t1.options);
    }
    /**
   * Finds and returns first listener by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} [eventType] - event type
   * @param {Function} [handler] - event handler
   * @returns {ListenerData|null}
   */ findOne(e, t1, o) {
        const i = this.findAll(e, t1, o);
        return i.length > 0 ? i[0] : null;
    }
    /**
   * Return all stored listeners by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} eventType - event type
   * @param {Function} handler - event handler
   * @returns {ListenerData[]}
   */ findAll(e, t1, o) {
        let i;
        const s = e ? this.findByEventTarget(e) : [];
        return e && t1 && o ? i = s.filter((r)=>r.eventType === t1 && r.handler === o) : e && t1 ? i = s.filter((r)=>r.eventType === t1) : i = s, i;
    }
    /**
   * Removes all listeners
   */ removeAll() {
        this.allListeners.map((e)=>{
            e.element.removeEventListener(e.eventType, e.handler, e.options);
        }), this.allListeners = [];
    }
    /**
   * Module cleanup on destruction
   */ destroy() {
        this.removeAll();
    }
    /**
   * Search method: looks for listener by passed element
   *
   * @param {EventTarget} element - searching element
   * @returns {Array} listeners that found on element
   */ findByEventTarget(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.element === e) return t1;
        });
    }
    /**
   * Search method: looks for listener by passed event type
   *
   * @param {string} eventType - event type
   * @returns {ListenerData[]} listeners that found on element
   */ findByType(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.eventType === e) return t1;
        });
    }
    /**
   * Search method: looks for listener by passed handler
   *
   * @param {Function} handler - event handler
   * @returns {ListenerData[]} listeners that found on element
   */ findByHandler(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.handler === e) return t1;
        });
    }
    /**
   * Returns listener data found by id
   *
   * @param {string} id - listener identifier
   * @returns {ListenerData}
   */ findById(e) {
        return this.allListeners.find((t1)=>t1.id === e);
    }
}
class $6813aa9d7dc8ab1a$var$E {
    /**
   * @class
   * @param options - Module options
   * @param options.config - Module config
   * @param options.eventsDispatcher - Common event bus
   */ constructor({ config: e, eventsDispatcher: t1 }){
        if (this.nodes = {}, this.listeners = new $6813aa9d7dc8ab1a$var$_e(), this.readOnlyMutableListeners = {
            /**
       * Assigns event listener on DOM element and pushes into special array that might be removed
       *
       * @param {EventTarget} element - DOM Element
       * @param {string} eventType - Event name
       * @param {Function} handler - Event handler
       * @param {boolean|AddEventListenerOptions} options - Listening options
       */ on: (o, i, s, r = !1)=>{
                this.mutableListenerIds.push(this.listeners.on(o, i, s, r));
            },
            /**
       * Clears all mutable listeners
       */ clearAll: ()=>{
                for (const o of this.mutableListenerIds)this.listeners.offById(o);
                this.mutableListenerIds = [];
            }
        }, this.mutableListenerIds = [], new.target === $6813aa9d7dc8ab1a$var$E) throw new TypeError("Constructors for abstract class Module are not allowed.");
        this.config = e, this.eventsDispatcher = t1;
    }
    /**
   * Editor modules setter
   *
   * @param {EditorModules} Editor - Editor's Modules
   */ set state(e) {
        this.Editor = e;
    }
    /**
   * Remove memorized nodes
   */ removeAllNodes() {
        for(const e in this.nodes){
            const t1 = this.nodes[e];
            t1 instanceof HTMLElement && t1.remove();
        }
    }
    /**
   * Returns true if current direction is RTL (Right-To-Left)
   */ get isRtl() {
        return this.config.i18n.direction === "rtl";
    }
}
class $6813aa9d7dc8ab1a$var$b {
    constructor(){
        this.instance = null, this.selection = null, this.savedSelectionRange = null, this.isFakeBackgroundEnabled = !1, this.commandBackground = "backColor";
    }
    /**
   * Editor styles
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ static get CSS() {
        return {
            editorWrapper: "codex-editor",
            editorZone: "codex-editor__redactor"
        };
    }
    /**
   * Returns selected anchor
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorNode}
   *
   * @returns {Node|null}
   */ static get anchorNode() {
        const e = window.getSelection();
        return e ? e.anchorNode : null;
    }
    /**
   * Returns selected anchor element
   *
   * @returns {Element|null}
   */ static get anchorElement() {
        const e = window.getSelection();
        if (!e) return null;
        const t1 = e.anchorNode;
        return t1 ? $6813aa9d7dc8ab1a$var$u.isElement(t1) ? t1 : t1.parentElement : null;
    }
    /**
   * Returns selection offset according to the anchor node
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorOffset}
   *
   * @returns {number|null}
   */ static get anchorOffset() {
        const e = window.getSelection();
        return e ? e.anchorOffset : null;
    }
    /**
   * Is current selection range collapsed
   *
   * @returns {boolean|null}
   */ static get isCollapsed() {
        const e = window.getSelection();
        return e ? e.isCollapsed : null;
    }
    /**
   * Check current selection if it is at Editor's zone
   *
   * @returns {boolean}
   */ static get isAtEditor() {
        return this.isSelectionAtEditor($6813aa9d7dc8ab1a$var$b.get());
    }
    /**
   * Check if passed selection is at Editor's zone
   *
   * @param selection - Selection object to check
   */ static isSelectionAtEditor(e) {
        if (!e) return !1;
        let t1 = e.anchorNode || e.focusNode;
        t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
        let o = null;
        return t1 && t1 instanceof Element && (o = t1.closest(`.${$6813aa9d7dc8ab1a$var$b.CSS.editorZone}`)), o ? o.nodeType === Node.ELEMENT_NODE : !1;
    }
    /**
   * Check if passed range at Editor zone
   *
   * @param range - range to check
   */ static isRangeAtEditor(e) {
        if (!e) return;
        let t1 = e.startContainer;
        t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
        let o = null;
        return t1 && t1 instanceof Element && (o = t1.closest(`.${$6813aa9d7dc8ab1a$var$b.CSS.editorZone}`)), o ? o.nodeType === Node.ELEMENT_NODE : !1;
    }
    /**
   * Methods return boolean that true if selection exists on the page
   */ static get isSelectionExists() {
        return !!$6813aa9d7dc8ab1a$var$b.get().anchorNode;
    }
    /**
   * Return first range
   *
   * @returns {Range|null}
   */ static get range() {
        return this.getRangeFromSelection(this.get());
    }
    /**
   * Returns range from passed Selection object
   *
   * @param selection - Selection object to get Range from
   */ static getRangeFromSelection(e) {
        return e && e.rangeCount ? e.getRangeAt(0) : null;
    }
    /**
   * Calculates position and size of selected text
   *
   * @returns {DOMRect | ClientRect}
   */ static get rect() {
        let e = document.selection, t1, o = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (e && e.type !== "Control") return e, t1 = e.createRange(), o.x = t1.boundingLeft, o.y = t1.boundingTop, o.width = t1.boundingWidth, o.height = t1.boundingHeight, o;
        if (!window.getSelection) return $6813aa9d7dc8ab1a$var$S("Method window.getSelection is not supported", "warn"), o;
        if (e = window.getSelection(), e.rangeCount === null || isNaN(e.rangeCount)) return $6813aa9d7dc8ab1a$var$S("Method SelectionUtils.rangeCount is not supported", "warn"), o;
        if (e.rangeCount === 0) return o;
        if (t1 = e.getRangeAt(0).cloneRange(), t1.getBoundingClientRect && (o = t1.getBoundingClientRect()), o.x === 0 && o.y === 0) {
            const i = document.createElement("span");
            if (i.getBoundingClientRect) {
                i.appendChild(document.createTextNode("\u200B")), t1.insertNode(i), o = i.getBoundingClientRect();
                const s = i.parentNode;
                s.removeChild(i), s.normalize();
            }
        }
        return o;
    }
    /**
   * Returns selected text as String
   *
   * @returns {string}
   */ static get text() {
        return window.getSelection ? window.getSelection().toString() : "";
    }
    /**
   * Returns window SelectionUtils
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Window/getSelection}
   *
   * @returns {Selection}
   */ static get() {
        return window.getSelection();
    }
    /**
   * Set focus to contenteditable or native input element
   *
   * @param element - element where to set focus
   * @param offset - offset of cursor
   */ static setCursor(e, t1 = 0) {
        const o = document.createRange(), i = window.getSelection();
        return $6813aa9d7dc8ab1a$var$u.isNativeInput(e) ? $6813aa9d7dc8ab1a$var$u.canSetCaret(e) ? (e.focus(), e.selectionStart = e.selectionEnd = t1, e.getBoundingClientRect()) : void 0 : (o.setStart(e, t1), o.setEnd(e, t1), i.removeAllRanges(), i.addRange(o), o.getBoundingClientRect());
    }
    /**
   * Check if current range exists and belongs to container
   *
   * @param container - where range should be
   */ static isRangeInsideContainer(e) {
        const t1 = $6813aa9d7dc8ab1a$var$b.range;
        return t1 === null ? !1 : e.contains(t1.startContainer);
    }
    /**
   * Adds fake cursor to the current range
   */ static addFakeCursor() {
        const e = $6813aa9d7dc8ab1a$var$b.range;
        if (e === null) return;
        const t1 = $6813aa9d7dc8ab1a$var$u.make("span", "codex-editor__fake-cursor");
        t1.dataset.mutationFree = "true", e.collapse(), e.insertNode(t1);
    }
    /**
   * Check if passed element contains a fake cursor
   *
   * @param el - where to check
   */ static isFakeCursorInsideContainer(e) {
        return $6813aa9d7dc8ab1a$var$u.find(e, ".codex-editor__fake-cursor") !== null;
    }
    /**
   * Removes fake cursor from a container
   *
   * @param container - container to look for
   */ static removeFakeCursor(e = document.body) {
        const t1 = $6813aa9d7dc8ab1a$var$u.find(e, ".codex-editor__fake-cursor");
        t1 && t1.remove();
    }
    /**
   * Removes fake background
   */ removeFakeBackground() {
        this.isFakeBackgroundEnabled && (document.execCommand(this.commandBackground, !1, "transparent"), this.isFakeBackgroundEnabled = !1);
    }
    /**
   * Sets fake background
   */ setFakeBackground() {
        document.execCommand(this.commandBackground, !1, "#a8d6ff"), this.isFakeBackgroundEnabled = !0;
    }
    /**
   * Save SelectionUtils's range
   */ save() {
        this.savedSelectionRange = $6813aa9d7dc8ab1a$var$b.range;
    }
    /**
   * Restore saved SelectionUtils's range
   */ restore() {
        if (!this.savedSelectionRange) return;
        const e = window.getSelection();
        e.removeAllRanges(), e.addRange(this.savedSelectionRange);
    }
    /**
   * Clears saved selection
   */ clearSaved() {
        this.savedSelectionRange = null;
    }
    /**
   * Collapse current selection
   */ collapseToEnd() {
        const e = window.getSelection(), t1 = document.createRange();
        t1.selectNodeContents(e.focusNode), t1.collapse(!1), e.removeAllRanges(), e.addRange(t1);
    }
    /**
   * Looks ahead to find passed tag from current selection
   *
   * @param  {string} tagName       - tag to found
   * @param  {string} [className]   - tag's class name
   * @param  {number} [searchDepth] - count of tags that can be included. For better performance.
   * @returns {HTMLElement|null}
   */ findParentTag(e, t1, o = 10) {
        const i = window.getSelection();
        let s = null;
        return !i || !i.anchorNode || !i.focusNode ? null : ([
            /** the Node in which the selection begins */ i.anchorNode,
            /** the Node in which the selection ends */ i.focusNode
        ].forEach((a)=>{
            let l = o;
            for(; l > 0 && a.parentNode && !(a.tagName === e && (s = a, t1 && a.classList && !a.classList.contains(t1) && (s = null), s));)a = a.parentNode, l--;
        }), s);
    }
    /**
   * Expands selection range to the passed parent node
   *
   * @param {HTMLElement} element - element which contents should be selected
   */ expandToTag(e) {
        const t1 = window.getSelection();
        t1.removeAllRanges();
        const o = document.createRange();
        o.selectNodeContents(e), t1.addRange(o);
    }
}
function $6813aa9d7dc8ab1a$var$pi(n, e) {
    const { type: t1, target: o, addedNodes: i, removedNodes: s } = n;
    return n.type === "attributes" && n.attributeName === "data-empty" ? !1 : !!(e.contains(o) || t1 === "childList" && (Array.from(i).some((l)=>l === e) || Array.from(s).some((l)=>l === e)));
}
const $6813aa9d7dc8ab1a$var$ft = "redactor dom changed", $6813aa9d7dc8ab1a$var$$o = "block changed", $6813aa9d7dc8ab1a$var$zo = "fake cursor is about to be toggled", $6813aa9d7dc8ab1a$var$Uo = "fake cursor have been set", $6813aa9d7dc8ab1a$var$Te = "editor mobile layout toggled";
function $6813aa9d7dc8ab1a$var$gt(n, e) {
    if (!n.conversionConfig) return !1;
    const t1 = n.conversionConfig[e];
    return $6813aa9d7dc8ab1a$var$A(t1) || $6813aa9d7dc8ab1a$var$te(t1);
}
function $6813aa9d7dc8ab1a$var$He(n, e) {
    return $6813aa9d7dc8ab1a$var$gt(n.tool, e);
}
function $6813aa9d7dc8ab1a$var$Wo(n, e) {
    return Object.entries(n).some(([t1, o])=>e[t1] && $6813aa9d7dc8ab1a$var$ri(e[t1], o));
}
async function $6813aa9d7dc8ab1a$var$Yo(n, e) {
    const o = (await n.save()).data, i = e.find((s)=>s.name === n.name);
    return i !== void 0 && !$6813aa9d7dc8ab1a$var$gt(i, "export") ? [] : e.reduce((s, r)=>{
        if (!$6813aa9d7dc8ab1a$var$gt(r, "import") || r.toolbox === void 0) return s;
        const a = r.toolbox.filter((l)=>{
            if ($6813aa9d7dc8ab1a$var$V(l) || l.icon === void 0) return !1;
            if (l.data !== void 0) {
                if ($6813aa9d7dc8ab1a$var$Wo(l.data, o)) return !1;
            } else if (r.name === n.name) return !1;
            return !0;
        });
        return s.push({
            ...r,
            toolbox: a
        }), s;
    }, []);
}
function $6813aa9d7dc8ab1a$var$xo(n, e) {
    return n.mergeable ? n.name === e.name ? !0 : $6813aa9d7dc8ab1a$var$He(e, "export") && $6813aa9d7dc8ab1a$var$He(n, "import") : !1;
}
function $6813aa9d7dc8ab1a$var$fi(n, e) {
    const t1 = e == null ? void 0 : e.export;
    return $6813aa9d7dc8ab1a$var$A(t1) ? t1(n) : $6813aa9d7dc8ab1a$var$te(t1) ? n[t1] : (t1 !== void 0 && $6813aa9d7dc8ab1a$var$S("Conversion \xabexport\xbb property must be a string or function. String means key of saved data object to export. Function should export processed string to export."), "");
}
function $6813aa9d7dc8ab1a$var$Bo(n, e, t1) {
    const o = e == null ? void 0 : e.import;
    return $6813aa9d7dc8ab1a$var$A(o) ? o(n, t1) : $6813aa9d7dc8ab1a$var$te(o) ? {
        [o]: n
    } : (o !== void 0 && $6813aa9d7dc8ab1a$var$S("Conversion \xabimport\xbb property must be a string or function. String means key of tool data to import. Function accepts a imported string and return composed tool data."), {});
}
var $6813aa9d7dc8ab1a$var$_ = /* @__PURE__ */ ((n)=>(n.Default = "default", n.Separator = "separator", n.Html = "html", n))($6813aa9d7dc8ab1a$var$_ || {}), $6813aa9d7dc8ab1a$var$ee = /* @__PURE__ */ ((n)=>(n.APPEND_CALLBACK = "appendCallback", n.RENDERED = "rendered", n.MOVED = "moved", n.UPDATED = "updated", n.REMOVED = "removed", n.ON_PASTE = "onPaste", n))($6813aa9d7dc8ab1a$var$ee || {});
class $6813aa9d7dc8ab1a$var$R extends $6813aa9d7dc8ab1a$var$Oe {
    /**
   * @param options - block constructor options
   * @param [options.id] - block's id. Will be generated if omitted.
   * @param options.data - Tool's initial data
   * @param options.tool — block's tool
   * @param options.api - Editor API module for pass it to the Block Tunes
   * @param options.readOnly - Read-Only flag
   * @param [eventBus] - Editor common event bus. Allows to subscribe on some Editor events. Could be omitted when "virtual" Block is created. See BlocksAPI@composeBlockData.
   */ constructor({ id: e = $6813aa9d7dc8ab1a$var$ni(), data: t1, tool: o, readOnly: i, tunesData: s }, r){
        super(), this.cachedInputs = [], this.toolRenderedElement = null, this.tunesInstances = /* @__PURE__ */ new Map(), this.defaultTunesInstances = /* @__PURE__ */ new Map(), this.unavailableTunesData = {}, this.inputIndex = 0, this.editorEventBus = null, this.handleFocus = ()=>{
            this.dropInputsCache(), this.updateCurrentInput();
        }, this.didMutated = (a)=>{
            const l = a === void 0, c = a instanceof InputEvent;
            !l && !c && this.detectToolRootChange(a);
            let d;
            l || c ? d = !0 : d = !(a.length > 0 && a.every((p)=>{
                const { addedNodes: g, removedNodes: f, target: v } = p;
                return [
                    ...Array.from(g),
                    ...Array.from(f),
                    v
                ].some((T)=>($6813aa9d7dc8ab1a$var$u.isElement(T) || (T = T.parentElement), T && T.closest('[data-mutation-free="true"]') !== null));
            })), d && (this.dropInputsCache(), this.updateCurrentInput(), this.toggleInputsEmptyMark(), this.call("updated"), this.emit("didMutated", this));
        }, this.name = o.name, this.id = e, this.settings = o.settings, this.config = o.settings.config || {}, this.editorEventBus = r || null, this.blockAPI = new $6813aa9d7dc8ab1a$var$J(this), this.tool = o, this.toolInstance = o.create(t1, this.blockAPI, i), this.tunes = o.tunes, this.composeTunes(s), this.holder = this.compose(), window.requestIdleCallback(()=>{
            this.watchBlockMutations(), this.addInputEvents(), this.toggleInputsEmptyMark();
        });
    }
    /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ static get CSS() {
        return {
            wrapper: "ce-block",
            wrapperStretched: "ce-block--stretched",
            content: "ce-block__content",
            selected: "ce-block--selected",
            dropTarget: "ce-block--drop-target"
        };
    }
    /**
   * Find and return all editable elements (contenteditable and native inputs) in the Tool HTML
   */ get inputs() {
        if (this.cachedInputs.length !== 0) return this.cachedInputs;
        const e = $6813aa9d7dc8ab1a$var$u.findAllInputs(this.holder);
        return this.inputIndex > e.length - 1 && (this.inputIndex = e.length - 1), this.cachedInputs = e, e;
    }
    /**
   * Return current Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get currentInput() {
        return this.inputs[this.inputIndex];
    }
    /**
   * Set input index to the passed element
   *
   * @param element - HTML Element to set as current input
   */ set currentInput(e) {
        const t1 = this.inputs.findIndex((o)=>o === e || o.contains(e));
        t1 !== -1 && (this.inputIndex = t1);
    }
    /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get firstInput() {
        return this.inputs[0];
    }
    /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get lastInput() {
        const e = this.inputs;
        return e[e.length - 1];
    }
    /**
   * Return next Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ get nextInput() {
        return this.inputs[this.inputIndex + 1];
    }
    /**
   * Return previous Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ get previousInput() {
        return this.inputs[this.inputIndex - 1];
    }
    /**
   * Get Block's JSON data
   *
   * @returns {object}
   */ get data() {
        return this.save().then((e)=>e && !$6813aa9d7dc8ab1a$var$V(e.data) ? e.data : {});
    }
    /**
   * Returns tool's sanitizer config
   *
   * @returns {object}
   */ get sanitize() {
        return this.tool.sanitizeConfig;
    }
    /**
   * is block mergeable
   * We plugin have merge function then we call it mergeable
   *
   * @returns {boolean}
   */ get mergeable() {
        return $6813aa9d7dc8ab1a$var$A(this.toolInstance.merge);
    }
    /**
   * If Block contains inputs, it is focusable
   */ get focusable() {
        return this.inputs.length !== 0;
    }
    /**
   * Check block for emptiness
   *
   * @returns {boolean}
   */ get isEmpty() {
        const e = $6813aa9d7dc8ab1a$var$u.isEmpty(this.pluginsContent, "/"), t1 = !this.hasMedia;
        return e && t1;
    }
    /**
   * Check if block has a media content such as images, iframe and other
   *
   * @returns {boolean}
   */ get hasMedia() {
        const e = [
            "img",
            "iframe",
            "video",
            "audio",
            "source",
            "input",
            "textarea",
            "twitterwidget"
        ];
        return !!this.holder.querySelector(e.join(","));
    }
    /**
   * Set selected state
   * We don't need to mark Block as Selected when it is empty
   *
   * @param {boolean} state - 'true' to select, 'false' to remove selection
   */ set selected(e) {
        var i, s;
        this.holder.classList.toggle($6813aa9d7dc8ab1a$var$R.CSS.selected, e);
        const t1 = e === !0 && $6813aa9d7dc8ab1a$var$b.isRangeInsideContainer(this.holder), o = e === !1 && $6813aa9d7dc8ab1a$var$b.isFakeCursorInsideContainer(this.holder);
        (t1 || o) && ((i = this.editorEventBus) == null || i.emit($6813aa9d7dc8ab1a$var$zo, {
            state: e
        }), t1 ? $6813aa9d7dc8ab1a$var$b.addFakeCursor() : $6813aa9d7dc8ab1a$var$b.removeFakeCursor(this.holder), (s = this.editorEventBus) == null || s.emit($6813aa9d7dc8ab1a$var$Uo, {
            state: e
        }));
    }
    /**
   * Returns True if it is Selected
   *
   * @returns {boolean}
   */ get selected() {
        return this.holder.classList.contains($6813aa9d7dc8ab1a$var$R.CSS.selected);
    }
    /**
   * Set stretched state
   *
   * @param {boolean} state - 'true' to enable, 'false' to disable stretched state
   */ set stretched(e) {
        this.holder.classList.toggle($6813aa9d7dc8ab1a$var$R.CSS.wrapperStretched, e);
    }
    /**
   * Return Block's stretched state
   *
   * @returns {boolean}
   */ get stretched() {
        return this.holder.classList.contains($6813aa9d7dc8ab1a$var$R.CSS.wrapperStretched);
    }
    /**
   * Toggle drop target state
   *
   * @param {boolean} state - 'true' if block is drop target, false otherwise
   */ set dropTarget(e) {
        this.holder.classList.toggle($6813aa9d7dc8ab1a$var$R.CSS.dropTarget, e);
    }
    /**
   * Returns Plugins content
   *
   * @returns {HTMLElement}
   */ get pluginsContent() {
        return this.toolRenderedElement;
    }
    /**
   * Calls Tool's method
   *
   * Method checks tool property {MethodName}. Fires method with passes params If it is instance of Function
   *
   * @param {string} methodName - method to call
   * @param {object} params - method argument
   */ call(e, t1) {
        if ($6813aa9d7dc8ab1a$var$A(this.toolInstance[e])) {
            e === "appendCallback" && $6813aa9d7dc8ab1a$var$S("`appendCallback` hook is deprecated and will be removed in the next major release. Use `rendered` hook instead", "warn");
            try {
                this.toolInstance[e].call(this.toolInstance, t1);
            } catch (o) {
                $6813aa9d7dc8ab1a$var$S(`Error during '${e}' call: ${o.message}`, "error");
            }
        }
    }
    /**
   * Call plugins merge method
   *
   * @param {BlockToolData} data - data to merge
   */ async mergeWith(e) {
        await this.toolInstance.merge(e);
    }
    /**
   * Extracts data from Block
   * Groups Tool's save processing time
   *
   * @returns {object}
   */ async save() {
        const e = await this.toolInstance.save(this.pluginsContent), t1 = this.unavailableTunesData;
        [
            ...this.tunesInstances.entries(),
            ...this.defaultTunesInstances.entries()
        ].forEach(([s, r])=>{
            if ($6813aa9d7dc8ab1a$var$A(r.save)) try {
                t1[s] = r.save();
            } catch (a) {
                $6813aa9d7dc8ab1a$var$S(`Tune ${r.constructor.name} save method throws an Error %o`, "warn", a);
            }
        });
        const o = window.performance.now();
        let i;
        return Promise.resolve(e).then((s)=>(i = window.performance.now(), {
                id: this.id,
                tool: this.name,
                data: s,
                tunes: t1,
                time: i - o
            })).catch((s)=>{
            $6813aa9d7dc8ab1a$var$S(`Saving process for ${this.name} tool failed due to the ${s}`, "log", "red");
        });
    }
    /**
   * Uses Tool's validation method to check the correctness of output data
   * Tool's validation method is optional
   *
   * @description Method returns true|false whether data passed the validation or not
   * @param {BlockToolData} data - data to validate
   * @returns {Promise<boolean>} valid
   */ async validate(e) {
        let t1 = !0;
        return this.toolInstance.validate instanceof Function && (t1 = await this.toolInstance.validate(e)), t1;
    }
    /**
   * Returns data to render in Block Tunes menu.
   * Splits block tunes into 2 groups: block specific tunes and common tunes
   */ getTunes() {
        const e = [], t1 = [], o = typeof this.toolInstance.renderSettings == "function" ? this.toolInstance.renderSettings() : [];
        return $6813aa9d7dc8ab1a$var$u.isElement(o) ? e.push({
            type: $6813aa9d7dc8ab1a$var$_.Html,
            element: o
        }) : Array.isArray(o) ? e.push(...o) : e.push(o), [
            ...this.tunesInstances.values(),
            ...this.defaultTunesInstances.values()
        ].map((s)=>s.render()).forEach((s)=>{
            $6813aa9d7dc8ab1a$var$u.isElement(s) ? t1.push({
                type: $6813aa9d7dc8ab1a$var$_.Html,
                element: s
            }) : Array.isArray(s) ? t1.push(...s) : t1.push(s);
        }), {
            toolTunes: e,
            commonTunes: t1
        };
    }
    /**
   * Update current input index with selection anchor node
   */ updateCurrentInput() {
        this.currentInput = $6813aa9d7dc8ab1a$var$u.isNativeInput(document.activeElement) || !$6813aa9d7dc8ab1a$var$b.anchorNode ? document.activeElement : $6813aa9d7dc8ab1a$var$b.anchorNode;
    }
    /**
   * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
   * Can be useful for block changes invisible for editor core.
   */ dispatchChange() {
        this.didMutated();
    }
    /**
   * Call Tool instance destroy method
   */ destroy() {
        this.unwatchBlockMutations(), this.removeInputEvents(), super.destroy(), $6813aa9d7dc8ab1a$var$A(this.toolInstance.destroy) && this.toolInstance.destroy();
    }
    /**
   * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
   * This method returns the entry that is related to the Block (depended on the Block data)
   */ async getActiveToolboxEntry() {
        const e = this.tool.toolbox;
        if (e.length === 1) return Promise.resolve(this.tool.toolbox[0]);
        const t1 = await this.data, o = e;
        return o == null ? void 0 : o.find((i)=>$6813aa9d7dc8ab1a$var$Wo(i.data, t1));
    }
    /**
   * Exports Block data as string using conversion config
   */ async exportDataAsString() {
        const e = await this.data;
        return $6813aa9d7dc8ab1a$var$fi(e, this.tool.conversionConfig);
    }
    /**
   * Make default Block wrappers and put Tool`s content there
   *
   * @returns {HTMLDivElement}
   */ compose() {
        const e = $6813aa9d7dc8ab1a$var$u.make("div", $6813aa9d7dc8ab1a$var$R.CSS.wrapper), t1 = $6813aa9d7dc8ab1a$var$u.make("div", $6813aa9d7dc8ab1a$var$R.CSS.content), o = this.toolInstance.render();
        e.dataset.id = this.id, this.toolRenderedElement = o, t1.appendChild(this.toolRenderedElement);
        let i = t1;
        return [
            ...this.tunesInstances.values(),
            ...this.defaultTunesInstances.values()
        ].forEach((s)=>{
            if ($6813aa9d7dc8ab1a$var$A(s.wrap)) try {
                i = s.wrap(i);
            } catch (r) {
                $6813aa9d7dc8ab1a$var$S(`Tune ${s.constructor.name} wrap method throws an Error %o`, "warn", r);
            }
        }), e.appendChild(i), e;
    }
    /**
   * Instantiate Block Tunes
   *
   * @param tunesData - current Block tunes data
   * @private
   */ composeTunes(e) {
        Array.from(this.tunes.values()).forEach((t1)=>{
            (t1.isInternal ? this.defaultTunesInstances : this.tunesInstances).set(t1.name, t1.create(e[t1.name], this.blockAPI));
        }), Object.entries(e).forEach(([t1, o])=>{
            this.tunesInstances.has(t1) || (this.unavailableTunesData[t1] = o);
        });
    }
    /**
   * Adds focus event listeners to all inputs and contenteditable
   */ addInputEvents() {
        this.inputs.forEach((e)=>{
            e.addEventListener("focus", this.handleFocus), $6813aa9d7dc8ab1a$var$u.isNativeInput(e) && e.addEventListener("input", this.didMutated);
        });
    }
    /**
   * removes focus event listeners from all inputs and contenteditable
   */ removeInputEvents() {
        this.inputs.forEach((e)=>{
            e.removeEventListener("focus", this.handleFocus), $6813aa9d7dc8ab1a$var$u.isNativeInput(e) && e.removeEventListener("input", this.didMutated);
        });
    }
    /**
   * Listen common editor Dom Changed event and detect mutations related to the  Block
   */ watchBlockMutations() {
        var e;
        this.redactorDomChangedCallback = (t1)=>{
            const { mutations: o } = t1;
            o.some((s)=>$6813aa9d7dc8ab1a$var$pi(s, this.toolRenderedElement)) && this.didMutated(o);
        }, (e = this.editorEventBus) == null || e.on($6813aa9d7dc8ab1a$var$ft, this.redactorDomChangedCallback);
    }
    /**
   * Remove redactor dom change event listener
   */ unwatchBlockMutations() {
        var e;
        (e = this.editorEventBus) == null || e.off($6813aa9d7dc8ab1a$var$ft, this.redactorDomChangedCallback);
    }
    /**
   * Sometimes Tool can replace own main element, for example H2 -> H4 or UL -> OL
   * We need to detect such changes and update a link to tools main element with the new one
   *
   * @param mutations - records of block content mutations
   */ detectToolRootChange(e) {
        e.forEach((t1)=>{
            if (Array.from(t1.removedNodes).includes(this.toolRenderedElement)) {
                const i = t1.addedNodes[t1.addedNodes.length - 1];
                this.toolRenderedElement = i;
            }
        });
    }
    /**
   * Clears inputs cached value
   */ dropInputsCache() {
        this.cachedInputs = [];
    }
    /**
   * Mark inputs with 'data-empty' attribute with the empty state
   */ toggleInputsEmptyMark() {
        this.inputs.forEach($6813aa9d7dc8ab1a$var$Do);
    }
}
class $6813aa9d7dc8ab1a$var$gi extends $6813aa9d7dc8ab1a$var$E {
    constructor(){
        super(...arguments), this.insert = (e = this.config.defaultBlock, t1 = {}, o = {}, i, s, r, a)=>{
            const l = this.Editor.BlockManager.insert({
                id: a,
                tool: e,
                data: t1,
                index: i,
                needToFocus: s,
                replace: r
            });
            return new $6813aa9d7dc8ab1a$var$J(l);
        }, this.composeBlockData = async (e)=>{
            const t1 = this.Editor.Tools.blockTools.get(e);
            return new $6813aa9d7dc8ab1a$var$R({
                tool: t1,
                api: this.Editor.API,
                readOnly: !0,
                data: {},
                tunesData: {}
            }).data;
        }, this.update = async (e, t1, o)=>{
            const { BlockManager: i } = this.Editor, s = i.getBlockById(e);
            if (s === void 0) throw new Error(`Block with id "${e}" not found`);
            const r = await i.update(s, t1, o);
            return new $6813aa9d7dc8ab1a$var$J(r);
        }, this.convert = async (e, t1, o)=>{
            var h, p;
            const { BlockManager: i, Tools: s } = this.Editor, r = i.getBlockById(e);
            if (!r) throw new Error(`Block with id "${e}" not found`);
            const a = s.blockTools.get(r.name), l = s.blockTools.get(t1);
            if (!l) throw new Error(`Block Tool with type "${t1}" not found`);
            const c = ((h = a == null ? void 0 : a.conversionConfig) == null ? void 0 : h.export) !== void 0, d = ((p = l.conversionConfig) == null ? void 0 : p.import) !== void 0;
            if (c && d) {
                const g = await i.convert(r, t1, o);
                return new $6813aa9d7dc8ab1a$var$J(g);
            } else {
                const g = [
                    c ? !1 : $6813aa9d7dc8ab1a$var$je(r.name),
                    d ? !1 : $6813aa9d7dc8ab1a$var$je(t1)
                ].filter(Boolean).join(" and ");
                throw new Error(`Conversion from "${r.name}" to "${t1}" is not possible. ${g} tool(s) should provide a "conversionConfig"`);
            }
        }, this.insertMany = (e, t1 = this.Editor.BlockManager.blocks.length - 1)=>{
            this.validateIndex(t1);
            const o = e.map(({ id: i, type: s, data: r })=>this.Editor.BlockManager.composeBlock({
                    id: i,
                    tool: s || this.config.defaultBlock,
                    data: r
                }));
            return this.Editor.BlockManager.insertMany(o, t1), o.map((i)=>new $6813aa9d7dc8ab1a$var$J(i));
        };
    }
    /**
   * Available methods
   *
   * @returns {Blocks}
   */ get methods() {
        return {
            clear: ()=>this.clear(),
            render: (e)=>this.render(e),
            renderFromHTML: (e)=>this.renderFromHTML(e),
            delete: (e)=>this.delete(e),
            swap: (e, t1)=>this.swap(e, t1),
            move: (e, t1)=>this.move(e, t1),
            getBlockByIndex: (e)=>this.getBlockByIndex(e),
            getById: (e)=>this.getById(e),
            getCurrentBlockIndex: ()=>this.getCurrentBlockIndex(),
            getBlockIndex: (e)=>this.getBlockIndex(e),
            getBlocksCount: ()=>this.getBlocksCount(),
            getBlockByElement: (e)=>this.getBlockByElement(e),
            stretchBlock: (e, t1 = !0)=>this.stretchBlock(e, t1),
            insertNewBlock: ()=>this.insertNewBlock(),
            insert: this.insert,
            insertMany: this.insertMany,
            update: this.update,
            composeBlockData: this.composeBlockData,
            convert: this.convert
        };
    }
    /**
   * Returns Blocks count
   *
   * @returns {number}
   */ getBlocksCount() {
        return this.Editor.BlockManager.blocks.length;
    }
    /**
   * Returns current block index
   *
   * @returns {number}
   */ getCurrentBlockIndex() {
        return this.Editor.BlockManager.currentBlockIndex;
    }
    /**
   * Returns the index of Block by id;
   *
   * @param id - block id
   */ getBlockIndex(e) {
        const t1 = this.Editor.BlockManager.getBlockById(e);
        if (!t1) {
            $6813aa9d7dc8ab1a$var$X("There is no block with id `" + e + "`", "warn");
            return;
        }
        return this.Editor.BlockManager.getBlockIndex(t1);
    }
    /**
   * Returns BlockAPI object by Block index
   *
   * @param {number} index - index to get
   */ getBlockByIndex(e) {
        const t1 = this.Editor.BlockManager.getBlockByIndex(e);
        if (t1 === void 0) {
            $6813aa9d7dc8ab1a$var$X("There is no block at index `" + e + "`", "warn");
            return;
        }
        return new $6813aa9d7dc8ab1a$var$J(t1);
    }
    /**
   * Returns BlockAPI object by Block id
   *
   * @param id - id of block to get
   */ getById(e) {
        const t1 = this.Editor.BlockManager.getBlockById(e);
        return t1 === void 0 ? ($6813aa9d7dc8ab1a$var$X("There is no block with id `" + e + "`", "warn"), null) : new $6813aa9d7dc8ab1a$var$J(t1);
    }
    /**
   * Get Block API object by any child html element
   *
   * @param element - html element to get Block by
   */ getBlockByElement(e) {
        const t1 = this.Editor.BlockManager.getBlock(e);
        if (t1 === void 0) {
            $6813aa9d7dc8ab1a$var$X("There is no block corresponding to element `" + e + "`", "warn");
            return;
        }
        return new $6813aa9d7dc8ab1a$var$J(t1);
    }
    /**
   * Call Block Manager method that swap Blocks
   *
   * @param {number} fromIndex - position of first Block
   * @param {number} toIndex - position of second Block
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        $6813aa9d7dc8ab1a$var$S("`blocks.swap()` method is deprecated and will be removed in the next major release. Use `block.move()` method instead", "info"), this.Editor.BlockManager.swap(e, t1);
    }
    /**
   * Move block from one index to another
   *
   * @param {number} toIndex - index to move to
   * @param {number} fromIndex - index to move from
   */ move(e, t1) {
        this.Editor.BlockManager.move(e, t1);
    }
    /**
   * Deletes Block
   *
   * @param {number} blockIndex - index of Block to delete
   */ delete(e = this.Editor.BlockManager.currentBlockIndex) {
        try {
            const t1 = this.Editor.BlockManager.getBlockByIndex(e);
            this.Editor.BlockManager.removeBlock(t1);
        } catch (t1) {
            $6813aa9d7dc8ab1a$var$X(t1, "warn");
            return;
        }
        this.Editor.BlockManager.blocks.length === 0 && this.Editor.BlockManager.insert(), this.Editor.BlockManager.currentBlock && this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END), this.Editor.Toolbar.close();
    }
    /**
   * Clear Editor's area
   */ async clear() {
        await this.Editor.BlockManager.clear(!0), this.Editor.InlineToolbar.close();
    }
    /**
   * Fills Editor with Blocks data
   *
   * @param {OutputData} data — Saved Editor data
   */ async render(e) {
        if (e === void 0 || e.blocks === void 0) throw new Error("Incorrect data passed to the render() method");
        this.Editor.ModificationsObserver.disable(), await this.Editor.BlockManager.clear(), await this.Editor.Renderer.render(e.blocks), this.Editor.ModificationsObserver.enable();
    }
    /**
   * Render passed HTML string
   *
   * @param {string} data - HTML string to render
   * @returns {Promise<void>}
   */ async renderFromHTML(e) {
        return await this.Editor.BlockManager.clear(), this.Editor.Paste.processText(e, !0);
    }
    /**
   * Stretch Block's content
   *
   * @param {number} index - index of Block to stretch
   * @param {boolean} status - true to enable, false to disable
   * @deprecated Use BlockAPI interface to stretch Blocks
   */ stretchBlock(e, t1 = !0) {
        $6813aa9d7dc8ab1a$var$ht(!0, "blocks.stretchBlock()", "BlockAPI");
        const o = this.Editor.BlockManager.getBlockByIndex(e);
        o && (o.stretched = t1);
    }
    /**
   * Insert new Block
   * After set caret to this Block
   *
   * @todo remove in 3.0.0
   * @deprecated with insert() method
   */ insertNewBlock() {
        $6813aa9d7dc8ab1a$var$S("Method blocks.insertNewBlock() is deprecated and it will be removed in the next major release. Use blocks.insert() instead.", "warn"), this.insert();
    }
    /**
   * Validated block index and throws an error if it's invalid
   *
   * @param index - index to validate
   */ validateIndex(e) {
        if (typeof e != "number") throw new Error("Index should be a number");
        if (e < 0) throw new Error("Index should be greater than or equal to 0");
        if (e === null) throw new Error("Index should be greater than or equal to 0");
    }
}
function $6813aa9d7dc8ab1a$var$mi(n, e) {
    return typeof n == "number" ? e.BlockManager.getBlockByIndex(n) : typeof n == "string" ? e.BlockManager.getBlockById(n) : e.BlockManager.getBlockById(n.id);
}
class $6813aa9d7dc8ab1a$var$bi extends $6813aa9d7dc8ab1a$var$E {
    constructor(){
        super(...arguments), this.setToFirstBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.firstBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.firstBlock, e, t1), !0) : !1, this.setToLastBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.lastBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.lastBlock, e, t1), !0) : !1, this.setToPreviousBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.previousBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.previousBlock, e, t1), !0) : !1, this.setToNextBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.nextBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.nextBlock, e, t1), !0) : !1, this.setToBlock = (e, t1 = this.Editor.Caret.positions.DEFAULT, o = 0)=>{
            const i = $6813aa9d7dc8ab1a$var$mi(e, this.Editor);
            return i === void 0 ? !1 : (this.Editor.Caret.setToBlock(i, t1, o), !0);
        }, this.focus = (e = !1)=>e ? this.setToLastBlock(this.Editor.Caret.positions.END) : this.setToFirstBlock(this.Editor.Caret.positions.START);
    }
    /**
   * Available methods
   *
   * @returns {Caret}
   */ get methods() {
        return {
            setToFirstBlock: this.setToFirstBlock,
            setToLastBlock: this.setToLastBlock,
            setToPreviousBlock: this.setToPreviousBlock,
            setToNextBlock: this.setToNextBlock,
            setToBlock: this.setToBlock,
            focus: this.focus
        };
    }
}
class $6813aa9d7dc8ab1a$var$vi extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Available methods
   *
   * @returns {Events}
   */ get methods() {
        return {
            emit: (e, t1)=>this.emit(e, t1),
            off: (e, t1)=>this.off(e, t1),
            on: (e, t1)=>this.on(e, t1)
        };
    }
    /**
   * Subscribe on Events
   *
   * @param {string} eventName - event name to subscribe
   * @param {Function} callback - event handler
   */ on(e, t1) {
        this.eventsDispatcher.on(e, t1);
    }
    /**
   * Emit event with data
   *
   * @param {string} eventName - event to emit
   * @param {object} data - event's data
   */ emit(e, t1) {
        this.eventsDispatcher.emit(e, t1);
    }
    /**
   * Unsubscribe from Event
   *
   * @param {string} eventName - event to unsubscribe
   * @param {Function} callback - event handler
   */ off(e, t1) {
        this.eventsDispatcher.off(e, t1);
    }
}
class $6813aa9d7dc8ab1a$var$kt extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Return namespace section for tool or block tune
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ static getNamespace(e, t1) {
        return t1 ? `blockTunes.${e}` : `tools.${e}`;
    }
    /**
   * Return I18n API methods with global dictionary access
   */ get methods() {
        return {
            t: ()=>{
                $6813aa9d7dc8ab1a$var$X("I18n.t() method can be accessed only from Tools", "warn");
            }
        };
    }
    /**
   * Return I18n API methods with tool namespaced dictionary
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ getMethodsForTool(e, t1) {
        return Object.assign(this.methods, {
            t: (o)=>$6813aa9d7dc8ab1a$var$z.t($6813aa9d7dc8ab1a$var$kt.getNamespace(e, t1), o)
        });
    }
}
class $6813aa9d7dc8ab1a$var$ki extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Editor.js Core API modules
   */ get methods() {
        return {
            blocks: this.Editor.BlocksAPI.methods,
            caret: this.Editor.CaretAPI.methods,
            tools: this.Editor.ToolsAPI.methods,
            events: this.Editor.EventsAPI.methods,
            listeners: this.Editor.ListenersAPI.methods,
            notifier: this.Editor.NotifierAPI.methods,
            sanitizer: this.Editor.SanitizerAPI.methods,
            saver: this.Editor.SaverAPI.methods,
            selection: this.Editor.SelectionAPI.methods,
            styles: this.Editor.StylesAPI.classes,
            toolbar: this.Editor.ToolbarAPI.methods,
            inlineToolbar: this.Editor.InlineToolbarAPI.methods,
            tooltip: this.Editor.TooltipAPI.methods,
            i18n: this.Editor.I18nAPI.methods,
            readOnly: this.Editor.ReadOnlyAPI.methods,
            ui: this.Editor.UiAPI.methods
        };
    }
    /**
   * Returns Editor.js Core API methods for passed tool
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ getMethodsForTool(e, t1) {
        return Object.assign(this.methods, {
            i18n: this.Editor.I18nAPI.getMethodsForTool(e, t1)
        });
    }
}
class $6813aa9d7dc8ab1a$var$yi extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Available methods
   *
   * @returns {InlineToolbar}
   */ get methods() {
        return {
            close: ()=>this.close(),
            open: ()=>this.open()
        };
    }
    /**
   * Open Inline Toolbar
   */ open() {
        this.Editor.InlineToolbar.tryToShow();
    }
    /**
   * Close Inline Toolbar
   */ close() {
        this.Editor.InlineToolbar.close();
    }
}
class $6813aa9d7dc8ab1a$var$wi extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Available methods
   *
   * @returns {Listeners}
   */ get methods() {
        return {
            on: (e, t1, o, i)=>this.on(e, t1, o, i),
            off: (e, t1, o, i)=>this.off(e, t1, o, i),
            offById: (e)=>this.offById(e)
        };
    }
    /**
   * Ads a DOM event listener. Return it's id.
   *
   * @param {HTMLElement} element - Element to set handler to
   * @param {string} eventType - event type
   * @param {() => void} handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ on(e, t1, o, i) {
        return this.listeners.on(e, t1, o, i);
    }
    /**
   * Removes DOM listener from element
   *
   * @param {Element} element - Element to remove handler from
   * @param eventType - event type
   * @param handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ off(e, t1, o, i) {
        this.listeners.off(e, t1, o, i);
    }
    /**
   * Removes DOM listener by the listener id
   *
   * @param id - id of the listener to remove
   */ offById(e) {
        this.listeners.offById(e);
    }
}
var $6813aa9d7dc8ab1a$var$Ko = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "/", i(i.s = 0);
        }([
            function(t1, o, i) {
                i(1), /*!
       * Codex JavaScript Notification module
       * https://github.com/codex-team/js-notifier
       */ t1.exports = function() {
                    var s = i(6), r = "cdx-notify--bounce-in", a = null;
                    return {
                        show: function(l) {
                            if (l.message) {
                                (function() {
                                    if (a) return !0;
                                    a = s.getWrapper(), document.body.appendChild(a);
                                })();
                                var c = null, d = l.time || 8e3;
                                switch(l.type){
                                    case "confirm":
                                        c = s.confirm(l);
                                        break;
                                    case "prompt":
                                        c = s.prompt(l);
                                        break;
                                    default:
                                        c = s.alert(l), window.setTimeout(function() {
                                            c.remove();
                                        }, d);
                                }
                                a.appendChild(c), c.classList.add(r);
                            }
                        }
                    };
                }();
            },
            function(t1, o, i) {
                var s = i(2);
                typeof s == "string" && (s = [
                    [
                        t1.i,
                        s,
                        ""
                    ]
                ]);
                var r = {
                    hmr: !0,
                    transform: void 0,
                    insertInto: void 0
                };
                i(4)(s, r), s.locals && (t1.exports = s.locals);
            },
            function(t1, o, i) {
                (t1.exports = i(3)(!1)).push([
                    t1.i,
                    `.cdx-notify--error{background:#fffbfb!important}.cdx-notify--error::before{background:#fb5d5d!important}.cdx-notify__input{max-width:130px;padding:5px 10px;background:#f7f7f7;border:0;border-radius:3px;font-size:13px;color:#656b7c;outline:0}.cdx-notify__input:-ms-input-placeholder{color:#656b7c}.cdx-notify__input::placeholder{color:#656b7c}.cdx-notify__input:focus:-ms-input-placeholder{color:rgba(101,107,124,.3)}.cdx-notify__input:focus::placeholder{color:rgba(101,107,124,.3)}.cdx-notify__button{border:none;border-radius:3px;font-size:13px;padding:5px 10px;cursor:pointer}.cdx-notify__button:last-child{margin-left:10px}.cdx-notify__button--cancel{background:#f2f5f7;box-shadow:0 2px 1px 0 rgba(16,19,29,0);color:#656b7c}.cdx-notify__button--cancel:hover{background:#eee}.cdx-notify__button--confirm{background:#34c992;box-shadow:0 1px 1px 0 rgba(18,49,35,.05);color:#fff}.cdx-notify__button--confirm:hover{background:#33b082}.cdx-notify__btns-wrapper{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;margin-top:5px}.cdx-notify__cross{position:absolute;top:5px;right:5px;width:10px;height:10px;padding:5px;opacity:.54;cursor:pointer}.cdx-notify__cross::after,.cdx-notify__cross::before{content:'';position:absolute;left:9px;top:5px;height:12px;width:2px;background:#575d67}.cdx-notify__cross::before{transform:rotate(-45deg)}.cdx-notify__cross::after{transform:rotate(45deg)}.cdx-notify__cross:hover{opacity:1}.cdx-notifies{position:fixed;z-index:2;bottom:20px;left:20px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif}.cdx-notify{position:relative;width:220px;margin-top:15px;padding:13px 16px;background:#fff;box-shadow:0 11px 17px 0 rgba(23,32,61,.13);border-radius:5px;font-size:14px;line-height:1.4em;word-wrap:break-word}.cdx-notify::before{content:'';position:absolute;display:block;top:0;left:0;width:3px;height:calc(100% - 6px);margin:3px;border-radius:5px;background:0 0}@keyframes bounceIn{0%{opacity:0;transform:scale(.3)}50%{opacity:1;transform:scale(1.05)}70%{transform:scale(.9)}100%{transform:scale(1)}}.cdx-notify--bounce-in{animation-name:bounceIn;animation-duration:.6s;animation-iteration-count:1}.cdx-notify--success{background:#fafffe!important}.cdx-notify--success::before{background:#41ffb1!important}`,
                    ""
                ]);
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = [];
                    return s.toString = function() {
                        return this.map(function(r) {
                            var a = function(l, c) {
                                var d = l[1] || "", h = l[3];
                                if (!h) return d;
                                if (c && typeof btoa == "function") {
                                    var p = (f = h, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(f)))) + " */"), g = h.sources.map(function(v) {
                                        return "/*# sourceURL=" + h.sourceRoot + v + " */";
                                    });
                                    return [
                                        d
                                    ].concat(g).concat([
                                        p
                                    ]).join(`
`);
                                }
                                var f;
                                return [
                                    d
                                ].join(`
`);
                            }(r, i);
                            return r[2] ? "@media " + r[2] + "{" + a + "}" : a;
                        }).join("");
                    }, s.i = function(r, a) {
                        typeof r == "string" && (r = [
                            [
                                null,
                                r,
                                ""
                            ]
                        ]);
                        for(var l = {}, c = 0; c < this.length; c++){
                            var d = this[c][0];
                            typeof d == "number" && (l[d] = !0);
                        }
                        for(c = 0; c < r.length; c++){
                            var h = r[c];
                            typeof h[0] == "number" && l[h[0]] || (a && !h[2] ? h[2] = a : a && (h[2] = "(" + h[2] + ") and (" + a + ")"), s.push(h));
                        }
                    }, s;
                };
            },
            function(t1, o, i) {
                var s, r, a = {}, l = (s = function() {
                    return window && document && document.all && !window.atob;
                }, function() {
                    return r === void 0 && (r = s.apply(this, arguments)), r;
                }), c = function(k) {
                    var m = {};
                    return function(w) {
                        if (typeof w == "function") return w();
                        if (m[w] === void 0) {
                            var x = (function(I) {
                                return document.querySelector(I);
                            }).call(this, w);
                            if (window.HTMLIFrameElement && x instanceof window.HTMLIFrameElement) try {
                                x = x.contentDocument.head;
                            } catch  {
                                x = null;
                            }
                            m[w] = x;
                        }
                        return m[w];
                    };
                }(), d = null, h = 0, p = [], g = i(5);
                function f(k, m) {
                    for(var w = 0; w < k.length; w++){
                        var x = k[w], I = a[x.id];
                        if (I) {
                            I.refs++;
                            for(var C = 0; C < I.parts.length; C++)I.parts[C](x.parts[C]);
                            for(; C < x.parts.length; C++)I.parts.push(F(x.parts[C], m));
                        } else {
                            var N = [];
                            for(C = 0; C < x.parts.length; C++)N.push(F(x.parts[C], m));
                            a[x.id] = {
                                id: x.id,
                                refs: 1,
                                parts: N
                            };
                        }
                    }
                }
                function v(k, m) {
                    for(var w = [], x = {}, I = 0; I < k.length; I++){
                        var C = k[I], N = m.base ? C[0] + m.base : C[0], B = {
                            css: C[1],
                            media: C[2],
                            sourceMap: C[3]
                        };
                        x[N] ? x[N].parts.push(B) : w.push(x[N] = {
                            id: N,
                            parts: [
                                B
                            ]
                        });
                    }
                    return w;
                }
                function O(k, m) {
                    var w = c(k.insertInto);
                    if (!w) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
                    var x = p[p.length - 1];
                    if (k.insertAt === "top") x ? x.nextSibling ? w.insertBefore(m, x.nextSibling) : w.appendChild(m) : w.insertBefore(m, w.firstChild), p.push(m);
                    else if (k.insertAt === "bottom") w.appendChild(m);
                    else {
                        if (typeof k.insertAt != "object" || !k.insertAt.before) throw new Error(`[Style Loader]

 Invalid value for parameter 'insertAt' ('options.insertAt') found.
 Must be 'top', 'bottom', or Object.
 (https://github.com/webpack-contrib/style-loader#insertat)
`);
                        var I = c(k.insertInto + " " + k.insertAt.before);
                        w.insertBefore(m, I);
                    }
                }
                function T(k) {
                    if (k.parentNode === null) return !1;
                    k.parentNode.removeChild(k);
                    var m = p.indexOf(k);
                    m >= 0 && p.splice(m, 1);
                }
                function M(k) {
                    var m = document.createElement("style");
                    return k.attrs.type === void 0 && (k.attrs.type = "text/css"), q(m, k.attrs), O(k, m), m;
                }
                function q(k, m) {
                    Object.keys(m).forEach(function(w) {
                        k.setAttribute(w, m[w]);
                    });
                }
                function F(k, m) {
                    var w, x, I, C;
                    if (m.transform && k.css) {
                        if (!(C = m.transform(k.css))) return function() {};
                        k.css = C;
                    }
                    if (m.singleton) {
                        var N = h++;
                        w = d || (d = M(m)), x = ie.bind(null, w, N, !1), I = ie.bind(null, w, N, !0);
                    } else k.sourceMap && typeof URL == "function" && typeof URL.createObjectURL == "function" && typeof URL.revokeObjectURL == "function" && typeof Blob == "function" && typeof btoa == "function" ? (w = function(B) {
                        var W = document.createElement("link");
                        return B.attrs.type === void 0 && (B.attrs.type = "text/css"), B.attrs.rel = "stylesheet", q(W, B.attrs), O(B, W), W;
                    }(m), x = (function(B, W, ve) {
                        var se = ve.css, tt = ve.sourceMap, Yn = W.convertToAbsoluteUrls === void 0 && tt;
                        (W.convertToAbsoluteUrls || Yn) && (se = g(se)), tt && (se += `
/*# sourceMappingURL=data:application/json;base64,` + btoa(unescape(encodeURIComponent(JSON.stringify(tt)))) + " */");
                        var Kn = new Blob([
                            se
                        ], {
                            type: "text/css"
                        }), ko = B.href;
                        B.href = URL.createObjectURL(Kn), ko && URL.revokeObjectURL(ko);
                    }).bind(null, w, m), I = function() {
                        T(w), w.href && URL.revokeObjectURL(w.href);
                    }) : (w = M(m), x = (function(B, W) {
                        var ve = W.css, se = W.media;
                        if (se && B.setAttribute("media", se), B.styleSheet) B.styleSheet.cssText = ve;
                        else {
                            for(; B.firstChild;)B.removeChild(B.firstChild);
                            B.appendChild(document.createTextNode(ve));
                        }
                    }).bind(null, w), I = function() {
                        T(w);
                    });
                    return x(k), function(B) {
                        if (B) {
                            if (B.css === k.css && B.media === k.media && B.sourceMap === k.sourceMap) return;
                            x(k = B);
                        } else I();
                    };
                }
                t1.exports = function(k, m) {
                    if (typeof DEBUG < "u" && DEBUG && typeof document != "object") throw new Error("The style-loader cannot be used in a non-browser environment");
                    (m = m || {}).attrs = typeof m.attrs == "object" ? m.attrs : {}, m.singleton || typeof m.singleton == "boolean" || (m.singleton = l()), m.insertInto || (m.insertInto = "head"), m.insertAt || (m.insertAt = "bottom");
                    var w = v(k, m);
                    return f(w, m), function(x) {
                        for(var I = [], C = 0; C < w.length; C++){
                            var N = w[C];
                            (B = a[N.id]).refs--, I.push(B);
                        }
                        for(x && f(v(x, m), m), C = 0; C < I.length; C++){
                            var B;
                            if ((B = I[C]).refs === 0) {
                                for(var W = 0; W < B.parts.length; W++)B.parts[W]();
                                delete a[B.id];
                            }
                        }
                    };
                };
                var H, Q = (H = [], function(k, m) {
                    return H[k] = m, H.filter(Boolean).join(`
`);
                });
                function ie(k, m, w, x) {
                    var I = w ? "" : x.css;
                    if (k.styleSheet) k.styleSheet.cssText = Q(m, I);
                    else {
                        var C = document.createTextNode(I), N = k.childNodes;
                        N[m] && k.removeChild(N[m]), N.length ? k.insertBefore(C, N[m]) : k.appendChild(C);
                    }
                }
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = typeof window < "u" && window.location;
                    if (!s) throw new Error("fixUrls requires window.location");
                    if (!i || typeof i != "string") return i;
                    var r = s.protocol + "//" + s.host, a = r + s.pathname.replace(/\/[^\/]*$/, "/");
                    return i.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(l, c) {
                        var d, h = c.trim().replace(/^"(.*)"$/, function(p, g) {
                            return g;
                        }).replace(/^'(.*)'$/, function(p, g) {
                            return g;
                        });
                        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(h) ? l : (d = h.indexOf("//") === 0 ? h : h.indexOf("/") === 0 ? r + h : a + h.replace(/^\.\//, ""), "url(" + JSON.stringify(d) + ")");
                    });
                };
            },
            function(t1, o, i) {
                var s, r, a, l, c, d, h, p, g;
                t1.exports = (s = "cdx-notifies", r = "cdx-notify", a = "cdx-notify__cross", l = "cdx-notify__button--confirm", c = "cdx-notify__button--cancel", d = "cdx-notify__input", h = "cdx-notify__button", p = "cdx-notify__btns-wrapper", {
                    alert: g = function(f) {
                        var v = document.createElement("DIV"), O = document.createElement("DIV"), T = f.message, M = f.style;
                        return v.classList.add(r), M && v.classList.add(r + "--" + M), v.innerHTML = T, O.classList.add(a), O.addEventListener("click", v.remove.bind(v)), v.appendChild(O), v;
                    },
                    confirm: function(f) {
                        var v = g(f), O = document.createElement("div"), T = document.createElement("button"), M = document.createElement("button"), q = v.querySelector("." + a), F = f.cancelHandler, H = f.okHandler;
                        return O.classList.add(p), T.innerHTML = f.okText || "Confirm", M.innerHTML = f.cancelText || "Cancel", T.classList.add(h), M.classList.add(h), T.classList.add(l), M.classList.add(c), F && typeof F == "function" && (M.addEventListener("click", F), q.addEventListener("click", F)), H && typeof H == "function" && T.addEventListener("click", H), T.addEventListener("click", v.remove.bind(v)), M.addEventListener("click", v.remove.bind(v)), O.appendChild(T), O.appendChild(M), v.appendChild(O), v;
                    },
                    prompt: function(f) {
                        var v = g(f), O = document.createElement("div"), T = document.createElement("button"), M = document.createElement("input"), q = v.querySelector("." + a), F = f.cancelHandler, H = f.okHandler;
                        return O.classList.add(p), T.innerHTML = f.okText || "Ok", T.classList.add(h), T.classList.add(l), M.classList.add(d), f.placeholder && M.setAttribute("placeholder", f.placeholder), f.default && (M.value = f.default), f.inputType && (M.type = f.inputType), F && typeof F == "function" && q.addEventListener("click", F), H && typeof H == "function" && T.addEventListener("click", function() {
                            H(M.value);
                        }), T.addEventListener("click", v.remove.bind(v)), O.appendChild(M), O.appendChild(T), v.appendChild(O), v;
                    },
                    getWrapper: function() {
                        var f = document.createElement("DIV");
                        return f.classList.add(s), f;
                    }
                });
            }
        ]);
    });
})($6813aa9d7dc8ab1a$var$Ko);
var $6813aa9d7dc8ab1a$var$Ei = $6813aa9d7dc8ab1a$var$Ko.exports;
const $6813aa9d7dc8ab1a$var$xi = /* @__PURE__ */ $6813aa9d7dc8ab1a$var$Ke($6813aa9d7dc8ab1a$var$Ei);
class $6813aa9d7dc8ab1a$var$Bi {
    /**
   * Show web notification
   *
   * @param {NotifierOptions | ConfirmNotifierOptions | PromptNotifierOptions} options - notification options
   */ show(e) {
        $6813aa9d7dc8ab1a$var$xi.show(e);
    }
}
class $6813aa9d7dc8ab1a$var$Ci extends $6813aa9d7dc8ab1a$var$E {
    /**
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.notifier = new $6813aa9d7dc8ab1a$var$Bi();
    }
    /**
   * Available methods
   */ get methods() {
        return {
            show: (e)=>this.show(e)
        };
    }
    /**
   * Show notification
   *
   * @param {NotifierOptions} options - message option
   */ show(e) {
        return this.notifier.show(e);
    }
}
class $6813aa9d7dc8ab1a$var$Ti extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Available methods
   */ get methods() {
        const e = ()=>this.isEnabled;
        return {
            toggle: (t1)=>this.toggle(t1),
            get isEnabled () {
                return e();
            }
        };
    }
    /**
   * Set or toggle read-only state
   *
   * @param {boolean|undefined} state - set or toggle state
   * @returns {boolean} current value
   */ toggle(e) {
        return this.Editor.ReadOnly.toggle(e);
    }
    /**
   * Returns current read-only state
   */ get isEnabled() {
        return this.Editor.ReadOnly.isEnabled;
    }
}
var $6813aa9d7dc8ab1a$var$Xo = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })($6813aa9d7dc8ab1a$var$Ce, function() {
        function t1(h) {
            var p = h.tags, g = Object.keys(p), f = g.map(function(v) {
                return typeof p[v];
            }).every(function(v) {
                return v === "object" || v === "boolean" || v === "function";
            });
            if (!f) throw new Error("The configuration was invalid");
            this.config = h;
        }
        var o = [
            "P",
            "LI",
            "TD",
            "TH",
            "DIV",
            "H1",
            "H2",
            "H3",
            "H4",
            "H5",
            "H6",
            "PRE"
        ];
        function i(h) {
            return o.indexOf(h.nodeName) !== -1;
        }
        var s = [
            "A",
            "B",
            "STRONG",
            "I",
            "EM",
            "SUB",
            "SUP",
            "U",
            "STRIKE"
        ];
        function r(h) {
            return s.indexOf(h.nodeName) !== -1;
        }
        t1.prototype.clean = function(h) {
            const p = document.implementation.createHTMLDocument(), g = p.createElement("div");
            return g.innerHTML = h, this._sanitize(p, g), g.innerHTML;
        }, t1.prototype._sanitize = function(h, p) {
            var g = a(h, p), f = g.firstChild();
            if (f) do {
                if (f.nodeType === Node.TEXT_NODE) {
                    if (f.data.trim() === "" && (f.previousElementSibling && i(f.previousElementSibling) || f.nextElementSibling && i(f.nextElementSibling))) {
                        p.removeChild(f), this._sanitize(h, p);
                        break;
                    } else continue;
                }
                if (f.nodeType === Node.COMMENT_NODE) {
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                var v = r(f), O;
                v && (O = Array.prototype.some.call(f.childNodes, i));
                var T = !!p.parentNode, M = i(p) && i(f) && T, q = f.nodeName.toLowerCase(), F = l(this.config, q, f), H = v && O;
                if (H || c(f, F) || !this.config.keepNestedBlockElements && M) {
                    if (!(f.nodeName === "SCRIPT" || f.nodeName === "STYLE")) for(; f.childNodes.length > 0;)p.insertBefore(f.childNodes[0], f);
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                for(var Q = 0; Q < f.attributes.length; Q += 1){
                    var ie = f.attributes[Q];
                    d(ie, F, f) && (f.removeAttribute(ie.name), Q = Q - 1);
                }
                this._sanitize(h, f);
            }while (f = g.nextSibling());
        };
        function a(h, p) {
            return h.createTreeWalker(p, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT, null, !1);
        }
        function l(h, p, g) {
            return typeof h.tags[p] == "function" ? h.tags[p](g) : h.tags[p];
        }
        function c(h, p) {
            return typeof p > "u" ? !0 : typeof p == "boolean" ? !p : !1;
        }
        function d(h, p, g) {
            var f = h.name.toLowerCase();
            return p === !0 ? !1 : typeof p[f] == "function" ? !p[f](h.value, g) : typeof p[f] > "u" || p[f] === !1 ? !0 : typeof p[f] == "string" ? p[f] !== h.value : !1;
        }
        return t1;
    });
})($6813aa9d7dc8ab1a$var$Xo);
var $6813aa9d7dc8ab1a$var$Si = $6813aa9d7dc8ab1a$var$Xo.exports;
const $6813aa9d7dc8ab1a$var$Ii = /* @__PURE__ */ $6813aa9d7dc8ab1a$var$Ke($6813aa9d7dc8ab1a$var$Si);
function $6813aa9d7dc8ab1a$var$yt(n, e) {
    return n.map((t1)=>{
        const o = $6813aa9d7dc8ab1a$var$A(e) ? e(t1.tool) : e;
        return $6813aa9d7dc8ab1a$var$V(o) || (t1.data = $6813aa9d7dc8ab1a$var$wt(t1.data, o)), t1;
    });
}
function $6813aa9d7dc8ab1a$var$Z(n, e = {}) {
    const t1 = {
        tags: e
    };
    return new $6813aa9d7dc8ab1a$var$Ii(t1).clean(n);
}
function $6813aa9d7dc8ab1a$var$wt(n, e) {
    return Array.isArray(n) ? $6813aa9d7dc8ab1a$var$Oi(n, e) : $6813aa9d7dc8ab1a$var$D(n) ? $6813aa9d7dc8ab1a$var$_i(n, e) : $6813aa9d7dc8ab1a$var$te(n) ? $6813aa9d7dc8ab1a$var$Mi(n, e) : n;
}
function $6813aa9d7dc8ab1a$var$Oi(n, e) {
    return n.map((t1)=>$6813aa9d7dc8ab1a$var$wt(t1, e));
}
function $6813aa9d7dc8ab1a$var$_i(n, e) {
    const t1 = {};
    for(const o in n){
        if (!Object.prototype.hasOwnProperty.call(n, o)) continue;
        const i = n[o], s = $6813aa9d7dc8ab1a$var$Ai(e[o]) ? e[o] : e;
        t1[o] = $6813aa9d7dc8ab1a$var$wt(i, s);
    }
    return t1;
}
function $6813aa9d7dc8ab1a$var$Mi(n, e) {
    return $6813aa9d7dc8ab1a$var$D(e) ? $6813aa9d7dc8ab1a$var$Z(n, e) : e === !1 ? $6813aa9d7dc8ab1a$var$Z(n, {}) : n;
}
function $6813aa9d7dc8ab1a$var$Ai(n) {
    return $6813aa9d7dc8ab1a$var$D(n) || $6813aa9d7dc8ab1a$var$Gn(n) || $6813aa9d7dc8ab1a$var$A(n);
}
class $6813aa9d7dc8ab1a$var$Li extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Available methods
   *
   * @returns {SanitizerConfig}
   */ get methods() {
        return {
            clean: (e, t1)=>this.clean(e, t1)
        };
    }
    /**
   * Perform sanitizing of a string
   *
   * @param {string} taintString - what to sanitize
   * @param {SanitizerConfig} config - sanitizer config
   * @returns {string}
   */ clean(e, t1) {
        return $6813aa9d7dc8ab1a$var$Z(e, t1);
    }
}
class $6813aa9d7dc8ab1a$var$Pi extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Available methods
   *
   * @returns {Saver}
   */ get methods() {
        return {
            save: ()=>this.save()
        };
    }
    /**
   * Return Editor's data
   *
   * @returns {OutputData}
   */ save() {
        const e = "Editor's content can not be saved in read-only mode";
        return this.Editor.ReadOnly.isEnabled ? ($6813aa9d7dc8ab1a$var$X(e, "warn"), Promise.reject(new Error(e))) : this.Editor.Saver.save();
    }
}
class $6813aa9d7dc8ab1a$var$Ni extends $6813aa9d7dc8ab1a$var$E {
    constructor(){
        super(...arguments), this.selectionUtils = new $6813aa9d7dc8ab1a$var$b();
    }
    /**
   * Available methods
   *
   * @returns {SelectionAPIInterface}
   */ get methods() {
        return {
            findParentTag: (e, t1)=>this.findParentTag(e, t1),
            expandToTag: (e)=>this.expandToTag(e),
            save: ()=>this.selectionUtils.save(),
            restore: ()=>this.selectionUtils.restore(),
            setFakeBackground: ()=>this.selectionUtils.setFakeBackground(),
            removeFakeBackground: ()=>this.selectionUtils.removeFakeBackground()
        };
    }
    /**
   * Looks ahead from selection and find passed tag with class name
   *
   * @param {string} tagName - tag to find
   * @param {string} className - tag's class name
   * @returns {HTMLElement|null}
   */ findParentTag(e, t1) {
        return this.selectionUtils.findParentTag(e, t1);
    }
    /**
   * Expand selection to passed tag
   *
   * @param {HTMLElement} node - tag that should contain selection
   */ expandToTag(e) {
        this.selectionUtils.expandToTag(e);
    }
}
class $6813aa9d7dc8ab1a$var$Ri extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Available methods
   */ get methods() {
        return {
            getBlockTools: ()=>Array.from(this.Editor.Tools.blockTools.values())
        };
    }
}
class $6813aa9d7dc8ab1a$var$Di extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Exported classes
   */ get classes() {
        return {
            /**
       * Base Block styles
       */ block: "cdx-block",
            /**
       * Inline Tools styles
       */ inlineToolButton: "ce-inline-tool",
            inlineToolButtonActive: "ce-inline-tool--active",
            /**
       * UI elements
       */ input: "cdx-input",
            loader: "cdx-loader",
            button: "cdx-button",
            /**
       * Settings styles
       */ settingsButton: "cdx-settings-button",
            settingsButtonActive: "cdx-settings-button--active"
        };
    }
}
class $6813aa9d7dc8ab1a$var$Fi extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Available methods
   *
   * @returns {Toolbar}
   */ get methods() {
        return {
            close: ()=>this.close(),
            open: ()=>this.open(),
            toggleBlockSettings: (e)=>this.toggleBlockSettings(e),
            toggleToolbox: (e)=>this.toggleToolbox(e)
        };
    }
    /**
   * Open toolbar
   */ open() {
        this.Editor.Toolbar.moveAndOpen();
    }
    /**
   * Close toolbar and all included elements
   */ close() {
        this.Editor.Toolbar.close();
    }
    /**
   * Toggles Block Setting of the current block
   *
   * @param {boolean} openingState —  opening state of Block Setting
   */ toggleBlockSettings(e) {
        if (this.Editor.BlockManager.currentBlockIndex === -1) {
            $6813aa9d7dc8ab1a$var$X("Could't toggle the Toolbar because there is no block selected ", "warn");
            return;
        }
        e ?? !this.Editor.BlockSettings.opened ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.open()) : this.Editor.BlockSettings.close();
    }
    /**
   * Open toolbox
   *
   * @param {boolean} openingState - Opening state of toolbox
   */ toggleToolbox(e) {
        if (this.Editor.BlockManager.currentBlockIndex === -1) {
            $6813aa9d7dc8ab1a$var$X("Could't toggle the Toolbox because there is no block selected ", "warn");
            return;
        }
        e ?? !this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open()) : this.Editor.Toolbar.toolbox.close();
    }
}
var $6813aa9d7dc8ab1a$var$Vo = {
    exports: {}
};
/*!
 * CodeX.Tooltips
 * 
 * @version 1.0.5
 * 
 * @licence MIT
 * @author CodeX <https://codex.so>
 * 
 * 
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                t1.exports = i(1);
            },
            function(t1, o, i) {
                i.r(o), i.d(o, "default", function() {
                    return s;
                });
                class s {
                    constructor(){
                        this.nodes = {
                            wrapper: null,
                            content: null
                        }, this.showed = !1, this.offsetTop = 10, this.offsetLeft = 10, this.offsetRight = 10, this.hidingDelay = 0, this.handleWindowScroll = ()=>{
                            this.showed && this.hide(!0);
                        }, this.loadStyles(), this.prepare(), window.addEventListener("scroll", this.handleWindowScroll, {
                            passive: !0
                        });
                    }
                    get CSS() {
                        return {
                            tooltip: "ct",
                            tooltipContent: "ct__content",
                            tooltipShown: "ct--shown",
                            placement: {
                                left: "ct--left",
                                bottom: "ct--bottom",
                                right: "ct--right",
                                top: "ct--top"
                            }
                        };
                    }
                    show(a, l, c) {
                        this.nodes.wrapper || this.prepare(), this.hidingTimeout && clearTimeout(this.hidingTimeout);
                        const d = Object.assign({
                            placement: "bottom",
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0,
                            marginBottom: 0,
                            delay: 70,
                            hidingDelay: 0
                        }, c);
                        if (d.hidingDelay && (this.hidingDelay = d.hidingDelay), this.nodes.content.innerHTML = "", typeof l == "string") this.nodes.content.appendChild(document.createTextNode(l));
                        else {
                            if (!(l instanceof Node)) throw Error("[CodeX Tooltip] Wrong type of \xabcontent\xbb passed. It should be an instance of Node or String. But " + typeof l + " given.");
                            this.nodes.content.appendChild(l);
                        }
                        switch(this.nodes.wrapper.classList.remove(...Object.values(this.CSS.placement)), d.placement){
                            case "top":
                                this.placeTop(a, d);
                                break;
                            case "left":
                                this.placeLeft(a, d);
                                break;
                            case "right":
                                this.placeRight(a, d);
                                break;
                            case "bottom":
                            default:
                                this.placeBottom(a, d);
                        }
                        d && d.delay ? this.showingTimeout = setTimeout(()=>{
                            this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0;
                        }, d.delay) : (this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0);
                    }
                    hide(a = !1) {
                        if (this.hidingDelay && !a) return this.hidingTimeout && clearTimeout(this.hidingTimeout), void (this.hidingTimeout = setTimeout(()=>{
                            this.hide(!0);
                        }, this.hidingDelay));
                        this.nodes.wrapper.classList.remove(this.CSS.tooltipShown), this.showed = !1, this.showingTimeout && clearTimeout(this.showingTimeout);
                    }
                    onHover(a, l, c) {
                        a.addEventListener("mouseenter", ()=>{
                            this.show(a, l, c);
                        }), a.addEventListener("mouseleave", ()=>{
                            this.hide();
                        });
                    }
                    destroy() {
                        this.nodes.wrapper.remove(), window.removeEventListener("scroll", this.handleWindowScroll);
                    }
                    prepare() {
                        this.nodes.wrapper = this.make("div", this.CSS.tooltip), this.nodes.content = this.make("div", this.CSS.tooltipContent), this.append(this.nodes.wrapper, this.nodes.content), this.append(document.body, this.nodes.wrapper);
                    }
                    loadStyles() {
                        const a = "codex-tooltips-style";
                        if (document.getElementById(a)) return;
                        const l = i(2), c = this.make("style", null, {
                            textContent: l.toString(),
                            id: a
                        });
                        this.prepend(document.head, c);
                    }
                    placeBottom(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.bottom + window.pageYOffset + this.offsetTop + l.marginTop;
                        this.applyPlacement("bottom", d, h);
                    }
                    placeTop(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.top + window.pageYOffset - this.nodes.wrapper.clientHeight - this.offsetTop;
                        this.applyPlacement("top", d, h);
                    }
                    placeLeft(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left - this.nodes.wrapper.offsetWidth - this.offsetLeft - l.marginLeft, h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                        this.applyPlacement("left", d, h);
                    }
                    placeRight(a, l) {
                        const c = a.getBoundingClientRect(), d = c.right + this.offsetRight + l.marginRight, h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                        this.applyPlacement("right", d, h);
                    }
                    applyPlacement(a, l, c) {
                        this.nodes.wrapper.classList.add(this.CSS.placement[a]), this.nodes.wrapper.style.left = l + "px", this.nodes.wrapper.style.top = c + "px";
                    }
                    make(a, l = null, c = {}) {
                        const d = document.createElement(a);
                        Array.isArray(l) ? d.classList.add(...l) : l && d.classList.add(l);
                        for(const h in c)c.hasOwnProperty(h) && (d[h] = c[h]);
                        return d;
                    }
                    append(a, l) {
                        Array.isArray(l) ? l.forEach((c)=>a.appendChild(c)) : a.appendChild(l);
                    }
                    prepend(a, l) {
                        Array.isArray(l) ? (l = l.reverse()).forEach((c)=>a.prepend(c)) : a.prepend(l);
                    }
                }
            },
            function(t1, o) {
                t1.exports = `.ct{z-index:999;opacity:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;-webkit-transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1),-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);will-change:opacity,top,left;-webkit-box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);border-radius:9px}.ct,.ct:before{position:absolute;top:0;left:0}.ct:before{content:"";bottom:0;right:0;background-color:#1d202b;z-index:-1;border-radius:4px}@supports(-webkit-mask-box-image:url("")){.ct:before{border-radius:0;-webkit-mask-box-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10.71 0h2.58c3.02 0 4.64.42 6.1 1.2a8.18 8.18 0 013.4 3.4C23.6 6.07 24 7.7 24 10.71v2.58c0 3.02-.42 4.64-1.2 6.1a8.18 8.18 0 01-3.4 3.4c-1.47.8-3.1 1.21-6.11 1.21H10.7c-3.02 0-4.64-.42-6.1-1.2a8.18 8.18 0 01-3.4-3.4C.4 17.93 0 16.3 0 13.29V10.7c0-3.02.42-4.64 1.2-6.1a8.18 8.18 0 013.4-3.4C6.07.4 7.7 0 10.71 0z"/></svg>') 48% 41% 37.9% 53.3%}}@media (--mobile){.ct{display:none}}.ct__content{padding:6px 10px;color:#cdd1e0;font-size:12px;text-align:center;letter-spacing:.02em;line-height:1em}.ct:after{content:"";width:8px;height:8px;position:absolute;background-color:#1d202b;z-index:-1}.ct--bottom{-webkit-transform:translateY(5px);transform:translateY(5px)}.ct--bottom:after{top:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--top{-webkit-transform:translateY(-5px);transform:translateY(-5px)}.ct--top:after{top:auto;bottom:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--left{-webkit-transform:translateX(-5px);transform:translateX(-5px)}.ct--left:after{top:50%;left:auto;right:0;-webkit-transform:translate(41.6%,-50%) rotate(-45deg);transform:translate(41.6%,-50%) rotate(-45deg)}.ct--right{-webkit-transform:translateX(5px);transform:translateX(5px)}.ct--right:after{top:50%;left:0;-webkit-transform:translate(-41.6%,-50%) rotate(-45deg);transform:translate(-41.6%,-50%) rotate(-45deg)}.ct--shown{opacity:1;-webkit-transform:none;transform:none}`;
            }
        ]).default;
    });
})($6813aa9d7dc8ab1a$var$Vo);
var $6813aa9d7dc8ab1a$var$ji = $6813aa9d7dc8ab1a$var$Vo.exports;
const $6813aa9d7dc8ab1a$var$Hi = /* @__PURE__ */ $6813aa9d7dc8ab1a$var$Ke($6813aa9d7dc8ab1a$var$ji);
let $6813aa9d7dc8ab1a$var$U = null;
function $6813aa9d7dc8ab1a$var$Et() {
    $6813aa9d7dc8ab1a$var$U || ($6813aa9d7dc8ab1a$var$U = new $6813aa9d7dc8ab1a$var$Hi());
}
function $6813aa9d7dc8ab1a$var$$i(n, e, t1) {
    $6813aa9d7dc8ab1a$var$Et(), $6813aa9d7dc8ab1a$var$U == null || $6813aa9d7dc8ab1a$var$U.show(n, e, t1);
}
function $6813aa9d7dc8ab1a$var$$e(n = !1) {
    $6813aa9d7dc8ab1a$var$Et(), $6813aa9d7dc8ab1a$var$U == null || $6813aa9d7dc8ab1a$var$U.hide(n);
}
function $6813aa9d7dc8ab1a$var$ze(n, e, t1) {
    $6813aa9d7dc8ab1a$var$Et(), $6813aa9d7dc8ab1a$var$U == null || $6813aa9d7dc8ab1a$var$U.onHover(n, e, t1);
}
function $6813aa9d7dc8ab1a$var$zi() {
    $6813aa9d7dc8ab1a$var$U == null || $6813aa9d7dc8ab1a$var$U.destroy(), $6813aa9d7dc8ab1a$var$U = null;
}
class $6813aa9d7dc8ab1a$var$Ui extends $6813aa9d7dc8ab1a$var$E {
    /**
   * @class
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        });
    }
    /**
   * Available methods
   */ get methods() {
        return {
            show: (e, t1, o)=>this.show(e, t1, o),
            hide: ()=>this.hide(),
            onHover: (e, t1, o)=>this.onHover(e, t1, o)
        };
    }
    /**
   * Method show tooltip on element with passed HTML content
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ show(e, t1, o) {
        $6813aa9d7dc8ab1a$var$$i(e, t1, o);
    }
    /**
   * Method hides tooltip on HTML page
   */ hide() {
        $6813aa9d7dc8ab1a$var$$e();
    }
    /**
   * Decorator for showing Tooltip by mouseenter/mouseleave
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ onHover(e, t1, o) {
        $6813aa9d7dc8ab1a$var$ze(e, t1, o);
    }
}
class $6813aa9d7dc8ab1a$var$Wi extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Available methods / getters
   */ get methods() {
        return {
            nodes: this.editorNodes
        };
    }
    /**
   * Exported classes
   */ get editorNodes() {
        return {
            /**
       * Top-level editor instance wrapper
       */ wrapper: this.Editor.UI.nodes.wrapper,
            /**
       * Element that holds all the Blocks
       */ redactor: this.Editor.UI.nodes.redactor
        };
    }
}
function $6813aa9d7dc8ab1a$var$qo(n, e) {
    const t1 = {};
    return Object.entries(n).forEach(([o, i])=>{
        if ($6813aa9d7dc8ab1a$var$D(i)) {
            const s = e ? `${e}.${o}` : o;
            Object.values(i).every((a)=>$6813aa9d7dc8ab1a$var$te(a)) ? t1[o] = s : t1[o] = $6813aa9d7dc8ab1a$var$qo(i, s);
            return;
        }
        t1[o] = i;
    }), t1;
}
const $6813aa9d7dc8ab1a$var$K = $6813aa9d7dc8ab1a$var$qo($6813aa9d7dc8ab1a$var$Fo);
function $6813aa9d7dc8ab1a$var$Yi(n, e) {
    const t1 = {};
    return Object.keys(n).forEach((o)=>{
        const i = e[o];
        i !== void 0 ? t1[i] = n[o] : t1[o] = n[o];
    }), t1;
}
const $6813aa9d7dc8ab1a$var$Zo = class Ee {
    /**
   * @param {HTMLElement[]} nodeList — the list of iterable HTML-items
   * @param {string} focusedCssClass - user-provided CSS-class that will be set in flipping process
   */ constructor(e, t1){
        this.cursor = -1, this.items = [], this.items = e || [], this.focusedCssClass = t1;
    }
    /**
   * Returns Focused button Node
   *
   * @returns {HTMLElement}
   */ get currentItem() {
        return this.cursor === -1 ? null : this.items[this.cursor];
    }
    /**
   * Sets cursor to specified position
   *
   * @param cursorPosition - new cursor position
   */ setCursor(e) {
        e < this.items.length && e >= -1 && (this.dropCursor(), this.cursor = e, this.items[this.cursor].classList.add(this.focusedCssClass));
    }
    /**
   * Sets items. Can be used when iterable items changed dynamically
   *
   * @param {HTMLElement[]} nodeList - nodes to iterate
   */ setItems(e) {
        this.items = e;
    }
    /**
   * Sets cursor next to the current
   */ next() {
        this.cursor = this.leafNodesAndReturnIndex(Ee.directions.RIGHT);
    }
    /**
   * Sets cursor before current
   */ previous() {
        this.cursor = this.leafNodesAndReturnIndex(Ee.directions.LEFT);
    }
    /**
   * Sets cursor to the default position and removes CSS-class from previously focused item
   */ dropCursor() {
        this.cursor !== -1 && (this.items[this.cursor].classList.remove(this.focusedCssClass), this.cursor = -1);
    }
    /**
   * Leafs nodes inside the target list from active element
   *
   * @param {string} direction - leaf direction. Can be 'left' or 'right'
   * @returns {number} index of focused node
   */ leafNodesAndReturnIndex(e) {
        if (this.items.length === 0) return this.cursor;
        let t1 = this.cursor;
        return t1 === -1 ? t1 = e === Ee.directions.RIGHT ? -1 : 0 : this.items[t1].classList.remove(this.focusedCssClass), e === Ee.directions.RIGHT ? t1 = (t1 + 1) % this.items.length : t1 = (this.items.length + t1 - 1) % this.items.length, $6813aa9d7dc8ab1a$var$u.canSetCaret(this.items[t1]) && $6813aa9d7dc8ab1a$var$Fe(()=>$6813aa9d7dc8ab1a$var$b.setCursor(this.items[t1]), 50)(), this.items[t1].classList.add(this.focusedCssClass), t1;
    }
};
$6813aa9d7dc8ab1a$var$Zo.directions = {
    RIGHT: "right",
    LEFT: "left"
};
let $6813aa9d7dc8ab1a$var$ke = $6813aa9d7dc8ab1a$var$Zo;
class $6813aa9d7dc8ab1a$var$ce {
    /**
   * @param options - different constructing settings
   */ constructor(e){
        this.iterator = null, this.activated = !1, this.flipCallbacks = [], this.onKeyDown = (t1)=>{
            if (!(!this.isEventReadyForHandling(t1) || t1.shiftKey === !0)) switch($6813aa9d7dc8ab1a$var$ce.usedKeys.includes(t1.keyCode) && t1.preventDefault(), t1.keyCode){
                case $6813aa9d7dc8ab1a$var$y.TAB:
                    this.handleTabPress(t1);
                    break;
                case $6813aa9d7dc8ab1a$var$y.LEFT:
                case $6813aa9d7dc8ab1a$var$y.UP:
                    this.flipLeft();
                    break;
                case $6813aa9d7dc8ab1a$var$y.RIGHT:
                case $6813aa9d7dc8ab1a$var$y.DOWN:
                    this.flipRight();
                    break;
                case $6813aa9d7dc8ab1a$var$y.ENTER:
                    this.handleEnterPress(t1);
                    break;
            }
        }, this.iterator = new $6813aa9d7dc8ab1a$var$ke(e.items, e.focusedItemClass), this.activateCallback = e.activateCallback, this.allowedKeys = e.allowedKeys || $6813aa9d7dc8ab1a$var$ce.usedKeys;
    }
    /**
   * True if flipper is currently activated
   */ get isActivated() {
        return this.activated;
    }
    /**
   * Array of keys (codes) that is handled by Flipper
   * Used to:
   *  - preventDefault only for this keys, not all keydowns (@see constructor)
   *  - to skip external behaviours only for these keys, when filler is activated (@see BlockEvents@arrowRightAndDown)
   */ static get usedKeys() {
        return [
            $6813aa9d7dc8ab1a$var$y.TAB,
            $6813aa9d7dc8ab1a$var$y.LEFT,
            $6813aa9d7dc8ab1a$var$y.RIGHT,
            $6813aa9d7dc8ab1a$var$y.ENTER,
            $6813aa9d7dc8ab1a$var$y.UP,
            $6813aa9d7dc8ab1a$var$y.DOWN
        ];
    }
    /**
   * Active tab/arrows handling by flipper
   *
   * @param items - Some modules (like, InlineToolbar, BlockSettings) might refresh buttons dynamically
   * @param cursorPosition - index of the item that should be focused once flipper is activated
   */ activate(e, t1) {
        this.activated = !0, e && this.iterator.setItems(e), t1 !== void 0 && this.iterator.setCursor(t1), document.addEventListener("keydown", this.onKeyDown, !0);
    }
    /**
   * Disable tab/arrows handling by flipper
   */ deactivate() {
        this.activated = !1, this.dropCursor(), document.removeEventListener("keydown", this.onKeyDown);
    }
    /**
   * Focus first item
   */ focusFirst() {
        this.dropCursor(), this.flipRight();
    }
    /**
   * Focuses previous flipper iterator item
   */ flipLeft() {
        this.iterator.previous(), this.flipCallback();
    }
    /**
   * Focuses next flipper iterator item
   */ flipRight() {
        this.iterator.next(), this.flipCallback();
    }
    /**
   * Return true if some button is focused
   */ hasFocus() {
        return !!this.iterator.currentItem;
    }
    /**
   * Registeres function that should be executed on each navigation action
   *
   * @param cb - function to execute
   */ onFlip(e) {
        this.flipCallbacks.push(e);
    }
    /**
   * Unregisteres function that is executed on each navigation action
   *
   * @param cb - function to stop executing
   */ removeOnFlip(e) {
        this.flipCallbacks = this.flipCallbacks.filter((t1)=>t1 !== e);
    }
    /**
   * Drops flipper's iterator cursor
   *
   * @see DomIterator#dropCursor
   */ dropCursor() {
        this.iterator.dropCursor();
    }
    /**
   * This function is fired before handling flipper keycodes
   * The result of this function defines if it is need to be handled or not
   *
   * @param {KeyboardEvent} event - keydown keyboard event
   * @returns {boolean}
   */ isEventReadyForHandling(e) {
        return this.activated && this.allowedKeys.includes(e.keyCode);
    }
    /**
   * When flipper is activated tab press will leaf the items
   *
   * @param {KeyboardEvent} event - tab keydown event
   */ handleTabPress(e) {
        switch(e.shiftKey ? $6813aa9d7dc8ab1a$var$ke.directions.LEFT : $6813aa9d7dc8ab1a$var$ke.directions.RIGHT){
            case $6813aa9d7dc8ab1a$var$ke.directions.RIGHT:
                this.flipRight();
                break;
            case $6813aa9d7dc8ab1a$var$ke.directions.LEFT:
                this.flipLeft();
                break;
        }
    }
    /**
   * Enter press will click current item if flipper is activated
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ handleEnterPress(e) {
        this.activated && (this.iterator.currentItem && (e.stopPropagation(), e.preventDefault(), this.iterator.currentItem.click()), $6813aa9d7dc8ab1a$var$A(this.activateCallback) && this.activateCallback(this.iterator.currentItem));
    }
    /**
   * Fired after flipping in any direction
   */ flipCallback() {
        this.iterator.currentItem && this.iterator.currentItem.scrollIntoViewIfNeeded(), this.flipCallbacks.forEach((e)=>e());
    }
}
const $6813aa9d7dc8ab1a$var$Ki = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 12L9 7.1C9 7.04477 9.04477 7 9.1 7H10.4C11.5 7 14 7.1 14 9.5C14 9.5 14 12 11 12M9 12V16.8C9 16.9105 9.08954 17 9.2 17H12.5C14 17 15 16 15 14.5C15 11.7046 11 12 11 12M9 12H11"/></svg>', $6813aa9d7dc8ab1a$var$Xi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 10L11.8586 14.8586C11.9367 14.9367 12.0633 14.9367 12.1414 14.8586L17 10"/></svg>', $6813aa9d7dc8ab1a$var$Vi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.5 17.5L9.64142 12.6414C9.56331 12.5633 9.56331 12.4367 9.64142 12.3586L14.5 7.5"/></svg>', $6813aa9d7dc8ab1a$var$qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9.58284 17.5L14.4414 12.6414C14.5195 12.5633 14.5195 12.4367 14.4414 12.3586L9.58284 7.5"/></svg>', $6813aa9d7dc8ab1a$var$Zi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 15L11.8586 10.1414C11.9367 10.0633 12.0633 10.0633 12.1414 10.1414L17 15"/></svg>', $6813aa9d7dc8ab1a$var$Gi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 8L12 12M12 12L16 16M12 12L16 8M12 12L8 16"/></svg>', $6813aa9d7dc8ab1a$var$Qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="2"/></svg>', $6813aa9d7dc8ab1a$var$Ji = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M13.34 10C12.4223 12.7337 11 17 11 17"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.21 7H14.2"/></svg>', $6813aa9d7dc8ab1a$var$Co = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.69998 12.6L7.67896 12.62C6.53993 13.7048 6.52012 15.5155 7.63516 16.625V16.625C8.72293 17.7073 10.4799 17.7102 11.5712 16.6314L13.0263 15.193C14.0703 14.1609 14.2141 12.525 13.3662 11.3266L13.22 11.12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16.22 11.12L16.3564 10.9805C17.2895 10.0265 17.3478 8.5207 16.4914 7.49733V7.49733C15.5691 6.39509 13.9269 6.25143 12.8271 7.17675L11.3901 8.38588C10.0935 9.47674 9.95706 11.4241 11.0888 12.6852L11.12 12.72"/></svg>', $6813aa9d7dc8ab1a$var$es = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 7.29999H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 7.29999H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.30999 12H9.3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 12H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 16.7H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 16.7H14.59"/></svg>', $6813aa9d7dc8ab1a$var$ts = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 7V12M12 17V12M17 12H12M12 12H7"/></svg>', $6813aa9d7dc8ab1a$var$Go = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M11.5 17.5L5 11M5 11V15.5M5 11H9.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12.5 6.5L19 13M19 13V8.5M19 13H14.5"/></svg>', $6813aa9d7dc8ab1a$var$os = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="5.5" stroke="currentColor" stroke-width="2"/><line x1="15.4142" x2="19" y1="15" y2="18.5858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $6813aa9d7dc8ab1a$var$ns = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M15.7795 11.5C15.7795 11.5 16.053 11.1962 16.5497 10.6722C17.4442 9.72856 17.4701 8.2475 16.5781 7.30145V7.30145C15.6482 6.31522 14.0873 6.29227 13.1288 7.25073L11.8796 8.49999"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.24517 12.3883C8.24517 12.3883 7.97171 12.6922 7.47504 13.2161C6.58051 14.1598 6.55467 15.6408 7.44666 16.5869V16.5869C8.37653 17.5731 9.93744 17.5961 10.8959 16.6376L12.1452 15.3883"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17.7802 15.1032L16.597 14.9422C16.0109 14.8624 15.4841 15.3059 15.4627 15.8969L15.4199 17.0818"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6.39064 9.03238L7.58432 9.06668C8.17551 9.08366 8.6522 8.58665 8.61056 7.99669L8.5271 6.81397"/><line x1="12.1142" x2="11.7" y1="12.2" y2="11.7858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $6813aa9d7dc8ab1a$var$is = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/><line x1="12" x2="12" y1="9" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 15.02V15.01"/></svg>', $6813aa9d7dc8ab1a$var$ss = "__", $6813aa9d7dc8ab1a$var$rs = "--";
function $6813aa9d7dc8ab1a$var$ne(n) {
    return (e, t1)=>[
            [
                n,
                e
            ].filter((i)=>!!i).join($6813aa9d7dc8ab1a$var$ss),
            t1
        ].filter((i)=>!!i).join($6813aa9d7dc8ab1a$var$rs);
}
const $6813aa9d7dc8ab1a$var$ye = $6813aa9d7dc8ab1a$var$ne("ce-hint"), $6813aa9d7dc8ab1a$var$we = {
    root: $6813aa9d7dc8ab1a$var$ye(),
    alignedStart: $6813aa9d7dc8ab1a$var$ye(null, "align-left"),
    alignedCenter: $6813aa9d7dc8ab1a$var$ye(null, "align-center"),
    title: $6813aa9d7dc8ab1a$var$ye("title"),
    description: $6813aa9d7dc8ab1a$var$ye("description")
};
class $6813aa9d7dc8ab1a$var$as {
    /**
   * Constructs the hint content instance
   *
   * @param params - hint content parameters
   */ constructor(e){
        this.nodes = {
            root: $6813aa9d7dc8ab1a$var$u.make("div", [
                $6813aa9d7dc8ab1a$var$we.root,
                e.alignment === "center" ? $6813aa9d7dc8ab1a$var$we.alignedCenter : $6813aa9d7dc8ab1a$var$we.alignedStart
            ]),
            title: $6813aa9d7dc8ab1a$var$u.make("div", $6813aa9d7dc8ab1a$var$we.title, {
                textContent: e.title
            })
        }, this.nodes.root.appendChild(this.nodes.title), e.description !== void 0 && (this.nodes.description = $6813aa9d7dc8ab1a$var$u.make("div", $6813aa9d7dc8ab1a$var$we.description, {
            textContent: e.description
        }), this.nodes.root.appendChild(this.nodes.description));
    }
    /**
   * Returns the root element of the hint content
   */ getElement() {
        return this.nodes.root;
    }
}
class $6813aa9d7dc8ab1a$var$xt {
    /**
   * Constructs the instance
   *
   * @param params - instance parameters
   */ constructor(e){
        this.params = e;
    }
    /**
   * Item name if exists
   */ get name() {
        if (this.params !== void 0 && "name" in this.params) return this.params.name;
    }
    /**
   * Destroys the instance
   */ destroy() {
        $6813aa9d7dc8ab1a$var$$e();
    }
    /**
   * Called when children popover is opened (if exists)
   */ onChildrenOpen() {
        var e;
        this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onOpen) == "function" && this.params.children.onOpen();
    }
    /**
   * Called when children popover is closed (if exists)
   */ onChildrenClose() {
        var e;
        this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onClose) == "function" && this.params.children.onClose();
    }
    /**
   * Called on popover item click
   */ handleClick() {
        var e, t1;
        this.params !== void 0 && "onActivate" in this.params && ((t1 = (e = this.params).onActivate) == null || t1.call(e, this.params));
    }
    /**
   * Adds hint to the item element if hint data is provided
   *
   * @param itemElement - popover item root element to add hint to
   * @param hintData - hint data
   */ addHint(e, t1) {
        const o = new $6813aa9d7dc8ab1a$var$as(t1);
        $6813aa9d7dc8ab1a$var$ze(e, o.getElement(), {
            placement: t1.position,
            hidingDelay: 100
        });
    }
    /**
   * Returns item children that are represented as popover items
   */ get children() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.items) !== void 0 ? this.params.children.items : [];
    }
    /**
   * Returns true if item has any type of children
   */ get hasChildren() {
        return this.children.length > 0;
    }
    /**
   * Returns true if item children should be open instantly after popover is opened and not on item click/hover
   */ get isChildrenOpen() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.isOpen) === !0;
    }
    /**
   * True if item children items should be navigatable via keyboard
   */ get isChildrenFlippable() {
        var e;
        return !(this.params === void 0 || !("children" in this.params) || ((e = this.params.children) == null ? void 0 : e.isFlippable) === !1);
    }
    /**
   * Returns true if item has children that should be searchable
   */ get isChildrenSearchable() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.searchable) === !0;
    }
    /**
   * True if popover should close once item is activated
   */ get closeOnActivate() {
        return this.params !== void 0 && "closeOnActivate" in this.params && this.params.closeOnActivate;
    }
    /**
   * True if item is active
   */ get isActive() {
        return this.params === void 0 || !("isActive" in this.params) ? !1 : typeof this.params.isActive == "function" ? this.params.isActive() : this.params.isActive === !0;
    }
}
const $6813aa9d7dc8ab1a$var$Y = $6813aa9d7dc8ab1a$var$ne("ce-popover-item"), $6813aa9d7dc8ab1a$var$L = {
    container: $6813aa9d7dc8ab1a$var$Y(),
    active: $6813aa9d7dc8ab1a$var$Y(null, "active"),
    disabled: $6813aa9d7dc8ab1a$var$Y(null, "disabled"),
    focused: $6813aa9d7dc8ab1a$var$Y(null, "focused"),
    hidden: $6813aa9d7dc8ab1a$var$Y(null, "hidden"),
    confirmationState: $6813aa9d7dc8ab1a$var$Y(null, "confirmation"),
    noHover: $6813aa9d7dc8ab1a$var$Y(null, "no-hover"),
    noFocus: $6813aa9d7dc8ab1a$var$Y(null, "no-focus"),
    title: $6813aa9d7dc8ab1a$var$Y("title"),
    secondaryTitle: $6813aa9d7dc8ab1a$var$Y("secondary-title"),
    icon: $6813aa9d7dc8ab1a$var$Y("icon"),
    iconTool: $6813aa9d7dc8ab1a$var$Y("icon", "tool"),
    iconChevronRight: $6813aa9d7dc8ab1a$var$Y("icon", "chevron-right"),
    wobbleAnimation: $6813aa9d7dc8ab1a$var$ne("wobble")()
};
class $6813aa9d7dc8ab1a$var$re extends $6813aa9d7dc8ab1a$var$xt {
    /**
   * Constructs popover item instance
   *
   * @param params - popover item construction params
   * @param renderParams - popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        super(e), this.params = e, this.nodes = {
            root: null,
            icon: null
        }, this.confirmationState = null, this.removeSpecialFocusBehavior = ()=>{
            var o;
            (o = this.nodes.root) == null || o.classList.remove($6813aa9d7dc8ab1a$var$L.noFocus);
        }, this.removeSpecialHoverBehavior = ()=>{
            var o;
            (o = this.nodes.root) == null || o.classList.remove($6813aa9d7dc8ab1a$var$L.noHover);
        }, this.onErrorAnimationEnd = ()=>{
            var o, i;
            (o = this.nodes.icon) == null || o.classList.remove($6813aa9d7dc8ab1a$var$L.wobbleAnimation), (i = this.nodes.icon) == null || i.removeEventListener("animationend", this.onErrorAnimationEnd);
        }, this.nodes.root = this.make(e, t1);
    }
    /**
   * True if item is disabled and hence not clickable
   */ get isDisabled() {
        return this.params.isDisabled === !0;
    }
    /**
   * Exposes popover item toggle parameter
   */ get toggle() {
        return this.params.toggle;
    }
    /**
   * Item title
   */ get title() {
        return this.params.title;
    }
    /**
   * True if confirmation state is enabled for popover item
   */ get isConfirmationStateEnabled() {
        return this.confirmationState !== null;
    }
    /**
   * True if item is focused in keyboard navigation process
   */ get isFocused() {
        return this.nodes.root === null ? !1 : this.nodes.root.classList.contains($6813aa9d7dc8ab1a$var$L.focused);
    }
    /**
   * Returns popover item root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Called on popover item click
   */ handleClick() {
        if (this.isConfirmationStateEnabled && this.confirmationState !== null) {
            this.activateOrEnableConfirmationMode(this.confirmationState);
            return;
        }
        this.activateOrEnableConfirmationMode(this.params);
    }
    /**
   * Toggles item active state
   *
   * @param isActive - true if item should strictly should become active
   */ toggleActive(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($6813aa9d7dc8ab1a$var$L.active, e);
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($6813aa9d7dc8ab1a$var$L.hidden, e);
    }
    /**
   * Resets popover item to its original state
   */ reset() {
        this.isConfirmationStateEnabled && this.disableConfirmationMode();
    }
    /**
   * Method called once item becomes focused during keyboard navigation
   */ onFocus() {
        this.disableSpecialHoverAndFocusBehavior();
    }
    /**
   * Constructs HTML element corresponding to popover item params
   *
   * @param params - item construction params
   * @param renderParams - popover item render params
   */ make(e, t1) {
        var s, r;
        const o = (t1 == null ? void 0 : t1.wrapperTag) || "div", i = $6813aa9d7dc8ab1a$var$u.make(o, $6813aa9d7dc8ab1a$var$L.container, {
            type: o === "button" ? "button" : void 0
        });
        return e.name && (i.dataset.itemName = e.name), this.nodes.icon = $6813aa9d7dc8ab1a$var$u.make("div", [
            $6813aa9d7dc8ab1a$var$L.icon,
            $6813aa9d7dc8ab1a$var$L.iconTool
        ], {
            innerHTML: e.icon || $6813aa9d7dc8ab1a$var$Qi
        }), i.appendChild(this.nodes.icon), e.title !== void 0 && i.appendChild($6813aa9d7dc8ab1a$var$u.make("div", $6813aa9d7dc8ab1a$var$L.title, {
            innerHTML: e.title || ""
        })), e.secondaryLabel && i.appendChild($6813aa9d7dc8ab1a$var$u.make("div", $6813aa9d7dc8ab1a$var$L.secondaryTitle, {
            textContent: e.secondaryLabel
        })), this.hasChildren && i.appendChild($6813aa9d7dc8ab1a$var$u.make("div", [
            $6813aa9d7dc8ab1a$var$L.icon,
            $6813aa9d7dc8ab1a$var$L.iconChevronRight
        ], {
            innerHTML: $6813aa9d7dc8ab1a$var$qi
        })), this.isActive && i.classList.add($6813aa9d7dc8ab1a$var$L.active), e.isDisabled && i.classList.add($6813aa9d7dc8ab1a$var$L.disabled), e.hint !== void 0 && ((s = t1 == null ? void 0 : t1.hint) == null ? void 0 : s.enabled) !== !1 && this.addHint(i, {
            ...e.hint,
            position: ((r = t1 == null ? void 0 : t1.hint) == null ? void 0 : r.position) || "right"
        }), i;
    }
    /**
   * Activates confirmation mode for the item.
   *
   * @param newState - new popover item params that should be applied
   */ enableConfirmationMode(e) {
        if (this.nodes.root === null) return;
        const t1 = {
            ...this.params,
            ...e,
            confirmation: "confirmation" in e ? e.confirmation : void 0
        }, o = this.make(t1);
        this.nodes.root.innerHTML = o.innerHTML, this.nodes.root.classList.add($6813aa9d7dc8ab1a$var$L.confirmationState), this.confirmationState = e, this.enableSpecialHoverAndFocusBehavior();
    }
    /**
   * Returns item to its original state
   */ disableConfirmationMode() {
        if (this.nodes.root === null) return;
        const e = this.make(this.params);
        this.nodes.root.innerHTML = e.innerHTML, this.nodes.root.classList.remove($6813aa9d7dc8ab1a$var$L.confirmationState), this.confirmationState = null, this.disableSpecialHoverAndFocusBehavior();
    }
    /**
   * Enables special focus and hover behavior for item in confirmation state.
   * This is needed to prevent item from being highlighted as hovered/focused just after click.
   */ enableSpecialHoverAndFocusBehavior() {
        var e, t1, o;
        (e = this.nodes.root) == null || e.classList.add($6813aa9d7dc8ab1a$var$L.noHover), (t1 = this.nodes.root) == null || t1.classList.add($6813aa9d7dc8ab1a$var$L.noFocus), (o = this.nodes.root) == null || o.addEventListener("mouseleave", this.removeSpecialHoverBehavior, {
            once: !0
        });
    }
    /**
   * Disables special focus and hover behavior
   */ disableSpecialHoverAndFocusBehavior() {
        var e;
        this.removeSpecialFocusBehavior(), this.removeSpecialHoverBehavior(), (e = this.nodes.root) == null || e.removeEventListener("mouseleave", this.removeSpecialHoverBehavior);
    }
    /**
   * Executes item's onActivate callback if the item has no confirmation configured
   *
   * @param item - item to activate or bring to confirmation mode
   */ activateOrEnableConfirmationMode(e) {
        var t1;
        if (!("confirmation" in e) || e.confirmation === void 0) try {
            (t1 = e.onActivate) == null || t1.call(e, e), this.disableConfirmationMode();
        } catch  {
            this.animateError();
        }
        else this.enableConfirmationMode(e.confirmation);
    }
    /**
   * Animates item which symbolizes that error occured while executing 'onActivate()' callback
   */ animateError() {
        var e, t1, o;
        (e = this.nodes.icon) != null && e.classList.contains($6813aa9d7dc8ab1a$var$L.wobbleAnimation) || ((t1 = this.nodes.icon) == null || t1.classList.add($6813aa9d7dc8ab1a$var$L.wobbleAnimation), (o = this.nodes.icon) == null || o.addEventListener("animationend", this.onErrorAnimationEnd));
    }
}
const $6813aa9d7dc8ab1a$var$nt = $6813aa9d7dc8ab1a$var$ne("ce-popover-item-separator"), $6813aa9d7dc8ab1a$var$it = {
    container: $6813aa9d7dc8ab1a$var$nt(),
    line: $6813aa9d7dc8ab1a$var$nt("line"),
    hidden: $6813aa9d7dc8ab1a$var$nt(null, "hidden")
};
class $6813aa9d7dc8ab1a$var$Qo extends $6813aa9d7dc8ab1a$var$xt {
    /**
   * Constructs the instance
   */ constructor(){
        super(), this.nodes = {
            root: $6813aa9d7dc8ab1a$var$u.make("div", $6813aa9d7dc8ab1a$var$it.container),
            line: $6813aa9d7dc8ab1a$var$u.make("div", $6813aa9d7dc8ab1a$var$it.line)
        }, this.nodes.root.appendChild(this.nodes.line);
    }
    /**
   * Returns popover separator root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($6813aa9d7dc8ab1a$var$it.hidden, e);
    }
}
var $6813aa9d7dc8ab1a$var$G = /* @__PURE__ */ ((n)=>(n.Closed = "closed", n.ClosedOnActivate = "closed-on-activate", n))($6813aa9d7dc8ab1a$var$G || {});
const $6813aa9d7dc8ab1a$var$$ = $6813aa9d7dc8ab1a$var$ne("ce-popover"), $6813aa9d7dc8ab1a$var$P = {
    popover: $6813aa9d7dc8ab1a$var$$(),
    popoverContainer: $6813aa9d7dc8ab1a$var$$("container"),
    popoverOpenTop: $6813aa9d7dc8ab1a$var$$(null, "open-top"),
    popoverOpenLeft: $6813aa9d7dc8ab1a$var$$(null, "open-left"),
    popoverOpened: $6813aa9d7dc8ab1a$var$$(null, "opened"),
    search: $6813aa9d7dc8ab1a$var$$("search"),
    nothingFoundMessage: $6813aa9d7dc8ab1a$var$$("nothing-found-message"),
    nothingFoundMessageDisplayed: $6813aa9d7dc8ab1a$var$$("nothing-found-message", "displayed"),
    items: $6813aa9d7dc8ab1a$var$$("items"),
    overlay: $6813aa9d7dc8ab1a$var$$("overlay"),
    overlayHidden: $6813aa9d7dc8ab1a$var$$("overlay", "hidden"),
    popoverNested: $6813aa9d7dc8ab1a$var$$(null, "nested"),
    getPopoverNestedClass: (n)=>$6813aa9d7dc8ab1a$var$$(null, `nested-level-${n.toString()}`),
    popoverInline: $6813aa9d7dc8ab1a$var$$(null, "inline"),
    popoverHeader: $6813aa9d7dc8ab1a$var$$("header")
};
var $6813aa9d7dc8ab1a$var$fe = /* @__PURE__ */ ((n)=>(n.NestingLevel = "--nesting-level", n.PopoverHeight = "--popover-height", n.InlinePopoverWidth = "--inline-popover-width", n.TriggerItemLeft = "--trigger-item-left", n.TriggerItemTop = "--trigger-item-top", n))($6813aa9d7dc8ab1a$var$fe || {});
const $6813aa9d7dc8ab1a$var$To = $6813aa9d7dc8ab1a$var$ne("ce-popover-item-html"), $6813aa9d7dc8ab1a$var$So = {
    root: $6813aa9d7dc8ab1a$var$To(),
    hidden: $6813aa9d7dc8ab1a$var$To(null, "hidden")
};
class $6813aa9d7dc8ab1a$var$Se extends $6813aa9d7dc8ab1a$var$xt {
    /**
   * Constructs the instance
   *
   * @param params – instance parameters
   * @param renderParams – popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        var o, i;
        super(e), this.nodes = {
            root: $6813aa9d7dc8ab1a$var$u.make("div", $6813aa9d7dc8ab1a$var$So.root)
        }, this.nodes.root.appendChild(e.element), e.name && (this.nodes.root.dataset.itemName = e.name), e.hint !== void 0 && ((o = t1 == null ? void 0 : t1.hint) == null ? void 0 : o.enabled) !== !1 && this.addHint(this.nodes.root, {
            ...e.hint,
            position: ((i = t1 == null ? void 0 : t1.hint) == null ? void 0 : i.position) || "right"
        });
    }
    /**
   * Returns popover item root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($6813aa9d7dc8ab1a$var$So.hidden, e);
    }
    /**
   * Returns list of buttons and inputs inside custom content
   */ getControls() {
        const e = this.nodes.root.querySelectorAll(`button, ${$6813aa9d7dc8ab1a$var$u.allInputsSelector}`);
        return Array.from(e);
    }
}
class $6813aa9d7dc8ab1a$var$Jo extends $6813aa9d7dc8ab1a$var$Oe {
    /**
   * Constructs the instance
   *
   * @param params - popover construction params
   * @param itemsRenderParams - popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1 = {}){
        super(), this.params = e, this.itemsRenderParams = t1, this.listeners = new $6813aa9d7dc8ab1a$var$_e(), this.messages = {
            nothingFound: "Nothing found",
            search: "Search"
        }, this.items = this.buildItems(e.items), e.messages && (this.messages = {
            ...this.messages,
            ...e.messages
        }), this.nodes = {}, this.nodes.popoverContainer = $6813aa9d7dc8ab1a$var$u.make("div", [
            $6813aa9d7dc8ab1a$var$P.popoverContainer
        ]), this.nodes.nothingFoundMessage = $6813aa9d7dc8ab1a$var$u.make("div", [
            $6813aa9d7dc8ab1a$var$P.nothingFoundMessage
        ], {
            textContent: this.messages.nothingFound
        }), this.nodes.popoverContainer.appendChild(this.nodes.nothingFoundMessage), this.nodes.items = $6813aa9d7dc8ab1a$var$u.make("div", [
            $6813aa9d7dc8ab1a$var$P.items
        ]), this.items.forEach((o)=>{
            const i = o.getElement();
            i !== null && this.nodes.items.appendChild(i);
        }), this.nodes.popoverContainer.appendChild(this.nodes.items), this.listeners.on(this.nodes.popoverContainer, "click", (o)=>this.handleClick(o)), this.nodes.popover = $6813aa9d7dc8ab1a$var$u.make("div", [
            $6813aa9d7dc8ab1a$var$P.popover,
            this.params.class
        ]), this.nodes.popover.appendChild(this.nodes.popoverContainer);
    }
    /**
   * List of default popover items that are searchable and may have confirmation state
   */ get itemsDefault() {
        return this.items.filter((e)=>e instanceof $6813aa9d7dc8ab1a$var$re);
    }
    /**
   * Returns HTML element corresponding to the popover
   */ getElement() {
        return this.nodes.popover;
    }
    /**
   * Open popover
   */ show() {
        this.nodes.popover.classList.add($6813aa9d7dc8ab1a$var$P.popoverOpened), this.search !== void 0 && this.search.focus();
    }
    /**
   * Closes popover
   */ hide() {
        this.nodes.popover.classList.remove($6813aa9d7dc8ab1a$var$P.popoverOpened), this.nodes.popover.classList.remove($6813aa9d7dc8ab1a$var$P.popoverOpenTop), this.itemsDefault.forEach((e)=>e.reset()), this.search !== void 0 && this.search.clear(), this.emit($6813aa9d7dc8ab1a$var$G.Closed);
    }
    /**
   * Clears memory
   */ destroy() {
        var e;
        this.items.forEach((t1)=>t1.destroy()), this.nodes.popover.remove(), this.listeners.removeAll(), (e = this.search) == null || e.destroy();
    }
    /**
   * Looks for the item by name and imitates click on it
   *
   * @param name - name of the item to activate
   */ activateItemByName(e) {
        const t1 = this.items.find((o)=>o.name === e);
        this.handleItemClick(t1);
    }
    /**
   * Factory method for creating popover items
   *
   * @param items - list of items params
   */ buildItems(e) {
        return e.map((t1)=>{
            switch(t1.type){
                case $6813aa9d7dc8ab1a$var$_.Separator:
                    return new $6813aa9d7dc8ab1a$var$Qo();
                case $6813aa9d7dc8ab1a$var$_.Html:
                    return new $6813aa9d7dc8ab1a$var$Se(t1, this.itemsRenderParams[$6813aa9d7dc8ab1a$var$_.Html]);
                default:
                    return new $6813aa9d7dc8ab1a$var$re(t1, this.itemsRenderParams[$6813aa9d7dc8ab1a$var$_.Default]);
            }
        });
    }
    /**
   * Retrieves popover item that is the target of the specified event
   *
   * @param event - event to retrieve popover item from
   */ getTargetItem(e) {
        return this.items.filter((t1)=>t1 instanceof $6813aa9d7dc8ab1a$var$re || t1 instanceof $6813aa9d7dc8ab1a$var$Se).find((t1)=>{
            const o = t1.getElement();
            return o === null ? !1 : e.composedPath().includes(o);
        });
    }
    /**
   * Handles popover item click
   *
   * @param item - item to handle click of
   */ handleItemClick(e) {
        if (!("isDisabled" in e && e.isDisabled)) {
            if (e.hasChildren) {
                this.showNestedItems(e), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick();
                return;
            }
            this.itemsDefault.filter((t1)=>t1 !== e).forEach((t1)=>t1.reset()), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick(), this.toggleItemActivenessIfNeeded(e), e.closeOnActivate && (this.hide(), this.emit($6813aa9d7dc8ab1a$var$G.ClosedOnActivate));
        }
    }
    /**
   * Handles clicks inside popover
   *
   * @param event - item to handle click of
   */ handleClick(e) {
        const t1 = this.getTargetItem(e);
        t1 !== void 0 && this.handleItemClick(t1);
    }
    /**
   * - Toggles item active state, if clicked popover item has property 'toggle' set to true.
   *
   * - Performs radiobutton-like behavior if the item has property 'toggle' set to string key.
   * (All the other items with the same key get inactive, and the item gets active)
   *
   * @param clickedItem - popover item that was clicked
   */ toggleItemActivenessIfNeeded(e) {
        if (e instanceof $6813aa9d7dc8ab1a$var$re && (e.toggle === !0 && e.toggleActive(), typeof e.toggle == "string")) {
            const t1 = this.itemsDefault.filter((o)=>o.toggle === e.toggle);
            if (t1.length === 1) {
                e.toggleActive();
                return;
            }
            t1.forEach((o)=>{
                o.toggleActive(o === e);
            });
        }
    }
}
var $6813aa9d7dc8ab1a$var$Ue = /* @__PURE__ */ ((n)=>(n.Search = "search", n))($6813aa9d7dc8ab1a$var$Ue || {});
const $6813aa9d7dc8ab1a$var$st = $6813aa9d7dc8ab1a$var$ne("cdx-search-field"), $6813aa9d7dc8ab1a$var$rt = {
    wrapper: $6813aa9d7dc8ab1a$var$st(),
    icon: $6813aa9d7dc8ab1a$var$st("icon"),
    input: $6813aa9d7dc8ab1a$var$st("input")
};
class $6813aa9d7dc8ab1a$var$ls extends $6813aa9d7dc8ab1a$var$Oe {
    /**
   * @param options - available config
   * @param options.items - searchable items list
   * @param options.placeholder - input placeholder
   */ constructor({ items: e, placeholder: t1 }){
        super(), this.listeners = new $6813aa9d7dc8ab1a$var$_e(), this.items = e, this.wrapper = $6813aa9d7dc8ab1a$var$u.make("div", $6813aa9d7dc8ab1a$var$rt.wrapper);
        const o = $6813aa9d7dc8ab1a$var$u.make("div", $6813aa9d7dc8ab1a$var$rt.icon, {
            innerHTML: $6813aa9d7dc8ab1a$var$os
        });
        this.input = $6813aa9d7dc8ab1a$var$u.make("input", $6813aa9d7dc8ab1a$var$rt.input, {
            placeholder: t1,
            /**
       * Used to prevent focusing on the input by Tab key
       * (Popover in the Toolbar lays below the blocks,
       * so Tab in the last block will focus this hidden input if this property is not set)
       */ tabIndex: -1
        }), this.wrapper.appendChild(o), this.wrapper.appendChild(this.input), this.listeners.on(this.input, "input", ()=>{
            this.searchQuery = this.input.value, this.emit($6813aa9d7dc8ab1a$var$Ue.Search, {
                query: this.searchQuery,
                items: this.foundItems
            });
        });
    }
    /**
   * Returns search field element
   */ getElement() {
        return this.wrapper;
    }
    /**
   * Sets focus to the input
   */ focus() {
        this.input.focus();
    }
    /**
   * Clears search query and results
   */ clear() {
        this.input.value = "", this.searchQuery = "", this.emit($6813aa9d7dc8ab1a$var$Ue.Search, {
            query: "",
            items: this.foundItems
        });
    }
    /**
   * Clears memory
   */ destroy() {
        this.listeners.removeAll();
    }
    /**
   * Returns list of found items for the current search query
   */ get foundItems() {
        return this.items.filter((e)=>this.checkItem(e));
    }
    /**
   * Contains logic for checking whether passed item conforms the search query
   *
   * @param item - item to be checked
   */ checkItem(e) {
        var i, s;
        const t1 = ((i = e.title) == null ? void 0 : i.toLowerCase()) || "", o = (s = this.searchQuery) == null ? void 0 : s.toLowerCase();
        return o !== void 0 ? t1.includes(o) : !1;
    }
}
var $6813aa9d7dc8ab1a$var$cs = Object.defineProperty, $6813aa9d7dc8ab1a$var$ds = Object.getOwnPropertyDescriptor, $6813aa9d7dc8ab1a$var$us = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $6813aa9d7dc8ab1a$var$ds(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $6813aa9d7dc8ab1a$var$cs(e, t1, i), i;
};
const $6813aa9d7dc8ab1a$var$en = class tn extends $6813aa9d7dc8ab1a$var$Jo {
    /**
   * Construct the instance
   *
   * @param params - popover params
   * @param itemsRenderParams – popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        super(e, t1), this.nestingLevel = 0, this.nestedPopoverTriggerItem = null, this.previouslyHoveredItem = null, this.scopeElement = document.body, this.hide = ()=>{
            var o;
            super.hide(), this.destroyNestedPopoverIfExists(), (o = this.flipper) == null || o.deactivate(), this.previouslyHoveredItem = null;
        }, this.onFlip = ()=>{
            const o = this.itemsDefault.find((i)=>i.isFocused);
            o == null || o.onFocus();
        }, this.onSearch = (o)=>{
            var a;
            const i = o.query === "", s = o.items.length === 0;
            this.items.forEach((l)=>{
                let c = !1;
                l instanceof $6813aa9d7dc8ab1a$var$re ? c = !o.items.includes(l) : (l instanceof $6813aa9d7dc8ab1a$var$Qo || l instanceof $6813aa9d7dc8ab1a$var$Se) && (c = s || !i), l.toggleHidden(c);
            }), this.toggleNothingFoundMessage(s);
            const r = o.query === "" ? this.flippableElements : o.items.map((l)=>l.getElement());
            (a = this.flipper) != null && a.isActivated && (this.flipper.deactivate(), this.flipper.activate(r));
        }, e.nestingLevel !== void 0 && (this.nestingLevel = e.nestingLevel), this.nestingLevel > 0 && this.nodes.popover.classList.add($6813aa9d7dc8ab1a$var$P.popoverNested), e.scopeElement !== void 0 && (this.scopeElement = e.scopeElement), this.nodes.popoverContainer !== null && this.listeners.on(this.nodes.popoverContainer, "mouseover", (o)=>this.handleHover(o)), e.searchable && this.addSearch(), e.flippable !== !1 && (this.flipper = new $6813aa9d7dc8ab1a$var$ce({
            items: this.flippableElements,
            focusedItemClass: $6813aa9d7dc8ab1a$var$L.focused,
            allowedKeys: [
                $6813aa9d7dc8ab1a$var$y.TAB,
                $6813aa9d7dc8ab1a$var$y.UP,
                $6813aa9d7dc8ab1a$var$y.DOWN,
                $6813aa9d7dc8ab1a$var$y.ENTER
            ]
        }), this.flipper.onFlip(this.onFlip));
    }
    /**
   * Returns true if some item inside popover is focused
   */ hasFocus() {
        return this.flipper === void 0 ? !1 : this.flipper.hasFocus();
    }
    /**
   * Scroll position inside items container of the popover
   */ get scrollTop() {
        return this.nodes.items === null ? 0 : this.nodes.items.scrollTop;
    }
    /**
   * Returns visible element offset top
   */ get offsetTop() {
        return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetTop;
    }
    /**
   * Open popover
   */ show() {
        var e;
        this.nodes.popover.style.setProperty($6813aa9d7dc8ab1a$var$fe.PopoverHeight, this.size.height + "px"), this.shouldOpenBottom || this.nodes.popover.classList.add($6813aa9d7dc8ab1a$var$P.popoverOpenTop), this.shouldOpenRight || this.nodes.popover.classList.add($6813aa9d7dc8ab1a$var$P.popoverOpenLeft), super.show(), (e = this.flipper) == null || e.activate(this.flippableElements);
    }
    /**
   * Clears memory
   */ destroy() {
        this.hide(), super.destroy();
    }
    /**
   * Handles displaying nested items for the item.
   *
   * @param item – item to show nested popover for
   */ showNestedItems(e) {
        this.nestedPopover !== null && this.nestedPopover !== void 0 || (this.nestedPopoverTriggerItem = e, this.showNestedPopoverForItem(e));
    }
    /**
   * Handles hover events inside popover items container
   *
   * @param event - hover event data
   */ handleHover(e) {
        const t1 = this.getTargetItem(e);
        t1 !== void 0 && this.previouslyHoveredItem !== t1 && (this.destroyNestedPopoverIfExists(), this.previouslyHoveredItem = t1, t1.hasChildren && this.showNestedPopoverForItem(t1));
    }
    /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used for correct positioning of the nested popover
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ setTriggerItemPosition(e, t1) {
        const o = t1.getElement(), i = (o ? o.offsetTop : 0) - this.scrollTop, s = this.offsetTop + i;
        e.style.setProperty($6813aa9d7dc8ab1a$var$fe.TriggerItemTop, s + "px");
    }
    /**
   * Destroys existing nested popover
   */ destroyNestedPopoverIfExists() {
        var e, t1;
        this.nestedPopover === void 0 || this.nestedPopover === null || (this.nestedPopover.off($6813aa9d7dc8ab1a$var$G.ClosedOnActivate, this.hide), this.nestedPopover.hide(), this.nestedPopover.destroy(), this.nestedPopover.getElement().remove(), this.nestedPopover = null, (e = this.flipper) == null || e.activate(this.flippableElements), (t1 = this.nestedPopoverTriggerItem) == null || t1.onChildrenClose());
    }
    /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ showNestedPopoverForItem(e) {
        var o;
        this.nestedPopover = new tn({
            searchable: e.isChildrenSearchable,
            items: e.children,
            nestingLevel: this.nestingLevel + 1,
            flippable: e.isChildrenFlippable,
            messages: this.messages
        }), e.onChildrenOpen(), this.nestedPopover.on($6813aa9d7dc8ab1a$var$G.ClosedOnActivate, this.hide);
        const t1 = this.nestedPopover.getElement();
        return this.nodes.popover.appendChild(t1), this.setTriggerItemPosition(t1, e), t1.style.setProperty($6813aa9d7dc8ab1a$var$fe.NestingLevel, this.nestedPopover.nestingLevel.toString()), this.nestedPopover.show(), (o = this.flipper) == null || o.deactivate(), this.nestedPopover;
    }
    /**
   * Checks if popover should be opened bottom.
   * It should happen when there is enough space below or not enough space above
   */ get shouldOpenBottom() {
        if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
        const e = this.nodes.popoverContainer.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.height, i = e.top + o, s = e.top - o, r = Math.min(window.innerHeight, t1.bottom);
        return s < t1.top || i <= r;
    }
    /**
   * Checks if popover should be opened left.
   * It should happen when there is enough space in the right or not enough space in the left
   */ get shouldOpenRight() {
        if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
        const e = this.nodes.popover.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.width, i = e.right + o, s = e.left - o, r = Math.min(window.innerWidth, t1.right);
        return s < t1.left || i <= r;
    }
    get size() {
        var i;
        const e = {
            height: 0,
            width: 0
        };
        if (this.nodes.popover === null) return e;
        const t1 = this.nodes.popover.cloneNode(!0);
        t1.style.visibility = "hidden", t1.style.position = "absolute", t1.style.top = "-1000px", t1.classList.add($6813aa9d7dc8ab1a$var$P.popoverOpened), (i = t1.querySelector("." + $6813aa9d7dc8ab1a$var$P.popoverNested)) == null || i.remove(), document.body.appendChild(t1);
        const o = t1.querySelector("." + $6813aa9d7dc8ab1a$var$P.popoverContainer);
        return e.height = o.offsetHeight, e.width = o.offsetWidth, t1.remove(), e;
    }
    /**
   * Returns list of elements available for keyboard navigation.
   */ get flippableElements() {
        return this.items.map((t1)=>{
            if (t1 instanceof $6813aa9d7dc8ab1a$var$re) return t1.getElement();
            if (t1 instanceof $6813aa9d7dc8ab1a$var$Se) return t1.getControls();
        }).flat().filter((t1)=>t1 != null);
    }
    /**
   * Adds search to the popover
   */ addSearch() {
        this.search = new $6813aa9d7dc8ab1a$var$ls({
            items: this.itemsDefault,
            placeholder: this.messages.search
        }), this.search.on($6813aa9d7dc8ab1a$var$Ue.Search, this.onSearch);
        const e = this.search.getElement();
        e.classList.add($6813aa9d7dc8ab1a$var$P.search), this.nodes.popoverContainer.insertBefore(e, this.nodes.popoverContainer.firstChild);
    }
    /**
   * Toggles nothing found message visibility
   *
   * @param isDisplayed - true if the message should be displayed
   */ toggleNothingFoundMessage(e) {
        this.nodes.nothingFoundMessage.classList.toggle($6813aa9d7dc8ab1a$var$P.nothingFoundMessageDisplayed, e);
    }
};
$6813aa9d7dc8ab1a$var$us([
    $6813aa9d7dc8ab1a$var$me
], $6813aa9d7dc8ab1a$var$en.prototype, "size", 1);
let $6813aa9d7dc8ab1a$var$Bt = $6813aa9d7dc8ab1a$var$en;
class $6813aa9d7dc8ab1a$var$hs extends $6813aa9d7dc8ab1a$var$Bt {
    /**
   * Constructs the instance
   *
   * @param params - instance parameters
   */ constructor(e){
        const t1 = !$6813aa9d7dc8ab1a$var$be();
        super({
            ...e,
            class: $6813aa9d7dc8ab1a$var$P.popoverInline
        }, {
            [$6813aa9d7dc8ab1a$var$_.Default]: {
                /**
           * We use button instead of div here to fix bug associated with focus loss (which leads to selection change) on click in safari
           *
           * @todo figure out better way to solve the issue
           */ wrapperTag: "button",
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            },
            [$6813aa9d7dc8ab1a$var$_.Html]: {
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            }
        }), this.items.forEach((o)=>{
            !(o instanceof $6813aa9d7dc8ab1a$var$re) && !(o instanceof $6813aa9d7dc8ab1a$var$Se) || o.hasChildren && o.isChildrenOpen && this.showNestedItems(o);
        });
    }
    /**
   * Returns visible element offset top
   */ get offsetLeft() {
        return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetLeft;
    }
    /**
   * Open popover
   */ show() {
        this.nestingLevel === 0 && this.nodes.popover.style.setProperty($6813aa9d7dc8ab1a$var$fe.InlinePopoverWidth, this.size.width + "px"), super.show();
    }
    /**
   * Disable hover event handling.
   * Overrides parent's class behavior
   */ handleHover() {}
    /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used to position nested popover right below clicked item
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ setTriggerItemPosition(e, t1) {
        const o = t1.getElement(), i = o ? o.offsetLeft : 0, s = this.offsetLeft + i;
        e.style.setProperty($6813aa9d7dc8ab1a$var$fe.TriggerItemLeft, s + "px");
    }
    /**
   * Handles displaying nested items for the item.
   * Overriding in order to add toggling behaviour
   *
   * @param item – item to toggle nested popover for
   */ showNestedItems(e) {
        if (this.nestedPopoverTriggerItem === e) {
            this.destroyNestedPopoverIfExists(), this.nestedPopoverTriggerItem = null;
            return;
        }
        super.showNestedItems(e);
    }
    /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ showNestedPopoverForItem(e) {
        const t1 = super.showNestedPopoverForItem(e);
        return t1.getElement().classList.add($6813aa9d7dc8ab1a$var$P.getPopoverNestedClass(t1.nestingLevel)), t1;
    }
    /**
   * Overrides default item click handling.
   * Helps to close nested popover once other item is clicked.
   *
   * @param item - clicked item
   */ handleItemClick(e) {
        var t1;
        e !== this.nestedPopoverTriggerItem && ((t1 = this.nestedPopoverTriggerItem) == null || t1.handleClick(), super.destroyNestedPopoverIfExists()), super.handleItemClick(e);
    }
}
const $6813aa9d7dc8ab1a$var$on = class xe {
    constructor(){
        this.scrollPosition = null;
    }
    /**
   * Locks body element scroll
   */ lock() {
        $6813aa9d7dc8ab1a$var$pt ? this.lockHard() : document.body.classList.add(xe.CSS.scrollLocked);
    }
    /**
   * Unlocks body element scroll
   */ unlock() {
        $6813aa9d7dc8ab1a$var$pt ? this.unlockHard() : document.body.classList.remove(xe.CSS.scrollLocked);
    }
    /**
   * Locks scroll in a hard way (via setting fixed position to body element)
   */ lockHard() {
        this.scrollPosition = window.pageYOffset, document.documentElement.style.setProperty("--window-scroll-offset", `${this.scrollPosition}px`), document.body.classList.add(xe.CSS.scrollLockedHard);
    }
    /**
   * Unlocks hard scroll lock
   */ unlockHard() {
        document.body.classList.remove(xe.CSS.scrollLockedHard), this.scrollPosition !== null && window.scrollTo(0, this.scrollPosition), this.scrollPosition = null;
    }
};
$6813aa9d7dc8ab1a$var$on.CSS = {
    scrollLocked: "ce-scroll-locked",
    scrollLockedHard: "ce-scroll-locked--hard"
};
let $6813aa9d7dc8ab1a$var$ps = $6813aa9d7dc8ab1a$var$on;
const $6813aa9d7dc8ab1a$var$at = $6813aa9d7dc8ab1a$var$ne("ce-popover-header"), $6813aa9d7dc8ab1a$var$lt = {
    root: $6813aa9d7dc8ab1a$var$at(),
    text: $6813aa9d7dc8ab1a$var$at("text"),
    backButton: $6813aa9d7dc8ab1a$var$at("back-button")
};
class $6813aa9d7dc8ab1a$var$fs {
    /**
   * Constructs the instance
   *
   * @param params - popover header params
   */ constructor({ text: e, onBackButtonClick: t1 }){
        this.listeners = new $6813aa9d7dc8ab1a$var$_e(), this.text = e, this.onBackButtonClick = t1, this.nodes = {
            root: $6813aa9d7dc8ab1a$var$u.make("div", [
                $6813aa9d7dc8ab1a$var$lt.root
            ]),
            backButton: $6813aa9d7dc8ab1a$var$u.make("button", [
                $6813aa9d7dc8ab1a$var$lt.backButton
            ]),
            text: $6813aa9d7dc8ab1a$var$u.make("div", [
                $6813aa9d7dc8ab1a$var$lt.text
            ])
        }, this.nodes.backButton.innerHTML = $6813aa9d7dc8ab1a$var$Vi, this.nodes.root.appendChild(this.nodes.backButton), this.listeners.on(this.nodes.backButton, "click", this.onBackButtonClick), this.nodes.text.innerText = this.text, this.nodes.root.appendChild(this.nodes.text);
    }
    /**
   * Returns popover header root html element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Destroys the instance
   */ destroy() {
        this.nodes.root.remove(), this.listeners.destroy();
    }
}
class $6813aa9d7dc8ab1a$var$gs {
    constructor(){
        this.history = [];
    }
    /**
   * Push new popover state
   *
   * @param state - new state
   */ push(e) {
        this.history.push(e);
    }
    /**
   * Pop last popover state
   */ pop() {
        return this.history.pop();
    }
    /**
   * Title retrieved from the current state
   */ get currentTitle() {
        return this.history.length === 0 ? "" : this.history[this.history.length - 1].title;
    }
    /**
   * Items list retrieved from the current state
   */ get currentItems() {
        return this.history.length === 0 ? [] : this.history[this.history.length - 1].items;
    }
    /**
   * Returns history to initial popover state
   */ reset() {
        for(; this.history.length > 1;)this.pop();
    }
}
class $6813aa9d7dc8ab1a$var$nn extends $6813aa9d7dc8ab1a$var$Jo {
    /**
   * Construct the instance
   *
   * @param params - popover params
   */ constructor(e){
        super(e, {
            [$6813aa9d7dc8ab1a$var$_.Default]: {
                hint: {
                    enabled: !1
                }
            },
            [$6813aa9d7dc8ab1a$var$_.Html]: {
                hint: {
                    enabled: !1
                }
            }
        }), this.scrollLocker = new $6813aa9d7dc8ab1a$var$ps(), this.history = new $6813aa9d7dc8ab1a$var$gs(), this.isHidden = !0, this.nodes.overlay = $6813aa9d7dc8ab1a$var$u.make("div", [
            $6813aa9d7dc8ab1a$var$P.overlay,
            $6813aa9d7dc8ab1a$var$P.overlayHidden
        ]), this.nodes.popover.insertBefore(this.nodes.overlay, this.nodes.popover.firstChild), this.listeners.on(this.nodes.overlay, "click", ()=>{
            this.hide();
        }), this.history.push({
            items: e.items
        });
    }
    /**
   * Open popover
   */ show() {
        this.nodes.overlay.classList.remove($6813aa9d7dc8ab1a$var$P.overlayHidden), super.show(), this.scrollLocker.lock(), this.isHidden = !1;
    }
    /**
   * Closes popover
   */ hide() {
        this.isHidden || (super.hide(), this.nodes.overlay.classList.add($6813aa9d7dc8ab1a$var$P.overlayHidden), this.scrollLocker.unlock(), this.history.reset(), this.isHidden = !0);
    }
    /**
   * Clears memory
   */ destroy() {
        super.destroy(), this.scrollLocker.unlock();
    }
    /**
   * Handles displaying nested items for the item
   *
   * @param item – item to show nested popover for
   */ showNestedItems(e) {
        this.updateItemsAndHeader(e.children, e.title), this.history.push({
            title: e.title,
            items: e.children
        });
    }
    /**
   * Removes rendered popover items and header and displays new ones
   *
   * @param items - new popover items
   * @param title - new popover header text
   */ updateItemsAndHeader(e, t1) {
        if (this.header !== null && this.header !== void 0 && (this.header.destroy(), this.header = null), t1 !== void 0) {
            this.header = new $6813aa9d7dc8ab1a$var$fs({
                text: t1,
                onBackButtonClick: ()=>{
                    this.history.pop(), this.updateItemsAndHeader(this.history.currentItems, this.history.currentTitle);
                }
            });
            const o = this.header.getElement();
            o !== null && this.nodes.popoverContainer.insertBefore(o, this.nodes.popoverContainer.firstChild);
        }
        this.items.forEach((o)=>{
            var i;
            return (i = o.getElement()) == null ? void 0 : i.remove();
        }), this.items = this.buildItems(e), this.items.forEach((o)=>{
            var s;
            const i = o.getElement();
            i !== null && ((s = this.nodes.items) == null || s.appendChild(i));
        });
    }
}
class $6813aa9d7dc8ab1a$var$ms extends $6813aa9d7dc8ab1a$var$E {
    constructor(){
        super(...arguments), this.opened = !1, this.hasMobileLayoutToggleListener = !1, this.selection = new $6813aa9d7dc8ab1a$var$b(), this.popover = null, this.close = ()=>{
            this.opened && (this.opened = !1, $6813aa9d7dc8ab1a$var$b.isAtEditor || this.selection.restore(), this.selection.clearSaved(), !this.Editor.CrossBlockSelection.isCrossBlockSelectionStarted && this.Editor.BlockManager.currentBlock && this.Editor.BlockSelection.unselectBlock(this.Editor.BlockManager.currentBlock), this.eventsDispatcher.emit(this.events.closed), this.popover && (this.popover.off($6813aa9d7dc8ab1a$var$G.Closed, this.onPopoverClose), this.popover.destroy(), this.popover.getElement().remove(), this.popover = null));
        }, this.onPopoverClose = ()=>{
            this.close();
        };
    }
    /**
   * Module Events
   */ get events() {
        return {
            opened: "block-settings-opened",
            closed: "block-settings-closed"
        };
    }
    /**
   * Block Settings CSS
   */ get CSS() {
        return {
            settings: "ce-settings"
        };
    }
    /**
   * Getter for inner popover's flipper instance
   *
   * @todo remove once BlockSettings becomes standalone non-module class
   */ get flipper() {
        var e;
        if (this.popover !== null) return "flipper" in this.popover ? (e = this.popover) == null ? void 0 : e.flipper : void 0;
    }
    /**
   * Panel with block settings with 2 sections:
   *  - Tool's Settings
   *  - Default Settings [Move, Remove, etc]
   */ make() {
        this.nodes.wrapper = $6813aa9d7dc8ab1a$var$u.make("div", [
            this.CSS.settings
        ]), this.eventsDispatcher.on($6813aa9d7dc8ab1a$var$Te, this.close), this.hasMobileLayoutToggleListener = !0;
    }
    /**
   * Destroys module
   */ destroy() {
        this.removeAllNodes(), this.listeners.destroy(), this.hasMobileLayoutToggleListener && (this.eventsDispatcher.off($6813aa9d7dc8ab1a$var$Te, this.close), this.hasMobileLayoutToggleListener = !1);
    }
    /**
   * Open Block Settings pane
   *
   * @param targetBlock - near which Block we should open BlockSettings
   */ async open(e = this.Editor.BlockManager.currentBlock) {
        var s;
        this.opened = !0, this.selection.save(), this.Editor.BlockSelection.selectBlock(e), this.Editor.BlockSelection.clearCache();
        const { toolTunes: t1, commonTunes: o } = e.getTunes();
        this.eventsDispatcher.emit(this.events.opened);
        const i = $6813aa9d7dc8ab1a$var$be() ? $6813aa9d7dc8ab1a$var$nn : $6813aa9d7dc8ab1a$var$Bt;
        this.popover = new i({
            searchable: !0,
            items: await this.getTunesItems(e, o, t1),
            scopeElement: this.Editor.API.methods.ui.nodes.redactor,
            messages: {
                nothingFound: $6813aa9d7dc8ab1a$var$z.ui($6813aa9d7dc8ab1a$var$K.ui.popover, "Nothing found"),
                search: $6813aa9d7dc8ab1a$var$z.ui($6813aa9d7dc8ab1a$var$K.ui.popover, "Filter")
            }
        }), this.popover.on($6813aa9d7dc8ab1a$var$G.Closed, this.onPopoverClose), (s = this.nodes.wrapper) == null || s.append(this.popover.getElement()), this.popover.show();
    }
    /**
   * Returns root block settings element
   */ getElement() {
        return this.nodes.wrapper;
    }
    /**
   * Returns list of items to be displayed in block tunes menu.
   * Merges tool specific tunes, conversion menu and common tunes in one list in predefined order
   *
   * @param currentBlock –  block we are about to open block tunes for
   * @param commonTunes – common tunes
   * @param toolTunes - tool specific tunes
   */ async getTunesItems(e, t1, o) {
        const i = [];
        o !== void 0 && o.length > 0 && (i.push(...o), i.push({
            type: $6813aa9d7dc8ab1a$var$_.Separator
        }));
        const s = Array.from(this.Editor.Tools.blockTools.values()), a = (await $6813aa9d7dc8ab1a$var$Yo(e, s)).reduce((l, c)=>(c.toolbox.forEach((d)=>{
                l.push({
                    icon: d.icon,
                    title: $6813aa9d7dc8ab1a$var$z.t($6813aa9d7dc8ab1a$var$K.toolNames, d.title),
                    name: c.name,
                    closeOnActivate: !0,
                    onActivate: async ()=>{
                        const { BlockManager: h, Caret: p, Toolbar: g } = this.Editor, f = await h.convert(e, c.name, d.data);
                        g.close(), p.setToBlock(f, p.positions.END);
                    }
                });
            }), l), []);
        return a.length > 0 && (i.push({
            icon: $6813aa9d7dc8ab1a$var$Go,
            name: "convert-to",
            title: $6813aa9d7dc8ab1a$var$z.ui($6813aa9d7dc8ab1a$var$K.ui.popover, "Convert to"),
            children: {
                searchable: !0,
                items: a
            }
        }), i.push({
            type: $6813aa9d7dc8ab1a$var$_.Separator
        })), i.push(...t1), i.map((l)=>this.resolveTuneAliases(l));
    }
    /**
   * Resolves aliases in tunes menu items
   *
   * @param item - item with resolved aliases
   */ resolveTuneAliases(e) {
        if (e.type === $6813aa9d7dc8ab1a$var$_.Separator || e.type === $6813aa9d7dc8ab1a$var$_.Html) return e;
        const t1 = $6813aa9d7dc8ab1a$var$Yi(e, {
            label: "title"
        });
        return e.confirmation && (t1.confirmation = this.resolveTuneAliases(e.confirmation)), t1;
    }
}
var $6813aa9d7dc8ab1a$var$sn = {
    exports: {}
};
/*!
 * Library for handling keyboard shortcuts
 * @copyright CodeX (https://codex.so)
 * @license MIT
 * @author CodeX (https://codex.so)
 * @version 1.2.0
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                function s(l, c) {
                    for(var d = 0; d < c.length; d++){
                        var h = c[d];
                        h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(l, h.key, h);
                    }
                }
                function r(l, c, d) {
                    return c && s(l.prototype, c), d && s(l, d), l;
                }
                i.r(o);
                var a = function() {
                    function l(c) {
                        var d = this;
                        (function(h, p) {
                            if (!(h instanceof p)) throw new TypeError("Cannot call a class as a function");
                        })(this, l), this.commands = {}, this.keys = {}, this.name = c.name, this.parseShortcutName(c.name), this.element = c.on, this.callback = c.callback, this.executeShortcut = function(h) {
                            d.execute(h);
                        }, this.element.addEventListener("keydown", this.executeShortcut, !1);
                    }
                    return r(l, null, [
                        {
                            key: "supportedCommands",
                            get: function() {
                                return {
                                    SHIFT: [
                                        "SHIFT"
                                    ],
                                    CMD: [
                                        "CMD",
                                        "CONTROL",
                                        "COMMAND",
                                        "WINDOWS",
                                        "CTRL"
                                    ],
                                    ALT: [
                                        "ALT",
                                        "OPTION"
                                    ]
                                };
                            }
                        },
                        {
                            key: "keyCodes",
                            get: function() {
                                return {
                                    0: 48,
                                    1: 49,
                                    2: 50,
                                    3: 51,
                                    4: 52,
                                    5: 53,
                                    6: 54,
                                    7: 55,
                                    8: 56,
                                    9: 57,
                                    A: 65,
                                    B: 66,
                                    C: 67,
                                    D: 68,
                                    E: 69,
                                    F: 70,
                                    G: 71,
                                    H: 72,
                                    I: 73,
                                    J: 74,
                                    K: 75,
                                    L: 76,
                                    M: 77,
                                    N: 78,
                                    O: 79,
                                    P: 80,
                                    Q: 81,
                                    R: 82,
                                    S: 83,
                                    T: 84,
                                    U: 85,
                                    V: 86,
                                    W: 87,
                                    X: 88,
                                    Y: 89,
                                    Z: 90,
                                    BACKSPACE: 8,
                                    ENTER: 13,
                                    ESCAPE: 27,
                                    LEFT: 37,
                                    UP: 38,
                                    RIGHT: 39,
                                    DOWN: 40,
                                    INSERT: 45,
                                    DELETE: 46,
                                    ".": 190
                                };
                            }
                        }
                    ]), r(l, [
                        {
                            key: "parseShortcutName",
                            value: function(c) {
                                c = c.split("+");
                                for(var d = 0; d < c.length; d++){
                                    c[d] = c[d].toUpperCase();
                                    var h = !1;
                                    for(var p in l.supportedCommands)if (l.supportedCommands[p].includes(c[d])) {
                                        h = this.commands[p] = !0;
                                        break;
                                    }
                                    h || (this.keys[c[d]] = !0);
                                }
                                for(var g in l.supportedCommands)this.commands[g] || (this.commands[g] = !1);
                            }
                        },
                        {
                            key: "execute",
                            value: function(c) {
                                var d, h = {
                                    CMD: c.ctrlKey || c.metaKey,
                                    SHIFT: c.shiftKey,
                                    ALT: c.altKey
                                }, p = !0;
                                for(d in this.commands)this.commands[d] !== h[d] && (p = !1);
                                var g, f = !0;
                                for(g in this.keys)f = f && c.keyCode === l.keyCodes[g];
                                p && f && this.callback(c);
                            }
                        },
                        {
                            key: "remove",
                            value: function() {
                                this.element.removeEventListener("keydown", this.executeShortcut);
                            }
                        }
                    ]), l;
                }();
                o.default = a;
            }
        ]).default;
    });
})($6813aa9d7dc8ab1a$var$sn);
var $6813aa9d7dc8ab1a$var$bs = $6813aa9d7dc8ab1a$var$sn.exports;
const $6813aa9d7dc8ab1a$var$vs = /* @__PURE__ */ $6813aa9d7dc8ab1a$var$Ke($6813aa9d7dc8ab1a$var$bs);
class $6813aa9d7dc8ab1a$var$ks {
    constructor(){
        this.registeredShortcuts = /* @__PURE__ */ new Map();
    }
    /**
   * Register shortcut
   *
   * @param shortcut - shortcut options
   */ add(e) {
        if (this.findShortcut(e.on, e.name)) throw Error(`Shortcut ${e.name} is already registered for ${e.on}. Please remove it before add a new handler.`);
        const o = new $6813aa9d7dc8ab1a$var$vs({
            name: e.name,
            on: e.on,
            callback: e.handler
        }), i = this.registeredShortcuts.get(e.on) || [];
        this.registeredShortcuts.set(e.on, [
            ...i,
            o
        ]);
    }
    /**
   * Remove shortcut
   *
   * @param element - Element shortcut is set for
   * @param name - shortcut name
   */ remove(e, t1) {
        const o = this.findShortcut(e, t1);
        if (!o) return;
        o.remove();
        const s = this.registeredShortcuts.get(e).filter((r)=>r !== o);
        if (s.length === 0) {
            this.registeredShortcuts.delete(e);
            return;
        }
        this.registeredShortcuts.set(e, s);
    }
    /**
   * Get Shortcut instance if exist
   *
   * @param element - Element shorcut is set for
   * @param shortcut - shortcut name
   * @returns {number} index - shortcut index if exist
   */ findShortcut(e, t1) {
        return (this.registeredShortcuts.get(e) || []).find(({ name: i })=>i === t1);
    }
}
const $6813aa9d7dc8ab1a$var$ge = new $6813aa9d7dc8ab1a$var$ks();
var $6813aa9d7dc8ab1a$var$ys = Object.defineProperty, $6813aa9d7dc8ab1a$var$ws = Object.getOwnPropertyDescriptor, $6813aa9d7dc8ab1a$var$rn = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $6813aa9d7dc8ab1a$var$ws(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $6813aa9d7dc8ab1a$var$ys(e, t1, i), i;
}, $6813aa9d7dc8ab1a$var$Le = /* @__PURE__ */ ((n)=>(n.Opened = "toolbox-opened", n.Closed = "toolbox-closed", n.BlockAdded = "toolbox-block-added", n))($6813aa9d7dc8ab1a$var$Le || {});
const $6813aa9d7dc8ab1a$var$Ct = class an extends $6813aa9d7dc8ab1a$var$Oe {
    /**
   * Toolbox constructor
   *
   * @param options - available parameters
   * @param options.api - Editor API methods
   * @param options.tools - Tools available to check whether some of them should be displayed at the Toolbox or not
   */ constructor({ api: e, tools: t1, i18nLabels: o }){
        super(), this.opened = !1, this.listeners = new $6813aa9d7dc8ab1a$var$_e(), this.popover = null, this.handleMobileLayoutToggle = ()=>{
            this.destroyPopover(), this.initPopover();
        }, this.onPopoverClose = ()=>{
            this.opened = !1, this.emit("toolbox-closed");
        }, this.api = e, this.tools = t1, this.i18nLabels = o, this.enableShortcuts(), this.nodes = {
            toolbox: $6813aa9d7dc8ab1a$var$u.make("div", an.CSS.toolbox)
        }, this.initPopover(), this.api.events.on($6813aa9d7dc8ab1a$var$Te, this.handleMobileLayoutToggle);
    }
    /**
   * Returns True if Toolbox is Empty and nothing to show
   *
   * @returns {boolean}
   */ get isEmpty() {
        return this.toolsToBeDisplayed.length === 0;
    }
    /**
   * CSS styles
   */ static get CSS() {
        return {
            toolbox: "ce-toolbox"
        };
    }
    /**
   * Returns root block settings element
   */ getElement() {
        return this.nodes.toolbox;
    }
    /**
   * Returns true if the Toolbox has the Flipper activated and the Flipper has selected button
   */ hasFocus() {
        if (this.popover !== null) return "hasFocus" in this.popover ? this.popover.hasFocus() : void 0;
    }
    /**
   * Destroy Module
   */ destroy() {
        var e;
        super.destroy(), this.nodes && this.nodes.toolbox && this.nodes.toolbox.remove(), this.removeAllShortcuts(), (e = this.popover) == null || e.off($6813aa9d7dc8ab1a$var$G.Closed, this.onPopoverClose), this.listeners.destroy(), this.api.events.off($6813aa9d7dc8ab1a$var$Te, this.handleMobileLayoutToggle);
    }
    /**
   * Toolbox Tool's button click handler
   *
   * @param toolName - tool type to be activated
   * @param blockDataOverrides - Block data predefined by the activated Toolbox item
   */ toolButtonActivated(e, t1) {
        this.insertNewBlock(e, t1);
    }
    /**
   * Open Toolbox with Tools
   */ open() {
        var e;
        this.isEmpty || ((e = this.popover) == null || e.show(), this.opened = !0, this.emit("toolbox-opened"));
    }
    /**
   * Close Toolbox
   */ close() {
        var e;
        (e = this.popover) == null || e.hide(), this.opened = !1, this.emit("toolbox-closed");
    }
    /**
   * Close Toolbox
   */ toggle() {
        this.opened ? this.close() : this.open();
    }
    /**
   * Creates toolbox popover and appends it inside wrapper element
   */ initPopover() {
        var t1;
        const e = $6813aa9d7dc8ab1a$var$be() ? $6813aa9d7dc8ab1a$var$nn : $6813aa9d7dc8ab1a$var$Bt;
        this.popover = new e({
            scopeElement: this.api.ui.nodes.redactor,
            searchable: !0,
            messages: {
                nothingFound: this.i18nLabels.nothingFound,
                search: this.i18nLabels.filter
            },
            items: this.toolboxItemsToBeDisplayed
        }), this.popover.on($6813aa9d7dc8ab1a$var$G.Closed, this.onPopoverClose), (t1 = this.nodes.toolbox) == null || t1.append(this.popover.getElement());
    }
    /**
   * Destroys popover instance and removes it from DOM
   */ destroyPopover() {
        this.popover !== null && (this.popover.hide(), this.popover.off($6813aa9d7dc8ab1a$var$G.Closed, this.onPopoverClose), this.popover.destroy(), this.popover = null), this.nodes.toolbox !== null && (this.nodes.toolbox.innerHTML = "");
    }
    get toolsToBeDisplayed() {
        const e = [];
        return this.tools.forEach((t1)=>{
            t1.toolbox && e.push(t1);
        }), e;
    }
    get toolboxItemsToBeDisplayed() {
        const e = (t1, o, i = !0)=>({
                icon: t1.icon,
                title: $6813aa9d7dc8ab1a$var$z.t($6813aa9d7dc8ab1a$var$K.toolNames, t1.title || $6813aa9d7dc8ab1a$var$je(o.name)),
                name: o.name,
                onActivate: ()=>{
                    this.toolButtonActivated(o.name, t1.data);
                },
                secondaryLabel: o.shortcut && i ? $6813aa9d7dc8ab1a$var$vt(o.shortcut) : ""
            });
        return this.toolsToBeDisplayed.reduce((t1, o)=>(Array.isArray(o.toolbox) ? o.toolbox.forEach((i, s)=>{
                t1.push(e(i, o, s === 0));
            }) : o.toolbox !== void 0 && t1.push(e(o.toolbox, o)), t1), []);
    }
    /**
   * Iterate all tools and enable theirs shortcuts if specified
   */ enableShortcuts() {
        this.toolsToBeDisplayed.forEach((e)=>{
            const t1 = e.shortcut;
            t1 && this.enableShortcutForTool(e.name, t1);
        });
    }
    /**
   * Enable shortcut Block Tool implemented shortcut
   *
   * @param {string} toolName - Tool name
   * @param {string} shortcut - shortcut according to the ShortcutData Module format
   */ enableShortcutForTool(e, t1) {
        $6813aa9d7dc8ab1a$var$ge.add({
            name: t1,
            on: this.api.ui.nodes.redactor,
            handler: async (o)=>{
                o.preventDefault();
                const i = this.api.blocks.getCurrentBlockIndex(), s = this.api.blocks.getBlockByIndex(i);
                if (s) try {
                    const r = await this.api.blocks.convert(s.id, e);
                    this.api.caret.setToBlock(r, "end");
                    return;
                } catch  {}
                this.insertNewBlock(e);
            }
        });
    }
    /**
   * Removes all added shortcuts
   * Fired when the Read-Only mode is activated
   */ removeAllShortcuts() {
        this.toolsToBeDisplayed.forEach((e)=>{
            const t1 = e.shortcut;
            t1 && $6813aa9d7dc8ab1a$var$ge.remove(this.api.ui.nodes.redactor, t1);
        });
    }
    /**
   * Inserts new block
   * Can be called when button clicked on Toolbox or by ShortcutData
   *
   * @param {string} toolName - Tool name
   * @param blockDataOverrides - predefined Block data
   */ async insertNewBlock(e, t1) {
        const o = this.api.blocks.getCurrentBlockIndex(), i = this.api.blocks.getBlockByIndex(o);
        if (!i) return;
        const s = i.isEmpty ? o : o + 1;
        let r;
        if (t1) {
            const l = await this.api.blocks.composeBlockData(e);
            r = Object.assign(l, t1);
        }
        const a = this.api.blocks.insert(e, r, void 0, s, void 0, i.isEmpty);
        a.call($6813aa9d7dc8ab1a$var$ee.APPEND_CALLBACK), this.api.caret.setToBlock(s), this.emit("toolbox-block-added", {
            block: a
        }), this.api.toolbar.close();
    }
};
$6813aa9d7dc8ab1a$var$rn([
    $6813aa9d7dc8ab1a$var$me
], $6813aa9d7dc8ab1a$var$Ct.prototype, "toolsToBeDisplayed", 1);
$6813aa9d7dc8ab1a$var$rn([
    $6813aa9d7dc8ab1a$var$me
], $6813aa9d7dc8ab1a$var$Ct.prototype, "toolboxItemsToBeDisplayed", 1);
let $6813aa9d7dc8ab1a$var$Es = $6813aa9d7dc8ab1a$var$Ct;
const $6813aa9d7dc8ab1a$var$ln = "block hovered";
async function $6813aa9d7dc8ab1a$var$xs(n, e) {
    const t1 = navigator.keyboard;
    if (!t1) return e;
    try {
        return (await t1.getLayoutMap()).get(n) || e;
    } catch (o) {
        return console.error(o), e;
    }
}
class $6813aa9d7dc8ab1a$var$Bs extends $6813aa9d7dc8ab1a$var$E {
    /**
   * @class
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.toolboxInstance = null;
    }
    /**
   * CSS styles
   *
   * @returns {object}
   */ get CSS() {
        return {
            toolbar: "ce-toolbar",
            content: "ce-toolbar__content",
            actions: "ce-toolbar__actions",
            actionsOpened: "ce-toolbar__actions--opened",
            toolbarOpened: "ce-toolbar--opened",
            openedToolboxHolderModifier: "codex-editor--toolbox-opened",
            plusButton: "ce-toolbar__plus",
            plusButtonShortcut: "ce-toolbar__plus-shortcut",
            settingsToggler: "ce-toolbar__settings-btn",
            settingsTogglerHidden: "ce-toolbar__settings-btn--hidden"
        };
    }
    /**
   * Returns the Toolbar opening state
   *
   * @returns {boolean}
   */ get opened() {
        return this.nodes.wrapper.classList.contains(this.CSS.toolbarOpened);
    }
    /**
   * Public interface for accessing the Toolbox
   */ get toolbox() {
        var e;
        return {
            opened: (e = this.toolboxInstance) == null ? void 0 : e.opened,
            close: ()=>{
                var t1;
                (t1 = this.toolboxInstance) == null || t1.close();
            },
            open: ()=>{
                if (this.toolboxInstance === null) {
                    $6813aa9d7dc8ab1a$var$S("toolbox.open() called before initialization is finished", "warn");
                    return;
                }
                this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.toolboxInstance.open();
            },
            toggle: ()=>{
                if (this.toolboxInstance === null) {
                    $6813aa9d7dc8ab1a$var$S("toolbox.toggle() called before initialization is finished", "warn");
                    return;
                }
                this.toolboxInstance.toggle();
            },
            hasFocus: ()=>{
                var t1;
                return (t1 = this.toolboxInstance) == null ? void 0 : t1.hasFocus();
            }
        };
    }
    /**
   * Block actions appearance manipulations
   */ get blockActions() {
        return {
            hide: ()=>{
                this.nodes.actions.classList.remove(this.CSS.actionsOpened);
            },
            show: ()=>{
                this.nodes.actions.classList.add(this.CSS.actionsOpened);
            }
        };
    }
    /**
   * Methods for working with Block Tunes toggler
   */ get blockTunesToggler() {
        return {
            hide: ()=>this.nodes.settingsToggler.classList.add(this.CSS.settingsTogglerHidden),
            show: ()=>this.nodes.settingsToggler.classList.remove(this.CSS.settingsTogglerHidden)
        };
    }
    /**
   * Toggles read-only mode
   *
   * @param {boolean} readOnlyEnabled - read-only mode
   */ toggleReadOnly(e) {
        e ? (this.destroy(), this.Editor.BlockSettings.destroy(), this.disableModuleBindings()) : window.requestIdleCallback(()=>{
            this.drawUI(), this.enableModuleBindings();
        }, {
            timeout: 2e3
        });
    }
    /**
   * Move Toolbar to the passed (or current) Block
   *
   * @param block - block to move Toolbar near it
   */ moveAndOpen(e = this.Editor.BlockManager.currentBlock) {
        if (this.toolboxInstance === null) {
            $6813aa9d7dc8ab1a$var$S("Can't open Toolbar since Editor initialization is not finished yet", "warn");
            return;
        }
        if (this.toolboxInstance.opened && this.toolboxInstance.close(), this.Editor.BlockSettings.opened && this.Editor.BlockSettings.close(), !e) return;
        this.hoveredBlock = e;
        const t1 = e.holder, { isMobile: o } = this.Editor.UI;
        let i;
        const s = 20, r = e.firstInput, a = t1.getBoundingClientRect(), l = r !== void 0 ? r.getBoundingClientRect() : null, c = l !== null ? l.top - a.top : null, d = c !== null ? c > s : void 0;
        if (o) i = t1.offsetTop + t1.offsetHeight;
        else if (r === void 0 || d) {
            const h = parseInt(window.getComputedStyle(e.pluginsContent).paddingTop);
            i = t1.offsetTop + h;
        } else {
            const h = $6813aa9d7dc8ab1a$var$li(r), p = parseInt(window.getComputedStyle(this.nodes.plusButton).height, 10), g = 8;
            i = t1.offsetTop + h - p + g + c;
        }
        this.nodes.wrapper.style.top = `${Math.floor(i)}px`, this.Editor.BlockManager.blocks.length === 1 && e.isEmpty ? this.blockTunesToggler.hide() : this.blockTunesToggler.show(), this.open();
    }
    /**
   * Close the Toolbar
   */ close() {
        var e, t1;
        this.Editor.ReadOnly.isEnabled || ((e = this.nodes.wrapper) == null || e.classList.remove(this.CSS.toolbarOpened), this.blockActions.hide(), (t1 = this.toolboxInstance) == null || t1.close(), this.Editor.BlockSettings.close(), this.reset());
    }
    /**
   * Reset the Toolbar position to prevent DOM height growth, for example after blocks deletion
   */ reset() {
        this.nodes.wrapper.style.top = "unset";
    }
    /**
   * Open Toolbar with Plus Button and Actions
   *
   * @param {boolean} withBlockActions - by default, Toolbar opens with Block Actions.
   *                                     This flag allows to open Toolbar without Actions.
   */ open(e = !0) {
        this.nodes.wrapper.classList.add(this.CSS.toolbarOpened), e ? this.blockActions.show() : this.blockActions.hide();
    }
    /**
   * Draws Toolbar elements
   */ async make() {
        this.nodes.wrapper = $6813aa9d7dc8ab1a$var$u.make("div", this.CSS.toolbar), [
            "content",
            "actions"
        ].forEach((s)=>{
            this.nodes[s] = $6813aa9d7dc8ab1a$var$u.make("div", this.CSS[s]);
        }), $6813aa9d7dc8ab1a$var$u.append(this.nodes.wrapper, this.nodes.content), $6813aa9d7dc8ab1a$var$u.append(this.nodes.content, this.nodes.actions), this.nodes.plusButton = $6813aa9d7dc8ab1a$var$u.make("div", this.CSS.plusButton, {
            innerHTML: $6813aa9d7dc8ab1a$var$ts
        }), $6813aa9d7dc8ab1a$var$u.append(this.nodes.actions, this.nodes.plusButton), this.readOnlyMutableListeners.on(this.nodes.plusButton, "click", ()=>{
            $6813aa9d7dc8ab1a$var$$e(!0), this.plusButtonClicked();
        }, !1);
        const e = $6813aa9d7dc8ab1a$var$u.make("div");
        e.appendChild(document.createTextNode($6813aa9d7dc8ab1a$var$z.ui($6813aa9d7dc8ab1a$var$K.ui.toolbar.toolbox, "Add"))), e.appendChild($6813aa9d7dc8ab1a$var$u.make("div", this.CSS.plusButtonShortcut, {
            textContent: "/"
        })), $6813aa9d7dc8ab1a$var$ze(this.nodes.plusButton, e, {
            hidingDelay: 400
        }), this.nodes.settingsToggler = $6813aa9d7dc8ab1a$var$u.make("span", this.CSS.settingsToggler, {
            innerHTML: $6813aa9d7dc8ab1a$var$es
        }), $6813aa9d7dc8ab1a$var$u.append(this.nodes.actions, this.nodes.settingsToggler);
        const t1 = $6813aa9d7dc8ab1a$var$u.make("div"), o = $6813aa9d7dc8ab1a$var$u.text($6813aa9d7dc8ab1a$var$z.ui($6813aa9d7dc8ab1a$var$K.ui.blockTunes.toggler, "Click to tune")), i = await $6813aa9d7dc8ab1a$var$xs("Slash", "/");
        t1.appendChild(o), t1.appendChild($6813aa9d7dc8ab1a$var$u.make("div", this.CSS.plusButtonShortcut, {
            textContent: $6813aa9d7dc8ab1a$var$vt(`CMD + ${i}`)
        })), $6813aa9d7dc8ab1a$var$ze(this.nodes.settingsToggler, t1, {
            hidingDelay: 400
        }), $6813aa9d7dc8ab1a$var$u.append(this.nodes.actions, this.makeToolbox()), $6813aa9d7dc8ab1a$var$u.append(this.nodes.actions, this.Editor.BlockSettings.getElement()), $6813aa9d7dc8ab1a$var$u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
    }
    /**
   * Creates the Toolbox instance and return it's rendered element
   */ makeToolbox() {
        return this.toolboxInstance = new $6813aa9d7dc8ab1a$var$Es({
            api: this.Editor.API.methods,
            tools: this.Editor.Tools.blockTools,
            i18nLabels: {
                filter: $6813aa9d7dc8ab1a$var$z.ui($6813aa9d7dc8ab1a$var$K.ui.popover, "Filter"),
                nothingFound: $6813aa9d7dc8ab1a$var$z.ui($6813aa9d7dc8ab1a$var$K.ui.popover, "Nothing found")
            }
        }), this.toolboxInstance.on($6813aa9d7dc8ab1a$var$Le.Opened, ()=>{
            this.Editor.UI.nodes.wrapper.classList.add(this.CSS.openedToolboxHolderModifier);
        }), this.toolboxInstance.on($6813aa9d7dc8ab1a$var$Le.Closed, ()=>{
            this.Editor.UI.nodes.wrapper.classList.remove(this.CSS.openedToolboxHolderModifier);
        }), this.toolboxInstance.on($6813aa9d7dc8ab1a$var$Le.BlockAdded, ({ block: e })=>{
            const { BlockManager: t1, Caret: o } = this.Editor, i = t1.getBlockById(e.id);
            i.inputs.length === 0 && (i === t1.lastBlock ? (t1.insertAtEnd(), o.setToBlock(t1.lastBlock)) : o.setToBlock(t1.nextBlock));
        }), this.toolboxInstance.getElement();
    }
    /**
   * Handler for Plus Button
   */ plusButtonClicked() {
        var e;
        this.Editor.BlockManager.currentBlock = this.hoveredBlock, (e = this.toolboxInstance) == null || e.toggle();
    }
    /**
   * Enable bindings
   */ enableModuleBindings() {
        this.readOnlyMutableListeners.on(this.nodes.settingsToggler, "mousedown", (e)=>{
            var t1;
            e.stopPropagation(), this.settingsTogglerClicked(), (t1 = this.toolboxInstance) != null && t1.opened && this.toolboxInstance.close(), $6813aa9d7dc8ab1a$var$$e(!0);
        }, !0), $6813aa9d7dc8ab1a$var$be() || this.eventsDispatcher.on($6813aa9d7dc8ab1a$var$ln, (e)=>{
            var t1;
            this.Editor.BlockSettings.opened || (t1 = this.toolboxInstance) != null && t1.opened || this.moveAndOpen(e.block);
        });
    }
    /**
   * Disable bindings
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Clicks on the Block Settings toggler
   */ settingsTogglerClicked() {
        this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.BlockSettings.open(this.hoveredBlock);
    }
    /**
   * Draws Toolbar UI
   *
   * Toolbar contains BlockSettings and Toolbox.
   * That's why at first we draw its components and then Toolbar itself
   *
   * Steps:
   *  - Make Toolbar dependent components like BlockSettings, Toolbox and so on
   *  - Make itself and append dependent nodes to itself
   *
   */ drawUI() {
        this.Editor.BlockSettings.make(), this.make();
    }
    /**
   * Removes all created and saved HTMLElements
   * It is used in Read-Only mode
   */ destroy() {
        this.removeAllNodes(), this.toolboxInstance && this.toolboxInstance.destroy();
    }
}
var $6813aa9d7dc8ab1a$var$ae = /* @__PURE__ */ ((n)=>(n[n.Block = 0] = "Block", n[n.Inline = 1] = "Inline", n[n.Tune = 2] = "Tune", n))($6813aa9d7dc8ab1a$var$ae || {}), $6813aa9d7dc8ab1a$var$Pe = /* @__PURE__ */ ((n)=>(n.Shortcut = "shortcut", n.Toolbox = "toolbox", n.EnabledInlineTools = "inlineToolbar", n.EnabledBlockTunes = "tunes", n.Config = "config", n))($6813aa9d7dc8ab1a$var$Pe || {}), $6813aa9d7dc8ab1a$var$cn = /* @__PURE__ */ ((n)=>(n.Shortcut = "shortcut", n.SanitizeConfig = "sanitize", n))($6813aa9d7dc8ab1a$var$cn || {}), $6813aa9d7dc8ab1a$var$pe = /* @__PURE__ */ ((n)=>(n.IsEnabledLineBreaks = "enableLineBreaks", n.Toolbox = "toolbox", n.ConversionConfig = "conversionConfig", n.IsReadOnlySupported = "isReadOnlySupported", n.PasteConfig = "pasteConfig", n))($6813aa9d7dc8ab1a$var$pe || {}), $6813aa9d7dc8ab1a$var$We = /* @__PURE__ */ ((n)=>(n.IsInline = "isInline", n.Title = "title", n.IsReadOnlySupported = "isReadOnlySupported", n))($6813aa9d7dc8ab1a$var$We || {}), $6813aa9d7dc8ab1a$var$mt = /* @__PURE__ */ ((n)=>(n.IsTune = "isTune", n))($6813aa9d7dc8ab1a$var$mt || {});
class $6813aa9d7dc8ab1a$var$Tt {
    /**
   * @class
   * @param {ConstructorOptions} options - Constructor options
   */ constructor({ name: e, constructable: t1, config: o, api: i, isDefault: s, isInternal: r = !1, defaultPlaceholder: a }){
        this.api = i, this.name = e, this.constructable = t1, this.config = o, this.isDefault = s, this.isInternal = r, this.defaultPlaceholder = a;
    }
    /**
   * Returns Tool user configuration
   */ get settings() {
        const e = this.config.config || {};
        return this.isDefault && !("placeholder" in e) && this.defaultPlaceholder && (e.placeholder = this.defaultPlaceholder), e;
    }
    /**
   * Calls Tool's reset method
   */ reset() {
        if ($6813aa9d7dc8ab1a$var$A(this.constructable.reset)) return this.constructable.reset();
    }
    /**
   * Calls Tool's prepare method
   */ prepare() {
        if ($6813aa9d7dc8ab1a$var$A(this.constructable.prepare)) return this.constructable.prepare({
            toolName: this.name,
            config: this.settings
        });
    }
    /**
   * Returns shortcut for Tool (internal or specified by user)
   */ get shortcut() {
        const e = this.constructable.shortcut;
        return this.config.shortcut || e;
    }
    /**
   * Returns Tool's sanitizer configuration
   */ get sanitizeConfig() {
        return this.constructable.sanitize || {};
    }
    /**
   * Returns true if Tools is inline
   */ isInline() {
        return this.type === $6813aa9d7dc8ab1a$var$ae.Inline;
    }
    /**
   * Returns true if Tools is block
   */ isBlock() {
        return this.type === $6813aa9d7dc8ab1a$var$ae.Block;
    }
    /**
   * Returns true if Tools is tune
   */ isTune() {
        return this.type === $6813aa9d7dc8ab1a$var$ae.Tune;
    }
}
class $6813aa9d7dc8ab1a$var$Cs extends $6813aa9d7dc8ab1a$var$E {
    /**
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.CSS = {
            inlineToolbar: "ce-inline-toolbar"
        }, this.opened = !1, this.popover = null, this.toolbarVerticalMargin = $6813aa9d7dc8ab1a$var$be() ? 20 : 6, this.tools = /* @__PURE__ */ new Map(), window.requestIdleCallback(()=>{
            this.make();
        }, {
            timeout: 2e3
        });
    }
    /**
   *  Moving / appearance
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Shows Inline Toolbar if something is selected
   *
   * @param [needToClose] - pass true to close toolbar if it is not allowed.
   *                                  Avoid to use it just for closing IT, better call .close() clearly.
   */ async tryToShow(e = !1) {
        e && this.close(), this.allowedToShow() && (await this.open(), this.Editor.Toolbar.close());
    }
    /**
   * Hides Inline Toolbar
   */ close() {
        var e, t1;
        if (this.opened) {
            for (const [o, i] of this.tools){
                const s = this.getToolShortcut(o.name);
                s !== void 0 && $6813aa9d7dc8ab1a$var$ge.remove(this.Editor.UI.nodes.redactor, s), $6813aa9d7dc8ab1a$var$A(i.clear) && i.clear();
            }
            this.tools = /* @__PURE__ */ new Map(), this.reset(), this.opened = !1, (e = this.popover) == null || e.hide(), (t1 = this.popover) == null || t1.destroy(), this.popover = null;
        }
    }
    /**
   * Check if node is contained by Inline Toolbar
   *
   * @param {Node} node — node to check
   */ containsNode(e) {
        return this.nodes.wrapper === void 0 ? !1 : this.nodes.wrapper.contains(e);
    }
    /**
   * Removes UI and its components
   */ destroy() {
        var e;
        this.removeAllNodes(), (e = this.popover) == null || e.destroy(), this.popover = null;
    }
    /**
   * Making DOM
   */ make() {
        this.nodes.wrapper = $6813aa9d7dc8ab1a$var$u.make("div", [
            this.CSS.inlineToolbar,
            ...this.isRtl ? [
                this.Editor.UI.CSS.editorRtlFix
            ] : []
        ]), $6813aa9d7dc8ab1a$var$u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
    }
    /**
   * Shows Inline Toolbar
   */ async open() {
        var t1;
        if (this.opened) return;
        this.opened = !0, this.popover !== null && this.popover.destroy(), this.createToolsInstances();
        const e = await this.getPopoverItems();
        this.popover = new $6813aa9d7dc8ab1a$var$hs({
            items: e,
            scopeElement: this.Editor.API.methods.ui.nodes.redactor,
            messages: {
                nothingFound: $6813aa9d7dc8ab1a$var$z.ui($6813aa9d7dc8ab1a$var$K.ui.popover, "Nothing found"),
                search: $6813aa9d7dc8ab1a$var$z.ui($6813aa9d7dc8ab1a$var$K.ui.popover, "Filter")
            }
        }), this.move(this.popover.size.width), (t1 = this.nodes.wrapper) == null || t1.append(this.popover.getElement()), this.popover.show();
    }
    /**
   * Move Toolbar to the selected text
   *
   * @param popoverWidth - width of the toolbar popover
   */ move(e) {
        const t1 = $6813aa9d7dc8ab1a$var$b.rect, o = this.Editor.UI.nodes.wrapper.getBoundingClientRect(), i = {
            x: t1.x - o.x,
            y: t1.y + t1.height - // + window.scrollY
            o.top + this.toolbarVerticalMargin
        };
        i.x + e + o.x > this.Editor.UI.contentRect.right && (i.x = this.Editor.UI.contentRect.right - e - o.x), this.nodes.wrapper.style.left = Math.floor(i.x) + "px", this.nodes.wrapper.style.top = Math.floor(i.y) + "px";
    }
    /**
   * Clear orientation classes and reset position
   */ reset() {
        this.nodes.wrapper.style.left = "0", this.nodes.wrapper.style.top = "0";
    }
    /**
   * Need to show Inline Toolbar or not
   */ allowedToShow() {
        const e = [
            "IMG",
            "INPUT"
        ], t1 = $6813aa9d7dc8ab1a$var$b.get(), o = $6813aa9d7dc8ab1a$var$b.text;
        if (!t1 || !t1.anchorNode || t1.isCollapsed || o.length < 1) return !1;
        const i = $6813aa9d7dc8ab1a$var$u.isElement(t1.anchorNode) ? t1.anchorNode : t1.anchorNode.parentElement;
        if (i === null || t1 !== null && e.includes(i.tagName)) return !1;
        const s = this.Editor.BlockManager.getBlock(t1.anchorNode);
        return !s || this.getTools().some((c)=>s.tool.inlineTools.has(c.name)) === !1 ? !1 : i.closest("[contenteditable]") !== null;
    }
    /**
   *  Working with Tools
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Returns tools that are available for current block
   *
   * Used to check if Inline Toolbar could be shown
   * and to render tools in the Inline Toolbar
   */ getTools() {
        const e = this.Editor.BlockManager.currentBlock;
        return e ? Array.from(e.tool.inlineTools.values()).filter((o)=>!(this.Editor.ReadOnly.isEnabled && o.isReadOnlySupported !== !0)) : [];
    }
    /**
   * Constructs tools instances and saves them to this.tools
   */ createToolsInstances() {
        this.tools = /* @__PURE__ */ new Map(), this.getTools().forEach((t1)=>{
            const o = t1.create();
            this.tools.set(t1, o);
        });
    }
    /**
   * Returns Popover Items for tools segregated by their appearance type: regular items and custom html elements.
   */ async getPopoverItems() {
        const e = [];
        let t1 = 0;
        for (const [o, i] of this.tools){
            const s = await i.render(), r = this.getToolShortcut(o.name);
            if (r !== void 0) try {
                this.enableShortcuts(o.name, r);
            } catch  {}
            const a = r !== void 0 ? $6813aa9d7dc8ab1a$var$vt(r) : void 0, l = $6813aa9d7dc8ab1a$var$z.t($6813aa9d7dc8ab1a$var$K.toolNames, o.title || $6813aa9d7dc8ab1a$var$je(o.name));
            [
                s
            ].flat().forEach((c)=>{
                var h, p;
                const d = {
                    name: o.name,
                    onActivate: ()=>{
                        this.toolClicked(i);
                    },
                    hint: {
                        title: l,
                        description: a
                    }
                };
                if ($6813aa9d7dc8ab1a$var$u.isElement(c)) {
                    const g = {
                        ...d,
                        element: c,
                        type: $6813aa9d7dc8ab1a$var$_.Html
                    };
                    if ($6813aa9d7dc8ab1a$var$A(i.renderActions)) {
                        const f = i.renderActions();
                        g.children = {
                            isOpen: (h = i.checkState) == null ? void 0 : h.call(i, $6813aa9d7dc8ab1a$var$b.get()),
                            /** Disable keyboard navigation in actions, as it might conflict with enter press handling */ isFlippable: !1,
                            items: [
                                {
                                    type: $6813aa9d7dc8ab1a$var$_.Html,
                                    element: f
                                }
                            ]
                        };
                    } else (p = i.checkState) == null || p.call(i, $6813aa9d7dc8ab1a$var$b.get());
                    e.push(g);
                } else if (c.type === $6813aa9d7dc8ab1a$var$_.Html) e.push({
                    ...d,
                    ...c,
                    type: $6813aa9d7dc8ab1a$var$_.Html
                });
                else if (c.type === $6813aa9d7dc8ab1a$var$_.Separator) e.push({
                    type: $6813aa9d7dc8ab1a$var$_.Separator
                });
                else {
                    const g = {
                        ...d,
                        ...c,
                        type: $6813aa9d7dc8ab1a$var$_.Default
                    };
                    "children" in g && t1 !== 0 && e.push({
                        type: $6813aa9d7dc8ab1a$var$_.Separator
                    }), e.push(g), "children" in g && t1 < this.tools.size - 1 && e.push({
                        type: $6813aa9d7dc8ab1a$var$_.Separator
                    });
                }
            }), t1++;
        }
        return e;
    }
    /**
   * Get shortcut name for tool
   *
   * @param toolName — Tool name
   */ getToolShortcut(e) {
        const { Tools: t1 } = this.Editor, o = t1.inlineTools.get(e), i = t1.internal.inlineTools;
        return Array.from(i.keys()).includes(e) ? this.inlineTools[e][$6813aa9d7dc8ab1a$var$cn.Shortcut] : o == null ? void 0 : o.shortcut;
    }
    /**
   * Enable Tool shortcut with Editor Shortcuts Module
   *
   * @param toolName - tool name
   * @param shortcut - shortcut according to the ShortcutData Module format
   */ enableShortcuts(e, t1) {
        $6813aa9d7dc8ab1a$var$ge.add({
            name: t1,
            handler: (o)=>{
                var s;
                const { currentBlock: i } = this.Editor.BlockManager;
                i && i.tool.enabledInlineTools && (o.preventDefault(), (s = this.popover) == null || s.activateItemByName(e));
            },
            /**
       * We need to bind shortcut to the document to make it work in read-only mode
       */ on: document
        });
    }
    /**
   * Inline Tool button clicks
   *
   * @param tool - Tool's instance
   */ toolClicked(e) {
        var o;
        const t1 = $6813aa9d7dc8ab1a$var$b.range;
        (o = e.surround) == null || o.call(e, t1), this.checkToolsState();
    }
    /**
   * Check Tools` state by selection
   */ checkToolsState() {
        var e;
        (e = this.tools) == null || e.forEach((t1)=>{
            var o;
            (o = t1.checkState) == null || o.call(t1, $6813aa9d7dc8ab1a$var$b.get());
        });
    }
    /**
   * Get inline tools tools
   * Tools that has isInline is true
   */ get inlineTools() {
        const e = {};
        return Array.from(this.Editor.Tools.inlineTools.entries()).forEach(([t1, o])=>{
            e[t1] = o.create();
        }), e;
    }
}
function $6813aa9d7dc8ab1a$var$dn() {
    const n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    let e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], t1 = e.textContent.length)), [
        e,
        t1
    ]);
}
function $6813aa9d7dc8ab1a$var$un(n, e, t1, o) {
    const i = document.createRange();
    o === "left" ? (i.setStart(n, 0), i.setEnd(e, t1)) : (i.setStart(e, t1), i.setEnd(n, n.childNodes.length));
    const s = i.cloneContents(), r = document.createElement("div");
    r.appendChild(s);
    const a = r.textContent || "";
    return $6813aa9d7dc8ab1a$var$ai(a);
}
function $6813aa9d7dc8ab1a$var$Ne(n) {
    const e = $6813aa9d7dc8ab1a$var$u.getDeepestNode(n);
    if (e === null || $6813aa9d7dc8ab1a$var$u.isEmpty(n)) return !0;
    if ($6813aa9d7dc8ab1a$var$u.isNativeInput(e)) return e.selectionEnd === 0;
    if ($6813aa9d7dc8ab1a$var$u.isEmpty(n)) return !0;
    const [t1, o] = $6813aa9d7dc8ab1a$var$dn();
    return t1 === null ? !1 : $6813aa9d7dc8ab1a$var$un(n, t1, o, "left");
}
function $6813aa9d7dc8ab1a$var$Re(n) {
    const e = $6813aa9d7dc8ab1a$var$u.getDeepestNode(n, !0);
    if (e === null) return !0;
    if ($6813aa9d7dc8ab1a$var$u.isNativeInput(e)) return e.selectionEnd === e.value.length;
    const [t1, o] = $6813aa9d7dc8ab1a$var$dn();
    return t1 === null ? !1 : $6813aa9d7dc8ab1a$var$un(n, t1, o, "right");
}
var $6813aa9d7dc8ab1a$var$hn = {}, $6813aa9d7dc8ab1a$var$St = {}, $6813aa9d7dc8ab1a$var$Xe = {}, $6813aa9d7dc8ab1a$var$de = {}, $6813aa9d7dc8ab1a$var$It = {}, $6813aa9d7dc8ab1a$var$Ot = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$Ot, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Ot.allInputsSelector = $6813aa9d7dc8ab1a$var$Ts;
function $6813aa9d7dc8ab1a$var$Ts() {
    var n = [
        "text",
        "password",
        "email",
        "number",
        "search",
        "tel",
        "url"
    ];
    return "[contenteditable=true], textarea, input:not([type]), " + n.map(function(e) {
        return 'input[type="'.concat(e, '"]');
    }).join(", ");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.allInputsSelector = void 0;
    var e = $6813aa9d7dc8ab1a$var$Ot;
    Object.defineProperty(n, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return e.allInputsSelector;
        }
    });
})($6813aa9d7dc8ab1a$var$It);
var $6813aa9d7dc8ab1a$var$ue = {}, $6813aa9d7dc8ab1a$var$_t = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$_t, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$_t.isNativeInput = $6813aa9d7dc8ab1a$var$Ss;
function $6813aa9d7dc8ab1a$var$Ss(n) {
    var e = [
        "INPUT",
        "TEXTAREA"
    ];
    return n && n.tagName ? e.includes(n.tagName) : !1;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isNativeInput = void 0;
    var e = $6813aa9d7dc8ab1a$var$_t;
    Object.defineProperty(n, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return e.isNativeInput;
        }
    });
})($6813aa9d7dc8ab1a$var$ue);
var $6813aa9d7dc8ab1a$var$pn = {}, $6813aa9d7dc8ab1a$var$Mt = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$Mt, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Mt.append = $6813aa9d7dc8ab1a$var$Is;
function $6813aa9d7dc8ab1a$var$Is(n, e) {
    Array.isArray(e) ? e.forEach(function(t1) {
        n.appendChild(t1);
    }) : n.appendChild(e);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.append = void 0;
    var e = $6813aa9d7dc8ab1a$var$Mt;
    Object.defineProperty(n, "append", {
        enumerable: !0,
        get: function() {
            return e.append;
        }
    });
})($6813aa9d7dc8ab1a$var$pn);
var $6813aa9d7dc8ab1a$var$At = {}, $6813aa9d7dc8ab1a$var$Lt = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$Lt, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Lt.blockElements = $6813aa9d7dc8ab1a$var$Os;
function $6813aa9d7dc8ab1a$var$Os() {
    return [
        "address",
        "article",
        "aside",
        "blockquote",
        "canvas",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "noscript",
        "ol",
        "output",
        "p",
        "pre",
        "ruby",
        "section",
        "table",
        "tbody",
        "thead",
        "tr",
        "tfoot",
        "ul",
        "video"
    ];
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.blockElements = void 0;
    var e = $6813aa9d7dc8ab1a$var$Lt;
    Object.defineProperty(n, "blockElements", {
        enumerable: !0,
        get: function() {
            return e.blockElements;
        }
    });
})($6813aa9d7dc8ab1a$var$At);
var $6813aa9d7dc8ab1a$var$fn = {}, $6813aa9d7dc8ab1a$var$Pt = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$Pt, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Pt.calculateBaseline = $6813aa9d7dc8ab1a$var$_s;
function $6813aa9d7dc8ab1a$var$_s(n) {
    var e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), a = t1 * 0.8, l = (o - t1) / 2, c = r + s + i + l + a;
    return c;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.calculateBaseline = void 0;
    var e = $6813aa9d7dc8ab1a$var$Pt;
    Object.defineProperty(n, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return e.calculateBaseline;
        }
    });
})($6813aa9d7dc8ab1a$var$fn);
var $6813aa9d7dc8ab1a$var$gn = {}, $6813aa9d7dc8ab1a$var$Nt = {}, $6813aa9d7dc8ab1a$var$Rt = {}, $6813aa9d7dc8ab1a$var$Dt = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$Dt, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Dt.isContentEditable = $6813aa9d7dc8ab1a$var$Ms;
function $6813aa9d7dc8ab1a$var$Ms(n) {
    return n.contentEditable === "true";
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isContentEditable = void 0;
    var e = $6813aa9d7dc8ab1a$var$Dt;
    Object.defineProperty(n, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return e.isContentEditable;
        }
    });
})($6813aa9d7dc8ab1a$var$Rt);
Object.defineProperty($6813aa9d7dc8ab1a$var$Nt, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Nt.canSetCaret = $6813aa9d7dc8ab1a$var$Ps;
var $6813aa9d7dc8ab1a$var$As = $6813aa9d7dc8ab1a$var$ue, $6813aa9d7dc8ab1a$var$Ls = $6813aa9d7dc8ab1a$var$Rt;
function $6813aa9d7dc8ab1a$var$Ps(n) {
    var e = !0;
    if ((0, $6813aa9d7dc8ab1a$var$As.isNativeInput)(n)) switch(n.type){
        case "file":
        case "checkbox":
        case "radio":
        case "hidden":
        case "submit":
        case "button":
        case "image":
        case "reset":
            e = !1;
            break;
    }
    else e = (0, $6813aa9d7dc8ab1a$var$Ls.isContentEditable)(n);
    return e;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.canSetCaret = void 0;
    var e = $6813aa9d7dc8ab1a$var$Nt;
    Object.defineProperty(n, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return e.canSetCaret;
        }
    });
})($6813aa9d7dc8ab1a$var$gn);
var $6813aa9d7dc8ab1a$var$Ve = {}, $6813aa9d7dc8ab1a$var$Ft = {};
function $6813aa9d7dc8ab1a$var$Ns(n, e, t1) {
    const o = t1.value !== void 0 ? "value" : "get", i = t1[o], s = `#${e}Cache`;
    if (t1[o] = function(...r) {
        return this[s] === void 0 && (this[s] = i.apply(this, r)), this[s];
    }, o === "get" && t1.set) {
        const r = t1.set;
        t1.set = function(a) {
            delete n[s], r.apply(this, a);
        };
    }
    return t1;
}
function $6813aa9d7dc8ab1a$var$mn() {
    const n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find((t1)=>window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1);
    return e !== void 0 && (n[e] = !0), n;
}
function $6813aa9d7dc8ab1a$var$jt(n) {
    return n != null && n !== "" && (typeof n != "object" || Object.keys(n).length > 0);
}
function $6813aa9d7dc8ab1a$var$Rs(n) {
    return !$6813aa9d7dc8ab1a$var$jt(n);
}
const $6813aa9d7dc8ab1a$var$Ds = ()=>typeof window < "u" && window.navigator !== null && $6813aa9d7dc8ab1a$var$jt(window.navigator.platform) && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $6813aa9d7dc8ab1a$var$Fs(n) {
    const e = $6813aa9d7dc8ab1a$var$mn();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, "+"), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $6813aa9d7dc8ab1a$var$js(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $6813aa9d7dc8ab1a$var$Hs(n) {
    const e = document.createElement("div");
    e.style.position = "absolute", e.style.left = "-999px", e.style.bottom = "-999px", e.innerHTML = n, document.body.appendChild(e);
    const t1 = window.getSelection(), o = document.createRange();
    if (o.selectNode(e), t1 === null) throw new Error("Cannot copy text to clipboard");
    t1.removeAllRanges(), t1.addRange(o), document.execCommand("copy"), document.body.removeChild(e);
}
function $6813aa9d7dc8ab1a$var$$s(n, e, t1) {
    let o;
    return (...i)=>{
        const s = this, r = ()=>{
            o = void 0, t1 !== !0 && n.apply(s, i);
        }, a = t1 === !0 && o !== void 0;
        window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
    };
}
function $6813aa9d7dc8ab1a$var$oe(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $6813aa9d7dc8ab1a$var$zs(n) {
    return $6813aa9d7dc8ab1a$var$oe(n) === "boolean";
}
function $6813aa9d7dc8ab1a$var$bn(n) {
    return $6813aa9d7dc8ab1a$var$oe(n) === "function" || $6813aa9d7dc8ab1a$var$oe(n) === "asyncfunction";
}
function $6813aa9d7dc8ab1a$var$Us(n) {
    return $6813aa9d7dc8ab1a$var$bn(n) && /^\s*class\s+/.test(n.toString());
}
function $6813aa9d7dc8ab1a$var$Ws(n) {
    return $6813aa9d7dc8ab1a$var$oe(n) === "number";
}
function $6813aa9d7dc8ab1a$var$De(n) {
    return $6813aa9d7dc8ab1a$var$oe(n) === "object";
}
function $6813aa9d7dc8ab1a$var$Ys(n) {
    return Promise.resolve(n) === n;
}
function $6813aa9d7dc8ab1a$var$Ks(n) {
    return $6813aa9d7dc8ab1a$var$oe(n) === "string";
}
function $6813aa9d7dc8ab1a$var$Xs(n) {
    return $6813aa9d7dc8ab1a$var$oe(n) === "undefined";
}
function $6813aa9d7dc8ab1a$var$bt(n, ...e) {
    if (!e.length) return n;
    const t1 = e.shift();
    if ($6813aa9d7dc8ab1a$var$De(n) && $6813aa9d7dc8ab1a$var$De(t1)) for(const o in t1)$6813aa9d7dc8ab1a$var$De(t1[o]) ? (n[o] === void 0 && Object.assign(n, {
        [o]: {}
    }), $6813aa9d7dc8ab1a$var$bt(n[o], t1[o])) : Object.assign(n, {
        [o]: t1[o]
    });
    return $6813aa9d7dc8ab1a$var$bt(n, ...e);
}
function $6813aa9d7dc8ab1a$var$Vs(n, e, t1) {
    const o = `\xab${e}\xbb is deprecated and will be removed in the next major release. Please use the \xab${t1}\xbb instead.`;
    n && console.warn(o);
}
function $6813aa9d7dc8ab1a$var$qs(n) {
    try {
        return new URL(n).href;
    } catch  {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $6813aa9d7dc8ab1a$var$Zs(n) {
    return n > 47 && n < 58 || n === 32 || n === 13 || n === 229 || n > 64 && n < 91 || n > 95 && n < 112 || n > 185 && n < 193 || n > 218 && n < 223;
}
const $6813aa9d7dc8ab1a$var$Gs = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $6813aa9d7dc8ab1a$var$Qs = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
let $6813aa9d7dc8ab1a$var$Js = class {
    constructor(){
        this.completed = Promise.resolve();
    }
    /**
   * Add new promise to queue
   * @param operation - promise should be added to queue
   */ add(e) {
        return new Promise((t1, o)=>{
            this.completed = this.completed.then(e).then(t1).catch(o);
        });
    }
};
function $6813aa9d7dc8ab1a$var$er(n, e, t1) {
    let o, i, s, r = null, a = 0;
    t1 || (t1 = {});
    const l = function() {
        a = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r === null && (o = i = null);
    };
    return function() {
        const c = Date.now();
        !a && t1.leading === !1 && (a = c);
        const d = e - (c - a);
        return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r === null && (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(l, d)), s;
    };
}
const $6813aa9d7dc8ab1a$var$tr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    PromiseQueue: $6813aa9d7dc8ab1a$var$Js,
    beautifyShortcut: $6813aa9d7dc8ab1a$var$Fs,
    cacheable: $6813aa9d7dc8ab1a$var$Ns,
    capitalize: $6813aa9d7dc8ab1a$var$js,
    copyTextToClipboard: $6813aa9d7dc8ab1a$var$Hs,
    debounce: $6813aa9d7dc8ab1a$var$$s,
    deepMerge: $6813aa9d7dc8ab1a$var$bt,
    deprecationAssert: $6813aa9d7dc8ab1a$var$Vs,
    getUserOS: $6813aa9d7dc8ab1a$var$mn,
    getValidUrl: $6813aa9d7dc8ab1a$var$qs,
    isBoolean: $6813aa9d7dc8ab1a$var$zs,
    isClass: $6813aa9d7dc8ab1a$var$Us,
    isEmpty: $6813aa9d7dc8ab1a$var$Rs,
    isFunction: $6813aa9d7dc8ab1a$var$bn,
    isIosDevice: $6813aa9d7dc8ab1a$var$Ds,
    isNumber: $6813aa9d7dc8ab1a$var$Ws,
    isObject: $6813aa9d7dc8ab1a$var$De,
    isPrintableKey: $6813aa9d7dc8ab1a$var$Zs,
    isPromise: $6813aa9d7dc8ab1a$var$Ys,
    isString: $6813aa9d7dc8ab1a$var$Ks,
    isUndefined: $6813aa9d7dc8ab1a$var$Xs,
    keyCodes: $6813aa9d7dc8ab1a$var$Gs,
    mouseButtons: $6813aa9d7dc8ab1a$var$Qs,
    notEmpty: $6813aa9d7dc8ab1a$var$jt,
    throttle: $6813aa9d7dc8ab1a$var$er,
    typeOf: $6813aa9d7dc8ab1a$var$oe
}, Symbol.toStringTag, {
    value: "Module"
})), $6813aa9d7dc8ab1a$var$Ht = /* @__PURE__ */ $6813aa9d7dc8ab1a$var$Xn($6813aa9d7dc8ab1a$var$tr);
Object.defineProperty($6813aa9d7dc8ab1a$var$Ft, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Ft.containsOnlyInlineElements = $6813aa9d7dc8ab1a$var$ir;
var $6813aa9d7dc8ab1a$var$or = $6813aa9d7dc8ab1a$var$Ht, $6813aa9d7dc8ab1a$var$nr = $6813aa9d7dc8ab1a$var$At;
function $6813aa9d7dc8ab1a$var$ir(n) {
    var e;
    (0, $6813aa9d7dc8ab1a$var$or.isString)(n) ? (e = document.createElement("div"), e.innerHTML = n) : e = n;
    var t1 = function(o) {
        return !(0, $6813aa9d7dc8ab1a$var$nr.blockElements)().includes(o.tagName.toLowerCase()) && Array.from(o.children).every(t1);
    };
    return Array.from(e.children).every(t1);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.containsOnlyInlineElements = void 0;
    var e = $6813aa9d7dc8ab1a$var$Ft;
    Object.defineProperty(n, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return e.containsOnlyInlineElements;
        }
    });
})($6813aa9d7dc8ab1a$var$Ve);
var $6813aa9d7dc8ab1a$var$vn = {}, $6813aa9d7dc8ab1a$var$$t = {}, $6813aa9d7dc8ab1a$var$qe = {}, $6813aa9d7dc8ab1a$var$zt = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$zt, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$zt.make = $6813aa9d7dc8ab1a$var$sr;
function $6813aa9d7dc8ab1a$var$sr(n, e, t1) {
    var o;
    e === void 0 && (e = null), t1 === void 0 && (t1 = {});
    var i = document.createElement(n);
    if (Array.isArray(e)) {
        var s = e.filter(function(a) {
            return a !== void 0;
        });
        (o = i.classList).add.apply(o, s);
    } else e !== null && i.classList.add(e);
    for(var r in t1)Object.prototype.hasOwnProperty.call(t1, r) && (i[r] = t1[r]);
    return i;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.make = void 0;
    var e = $6813aa9d7dc8ab1a$var$zt;
    Object.defineProperty(n, "make", {
        enumerable: !0,
        get: function() {
            return e.make;
        }
    });
})($6813aa9d7dc8ab1a$var$qe);
Object.defineProperty($6813aa9d7dc8ab1a$var$$t, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$$t.fragmentToString = $6813aa9d7dc8ab1a$var$ar;
var $6813aa9d7dc8ab1a$var$rr = $6813aa9d7dc8ab1a$var$qe;
function $6813aa9d7dc8ab1a$var$ar(n) {
    var e = (0, $6813aa9d7dc8ab1a$var$rr.make)("div");
    return e.appendChild(n), e.innerHTML;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.fragmentToString = void 0;
    var e = $6813aa9d7dc8ab1a$var$$t;
    Object.defineProperty(n, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return e.fragmentToString;
        }
    });
})($6813aa9d7dc8ab1a$var$vn);
var $6813aa9d7dc8ab1a$var$kn = {}, $6813aa9d7dc8ab1a$var$Ut = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$Ut, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Ut.getContentLength = $6813aa9d7dc8ab1a$var$cr;
var $6813aa9d7dc8ab1a$var$lr = $6813aa9d7dc8ab1a$var$ue;
function $6813aa9d7dc8ab1a$var$cr(n) {
    var e, t1;
    return (0, $6813aa9d7dc8ab1a$var$lr.isNativeInput)(n) ? n.value.length : n.nodeType === Node.TEXT_NODE ? n.length : (t1 = (e = n.textContent) === null || e === void 0 ? void 0 : e.length) !== null && t1 !== void 0 ? t1 : 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getContentLength = void 0;
    var e = $6813aa9d7dc8ab1a$var$Ut;
    Object.defineProperty(n, "getContentLength", {
        enumerable: !0,
        get: function() {
            return e.getContentLength;
        }
    });
})($6813aa9d7dc8ab1a$var$kn);
var $6813aa9d7dc8ab1a$var$Wt = {}, $6813aa9d7dc8ab1a$var$Yt = {}, $6813aa9d7dc8ab1a$var$Io = $6813aa9d7dc8ab1a$var$Ce && $6813aa9d7dc8ab1a$var$Ce.__spreadArray || function(n, e, t1) {
    if (t1 || arguments.length === 2) for(var o = 0, i = e.length, s; o < i; o++)(s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
    return n.concat(s || Array.prototype.slice.call(e));
};
Object.defineProperty($6813aa9d7dc8ab1a$var$Yt, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Yt.getDeepestBlockElements = $6813aa9d7dc8ab1a$var$yn;
var $6813aa9d7dc8ab1a$var$dr = $6813aa9d7dc8ab1a$var$Ve;
function $6813aa9d7dc8ab1a$var$yn(n) {
    return (0, $6813aa9d7dc8ab1a$var$dr.containsOnlyInlineElements)(n) ? [
        n
    ] : Array.from(n.children).reduce(function(e, t1) {
        return $6813aa9d7dc8ab1a$var$Io($6813aa9d7dc8ab1a$var$Io([], e, !0), $6813aa9d7dc8ab1a$var$yn(t1), !0);
    }, []);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getDeepestBlockElements = void 0;
    var e = $6813aa9d7dc8ab1a$var$Yt;
    Object.defineProperty(n, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return e.getDeepestBlockElements;
        }
    });
})($6813aa9d7dc8ab1a$var$Wt);
var $6813aa9d7dc8ab1a$var$wn = {}, $6813aa9d7dc8ab1a$var$Kt = {}, $6813aa9d7dc8ab1a$var$Ze = {}, $6813aa9d7dc8ab1a$var$Xt = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$Xt, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Xt.isLineBreakTag = $6813aa9d7dc8ab1a$var$ur;
function $6813aa9d7dc8ab1a$var$ur(n) {
    return [
        "BR",
        "WBR"
    ].includes(n.tagName);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isLineBreakTag = void 0;
    var e = $6813aa9d7dc8ab1a$var$Xt;
    Object.defineProperty(n, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return e.isLineBreakTag;
        }
    });
})($6813aa9d7dc8ab1a$var$Ze);
var $6813aa9d7dc8ab1a$var$Ge = {}, $6813aa9d7dc8ab1a$var$Vt = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$Vt, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Vt.isSingleTag = $6813aa9d7dc8ab1a$var$hr;
function $6813aa9d7dc8ab1a$var$hr(n) {
    return [
        "AREA",
        "BASE",
        "BR",
        "COL",
        "COMMAND",
        "EMBED",
        "HR",
        "IMG",
        "INPUT",
        "KEYGEN",
        "LINK",
        "META",
        "PARAM",
        "SOURCE",
        "TRACK",
        "WBR"
    ].includes(n.tagName);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isSingleTag = void 0;
    var e = $6813aa9d7dc8ab1a$var$Vt;
    Object.defineProperty(n, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return e.isSingleTag;
        }
    });
})($6813aa9d7dc8ab1a$var$Ge);
Object.defineProperty($6813aa9d7dc8ab1a$var$Kt, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Kt.getDeepestNode = $6813aa9d7dc8ab1a$var$En;
var $6813aa9d7dc8ab1a$var$pr = $6813aa9d7dc8ab1a$var$ue, $6813aa9d7dc8ab1a$var$fr = $6813aa9d7dc8ab1a$var$Ze, $6813aa9d7dc8ab1a$var$gr = $6813aa9d7dc8ab1a$var$Ge;
function $6813aa9d7dc8ab1a$var$En(n, e) {
    e === void 0 && (e = !1);
    var t1 = e ? "lastChild" : "firstChild", o = e ? "previousSibling" : "nextSibling";
    if (n.nodeType === Node.ELEMENT_NODE && n[t1]) {
        var i = n[t1];
        if ((0, $6813aa9d7dc8ab1a$var$gr.isSingleTag)(i) && !(0, $6813aa9d7dc8ab1a$var$pr.isNativeInput)(i) && !(0, $6813aa9d7dc8ab1a$var$fr.isLineBreakTag)(i)) {
            if (i[o]) i = i[o];
            else if (i.parentNode !== null && i.parentNode[o]) i = i.parentNode[o];
            else return i.parentNode;
        }
        return $6813aa9d7dc8ab1a$var$En(i, e);
    }
    return n;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getDeepestNode = void 0;
    var e = $6813aa9d7dc8ab1a$var$Kt;
    Object.defineProperty(n, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return e.getDeepestNode;
        }
    });
})($6813aa9d7dc8ab1a$var$wn);
var $6813aa9d7dc8ab1a$var$xn = {}, $6813aa9d7dc8ab1a$var$qt = {}, $6813aa9d7dc8ab1a$var$Me = $6813aa9d7dc8ab1a$var$Ce && $6813aa9d7dc8ab1a$var$Ce.__spreadArray || function(n, e, t1) {
    if (t1 || arguments.length === 2) for(var o = 0, i = e.length, s; o < i; o++)(s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
    return n.concat(s || Array.prototype.slice.call(e));
};
Object.defineProperty($6813aa9d7dc8ab1a$var$qt, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$qt.findAllInputs = $6813aa9d7dc8ab1a$var$yr;
var $6813aa9d7dc8ab1a$var$mr = $6813aa9d7dc8ab1a$var$Ve, $6813aa9d7dc8ab1a$var$br = $6813aa9d7dc8ab1a$var$Wt, $6813aa9d7dc8ab1a$var$vr = $6813aa9d7dc8ab1a$var$It, $6813aa9d7dc8ab1a$var$kr = $6813aa9d7dc8ab1a$var$ue;
function $6813aa9d7dc8ab1a$var$yr(n) {
    return Array.from(n.querySelectorAll((0, $6813aa9d7dc8ab1a$var$vr.allInputsSelector)())).reduce(function(e, t1) {
        return (0, $6813aa9d7dc8ab1a$var$kr.isNativeInput)(t1) || (0, $6813aa9d7dc8ab1a$var$mr.containsOnlyInlineElements)(t1) ? $6813aa9d7dc8ab1a$var$Me($6813aa9d7dc8ab1a$var$Me([], e, !0), [
            t1
        ], !1) : $6813aa9d7dc8ab1a$var$Me($6813aa9d7dc8ab1a$var$Me([], e, !0), (0, $6813aa9d7dc8ab1a$var$br.getDeepestBlockElements)(t1), !0);
    }, []);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.findAllInputs = void 0;
    var e = $6813aa9d7dc8ab1a$var$qt;
    Object.defineProperty(n, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return e.findAllInputs;
        }
    });
})($6813aa9d7dc8ab1a$var$xn);
var $6813aa9d7dc8ab1a$var$Bn = {}, $6813aa9d7dc8ab1a$var$Zt = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$Zt, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Zt.isCollapsedWhitespaces = $6813aa9d7dc8ab1a$var$wr;
function $6813aa9d7dc8ab1a$var$wr(n) {
    return !/[^\t\n\r ]/.test(n);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCollapsedWhitespaces = void 0;
    var e = $6813aa9d7dc8ab1a$var$Zt;
    Object.defineProperty(n, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return e.isCollapsedWhitespaces;
        }
    });
})($6813aa9d7dc8ab1a$var$Bn);
var $6813aa9d7dc8ab1a$var$Gt = {}, $6813aa9d7dc8ab1a$var$Qt = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$Qt, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Qt.isElement = $6813aa9d7dc8ab1a$var$xr;
var $6813aa9d7dc8ab1a$var$Er = $6813aa9d7dc8ab1a$var$Ht;
function $6813aa9d7dc8ab1a$var$xr(n) {
    return (0, $6813aa9d7dc8ab1a$var$Er.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.ELEMENT_NODE;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isElement = void 0;
    var e = $6813aa9d7dc8ab1a$var$Qt;
    Object.defineProperty(n, "isElement", {
        enumerable: !0,
        get: function() {
            return e.isElement;
        }
    });
})($6813aa9d7dc8ab1a$var$Gt);
var $6813aa9d7dc8ab1a$var$Cn = {}, $6813aa9d7dc8ab1a$var$Jt = {}, $6813aa9d7dc8ab1a$var$eo = {}, $6813aa9d7dc8ab1a$var$to = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$to, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$to.isLeaf = $6813aa9d7dc8ab1a$var$Br;
function $6813aa9d7dc8ab1a$var$Br(n) {
    return n === null ? !1 : n.childNodes.length === 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isLeaf = void 0;
    var e = $6813aa9d7dc8ab1a$var$to;
    Object.defineProperty(n, "isLeaf", {
        enumerable: !0,
        get: function() {
            return e.isLeaf;
        }
    });
})($6813aa9d7dc8ab1a$var$eo);
var $6813aa9d7dc8ab1a$var$oo = {}, $6813aa9d7dc8ab1a$var$no = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$no, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$no.isNodeEmpty = $6813aa9d7dc8ab1a$var$Or;
var $6813aa9d7dc8ab1a$var$Cr = $6813aa9d7dc8ab1a$var$Ze, $6813aa9d7dc8ab1a$var$Tr = $6813aa9d7dc8ab1a$var$Gt, $6813aa9d7dc8ab1a$var$Sr = $6813aa9d7dc8ab1a$var$ue, $6813aa9d7dc8ab1a$var$Ir = $6813aa9d7dc8ab1a$var$Ge;
function $6813aa9d7dc8ab1a$var$Or(n, e) {
    var t1 = "";
    return (0, $6813aa9d7dc8ab1a$var$Ir.isSingleTag)(n) && !(0, $6813aa9d7dc8ab1a$var$Cr.isLineBreakTag)(n) ? !1 : ((0, $6813aa9d7dc8ab1a$var$Tr.isElement)(n) && (0, $6813aa9d7dc8ab1a$var$Sr.isNativeInput)(n) ? t1 = n.value : n.textContent !== null && (t1 = n.textContent.replace("\u200B", "")), e !== void 0 && (t1 = t1.replace(new RegExp(e, "g"), "")), t1.trim().length === 0);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isNodeEmpty = void 0;
    var e = $6813aa9d7dc8ab1a$var$no;
    Object.defineProperty(n, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return e.isNodeEmpty;
        }
    });
})($6813aa9d7dc8ab1a$var$oo);
Object.defineProperty($6813aa9d7dc8ab1a$var$Jt, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Jt.isEmpty = $6813aa9d7dc8ab1a$var$Ar;
var $6813aa9d7dc8ab1a$var$_r = $6813aa9d7dc8ab1a$var$eo, $6813aa9d7dc8ab1a$var$Mr = $6813aa9d7dc8ab1a$var$oo;
function $6813aa9d7dc8ab1a$var$Ar(n, e) {
    n.normalize();
    for(var t1 = [
        n
    ]; t1.length > 0;){
        var o = t1.shift();
        if (o) {
            if (n = o, (0, $6813aa9d7dc8ab1a$var$_r.isLeaf)(n) && !(0, $6813aa9d7dc8ab1a$var$Mr.isNodeEmpty)(n, e)) return !1;
            t1.push.apply(t1, Array.from(n.childNodes));
        }
    }
    return !0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isEmpty = void 0;
    var e = $6813aa9d7dc8ab1a$var$Jt;
    Object.defineProperty(n, "isEmpty", {
        enumerable: !0,
        get: function() {
            return e.isEmpty;
        }
    });
})($6813aa9d7dc8ab1a$var$Cn);
var $6813aa9d7dc8ab1a$var$Tn = {}, $6813aa9d7dc8ab1a$var$io = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$io, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$io.isFragment = $6813aa9d7dc8ab1a$var$Pr;
var $6813aa9d7dc8ab1a$var$Lr = $6813aa9d7dc8ab1a$var$Ht;
function $6813aa9d7dc8ab1a$var$Pr(n) {
    return (0, $6813aa9d7dc8ab1a$var$Lr.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isFragment = void 0;
    var e = $6813aa9d7dc8ab1a$var$io;
    Object.defineProperty(n, "isFragment", {
        enumerable: !0,
        get: function() {
            return e.isFragment;
        }
    });
})($6813aa9d7dc8ab1a$var$Tn);
var $6813aa9d7dc8ab1a$var$Sn = {}, $6813aa9d7dc8ab1a$var$so = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$so, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$so.isHTMLString = $6813aa9d7dc8ab1a$var$Rr;
var $6813aa9d7dc8ab1a$var$Nr = $6813aa9d7dc8ab1a$var$qe;
function $6813aa9d7dc8ab1a$var$Rr(n) {
    var e = (0, $6813aa9d7dc8ab1a$var$Nr.make)("div");
    return e.innerHTML = n, e.childElementCount > 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isHTMLString = void 0;
    var e = $6813aa9d7dc8ab1a$var$so;
    Object.defineProperty(n, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return e.isHTMLString;
        }
    });
})($6813aa9d7dc8ab1a$var$Sn);
var $6813aa9d7dc8ab1a$var$In = {}, $6813aa9d7dc8ab1a$var$ro = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$ro, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$ro.offset = $6813aa9d7dc8ab1a$var$Dr;
function $6813aa9d7dc8ab1a$var$Dr(n) {
    var e = n.getBoundingClientRect(), t1 = window.pageXOffset || document.documentElement.scrollLeft, o = window.pageYOffset || document.documentElement.scrollTop, i = e.top + o, s = e.left + t1;
    return {
        top: i,
        left: s,
        bottom: i + e.height,
        right: s + e.width
    };
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.offset = void 0;
    var e = $6813aa9d7dc8ab1a$var$ro;
    Object.defineProperty(n, "offset", {
        enumerable: !0,
        get: function() {
            return e.offset;
        }
    });
})($6813aa9d7dc8ab1a$var$In);
var $6813aa9d7dc8ab1a$var$On = {}, $6813aa9d7dc8ab1a$var$ao = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$ao, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$ao.prepend = $6813aa9d7dc8ab1a$var$Fr;
function $6813aa9d7dc8ab1a$var$Fr(n, e) {
    Array.isArray(e) ? (e = e.reverse(), e.forEach(function(t1) {
        return n.prepend(t1);
    })) : n.prepend(e);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.prepend = void 0;
    var e = $6813aa9d7dc8ab1a$var$ao;
    Object.defineProperty(n, "prepend", {
        enumerable: !0,
        get: function() {
            return e.prepend;
        }
    });
})($6813aa9d7dc8ab1a$var$On);
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.prepend = n.offset = n.make = n.isLineBreakTag = n.isSingleTag = n.isNodeEmpty = n.isLeaf = n.isHTMLString = n.isFragment = n.isEmpty = n.isElement = n.isContentEditable = n.isCollapsedWhitespaces = n.findAllInputs = n.isNativeInput = n.allInputsSelector = n.getDeepestNode = n.getDeepestBlockElements = n.getContentLength = n.fragmentToString = n.containsOnlyInlineElements = n.canSetCaret = n.calculateBaseline = n.blockElements = n.append = void 0;
    var e = $6813aa9d7dc8ab1a$var$It;
    Object.defineProperty(n, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return e.allInputsSelector;
        }
    });
    var t1 = $6813aa9d7dc8ab1a$var$ue;
    Object.defineProperty(n, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return t1.isNativeInput;
        }
    });
    var o = $6813aa9d7dc8ab1a$var$pn;
    Object.defineProperty(n, "append", {
        enumerable: !0,
        get: function() {
            return o.append;
        }
    });
    var i = $6813aa9d7dc8ab1a$var$At;
    Object.defineProperty(n, "blockElements", {
        enumerable: !0,
        get: function() {
            return i.blockElements;
        }
    });
    var s = $6813aa9d7dc8ab1a$var$fn;
    Object.defineProperty(n, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return s.calculateBaseline;
        }
    });
    var r = $6813aa9d7dc8ab1a$var$gn;
    Object.defineProperty(n, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return r.canSetCaret;
        }
    });
    var a = $6813aa9d7dc8ab1a$var$Ve;
    Object.defineProperty(n, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return a.containsOnlyInlineElements;
        }
    });
    var l = $6813aa9d7dc8ab1a$var$vn;
    Object.defineProperty(n, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return l.fragmentToString;
        }
    });
    var c = $6813aa9d7dc8ab1a$var$kn;
    Object.defineProperty(n, "getContentLength", {
        enumerable: !0,
        get: function() {
            return c.getContentLength;
        }
    });
    var d = $6813aa9d7dc8ab1a$var$Wt;
    Object.defineProperty(n, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return d.getDeepestBlockElements;
        }
    });
    var h = $6813aa9d7dc8ab1a$var$wn;
    Object.defineProperty(n, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return h.getDeepestNode;
        }
    });
    var p = $6813aa9d7dc8ab1a$var$xn;
    Object.defineProperty(n, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return p.findAllInputs;
        }
    });
    var g = $6813aa9d7dc8ab1a$var$Bn;
    Object.defineProperty(n, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return g.isCollapsedWhitespaces;
        }
    });
    var f = $6813aa9d7dc8ab1a$var$Rt;
    Object.defineProperty(n, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return f.isContentEditable;
        }
    });
    var v = $6813aa9d7dc8ab1a$var$Gt;
    Object.defineProperty(n, "isElement", {
        enumerable: !0,
        get: function() {
            return v.isElement;
        }
    });
    var O = $6813aa9d7dc8ab1a$var$Cn;
    Object.defineProperty(n, "isEmpty", {
        enumerable: !0,
        get: function() {
            return O.isEmpty;
        }
    });
    var T = $6813aa9d7dc8ab1a$var$Tn;
    Object.defineProperty(n, "isFragment", {
        enumerable: !0,
        get: function() {
            return T.isFragment;
        }
    });
    var M = $6813aa9d7dc8ab1a$var$Sn;
    Object.defineProperty(n, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return M.isHTMLString;
        }
    });
    var q = $6813aa9d7dc8ab1a$var$eo;
    Object.defineProperty(n, "isLeaf", {
        enumerable: !0,
        get: function() {
            return q.isLeaf;
        }
    });
    var F = $6813aa9d7dc8ab1a$var$oo;
    Object.defineProperty(n, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return F.isNodeEmpty;
        }
    });
    var H = $6813aa9d7dc8ab1a$var$Ze;
    Object.defineProperty(n, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return H.isLineBreakTag;
        }
    });
    var Q = $6813aa9d7dc8ab1a$var$Ge;
    Object.defineProperty(n, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return Q.isSingleTag;
        }
    });
    var ie = $6813aa9d7dc8ab1a$var$qe;
    Object.defineProperty(n, "make", {
        enumerable: !0,
        get: function() {
            return ie.make;
        }
    });
    var k = $6813aa9d7dc8ab1a$var$In;
    Object.defineProperty(n, "offset", {
        enumerable: !0,
        get: function() {
            return k.offset;
        }
    });
    var m = $6813aa9d7dc8ab1a$var$On;
    Object.defineProperty(n, "prepend", {
        enumerable: !0,
        get: function() {
            return m.prepend;
        }
    });
})($6813aa9d7dc8ab1a$var$de);
var $6813aa9d7dc8ab1a$var$Qe = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$Qe, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Qe.getContenteditableSlice = $6813aa9d7dc8ab1a$var$Hr;
var $6813aa9d7dc8ab1a$var$jr = $6813aa9d7dc8ab1a$var$de;
function $6813aa9d7dc8ab1a$var$Hr(n, e, t1, o, i) {
    var s;
    i === void 0 && (i = !1);
    var r = document.createRange();
    if (o === "left" ? (r.setStart(n, 0), r.setEnd(e, t1)) : (r.setStart(e, t1), r.setEnd(n, n.childNodes.length)), i === !0) {
        var a = r.extractContents();
        return (0, $6813aa9d7dc8ab1a$var$jr.fragmentToString)(a);
    }
    var l = r.cloneContents(), c = document.createElement("div");
    c.appendChild(l);
    var d = (s = c.textContent) !== null && s !== void 0 ? s : "";
    return d;
}
Object.defineProperty($6813aa9d7dc8ab1a$var$Xe, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Xe.checkContenteditableSliceForEmptiness = $6813aa9d7dc8ab1a$var$Ur;
var $6813aa9d7dc8ab1a$var$$r = $6813aa9d7dc8ab1a$var$de, $6813aa9d7dc8ab1a$var$zr = $6813aa9d7dc8ab1a$var$Qe;
function $6813aa9d7dc8ab1a$var$Ur(n, e, t1, o) {
    var i = (0, $6813aa9d7dc8ab1a$var$zr.getContenteditableSlice)(n, e, t1, o);
    return (0, $6813aa9d7dc8ab1a$var$$r.isCollapsedWhitespaces)(i);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.checkContenteditableSliceForEmptiness = void 0;
    var e = $6813aa9d7dc8ab1a$var$Xe;
    Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function() {
            return e.checkContenteditableSliceForEmptiness;
        }
    });
})($6813aa9d7dc8ab1a$var$St);
var $6813aa9d7dc8ab1a$var$_n = {};
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getContenteditableSlice = void 0;
    var e = $6813aa9d7dc8ab1a$var$Qe;
    Object.defineProperty(n, "getContenteditableSlice", {
        enumerable: !0,
        get: function() {
            return e.getContenteditableSlice;
        }
    });
})($6813aa9d7dc8ab1a$var$_n);
var $6813aa9d7dc8ab1a$var$Mn = {}, $6813aa9d7dc8ab1a$var$lo = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$lo, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$lo.focus = $6813aa9d7dc8ab1a$var$Yr;
var $6813aa9d7dc8ab1a$var$Wr = $6813aa9d7dc8ab1a$var$de;
function $6813aa9d7dc8ab1a$var$Yr(n, e) {
    var t1, o;
    if (e === void 0 && (e = !0), (0, $6813aa9d7dc8ab1a$var$Wr.isNativeInput)(n)) {
        n.focus();
        var i = e ? 0 : n.value.length;
        n.setSelectionRange(i, i);
    } else {
        var s = document.createRange(), r = window.getSelection();
        if (!r) return;
        var a = function(p) {
            var g = document.createTextNode("");
            p.appendChild(g), s.setStart(g, 0), s.setEnd(g, 0);
        }, l = function(p) {
            return p != null;
        }, c = n.childNodes, d = e ? c[0] : c[c.length - 1];
        if (l(d)) {
            for(; l(d) && d.nodeType !== Node.TEXT_NODE;)d = e ? d.firstChild : d.lastChild;
            if (l(d) && d.nodeType === Node.TEXT_NODE) {
                var h = (o = (t1 = d.textContent) === null || t1 === void 0 ? void 0 : t1.length) !== null && o !== void 0 ? o : 0, i = e ? 0 : h;
                s.setStart(d, i), s.setEnd(d, i);
            } else a(n);
        } else a(n);
        r.removeAllRanges(), r.addRange(s);
    }
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.focus = void 0;
    var e = $6813aa9d7dc8ab1a$var$lo;
    Object.defineProperty(n, "focus", {
        enumerable: !0,
        get: function() {
            return e.focus;
        }
    });
})($6813aa9d7dc8ab1a$var$Mn);
var $6813aa9d7dc8ab1a$var$co = {}, $6813aa9d7dc8ab1a$var$Je = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$Je, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$Je.getCaretNodeAndOffset = $6813aa9d7dc8ab1a$var$Kr;
function $6813aa9d7dc8ab1a$var$Kr() {
    var n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    var e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] !== void 0 ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], e.textContent !== null && (t1 = e.textContent.length))), [
        e,
        t1
    ]);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getCaretNodeAndOffset = void 0;
    var e = $6813aa9d7dc8ab1a$var$Je;
    Object.defineProperty(n, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function() {
            return e.getCaretNodeAndOffset;
        }
    });
})($6813aa9d7dc8ab1a$var$co);
var $6813aa9d7dc8ab1a$var$An = {}, $6813aa9d7dc8ab1a$var$et = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$et, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$et.getRange = $6813aa9d7dc8ab1a$var$Xr;
function $6813aa9d7dc8ab1a$var$Xr() {
    var n = window.getSelection();
    return n && n.rangeCount ? n.getRangeAt(0) : null;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getRange = void 0;
    var e = $6813aa9d7dc8ab1a$var$et;
    Object.defineProperty(n, "getRange", {
        enumerable: !0,
        get: function() {
            return e.getRange;
        }
    });
})($6813aa9d7dc8ab1a$var$An);
var $6813aa9d7dc8ab1a$var$Ln = {}, $6813aa9d7dc8ab1a$var$uo = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$uo, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$uo.isCaretAtEndOfInput = $6813aa9d7dc8ab1a$var$Zr;
var $6813aa9d7dc8ab1a$var$Oo = $6813aa9d7dc8ab1a$var$de, $6813aa9d7dc8ab1a$var$Vr = $6813aa9d7dc8ab1a$var$co, $6813aa9d7dc8ab1a$var$qr = $6813aa9d7dc8ab1a$var$St;
function $6813aa9d7dc8ab1a$var$Zr(n) {
    var e = (0, $6813aa9d7dc8ab1a$var$Oo.getDeepestNode)(n, !0);
    if (e === null) return !0;
    if ((0, $6813aa9d7dc8ab1a$var$Oo.isNativeInput)(e)) return e.selectionEnd === e.value.length;
    var t1 = (0, $6813aa9d7dc8ab1a$var$Vr.getCaretNodeAndOffset)(), o = t1[0], i = t1[1];
    return o === null ? !1 : (0, $6813aa9d7dc8ab1a$var$qr.checkContenteditableSliceForEmptiness)(n, o, i, "right");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCaretAtEndOfInput = void 0;
    var e = $6813aa9d7dc8ab1a$var$uo;
    Object.defineProperty(n, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function() {
            return e.isCaretAtEndOfInput;
        }
    });
})($6813aa9d7dc8ab1a$var$Ln);
var $6813aa9d7dc8ab1a$var$Pn = {}, $6813aa9d7dc8ab1a$var$ho = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$ho, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$ho.isCaretAtStartOfInput = $6813aa9d7dc8ab1a$var$Jr;
var $6813aa9d7dc8ab1a$var$Ae = $6813aa9d7dc8ab1a$var$de, $6813aa9d7dc8ab1a$var$Gr = $6813aa9d7dc8ab1a$var$Je, $6813aa9d7dc8ab1a$var$Qr = $6813aa9d7dc8ab1a$var$Xe;
function $6813aa9d7dc8ab1a$var$Jr(n) {
    var e = (0, $6813aa9d7dc8ab1a$var$Ae.getDeepestNode)(n);
    if (e === null || (0, $6813aa9d7dc8ab1a$var$Ae.isEmpty)(n)) return !0;
    if ((0, $6813aa9d7dc8ab1a$var$Ae.isNativeInput)(e)) return e.selectionEnd === 0;
    if ((0, $6813aa9d7dc8ab1a$var$Ae.isEmpty)(n)) return !0;
    var t1 = (0, $6813aa9d7dc8ab1a$var$Gr.getCaretNodeAndOffset)(), o = t1[0], i = t1[1];
    return o === null ? !1 : (0, $6813aa9d7dc8ab1a$var$Qr.checkContenteditableSliceForEmptiness)(n, o, i, "left");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCaretAtStartOfInput = void 0;
    var e = $6813aa9d7dc8ab1a$var$ho;
    Object.defineProperty(n, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function() {
            return e.isCaretAtStartOfInput;
        }
    });
})($6813aa9d7dc8ab1a$var$Pn);
var $6813aa9d7dc8ab1a$var$Nn = {}, $6813aa9d7dc8ab1a$var$po = {};
Object.defineProperty($6813aa9d7dc8ab1a$var$po, "__esModule", {
    value: !0
});
$6813aa9d7dc8ab1a$var$po.save = $6813aa9d7dc8ab1a$var$oa;
var $6813aa9d7dc8ab1a$var$ea = $6813aa9d7dc8ab1a$var$de, $6813aa9d7dc8ab1a$var$ta = $6813aa9d7dc8ab1a$var$et;
function $6813aa9d7dc8ab1a$var$oa() {
    var n = (0, $6813aa9d7dc8ab1a$var$ta.getRange)(), e = (0, $6813aa9d7dc8ab1a$var$ea.make)("span");
    if (e.id = "cursor", e.hidden = !0, !!n) return n.insertNode(e), function() {
        var o = window.getSelection();
        o && (n.setStartAfter(e), n.setEndAfter(e), o.removeAllRanges(), o.addRange(n), setTimeout(function() {
            e.remove();
        }, 150));
    };
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.save = void 0;
    var e = $6813aa9d7dc8ab1a$var$po;
    Object.defineProperty(n, "save", {
        enumerable: !0,
        get: function() {
            return e.save;
        }
    });
})($6813aa9d7dc8ab1a$var$Nn);
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.save = n.isCaretAtStartOfInput = n.isCaretAtEndOfInput = n.getRange = n.getCaretNodeAndOffset = n.focus = n.getContenteditableSlice = n.checkContenteditableSliceForEmptiness = void 0;
    var e = $6813aa9d7dc8ab1a$var$St;
    Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function() {
            return e.checkContenteditableSliceForEmptiness;
        }
    });
    var t1 = $6813aa9d7dc8ab1a$var$_n;
    Object.defineProperty(n, "getContenteditableSlice", {
        enumerable: !0,
        get: function() {
            return t1.getContenteditableSlice;
        }
    });
    var o = $6813aa9d7dc8ab1a$var$Mn;
    Object.defineProperty(n, "focus", {
        enumerable: !0,
        get: function() {
            return o.focus;
        }
    });
    var i = $6813aa9d7dc8ab1a$var$co;
    Object.defineProperty(n, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function() {
            return i.getCaretNodeAndOffset;
        }
    });
    var s = $6813aa9d7dc8ab1a$var$An;
    Object.defineProperty(n, "getRange", {
        enumerable: !0,
        get: function() {
            return s.getRange;
        }
    });
    var r = $6813aa9d7dc8ab1a$var$Ln;
    Object.defineProperty(n, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function() {
            return r.isCaretAtEndOfInput;
        }
    });
    var a = $6813aa9d7dc8ab1a$var$Pn;
    Object.defineProperty(n, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function() {
            return a.isCaretAtStartOfInput;
        }
    });
    var l = $6813aa9d7dc8ab1a$var$Nn;
    Object.defineProperty(n, "save", {
        enumerable: !0,
        get: function() {
            return l.save;
        }
    });
})($6813aa9d7dc8ab1a$var$hn);
class $6813aa9d7dc8ab1a$var$na extends $6813aa9d7dc8ab1a$var$E {
    /**
   * All keydowns on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ keydown(e) {
        switch(this.beforeKeydownProcessing(e), e.keyCode){
            case $6813aa9d7dc8ab1a$var$y.BACKSPACE:
                this.backspace(e);
                break;
            case $6813aa9d7dc8ab1a$var$y.DELETE:
                this.delete(e);
                break;
            case $6813aa9d7dc8ab1a$var$y.ENTER:
                this.enter(e);
                break;
            case $6813aa9d7dc8ab1a$var$y.DOWN:
            case $6813aa9d7dc8ab1a$var$y.RIGHT:
                this.arrowRightAndDown(e);
                break;
            case $6813aa9d7dc8ab1a$var$y.UP:
            case $6813aa9d7dc8ab1a$var$y.LEFT:
                this.arrowLeftAndUp(e);
                break;
            case $6813aa9d7dc8ab1a$var$y.TAB:
                this.tabPressed(e);
                break;
        }
        e.key === "/" && !e.ctrlKey && !e.metaKey && this.slashPressed(e), e.code === "Slash" && (e.ctrlKey || e.metaKey) && (e.preventDefault(), this.commandSlashPressed());
    }
    /**
   * Fires on keydown before event processing
   *
   * @param {KeyboardEvent} event - keydown
   */ beforeKeydownProcessing(e) {
        this.needToolbarClosing(e) && $6813aa9d7dc8ab1a$var$Po(e.keyCode) && (this.Editor.Toolbar.close(), e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || this.Editor.BlockSelection.clearSelection(e));
    }
    /**
   * Key up on Block:
   * - shows Inline Toolbar if something selected
   * - shows conversion toolbar with 85% of block selection
   *
   * @param {KeyboardEvent} event - keyup event
   */ keyup(e) {
        e.shiftKey || this.Editor.UI.checkEmptiness();
    }
    /**
   * Add drop target styles
   *
   * @param {DragEvent} event - drag over event
   */ dragOver(e) {
        const t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
        t1.dropTarget = !0;
    }
    /**
   * Remove drop target style
   *
   * @param {DragEvent} event - drag leave event
   */ dragLeave(e) {
        const t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
        t1.dropTarget = !1;
    }
    /**
   * Copying selected blocks
   * Before putting to the clipboard we sanitize all blocks and then copy to the clipboard
   *
   * @param {ClipboardEvent} event - clipboard event
   */ handleCommandC(e) {
        const { BlockSelection: t1 } = this.Editor;
        t1.anyBlockSelected && t1.copySelectedBlocks(e);
    }
    /**
   * Copy and Delete selected Blocks
   *
   * @param {ClipboardEvent} event - clipboard event
   */ handleCommandX(e) {
        const { BlockSelection: t1, BlockManager: o, Caret: i } = this.Editor;
        t1.anyBlockSelected && t1.copySelectedBlocks(e).then(()=>{
            const s = o.removeSelectedBlocks(), r = o.insertDefaultBlockAtIndex(s, !0);
            i.setToBlock(r, i.positions.START), t1.clearSelection(e);
        });
    }
    /**
   * Tab pressed inside a Block.
   *
   * @param {KeyboardEvent} event - keydown
   */ tabPressed(e) {
        const { InlineToolbar: t1, Caret: o } = this.Editor;
        if (t1.opened) return;
        (e.shiftKey ? o.navigatePrevious(!0) : o.navigateNext(!0)) && e.preventDefault();
    }
    /**
   * '/' + 'command' keydown inside a Block
   */ commandSlashPressed() {
        this.Editor.BlockSelection.selectedBlocks.length > 1 || this.activateBlockSettings();
    }
    /**
   * '/' keydown inside a Block
   *
   * @param event - keydown
   */ slashPressed(e) {
        !this.Editor.UI.nodes.wrapper.contains(e.target) || !this.Editor.BlockManager.currentBlock.isEmpty || (e.preventDefault(), this.Editor.Caret.insertContentAtCaretPosition("/"), this.activateToolbox());
    }
    /**
   * ENTER pressed on block
   *
   * @param {KeyboardEvent} event - keydown
   */ enter(e) {
        const { BlockManager: t1, UI: o } = this.Editor, i = t1.currentBlock;
        if (i === void 0 || i.tool.isLineBreaksEnabled || o.someToolbarOpened && o.someFlipperButtonFocused || e.shiftKey && !$6813aa9d7dc8ab1a$var$pt) return;
        let s = i;
        i.currentInput !== void 0 && $6813aa9d7dc8ab1a$var$Ne(i.currentInput) && !i.hasMedia ? this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex) : i.currentInput && $6813aa9d7dc8ab1a$var$Re(i.currentInput) ? s = this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex + 1) : s = this.Editor.BlockManager.split(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s), e.preventDefault();
    }
    /**
   * Handle backspace keydown on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ backspace(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { currentBlock: i, previousBlock: s } = t1;
        if (i === void 0 || !$6813aa9d7dc8ab1a$var$b.isCollapsed || !i.currentInput || !$6813aa9d7dc8ab1a$var$Ne(i.currentInput)) return;
        if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.firstInput)) {
            o.navigatePrevious();
            return;
        }
        if (s === null) return;
        if (s.isEmpty) {
            t1.removeBlock(s);
            return;
        }
        if (i.isEmpty) {
            t1.removeBlock(i);
            const l = t1.currentBlock;
            o.setToBlock(l, o.positions.END);
            return;
        }
        $6813aa9d7dc8ab1a$var$xo(s, i) ? this.mergeBlocks(s, i) : o.setToBlock(s, o.positions.END);
    }
    /**
   * Handles delete keydown on Block
   * Removes char after the caret.
   * If caret is at the end of the block, merge next block with current
   *
   * @param {KeyboardEvent} event - keydown
   */ delete(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { currentBlock: i, nextBlock: s } = t1;
        if (!$6813aa9d7dc8ab1a$var$b.isCollapsed || !$6813aa9d7dc8ab1a$var$Re(i.currentInput)) return;
        if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.lastInput)) {
            o.navigateNext();
            return;
        }
        if (s === null) return;
        if (s.isEmpty) {
            t1.removeBlock(s);
            return;
        }
        if (i.isEmpty) {
            t1.removeBlock(i), o.setToBlock(s, o.positions.START);
            return;
        }
        $6813aa9d7dc8ab1a$var$xo(i, s) ? this.mergeBlocks(i, s) : o.setToBlock(s, o.positions.START);
    }
    /**
   * Merge passed Blocks
   *
   * @param targetBlock - to which Block we want to merge
   * @param blockToMerge - what Block we want to merge
   */ mergeBlocks(e, t1) {
        const { BlockManager: o, Toolbar: i } = this.Editor;
        e.lastInput !== void 0 && ($6813aa9d7dc8ab1a$var$hn.focus(e.lastInput, !1), o.mergeBlocks(e, t1).then(()=>{
            i.close();
        }));
    }
    /**
   * Handle right and down keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ arrowRightAndDown(e) {
        const t1 = $6813aa9d7dc8ab1a$var$ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $6813aa9d7dc8ab1a$var$y.TAB);
        if (this.Editor.UI.someToolbarOpened && t1) return;
        this.Editor.Toolbar.close();
        const { currentBlock: o } = this.Editor.BlockManager, s = ((o == null ? void 0 : o.currentInput) !== void 0 ? $6813aa9d7dc8ab1a$var$Re(o.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
        if (e.shiftKey && e.keyCode === $6813aa9d7dc8ab1a$var$y.DOWN && s) {
            this.Editor.CrossBlockSelection.toggleBlockSelectedState();
            return;
        }
        if (e.keyCode === $6813aa9d7dc8ab1a$var$y.DOWN || e.keyCode === $6813aa9d7dc8ab1a$var$y.RIGHT && !this.isRtl ? this.Editor.Caret.navigateNext() : this.Editor.Caret.navigatePrevious()) {
            e.preventDefault();
            return;
        }
        $6813aa9d7dc8ab1a$var$Fe(()=>{
            this.Editor.BlockManager.currentBlock && this.Editor.BlockManager.currentBlock.updateCurrentInput();
        }, 20)(), this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Handle left and up keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ arrowLeftAndUp(e) {
        if (this.Editor.UI.someToolbarOpened) {
            if ($6813aa9d7dc8ab1a$var$ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $6813aa9d7dc8ab1a$var$y.TAB)) return;
            this.Editor.UI.closeAllToolbars();
        }
        this.Editor.Toolbar.close();
        const { currentBlock: t1 } = this.Editor.BlockManager, i = ((t1 == null ? void 0 : t1.currentInput) !== void 0 ? $6813aa9d7dc8ab1a$var$Ne(t1.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
        if (e.shiftKey && e.keyCode === $6813aa9d7dc8ab1a$var$y.UP && i) {
            this.Editor.CrossBlockSelection.toggleBlockSelectedState(!1);
            return;
        }
        if (e.keyCode === $6813aa9d7dc8ab1a$var$y.UP || e.keyCode === $6813aa9d7dc8ab1a$var$y.LEFT && !this.isRtl ? this.Editor.Caret.navigatePrevious() : this.Editor.Caret.navigateNext()) {
            e.preventDefault();
            return;
        }
        $6813aa9d7dc8ab1a$var$Fe(()=>{
            this.Editor.BlockManager.currentBlock && this.Editor.BlockManager.currentBlock.updateCurrentInput();
        }, 20)(), this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Cases when we need to close Toolbar
   *
   * @param {KeyboardEvent} event - keyboard event
   */ needToolbarClosing(e) {
        const t1 = e.keyCode === $6813aa9d7dc8ab1a$var$y.ENTER && this.Editor.Toolbar.toolbox.opened, o = e.keyCode === $6813aa9d7dc8ab1a$var$y.ENTER && this.Editor.BlockSettings.opened, i = e.keyCode === $6813aa9d7dc8ab1a$var$y.ENTER && this.Editor.InlineToolbar.opened, s = e.keyCode === $6813aa9d7dc8ab1a$var$y.TAB;
        return !(e.shiftKey || s || t1 || o || i);
    }
    /**
   * If Toolbox is not open, then just open it and show plus button
   */ activateToolbox() {
        this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open();
    }
    /**
   * Open Toolbar and show BlockSettings before flipping Tools
   */ activateBlockSettings() {
        this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.opened || this.Editor.BlockSettings.open();
    }
}
class $6813aa9d7dc8ab1a$var$ct {
    /**
   * @class
   * @param {HTMLElement} workingArea — editor`s working node
   */ constructor(e){
        this.blocks = [], this.workingArea = e;
    }
    /**
   * Get length of Block instances array
   *
   * @returns {number}
   */ get length() {
        return this.blocks.length;
    }
    /**
   * Get Block instances array
   *
   * @returns {Block[]}
   */ get array() {
        return this.blocks;
    }
    /**
   * Get blocks html elements array
   *
   * @returns {HTMLElement[]}
   */ get nodes() {
        return $6813aa9d7dc8ab1a$var$No(this.workingArea.children);
    }
    /**
   * Proxy trap to implement array-like setter
   *
   * @example
   * blocks[0] = new Block(...)
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — block index or any Blocks class property key to set
   * @param {Block} value — value to set
   * @returns {boolean}
   */ static set(e, t1, o) {
        return isNaN(Number(t1)) ? (Reflect.set(e, t1, o), !0) : (e.insert(+t1, o), !0);
    }
    /**
   * Proxy trap to implement array-like getter
   *
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — Blocks class property key
   * @returns {Block|*}
   */ static get(e, t1) {
        return isNaN(Number(t1)) ? Reflect.get(e, t1) : e.get(+t1);
    }
    /**
   * Push new Block to the blocks array and append it to working area
   *
   * @param {Block} block - Block to add
   */ push(e) {
        this.blocks.push(e), this.insertToDOM(e);
    }
    /**
   * Swaps blocks with indexes first and second
   *
   * @param {number} first - first block index
   * @param {number} second - second block index
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        const o = this.blocks[t1];
        $6813aa9d7dc8ab1a$var$u.swap(this.blocks[e].holder, o.holder), this.blocks[t1] = this.blocks[e], this.blocks[e] = o;
    }
    /**
   * Move a block from one to another index
   *
   * @param {number} toIndex - new index of the block
   * @param {number} fromIndex - block to move
   */ move(e, t1) {
        const o = this.blocks.splice(t1, 1)[0], i = e - 1, s = Math.max(0, i), r = this.blocks[s];
        e > 0 ? this.insertToDOM(o, "afterend", r) : this.insertToDOM(o, "beforebegin", r), this.blocks.splice(e, 0, o);
        const a = this.composeBlockEvent("move", {
            fromIndex: t1,
            toIndex: e
        });
        o.call($6813aa9d7dc8ab1a$var$ee.MOVED, a);
    }
    /**
   * Insert new Block at passed index
   *
   * @param {number} index — index to insert Block
   * @param {Block} block — Block to insert
   * @param {boolean} replace — it true, replace block on given index
   */ insert(e, t1, o = !1) {
        if (!this.length) {
            this.push(t1);
            return;
        }
        e > this.length && (e = this.length), o && (this.blocks[e].holder.remove(), this.blocks[e].call($6813aa9d7dc8ab1a$var$ee.REMOVED));
        const i = o ? 1 : 0;
        if (this.blocks.splice(e, i, t1), e > 0) {
            const s = this.blocks[e - 1];
            this.insertToDOM(t1, "afterend", s);
        } else {
            const s = this.blocks[e + 1];
            s ? this.insertToDOM(t1, "beforebegin", s) : this.insertToDOM(t1);
        }
    }
    /**
   * Replaces block under passed index with passed block
   *
   * @param index - index of existed block
   * @param block - new block
   */ replace(e, t1) {
        if (this.blocks[e] === void 0) throw Error("Incorrect index");
        this.blocks[e].holder.replaceWith(t1.holder), this.blocks[e] = t1;
    }
    /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index to insert blocks at
   */ insertMany(e, t1) {
        const o = new DocumentFragment();
        for (const i of e)o.appendChild(i.holder);
        if (this.length > 0) {
            if (t1 > 0) {
                const i = Math.min(t1 - 1, this.length - 1);
                this.blocks[i].holder.after(o);
            } else t1 === 0 && this.workingArea.prepend(o);
            this.blocks.splice(t1, 0, ...e);
        } else this.blocks.push(...e), this.workingArea.appendChild(o);
        e.forEach((i)=>i.call($6813aa9d7dc8ab1a$var$ee.RENDERED));
    }
    /**
   * Remove block
   *
   * @param {number} index - index of Block to remove
   */ remove(e) {
        isNaN(e) && (e = this.length - 1), this.blocks[e].holder.remove(), this.blocks[e].call($6813aa9d7dc8ab1a$var$ee.REMOVED), this.blocks.splice(e, 1);
    }
    /**
   * Remove all blocks
   */ removeAll() {
        this.workingArea.innerHTML = "", this.blocks.forEach((e)=>e.call($6813aa9d7dc8ab1a$var$ee.REMOVED)), this.blocks.length = 0;
    }
    /**
   * Insert Block after passed target
   *
   * @todo decide if this method is necessary
   * @param {Block} targetBlock — target after which Block should be inserted
   * @param {Block} newBlock — Block to insert
   */ insertAfter(e, t1) {
        const o = this.blocks.indexOf(e);
        this.insert(o + 1, t1);
    }
    /**
   * Get Block by index
   *
   * @param {number} index — Block index
   * @returns {Block}
   */ get(e) {
        return this.blocks[e];
    }
    /**
   * Return index of passed Block
   *
   * @param {Block} block - Block to find
   * @returns {number}
   */ indexOf(e) {
        return this.blocks.indexOf(e);
    }
    /**
   * Insert new Block into DOM
   *
   * @param {Block} block - Block to insert
   * @param {InsertPosition} position — insert position (if set, will use insertAdjacentElement)
   * @param {Block} target — Block related to position
   */ insertToDOM(e, t1, o) {
        t1 ? o.holder.insertAdjacentElement(t1, e.holder) : this.workingArea.appendChild(e.holder), e.call($6813aa9d7dc8ab1a$var$ee.RENDERED);
    }
    /**
   * Composes Block event with passed type and details
   *
   * @param {string} type - event type
   * @param {object} detail - event detail
   */ composeBlockEvent(e, t1) {
        return new CustomEvent(e, {
            detail: t1
        });
    }
}
const $6813aa9d7dc8ab1a$var$_o = "block-removed", $6813aa9d7dc8ab1a$var$Mo = "block-added", $6813aa9d7dc8ab1a$var$ia = "block-moved", $6813aa9d7dc8ab1a$var$Ao = "block-changed";
class $6813aa9d7dc8ab1a$var$sa {
    constructor(){
        this.completed = Promise.resolve();
    }
    /**
   * Add new promise to queue
   *
   * @param operation - promise should be added to queue
   */ add(e) {
        return new Promise((t1, o)=>{
            this.completed = this.completed.then(e).then(t1).catch(o);
        });
    }
}
class $6813aa9d7dc8ab1a$var$ra extends $6813aa9d7dc8ab1a$var$E {
    constructor(){
        super(...arguments), this._currentBlockIndex = -1, this._blocks = null;
    }
    /**
   * Returns current Block index
   *
   * @returns {number}
   */ get currentBlockIndex() {
        return this._currentBlockIndex;
    }
    /**
   * Set current Block index and fire Block lifecycle callbacks
   *
   * @param {number} newIndex - index of Block to set as current
   */ set currentBlockIndex(e) {
        this._currentBlockIndex = e;
    }
    /**
   * returns first Block
   *
   * @returns {Block}
   */ get firstBlock() {
        return this._blocks[0];
    }
    /**
   * returns last Block
   *
   * @returns {Block}
   */ get lastBlock() {
        return this._blocks[this._blocks.length - 1];
    }
    /**
   * Get current Block instance
   *
   * @returns {Block}
   */ get currentBlock() {
        return this._blocks[this.currentBlockIndex];
    }
    /**
   * Set passed Block as a current
   *
   * @param block - block to set as a current
   */ set currentBlock(e) {
        this.currentBlockIndex = this.getBlockIndex(e);
    }
    /**
   * Returns next Block instance
   *
   * @returns {Block|null}
   */ get nextBlock() {
        return this.currentBlockIndex === this._blocks.length - 1 ? null : this._blocks[this.currentBlockIndex + 1];
    }
    /**
   * Return first Block with inputs after current Block
   *
   * @returns {Block | undefined}
   */ get nextContentfulBlock() {
        return this.blocks.slice(this.currentBlockIndex + 1).find((t1)=>!!t1.inputs.length);
    }
    /**
   * Return first Block with inputs before current Block
   *
   * @returns {Block | undefined}
   */ get previousContentfulBlock() {
        return this.blocks.slice(0, this.currentBlockIndex).reverse().find((t1)=>!!t1.inputs.length);
    }
    /**
   * Returns previous Block instance
   *
   * @returns {Block|null}
   */ get previousBlock() {
        return this.currentBlockIndex === 0 ? null : this._blocks[this.currentBlockIndex - 1];
    }
    /**
   * Get array of Block instances
   *
   * @returns {Block[]} {@link Blocks#array}
   */ get blocks() {
        return this._blocks.array;
    }
    /**
   * Check if each Block is empty
   *
   * @returns {boolean}
   */ get isEditorEmpty() {
        return this.blocks.every((e)=>e.isEmpty);
    }
    /**
   * Should be called after Editor.UI preparation
   * Define this._blocks property
   */ prepare() {
        const e = new $6813aa9d7dc8ab1a$var$ct(this.Editor.UI.nodes.redactor);
        this._blocks = new Proxy(e, {
            set: $6813aa9d7dc8ab1a$var$ct.set,
            get: $6813aa9d7dc8ab1a$var$ct.get
        }), this.listeners.on(document, "copy", (t1)=>this.Editor.BlockEvents.handleCommandC(t1));
    }
    /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - Unbind event handlers from created Blocks
   *
   * if readOnly is false:
   *  - Bind event handlers to all existing Blocks
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.disableModuleBindings() : this.enableModuleBindings();
    }
    /**
   * Creates Block instance by tool name
   *
   * @param {object} options - block creation options
   * @param {string} options.tool - tools passed in editor config {@link EditorConfig#tools}
   * @param {string} [options.id] - unique id for this block
   * @param {BlockToolData} [options.data] - constructor params
   * @returns {Block}
   */ composeBlock({ tool: e, data: t1 = {}, id: o, tunes: i = {} }) {
        const s = this.Editor.ReadOnly.isEnabled, r = this.Editor.Tools.blockTools.get(e), a = new $6813aa9d7dc8ab1a$var$R({
            id: o,
            data: t1,
            tool: r,
            api: this.Editor.API,
            readOnly: s,
            tunesData: i
        }, this.eventsDispatcher);
        return s || window.requestIdleCallback(()=>{
            this.bindBlockEvents(a);
        }, {
            timeout: 2e3
        }), a;
    }
    /**
   * Insert new block into _blocks
   *
   * @param {object} options - insert options
   * @param {string} [options.id] - block's unique id
   * @param {string} [options.tool] - plugin name, by default method inserts the default block type
   * @param {object} [options.data] - plugin data
   * @param {number} [options.index] - index where to insert new Block
   * @param {boolean} [options.needToFocus] - flag shows if needed to update current Block index
   * @param {boolean} [options.replace] - flag shows if block by passed index should be replaced with inserted one
   * @returns {Block}
   */ insert({ id: e, tool: t1 = this.config.defaultBlock, data: o = {}, index: i, needToFocus: s = !0, replace: r = !1, tunes: a = {} } = {}) {
        let l = i;
        l === void 0 && (l = this.currentBlockIndex + (r ? 0 : 1));
        const c = this.composeBlock({
            id: e,
            tool: t1,
            data: o,
            tunes: a
        });
        return r && this.blockDidMutated($6813aa9d7dc8ab1a$var$_o, this.getBlockByIndex(l), {
            index: l
        }), this._blocks.insert(l, c, r), this.blockDidMutated($6813aa9d7dc8ab1a$var$Mo, c, {
            index: l
        }), s ? this.currentBlockIndex = l : l <= this.currentBlockIndex && this.currentBlockIndex++, c;
    }
    /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index where to insert
   */ insertMany(e, t1 = 0) {
        this._blocks.insertMany(e, t1);
    }
    /**
   * Update Block data.
   *
   * Currently we don't have an 'update' method in the Tools API, so we just create a new block with the same id and type
   * Should not trigger 'block-removed' or 'block-added' events.
   *
   * If neither data nor tunes is provided, return the provided block instead.
   *
   * @param block - block to update
   * @param data - (optional) new data
   * @param tunes - (optional) tune data
   */ async update(e, t1, o) {
        if (!t1 && !o) return e;
        const i = await e.data, s = this.composeBlock({
            id: e.id,
            tool: e.name,
            data: Object.assign({}, i, t1 ?? {}),
            tunes: o ?? e.tunes
        }), r = this.getBlockIndex(e);
        return this._blocks.replace(r, s), this.blockDidMutated($6813aa9d7dc8ab1a$var$Ao, s, {
            index: r
        }), s;
    }
    /**
   * Replace passed Block with the new one with specified Tool and data
   *
   * @param block - block to replace
   * @param newTool - new Tool name
   * @param data - new Tool data
   */ replace(e, t1, o) {
        const i = this.getBlockIndex(e);
        return this.insert({
            tool: t1,
            data: o,
            index: i,
            replace: !0
        });
    }
    /**
   * Insert pasted content. Call onPaste callback after insert.
   *
   * @param {string} toolName - name of Tool to insert
   * @param {PasteEvent} pasteEvent - pasted data
   * @param {boolean} replace - should replace current block
   */ paste(e, t1, o = !1) {
        const i = this.insert({
            tool: e,
            replace: o
        });
        try {
            window.requestIdleCallback(()=>{
                i.call($6813aa9d7dc8ab1a$var$ee.ON_PASTE, t1);
            });
        } catch (s) {
            $6813aa9d7dc8ab1a$var$S(`${e}: onPaste callback call is failed`, "error", s);
        }
        return i;
    }
    /**
   * Insert new default block at passed index
   *
   * @param {number} index - index where Block should be inserted
   * @param {boolean} needToFocus - if true, updates current Block index
   *
   * TODO: Remove method and use insert() with index instead (?)
   * @returns {Block} inserted Block
   */ insertDefaultBlockAtIndex(e, t1 = !1) {
        const o = this.composeBlock({
            tool: this.config.defaultBlock
        });
        return this._blocks[e] = o, this.blockDidMutated($6813aa9d7dc8ab1a$var$Mo, o, {
            index: e
        }), t1 ? this.currentBlockIndex = e : e <= this.currentBlockIndex && this.currentBlockIndex++, o;
    }
    /**
   * Always inserts at the end
   *
   * @returns {Block}
   */ insertAtEnd() {
        return this.currentBlockIndex = this.blocks.length - 1, this.insert();
    }
    /**
   * Merge two blocks
   *
   * @param {Block} targetBlock - previous block will be append to this block
   * @param {Block} blockToMerge - block that will be merged with target block
   * @returns {Promise} - the sequence that can be continued
   */ async mergeBlocks(e, t1) {
        let o;
        if (e.name === t1.name && e.mergeable) {
            const i = await t1.data;
            if ($6813aa9d7dc8ab1a$var$V(i)) {
                console.error("Could not merge Block. Failed to extract original Block data.");
                return;
            }
            const [s] = $6813aa9d7dc8ab1a$var$yt([
                i
            ], e.tool.sanitizeConfig);
            o = s;
        } else if (e.mergeable && $6813aa9d7dc8ab1a$var$He(t1, "export") && $6813aa9d7dc8ab1a$var$He(e, "import")) {
            const i = await t1.exportDataAsString(), s = $6813aa9d7dc8ab1a$var$Z(i, e.tool.sanitizeConfig);
            o = $6813aa9d7dc8ab1a$var$Bo(s, e.tool.conversionConfig);
        }
        o !== void 0 && (await e.mergeWith(o), this.removeBlock(t1), this.currentBlockIndex = this._blocks.indexOf(e));
    }
    /**
   * Remove passed Block
   *
   * @param block - Block to remove
   * @param addLastBlock - if true, adds new default block at the end. @todo remove this logic and use event-bus instead
   */ removeBlock(e, t1 = !0) {
        return new Promise((o)=>{
            const i = this._blocks.indexOf(e);
            if (!this.validateIndex(i)) throw new Error("Can't find a Block to remove");
            this._blocks.remove(i), e.destroy(), this.blockDidMutated($6813aa9d7dc8ab1a$var$_o, e, {
                index: i
            }), this.currentBlockIndex >= i && this.currentBlockIndex--, this.blocks.length ? i === 0 && (this.currentBlockIndex = 0) : (this.unsetCurrentBlock(), t1 && this.insert()), o();
        });
    }
    /**
   * Remove only selected Blocks
   * and returns first Block index where started removing...
   *
   * @returns {number|undefined}
   */ removeSelectedBlocks() {
        let e;
        for(let t1 = this.blocks.length - 1; t1 >= 0; t1--)this.blocks[t1].selected && (this.removeBlock(this.blocks[t1]), e = t1);
        return e;
    }
    /**
   * Attention!
   * After removing insert the new default typed Block and focus on it
   * Removes all blocks
   */ removeAllBlocks() {
        for(let e = this.blocks.length - 1; e >= 0; e--)this._blocks.remove(e);
        this.unsetCurrentBlock(), this.insert(), this.currentBlock.firstInput.focus();
    }
    /**
   * Split current Block
   * 1. Extract content from Caret position to the Block`s end
   * 2. Insert a new Block below current one with extracted content
   *
   * @returns {Block}
   */ split() {
        const e = this.Editor.Caret.extractFragmentFromCaretPosition(), t1 = $6813aa9d7dc8ab1a$var$u.make("div");
        t1.appendChild(e);
        const o = {
            text: $6813aa9d7dc8ab1a$var$u.isEmpty(t1) ? "" : t1.innerHTML
        };
        return this.insert({
            data: o
        });
    }
    /**
   * Returns Block by passed index
   *
   * @param {number} index - index to get. -1 to get last
   * @returns {Block}
   */ getBlockByIndex(e) {
        return e === -1 && (e = this._blocks.length - 1), this._blocks[e];
    }
    /**
   * Returns an index for passed Block
   *
   * @param block - block to find index
   */ getBlockIndex(e) {
        return this._blocks.indexOf(e);
    }
    /**
   * Returns the Block by passed id
   *
   * @param id - id of block to get
   * @returns {Block}
   */ getBlockById(e) {
        return this._blocks.array.find((t1)=>t1.id === e);
    }
    /**
   * Get Block instance by html element
   *
   * @param {Node} element - html element to get Block by
   */ getBlock(e) {
        $6813aa9d7dc8ab1a$var$u.isElement(e) || (e = e.parentNode);
        const t1 = this._blocks.nodes, o = e.closest(`.${$6813aa9d7dc8ab1a$var$R.CSS.wrapper}`), i = t1.indexOf(o);
        if (i >= 0) return this._blocks[i];
    }
    /**
   * 1) Find first-level Block from passed child Node
   * 2) Mark it as current
   *
   * @param {Node} childNode - look ahead from this node.
   * @returns {Block | undefined} can return undefined in case when the passed child note is not a part of the current editor instance
   */ setCurrentBlockByChildNode(e) {
        $6813aa9d7dc8ab1a$var$u.isElement(e) || (e = e.parentNode);
        const t1 = e.closest(`.${$6813aa9d7dc8ab1a$var$R.CSS.wrapper}`);
        if (!t1) return;
        const o = t1.closest(`.${this.Editor.UI.CSS.editorWrapper}`);
        if (o != null && o.isEqualNode(this.Editor.UI.nodes.wrapper)) return this.currentBlockIndex = this._blocks.nodes.indexOf(t1), this.currentBlock.updateCurrentInput(), this.currentBlock;
    }
    /**
   * Return block which contents passed node
   *
   * @param {Node} childNode - node to get Block by
   * @returns {Block}
   */ getBlockByChildNode(e) {
        if (!e || !(e instanceof Node)) return;
        $6813aa9d7dc8ab1a$var$u.isElement(e) || (e = e.parentNode);
        const t1 = e.closest(`.${$6813aa9d7dc8ab1a$var$R.CSS.wrapper}`);
        return this.blocks.find((o)=>o.holder === t1);
    }
    /**
   * Swap Blocks Position
   *
   * @param {number} fromIndex - index of first block
   * @param {number} toIndex - index of second block
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        this._blocks.swap(e, t1), this.currentBlockIndex = t1;
    }
    /**
   * Move a block to a new index
   *
   * @param {number} toIndex - index where to move Block
   * @param {number} fromIndex - index of Block to move
   */ move(e, t1 = this.currentBlockIndex) {
        if (isNaN(e) || isNaN(t1)) {
            $6813aa9d7dc8ab1a$var$S("Warning during 'move' call: incorrect indices provided.", "warn");
            return;
        }
        if (!this.validateIndex(e) || !this.validateIndex(t1)) {
            $6813aa9d7dc8ab1a$var$S("Warning during 'move' call: indices cannot be lower than 0 or greater than the amount of blocks.", "warn");
            return;
        }
        this._blocks.move(e, t1), this.currentBlockIndex = e, this.blockDidMutated($6813aa9d7dc8ab1a$var$ia, this.currentBlock, {
            fromIndex: t1,
            toIndex: e
        });
    }
    /**
   * Converts passed Block to the new Tool
   * Uses Conversion Config
   *
   * @param blockToConvert - Block that should be converted
   * @param targetToolName - name of the Tool to convert to
   * @param blockDataOverrides - optional new Block data overrides
   */ async convert(e, t1, o) {
        if (!await e.save()) throw new Error("Could not convert Block. Failed to extract original Block data.");
        const s = this.Editor.Tools.blockTools.get(t1);
        if (!s) throw new Error(`Could not convert Block. Tool \xab${t1}\xbb not found.`);
        const r = await e.exportDataAsString(), a = $6813aa9d7dc8ab1a$var$Z(r, s.sanitizeConfig);
        let l = $6813aa9d7dc8ab1a$var$Bo(a, s.conversionConfig, s.settings);
        return o && (l = Object.assign(l, o)), this.replace(e, s.name, l);
    }
    /**
   * Sets current Block Index -1 which means unknown
   * and clear highlights
   */ unsetCurrentBlock() {
        this.currentBlockIndex = -1;
    }
    /**
   * Clears Editor
   *
   * @param {boolean} needToAddDefaultBlock - 1) in internal calls (for example, in api.blocks.render)
   *                                             we don't need to add an empty default block
   *                                        2) in api.blocks.clear we should add empty block
   */ async clear(e = !1) {
        const t1 = new $6813aa9d7dc8ab1a$var$sa();
        [
            ...this.blocks
        ].forEach((i)=>{
            t1.add(async ()=>{
                await this.removeBlock(i, !1);
            });
        }), await t1.completed, this.unsetCurrentBlock(), e && this.insert(), this.Editor.UI.checkEmptiness();
    }
    /**
   * Cleans up all the block tools' resources
   * This is called when editor is destroyed
   */ async destroy() {
        await Promise.all(this.blocks.map((e)=>e.destroy()));
    }
    /**
   * Bind Block events
   *
   * @param {Block} block - Block to which event should be bound
   */ bindBlockEvents(e) {
        const { BlockEvents: t1 } = this.Editor;
        this.readOnlyMutableListeners.on(e.holder, "keydown", (o)=>{
            t1.keydown(o);
        }), this.readOnlyMutableListeners.on(e.holder, "keyup", (o)=>{
            t1.keyup(o);
        }), this.readOnlyMutableListeners.on(e.holder, "dragover", (o)=>{
            t1.dragOver(o);
        }), this.readOnlyMutableListeners.on(e.holder, "dragleave", (o)=>{
            t1.dragLeave(o);
        }), e.on("didMutated", (o)=>this.blockDidMutated($6813aa9d7dc8ab1a$var$Ao, o, {
                index: this.getBlockIndex(o)
            }));
    }
    /**
   * Disable mutable handlers and bindings
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Enables all module handlers and bindings for all Blocks
   */ enableModuleBindings() {
        this.readOnlyMutableListeners.on(document, "cut", (e)=>this.Editor.BlockEvents.handleCommandX(e)), this.blocks.forEach((e)=>{
            this.bindBlockEvents(e);
        });
    }
    /**
   * Validates that the given index is not lower than 0 or higher than the amount of blocks
   *
   * @param {number} index - index of blocks array to validate
   * @returns {boolean}
   */ validateIndex(e) {
        return !(e < 0 || e >= this._blocks.length);
    }
    /**
   * Block mutation callback
   *
   * @param mutationType - what happened with block
   * @param block - mutated block
   * @param detailData - additional data to pass with change event
   */ blockDidMutated(e, t1, o) {
        const i = new CustomEvent(e, {
            detail: {
                target: new $6813aa9d7dc8ab1a$var$J(t1),
                ...o
            }
        });
        return this.eventsDispatcher.emit($6813aa9d7dc8ab1a$var$$o, {
            event: i
        }), t1;
    }
}
class $6813aa9d7dc8ab1a$var$aa extends $6813aa9d7dc8ab1a$var$E {
    constructor(){
        super(...arguments), this.anyBlockSelectedCache = null, this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
    }
    /**
   * Sanitizer Config
   *
   * @returns {SanitizerConfig}
   */ get sanitizerConfig() {
        return {
            p: {},
            h1: {},
            h2: {},
            h3: {},
            h4: {},
            h5: {},
            h6: {},
            ol: {},
            ul: {},
            li: {},
            br: !0,
            img: {
                src: !0,
                width: !0,
                height: !0
            },
            a: {
                href: !0
            },
            b: {},
            i: {},
            u: {}
        };
    }
    /**
   * Flag that identifies all Blocks selection
   *
   * @returns {boolean}
   */ get allBlocksSelected() {
        const { BlockManager: e } = this.Editor;
        return e.blocks.every((t1)=>t1.selected === !0);
    }
    /**
   * Set selected all blocks
   *
   * @param {boolean} state - state to set
   */ set allBlocksSelected(e) {
        const { BlockManager: t1 } = this.Editor;
        t1.blocks.forEach((o)=>{
            o.selected = e;
        }), this.clearCache();
    }
    /**
   * Flag that identifies any Block selection
   *
   * @returns {boolean}
   */ get anyBlockSelected() {
        const { BlockManager: e } = this.Editor;
        return this.anyBlockSelectedCache === null && (this.anyBlockSelectedCache = e.blocks.some((t1)=>t1.selected === !0)), this.anyBlockSelectedCache;
    }
    /**
   * Return selected Blocks array
   *
   * @returns {Block[]}
   */ get selectedBlocks() {
        return this.Editor.BlockManager.blocks.filter((e)=>e.selected);
    }
    /**
   * Module Preparation
   * Registers Shortcuts CMD+A and CMD+C
   * to select all and copy them
   */ prepare() {
        this.selection = new $6813aa9d7dc8ab1a$var$b(), $6813aa9d7dc8ab1a$var$ge.add({
            name: "CMD+A",
            handler: (e)=>{
                const { BlockManager: t1, ReadOnly: o } = this.Editor;
                if (o.isEnabled) {
                    e.preventDefault(), this.selectAllBlocks();
                    return;
                }
                t1.currentBlock && this.handleCommandA(e);
            },
            on: this.Editor.UI.nodes.redactor
        });
    }
    /**
   * Toggle read-only state
   *
   *  - Remove all ranges
   *  - Unselect all Blocks
   */ toggleReadOnly() {
        $6813aa9d7dc8ab1a$var$b.get().removeAllRanges(), this.allBlocksSelected = !1;
    }
    /**
   * Remove selection of Block
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ unSelectBlockByIndex(e) {
        const { BlockManager: t1 } = this.Editor;
        let o;
        isNaN(e) ? o = t1.currentBlock : o = t1.getBlockByIndex(e), o.selected = !1, this.clearCache();
    }
    /**
   * Clear selection from Blocks
   *
   * @param {Event} reason - event caused clear of selection
   * @param {boolean} restoreSelection - if true, restore saved selection
   */ clearSelection(e, t1 = !1) {
        const { BlockManager: o, Caret: i, RectangleSelection: s } = this.Editor;
        this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
        const r = e && e instanceof KeyboardEvent, a = r && $6813aa9d7dc8ab1a$var$Po(e.keyCode);
        if (this.anyBlockSelected && r && a && !$6813aa9d7dc8ab1a$var$b.isSelectionExists) {
            const l = o.removeSelectedBlocks();
            o.insertDefaultBlockAtIndex(l, !0), i.setToBlock(o.currentBlock), $6813aa9d7dc8ab1a$var$Fe(()=>{
                const c = e.key;
                i.insertContentAtCaretPosition(c.length > 1 ? "" : c);
            }, 20)();
        }
        if (this.Editor.CrossBlockSelection.clear(e), !this.anyBlockSelected || s.isRectActivated()) {
            this.Editor.RectangleSelection.clearSelection();
            return;
        }
        t1 && this.selection.restore(), this.allBlocksSelected = !1;
    }
    /**
   * Reduce each Block and copy its content
   *
   * @param {ClipboardEvent} e - copy/cut event
   * @returns {Promise<void>}
   */ copySelectedBlocks(e) {
        e.preventDefault();
        const t1 = $6813aa9d7dc8ab1a$var$u.make("div");
        this.selectedBlocks.forEach((s)=>{
            const r = $6813aa9d7dc8ab1a$var$Z(s.holder.innerHTML, this.sanitizerConfig), a = $6813aa9d7dc8ab1a$var$u.make("p");
            a.innerHTML = r, t1.appendChild(a);
        });
        const o = Array.from(t1.childNodes).map((s)=>s.textContent).join(`

`), i = t1.innerHTML;
        return e.clipboardData.setData("text/plain", o), e.clipboardData.setData("text/html", i), Promise.all(this.selectedBlocks.map((s)=>s.save())).then((s)=>{
            try {
                e.clipboardData.setData(this.Editor.Paste.MIME_TYPE, JSON.stringify(s));
            } catch  {}
        });
    }
    /**
   * Select Block by its index
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ selectBlockByIndex(e) {
        const { BlockManager: t1 } = this.Editor, o = t1.getBlockByIndex(e);
        o !== void 0 && this.selectBlock(o);
    }
    /**
   * Select passed Block
   *
   * @param {Block} block - Block to select
   */ selectBlock(e) {
        this.selection.save(), $6813aa9d7dc8ab1a$var$b.get().removeAllRanges(), e.selected = !0, this.clearCache(), this.Editor.InlineToolbar.close();
    }
    /**
   * Remove selection from passed Block
   *
   * @param {Block} block - Block to unselect
   */ unselectBlock(e) {
        e.selected = !1, this.clearCache();
    }
    /**
   * Clear anyBlockSelected cache
   */ clearCache() {
        this.anyBlockSelectedCache = null;
    }
    /**
   * Module destruction
   * De-registers Shortcut CMD+A
   */ destroy() {
        $6813aa9d7dc8ab1a$var$ge.remove(this.Editor.UI.nodes.redactor, "CMD+A");
    }
    /**
   * First CMD+A selects all input content by native behaviour,
   * next CMD+A keypress selects all blocks
   *
   * @param {KeyboardEvent} event - keyboard event
   */ handleCommandA(e) {
        if (this.Editor.RectangleSelection.clearSelection(), $6813aa9d7dc8ab1a$var$u.isNativeInput(e.target) && !this.readyToBlockSelection) {
            this.readyToBlockSelection = !0;
            return;
        }
        const t1 = this.Editor.BlockManager.getBlock(e.target), o = t1.inputs;
        if (o.length > 1 && !this.readyToBlockSelection) {
            this.readyToBlockSelection = !0;
            return;
        }
        if (o.length === 1 && !this.needToSelectAll) {
            this.needToSelectAll = !0;
            return;
        }
        this.needToSelectAll ? (e.preventDefault(), this.selectAllBlocks(), this.needToSelectAll = !1, this.readyToBlockSelection = !1) : this.readyToBlockSelection && (e.preventDefault(), this.selectBlock(t1), this.needToSelectAll = !0);
    }
    /**
   * Select All Blocks
   * Each Block has selected setter that makes Block copyable
   */ selectAllBlocks() {
        this.selection.save(), $6813aa9d7dc8ab1a$var$b.get().removeAllRanges(), this.allBlocksSelected = !0, this.Editor.InlineToolbar.close();
    }
}
class $6813aa9d7dc8ab1a$var$Ye extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Allowed caret positions in input
   *
   * @static
   * @returns {{START: string, END: string, DEFAULT: string}}
   */ get positions() {
        return {
            START: "start",
            END: "end",
            DEFAULT: "default"
        };
    }
    /**
   * Elements styles that can be useful for Caret Module
   */ static get CSS() {
        return {
            shadowCaret: "cdx-shadow-caret"
        };
    }
    /**
   * Method gets Block instance and puts caret to the text node with offset
   * There two ways that method applies caret position:
   *   - first found text node: sets at the beginning, but you can pass an offset
   *   - last found text node: sets at the end of the node. Also, you can customize the behaviour
   *
   * @param {Block} block - Block class
   * @param {string} position - position where to set caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the block content
   */ setToBlock(e, t1 = this.positions.DEFAULT, o = 0) {
        var c;
        const { BlockManager: i, BlockSelection: s } = this.Editor;
        if (s.clearSelection(), !e.focusable) {
            (c = window.getSelection()) == null || c.removeAllRanges(), s.selectBlock(e), i.currentBlock = e;
            return;
        }
        let r;
        switch(t1){
            case this.positions.START:
                r = e.firstInput;
                break;
            case this.positions.END:
                r = e.lastInput;
                break;
            default:
                r = e.currentInput;
        }
        if (!r) return;
        let a, l = o;
        if (t1 === this.positions.START) a = $6813aa9d7dc8ab1a$var$u.getDeepestNode(r, !1), l = 0;
        else if (t1 === this.positions.END) a = $6813aa9d7dc8ab1a$var$u.getDeepestNode(r, !0), l = $6813aa9d7dc8ab1a$var$u.getContentLength(a);
        else {
            const { node: d, offset: h } = $6813aa9d7dc8ab1a$var$u.getNodeByOffset(r, o);
            d ? (a = d, l = h) : (a = $6813aa9d7dc8ab1a$var$u.getDeepestNode(r, !1), l = 0);
        }
        this.set(a, l), i.setCurrentBlockByChildNode(e.holder), i.currentBlock.currentInput = r;
    }
    /**
   * Set caret to the current input of current Block.
   *
   * @param {HTMLElement} input - input where caret should be set
   * @param {string} position - position of the caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the text node
   */ setToInput(e, t1 = this.positions.DEFAULT, o = 0) {
        const { currentBlock: i } = this.Editor.BlockManager, s = $6813aa9d7dc8ab1a$var$u.getDeepestNode(e);
        switch(t1){
            case this.positions.START:
                this.set(s, 0);
                break;
            case this.positions.END:
                this.set(s, $6813aa9d7dc8ab1a$var$u.getContentLength(s));
                break;
            default:
                o && this.set(s, o);
        }
        i.currentInput = e;
    }
    /**
   * Creates Document Range and sets caret to the element with offset
   *
   * @param {HTMLElement} element - target node.
   * @param {number} offset - offset
   */ set(e, t1 = 0) {
        const { top: i, bottom: s } = $6813aa9d7dc8ab1a$var$b.setCursor(e, t1), { innerHeight: r } = window;
        i < 0 ? window.scrollBy(0, i - 30) : s > r && window.scrollBy(0, s - r + 30);
    }
    /**
   * Set Caret to the last Block
   * If last block is not empty, append another empty block
   */ setToTheLastBlock() {
        const e = this.Editor.BlockManager.lastBlock;
        if (e) {
            if (e.tool.isDefault && e.isEmpty) this.setToBlock(e);
            else {
                const t1 = this.Editor.BlockManager.insertAtEnd();
                this.setToBlock(t1);
            }
        }
    }
    /**
   * Extract content fragment of current Block from Caret position to the end of the Block
   */ extractFragmentFromCaretPosition() {
        const e = $6813aa9d7dc8ab1a$var$b.get();
        if (e.rangeCount) {
            const t1 = e.getRangeAt(0), o = this.Editor.BlockManager.currentBlock.currentInput;
            if (t1.deleteContents(), o) {
                if ($6813aa9d7dc8ab1a$var$u.isNativeInput(o)) {
                    const i = o, s = document.createDocumentFragment(), r = i.value.substring(0, i.selectionStart), a = i.value.substring(i.selectionStart);
                    return s.textContent = a, i.value = r, s;
                } else {
                    const i = t1.cloneRange();
                    return i.selectNodeContents(o), i.setStart(t1.endContainer, t1.endOffset), i.extractContents();
                }
            }
        }
    }
    /**
   * Set's caret to the next Block or Tool`s input
   * Before moving caret, we should check if caret position is at the end of Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ navigateNext(e = !1) {
        const { BlockManager: t1 } = this.Editor, { currentBlock: o, nextBlock: i } = t1;
        if (o === void 0) return !1;
        const { nextInput: s, currentInput: r } = o, a = r !== void 0 ? $6813aa9d7dc8ab1a$var$Re(r) : void 0;
        let l = i;
        const c = e || a || !o.focusable;
        if (s && c) return this.setToInput(s, this.positions.START), !0;
        if (l === null) {
            if (o.tool.isDefault || !c) return !1;
            l = t1.insertAtEnd();
        }
        return c ? (this.setToBlock(l, this.positions.START), !0) : !1;
    }
    /**
   * Set's caret to the previous Tool`s input or Block
   * Before moving caret, we should check if caret position is start of the Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ navigatePrevious(e = !1) {
        const { currentBlock: t1, previousBlock: o } = this.Editor.BlockManager;
        if (!t1) return !1;
        const { previousInput: i, currentInput: s } = t1, r = s !== void 0 ? $6813aa9d7dc8ab1a$var$Ne(s) : void 0, a = e || r || !t1.focusable;
        return i && a ? (this.setToInput(i, this.positions.END), !0) : o !== null && a ? (this.setToBlock(o, this.positions.END), !0) : !1;
    }
    /**
   * Inserts shadow element after passed element where caret can be placed
   *
   * @param {Element} element - element after which shadow caret should be inserted
   */ createShadow(e) {
        const t1 = document.createElement("span");
        t1.classList.add($6813aa9d7dc8ab1a$var$Ye.CSS.shadowCaret), e.insertAdjacentElement("beforeend", t1);
    }
    /**
   * Restores caret position
   *
   * @param {HTMLElement} element - element where caret should be restored
   */ restoreCaret(e) {
        const t1 = e.querySelector(`.${$6813aa9d7dc8ab1a$var$Ye.CSS.shadowCaret}`);
        if (!t1) return;
        new $6813aa9d7dc8ab1a$var$b().expandToTag(t1);
        const i = document.createRange();
        i.selectNode(t1), i.extractContents();
    }
    /**
   * Inserts passed content at caret position
   *
   * @param {string} content - content to insert
   */ insertContentAtCaretPosition(e) {
        const t1 = document.createDocumentFragment(), o = document.createElement("div"), i = $6813aa9d7dc8ab1a$var$b.get(), s = $6813aa9d7dc8ab1a$var$b.range;
        o.innerHTML = e, Array.from(o.childNodes).forEach((c)=>t1.appendChild(c)), t1.childNodes.length === 0 && t1.appendChild(new Text());
        const r = t1.lastChild;
        s.deleteContents(), s.insertNode(t1);
        const a = document.createRange(), l = r.nodeType === Node.TEXT_NODE ? r : r.firstChild;
        l !== null && l.textContent !== null && a.setStart(l, l.textContent.length), i.removeAllRanges(), i.addRange(a);
    }
}
class $6813aa9d7dc8ab1a$var$la extends $6813aa9d7dc8ab1a$var$E {
    constructor(){
        super(...arguments), this.onMouseUp = ()=>{
            this.listeners.off(document, "mouseover", this.onMouseOver), this.listeners.off(document, "mouseup", this.onMouseUp);
        }, this.onMouseOver = (e)=>{
            const { BlockManager: t1, BlockSelection: o } = this.Editor;
            if (e.relatedTarget === null && e.target === null) return;
            const i = t1.getBlockByChildNode(e.relatedTarget) || this.lastSelectedBlock, s = t1.getBlockByChildNode(e.target);
            if (!(!i || !s) && s !== i) {
                if (i === this.firstSelectedBlock) {
                    $6813aa9d7dc8ab1a$var$b.get().removeAllRanges(), i.selected = !0, s.selected = !0, o.clearCache();
                    return;
                }
                if (s === this.firstSelectedBlock) {
                    i.selected = !1, s.selected = !1, o.clearCache();
                    return;
                }
                this.Editor.InlineToolbar.close(), this.toggleBlocksSelectedState(i, s), this.lastSelectedBlock = s;
            }
        };
    }
    /**
   * Module preparation
   *
   * @returns {Promise}
   */ async prepare() {
        this.listeners.on(document, "mousedown", (e)=>{
            this.enableCrossBlockSelection(e);
        });
    }
    /**
   * Sets up listeners
   *
   * @param {MouseEvent} event - mouse down event
   */ watchSelection(e) {
        if (e.button !== $6813aa9d7dc8ab1a$var$qn.LEFT) return;
        const { BlockManager: t1 } = this.Editor;
        this.firstSelectedBlock = t1.getBlock(e.target), this.lastSelectedBlock = this.firstSelectedBlock, this.listeners.on(document, "mouseover", this.onMouseOver), this.listeners.on(document, "mouseup", this.onMouseUp);
    }
    /**
   * Return boolean is cross block selection started:
   * there should be at least 2 selected blocks
   */ get isCrossBlockSelectionStarted() {
        return !!this.firstSelectedBlock && !!this.lastSelectedBlock && this.firstSelectedBlock !== this.lastSelectedBlock;
    }
    /**
   * Change selection state of the next Block
   * Used for CBS via Shift + arrow keys
   *
   * @param {boolean} next - if true, toggle next block. Previous otherwise
   */ toggleBlockSelectedState(e = !0) {
        const { BlockManager: t1, BlockSelection: o } = this.Editor;
        this.lastSelectedBlock || (this.lastSelectedBlock = this.firstSelectedBlock = t1.currentBlock), this.firstSelectedBlock === this.lastSelectedBlock && (this.firstSelectedBlock.selected = !0, o.clearCache(), $6813aa9d7dc8ab1a$var$b.get().removeAllRanges());
        const i = t1.blocks.indexOf(this.lastSelectedBlock) + (e ? 1 : -1), s = t1.blocks[i];
        s && (this.lastSelectedBlock.selected !== s.selected ? (s.selected = !0, o.clearCache()) : (this.lastSelectedBlock.selected = !1, o.clearCache()), this.lastSelectedBlock = s, this.Editor.InlineToolbar.close(), s.holder.scrollIntoView({
            block: "nearest"
        }));
    }
    /**
   * Clear saved state
   *
   * @param {Event} reason - event caused clear of selection
   */ clear(e) {
        const { BlockManager: t1, BlockSelection: o, Caret: i } = this.Editor, s = t1.blocks.indexOf(this.firstSelectedBlock), r = t1.blocks.indexOf(this.lastSelectedBlock);
        if (o.anyBlockSelected && s > -1 && r > -1 && e && e instanceof KeyboardEvent) switch(e.keyCode){
            case $6813aa9d7dc8ab1a$var$y.DOWN:
            case $6813aa9d7dc8ab1a$var$y.RIGHT:
                i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
                break;
            case $6813aa9d7dc8ab1a$var$y.UP:
            case $6813aa9d7dc8ab1a$var$y.LEFT:
                i.setToBlock(t1.blocks[Math.min(s, r)], i.positions.START);
                break;
            default:
                i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
        }
        this.firstSelectedBlock = this.lastSelectedBlock = null;
    }
    /**
   * Enables Cross Block Selection
   *
   * @param {MouseEvent} event - mouse down event
   */ enableCrossBlockSelection(e) {
        const { UI: t1 } = this.Editor;
        $6813aa9d7dc8ab1a$var$b.isCollapsed || this.Editor.BlockSelection.clearSelection(e), t1.nodes.redactor.contains(e.target) ? this.watchSelection(e) : this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Change blocks selection state between passed two blocks.
   *
   * @param {Block} firstBlock - first block in range
   * @param {Block} lastBlock - last block in range
   */ toggleBlocksSelectedState(e, t1) {
        const { BlockManager: o, BlockSelection: i } = this.Editor, s = o.blocks.indexOf(e), r = o.blocks.indexOf(t1), a = e.selected !== t1.selected;
        for(let l = Math.min(s, r); l <= Math.max(s, r); l++){
            const c = o.blocks[l];
            c !== this.firstSelectedBlock && c !== (a ? e : t1) && (o.blocks[l].selected = !o.blocks[l].selected, i.clearCache());
        }
    }
}
class $6813aa9d7dc8ab1a$var$ca extends $6813aa9d7dc8ab1a$var$E {
    constructor(){
        super(...arguments), this.isStartedAtEditor = !1;
    }
    /**
   * Toggle read-only state
   *
   * if state is true:
   *  - disable all drag-n-drop event handlers
   *
   * if state is false:
   *  - restore drag-n-drop event handlers
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.disableModuleBindings() : this.enableModuleBindings();
    }
    /**
   * Add drag events listeners to editor zone
   */ enableModuleBindings() {
        const { UI: e } = this.Editor;
        this.readOnlyMutableListeners.on(e.nodes.holder, "drop", async (t1)=>{
            await this.processDrop(t1);
        }, !0), this.readOnlyMutableListeners.on(e.nodes.holder, "dragstart", ()=>{
            this.processDragStart();
        }), this.readOnlyMutableListeners.on(e.nodes.holder, "dragover", (t1)=>{
            this.processDragOver(t1);
        }, !0);
    }
    /**
   * Unbind drag-n-drop event handlers
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Handle drop event
   *
   * @param {DragEvent} dropEvent - drop event
   */ async processDrop(e) {
        const { BlockManager: t1, Paste: o, Caret: i } = this.Editor;
        e.preventDefault(), t1.blocks.forEach((r)=>{
            r.dropTarget = !1;
        }), $6813aa9d7dc8ab1a$var$b.isAtEditor && !$6813aa9d7dc8ab1a$var$b.isCollapsed && this.isStartedAtEditor && document.execCommand("delete"), this.isStartedAtEditor = !1;
        const s = t1.setCurrentBlockByChildNode(e.target);
        if (s) this.Editor.Caret.setToBlock(s, i.positions.END);
        else {
            const r = t1.setCurrentBlockByChildNode(t1.lastBlock.holder);
            this.Editor.Caret.setToBlock(r, i.positions.END);
        }
        await o.processDataTransfer(e.dataTransfer, !0);
    }
    /**
   * Handle drag start event
   */ processDragStart() {
        $6813aa9d7dc8ab1a$var$b.isAtEditor && !$6813aa9d7dc8ab1a$var$b.isCollapsed && (this.isStartedAtEditor = !0), this.Editor.InlineToolbar.close();
    }
    /**
   * @param {DragEvent} dragEvent - drag event
   */ processDragOver(e) {
        e.preventDefault();
    }
}
const $6813aa9d7dc8ab1a$var$da = 180, $6813aa9d7dc8ab1a$var$ua = 400;
class $6813aa9d7dc8ab1a$var$ha extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Prepare the module
   *
   * @param options - options used by the modification observer module
   * @param options.config - Editor configuration object
   * @param options.eventsDispatcher - common Editor event bus
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.disabled = !1, this.batchingTimeout = null, this.batchingOnChangeQueue = /* @__PURE__ */ new Map(), this.batchTime = $6813aa9d7dc8ab1a$var$ua, this.mutationObserver = new MutationObserver((o)=>{
            this.redactorChanged(o);
        }), this.eventsDispatcher.on($6813aa9d7dc8ab1a$var$$o, (o)=>{
            this.particularBlockChanged(o.event);
        }), this.eventsDispatcher.on($6813aa9d7dc8ab1a$var$zo, ()=>{
            this.disable();
        }), this.eventsDispatcher.on($6813aa9d7dc8ab1a$var$Uo, ()=>{
            this.enable();
        });
    }
    /**
   * Enables onChange event
   */ enable() {
        this.mutationObserver.observe(this.Editor.UI.nodes.redactor, {
            childList: !0,
            subtree: !0,
            characterData: !0,
            attributes: !0
        }), this.disabled = !1;
    }
    /**
   * Disables onChange event
   */ disable() {
        this.mutationObserver.disconnect(), this.disabled = !0;
    }
    /**
   * Call onChange event passed to Editor.js configuration
   *
   * @param event - some of our custom change events
   */ particularBlockChanged(e) {
        this.disabled || !$6813aa9d7dc8ab1a$var$A(this.config.onChange) || (this.batchingOnChangeQueue.set(`block:${e.detail.target.id}:event:${e.type}`, e), this.batchingTimeout && clearTimeout(this.batchingTimeout), this.batchingTimeout = setTimeout(()=>{
            let t1;
            this.batchingOnChangeQueue.size === 1 ? t1 = this.batchingOnChangeQueue.values().next().value : t1 = Array.from(this.batchingOnChangeQueue.values()), this.config.onChange && this.config.onChange(this.Editor.API.methods, t1), this.batchingOnChangeQueue.clear();
        }, this.batchTime));
    }
    /**
   * Fired on every blocks wrapper dom change
   *
   * @param mutations - mutations happened
   */ redactorChanged(e) {
        this.eventsDispatcher.emit($6813aa9d7dc8ab1a$var$ft, {
            mutations: e
        });
    }
}
const $6813aa9d7dc8ab1a$var$Rn = class Dn extends $6813aa9d7dc8ab1a$var$E {
    constructor(){
        super(...arguments), this.MIME_TYPE = "application/x-editor-js", this.toolsTags = {}, this.tagsByTool = {}, this.toolsPatterns = [], this.toolsFiles = {}, this.exceptionList = [], this.processTool = (e)=>{
            try {
                const t1 = e.create({}, {}, !1);
                if (e.pasteConfig === !1) {
                    this.exceptionList.push(e.name);
                    return;
                }
                if (!$6813aa9d7dc8ab1a$var$A(t1.onPaste)) return;
                this.getTagsConfig(e), this.getFilesConfig(e), this.getPatternsConfig(e);
            } catch (t1) {
                $6813aa9d7dc8ab1a$var$S(`Paste handling for \xab${e.name}\xbb Tool hasn't been set up because of the error`, "warn", t1);
            }
        }, this.handlePasteEvent = async (e)=>{
            const { BlockManager: t1, Toolbar: o } = this.Editor, i = t1.setCurrentBlockByChildNode(e.target);
            !i || this.isNativeBehaviour(e.target) && !e.clipboardData.types.includes("Files") || i && this.exceptionList.includes(i.name) || (e.preventDefault(), this.processDataTransfer(e.clipboardData), o.close());
        };
    }
    /**
   * Set onPaste callback and collect tools` paste configurations
   */ async prepare() {
        this.processTools();
    }
    /**
   * Set read-only state
   *
   * @param {boolean} readOnlyEnabled - read only flag value
   */ toggleReadOnly(e) {
        e ? this.unsetCallback() : this.setCallback();
    }
    /**
   * Handle pasted or dropped data transfer object
   *
   * @param {DataTransfer} dataTransfer - pasted or dropped data transfer object
   * @param {boolean} isDragNDrop - true if data transfer comes from drag'n'drop events
   */ async processDataTransfer(e, t1 = !1) {
        const { Tools: o } = this.Editor, i = e.types;
        if ((i.includes ? i.includes("Files") : i.contains("Files")) && !$6813aa9d7dc8ab1a$var$V(this.toolsFiles)) {
            await this.processFiles(e.files);
            return;
        }
        const r = e.getData(this.MIME_TYPE), a = e.getData("text/plain");
        let l = e.getData("text/html");
        if (r) try {
            this.insertEditorJSData(JSON.parse(r));
            return;
        } catch  {}
        t1 && a.trim() && l.trim() && (l = "<p>" + (l.trim() ? l : a) + "</p>");
        const c = Object.keys(this.toolsTags).reduce((p, g)=>(p[g.toLowerCase()] = this.toolsTags[g].sanitizationConfig ?? {}, p), {}), d = Object.assign({}, c, o.getAllInlineToolsSanitizeConfig(), {
            br: {}
        }), h = $6813aa9d7dc8ab1a$var$Z(l, d);
        !h.trim() || h.trim() === a || !$6813aa9d7dc8ab1a$var$u.isHTMLString(h) ? await this.processText(a) : await this.processText(h, !0);
    }
    /**
   * Process pasted text and divide them into Blocks
   *
   * @param {string} data - text to process. Can be HTML or plain.
   * @param {boolean} isHTML - if passed string is HTML, this parameter should be true
   */ async processText(e, t1 = !1) {
        const { Caret: o, BlockManager: i } = this.Editor, s = t1 ? this.processHTML(e) : this.processPlain(e);
        if (!s.length) return;
        if (s.length === 1) {
            s[0].isBlock ? this.processSingleBlock(s.pop()) : this.processInlinePaste(s.pop());
            return;
        }
        const a = i.currentBlock && i.currentBlock.tool.isDefault && i.currentBlock.isEmpty;
        s.map(async (l, c)=>this.insertBlock(l, c === 0 && a)), i.currentBlock && o.setToBlock(i.currentBlock, o.positions.END);
    }
    /**
   * Set onPaste callback handler
   */ setCallback() {
        this.listeners.on(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
    }
    /**
   * Unset onPaste callback handler
   */ unsetCallback() {
        this.listeners.off(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
    }
    /**
   * Get and process tool`s paste configs
   */ processTools() {
        const e = this.Editor.Tools.blockTools;
        Array.from(e.values()).forEach(this.processTool);
    }
    /**
   * Get tags name list from either tag name or sanitization config.
   *
   * @param {string | object} tagOrSanitizeConfig - tag name or sanitize config object.
   * @returns {string[]} array of tags.
   */ collectTagNames(e) {
        return $6813aa9d7dc8ab1a$var$te(e) ? [
            e
        ] : $6813aa9d7dc8ab1a$var$D(e) ? Object.keys(e) : [];
    }
    /**
   * Get tags to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getTagsConfig(e) {
        if (e.pasteConfig === !1) return;
        const t1 = e.pasteConfig.tags || [], o = [];
        t1.forEach((i)=>{
            const s = this.collectTagNames(i);
            o.push(...s), s.forEach((r)=>{
                if (Object.prototype.hasOwnProperty.call(this.toolsTags, r)) {
                    $6813aa9d7dc8ab1a$var$S(`Paste handler for \xab${e.name}\xbb Tool on \xab${r}\xbb tag is skipped because it is already used by \xab${this.toolsTags[r].tool.name}\xbb Tool.`, "warn");
                    return;
                }
                const a = $6813aa9d7dc8ab1a$var$D(i) ? i[r] : null;
                this.toolsTags[r.toUpperCase()] = {
                    tool: e,
                    sanitizationConfig: a
                };
            });
        }), this.tagsByTool[e.name] = o.map((i)=>i.toUpperCase());
    }
    /**
   * Get files` types and extensions to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getFilesConfig(e) {
        if (e.pasteConfig === !1) return;
        const { files: t1 = {} } = e.pasteConfig;
        let { extensions: o, mimeTypes: i } = t1;
        !o && !i || (o && !Array.isArray(o) && ($6813aa9d7dc8ab1a$var$S(`\xabextensions\xbb property of the onDrop config for \xab${e.name}\xbb Tool should be an array`), o = []), i && !Array.isArray(i) && ($6813aa9d7dc8ab1a$var$S(`\xabmimeTypes\xbb property of the onDrop config for \xab${e.name}\xbb Tool should be an array`), i = []), i && (i = i.filter((s)=>$6813aa9d7dc8ab1a$var$ei(s) ? !0 : ($6813aa9d7dc8ab1a$var$S(`MIME type value \xab${s}\xbb for the \xab${e.name}\xbb Tool is not a valid MIME type`, "warn"), !1))), this.toolsFiles[e.name] = {
            extensions: o || [],
            mimeTypes: i || []
        });
    }
    /**
   * Get RegExp patterns to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getPatternsConfig(e) {
        e.pasteConfig === !1 || !e.pasteConfig.patterns || $6813aa9d7dc8ab1a$var$V(e.pasteConfig.patterns) || Object.entries(e.pasteConfig.patterns).forEach(([t1, o])=>{
            o instanceof RegExp || $6813aa9d7dc8ab1a$var$S(`Pattern ${o} for \xab${e.name}\xbb Tool is skipped because it should be a Regexp instance.`, "warn"), this.toolsPatterns.push({
                key: t1,
                pattern: o,
                tool: e
            });
        });
    }
    /**
   * Check if browser behavior suits better
   *
   * @param {EventTarget} element - element where content has been pasted
   * @returns {boolean}
   */ isNativeBehaviour(e) {
        return $6813aa9d7dc8ab1a$var$u.isNativeInput(e);
    }
    /**
   * Get files from data transfer object and insert related Tools
   *
   * @param {FileList} items - pasted or dropped items
   */ async processFiles(e) {
        const { BlockManager: t1 } = this.Editor;
        let o;
        o = await Promise.all(Array.from(e).map((r)=>this.processFile(r))), o = o.filter((r)=>!!r);
        const s = t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty;
        o.forEach((r, a)=>{
            t1.paste(r.type, r.event, a === 0 && s);
        });
    }
    /**
   * Get information about file and find Tool to handle it
   *
   * @param {File} file - file to process
   */ async processFile(e) {
        const t1 = $6813aa9d7dc8ab1a$var$Jn(e), o = Object.entries(this.toolsFiles).find(([r, { mimeTypes: a, extensions: l }])=>{
            const [c, d] = e.type.split("/"), h = l.find((g)=>g.toLowerCase() === t1.toLowerCase()), p = a.find((g)=>{
                const [f, v] = g.split("/");
                return f === c && (v === d || v === "*");
            });
            return !!h || !!p;
        });
        if (!o) return;
        const [i] = o;
        return {
            event: this.composePasteEvent("file", {
                file: e
            }),
            type: i
        };
    }
    /**
   * Split HTML string to blocks and return it as array of Block data
   *
   * @param {string} innerHTML - html string to process
   * @returns {PasteData[]}
   */ processHTML(e) {
        const { Tools: t1 } = this.Editor, o = $6813aa9d7dc8ab1a$var$u.make("DIV");
        return o.innerHTML = e, this.getNodes(o).map((s)=>{
            let r, a = t1.defaultTool, l = !1;
            switch(s.nodeType){
                case Node.DOCUMENT_FRAGMENT_NODE:
                    r = $6813aa9d7dc8ab1a$var$u.make("div"), r.appendChild(s);
                    break;
                case Node.ELEMENT_NODE:
                    r = s, l = !0, this.toolsTags[r.tagName] && (a = this.toolsTags[r.tagName].tool);
                    break;
            }
            const { tags: c } = a.pasteConfig || {
                tags: []
            }, d = c.reduce((g, f)=>(this.collectTagNames(f).forEach((O)=>{
                    const T = $6813aa9d7dc8ab1a$var$D(f) ? f[O] : null;
                    g[O.toLowerCase()] = T || {};
                }), g), {}), h = Object.assign({}, d, a.baseSanitizeConfig);
            if (r.tagName.toLowerCase() === "table") {
                const g = $6813aa9d7dc8ab1a$var$Z(r.outerHTML, h);
                r = $6813aa9d7dc8ab1a$var$u.make("div", void 0, {
                    innerHTML: g
                }).firstChild;
            } else r.innerHTML = $6813aa9d7dc8ab1a$var$Z(r.innerHTML, h);
            const p = this.composePasteEvent("tag", {
                data: r
            });
            return {
                content: r,
                isBlock: l,
                tool: a.name,
                event: p
            };
        }).filter((s)=>{
            const r = $6813aa9d7dc8ab1a$var$u.isEmpty(s.content), a = $6813aa9d7dc8ab1a$var$u.isSingleTag(s.content);
            return !r || a;
        });
    }
    /**
   * Split plain text by new line symbols and return it as array of Block data
   *
   * @param {string} plain - string to process
   * @returns {PasteData[]}
   */ processPlain(e) {
        const { defaultBlock: t1 } = this.config;
        if (!e) return [];
        const o = t1;
        return e.split(/\r?\n/).filter((i)=>i.trim()).map((i)=>{
            const s = $6813aa9d7dc8ab1a$var$u.make("div");
            s.textContent = i;
            const r = this.composePasteEvent("tag", {
                data: s
            });
            return {
                content: s,
                tool: o,
                isBlock: !1,
                event: r
            };
        });
    }
    /**
   * Process paste of single Block tool content
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ async processSingleBlock(e) {
        const { Caret: t1, BlockManager: o } = this.Editor, { currentBlock: i } = o;
        if (!i || e.tool !== i.name || !$6813aa9d7dc8ab1a$var$u.containsOnlyInlineElements(e.content.innerHTML)) {
            this.insertBlock(e, (i == null ? void 0 : i.tool.isDefault) && i.isEmpty);
            return;
        }
        t1.insertContentAtCaretPosition(e.content.innerHTML);
    }
    /**
   * Process paste to single Block:
   * 1. Find patterns` matches
   * 2. Insert new block if it is not the same type as current one
   * 3. Just insert text if there is no substitutions
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ async processInlinePaste(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { content: i } = e;
        if (t1.currentBlock && t1.currentBlock.tool.isDefault && i.textContent.length < Dn.PATTERN_PROCESSING_MAX_LENGTH) {
            const r = await this.processPattern(i.textContent);
            if (r) {
                const a = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty, l = t1.paste(r.tool, r.event, a);
                o.setToBlock(l, o.positions.END);
                return;
            }
        }
        if (t1.currentBlock && t1.currentBlock.currentInput) {
            const r = t1.currentBlock.tool.baseSanitizeConfig;
            document.execCommand("insertHTML", !1, $6813aa9d7dc8ab1a$var$Z(i.innerHTML, r));
        } else this.insertBlock(e);
    }
    /**
   * Get patterns` matches
   *
   * @param {string} text - text to process
   * @returns {Promise<{event: PasteEvent, tool: string}>}
   */ async processPattern(e) {
        const t1 = this.toolsPatterns.find((i)=>{
            const s = i.pattern.exec(e);
            return s ? e === s.shift() : !1;
        });
        return t1 ? {
            event: this.composePasteEvent("pattern", {
                key: t1.key,
                data: e
            }),
            tool: t1.tool.name
        } : void 0;
    }
    /**
   * Insert pasted Block content to Editor
   *
   * @param {PasteData} data - data to insert
   * @param {boolean} canReplaceCurrentBlock - if true and is current Block is empty, will replace current Block
   * @returns {void}
   */ insertBlock(e, t1 = !1) {
        const { BlockManager: o, Caret: i } = this.Editor, { currentBlock: s } = o;
        let r;
        if (t1 && s && s.isEmpty) {
            r = o.paste(e.tool, e.event, !0), i.setToBlock(r, i.positions.END);
            return;
        }
        r = o.paste(e.tool, e.event), i.setToBlock(r, i.positions.END);
    }
    /**
   * Insert data passed as application/x-editor-js JSON
   *
   * @param {Array} blocks — Blocks' data to insert
   * @returns {void}
   */ insertEditorJSData(e) {
        const { BlockManager: t1, Caret: o, Tools: i } = this.Editor;
        $6813aa9d7dc8ab1a$var$yt(e, (r)=>i.blockTools.get(r).sanitizeConfig).forEach(({ tool: r, data: a }, l)=>{
            let c = !1;
            l === 0 && (c = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty);
            const d = t1.insert({
                tool: r,
                data: a,
                replace: c
            });
            o.setToBlock(d, o.positions.END);
        });
    }
    /**
   * Fetch nodes from Element node
   *
   * @param {Node} node - current node
   * @param {Node[]} nodes - processed nodes
   * @param {Node} destNode - destination node
   */ processElementNode(e, t1, o) {
        const i = Object.keys(this.toolsTags), s = e, { tool: r } = this.toolsTags[s.tagName] || {}, a = this.tagsByTool[r == null ? void 0 : r.name] || [], l = i.includes(s.tagName), c = $6813aa9d7dc8ab1a$var$u.blockElements.includes(s.tagName.toLowerCase()), d = Array.from(s.children).some(({ tagName: p })=>i.includes(p) && !a.includes(p)), h = Array.from(s.children).some(({ tagName: p })=>$6813aa9d7dc8ab1a$var$u.blockElements.includes(p.toLowerCase()));
        if (!c && !l && !d) return o.appendChild(s), [
            ...t1,
            o
        ];
        if (l && !d || c && !h && !d) return [
            ...t1,
            o,
            s
        ];
    }
    /**
   * Recursively divide HTML string to two types of nodes:
   * 1. Block element
   * 2. Document Fragments contained text and markup tags like a, b, i etc.
   *
   * @param {Node} wrapper - wrapper of paster HTML content
   * @returns {Node[]}
   */ getNodes(e) {
        const t1 = Array.from(e.childNodes);
        let o;
        const i = (s, r)=>{
            if ($6813aa9d7dc8ab1a$var$u.isEmpty(r) && !$6813aa9d7dc8ab1a$var$u.isSingleTag(r)) return s;
            const a = s[s.length - 1];
            let l = new DocumentFragment();
            switch(a && $6813aa9d7dc8ab1a$var$u.isFragment(a) && (l = s.pop()), r.nodeType){
                case Node.ELEMENT_NODE:
                    if (o = this.processElementNode(r, s, l), o) return o;
                    break;
                case Node.TEXT_NODE:
                    return l.appendChild(r), [
                        ...s,
                        l
                    ];
                default:
                    return [
                        ...s,
                        l
                    ];
            }
            return [
                ...s,
                ...Array.from(r.childNodes).reduce(i, [])
            ];
        };
        return t1.reduce(i, []);
    }
    /**
   * Compose paste event with passed type and detail
   *
   * @param {string} type - event type
   * @param {PasteEventDetail} detail - event detail
   */ composePasteEvent(e, t1) {
        return new CustomEvent(e, {
            detail: t1
        });
    }
};
$6813aa9d7dc8ab1a$var$Rn.PATTERN_PROCESSING_MAX_LENGTH = 450;
let $6813aa9d7dc8ab1a$var$pa = $6813aa9d7dc8ab1a$var$Rn;
class $6813aa9d7dc8ab1a$var$fa extends $6813aa9d7dc8ab1a$var$E {
    constructor(){
        super(...arguments), this.toolsDontSupportReadOnly = [], this.readOnlyEnabled = !1;
    }
    /**
   * Returns state of read only mode
   */ get isEnabled() {
        return this.readOnlyEnabled;
    }
    /**
   * Set initial state
   */ async prepare() {
        const { Tools: e } = this.Editor, { blockTools: t1 } = e, o = [];
        Array.from(t1.entries()).forEach(([i, s])=>{
            s.isReadOnlySupported || o.push(i);
        }), this.toolsDontSupportReadOnly = o, this.config.readOnly && o.length > 0 && this.throwCriticalError(), this.toggle(this.config.readOnly, !0);
    }
    /**
   * Set read-only mode or toggle current state
   * Call all Modules `toggleReadOnly` method and re-render Editor
   *
   * @param state - (optional) read-only state or toggle
   * @param isInitial - (optional) true when editor is initializing
   */ async toggle(e = !this.readOnlyEnabled, t1 = !1) {
        e && this.toolsDontSupportReadOnly.length > 0 && this.throwCriticalError();
        const o = this.readOnlyEnabled;
        this.readOnlyEnabled = e;
        for(const s in this.Editor)this.Editor[s].toggleReadOnly && this.Editor[s].toggleReadOnly(e);
        if (o === e) return this.readOnlyEnabled;
        if (t1) return this.readOnlyEnabled;
        this.Editor.ModificationsObserver.disable();
        const i = await this.Editor.Saver.save();
        return await this.Editor.BlockManager.clear(), await this.Editor.Renderer.render(i.blocks), this.Editor.ModificationsObserver.enable(), this.readOnlyEnabled;
    }
    /**
   * Throws an error about tools which don't support read-only mode
   */ throwCriticalError() {
        throw new $6813aa9d7dc8ab1a$var$Ho(`To enable read-only mode all connected tools should support it. Tools ${this.toolsDontSupportReadOnly.join(", ")} don't support read-only mode.`);
    }
}
class $6813aa9d7dc8ab1a$var$Be extends $6813aa9d7dc8ab1a$var$E {
    constructor(){
        super(...arguments), this.isRectSelectionActivated = !1, this.SCROLL_SPEED = 3, this.HEIGHT_OF_SCROLL_ZONE = 40, this.BOTTOM_SCROLL_ZONE = 1, this.TOP_SCROLL_ZONE = 2, this.MAIN_MOUSE_BUTTON = 0, this.mousedown = !1, this.isScrolling = !1, this.inScrollZone = null, this.startX = 0, this.startY = 0, this.mouseX = 0, this.mouseY = 0, this.stackOfSelected = [], this.listenerIds = [];
    }
    /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ static get CSS() {
        return {
            overlay: "codex-editor-overlay",
            overlayContainer: "codex-editor-overlay__container",
            rect: "codex-editor-overlay__rectangle",
            topScrollZone: "codex-editor-overlay__scroll-zone--top",
            bottomScrollZone: "codex-editor-overlay__scroll-zone--bottom"
        };
    }
    /**
   * Module Preparation
   * Creating rect and hang handlers
   */ prepare() {
        this.enableModuleBindings();
    }
    /**
   * Init rect params
   *
   * @param {number} pageX - X coord of mouse
   * @param {number} pageY - Y coord of mouse
   */ startSelection(e, t1) {
        const o = document.elementFromPoint(e - window.pageXOffset, t1 - window.pageYOffset);
        o.closest(`.${this.Editor.Toolbar.CSS.toolbar}`) || (this.Editor.BlockSelection.allBlocksSelected = !1, this.clearSelection(), this.stackOfSelected = []);
        const s = [
            `.${$6813aa9d7dc8ab1a$var$R.CSS.content}`,
            `.${this.Editor.Toolbar.CSS.toolbar}`,
            `.${this.Editor.InlineToolbar.CSS.inlineToolbar}`
        ], r = o.closest("." + this.Editor.UI.CSS.editorWrapper), a = s.some((l)=>!!o.closest(l));
        !r || a || (this.mousedown = !0, this.startX = e, this.startY = t1);
    }
    /**
   * Clear all params to end selection
   */ endSelection() {
        this.mousedown = !1, this.startX = 0, this.startY = 0, this.overlayRectangle.style.display = "none";
    }
    /**
   * is RectSelection Activated
   */ isRectActivated() {
        return this.isRectSelectionActivated;
    }
    /**
   * Mark that selection is end
   */ clearSelection() {
        this.isRectSelectionActivated = !1;
    }
    /**
   * Sets Module necessary event handlers
   */ enableModuleBindings() {
        const { container: e } = this.genHTML();
        this.listeners.on(e, "mousedown", (t1)=>{
            this.processMouseDown(t1);
        }, !1), this.listeners.on(document.body, "mousemove", $6813aa9d7dc8ab1a$var$dt((t1)=>{
            this.processMouseMove(t1);
        }, 10), {
            passive: !0
        }), this.listeners.on(document.body, "mouseleave", ()=>{
            this.processMouseLeave();
        }), this.listeners.on(window, "scroll", $6813aa9d7dc8ab1a$var$dt((t1)=>{
            this.processScroll(t1);
        }, 10), {
            passive: !0
        }), this.listeners.on(document.body, "mouseup", ()=>{
            this.processMouseUp();
        }, !1);
    }
    /**
   * Handle mouse down events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processMouseDown(e) {
        if (e.button !== this.MAIN_MOUSE_BUTTON) return;
        e.target.closest($6813aa9d7dc8ab1a$var$u.allInputsSelector) !== null || this.startSelection(e.pageX, e.pageY);
    }
    /**
   * Handle mouse move events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processMouseMove(e) {
        this.changingRectangle(e), this.scrollByZones(e.clientY);
    }
    /**
   * Handle mouse leave
   */ processMouseLeave() {
        this.clearSelection(), this.endSelection();
    }
    /**
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processScroll(e) {
        this.changingRectangle(e);
    }
    /**
   * Handle mouse up
   */ processMouseUp() {
        this.clearSelection(), this.endSelection();
    }
    /**
   * Scroll If mouse in scroll zone
   *
   * @param {number} clientY - Y coord of mouse
   */ scrollByZones(e) {
        if (this.inScrollZone = null, e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.TOP_SCROLL_ZONE), document.documentElement.clientHeight - e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.BOTTOM_SCROLL_ZONE), !this.inScrollZone) {
            this.isScrolling = !1;
            return;
        }
        this.isScrolling || (this.scrollVertical(this.inScrollZone === this.TOP_SCROLL_ZONE ? -this.SCROLL_SPEED : this.SCROLL_SPEED), this.isScrolling = !0);
    }
    /**
   * Generates required HTML elements
   *
   * @returns {Object<string, Element>}
   */ genHTML() {
        const { UI: e } = this.Editor, t1 = e.nodes.holder.querySelector("." + e.CSS.editorWrapper), o = $6813aa9d7dc8ab1a$var$u.make("div", $6813aa9d7dc8ab1a$var$Be.CSS.overlay, {}), i = $6813aa9d7dc8ab1a$var$u.make("div", $6813aa9d7dc8ab1a$var$Be.CSS.overlayContainer, {}), s = $6813aa9d7dc8ab1a$var$u.make("div", $6813aa9d7dc8ab1a$var$Be.CSS.rect, {});
        return i.appendChild(s), o.appendChild(i), t1.appendChild(o), this.overlayRectangle = s, {
            container: t1,
            overlay: o
        };
    }
    /**
   * Activates scrolling if blockSelection is active and mouse is in scroll zone
   *
   * @param {number} speed - speed of scrolling
   */ scrollVertical(e) {
        if (!(this.inScrollZone && this.mousedown)) return;
        const t1 = window.pageYOffset;
        window.scrollBy(0, e), this.mouseY += window.pageYOffset - t1, setTimeout(()=>{
            this.scrollVertical(e);
        }, 0);
    }
    /**
   * Handles the change in the rectangle and its effect
   *
   * @param {MouseEvent} event - mouse event
   */ changingRectangle(e) {
        if (!this.mousedown) return;
        e.pageY !== void 0 && (this.mouseX = e.pageX, this.mouseY = e.pageY);
        const { rightPos: t1, leftPos: o, index: i } = this.genInfoForMouseSelection(), s = this.startX > t1 && this.mouseX > t1, r = this.startX < o && this.mouseX < o;
        this.rectCrossesBlocks = !(s || r), this.isRectSelectionActivated || (this.rectCrossesBlocks = !1, this.isRectSelectionActivated = !0, this.shrinkRectangleToPoint(), this.overlayRectangle.style.display = "block"), this.updateRectangleSize(), this.Editor.Toolbar.close(), i !== void 0 && (this.trySelectNextBlock(i), this.inverseSelection(), $6813aa9d7dc8ab1a$var$b.get().removeAllRanges());
    }
    /**
   * Shrink rect to singular point
   */ shrinkRectangleToPoint() {
        this.overlayRectangle.style.left = `${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.top = `${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.bottom = `calc(100% - ${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.right = `calc(100% - ${this.startX - window.pageXOffset}px`;
    }
    /**
   * Select or unselect all of blocks in array if rect is out or in selectable area
   */ inverseSelection() {
        const t1 = this.Editor.BlockManager.getBlockByIndex(this.stackOfSelected[0]).selected;
        if (this.rectCrossesBlocks && !t1) for (const o of this.stackOfSelected)this.Editor.BlockSelection.selectBlockByIndex(o);
        if (!this.rectCrossesBlocks && t1) for (const o of this.stackOfSelected)this.Editor.BlockSelection.unSelectBlockByIndex(o);
    }
    /**
   * Updates size of rectangle
   */ updateRectangleSize() {
        this.mouseY >= this.startY ? (this.overlayRectangle.style.top = `${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.bottom = `calc(100% - ${this.mouseY - window.pageYOffset}px`) : (this.overlayRectangle.style.bottom = `calc(100% - ${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.top = `${this.mouseY - window.pageYOffset}px`), this.mouseX >= this.startX ? (this.overlayRectangle.style.left = `${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.right = `calc(100% - ${this.mouseX - window.pageXOffset}px`) : (this.overlayRectangle.style.right = `calc(100% - ${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.left = `${this.mouseX - window.pageXOffset}px`);
    }
    /**
   * Collects information needed to determine the behavior of the rectangle
   *
   * @returns {object} index - index next Block, leftPos - start of left border of Block, rightPos - right border
   */ genInfoForMouseSelection() {
        const t1 = document.body.offsetWidth / 2, o = this.mouseY - window.pageYOffset, i = document.elementFromPoint(t1, o), s = this.Editor.BlockManager.getBlockByChildNode(i);
        let r;
        s !== void 0 && (r = this.Editor.BlockManager.blocks.findIndex((h)=>h.holder === s.holder));
        const a = this.Editor.BlockManager.lastBlock.holder.querySelector("." + $6813aa9d7dc8ab1a$var$R.CSS.content), l = Number.parseInt(window.getComputedStyle(a).width, 10) / 2, c = t1 - l, d = t1 + l;
        return {
            index: r,
            leftPos: c,
            rightPos: d
        };
    }
    /**
   * Select block with index index
   *
   * @param index - index of block in redactor
   */ addBlockInSelection(e) {
        this.rectCrossesBlocks && this.Editor.BlockSelection.selectBlockByIndex(e), this.stackOfSelected.push(e);
    }
    /**
   * Adds a block to the selection and determines which blocks should be selected
   *
   * @param {object} index - index of new block in the reactor
   */ trySelectNextBlock(e) {
        const t1 = this.stackOfSelected[this.stackOfSelected.length - 1] === e, o = this.stackOfSelected.length, i = 1, s = -1, r = 0;
        if (t1) return;
        const a = this.stackOfSelected[o - 1] - this.stackOfSelected[o - 2] > 0;
        let l = r;
        o > 1 && (l = a ? i : s);
        const c = e > this.stackOfSelected[o - 1] && l === i, d = e < this.stackOfSelected[o - 1] && l === s, p = !(c || d || l === r);
        if (!p && (e > this.stackOfSelected[o - 1] || this.stackOfSelected[o - 1] === void 0)) {
            let v = this.stackOfSelected[o - 1] + 1 || e;
            for(v; v <= e; v++)this.addBlockInSelection(v);
            return;
        }
        if (!p && e < this.stackOfSelected[o - 1]) {
            for(let v = this.stackOfSelected[o - 1] - 1; v >= e; v--)this.addBlockInSelection(v);
            return;
        }
        if (!p) return;
        let g = o - 1, f;
        for(e > this.stackOfSelected[o - 1] ? f = ()=>e > this.stackOfSelected[g] : f = ()=>e < this.stackOfSelected[g]; f();)this.rectCrossesBlocks && this.Editor.BlockSelection.unSelectBlockByIndex(this.stackOfSelected[g]), this.stackOfSelected.pop(), g--;
    }
}
class $6813aa9d7dc8ab1a$var$ga extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Renders passed blocks as one batch
   *
   * @param blocksData - blocks to render
   */ async render(e) {
        return new Promise((t1)=>{
            const { Tools: o, BlockManager: i } = this.Editor;
            if (e.length === 0) i.insert();
            else {
                const s = e.map(({ type: r, data: a, tunes: l, id: c })=>{
                    o.available.has(r) === !1 && ($6813aa9d7dc8ab1a$var$X(`Tool \xab${r}\xbb is not found. Check 'tools' property at the Editor.js config.`, "warn"), a = this.composeStubDataForTool(r, a, c), r = o.stubTool);
                    let d;
                    try {
                        d = i.composeBlock({
                            id: c,
                            tool: r,
                            data: a,
                            tunes: l
                        });
                    } catch (h) {
                        $6813aa9d7dc8ab1a$var$S(`Block \xab${r}\xbb skipped because of plugins error`, "error", {
                            data: a,
                            error: h
                        }), a = this.composeStubDataForTool(r, a, c), r = o.stubTool, d = i.composeBlock({
                            id: c,
                            tool: r,
                            data: a,
                            tunes: l
                        });
                    }
                    return d;
                });
                i.insertMany(s);
            }
            window.requestIdleCallback(()=>{
                t1();
            }, {
                timeout: 2e3
            });
        });
    }
    /**
   * Create data for the Stub Tool that will be used instead of unavailable tool
   *
   * @param tool - unavailable tool name to stub
   * @param data - data of unavailable block
   * @param [id] - id of unavailable block
   */ composeStubDataForTool(e, t1, o) {
        const { Tools: i } = this.Editor;
        let s = e;
        if (i.unavailable.has(e)) {
            const r = i.unavailable.get(e).toolbox;
            r !== void 0 && r[0].title !== void 0 && (s = r[0].title);
        }
        return {
            savedData: {
                id: o,
                type: e,
                data: t1
            },
            title: s
        };
    }
}
class $6813aa9d7dc8ab1a$var$ma extends $6813aa9d7dc8ab1a$var$E {
    /**
   * Composes new chain of Promises to fire them alternatelly
   *
   * @returns {OutputData}
   */ async save() {
        const { BlockManager: e, Tools: t1 } = this.Editor, o = e.blocks, i = [];
        try {
            o.forEach((a)=>{
                i.push(this.getSavedData(a));
            });
            const s = await Promise.all(i), r = await $6813aa9d7dc8ab1a$var$yt(s, (a)=>t1.blockTools.get(a).sanitizeConfig);
            return this.makeOutput(r);
        } catch (s) {
            $6813aa9d7dc8ab1a$var$X("Saving failed due to the Error %o", "error", s);
        }
    }
    /**
   * Saves and validates
   *
   * @param {Block} block - Editor's Tool
   * @returns {ValidatedData} - Tool's validated data
   */ async getSavedData(e) {
        const t1 = await e.save(), o = t1 && await e.validate(t1.data);
        return {
            ...t1,
            isValid: o
        };
    }
    /**
   * Creates output object with saved data, time and version of editor
   *
   * @param {ValidatedData} allExtractedData - data extracted from Blocks
   * @returns {OutputData}
   */ makeOutput(e) {
        const t1 = [];
        return e.forEach(({ id: o, tool: i, data: s, tunes: r, isValid: a })=>{
            if (!a) {
                $6813aa9d7dc8ab1a$var$S(`Block \xab${i}\xbb skipped because saved data is invalid`);
                return;
            }
            if (i === this.Editor.Tools.stubTool) {
                t1.push(s);
                return;
            }
            const l = {
                id: o,
                type: i,
                data: s,
                ...!$6813aa9d7dc8ab1a$var$V(r) && {
                    tunes: r
                }
            };
            t1.push(l);
        }), {
            time: +/* @__PURE__ */ new Date(),
            blocks: t1,
            version: "2.31.6"
        };
    }
}
(function() {
    try {
        if (typeof document < "u") {
            var n = document.createElement("style");
            n.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(n);
        }
    } catch (e) {
        console.error("vite-plugin-css-injected-by-js", e);
    }
})();
const $6813aa9d7dc8ab1a$var$ba = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $6813aa9d7dc8ab1a$var$va(n) {
    const e = document.createElement("div");
    e.innerHTML = n.trim();
    const t1 = document.createDocumentFragment();
    return t1.append(...Array.from(e.childNodes)), t1;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ class $6813aa9d7dc8ab1a$var$fo {
    /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ static get DEFAULT_PLACEHOLDER() {
        return "";
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} params - constructor params
   * @param {ParagraphData} params.data - previously saved data
   * @param {ParagraphConfig} params.config - user config for Tool
   * @param {object} params.api - editor.js api
   * @param {boolean} readOnly - read only mode flag
   */ constructor({ data: e, config: t1, api: o, readOnly: i }){
        this.api = o, this.readOnly = i, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = t1.placeholder ? t1.placeholder : $6813aa9d7dc8ab1a$var$fo.DEFAULT_PLACEHOLDER, this._data = e ?? {}, this._element = null, this._preserveBlank = t1.preserveBlank ?? !1;
    }
    /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ onKeyUp(e) {
        if (e.code !== "Backspace" && e.code !== "Delete" || !this._element) return;
        const { textContent: t1 } = this._element;
        t1 === "" && (this._element.innerHTML = "");
    }
    /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ drawView() {
        const e = document.createElement("DIV");
        return e.classList.add(this._CSS.wrapper, this._CSS.block), e.contentEditable = "false", e.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (e.innerHTML = this._data.text), this.readOnly || (e.contentEditable = "true", e.addEventListener("keyup", this.onKeyUp)), e;
    }
    /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ render() {
        return this._element = this.drawView(), this._element;
    }
    /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ merge(e) {
        if (!this._element) return;
        this._data.text += e.text;
        const t1 = $6813aa9d7dc8ab1a$var$va(e.text);
        this._element.appendChild(t1), this._element.normalize();
    }
    /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ validate(e) {
        return !(e.text.trim() === "" && !this._preserveBlank);
    }
    /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ save(e) {
        return {
            text: e.innerHTML
        };
    }
    /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ onPaste(e) {
        const t1 = {
            text: e.detail.data.innerHTML
        };
        this._data = t1, window.requestAnimationFrame(()=>{
            this._element && (this._element.innerHTML = this._data.text || "");
        });
    }
    /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ static get conversionConfig() {
        return {
            export: "text",
            // to convert Paragraph to other block, use 'text' property of saved data
            import: "text"
        };
    }
    /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ static get sanitize() {
        return {
            text: {
                br: !0
            }
        };
    }
    /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ static get pasteConfig() {
        return {
            tags: [
                "P"
            ]
        };
    }
    /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ static get toolbox() {
        return {
            icon: $6813aa9d7dc8ab1a$var$ba,
            title: "Text"
        };
    }
}
class $6813aa9d7dc8ab1a$var$go {
    constructor(){
        this.commandName = "bold";
    }
    /**
   * Sanitizer Rule
   * Leave <b> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            b: {}
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return {
            icon: $6813aa9d7dc8ab1a$var$Ki,
            name: "bold",
            onActivate: ()=>{
                document.execCommand(this.commandName);
            },
            isActive: ()=>document.queryCommandState(this.commandName)
        };
    }
    /**
   * Set a shortcut
   *
   * @returns {boolean}
   */ get shortcut() {
        return "CMD+B";
    }
}
$6813aa9d7dc8ab1a$var$go.isInline = !0;
$6813aa9d7dc8ab1a$var$go.title = "Bold";
class $6813aa9d7dc8ab1a$var$mo {
    constructor(){
        this.commandName = "italic", this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--italic"
        }, this.nodes = {
            button: null
        };
    }
    /**
   * Sanitizer Rule
   * Leave <i> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            i: {}
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $6813aa9d7dc8ab1a$var$Ji, this.nodes.button;
    }
    /**
   * Wrap range with <i> tag
   */ surround() {
        document.execCommand(this.commandName);
    }
    /**
   * Check selection and set activated state to button if there are <i> tag
   */ checkState() {
        const e = document.queryCommandState(this.commandName);
        return this.nodes.button.classList.toggle(this.CSS.buttonActive, e), e;
    }
    /**
   * Set a shortcut
   */ get shortcut() {
        return "CMD+I";
    }
}
$6813aa9d7dc8ab1a$var$mo.isInline = !0;
$6813aa9d7dc8ab1a$var$mo.title = "Italic";
class $6813aa9d7dc8ab1a$var$bo {
    /**
   * @param api - Editor.js API
   */ constructor({ api: e }){
        this.commandLink = "createLink", this.commandUnlink = "unlink", this.ENTER_KEY = 13, this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--link",
            buttonUnlink: "ce-inline-tool--unlink",
            input: "ce-inline-tool-input",
            inputShowed: "ce-inline-tool-input--showed"
        }, this.nodes = {
            button: null,
            input: null
        }, this.inputOpened = !1, this.toolbar = e.toolbar, this.inlineToolbar = e.inlineToolbar, this.notifier = e.notifier, this.i18n = e.i18n, this.selection = new $6813aa9d7dc8ab1a$var$b();
    }
    /**
   * Sanitizer Rule
   * Leave <a> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            a: {
                href: !0,
                target: "_blank",
                rel: "nofollow"
            }
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $6813aa9d7dc8ab1a$var$Co, this.nodes.button;
    }
    /**
   * Input for the link
   */ renderActions() {
        return this.nodes.input = document.createElement("input"), this.nodes.input.placeholder = this.i18n.t("Add a link"), this.nodes.input.enterKeyHint = "done", this.nodes.input.classList.add(this.CSS.input), this.nodes.input.addEventListener("keydown", (e)=>{
            e.keyCode === this.ENTER_KEY && this.enterPressed(e);
        }), this.nodes.input;
    }
    /**
   * Handle clicks on the Inline Toolbar icon
   *
   * @param {Range} range - range to wrap with link
   */ surround(e) {
        if (e) {
            this.inputOpened ? (this.selection.restore(), this.selection.removeFakeBackground()) : (this.selection.setFakeBackground(), this.selection.save());
            const t1 = this.selection.findParentTag("A");
            if (t1) {
                this.inputOpened ? (this.closeActions(!1), this.checkState()) : (this.selection.expandToTag(t1), this.unlink(), this.closeActions(), this.checkState(), this.toolbar.close());
                return;
            }
        }
        this.toggleActions();
    }
    /**
   * Check selection and set activated state to button if there are <a> tag
   */ checkState() {
        const e = this.selection.findParentTag("A");
        if (e) {
            this.nodes.button.innerHTML = $6813aa9d7dc8ab1a$var$ns, this.nodes.button.classList.add(this.CSS.buttonUnlink), this.nodes.button.classList.add(this.CSS.buttonActive), this.openActions();
            const t1 = e.getAttribute("href");
            this.nodes.input.defaultValue = t1 !== "null" ? t1 : "", this.selection.save();
        } else this.nodes.button.innerHTML = $6813aa9d7dc8ab1a$var$Co, this.nodes.button.classList.remove(this.CSS.buttonUnlink), this.nodes.button.classList.remove(this.CSS.buttonActive);
        return !!e;
    }
    /**
   * Function called with Inline Toolbar closing
   */ clear() {
        this.closeActions();
    }
    /**
   * Set a shortcut
   */ get shortcut() {
        return "CMD+K";
    }
    /**
   * Show/close link input
   */ toggleActions() {
        this.inputOpened ? this.closeActions(!1) : this.openActions(!0);
    }
    /**
   * @param {boolean} needFocus - on link creation we need to focus input. On editing - nope.
   */ openActions(e = !1) {
        this.nodes.input.classList.add(this.CSS.inputShowed), e && this.nodes.input.focus(), this.inputOpened = !0;
    }
    /**
   * Close input
   *
   * @param {boolean} clearSavedSelection — we don't need to clear saved selection
   *                                        on toggle-clicks on the icon of opened Toolbar
   */ closeActions(e = !0) {
        if (this.selection.isFakeBackgroundEnabled) {
            const t1 = new $6813aa9d7dc8ab1a$var$b();
            t1.save(), this.selection.restore(), this.selection.removeFakeBackground(), t1.restore();
        }
        this.nodes.input.classList.remove(this.CSS.inputShowed), this.nodes.input.value = "", e && this.selection.clearSaved(), this.inputOpened = !1;
    }
    /**
   * Enter pressed on input
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ enterPressed(e) {
        let t1 = this.nodes.input.value || "";
        if (!t1.trim()) {
            this.selection.restore(), this.unlink(), e.preventDefault(), this.closeActions();
            return;
        }
        if (!this.validateURL(t1)) {
            this.notifier.show({
                message: "Pasted link is not valid.",
                style: "error"
            }), $6813aa9d7dc8ab1a$var$S("Incorrect Link pasted", "warn", t1);
            return;
        }
        t1 = this.prepareLink(t1), this.selection.restore(), this.selection.removeFakeBackground(), this.insertLink(t1), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), this.selection.collapseToEnd(), this.inlineToolbar.close();
    }
    /**
   * Detects if passed string is URL
   *
   * @param {string} str - string to validate
   * @returns {boolean}
   */ validateURL(e) {
        return !/\s/.test(e);
    }
    /**
   * Process link before injection
   * - sanitize
   * - add protocol for links like 'google.com'
   *
   * @param {string} link - raw user input
   */ prepareLink(e) {
        return e = e.trim(), e = this.addProtocol(e), e;
    }
    /**
   * Add 'http' protocol to the links like 'vc.ru', 'google.com'
   *
   * @param {string} link - string to process
   */ addProtocol(e) {
        if (/^(\w+):(\/\/)?/.test(e)) return e;
        const t1 = /^\/[^/\s]/.test(e), o = e.substring(0, 1) === "#", i = /^\/\/[^/\s]/.test(e);
        return !t1 && !o && !i && (e = "http://" + e), e;
    }
    /**
   * Inserts <a> tag with "href"
   *
   * @param {string} link - "href" value
   */ insertLink(e) {
        const t1 = this.selection.findParentTag("A");
        t1 && this.selection.expandToTag(t1), document.execCommand(this.commandLink, !1, e);
    }
    /**
   * Removes <a> tag
   */ unlink() {
        document.execCommand(this.commandUnlink);
    }
}
$6813aa9d7dc8ab1a$var$bo.isInline = !0;
$6813aa9d7dc8ab1a$var$bo.title = "Link";
class $6813aa9d7dc8ab1a$var$Fn {
    /**
   * @param api - Editor.js API
   */ constructor({ api: e }){
        this.i18nAPI = e.i18n, this.blocksAPI = e.blocks, this.selectionAPI = e.selection, this.toolsAPI = e.tools, this.caretAPI = e.caret;
    }
    /**
   * Returns tool's UI config
   */ async render() {
        const e = $6813aa9d7dc8ab1a$var$b.get(), t1 = this.blocksAPI.getBlockByElement(e.anchorNode);
        if (t1 === void 0) return [];
        const o = this.toolsAPI.getBlockTools(), i = await $6813aa9d7dc8ab1a$var$Yo(t1, o);
        if (i.length === 0) return [];
        const s = i.reduce((c, d)=>{
            var h;
            return (h = d.toolbox) == null || h.forEach((p)=>{
                c.push({
                    icon: p.icon,
                    title: $6813aa9d7dc8ab1a$var$z.t($6813aa9d7dc8ab1a$var$K.toolNames, p.title),
                    name: d.name,
                    closeOnActivate: !0,
                    onActivate: async ()=>{
                        const g = await this.blocksAPI.convert(t1.id, d.name, p.data);
                        this.caretAPI.setToBlock(g, "end");
                    }
                });
            }), c;
        }, []), r = await t1.getActiveToolboxEntry(), a = r !== void 0 ? r.icon : $6813aa9d7dc8ab1a$var$Go, l = !$6813aa9d7dc8ab1a$var$be();
        return {
            icon: a,
            name: "convert-to",
            hint: {
                title: this.i18nAPI.t("Convert to")
            },
            children: {
                searchable: l,
                items: s,
                onOpen: ()=>{
                    l && (this.selectionAPI.setFakeBackground(), this.selectionAPI.save());
                },
                onClose: ()=>{
                    l && (this.selectionAPI.restore(), this.selectionAPI.removeFakeBackground());
                }
            }
        };
    }
}
$6813aa9d7dc8ab1a$var$Fn.isInline = !0;
class $6813aa9d7dc8ab1a$var$jn {
    /**
   * @param options - constructor options
   * @param options.data - stub tool data
   * @param options.api - Editor.js API
   */ constructor({ data: e, api: t1 }){
        this.CSS = {
            wrapper: "ce-stub",
            info: "ce-stub__info",
            title: "ce-stub__title",
            subtitle: "ce-stub__subtitle"
        }, this.api = t1, this.title = e.title || this.api.i18n.t("Error"), this.subtitle = this.api.i18n.t("The block can not be displayed correctly."), this.savedData = e.savedData, this.wrapper = this.make();
    }
    /**
   * Returns stub holder
   *
   * @returns {HTMLElement}
   */ render() {
        return this.wrapper;
    }
    /**
   * Return original Tool data
   *
   * @returns {BlockToolData}
   */ save() {
        return this.savedData;
    }
    /**
   * Create Tool html markup
   *
   * @returns {HTMLElement}
   */ make() {
        const e = $6813aa9d7dc8ab1a$var$u.make("div", this.CSS.wrapper), t1 = $6813aa9d7dc8ab1a$var$is, o = $6813aa9d7dc8ab1a$var$u.make("div", this.CSS.info), i = $6813aa9d7dc8ab1a$var$u.make("div", this.CSS.title, {
            textContent: this.title
        }), s = $6813aa9d7dc8ab1a$var$u.make("div", this.CSS.subtitle, {
            textContent: this.subtitle
        });
        return e.innerHTML = t1, o.appendChild(i), o.appendChild(s), e.appendChild(o), e;
    }
}
$6813aa9d7dc8ab1a$var$jn.isReadOnlySupported = !0;
class $6813aa9d7dc8ab1a$var$ka extends $6813aa9d7dc8ab1a$var$Tt {
    constructor(){
        super(...arguments), this.type = $6813aa9d7dc8ab1a$var$ae.Inline;
    }
    /**
   * Returns title for Inline Tool if specified by user
   */ get title() {
        return this.constructable[$6813aa9d7dc8ab1a$var$We.Title];
    }
    /**
   * Constructs new InlineTool instance from constructable
   */ create() {
        return new this.constructable({
            api: this.api,
            config: this.settings
        });
    }
    /**
   * Allows inline tool to be available in read-only mode
   * Can be used, for example, by comments tool
   */ get isReadOnlySupported() {
        return this.constructable[$6813aa9d7dc8ab1a$var$We.IsReadOnlySupported] ?? !1;
    }
}
class $6813aa9d7dc8ab1a$var$ya extends $6813aa9d7dc8ab1a$var$Tt {
    constructor(){
        super(...arguments), this.type = $6813aa9d7dc8ab1a$var$ae.Tune;
    }
    /**
   * Constructs new BlockTune instance from constructable
   *
   * @param data - Tune data
   * @param block - Block API object
   */ create(e, t1) {
        return new this.constructable({
            api: this.api,
            config: this.settings,
            block: t1,
            data: e
        });
    }
}
class $6813aa9d7dc8ab1a$var$j extends Map {
    /**
   * Returns Block Tools collection
   */ get blockTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isBlock());
        return new $6813aa9d7dc8ab1a$var$j(e);
    }
    /**
   * Returns Inline Tools collection
   */ get inlineTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isInline());
        return new $6813aa9d7dc8ab1a$var$j(e);
    }
    /**
   * Returns Block Tunes collection
   */ get blockTunes() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isTune());
        return new $6813aa9d7dc8ab1a$var$j(e);
    }
    /**
   * Returns internal Tools collection
   */ get internalTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isInternal);
        return new $6813aa9d7dc8ab1a$var$j(e);
    }
    /**
   * Returns Tools collection provided by user
   */ get externalTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>!t1.isInternal);
        return new $6813aa9d7dc8ab1a$var$j(e);
    }
}
var $6813aa9d7dc8ab1a$var$wa = Object.defineProperty, $6813aa9d7dc8ab1a$var$Ea = Object.getOwnPropertyDescriptor, $6813aa9d7dc8ab1a$var$Hn = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $6813aa9d7dc8ab1a$var$Ea(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $6813aa9d7dc8ab1a$var$wa(e, t1, i), i;
};
class $6813aa9d7dc8ab1a$var$vo extends $6813aa9d7dc8ab1a$var$Tt {
    constructor(){
        super(...arguments), this.type = $6813aa9d7dc8ab1a$var$ae.Block, this.inlineTools = new $6813aa9d7dc8ab1a$var$j(), this.tunes = new $6813aa9d7dc8ab1a$var$j();
    }
    /**
   * Creates new Tool instance
   *
   * @param data - Tool data
   * @param block - BlockAPI for current Block
   * @param readOnly - True if Editor is in read-only mode
   */ create(e, t1, o) {
        return new this.constructable({
            data: e,
            block: t1,
            readOnly: o,
            api: this.api,
            config: this.settings
        });
    }
    /**
   * Returns true if read-only mode is supported by Tool
   */ get isReadOnlySupported() {
        return this.constructable[$6813aa9d7dc8ab1a$var$pe.IsReadOnlySupported] === !0;
    }
    /**
   * Returns true if Tool supports linebreaks
   */ get isLineBreaksEnabled() {
        return this.constructable[$6813aa9d7dc8ab1a$var$pe.IsEnabledLineBreaks];
    }
    /**
   * Returns Tool toolbox configuration (internal or user-specified).
   *
   * Merges internal and user-defined toolbox configs based on the following rules:
   *
   * - If both internal and user-defined toolbox configs are arrays their items are merged.
   * Length of the second one is kept.
   *
   * - If both are objects their properties are merged.
   *
   * - If one is an object and another is an array than internal config is replaced with user-defined
   * config. This is made to allow user to override default tool's toolbox representation (single/multiple entries)
   */ get toolbox() {
        const e = this.constructable[$6813aa9d7dc8ab1a$var$pe.Toolbox], t1 = this.config[$6813aa9d7dc8ab1a$var$Pe.Toolbox];
        if (!$6813aa9d7dc8ab1a$var$V(e) && t1 !== !1) return t1 ? Array.isArray(e) ? Array.isArray(t1) ? t1.map((o, i)=>{
            const s = e[i];
            return s ? {
                ...s,
                ...o
            } : o;
        }) : [
            t1
        ] : Array.isArray(t1) ? t1 : [
            {
                ...e,
                ...t1
            }
        ] : Array.isArray(e) ? e : [
            e
        ];
    }
    /**
   * Returns Tool conversion configuration
   */ get conversionConfig() {
        return this.constructable[$6813aa9d7dc8ab1a$var$pe.ConversionConfig];
    }
    /**
   * Returns enabled inline tools for Tool
   */ get enabledInlineTools() {
        return this.config[$6813aa9d7dc8ab1a$var$Pe.EnabledInlineTools] || !1;
    }
    /**
   * Returns enabled tunes for Tool
   */ get enabledBlockTunes() {
        return this.config[$6813aa9d7dc8ab1a$var$Pe.EnabledBlockTunes];
    }
    /**
   * Returns Tool paste configuration
   */ get pasteConfig() {
        return this.constructable[$6813aa9d7dc8ab1a$var$pe.PasteConfig] ?? {};
    }
    get sanitizeConfig() {
        const e = super.sanitizeConfig, t1 = this.baseSanitizeConfig;
        if ($6813aa9d7dc8ab1a$var$V(e)) return t1;
        const o = {};
        for(const i in e)if (Object.prototype.hasOwnProperty.call(e, i)) {
            const s = e[i];
            $6813aa9d7dc8ab1a$var$D(s) ? o[i] = Object.assign({}, t1, s) : o[i] = s;
        }
        return o;
    }
    get baseSanitizeConfig() {
        const e = {};
        return Array.from(this.inlineTools.values()).forEach((t1)=>Object.assign(e, t1.sanitizeConfig)), Array.from(this.tunes.values()).forEach((t1)=>Object.assign(e, t1.sanitizeConfig)), e;
    }
}
$6813aa9d7dc8ab1a$var$Hn([
    $6813aa9d7dc8ab1a$var$me
], $6813aa9d7dc8ab1a$var$vo.prototype, "sanitizeConfig", 1);
$6813aa9d7dc8ab1a$var$Hn([
    $6813aa9d7dc8ab1a$var$me
], $6813aa9d7dc8ab1a$var$vo.prototype, "baseSanitizeConfig", 1);
class $6813aa9d7dc8ab1a$var$xa {
    /**
   * @class
   * @param config - tools config
   * @param editorConfig - EditorJS config
   * @param api - EditorJS API module
   */ constructor(e, t1, o){
        this.api = o, this.config = e, this.editorConfig = t1;
    }
    /**
   * Returns Tool object based on it's type
   *
   * @param name - tool name
   */ get(e) {
        const { class: t1, isInternal: o = !1, ...i } = this.config[e], s = this.getConstructor(t1), r = t1[$6813aa9d7dc8ab1a$var$mt.IsTune];
        return new s({
            name: e,
            constructable: t1,
            config: i,
            api: this.api.getMethodsForTool(e, r),
            isDefault: e === this.editorConfig.defaultBlock,
            defaultPlaceholder: this.editorConfig.placeholder,
            isInternal: o
        });
    }
    /**
   * Find appropriate Tool object constructor for Tool constructable
   *
   * @param constructable - Tools constructable
   */ getConstructor(e) {
        switch(!0){
            case e[$6813aa9d7dc8ab1a$var$We.IsInline]:
                return $6813aa9d7dc8ab1a$var$ka;
            case e[$6813aa9d7dc8ab1a$var$mt.IsTune]:
                return $6813aa9d7dc8ab1a$var$ya;
            default:
                return $6813aa9d7dc8ab1a$var$vo;
        }
    }
}
class $6813aa9d7dc8ab1a$var$$n {
    /**
   * MoveDownTune constructor
   *
   * @param {API} api — Editor's API
   */ constructor({ api: e }){
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $6813aa9d7dc8ab1a$var$Xi,
            title: this.api.i18n.t("Move down"),
            onActivate: ()=>this.handleClick(),
            name: "move-down"
        };
    }
    /**
   * Handle clicks on 'move down' button
   */ handleClick() {
        const e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e + 1);
        if (!t1) throw new Error("Unable to move Block down since it is already the last");
        const o = t1.holder, i = o.getBoundingClientRect();
        let s = Math.abs(window.innerHeight - o.offsetHeight);
        i.top < window.innerHeight && (s = window.scrollY + o.offsetHeight), window.scrollTo(0, s), this.api.blocks.move(e + 1), this.api.toolbar.toggleBlockSettings(!0);
    }
}
$6813aa9d7dc8ab1a$var$$n.isTune = !0;
class $6813aa9d7dc8ab1a$var$zn {
    /**
   * DeleteTune constructor
   *
   * @param {API} api - Editor's API
   */ constructor({ api: e }){
        this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $6813aa9d7dc8ab1a$var$Gi,
            title: this.api.i18n.t("Delete"),
            name: "delete",
            confirmation: {
                title: this.api.i18n.t("Click to delete"),
                onActivate: ()=>this.handleClick()
            }
        };
    }
    /**
   * Delete block conditions passed
   */ handleClick() {
        this.api.blocks.delete();
    }
}
$6813aa9d7dc8ab1a$var$zn.isTune = !0;
class $6813aa9d7dc8ab1a$var$Un {
    /**
   * MoveUpTune constructor
   *
   * @param {API} api - Editor's API
   */ constructor({ api: e }){
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $6813aa9d7dc8ab1a$var$Zi,
            title: this.api.i18n.t("Move up"),
            onActivate: ()=>this.handleClick(),
            name: "move-up"
        };
    }
    /**
   * Move current block up
   */ handleClick() {
        const e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e), o = this.api.blocks.getBlockByIndex(e - 1);
        if (e === 0 || !t1 || !o) throw new Error("Unable to move Block up since it is already the first");
        const i = t1.holder, s = o.holder, r = i.getBoundingClientRect(), a = s.getBoundingClientRect();
        let l;
        a.top > 0 ? l = Math.abs(r.top) - Math.abs(a.top) : l = Math.abs(r.top) + a.height, window.scrollBy(0, -1 * l), this.api.blocks.move(e - 1), this.api.toolbar.toggleBlockSettings(!0);
    }
}
$6813aa9d7dc8ab1a$var$Un.isTune = !0;
var $6813aa9d7dc8ab1a$var$Ba = Object.defineProperty, $6813aa9d7dc8ab1a$var$Ca = Object.getOwnPropertyDescriptor, $6813aa9d7dc8ab1a$var$Ta = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $6813aa9d7dc8ab1a$var$Ca(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $6813aa9d7dc8ab1a$var$Ba(e, t1, i), i;
};
class $6813aa9d7dc8ab1a$var$Wn extends $6813aa9d7dc8ab1a$var$E {
    constructor(){
        super(...arguments), this.stubTool = "stub", this.toolsAvailable = new $6813aa9d7dc8ab1a$var$j(), this.toolsUnavailable = new $6813aa9d7dc8ab1a$var$j();
    }
    /**
   * Returns available Tools
   */ get available() {
        return this.toolsAvailable;
    }
    /**
   * Returns unavailable Tools
   */ get unavailable() {
        return this.toolsUnavailable;
    }
    /**
   * Return Tools for the Inline Toolbar
   */ get inlineTools() {
        return this.available.inlineTools;
    }
    /**
   * Return editor block tools
   */ get blockTools() {
        return this.available.blockTools;
    }
    /**
   * Return available Block Tunes
   *
   * @returns {object} - object of Inline Tool's classes
   */ get blockTunes() {
        return this.available.blockTunes;
    }
    /**
   * Returns default Tool object
   */ get defaultTool() {
        return this.blockTools.get(this.config.defaultBlock);
    }
    /**
   * Returns internal tools
   */ get internal() {
        return this.available.internalTools;
    }
    /**
   * Creates instances via passed or default configuration
   *
   * @returns {Promise<void>}
   */ async prepare() {
        if (this.validateTools(), this.config.tools = $6813aa9d7dc8ab1a$var$ut({}, this.internalTools, this.config.tools), !Object.prototype.hasOwnProperty.call(this.config, "tools") || Object.keys(this.config.tools).length === 0) throw Error("Can't start without tools");
        const e = this.prepareConfig();
        this.factory = new $6813aa9d7dc8ab1a$var$xa(e, this.config, this.Editor.API);
        const t1 = this.getListOfPrepareFunctions(e);
        if (t1.length === 0) return Promise.resolve();
        await $6813aa9d7dc8ab1a$var$Qn(t1, (o)=>{
            this.toolPrepareMethodSuccess(o);
        }, (o)=>{
            this.toolPrepareMethodFallback(o);
        }), this.prepareBlockTools();
    }
    getAllInlineToolsSanitizeConfig() {
        const e = {};
        return Array.from(this.inlineTools.values()).forEach((t1)=>{
            Object.assign(e, t1.sanitizeConfig);
        }), e;
    }
    /**
   * Calls each Tool reset method to clean up anything set by Tool
   */ destroy() {
        Object.values(this.available).forEach(async (e)=>{
            $6813aa9d7dc8ab1a$var$A(e.reset) && await e.reset();
        });
    }
    /**
   * Returns internal tools
   * Includes Bold, Italic, Link and Paragraph
   */ get internalTools() {
        return {
            convertTo: {
                class: $6813aa9d7dc8ab1a$var$Fn,
                isInternal: !0
            },
            link: {
                class: $6813aa9d7dc8ab1a$var$bo,
                isInternal: !0
            },
            bold: {
                class: $6813aa9d7dc8ab1a$var$go,
                isInternal: !0
            },
            italic: {
                class: $6813aa9d7dc8ab1a$var$mo,
                isInternal: !0
            },
            paragraph: {
                class: $6813aa9d7dc8ab1a$var$fo,
                inlineToolbar: !0,
                isInternal: !0
            },
            stub: {
                class: $6813aa9d7dc8ab1a$var$jn,
                isInternal: !0
            },
            moveUp: {
                class: $6813aa9d7dc8ab1a$var$Un,
                isInternal: !0
            },
            delete: {
                class: $6813aa9d7dc8ab1a$var$zn,
                isInternal: !0
            },
            moveDown: {
                class: $6813aa9d7dc8ab1a$var$$n,
                isInternal: !0
            }
        };
    }
    /**
   * Tool prepare method success callback
   *
   * @param {object} data - append tool to available list
   */ toolPrepareMethodSuccess(e) {
        const t1 = this.factory.get(e.toolName);
        if (t1.isInline()) {
            const i = [
                "render"
            ].filter((s)=>!t1.create()[s]);
            if (i.length) {
                $6813aa9d7dc8ab1a$var$S(`Incorrect Inline Tool: ${t1.name}. Some of required methods is not implemented %o`, "warn", i), this.toolsUnavailable.set(t1.name, t1);
                return;
            }
        }
        this.toolsAvailable.set(t1.name, t1);
    }
    /**
   * Tool prepare method fail callback
   *
   * @param {object} data - append tool to unavailable list
   */ toolPrepareMethodFallback(e) {
        this.toolsUnavailable.set(e.toolName, this.factory.get(e.toolName));
    }
    /**
   * Binds prepare function of plugins with user or default config
   *
   * @returns {Array} list of functions that needs to be fired sequentially
   * @param config - tools config
   */ getListOfPrepareFunctions(e) {
        const t1 = [];
        return Object.entries(e).forEach(([o, i])=>{
            t1.push({
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                function: $6813aa9d7dc8ab1a$var$A(i.class.prepare) ? i.class.prepare : ()=>{},
                data: {
                    toolName: o,
                    config: i.config
                }
            });
        }), t1;
    }
    /**
   * Assign enabled Inline Tools and Block Tunes for Block Tool
   */ prepareBlockTools() {
        Array.from(this.blockTools.values()).forEach((e)=>{
            this.assignInlineToolsToBlockTool(e), this.assignBlockTunesToBlockTool(e);
        });
    }
    /**
   * Assign enabled Inline Tools for Block Tool
   *
   * @param tool - Block Tool
   */ assignInlineToolsToBlockTool(e) {
        if (this.config.inlineToolbar !== !1) {
            if (e.enabledInlineTools === !0) {
                e.inlineTools = new $6813aa9d7dc8ab1a$var$j(Array.isArray(this.config.inlineToolbar) ? this.config.inlineToolbar.map((t1)=>[
                        t1,
                        this.inlineTools.get(t1)
                    ]) : Array.from(this.inlineTools.entries()));
                return;
            }
            Array.isArray(e.enabledInlineTools) && (e.inlineTools = new $6813aa9d7dc8ab1a$var$j(/** Prepend ConvertTo Inline Tool */ [
                "convertTo",
                ...e.enabledInlineTools
            ].map((t1)=>[
                    t1,
                    this.inlineTools.get(t1)
                ])));
        }
    }
    /**
   * Assign enabled Block Tunes for Block Tool
   *
   * @param tool — Block Tool
   */ assignBlockTunesToBlockTool(e) {
        if (e.enabledBlockTunes !== !1) {
            if (Array.isArray(e.enabledBlockTunes)) {
                const t1 = new $6813aa9d7dc8ab1a$var$j(e.enabledBlockTunes.map((o)=>[
                        o,
                        this.blockTunes.get(o)
                    ]));
                e.tunes = new $6813aa9d7dc8ab1a$var$j([
                    ...t1,
                    ...this.blockTunes.internalTools
                ]);
                return;
            }
            if (Array.isArray(this.config.tunes)) {
                const t1 = new $6813aa9d7dc8ab1a$var$j(this.config.tunes.map((o)=>[
                        o,
                        this.blockTunes.get(o)
                    ]));
                e.tunes = new $6813aa9d7dc8ab1a$var$j([
                    ...t1,
                    ...this.blockTunes.internalTools
                ]);
                return;
            }
            e.tunes = this.blockTunes.internalTools;
        }
    }
    /**
   * Validate Tools configuration objects and throw Error for user if it is invalid
   */ validateTools() {
        for(const e in this.config.tools)if (Object.prototype.hasOwnProperty.call(this.config.tools, e)) {
            if (e in this.internalTools) return;
            const t1 = this.config.tools[e];
            if (!$6813aa9d7dc8ab1a$var$A(t1) && !$6813aa9d7dc8ab1a$var$A(t1.class)) throw Error(`Tool \xab${e}\xbb must be a constructor function or an object with function in the \xabclass\xbb property`);
        }
    }
    /**
   * Unify tools config
   */ prepareConfig() {
        const e = {};
        for(const t1 in this.config.tools)$6813aa9d7dc8ab1a$var$D(this.config.tools[t1]) ? e[t1] = this.config.tools[t1] : e[t1] = {
            class: this.config.tools[t1]
        };
        return e;
    }
}
$6813aa9d7dc8ab1a$var$Ta([
    $6813aa9d7dc8ab1a$var$me
], $6813aa9d7dc8ab1a$var$Wn.prototype, "getAllInlineToolsSanitizeConfig", 1);
const $6813aa9d7dc8ab1a$var$Sa = `:root{--selectionColor: #e1f2ff;--inlineSelectionColor: #d4ecff;--bg-light: #eff2f5;--grayText: #707684;--color-dark: #1D202B;--color-active-icon: #388AE5;--color-gray-border: rgba(201, 201, 204, .48);--content-width: 650px;--narrow-mode-right-padding: 50px;--toolbox-buttons-size: 26px;--toolbox-buttons-size--mobile: 36px;--icon-size: 20px;--icon-size--mobile: 28px;--block-padding-vertical: .4em;--color-line-gray: #EFF0F1 }.codex-editor{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;z-index:1}.codex-editor .hide{display:none}.codex-editor__redactor [contenteditable]:empty:after{content:"\\feff"}@media (min-width: 651px){.codex-editor--narrow .codex-editor__redactor{margin-right:50px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .codex-editor__redactor{margin-left:50px;margin-right:0}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__actions{right:-5px}}.codex-editor-copyable{position:absolute;height:1px;width:1px;top:-400%;opacity:.001}.codex-editor-overlay{position:fixed;top:0;left:0;right:0;bottom:0;z-index:999;pointer-events:none;overflow:hidden}.codex-editor-overlay__container{position:relative;pointer-events:auto;z-index:0}.codex-editor-overlay__rectangle{position:absolute;pointer-events:none;background-color:#2eaadc33;border:1px solid transparent}.codex-editor svg{max-height:100%}.codex-editor path{stroke:currentColor}.codex-editor ::-moz-selection{background-color:#d4ecff}.codex-editor ::selection{background-color:#d4ecff}.codex-editor--toolbox-opened [contentEditable=true][data-placeholder]:focus:before{opacity:0!important}.ce-scroll-locked{overflow:hidden}.ce-scroll-locked--hard{overflow:hidden;top:calc(-1 * var(--window-scroll-offset));position:fixed;width:100%}.ce-toolbar{position:absolute;left:0;right:0;top:0;-webkit-transition:opacity .1s ease;transition:opacity .1s ease;will-change:opacity,top;display:none}.ce-toolbar--opened{display:block}.ce-toolbar__content{max-width:650px;margin:0 auto;position:relative}.ce-toolbar__plus{color:#1d202b;cursor:pointer;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-flex-negative:0;flex-shrink:0}@media (max-width: 650px){.ce-toolbar__plus{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__plus:hover{background-color:#eff2f5}}.ce-toolbar__plus--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.ce-toolbar__plus-shortcut{opacity:.6;word-spacing:-2px;margin-top:5px}@media (max-width: 650px){.ce-toolbar__plus{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__plus--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__plus--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__actions{position:absolute;right:100%;opacity:0;display:-webkit-box;display:-ms-flexbox;display:flex;padding-right:5px}.ce-toolbar__actions--opened{opacity:1}@media (max-width: 650px){.ce-toolbar__actions{right:auto}}.ce-toolbar__settings-btn{color:#1d202b;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;margin-left:3px;cursor:pointer;user-select:none}@media (max-width: 650px){.ce-toolbar__settings-btn{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__settings-btn:hover{background-color:#eff2f5}}.ce-toolbar__settings-btn--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}@media (min-width: 651px){.ce-toolbar__settings-btn{width:24px}}.ce-toolbar__settings-btn--hidden{display:none}@media (max-width: 650px){.ce-toolbar__settings-btn{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__settings-btn--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__settings-btn--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__plus svg,.ce-toolbar__settings-btn svg{width:24px;height:24px}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__plus{left:5px}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbox .ce-popover{right:0;left:auto;left:initial}}.ce-inline-toolbar{--y-offset: 8px;--color-background-icon-active: rgba(56, 138, 229, .1);--color-text-icon-active: #388AE5;--color-text-primary: black;position:absolute;visibility:hidden;-webkit-transition:opacity .25s ease;transition:opacity .25s ease;will-change:opacity,left,top;top:0;left:0;z-index:3;opacity:1;visibility:visible}.ce-inline-toolbar [hidden]{display:none!important}.ce-inline-toolbar__toggler-and-button-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;padding:0 6px}.ce-inline-toolbar__buttons{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown{display:-webkit-box;display:-ms-flexbox;display:flex;padding:6px;margin:0 6px 0 -6px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;border-right:1px solid rgba(201,201,204,.48);-webkit-box-sizing:border-box;box-sizing:border-box}@media (hover: hover){.ce-inline-toolbar__dropdown:hover{background:#eff2f5}}.ce-inline-toolbar__dropdown--hidden{display:none}.ce-inline-toolbar__dropdown-content,.ce-inline-toolbar__dropdown-arrow{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown-content svg,.ce-inline-toolbar__dropdown-arrow svg{width:20px;height:20px}.ce-inline-toolbar__shortcut{opacity:.6;word-spacing:-3px;margin-top:3px}.ce-inline-tool{color:var(--color-text-primary);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:0;border-radius:4px;line-height:normal;height:100%;padding:0;width:28px;background-color:transparent;cursor:pointer}@media (max-width: 650px){.ce-inline-tool{width:36px;height:36px}}@media (hover: hover){.ce-inline-tool:hover{background-color:#f8f8f8}}.ce-inline-tool svg{display:block;width:20px;height:20px}@media (max-width: 650px){.ce-inline-tool svg{width:28px;height:28px}}.ce-inline-tool--link .icon--unlink,.ce-inline-tool--unlink .icon--link{display:none}.ce-inline-tool--unlink .icon--unlink{display:inline-block;margin-bottom:-1px}.ce-inline-tool-input{background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:4px 8px;font-size:14px;line-height:22px;outline:none;margin:0;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;display:none;font-weight:500;-webkit-appearance:none;font-family:inherit}@media (max-width: 650px){.ce-inline-tool-input{font-size:15px;font-weight:500}}.ce-inline-tool-input::-webkit-input-placeholder{color:#707684}.ce-inline-tool-input::-moz-placeholder{color:#707684}.ce-inline-tool-input:-ms-input-placeholder{color:#707684}.ce-inline-tool-input::-ms-input-placeholder{color:#707684}.ce-inline-tool-input::placeholder{color:#707684}.ce-inline-tool-input--showed{display:block}.ce-inline-tool--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}@-webkit-keyframes fade-in{0%{opacity:0}to{opacity:1}}@keyframes fade-in{0%{opacity:0}to{opacity:1}}.ce-block{-webkit-animation:fade-in .3s ease;animation:fade-in .3s ease;-webkit-animation-fill-mode:none;animation-fill-mode:none;-webkit-animation-fill-mode:initial;animation-fill-mode:initial}.ce-block:first-of-type{margin-top:0}.ce-block--selected .ce-block__content{background:#e1f2ff}.ce-block--selected .ce-block__content [contenteditable]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ce-block--selected .ce-block__content img,.ce-block--selected .ce-block__content .ce-stub{opacity:.55}.ce-block--stretched .ce-block__content{max-width:none}.ce-block__content{position:relative;max-width:650px;margin:0 auto;-webkit-transition:background-color .15s ease;transition:background-color .15s ease}.ce-block--drop-target .ce-block__content:before{content:"";position:absolute;top:100%;left:-20px;margin-top:-1px;height:8px;width:8px;border:solid #388AE5;border-width:1px 1px 0 0;-webkit-transform-origin:right;transform-origin:right;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.ce-block--drop-target .ce-block__content:after{content:"";position:absolute;top:100%;height:1px;width:100%;color:#388ae5;background:repeating-linear-gradient(90deg,#388AE5,#388AE5 1px,#fff 1px,#fff 6px)}.ce-block a{cursor:pointer;-webkit-text-decoration:underline;text-decoration:underline}.ce-block b{font-weight:700}.ce-block i{font-style:italic}@-webkit-keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}.cdx-block{padding:.4em 0}.cdx-block::-webkit-input-placeholder{line-height:normal!important}.cdx-input{border:1px solid rgba(201,201,204,.48);-webkit-box-shadow:inset 0 1px 2px 0 rgba(35,44,72,.06);box-shadow:inset 0 1px 2px #232c480f;border-radius:3px;padding:10px 12px;outline:none;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.cdx-input[data-placeholder]:before{position:static!important}.cdx-input[data-placeholder]:before{display:inline-block;width:0;white-space:nowrap;pointer-events:none}.cdx-settings-button{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:3px;cursor:pointer;border:0;outline:none;background-color:transparent;vertical-align:bottom;color:inherit;margin:0;min-width:26px;min-height:26px}.cdx-settings-button--focused{background:rgba(34,186,255,.08)!important}.cdx-settings-button--focused{-webkit-box-shadow:inset 0 0 0px 1px rgba(7,161,227,.08);box-shadow:inset 0 0 0 1px #07a1e314}.cdx-settings-button--focused-animated{-webkit-animation-name:buttonClicked;animation-name:buttonClicked;-webkit-animation-duration:.25s;animation-duration:.25s}.cdx-settings-button--active{color:#388ae5}.cdx-settings-button svg{width:auto;height:auto}@media (max-width: 650px){.cdx-settings-button svg{width:28px;height:28px}}@media (max-width: 650px){.cdx-settings-button{width:36px;height:36px;border-radius:8px}}@media (hover: hover){.cdx-settings-button:hover{background-color:#eff2f5}}.cdx-loader{position:relative;border:1px solid rgba(201,201,204,.48)}.cdx-loader:before{content:"";position:absolute;left:50%;top:50%;width:18px;height:18px;margin:-11px 0 0 -11px;border:2px solid rgba(201,201,204,.48);border-left-color:#388ae5;border-radius:50%;-webkit-animation:cdxRotation 1.2s infinite linear;animation:cdxRotation 1.2s infinite linear}@-webkit-keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.cdx-button{padding:13px;border-radius:3px;border:1px solid rgba(201,201,204,.48);font-size:14.9px;background:#fff;-webkit-box-shadow:0 2px 2px 0 rgba(18,30,57,.04);box-shadow:0 2px 2px #121e390a;color:#707684;text-align:center;cursor:pointer}@media (hover: hover){.cdx-button:hover{background:#FBFCFE;-webkit-box-shadow:0 1px 3px 0 rgba(18,30,57,.08);box-shadow:0 1px 3px #121e3914}}.cdx-button svg{height:20px;margin-right:.2em;margin-top:-2px}.ce-stub{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:12px 18px;margin:10px 0;border-radius:10px;background:#eff2f5;border:1px solid #EFF0F1;color:#707684;font-size:14px}.ce-stub svg{width:20px;height:20px}.ce-stub__info{margin-left:14px}.ce-stub__title{font-weight:500;text-transform:capitalize}.codex-editor.codex-editor--rtl{direction:rtl}.codex-editor.codex-editor--rtl .cdx-list{padding-left:0;padding-right:40px}.codex-editor.codex-editor--rtl .ce-toolbar__plus{right:-26px;left:auto}.codex-editor.codex-editor--rtl .ce-toolbar__actions{right:auto;left:-26px}@media (max-width: 650px){.codex-editor.codex-editor--rtl .ce-toolbar__actions{margin-left:0;margin-right:auto;padding-right:0;padding-left:10px}}.codex-editor.codex-editor--rtl .ce-settings{left:5px;right:auto}.codex-editor.codex-editor--rtl .ce-settings:before{right:auto;left:25px}.codex-editor.codex-editor--rtl .ce-settings__button:not(:nth-child(3n+3)){margin-left:3px;margin-right:0}.codex-editor.codex-editor--rtl .ce-conversion-tool__icon{margin-right:0;margin-left:10px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown{border-right:0px solid transparent;border-left:1px solid rgba(201,201,204,.48);margin:0 -6px 0 6px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown .icon--toggler-down{margin-left:0;margin-right:4px}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__plus{left:0;right:5px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__actions{left:-5px}}.cdx-search-field{--icon-margin-right: 10px;background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:2px;display:grid;grid-template-columns:auto auto 1fr;grid-template-rows:auto}.cdx-search-field__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:var(--icon-margin-right)}.cdx-search-field__icon svg{width:20px;height:20px;color:#707684}.cdx-search-field__input{font-size:14px;outline:none;font-weight:500;font-family:inherit;border:0;background:transparent;margin:0;padding:0;line-height:22px;min-width:calc(100% - 26px - var(--icon-margin-right))}.cdx-search-field__input::-webkit-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-moz-placeholder{color:#707684;font-weight:500}.cdx-search-field__input:-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::placeholder{color:#707684;font-weight:500}.ce-popover{--border-radius: 6px;--width: 200px;--max-height: 270px;--padding: 6px;--offset-from-target: 8px;--color-border: #EFF0F1;--color-shadow: rgba(13, 20, 33, .1);--color-background: white;--color-text-primary: black;--color-text-secondary: #707684;--color-border-icon: rgba(201, 201, 204, .48);--color-border-icon-disabled: #EFF0F1;--color-text-icon-active: #388AE5;--color-background-icon-active: rgba(56, 138, 229, .1);--color-background-item-focus: rgba(34, 186, 255, .08);--color-shadow-item-focus: rgba(7, 161, 227, .08);--color-background-item-hover: #F8F8F8;--color-background-item-confirm: #E24A4A;--color-background-item-confirm-hover: #CE4343;--popover-top: calc(100% + var(--offset-from-target));--popover-left: 0;--nested-popover-overlap: 4px;--icon-size: 20px;--item-padding: 3px;--item-height: calc(var(--icon-size) + 2 * var(--item-padding))}.ce-popover__container{min-width:var(--width);width:var(--width);max-height:var(--max-height);border-radius:var(--border-radius);overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0px 3px 15px -3px var(--color-shadow);box-shadow:0 3px 15px -3px var(--color-shadow);position:absolute;left:var(--popover-left);top:var(--popover-top);background:var(--color-background);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;z-index:4;opacity:0;max-height:0;pointer-events:none;padding:0;border:none}.ce-popover--opened>.ce-popover__container{opacity:1;padding:var(--padding);max-height:var(--max-height);pointer-events:auto;-webkit-animation:panelShowing .1s ease;animation:panelShowing .1s ease;border:1px solid var(--color-border)}@media (max-width: 650px){.ce-popover--opened>.ce-popover__container{-webkit-animation:panelShowingMobile .25s ease;animation:panelShowingMobile .25s ease}}.ce-popover--open-top .ce-popover__container{--popover-top: calc(-1 * (var(--offset-from-target) + var(--popover-height)))}.ce-popover--open-left .ce-popover__container{--popover-left: calc(-1 * var(--width) + 100%)}.ce-popover__items{overflow-y:auto;-ms-scroll-chaining:none;overscroll-behavior:contain}@media (max-width: 650px){.ce-popover__overlay{position:fixed;top:0;bottom:0;left:0;right:0;background:#1D202B;z-index:3;opacity:.5;-webkit-transition:opacity .12s ease-in;transition:opacity .12s ease-in;will-change:opacity;visibility:visible}}.ce-popover__overlay--hidden{display:none}@media (max-width: 650px){.ce-popover .ce-popover__container{--offset: 5px;position:fixed;max-width:none;min-width:calc(100% - var(--offset) * 2);left:var(--offset);right:var(--offset);bottom:calc(var(--offset) + env(safe-area-inset-bottom));top:auto;border-radius:10px}}.ce-popover__search{margin-bottom:5px}.ce-popover__nothing-found-message{color:#707684;display:none;cursor:default;padding:3px;font-size:14px;line-height:20px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ce-popover__nothing-found-message--displayed{display:block}.ce-popover--nested .ce-popover__container{--popover-left: calc(var(--nesting-level) * (var(--width) - var(--nested-popover-overlap)));top:calc(var(--trigger-item-top) - var(--nested-popover-overlap));position:absolute}.ce-popover--open-top.ce-popover--nested .ce-popover__container{top:calc(var(--trigger-item-top) - var(--popover-height) + var(--item-height) + var(--offset-from-target) + var(--nested-popover-overlap))}.ce-popover--open-left .ce-popover--nested .ce-popover__container{--popover-left: calc(-1 * (var(--nesting-level) + 1) * var(--width) + 100%)}.ce-popover-item-separator{padding:4px 3px}.ce-popover-item-separator--hidden{display:none}.ce-popover-item-separator__line{height:1px;background:var(--color-border);width:100%}.ce-popover-item-html--hidden{display:none}.ce-popover-item{--border-radius: 6px;border-radius:var(--border-radius);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:var(--item-padding);color:var(--color-text-primary);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:none;background:transparent}@media (max-width: 650px){.ce-popover-item{padding:4px}}.ce-popover-item:not(:last-of-type){margin-bottom:1px}.ce-popover-item__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover-item__icon{width:36px;height:36px;border-radius:8px}.ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover-item__icon--tool{margin-right:4px}.ce-popover-item__title{font-size:14px;line-height:20px;font-weight:500;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right:auto}@media (max-width: 650px){.ce-popover-item__title{font-size:16px}}.ce-popover-item__secondary-title{color:var(--color-text-secondary);font-size:12px;white-space:nowrap;letter-spacing:-.1em;padding-right:5px;opacity:.6}@media (max-width: 650px){.ce-popover-item__secondary-title{display:none}}.ce-popover-item--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}.ce-popover-item--disabled{color:var(--color-text-secondary);cursor:default;pointer-events:none}.ce-popover-item--focused:not(.ce-popover-item--no-focus){background:var(--color-background-item-focus)!important}.ce-popover-item--hidden{display:none}@media (hover: hover){.ce-popover-item:hover{cursor:pointer}.ce-popover-item:hover:not(.ce-popover-item--no-hover){background-color:var(--color-background-item-hover)}}.ce-popover-item--confirmation{background:var(--color-background-item-confirm)}.ce-popover-item--confirmation .ce-popover-item__title,.ce-popover-item--confirmation .ce-popover-item__icon{color:#fff}@media (hover: hover){.ce-popover-item--confirmation:not(.ce-popover-item--no-hover):hover{background:var(--color-background-item-confirm-hover)}}.ce-popover-item--confirmation:not(.ce-popover-item--no-focus).ce-popover-item--focused{background:var(--color-background-item-confirm-hover)!important}@-webkit-keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.wobble{-webkit-animation-name:wobble;animation-name:wobble;-webkit-animation-duration:.4s;animation-duration:.4s}@-webkit-keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}@keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}.ce-popover-header{margin-bottom:8px;margin-top:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover-header__text{font-size:18px;font-weight:600}.ce-popover-header__back-button{border:0;background:transparent;width:36px;height:36px;color:var(--color-text-primary)}.ce-popover-header__back-button svg{display:block;width:28px;height:28px}.ce-popover--inline{--height: 38px;--height-mobile: 46px;--container-padding: 4px;position:relative}.ce-popover--inline .ce-popover__custom-content{margin-bottom:0}.ce-popover--inline .ce-popover__items{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-popover--inline .ce-popover__container{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;padding:var(--container-padding);height:var(--height);top:0;min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content;width:-webkit-max-content;width:-moz-max-content;width:max-content;-webkit-animation:none;animation:none}@media (max-width: 650px){.ce-popover--inline .ce-popover__container{height:var(--height-mobile);position:absolute}}.ce-popover--inline .ce-popover-item-separator{padding:0 4px}.ce-popover--inline .ce-popover-item-separator__line{height:100%;width:1px}.ce-popover--inline .ce-popover-item{border-radius:4px;padding:4px}.ce-popover--inline .ce-popover-item__icon--tool{-webkit-box-shadow:none;box-shadow:none;background:transparent;margin-right:0}.ce-popover--inline .ce-popover-item__icon{width:auto;width:initial;height:auto;height:initial}.ce-popover--inline .ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover--inline .ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover--inline .ce-popover-item:not(:last-of-type){margin-bottom:0;margin-bottom:initial}.ce-popover--inline .ce-popover-item-html{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover--inline .ce-popover-item__icon--chevron-right{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{--offset: 3px;left:0;top:calc(var(--height) + var(--offset))}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{top:calc(var(--height-mobile) + var(--offset))}}.ce-popover--inline .ce-popover--nested .ce-popover__container{min-width:var(--width);width:var(--width);height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;padding:6px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ce-popover--inline .ce-popover--nested .ce-popover__items{display:block;width:100%}.ce-popover--inline .ce-popover--nested .ce-popover-item{border-radius:6px;padding:3px}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested .ce-popover-item{padding:4px}}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon--tool{margin-right:4px}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon{width:26px;height:26px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator{padding:4px 3px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator__line{width:100%;height:1px}.codex-editor [data-placeholder]:empty:before,.codex-editor [data-placeholder][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text;content:attr(data-placeholder)}.codex-editor [data-placeholder-active]:empty:before,.codex-editor [data-placeholder-active][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text}.codex-editor [data-placeholder-active]:empty:focus:before,.codex-editor [data-placeholder-active][data-empty=true]:focus:before{content:attr(data-placeholder-active)}
`;
class $6813aa9d7dc8ab1a$var$Ia extends $6813aa9d7dc8ab1a$var$E {
    constructor(){
        super(...arguments), this.isMobile = !1, this.contentRectCache = null, this.resizeDebouncer = $6813aa9d7dc8ab1a$var$Eo(()=>{
            this.windowResize();
        }, 200), this.selectionChangeDebounced = $6813aa9d7dc8ab1a$var$Eo(()=>{
            this.selectionChanged();
        }, $6813aa9d7dc8ab1a$var$da), this.documentTouchedListener = (e)=>{
            this.documentTouched(e);
        };
    }
    /**
   * Editor.js UI CSS class names
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ get CSS() {
        return {
            editorWrapper: "codex-editor",
            editorWrapperNarrow: "codex-editor--narrow",
            editorZone: "codex-editor__redactor",
            editorZoneHidden: "codex-editor__redactor--hidden",
            editorEmpty: "codex-editor--empty",
            editorRtlFix: "codex-editor--rtl"
        };
    }
    /**
   * Return Width of center column of Editor
   *
   * @returns {DOMRect}
   */ get contentRect() {
        if (this.contentRectCache !== null) return this.contentRectCache;
        const e = this.nodes.wrapper.querySelector(`.${$6813aa9d7dc8ab1a$var$R.CSS.content}`);
        return e ? (this.contentRectCache = e.getBoundingClientRect(), this.contentRectCache) : {
            width: 650,
            left: 0,
            right: 0
        };
    }
    /**
   * Making main interface
   */ async prepare() {
        this.setIsMobile(), this.make(), this.loadStyles();
    }
    /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - removes all listeners from main UI module elements
   *
   * if readOnly is false:
   *  - enables all listeners to UI module elements
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.unbindReadOnlySensitiveListeners() : window.requestIdleCallback(()=>{
            this.bindReadOnlySensitiveListeners();
        }, {
            timeout: 2e3
        });
    }
    /**
   * Check if Editor is empty and set CSS class to wrapper
   */ checkEmptiness() {
        const { BlockManager: e } = this.Editor;
        this.nodes.wrapper.classList.toggle(this.CSS.editorEmpty, e.isEditorEmpty);
    }
    /**
   * Check if one of Toolbar is opened
   * Used to prevent global keydowns (for example, Enter) conflicts with Enter-on-toolbar
   *
   * @returns {boolean}
   */ get someToolbarOpened() {
        const { Toolbar: e, BlockSettings: t1, InlineToolbar: o } = this.Editor;
        return !!(t1.opened || o.opened || e.toolbox.opened);
    }
    /**
   * Check for some Flipper-buttons is under focus
   */ get someFlipperButtonFocused() {
        return this.Editor.Toolbar.toolbox.hasFocus() ? !0 : Object.entries(this.Editor).filter(([e, t1])=>t1.flipper instanceof $6813aa9d7dc8ab1a$var$ce).some(([e, t1])=>t1.flipper.hasFocus());
    }
    /**
   * Clean editor`s UI
   */ destroy() {
        this.nodes.holder.innerHTML = "", this.unbindReadOnlyInsensitiveListeners();
    }
    /**
   * Close all Editor's toolbars
   */ closeAllToolbars() {
        const { Toolbar: e, BlockSettings: t1, InlineToolbar: o } = this.Editor;
        t1.close(), o.close(), e.toolbox.close();
    }
    /**
   * Check for mobile mode and save the result
   */ setIsMobile() {
        const e = window.innerWidth < $6813aa9d7dc8ab1a$var$Ro;
        e !== this.isMobile && this.eventsDispatcher.emit($6813aa9d7dc8ab1a$var$Te, {
            isEnabled: this.isMobile
        }), this.isMobile = e;
    }
    /**
   * Makes Editor.js interface
   */ make() {
        this.nodes.holder = $6813aa9d7dc8ab1a$var$u.getHolder(this.config.holder), this.nodes.wrapper = $6813aa9d7dc8ab1a$var$u.make("div", [
            this.CSS.editorWrapper,
            ...this.isRtl ? [
                this.CSS.editorRtlFix
            ] : []
        ]), this.nodes.redactor = $6813aa9d7dc8ab1a$var$u.make("div", this.CSS.editorZone), this.nodes.holder.offsetWidth < this.contentRect.width && this.nodes.wrapper.classList.add(this.CSS.editorWrapperNarrow), this.nodes.redactor.style.paddingBottom = this.config.minHeight + "px", this.nodes.wrapper.appendChild(this.nodes.redactor), this.nodes.holder.appendChild(this.nodes.wrapper), this.bindReadOnlyInsensitiveListeners();
    }
    /**
   * Appends CSS
   */ loadStyles() {
        const e = "editor-js-styles";
        if ($6813aa9d7dc8ab1a$var$u.get(e)) return;
        const t1 = $6813aa9d7dc8ab1a$var$u.make("style", null, {
            id: e,
            textContent: $6813aa9d7dc8ab1a$var$Sa.toString()
        });
        this.config.style && !$6813aa9d7dc8ab1a$var$V(this.config.style) && this.config.style.nonce && t1.setAttribute("nonce", this.config.style.nonce), $6813aa9d7dc8ab1a$var$u.prepend(document.head, t1);
    }
    /**
   * Adds listeners that should work both in read-only and read-write modes
   */ bindReadOnlyInsensitiveListeners() {
        this.listeners.on(document, "selectionchange", this.selectionChangeDebounced), this.listeners.on(window, "resize", this.resizeDebouncer, {
            passive: !0
        }), this.listeners.on(this.nodes.redactor, "mousedown", this.documentTouchedListener, {
            capture: !0,
            passive: !0
        }), this.listeners.on(this.nodes.redactor, "touchstart", this.documentTouchedListener, {
            capture: !0,
            passive: !0
        });
    }
    /**
   * Removes listeners that should work both in read-only and read-write modes
   */ unbindReadOnlyInsensitiveListeners() {
        this.listeners.off(document, "selectionchange", this.selectionChangeDebounced), this.listeners.off(window, "resize", this.resizeDebouncer), this.listeners.off(this.nodes.redactor, "mousedown", this.documentTouchedListener), this.listeners.off(this.nodes.redactor, "touchstart", this.documentTouchedListener);
    }
    /**
   * Adds listeners that should work only in read-only mode
   */ bindReadOnlySensitiveListeners() {
        this.readOnlyMutableListeners.on(this.nodes.redactor, "click", (e)=>{
            this.redactorClicked(e);
        }, !1), this.readOnlyMutableListeners.on(document, "keydown", (e)=>{
            this.documentKeydown(e);
        }, !0), this.readOnlyMutableListeners.on(document, "mousedown", (e)=>{
            this.documentClicked(e);
        }, !0), this.watchBlockHoveredEvents(), this.enableInputsEmptyMark();
    }
    /**
   * Listen redactor mousemove to emit 'block-hovered' event
   */ watchBlockHoveredEvents() {
        let e;
        this.readOnlyMutableListeners.on(this.nodes.redactor, "mousemove", $6813aa9d7dc8ab1a$var$dt((t1)=>{
            const o = t1.target.closest(".ce-block");
            this.Editor.BlockSelection.anyBlockSelected || o && e !== o && (e = o, this.eventsDispatcher.emit($6813aa9d7dc8ab1a$var$ln, {
                block: this.Editor.BlockManager.getBlockByChildNode(o)
            }));
        }, 20), {
            passive: !0
        });
    }
    /**
   * Unbind events that should work only in read-only mode
   */ unbindReadOnlySensitiveListeners() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Resize window handler
   */ windowResize() {
        this.contentRectCache = null, this.setIsMobile();
    }
    /**
   * All keydowns on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ documentKeydown(e) {
        switch(e.keyCode){
            case $6813aa9d7dc8ab1a$var$y.ENTER:
                this.enterPressed(e);
                break;
            case $6813aa9d7dc8ab1a$var$y.BACKSPACE:
            case $6813aa9d7dc8ab1a$var$y.DELETE:
                this.backspacePressed(e);
                break;
            case $6813aa9d7dc8ab1a$var$y.ESC:
                this.escapePressed(e);
                break;
            default:
                this.defaultBehaviour(e);
                break;
        }
    }
    /**
   * Ignore all other document's keydown events
   *
   * @param {KeyboardEvent} event - keyboard event
   */ defaultBehaviour(e) {
        const { currentBlock: t1 } = this.Editor.BlockManager, o = e.target.closest(`.${this.CSS.editorWrapper}`), i = e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
        if (t1 !== void 0 && o === null) {
            this.Editor.BlockEvents.keydown(e);
            return;
        }
        o || t1 && i || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
    }
    /**
   * @param {KeyboardEvent} event - keyboard event
   */ backspacePressed(e) {
        const { BlockManager: t1, BlockSelection: o, Caret: i } = this.Editor;
        if (o.anyBlockSelected && !$6813aa9d7dc8ab1a$var$b.isSelectionExists) {
            const s = t1.removeSelectedBlocks(), r = t1.insertDefaultBlockAtIndex(s, !0);
            i.setToBlock(r, i.positions.START), o.clearSelection(e), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
        }
    }
    /**
   * Escape pressed
   * If some of Toolbar components are opened, then close it otherwise close Toolbar
   *
   * @param {Event} event - escape keydown event
   */ escapePressed(e) {
        this.Editor.BlockSelection.clearSelection(e), this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.toolbox.close(), this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END)) : this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.InlineToolbar.opened ? this.Editor.InlineToolbar.close() : this.Editor.Toolbar.close();
    }
    /**
   * Enter pressed on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ enterPressed(e) {
        const { BlockManager: t1, BlockSelection: o } = this.Editor;
        if (this.someToolbarOpened) return;
        const i = t1.currentBlockIndex >= 0;
        if (o.anyBlockSelected && !$6813aa9d7dc8ab1a$var$b.isSelectionExists) {
            o.clearSelection(e), e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation();
            return;
        }
        if (!this.someToolbarOpened && i && e.target.tagName === "BODY") {
            const s = this.Editor.BlockManager.insert();
            e.preventDefault(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s);
        }
        this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * All clicks on document
   *
   * @param {MouseEvent} event - Click event
   */ documentClicked(e) {
        var a, l;
        if (!e.isTrusted) return;
        const t1 = e.target;
        this.nodes.holder.contains(t1) || $6813aa9d7dc8ab1a$var$b.isAtEditor || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
        const i = (a = this.Editor.BlockSettings.nodes.wrapper) == null ? void 0 : a.contains(t1), s = (l = this.Editor.Toolbar.nodes.settingsToggler) == null ? void 0 : l.contains(t1), r = i || s;
        if (this.Editor.BlockSettings.opened && !r) {
            this.Editor.BlockSettings.close();
            const c = this.Editor.BlockManager.getBlockByChildNode(t1);
            this.Editor.Toolbar.moveAndOpen(c);
        }
        this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * First touch on editor
   * Fired before click
   *
   * Used to change current block — we need to do it before 'selectionChange' event.
   * Also:
   * - Move and show the Toolbar
   * - Set a Caret
   *
   * @param event - touch or mouse event
   */ documentTouched(e) {
        let t1 = e.target;
        if (t1 === this.nodes.redactor) {
            const o = e instanceof MouseEvent ? e.clientX : e.touches[0].clientX, i = e instanceof MouseEvent ? e.clientY : e.touches[0].clientY;
            t1 = document.elementFromPoint(o, i);
        }
        try {
            this.Editor.BlockManager.setCurrentBlockByChildNode(t1);
        } catch  {
            this.Editor.RectangleSelection.isRectActivated() || this.Editor.Caret.setToTheLastBlock();
        }
        this.Editor.ReadOnly.isEnabled || this.Editor.Toolbar.moveAndOpen();
    }
    /**
   * All clicks on the redactor zone
   *
   * @param {MouseEvent} event - click event
   * @description
   * - By clicks on the Editor's bottom zone:
   *      - if last Block is empty, set a Caret to this
   *      - otherwise, add a new empty Block and set a Caret to that
   */ redactorClicked(e) {
        if (!$6813aa9d7dc8ab1a$var$b.isCollapsed) return;
        const t1 = e.target, o = e.metaKey || e.ctrlKey, i = $6813aa9d7dc8ab1a$var$u.getClosestAnchor(t1);
        if (i && o) {
            e.stopImmediatePropagation(), e.stopPropagation();
            const s = i.getAttribute("href"), r = $6813aa9d7dc8ab1a$var$oi(s);
            $6813aa9d7dc8ab1a$var$ii(r);
            return;
        }
        this.processBottomZoneClick(e);
    }
    /**
   * Check if user clicks on the Editor's bottom zone:
   *  - set caret to the last block
   *  - or add new empty block
   *
   * @param event - click event
   */ processBottomZoneClick(e) {
        const t1 = this.Editor.BlockManager.getBlockByIndex(-1), o = $6813aa9d7dc8ab1a$var$u.offset(t1.holder).bottom, i = e.pageY, { BlockSelection: s } = this.Editor;
        if (e.target instanceof Element && e.target.isEqualNode(this.nodes.redactor) && /**
    * If there is cross block selection started, target will be equal to redactor so we need additional check
    */ !s.anyBlockSelected && /**
    * Prevent caret jumping (to last block) when clicking between blocks
    */ o < i) {
            e.stopImmediatePropagation(), e.stopPropagation();
            const { BlockManager: a, Caret: l, Toolbar: c } = this.Editor;
            (!a.lastBlock.tool.isDefault || !a.lastBlock.isEmpty) && a.insertAtEnd(), l.setToTheLastBlock(), c.moveAndOpen(a.lastBlock);
        }
    }
    /**
   * Handle selection changes on mobile devices
   * Uses for showing the Inline Toolbar
   */ selectionChanged() {
        const { CrossBlockSelection: e, BlockSelection: t1 } = this.Editor, o = $6813aa9d7dc8ab1a$var$b.anchorElement;
        if (e.isCrossBlockSelectionStarted && t1.anyBlockSelected && $6813aa9d7dc8ab1a$var$b.get().removeAllRanges(), !o) {
            $6813aa9d7dc8ab1a$var$b.range || this.Editor.InlineToolbar.close();
            return;
        }
        const i = o.closest(`.${$6813aa9d7dc8ab1a$var$R.CSS.content}`);
        (i === null || i.closest(`.${$6813aa9d7dc8ab1a$var$b.CSS.editorWrapper}`) !== this.nodes.wrapper) && (this.Editor.InlineToolbar.containsNode(o) || this.Editor.InlineToolbar.close(), !(o.dataset.inlineToolbar === "true")) || (this.Editor.BlockManager.currentBlock || this.Editor.BlockManager.setCurrentBlockByChildNode(o), this.Editor.InlineToolbar.tryToShow(!0));
    }
    /**
   * Editor.js provides and ability to show placeholders for empty contenteditable elements
   *
   * This method watches for input and focus events and toggles 'data-empty' attribute
   * to workaroud the case, when inputs contains only <br>s and has no visible content
   * Then, CSS could rely on this attribute to show placeholders
   */ enableInputsEmptyMark() {
        function e(t1) {
            const o = t1.target;
            $6813aa9d7dc8ab1a$var$Do(o);
        }
        this.readOnlyMutableListeners.on(this.nodes.wrapper, "input", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusin", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusout", e);
    }
}
const $6813aa9d7dc8ab1a$var$Oa = {
    // API Modules
    BlocksAPI: $6813aa9d7dc8ab1a$var$gi,
    CaretAPI: $6813aa9d7dc8ab1a$var$bi,
    EventsAPI: $6813aa9d7dc8ab1a$var$vi,
    I18nAPI: $6813aa9d7dc8ab1a$var$kt,
    API: $6813aa9d7dc8ab1a$var$ki,
    InlineToolbarAPI: $6813aa9d7dc8ab1a$var$yi,
    ListenersAPI: $6813aa9d7dc8ab1a$var$wi,
    NotifierAPI: $6813aa9d7dc8ab1a$var$Ci,
    ReadOnlyAPI: $6813aa9d7dc8ab1a$var$Ti,
    SanitizerAPI: $6813aa9d7dc8ab1a$var$Li,
    SaverAPI: $6813aa9d7dc8ab1a$var$Pi,
    SelectionAPI: $6813aa9d7dc8ab1a$var$Ni,
    ToolsAPI: $6813aa9d7dc8ab1a$var$Ri,
    StylesAPI: $6813aa9d7dc8ab1a$var$Di,
    ToolbarAPI: $6813aa9d7dc8ab1a$var$Fi,
    TooltipAPI: $6813aa9d7dc8ab1a$var$Ui,
    UiAPI: $6813aa9d7dc8ab1a$var$Wi,
    // Toolbar Modules
    BlockSettings: $6813aa9d7dc8ab1a$var$ms,
    Toolbar: $6813aa9d7dc8ab1a$var$Bs,
    InlineToolbar: $6813aa9d7dc8ab1a$var$Cs,
    // Modules
    BlockEvents: $6813aa9d7dc8ab1a$var$na,
    BlockManager: $6813aa9d7dc8ab1a$var$ra,
    BlockSelection: $6813aa9d7dc8ab1a$var$aa,
    Caret: $6813aa9d7dc8ab1a$var$Ye,
    CrossBlockSelection: $6813aa9d7dc8ab1a$var$la,
    DragNDrop: $6813aa9d7dc8ab1a$var$ca,
    ModificationsObserver: $6813aa9d7dc8ab1a$var$ha,
    Paste: $6813aa9d7dc8ab1a$var$pa,
    ReadOnly: $6813aa9d7dc8ab1a$var$fa,
    RectangleSelection: $6813aa9d7dc8ab1a$var$Be,
    Renderer: $6813aa9d7dc8ab1a$var$ga,
    Saver: $6813aa9d7dc8ab1a$var$ma,
    Tools: $6813aa9d7dc8ab1a$var$Wn,
    UI: $6813aa9d7dc8ab1a$var$Ia
};
class $6813aa9d7dc8ab1a$var$_a {
    /**
   * @param {EditorConfig} config - user configuration
   */ constructor(e){
        this.moduleInstances = {}, this.eventsDispatcher = new $6813aa9d7dc8ab1a$var$Oe();
        let t1, o;
        this.isReady = new Promise((i, s)=>{
            t1 = i, o = s;
        }), Promise.resolve().then(async ()=>{
            this.configuration = e, this.validate(), this.init(), await this.start(), await this.render();
            const { BlockManager: i, Caret: s, UI: r, ModificationsObserver: a } = this.moduleInstances;
            r.checkEmptiness(), a.enable(), this.configuration.autofocus === !0 && this.configuration.readOnly !== !0 && s.setToBlock(i.blocks[0], s.positions.START), t1();
        }).catch((i)=>{
            $6813aa9d7dc8ab1a$var$S(`Editor.js is not ready because of ${i}`, "error"), o(i);
        });
    }
    /**
   * Setting for configuration
   *
   * @param {EditorConfig|string} config - Editor's config to set
   */ set configuration(e) {
        var o, i;
        $6813aa9d7dc8ab1a$var$D(e) ? this.config = {
            ...e
        } : this.config = {
            holder: e
        }, $6813aa9d7dc8ab1a$var$ht(!!this.config.holderId, "config.holderId", "config.holder"), this.config.holderId && !this.config.holder && (this.config.holder = this.config.holderId, this.config.holderId = null), this.config.holder == null && (this.config.holder = "editorjs"), this.config.logLevel || (this.config.logLevel = $6813aa9d7dc8ab1a$var$Lo.VERBOSE), $6813aa9d7dc8ab1a$var$Zn(this.config.logLevel), $6813aa9d7dc8ab1a$var$ht(!!this.config.initialBlock, "config.initialBlock", "config.defaultBlock"), this.config.defaultBlock = this.config.defaultBlock || this.config.initialBlock || "paragraph", this.config.minHeight = this.config.minHeight !== void 0 ? this.config.minHeight : 300;
        const t1 = {
            type: this.config.defaultBlock,
            data: {}
        };
        this.config.placeholder = this.config.placeholder || !1, this.config.sanitizer = this.config.sanitizer || {
            p: !0,
            b: !0,
            a: !0
        }, this.config.hideToolbar = this.config.hideToolbar ? this.config.hideToolbar : !1, this.config.tools = this.config.tools || {}, this.config.i18n = this.config.i18n || {}, this.config.data = this.config.data || {
            blocks: []
        }, this.config.onReady = this.config.onReady || (()=>{}), this.config.onChange = this.config.onChange || (()=>{}), this.config.inlineToolbar = this.config.inlineToolbar !== void 0 ? this.config.inlineToolbar : !0, ($6813aa9d7dc8ab1a$var$V(this.config.data) || !this.config.data.blocks || this.config.data.blocks.length === 0) && (this.config.data = {
            blocks: [
                t1
            ]
        }), this.config.readOnly = this.config.readOnly || !1, (o = this.config.i18n) != null && o.messages && $6813aa9d7dc8ab1a$var$z.setDictionary(this.config.i18n.messages), this.config.i18n.direction = ((i = this.config.i18n) == null ? void 0 : i.direction) || "ltr";
    }
    /**
   * Returns private property
   *
   * @returns {EditorConfig}
   */ get configuration() {
        return this.config;
    }
    /**
   * Checks for required fields in Editor's config
   */ validate() {
        const { holderId: e, holder: t1 } = this.config;
        if (e && t1) throw Error("\xabholderId\xbb and \xabholder\xbb param can't assign at the same time.");
        if ($6813aa9d7dc8ab1a$var$te(t1) && !$6813aa9d7dc8ab1a$var$u.get(t1)) throw Error(`element with ID \xab${t1}\xbb is missing. Pass correct holder's ID.`);
        if (t1 && $6813aa9d7dc8ab1a$var$D(t1) && !$6813aa9d7dc8ab1a$var$u.isElement(t1)) throw Error("\xabholder\xbb value must be an Element node");
    }
    /**
   * Initializes modules:
   *  - make and save instances
   *  - configure
   */ init() {
        this.constructModules(), this.configureModules();
    }
    /**
   * Start Editor!
   *
   * Get list of modules that needs to be prepared and return a sequence (Promise)
   *
   * @returns {Promise<void>}
   */ async start() {
        await [
            "Tools",
            "UI",
            "BlockManager",
            "Paste",
            "BlockSelection",
            "RectangleSelection",
            "CrossBlockSelection",
            "ReadOnly"
        ].reduce((t1, o)=>t1.then(async ()=>{
                try {
                    await this.moduleInstances[o].prepare();
                } catch (i) {
                    if (i instanceof $6813aa9d7dc8ab1a$var$Ho) throw new Error(i.message);
                    $6813aa9d7dc8ab1a$var$S(`Module ${o} was skipped because of %o`, "warn", i);
                }
            }), Promise.resolve());
    }
    /**
   * Render initial data
   */ render() {
        return this.moduleInstances.Renderer.render(this.config.data.blocks);
    }
    /**
   * Make modules instances and save it to the @property this.moduleInstances
   */ constructModules() {
        Object.entries($6813aa9d7dc8ab1a$var$Oa).forEach(([e, t1])=>{
            try {
                this.moduleInstances[e] = new t1({
                    config: this.configuration,
                    eventsDispatcher: this.eventsDispatcher
                });
            } catch (o) {
                $6813aa9d7dc8ab1a$var$S("[constructModules]", `Module ${e} skipped because`, "error", o);
            }
        });
    }
    /**
   * Modules instances configuration:
   *  - pass other modules to the 'state' property
   *  - ...
   */ configureModules() {
        for(const e in this.moduleInstances)Object.prototype.hasOwnProperty.call(this.moduleInstances, e) && (this.moduleInstances[e].state = this.getModulesDiff(e));
    }
    /**
   * Return modules without passed name
   *
   * @param {string} name - module for witch modules difference should be calculated
   */ getModulesDiff(e) {
        const t1 = {};
        for(const o in this.moduleInstances)o !== e && (t1[o] = this.moduleInstances[o]);
        return t1;
    }
}
/**
 * Editor.js
 *
 * @license Apache-2.0
 * @see Editor.js <https://editorjs.io>
 * @author CodeX Team <https://codex.so>
 */ class $6813aa9d7dc8ab1a$export$2e2bcd8739ae039 {
    /** Editor version */ static get version() {
        return "2.31.6";
    }
    /**
   * @param {EditorConfig|string|undefined} [configuration] - user configuration
   */ constructor(e){
        let t1 = ()=>{};
        $6813aa9d7dc8ab1a$var$D(e) && $6813aa9d7dc8ab1a$var$A(e.onReady) && (t1 = e.onReady);
        const o = new $6813aa9d7dc8ab1a$var$_a(e);
        this.isReady = o.isReady.then(()=>{
            this.exportAPI(o), t1();
        });
    }
    /**
   * Export external API methods
   *
   * @param {Core} editor — Editor's instance
   */ exportAPI(e) {
        const t1 = [
            "configuration"
        ], o = ()=>{
            Object.values(e.moduleInstances).forEach((s)=>{
                $6813aa9d7dc8ab1a$var$A(s.destroy) && s.destroy(), s.listeners.removeAll();
            }), $6813aa9d7dc8ab1a$var$zi(), e = null;
            for(const s in this)Object.prototype.hasOwnProperty.call(this, s) && delete this[s];
            Object.setPrototypeOf(this, null);
        };
        t1.forEach((s)=>{
            this[s] = e[s];
        }), this.destroy = o, Object.setPrototypeOf(this, e.moduleInstances.API.methods), delete this.exportAPI, Object.entries({
            blocks: {
                clear: "clear",
                render: "render"
            },
            caret: {
                focus: "focus"
            },
            events: {
                on: "on",
                off: "off",
                emit: "emit"
            },
            saver: {
                save: "save"
            }
        }).forEach(([s, r])=>{
            Object.entries(r).forEach(([a, l])=>{
                this[l] = e.moduleInstances.API.methods[s][a];
            });
        });
    }
}

});

parcelRegister("62bxO", function(module, exports) {

$parcel$export(module.exports, "default", () => $892a05942d3d6c0a$export$2e2bcd8739ae039);
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(e);
        }
    } catch (a) {
        console.error("vite-plugin-css-injected-by-js", a);
    }
})();
const $892a05942d3d6c0a$var$a = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $892a05942d3d6c0a$var$l(r) {
    const t = document.createElement("div");
    t.innerHTML = r.trim();
    const e = document.createDocumentFragment();
    return e.append(...Array.from(t.childNodes)), e;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ class $892a05942d3d6c0a$export$2e2bcd8739ae039 {
    /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ static get DEFAULT_PLACEHOLDER() {
        return "";
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} params - constructor params
   * @param {ParagraphData} params.data - previously saved data
   * @param {ParagraphConfig} params.config - user config for Tool
   * @param {object} params.api - editor.js api
   * @param {boolean} readOnly - read only mode flag
   */ constructor({ data: t, config: e, api: i, readOnly: s }){
        this.api = i, this.readOnly = s, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = e.placeholder ? e.placeholder : $892a05942d3d6c0a$export$2e2bcd8739ae039.DEFAULT_PLACEHOLDER, this._data = t ?? {}, this._element = null, this._preserveBlank = e.preserveBlank ?? !1;
    }
    /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ onKeyUp(t) {
        if (t.code !== "Backspace" && t.code !== "Delete" || !this._element) return;
        const { textContent: e } = this._element;
        e === "" && (this._element.innerHTML = "");
    }
    /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ drawView() {
        const t = document.createElement("DIV");
        return t.classList.add(this._CSS.wrapper, this._CSS.block), t.contentEditable = "false", t.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (t.innerHTML = this._data.text), this.readOnly || (t.contentEditable = "true", t.addEventListener("keyup", this.onKeyUp)), t;
    }
    /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ render() {
        return this._element = this.drawView(), this._element;
    }
    /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ merge(t) {
        if (!this._element) return;
        this._data.text += t.text;
        const e = $892a05942d3d6c0a$var$l(t.text);
        this._element.appendChild(e), this._element.normalize();
    }
    /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ validate(t) {
        return !(t.text.trim() === "" && !this._preserveBlank);
    }
    /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ save(t) {
        return {
            text: t.innerHTML
        };
    }
    /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ onPaste(t) {
        const e = {
            text: t.detail.data.innerHTML
        };
        this._data = e, window.requestAnimationFrame(()=>{
            this._element && (this._element.innerHTML = this._data.text || "");
        });
    }
    /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ static get conversionConfig() {
        return {
            export: "text",
            // to convert Paragraph to other block, use 'text' property of saved data
            import: "text"
        };
    }
    /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ static get sanitize() {
        return {
            text: {
                br: !0
            }
        };
    }
    /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ static get pasteConfig() {
        return {
            tags: [
                "P"
            ]
        };
    }
    /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ static get toolbox() {
        return {
            icon: $892a05942d3d6c0a$var$a,
            title: "Text"
        };
    }
}

});


parcelRegister("4Jk9A", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $371aff813660d66c$export$2e2bcd8739ae039);

var $7DB8U = parcelRequire("7DB8U");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $371aff813660d66c$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $371aff813660d66c$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $371aff813660d66c$var$ReactEditorJS(_a) {
    var { factory: factory, holder: holder, defaultValue: defaultValue, children: children, value: value, onInitialize: onInitialize } = _a, restProps = $371aff813660d66c$var$__rest(_a, [
        "factory",
        "holder",
        "defaultValue",
        "children",
        "value",
        "onInitialize"
    ]);
    const memoizedHolder = (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).useRef(holder !== null && holder !== void 0 ? holder : `react-editor-js-${Date.now().toString(16)}`);
    const editorJS = (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).useEffect(()=>{
        editorJS.current = factory(Object.assign(Object.assign({
            holder: memoizedHolder.current
        }, defaultValue && {
            data: defaultValue
        }), restProps));
        onInitialize === null || onInitialize === void 0 || onInitialize(editorJS.current);
        return ()=>{
            var _a;
            (_a = editorJS.current) === null || _a === void 0 || _a.destroy();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).useEffect(()=>{
        var _a;
        if (value) (_a = editorJS.current) === null || _a === void 0 || _a.render(value);
    }, [
        value
    ]);
    return children || (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).createElement("div", {
        id: memoizedHolder.current
    });
}
class $371aff813660d66c$var$ServerEditorCore {
    constructor({ data: data }){
        if (data) this._memoizedData = data;
    }
    get dangerouslyLowLevelInstance() {
        return null;
    }
    clear() {
        return $371aff813660d66c$var$__awaiter(this, void 0, void 0, function*() {});
    }
    save() {
        return $371aff813660d66c$var$__awaiter(this, void 0, void 0, function*() {
            return this._memoizedData;
        });
    }
    destroy() {
        return $371aff813660d66c$var$__awaiter(this, void 0, void 0, function*() {});
    }
    render() {
        return $371aff813660d66c$var$__awaiter(this, void 0, void 0, function*() {});
    }
}
function $371aff813660d66c$export$2e2bcd8739ae039(props) {
    const factory = (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).useCallback((config)=>new $371aff813660d66c$var$ServerEditorCore(config), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).createElement($371aff813660d66c$var$ReactEditorJS, Object.assign({
        factory: factory
    }, props));
}

});

parcelRegister("i143t", function(module, exports) {

var $cbQCu = parcelRequire("cbQCu");
var $d1db7736deae183e$require$Buffer = $cbQCu.Buffer;
"use strict";
/**
 * This module defines nodes used to define types and validations for objects and interfaces.
 */ // tslint:disable:no-shadowed-variable prefer-for-of
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.basicTypes = exports.BasicType = exports.TParamList = exports.TParam = exports.param = exports.TFunc = exports.func = exports.TProp = exports.TOptional = exports.opt = exports.TIface = exports.iface = exports.TEnumLiteral = exports.enumlit = exports.TEnumType = exports.enumtype = exports.TIntersection = exports.intersection = exports.TUnion = exports.union = exports.TTuple = exports.tuple = exports.TArray = exports.array = exports.TLiteral = exports.lit = exports.TName = exports.name = exports.TType = void 0;

var $d3AJN = parcelRequire("d3AJN");
/** Node that represents a type. */ var TType = /** @class */ function() {
    function TType() {}
    return TType;
}();
exports.TType = TType;
/** Parses a type spec into a TType node. */ function parseSpec(typeSpec) {
    return typeof typeSpec === "string" ? name(typeSpec) : typeSpec;
}
function getNamedType(suite, name) {
    var ttype = suite[name];
    if (!ttype) throw new Error("Unknown type " + name);
    return ttype;
}
/**
 * Defines a type name, either built-in, or defined in this suite. It can typically be included in
 * the specs as just a plain string.
 */ function name(value) {
    return new TName(value);
}
exports.name = name;
var TName = /** @class */ function(_super) {
    __extends(TName, _super);
    function TName(name) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this._failMsg = "is not a " + name;
        return _this;
    }
    TName.prototype.getChecker = function(suite, strict, allowedProps) {
        var _this = this;
        var ttype = getNamedType(suite, this.name);
        var checker = ttype.getChecker(suite, strict, allowedProps);
        if (ttype instanceof BasicType || ttype instanceof TName) return checker;
        // For complex types, add an additional "is not a <Type>" message on failure.
        return function(value, ctx) {
            return checker(value, ctx) ? true : ctx.fail(null, _this._failMsg, 0);
        };
    };
    return TName;
}(TType);
exports.TName = TName;
/**
 * Defines a literal value, e.g. lit('hello') or lit(123).
 */ function lit(value) {
    return new TLiteral(value);
}
exports.lit = lit;
var TLiteral = /** @class */ function(_super) {
    __extends(TLiteral, _super);
    function TLiteral(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        _this.name = JSON.stringify(value);
        _this._failMsg = "is not " + _this.name;
        return _this;
    }
    TLiteral.prototype.getChecker = function(suite, strict) {
        var _this = this;
        return function(value, ctx) {
            return value === _this.value ? true : ctx.fail(null, _this._failMsg, -1);
        };
    };
    return TLiteral;
}(TType);
exports.TLiteral = TLiteral;
/**
 * Defines an array type, e.g. array('number').
 */ function array(typeSpec) {
    return new TArray(parseSpec(typeSpec));
}
exports.array = array;
var TArray = /** @class */ function(_super) {
    __extends(TArray, _super);
    function TArray(ttype) {
        var _this = _super.call(this) || this;
        _this.ttype = ttype;
        return _this;
    }
    TArray.prototype.getChecker = function(suite, strict) {
        var itemChecker = this.ttype.getChecker(suite, strict);
        return function(value, ctx) {
            if (!Array.isArray(value)) return ctx.fail(null, "is not an array", 0);
            for(var i = 0; i < value.length; i++){
                var ok = itemChecker(value[i], ctx);
                if (!ok) return ctx.fail(i, null, 1);
            }
            return true;
        };
    };
    return TArray;
}(TType);
exports.TArray = TArray;
/**
 * Defines a tuple type, e.g. tuple('string', 'number').
 */ function tuple() {
    var typeSpec = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSpec[_i] = arguments[_i];
    return new TTuple(typeSpec.map(function(t) {
        return parseSpec(t);
    }));
}
exports.tuple = tuple;
var TTuple = /** @class */ function(_super) {
    __extends(TTuple, _super);
    function TTuple(ttypes) {
        var _this = _super.call(this) || this;
        _this.ttypes = ttypes;
        return _this;
    }
    TTuple.prototype.getChecker = function(suite, strict) {
        var itemCheckers = this.ttypes.map(function(t) {
            return t.getChecker(suite, strict);
        });
        var checker = function(value, ctx) {
            if (!Array.isArray(value)) return ctx.fail(null, "is not an array", 0);
            for(var i = 0; i < itemCheckers.length; i++){
                var ok = itemCheckers[i](value[i], ctx);
                if (!ok) return ctx.fail(i, null, 1);
            }
            return true;
        };
        if (!strict) return checker;
        return function(value, ctx) {
            if (!checker(value, ctx)) return false;
            return value.length <= itemCheckers.length ? true : ctx.fail(itemCheckers.length, "is extraneous", 2);
        };
    };
    return TTuple;
}(TType);
exports.TTuple = TTuple;
/**
 * Defines a union type, e.g. union('number', 'null').
 */ function union() {
    var typeSpec = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSpec[_i] = arguments[_i];
    return new TUnion(typeSpec.map(function(t) {
        return parseSpec(t);
    }));
}
exports.union = union;
var TUnion = /** @class */ function(_super) {
    __extends(TUnion, _super);
    function TUnion(ttypes) {
        var _this = _super.call(this) || this;
        _this.ttypes = ttypes;
        var names = ttypes.map(function(t) {
            return t instanceof TName || t instanceof TLiteral ? t.name : null;
        }).filter(function(n) {
            return n;
        });
        var otherTypes = ttypes.length - names.length;
        if (names.length) {
            if (otherTypes > 0) names.push(otherTypes + " more");
            _this._failMsg = "is none of " + names.join(", ");
        } else _this._failMsg = "is none of " + otherTypes + " types";
        return _this;
    }
    TUnion.prototype.getChecker = function(suite, strict) {
        var _this = this;
        var itemCheckers = this.ttypes.map(function(t) {
            return t.getChecker(suite, strict);
        });
        return function(value, ctx) {
            var ur = ctx.unionResolver();
            for(var i = 0; i < itemCheckers.length; i++){
                var ok = itemCheckers[i](value, ur.createContext());
                if (ok) return true;
            }
            ctx.resolveUnion(ur);
            return ctx.fail(null, _this._failMsg, 0);
        };
    };
    return TUnion;
}(TType);
exports.TUnion = TUnion;
/**
 * Defines an intersection type, e.g. intersection('number', 'null').
 */ function intersection() {
    var typeSpec = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSpec[_i] = arguments[_i];
    return new TIntersection(typeSpec.map(function(t) {
        return parseSpec(t);
    }));
}
exports.intersection = intersection;
var TIntersection = /** @class */ function(_super) {
    __extends(TIntersection, _super);
    function TIntersection(ttypes) {
        var _this = _super.call(this) || this;
        _this.ttypes = ttypes;
        return _this;
    }
    TIntersection.prototype.getChecker = function(suite, strict) {
        var allowedProps = new Set();
        var itemCheckers = this.ttypes.map(function(t) {
            return t.getChecker(suite, strict, allowedProps);
        });
        return function(value, ctx) {
            var ok = itemCheckers.every(function(checker) {
                return checker(value, ctx);
            });
            if (ok) return true;
            return ctx.fail(null, null, 0);
        };
    };
    return TIntersection;
}(TType);
exports.TIntersection = TIntersection;
/**
 * Defines an enum type, e.g. enum({'A': 1, 'B': 2}).
 */ function enumtype(values) {
    return new TEnumType(values);
}
exports.enumtype = enumtype;
var TEnumType = /** @class */ function(_super) {
    __extends(TEnumType, _super);
    function TEnumType(members) {
        var _this = _super.call(this) || this;
        _this.members = members;
        _this.validValues = new Set();
        _this._failMsg = "is not a valid enum value";
        _this.validValues = new Set(Object.keys(members).map(function(name) {
            return members[name];
        }));
        return _this;
    }
    TEnumType.prototype.getChecker = function(suite, strict) {
        var _this = this;
        return function(value, ctx) {
            return _this.validValues.has(value) ? true : ctx.fail(null, _this._failMsg, 0);
        };
    };
    return TEnumType;
}(TType);
exports.TEnumType = TEnumType;
/**
 * Defines a literal enum value, such as Direction.Up, specified as enumlit("Direction", "Up").
 */ function enumlit(name, prop) {
    return new TEnumLiteral(name, prop);
}
exports.enumlit = enumlit;
var TEnumLiteral = /** @class */ function(_super) {
    __extends(TEnumLiteral, _super);
    function TEnumLiteral(enumName, prop) {
        var _this = _super.call(this) || this;
        _this.enumName = enumName;
        _this.prop = prop;
        _this._failMsg = "is not " + enumName + "." + prop;
        return _this;
    }
    TEnumLiteral.prototype.getChecker = function(suite, strict) {
        var _this = this;
        var ttype = getNamedType(suite, this.enumName);
        if (!(ttype instanceof TEnumType)) throw new Error("Type " + this.enumName + " used in enumlit is not an enum type");
        var val = ttype.members[this.prop];
        if (!ttype.members.hasOwnProperty(this.prop)) throw new Error("Unknown value " + this.enumName + "." + this.prop + " used in enumlit");
        return function(value, ctx) {
            return value === val ? true : ctx.fail(null, _this._failMsg, -1);
        };
    };
    return TEnumLiteral;
}(TType);
exports.TEnumLiteral = TEnumLiteral;
function makeIfaceProps(props) {
    return Object.keys(props).map(function(name) {
        return makeIfaceProp(name, props[name]);
    });
}
function makeIfaceProp(name, prop) {
    return prop instanceof TOptional ? new TProp(name, prop.ttype, true) : new TProp(name, parseSpec(prop), false);
}
/**
 * Defines an interface. The first argument is an array of interfaces that it extends, and the
 * second is an array of properties.
 */ function iface(bases, props) {
    return new TIface(bases, makeIfaceProps(props));
}
exports.iface = iface;
var TIface = /** @class */ function(_super) {
    __extends(TIface, _super);
    function TIface(bases, props) {
        var _this = _super.call(this) || this;
        _this.bases = bases;
        _this.props = props;
        _this.propSet = new Set(props.map(function(p) {
            return p.name;
        }));
        return _this;
    }
    TIface.prototype.getChecker = function(suite, strict, allowedProps) {
        var _this = this;
        var baseCheckers = this.bases.map(function(b) {
            return getNamedType(suite, b).getChecker(suite, strict);
        });
        var propCheckers = this.props.map(function(prop) {
            return prop.ttype.getChecker(suite, strict);
        });
        var testCtx = new $d3AJN.NoopContext();
        // Consider a prop required if it's not optional AND does not allow for undefined as a value.
        var isPropRequired = this.props.map(function(prop, i) {
            return !prop.isOpt && !propCheckers[i](undefined, testCtx);
        });
        var checker = function(value, ctx) {
            if (typeof value !== "object" || value === null) return ctx.fail(null, "is not an object", 0);
            for(var i = 0; i < baseCheckers.length; i++){
                if (!baseCheckers[i](value, ctx)) return false;
            }
            for(var i = 0; i < propCheckers.length; i++){
                var name_1 = _this.props[i].name;
                var v = value[name_1];
                if (v === undefined) {
                    if (isPropRequired[i]) return ctx.fail(name_1, "is missing", 1);
                } else {
                    var ok = propCheckers[i](v, ctx);
                    if (!ok) return ctx.fail(name_1, null, 1);
                }
            }
            return true;
        };
        if (!strict) return checker;
        var propSet = this.propSet;
        if (allowedProps) {
            this.propSet.forEach(function(prop) {
                return allowedProps.add(prop);
            });
            propSet = allowedProps;
        }
        // In strict mode, check also for unknown enumerable properties.
        return function(value, ctx) {
            if (!checker(value, ctx)) return false;
            for(var prop in value){
                if (!propSet.has(prop)) return ctx.fail(prop, "is extraneous", 2);
            }
            return true;
        };
    };
    return TIface;
}(TType);
exports.TIface = TIface;
/**
 * Defines an optional property on an interface.
 */ function opt(typeSpec) {
    return new TOptional(parseSpec(typeSpec));
}
exports.opt = opt;
var TOptional = /** @class */ function(_super) {
    __extends(TOptional, _super);
    function TOptional(ttype) {
        var _this = _super.call(this) || this;
        _this.ttype = ttype;
        return _this;
    }
    TOptional.prototype.getChecker = function(suite, strict) {
        var itemChecker = this.ttype.getChecker(suite, strict);
        return function(value, ctx) {
            return value === undefined || itemChecker(value, ctx);
        };
    };
    return TOptional;
}(TType);
exports.TOptional = TOptional;
/**
 * Defines a property in an interface.
 */ var TProp = /** @class */ function() {
    function TProp(name, ttype, isOpt) {
        this.name = name;
        this.ttype = ttype;
        this.isOpt = isOpt;
    }
    return TProp;
}();
exports.TProp = TProp;
/**
 * Defines a function. The first argument declares the function's return type, the rest declare
 * its parameters.
 */ function func(resultSpec) {
    var params = [];
    for(var _i = 1; _i < arguments.length; _i++)params[_i - 1] = arguments[_i];
    return new TFunc(new TParamList(params), parseSpec(resultSpec));
}
exports.func = func;
var TFunc = /** @class */ function(_super) {
    __extends(TFunc, _super);
    function TFunc(paramList, result) {
        var _this = _super.call(this) || this;
        _this.paramList = paramList;
        _this.result = result;
        return _this;
    }
    TFunc.prototype.getChecker = function(suite, strict) {
        return function(value, ctx) {
            return typeof value === "function" ? true : ctx.fail(null, "is not a function", 0);
        };
    };
    return TFunc;
}(TType);
exports.TFunc = TFunc;
/**
 * Defines a function parameter.
 */ function param(name, typeSpec, isOpt) {
    return new TParam(name, parseSpec(typeSpec), Boolean(isOpt));
}
exports.param = param;
var TParam = /** @class */ function() {
    function TParam(name, ttype, isOpt) {
        this.name = name;
        this.ttype = ttype;
        this.isOpt = isOpt;
    }
    return TParam;
}();
exports.TParam = TParam;
/**
 * Defines a function parameter list.
 */ var TParamList = /** @class */ function(_super) {
    __extends(TParamList, _super);
    function TParamList(params) {
        var _this = _super.call(this) || this;
        _this.params = params;
        return _this;
    }
    TParamList.prototype.getChecker = function(suite, strict) {
        var _this = this;
        var itemCheckers = this.params.map(function(t) {
            return t.ttype.getChecker(suite, strict);
        });
        var testCtx = new $d3AJN.NoopContext();
        var isParamRequired = this.params.map(function(param, i) {
            return !param.isOpt && !itemCheckers[i](undefined, testCtx);
        });
        var checker = function(value, ctx) {
            if (!Array.isArray(value)) return ctx.fail(null, "is not an array", 0);
            for(var i = 0; i < itemCheckers.length; i++){
                var p = _this.params[i];
                if (value[i] === undefined) {
                    if (isParamRequired[i]) return ctx.fail(p.name, "is missing", 1);
                } else {
                    var ok = itemCheckers[i](value[i], ctx);
                    if (!ok) return ctx.fail(p.name, null, 1);
                }
            }
            return true;
        };
        if (!strict) return checker;
        return function(value, ctx) {
            if (!checker(value, ctx)) return false;
            return value.length <= itemCheckers.length ? true : ctx.fail(itemCheckers.length, "is extraneous", 2);
        };
    };
    return TParamList;
}(TType);
exports.TParamList = TParamList;
/**
 * Single TType implementation for all basic built-in types.
 */ var BasicType = /** @class */ function(_super) {
    __extends(BasicType, _super);
    function BasicType(validator, message) {
        var _this = _super.call(this) || this;
        _this.validator = validator;
        _this.message = message;
        return _this;
    }
    BasicType.prototype.getChecker = function(suite, strict) {
        var _this = this;
        return function(value, ctx) {
            return _this.validator(value) ? true : ctx.fail(null, _this.message, 0);
        };
    };
    return BasicType;
}(TType);
exports.BasicType = BasicType;
/**
 * Defines the suite of basic types.
 */ exports.basicTypes = {
    any: new BasicType(function(v) {
        return true;
    }, "is invalid"),
    number: new BasicType(function(v) {
        return typeof v === "number";
    }, "is not a number"),
    object: new BasicType(function(v) {
        return typeof v === "object" && v;
    }, "is not an object"),
    boolean: new BasicType(function(v) {
        return typeof v === "boolean";
    }, "is not a boolean"),
    string: new BasicType(function(v) {
        return typeof v === "string";
    }, "is not a string"),
    symbol: new BasicType(function(v) {
        return typeof v === "symbol";
    }, "is not a symbol"),
    void: new BasicType(function(v) {
        return v == null;
    }, "is not void"),
    undefined: new BasicType(function(v) {
        return v === undefined;
    }, "is not undefined"),
    null: new BasicType(function(v) {
        return v === null;
    }, "is not null"),
    never: new BasicType(function(v) {
        return false;
    }, "is unexpected"),
    Date: new BasicType(getIsNativeChecker("[object Date]"), "is not a Date"),
    RegExp: new BasicType(getIsNativeChecker("[object RegExp]"), "is not a RegExp")
};
// This approach for checking native object types mirrors that of lodash. Its advantage over
// `isinstance` is that it can still return true for native objects created in different JS
// execution environments.
var nativeToString = Object.prototype.toString;
function getIsNativeChecker(tag) {
    return function(v) {
        return typeof v === "object" && v && nativeToString.call(v) === tag;
    };
}
if (typeof $d1db7736deae183e$require$Buffer !== "undefined") exports.basicTypes.Buffer = new BasicType(function(v) {
    return $d1db7736deae183e$require$Buffer.isBuffer(v);
}, "is not a Buffer");
var _loop_1 = function(array_1) {
    exports.basicTypes[array_1.name] = new BasicType(function(v) {
        return v instanceof array_1;
    }, "is not a " + array_1.name);
};
// Support typed arrays of various flavors
for(var _i = 0, _a = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array,
    ArrayBuffer
]; _i < _a.length; _i++){
    var array_1 = _a[_i];
    _loop_1(array_1);
}

});
parcelRegister("cbQCu", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $8dff54558831dec9$export$a143d493d941bafc, (v) => $8dff54558831dec9$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $8dff54558831dec9$export$f99ded8fe4b79145, (v) => $8dff54558831dec9$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
'use strict';

var $6ocIT = parcelRequire("6ocIT");

var $1wLos = parcelRequire("1wLos");
const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case 'base64':
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6ocIT.fromByteArray(buf);
    else return $6ocIT.fromByteArray(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$8dff54558831dec9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $6ocIT.toByteArray($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("6ocIT", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $4a6eda7d0e4e0857$export$d622b2ad8d90c771, (v) => $4a6eda7d0e4e0857$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $4a6eda7d0e4e0857$export$6100ba28696e12de, (v) => $4a6eda7d0e4e0857$export$6100ba28696e12de = v);
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
'use strict';
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup['-'.charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup['_'.charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("1wLos", function(module, exports) {

$parcel$export(module.exports, "read", () => $11cd8afb6c84e33a$export$aafa59e2e03f2942, (v) => $11cd8afb6c84e33a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $11cd8afb6c84e33a$export$68d8715fc104d294, (v) => $11cd8afb6c84e33a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("d3AJN", function(module, exports) {
"use strict";
var $98180d8587d5f612$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DetailContext = module.exports.NoopContext = module.exports.VError = void 0;
/**
 * Error thrown by validation. Besides an informative message, it includes the path to the
 * property which triggered the failure.
 */ var $98180d8587d5f612$var$VError = /** @class */ function(_super) {
    $98180d8587d5f612$var$__extends(VError, _super);
    function VError(path, message) {
        var _this = _super.call(this, message) || this;
        _this.path = path;
        // See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work for info about this workaround.
        Object.setPrototypeOf(_this, VError.prototype);
        return _this;
    }
    return VError;
}(Error);
module.exports.VError = $98180d8587d5f612$var$VError;
/**
 * Fast implementation of IContext used for first-pass validation. If that fails, we can validate
 * using DetailContext to collect error messages. That's faster for the common case when messages
 * normally pass validation.
 */ var $98180d8587d5f612$var$NoopContext = /** @class */ function() {
    function NoopContext() {}
    NoopContext.prototype.fail = function(relPath, message, score) {
        return false;
    };
    NoopContext.prototype.unionResolver = function() {
        return this;
    };
    NoopContext.prototype.createContext = function() {
        return this;
    };
    NoopContext.prototype.resolveUnion = function(ur) {};
    return NoopContext;
}();
module.exports.NoopContext = $98180d8587d5f612$var$NoopContext;
/**
 * Complete implementation of IContext that collects meaningfull errors.
 */ var $98180d8587d5f612$var$DetailContext = /** @class */ function() {
    function DetailContext() {
        // Stack of property names and associated messages for reporting helpful error messages.
        this._propNames = [
            ""
        ];
        this._messages = [
            null
        ];
        // Score is used to choose the best union member whose DetailContext to use for reporting.
        // Higher score means better match (or rather less severe mismatch).
        this._score = 0;
    }
    DetailContext.prototype.fail = function(relPath, message, score) {
        this._propNames.push(relPath);
        this._messages.push(message);
        this._score += score;
        return false;
    };
    DetailContext.prototype.unionResolver = function() {
        return new $98180d8587d5f612$var$DetailUnionResolver();
    };
    DetailContext.prototype.resolveUnion = function(unionResolver) {
        var _a, _b;
        var u = unionResolver;
        var best = null;
        for(var _i = 0, _c = u.contexts; _i < _c.length; _i++){
            var ctx = _c[_i];
            if (!best || ctx._score >= best._score) best = ctx;
        }
        if (best && best._score > 0) {
            (_a = this._propNames).push.apply(_a, best._propNames);
            (_b = this._messages).push.apply(_b, best._messages);
        }
    };
    DetailContext.prototype.getError = function(path) {
        var msgParts = [];
        for(var i = this._propNames.length - 1; i >= 0; i--){
            var p = this._propNames[i];
            path += typeof p === "number" ? "[" + p + "]" : p ? "." + p : "";
            var m = this._messages[i];
            if (m) msgParts.push(path + " " + m);
        }
        return new $98180d8587d5f612$var$VError(path, msgParts.join("; "));
    };
    DetailContext.prototype.getErrorDetail = function(path) {
        var details = [];
        for(var i = this._propNames.length - 1; i >= 0; i--){
            var p = this._propNames[i];
            path += typeof p === "number" ? "[" + p + "]" : p ? "." + p : "";
            var message = this._messages[i];
            if (message) details.push({
                path: path,
                message: message
            });
        }
        var detail = null;
        for(var i = details.length - 1; i >= 0; i--){
            if (detail) details[i].nested = [
                detail
            ];
            detail = details[i];
        }
        return detail;
    };
    return DetailContext;
}();
module.exports.DetailContext = $98180d8587d5f612$var$DetailContext;
var $98180d8587d5f612$var$DetailUnionResolver = /** @class */ function() {
    function DetailUnionResolver() {
        this.contexts = [];
    }
    DetailUnionResolver.prototype.createContext = function() {
        var ctx = new $98180d8587d5f612$var$DetailContext();
        this.contexts.push(ctx);
        return ctx;
    };
    return DetailUnionResolver;
}();

});


var $e830bf8f8acfe41d$exports = {};
'use strict';

$e830bf8f8acfe41d$exports = (parcelRequire("iny3D"));


const $fecbc4a33bb0f224$var$niceErrors = {
    0: `Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'`,
    1 (annotationType, key) {
        return `Cannot apply '${annotationType}' to '${key.toString()}': Field not found.`;
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: `Invalid annotation`,
    13: `Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)`,
    14: "Intercept handlers should return nothing or a change object",
    15: `Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)`,
    16: `Modification exception: the internal structure of an observable array was changed.`,
    19 (other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20 (other) {
        return "Cannot initialize map from " + other;
    },
    21 (dataStructure) {
        return `Cannot convert to map from '${dataStructure}'`;
    },
    23: "It is not possible to get index atoms from arrays",
    24 (thing) {
        return "Cannot obtain administration from " + thing;
    },
    25 (property, name) {
        return `the entry '${property}' does not exist in the observable map '${name}'`;
    },
    26: "please specify a property",
    27 (property, name) {
        return `no observable property '${property.toString()}' found on the observable object '${name}'`;
    },
    28 (thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32 (name, derivation) {
        return `Cycle detected in computation ${name}: ${derivation}`;
    },
    33 (name) {
        return `The setter of computed value '${name}' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?`;
    },
    34 (name) {
        return `[ComputedValue '${name}'] It is not possible to assign a new value to a computed value.`;
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37 (method) {
        return `[mobx] \`observableArray.${method}()\` mutates the array in-place, which is not allowed inside a derivation. Use \`array.slice().${method}()\` instead`;
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects",
    40 (length) {
        return "Out of range: " + length;
    },
    41 (other) {
        return "Cannot initialize set from " + other;
    },
    42 (key) {
        return `Invalid index: '${key}'`;
    },
    43 (annotationType, name, kind) {
        return `Cannot apply '${annotationType}' to '${name}' (kind: ${kind}):` + `\n'${annotationType}' can only be used on properties with a function value.`;
    },
    44 (annotationType) {
        return `'${annotationType}' can only be used with 'makeObservable'`;
    }
};
const $fecbc4a33bb0f224$var$errors = {};
function $fecbc4a33bb0f224$var$die(error, ...args) {
    throw new Error(`[MobX] minified error nr: ${error}${args.length ? " " + args.map(String).join(",") : ""}. See mobx.js.org/errors`);
}
// We shorten anything used > 5 times
const $fecbc4a33bb0f224$var$assign = Object.assign;
const $fecbc4a33bb0f224$var$getDescriptor = Object.getOwnPropertyDescriptor;
const $fecbc4a33bb0f224$var$defineProperty = Object.defineProperty;
const $fecbc4a33bb0f224$var$objectPrototype = Object.prototype;
const $fecbc4a33bb0f224$var$EMPTY_ARRAY = [];
Object.freeze($fecbc4a33bb0f224$var$EMPTY_ARRAY);
const $fecbc4a33bb0f224$var$EMPTY_OBJECT = {};
Object.freeze($fecbc4a33bb0f224$var$EMPTY_OBJECT);
const $fecbc4a33bb0f224$var$plainObjectString = /*#__PURE__*/ Object.toString();
function $fecbc4a33bb0f224$var$getNextId() {
    return ++$fecbc4a33bb0f224$var$globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function $fecbc4a33bb0f224$var$once(func) {
    let invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
const $fecbc4a33bb0f224$var$noop = ()=>{};
function $fecbc4a33bb0f224$var$isFunction(fn) {
    return typeof fn === "function";
}
function $fecbc4a33bb0f224$var$isStringish(value) {
    const t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function $fecbc4a33bb0f224$var$isObject(value) {
    return value !== null && typeof value === "object";
}
function $fecbc4a33bb0f224$var$isPlainObject(value) {
    if (!$fecbc4a33bb0f224$var$isObject(value)) return false;
    const proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    const protoConstructor = $fecbc4a33bb0f224$var$hasProp(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === $fecbc4a33bb0f224$var$plainObjectString;
}
// https://stackoverflow.com/a/37865170
function $fecbc4a33bb0f224$var$isGenerator(obj) {
    const constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function $fecbc4a33bb0f224$var$addHiddenProp(object, propName, value) {
    $fecbc4a33bb0f224$var$defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function $fecbc4a33bb0f224$var$addHiddenFinalProp(object, propName, value) {
    $fecbc4a33bb0f224$var$defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function $fecbc4a33bb0f224$var$createInstanceofPredicate(name, theClass) {
    const propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return $fecbc4a33bb0f224$var$isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function $fecbc4a33bb0f224$var$isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function $fecbc4a33bb0f224$var$isPlainES6Map(thing) {
    const mapProto = Object.getPrototypeOf(thing);
    const objectProto = Object.getPrototypeOf(mapProto);
    const nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function $fecbc4a33bb0f224$var$isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
/**
 * Returns the following: own enumerable keys and symbols.
 */ function $fecbc4a33bb0f224$var$getPlainObjectKeys(object) {
    const keys = Object.keys(object);
    const symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [
        ...keys,
        ...symbols.filter((s)=>$fecbc4a33bb0f224$var$objectPrototype.propertyIsEnumerable.call(object, s))
    ];
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
const $fecbc4a33bb0f224$var$ownKeys = Reflect.ownKeys;
function $fecbc4a33bb0f224$var$stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function $fecbc4a33bb0f224$var$toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function $fecbc4a33bb0f224$var$hasProp(target, prop) {
    return $fecbc4a33bb0f224$var$objectPrototype.hasOwnProperty.call(target, prop);
}
const $fecbc4a33bb0f224$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors;
function $fecbc4a33bb0f224$var$getFlag(flags, mask) {
    return !!(flags & mask);
}
function $fecbc4a33bb0f224$var$setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function $fecbc4a33bb0f224$var$assert20223DecoratorType(context, types) {}
const $fecbc4a33bb0f224$export$f246528900dd4467 = /*#__PURE__*/ Symbol("mobx administration");
class $fecbc4a33bb0f224$var$Atom {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ constructor(name_ = "Atom"){
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = -1 /* IDerivationState_.NOT_TRACKING_ */ ;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    get isBeingObserved() {
        return $fecbc4a33bb0f224$var$getFlag(this.flags_, 1 /* AtomFlags.isBeingObserved */ );
    }
    set isBeingObserved(newValue) {
        this.flags_ = $fecbc4a33bb0f224$var$setFlag(this.flags_, 1 /* AtomFlags.isBeingObserved */ , newValue);
    }
    get isPendingUnobservation() {
        return $fecbc4a33bb0f224$var$getFlag(this.flags_, 2 /* AtomFlags.isPendingUnobservation */ );
    }
    set isPendingUnobservation(newValue) {
        this.flags_ = $fecbc4a33bb0f224$var$setFlag(this.flags_, 2 /* AtomFlags.isPendingUnobservation */ , newValue);
    }
    get diffValue() {
        return $fecbc4a33bb0f224$var$getFlag(this.flags_, 4 /* AtomFlags.diffValue */ ) ? 1 : 0;
    }
    set diffValue(newValue) {
        this.flags_ = $fecbc4a33bb0f224$var$setFlag(this.flags_, 4 /* AtomFlags.diffValue */ , newValue === 1 ? true : false);
    }
    onBO() {
        if (this.onBOL) this.onBOL.forEach((listener)=>listener());
    }
    onBUO() {
        if (this.onBUOL) this.onBUOL.forEach((listener)=>listener());
    }
    /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ reportObserved() {
        return $fecbc4a33bb0f224$var$reportObserved(this);
    }
    /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ reportChanged() {
        $fecbc4a33bb0f224$var$startBatch();
        $fecbc4a33bb0f224$var$propagateChanged(this);
        $fecbc4a33bb0f224$var$endBatch();
    }
    toString() {
        return this.name_;
    }
}
const $fecbc4a33bb0f224$var$isAtom = /*#__PURE__*/ $fecbc4a33bb0f224$var$createInstanceofPredicate("Atom", $fecbc4a33bb0f224$var$Atom);
function $fecbc4a33bb0f224$export$2e17fe64ec9a826e(name, onBecomeObservedHandler = $fecbc4a33bb0f224$var$noop, onBecomeUnobservedHandler = $fecbc4a33bb0f224$var$noop) {
    const atom = new $fecbc4a33bb0f224$var$Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== $fecbc4a33bb0f224$var$noop) atom.onBOL = new Set([
        onBecomeObservedHandler
    ]);
    if (onBecomeUnobservedHandler !== $fecbc4a33bb0f224$var$noop) atom.onBUOL = new Set([
        onBecomeUnobservedHandler
    ]);
    return atom;
}
function $fecbc4a33bb0f224$export$3de73ed166baf608(a, b) {
    return a === b;
}
function $fecbc4a33bb0f224$export$8a67fbe40c3dd8c1(a, b) {
    return $fecbc4a33bb0f224$var$deepEqual(a, b);
}
function $fecbc4a33bb0f224$export$202cfbbbce69d3c4(a, b) {
    return $fecbc4a33bb0f224$var$deepEqual(a, b, 1);
}
const $fecbc4a33bb0f224$export$700812e5ccfdbb1d = Object.is;
function $fecbc4a33bb0f224$var$deepEnhancer(v, _, name) {
    // it is an observable already, done
    if ($fecbc4a33bb0f224$export$5cd057a6046189f9(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return $fecbc4a33bb0f224$export$5ab46cbf6120b33a.array(v, {
        name: name
    });
    if ($fecbc4a33bb0f224$var$isPlainObject(v)) return $fecbc4a33bb0f224$export$5ab46cbf6120b33a.object(v, undefined, {
        name: name
    });
    if ($fecbc4a33bb0f224$var$isES6Map(v)) return $fecbc4a33bb0f224$export$5ab46cbf6120b33a.map(v, {
        name: name
    });
    if ($fecbc4a33bb0f224$var$isES6Set(v)) return $fecbc4a33bb0f224$export$5ab46cbf6120b33a.set(v, {
        name: name
    });
    if (typeof v === "function" && !$fecbc4a33bb0f224$export$b956e38827fca970(v) && !$fecbc4a33bb0f224$export$8c23365ce94ba925(v)) {
        if ($fecbc4a33bb0f224$var$isGenerator(v)) return $fecbc4a33bb0f224$export$ccc7b0636abaffc3(v);
        else return $fecbc4a33bb0f224$export$b8aa795084cbf86b(name, v);
    }
    return v;
}
function $fecbc4a33bb0f224$var$shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if ($fecbc4a33bb0f224$export$31960fb081a18155(v) || $fecbc4a33bb0f224$export$f5afceff386badf9(v) || $fecbc4a33bb0f224$export$27a7faddcfd44960(v) || $fecbc4a33bb0f224$export$da6b063694cb52c1(v)) return v;
    if (Array.isArray(v)) return $fecbc4a33bb0f224$export$5ab46cbf6120b33a.array(v, {
        name: name,
        deep: false
    });
    if ($fecbc4a33bb0f224$var$isPlainObject(v)) return $fecbc4a33bb0f224$export$5ab46cbf6120b33a.object(v, undefined, {
        name: name,
        deep: false
    });
    if ($fecbc4a33bb0f224$var$isES6Map(v)) return $fecbc4a33bb0f224$export$5ab46cbf6120b33a.map(v, {
        name: name,
        deep: false
    });
    if ($fecbc4a33bb0f224$var$isES6Set(v)) return $fecbc4a33bb0f224$export$5ab46cbf6120b33a.set(v, {
        name: name,
        deep: false
    });
}
function $fecbc4a33bb0f224$var$referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function $fecbc4a33bb0f224$var$refStructEnhancer(v, oldValue) {
    if ($fecbc4a33bb0f224$var$deepEqual(v, oldValue)) return oldValue;
    return v;
}
const $fecbc4a33bb0f224$var$OVERRIDE = "override";
const $fecbc4a33bb0f224$export$a46fbcd73382caa5 = {
    annotationType_: $fecbc4a33bb0f224$var$OVERRIDE,
    make_: $fecbc4a33bb0f224$var$make_$6,
    extend_: $fecbc4a33bb0f224$var$extend_$5
};
function $fecbc4a33bb0f224$var$isOverride(annotation) {
    return annotation.annotationType_ === $fecbc4a33bb0f224$var$OVERRIDE;
}
function $fecbc4a33bb0f224$var$make_$6(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function $fecbc4a33bb0f224$var$extend_$5(adm, key, descriptor, proxyTrap) {
    $fecbc4a33bb0f224$var$die(44, this.annotationType_);
}
function $fecbc4a33bb0f224$var$createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $fecbc4a33bb0f224$var$make_$5,
        extend_: $fecbc4a33bb0f224$var$extend_$4
    };
}
function $fecbc4a33bb0f224$var$make_$5(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if ($fecbc4a33bb0f224$export$b956e38827fca970(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    const actionDescriptor = $fecbc4a33bb0f224$var$createActionDescriptor(adm, this, key, descriptor, false);
    $fecbc4a33bb0f224$var$defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function $fecbc4a33bb0f224$var$extend_$4(adm, key, descriptor, proxyTrap) {
    const actionDescriptor = $fecbc4a33bb0f224$var$createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function $fecbc4a33bb0f224$var$decorateAction20223_(annotation, mthd, context) {
    const { kind: kind, name: name, addInitializer: addInitializer } = context;
    const ann = annotation;
    const _createAction = (m)=>{
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return $fecbc4a33bb0f224$var$createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        let mthd = initMthd;
        if (!$fecbc4a33bb0f224$export$b956e38827fca970(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _ann$options_4;
        if (!$fecbc4a33bb0f224$export$b956e38827fca970(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_4 = ann.options_) != null && _ann$options_4.bound) addInitializer(function() {
            const self = this;
            const bound = self[name].bind(self);
            bound.isMobxAction = true;
            self[name] = bound;
        });
        return mthd;
    }
    $fecbc4a33bb0f224$var$die(43, ann.annotationType_, String(name), kind);
}
function $fecbc4a33bb0f224$var$assertActionDescriptor(adm, { annotationType_: annotationType_ }, key, { value: value }) {}
function $fecbc4a33bb0f224$var$createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors = $fecbc4a33bb0f224$var$globalState.safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    $fecbc4a33bb0f224$var$assertActionDescriptor(adm, annotation, key, descriptor);
    let { value: value } = descriptor;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: $fecbc4a33bb0f224$var$createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function $fecbc4a33bb0f224$var$createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $fecbc4a33bb0f224$var$make_$4,
        extend_: $fecbc4a33bb0f224$var$extend_$3
    };
}
function $fecbc4a33bb0f224$var$make_$4(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!$fecbc4a33bb0f224$var$hasProp(adm.target_, key) || !$fecbc4a33bb0f224$export$8c23365ce94ba925(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if ($fecbc4a33bb0f224$export$8c23365ce94ba925(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    const flowDescriptor = $fecbc4a33bb0f224$var$createFlowDescriptor(adm, this, key, descriptor, false, false);
    $fecbc4a33bb0f224$var$defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function $fecbc4a33bb0f224$var$extend_$3(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    const flowDescriptor = $fecbc4a33bb0f224$var$createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function $fecbc4a33bb0f224$var$decorateFlow20223_(annotation, mthd, context) {
    var _annotation$options_;
    const { name: name, addInitializer: addInitializer } = context;
    if (!$fecbc4a33bb0f224$export$8c23365ce94ba925(mthd)) mthd = $fecbc4a33bb0f224$export$ccc7b0636abaffc3(mthd);
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) addInitializer(function() {
        const self = this;
        const bound = self[name].bind(self);
        bound.isMobXFlow = true;
        self[name] = bound;
    });
    return mthd;
}
function $fecbc4a33bb0f224$var$assertFlowDescriptor(adm, { annotationType_: annotationType_ }, key, { value: value }) {}
function $fecbc4a33bb0f224$var$createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors = $fecbc4a33bb0f224$var$globalState.safeDescriptors) {
    $fecbc4a33bb0f224$var$assertFlowDescriptor(adm, annotation, key, descriptor);
    let { value: value } = descriptor;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!$fecbc4a33bb0f224$export$8c23365ce94ba925(value)) value = $fecbc4a33bb0f224$export$ccc7b0636abaffc3(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function $fecbc4a33bb0f224$var$createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $fecbc4a33bb0f224$var$make_$3,
        extend_: $fecbc4a33bb0f224$var$extend_$2
    };
}
function $fecbc4a33bb0f224$var$make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function $fecbc4a33bb0f224$var$extend_$2(adm, key, descriptor, proxyTrap) {
    $fecbc4a33bb0f224$var$assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, $fecbc4a33bb0f224$var$assign({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function $fecbc4a33bb0f224$var$decorateComputed20223_(annotation, get, context) {
    const ann = annotation;
    const { name: key, addInitializer: addInitializer } = context;
    let computedValues;
    // Defer ComputedValue creation until first access — avoids allocating
    // ComputedValues for getters that are never read on a given instance.
    // The factory is materialised by ObservableObjectAdministration on demand.
    function createComputedValue(target, adm) {
        const options = $fecbc4a33bb0f224$var$assign({}, ann.options_, {
            get: get,
            context: target
        });
        options.name || (options.name = `ObservableObject.${key.toString()}`);
        return new $fecbc4a33bb0f224$var$ComputedValue(options);
    }
    addInitializer(function() {
        var _adm$lazyComputedKeys;
        const adm = $fecbc4a33bb0f224$var$asObservableObject(this)[$fecbc4a33bb0f224$export$f246528900dd4467];
        const target = this;
        const observable = adm.values_.get(key);
        if (observable instanceof $fecbc4a33bb0f224$var$ComputedValue && observable.derivation !== get) adm.values_.delete(key);
        ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null ? _adm$lazyComputedKeys : adm.lazyComputedKeys_ = new Map()).set(key, ()=>createComputedValue(target, adm));
    });
    return function() {
        const adm = this[$fecbc4a33bb0f224$export$f246528900dd4467];
        const observable = adm.values_.get(key);
        if (observable instanceof $fecbc4a33bb0f224$var$ComputedValue && observable.derivation !== get) {
            var _computedValues;
            let computed = (_computedValues = computedValues) == null ? void 0 : _computedValues.get(this);
            if (!computed) {
                var _computedValues2;
                computed = createComputedValue(this, adm);
                ((_computedValues2 = computedValues) != null ? _computedValues2 : computedValues = new WeakMap()).set(this, computed);
            }
            return computed.get();
        }
        return adm.getObservablePropValue_(key);
    };
}
function $fecbc4a33bb0f224$var$assertComputedDescriptor(adm, { annotationType_: annotationType_ }, key, { get: get }) {}
function $fecbc4a33bb0f224$var$createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $fecbc4a33bb0f224$var$make_$2,
        extend_: $fecbc4a33bb0f224$var$extend_$1
    };
}
function $fecbc4a33bb0f224$var$make_$2(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function $fecbc4a33bb0f224$var$extend_$1(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    $fecbc4a33bb0f224$var$assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer_) != null ? _this$options_$enhanc : $fecbc4a33bb0f224$var$deepEnhancer, proxyTrap);
}
function $fecbc4a33bb0f224$var$decorateObservable20223_(annotation, desc, context) {
    const ann = annotation;
    const { kind: kind, name: name } = context;
    if (kind !== "accessor") return;
    // Defer ObservableValue construction until first access. The factory is
    // materialised by ObservableObjectAdministration on demand, so unused
    // fields on wide classes never pay the per-instance allocation cost.
    function registerLazy(target, value) {
        var _adm$lazyObservableKe;
        const adm = $fecbc4a33bb0f224$var$asObservableObject(target)[$fecbc4a33bb0f224$export$f246528900dd4467];
        ((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null ? _adm$lazyObservableKe : adm.lazyObservableKeys_ = new Map()).set(name, ()=>{
            var _ann$options_$enhance, _ann$options_;
            return new $fecbc4a33bb0f224$var$ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer_) != null ? _ann$options_$enhance : $fecbc4a33bb0f224$var$deepEnhancer, `ObservableObject.${name.toString()}`, false);
        });
        return adm;
    }
    return {
        get () {
            var _this$$mobx;
            const adm = (_this$$mobx = this[$fecbc4a33bb0f224$export$f246528900dd4467]) != null ? _this$$mobx : registerLazy(this, desc.get.call(this));
            return adm.getObservablePropValue_(name);
        },
        set (value) {
            var _this$$mobx2;
            const adm = (_this$$mobx2 = this[$fecbc4a33bb0f224$export$f246528900dd4467]) != null ? _this$$mobx2 : registerLazy(this, value);
            return adm.setObservablePropValue_(name, value);
        },
        init (value) {
            registerLazy(this, value);
            return value;
        }
    };
}
function $fecbc4a33bb0f224$var$assertObservableDescriptor(adm, { annotationType_: annotationType_ }, key, descriptor) {}
const $fecbc4a33bb0f224$var$AUTO = "true";
const $fecbc4a33bb0f224$var$autoAnnotation = /*#__PURE__*/ $fecbc4a33bb0f224$var$createAutoAnnotation();
function $fecbc4a33bb0f224$var$createAutoAnnotation(options) {
    return {
        annotationType_: $fecbc4a33bb0f224$var$AUTO,
        options_: options,
        make_: $fecbc4a33bb0f224$var$make_$1,
        extend_: $fecbc4a33bb0f224$var$extend_
    };
}
function $fecbc4a33bb0f224$var$make_$1(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return $fecbc4a33bb0f224$export$2983e091f1a1e8e2.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        const set = $fecbc4a33bb0f224$export$b956e38827fca970(descriptor.set) ? descriptor.set // See #4553
         : $fecbc4a33bb0f224$var$createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: $fecbc4a33bb0f224$var$globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        $fecbc4a33bb0f224$var$defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if ($fecbc4a33bb0f224$var$isGenerator(descriptor.value)) {
            var _this$options_;
            const flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? $fecbc4a33bb0f224$export$d41c06fa934cc67e : $fecbc4a33bb0f224$export$ccc7b0636abaffc3;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        const actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? $fecbc4a33bb0f224$export$4dd0b06162f181e : $fecbc4a33bb0f224$export$b8aa795084cbf86b;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    let observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? $fecbc4a33bb0f224$export$431518ad42ffb7bd : $fecbc4a33bb0f224$export$5ab46cbf6120b33a;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function $fecbc4a33bb0f224$var$extend_(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return $fecbc4a33bb0f224$export$2983e091f1a1e8e2.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: $fecbc4a33bb0f224$var$globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: $fecbc4a33bb0f224$var$createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    let observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? $fecbc4a33bb0f224$export$431518ad42ffb7bd : $fecbc4a33bb0f224$export$5ab46cbf6120b33a;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function $fecbc4a33bb0f224$var$createDecoratorAnnotation(annotation, decorate) {
    return $fecbc4a33bb0f224$var$assign(function decoratorAnnotation(value, context) {
        if (context && typeof context.kind === "string") return decorate(annotation, value, context);
        return undefined;
    }, annotation);
}
const $fecbc4a33bb0f224$var$OBSERVABLE = "observable";
const $fecbc4a33bb0f224$var$OBSERVABLE_REF = "observable.ref";
const $fecbc4a33bb0f224$var$OBSERVABLE_SHALLOW = "observable.shallow";
const $fecbc4a33bb0f224$var$OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
const $fecbc4a33bb0f224$var$defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined
};
Object.freeze($fecbc4a33bb0f224$var$defaultCreateObservableOptions);
function $fecbc4a33bb0f224$var$asCreateObservableOptions(thing) {
    return thing || $fecbc4a33bb0f224$var$defaultCreateObservableOptions;
}
const $fecbc4a33bb0f224$var$observableAnnotation = /*#__PURE__*/ $fecbc4a33bb0f224$var$createObservableAnnotation($fecbc4a33bb0f224$var$OBSERVABLE);
const $fecbc4a33bb0f224$var$observableRefAnnotation = /*#__PURE__*/ $fecbc4a33bb0f224$var$createObservableAnnotation($fecbc4a33bb0f224$var$OBSERVABLE_REF, {
    enhancer_: $fecbc4a33bb0f224$var$referenceEnhancer
});
const $fecbc4a33bb0f224$var$observableShallowAnnotation = /*#__PURE__*/ $fecbc4a33bb0f224$var$createObservableAnnotation($fecbc4a33bb0f224$var$OBSERVABLE_SHALLOW, {
    enhancer_: $fecbc4a33bb0f224$var$shallowEnhancer
});
const $fecbc4a33bb0f224$var$observableStructAnnotation = /*#__PURE__*/ $fecbc4a33bb0f224$var$createObservableAnnotation($fecbc4a33bb0f224$var$OBSERVABLE_STRUCT, {
    enhancer_: $fecbc4a33bb0f224$var$refStructEnhancer
});
function $fecbc4a33bb0f224$var$createObservableDecoratorAnnotation(annotation) {
    return $fecbc4a33bb0f224$var$createDecoratorAnnotation(annotation, $fecbc4a33bb0f224$var$decorateObservable20223_);
}
function $fecbc4a33bb0f224$var$getEnhancerFromOptions(options) {
    return options.deep === true ? $fecbc4a33bb0f224$var$deepEnhancer : options.deep === false ? $fecbc4a33bb0f224$var$referenceEnhancer : $fecbc4a33bb0f224$var$getEnhancerFromAnnotation(options.defaultDecorator);
}
function $fecbc4a33bb0f224$var$getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : $fecbc4a33bb0f224$var$createAutoAnnotation(options) : undefined;
}
function $fecbc4a33bb0f224$var$getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? $fecbc4a33bb0f224$var$deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer_) != null ? _annotation$options_$ : $fecbc4a33bb0f224$var$deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function $fecbc4a33bb0f224$var$createObservable(v, arg2, arg3) {
    if (arg2 && typeof arg2.kind === "string") return $fecbc4a33bb0f224$var$decorateObservable20223_($fecbc4a33bb0f224$var$observableAnnotation, v, arg2);
    // already observable - ignore
    if ($fecbc4a33bb0f224$export$5cd057a6046189f9(v)) return v;
    // plain object
    if ($fecbc4a33bb0f224$var$isPlainObject(v)) return $fecbc4a33bb0f224$export$5ab46cbf6120b33a.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return $fecbc4a33bb0f224$export$5ab46cbf6120b33a.array(v, arg2);
    // Map
    if ($fecbc4a33bb0f224$var$isES6Map(v)) return $fecbc4a33bb0f224$export$5ab46cbf6120b33a.map(v, arg2);
    // Set
    if ($fecbc4a33bb0f224$var$isES6Set(v)) return $fecbc4a33bb0f224$export$5ab46cbf6120b33a.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return $fecbc4a33bb0f224$export$5ab46cbf6120b33a.box(v, arg2);
}
const $fecbc4a33bb0f224$var$observableFactories = {
    box (value, options) {
        const o = $fecbc4a33bb0f224$var$asCreateObservableOptions(options);
        return new $fecbc4a33bb0f224$var$ObservableValue(value, $fecbc4a33bb0f224$var$getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array (initialValues, options) {
        const o = $fecbc4a33bb0f224$var$asCreateObservableOptions(options);
        return $fecbc4a33bb0f224$var$createObservableArray(initialValues, $fecbc4a33bb0f224$var$getEnhancerFromOptions(o), o.name);
    },
    map (initialValues, options) {
        const o = $fecbc4a33bb0f224$var$asCreateObservableOptions(options);
        return new $fecbc4a33bb0f224$export$db1c0901f08fc6fd(initialValues, $fecbc4a33bb0f224$var$getEnhancerFromOptions(o), o.name);
    },
    set (initialValues, options) {
        const o = $fecbc4a33bb0f224$var$asCreateObservableOptions(options);
        return new $fecbc4a33bb0f224$export$2235f602a7a77c81(initialValues, $fecbc4a33bb0f224$var$getEnhancerFromOptions(o), o.name);
    },
    object (props, annotations, options) {
        return $fecbc4a33bb0f224$var$initObservable(()=>$fecbc4a33bb0f224$export$59d8134e963031bd($fecbc4a33bb0f224$var$asDynamicObservableObject({}, options), props, annotations));
    }
};
const $fecbc4a33bb0f224$export$431518ad42ffb7bd = /*#__PURE__*/ $fecbc4a33bb0f224$var$createObservableDecoratorAnnotation($fecbc4a33bb0f224$var$observableRefAnnotation);
const $fecbc4a33bb0f224$export$d618cc4ca9414c13 = /*#__PURE__*/ $fecbc4a33bb0f224$var$createObservableDecoratorAnnotation($fecbc4a33bb0f224$var$observableShallowAnnotation);
const $fecbc4a33bb0f224$export$36408c859af67d57 = /*#__PURE__*/ $fecbc4a33bb0f224$var$createObservableDecoratorAnnotation($fecbc4a33bb0f224$var$observableAnnotation);
const $fecbc4a33bb0f224$export$716593212ba381a0 = /*#__PURE__*/ $fecbc4a33bb0f224$var$createObservableDecoratorAnnotation($fecbc4a33bb0f224$var$observableStructAnnotation);
// eslint-disable-next-line
var $fecbc4a33bb0f224$export$5ab46cbf6120b33a = /*#__PURE__*/ $fecbc4a33bb0f224$var$assign($fecbc4a33bb0f224$var$createObservable, $fecbc4a33bb0f224$var$observableAnnotation, $fecbc4a33bb0f224$var$observableFactories);
const $fecbc4a33bb0f224$var$COMPUTED = "computed";
const $fecbc4a33bb0f224$var$COMPUTED_STRUCT = "computed.struct";
function $fecbc4a33bb0f224$var$createComputedDecoratorAnnotation(annotation) {
    return $fecbc4a33bb0f224$var$createDecoratorAnnotation(annotation, $fecbc4a33bb0f224$var$decorateComputed20223_);
}
const $fecbc4a33bb0f224$var$computedAnnotation = /*#__PURE__*/ $fecbc4a33bb0f224$var$createComputedAnnotation($fecbc4a33bb0f224$var$COMPUTED);
const $fecbc4a33bb0f224$var$computedStructAnnotation = /*#__PURE__*/ $fecbc4a33bb0f224$var$createComputedAnnotation($fecbc4a33bb0f224$var$COMPUTED_STRUCT, {
    equals: $fecbc4a33bb0f224$export$8a67fbe40c3dd8c1
});
const $fecbc4a33bb0f224$export$356bab705a4abec5 = /*#__PURE__*/ $fecbc4a33bb0f224$var$createComputedDecoratorAnnotation($fecbc4a33bb0f224$var$computedStructAnnotation);
const $fecbc4a33bb0f224$export$2983e091f1a1e8e2 = function computed(arg1, arg2) {
    if (arg2 && typeof arg2.kind === "string") return $fecbc4a33bb0f224$var$decorateComputed20223_($fecbc4a33bb0f224$var$computedAnnotation, arg1, arg2);
    if ($fecbc4a33bb0f224$var$isPlainObject(arg1)) // computed annotation with options
    return $fecbc4a33bb0f224$var$createComputedDecoratorAnnotation($fecbc4a33bb0f224$var$createComputedAnnotation($fecbc4a33bb0f224$var$COMPUTED, arg1));
    const opts = $fecbc4a33bb0f224$var$isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new $fecbc4a33bb0f224$var$ComputedValue(opts);
};
$fecbc4a33bb0f224$var$assign($fecbc4a33bb0f224$export$2983e091f1a1e8e2, $fecbc4a33bb0f224$var$computedAnnotation);
var $fecbc4a33bb0f224$var$_getDescriptor$config, $fecbc4a33bb0f224$var$_getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
let $fecbc4a33bb0f224$var$currentActionId = 0;
let $fecbc4a33bb0f224$var$nextActionId = 1;
const $fecbc4a33bb0f224$var$isFunctionNameConfigurable = ($fecbc4a33bb0f224$var$_getDescriptor$config = ($fecbc4a33bb0f224$var$_getDescriptor = /*#__PURE__*/ $fecbc4a33bb0f224$var$getDescriptor(()=>{}, "name")) == null ? void 0 : $fecbc4a33bb0f224$var$_getDescriptor.configurable) != null ? $fecbc4a33bb0f224$var$_getDescriptor$config : false;
// we can safely recycle this object
const $fecbc4a33bb0f224$var$tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function $fecbc4a33bb0f224$var$createAction(actionName, fn, autoAction = false, ref) {
    function res() {
        return $fecbc4a33bb0f224$var$executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = ()=>fn.toString();
    if ($fecbc4a33bb0f224$var$isFunctionNameConfigurable) {
        $fecbc4a33bb0f224$var$tmpNameDescriptor.value = actionName;
        $fecbc4a33bb0f224$var$defineProperty(res, "name", $fecbc4a33bb0f224$var$tmpNameDescriptor);
    }
    return res;
}
function $fecbc4a33bb0f224$var$executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    const runInfo = $fecbc4a33bb0f224$export$42f76bef54cf1cd3(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        $fecbc4a33bb0f224$export$9d569d1d4d631c2d(runInfo);
    }
}
function $fecbc4a33bb0f224$export$42f76bef54cf1cd3(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    const notifySpy_ = false;
    let startTime_ = 0;
    if (notifySpy_) {
        startTime_ = Date.now();
        const flattenedArgs = args ? Array.from(args) : $fecbc4a33bb0f224$var$EMPTY_ARRAY;
        $fecbc4a33bb0f224$var$spyReportStart({
            type: $fecbc4a33bb0f224$var$ACTION,
            name: actionName,
            object: scope,
            arguments: flattenedArgs
        });
    }
    const prevDerivation_ = $fecbc4a33bb0f224$var$globalState.trackingDerivation;
    const runAsAction = !canRunAsDerivation || !prevDerivation_;
    $fecbc4a33bb0f224$var$startBatch();
    let prevAllowStateChanges_ = $fecbc4a33bb0f224$var$globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) $fecbc4a33bb0f224$var$untrackedStart();
    const prevAllowStateReads_ = $fecbc4a33bb0f224$var$globalState.allowStateReads;
    const runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: $fecbc4a33bb0f224$var$nextActionId++,
        parentActionId_: $fecbc4a33bb0f224$var$currentActionId
    };
    $fecbc4a33bb0f224$var$currentActionId = runInfo.actionId_;
    return runInfo;
}
function $fecbc4a33bb0f224$export$9d569d1d4d631c2d(runInfo) {
    if ($fecbc4a33bb0f224$var$currentActionId !== runInfo.actionId_) $fecbc4a33bb0f224$var$die(30);
    $fecbc4a33bb0f224$var$currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) $fecbc4a33bb0f224$var$globalState.suppressReactionErrors = true;
    $fecbc4a33bb0f224$var$endBatch();
    if (runInfo.runAsAction_) $fecbc4a33bb0f224$var$untrackedEnd(runInfo.prevDerivation_);
    $fecbc4a33bb0f224$var$globalState.suppressReactionErrors = false;
}
function $fecbc4a33bb0f224$export$e510c5d1ea4358b1(allowStateChanges, func) {
    const prev = $fecbc4a33bb0f224$var$allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        $fecbc4a33bb0f224$var$allowStateChangesEnd(prev);
    }
}
function $fecbc4a33bb0f224$var$allowStateChangesStart(allowStateChanges) {
    const prev = $fecbc4a33bb0f224$var$globalState.allowStateChanges;
    $fecbc4a33bb0f224$var$globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function $fecbc4a33bb0f224$var$allowStateChangesEnd(prev) {
    $fecbc4a33bb0f224$var$globalState.allowStateChanges = prev;
}
const $fecbc4a33bb0f224$var$CREATE = "create";
class $fecbc4a33bb0f224$var$ObservableValue extends $fecbc4a33bb0f224$var$Atom {
    constructor(value, enhancer_, name_ = "ObservableValue", notifySpy = true, equals_ = $fecbc4a33bb0f224$export$700812e5ccfdbb1d){
        super(name_);
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this.equals_ = void 0;
        this.hasUnreportedChange_ = false;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.value_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        this.equals_ = equals_;
        this.value_ = enhancer_(value, undefined, name_);
        var _this$value_;
    }
    dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    }
    set(newValue) {
        const oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== $fecbc4a33bb0f224$var$globalState.UNCHANGED) {
            const notifySpy = false;
            this.setNewValue_(newValue);
        }
    }
    prepareNewValue_(newValue) {
        $fecbc4a33bb0f224$var$checkIfStateModificationsAreAllowed(this);
        if ($fecbc4a33bb0f224$var$hasInterceptors(this)) {
            const change = $fecbc4a33bb0f224$var$interceptChange(this, {
                object: this,
                type: $fecbc4a33bb0f224$var$UPDATE,
                newValue: newValue
            });
            if (!change) return $fecbc4a33bb0f224$var$globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer_(newValue, this.value_, this.name_);
        return this.equals_(this.value_, newValue) ? $fecbc4a33bb0f224$var$globalState.UNCHANGED : newValue;
    }
    setNewValue_(newValue) {
        const oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if ($fecbc4a33bb0f224$var$hasListeners(this)) $fecbc4a33bb0f224$var$notifyListeners(this, {
            type: $fecbc4a33bb0f224$var$UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    }
    get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    }
    raw() {
        // used by MST ot get undehanced value
        return this.value_;
    }
    toJSON() {
        return this.get();
    }
    toString() {
        return `${this.name_}[${this.value_}]`;
    }
    valueOf() {
        return $fecbc4a33bb0f224$var$toPrimitive(this.get());
    }
    [Symbol.toPrimitive]() {
        return this.valueOf();
    }
}
const $fecbc4a33bb0f224$export$fafbc00dbefd1aef = /*#__PURE__*/ $fecbc4a33bb0f224$var$createInstanceofPredicate("ObservableValue", $fecbc4a33bb0f224$var$ObservableValue);
class $fecbc4a33bb0f224$var$ComputedValue {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function used to determine if a newly produced
   * value differs from the previous value. Structural comparison can be convenient if you always
   * produce a new aggregated object and don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ constructor(options){
        this.dependenciesState_ = -1 /* IDerivationState_.NOT_TRACKING_ */ ;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
        this.unboundDepsCount_ = 0;
        this.value_ = new $fecbc4a33bb0f224$var$CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) $fecbc4a33bb0f224$var$die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = $fecbc4a33bb0f224$var$createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || $fecbc4a33bb0f224$export$700812e5ccfdbb1d;
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    onBecomeStale_() {
        $fecbc4a33bb0f224$var$propagateMaybeChanged(this);
    }
    onBO() {
        if (this.onBOL) this.onBOL.forEach((listener)=>listener());
    }
    onBUO() {
        if (this.onBUOL) this.onBUOL.forEach((listener)=>listener());
    }
    // to check for cycles
    get isComputing() {
        return $fecbc4a33bb0f224$var$getFlag(this.flags_, 1 /* ComputedValueFlags.isComputing */ );
    }
    set isComputing(newValue) {
        this.flags_ = $fecbc4a33bb0f224$var$setFlag(this.flags_, 1 /* ComputedValueFlags.isComputing */ , newValue);
    }
    get isRunningSetter() {
        return $fecbc4a33bb0f224$var$getFlag(this.flags_, 2 /* ComputedValueFlags.isRunningSetter */ );
    }
    set isRunningSetter(newValue) {
        this.flags_ = $fecbc4a33bb0f224$var$setFlag(this.flags_, 2 /* ComputedValueFlags.isRunningSetter */ , newValue);
    }
    get isBeingObserved() {
        return $fecbc4a33bb0f224$var$getFlag(this.flags_, 4 /* ComputedValueFlags.isBeingObserved */ );
    }
    set isBeingObserved(newValue) {
        this.flags_ = $fecbc4a33bb0f224$var$setFlag(this.flags_, 4 /* ComputedValueFlags.isBeingObserved */ , newValue);
    }
    get isPendingUnobservation() {
        return $fecbc4a33bb0f224$var$getFlag(this.flags_, 8 /* ComputedValueFlags.isPendingUnobservation */ );
    }
    set isPendingUnobservation(newValue) {
        this.flags_ = $fecbc4a33bb0f224$var$setFlag(this.flags_, 8 /* ComputedValueFlags.isPendingUnobservation */ , newValue);
    }
    get diffValue() {
        return $fecbc4a33bb0f224$var$getFlag(this.flags_, 16 /* ComputedValueFlags.diffValue */ ) ? 1 : 0;
    }
    set diffValue(newValue) {
        this.flags_ = $fecbc4a33bb0f224$var$setFlag(this.flags_, 16 /* ComputedValueFlags.diffValue */ , newValue === 1 ? true : false);
    }
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ get() {
        if (this.isComputing) $fecbc4a33bb0f224$var$die(32, this.name_, this.derivation);
        if ($fecbc4a33bb0f224$var$globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if ($fecbc4a33bb0f224$var$shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                $fecbc4a33bb0f224$var$startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                $fecbc4a33bb0f224$var$endBatch();
            }
        } else {
            $fecbc4a33bb0f224$var$reportObserved(this);
            if ($fecbc4a33bb0f224$var$shouldCompute(this)) {
                let prevTrackingContext = $fecbc4a33bb0f224$var$globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) $fecbc4a33bb0f224$var$globalState.trackingContext = this;
                if (this.trackAndCompute()) $fecbc4a33bb0f224$var$propagateChangeConfirmed(this);
                $fecbc4a33bb0f224$var$globalState.trackingContext = prevTrackingContext;
            }
        }
        const result = this.value_;
        if ($fecbc4a33bb0f224$var$isCaughtException(result)) throw result.cause;
        return result;
    }
    set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) $fecbc4a33bb0f224$var$die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else $fecbc4a33bb0f224$var$die(34, this.name_);
    }
    trackAndCompute() {
        // N.B: unminified as it is used by MST
        const oldValue = this.value_;
        const wasSuspended = /* see #1208 */ this.dependenciesState_ === -1 /* IDerivationState_.NOT_TRACKING_ */ ;
        const newValue = this.computeValue_(true);
        const changed = wasSuspended || $fecbc4a33bb0f224$var$isCaughtException(oldValue) || $fecbc4a33bb0f224$var$isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    }
    computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        const prev = false;
        let res;
        if (track) res = $fecbc4a33bb0f224$var$trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if ($fecbc4a33bb0f224$var$globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new $fecbc4a33bb0f224$var$CaughtException(e);
            }
        }
        this.isComputing = false;
        return res;
    }
    suspend_() {
        if (!this.keepAlive_) {
            $fecbc4a33bb0f224$var$clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    }
    warnAboutUntrackedRead_() {
        return;
    }
    toString() {
        return `${this.name_}[${this.derivation.toString()}]`;
    }
    valueOf() {
        return $fecbc4a33bb0f224$var$toPrimitive(this.get());
    }
    [Symbol.toPrimitive]() {
        return this.valueOf();
    }
}
const $fecbc4a33bb0f224$var$isComputedValue = /*#__PURE__*/ $fecbc4a33bb0f224$var$createInstanceofPredicate("ComputedValue", $fecbc4a33bb0f224$var$ComputedValue);
class $fecbc4a33bb0f224$var$CaughtException {
    constructor(cause){
        this.cause = void 0;
        this.cause = cause;
    // Empty
    }
}
function $fecbc4a33bb0f224$var$isCaughtException(e) {
    return e instanceof $fecbc4a33bb0f224$var$CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function $fecbc4a33bb0f224$var$shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case 0 /* IDerivationState_.UP_TO_DATE_ */ :
            return false;
        case -1 /* IDerivationState_.NOT_TRACKING_ */ :
        case 2 /* IDerivationState_.STALE_ */ :
            return true;
        case 1 /* IDerivationState_.POSSIBLY_STALE_ */ :
            {
                // state propagation can occur outside of action/reactive context #2195
                const prevAllowStateReads = true;
                const prevUntracked = $fecbc4a33bb0f224$var$untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
                const obs = derivation.observing_, l = obs.length;
                for(let i = 0; i < l; i++){
                    const obj = obs[i];
                    if ($fecbc4a33bb0f224$var$isComputedValue(obj)) {
                        if ($fecbc4a33bb0f224$var$globalState.disableErrorBoundaries) obj.get();
                        else try {
                            obj.get();
                        } catch (e) {
                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                            $fecbc4a33bb0f224$var$untrackedEnd(prevUntracked);
                            return true;
                        }
                        // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                        // and `derivation` is an observer of `obj`
                        // invariantShouldCompute(derivation)
                        if (derivation.dependenciesState_ === 2 /* IDerivationState_.STALE_ */ ) {
                            $fecbc4a33bb0f224$var$untrackedEnd(prevUntracked);
                            return true;
                        }
                    }
                }
                $fecbc4a33bb0f224$var$changeDependenciesStateTo0(derivation);
                $fecbc4a33bb0f224$var$untrackedEnd(prevUntracked);
                return false;
            }
    }
}
function $fecbc4a33bb0f224$export$34c53f8cb85e26c1() {
    return $fecbc4a33bb0f224$var$globalState.trackingDerivation !== null; // filter out actions inside computations
}
function $fecbc4a33bb0f224$var$checkIfStateModificationsAreAllowed(atom) {
    return;
}
function $fecbc4a33bb0f224$var$checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function $fecbc4a33bb0f224$var$trackDerivedFunction(derivation, f, context) {
    const prevAllowStateReads = true;
    $fecbc4a33bb0f224$var$changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++$fecbc4a33bb0f224$var$globalState.runId;
    const prevTracking = $fecbc4a33bb0f224$var$globalState.trackingDerivation;
    $fecbc4a33bb0f224$var$globalState.trackingDerivation = derivation;
    $fecbc4a33bb0f224$var$globalState.inBatch++;
    let result;
    if ($fecbc4a33bb0f224$var$globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new $fecbc4a33bb0f224$var$CaughtException(e);
    }
    $fecbc4a33bb0f224$var$globalState.inBatch--;
    $fecbc4a33bb0f224$var$globalState.trackingDerivation = prevTracking;
    $fecbc4a33bb0f224$var$bindDependencies(derivation);
    $fecbc4a33bb0f224$var$warnAboutDerivationWithoutDependencies(derivation);
    return result;
}
function $fecbc4a33bb0f224$var$warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function $fecbc4a33bb0f224$var$bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    const prevObserving = derivation.observing_;
    const observing = derivation.observing_ = derivation.newObserving_;
    let lowestNewObservingDerivationState = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    let i0 = 0, l = derivation.unboundDepsCount_;
    for(let i = 0; i < l; i++){
        const dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        const dep = prevObserving[l];
        if (dep.diffValue === 0) $fecbc4a33bb0f224$var$removeObserver(dep, derivation);
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        const dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            $fecbc4a33bb0f224$var$addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== 0 /* IDerivationState_.UP_TO_DATE_ */ ) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function $fecbc4a33bb0f224$var$clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    const obs = derivation.observing_;
    derivation.observing_ = [];
    let i = obs.length;
    while(i--)$fecbc4a33bb0f224$var$removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = -1 /* IDerivationState_.NOT_TRACKING_ */ ;
}
function $fecbc4a33bb0f224$export$8c437e4d572e2f99(action) {
    const prev = $fecbc4a33bb0f224$var$untrackedStart();
    try {
        return action();
    } finally{
        $fecbc4a33bb0f224$var$untrackedEnd(prev);
    }
}
function $fecbc4a33bb0f224$var$untrackedStart() {
    const prev = $fecbc4a33bb0f224$var$globalState.trackingDerivation;
    $fecbc4a33bb0f224$var$globalState.trackingDerivation = null;
    return prev;
}
function $fecbc4a33bb0f224$var$untrackedEnd(prev) {
    $fecbc4a33bb0f224$var$globalState.trackingDerivation = prev;
}
function $fecbc4a33bb0f224$export$84c93b6404d77e6f(allowStateReads) {
    const prev = $fecbc4a33bb0f224$var$globalState.allowStateReads;
    $fecbc4a33bb0f224$var$globalState.allowStateReads = allowStateReads;
    return prev;
}
function $fecbc4a33bb0f224$export$c7b7fb1b2b410642(prev) {
    $fecbc4a33bb0f224$var$globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function $fecbc4a33bb0f224$var$changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === 0 /* IDerivationState_.UP_TO_DATE_ */ ) return;
    derivation.dependenciesState_ = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
    const obs = derivation.observing_;
    let i = obs.length;
    while(i--)obs[i].lowestObserverState_ = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
}
const $fecbc4a33bb0f224$var$MOBX_GLOBALS_VERSION = 7;
/**
 * These values will persist if global state is reset
 */ const $fecbc4a33bb0f224$var$persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED"
];
class $fecbc4a33bb0f224$var$MobXGlobals {
    constructor(){
        /**
     * MobXGlobals version.
     * MobX compatiblity with other versions loaded in memory as long as this version matches.
     * It indicates that the global state still stores similar information
     *
     * N.B: this version is unrelated to the package version of MobX, and is only the version of the
     * internal state storage of MobX, and can be the same across many different package versions
     */ this.version = $fecbc4a33bb0f224$var$MOBX_GLOBALS_VERSION;
        /**
     * globally unique token to signal unchanged
     */ this.UNCHANGED = {};
        /**
     * Currently running derivation
     */ this.trackingDerivation = null;
        /**
     * Currently running reaction. This determines if we currently have a reactive context.
     * (Tracking derivation is also set for temporal tracking of computed values inside actions,
     * but trackingReaction can only be set by a form of Reaction)
     */ this.trackingContext = null;
        /**
     * Each time a derivation is tracked, it is assigned a unique run-id
     */ this.runId = 0;
        /**
     * 'guid' for general purpose. Will be persisted amongst resets.
     */ this.mobxGuid = 0;
        /**
     * Are we in a batch block? (and how many of them)
     */ this.inBatch = 0;
        /**
     * Observables that don't have observers anymore, and are about to be
     * suspended, unless somebody else accesses it in the same batch
     *
     * @type {IObservable[]}
     */ this.pendingUnobservations = [];
        /**
     * List of scheduled, not yet executed, reactions.
     */ this.pendingReactions = [];
        /**
     * Are we currently processing reactions?
     */ this.isRunningReactions = false;
        /**
     * Is it allowed to change observables at this point?
     * In general, MobX doesn't allow that when running computations and React.render.
     * To ensure that those functions stay pure.
     */ this.allowStateChanges = false;
        /**
     * Is it allowed to read observables at this point?
     * Used to hold the state needed for `observableRequiresReaction`
     */ this.allowStateReads = true;
        /**
     * If strict mode is enabled, state changes are by default not allowed
     */ this.enforceActions = true;
        /**
     * Spy callbacks
     */ this.spyListeners = [];
        /**
     * Globally attached error handlers that react specifically to errors in reactions
     */ this.globalReactionErrorHandlers = [];
        /**
     * Warn if computed values are accessed outside a reactive context
     */ this.computedRequiresReaction = false;
        /**
     * (Experimental)
     * Warn if you try to create to derivation / reactive context without accessing any observable.
     */ this.reactionRequiresObservable = false;
        /**
     * (Experimental)
     * Warn if observables are accessed outside a reactive context
     */ this.observableRequiresReaction = false;
        /*
     * Don't catch and rethrow exceptions. This is useful for inspecting the state of
     * the stack when an exception occurs while debugging.
     */ this.disableErrorBoundaries = false;
        /*
     * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
     * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
     */ this.suppressReactionErrors = false;
        /**
     * False forces all object's descriptors to
     * writable: true
     * configurable: true
     */ this.safeDescriptors = true;
    }
}
let $fecbc4a33bb0f224$var$canMergeGlobalState = true;
let $fecbc4a33bb0f224$var$isolateCalled = false;
let $fecbc4a33bb0f224$var$globalState = /*#__PURE__*/ function() {
    let global = globalThis;
    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals) $fecbc4a33bb0f224$var$canMergeGlobalState = false;
    if (global.__mobxGlobals && global.__mobxGlobals.version !== $fecbc4a33bb0f224$var$MOBX_GLOBALS_VERSION) $fecbc4a33bb0f224$var$canMergeGlobalState = false;
    if (!$fecbc4a33bb0f224$var$canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(()=>{
            if (!$fecbc4a33bb0f224$var$isolateCalled) $fecbc4a33bb0f224$var$die(35);
        }, 1);
        return new $fecbc4a33bb0f224$var$MobXGlobals();
    } else if (global.__mobxGlobals) {
        global.__mobxInstanceCount += 1;
        if (!global.__mobxGlobals.UNCHANGED) global.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global.__mobxGlobals;
    } else {
        global.__mobxInstanceCount = 1;
        return global.__mobxGlobals = /*#__PURE__*/ new $fecbc4a33bb0f224$var$MobXGlobals();
    }
}();
function $fecbc4a33bb0f224$var$isolateGlobalState() {
    if ($fecbc4a33bb0f224$var$globalState.pendingReactions.length || $fecbc4a33bb0f224$var$globalState.inBatch || $fecbc4a33bb0f224$var$globalState.isRunningReactions) $fecbc4a33bb0f224$var$die(36);
    $fecbc4a33bb0f224$var$isolateCalled = true;
    if ($fecbc4a33bb0f224$var$canMergeGlobalState) {
        let global = globalThis;
        if (--global.__mobxInstanceCount === 0) global.__mobxGlobals = undefined;
        $fecbc4a33bb0f224$var$globalState = new $fecbc4a33bb0f224$var$MobXGlobals();
    }
}
function $fecbc4a33bb0f224$export$c78907783e606401() {
    return $fecbc4a33bb0f224$var$globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function $fecbc4a33bb0f224$export$5c18e491c80b9ab4() {
    const defaultGlobals = new $fecbc4a33bb0f224$var$MobXGlobals();
    for(let key in defaultGlobals)if ($fecbc4a33bb0f224$var$persistentKeys.indexOf(key) === -1) $fecbc4a33bb0f224$var$globalState[key] = defaultGlobals[key];
    $fecbc4a33bb0f224$var$globalState.allowStateChanges = !$fecbc4a33bb0f224$var$globalState.enforceActions;
}
function $fecbc4a33bb0f224$var$hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function $fecbc4a33bb0f224$var$getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function $fecbc4a33bb0f224$var$addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function $fecbc4a33bb0f224$var$removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_.delete(node);
    if (observable.observers_.size === 0) // deleting last observer
    $fecbc4a33bb0f224$var$queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function $fecbc4a33bb0f224$var$queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        $fecbc4a33bb0f224$var$globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function $fecbc4a33bb0f224$var$startBatch() {
    $fecbc4a33bb0f224$var$globalState.inBatch++;
}
function $fecbc4a33bb0f224$var$endBatch() {
    if (--$fecbc4a33bb0f224$var$globalState.inBatch === 0) {
        $fecbc4a33bb0f224$var$runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        const list = $fecbc4a33bb0f224$var$globalState.pendingUnobservations;
        for(let i = 0; i < list.length; i++){
            const observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof $fecbc4a33bb0f224$var$ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        $fecbc4a33bb0f224$var$globalState.pendingUnobservations = [];
    }
}
function $fecbc4a33bb0f224$var$reportObserved(observable) {
    $fecbc4a33bb0f224$var$checkIfStateReadsAreAllowed(observable);
    const derivation = $fecbc4a33bb0f224$var$globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && $fecbc4a33bb0f224$var$globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && $fecbc4a33bb0f224$var$globalState.inBatch > 0) $fecbc4a33bb0f224$var$queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function $fecbc4a33bb0f224$var$propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === 2 /* IDerivationState_.STALE_ */ ) return;
    observable.lowestObserverState_ = 2 /* IDerivationState_.STALE_ */ ;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach((d)=>{
        if (d.dependenciesState_ === 0 /* IDerivationState_.UP_TO_DATE_ */ ) d.onBecomeStale_();
        d.dependenciesState_ = 2 /* IDerivationState_.STALE_ */ ;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function $fecbc4a33bb0f224$var$propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === 2 /* IDerivationState_.STALE_ */ ) return;
    observable.lowestObserverState_ = 2 /* IDerivationState_.STALE_ */ ;
    observable.observers_.forEach((d)=>{
        if (d.dependenciesState_ === 1 /* IDerivationState_.POSSIBLY_STALE_ */ ) d.dependenciesState_ = 2 /* IDerivationState_.STALE_ */ ;
        else if (d.dependenciesState_ === 0 /* IDerivationState_.UP_TO_DATE_ */  // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function $fecbc4a33bb0f224$var$propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== 0 /* IDerivationState_.UP_TO_DATE_ */ ) return;
    observable.lowestObserverState_ = 1 /* IDerivationState_.POSSIBLY_STALE_ */ ;
    observable.observers_.forEach((d)=>{
        if (d.dependenciesState_ === 0 /* IDerivationState_.UP_TO_DATE_ */ ) {
            d.dependenciesState_ = 1 /* IDerivationState_.POSSIBLY_STALE_ */ ;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
class $fecbc4a33bb0f224$export$d2ae4167a30cf6bb {
    constructor(name_ = "Reaction", onInvalidate_, errorHandler_, requiresObservable_){
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = -1 /* IDerivationState_.NOT_TRACKING_ */ ;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    get isDisposed() {
        return $fecbc4a33bb0f224$var$getFlag(this.flags_, 1 /* ReactionFlags.isDisposed */ );
    }
    set isDisposed(newValue) {
        this.flags_ = $fecbc4a33bb0f224$var$setFlag(this.flags_, 1 /* ReactionFlags.isDisposed */ , newValue);
    }
    get isScheduled() {
        return $fecbc4a33bb0f224$var$getFlag(this.flags_, 2 /* ReactionFlags.isScheduled */ );
    }
    set isScheduled(newValue) {
        this.flags_ = $fecbc4a33bb0f224$var$setFlag(this.flags_, 2 /* ReactionFlags.isScheduled */ , newValue);
    }
    get isTrackPending() {
        return $fecbc4a33bb0f224$var$getFlag(this.flags_, 4 /* ReactionFlags.isTrackPending */ );
    }
    set isTrackPending(newValue) {
        this.flags_ = $fecbc4a33bb0f224$var$setFlag(this.flags_, 4 /* ReactionFlags.isTrackPending */ , newValue);
    }
    get isRunning() {
        return $fecbc4a33bb0f224$var$getFlag(this.flags_, 8 /* ReactionFlags.isRunning */ );
    }
    set isRunning(newValue) {
        this.flags_ = $fecbc4a33bb0f224$var$setFlag(this.flags_, 8 /* ReactionFlags.isRunning */ , newValue);
    }
    get diffValue() {
        return $fecbc4a33bb0f224$var$getFlag(this.flags_, 16 /* ReactionFlags.diffValue */ ) ? 1 : 0;
    }
    set diffValue(newValue) {
        this.flags_ = $fecbc4a33bb0f224$var$setFlag(this.flags_, 16 /* ReactionFlags.diffValue */ , newValue === 1 ? true : false);
    }
    onBecomeStale_() {
        this.schedule_();
    }
    schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            $fecbc4a33bb0f224$var$globalState.pendingReactions.push(this);
            $fecbc4a33bb0f224$var$runReactions();
        }
    }
    /**
   * internal, use schedule() if you intend to kick off a reaction
   */ runReaction_() {
        if (!this.isDisposed) {
            $fecbc4a33bb0f224$var$startBatch();
            this.isScheduled = false;
            const prev = $fecbc4a33bb0f224$var$globalState.trackingContext;
            $fecbc4a33bb0f224$var$globalState.trackingContext = this;
            if ($fecbc4a33bb0f224$var$shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            $fecbc4a33bb0f224$var$globalState.trackingContext = prev;
            $fecbc4a33bb0f224$var$endBatch();
        }
    }
    track(fn) {
        if (this.isDisposed) return;
        $fecbc4a33bb0f224$var$startBatch();
        const notify = false;
        let startTime;
        this.isRunning = true;
        const prevReaction = $fecbc4a33bb0f224$var$globalState.trackingContext; // reactions could create reactions...
        $fecbc4a33bb0f224$var$globalState.trackingContext = this;
        const result = $fecbc4a33bb0f224$var$trackDerivedFunction(this, fn, undefined);
        $fecbc4a33bb0f224$var$globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        $fecbc4a33bb0f224$var$clearObserving(this);
        if ($fecbc4a33bb0f224$var$isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        $fecbc4a33bb0f224$var$endBatch();
    }
    reportExceptionInDerivation_(error) {
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if ($fecbc4a33bb0f224$var$globalState.disableErrorBoundaries) throw error;
        const message = `[mobx] uncaught error in '${this}'`;
        if (!$fecbc4a33bb0f224$var$globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        $fecbc4a33bb0f224$var$globalState.globalReactionErrorHandlers.forEach((f)=>f(error, this));
    }
    dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                $fecbc4a33bb0f224$var$startBatch();
                $fecbc4a33bb0f224$var$clearObserving(this);
                $fecbc4a33bb0f224$var$endBatch();
            }
        }
    }
    getDisposer_(abortSignal) {
        const dispose = ()=>{
            this.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$fecbc4a33bb0f224$export$f246528900dd4467] = this;
        if ("dispose" in Symbol && typeof Symbol.dispose === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    }
    toString() {
        return `Reaction[${this.name_}]`;
    }
}
function $fecbc4a33bb0f224$export$d7203a53b5e117e4(handler) {
    $fecbc4a33bb0f224$var$globalState.globalReactionErrorHandlers.push(handler);
    return ()=>{
        const idx = $fecbc4a33bb0f224$var$globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) $fecbc4a33bb0f224$var$globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ const $fecbc4a33bb0f224$var$MAX_REACTION_ITERATIONS = 100;
let $fecbc4a33bb0f224$var$reactionScheduler = (f)=>f();
function $fecbc4a33bb0f224$var$runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if ($fecbc4a33bb0f224$var$globalState.inBatch > 0 || $fecbc4a33bb0f224$var$globalState.isRunningReactions) return;
    $fecbc4a33bb0f224$var$reactionScheduler($fecbc4a33bb0f224$var$runReactionsHelper);
}
function $fecbc4a33bb0f224$var$runReactionsHelper() {
    $fecbc4a33bb0f224$var$globalState.isRunningReactions = true;
    const allReactions = $fecbc4a33bb0f224$var$globalState.pendingReactions;
    let iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === $fecbc4a33bb0f224$var$MAX_REACTION_ITERATIONS) {
            console.error(`[mobx] cycle in reaction: ${allReactions[0]}`);
            allReactions.splice(0); // clear reactions
        }
        let remainingReactions = allReactions.splice(0);
        for(let i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    $fecbc4a33bb0f224$var$globalState.isRunningReactions = false;
}
const $fecbc4a33bb0f224$var$isReaction = /*#__PURE__*/ $fecbc4a33bb0f224$var$createInstanceofPredicate("Reaction", $fecbc4a33bb0f224$export$d2ae4167a30cf6bb);
function $fecbc4a33bb0f224$var$setReactionScheduler(fn) {
    const baseScheduler = $fecbc4a33bb0f224$var$reactionScheduler;
    $fecbc4a33bb0f224$var$reactionScheduler = (f)=>fn(()=>baseScheduler(f));
}
function $fecbc4a33bb0f224$var$isSpyEnabled() {
    return false;
}
function $fecbc4a33bb0f224$var$spyReport(event) {
    return;
}
function $fecbc4a33bb0f224$var$spyReportStart(event) {
    return;
}
const $fecbc4a33bb0f224$var$END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function $fecbc4a33bb0f224$var$spyReportEnd(change) {
    return;
}
function $fecbc4a33bb0f224$export$fcc0cd19e9fb2b4c(listener) {
    var l;
    console.warn(`[mobx.spy] Is a no-op in production builds`);
    return function() {};
}
const $fecbc4a33bb0f224$var$ACTION = "action";
const $fecbc4a33bb0f224$var$ACTION_BOUND = "action.bound";
const $fecbc4a33bb0f224$var$AUTOACTION = "autoAction";
const $fecbc4a33bb0f224$var$AUTOACTION_BOUND = "autoAction.bound";
const $fecbc4a33bb0f224$var$DEFAULT_ACTION_NAME = "<unnamed action>";
const $fecbc4a33bb0f224$var$actionAnnotation = /*#__PURE__*/ $fecbc4a33bb0f224$var$createActionAnnotation($fecbc4a33bb0f224$var$ACTION);
const $fecbc4a33bb0f224$var$actionBoundAnnotation = /*#__PURE__*/ $fecbc4a33bb0f224$var$createActionAnnotation($fecbc4a33bb0f224$var$ACTION_BOUND, {
    bound: true
});
const $fecbc4a33bb0f224$var$autoActionAnnotation = /*#__PURE__*/ $fecbc4a33bb0f224$var$createActionAnnotation($fecbc4a33bb0f224$var$AUTOACTION, {
    autoAction: true
});
const $fecbc4a33bb0f224$var$autoActionBoundAnnotation = /*#__PURE__*/ $fecbc4a33bb0f224$var$createActionAnnotation($fecbc4a33bb0f224$var$AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function $fecbc4a33bb0f224$var$createActionDecoratorAnnotation(annotation) {
    return $fecbc4a33bb0f224$var$createDecoratorAnnotation(annotation, $fecbc4a33bb0f224$var$decorateAction20223_);
}
function $fecbc4a33bb0f224$var$createActionFactory(autoAction) {
    const res = function action(arg1, arg2) {
        if (arg2 && typeof arg2.kind === "string") return $fecbc4a33bb0f224$var$decorateAction20223_(autoAction ? $fecbc4a33bb0f224$var$autoActionAnnotation : $fecbc4a33bb0f224$var$actionAnnotation, arg1, arg2);
        // action(fn() {})
        if ($fecbc4a33bb0f224$var$isFunction(arg1)) return $fecbc4a33bb0f224$var$createAction(arg1.name || $fecbc4a33bb0f224$var$DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if ($fecbc4a33bb0f224$var$isFunction(arg2)) return $fecbc4a33bb0f224$var$createAction(arg1, arg2, autoAction);
        // action("name") annotation
        if ($fecbc4a33bb0f224$var$isStringish(arg1)) return $fecbc4a33bb0f224$var$createActionDecoratorAnnotation($fecbc4a33bb0f224$var$createActionAnnotation(autoAction ? $fecbc4a33bb0f224$var$AUTOACTION : $fecbc4a33bb0f224$var$ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
const $fecbc4a33bb0f224$export$31eb53bd5b582a97 = /*#__PURE__*/ $fecbc4a33bb0f224$var$createActionFactory(false);
$fecbc4a33bb0f224$var$assign($fecbc4a33bb0f224$export$31eb53bd5b582a97, $fecbc4a33bb0f224$var$actionAnnotation);
const $fecbc4a33bb0f224$export$b8aa795084cbf86b = /*#__PURE__*/ $fecbc4a33bb0f224$var$createActionFactory(true);
$fecbc4a33bb0f224$var$assign($fecbc4a33bb0f224$export$b8aa795084cbf86b, $fecbc4a33bb0f224$var$autoActionAnnotation);
const $fecbc4a33bb0f224$export$3720eced4297d10c = /*#__PURE__*/ $fecbc4a33bb0f224$var$createActionDecoratorAnnotation($fecbc4a33bb0f224$var$actionBoundAnnotation);
const $fecbc4a33bb0f224$export$4dd0b06162f181e = /*#__PURE__*/ $fecbc4a33bb0f224$var$createActionDecoratorAnnotation($fecbc4a33bb0f224$var$autoActionBoundAnnotation);
function $fecbc4a33bb0f224$export$832370e58be26204(fn) {
    return $fecbc4a33bb0f224$var$executeAction(fn.name || $fecbc4a33bb0f224$var$DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function $fecbc4a33bb0f224$export$b956e38827fca970(thing) {
    return $fecbc4a33bb0f224$var$isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function $fecbc4a33bb0f224$export$4abd31caebb0bb24(view, opts = $fecbc4a33bb0f224$var$EMPTY_OBJECT) {
    var _opts$name, _opts$signal;
    const name = (_opts$name = opts == null ? void 0 : opts.name) != null ? _opts$name : "Autorun";
    const runSync = !opts.scheduler && !opts.delay;
    let reaction;
    if (runSync) // normal autorun
    reaction = new $fecbc4a33bb0f224$export$d2ae4167a30cf6bb(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        const scheduler = $fecbc4a33bb0f224$var$createSchedulerFromOptions(opts);
        // debounced autorun
        let isScheduled = false;
        reaction = new $fecbc4a33bb0f224$export$d2ae4167a30cf6bb(name, ()=>{
            if (!isScheduled) {
                isScheduled = true;
                scheduler(()=>{
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!(opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted)) reaction.schedule_();
    return reaction.getDisposer_(opts == null ? void 0 : opts.signal);
}
const $fecbc4a33bb0f224$var$run = (f)=>f();
function $fecbc4a33bb0f224$var$createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? (f)=>setTimeout(f, opts.delay) : $fecbc4a33bb0f224$var$run;
}
function $fecbc4a33bb0f224$export$7203b476385689ae(expression, effect, opts = $fecbc4a33bb0f224$var$EMPTY_OBJECT) {
    var _opts$name2, _opts$signal2;
    const name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    const effectAction = $fecbc4a33bb0f224$export$31eb53bd5b582a97(name, opts.onError ? $fecbc4a33bb0f224$var$wrapErrorHandler(opts.onError, effect) : effect);
    const runSync = !opts.scheduler && !opts.delay;
    const scheduler = $fecbc4a33bb0f224$var$createSchedulerFromOptions(opts);
    let firstTime = true;
    let isScheduled = false;
    let value;
    const equals = opts.equals || $fecbc4a33bb0f224$export$700812e5ccfdbb1d;
    const r = new $fecbc4a33bb0f224$export$d2ae4167a30cf6bb(name, ()=>{
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        let changed = false;
        const oldValue = value;
        r.track(()=>{
            const nextValue = $fecbc4a33bb0f224$export$e510c5d1ea4358b1(false, ()=>expression(r));
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!(opts != null && (_opts$signal2 = opts.signal) != null && _opts$signal2.aborted)) r.schedule_();
    return r.getDisposer_(opts == null ? void 0 : opts.signal);
}
function $fecbc4a33bb0f224$var$wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
const $fecbc4a33bb0f224$var$ON_BECOME_OBSERVED = "onBO";
const $fecbc4a33bb0f224$var$ON_BECOME_UNOBSERVED = "onBUO";
function $fecbc4a33bb0f224$export$24d7f9cdf0de2679(thing, arg2, arg3) {
    return $fecbc4a33bb0f224$var$interceptHook($fecbc4a33bb0f224$var$ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function $fecbc4a33bb0f224$export$f8586f6f22b9cba9(thing, arg2, arg3) {
    return $fecbc4a33bb0f224$var$interceptHook($fecbc4a33bb0f224$var$ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function $fecbc4a33bb0f224$var$interceptHook(hook, thing, arg2, arg3) {
    const atom = typeof arg3 === "function" ? $fecbc4a33bb0f224$export$25fc416d10fa1afa(thing, arg2) : $fecbc4a33bb0f224$export$25fc416d10fa1afa(thing);
    const cb = $fecbc4a33bb0f224$var$isFunction(arg3) ? arg3 : arg2;
    const listenersKey = `${hook}L`;
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        const hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners.delete(cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
const $fecbc4a33bb0f224$var$ALWAYS = "always";
const $fecbc4a33bb0f224$var$OBSERVED = "observed";
function $fecbc4a33bb0f224$export$8d21e34596265fa2(options) {
    if (options.isolateGlobalState === true) $fecbc4a33bb0f224$var$isolateGlobalState();
    const { enforceActions: enforceActions } = options;
    if (enforceActions !== undefined) {
        const ea = enforceActions === $fecbc4a33bb0f224$var$ALWAYS ? $fecbc4a33bb0f224$var$ALWAYS : enforceActions === $fecbc4a33bb0f224$var$OBSERVED;
        $fecbc4a33bb0f224$var$globalState.enforceActions = ea;
        $fecbc4a33bb0f224$var$globalState.allowStateChanges = ea === true || ea === $fecbc4a33bb0f224$var$ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach((key)=>{
        if (key in options) $fecbc4a33bb0f224$var$globalState[key] = !!options[key];
    });
    $fecbc4a33bb0f224$var$globalState.allowStateReads = !$fecbc4a33bb0f224$var$globalState.observableRequiresReaction;
    if (options.reactionScheduler) $fecbc4a33bb0f224$var$setReactionScheduler(options.reactionScheduler);
}
function $fecbc4a33bb0f224$export$59d8134e963031bd(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    const descriptors = $fecbc4a33bb0f224$var$getOwnPropertyDescriptors(properties);
    $fecbc4a33bb0f224$var$initObservable(()=>{
        const adm = $fecbc4a33bb0f224$var$asObservableObject(target, options)[$fecbc4a33bb0f224$export$f246528900dd4467];
        $fecbc4a33bb0f224$var$ownKeys(descriptors).forEach((key)=>{
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function $fecbc4a33bb0f224$export$23fbf90e5d80a5ee(thing, property) {
    return $fecbc4a33bb0f224$var$nodeToDependencyTree($fecbc4a33bb0f224$export$25fc416d10fa1afa(thing, property));
}
function $fecbc4a33bb0f224$var$nodeToDependencyTree(node) {
    const result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = $fecbc4a33bb0f224$var$unique(node.observing_).map($fecbc4a33bb0f224$var$nodeToDependencyTree);
    return result;
}
function $fecbc4a33bb0f224$export$3b1621dddf5aeacd(thing, property) {
    return $fecbc4a33bb0f224$var$nodeToObserverTree($fecbc4a33bb0f224$export$25fc416d10fa1afa(thing, property));
}
function $fecbc4a33bb0f224$var$nodeToObserverTree(node) {
    const result = {
        name: node.name_
    };
    if ($fecbc4a33bb0f224$var$hasObservers(node)) result.observers = Array.from($fecbc4a33bb0f224$var$getObservers(node), $fecbc4a33bb0f224$var$nodeToObserverTree);
    return result;
}
function $fecbc4a33bb0f224$var$unique(list) {
    return Array.from(new Set(list));
}
let $fecbc4a33bb0f224$var$generatorId = 0;
class $fecbc4a33bb0f224$export$134218f44485f691 extends Error {
    constructor(){
        super("FLOW_CANCELLED");
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = "FlowCancellationError";
    }
    toString() {
        return `Error: ${this.message}`;
    }
}
function $fecbc4a33bb0f224$export$e01c2a57c655302d(error) {
    return error instanceof $fecbc4a33bb0f224$export$134218f44485f691;
}
function $fecbc4a33bb0f224$var$createFlowDecoratorAnnotation(annotation) {
    return $fecbc4a33bb0f224$var$createDecoratorAnnotation(annotation, $fecbc4a33bb0f224$var$decorateFlow20223_);
}
const $fecbc4a33bb0f224$var$flowAnnotation = /*#__PURE__*/ $fecbc4a33bb0f224$var$createFlowAnnotation("flow");
const $fecbc4a33bb0f224$var$flowBoundAnnotation = /*#__PURE__*/ $fecbc4a33bb0f224$var$createFlowAnnotation("flow.bound", {
    bound: true
});
const $fecbc4a33bb0f224$export$ccc7b0636abaffc3 = /*#__PURE__*/ $fecbc4a33bb0f224$var$assign(function flow(arg1, arg2) {
    if (arg2 && typeof arg2.kind === "string") return $fecbc4a33bb0f224$var$decorateFlow20223_($fecbc4a33bb0f224$var$flowAnnotation, arg1, arg2);
    const generator = arg1;
    const name = generator.name || "flow";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    const res = function res() {
        const ctx = this;
        const args = arguments;
        const runId = 0;
        const gen = $fecbc4a33bb0f224$export$31eb53bd5b582a97(name, generator).apply(ctx, args);
        let rejector;
        let pendingPromise = undefined;
        const promise = new Promise(function(resolve, reject) {
            let stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                let ret;
                try {
                    ret = $fecbc4a33bb0f224$export$31eb53bd5b582a97(name, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                let ret;
                try {
                    ret = $fecbc4a33bb0f224$export$31eb53bd5b582a97(name, gen.throw).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if ($fecbc4a33bb0f224$var$isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        const cancelActionName = name;
        promise.cancel = $fecbc4a33bb0f224$export$31eb53bd5b582a97(cancelActionName, function() {
            try {
                if (pendingPromise) $fecbc4a33bb0f224$var$cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                const res = gen.return(undefined);
                // eat anything that promise would do, it's cancelled!
                const yieldedPromise = Promise.resolve(res.value);
                yieldedPromise.then($fecbc4a33bb0f224$var$noop, $fecbc4a33bb0f224$var$noop);
                $fecbc4a33bb0f224$var$cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new $fecbc4a33bb0f224$export$134218f44485f691());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, $fecbc4a33bb0f224$var$flowAnnotation);
const $fecbc4a33bb0f224$export$d41c06fa934cc67e = /*#__PURE__*/ $fecbc4a33bb0f224$var$createFlowDecoratorAnnotation($fecbc4a33bb0f224$var$flowBoundAnnotation);
function $fecbc4a33bb0f224$var$cancelPromise(promise) {
    if ($fecbc4a33bb0f224$var$isFunction(promise.cancel)) promise.cancel();
}
function $fecbc4a33bb0f224$export$b1b0dfc8def25964(result) {
    return result; // just tricking TypeScript :)
}
function $fecbc4a33bb0f224$export$8c23365ce94ba925(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function $fecbc4a33bb0f224$export$bf4da824ef9b40d0(thing, propOrHandler, handler) {
    let target;
    if ($fecbc4a33bb0f224$export$27a7faddcfd44960(thing) || $fecbc4a33bb0f224$export$f5afceff386badf9(thing) || $fecbc4a33bb0f224$export$fafbc00dbefd1aef(thing)) target = $fecbc4a33bb0f224$export$71ff639cb8b2a36e(thing);
    else if ($fecbc4a33bb0f224$export$31960fb081a18155(thing)) target = $fecbc4a33bb0f224$export$71ff639cb8b2a36e(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return ()=>{
        target.dehancer = undefined;
    };
}
function $fecbc4a33bb0f224$export$ab0f802c05dd969b(thing, propOrHandler, handler) {
    if ($fecbc4a33bb0f224$var$isFunction(handler)) return $fecbc4a33bb0f224$var$interceptProperty(thing, propOrHandler, handler);
    else return $fecbc4a33bb0f224$var$interceptInterceptable(thing, propOrHandler);
}
function $fecbc4a33bb0f224$var$interceptInterceptable(thing, handler) {
    return $fecbc4a33bb0f224$var$registerInterceptor($fecbc4a33bb0f224$export$71ff639cb8b2a36e(thing), handler);
}
function $fecbc4a33bb0f224$var$interceptProperty(thing, property, handler) {
    return $fecbc4a33bb0f224$var$registerInterceptor($fecbc4a33bb0f224$export$71ff639cb8b2a36e(thing, property), handler);
}
function $fecbc4a33bb0f224$var$_isComputed(value, property) {
    var _adm$lazyComputedKeys;
    if (property === undefined) return $fecbc4a33bb0f224$var$isComputedValue(value);
    if ($fecbc4a33bb0f224$export$31960fb081a18155(value) === false) return false;
    const adm = value[$fecbc4a33bb0f224$export$f246528900dd4467];
    if ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) return true;
    if (!adm.values_.has(property)) return false;
    const atom = $fecbc4a33bb0f224$export$25fc416d10fa1afa(value, property);
    return $fecbc4a33bb0f224$var$isComputedValue(atom);
}
function $fecbc4a33bb0f224$export$21bb8b7af2417cc3(value) {
    return $fecbc4a33bb0f224$var$_isComputed(value);
}
function $fecbc4a33bb0f224$export$3cf701ab9f66d86a(value, propName) {
    return $fecbc4a33bb0f224$var$_isComputed(value, propName);
}
function $fecbc4a33bb0f224$var$_isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if ($fecbc4a33bb0f224$export$31960fb081a18155(value)) {
            var _adm$lazyComputedKeys, _adm$lazyObservableKe;
            const adm = value[$fecbc4a33bb0f224$export$f246528900dd4467];
            return adm.values_.has(property) || !!((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) || !!((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null && _adm$lazyObservableKe.has(property));
        }
        return false;
    }
    // For first check, see #701
    return $fecbc4a33bb0f224$export$31960fb081a18155(value) || !!value[$fecbc4a33bb0f224$export$f246528900dd4467] || $fecbc4a33bb0f224$var$isAtom(value) || $fecbc4a33bb0f224$var$isReaction(value) || $fecbc4a33bb0f224$var$isComputedValue(value);
}
function $fecbc4a33bb0f224$export$5cd057a6046189f9(value) {
    return $fecbc4a33bb0f224$var$_isObservable(value);
}
function $fecbc4a33bb0f224$export$7ad7acc949ba3cc7(value, propName) {
    return $fecbc4a33bb0f224$var$_isObservable(value, propName);
}
function $fecbc4a33bb0f224$export$ed97f33186d4b816(obj) {
    if ($fecbc4a33bb0f224$export$31960fb081a18155(obj)) return obj[$fecbc4a33bb0f224$export$f246528900dd4467].keys_();
    if ($fecbc4a33bb0f224$export$27a7faddcfd44960(obj) || $fecbc4a33bb0f224$export$da6b063694cb52c1(obj)) return Array.from(obj.keys());
    if ($fecbc4a33bb0f224$export$f5afceff386badf9(obj)) return obj.map((_, index)=>index);
    $fecbc4a33bb0f224$var$die(5);
}
function $fecbc4a33bb0f224$export$68c286be0e7e55b7(obj) {
    if ($fecbc4a33bb0f224$export$31960fb081a18155(obj)) return $fecbc4a33bb0f224$export$ed97f33186d4b816(obj).map((key)=>obj[key]);
    if ($fecbc4a33bb0f224$export$27a7faddcfd44960(obj)) return $fecbc4a33bb0f224$export$ed97f33186d4b816(obj).map((key)=>obj.get(key));
    if ($fecbc4a33bb0f224$export$da6b063694cb52c1(obj)) return Array.from(obj.values());
    if ($fecbc4a33bb0f224$export$f5afceff386badf9(obj)) return obj.slice();
    $fecbc4a33bb0f224$var$die(6);
}
function $fecbc4a33bb0f224$export$3e9f948b41964866(obj) {
    if ($fecbc4a33bb0f224$export$31960fb081a18155(obj)) return $fecbc4a33bb0f224$export$ed97f33186d4b816(obj).map((key)=>[
            key,
            obj[key]
        ]);
    if ($fecbc4a33bb0f224$export$27a7faddcfd44960(obj)) return $fecbc4a33bb0f224$export$ed97f33186d4b816(obj).map((key)=>[
            key,
            obj.get(key)
        ]);
    if ($fecbc4a33bb0f224$export$da6b063694cb52c1(obj)) return Array.from(obj.entries());
    if ($fecbc4a33bb0f224$export$f5afceff386badf9(obj)) return obj.map((key, index)=>[
            index,
            key
        ]);
    $fecbc4a33bb0f224$var$die(7);
}
function $fecbc4a33bb0f224$export$adaa4cf7ef1b65be(obj, key, value) {
    if (arguments.length === 2 && !$fecbc4a33bb0f224$export$da6b063694cb52c1(obj)) {
        $fecbc4a33bb0f224$var$startBatch();
        const values = key;
        try {
            for(let _key in values)$fecbc4a33bb0f224$export$adaa4cf7ef1b65be(obj, _key, values[_key]);
        } finally{
            $fecbc4a33bb0f224$var$endBatch();
        }
        return;
    }
    if ($fecbc4a33bb0f224$export$31960fb081a18155(obj)) obj[$fecbc4a33bb0f224$export$f246528900dd4467].set_(key, value);
    else if ($fecbc4a33bb0f224$export$27a7faddcfd44960(obj)) obj.set(key, value);
    else if ($fecbc4a33bb0f224$export$da6b063694cb52c1(obj)) obj.add(key);
    else if ($fecbc4a33bb0f224$export$f5afceff386badf9(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) $fecbc4a33bb0f224$var$die(42, key);
        $fecbc4a33bb0f224$var$startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        $fecbc4a33bb0f224$var$endBatch();
    } else $fecbc4a33bb0f224$var$die(8);
}
function $fecbc4a33bb0f224$export$cd7f480d6b8286c3(obj, key) {
    if ($fecbc4a33bb0f224$export$31960fb081a18155(obj)) obj[$fecbc4a33bb0f224$export$f246528900dd4467].delete_(key);
    else if ($fecbc4a33bb0f224$export$27a7faddcfd44960(obj)) obj.delete(key);
    else if ($fecbc4a33bb0f224$export$da6b063694cb52c1(obj)) obj.delete(key);
    else if ($fecbc4a33bb0f224$export$f5afceff386badf9(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else $fecbc4a33bb0f224$var$die(9);
}
function $fecbc4a33bb0f224$export$a4f4bb6b1453fff5(obj, key) {
    if ($fecbc4a33bb0f224$export$31960fb081a18155(obj)) return obj[$fecbc4a33bb0f224$export$f246528900dd4467].has_(key);
    else if ($fecbc4a33bb0f224$export$27a7faddcfd44960(obj)) return obj.has(key);
    else if ($fecbc4a33bb0f224$export$da6b063694cb52c1(obj)) return obj.has(key);
    else if ($fecbc4a33bb0f224$export$f5afceff386badf9(obj)) return key >= 0 && key < obj.length;
    $fecbc4a33bb0f224$var$die(10);
}
function $fecbc4a33bb0f224$export$3988ae62b71be9a3(obj, key) {
    if (!$fecbc4a33bb0f224$export$a4f4bb6b1453fff5(obj, key)) return undefined;
    if ($fecbc4a33bb0f224$export$31960fb081a18155(obj)) return obj[$fecbc4a33bb0f224$export$f246528900dd4467].get_(key);
    else if ($fecbc4a33bb0f224$export$27a7faddcfd44960(obj)) return obj.get(key);
    else if ($fecbc4a33bb0f224$export$f5afceff386badf9(obj)) return obj[key];
    $fecbc4a33bb0f224$var$die(11);
}
function $fecbc4a33bb0f224$export$fdab3c20aae16ddf(obj, key, descriptor) {
    if ($fecbc4a33bb0f224$export$31960fb081a18155(obj)) return obj[$fecbc4a33bb0f224$export$f246528900dd4467].defineProperty_(key, descriptor);
    $fecbc4a33bb0f224$var$die(39);
}
function $fecbc4a33bb0f224$export$6aa2094d45f88f20(obj) {
    if ($fecbc4a33bb0f224$export$31960fb081a18155(obj)) return obj[$fecbc4a33bb0f224$export$f246528900dd4467].ownKeys_();
    $fecbc4a33bb0f224$var$die(38);
}
function $fecbc4a33bb0f224$export$d1203567a167490e(thing, propOrCb, cbOrFire, fireImmediately) {
    if ($fecbc4a33bb0f224$var$isFunction(cbOrFire)) return $fecbc4a33bb0f224$var$observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return $fecbc4a33bb0f224$var$observeObservable(thing, propOrCb, cbOrFire);
}
function $fecbc4a33bb0f224$var$observeObservable(thing, listener, fireImmediately) {
    const adm = $fecbc4a33bb0f224$export$71ff639cb8b2a36e(thing);
    if ($fecbc4a33bb0f224$export$f5afceff386badf9(thing)) {
        if (fireImmediately) listener({
            observableKind: "array",
            object: adm.proxy_,
            debugObjectName: adm.atom_.name_,
            type: "splice",
            index: 0,
            added: adm.values_.slice(),
            addedCount: adm.values_.length,
            removed: [],
            removedCount: 0
        });
    } else if ($fecbc4a33bb0f224$export$27a7faddcfd44960(thing)) ;
    else if ($fecbc4a33bb0f224$export$da6b063694cb52c1(thing)) ;
    else if ($fecbc4a33bb0f224$export$31960fb081a18155(thing)) ;
    else return $fecbc4a33bb0f224$var$observeValue(adm, listener, fireImmediately);
    return $fecbc4a33bb0f224$var$registerListener(adm, listener);
}
function $fecbc4a33bb0f224$var$observeObservableProperty(thing, property, listener, fireImmediately) {
    return $fecbc4a33bb0f224$var$observeValue($fecbc4a33bb0f224$export$71ff639cb8b2a36e(thing, property), listener, fireImmediately);
}
function $fecbc4a33bb0f224$var$observeValue(adm, listener, fireImmediately) {
    if ($fecbc4a33bb0f224$var$isComputedValue(adm)) {
        let firstTime = true;
        let prevValue = undefined;
        return $fecbc4a33bb0f224$export$4abd31caebb0bb24(()=>{
            const newValue = adm.get();
            if (!firstTime || fireImmediately) {
                const prevU = $fecbc4a33bb0f224$var$untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: adm.name_,
                    type: $fecbc4a33bb0f224$var$UPDATE,
                    object: adm,
                    newValue: newValue,
                    oldValue: prevValue
                });
                $fecbc4a33bb0f224$var$untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    }
    if (fireImmediately) listener({
        observableKind: "value",
        debugObjectName: adm.name_,
        object: adm,
        type: $fecbc4a33bb0f224$var$UPDATE,
        newValue: adm.value_,
        oldValue: undefined
    });
    return $fecbc4a33bb0f224$var$registerListener(adm, listener);
}
function $fecbc4a33bb0f224$var$cache(map, key, value) {
    map.set(key, value);
    return value;
}
function $fecbc4a33bb0f224$var$toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !$fecbc4a33bb0f224$export$5cd057a6046189f9(source)) return source;
    if ($fecbc4a33bb0f224$export$fafbc00dbefd1aef(source) || $fecbc4a33bb0f224$var$isComputedValue(source)) return $fecbc4a33bb0f224$var$toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if ($fecbc4a33bb0f224$export$f5afceff386badf9(source)) {
        const res = $fecbc4a33bb0f224$var$cache(__alreadySeen, source, new Array(source.length));
        source.forEach((value, idx)=>{
            res[idx] = $fecbc4a33bb0f224$var$toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if ($fecbc4a33bb0f224$export$da6b063694cb52c1(source)) {
        const res = $fecbc4a33bb0f224$var$cache(__alreadySeen, source, new Set());
        source.forEach((value)=>{
            res.add($fecbc4a33bb0f224$var$toJSHelper(value, __alreadySeen));
        });
        return res;
    }
    if ($fecbc4a33bb0f224$export$27a7faddcfd44960(source)) {
        const res = $fecbc4a33bb0f224$var$cache(__alreadySeen, source, new Map());
        source.forEach((value, key)=>{
            res.set(key, $fecbc4a33bb0f224$var$toJSHelper(value, __alreadySeen));
        });
        return res;
    } else {
        // must be observable object
        const res = $fecbc4a33bb0f224$var$cache(__alreadySeen, source, {});
        $fecbc4a33bb0f224$export$6aa2094d45f88f20(source).forEach((key)=>{
            if ($fecbc4a33bb0f224$var$objectPrototype.propertyIsEnumerable.call(source, key)) res[key] = $fecbc4a33bb0f224$var$toJSHelper(source[key], __alreadySeen);
        });
        return res;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function $fecbc4a33bb0f224$export$f08965dd1304d490(source, options) {
    return $fecbc4a33bb0f224$var$toJSHelper(source, new Map());
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function $fecbc4a33bb0f224$export$2d62d2646dd2fb3c(action, thisArg) {
    $fecbc4a33bb0f224$var$startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        $fecbc4a33bb0f224$var$endBatch();
    }
}
function $fecbc4a33bb0f224$export$a55877ca9db47377(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return $fecbc4a33bb0f224$var$whenPromise(predicate, arg1);
    return $fecbc4a33bb0f224$var$_when(predicate, arg1, arg2 || {});
}
function $fecbc4a33bb0f224$var$_when(predicate, effect, opts) {
    let timeoutHandle;
    if (typeof opts.timeout === "number") {
        const error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(()=>{
            if (!disposer[$fecbc4a33bb0f224$export$f246528900dd4467].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    const effectAction = $fecbc4a33bb0f224$var$createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = $fecbc4a33bb0f224$export$4abd31caebb0bb24((r)=>{
        // predicate should not change state
        let cond = $fecbc4a33bb0f224$export$e510c5d1ea4358b1(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function $fecbc4a33bb0f224$var$whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return $fecbc4a33bb0f224$var$assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: ()=>null
    });
    let cancel;
    let abort;
    const res = new Promise((resolve, reject)=>{
        var _opts$signal2;
        let disposer = $fecbc4a33bb0f224$var$_when(predicate, resolve, $fecbc4a33bb0f224$var$assign({}, opts, {
            onError: reject
        }));
        cancel = ()=>{
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = ()=>{
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    }).finally(()=>{
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function $fecbc4a33bb0f224$var$getAdm(target) {
    return target[$fecbc4a33bb0f224$export$f246528900dd4467];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
const $fecbc4a33bb0f224$var$objectProxyTraps = {
    has (target, name) {
        return $fecbc4a33bb0f224$var$getAdm(target).has_(name);
    },
    get (target, name) {
        return $fecbc4a33bb0f224$var$getAdm(target).get_(name);
    },
    set (target, name, value) {
        var _getAdm$set_;
        if (!$fecbc4a33bb0f224$var$isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = $fecbc4a33bb0f224$var$getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty (target, name) {
        var _getAdm$delete_;
        if (!$fecbc4a33bb0f224$var$isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = $fecbc4a33bb0f224$var$getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty (target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = $fecbc4a33bb0f224$var$getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys (target) {
        return $fecbc4a33bb0f224$var$getAdm(target).ownKeys_();
    },
    preventExtensions (target) {
        $fecbc4a33bb0f224$var$die(13);
    }
};
function $fecbc4a33bb0f224$var$asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    target = $fecbc4a33bb0f224$var$asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$fecbc4a33bb0f224$export$f246528900dd4467]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, $fecbc4a33bb0f224$var$objectProxyTraps);
}
function $fecbc4a33bb0f224$var$hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function $fecbc4a33bb0f224$var$registerInterceptor(interceptable, handler) {
    const interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return $fecbc4a33bb0f224$var$once(()=>{
        const idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function $fecbc4a33bb0f224$var$interceptChange(interceptable, change) {
    const prevU = $fecbc4a33bb0f224$var$untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        const interceptors = [
            ...interceptable.interceptors_ || []
        ];
        for(let i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) $fecbc4a33bb0f224$var$die(14);
            if (!change) break;
        }
        return change;
    } finally{
        $fecbc4a33bb0f224$var$untrackedEnd(prevU);
    }
}
function $fecbc4a33bb0f224$var$hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function $fecbc4a33bb0f224$var$registerListener(listenable, handler) {
    const listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return $fecbc4a33bb0f224$var$once(()=>{
        const idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function $fecbc4a33bb0f224$var$notifyListeners(listenable, change) {
    const prevU = $fecbc4a33bb0f224$var$untrackedStart();
    let listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(let i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    $fecbc4a33bb0f224$var$untrackedEnd(prevU);
}
function $fecbc4a33bb0f224$export$885e6ca7a4dc4b3e(target, annotations, options) {
    $fecbc4a33bb0f224$var$initObservable(()=>{
        const adm = $fecbc4a33bb0f224$var$asObservableObject(target, options)[$fecbc4a33bb0f224$export$f246528900dd4467];
        // Annotate
        $fecbc4a33bb0f224$var$ownKeys(annotations).forEach((key)=>$fecbc4a33bb0f224$var$make_(adm, key, annotations[key]));
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
const $fecbc4a33bb0f224$var$keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function $fecbc4a33bb0f224$export$1cfaca5abb185fe7(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if ($fecbc4a33bb0f224$var$isPlainObject(target)) return $fecbc4a33bb0f224$export$59d8134e963031bd(target, target, overrides, options);
    $fecbc4a33bb0f224$var$initObservable(()=>{
        const adm = $fecbc4a33bb0f224$var$asObservableObject(target, options)[$fecbc4a33bb0f224$export$f246528900dd4467];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[$fecbc4a33bb0f224$var$keysSymbol]) {
            const proto = Object.getPrototypeOf(target);
            const keys = new Set([
                ...$fecbc4a33bb0f224$var$ownKeys(target),
                ...$fecbc4a33bb0f224$var$ownKeys(proto)
            ]);
            keys.delete("constructor");
            keys.delete($fecbc4a33bb0f224$export$f246528900dd4467);
            $fecbc4a33bb0f224$var$addHiddenProp(proto, $fecbc4a33bb0f224$var$keysSymbol, keys);
        }
        target[$fecbc4a33bb0f224$var$keysSymbol].forEach((key)=>$fecbc4a33bb0f224$var$make_(adm, key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true));
    });
    return target;
}
function $fecbc4a33bb0f224$var$make_(adm, key, annotation) {
    if (annotation === true) annotation = adm.defaultAnnotation_;
    if (annotation === false) return;
    $fecbc4a33bb0f224$var$assertAnnotable(adm, annotation, key);
    if (!(key in adm.target_)) $fecbc4a33bb0f224$var$die(1, annotation.annotationType_, `${adm.name_}.${key.toString()}`);
    let source = adm.target_;
    while(source && source !== $fecbc4a33bb0f224$var$objectPrototype){
        const descriptor = $fecbc4a33bb0f224$var$getDescriptor(source, key);
        if (descriptor) {
            const outcome = annotation.make_(adm, key, descriptor, source);
            if (outcome === 0 /* MakeResult.Cancel */ ) return;
            if (outcome === 1 /* MakeResult.Break */ ) break;
        }
        source = Object.getPrototypeOf(source);
    }
    $fecbc4a33bb0f224$var$recordAnnotationApplied(adm, annotation, key);
}
const $fecbc4a33bb0f224$var$SPLICE = "splice";
const $fecbc4a33bb0f224$var$UPDATE = "update";
const $fecbc4a33bb0f224$var$MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
const $fecbc4a33bb0f224$var$arrayTraps = {
    get (target, name) {
        const adm = target[$fecbc4a33bb0f224$export$f246528900dd4467];
        if (name === $fecbc4a33bb0f224$export$f246528900dd4467) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if ($fecbc4a33bb0f224$var$hasProp($fecbc4a33bb0f224$var$arrayExtensions, name)) return $fecbc4a33bb0f224$var$arrayExtensions[name];
        return target[name];
    },
    set (target, name, value) {
        const adm = target[$fecbc4a33bb0f224$export$f246528900dd4467];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions () {
        $fecbc4a33bb0f224$var$die(15);
    }
};
class $fecbc4a33bb0f224$var$ObservableArrayAdministration {
    constructor(name = "ObservableArray", enhancer, owned_){
        this.owned_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.atom_ = new $fecbc4a33bb0f224$var$Atom(name);
        this.enhancer_ = (newV, oldV)=>enhancer(newV, oldV, "ObservableArray[..]");
    }
    dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    }
    dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    }
    getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    }
    setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) $fecbc4a33bb0f224$var$die(40, newLength);
        let currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            const newItems = Array.from({
                length: newLength - currentLength
            });
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    }
    updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) $fecbc4a33bb0f224$var$die(16);
        this.lastKnownLength_ += delta;
    }
    spliceWithArray_(index, deleteCount, newItems) {
        $fecbc4a33bb0f224$var$checkIfStateModificationsAreAllowed(this.atom_);
        const length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = $fecbc4a33bb0f224$var$EMPTY_ARRAY;
        if ($fecbc4a33bb0f224$var$hasInterceptors(this)) {
            const change = $fecbc4a33bb0f224$var$interceptChange(this, {
                object: this.proxy_,
                type: $fecbc4a33bb0f224$var$SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return $fecbc4a33bb0f224$var$EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map((v)=>this.enhancer_(v, undefined));
        const res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    }
    spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < $fecbc4a33bb0f224$var$MAX_SPLICE_SIZE) return this.values_.splice(index, deleteCount, ...newItems);
        else {
            // The items removed by the splice
            const res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            let oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(let i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(let i = 0; i < oldItems.length; i++)this.values_[index + newItems.length + i] = oldItems[i];
            return res;
        }
    }
    notifyArrayChildUpdate_(index, newValue, oldValue) {
        const notifySpy = false;
        const notify = $fecbc4a33bb0f224$var$hasListeners(this);
        const change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: $fecbc4a33bb0f224$var$UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) $fecbc4a33bb0f224$var$notifyListeners(this, change);
    }
    notifyArraySplice_(index, added, removed) {
        const notifySpy = false;
        const notify = $fecbc4a33bb0f224$var$hasListeners(this);
        const change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: $fecbc4a33bb0f224$var$SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) $fecbc4a33bb0f224$var$notifyListeners(this, change);
    }
    get_(index) {
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    }
    set_(index, newValue) {
        const values = this.values_;
        if (index < values.length) {
            // update at index in range
            $fecbc4a33bb0f224$var$checkIfStateModificationsAreAllowed(this.atom_);
            const oldValue = values[index];
            if ($fecbc4a33bb0f224$var$hasInterceptors(this)) {
                const change = $fecbc4a33bb0f224$var$interceptChange(this, {
                    type: $fecbc4a33bb0f224$var$UPDATE,
                    object: this.proxy_,
                    index: // since "this" is the real array we need to pass its proxy
                    index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            const changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            const newItems = Array.from({
                length: index + 1 - values.length
            });
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    }
}
function $fecbc4a33bb0f224$var$createObservableArray(initialValues, enhancer, name = "ObservableArray", owned = false) {
    return $fecbc4a33bb0f224$var$initObservable(()=>{
        const adm = new $fecbc4a33bb0f224$var$ObservableArrayAdministration(name, enhancer, owned);
        $fecbc4a33bb0f224$var$addHiddenFinalProp(adm.values_, $fecbc4a33bb0f224$export$f246528900dd4467, adm);
        const proxy = new Proxy(adm.values_, $fecbc4a33bb0f224$var$arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var $fecbc4a33bb0f224$var$arrayExtensions = {
    clear () {
        return this.splice(0);
    },
    replace (newItems) {
        const adm = this[$fecbc4a33bb0f224$export$f246528900dd4467];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON () {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice (index, deleteCount, ...newItems) {
        const adm = this[$fecbc4a33bb0f224$export$f246528900dd4467];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray (index, deleteCount, newItems) {
        return this[$fecbc4a33bb0f224$export$f246528900dd4467].spliceWithArray_(index, deleteCount, newItems);
    },
    push (...items) {
        const adm = this[$fecbc4a33bb0f224$export$f246528900dd4467];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop () {
        return this.splice(Math.max(this[$fecbc4a33bb0f224$export$f246528900dd4467].values_.length - 1, 0), 1)[0];
    },
    shift () {
        return this.splice(0, 1)[0];
    },
    unshift (...items) {
        const adm = this[$fecbc4a33bb0f224$export$f246528900dd4467];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if ($fecbc4a33bb0f224$var$globalState.trackingDerivation) $fecbc4a33bb0f224$var$die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort () {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if ($fecbc4a33bb0f224$var$globalState.trackingDerivation) $fecbc4a33bb0f224$var$die(37, "sort");
        const copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove (value) {
        const adm = this[$fecbc4a33bb0f224$export$f246528900dd4467];
        const idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ $fecbc4a33bb0f224$var$addArrayExtension("at", $fecbc4a33bb0f224$var$simpleFunc);
$fecbc4a33bb0f224$var$addArrayExtension("concat", $fecbc4a33bb0f224$var$simpleFunc);
$fecbc4a33bb0f224$var$addArrayExtension("flat", $fecbc4a33bb0f224$var$simpleFunc);
$fecbc4a33bb0f224$var$addArrayExtension("includes", $fecbc4a33bb0f224$var$simpleFunc);
$fecbc4a33bb0f224$var$addArrayExtension("indexOf", $fecbc4a33bb0f224$var$simpleFunc);
$fecbc4a33bb0f224$var$addArrayExtension("join", $fecbc4a33bb0f224$var$simpleFunc);
$fecbc4a33bb0f224$var$addArrayExtension("lastIndexOf", $fecbc4a33bb0f224$var$simpleFunc);
$fecbc4a33bb0f224$var$addArrayExtension("slice", $fecbc4a33bb0f224$var$simpleFunc);
$fecbc4a33bb0f224$var$addArrayExtension("toString", $fecbc4a33bb0f224$var$simpleFunc);
$fecbc4a33bb0f224$var$addArrayExtension("toLocaleString", $fecbc4a33bb0f224$var$simpleFunc);
$fecbc4a33bb0f224$var$addArrayExtension("toSorted", $fecbc4a33bb0f224$var$simpleFunc);
$fecbc4a33bb0f224$var$addArrayExtension("toSpliced", $fecbc4a33bb0f224$var$simpleFunc);
$fecbc4a33bb0f224$var$addArrayExtension("with", $fecbc4a33bb0f224$var$simpleFunc);
// map
$fecbc4a33bb0f224$var$addArrayExtension("every", $fecbc4a33bb0f224$var$mapLikeFunc);
$fecbc4a33bb0f224$var$addArrayExtension("filter", $fecbc4a33bb0f224$var$mapLikeFunc);
$fecbc4a33bb0f224$var$addArrayExtension("find", $fecbc4a33bb0f224$var$mapLikeFunc);
$fecbc4a33bb0f224$var$addArrayExtension("findIndex", $fecbc4a33bb0f224$var$mapLikeFunc);
$fecbc4a33bb0f224$var$addArrayExtension("findLast", $fecbc4a33bb0f224$var$mapLikeFunc);
$fecbc4a33bb0f224$var$addArrayExtension("findLastIndex", $fecbc4a33bb0f224$var$mapLikeFunc);
$fecbc4a33bb0f224$var$addArrayExtension("flatMap", $fecbc4a33bb0f224$var$mapLikeFunc);
$fecbc4a33bb0f224$var$addArrayExtension("forEach", $fecbc4a33bb0f224$var$mapLikeFunc);
$fecbc4a33bb0f224$var$addArrayExtension("map", $fecbc4a33bb0f224$var$mapLikeFunc);
$fecbc4a33bb0f224$var$addArrayExtension("some", $fecbc4a33bb0f224$var$mapLikeFunc);
$fecbc4a33bb0f224$var$addArrayExtension("toReversed", $fecbc4a33bb0f224$var$mapLikeFunc);
// reduce
$fecbc4a33bb0f224$var$addArrayExtension("reduce", $fecbc4a33bb0f224$var$reduceLikeFunc);
$fecbc4a33bb0f224$var$addArrayExtension("reduceRight", $fecbc4a33bb0f224$var$reduceLikeFunc);
function $fecbc4a33bb0f224$var$addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") $fecbc4a33bb0f224$var$arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function $fecbc4a33bb0f224$var$simpleFunc(funcName) {
    return function() {
        const adm = this[$fecbc4a33bb0f224$export$f246528900dd4467];
        adm.atom_.reportObserved();
        const dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function $fecbc4a33bb0f224$var$mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        const adm = this[$fecbc4a33bb0f224$export$f246528900dd4467];
        adm.atom_.reportObserved();
        const dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName]((element, index)=>{
            return callback.call(thisArg, element, index, this);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function $fecbc4a33bb0f224$var$reduceLikeFunc(funcName) {
    return function() {
        const adm = this[$fecbc4a33bb0f224$export$f246528900dd4467];
        adm.atom_.reportObserved();
        const dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        const callback = arguments[0];
        arguments[0] = (accumulator, currentValue, index)=>{
            return callback(accumulator, currentValue, index, this);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
const $fecbc4a33bb0f224$var$isObservableArrayAdministration = /*#__PURE__*/ $fecbc4a33bb0f224$var$createInstanceofPredicate("ObservableArrayAdministration", $fecbc4a33bb0f224$var$ObservableArrayAdministration);
function $fecbc4a33bb0f224$export$f5afceff386badf9(thing) {
    return $fecbc4a33bb0f224$var$isObject(thing) && $fecbc4a33bb0f224$var$isObservableArrayAdministration(thing[$fecbc4a33bb0f224$export$f246528900dd4467]);
}
const $fecbc4a33bb0f224$var$ObservableMapMarker = {};
const $fecbc4a33bb0f224$var$ADD = "add";
const $fecbc4a33bb0f224$var$DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
class $fecbc4a33bb0f224$export$db1c0901f08fc6fd {
    constructor(initialData, enhancer_ = $fecbc4a33bb0f224$var$deepEnhancer, name_ = "ObservableMap"){
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$fecbc4a33bb0f224$export$f246528900dd4467] = $fecbc4a33bb0f224$var$ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        $fecbc4a33bb0f224$var$initObservable(()=>{
            this.keysAtom_ = $fecbc4a33bb0f224$export$2e17fe64ec9a826e("ObservableMap.keys()");
            this.data_ = new Map();
            this.hasMap_ = new Map();
            if (initialData) this.merge(initialData);
        });
    }
    has_(key) {
        return this.data_.has(key);
    }
    has(key) {
        if (!$fecbc4a33bb0f224$var$globalState.trackingDerivation) return this.has_(key);
        let entry = this.hasMap_.get(key);
        if (!entry) {
            const newEntry = entry = new $fecbc4a33bb0f224$var$ObservableValue(this.has_(key), $fecbc4a33bb0f224$var$referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            newEntry.onBUOL = new Set([
                ()=>this.hasMap_.delete(key)
            ]);
        }
        return entry.get();
    }
    set(key, value) {
        const hasKey = this.has_(key);
        if ($fecbc4a33bb0f224$var$hasInterceptors(this)) {
            const change = $fecbc4a33bb0f224$var$interceptChange(this, {
                type: hasKey ? $fecbc4a33bb0f224$var$UPDATE : $fecbc4a33bb0f224$var$ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    }
    delete(key) {
        $fecbc4a33bb0f224$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        if ($fecbc4a33bb0f224$var$hasInterceptors(this)) {
            const change = $fecbc4a33bb0f224$var$interceptChange(this, {
                type: $fecbc4a33bb0f224$var$DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            const notifySpy = false;
            const notify = $fecbc4a33bb0f224$var$hasListeners(this);
            const change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: $fecbc4a33bb0f224$var$DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            $fecbc4a33bb0f224$export$2d62d2646dd2fb3c(()=>{
                var _this$hasMap_$get;
                this.keysAtom_.reportChanged();
                (_this$hasMap_$get = this.hasMap_.get(key)) == null || _this$hasMap_$get.setNewValue_(false);
                const observable = this.data_.get(key);
                observable.setNewValue_(undefined);
                this.data_.delete(key);
            });
            if (notify) $fecbc4a33bb0f224$var$notifyListeners(this, change);
            return true;
        }
        return false;
    }
    updateValue_(key, newValue) {
        const observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== $fecbc4a33bb0f224$var$globalState.UNCHANGED) {
            const notifySpy = false;
            const notify = $fecbc4a33bb0f224$var$hasListeners(this);
            const change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: $fecbc4a33bb0f224$var$UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) $fecbc4a33bb0f224$var$notifyListeners(this, change);
        }
    }
    addValue_(key, newValue) {
        $fecbc4a33bb0f224$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        $fecbc4a33bb0f224$export$2d62d2646dd2fb3c(()=>{
            var _this$hasMap_$get2;
            const observable = new $fecbc4a33bb0f224$var$ObservableValue(newValue, this.enhancer_, "ObservableMap.key", false);
            this.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this$hasMap_$get2 = this.hasMap_.get(key)) == null || _this$hasMap_$get2.setNewValue_(true);
            this.keysAtom_.reportChanged();
        });
        const notifySpy = false;
        const notify = $fecbc4a33bb0f224$var$hasListeners(this);
        const change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: $fecbc4a33bb0f224$var$ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) $fecbc4a33bb0f224$var$notifyListeners(this, change);
    }
    get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    }
    getOrInsert(key, value) {
        if (!this.has(key)) this.set(key, value);
        return this.get(key);
    }
    getOrInsertComputed(key, callback) {
        if (!this.has(key)) this.set(key, callback(key));
        return this.get(key);
    }
    dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    }
    keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    }
    values() {
        const self = this;
        const keys = this.keys();
        return $fecbc4a33bb0f224$var$makeIterableForMap({
            next () {
                const { done: done, value: value } = keys.next();
                return {
                    done: done,
                    value: done ? undefined : self.get(value)
                };
            }
        });
    }
    entries() {
        const self = this;
        const keys = this.keys();
        return $fecbc4a33bb0f224$var$makeIterableForMap({
            next () {
                const { done: done, value: value } = keys.next();
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self.get(value)
                    ]
                };
            }
        });
    }
    [Symbol.iterator]() {
        return this.entries();
    }
    forEach(callback, thisArg) {
        for (const [key, value] of this)callback.call(thisArg, value, key, this);
    }
    /** Merge another object into this object, returns this. */ merge(other) {
        if ($fecbc4a33bb0f224$export$27a7faddcfd44960(other)) other = new Map(other);
        $fecbc4a33bb0f224$export$2d62d2646dd2fb3c(()=>{
            if ($fecbc4a33bb0f224$var$isPlainObject(other)) $fecbc4a33bb0f224$var$getPlainObjectKeys(other).forEach((key)=>this.set(key, other[key]));
            else if (Array.isArray(other)) other.forEach(([key, value])=>this.set(key, value));
            else if ($fecbc4a33bb0f224$var$isES6Map(other)) {
                if (!$fecbc4a33bb0f224$var$isPlainES6Map(other)) $fecbc4a33bb0f224$var$die(19, other);
                other.forEach((value, key)=>this.set(key, value));
            } else if (other !== null && other !== undefined) $fecbc4a33bb0f224$var$die(20, other);
        });
        return this;
    }
    clear() {
        $fecbc4a33bb0f224$export$2d62d2646dd2fb3c(()=>{
            $fecbc4a33bb0f224$export$8c437e4d572e2f99(()=>{
                for (const key of this.keys())this.delete(key);
            });
        });
    }
    replace(values) {
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        $fecbc4a33bb0f224$export$2d62d2646dd2fb3c(()=>{
            // Convert to map so we can do quick key lookups
            const replacementMap = $fecbc4a33bb0f224$var$convertToMap(values);
            const orderedData = new Map();
            // Used for optimization
            let keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for (const key of this.data_.keys())// Concurrently iterating/deleting keys
            // iterator should handle this correctly
            if (!replacementMap.has(key)) {
                const deleted = this.delete(key);
                // Was the key removed?
                if (deleted) // _keysAtom.reportChanged() was already called
                keysReportChangedCalled = true;
                else {
                    // Delete prevented by interceptor
                    const value = this.data_.get(key);
                    orderedData.set(key, value);
                }
            }
            // Merge entries
            for (const [key, value] of replacementMap.entries()){
                // We will want to know whether a new key is added
                const keyExisted = this.data_.has(key);
                // Add or update value
                this.set(key, value);
                // The addition could have been prevent by interceptor
                if (this.data_.has(key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    const _value = this.data_.get(key);
                    orderedData.set(key, _value);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (this.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                this.keysAtom_.reportChanged();
                else {
                    const iter1 = this.data_.keys();
                    const iter2 = orderedData.keys();
                    let next1 = iter1.next();
                    let next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            this.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            this.data_ = orderedData;
        });
        return this;
    }
    get size() {
        this.keysAtom_.reportObserved();
        return this.data_.size;
    }
    toString() {
        return "[object ObservableMap]";
    }
    toJSON() {
        return Array.from(this);
    }
    get [Symbol.toStringTag]() {
        return "Map";
    }
}
// eslint-disable-next-line
var $fecbc4a33bb0f224$export$27a7faddcfd44960 = /*#__PURE__*/ $fecbc4a33bb0f224$var$createInstanceofPredicate("ObservableMap", $fecbc4a33bb0f224$export$db1c0901f08fc6fd);
function $fecbc4a33bb0f224$var$makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return $fecbc4a33bb0f224$var$makeIterable(iterator);
}
function $fecbc4a33bb0f224$var$convertToMap(dataStructure) {
    if ($fecbc4a33bb0f224$var$isES6Map(dataStructure) || $fecbc4a33bb0f224$export$27a7faddcfd44960(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if ($fecbc4a33bb0f224$var$isPlainObject(dataStructure)) {
        const map = new Map();
        for(const key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return $fecbc4a33bb0f224$var$die(21, dataStructure);
}
const $fecbc4a33bb0f224$var$ObservableSetMarker = {};
class $fecbc4a33bb0f224$export$2235f602a7a77c81 {
    constructor(initialData, enhancer = $fecbc4a33bb0f224$var$deepEnhancer, name_ = "ObservableSet"){
        this.name_ = void 0;
        this[$fecbc4a33bb0f224$export$f246528900dd4467] = $fecbc4a33bb0f224$var$ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        this.enhancer_ = (newV, oldV)=>enhancer(newV, oldV, name_);
        $fecbc4a33bb0f224$var$initObservable(()=>{
            this.atom_ = $fecbc4a33bb0f224$export$2e17fe64ec9a826e(this.name_);
            if (initialData) this.replace(initialData);
        });
    }
    dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    }
    clear() {
        $fecbc4a33bb0f224$export$2d62d2646dd2fb3c(()=>{
            $fecbc4a33bb0f224$export$8c437e4d572e2f99(()=>{
                for (const value of this.data_.values())this.delete(value);
            });
        });
    }
    forEach(callbackFn, thisArg) {
        for (const value of this)callbackFn.call(thisArg, value, value, this);
    }
    get size() {
        this.atom_.reportObserved();
        return this.data_.size;
    }
    add(value) {
        $fecbc4a33bb0f224$var$checkIfStateModificationsAreAllowed(this.atom_);
        if ($fecbc4a33bb0f224$var$hasInterceptors(this)) {
            const change = $fecbc4a33bb0f224$var$interceptChange(this, {
                type: $fecbc4a33bb0f224$var$ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            $fecbc4a33bb0f224$export$2d62d2646dd2fb3c(()=>{
                this.data_.add(this.enhancer_(value, undefined));
                this.atom_.reportChanged();
            });
            const notifySpy = false;
            const notify = $fecbc4a33bb0f224$var$hasListeners(this);
            const change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: $fecbc4a33bb0f224$var$ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) $fecbc4a33bb0f224$var$notifyListeners(this, change);
        }
        return this;
    }
    delete(value) {
        if ($fecbc4a33bb0f224$var$hasInterceptors(this)) {
            const change = $fecbc4a33bb0f224$var$interceptChange(this, {
                type: $fecbc4a33bb0f224$var$DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            const notifySpy = false;
            const notify = $fecbc4a33bb0f224$var$hasListeners(this);
            const change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: $fecbc4a33bb0f224$var$DELETE,
                object: this,
                oldValue: value
            } : null;
            $fecbc4a33bb0f224$export$2d62d2646dd2fb3c(()=>{
                this.atom_.reportChanged();
                this.data_.delete(value);
            });
            if (notify) $fecbc4a33bb0f224$var$notifyListeners(this, change);
            return true;
        }
        return false;
    }
    has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    }
    entries() {
        const values = this.values();
        return $fecbc4a33bb0f224$var$makeIterableForSet({
            next () {
                const { value: value, done: done } = values.next();
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    }
    keys() {
        return this.values();
    }
    values() {
        this.atom_.reportObserved();
        const self = this;
        const values = this.data_.values();
        return $fecbc4a33bb0f224$var$makeIterableForSet({
            next () {
                const { value: value, done: done } = values.next();
                return !done ? {
                    value: self.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    }
    intersection(otherSet) {
        if ($fecbc4a33bb0f224$var$isES6Set(otherSet) && !$fecbc4a33bb0f224$export$da6b063694cb52c1(otherSet)) return otherSet.intersection(this);
        else {
            const dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    }
    union(otherSet) {
        if ($fecbc4a33bb0f224$var$isES6Set(otherSet) && !$fecbc4a33bb0f224$export$da6b063694cb52c1(otherSet)) return otherSet.union(this);
        else {
            const dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    }
    difference(otherSet) {
        return new Set(this).difference(otherSet);
    }
    symmetricDifference(otherSet) {
        if ($fecbc4a33bb0f224$var$isES6Set(otherSet) && !$fecbc4a33bb0f224$export$da6b063694cb52c1(otherSet)) return otherSet.symmetricDifference(this);
        else {
            const dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    }
    isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    }
    isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    }
    isDisjointFrom(otherSet) {
        if ($fecbc4a33bb0f224$var$isES6Set(otherSet) && !$fecbc4a33bb0f224$export$da6b063694cb52c1(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            const dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    }
    replace(other) {
        if ($fecbc4a33bb0f224$export$da6b063694cb52c1(other)) other = new Set(other);
        $fecbc4a33bb0f224$export$2d62d2646dd2fb3c(()=>{
            if (Array.isArray(other)) {
                this.clear();
                other.forEach((value)=>this.add(value));
            } else if ($fecbc4a33bb0f224$var$isES6Set(other)) {
                this.clear();
                other.forEach((value)=>this.add(value));
            } else if (other !== null && other !== undefined) $fecbc4a33bb0f224$var$die(41, other);
        });
        return this;
    }
    toJSON() {
        return Array.from(this);
    }
    toString() {
        return "[object ObservableSet]";
    }
    [Symbol.iterator]() {
        return this.values();
    }
    get [Symbol.toStringTag]() {
        return "Set";
    }
}
// eslint-disable-next-line
var $fecbc4a33bb0f224$export$da6b063694cb52c1 = /*#__PURE__*/ $fecbc4a33bb0f224$var$createInstanceofPredicate("ObservableSet", $fecbc4a33bb0f224$export$2235f602a7a77c81);
function $fecbc4a33bb0f224$var$makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return $fecbc4a33bb0f224$var$makeIterable(iterator);
}
const $fecbc4a33bb0f224$var$descriptorCache = /*#__PURE__*/ Object.create(null);
const $fecbc4a33bb0f224$var$REMOVE = "remove";
class $fecbc4a33bb0f224$var$ObservableObjectAdministration {
    constructor(target_, values_ = new Map(), name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_ = $fecbc4a33bb0f224$var$autoAnnotation){
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.lazyComputedKeys_ = void 0;
        this.lazyObservableKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new $fecbc4a33bb0f224$var$Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = $fecbc4a33bb0f224$var$isPlainObject(this.target_);
    }
    getObservablePropValue_(key) {
        var _ref, _this$values_$get;
        // Hot path: single map lookup. Lazy entries (rare) take the materialise branch.
        const observable = (_ref = (_this$values_$get = this.values_.get(key)) != null ? _this$values_$get : this.materializeLazyComputed_(key)) != null ? _ref : this.materializeLazyObservable_(key);
        return observable.get();
    }
    materializeLazyComputed_(key) {
        var _this$lazyComputedKey;
        const factory = (_this$lazyComputedKey = this.lazyComputedKeys_) == null ? void 0 : _this$lazyComputedKey.get(key);
        if (!factory) return undefined;
        this.lazyComputedKeys_.delete(key);
        if (this.lazyComputedKeys_.size === 0) this.lazyComputedKeys_ = undefined;
        const computed = factory();
        this.values_.set(key, computed);
        return computed;
    }
    materializeLazyObservable_(key) {
        var _this$lazyObservableK;
        const factory = (_this$lazyObservableK = this.lazyObservableKeys_) == null ? void 0 : _this$lazyObservableK.get(key);
        if (!factory) return undefined;
        this.lazyObservableKeys_.delete(key);
        if (this.lazyObservableKeys_.size === 0) this.lazyObservableKeys_ = undefined;
        const observable = factory();
        this.values_.set(key, observable);
        return observable;
    }
    setObservablePropValue_(key, newValue) {
        var _ref2, _this$values_$get2;
        const observable = (_ref2 = (_this$values_$get2 = this.values_.get(key)) != null ? _this$values_$get2 : this.materializeLazyComputed_(key)) != null ? _ref2 : this.materializeLazyObservable_(key);
        if (observable instanceof $fecbc4a33bb0f224$var$ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if ($fecbc4a33bb0f224$var$hasInterceptors(this)) {
            const change = $fecbc4a33bb0f224$var$interceptChange(this, {
                type: $fecbc4a33bb0f224$var$UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== $fecbc4a33bb0f224$var$globalState.UNCHANGED) {
            const notify = $fecbc4a33bb0f224$var$hasListeners(this);
            const notifySpy = false;
            const change = notify || notifySpy ? {
                type: $fecbc4a33bb0f224$var$UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) $fecbc4a33bb0f224$var$notifyListeners(this, change);
        }
        return true;
    }
    get_(key) {
        if ($fecbc4a33bb0f224$var$globalState.trackingDerivation && !$fecbc4a33bb0f224$var$hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    }
    /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ set_(key, value, proxyTrap = false) {
        // Don't use .has(key) - we care about own
        if ($fecbc4a33bb0f224$var$hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    }
    // Trap for "in"
    has_(key) {
        if (!$fecbc4a33bb0f224$var$globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        let entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new $fecbc4a33bb0f224$var$ObservableValue(key in this.target_, $fecbc4a33bb0f224$var$referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    }
    /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ extend_(key, descriptor, annotation, proxyTrap = false) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        $fecbc4a33bb0f224$var$assertAnnotable(this, annotation, key);
        const outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) $fecbc4a33bb0f224$var$recordAnnotationApplied(this, annotation, key);
        return outcome;
    }
    /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ defineProperty_(key, descriptor, proxyTrap = false) {
        $fecbc4a33bb0f224$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            $fecbc4a33bb0f224$var$startBatch();
            // Delete
            const deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if ($fecbc4a33bb0f224$var$hasInterceptors(this)) {
                const change = $fecbc4a33bb0f224$var$interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: $fecbc4a33bb0f224$var$ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                const { newValue: newValue } = change;
                if (descriptor.value !== newValue) descriptor = $fecbc4a33bb0f224$var$assign({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else $fecbc4a33bb0f224$var$defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            $fecbc4a33bb0f224$var$endBatch();
        }
        return true;
    }
    // If original descriptor becomes relevant, move this to annotation directly
    defineObservableProperty_(key, value, enhancer, proxyTrap = false) {
        $fecbc4a33bb0f224$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            $fecbc4a33bb0f224$var$startBatch();
            // Delete
            const deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if ($fecbc4a33bb0f224$var$hasInterceptors(this)) {
                const change = $fecbc4a33bb0f224$var$interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: $fecbc4a33bb0f224$var$ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            const cachedDescriptor = $fecbc4a33bb0f224$var$getCachedObservablePropDescriptor(key);
            const descriptor = {
                configurable: $fecbc4a33bb0f224$var$globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else $fecbc4a33bb0f224$var$defineProperty(this.target_, key, descriptor);
            const observable = new $fecbc4a33bb0f224$var$ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            $fecbc4a33bb0f224$var$endBatch();
        }
        return true;
    }
    // If original descriptor becomes relevant, move this to annotation directly
    defineComputedProperty_(key, options, proxyTrap = false) {
        $fecbc4a33bb0f224$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            $fecbc4a33bb0f224$var$startBatch();
            // Delete
            const deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if ($fecbc4a33bb0f224$var$hasInterceptors(this)) {
                const change = $fecbc4a33bb0f224$var$interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: $fecbc4a33bb0f224$var$ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            const cachedDescriptor = $fecbc4a33bb0f224$var$getCachedObservablePropDescriptor(key);
            const descriptor = {
                configurable: $fecbc4a33bb0f224$var$globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else $fecbc4a33bb0f224$var$defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new $fecbc4a33bb0f224$var$ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            $fecbc4a33bb0f224$var$endBatch();
        }
        return true;
    }
    /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ delete_(key, proxyTrap = false) {
        $fecbc4a33bb0f224$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!$fecbc4a33bb0f224$var$hasProp(this.target_, key)) return true;
        // Intercept
        if ($fecbc4a33bb0f224$var$hasInterceptors(this)) {
            const change = $fecbc4a33bb0f224$var$interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: $fecbc4a33bb0f224$var$REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            $fecbc4a33bb0f224$var$startBatch();
            const notify = $fecbc4a33bb0f224$var$hasListeners(this);
            const notifySpy = false;
            const observable = this.values_.get(key);
            // Value needed for spies/listeners
            let value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = $fecbc4a33bb0f224$var$getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_.delete(key);
                // for computed, value is undefined
                if (observable instanceof $fecbc4a33bb0f224$var$ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                $fecbc4a33bb0f224$var$propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                const change = {
                    type: $fecbc4a33bb0f224$var$REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) $fecbc4a33bb0f224$var$notifyListeners(this, change);
            }
        } finally{
            $fecbc4a33bb0f224$var$endBatch();
        }
        return true;
    }
    notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        const notify = $fecbc4a33bb0f224$var$hasListeners(this);
        const notifySpy = false;
        if (notify || notifySpy) {
            const change = notify || notifySpy ? {
                type: $fecbc4a33bb0f224$var$ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) $fecbc4a33bb0f224$var$notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    }
    ownKeys_() {
        this.keysAtom_.reportObserved();
        return $fecbc4a33bb0f224$var$ownKeys(this.target_);
    }
    keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    }
}
function $fecbc4a33bb0f224$var$asObservableObject(target, options) {
    var _options$name;
    if ($fecbc4a33bb0f224$var$hasProp(target, $fecbc4a33bb0f224$export$f246528900dd4467)) return target;
    const name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    const adm = new $fecbc4a33bb0f224$var$ObservableObjectAdministration(target, new Map(), String(name), $fecbc4a33bb0f224$var$getAnnotationFromOptions(options));
    $fecbc4a33bb0f224$var$addHiddenProp(target, $fecbc4a33bb0f224$export$f246528900dd4467, adm);
    return target;
}
const $fecbc4a33bb0f224$var$isObservableObjectAdministration = /*#__PURE__*/ $fecbc4a33bb0f224$var$createInstanceofPredicate("ObservableObjectAdministration", $fecbc4a33bb0f224$var$ObservableObjectAdministration);
function $fecbc4a33bb0f224$var$getCachedObservablePropDescriptor(key) {
    return $fecbc4a33bb0f224$var$descriptorCache[key] || ($fecbc4a33bb0f224$var$descriptorCache[key] = {
        get () {
            return this[$fecbc4a33bb0f224$export$f246528900dd4467].getObservablePropValue_(key);
        },
        set (value) {
            return this[$fecbc4a33bb0f224$export$f246528900dd4467].setObservablePropValue_(key, value);
        }
    });
}
function $fecbc4a33bb0f224$export$31960fb081a18155(thing) {
    if ($fecbc4a33bb0f224$var$isObject(thing)) return $fecbc4a33bb0f224$var$isObservableObjectAdministration(thing[$fecbc4a33bb0f224$export$f246528900dd4467]);
    return false;
}
function $fecbc4a33bb0f224$var$recordAnnotationApplied(adm, annotation, key) {}
function $fecbc4a33bb0f224$var$assertAnnotable(adm, annotation, key) {}
function $fecbc4a33bb0f224$export$25fc416d10fa1afa(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if ($fecbc4a33bb0f224$export$f5afceff386badf9(thing)) {
            if (property !== undefined) $fecbc4a33bb0f224$var$die(23);
            return thing[$fecbc4a33bb0f224$export$f246528900dd4467].atom_;
        }
        if ($fecbc4a33bb0f224$export$da6b063694cb52c1(thing)) return thing.atom_;
        if ($fecbc4a33bb0f224$export$27a7faddcfd44960(thing)) {
            if (property === undefined) return thing.keysAtom_;
            const observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) $fecbc4a33bb0f224$var$die(25, property, $fecbc4a33bb0f224$export$c48237bbccf30144(thing));
            return observable;
        }
        if ($fecbc4a33bb0f224$export$31960fb081a18155(thing)) {
            var _ref, _adm$values_$get;
            if (!property) return $fecbc4a33bb0f224$var$die(26);
            const adm = thing[$fecbc4a33bb0f224$export$f246528900dd4467];
            const observable = (_ref = (_adm$values_$get = adm.values_.get(property)) != null ? _adm$values_$get : adm.materializeLazyComputed_(property)) != null ? _ref : adm.materializeLazyObservable_(property);
            if (!observable) $fecbc4a33bb0f224$var$die(27, property, $fecbc4a33bb0f224$export$c48237bbccf30144(thing));
            return observable;
        }
        if ($fecbc4a33bb0f224$var$isAtom(thing) || $fecbc4a33bb0f224$var$isComputedValue(thing) || $fecbc4a33bb0f224$var$isReaction(thing)) return thing;
    } else if ($fecbc4a33bb0f224$var$isFunction(thing)) {
        if ($fecbc4a33bb0f224$var$isReaction(thing[$fecbc4a33bb0f224$export$f246528900dd4467])) // disposer function
        return thing[$fecbc4a33bb0f224$export$f246528900dd4467];
    }
    $fecbc4a33bb0f224$var$die(28);
}
function $fecbc4a33bb0f224$export$71ff639cb8b2a36e(thing, property) {
    if (!thing) $fecbc4a33bb0f224$var$die(29);
    if (property !== undefined) return $fecbc4a33bb0f224$export$71ff639cb8b2a36e($fecbc4a33bb0f224$export$25fc416d10fa1afa(thing, property));
    if ($fecbc4a33bb0f224$var$isAtom(thing) || $fecbc4a33bb0f224$var$isComputedValue(thing) || $fecbc4a33bb0f224$var$isReaction(thing)) return thing;
    if ($fecbc4a33bb0f224$export$27a7faddcfd44960(thing) || $fecbc4a33bb0f224$export$da6b063694cb52c1(thing)) return thing;
    if (thing[$fecbc4a33bb0f224$export$f246528900dd4467]) return thing[$fecbc4a33bb0f224$export$f246528900dd4467];
    $fecbc4a33bb0f224$var$die(24, thing);
}
function $fecbc4a33bb0f224$export$c48237bbccf30144(thing, property) {
    let named;
    if (property !== undefined) named = $fecbc4a33bb0f224$export$25fc416d10fa1afa(thing, property);
    else if ($fecbc4a33bb0f224$export$b956e38827fca970(thing)) return thing.name;
    else if ($fecbc4a33bb0f224$export$31960fb081a18155(thing) || $fecbc4a33bb0f224$export$27a7faddcfd44960(thing) || $fecbc4a33bb0f224$export$da6b063694cb52c1(thing)) named = $fecbc4a33bb0f224$export$71ff639cb8b2a36e(thing);
    else // valid for arrays as well
    named = $fecbc4a33bb0f224$export$25fc416d10fa1afa(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function $fecbc4a33bb0f224$var$initObservable(cb) {
    const derivation = $fecbc4a33bb0f224$var$untrackedStart();
    const allowStateChanges = true;
    $fecbc4a33bb0f224$var$startBatch();
    try {
        return cb();
    } finally{
        $fecbc4a33bb0f224$var$endBatch();
        $fecbc4a33bb0f224$var$untrackedEnd(derivation);
    }
}
const $fecbc4a33bb0f224$var$toString = $fecbc4a33bb0f224$var$objectPrototype.toString;
function $fecbc4a33bb0f224$var$deepEqual(a, b, depth = -1) {
    return $fecbc4a33bb0f224$var$eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function $fecbc4a33bb0f224$var$eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    const type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    const className = $fecbc4a33bb0f224$var$toString.call(a);
    if (className !== $fecbc4a33bb0f224$var$toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = $fecbc4a33bb0f224$var$unwrap(a);
    b = $fecbc4a33bb0f224$var$unwrap(b);
    const areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        const aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !($fecbc4a33bb0f224$var$isFunction(aCtor) && aCtor instanceof aCtor && $fecbc4a33bb0f224$var$isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    let length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!$fecbc4a33bb0f224$var$eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        const keys = Object.keys(a);
        const _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(let i = 0; i < _length; i++){
            // Deep compare each member
            const key = keys[i];
            if (!($fecbc4a33bb0f224$var$hasProp(b, key) && $fecbc4a33bb0f224$var$eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function $fecbc4a33bb0f224$var$unwrap(a) {
    if ($fecbc4a33bb0f224$export$f5afceff386badf9(a)) return a.slice();
    if ($fecbc4a33bb0f224$var$isES6Map(a) || $fecbc4a33bb0f224$export$27a7faddcfd44960(a)) return Array.from(a.entries());
    if ($fecbc4a33bb0f224$var$isES6Set(a) || $fecbc4a33bb0f224$export$da6b063694cb52c1(a)) return Array.from(a.entries());
    return a;
}
var $fecbc4a33bb0f224$var$_globalThis$Iterator;
// safely get iterator prototype if available
const $fecbc4a33bb0f224$var$maybeIteratorPrototype = (($fecbc4a33bb0f224$var$_globalThis$Iterator = globalThis.Iterator) == null ? void 0 : $fecbc4a33bb0f224$var$_globalThis$Iterator.prototype) || {};
function $fecbc4a33bb0f224$var$makeIterable(iterator) {
    iterator[Symbol.iterator] = $fecbc4a33bb0f224$var$getSelf;
    return $fecbc4a33bb0f224$var$assign(Object.create($fecbc4a33bb0f224$var$maybeIteratorPrototype), iterator);
}
function $fecbc4a33bb0f224$var$getSelf() {
    return this;
}
function $fecbc4a33bb0f224$var$isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && $fecbc4a33bb0f224$var$isFunction(thing.make_) && $fecbc4a33bb0f224$var$isFunction(thing.extend_));
}
var $fecbc4a33bb0f224$var$m;




var $7DB8U = parcelRequire("7DB8U");


var $7DB8U = parcelRequire("7DB8U");
var $e6ea43bdc865b43a$var$_getGlobalState2;
if (!(0, $7DB8U.useState) || !(0, $7DB8U.useSyncExternalStore)) throw new Error("mobx-react-lite requires React 18 or later");
if (!(((0, $fecbc4a33bb0f224$export$c78907783e606401) == null || ($e6ea43bdc865b43a$var$_getGlobalState2 = (0, $fecbc4a33bb0f224$export$c78907783e606401)()) == null ? void 0 : $e6ea43bdc865b43a$var$_getGlobalState2.version) >= 7)) throw new Error("mobx-react-lite requires mobx at least version 7 to be available");
const $e6ea43bdc865b43a$var$REGISTRY_FINALIZE_AFTER = 10000;
const $e6ea43bdc865b43a$var$REGISTRY_SWEEP_INTERVAL = 10000;
class $e6ea43bdc865b43a$var$TimerBasedFinalizationRegistry {
    constructor(finalize){
        this.finalize = void 0;
        this.registrations = new Map();
        this.sweepTimeout = void 0;
        // Bound so it can be used directly as setTimeout callback.
        this.sweep = (maxAge = $e6ea43bdc865b43a$var$REGISTRY_FINALIZE_AFTER)=>{
            // cancel timeout so we can force sweep anytime
            clearTimeout(this.sweepTimeout);
            this.sweepTimeout = undefined;
            const now = Date.now();
            this.registrations.forEach((registration, token)=>{
                if (now - registration.registeredAt >= maxAge) {
                    this.finalize(registration.value);
                    this.registrations.delete(token);
                }
            });
            if (this.registrations.size > 0) this.scheduleSweep();
        };
        // Bound so it can be exported directly as clearTimers test utility.
        this.finalizeAllImmediately = ()=>{
            this.sweep(0);
        };
        this.finalize = finalize;
    }
    // Token is actually required with this impl
    register(target, value, token) {
        this.registrations.set(token, {
            value: value,
            registeredAt: Date.now()
        });
        this.scheduleSweep();
    }
    unregister(token) {
        this.registrations.delete(token);
    }
    scheduleSweep() {
        if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $e6ea43bdc865b43a$var$REGISTRY_SWEEP_INTERVAL);
    }
}
const $e6ea43bdc865b43a$var$UniversalFinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $e6ea43bdc865b43a$var$TimerBasedFinalizationRegistry;
const $e6ea43bdc865b43a$export$e709e546a713a22e = /*#__PURE__*/ new $e6ea43bdc865b43a$var$UniversalFinalizationRegistry((adm)=>{
    var _adm$reaction;
    (_adm$reaction = adm.reaction) == null || _adm$reaction.dispose();
    adm.reaction = null;
});
let $e6ea43bdc865b43a$var$globalIsUsingStaticRendering = false;
function $e6ea43bdc865b43a$export$5d52eaa7c0f24c9e(enable) {
    $e6ea43bdc865b43a$var$globalIsUsingStaticRendering = enable;
}
function $e6ea43bdc865b43a$export$55979271896d643e() {
    return $e6ea43bdc865b43a$var$globalIsUsingStaticRendering;
}
function $e6ea43bdc865b43a$var$createReaction(adm) {
    adm.reaction = new (0, $fecbc4a33bb0f224$export$d2ae4167a30cf6bb)(`observer${adm.name}`, ()=>{
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        adm.onStoreChange == null || adm.onStoreChange();
    });
}
function $e6ea43bdc865b43a$var$useObserver(render, baseComponentName = "observed") {
    if ($e6ea43bdc865b43a$export$55979271896d643e()) return render();
    const admRef = (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).useRef(null);
    if (!admRef.current) {
        // First render
        const _adm = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe (onStoreChange) {
                // Do NOT access admRef here!
                $e6ea43bdc865b43a$export$e709e546a713a22e.unregister(_adm);
                _adm.onStoreChange = onStoreChange;
                if (!_adm.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $e6ea43bdc865b43a$var$createReaction(_adm);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    _adm.stateVersion = Symbol();
                }
                return ()=>{
                    var _adm$reaction;
                    // Do NOT access admRef here!
                    _adm.onStoreChange = null;
                    (_adm$reaction = _adm.reaction) == null || _adm$reaction.dispose();
                    _adm.reaction = null;
                };
            },
            getSnapshot () {
                // Do NOT access admRef here!
                return _adm.stateVersion;
            }
        };
        admRef.current = _adm;
    }
    const adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $e6ea43bdc865b43a$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        $e6ea43bdc865b43a$export$e709e546a713a22e.register(admRef, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).useDebugValue(adm.reaction, (0, $fecbc4a33bb0f224$export$23fbf90e5d80a5ee));
    (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).useSyncExternalStore(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    let renderResult;
    let exception;
    adm.reaction.track(()=>{
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}
var $e6ea43bdc865b43a$var$_Object$getOwnPropert, $e6ea43bdc865b43a$var$_Object$getOwnPropert2;
const $e6ea43bdc865b43a$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
const $e6ea43bdc865b43a$var$isFunctionNameConfigurable = ($e6ea43bdc865b43a$var$_Object$getOwnPropert = ($e6ea43bdc865b43a$var$_Object$getOwnPropert2 = /*#__PURE__*/ Object.getOwnPropertyDescriptor(()=>{}, "name")) == null ? void 0 : $e6ea43bdc865b43a$var$_Object$getOwnPropert2.configurable) != null ? $e6ea43bdc865b43a$var$_Object$getOwnPropert : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
const $e6ea43bdc865b43a$var$ReactForwardRefSymbol = $e6ea43bdc865b43a$var$hasSymbol ? /*#__PURE__*/ Symbol.for("react.forward_ref") : typeof (0, $7DB8U.forwardRef) === "function" && (0, $7DB8U.forwardRef)((props)=>null)["$$typeof"];
const $e6ea43bdc865b43a$var$ReactMemoSymbol = $e6ea43bdc865b43a$var$hasSymbol ? /*#__PURE__*/ Symbol.for("react.memo") : typeof (0, $7DB8U.memo) === "function" && (0, $7DB8U.memo)((props)=>null)["$$typeof"];
// n.b. base case is not used for actual typings or exported in the typing files
function $e6ea43bdc865b43a$export$b6ae1bc530f4c149(baseComponent) {
    if ($e6ea43bdc865b43a$var$ReactMemoSymbol && baseComponent["$$typeof"] === $e6ea43bdc865b43a$var$ReactMemoSymbol) throw new Error(`[mobx-react-lite] You are trying to use \`observer\` on a function component wrapped in either another \`observer\` or \`React.memo\`. The observer already applies 'React.memo' for you.`);
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ($e6ea43bdc865b43a$export$55979271896d643e()) return baseComponent;
    let useForwardRef = false;
    let render = baseComponent;
    const baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($e6ea43bdc865b43a$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $e6ea43bdc865b43a$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error(`[mobx-react-lite] \`render\` property of ForwardRef was not a function`);
    }
    let observerComponent = (props, ref)=>{
        return $e6ea43bdc865b43a$var$useObserver(()=>render(props, ref), baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($e6ea43bdc865b43a$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $7DB8U.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $7DB8U.memo)(observerComponent);
    $e6ea43bdc865b43a$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
const $e6ea43bdc865b43a$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $e6ea43bdc865b43a$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach((key)=>{
        if (!$e6ea43bdc865b43a$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
function $e6ea43bdc865b43a$export$c1cbdee04e18ea8b({ children: children, render: render }) {
    if (children && render) console.error("MobX Observer: Do not use children and render in the same time in `Observer`");
    const component = children || render;
    if (typeof component !== "function") return null;
    return $e6ea43bdc865b43a$var$useObserver(component);
}
$e6ea43bdc865b43a$export$c1cbdee04e18ea8b.displayName = "Observer";
function $e6ea43bdc865b43a$export$aa207039f277c5f(initializer, annotations) {
    return (0, $7DB8U.useState)(()=>(0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)(initializer(), annotations, {
            autoBind: true
        }))[0];
}
var $e6ea43bdc865b43a$var$_observerFinalization;
const $e6ea43bdc865b43a$export$469d51fb8d268227 = ($e6ea43bdc865b43a$var$_observerFinalization = $e6ea43bdc865b43a$export$e709e546a713a22e["finalizeAllImmediately"]) != null ? $e6ea43bdc865b43a$var$_observerFinalization : ()=>{};


function $2c52cd3eacadeaca$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($2c52cd3eacadeaca$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$2c52cd3eacadeaca$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $2c52cd3eacadeaca$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ const $2c52cd3eacadeaca$var$mobxMixins = /*#__PURE__*/ Symbol("patchMixins");
const $2c52cd3eacadeaca$var$mobxPatchedDefinition = /*#__PURE__*/ Symbol("patchedDefinition");
function $2c52cd3eacadeaca$var$getMixins(target, methodName) {
    const mixins = target[$2c52cd3eacadeaca$var$mobxMixins] = target[$2c52cd3eacadeaca$var$mobxMixins] || {};
    const methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $2c52cd3eacadeaca$var$wrapper(realMethod, mixins, ...args) {
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        let retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach((mx)=>{
            mx.apply(this, args);
        });
    }
}
function $2c52cd3eacadeaca$var$wrapFunction(realMethod, mixins) {
    const fn = function fn(...args) {
        $2c52cd3eacadeaca$var$wrapper.call(this, realMethod, mixins, ...args);
    };
    return fn;
}
function $2c52cd3eacadeaca$var$patch(target, methodName, mixinMethod) {
    const mixins = $2c52cd3eacadeaca$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    const oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$2c52cd3eacadeaca$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    const originalMethod = target[methodName];
    const newDefinition = $2c52cd3eacadeaca$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $2c52cd3eacadeaca$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    let wrappedFunc = $2c52cd3eacadeaca$var$wrapFunction(originalMethod, mixins);
    return {
        // @ts-ignore
        [$2c52cd3eacadeaca$var$mobxPatchedDefinition]: true,
        get: function() {
            return wrappedFunc;
        },
        set: function(value) {
            if (this === target) wrappedFunc = $2c52cd3eacadeaca$var$wrapFunction(value, mixins);
            else {
                // when it is an instance of the prototype/a child prototype patch that particular case again separately
                // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
                // e.g. the method for super might not be the same as the method for the prototype which might be not the same
                // as the method for the instance
                const newDefinition = $2c52cd3eacadeaca$var$createDefinition(this, methodName, enumerable, mixins, value);
                Object.defineProperty(this, methodName, newDefinition);
            }
        },
        configurable: true,
        enumerable: enumerable
    };
}
const $2c52cd3eacadeaca$var$administrationSymbol = /*#__PURE__*/ Symbol("ObserverAdministration");
const $2c52cd3eacadeaca$var$isMobXReactObserverSymbol = /*#__PURE__*/ Symbol("isMobXReactObserver");
let $2c52cd3eacadeaca$var$observablePropDescriptors;
function $2c52cd3eacadeaca$var$getAdministration(component) {
    var _component$administra;
    // We create administration lazily, because we can't patch constructor
    // and the exact moment of initialization partially depends on React internals.
    // At the time of writing this, the first thing invoked is one of the observable getter/setter (state/props/context).
    return (_component$administra = component[$2c52cd3eacadeaca$var$administrationSymbol]) != null ? _component$administra : component[$2c52cd3eacadeaca$var$administrationSymbol] = {
        reaction: null,
        mounted: false,
        reactionInvalidatedBeforeMount: false,
        forceUpdate: null,
        name: $2c52cd3eacadeaca$var$getDisplayName(component.constructor),
        state: undefined,
        props: undefined,
        context: undefined
    };
}
function $2c52cd3eacadeaca$var$makeClassComponentObserver(componentClass) {
    const { prototype: prototype } = componentClass;
    if (componentClass[$2c52cd3eacadeaca$var$isMobXReactObserverSymbol]) {
        const displayName = $2c52cd3eacadeaca$var$getDisplayName(componentClass);
        throw new Error(`The provided component class (${displayName}) has already been declared as an observer component.`);
    } else componentClass[$2c52cd3eacadeaca$var$isMobXReactObserverSymbol] = true;
    if (prototype.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $7DB8U.PureComponent)) {
        if (!prototype.shouldComponentUpdate) prototype.shouldComponentUpdate = $2c52cd3eacadeaca$var$observerSCU;
        else if (prototype.shouldComponentUpdate !== $2c52cd3eacadeaca$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    }
    const originalRender = prototype.render;
    if (typeof originalRender !== "function") {
        const displayName = $2c52cd3eacadeaca$var$getDisplayName(componentClass);
        throw new Error(`[mobx-react] class component (${displayName}) is missing \`render\` method.` + `\n\`observer\` requires \`render\` being a function defined on prototype.` + `\n\`render = () => {}\` or \`render = function() {}\` is not supported.`);
    }
    prototype.render = function() {
        Object.defineProperty(this, "render", {
            // There is no safe way to replace render, therefore it's forbidden.
            configurable: false,
            writable: false,
            value: (0, $e6ea43bdc865b43a$export$55979271896d643e)() ? originalRender : $2c52cd3eacadeaca$var$createReactiveRender.call(this, originalRender)
        });
        return this.render();
    };
    const originalComponentDidMount = prototype.componentDidMount;
    prototype.componentDidMount = function() {
        // `componentDidMount` may not be called at all. React can abandon the instance after `render`.
        // That's why we use finalization registry to dispose reaction created during render.
        // Happens with `<Suspend>` see #3492
        //
        // `componentDidMount` can be called immediately after `componentWillUnmount` without calling `render` in between.
        // Happens with `<StrictMode>`see #3395.
        //
        // If `componentDidMount` is called, it's guaranteed to run synchronously with render (similary to `useLayoutEffect`).
        // Therefore we don't have to worry about external (observable) state being updated before mount (no state version checking).
        //
        // Things may change: "In the future, React will provide a feature that lets components preserve state between unmounts"
        const admin = $2c52cd3eacadeaca$var$getAdministration(this);
        admin.mounted = true;
        // Component instance committed, prevent reaction disposal.
        (0, $e6ea43bdc865b43a$export$e709e546a713a22e).unregister(this);
        // We don't set forceUpdate before mount because it requires a reference to `this`,
        // therefore `this` could NOT be garbage collected before mount,
        // preventing reaction disposal by FinalizationRegistry and leading to memory leak.
        // As an alternative we could have `admin.instanceRef = new WeakRef(this)`, but lets avoid it if possible.
        admin.forceUpdate = ()=>this.forceUpdate();
        if (!admin.reaction || admin.reactionInvalidatedBeforeMount) // Missing reaction:
        // 1. Instance was unmounted (reaction disposed) and immediately remounted without running render #3395.
        // 2. Reaction was disposed by finalization registry before mount. Shouldn't ever happen for class components:
        // `componentDidMount` runs synchronously after render, but our registry are deferred (can't run in between).
        // In any case we lost subscriptions to observables, so we have to create new reaction and re-render to resubscribe.
        // The reaction will be created lazily by following render.
        // Reaction invalidated before mount:
        // 1. A descendant's `componenDidMount` invalidated it's parent #3730
        admin.forceUpdate();
        return originalComponentDidMount == null ? void 0 : originalComponentDidMount.apply(this, arguments);
    };
    // TODO@major Overly complicated "patch" is only needed to support the deprecated @disposeOnUnmount
    $2c52cd3eacadeaca$var$patch(prototype, "componentWillUnmount", function() {
        var _admin$reaction;
        if ((0, $e6ea43bdc865b43a$export$55979271896d643e)()) return;
        const admin = $2c52cd3eacadeaca$var$getAdministration(this);
        (_admin$reaction = admin.reaction) == null || _admin$reaction.dispose();
        admin.reaction = null;
        admin.forceUpdate = null;
        admin.mounted = false;
        admin.reactionInvalidatedBeforeMount = false;
    });
    return componentClass;
}
// Generates a friendly name for debugging
function $2c52cd3eacadeaca$var$getDisplayName(componentClass) {
    return componentClass.displayName || componentClass.name || "<component>";
}
function $2c52cd3eacadeaca$var$createReactiveRender(originalRender) {
    const boundOriginalRender = originalRender.bind(this);
    const admin = $2c52cd3eacadeaca$var$getAdministration(this);
    function reactiveRender() {
        if (!admin.reaction) {
            // Create reaction lazily to support re-mounting #3395
            admin.reaction = $2c52cd3eacadeaca$var$createReaction(admin);
            if (!admin.mounted) // React can abandon this instance and never call `componentDidMount`/`componentWillUnmount`,
            // we have to make sure reaction will be disposed.
            (0, $e6ea43bdc865b43a$export$e709e546a713a22e).register(this, admin, this);
        }
        let error = undefined;
        let renderResult = undefined;
        admin.reaction.track(()=>{
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                renderResult = (0, $fecbc4a33bb0f224$export$e510c5d1ea4358b1)(false, boundOriginalRender);
            } catch (e) {
                error = e;
            }
        });
        if (error) throw error;
        return renderResult;
    }
    return reactiveRender;
}
function $2c52cd3eacadeaca$var$createReaction(admin) {
    return new (0, $fecbc4a33bb0f224$export$d2ae4167a30cf6bb)(`${admin.name}.render()`, ()=>{
        if (!admin.mounted) {
            // This is neccessary to avoid react warning about calling forceUpdate on component that isn't mounted yet.
            // This happens when component is abandoned after render - our reaction is already created and reacts to changes.
            // `componenDidMount` runs synchronously after `render`, so unlike functional component, there is no delay during which the reaction could be invalidated.
            // However `componentDidMount` runs AFTER it's descendants' `componentDidMount`, which CAN invalidate the reaction, see #3730. Therefore remember and forceUpdate on mount.
            admin.reactionInvalidatedBeforeMount = true;
            return;
        }
        try {
            admin.forceUpdate == null || admin.forceUpdate();
        } catch (error) {
            var _admin$reaction2;
            (_admin$reaction2 = admin.reaction) == null || _admin$reaction2.dispose();
            admin.reaction = null;
        }
    });
}
function $2c52cd3eacadeaca$var$observerSCU(nextProps, nextState) {
    if ((0, $e6ea43bdc865b43a$export$55979271896d643e)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$2c52cd3eacadeaca$var$shallowEqual(this.props, nextProps);
}
function $2c52cd3eacadeaca$var$createObservablePropDescriptor(key) {
    return {
        configurable: true,
        enumerable: true,
        get () {
            const admin = $2c52cd3eacadeaca$var$getAdministration(this);
            const derivation = (0, $fecbc4a33bb0f224$export$c78907783e606401)().trackingDerivation;
            if (derivation && derivation !== admin.reaction) throw new Error(`[mobx-react] Cannot read "${admin.name}.${key}" in a reactive context, as it isn't observable.
                    Please use component lifecycle method to copy the value into a local observable first.
                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations`);
            return admin[key];
        },
        set (value) {
            $2c52cd3eacadeaca$var$getAdministration(this)[key] = value;
        }
    };
}
function $2c52cd3eacadeaca$export$b6ae1bc530f4c149(component, context) {
    if (context && context.kind !== "class") throw new Error("The @observer decorator can be used on classes only");
    if (Object.prototype.isPrototypeOf.call($7DB8U.Component, component) || Object.prototype.isPrototypeOf.call($7DB8U.PureComponent, component)) // Class component
    return $2c52cd3eacadeaca$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $e6ea43bdc865b43a$export$b6ae1bc530f4c149)(component);
}
if (!(0, $7DB8U.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)) throw new Error("mobx-react requires mobx to be available");



var $7DB8U = parcelRequire("7DB8U");
var $852a55cf17d8b19d$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($852a55cf17d8b19d$exports) {
        classNames.default = classNames;
        $852a55cf17d8b19d$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");

const $ca03a707c779611a$var$_excluded = [
    "as",
    "disabled"
];
function $ca03a707c779611a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $ca03a707c779611a$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $ca03a707c779611a$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $ca03a707c779611a$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $ca03a707c779611a$var$Button = /*#__PURE__*/ $7DB8U.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $ca03a707c779611a$var$_objectWithoutPropertiesLoose(_ref, $ca03a707c779611a$var$_excluded);
    const [buttonProps, { tagName: Component }] = $ca03a707c779611a$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$ca03a707c779611a$var$Button.displayName = 'Button';
var $ca03a707c779611a$export$2e2bcd8739ae039 = $ca03a707c779611a$var$Button;



var $7DB8U = parcelRequire("7DB8U");

"use client";
const $d36baff69136067a$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $d36baff69136067a$export$ff817e17bad2e091 = 'xs';
const $d36baff69136067a$var$ThemeContext = /*#__PURE__*/ $7DB8U.createContext({
    prefixes: {},
    breakpoints: $d36baff69136067a$export$666ad80b5007f835,
    minBreakpoint: $d36baff69136067a$export$ff817e17bad2e091
});
const { Consumer: $d36baff69136067a$export$b631efc24e9d5e2f, Provider: $d36baff69136067a$var$Provider } = $d36baff69136067a$var$ThemeContext;
function $d36baff69136067a$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $d36baff69136067a$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $d36baff69136067a$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $7DB8U.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)($d36baff69136067a$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $d36baff69136067a$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $7DB8U.useContext)($d36baff69136067a$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $d36baff69136067a$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $7DB8U.useContext)($d36baff69136067a$var$ThemeContext);
    return breakpoints;
}
function $d36baff69136067a$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $7DB8U.useContext)($d36baff69136067a$var$ThemeContext);
    return minBreakpoint;
}
function $d36baff69136067a$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $7DB8U.useContext)($d36baff69136067a$var$ThemeContext);
    return dir === 'rtl';
}
function $d36baff69136067a$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $7DB8U.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $d36baff69136067a$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $d36baff69136067a$export$2e2bcd8739ae039 = $d36baff69136067a$var$ThemeProvider;



"use client";
const $e4f2607df5423ec3$var$Button = /*#__PURE__*/ $7DB8U.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $ca03a707c779611a$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$e4f2607df5423ec3$var$Button.displayName = 'Button';
var $e4f2607df5423ec3$export$2e2bcd8739ae039 = $e4f2607df5423ec3$var$Button;



var $7DB8U = parcelRequire("7DB8U");


"use client";
function $51362f0aeeaa849e$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $d36baff69136067a$export$8970c8db816a5863)();
    const minBreakpoint = (0, $d36baff69136067a$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $51362f0aeeaa849e$var$Col = /*#__PURE__*/ $7DB8U.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $51362f0aeeaa849e$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, !spans.length && bsPrefix)
    });
});
$51362f0aeeaa849e$var$Col.displayName = 'Col';
var $51362f0aeeaa849e$export$2e2bcd8739ae039 = $51362f0aeeaa849e$var$Col;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $e2f451e3d449ae45$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $687967af0f2f65dd$export$2e2bcd8739ae039(node) {
    var doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $bab365215d6465d0$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $687967af0f2f65dd$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $bb45a00770e1e637$var$rUpper = /([A-Z])/g;
function $bb45a00770e1e637$export$2e2bcd8739ae039(string) {
    return string.replace($bb45a00770e1e637$var$rUpper, '-$1').toLowerCase();
}


var $b9e9e022259fd181$var$msPattern = /^ms-/;
function $b9e9e022259fd181$export$2e2bcd8739ae039(string) {
    return (0, $bb45a00770e1e637$export$2e2bcd8739ae039)(string).replace($b9e9e022259fd181$var$msPattern, '-ms-');
}


var $cfefa1cd0af90d26$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $cfefa1cd0af90d26$export$2e2bcd8739ae039(value) {
    return !!(value && $cfefa1cd0af90d26$var$supportedTransforms.test(value));
}


function $8e0039237f2a8b13$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(property)) || (0, $bab365215d6465d0$export$2e2bcd8739ae039)(node).getPropertyValue((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(key));
        else if ((0, $cfefa1cd0af90d26$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $b9e9e022259fd181$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $8e0039237f2a8b13$export$2e2bcd8739ae039 = $8e0039237f2a8b13$var$style;



var $7DB8U = parcelRequire("7DB8U");
function $00f30e90ee9941ee$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $50953dc634c28d5e$export$2e2bcd8739ae039(t, e) {
    return $50953dc634c28d5e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $50953dc634c28d5e$export$2e2bcd8739ae039(t, e);
}


function $92d77d83ed66349d$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $50953dc634c28d5e$export$2e2bcd8739ae039)(t, o);
}




var $7DB8U = parcelRequire("7DB8U");

var $9lImh = parcelRequire("9lImh");
var $ecff25fb561c6893$export$2e2bcd8739ae039 = {
    disabled: false
};




var $7DB8U = parcelRequire("7DB8U");
var $83af386bc15fe7aa$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).createContext(null);


var $539ec384df747b33$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $6d8a24823bc267eb$export$bb38bb9a1161268 = 'unmounted';
var $6d8a24823bc267eb$export$84cbff306f539230 = 'exited';
var $6d8a24823bc267eb$export$df38205c966be359 = 'entering';
var $6d8a24823bc267eb$export$78e9e6e3e014d60a = 'entered';
var $6d8a24823bc267eb$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $6d8a24823bc267eb$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $92d77d83ed66349d$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $6d8a24823bc267eb$export$84cbff306f539230;
                _this.appearStatus = $6d8a24823bc267eb$export$df38205c966be359;
            } else initialStatus = $6d8a24823bc267eb$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $6d8a24823bc267eb$export$bb38bb9a1161268;
        else initialStatus = $6d8a24823bc267eb$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $6d8a24823bc267eb$export$bb38bb9a1161268) return {
            status: $6d8a24823bc267eb$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $6d8a24823bc267eb$export$df38205c966be359 && status !== $6d8a24823bc267eb$export$78e9e6e3e014d60a) nextStatus = $6d8a24823bc267eb$export$df38205c966be359;
            } else if (status === $6d8a24823bc267eb$export$df38205c966be359 || status === $6d8a24823bc267eb$export$78e9e6e3e014d60a) nextStatus = $6d8a24823bc267eb$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $6d8a24823bc267eb$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9lImh))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $539ec384df747b33$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $6d8a24823bc267eb$export$84cbff306f539230) this.setState({
            status: $6d8a24823bc267eb$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($9lImh))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $ecff25fb561c6893$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $6d8a24823bc267eb$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $6d8a24823bc267eb$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $6d8a24823bc267eb$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($9lImh))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $ecff25fb561c6893$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $6d8a24823bc267eb$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $6d8a24823bc267eb$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $6d8a24823bc267eb$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9lImh))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $6d8a24823bc267eb$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $00f30e90ee9941ee$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).createElement((0, $83af386bc15fe7aa$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).Component);
$6d8a24823bc267eb$var$Transition.contextType = (0, $83af386bc15fe7aa$export$2e2bcd8739ae039);
$6d8a24823bc267eb$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $6d8a24823bc267eb$var$noop() {}
$6d8a24823bc267eb$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $6d8a24823bc267eb$var$noop,
    onEntering: $6d8a24823bc267eb$var$noop,
    onEntered: $6d8a24823bc267eb$var$noop,
    onExit: $6d8a24823bc267eb$var$noop,
    onExiting: $6d8a24823bc267eb$var$noop,
    onExited: $6d8a24823bc267eb$var$noop
};
$6d8a24823bc267eb$var$Transition.UNMOUNTED = $6d8a24823bc267eb$export$bb38bb9a1161268;
$6d8a24823bc267eb$var$Transition.EXITED = $6d8a24823bc267eb$export$84cbff306f539230;
$6d8a24823bc267eb$var$Transition.ENTERING = $6d8a24823bc267eb$export$df38205c966be359;
$6d8a24823bc267eb$var$Transition.ENTERED = $6d8a24823bc267eb$export$78e9e6e3e014d60a;
$6d8a24823bc267eb$var$Transition.EXITING = $6d8a24823bc267eb$export$4aacc83d4d59139f;
var $6d8a24823bc267eb$export$2e2bcd8739ae039 = $6d8a24823bc267eb$var$Transition;



var $7DB8U = parcelRequire("7DB8U");
function $36a3340f9542756b$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $36a3340f9542756b$export$13e065f3a74cfe36() {
    const parts = $7DB8U.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $36a3340f9542756b$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $36a3340f9542756b$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}




/* eslint-disable no-return-assign */ var $c36f36ded4bef1c0$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $7e72389cdcb8fa2e$export$63fefd044b2bc624 = false;
var $7e72389cdcb8fa2e$export$a614c6b395900f69 = false;
try {
    var $7e72389cdcb8fa2e$var$options = {
        get passive () {
            return $7e72389cdcb8fa2e$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $7e72389cdcb8fa2e$export$a614c6b395900f69 = $7e72389cdcb8fa2e$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) {
        window.addEventListener('test', $7e72389cdcb8fa2e$var$options, $7e72389cdcb8fa2e$var$options);
        window.removeEventListener('test', $7e72389cdcb8fa2e$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $7e72389cdcb8fa2e$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$7e72389cdcb8fa2e$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$7e72389cdcb8fa2e$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $7e72389cdcb8fa2e$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $7e72389cdcb8fa2e$export$2e2bcd8739ae039 = $7e72389cdcb8fa2e$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $1570e8bef8c3dfba$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $1570e8bef8c3dfba$export$2e2bcd8739ae039 = $1570e8bef8c3dfba$var$removeEventListener;


function $e30c1a8b3e180f01$var$listen(node, eventName, handler, options) {
    (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $e30c1a8b3e180f01$export$2e2bcd8739ae039 = $e30c1a8b3e180f01$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $86531d9dcbce6c08$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $d247f6e7f04e903f$var$parseDuration(node) {
    var str = (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $d247f6e7f04e903f$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $86531d9dcbce6c08$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $d247f6e7f04e903f$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $d247f6e7f04e903f$var$parseDuration(element) || 0;
    var removeEmulate = $d247f6e7f04e903f$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $3d830b57987dc180$var$parseDuration(node, property) {
    const str = (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $3d830b57987dc180$export$2e2bcd8739ae039(element, handler) {
    const duration = $3d830b57987dc180$var$parseDuration(element, 'transitionDuration');
    const delay = $3d830b57987dc180$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $d247f6e7f04e903f$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $e8368103dfe16a7d$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $e8368103dfe16a7d$export$2e2bcd8739ae039 = $e8368103dfe16a7d$var$createChainedFunction;


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $772cecf998cebdd5$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $7DB8U = parcelRequire("7DB8U");


var $7DB8U = parcelRequire("7DB8U");
const $1e2b613deffe4140$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $1e2b613deffe4140$export$c9058316764c140e(refA, refB) {
    const a = $1e2b613deffe4140$var$toFnRef(refA);
    const b = $1e2b613deffe4140$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $1e2b613deffe4140$var$useMergedRefs(refA, refB) {
    return (0, $7DB8U.useMemo)(()=>$1e2b613deffe4140$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $1e2b613deffe4140$export$2e2bcd8739ae039 = $1e2b613deffe4140$var$useMergedRefs;



var $9lImh = parcelRequire("9lImh");
function $ed8c95812e06aea0$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($9lImh))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $2fc98acac168f363$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $7DB8U.useRef)(null);
    const mergedRef = (0, $1e2b613deffe4140$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $ed8c95812e06aea0$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $7DB8U.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $7DB8U.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $7DB8U.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $7DB8U.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $7DB8U.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $7DB8U.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $7DB8U.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $6d8a24823bc267eb$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).cloneElement(children, {
            ref: attachRef
        })
    });
});
$2fc98acac168f363$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $2fc98acac168f363$export$2e2bcd8739ae039 = $2fc98acac168f363$var$TransitionWrapper;



const $7476d4e4f4ba1c12$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $7476d4e4f4ba1c12$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $7476d4e4f4ba1c12$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $7476d4e4f4ba1c12$var$collapseStyles = {
    [(0, $6d8a24823bc267eb$export$84cbff306f539230)]: 'collapse',
    [(0, $6d8a24823bc267eb$export$4aacc83d4d59139f)]: 'collapsing',
    [(0, $6d8a24823bc267eb$export$df38205c966be359)]: 'collapsing',
    [(0, $6d8a24823bc267eb$export$78e9e6e3e014d60a)]: 'collapse show'
};
const $7476d4e4f4ba1c12$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $7476d4e4f4ba1c12$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $7DB8U.useMemo)(()=>(0, $e8368103dfe16a7d$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $7DB8U.useMemo)(()=>(0, $e8368103dfe16a7d$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $7DB8U.useMemo)(()=>(0, $e8368103dfe16a7d$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $7DB8U.useMemo)(()=>(0, $e8368103dfe16a7d$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $772cecf998cebdd5$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $7DB8U.useMemo)(()=>(0, $e8368103dfe16a7d$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $2fc98acac168f363$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $3d830b57987dc180$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $36a3340f9542756b$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, children.props.className, $7476d4e4f4ba1c12$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
$7476d4e4f4ba1c12$var$Collapse.displayName = 'Collapse';
var $7476d4e4f4ba1c12$export$2e2bcd8739ae039 = $7476d4e4f4ba1c12$var$Collapse;



var $7DB8U = parcelRequire("7DB8U");


"use client";
const $6d27f416cee9d181$var$Container = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$6d27f416cee9d181$var$Container.displayName = 'Container';
var $6d27f416cee9d181$export$2e2bcd8739ae039 = $6d27f416cee9d181$var$Container;



var $7DB8U = parcelRequire("7DB8U");


"use client";
const $e2e7a3888803d0e1$var$Row = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'row');
    const breakpoints = (0, $d36baff69136067a$export$8970c8db816a5863)();
    const minBreakpoint = (0, $d36baff69136067a$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$e2e7a3888803d0e1$var$Row.displayName = 'Row';
var $e2e7a3888803d0e1$export$2e2bcd8739ae039 = $e2e7a3888803d0e1$var$Row;


var $1be8aacc786f9a64$exports = {};
'use strict';
function $1be8aacc786f9a64$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1be8aacc786f9a64$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1be8aacc786f9a64$var$checkDCE();

$1be8aacc786f9a64$exports = (parcelRequire("40IcI"));


var $5b9516050fe8824f$exports = {};
var $3f00cc594615b3bc$exports = {};

$parcel$export($3f00cc594615b3bc$exports, "animate", () => $3f00cc594615b3bc$export$e3607ec2d7a891c4);
function $3f00cc594615b3bc$export$e3607ec2d7a891c4(name) {
    return (element)=>element && new IntersectionObserver(([{ isIntersecting: isIntersecting, target: target }], observer)=>{
            if (!isIntersecting) return;
            const classes = [
                'animate__animated',
                `animate__${name}`
            ];
            target.classList.add(...classes);
            target.addEventListener('animationend', ()=>target.classList.remove(...classes), {
                once: true
            });
            observer.disconnect();
        }).observe(element);
}


var $bbe3314f1df38781$exports = {};

$parcel$export($bbe3314f1df38781$exports, "Avatar", () => $bbe3314f1df38781$export$e2255cf6045e8d47);


var $bbe3314f1df38781$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $bbe3314f1df38781$export$e2255cf6045e8d47 = (_a)=>{
    var { className: className, style: style, size: size = 3 } = _a, props = $bbe3314f1df38781$var$__rest(_a, [
        "className",
        "style",
        "size"
    ]);
    return (0, $e830bf8f8acfe41d$exports.jsx)("img", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('object-fit-cover rounded-circle', className),
        style: Object.assign({
            width: `${size}rem`,
            height: `${size}rem`
        }, style)
    }, props));
};
$bbe3314f1df38781$export$e2255cf6045e8d47.displayName = 'Avatar';


var $b5fd569e8732cd5e$exports = {};

$parcel$export($b5fd569e8732cd5e$exports, "ClickBoundary", () => $b5fd569e8732cd5e$export$707fce199b8e37aa);


var $7DB8U = parcelRequire("7DB8U");
var $b5fd569e8732cd5e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $b5fd569e8732cd5e$export$707fce199b8e37aa extends (0, $7DB8U.PureComponent) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "root", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: /*#__PURE__*/ (0, $7DB8U.createRef)()
        });
        Object.defineProperty(this, "switchClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event)=>{
                var _a;
                const { onInnerClick: onInnerClick, onOuterClick: onOuterClick } = this.props;
                if ((_a = this.root.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) onInnerClick === null || onInnerClick === void 0 || onInnerClick(event);
                else onOuterClick === null || onOuterClick === void 0 || onOuterClick(event);
            }
        });
    }
    componentDidMount() {
        window.addEventListener('click', this.switchClick, true);
    }
    componentWillUnmount() {
        window.removeEventListener('click', this.switchClick, true);
    }
    render() {
        const _a = this.props, { children: children, onInnerClick: onInnerClick, onOuterClick: onOuterClick } = _a, props = $b5fd569e8732cd5e$var$__rest(_a, [
            "children",
            "onInnerClick",
            "onOuterClick"
        ]);
        return (0, $e830bf8f8acfe41d$exports.jsx)("div", Object.assign({
            ref: this.root
        }, props, {
            children: children
        }));
    }
}


var $f3be3fdd0ed40ade$exports = {};

$parcel$export($f3be3fdd0ed40ade$exports, "CodeBlock", () => $f3be3fdd0ed40ade$export$6c415d1fdae3dfdb);

const $fd0801c4416ab412$var$lang = Object.freeze(JSON.parse("{\"displayName\":\"JavaScript\",\"name\":\"javascript\",\"patterns\":[{\"include\":\"#directives\"},{\"include\":\"#statements\"},{\"include\":\"#shebang\"}],\"repository\":{\"access-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(abstract|declare|override|public|protected|private|readonly|static)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js\"},\"after-operator-block-as-object-literal\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[!(+,:=>?\\\\[]|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^yield|[^$._[:alnum:]]yield|^throw|[^$._[:alnum:]]throw|^in|[^$._[:alnum:]]in|^of|[^$._[:alnum:]]of|^typeof|[^$._[:alnum:]]typeof|&&|\\\\|\\\\||\\\\*)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.objectliteral.js\",\"patterns\":[{\"include\":\"#object-member\"}]},\"array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"patterns\":[{\"include\":\"#binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"array-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"patterns\":[{\"include\":\"#binding-element-const\"},{\"include\":\"#punctuation-comma\"}]},\"array-literal\":{\"begin\":\"\\\\s*(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.square.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.js\"}},\"name\":\"meta.array.literal.js\",\"patterns\":[{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]},\"arrow-function\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"variable.parameter.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async)\\\\s+)?([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?==>)\",\"name\":\"meta.arrow.js\"},{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async))?((?<![]!)}])\\\\s*(?=((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.arrow.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#arrow-return-type\"},{\"include\":\"#possibly-arrow-return-type\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.js\"}},\"end\":\"((?<=[}\\\\S])(?<!=>)|((?!\\\\{)(?=\\\\S)))(?!/[*/])\",\"name\":\"meta.arrow.js\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"}]}]},\"arrow-return-type\":{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.return.type.arrow.js\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"arrow-return-type-body\":{\"patterns\":[{\"begin\":\"(?<=:)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"async-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(async)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.async.js\"},\"binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#array-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"}]},\"binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"}]},\"boolean-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))true(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.true.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))false(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.false.js\"}]},\"brackets\":{\"patterns\":[{\"begin\":\"\\\\{\",\"end\":\"}|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]},{\"begin\":\"\\\\[\",\"end\":\"]|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]}]},\"cast\":{\"patterns\":[{\"include\":\"#jsx\"}]},\"class-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(class)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.type.class.js\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.js\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-declaration-or-expression-patterns\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.class.js\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"class-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(class)\\\\b(?=\\\\s+|[<{]|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"storage.type.class.js\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.js\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-or-interface-body\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#decorator\"},{\"begin\":\"(?<=:)\\\\s*\",\"end\":\"(?=[-\\\\])+,:;}\\\\s]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#string\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#access-modifier\"},{\"include\":\"#property-accessor\"},{\"include\":\"#async-modifier\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"}]},\"class-or-interface-heritage\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(extends|implements)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"end\":\"(?=\\\\{)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"include\":\"#type-parameters\"},{\"include\":\"#expressionWithoutIdentifiers\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*(\\\\s*\\\\??\\\\.\\\\s*[$_[:alpha:]][$_[:alnum:]]*)*\\\\s*)\"},{\"captures\":{\"1\":{\"name\":\"entity.other.inherited-class.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\"},{\"include\":\"#expressionPunctuations\"}]},\"comment\":{\"patterns\":[{\"begin\":\"/\\\\*\\\\*(?!/)\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js\"}},\"name\":\"comment.block.documentation.js\",\"patterns\":[{\"include\":\"#docblock\"}]},{\"begin\":\"(/\\\\*)(?:\\\\s*((@)internal)(?=\\\\s|(\\\\*/)))?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.js\"},\"2\":{\"name\":\"storage.type.internaldeclaration.js\"},\"3\":{\"name\":\"punctuation.decorator.internaldeclaration.js\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js\"}},\"name\":\"comment.block.js\"},{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.js\"},\"2\":{\"name\":\"comment.line.double-slash.js\"},\"3\":{\"name\":\"punctuation.definition.comment.js\"},\"4\":{\"name\":\"storage.type.internaldeclaration.js\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.js\"}},\"contentName\":\"comment.line.double-slash.js\",\"end\":\"(?=$)\"}]},\"control-statement\":{\"patterns\":[{\"include\":\"#switch-statement\"},{\"include\":\"#for-loop\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(catch|finally|throw|try)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.trycatch.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.loop.js\"},\"2\":{\"name\":\"entity.name.label.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|goto)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|do|goto|while)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.loop.js\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(return)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.flow.js\"}},\"end\":\"(?=[;}]|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default|switch)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.switch.js\"},{\"include\":\"#if-statement\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(else|if)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.conditional.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(with)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.with.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(package)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(debugger)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.other.debugger.js\"}]},\"decl-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.block.js\",\"patterns\":[{\"include\":\"#statements\"}]},\"declaration\":{\"patterns\":[{\"include\":\"#decorator\"},{\"include\":\"#var-expr\"},{\"include\":\"#function-declaration\"},{\"include\":\"#class-declaration\"},{\"include\":\"#interface-declaration\"},{\"include\":\"#enum-declaration\"},{\"include\":\"#namespace-declaration\"},{\"include\":\"#type-alias-declaration\"},{\"include\":\"#import-equals-declaration\"},{\"include\":\"#import-declaration\"},{\"include\":\"#export-declaration\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(declare|export)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js\"}]},\"decorator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))@\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.decorator.js\"}},\"end\":\"(?=\\\\s)\",\"name\":\"meta.decorator.js\",\"patterns\":[{\"include\":\"#expression\"}]},\"destructuring-const\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.js\",\"patterns\":[{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.js\",\"patterns\":[{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-parameter\":{\"patterns\":[{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"name\":\"meta.parameter.object-binding-pattern.js\",\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"name\":\"meta.paramter.array-binding-pattern.js\",\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]}]},\"destructuring-parameter-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"variable.parameter.js\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.js\",\"patterns\":[{\"include\":\"#object-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.js\",\"patterns\":[{\"include\":\"#array-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-variable-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"meta.definition.variable.js variable.other.readwrite.js\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable-rest-const\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"meta.definition.variable.js variable.other.constant.js\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"directives\":{\"begin\":\"^(///)\\\\s*(?=<(reference|amd-dependency|amd-module)(\\\\s+(path|types|no-default-lib|lib|name|resolution-mode)\\\\s*=\\\\s*(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))+\\\\s*/>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.js\"}},\"end\":\"(?=$)\",\"name\":\"comment.line.triple-slash.directive.js\",\"patterns\":[{\"begin\":\"(<)(reference|amd-dependency|amd-module)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.directive.js\"},\"2\":{\"name\":\"entity.name.tag.directive.js\"}},\"end\":\"/>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.directive.js\"}},\"name\":\"meta.tag.js\",\"patterns\":[{\"match\":\"path|types|no-default-lib|lib|name|resolution-mode\",\"name\":\"entity.other.attribute-name.directive.js\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.js\"},{\"include\":\"#string\"}]}]},\"docblock\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.access-type.jsdoc\"}},\"match\":\"((@)a(?:ccess|pi))\\\\s+(p(?:rivate|rotected|ublic))\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"5\":{\"name\":\"constant.other.email.link.underline.jsdoc\"},\"6\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"match\":\"((@)author)\\\\s+([^*/<>@\\\\s](?:[^*/<>@]|\\\\*[^/])*)(?:\\\\s*(<)([^>\\\\s]+)(>))?\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"keyword.operator.control.jsdoc\"},\"5\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)borrows)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\\\\s+(as)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)example)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=@|\\\\*/)\",\"name\":\"meta.example.jsdoc\",\"patterns\":[{\"match\":\"^\\\\s\\\\*\\\\s+\"},{\"begin\":\"\\\\G(<)caption(>)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"contentName\":\"constant.other.description.jsdoc\",\"end\":\"(</)caption(>)|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}}},{\"captures\":{\"0\":{\"name\":\"source.embedded.js\"}},\"match\":\"[^*@\\\\s](?:[^*]|\\\\*[^/])*\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.symbol-type.jsdoc\"}},\"match\":\"((@)kind)\\\\s+(class|constant|event|external|file|function|member|mixin|module|namespace|typedef)\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"4\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)see)\\\\s+(?:((?=https?://)(?:[^*\\\\s]|\\\\*[^/])+)|((?!https?://|(?:\\\\[[^]\\\\[]*])?\\\\{@(?:link|linkcode|linkplain|tutorial)\\\\b)(?:[^*/@\\\\s]|\\\\*[^/])+))\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)template)\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*(?:\\\\s*,\\\\s*[$A-Z_a-z][]$.\\\\[\\\\w]*)*)\"},{\"begin\":\"((@)template)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:arg|argument|const|constant|member|namespace|param|var))\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*)\"},{\"begin\":\"((@)typedef)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"(?:[^*/@\\\\s]|\\\\*[^/])+\",\"name\":\"entity.name.type.instance.jsdoc\"}]},{\"begin\":\"((@)(?:arg|argument|const|constant|member|namespace|param|prop|property|var))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.optional-value.begin.bracket.square.jsdoc\"},\"2\":{\"name\":\"keyword.operator.assignment.jsdoc\"},\"3\":{\"name\":\"source.embedded.js\"},\"4\":{\"name\":\"punctuation.definition.optional-value.end.bracket.square.jsdoc\"},\"5\":{\"name\":\"invalid.illegal.syntax.jsdoc\"}},\"match\":\"(\\\\[)\\\\s*[$\\\\w]+(?:(?:\\\\[])?\\\\.[$\\\\w]+)*(?:\\\\s*(=)\\\\s*((?>\\\"(?:\\\\*(?!/)|\\\\\\\\(?!\\\")|[^*\\\\\\\\])*?\\\"|'(?:\\\\*(?!/)|\\\\\\\\(?!')|[^*\\\\\\\\])*?'|\\\\[(?:\\\\*(?!/)|[^*])*?]|(?:\\\\*(?!/)|\\\\s(?!\\\\s*])|\\\\[.*?(?:]|(?=\\\\*/))|[^]*\\\\[\\\\s])*)*))?\\\\s*(?:(])((?:[^*\\\\s]|\\\\*[^/\\\\s])+)?|(?=\\\\*/))\",\"name\":\"variable.other.jsdoc\"}]},{\"begin\":\"((@)(?:define|enum|exception|export|extends|lends|implements|modifies|namespace|private|protected|returns?|satisfies|suppress|this|throws|type|yields?))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)(?:alias|augments|callback|constructs|emits|event|fires|exports?|extends|external|function|func|host|lends|listens|interface|memberof!?|method|module|mixes|mixin|name|requires|see|this|typedef|uses))\\\\s+((?:[^*@{}\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)(?:default(?:value)?|license|version))\\\\s+(([\\\"']))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.string.begin.jsdoc\"}},\"contentName\":\"variable.other.jsdoc\",\"end\":\"(\\\\3)|(?=$|\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"variable.other.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.string.end.jsdoc\"}}},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:default(?:value)?|license|tutorial|variation|version))\\\\s+([^*\\\\s]+)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"(@)(?:abstract|access|alias|api|arg|argument|async|attribute|augments|author|beta|borrows|bubbles|callback|chainable|class|classdesc|code|config|const|constant|constructor|constructs|copyright|default|defaultvalue|define|deprecated|desc|description|dict|emits|enum|event|example|exception|exports?|extends|extension(?:_?for)?|external|externs|file|fileoverview|final|fires|for|func|function|generator|global|hideconstructor|host|ignore|implements|implicitCast|inherit[Dd]oc|inner|instance|interface|internal|kind|lends|license|listens|main|member|memberof!?|method|mixes|mixins?|modifies|module|name|namespace|noalias|nocollapse|nocompile|nosideeffects|override|overview|package|param|polymer(?:Behavior)?|preserve|private|prop|property|protected|public|read[Oo]nly|record|require[ds]|returns?|see|since|static|struct|submodule|summary|suppress|template|this|throws|todo|tutorial|type|typedef|unrestricted|uses|var|variation|version|virtual|writeOnce|yields?)\\\\b\",\"name\":\"storage.type.class.jsdoc\"},{\"include\":\"#inline-tags\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"((@)[$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s+)\"}]},\"enum-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:\\\\b(const)\\\\s+)?\\\\b(enum)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.type.enum.js\"},\"5\":{\"name\":\"entity.name.type.enum.js\"}},\"end\":\"(?<=})\",\"name\":\"meta.enum.declaration.js\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"0\":{\"name\":\"variable.other.enummember.js\"}},\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"begin\":\"(?=(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+])))\",\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"export-declaration\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"keyword.control.as.js\"},\"3\":{\"name\":\"storage.type.namespace.js\"},\"4\":{\"name\":\"entity.name.type.module.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)\\\\s+(as)\\\\s+(namespace)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?(?:\\\\s*(=)|\\\\s+(default)(?=\\\\s+))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"keyword.control.type.js\"},\"3\":{\"name\":\"keyword.operator.assignment.js\"},\"4\":{\"name\":\"keyword.control.default.js\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.default.js\",\"patterns\":[{\"include\":\"#interface-declaration\"},{\"include\":\"#expression\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?\\\\b(?!(\\\\$)|(\\\\s*:))((?=\\\\s*[*{])|((?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*([,\\\\s]))(?!\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"keyword.control.type.js\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.js\",\"patterns\":[{\"include\":\"#import-export-declaration\"}]}]},\"expression\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-inside-possibly-arrow-parens\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"entity.name.function.js variable.language.this.js\"},\"4\":{\"name\":\"entity.name.function.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"4\":{\"name\":\"variable.parameter.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*[,:]|$)\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-operators\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(await)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.flow.js\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?=\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*\\\\*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.flow.js\"}},\"end\":\"\\\\*\",\"endCaptures\":{\"0\":{\"name\":\"keyword.generator.asterisk.js\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.control.flow.js\"},\"2\":{\"name\":\"keyword.generator.asterisk.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s*(\\\\*))?\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))delete(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.delete.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))in(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.in.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))of(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.of.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.instanceof.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.new.js\"},{\"include\":\"#typeof-operator\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))void(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.void.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js\"},\"2\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*($|[]),:;}]))\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.js\"},\"2\":{\"name\":\"keyword.control.satisfies.js\"}},\"end\":\"(?=^|[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisfies)\\\\s+)|(\\\\s+<))\",\"patterns\":[{\"include\":\"#type\"}]},{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.spread.js\"},{\"match\":\"(?:\\\\*|(?<!\\\\()/|[-%+])=\",\"name\":\"keyword.operator.assignment.compound.js\"},{\"match\":\"(?:[\\\\&^]|<<|>>>??|\\\\|)=\",\"name\":\"keyword.operator.assignment.compound.bitwise.js\"},{\"match\":\"<<|>>>?\",\"name\":\"keyword.operator.bitwise.shift.js\"},{\"match\":\"[!=]==?\",\"name\":\"keyword.operator.comparison.js\"},{\"match\":\"<=|>=|<>|[<>]\",\"name\":\"keyword.operator.relational.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.logical.js\"},\"2\":{\"name\":\"keyword.operator.assignment.compound.js\"},\"3\":{\"name\":\"keyword.operator.arithmetic.js\"}},\"match\":\"(?<=[$_[:alnum:]])(!)\\\\s*(?:(/=)|(/)(?![*/]))\"},{\"match\":\"!|&&|\\\\|\\\\||\\\\?\\\\?\",\"name\":\"keyword.operator.logical.js\"},{\"match\":\"[\\\\&^|~]\",\"name\":\"keyword.operator.bitwise.js\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.js\"},{\"match\":\"--\",\"name\":\"keyword.operator.decrement.js\"},{\"match\":\"\\\\+\\\\+\",\"name\":\"keyword.operator.increment.js\"},{\"match\":\"[-%*+/]\",\"name\":\"keyword.operator.arithmetic.js\"},{\"begin\":\"(?<=[]$)_[:alnum:]])\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)+(?:(/=)|(/)(?![*/])))\",\"end\":\"(/=)|(/)(?!\\\\*([^*]|(\\\\*[^/]))*\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.js\"},\"2\":{\"name\":\"keyword.operator.arithmetic.js\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.js\"},\"2\":{\"name\":\"keyword.operator.arithmetic.js\"}},\"match\":\"(?<=[]$)_[:alnum:]])\\\\s*(?:(/=)|(/)(?![*/]))\"}]},\"expressionPunctuations\":{\"patterns\":[{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-accessor\"}]},\"expressionWithoutIdentifiers\":{\"patterns\":[{\"include\":\"#jsx\"},{\"include\":\"#string\"},{\"include\":\"#regex\"},{\"include\":\"#comment\"},{\"include\":\"#function-expression\"},{\"include\":\"#class-expression\"},{\"include\":\"#arrow-function\"},{\"include\":\"#paren-expression-possibly-arrow\"},{\"include\":\"#cast\"},{\"include\":\"#ternary-expression\"},{\"include\":\"#new-expr\"},{\"include\":\"#instanceof-expr\"},{\"include\":\"#object-literal\"},{\"include\":\"#expression-operators\"},{\"include\":\"#function-call\"},{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#paren-expression\"}]},\"field-declaration\":{\"begin\":\"(?<!\\\\()(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s+)?(?=\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=}]|$))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"end\":\"(?=[,;}]|$|^((?!\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=]|$))))|(?<=})\",\"name\":\"meta.field.declaration.js\",\"patterns\":[{\"include\":\"#variable-initializer\"},{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"meta.definition.property.js entity.name.function.js\"},\"2\":{\"name\":\"keyword.operator.optional.js\"},\"3\":{\"name\":\"keyword.operator.definiteassignment.js\"}},\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)(?:(\\\\?)|(!))?(?=\\\\s*\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"match\":\"#?[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.property.js variable.object.property.js\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.js\"},{\"match\":\"!\",\"name\":\"keyword.operator.definiteassignment.js\"}]},\"for-loop\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))for(?=((\\\\s+|(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*))await)?\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)?(\\\\())\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.loop.js\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"await\",\"name\":\"keyword.control.loop.js\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#var-expr\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"}]}]},\"function-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#return-type\"},{\"include\":\"#type-function-return-type\"},{\"include\":\"#decl-block\"},{\"match\":\"\\\\*\",\"name\":\"keyword.generator.asterisk.js\"}]},\"function-call\":{\"patterns\":[{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"end\":\"(?<=\\\\))(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"name\":\"meta.function-call.js\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"},{\"include\":\"#paren-expression\"}]},{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"end\":\"(?<=>)(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"name\":\"meta.function-call.js\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"}]}]},\"function-call-optionals\":{\"patterns\":[{\"match\":\"\\\\?\\\\.\",\"name\":\"meta.function-call.js punctuation.accessor.optional.js\"},{\"match\":\"!\",\"name\":\"meta.function-call.js keyword.operator.definiteassignment.js\"}]},\"function-call-target\":{\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.js\"}]},\"function-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.async.js\"},\"4\":{\"name\":\"storage.type.function.js\"},\"5\":{\"name\":\"keyword.generator.asterisk.js\"},\"6\":{\"name\":\"meta.definition.function.js entity.name.function.js\"}},\"end\":\"(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|(?<=})\",\"name\":\"meta.function.js\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#function-body\"}]},\"function-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"storage.type.function.js\"},\"3\":{\"name\":\"keyword.generator.asterisk.js\"},\"4\":{\"name\":\"meta.definition.function.js entity.name.function.js\"}},\"end\":\"(?=;)|(?<=})\",\"name\":\"meta.function.expression.js\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#function-body\"}]},\"function-name\":{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.function.js entity.name.function.js\"},\"function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.begin.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.end.js\"}},\"name\":\"meta.parameters.js\",\"patterns\":[{\"include\":\"#function-parameters-body\"}]},\"function-parameters-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"include\":\"#parameter-name\"},{\"include\":\"#parameter-type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js\"}]},\"identifiers\":{\"patterns\":[{\"include\":\"#object-identifiers\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"entity.name.function.js\"}},\"match\":\"(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"variable.other.constant.property.js\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"variable.other.property.js\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"match\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\",\"name\":\"variable.other.constant.js\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"variable.other.readwrite.js\"}]},\"if-statement\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bif\\\\s*(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))\\\\s*(?!\\\\{))\",\"end\":\"(?=;|$|})\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(if)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.js\"},\"2\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<=\\\\))\\\\s*/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"keyword.other.js\"}},\"name\":\"string.regexp.js\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"include\":\"#statements\"}]}]},\"import-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type)(?!\\\\s+from))?(?!\\\\s*[(:])(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"keyword.control.import.js\"},\"4\":{\"name\":\"keyword.control.type.js\"}},\"end\":\"(?<!(?:^|[^$._[:alnum:]])import)(?=;|$|^)\",\"name\":\"meta.import.js\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"begin\":\"(?<=(?:^|[^$._[:alnum:]])import)(?!\\\\s*[\\\"'])\",\"end\":\"\\\\bfrom\\\\b\",\"endCaptures\":{\"0\":{\"name\":\"keyword.control.from.js\"}},\"patterns\":[{\"include\":\"#import-export-declaration\"}]},{\"include\":\"#import-export-declaration\"}]},\"import-equals-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(require)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"keyword.control.import.js\"},\"4\":{\"name\":\"keyword.control.type.js\"},\"5\":{\"name\":\"variable.other.readwrite.alias.js\"},\"6\":{\"name\":\"keyword.operator.assignment.js\"},\"7\":{\"name\":\"keyword.control.require.js\"},\"8\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"name\":\"meta.import-equals.external.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(?!require\\\\b)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"keyword.control.import.js\"},\"4\":{\"name\":\"keyword.control.type.js\"},\"5\":{\"name\":\"variable.other.readwrite.alias.js\"},\"6\":{\"name\":\"keyword.operator.assignment.js\"}},\"end\":\"(?=;|$|^)\",\"name\":\"meta.import-equals.internal.js\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.other.readwrite.js\"}]}]},\"import-export-assert-clause\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(with)|(assert))\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.with.js\"},\"2\":{\"name\":\"keyword.control.assert.js\"},\"3\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object-literal.key.js\"},{\"match\":\":\",\"name\":\"punctuation.separator.key-value.js\"}]},\"import-export-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.block.js\",\"patterns\":[{\"include\":\"#import-export-clause\"}]},\"import-export-clause\":{\"patterns\":[{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.js\"},\"2\":{\"name\":\"keyword.control.default.js\"},\"3\":{\"name\":\"constant.language.import-export-all.js\"},\"4\":{\"name\":\"variable.other.readwrite.js\"},\"5\":{\"name\":\"string.quoted.alias.js\"},\"12\":{\"name\":\"keyword.control.as.js\"},\"13\":{\"name\":\"keyword.control.default.js\"},\"14\":{\"name\":\"variable.other.readwrite.alias.js\"},\"15\":{\"name\":\"string.quoted.alias.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(type)\\\\s+)?(?:\\\\b(default)|(\\\\*)|\\\\b([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\\\\s+(as)\\\\s+(?:(default(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"\\\\*\",\"name\":\"constant.language.import-export-all.js\"},{\"match\":\"\\\\b(default)\\\\b\",\"name\":\"keyword.control.default.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.js\"},\"2\":{\"name\":\"variable.other.readwrite.alias.js\"},\"3\":{\"name\":\"string.quoted.alias.js\"}},\"match\":\"(?:\\\\b(type)\\\\s+)?(?:([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"}]},\"import-export-declaration\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#import-export-block\"},{\"match\":\"\\\\bfrom\\\\b\",\"name\":\"keyword.control.from.js\"},{\"include\":\"#import-export-assert-clause\"},{\"include\":\"#import-export-clause\"}]},\"indexer-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=:)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"meta.brace.square.js\"},\"3\":{\"name\":\"variable.parameter.js\"}},\"end\":\"(])\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.js\"},\"2\":{\"name\":\"keyword.operator.optional.js\"}},\"name\":\"meta.indexer.declaration.js\",\"patterns\":[{\"include\":\"#type-annotation\"}]},\"indexer-mapped-type-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([-+])?(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s+(in)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.modifier.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"meta.brace.square.js\"},\"4\":{\"name\":\"entity.name.type.js\"},\"5\":{\"name\":\"keyword.operator.expression.in.js\"}},\"end\":\"(])([-+])?\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.js\"},\"2\":{\"name\":\"keyword.operator.type.modifier.js\"},\"3\":{\"name\":\"keyword.operator.optional.js\"}},\"name\":\"meta.indexer.mappedtype.declaration.js\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+\"},{\"include\":\"#type\"}]},\"inline-tags\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.bracket.square.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.square.end.jsdoc\"}},\"match\":\"(\\\\[)[^]]+(])(?=\\\\{@(?:link|linkcode|linkplain|tutorial))\",\"name\":\"constant.other.description.jsdoc\"},{\"begin\":\"(\\\\{)((@)(?:link(?:code|plain)?|tutorial))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"},\"2\":{\"name\":\"storage.type.class.jsdoc\"},\"3\":{\"name\":\"punctuation.definition.inline.tag.jsdoc\"}},\"end\":\"}|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"name\":\"entity.name.type.instance.jsdoc\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?=https?://)(?:[^*|}\\\\s]|\\\\*/)+)(\\\\|)?\"},{\"captures\":{\"1\":{\"name\":\"variable.other.description.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?:[^*@{|}\\\\s]|\\\\*[^/])+)(\\\\|)?\"}]}]},\"instanceof-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(instanceof)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.instanceof.js\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|([!=]==?)|(([\\\\&^|~]\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s+instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"patterns\":[{\"include\":\"#type\"}]},\"interface-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(interface)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.type.interface.js\"}},\"end\":\"(?<=})\",\"name\":\"meta.interface.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.interface.js\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"jsdoctype\":{\"patterns\":[{\"begin\":\"\\\\G(\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"}},\"contentName\":\"entity.name.type.instance.jsdoc\",\"end\":\"((}))\\\\s*|(?=\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"patterns\":[{\"include\":\"#brackets\"}]}]},\"jsx\":{\"patterns\":[{\"include\":\"#jsx-tag-without-attributes-in-expression\"},{\"include\":\"#jsx-tag-in-expression\"}]},\"jsx-children\":{\"patterns\":[{\"include\":\"#jsx-tag-without-attributes\"},{\"include\":\"#jsx-tag\"},{\"include\":\"#jsx-evaluated-code\"},{\"include\":\"#jsx-entities\"}]},\"jsx-entities\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.js\"},\"3\":{\"name\":\"punctuation.definition.entity.js\"}},\"match\":\"(&)([0-9A-Za-z]+|#[0-9]+|#x\\\\h+)(;)\",\"name\":\"constant.character.entity.js\"}]},\"jsx-evaluated-code\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.embedded.begin.js\"}},\"contentName\":\"meta.embedded.expression.js\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.embedded.end.js\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"jsx-string-double-quoted\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.js\"}},\"name\":\"string.quoted.double.js\",\"patterns\":[{\"include\":\"#jsx-entities\"}]},\"jsx-string-single-quoted\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"'\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.js\"}},\"name\":\"string.quoted.single.js\",\"patterns\":[{\"include\":\"#jsx-entities\"}]},\"jsx-tag\":{\"begin\":\"(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"end\":\"(/>)|(</)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.js\"},\"2\":{\"name\":\"punctuation.definition.tag.begin.js\"},\"3\":{\"name\":\"entity.name.tag.namespace.js\"},\"4\":{\"name\":\"punctuation.separator.namespace.js\"},\"5\":{\"name\":\"entity.name.tag.js\"},\"6\":{\"name\":\"support.class.component.js\"},\"7\":{\"name\":\"punctuation.definition.tag.end.js\"}},\"name\":\"meta.tag.js\",\"patterns\":[{\"begin\":\"(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js\"},\"2\":{\"name\":\"entity.name.tag.namespace.js\"},\"3\":{\"name\":\"punctuation.separator.namespace.js\"},\"4\":{\"name\":\"entity.name.tag.js\"},\"5\":{\"name\":\"support.class.component.js\"}},\"end\":\"(?=/?>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-arguments\"},{\"include\":\"#jsx-tag-attributes\"}]},{\"begin\":\"(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.js\"}},\"contentName\":\"meta.jsx.children.js\",\"end\":\"(?=</)\",\"patterns\":[{\"include\":\"#jsx-children\"}]}]},\"jsx-tag-attribute-assignment\":{\"match\":\"=(?=\\\\s*(?:[\\\"'{]|/\\\\*|//|\\\\n))\",\"name\":\"keyword.operator.assignment.js\"},\"jsx-tag-attribute-name\":{\"captures\":{\"1\":{\"name\":\"entity.other.attribute-name.namespace.js\"},\"2\":{\"name\":\"punctuation.separator.namespace.js\"},\"3\":{\"name\":\"entity.other.attribute-name.js\"}},\"match\":\"\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(:))?([$_[:alpha:]][-$_[:alnum:]]*)(?=[=\\\\s]|/?>|/\\\\*|//)\"},\"jsx-tag-attributes\":{\"begin\":\"\\\\s+\",\"end\":\"(?=/?>)\",\"name\":\"meta.tag.attributes.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#jsx-tag-attribute-name\"},{\"include\":\"#jsx-tag-attribute-assignment\"},{\"include\":\"#jsx-string-double-quoted\"},{\"include\":\"#jsx-string-single-quoted\"},{\"include\":\"#jsx-evaluated-code\"},{\"include\":\"#jsx-tag-attributes-illegal\"}]},\"jsx-tag-attributes-illegal\":{\"match\":\"\\\\S+\",\"name\":\"invalid.illegal.attribute.js\"},\"jsx-tag-in-expression\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[(*,:=>?\\\\[{]|&&|\\\\|\\\\||\\\\?|\\\\*/|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^default|[^$._[:alnum:]]default|^yield|[^$._[:alnum:]]yield|^)\\\\s*(?!<\\\\s*[$_[:alpha:]][$_[:alnum:]]*((\\\\s+extends\\\\s+[^=>])|,))(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"end\":\"(?!(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"patterns\":[{\"include\":\"#jsx-tag\"}]},\"jsx-tag-without-attributes\":{\"begin\":\"(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js\"},\"2\":{\"name\":\"entity.name.tag.namespace.js\"},\"3\":{\"name\":\"punctuation.separator.namespace.js\"},\"4\":{\"name\":\"entity.name.tag.js\"},\"5\":{\"name\":\"support.class.component.js\"},\"6\":{\"name\":\"punctuation.definition.tag.end.js\"}},\"contentName\":\"meta.jsx.children.js\",\"end\":\"(</)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js\"},\"2\":{\"name\":\"entity.name.tag.namespace.js\"},\"3\":{\"name\":\"punctuation.separator.namespace.js\"},\"4\":{\"name\":\"entity.name.tag.js\"},\"5\":{\"name\":\"support.class.component.js\"},\"6\":{\"name\":\"punctuation.definition.tag.end.js\"}},\"name\":\"meta.tag.without-attributes.js\",\"patterns\":[{\"include\":\"#jsx-children\"}]},\"jsx-tag-without-attributes-in-expression\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[(*,:=>?\\\\[{]|&&|\\\\|\\\\||\\\\?|\\\\*/|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^default|[^$._[:alnum:]]default|^yield|[^$._[:alnum:]]yield|^)\\\\s*(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>))\",\"end\":\"(?!(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>))\",\"patterns\":[{\"include\":\"#jsx-tag-without-attributes\"}]},\"label\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.label.js\"},\"2\":{\"name\":\"punctuation.separator.label.js\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#decl-block\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.label.js\"},\"2\":{\"name\":\"punctuation.separator.label.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)\"}]},\"literal\":{\"patterns\":[{\"include\":\"#numeric-literal\"},{\"include\":\"#boolean-literal\"},{\"include\":\"#null-literal\"},{\"include\":\"#undefined-literal\"},{\"include\":\"#numericConstant-literal\"},{\"include\":\"#array-literal\"},{\"include\":\"#this-literal\"},{\"include\":\"#super-literal\"}]},\"method-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?\\\\s*\\\\b(constructor)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.modifier.async.js\"},\"5\":{\"name\":\"storage.type.js\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\s*\\\\b(new)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))|(?:(\\\\*)\\\\s*)?)(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.modifier.async.js\"},\"5\":{\"name\":\"keyword.operator.new.js\"},\"6\":{\"name\":\"keyword.generator.asterisk.js\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.modifier.async.js\"},\"5\":{\"name\":\"storage.type.property.js\"},\"6\":{\"name\":\"keyword.generator.asterisk.js\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]}]},\"method-declaration-name\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??)\\\\s*[(<])\",\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.method.js entity.name.function.js\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.js\"}]},\"namespace-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(namespace|module)\\\\s+(?=[\\\"$'_`[:alpha:]])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.namespace.js\"}},\"end\":\"(?<=})|(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.namespace.declaration.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.type.module.js\"},{\"include\":\"#punctuation-accessor\"},{\"include\":\"#decl-block\"}]},\"new-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.new.js\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"name\":\"new.expr.js\",\"patterns\":[{\"include\":\"#expression\"}]},\"null-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))null(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.null.js\"},\"numeric-literal\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js\"}},\"match\":\"\\\\b(?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.hex.js\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js\"}},\"match\":\"\\\\b(?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.binary.js\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js\"}},\"match\":\"\\\\b(?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.octal.js\"},{\"captures\":{\"0\":{\"name\":\"constant.numeric.decimal.js\"},\"1\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"2\":{\"name\":\"storage.type.numeric.bigint.js\"},\"3\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"4\":{\"name\":\"storage.type.numeric.bigint.js\"},\"5\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"6\":{\"name\":\"storage.type.numeric.bigint.js\"},\"7\":{\"name\":\"storage.type.numeric.bigint.js\"},\"8\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"9\":{\"name\":\"storage.type.numeric.bigint.js\"},\"10\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"11\":{\"name\":\"storage.type.numeric.bigint.js\"},\"12\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"13\":{\"name\":\"storage.type.numeric.bigint.js\"},\"14\":{\"name\":\"storage.type.numeric.bigint.js\"}},\"match\":\"(?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)\"}]},\"numericConstant-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))NaN(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.nan.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Infinity(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.infinity.js\"}]},\"object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element\"}]},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element-const\"}]},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-propertyName\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(:)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.destructuring.js\"}},\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.object.property.js\"}]},\"object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"patterns\":[{\"include\":\"#object-binding-element\"}]},\"object-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"patterns\":[{\"include\":\"#object-binding-element-const\"}]},\"object-identifiers\":{\"patterns\":[{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*\\\\??\\\\.\\\\s*prototype\\\\b(?!\\\\$))\",\"name\":\"support.class.js\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"variable.other.constant.object.property.js\"},\"4\":{\"name\":\"variable.other.object.property.js\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(#?\\\\p{upper}[$_\\\\d[:upper:]]*)|(#?[$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"captures\":{\"1\":{\"name\":\"variable.other.constant.object.js\"},\"2\":{\"name\":\"variable.other.object.js\"}},\"match\":\"(?:(\\\\p{upper}[$_\\\\d[:upper:]]*)|([$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"}]},\"object-literal\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.objectliteral.js\",\"patterns\":[{\"include\":\"#object-member\"}]},\"object-literal-method-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"storage.type.property.js\"},\"3\":{\"name\":\"keyword.generator.asterisk.js\"}},\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"storage.type.property.js\"},\"3\":{\"name\":\"keyword.generator.asterisk.js\"}},\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#method-declaration-name\"}]}]},\"object-member\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#object-literal-method-declaration\"},{\"begin\":\"(?=\\\\[)\",\"end\":\"(?=:)|((?<=])(?=\\\\s*[(<]))\",\"name\":\"meta.object.member.js meta.object-literal.key.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#array-literal\"}]},{\"begin\":\"(?=[\\\"'`])\",\"end\":\"(?=:)|((?<=[\\\"'`])(?=((\\\\s*[(,<}])|(\\\\s+(as|satisifies)\\\\s+))))\",\"name\":\"meta.object.member.js meta.object-literal.key.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?=\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)))\",\"end\":\"(?=:)|(?=\\\\s*([(,<}])|(\\\\s+as|satisifies\\\\s+))\",\"name\":\"meta.object.member.js meta.object-literal.key.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#numeric-literal\"}]},{\"begin\":\"(?<=[]\\\"'`])(?=\\\\s*[(<])\",\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#function-body\"}]},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js\"},\"1\":{\"name\":\"constant.numeric.decimal.js\"}},\"match\":\"(?![$_[:alpha:]])(\\\\d+)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.js\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js\"},\"1\":{\"name\":\"entity.name.function.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/)*\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\",\"name\":\"meta.object.member.js\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.js\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.js\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.js\",\"patterns\":[{\"include\":\"#expression\"}]},{\"captures\":{\"1\":{\"name\":\"variable.other.readwrite.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js\"},\"2\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*([,}]|$))\",\"name\":\"meta.object.member.js\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.js\"},\"2\":{\"name\":\"keyword.control.satisfies.js\"}},\"end\":\"(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|^|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisifies)\\\\s+))\",\"name\":\"meta.object.member.js\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(?=[$_[:alpha:]][$_[:alnum:]]*\\\\s*=)\",\"end\":\"(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.js\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\":\",\"beginCaptures\":{\"0\":{\"name\":\"meta.object-literal.key.js punctuation.separator.key-value.js\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.js\",\"patterns\":[{\"begin\":\"(?<=:)\\\\s*(async)?(?=\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(?=<\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<=>)\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"include\":\"#possibly-arrow-return-type\"},{\"include\":\"#expression\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#decl-block\"}]},\"parameter-array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#parameter-array-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"}]},\"parameter-name\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"entity.name.function.js variable.language.this.js\"},\"4\":{\"name\":\"entity.name.function.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"4\":{\"name\":\"variable.parameter.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)\"}]},\"parameter-object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#parameter-binding-element\"},{\"include\":\"#paren-expression\"}]},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},\"parameter-type-annotation\":{\"patterns\":[{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?=[),])|(?==[^>])\",\"name\":\"meta.type.annotation.js\",\"patterns\":[{\"include\":\"#type\"}]}]},\"paren-expression\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"paren-expression-possibly-arrow\":{\"patterns\":[{\"begin\":\"(?<=[(,=])\\\\s*(async)?(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"begin\":\"(?<=[(,=]|=>|^return|[^$._[:alnum:]]return)\\\\s*(async)?(?=\\\\s*((((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()|(<)|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)))\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"include\":\"#possibly-arrow-return-type\"}]},\"paren-expression-possibly-arrow-with-typeparameters\":{\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},\"possibly-arrow-return-type\":{\"begin\":\"(?<=\\\\)|^)\\\\s*(:)(?=\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*=>)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.arrow.js meta.return.type.arrow.js keyword.operator.type.annotation.js\"}},\"contentName\":\"meta.arrow.js meta.return.type.arrow.js\",\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"property-accessor\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(accessor|get|set)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.type.property.js\"},\"punctuation-accessor\":{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"}},\"match\":\"(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d))\"},\"punctuation-comma\":{\"match\":\",\",\"name\":\"punctuation.separator.comma.js\"},\"punctuation-semicolon\":{\"match\":\";\",\"name\":\"punctuation.terminator.statement.js\"},\"qstring-double\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(\\\")|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"invalid.illegal.newline.js\"}},\"name\":\"string.quoted.double.js\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"qstring-single\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(')|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"invalid.illegal.newline.js\"}},\"name\":\"string.quoted.single.js\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"regex\":{\"patterns\":[{\"begin\":\"(?<!\\\\+\\\\+|--|})(?<=[!(+,:=?\\\\[]|^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case|=>|&&|\\\\|\\\\||\\\\*/)\\\\s*(/)(?![*/])(?=(?:[^()/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)+]|\\\\(([^)\\\\\\\\]|\\\\\\\\.)+\\\\))+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"keyword.other.js\"}},\"name\":\"string.regexp.js\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"((?<![]$)_[:alnum:]]|\\\\+\\\\+|--|}|\\\\*/)|((?<=^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case))\\\\s*)/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"keyword.other.js\"}},\"name\":\"string.regexp.js\",\"patterns\":[{\"include\":\"#regexp\"}]}]},\"regex-character-class\":{\"patterns\":[{\"match\":\"\\\\\\\\[DSWdfnrstvw]|\\\\.\",\"name\":\"constant.other.character-class.regexp\"},{\"match\":\"\\\\\\\\([0-7]{3}|x\\\\h{2}|u\\\\h{4})\",\"name\":\"constant.character.numeric.regexp\"},{\"match\":\"\\\\\\\\c[A-Z]\",\"name\":\"constant.character.control.regexp\"},{\"match\":\"\\\\\\\\.\",\"name\":\"constant.character.escape.backslash.regexp\"}]},\"regexp\":{\"patterns\":[{\"match\":\"\\\\\\\\[Bb]|[$^]\",\"name\":\"keyword.control.anchor.regexp\"},{\"captures\":{\"0\":{\"name\":\"keyword.other.back-reference.regexp\"},\"1\":{\"name\":\"variable.other.regexp\"}},\"match\":\"\\\\\\\\(?:[1-9]\\\\d*|k<([$A-Z_a-z][$\\\\w]*)>)\"},{\"match\":\"[*+?]|\\\\{(\\\\d+,\\\\d+|\\\\d+,|,\\\\d+|\\\\d+)}\\\\??\",\"name\":\"keyword.operator.quantifier.regexp\"},{\"match\":\"\\\\|\",\"name\":\"keyword.operator.or.regexp\"},{\"begin\":\"(\\\\()((\\\\?=)|(\\\\?!)|(\\\\?<=)|(\\\\?<!))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"},\"2\":{\"name\":\"punctuation.definition.group.assertion.regexp\"},\"3\":{\"name\":\"meta.assertion.look-ahead.regexp\"},\"4\":{\"name\":\"meta.assertion.negative-look-ahead.regexp\"},\"5\":{\"name\":\"meta.assertion.look-behind.regexp\"},\"6\":{\"name\":\"meta.assertion.negative-look-behind.regexp\"}},\"end\":\"(\\\\))\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.assertion.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"\\\\((?:(\\\\?:)|\\\\?<([$A-Z_a-z][$\\\\w]*)>)?\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"},\"1\":{\"name\":\"punctuation.definition.group.no-capture.regexp\"},\"2\":{\"name\":\"variable.other.regexp\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"(\\\\[)(\\\\^)?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"},\"2\":{\"name\":\"keyword.operator.negation.regexp\"}},\"end\":\"(])\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"}},\"name\":\"constant.other.character-class.set.regexp\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"constant.character.numeric.regexp\"},\"2\":{\"name\":\"constant.character.control.regexp\"},\"3\":{\"name\":\"constant.character.escape.backslash.regexp\"},\"4\":{\"name\":\"constant.character.numeric.regexp\"},\"5\":{\"name\":\"constant.character.control.regexp\"},\"6\":{\"name\":\"constant.character.escape.backslash.regexp\"}},\"match\":\"(?:.|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))-(?:[^]\\\\\\\\]|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))\",\"name\":\"constant.other.character-class.range.regexp\"},{\"include\":\"#regex-character-class\"}]},{\"include\":\"#regex-character-class\"}]},\"return-type\":{\"patterns\":[{\"begin\":\"(?<=\\\\))\\\\s*(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?<![\\\\&:|])(?=$|^|[,;{}]|//)\",\"name\":\"meta.return.type.js\",\"patterns\":[{\"include\":\"#return-type-core\"}]},{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?<![\\\\&:|])((?=[,;{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.return.type.js\",\"patterns\":[{\"include\":\"#return-type-core\"}]}]},\"return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<=[\\\\&:|])(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"shebang\":{\"captures\":{\"1\":{\"name\":\"punctuation.definition.comment.js\"}},\"match\":\"\\\\A(#!).*(?=$)\",\"name\":\"comment.line.shebang.js\"},\"single-line-comment-consuming-line-ending\":{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.js\"},\"2\":{\"name\":\"comment.line.double-slash.js\"},\"3\":{\"name\":\"punctuation.definition.comment.js\"},\"4\":{\"name\":\"storage.type.internaldeclaration.js\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.js\"}},\"contentName\":\"comment.line.double-slash.js\",\"end\":\"(?=^)\"},\"statements\":{\"patterns\":[{\"include\":\"#declaration\"},{\"include\":\"#control-statement\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#label\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template\"}]},\"string-character-escape\":{\"match\":\"\\\\\\\\(x\\\\h{2}|u\\\\h{4}|u\\\\{\\\\h+}|[012][0-7]{0,2}|3[0-6][0-7]?|37[0-7]?|[4-7][0-7]?|.|$)\",\"name\":\"constant.character.escape.js\"},\"super-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))super\\\\b(?!\\\\$)\",\"name\":\"variable.language.super.js\"},\"support-function-call-identifiers\":{\"patterns\":[{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#object-identifiers\"},{\"include\":\"#punctuation-accessor\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\(\\\\s*[\\\"'`])\",\"name\":\"keyword.operator.expression.import.js\"}]},\"support-objects\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(arguments)\\\\b(?!\\\\$)\",\"name\":\"variable.language.arguments.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(Promise)\\\\b(?!\\\\$)\",\"name\":\"support.class.promise.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.import.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"},\"4\":{\"name\":\"support.variable.property.importmeta.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(import)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(meta)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.new.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"},\"4\":{\"name\":\"support.variable.property.target.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(target)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"support.variable.property.js\"},\"4\":{\"name\":\"support.constant.js\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(constructor|length|prototype|__proto__)\\\\b(?!\\\\$|\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\()|(EPSILON|MAX_SAFE_INTEGER|MAX_VALUE|MIN_SAFE_INTEGER|MIN_VALUE|NEGATIVE_INFINITY|POSITIVE_INFINITY)\\\\b(?!\\\\$))\"},{\"captures\":{\"1\":{\"name\":\"support.type.object.module.js\"},\"2\":{\"name\":\"support.type.object.module.js\"},\"3\":{\"name\":\"punctuation.accessor.js\"},\"4\":{\"name\":\"punctuation.accessor.optional.js\"},\"5\":{\"name\":\"support.type.object.module.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(exports)|(module)(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(exports|id|filename|loaded|parent|children))?)\\\\b(?!\\\\$)\"}]},\"switch-statement\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bswitch\\\\s*\\\\()\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"switch-statement.expr.js\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(switch)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.js\"},\"2\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"name\":\"switch-expression.expr.js\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"(?=})\",\"name\":\"switch-block.expr.js\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default(?=:))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.js\"}},\"end\":\"(?=:)\",\"name\":\"case-clause.expr.js\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(:)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"case-clause.expr.js punctuation.definition.section.case-statement.js\"},\"2\":{\"name\":\"meta.block.js punctuation.definition.block.js\"}},\"contentName\":\"meta.block.js\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"meta.block.js punctuation.definition.block.js\"}},\"patterns\":[{\"include\":\"#statements\"}]},{\"captures\":{\"0\":{\"name\":\"case-clause.expr.js punctuation.definition.section.case-statement.js\"}},\"match\":\"(:)\"},{\"include\":\"#statements\"}]}]},\"template\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js\"},\"2\":{\"name\":\"string.template.js punctuation.definition.string.template.begin.js\"}},\"contentName\":\"string.template.js\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.js punctuation.definition.string.template.end.js\"}},\"patterns\":[{\"include\":\"#template-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-call\":{\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*)(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"end\":\"(?=`)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.tagged-template.js\"}]},{\"include\":\"#type-arguments\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?\\\\s*(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js\"}},\"end\":\"(?=`)\",\"patterns\":[{\"include\":\"#type-arguments\"}]}]},\"template-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.js\"}},\"contentName\":\"meta.embedded.line.js\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.js\"}},\"name\":\"meta.template.expression.js\",\"patterns\":[{\"include\":\"#expression\"}]},\"template-type\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js\"},\"2\":{\"name\":\"string.template.js punctuation.definition.string.template.begin.js\"}},\"contentName\":\"string.template.js\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.js punctuation.definition.string.template.end.js\"}},\"patterns\":[{\"include\":\"#template-type-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-type-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.js\"}},\"contentName\":\"meta.embedded.line.js\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.js\"}},\"name\":\"meta.template.expression.js\",\"patterns\":[{\"include\":\"#type\"}]},\"ternary-expression\":{\"begin\":\"(?!\\\\?\\\\.\\\\s*\\\\D)(\\\\?)(?!\\\\?)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.js\"}},\"end\":\"\\\\s*(:)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.js\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"this-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))this\\\\b(?!\\\\$)\",\"name\":\"variable.language.this.js\"},\"type\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#type-primitive\"},{\"include\":\"#type-builtin-literals\"},{\"include\":\"#type-parameters\"},{\"include\":\"#type-tuple\"},{\"include\":\"#type-object\"},{\"include\":\"#type-operators\"},{\"include\":\"#type-conditional\"},{\"include\":\"#type-fn-type-parameters\"},{\"include\":\"#type-paren-or-function-parameters\"},{\"include\":\"#type-function-return-type\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\"},{\"include\":\"#type-name\"}]},\"type-alias-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(type)\\\\b\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.type.js\"},\"4\":{\"name\":\"entity.name.type.alias.js\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.type.declaration.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"begin\":\"(=)\\\\s*(intrinsic)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js\"},\"2\":{\"name\":\"keyword.control.intrinsic.js\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(=)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-annotation\":{\"patterns\":[{\"begin\":\"(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?<![\\\\&:|])(?!\\\\s*[\\\\&|]\\\\s+)((?=^|[]),;}]|//)|(?==[^>])|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.js\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?<![\\\\&:|])((?=[]),;}]|//)|(?==[^>])|(?=^\\\\s*$)|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.js\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-arguments\":{\"begin\":\"<\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.begin.js\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.end.js\"}},\"name\":\"meta.type.parameters.js\",\"patterns\":[{\"include\":\"#type-arguments-body\"}]},\"type-arguments-body\":{\"patterns\":[{\"captures\":{\"0\":{\"name\":\"keyword.operator.type.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(_)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"type-builtin-literals\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(this|true|false|undefined|null|object)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.builtin.js\"},\"type-conditional\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"end\":\"(?<=:)\",\"patterns\":[{\"begin\":\"\\\\?\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.js\"}},\"end\":\":\",\"endCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.js\"}},\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#type\"}]}]},\"type-fn-type-parameters\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b(?=\\\\s*<)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.type.constructor.js storage.modifier.js\"},\"2\":{\"name\":\"meta.type.constructor.js keyword.control.new.js\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.control.new.js\"}},\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.constructor.js\",\"patterns\":[{\"include\":\"#function-parameters\"}]},{\"begin\":\"((?=\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>))))))\",\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.function.js\",\"patterns\":[{\"include\":\"#function-parameters\"}]}]},\"type-function-return-type\":{\"patterns\":[{\"begin\":\"(=>)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.function.arrow.js\"}},\"end\":\"(?<!=>)(?<![\\\\&|])(?=[]),:;=>?{}]|//|$)\",\"name\":\"meta.type.function.return.js\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.js\"}},\"end\":\"(?<!=>)(?<![\\\\&|])((?=[]),:;=>?{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.type.function.return.js\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]}]},\"type-function-return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<==>)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"type-infer\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.infer.js\"},\"2\":{\"name\":\"entity.name.type.js\"},\"3\":{\"name\":\"keyword.operator.expression.extends.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(infer)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s+(extends)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))?\",\"name\":\"meta.type.infer.js\"}]},\"type-name\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(<)\",\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"},\"4\":{\"name\":\"meta.type.parameters.js punctuation.definition.typeparameters.begin.js\"}},\"contentName\":\"meta.type.parameters.js\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.js punctuation.definition.typeparameters.end.js\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(<)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.type.js\"},\"2\":{\"name\":\"meta.type.parameters.js punctuation.definition.typeparameters.begin.js\"}},\"contentName\":\"meta.type.parameters.js\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.js punctuation.definition.typeparameters.end.js\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"entity.name.type.js\"}]},\"type-object\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.object.type.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#indexer-mapped-type-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#type-annotation\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.js\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#type\"}]},\"type-operators\":{\"patterns\":[{\"include\":\"#typeof-operator\"},{\"include\":\"#type-infer\"},{\"begin\":\"([\\\\&|])(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.js\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"begin\":\"[\\\\&|]\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.js\"}},\"end\":\"(?=\\\\S)\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))keyof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.keyof.js\"},{\"match\":\"([:?])\",\"name\":\"keyword.operator.ternary.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\()\",\"name\":\"keyword.operator.expression.import.js\"}]},\"type-parameters\":{\"begin\":\"(<)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.begin.js\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.end.js\"}},\"name\":\"meta.type.parameters.js\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends|in|out|const)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"(=)(?!>)\",\"name\":\"keyword.operator.assignment.js\"}]},\"type-paren-or-function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"name\":\"meta.type.paren.cover.js\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"entity.name.function.js variable.language.this.js\"},\"4\":{\"name\":\"entity.name.function.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=\\\\s*(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"4\":{\"name\":\"variable.parameter.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=:)\"},{\"include\":\"#type-annotation\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js\"},{\"include\":\"#type\"}]},\"type-predicate-operator\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.js\"},\"2\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"3\":{\"name\":\"variable.parameter.js\"},\"4\":{\"name\":\"keyword.operator.expression.is.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(asserts)\\\\s+)?(?!asserts)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s(is)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.js\"},\"2\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"3\":{\"name\":\"variable.parameter.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(asserts)\\\\s+(?!is)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))asserts(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.type.asserts.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))is(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.is.js\"}]},\"type-primitive\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(string|number|bigint|boolean|symbol|any|void|never|unknown)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.primitive.js\"},\"type-string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template-type\"}]},\"type-tuple\":{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.square.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.js\"}},\"name\":\"meta.type.tuple.js\",\"patterns\":[{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.rest.js\"},{\"captures\":{\"1\":{\"name\":\"entity.name.label.js\"},\"2\":{\"name\":\"keyword.operator.optional.js\"},\"3\":{\"name\":\"punctuation.separator.label.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(\\\\?)?\\\\s*(:)\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"typeof-operator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))typeof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.expression.typeof.js\"}},\"end\":\"(?=[]\\\\&),:;=>?{|}]|(extends\\\\s+)|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type-arguments\"},{\"include\":\"#expression\"}]},\"undefined-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))undefined(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.undefined.js\"},\"var-expr\":{\"patterns\":[{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!^let|[^$._[:alnum:]]let|^var|[^$._[:alnum:]]var)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]])const)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]]|^await\\\\s+|[^$._[:alnum:]]await\\\\s+)using)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*((?!\\\\S)|(?=//))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"var-single-const\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js variable.other.constant.js entity.name.function.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js variable.other.constant.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js entity.name.function.js\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js variable.other.constant.js\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js variable.other.readwrite.js\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable-type-annotation\":{\"patterns\":[{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"variable-initializer\":{\"patterns\":[{\"begin\":\"(?<![!=])(=)(?!=)(?=\\\\s*\\\\S)(?!\\\\s*.*=>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js\"}},\"end\":\"(?=$|^|[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<![!=])(=)(?!=)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js\"}},\"end\":\"(?=[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))|(?=^\\\\s*$)|(?<![-\\\\&*+/|])(?<=\\\\S)(?<!=)(?=\\\\s*$)\",\"patterns\":[{\"include\":\"#expression\"}]}]}},\"scopeName\":\"source.js\",\"aliases\":[\"js\",\"cjs\",\"mjs\"]}"));
var $fd0801c4416ab412$export$2e2bcd8739ae039 = [
    $fd0801c4416ab412$var$lang
];


const $efe74ad407a81fb4$var$lang = Object.freeze(JSON.parse("{\"displayName\":\"JSX\",\"name\":\"jsx\",\"patterns\":[{\"include\":\"#directives\"},{\"include\":\"#statements\"},{\"include\":\"#shebang\"}],\"repository\":{\"access-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(abstract|declare|override|public|protected|private|readonly|static)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js.jsx\"},\"after-operator-block-as-object-literal\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[!(+,:=>?\\\\[]|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^yield|[^$._[:alnum:]]yield|^throw|[^$._[:alnum:]]throw|^in|[^$._[:alnum:]]in|^of|[^$._[:alnum:]]of|^typeof|[^$._[:alnum:]]typeof|&&|\\\\|\\\\||\\\\*)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"name\":\"meta.objectliteral.js.jsx\",\"patterns\":[{\"include\":\"#object-member\"}]},\"array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"patterns\":[{\"include\":\"#binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"array-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"patterns\":[{\"include\":\"#binding-element-const\"},{\"include\":\"#punctuation-comma\"}]},\"array-literal\":{\"begin\":\"\\\\s*(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.square.js.jsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.js.jsx\"}},\"name\":\"meta.array.literal.js.jsx\",\"patterns\":[{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]},\"arrow-function\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"},\"2\":{\"name\":\"variable.parameter.js.jsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async)\\\\s+)?([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?==>)\",\"name\":\"meta.arrow.js.jsx\"},{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async))?((?<![]!)}])\\\\s*(?=((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.arrow.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#arrow-return-type\"},{\"include\":\"#possibly-arrow-return-type\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.js.jsx\"}},\"end\":\"((?<=[}\\\\S])(?<!=>)|((?!\\\\{)(?=\\\\S)))(?!/[*/])\",\"name\":\"meta.arrow.js.jsx\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"}]}]},\"arrow-return-type\":{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js.jsx\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.return.type.arrow.js.jsx\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"arrow-return-type-body\":{\"patterns\":[{\"begin\":\"(?<=:)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"async-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(async)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.async.js.jsx\"},\"binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#array-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"}]},\"binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"}]},\"boolean-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))true(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.true.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))false(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.false.js.jsx\"}]},\"brackets\":{\"patterns\":[{\"begin\":\"\\\\{\",\"end\":\"}|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]},{\"begin\":\"\\\\[\",\"end\":\"]|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]}]},\"cast\":{\"patterns\":[{\"include\":\"#jsx\"}]},\"class-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(class)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.modifier.js.jsx\"},\"4\":{\"name\":\"storage.type.class.js.jsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.js.jsx\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-declaration-or-expression-patterns\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.class.js.jsx\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"class-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(class)\\\\b(?=\\\\s+|[<{]|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"storage.type.class.js.jsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.js.jsx\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-or-interface-body\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#decorator\"},{\"begin\":\"(?<=:)\\\\s*\",\"end\":\"(?=[-\\\\])+,:;}\\\\s]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#string\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#access-modifier\"},{\"include\":\"#property-accessor\"},{\"include\":\"#async-modifier\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"}]},\"class-or-interface-heritage\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(extends|implements)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"}},\"end\":\"(?=\\\\{)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"include\":\"#type-parameters\"},{\"include\":\"#expressionWithoutIdentifiers\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.js.jsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.js.jsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*(\\\\s*\\\\??\\\\.\\\\s*[$_[:alpha:]][$_[:alnum:]]*)*\\\\s*)\"},{\"captures\":{\"1\":{\"name\":\"entity.other.inherited-class.js.jsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\"},{\"include\":\"#expressionPunctuations\"}]},\"comment\":{\"patterns\":[{\"begin\":\"/\\\\*\\\\*(?!/)\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js.jsx\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js.jsx\"}},\"name\":\"comment.block.documentation.js.jsx\",\"patterns\":[{\"include\":\"#docblock\"}]},{\"begin\":\"(/\\\\*)(?:\\\\s*((@)internal)(?=\\\\s|(\\\\*/)))?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.js.jsx\"},\"2\":{\"name\":\"storage.type.internaldeclaration.js.jsx\"},\"3\":{\"name\":\"punctuation.decorator.internaldeclaration.js.jsx\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js.jsx\"}},\"name\":\"comment.block.js.jsx\"},{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.js.jsx\"},\"2\":{\"name\":\"comment.line.double-slash.js.jsx\"},\"3\":{\"name\":\"punctuation.definition.comment.js.jsx\"},\"4\":{\"name\":\"storage.type.internaldeclaration.js.jsx\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.js.jsx\"}},\"contentName\":\"comment.line.double-slash.js.jsx\",\"end\":\"(?=$)\"}]},\"control-statement\":{\"patterns\":[{\"include\":\"#switch-statement\"},{\"include\":\"#for-loop\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(catch|finally|throw|try)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.trycatch.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.loop.js.jsx\"},\"2\":{\"name\":\"entity.name.label.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|goto)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|do|goto|while)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.loop.js.jsx\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(return)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.flow.js.jsx\"}},\"end\":\"(?=[;}]|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default|switch)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.switch.js.jsx\"},{\"include\":\"#if-statement\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(else|if)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.conditional.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(with)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.with.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(package)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(debugger)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.other.debugger.js.jsx\"}]},\"decl-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"name\":\"meta.block.js.jsx\",\"patterns\":[{\"include\":\"#statements\"}]},\"declaration\":{\"patterns\":[{\"include\":\"#decorator\"},{\"include\":\"#var-expr\"},{\"include\":\"#function-declaration\"},{\"include\":\"#class-declaration\"},{\"include\":\"#interface-declaration\"},{\"include\":\"#enum-declaration\"},{\"include\":\"#namespace-declaration\"},{\"include\":\"#type-alias-declaration\"},{\"include\":\"#import-equals-declaration\"},{\"include\":\"#import-declaration\"},{\"include\":\"#export-declaration\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(declare|export)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js.jsx\"}]},\"decorator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))@\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.decorator.js.jsx\"}},\"end\":\"(?=\\\\s)\",\"name\":\"meta.decorator.js.jsx\",\"patterns\":[{\"include\":\"#expression\"}]},\"destructuring-const\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.js.jsx\",\"patterns\":[{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.js.jsx\",\"patterns\":[{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-parameter\":{\"patterns\":[{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"name\":\"meta.parameter.object-binding-pattern.js.jsx\",\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"name\":\"meta.paramter.array-binding-pattern.js.jsx\",\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]}]},\"destructuring-parameter-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"variable.parameter.js.jsx\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.js.jsx\",\"patterns\":[{\"include\":\"#object-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.js.jsx\",\"patterns\":[{\"include\":\"#array-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-variable-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"meta.definition.variable.js.jsx variable.other.readwrite.js.jsx\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable-rest-const\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"meta.definition.variable.js.jsx variable.other.constant.js.jsx\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"directives\":{\"begin\":\"^(///)\\\\s*(?=<(reference|amd-dependency|amd-module)(\\\\s+(path|types|no-default-lib|lib|name|resolution-mode)\\\\s*=\\\\s*(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))+\\\\s*/>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.js.jsx\"}},\"end\":\"(?=$)\",\"name\":\"comment.line.triple-slash.directive.js.jsx\",\"patterns\":[{\"begin\":\"(<)(reference|amd-dependency|amd-module)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.directive.js.jsx\"},\"2\":{\"name\":\"entity.name.tag.directive.js.jsx\"}},\"end\":\"/>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.directive.js.jsx\"}},\"name\":\"meta.tag.js.jsx\",\"patterns\":[{\"match\":\"path|types|no-default-lib|lib|name|resolution-mode\",\"name\":\"entity.other.attribute-name.directive.js.jsx\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.js.jsx\"},{\"include\":\"#string\"}]}]},\"docblock\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.access-type.jsdoc\"}},\"match\":\"((@)a(?:ccess|pi))\\\\s+(p(?:rivate|rotected|ublic))\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"5\":{\"name\":\"constant.other.email.link.underline.jsdoc\"},\"6\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"match\":\"((@)author)\\\\s+([^*/<>@\\\\s](?:[^*/<>@]|\\\\*[^/])*)(?:\\\\s*(<)([^>\\\\s]+)(>))?\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"keyword.operator.control.jsdoc\"},\"5\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)borrows)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\\\\s+(as)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)example)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=@|\\\\*/)\",\"name\":\"meta.example.jsdoc\",\"patterns\":[{\"match\":\"^\\\\s\\\\*\\\\s+\"},{\"begin\":\"\\\\G(<)caption(>)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"contentName\":\"constant.other.description.jsdoc\",\"end\":\"(</)caption(>)|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}}},{\"captures\":{\"0\":{\"name\":\"source.embedded.js.jsx\"}},\"match\":\"[^*@\\\\s](?:[^*]|\\\\*[^/])*\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.symbol-type.jsdoc\"}},\"match\":\"((@)kind)\\\\s+(class|constant|event|external|file|function|member|mixin|module|namespace|typedef)\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"4\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)see)\\\\s+(?:((?=https?://)(?:[^*\\\\s]|\\\\*[^/])+)|((?!https?://|(?:\\\\[[^]\\\\[]*])?\\\\{@(?:link|linkcode|linkplain|tutorial)\\\\b)(?:[^*/@\\\\s]|\\\\*[^/])+))\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)template)\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*(?:\\\\s*,\\\\s*[$A-Z_a-z][]$.\\\\[\\\\w]*)*)\"},{\"begin\":\"((@)template)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:arg|argument|const|constant|member|namespace|param|var))\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*)\"},{\"begin\":\"((@)typedef)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"(?:[^*/@\\\\s]|\\\\*[^/])+\",\"name\":\"entity.name.type.instance.jsdoc\"}]},{\"begin\":\"((@)(?:arg|argument|const|constant|member|namespace|param|prop|property|var))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.optional-value.begin.bracket.square.jsdoc\"},\"2\":{\"name\":\"keyword.operator.assignment.jsdoc\"},\"3\":{\"name\":\"source.embedded.js.jsx\"},\"4\":{\"name\":\"punctuation.definition.optional-value.end.bracket.square.jsdoc\"},\"5\":{\"name\":\"invalid.illegal.syntax.jsdoc\"}},\"match\":\"(\\\\[)\\\\s*[$\\\\w]+(?:(?:\\\\[])?\\\\.[$\\\\w]+)*(?:\\\\s*(=)\\\\s*((?>\\\"(?:\\\\*(?!/)|\\\\\\\\(?!\\\")|[^*\\\\\\\\])*?\\\"|'(?:\\\\*(?!/)|\\\\\\\\(?!')|[^*\\\\\\\\])*?'|\\\\[(?:\\\\*(?!/)|[^*])*?]|(?:\\\\*(?!/)|\\\\s(?!\\\\s*])|\\\\[.*?(?:]|(?=\\\\*/))|[^]*\\\\[\\\\s])*)*))?\\\\s*(?:(])((?:[^*\\\\s]|\\\\*[^/\\\\s])+)?|(?=\\\\*/))\",\"name\":\"variable.other.jsdoc\"}]},{\"begin\":\"((@)(?:define|enum|exception|export|extends|lends|implements|modifies|namespace|private|protected|returns?|satisfies|suppress|this|throws|type|yields?))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)(?:alias|augments|callback|constructs|emits|event|fires|exports?|extends|external|function|func|host|lends|listens|interface|memberof!?|method|module|mixes|mixin|name|requires|see|this|typedef|uses))\\\\s+((?:[^*@{}\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)(?:default(?:value)?|license|version))\\\\s+(([\\\"']))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.string.begin.jsdoc\"}},\"contentName\":\"variable.other.jsdoc\",\"end\":\"(\\\\3)|(?=$|\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"variable.other.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.string.end.jsdoc\"}}},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:default(?:value)?|license|tutorial|variation|version))\\\\s+([^*\\\\s]+)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"(@)(?:abstract|access|alias|api|arg|argument|async|attribute|augments|author|beta|borrows|bubbles|callback|chainable|class|classdesc|code|config|const|constant|constructor|constructs|copyright|default|defaultvalue|define|deprecated|desc|description|dict|emits|enum|event|example|exception|exports?|extends|extension(?:_?for)?|external|externs|file|fileoverview|final|fires|for|func|function|generator|global|hideconstructor|host|ignore|implements|implicitCast|inherit[Dd]oc|inner|instance|interface|internal|kind|lends|license|listens|main|member|memberof!?|method|mixes|mixins?|modifies|module|name|namespace|noalias|nocollapse|nocompile|nosideeffects|override|overview|package|param|polymer(?:Behavior)?|preserve|private|prop|property|protected|public|read[Oo]nly|record|require[ds]|returns?|see|since|static|struct|submodule|summary|suppress|template|this|throws|todo|tutorial|type|typedef|unrestricted|uses|var|variation|version|virtual|writeOnce|yields?)\\\\b\",\"name\":\"storage.type.class.jsdoc\"},{\"include\":\"#inline-tags\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"((@)[$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s+)\"}]},\"enum-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:\\\\b(const)\\\\s+)?\\\\b(enum)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.modifier.js.jsx\"},\"4\":{\"name\":\"storage.type.enum.js.jsx\"},\"5\":{\"name\":\"entity.name.type.enum.js.jsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.enum.declaration.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"0\":{\"name\":\"variable.other.enummember.js.jsx\"}},\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"begin\":\"(?=(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+])))\",\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"export-declaration\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"keyword.control.as.js.jsx\"},\"3\":{\"name\":\"storage.type.namespace.js.jsx\"},\"4\":{\"name\":\"entity.name.type.module.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)\\\\s+(as)\\\\s+(namespace)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?(?:\\\\s*(=)|\\\\s+(default)(?=\\\\s+))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"keyword.control.type.js.jsx\"},\"3\":{\"name\":\"keyword.operator.assignment.js.jsx\"},\"4\":{\"name\":\"keyword.control.default.js.jsx\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.default.js.jsx\",\"patterns\":[{\"include\":\"#interface-declaration\"},{\"include\":\"#expression\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?\\\\b(?!(\\\\$)|(\\\\s*:))((?=\\\\s*[*{])|((?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*([,\\\\s]))(?!\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"keyword.control.type.js.jsx\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.js.jsx\",\"patterns\":[{\"include\":\"#import-export-declaration\"}]}]},\"expression\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-inside-possibly-arrow-parens\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"3\":{\"name\":\"entity.name.function.js.jsx variable.language.this.js.jsx\"},\"4\":{\"name\":\"entity.name.function.js.jsx\"},\"5\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"3\":{\"name\":\"variable.parameter.js.jsx variable.language.this.js.jsx\"},\"4\":{\"name\":\"variable.parameter.js.jsx\"},\"5\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*[,:]|$)\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js.jsx\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-operators\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(await)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.flow.js.jsx\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?=\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*\\\\*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.flow.js.jsx\"}},\"end\":\"\\\\*\",\"endCaptures\":{\"0\":{\"name\":\"keyword.generator.asterisk.js.jsx\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.control.flow.js.jsx\"},\"2\":{\"name\":\"keyword.generator.asterisk.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s*(\\\\*))?\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))delete(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.delete.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))in(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.in.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))of(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.of.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.instanceof.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.new.js.jsx\"},{\"include\":\"#typeof-operator\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))void(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.void.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*($|[]),:;}]))\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.js.jsx\"},\"2\":{\"name\":\"keyword.control.satisfies.js.jsx\"}},\"end\":\"(?=^|[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisfies)\\\\s+)|(\\\\s+<))\",\"patterns\":[{\"include\":\"#type\"}]},{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.spread.js.jsx\"},{\"match\":\"(?:\\\\*|(?<!\\\\()/|[-%+])=\",\"name\":\"keyword.operator.assignment.compound.js.jsx\"},{\"match\":\"(?:[\\\\&^]|<<|>>>??|\\\\|)=\",\"name\":\"keyword.operator.assignment.compound.bitwise.js.jsx\"},{\"match\":\"<<|>>>?\",\"name\":\"keyword.operator.bitwise.shift.js.jsx\"},{\"match\":\"[!=]==?\",\"name\":\"keyword.operator.comparison.js.jsx\"},{\"match\":\"<=|>=|<>|[<>]\",\"name\":\"keyword.operator.relational.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.logical.js.jsx\"},\"2\":{\"name\":\"keyword.operator.assignment.compound.js.jsx\"},\"3\":{\"name\":\"keyword.operator.arithmetic.js.jsx\"}},\"match\":\"(?<=[$_[:alnum:]])(!)\\\\s*(?:(/=)|(/)(?![*/]))\"},{\"match\":\"!|&&|\\\\|\\\\||\\\\?\\\\?\",\"name\":\"keyword.operator.logical.js.jsx\"},{\"match\":\"[\\\\&^|~]\",\"name\":\"keyword.operator.bitwise.js.jsx\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.js.jsx\"},{\"match\":\"--\",\"name\":\"keyword.operator.decrement.js.jsx\"},{\"match\":\"\\\\+\\\\+\",\"name\":\"keyword.operator.increment.js.jsx\"},{\"match\":\"[-%*+/]\",\"name\":\"keyword.operator.arithmetic.js.jsx\"},{\"begin\":\"(?<=[]$)_[:alnum:]])\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)+(?:(/=)|(/)(?![*/])))\",\"end\":\"(/=)|(/)(?!\\\\*([^*]|(\\\\*[^/]))*\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.js.jsx\"},\"2\":{\"name\":\"keyword.operator.arithmetic.js.jsx\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.js.jsx\"},\"2\":{\"name\":\"keyword.operator.arithmetic.js.jsx\"}},\"match\":\"(?<=[]$)_[:alnum:]])\\\\s*(?:(/=)|(/)(?![*/]))\"}]},\"expressionPunctuations\":{\"patterns\":[{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-accessor\"}]},\"expressionWithoutIdentifiers\":{\"patterns\":[{\"include\":\"#jsx\"},{\"include\":\"#string\"},{\"include\":\"#regex\"},{\"include\":\"#comment\"},{\"include\":\"#function-expression\"},{\"include\":\"#class-expression\"},{\"include\":\"#arrow-function\"},{\"include\":\"#paren-expression-possibly-arrow\"},{\"include\":\"#cast\"},{\"include\":\"#ternary-expression\"},{\"include\":\"#new-expr\"},{\"include\":\"#instanceof-expr\"},{\"include\":\"#object-literal\"},{\"include\":\"#expression-operators\"},{\"include\":\"#function-call\"},{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#paren-expression\"}]},\"field-declaration\":{\"begin\":\"(?<!\\\\()(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s+)?(?=\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=}]|$))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"}},\"end\":\"(?=[,;}]|$|^((?!\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=]|$))))|(?<=})\",\"name\":\"meta.field.declaration.js.jsx\",\"patterns\":[{\"include\":\"#variable-initializer\"},{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"meta.definition.property.js.jsx entity.name.function.js.jsx\"},\"2\":{\"name\":\"keyword.operator.optional.js.jsx\"},\"3\":{\"name\":\"keyword.operator.definiteassignment.js.jsx\"}},\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)(?:(\\\\?)|(!))?(?=\\\\s*\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"match\":\"#?[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.property.js.jsx variable.object.property.js.jsx\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.js.jsx\"},{\"match\":\"!\",\"name\":\"keyword.operator.definiteassignment.js.jsx\"}]},\"for-loop\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))for(?=((\\\\s+|(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*))await)?\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)?(\\\\())\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.loop.js.jsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"await\",\"name\":\"keyword.control.loop.js.jsx\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"patterns\":[{\"include\":\"#var-expr\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"}]}]},\"function-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#return-type\"},{\"include\":\"#type-function-return-type\"},{\"include\":\"#decl-block\"},{\"match\":\"\\\\*\",\"name\":\"keyword.generator.asterisk.js.jsx\"}]},\"function-call\":{\"patterns\":[{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"end\":\"(?<=\\\\))(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"name\":\"meta.function-call.js.jsx\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"},{\"include\":\"#paren-expression\"}]},{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"end\":\"(?<=>)(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"name\":\"meta.function-call.js.jsx\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"}]}]},\"function-call-optionals\":{\"patterns\":[{\"match\":\"\\\\?\\\\.\",\"name\":\"meta.function-call.js.jsx punctuation.accessor.optional.js.jsx\"},{\"match\":\"!\",\"name\":\"meta.function-call.js.jsx keyword.operator.definiteassignment.js.jsx\"}]},\"function-call-target\":{\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.js.jsx\"}]},\"function-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.modifier.async.js.jsx\"},\"4\":{\"name\":\"storage.type.function.js.jsx\"},\"5\":{\"name\":\"keyword.generator.asterisk.js.jsx\"},\"6\":{\"name\":\"meta.definition.function.js.jsx entity.name.function.js.jsx\"}},\"end\":\"(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|(?<=})\",\"name\":\"meta.function.js.jsx\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#function-body\"}]},\"function-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"},\"2\":{\"name\":\"storage.type.function.js.jsx\"},\"3\":{\"name\":\"keyword.generator.asterisk.js.jsx\"},\"4\":{\"name\":\"meta.definition.function.js.jsx entity.name.function.js.jsx\"}},\"end\":\"(?=;)|(?<=})\",\"name\":\"meta.function.expression.js.jsx\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#function-body\"}]},\"function-name\":{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.function.js.jsx entity.name.function.js.jsx\"},\"function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.begin.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.end.js.jsx\"}},\"name\":\"meta.parameters.js.jsx\",\"patterns\":[{\"include\":\"#function-parameters-body\"}]},\"function-parameters-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"include\":\"#parameter-name\"},{\"include\":\"#parameter-type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js.jsx\"}]},\"identifiers\":{\"patterns\":[{\"include\":\"#object-identifiers\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"3\":{\"name\":\"entity.name.function.js.jsx\"}},\"match\":\"(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"3\":{\"name\":\"variable.other.constant.property.js.jsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"3\":{\"name\":\"variable.other.property.js.jsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"match\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\",\"name\":\"variable.other.constant.js.jsx\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"variable.other.readwrite.js.jsx\"}]},\"if-statement\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bif\\\\s*(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))\\\\s*(?!\\\\{))\",\"end\":\"(?=;|$|})\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(if)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.js.jsx\"},\"2\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<=\\\\))\\\\s*/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js.jsx\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js.jsx\"},\"2\":{\"name\":\"keyword.other.js.jsx\"}},\"name\":\"string.regexp.js.jsx\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"include\":\"#statements\"}]}]},\"import-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type)(?!\\\\s+from))?(?!\\\\s*[(:])(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"keyword.control.import.js.jsx\"},\"4\":{\"name\":\"keyword.control.type.js.jsx\"}},\"end\":\"(?<!(?:^|[^$._[:alnum:]])import)(?=;|$|^)\",\"name\":\"meta.import.js.jsx\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"begin\":\"(?<=(?:^|[^$._[:alnum:]])import)(?!\\\\s*[\\\"'])\",\"end\":\"\\\\bfrom\\\\b\",\"endCaptures\":{\"0\":{\"name\":\"keyword.control.from.js.jsx\"}},\"patterns\":[{\"include\":\"#import-export-declaration\"}]},{\"include\":\"#import-export-declaration\"}]},\"import-equals-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(require)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"keyword.control.import.js.jsx\"},\"4\":{\"name\":\"keyword.control.type.js.jsx\"},\"5\":{\"name\":\"variable.other.readwrite.alias.js.jsx\"},\"6\":{\"name\":\"keyword.operator.assignment.js.jsx\"},\"7\":{\"name\":\"keyword.control.require.js.jsx\"},\"8\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"name\":\"meta.import-equals.external.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(?!require\\\\b)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"keyword.control.import.js.jsx\"},\"4\":{\"name\":\"keyword.control.type.js.jsx\"},\"5\":{\"name\":\"variable.other.readwrite.alias.js.jsx\"},\"6\":{\"name\":\"keyword.operator.assignment.js.jsx\"}},\"end\":\"(?=;|$|^)\",\"name\":\"meta.import-equals.internal.js.jsx\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.js.jsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.js.jsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.other.readwrite.js.jsx\"}]}]},\"import-export-assert-clause\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(with)|(assert))\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.with.js.jsx\"},\"2\":{\"name\":\"keyword.control.assert.js.jsx\"},\"3\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object-literal.key.js.jsx\"},{\"match\":\":\",\"name\":\"punctuation.separator.key-value.js.jsx\"}]},\"import-export-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"name\":\"meta.block.js.jsx\",\"patterns\":[{\"include\":\"#import-export-clause\"}]},\"import-export-clause\":{\"patterns\":[{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.js.jsx\"},\"2\":{\"name\":\"keyword.control.default.js.jsx\"},\"3\":{\"name\":\"constant.language.import-export-all.js.jsx\"},\"4\":{\"name\":\"variable.other.readwrite.js.jsx\"},\"5\":{\"name\":\"string.quoted.alias.js.jsx\"},\"12\":{\"name\":\"keyword.control.as.js.jsx\"},\"13\":{\"name\":\"keyword.control.default.js.jsx\"},\"14\":{\"name\":\"variable.other.readwrite.alias.js.jsx\"},\"15\":{\"name\":\"string.quoted.alias.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(type)\\\\s+)?(?:\\\\b(default)|(\\\\*)|\\\\b([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\\\\s+(as)\\\\s+(?:(default(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"\\\\*\",\"name\":\"constant.language.import-export-all.js.jsx\"},{\"match\":\"\\\\b(default)\\\\b\",\"name\":\"keyword.control.default.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.js.jsx\"},\"2\":{\"name\":\"variable.other.readwrite.alias.js.jsx\"},\"3\":{\"name\":\"string.quoted.alias.js.jsx\"}},\"match\":\"(?:\\\\b(type)\\\\s+)?(?:([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"}]},\"import-export-declaration\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#import-export-block\"},{\"match\":\"\\\\bfrom\\\\b\",\"name\":\"keyword.control.from.js.jsx\"},{\"include\":\"#import-export-assert-clause\"},{\"include\":\"#import-export-clause\"}]},\"indexer-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=:)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"meta.brace.square.js.jsx\"},\"3\":{\"name\":\"variable.parameter.js.jsx\"}},\"end\":\"(])\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.js.jsx\"},\"2\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"name\":\"meta.indexer.declaration.js.jsx\",\"patterns\":[{\"include\":\"#type-annotation\"}]},\"indexer-mapped-type-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([-+])?(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s+(in)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.modifier.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"meta.brace.square.js.jsx\"},\"4\":{\"name\":\"entity.name.type.js.jsx\"},\"5\":{\"name\":\"keyword.operator.expression.in.js.jsx\"}},\"end\":\"(])([-+])?\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.js.jsx\"},\"2\":{\"name\":\"keyword.operator.type.modifier.js.jsx\"},\"3\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"name\":\"meta.indexer.mappedtype.declaration.js.jsx\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+\"},{\"include\":\"#type\"}]},\"inline-tags\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.bracket.square.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.square.end.jsdoc\"}},\"match\":\"(\\\\[)[^]]+(])(?=\\\\{@(?:link|linkcode|linkplain|tutorial))\",\"name\":\"constant.other.description.jsdoc\"},{\"begin\":\"(\\\\{)((@)(?:link(?:code|plain)?|tutorial))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"},\"2\":{\"name\":\"storage.type.class.jsdoc\"},\"3\":{\"name\":\"punctuation.definition.inline.tag.jsdoc\"}},\"end\":\"}|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"name\":\"entity.name.type.instance.jsdoc\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?=https?://)(?:[^*|}\\\\s]|\\\\*/)+)(\\\\|)?\"},{\"captures\":{\"1\":{\"name\":\"variable.other.description.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?:[^*@{|}\\\\s]|\\\\*[^/])+)(\\\\|)?\"}]}]},\"instanceof-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(instanceof)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.instanceof.js.jsx\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|([!=]==?)|(([\\\\&^|~]\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s+instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"patterns\":[{\"include\":\"#type\"}]},\"interface-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(interface)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.modifier.js.jsx\"},\"4\":{\"name\":\"storage.type.interface.js.jsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.interface.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.interface.js.jsx\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"jsdoctype\":{\"patterns\":[{\"begin\":\"\\\\G(\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"}},\"contentName\":\"entity.name.type.instance.jsdoc\",\"end\":\"((}))\\\\s*|(?=\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"patterns\":[{\"include\":\"#brackets\"}]}]},\"jsx\":{\"patterns\":[{\"include\":\"#jsx-tag-without-attributes-in-expression\"},{\"include\":\"#jsx-tag-in-expression\"}]},\"jsx-children\":{\"patterns\":[{\"include\":\"#jsx-tag-without-attributes\"},{\"include\":\"#jsx-tag\"},{\"include\":\"#jsx-evaluated-code\"},{\"include\":\"#jsx-entities\"}]},\"jsx-entities\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.js.jsx\"},\"3\":{\"name\":\"punctuation.definition.entity.js.jsx\"}},\"match\":\"(&)([0-9A-Za-z]+|#[0-9]+|#x\\\\h+)(;)\",\"name\":\"constant.character.entity.js.jsx\"}]},\"jsx-evaluated-code\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.embedded.begin.js.jsx\"}},\"contentName\":\"meta.embedded.expression.js.jsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.embedded.end.js.jsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"jsx-string-double-quoted\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js.jsx\"}},\"end\":\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.js.jsx\"}},\"name\":\"string.quoted.double.js.jsx\",\"patterns\":[{\"include\":\"#jsx-entities\"}]},\"jsx-string-single-quoted\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js.jsx\"}},\"end\":\"'\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.js.jsx\"}},\"name\":\"string.quoted.single.js.jsx\",\"patterns\":[{\"include\":\"#jsx-entities\"}]},\"jsx-tag\":{\"begin\":\"(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"end\":\"(/>)|(</)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.tag.begin.js.jsx\"},\"3\":{\"name\":\"entity.name.tag.namespace.js.jsx\"},\"4\":{\"name\":\"punctuation.separator.namespace.js.jsx\"},\"5\":{\"name\":\"entity.name.tag.js.jsx\"},\"6\":{\"name\":\"support.class.component.js.jsx\"},\"7\":{\"name\":\"punctuation.definition.tag.end.js.jsx\"}},\"name\":\"meta.tag.js.jsx\",\"patterns\":[{\"begin\":\"(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js.jsx\"},\"2\":{\"name\":\"entity.name.tag.namespace.js.jsx\"},\"3\":{\"name\":\"punctuation.separator.namespace.js.jsx\"},\"4\":{\"name\":\"entity.name.tag.js.jsx\"},\"5\":{\"name\":\"support.class.component.js.jsx\"}},\"end\":\"(?=/?>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-arguments\"},{\"include\":\"#jsx-tag-attributes\"}]},{\"begin\":\"(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.js.jsx\"}},\"contentName\":\"meta.jsx.children.js.jsx\",\"end\":\"(?=</)\",\"patterns\":[{\"include\":\"#jsx-children\"}]}]},\"jsx-tag-attribute-assignment\":{\"match\":\"=(?=\\\\s*(?:[\\\"'{]|/\\\\*|//|\\\\n))\",\"name\":\"keyword.operator.assignment.js.jsx\"},\"jsx-tag-attribute-name\":{\"captures\":{\"1\":{\"name\":\"entity.other.attribute-name.namespace.js.jsx\"},\"2\":{\"name\":\"punctuation.separator.namespace.js.jsx\"},\"3\":{\"name\":\"entity.other.attribute-name.js.jsx\"}},\"match\":\"\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(:))?([$_[:alpha:]][-$_[:alnum:]]*)(?=[=\\\\s]|/?>|/\\\\*|//)\"},\"jsx-tag-attributes\":{\"begin\":\"\\\\s+\",\"end\":\"(?=/?>)\",\"name\":\"meta.tag.attributes.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#jsx-tag-attribute-name\"},{\"include\":\"#jsx-tag-attribute-assignment\"},{\"include\":\"#jsx-string-double-quoted\"},{\"include\":\"#jsx-string-single-quoted\"},{\"include\":\"#jsx-evaluated-code\"},{\"include\":\"#jsx-tag-attributes-illegal\"}]},\"jsx-tag-attributes-illegal\":{\"match\":\"\\\\S+\",\"name\":\"invalid.illegal.attribute.js.jsx\"},\"jsx-tag-in-expression\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[(*,:=>?\\\\[{]|&&|\\\\|\\\\||\\\\?|\\\\*/|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^default|[^$._[:alnum:]]default|^yield|[^$._[:alnum:]]yield|^)\\\\s*(?!<\\\\s*[$_[:alpha:]][$_[:alnum:]]*((\\\\s+extends\\\\s+[^=>])|,))(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"end\":\"(?!(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"patterns\":[{\"include\":\"#jsx-tag\"}]},\"jsx-tag-without-attributes\":{\"begin\":\"(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js.jsx\"},\"2\":{\"name\":\"entity.name.tag.namespace.js.jsx\"},\"3\":{\"name\":\"punctuation.separator.namespace.js.jsx\"},\"4\":{\"name\":\"entity.name.tag.js.jsx\"},\"5\":{\"name\":\"support.class.component.js.jsx\"},\"6\":{\"name\":\"punctuation.definition.tag.end.js.jsx\"}},\"contentName\":\"meta.jsx.children.js.jsx\",\"end\":\"(</)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js.jsx\"},\"2\":{\"name\":\"entity.name.tag.namespace.js.jsx\"},\"3\":{\"name\":\"punctuation.separator.namespace.js.jsx\"},\"4\":{\"name\":\"entity.name.tag.js.jsx\"},\"5\":{\"name\":\"support.class.component.js.jsx\"},\"6\":{\"name\":\"punctuation.definition.tag.end.js.jsx\"}},\"name\":\"meta.tag.without-attributes.js.jsx\",\"patterns\":[{\"include\":\"#jsx-children\"}]},\"jsx-tag-without-attributes-in-expression\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[(*,:=>?\\\\[{]|&&|\\\\|\\\\||\\\\?|\\\\*/|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^default|[^$._[:alnum:]]default|^yield|[^$._[:alnum:]]yield|^)\\\\s*(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>))\",\"end\":\"(?!(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>))\",\"patterns\":[{\"include\":\"#jsx-tag-without-attributes\"}]},\"label\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.label.js.jsx\"},\"2\":{\"name\":\"punctuation.separator.label.js.jsx\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#decl-block\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.label.js.jsx\"},\"2\":{\"name\":\"punctuation.separator.label.js.jsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)\"}]},\"literal\":{\"patterns\":[{\"include\":\"#numeric-literal\"},{\"include\":\"#boolean-literal\"},{\"include\":\"#null-literal\"},{\"include\":\"#undefined-literal\"},{\"include\":\"#numericConstant-literal\"},{\"include\":\"#array-literal\"},{\"include\":\"#this-literal\"},{\"include\":\"#super-literal\"}]},\"method-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?\\\\s*\\\\b(constructor)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.modifier.js.jsx\"},\"4\":{\"name\":\"storage.modifier.async.js.jsx\"},\"5\":{\"name\":\"storage.type.js.jsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js.jsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\s*\\\\b(new)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))|(?:(\\\\*)\\\\s*)?)(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.modifier.js.jsx\"},\"4\":{\"name\":\"storage.modifier.async.js.jsx\"},\"5\":{\"name\":\"keyword.operator.new.js.jsx\"},\"6\":{\"name\":\"keyword.generator.asterisk.js.jsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js.jsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.modifier.js.jsx\"},\"4\":{\"name\":\"storage.modifier.async.js.jsx\"},\"5\":{\"name\":\"storage.type.property.js.jsx\"},\"6\":{\"name\":\"keyword.generator.asterisk.js.jsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js.jsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]}]},\"method-declaration-name\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??)\\\\s*[(<])\",\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.method.js.jsx entity.name.function.js.jsx\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.js.jsx\"}]},\"namespace-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(namespace|module)\\\\s+(?=[\\\"$'_`[:alpha:]])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.type.namespace.js.jsx\"}},\"end\":\"(?<=})|(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.namespace.declaration.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.type.module.js.jsx\"},{\"include\":\"#punctuation-accessor\"},{\"include\":\"#decl-block\"}]},\"new-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.new.js.jsx\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"name\":\"new.expr.js.jsx\",\"patterns\":[{\"include\":\"#expression\"}]},\"null-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))null(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.null.js.jsx\"},\"numeric-literal\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"}},\"match\":\"\\\\b(?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.hex.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"}},\"match\":\"\\\\b(?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.binary.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"}},\"match\":\"\\\\b(?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.octal.js.jsx\"},{\"captures\":{\"0\":{\"name\":\"constant.numeric.decimal.js.jsx\"},\"1\":{\"name\":\"meta.delimiter.decimal.period.js.jsx\"},\"2\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"},\"3\":{\"name\":\"meta.delimiter.decimal.period.js.jsx\"},\"4\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"},\"5\":{\"name\":\"meta.delimiter.decimal.period.js.jsx\"},\"6\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"},\"7\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"},\"8\":{\"name\":\"meta.delimiter.decimal.period.js.jsx\"},\"9\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"},\"10\":{\"name\":\"meta.delimiter.decimal.period.js.jsx\"},\"11\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"},\"12\":{\"name\":\"meta.delimiter.decimal.period.js.jsx\"},\"13\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"},\"14\":{\"name\":\"storage.type.numeric.bigint.js.jsx\"}},\"match\":\"(?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)\"}]},\"numericConstant-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))NaN(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.nan.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Infinity(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.infinity.js.jsx\"}]},\"object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element\"}]},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element-const\"}]},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-propertyName\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(:)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.destructuring.js.jsx\"}},\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.object.property.js.jsx\"}]},\"object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"patterns\":[{\"include\":\"#object-binding-element\"}]},\"object-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"patterns\":[{\"include\":\"#object-binding-element-const\"}]},\"object-identifiers\":{\"patterns\":[{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*\\\\??\\\\.\\\\s*prototype\\\\b(?!\\\\$))\",\"name\":\"support.class.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"3\":{\"name\":\"variable.other.constant.object.property.js.jsx\"},\"4\":{\"name\":\"variable.other.object.property.js.jsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(#?\\\\p{upper}[$_\\\\d[:upper:]]*)|(#?[$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"captures\":{\"1\":{\"name\":\"variable.other.constant.object.js.jsx\"},\"2\":{\"name\":\"variable.other.object.js.jsx\"}},\"match\":\"(?:(\\\\p{upper}[$_\\\\d[:upper:]]*)|([$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"}]},\"object-literal\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"name\":\"meta.objectliteral.js.jsx\",\"patterns\":[{\"include\":\"#object-member\"}]},\"object-literal-method-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"},\"2\":{\"name\":\"storage.type.property.js.jsx\"},\"3\":{\"name\":\"keyword.generator.asterisk.js.jsx\"}},\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.js.jsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"},\"2\":{\"name\":\"storage.type.property.js.jsx\"},\"3\":{\"name\":\"keyword.generator.asterisk.js.jsx\"}},\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#method-declaration-name\"}]}]},\"object-member\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#object-literal-method-declaration\"},{\"begin\":\"(?=\\\\[)\",\"end\":\"(?=:)|((?<=])(?=\\\\s*[(<]))\",\"name\":\"meta.object.member.js.jsx meta.object-literal.key.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#array-literal\"}]},{\"begin\":\"(?=[\\\"'`])\",\"end\":\"(?=:)|((?<=[\\\"'`])(?=((\\\\s*[(,<}])|(\\\\s+(as|satisifies)\\\\s+))))\",\"name\":\"meta.object.member.js.jsx meta.object-literal.key.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?=\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)))\",\"end\":\"(?=:)|(?=\\\\s*([(,<}])|(\\\\s+as|satisifies\\\\s+))\",\"name\":\"meta.object.member.js.jsx meta.object-literal.key.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#numeric-literal\"}]},{\"begin\":\"(?<=[]\\\"'`])(?=\\\\s*[(<])\",\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.js.jsx\",\"patterns\":[{\"include\":\"#function-body\"}]},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js.jsx\"},\"1\":{\"name\":\"constant.numeric.decimal.js.jsx\"}},\"match\":\"(?![$_[:alpha:]])(\\\\d+)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.js.jsx\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js.jsx\"},\"1\":{\"name\":\"entity.name.function.js.jsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/)*\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\",\"name\":\"meta.object.member.js.jsx\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js.jsx\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.js.jsx\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.js.jsx\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.js.jsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"captures\":{\"1\":{\"name\":\"variable.other.readwrite.js.jsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*([,}]|$))\",\"name\":\"meta.object.member.js.jsx\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.js.jsx\"},\"2\":{\"name\":\"keyword.control.satisfies.js.jsx\"}},\"end\":\"(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|^|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisifies)\\\\s+))\",\"name\":\"meta.object.member.js.jsx\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(?=[$_[:alpha:]][$_[:alnum:]]*\\\\s*=)\",\"end\":\"(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.js.jsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\":\",\"beginCaptures\":{\"0\":{\"name\":\"meta.object-literal.key.js.jsx punctuation.separator.key-value.js.jsx\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.js.jsx\",\"patterns\":[{\"begin\":\"(?<=:)\\\\s*(async)?(?=\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"},\"2\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(?=<\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<=>)\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"include\":\"#possibly-arrow-return-type\"},{\"include\":\"#expression\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#decl-block\"}]},\"parameter-array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js.jsx\"}},\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#parameter-array-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"}]},\"parameter-name\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"3\":{\"name\":\"entity.name.function.js.jsx variable.language.this.js.jsx\"},\"4\":{\"name\":\"entity.name.function.js.jsx\"},\"5\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"3\":{\"name\":\"variable.parameter.js.jsx variable.language.this.js.jsx\"},\"4\":{\"name\":\"variable.parameter.js.jsx\"},\"5\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)\"}]},\"parameter-object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#parameter-binding-element\"},{\"include\":\"#paren-expression\"}]},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js.jsx\"}},\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},\"parameter-type-annotation\":{\"patterns\":[{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js.jsx\"}},\"end\":\"(?=[),])|(?==[^>])\",\"name\":\"meta.type.annotation.js.jsx\",\"patterns\":[{\"include\":\"#type\"}]}]},\"paren-expression\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"paren-expression-possibly-arrow\":{\"patterns\":[{\"begin\":\"(?<=[(,=])\\\\s*(async)?(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"begin\":\"(?<=[(,=]|=>|^return|[^$._[:alnum:]]return)\\\\s*(async)?(?=\\\\s*((((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()|(<)|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)))\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js.jsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"include\":\"#possibly-arrow-return-type\"}]},\"paren-expression-possibly-arrow-with-typeparameters\":{\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},\"possibly-arrow-return-type\":{\"begin\":\"(?<=\\\\)|^)\\\\s*(:)(?=\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*=>)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.arrow.js.jsx meta.return.type.arrow.js.jsx keyword.operator.type.annotation.js.jsx\"}},\"contentName\":\"meta.arrow.js.jsx meta.return.type.arrow.js.jsx\",\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"property-accessor\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(accessor|get|set)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.type.property.js.jsx\"},\"punctuation-accessor\":{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.js.jsx\"}},\"match\":\"(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d))\"},\"punctuation-comma\":{\"match\":\",\",\"name\":\"punctuation.separator.comma.js.jsx\"},\"punctuation-semicolon\":{\"match\":\";\",\"name\":\"punctuation.terminator.statement.js.jsx\"},\"qstring-double\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js.jsx\"}},\"end\":\"(\\\")|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js.jsx\"},\"2\":{\"name\":\"invalid.illegal.newline.js.jsx\"}},\"name\":\"string.quoted.double.js.jsx\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"qstring-single\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js.jsx\"}},\"end\":\"(')|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js.jsx\"},\"2\":{\"name\":\"invalid.illegal.newline.js.jsx\"}},\"name\":\"string.quoted.single.js.jsx\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"regex\":{\"patterns\":[{\"begin\":\"(?<!\\\\+\\\\+|--|})(?<=[!(+,:=?\\\\[]|^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case|=>|&&|\\\\|\\\\||\\\\*/)\\\\s*(/)(?![*/])(?=(?:[^()/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)+]|\\\\(([^)\\\\\\\\]|\\\\\\\\.)+\\\\))+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.js.jsx\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js.jsx\"},\"2\":{\"name\":\"keyword.other.js.jsx\"}},\"name\":\"string.regexp.js.jsx\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"((?<![]$)_[:alnum:]]|\\\\+\\\\+|--|}|\\\\*/)|((?<=^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case))\\\\s*)/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js.jsx\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js.jsx\"},\"2\":{\"name\":\"keyword.other.js.jsx\"}},\"name\":\"string.regexp.js.jsx\",\"patterns\":[{\"include\":\"#regexp\"}]}]},\"regex-character-class\":{\"patterns\":[{\"match\":\"\\\\\\\\[DSWdfnrstvw]|\\\\.\",\"name\":\"constant.other.character-class.regexp\"},{\"match\":\"\\\\\\\\([0-7]{3}|x\\\\h{2}|u\\\\h{4})\",\"name\":\"constant.character.numeric.regexp\"},{\"match\":\"\\\\\\\\c[A-Z]\",\"name\":\"constant.character.control.regexp\"},{\"match\":\"\\\\\\\\.\",\"name\":\"constant.character.escape.backslash.regexp\"}]},\"regexp\":{\"patterns\":[{\"match\":\"\\\\\\\\[Bb]|[$^]\",\"name\":\"keyword.control.anchor.regexp\"},{\"captures\":{\"0\":{\"name\":\"keyword.other.back-reference.regexp\"},\"1\":{\"name\":\"variable.other.regexp\"}},\"match\":\"\\\\\\\\(?:[1-9]\\\\d*|k<([$A-Z_a-z][$\\\\w]*)>)\"},{\"match\":\"[*+?]|\\\\{(\\\\d+,\\\\d+|\\\\d+,|,\\\\d+|\\\\d+)}\\\\??\",\"name\":\"keyword.operator.quantifier.regexp\"},{\"match\":\"\\\\|\",\"name\":\"keyword.operator.or.regexp\"},{\"begin\":\"(\\\\()((\\\\?=)|(\\\\?!)|(\\\\?<=)|(\\\\?<!))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"},\"2\":{\"name\":\"punctuation.definition.group.assertion.regexp\"},\"3\":{\"name\":\"meta.assertion.look-ahead.regexp\"},\"4\":{\"name\":\"meta.assertion.negative-look-ahead.regexp\"},\"5\":{\"name\":\"meta.assertion.look-behind.regexp\"},\"6\":{\"name\":\"meta.assertion.negative-look-behind.regexp\"}},\"end\":\"(\\\\))\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.assertion.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"\\\\((?:(\\\\?:)|\\\\?<([$A-Z_a-z][$\\\\w]*)>)?\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"},\"1\":{\"name\":\"punctuation.definition.group.no-capture.regexp\"},\"2\":{\"name\":\"variable.other.regexp\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"(\\\\[)(\\\\^)?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"},\"2\":{\"name\":\"keyword.operator.negation.regexp\"}},\"end\":\"(])\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"}},\"name\":\"constant.other.character-class.set.regexp\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"constant.character.numeric.regexp\"},\"2\":{\"name\":\"constant.character.control.regexp\"},\"3\":{\"name\":\"constant.character.escape.backslash.regexp\"},\"4\":{\"name\":\"constant.character.numeric.regexp\"},\"5\":{\"name\":\"constant.character.control.regexp\"},\"6\":{\"name\":\"constant.character.escape.backslash.regexp\"}},\"match\":\"(?:.|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))-(?:[^]\\\\\\\\]|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))\",\"name\":\"constant.other.character-class.range.regexp\"},{\"include\":\"#regex-character-class\"}]},{\"include\":\"#regex-character-class\"}]},\"return-type\":{\"patterns\":[{\"begin\":\"(?<=\\\\))\\\\s*(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js.jsx\"}},\"end\":\"(?<![\\\\&:|])(?=$|^|[,;{}]|//)\",\"name\":\"meta.return.type.js.jsx\",\"patterns\":[{\"include\":\"#return-type-core\"}]},{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js.jsx\"}},\"end\":\"(?<![\\\\&:|])((?=[,;{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.return.type.js.jsx\",\"patterns\":[{\"include\":\"#return-type-core\"}]}]},\"return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<=[\\\\&:|])(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"shebang\":{\"captures\":{\"1\":{\"name\":\"punctuation.definition.comment.js.jsx\"}},\"match\":\"\\\\A(#!).*(?=$)\",\"name\":\"comment.line.shebang.js.jsx\"},\"single-line-comment-consuming-line-ending\":{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.js.jsx\"},\"2\":{\"name\":\"comment.line.double-slash.js.jsx\"},\"3\":{\"name\":\"punctuation.definition.comment.js.jsx\"},\"4\":{\"name\":\"storage.type.internaldeclaration.js.jsx\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.js.jsx\"}},\"contentName\":\"comment.line.double-slash.js.jsx\",\"end\":\"(?=^)\"},\"statements\":{\"patterns\":[{\"include\":\"#declaration\"},{\"include\":\"#control-statement\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#label\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template\"}]},\"string-character-escape\":{\"match\":\"\\\\\\\\(x\\\\h{2}|u\\\\h{4}|u\\\\{\\\\h+}|[012][0-7]{0,2}|3[0-6][0-7]?|37[0-7]?|[4-7][0-7]?|.|$)\",\"name\":\"constant.character.escape.js.jsx\"},\"super-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))super\\\\b(?!\\\\$)\",\"name\":\"variable.language.super.js.jsx\"},\"support-function-call-identifiers\":{\"patterns\":[{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#object-identifiers\"},{\"include\":\"#punctuation-accessor\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\(\\\\s*[\\\"'`])\",\"name\":\"keyword.operator.expression.import.js.jsx\"}]},\"support-objects\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(arguments)\\\\b(?!\\\\$)\",\"name\":\"variable.language.arguments.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(Promise)\\\\b(?!\\\\$)\",\"name\":\"support.class.promise.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.import.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.js.jsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"4\":{\"name\":\"support.variable.property.importmeta.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(import)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(meta)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.new.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.js.jsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"4\":{\"name\":\"support.variable.property.target.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(target)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"3\":{\"name\":\"support.variable.property.js.jsx\"},\"4\":{\"name\":\"support.constant.js.jsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(constructor|length|prototype|__proto__)\\\\b(?!\\\\$|\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\()|(EPSILON|MAX_SAFE_INTEGER|MAX_VALUE|MIN_SAFE_INTEGER|MIN_VALUE|NEGATIVE_INFINITY|POSITIVE_INFINITY)\\\\b(?!\\\\$))\"},{\"captures\":{\"1\":{\"name\":\"support.type.object.module.js.jsx\"},\"2\":{\"name\":\"support.type.object.module.js.jsx\"},\"3\":{\"name\":\"punctuation.accessor.js.jsx\"},\"4\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"5\":{\"name\":\"support.type.object.module.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(exports)|(module)(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(exports|id|filename|loaded|parent|children))?)\\\\b(?!\\\\$)\"}]},\"switch-statement\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bswitch\\\\s*\\\\()\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"name\":\"switch-statement.expr.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(switch)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.js.jsx\"},\"2\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"name\":\"switch-expression.expr.js.jsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"(?=})\",\"name\":\"switch-block.expr.js.jsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default(?=:))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.js.jsx\"}},\"end\":\"(?=:)\",\"name\":\"case-clause.expr.js.jsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(:)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"case-clause.expr.js.jsx punctuation.definition.section.case-statement.js.jsx\"},\"2\":{\"name\":\"meta.block.js.jsx punctuation.definition.block.js.jsx\"}},\"contentName\":\"meta.block.js.jsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"meta.block.js.jsx punctuation.definition.block.js.jsx\"}},\"patterns\":[{\"include\":\"#statements\"}]},{\"captures\":{\"0\":{\"name\":\"case-clause.expr.js.jsx punctuation.definition.section.case-statement.js.jsx\"}},\"match\":\"(:)\"},{\"include\":\"#statements\"}]}]},\"template\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js.jsx\"},\"2\":{\"name\":\"string.template.js.jsx punctuation.definition.string.template.begin.js.jsx\"}},\"contentName\":\"string.template.js.jsx\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.js.jsx punctuation.definition.string.template.end.js.jsx\"}},\"patterns\":[{\"include\":\"#template-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-call\":{\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*)(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"end\":\"(?=`)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.tagged-template.js.jsx\"}]},{\"include\":\"#type-arguments\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?\\\\s*(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js.jsx\"}},\"end\":\"(?=`)\",\"patterns\":[{\"include\":\"#type-arguments\"}]}]},\"template-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.js.jsx\"}},\"contentName\":\"meta.embedded.line.js.jsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.js.jsx\"}},\"name\":\"meta.template.expression.js.jsx\",\"patterns\":[{\"include\":\"#expression\"}]},\"template-type\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js.jsx\"},\"2\":{\"name\":\"string.template.js.jsx punctuation.definition.string.template.begin.js.jsx\"}},\"contentName\":\"string.template.js.jsx\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.js.jsx punctuation.definition.string.template.end.js.jsx\"}},\"patterns\":[{\"include\":\"#template-type-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-type-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.js.jsx\"}},\"contentName\":\"meta.embedded.line.js.jsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.js.jsx\"}},\"name\":\"meta.template.expression.js.jsx\",\"patterns\":[{\"include\":\"#type\"}]},\"ternary-expression\":{\"begin\":\"(?!\\\\?\\\\.\\\\s*\\\\D)(\\\\?)(?!\\\\?)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.js.jsx\"}},\"end\":\"\\\\s*(:)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.js.jsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"this-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))this\\\\b(?!\\\\$)\",\"name\":\"variable.language.this.js.jsx\"},\"type\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#type-primitive\"},{\"include\":\"#type-builtin-literals\"},{\"include\":\"#type-parameters\"},{\"include\":\"#type-tuple\"},{\"include\":\"#type-object\"},{\"include\":\"#type-operators\"},{\"include\":\"#type-conditional\"},{\"include\":\"#type-fn-type-parameters\"},{\"include\":\"#type-paren-or-function-parameters\"},{\"include\":\"#type-function-return-type\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\"},{\"include\":\"#type-name\"}]},\"type-alias-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(type)\\\\b\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.type.type.js.jsx\"},\"4\":{\"name\":\"entity.name.type.alias.js.jsx\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.type.declaration.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"begin\":\"(=)\\\\s*(intrinsic)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js.jsx\"},\"2\":{\"name\":\"keyword.control.intrinsic.js.jsx\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(=)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js.jsx\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-annotation\":{\"patterns\":[{\"begin\":\"(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js.jsx\"}},\"end\":\"(?<![\\\\&:|])(?!\\\\s*[\\\\&|]\\\\s+)((?=^|[]),;}]|//)|(?==[^>])|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.js.jsx\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js.jsx\"}},\"end\":\"(?<![\\\\&:|])((?=[]),;}]|//)|(?==[^>])|(?=^\\\\s*$)|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.js.jsx\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-arguments\":{\"begin\":\"<\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.begin.js.jsx\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.end.js.jsx\"}},\"name\":\"meta.type.parameters.js.jsx\",\"patterns\":[{\"include\":\"#type-arguments-body\"}]},\"type-arguments-body\":{\"patterns\":[{\"captures\":{\"0\":{\"name\":\"keyword.operator.type.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(_)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"type-builtin-literals\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(this|true|false|undefined|null|object)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.builtin.js.jsx\"},\"type-conditional\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"}},\"end\":\"(?<=:)\",\"patterns\":[{\"begin\":\"\\\\?\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.js.jsx\"}},\"end\":\":\",\"endCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.js.jsx\"}},\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#type\"}]}]},\"type-fn-type-parameters\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b(?=\\\\s*<)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.type.constructor.js.jsx storage.modifier.js.jsx\"},\"2\":{\"name\":\"meta.type.constructor.js.jsx keyword.control.new.js.jsx\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"keyword.control.new.js.jsx\"}},\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.constructor.js.jsx\",\"patterns\":[{\"include\":\"#function-parameters\"}]},{\"begin\":\"((?=\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>))))))\",\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.function.js.jsx\",\"patterns\":[{\"include\":\"#function-parameters\"}]}]},\"type-function-return-type\":{\"patterns\":[{\"begin\":\"(=>)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.function.arrow.js.jsx\"}},\"end\":\"(?<!=>)(?<![\\\\&|])(?=[]),:;=>?{}]|//|$)\",\"name\":\"meta.type.function.return.js.jsx\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.js.jsx\"}},\"end\":\"(?<!=>)(?<![\\\\&|])((?=[]),:;=>?{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.type.function.return.js.jsx\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]}]},\"type-function-return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<==>)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"type-infer\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.infer.js.jsx\"},\"2\":{\"name\":\"entity.name.type.js.jsx\"},\"3\":{\"name\":\"keyword.operator.expression.extends.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(infer)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s+(extends)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))?\",\"name\":\"meta.type.infer.js.jsx\"}]},\"type-name\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(<)\",\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.js.jsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.js.jsx\"},\"4\":{\"name\":\"meta.type.parameters.js.jsx punctuation.definition.typeparameters.begin.js.jsx\"}},\"contentName\":\"meta.type.parameters.js.jsx\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.js.jsx punctuation.definition.typeparameters.end.js.jsx\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(<)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.type.js.jsx\"},\"2\":{\"name\":\"meta.type.parameters.js.jsx punctuation.definition.typeparameters.begin.js.jsx\"}},\"contentName\":\"meta.type.parameters.js.jsx\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.js.jsx punctuation.definition.typeparameters.end.js.jsx\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js.jsx\"},\"2\":{\"name\":\"punctuation.accessor.js.jsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.js.jsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"entity.name.type.js.jsx\"}]},\"type-object\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js.jsx\"}},\"name\":\"meta.object.type.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#indexer-mapped-type-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#type-annotation\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.js.jsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#type\"}]},\"type-operators\":{\"patterns\":[{\"include\":\"#typeof-operator\"},{\"include\":\"#type-infer\"},{\"begin\":\"([\\\\&|])(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.js.jsx\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"begin\":\"[\\\\&|]\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.js.jsx\"}},\"end\":\"(?=\\\\S)\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))keyof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.keyof.js.jsx\"},{\"match\":\"([:?])\",\"name\":\"keyword.operator.ternary.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\()\",\"name\":\"keyword.operator.expression.import.js.jsx\"}]},\"type-parameters\":{\"begin\":\"(<)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.begin.js.jsx\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.end.js.jsx\"}},\"name\":\"meta.type.parameters.js.jsx\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends|in|out|const)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js.jsx\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"(=)(?!>)\",\"name\":\"keyword.operator.assignment.js.jsx\"}]},\"type-paren-or-function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js.jsx\"}},\"name\":\"meta.type.paren.cover.js.jsx\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"3\":{\"name\":\"entity.name.function.js.jsx variable.language.this.js.jsx\"},\"4\":{\"name\":\"entity.name.function.js.jsx\"},\"5\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=\\\\s*(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js.jsx\"},\"2\":{\"name\":\"keyword.operator.rest.js.jsx\"},\"3\":{\"name\":\"variable.parameter.js.jsx variable.language.this.js.jsx\"},\"4\":{\"name\":\"variable.parameter.js.jsx\"},\"5\":{\"name\":\"keyword.operator.optional.js.jsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=:)\"},{\"include\":\"#type-annotation\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js.jsx\"},{\"include\":\"#type\"}]},\"type-predicate-operator\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.js.jsx\"},\"2\":{\"name\":\"variable.parameter.js.jsx variable.language.this.js.jsx\"},\"3\":{\"name\":\"variable.parameter.js.jsx\"},\"4\":{\"name\":\"keyword.operator.expression.is.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(asserts)\\\\s+)?(?!asserts)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s(is)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.js.jsx\"},\"2\":{\"name\":\"variable.parameter.js.jsx variable.language.this.js.jsx\"},\"3\":{\"name\":\"variable.parameter.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(asserts)\\\\s+(?!is)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))asserts(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.type.asserts.js.jsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))is(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.is.js.jsx\"}]},\"type-primitive\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(string|number|bigint|boolean|symbol|any|void|never|unknown)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.primitive.js.jsx\"},\"type-string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template-type\"}]},\"type-tuple\":{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.square.js.jsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.js.jsx\"}},\"name\":\"meta.type.tuple.js.jsx\",\"patterns\":[{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.rest.js.jsx\"},{\"captures\":{\"1\":{\"name\":\"entity.name.label.js.jsx\"},\"2\":{\"name\":\"keyword.operator.optional.js.jsx\"},\"3\":{\"name\":\"punctuation.separator.label.js.jsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(\\\\?)?\\\\s*(:)\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"typeof-operator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))typeof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.expression.typeof.js.jsx\"}},\"end\":\"(?=[]\\\\&),:;=>?{|}]|(extends\\\\s+)|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type-arguments\"},{\"include\":\"#expression\"}]},\"undefined-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))undefined(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.undefined.js.jsx\"},\"var-expr\":{\"patterns\":[{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!^let|[^$._[:alnum:]]let|^var|[^$._[:alnum:]]var)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js.jsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.type.js.jsx\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js.jsx\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.type.js.jsx\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]])const)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js.jsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.type.js.jsx\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js.jsx\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.type.js.jsx\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]]|^await\\\\s+|[^$._[:alnum:]]await\\\\s+)using)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js.jsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js.jsx\"},\"2\":{\"name\":\"storage.modifier.js.jsx\"},\"3\":{\"name\":\"storage.type.js.jsx\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*((?!\\\\S)|(?=//))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js.jsx\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"var-single-const\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js.jsx variable.other.constant.js.jsx entity.name.function.js.jsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js.jsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js.jsx variable.other.constant.js.jsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js.jsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js.jsx entity.name.function.js.jsx\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js.jsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js.jsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js.jsx variable.other.constant.js.jsx\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js.jsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js.jsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js.jsx variable.other.readwrite.js.jsx\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js.jsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js.jsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable-type-annotation\":{\"patterns\":[{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"variable-initializer\":{\"patterns\":[{\"begin\":\"(?<![!=])(=)(?!=)(?=\\\\s*\\\\S)(?!\\\\s*.*=>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js.jsx\"}},\"end\":\"(?=$|^|[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<![!=])(=)(?!=)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js.jsx\"}},\"end\":\"(?=[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))|(?=^\\\\s*$)|(?<![-\\\\&*+/|])(?<=\\\\S)(?<!=)(?=\\\\s*$)\",\"patterns\":[{\"include\":\"#expression\"}]}]}},\"scopeName\":\"source.js.jsx\"}"));
var $efe74ad407a81fb4$export$2e2bcd8739ae039 = [
    $efe74ad407a81fb4$var$lang
];


const $7bf97d7efe7ac605$var$lang = Object.freeze(JSON.parse("{\"displayName\":\"TSX\",\"name\":\"tsx\",\"patterns\":[{\"include\":\"#directives\"},{\"include\":\"#statements\"},{\"include\":\"#shebang\"}],\"repository\":{\"access-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(abstract|declare|override|public|protected|private|readonly|static)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.tsx\"},\"after-operator-block-as-object-literal\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[!(+,:=>?\\\\[]|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^yield|[^$._[:alnum:]]yield|^throw|[^$._[:alnum:]]throw|^in|[^$._[:alnum:]]in|^of|[^$._[:alnum:]]of|^typeof|[^$._[:alnum:]]typeof|&&|\\\\|\\\\||\\\\*)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"name\":\"meta.objectliteral.tsx\",\"patterns\":[{\"include\":\"#object-member\"}]},\"array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"patterns\":[{\"include\":\"#binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"array-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"patterns\":[{\"include\":\"#binding-element-const\"},{\"include\":\"#punctuation-comma\"}]},\"array-literal\":{\"begin\":\"\\\\s*(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.square.tsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.tsx\"}},\"name\":\"meta.array.literal.tsx\",\"patterns\":[{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]},\"arrow-function\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"},\"2\":{\"name\":\"variable.parameter.tsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async)\\\\s+)?([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?==>)\",\"name\":\"meta.arrow.tsx\"},{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async))?((?<![]!)}])\\\\s*(?=((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.arrow.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#arrow-return-type\"},{\"include\":\"#possibly-arrow-return-type\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.tsx\"}},\"end\":\"((?<=[}\\\\S])(?<!=>)|((?!\\\\{)(?=\\\\S)))(?!/[*/])\",\"name\":\"meta.arrow.tsx\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"}]}]},\"arrow-return-type\":{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.tsx\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.return.type.arrow.tsx\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"arrow-return-type-body\":{\"patterns\":[{\"begin\":\"(?<=:)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"async-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(async)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.async.tsx\"},\"binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#array-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"}]},\"binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"}]},\"boolean-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))true(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.true.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))false(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.false.tsx\"}]},\"brackets\":{\"patterns\":[{\"begin\":\"\\\\{\",\"end\":\"}|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]},{\"begin\":\"\\\\[\",\"end\":\"]|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]}]},\"cast\":{\"patterns\":[{\"include\":\"#jsx\"}]},\"class-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(class)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.modifier.tsx\"},\"4\":{\"name\":\"storage.type.class.tsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.tsx\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-declaration-or-expression-patterns\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.class.tsx\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"class-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(class)\\\\b(?=\\\\s+|[<{]|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"storage.type.class.tsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.tsx\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-or-interface-body\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#decorator\"},{\"begin\":\"(?<=:)\\\\s*\",\"end\":\"(?=[-\\\\])+,:;}\\\\s]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#string\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#access-modifier\"},{\"include\":\"#property-accessor\"},{\"include\":\"#async-modifier\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"}]},\"class-or-interface-heritage\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(extends|implements)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"}},\"end\":\"(?=\\\\{)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"include\":\"#type-parameters\"},{\"include\":\"#expressionWithoutIdentifiers\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.tsx\"},\"2\":{\"name\":\"punctuation.accessor.tsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.tsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*(\\\\s*\\\\??\\\\.\\\\s*[$_[:alpha:]][$_[:alnum:]]*)*\\\\s*)\"},{\"captures\":{\"1\":{\"name\":\"entity.other.inherited-class.tsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\"},{\"include\":\"#expressionPunctuations\"}]},\"comment\":{\"patterns\":[{\"begin\":\"/\\\\*\\\\*(?!/)\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.tsx\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.tsx\"}},\"name\":\"comment.block.documentation.tsx\",\"patterns\":[{\"include\":\"#docblock\"}]},{\"begin\":\"(/\\\\*)(?:\\\\s*((@)internal)(?=\\\\s|(\\\\*/)))?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.tsx\"},\"2\":{\"name\":\"storage.type.internaldeclaration.tsx\"},\"3\":{\"name\":\"punctuation.decorator.internaldeclaration.tsx\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.tsx\"}},\"name\":\"comment.block.tsx\"},{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.tsx\"},\"2\":{\"name\":\"comment.line.double-slash.tsx\"},\"3\":{\"name\":\"punctuation.definition.comment.tsx\"},\"4\":{\"name\":\"storage.type.internaldeclaration.tsx\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.tsx\"}},\"contentName\":\"comment.line.double-slash.tsx\",\"end\":\"(?=$)\"}]},\"control-statement\":{\"patterns\":[{\"include\":\"#switch-statement\"},{\"include\":\"#for-loop\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(catch|finally|throw|try)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.trycatch.tsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.loop.tsx\"},\"2\":{\"name\":\"entity.name.label.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|goto)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|do|goto|while)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.loop.tsx\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(return)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.flow.tsx\"}},\"end\":\"(?=[;}]|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default|switch)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.switch.tsx\"},{\"include\":\"#if-statement\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(else|if)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.conditional.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(with)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.with.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(package)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(debugger)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.other.debugger.tsx\"}]},\"decl-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"name\":\"meta.block.tsx\",\"patterns\":[{\"include\":\"#statements\"}]},\"declaration\":{\"patterns\":[{\"include\":\"#decorator\"},{\"include\":\"#var-expr\"},{\"include\":\"#function-declaration\"},{\"include\":\"#class-declaration\"},{\"include\":\"#interface-declaration\"},{\"include\":\"#enum-declaration\"},{\"include\":\"#namespace-declaration\"},{\"include\":\"#type-alias-declaration\"},{\"include\":\"#import-equals-declaration\"},{\"include\":\"#import-declaration\"},{\"include\":\"#export-declaration\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(declare|export)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.tsx\"}]},\"decorator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))@\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.decorator.tsx\"}},\"end\":\"(?=\\\\s)\",\"name\":\"meta.decorator.tsx\",\"patterns\":[{\"include\":\"#expression\"}]},\"destructuring-const\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.tsx\",\"patterns\":[{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.tsx\",\"patterns\":[{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-parameter\":{\"patterns\":[{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"name\":\"meta.parameter.object-binding-pattern.tsx\",\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"name\":\"meta.paramter.array-binding-pattern.tsx\",\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]}]},\"destructuring-parameter-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"variable.parameter.tsx\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.tsx\",\"patterns\":[{\"include\":\"#object-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.tsx\",\"patterns\":[{\"include\":\"#array-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-variable-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"meta.definition.variable.tsx variable.other.readwrite.tsx\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable-rest-const\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"meta.definition.variable.tsx variable.other.constant.tsx\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"directives\":{\"begin\":\"^(///)\\\\s*(?=<(reference|amd-dependency|amd-module)(\\\\s+(path|types|no-default-lib|lib|name|resolution-mode)\\\\s*=\\\\s*(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))+\\\\s*/>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.tsx\"}},\"end\":\"(?=$)\",\"name\":\"comment.line.triple-slash.directive.tsx\",\"patterns\":[{\"begin\":\"(<)(reference|amd-dependency|amd-module)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.directive.tsx\"},\"2\":{\"name\":\"entity.name.tag.directive.tsx\"}},\"end\":\"/>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.directive.tsx\"}},\"name\":\"meta.tag.tsx\",\"patterns\":[{\"match\":\"path|types|no-default-lib|lib|name|resolution-mode\",\"name\":\"entity.other.attribute-name.directive.tsx\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.tsx\"},{\"include\":\"#string\"}]}]},\"docblock\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.access-type.jsdoc\"}},\"match\":\"((@)a(?:ccess|pi))\\\\s+(p(?:rivate|rotected|ublic))\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"5\":{\"name\":\"constant.other.email.link.underline.jsdoc\"},\"6\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"match\":\"((@)author)\\\\s+([^*/<>@\\\\s](?:[^*/<>@]|\\\\*[^/])*)(?:\\\\s*(<)([^>\\\\s]+)(>))?\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"keyword.operator.control.jsdoc\"},\"5\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)borrows)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\\\\s+(as)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)example)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=@|\\\\*/)\",\"name\":\"meta.example.jsdoc\",\"patterns\":[{\"match\":\"^\\\\s\\\\*\\\\s+\"},{\"begin\":\"\\\\G(<)caption(>)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"contentName\":\"constant.other.description.jsdoc\",\"end\":\"(</)caption(>)|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}}},{\"captures\":{\"0\":{\"name\":\"source.embedded.tsx\"}},\"match\":\"[^*@\\\\s](?:[^*]|\\\\*[^/])*\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.symbol-type.jsdoc\"}},\"match\":\"((@)kind)\\\\s+(class|constant|event|external|file|function|member|mixin|module|namespace|typedef)\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"4\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)see)\\\\s+(?:((?=https?://)(?:[^*\\\\s]|\\\\*[^/])+)|((?!https?://|(?:\\\\[[^]\\\\[]*])?\\\\{@(?:link|linkcode|linkplain|tutorial)\\\\b)(?:[^*/@\\\\s]|\\\\*[^/])+))\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)template)\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*(?:\\\\s*,\\\\s*[$A-Z_a-z][]$.\\\\[\\\\w]*)*)\"},{\"begin\":\"((@)template)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:arg|argument|const|constant|member|namespace|param|var))\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*)\"},{\"begin\":\"((@)typedef)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"(?:[^*/@\\\\s]|\\\\*[^/])+\",\"name\":\"entity.name.type.instance.jsdoc\"}]},{\"begin\":\"((@)(?:arg|argument|const|constant|member|namespace|param|prop|property|var))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.optional-value.begin.bracket.square.jsdoc\"},\"2\":{\"name\":\"keyword.operator.assignment.jsdoc\"},\"3\":{\"name\":\"source.embedded.tsx\"},\"4\":{\"name\":\"punctuation.definition.optional-value.end.bracket.square.jsdoc\"},\"5\":{\"name\":\"invalid.illegal.syntax.jsdoc\"}},\"match\":\"(\\\\[)\\\\s*[$\\\\w]+(?:(?:\\\\[])?\\\\.[$\\\\w]+)*(?:\\\\s*(=)\\\\s*((?>\\\"(?:\\\\*(?!/)|\\\\\\\\(?!\\\")|[^*\\\\\\\\])*?\\\"|'(?:\\\\*(?!/)|\\\\\\\\(?!')|[^*\\\\\\\\])*?'|\\\\[(?:\\\\*(?!/)|[^*])*?]|(?:\\\\*(?!/)|\\\\s(?!\\\\s*])|\\\\[.*?(?:]|(?=\\\\*/))|[^]*\\\\[\\\\s])*)*))?\\\\s*(?:(])((?:[^*\\\\s]|\\\\*[^/\\\\s])+)?|(?=\\\\*/))\",\"name\":\"variable.other.jsdoc\"}]},{\"begin\":\"((@)(?:define|enum|exception|export|extends|lends|implements|modifies|namespace|private|protected|returns?|satisfies|suppress|this|throws|type|yields?))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)(?:alias|augments|callback|constructs|emits|event|fires|exports?|extends|external|function|func|host|lends|listens|interface|memberof!?|method|module|mixes|mixin|name|requires|see|this|typedef|uses))\\\\s+((?:[^*@{}\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)(?:default(?:value)?|license|version))\\\\s+(([\\\"']))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.string.begin.jsdoc\"}},\"contentName\":\"variable.other.jsdoc\",\"end\":\"(\\\\3)|(?=$|\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"variable.other.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.string.end.jsdoc\"}}},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:default(?:value)?|license|tutorial|variation|version))\\\\s+([^*\\\\s]+)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"(@)(?:abstract|access|alias|api|arg|argument|async|attribute|augments|author|beta|borrows|bubbles|callback|chainable|class|classdesc|code|config|const|constant|constructor|constructs|copyright|default|defaultvalue|define|deprecated|desc|description|dict|emits|enum|event|example|exception|exports?|extends|extension(?:_?for)?|external|externs|file|fileoverview|final|fires|for|func|function|generator|global|hideconstructor|host|ignore|implements|implicitCast|inherit[Dd]oc|inner|instance|interface|internal|kind|lends|license|listens|main|member|memberof!?|method|mixes|mixins?|modifies|module|name|namespace|noalias|nocollapse|nocompile|nosideeffects|override|overview|package|param|polymer(?:Behavior)?|preserve|private|prop|property|protected|public|read[Oo]nly|record|require[ds]|returns?|see|since|static|struct|submodule|summary|suppress|template|this|throws|todo|tutorial|type|typedef|unrestricted|uses|var|variation|version|virtual|writeOnce|yields?)\\\\b\",\"name\":\"storage.type.class.jsdoc\"},{\"include\":\"#inline-tags\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"((@)[$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s+)\"}]},\"enum-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:\\\\b(const)\\\\s+)?\\\\b(enum)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.modifier.tsx\"},\"4\":{\"name\":\"storage.type.enum.tsx\"},\"5\":{\"name\":\"entity.name.type.enum.tsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.enum.declaration.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"0\":{\"name\":\"variable.other.enummember.tsx\"}},\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"begin\":\"(?=(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+])))\",\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"export-declaration\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"keyword.control.as.tsx\"},\"3\":{\"name\":\"storage.type.namespace.tsx\"},\"4\":{\"name\":\"entity.name.type.module.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)\\\\s+(as)\\\\s+(namespace)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?(?:\\\\s*(=)|\\\\s+(default)(?=\\\\s+))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"keyword.control.type.tsx\"},\"3\":{\"name\":\"keyword.operator.assignment.tsx\"},\"4\":{\"name\":\"keyword.control.default.tsx\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.default.tsx\",\"patterns\":[{\"include\":\"#interface-declaration\"},{\"include\":\"#expression\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?\\\\b(?!(\\\\$)|(\\\\s*:))((?=\\\\s*[*{])|((?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*([,\\\\s]))(?!\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"keyword.control.type.tsx\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.tsx\",\"patterns\":[{\"include\":\"#import-export-declaration\"}]}]},\"expression\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-inside-possibly-arrow-parens\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"keyword.operator.rest.tsx\"},\"3\":{\"name\":\"entity.name.function.tsx variable.language.this.tsx\"},\"4\":{\"name\":\"entity.name.function.tsx\"},\"5\":{\"name\":\"keyword.operator.optional.tsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"keyword.operator.rest.tsx\"},\"3\":{\"name\":\"variable.parameter.tsx variable.language.this.tsx\"},\"4\":{\"name\":\"variable.parameter.tsx\"},\"5\":{\"name\":\"keyword.operator.optional.tsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*[,:]|$)\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.tsx\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-operators\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(await)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.flow.tsx\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?=\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*\\\\*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.flow.tsx\"}},\"end\":\"\\\\*\",\"endCaptures\":{\"0\":{\"name\":\"keyword.generator.asterisk.tsx\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.control.flow.tsx\"},\"2\":{\"name\":\"keyword.generator.asterisk.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s*(\\\\*))?\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))delete(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.delete.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))in(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.in.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))of(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.of.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.instanceof.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.new.tsx\"},{\"include\":\"#typeof-operator\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))void(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.void.tsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*($|[]),:;}]))\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.tsx\"},\"2\":{\"name\":\"keyword.control.satisfies.tsx\"}},\"end\":\"(?=^|[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisfies)\\\\s+)|(\\\\s+<))\",\"patterns\":[{\"include\":\"#type\"}]},{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.spread.tsx\"},{\"match\":\"(?:\\\\*|(?<!\\\\()/|[-%+])=\",\"name\":\"keyword.operator.assignment.compound.tsx\"},{\"match\":\"(?:[\\\\&^]|<<|>>>??|\\\\|)=\",\"name\":\"keyword.operator.assignment.compound.bitwise.tsx\"},{\"match\":\"<<|>>>?\",\"name\":\"keyword.operator.bitwise.shift.tsx\"},{\"match\":\"[!=]==?\",\"name\":\"keyword.operator.comparison.tsx\"},{\"match\":\"<=|>=|<>|[<>]\",\"name\":\"keyword.operator.relational.tsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.logical.tsx\"},\"2\":{\"name\":\"keyword.operator.assignment.compound.tsx\"},\"3\":{\"name\":\"keyword.operator.arithmetic.tsx\"}},\"match\":\"(?<=[$_[:alnum:]])(!)\\\\s*(?:(/=)|(/)(?![*/]))\"},{\"match\":\"!|&&|\\\\|\\\\||\\\\?\\\\?\",\"name\":\"keyword.operator.logical.tsx\"},{\"match\":\"[\\\\&^|~]\",\"name\":\"keyword.operator.bitwise.tsx\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.tsx\"},{\"match\":\"--\",\"name\":\"keyword.operator.decrement.tsx\"},{\"match\":\"\\\\+\\\\+\",\"name\":\"keyword.operator.increment.tsx\"},{\"match\":\"[-%*+/]\",\"name\":\"keyword.operator.arithmetic.tsx\"},{\"begin\":\"(?<=[]$)_[:alnum:]])\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)+(?:(/=)|(/)(?![*/])))\",\"end\":\"(/=)|(/)(?!\\\\*([^*]|(\\\\*[^/]))*\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.tsx\"},\"2\":{\"name\":\"keyword.operator.arithmetic.tsx\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.tsx\"},\"2\":{\"name\":\"keyword.operator.arithmetic.tsx\"}},\"match\":\"(?<=[]$)_[:alnum:]])\\\\s*(?:(/=)|(/)(?![*/]))\"}]},\"expressionPunctuations\":{\"patterns\":[{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-accessor\"}]},\"expressionWithoutIdentifiers\":{\"patterns\":[{\"include\":\"#jsx\"},{\"include\":\"#string\"},{\"include\":\"#regex\"},{\"include\":\"#comment\"},{\"include\":\"#function-expression\"},{\"include\":\"#class-expression\"},{\"include\":\"#arrow-function\"},{\"include\":\"#paren-expression-possibly-arrow\"},{\"include\":\"#cast\"},{\"include\":\"#ternary-expression\"},{\"include\":\"#new-expr\"},{\"include\":\"#instanceof-expr\"},{\"include\":\"#object-literal\"},{\"include\":\"#expression-operators\"},{\"include\":\"#function-call\"},{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#paren-expression\"}]},\"field-declaration\":{\"begin\":\"(?<!\\\\()(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s+)?(?=\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=}]|$))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"}},\"end\":\"(?=[,;}]|$|^((?!\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=]|$))))|(?<=})\",\"name\":\"meta.field.declaration.tsx\",\"patterns\":[{\"include\":\"#variable-initializer\"},{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"meta.definition.property.tsx entity.name.function.tsx\"},\"2\":{\"name\":\"keyword.operator.optional.tsx\"},\"3\":{\"name\":\"keyword.operator.definiteassignment.tsx\"}},\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)(?:(\\\\?)|(!))?(?=\\\\s*\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"match\":\"#?[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.property.tsx variable.object.property.tsx\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.tsx\"},{\"match\":\"!\",\"name\":\"keyword.operator.definiteassignment.tsx\"}]},\"for-loop\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))for(?=((\\\\s+|(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*))await)?\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)?(\\\\())\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.loop.tsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"await\",\"name\":\"keyword.control.loop.tsx\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"patterns\":[{\"include\":\"#var-expr\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"}]}]},\"function-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#return-type\"},{\"include\":\"#type-function-return-type\"},{\"include\":\"#decl-block\"},{\"match\":\"\\\\*\",\"name\":\"keyword.generator.asterisk.tsx\"}]},\"function-call\":{\"patterns\":[{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"end\":\"(?<=\\\\))(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"name\":\"meta.function-call.tsx\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"},{\"include\":\"#paren-expression\"}]},{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"end\":\"(?<=>)(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"name\":\"meta.function-call.tsx\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"}]}]},\"function-call-optionals\":{\"patterns\":[{\"match\":\"\\\\?\\\\.\",\"name\":\"meta.function-call.tsx punctuation.accessor.optional.tsx\"},{\"match\":\"!\",\"name\":\"meta.function-call.tsx keyword.operator.definiteassignment.tsx\"}]},\"function-call-target\":{\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.tsx\"}]},\"function-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.modifier.async.tsx\"},\"4\":{\"name\":\"storage.type.function.tsx\"},\"5\":{\"name\":\"keyword.generator.asterisk.tsx\"},\"6\":{\"name\":\"meta.definition.function.tsx entity.name.function.tsx\"}},\"end\":\"(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|(?<=})\",\"name\":\"meta.function.tsx\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#function-body\"}]},\"function-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"},\"2\":{\"name\":\"storage.type.function.tsx\"},\"3\":{\"name\":\"keyword.generator.asterisk.tsx\"},\"4\":{\"name\":\"meta.definition.function.tsx entity.name.function.tsx\"}},\"end\":\"(?=;)|(?<=})\",\"name\":\"meta.function.expression.tsx\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#function-body\"}]},\"function-name\":{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.function.tsx entity.name.function.tsx\"},\"function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.begin.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.end.tsx\"}},\"name\":\"meta.parameters.tsx\",\"patterns\":[{\"include\":\"#function-parameters-body\"}]},\"function-parameters-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"include\":\"#parameter-name\"},{\"include\":\"#parameter-type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.tsx\"}]},\"identifiers\":{\"patterns\":[{\"include\":\"#object-identifiers\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.tsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"3\":{\"name\":\"entity.name.function.tsx\"}},\"match\":\"(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.tsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"3\":{\"name\":\"variable.other.constant.property.tsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.tsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"3\":{\"name\":\"variable.other.property.tsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"match\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\",\"name\":\"variable.other.constant.tsx\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"variable.other.readwrite.tsx\"}]},\"if-statement\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bif\\\\s*(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))\\\\s*(?!\\\\{))\",\"end\":\"(?=;|$|})\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(if)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.tsx\"},\"2\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<=\\\\))\\\\s*/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.tsx\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.tsx\"},\"2\":{\"name\":\"keyword.other.tsx\"}},\"name\":\"string.regexp.tsx\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"include\":\"#statements\"}]}]},\"import-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type)(?!\\\\s+from))?(?!\\\\s*[(:])(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"keyword.control.import.tsx\"},\"4\":{\"name\":\"keyword.control.type.tsx\"}},\"end\":\"(?<!(?:^|[^$._[:alnum:]])import)(?=;|$|^)\",\"name\":\"meta.import.tsx\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"begin\":\"(?<=(?:^|[^$._[:alnum:]])import)(?!\\\\s*[\\\"'])\",\"end\":\"\\\\bfrom\\\\b\",\"endCaptures\":{\"0\":{\"name\":\"keyword.control.from.tsx\"}},\"patterns\":[{\"include\":\"#import-export-declaration\"}]},{\"include\":\"#import-export-declaration\"}]},\"import-equals-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(require)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"keyword.control.import.tsx\"},\"4\":{\"name\":\"keyword.control.type.tsx\"},\"5\":{\"name\":\"variable.other.readwrite.alias.tsx\"},\"6\":{\"name\":\"keyword.operator.assignment.tsx\"},\"7\":{\"name\":\"keyword.control.require.tsx\"},\"8\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"name\":\"meta.import-equals.external.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(?!require\\\\b)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"keyword.control.import.tsx\"},\"4\":{\"name\":\"keyword.control.type.tsx\"},\"5\":{\"name\":\"variable.other.readwrite.alias.tsx\"},\"6\":{\"name\":\"keyword.operator.assignment.tsx\"}},\"end\":\"(?=;|$|^)\",\"name\":\"meta.import-equals.internal.tsx\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.tsx\"},\"2\":{\"name\":\"punctuation.accessor.tsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.tsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.other.readwrite.tsx\"}]}]},\"import-export-assert-clause\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(with)|(assert))\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.with.tsx\"},\"2\":{\"name\":\"keyword.control.assert.tsx\"},\"3\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object-literal.key.tsx\"},{\"match\":\":\",\"name\":\"punctuation.separator.key-value.tsx\"}]},\"import-export-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"name\":\"meta.block.tsx\",\"patterns\":[{\"include\":\"#import-export-clause\"}]},\"import-export-clause\":{\"patterns\":[{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.tsx\"},\"2\":{\"name\":\"keyword.control.default.tsx\"},\"3\":{\"name\":\"constant.language.import-export-all.tsx\"},\"4\":{\"name\":\"variable.other.readwrite.tsx\"},\"5\":{\"name\":\"string.quoted.alias.tsx\"},\"12\":{\"name\":\"keyword.control.as.tsx\"},\"13\":{\"name\":\"keyword.control.default.tsx\"},\"14\":{\"name\":\"variable.other.readwrite.alias.tsx\"},\"15\":{\"name\":\"string.quoted.alias.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(type)\\\\s+)?(?:\\\\b(default)|(\\\\*)|\\\\b([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\\\\s+(as)\\\\s+(?:(default(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"\\\\*\",\"name\":\"constant.language.import-export-all.tsx\"},{\"match\":\"\\\\b(default)\\\\b\",\"name\":\"keyword.control.default.tsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.tsx\"},\"2\":{\"name\":\"variable.other.readwrite.alias.tsx\"},\"3\":{\"name\":\"string.quoted.alias.tsx\"}},\"match\":\"(?:\\\\b(type)\\\\s+)?(?:([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"}]},\"import-export-declaration\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#import-export-block\"},{\"match\":\"\\\\bfrom\\\\b\",\"name\":\"keyword.control.from.tsx\"},{\"include\":\"#import-export-assert-clause\"},{\"include\":\"#import-export-clause\"}]},\"indexer-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=:)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"meta.brace.square.tsx\"},\"3\":{\"name\":\"variable.parameter.tsx\"}},\"end\":\"(])\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.tsx\"},\"2\":{\"name\":\"keyword.operator.optional.tsx\"}},\"name\":\"meta.indexer.declaration.tsx\",\"patterns\":[{\"include\":\"#type-annotation\"}]},\"indexer-mapped-type-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([-+])?(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s+(in)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.modifier.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"meta.brace.square.tsx\"},\"4\":{\"name\":\"entity.name.type.tsx\"},\"5\":{\"name\":\"keyword.operator.expression.in.tsx\"}},\"end\":\"(])([-+])?\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.tsx\"},\"2\":{\"name\":\"keyword.operator.type.modifier.tsx\"},\"3\":{\"name\":\"keyword.operator.optional.tsx\"}},\"name\":\"meta.indexer.mappedtype.declaration.tsx\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.as.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+\"},{\"include\":\"#type\"}]},\"inline-tags\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.bracket.square.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.square.end.jsdoc\"}},\"match\":\"(\\\\[)[^]]+(])(?=\\\\{@(?:link|linkcode|linkplain|tutorial))\",\"name\":\"constant.other.description.jsdoc\"},{\"begin\":\"(\\\\{)((@)(?:link(?:code|plain)?|tutorial))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"},\"2\":{\"name\":\"storage.type.class.jsdoc\"},\"3\":{\"name\":\"punctuation.definition.inline.tag.jsdoc\"}},\"end\":\"}|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"name\":\"entity.name.type.instance.jsdoc\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?=https?://)(?:[^*|}\\\\s]|\\\\*/)+)(\\\\|)?\"},{\"captures\":{\"1\":{\"name\":\"variable.other.description.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?:[^*@{|}\\\\s]|\\\\*[^/])+)(\\\\|)?\"}]}]},\"instanceof-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(instanceof)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.instanceof.tsx\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|([!=]==?)|(([\\\\&^|~]\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s+instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"patterns\":[{\"include\":\"#type\"}]},\"interface-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(interface)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.modifier.tsx\"},\"4\":{\"name\":\"storage.type.interface.tsx\"}},\"end\":\"(?<=})\",\"name\":\"meta.interface.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.interface.tsx\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"jsdoctype\":{\"patterns\":[{\"begin\":\"\\\\G(\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"}},\"contentName\":\"entity.name.type.instance.jsdoc\",\"end\":\"((}))\\\\s*|(?=\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"patterns\":[{\"include\":\"#brackets\"}]}]},\"jsx\":{\"patterns\":[{\"include\":\"#jsx-tag-without-attributes-in-expression\"},{\"include\":\"#jsx-tag-in-expression\"}]},\"jsx-children\":{\"patterns\":[{\"include\":\"#jsx-tag-without-attributes\"},{\"include\":\"#jsx-tag\"},{\"include\":\"#jsx-evaluated-code\"},{\"include\":\"#jsx-entities\"}]},\"jsx-entities\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.tsx\"},\"3\":{\"name\":\"punctuation.definition.entity.tsx\"}},\"match\":\"(&)([0-9A-Za-z]+|#[0-9]+|#x\\\\h+)(;)\",\"name\":\"constant.character.entity.tsx\"}]},\"jsx-evaluated-code\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.embedded.begin.tsx\"}},\"contentName\":\"meta.embedded.expression.tsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.embedded.end.tsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"jsx-string-double-quoted\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.tsx\"}},\"end\":\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.tsx\"}},\"name\":\"string.quoted.double.tsx\",\"patterns\":[{\"include\":\"#jsx-entities\"}]},\"jsx-string-single-quoted\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.tsx\"}},\"end\":\"'\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.tsx\"}},\"name\":\"string.quoted.single.tsx\",\"patterns\":[{\"include\":\"#jsx-entities\"}]},\"jsx-tag\":{\"begin\":\"(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"end\":\"(/>)|(</)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.tsx\"},\"2\":{\"name\":\"punctuation.definition.tag.begin.tsx\"},\"3\":{\"name\":\"entity.name.tag.namespace.tsx\"},\"4\":{\"name\":\"punctuation.separator.namespace.tsx\"},\"5\":{\"name\":\"entity.name.tag.tsx\"},\"6\":{\"name\":\"support.class.component.tsx\"},\"7\":{\"name\":\"punctuation.definition.tag.end.tsx\"}},\"name\":\"meta.tag.tsx\",\"patterns\":[{\"begin\":\"(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.tsx\"},\"2\":{\"name\":\"entity.name.tag.namespace.tsx\"},\"3\":{\"name\":\"punctuation.separator.namespace.tsx\"},\"4\":{\"name\":\"entity.name.tag.tsx\"},\"5\":{\"name\":\"support.class.component.tsx\"}},\"end\":\"(?=/?>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-arguments\"},{\"include\":\"#jsx-tag-attributes\"}]},{\"begin\":\"(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.tsx\"}},\"contentName\":\"meta.jsx.children.tsx\",\"end\":\"(?=</)\",\"patterns\":[{\"include\":\"#jsx-children\"}]}]},\"jsx-tag-attribute-assignment\":{\"match\":\"=(?=\\\\s*(?:[\\\"'{]|/\\\\*|//|\\\\n))\",\"name\":\"keyword.operator.assignment.tsx\"},\"jsx-tag-attribute-name\":{\"captures\":{\"1\":{\"name\":\"entity.other.attribute-name.namespace.tsx\"},\"2\":{\"name\":\"punctuation.separator.namespace.tsx\"},\"3\":{\"name\":\"entity.other.attribute-name.tsx\"}},\"match\":\"\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(:))?([$_[:alpha:]][-$_[:alnum:]]*)(?=[=\\\\s]|/?>|/\\\\*|//)\"},\"jsx-tag-attributes\":{\"begin\":\"\\\\s+\",\"end\":\"(?=/?>)\",\"name\":\"meta.tag.attributes.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#jsx-tag-attribute-name\"},{\"include\":\"#jsx-tag-attribute-assignment\"},{\"include\":\"#jsx-string-double-quoted\"},{\"include\":\"#jsx-string-single-quoted\"},{\"include\":\"#jsx-evaluated-code\"},{\"include\":\"#jsx-tag-attributes-illegal\"}]},\"jsx-tag-attributes-illegal\":{\"match\":\"\\\\S+\",\"name\":\"invalid.illegal.attribute.tsx\"},\"jsx-tag-in-expression\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[(*,:=>?\\\\[{]|&&|\\\\|\\\\||\\\\?|\\\\*/|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^default|[^$._[:alnum:]]default|^yield|[^$._[:alnum:]]yield|^)\\\\s*(?!<\\\\s*[$_[:alpha:]][$_[:alnum:]]*((\\\\s+extends\\\\s+[^=>])|,))(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"end\":\"(?!(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"patterns\":[{\"include\":\"#jsx-tag\"}]},\"jsx-tag-without-attributes\":{\"begin\":\"(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.tsx\"},\"2\":{\"name\":\"entity.name.tag.namespace.tsx\"},\"3\":{\"name\":\"punctuation.separator.namespace.tsx\"},\"4\":{\"name\":\"entity.name.tag.tsx\"},\"5\":{\"name\":\"support.class.component.tsx\"},\"6\":{\"name\":\"punctuation.definition.tag.end.tsx\"}},\"contentName\":\"meta.jsx.children.tsx\",\"end\":\"(</)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.tsx\"},\"2\":{\"name\":\"entity.name.tag.namespace.tsx\"},\"3\":{\"name\":\"punctuation.separator.namespace.tsx\"},\"4\":{\"name\":\"entity.name.tag.tsx\"},\"5\":{\"name\":\"support.class.component.tsx\"},\"6\":{\"name\":\"punctuation.definition.tag.end.tsx\"}},\"name\":\"meta.tag.without-attributes.tsx\",\"patterns\":[{\"include\":\"#jsx-children\"}]},\"jsx-tag-without-attributes-in-expression\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[(*,:=>?\\\\[{]|&&|\\\\|\\\\||\\\\?|\\\\*/|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^default|[^$._[:alnum:]]default|^yield|[^$._[:alnum:]]yield|^)\\\\s*(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>))\",\"end\":\"(?!(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>))\",\"patterns\":[{\"include\":\"#jsx-tag-without-attributes\"}]},\"label\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.label.tsx\"},\"2\":{\"name\":\"punctuation.separator.label.tsx\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#decl-block\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.label.tsx\"},\"2\":{\"name\":\"punctuation.separator.label.tsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)\"}]},\"literal\":{\"patterns\":[{\"include\":\"#numeric-literal\"},{\"include\":\"#boolean-literal\"},{\"include\":\"#null-literal\"},{\"include\":\"#undefined-literal\"},{\"include\":\"#numericConstant-literal\"},{\"include\":\"#array-literal\"},{\"include\":\"#this-literal\"},{\"include\":\"#super-literal\"}]},\"method-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?\\\\s*\\\\b(constructor)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.modifier.tsx\"},\"4\":{\"name\":\"storage.modifier.async.tsx\"},\"5\":{\"name\":\"storage.type.tsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.tsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\s*\\\\b(new)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))|(?:(\\\\*)\\\\s*)?)(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.modifier.tsx\"},\"4\":{\"name\":\"storage.modifier.async.tsx\"},\"5\":{\"name\":\"keyword.operator.new.tsx\"},\"6\":{\"name\":\"keyword.generator.asterisk.tsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.tsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.modifier.tsx\"},\"4\":{\"name\":\"storage.modifier.async.tsx\"},\"5\":{\"name\":\"storage.type.property.tsx\"},\"6\":{\"name\":\"keyword.generator.asterisk.tsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.tsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]}]},\"method-declaration-name\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??)\\\\s*[(<])\",\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.method.tsx entity.name.function.tsx\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.tsx\"}]},\"namespace-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(namespace|module)\\\\s+(?=[\\\"$'_`[:alpha:]])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.type.namespace.tsx\"}},\"end\":\"(?<=})|(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.namespace.declaration.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.type.module.tsx\"},{\"include\":\"#punctuation-accessor\"},{\"include\":\"#decl-block\"}]},\"new-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.new.tsx\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"name\":\"new.expr.tsx\",\"patterns\":[{\"include\":\"#expression\"}]},\"null-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))null(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.null.tsx\"},\"numeric-literal\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.tsx\"}},\"match\":\"\\\\b(?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.hex.tsx\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.tsx\"}},\"match\":\"\\\\b(?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.binary.tsx\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.tsx\"}},\"match\":\"\\\\b(?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.octal.tsx\"},{\"captures\":{\"0\":{\"name\":\"constant.numeric.decimal.tsx\"},\"1\":{\"name\":\"meta.delimiter.decimal.period.tsx\"},\"2\":{\"name\":\"storage.type.numeric.bigint.tsx\"},\"3\":{\"name\":\"meta.delimiter.decimal.period.tsx\"},\"4\":{\"name\":\"storage.type.numeric.bigint.tsx\"},\"5\":{\"name\":\"meta.delimiter.decimal.period.tsx\"},\"6\":{\"name\":\"storage.type.numeric.bigint.tsx\"},\"7\":{\"name\":\"storage.type.numeric.bigint.tsx\"},\"8\":{\"name\":\"meta.delimiter.decimal.period.tsx\"},\"9\":{\"name\":\"storage.type.numeric.bigint.tsx\"},\"10\":{\"name\":\"meta.delimiter.decimal.period.tsx\"},\"11\":{\"name\":\"storage.type.numeric.bigint.tsx\"},\"12\":{\"name\":\"meta.delimiter.decimal.period.tsx\"},\"13\":{\"name\":\"storage.type.numeric.bigint.tsx\"},\"14\":{\"name\":\"storage.type.numeric.bigint.tsx\"}},\"match\":\"(?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)\"}]},\"numericConstant-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))NaN(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.nan.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Infinity(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.infinity.tsx\"}]},\"object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element\"}]},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element-const\"}]},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-propertyName\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(:)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.destructuring.tsx\"}},\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.object.property.tsx\"}]},\"object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"patterns\":[{\"include\":\"#object-binding-element\"}]},\"object-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"patterns\":[{\"include\":\"#object-binding-element-const\"}]},\"object-identifiers\":{\"patterns\":[{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*\\\\??\\\\.\\\\s*prototype\\\\b(?!\\\\$))\",\"name\":\"support.class.tsx\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.tsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"3\":{\"name\":\"variable.other.constant.object.property.tsx\"},\"4\":{\"name\":\"variable.other.object.property.tsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(#?\\\\p{upper}[$_\\\\d[:upper:]]*)|(#?[$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"captures\":{\"1\":{\"name\":\"variable.other.constant.object.tsx\"},\"2\":{\"name\":\"variable.other.object.tsx\"}},\"match\":\"(?:(\\\\p{upper}[$_\\\\d[:upper:]]*)|([$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"}]},\"object-literal\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"name\":\"meta.objectliteral.tsx\",\"patterns\":[{\"include\":\"#object-member\"}]},\"object-literal-method-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"},\"2\":{\"name\":\"storage.type.property.tsx\"},\"3\":{\"name\":\"keyword.generator.asterisk.tsx\"}},\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.tsx\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"},\"2\":{\"name\":\"storage.type.property.tsx\"},\"3\":{\"name\":\"keyword.generator.asterisk.tsx\"}},\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#method-declaration-name\"}]}]},\"object-member\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#object-literal-method-declaration\"},{\"begin\":\"(?=\\\\[)\",\"end\":\"(?=:)|((?<=])(?=\\\\s*[(<]))\",\"name\":\"meta.object.member.tsx meta.object-literal.key.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#array-literal\"}]},{\"begin\":\"(?=[\\\"'`])\",\"end\":\"(?=:)|((?<=[\\\"'`])(?=((\\\\s*[(,<}])|(\\\\s+(as|satisifies)\\\\s+))))\",\"name\":\"meta.object.member.tsx meta.object-literal.key.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?=\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)))\",\"end\":\"(?=:)|(?=\\\\s*([(,<}])|(\\\\s+as|satisifies\\\\s+))\",\"name\":\"meta.object.member.tsx meta.object-literal.key.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#numeric-literal\"}]},{\"begin\":\"(?<=[]\\\"'`])(?=\\\\s*[(<])\",\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.tsx\",\"patterns\":[{\"include\":\"#function-body\"}]},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.tsx\"},\"1\":{\"name\":\"constant.numeric.decimal.tsx\"}},\"match\":\"(?![$_[:alpha:]])(\\\\d+)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.tsx\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.tsx\"},\"1\":{\"name\":\"entity.name.function.tsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/)*\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\",\"name\":\"meta.object.member.tsx\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.tsx\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.tsx\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.tsx\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.tsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"captures\":{\"1\":{\"name\":\"variable.other.readwrite.tsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.tsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*([,}]|$))\",\"name\":\"meta.object.member.tsx\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.tsx\"},\"2\":{\"name\":\"keyword.control.satisfies.tsx\"}},\"end\":\"(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|^|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisifies)\\\\s+))\",\"name\":\"meta.object.member.tsx\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(?=[$_[:alpha:]][$_[:alnum:]]*\\\\s*=)\",\"end\":\"(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.tsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\":\",\"beginCaptures\":{\"0\":{\"name\":\"meta.object-literal.key.tsx punctuation.separator.key-value.tsx\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.tsx\",\"patterns\":[{\"begin\":\"(?<=:)\\\\s*(async)?(?=\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"},\"2\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(?=<\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<=>)\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"include\":\"#possibly-arrow-return-type\"},{\"include\":\"#expression\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#decl-block\"}]},\"parameter-array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.tsx\"}},\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#parameter-array-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"}]},\"parameter-name\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"keyword.operator.rest.tsx\"},\"3\":{\"name\":\"entity.name.function.tsx variable.language.this.tsx\"},\"4\":{\"name\":\"entity.name.function.tsx\"},\"5\":{\"name\":\"keyword.operator.optional.tsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"keyword.operator.rest.tsx\"},\"3\":{\"name\":\"variable.parameter.tsx variable.language.this.tsx\"},\"4\":{\"name\":\"variable.parameter.tsx\"},\"5\":{\"name\":\"keyword.operator.optional.tsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)\"}]},\"parameter-object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#parameter-binding-element\"},{\"include\":\"#paren-expression\"}]},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.tsx\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.tsx\"}},\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},\"parameter-type-annotation\":{\"patterns\":[{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.tsx\"}},\"end\":\"(?=[),])|(?==[^>])\",\"name\":\"meta.type.annotation.tsx\",\"patterns\":[{\"include\":\"#type\"}]}]},\"paren-expression\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"paren-expression-possibly-arrow\":{\"patterns\":[{\"begin\":\"(?<=[(,=])\\\\s*(async)?(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"begin\":\"(?<=[(,=]|=>|^return|[^$._[:alnum:]]return)\\\\s*(async)?(?=\\\\s*((((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()|(<)|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)))\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.tsx\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"include\":\"#possibly-arrow-return-type\"}]},\"paren-expression-possibly-arrow-with-typeparameters\":{\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},\"possibly-arrow-return-type\":{\"begin\":\"(?<=\\\\)|^)\\\\s*(:)(?=\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*=>)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.arrow.tsx meta.return.type.arrow.tsx keyword.operator.type.annotation.tsx\"}},\"contentName\":\"meta.arrow.tsx meta.return.type.arrow.tsx\",\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"property-accessor\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(accessor|get|set)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.type.property.tsx\"},\"punctuation-accessor\":{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.tsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.tsx\"}},\"match\":\"(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d))\"},\"punctuation-comma\":{\"match\":\",\",\"name\":\"punctuation.separator.comma.tsx\"},\"punctuation-semicolon\":{\"match\":\";\",\"name\":\"punctuation.terminator.statement.tsx\"},\"qstring-double\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.tsx\"}},\"end\":\"(\\\")|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.tsx\"},\"2\":{\"name\":\"invalid.illegal.newline.tsx\"}},\"name\":\"string.quoted.double.tsx\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"qstring-single\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.tsx\"}},\"end\":\"(')|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.tsx\"},\"2\":{\"name\":\"invalid.illegal.newline.tsx\"}},\"name\":\"string.quoted.single.tsx\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"regex\":{\"patterns\":[{\"begin\":\"(?<!\\\\+\\\\+|--|})(?<=[!(+,:=?\\\\[]|^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case|=>|&&|\\\\|\\\\||\\\\*/)\\\\s*(/)(?![*/])(?=(?:[^()/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)+]|\\\\(([^)\\\\\\\\]|\\\\\\\\.)+\\\\))+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.tsx\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.tsx\"},\"2\":{\"name\":\"keyword.other.tsx\"}},\"name\":\"string.regexp.tsx\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"((?<![]$)_[:alnum:]]|\\\\+\\\\+|--|}|\\\\*/)|((?<=^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case))\\\\s*)/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.tsx\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.tsx\"},\"2\":{\"name\":\"keyword.other.tsx\"}},\"name\":\"string.regexp.tsx\",\"patterns\":[{\"include\":\"#regexp\"}]}]},\"regex-character-class\":{\"patterns\":[{\"match\":\"\\\\\\\\[DSWdfnrstvw]|\\\\.\",\"name\":\"constant.other.character-class.regexp\"},{\"match\":\"\\\\\\\\([0-7]{3}|x\\\\h{2}|u\\\\h{4})\",\"name\":\"constant.character.numeric.regexp\"},{\"match\":\"\\\\\\\\c[A-Z]\",\"name\":\"constant.character.control.regexp\"},{\"match\":\"\\\\\\\\.\",\"name\":\"constant.character.escape.backslash.regexp\"}]},\"regexp\":{\"patterns\":[{\"match\":\"\\\\\\\\[Bb]|[$^]\",\"name\":\"keyword.control.anchor.regexp\"},{\"captures\":{\"0\":{\"name\":\"keyword.other.back-reference.regexp\"},\"1\":{\"name\":\"variable.other.regexp\"}},\"match\":\"\\\\\\\\(?:[1-9]\\\\d*|k<([$A-Z_a-z][$\\\\w]*)>)\"},{\"match\":\"[*+?]|\\\\{(\\\\d+,\\\\d+|\\\\d+,|,\\\\d+|\\\\d+)}\\\\??\",\"name\":\"keyword.operator.quantifier.regexp\"},{\"match\":\"\\\\|\",\"name\":\"keyword.operator.or.regexp\"},{\"begin\":\"(\\\\()((\\\\?=)|(\\\\?!)|(\\\\?<=)|(\\\\?<!))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"},\"2\":{\"name\":\"punctuation.definition.group.assertion.regexp\"},\"3\":{\"name\":\"meta.assertion.look-ahead.regexp\"},\"4\":{\"name\":\"meta.assertion.negative-look-ahead.regexp\"},\"5\":{\"name\":\"meta.assertion.look-behind.regexp\"},\"6\":{\"name\":\"meta.assertion.negative-look-behind.regexp\"}},\"end\":\"(\\\\))\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.assertion.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"\\\\((?:(\\\\?:)|\\\\?<([$A-Z_a-z][$\\\\w]*)>)?\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"},\"1\":{\"name\":\"punctuation.definition.group.no-capture.regexp\"},\"2\":{\"name\":\"variable.other.regexp\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"(\\\\[)(\\\\^)?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"},\"2\":{\"name\":\"keyword.operator.negation.regexp\"}},\"end\":\"(])\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"}},\"name\":\"constant.other.character-class.set.regexp\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"constant.character.numeric.regexp\"},\"2\":{\"name\":\"constant.character.control.regexp\"},\"3\":{\"name\":\"constant.character.escape.backslash.regexp\"},\"4\":{\"name\":\"constant.character.numeric.regexp\"},\"5\":{\"name\":\"constant.character.control.regexp\"},\"6\":{\"name\":\"constant.character.escape.backslash.regexp\"}},\"match\":\"(?:.|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))-(?:[^]\\\\\\\\]|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))\",\"name\":\"constant.other.character-class.range.regexp\"},{\"include\":\"#regex-character-class\"}]},{\"include\":\"#regex-character-class\"}]},\"return-type\":{\"patterns\":[{\"begin\":\"(?<=\\\\))\\\\s*(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.tsx\"}},\"end\":\"(?<![\\\\&:|])(?=$|^|[,;{}]|//)\",\"name\":\"meta.return.type.tsx\",\"patterns\":[{\"include\":\"#return-type-core\"}]},{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.tsx\"}},\"end\":\"(?<![\\\\&:|])((?=[,;{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.return.type.tsx\",\"patterns\":[{\"include\":\"#return-type-core\"}]}]},\"return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<=[\\\\&:|])(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"shebang\":{\"captures\":{\"1\":{\"name\":\"punctuation.definition.comment.tsx\"}},\"match\":\"\\\\A(#!).*(?=$)\",\"name\":\"comment.line.shebang.tsx\"},\"single-line-comment-consuming-line-ending\":{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.tsx\"},\"2\":{\"name\":\"comment.line.double-slash.tsx\"},\"3\":{\"name\":\"punctuation.definition.comment.tsx\"},\"4\":{\"name\":\"storage.type.internaldeclaration.tsx\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.tsx\"}},\"contentName\":\"comment.line.double-slash.tsx\",\"end\":\"(?=^)\"},\"statements\":{\"patterns\":[{\"include\":\"#declaration\"},{\"include\":\"#control-statement\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#label\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template\"}]},\"string-character-escape\":{\"match\":\"\\\\\\\\(x\\\\h{2}|u\\\\h{4}|u\\\\{\\\\h+}|[012][0-7]{0,2}|3[0-6][0-7]?|37[0-7]?|[4-7][0-7]?|.|$)\",\"name\":\"constant.character.escape.tsx\"},\"super-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))super\\\\b(?!\\\\$)\",\"name\":\"variable.language.super.tsx\"},\"support-function-call-identifiers\":{\"patterns\":[{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#object-identifiers\"},{\"include\":\"#punctuation-accessor\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\(\\\\s*[\\\"'`])\",\"name\":\"keyword.operator.expression.import.tsx\"}]},\"support-objects\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(arguments)\\\\b(?!\\\\$)\",\"name\":\"variable.language.arguments.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(Promise)\\\\b(?!\\\\$)\",\"name\":\"support.class.promise.tsx\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.import.tsx\"},\"2\":{\"name\":\"punctuation.accessor.tsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"4\":{\"name\":\"support.variable.property.importmeta.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(import)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(meta)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.new.tsx\"},\"2\":{\"name\":\"punctuation.accessor.tsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"4\":{\"name\":\"support.variable.property.target.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(target)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.tsx\"},\"2\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"3\":{\"name\":\"support.variable.property.tsx\"},\"4\":{\"name\":\"support.constant.tsx\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(constructor|length|prototype|__proto__)\\\\b(?!\\\\$|\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\()|(EPSILON|MAX_SAFE_INTEGER|MAX_VALUE|MIN_SAFE_INTEGER|MIN_VALUE|NEGATIVE_INFINITY|POSITIVE_INFINITY)\\\\b(?!\\\\$))\"},{\"captures\":{\"1\":{\"name\":\"support.type.object.module.tsx\"},\"2\":{\"name\":\"support.type.object.module.tsx\"},\"3\":{\"name\":\"punctuation.accessor.tsx\"},\"4\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"5\":{\"name\":\"support.type.object.module.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(exports)|(module)(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(exports|id|filename|loaded|parent|children))?)\\\\b(?!\\\\$)\"}]},\"switch-statement\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bswitch\\\\s*\\\\()\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"name\":\"switch-statement.expr.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(switch)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.tsx\"},\"2\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"name\":\"switch-expression.expr.tsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"(?=})\",\"name\":\"switch-block.expr.tsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default(?=:))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.tsx\"}},\"end\":\"(?=:)\",\"name\":\"case-clause.expr.tsx\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(:)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"case-clause.expr.tsx punctuation.definition.section.case-statement.tsx\"},\"2\":{\"name\":\"meta.block.tsx punctuation.definition.block.tsx\"}},\"contentName\":\"meta.block.tsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"meta.block.tsx punctuation.definition.block.tsx\"}},\"patterns\":[{\"include\":\"#statements\"}]},{\"captures\":{\"0\":{\"name\":\"case-clause.expr.tsx punctuation.definition.section.case-statement.tsx\"}},\"match\":\"(:)\"},{\"include\":\"#statements\"}]}]},\"template\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.tsx\"},\"2\":{\"name\":\"string.template.tsx punctuation.definition.string.template.begin.tsx\"}},\"contentName\":\"string.template.tsx\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.tsx punctuation.definition.string.template.end.tsx\"}},\"patterns\":[{\"include\":\"#template-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-call\":{\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*)(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"end\":\"(?=`)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.tagged-template.tsx\"}]},{\"include\":\"#type-arguments\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?\\\\s*(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.tsx\"}},\"end\":\"(?=`)\",\"patterns\":[{\"include\":\"#type-arguments\"}]}]},\"template-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.tsx\"}},\"contentName\":\"meta.embedded.line.tsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.tsx\"}},\"name\":\"meta.template.expression.tsx\",\"patterns\":[{\"include\":\"#expression\"}]},\"template-type\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.tsx\"},\"2\":{\"name\":\"string.template.tsx punctuation.definition.string.template.begin.tsx\"}},\"contentName\":\"string.template.tsx\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.tsx punctuation.definition.string.template.end.tsx\"}},\"patterns\":[{\"include\":\"#template-type-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-type-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.tsx\"}},\"contentName\":\"meta.embedded.line.tsx\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.tsx\"}},\"name\":\"meta.template.expression.tsx\",\"patterns\":[{\"include\":\"#type\"}]},\"ternary-expression\":{\"begin\":\"(?!\\\\?\\\\.\\\\s*\\\\D)(\\\\?)(?!\\\\?)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.tsx\"}},\"end\":\"\\\\s*(:)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.tsx\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"this-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))this\\\\b(?!\\\\$)\",\"name\":\"variable.language.this.tsx\"},\"type\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#type-primitive\"},{\"include\":\"#type-builtin-literals\"},{\"include\":\"#type-parameters\"},{\"include\":\"#type-tuple\"},{\"include\":\"#type-object\"},{\"include\":\"#type-operators\"},{\"include\":\"#type-conditional\"},{\"include\":\"#type-fn-type-parameters\"},{\"include\":\"#type-paren-or-function-parameters\"},{\"include\":\"#type-function-return-type\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\"},{\"include\":\"#type-name\"}]},\"type-alias-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(type)\\\\b\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.type.type.tsx\"},\"4\":{\"name\":\"entity.name.type.alias.tsx\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.type.declaration.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"begin\":\"(=)\\\\s*(intrinsic)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.tsx\"},\"2\":{\"name\":\"keyword.control.intrinsic.tsx\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(=)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.tsx\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-annotation\":{\"patterns\":[{\"begin\":\"(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.tsx\"}},\"end\":\"(?<![\\\\&:|])(?!\\\\s*[\\\\&|]\\\\s+)((?=^|[]),;}]|//)|(?==[^>])|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.tsx\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.tsx\"}},\"end\":\"(?<![\\\\&:|])((?=[]),;}]|//)|(?==[^>])|(?=^\\\\s*$)|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.tsx\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-arguments\":{\"begin\":\"<\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.begin.tsx\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.end.tsx\"}},\"name\":\"meta.type.parameters.tsx\",\"patterns\":[{\"include\":\"#type-arguments-body\"}]},\"type-arguments-body\":{\"patterns\":[{\"captures\":{\"0\":{\"name\":\"keyword.operator.type.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(_)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"type-builtin-literals\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(this|true|false|undefined|null|object)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.builtin.tsx\"},\"type-conditional\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"}},\"end\":\"(?<=:)\",\"patterns\":[{\"begin\":\"\\\\?\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.tsx\"}},\"end\":\":\",\"endCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.tsx\"}},\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#type\"}]}]},\"type-fn-type-parameters\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b(?=\\\\s*<)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.type.constructor.tsx storage.modifier.tsx\"},\"2\":{\"name\":\"meta.type.constructor.tsx keyword.control.new.tsx\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"keyword.control.new.tsx\"}},\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.constructor.tsx\",\"patterns\":[{\"include\":\"#function-parameters\"}]},{\"begin\":\"((?=\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>))))))\",\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.function.tsx\",\"patterns\":[{\"include\":\"#function-parameters\"}]}]},\"type-function-return-type\":{\"patterns\":[{\"begin\":\"(=>)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.function.arrow.tsx\"}},\"end\":\"(?<!=>)(?<![\\\\&|])(?=[]),:;=>?{}]|//|$)\",\"name\":\"meta.type.function.return.tsx\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.tsx\"}},\"end\":\"(?<!=>)(?<![\\\\&|])((?=[]),:;=>?{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.type.function.return.tsx\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]}]},\"type-function-return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<==>)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"type-infer\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.infer.tsx\"},\"2\":{\"name\":\"entity.name.type.tsx\"},\"3\":{\"name\":\"keyword.operator.expression.extends.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(infer)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s+(extends)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))?\",\"name\":\"meta.type.infer.tsx\"}]},\"type-name\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(<)\",\"captures\":{\"1\":{\"name\":\"entity.name.type.module.tsx\"},\"2\":{\"name\":\"punctuation.accessor.tsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.tsx\"},\"4\":{\"name\":\"meta.type.parameters.tsx punctuation.definition.typeparameters.begin.tsx\"}},\"contentName\":\"meta.type.parameters.tsx\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.tsx punctuation.definition.typeparameters.end.tsx\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(<)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.type.tsx\"},\"2\":{\"name\":\"meta.type.parameters.tsx punctuation.definition.typeparameters.begin.tsx\"}},\"contentName\":\"meta.type.parameters.tsx\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.tsx punctuation.definition.typeparameters.end.tsx\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.tsx\"},\"2\":{\"name\":\"punctuation.accessor.tsx\"},\"3\":{\"name\":\"punctuation.accessor.optional.tsx\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"entity.name.type.tsx\"}]},\"type-object\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.tsx\"}},\"name\":\"meta.object.type.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#indexer-mapped-type-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#type-annotation\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.tsx\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#type\"}]},\"type-operators\":{\"patterns\":[{\"include\":\"#typeof-operator\"},{\"include\":\"#type-infer\"},{\"begin\":\"([\\\\&|])(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.tsx\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"begin\":\"[\\\\&|]\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.tsx\"}},\"end\":\"(?=\\\\S)\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))keyof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.keyof.tsx\"},{\"match\":\"([:?])\",\"name\":\"keyword.operator.ternary.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\()\",\"name\":\"keyword.operator.expression.import.tsx\"}]},\"type-parameters\":{\"begin\":\"(<)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.begin.tsx\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.end.tsx\"}},\"name\":\"meta.type.parameters.tsx\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends|in|out|const)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.tsx\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"(=)(?!>)\",\"name\":\"keyword.operator.assignment.tsx\"}]},\"type-paren-or-function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.tsx\"}},\"name\":\"meta.type.paren.cover.tsx\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"keyword.operator.rest.tsx\"},\"3\":{\"name\":\"entity.name.function.tsx variable.language.this.tsx\"},\"4\":{\"name\":\"entity.name.function.tsx\"},\"5\":{\"name\":\"keyword.operator.optional.tsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=\\\\s*(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.tsx\"},\"2\":{\"name\":\"keyword.operator.rest.tsx\"},\"3\":{\"name\":\"variable.parameter.tsx variable.language.this.tsx\"},\"4\":{\"name\":\"variable.parameter.tsx\"},\"5\":{\"name\":\"keyword.operator.optional.tsx\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=:)\"},{\"include\":\"#type-annotation\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.tsx\"},{\"include\":\"#type\"}]},\"type-predicate-operator\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.tsx\"},\"2\":{\"name\":\"variable.parameter.tsx variable.language.this.tsx\"},\"3\":{\"name\":\"variable.parameter.tsx\"},\"4\":{\"name\":\"keyword.operator.expression.is.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(asserts)\\\\s+)?(?!asserts)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s(is)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.tsx\"},\"2\":{\"name\":\"variable.parameter.tsx variable.language.this.tsx\"},\"3\":{\"name\":\"variable.parameter.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(asserts)\\\\s+(?!is)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))asserts(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.type.asserts.tsx\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))is(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.is.tsx\"}]},\"type-primitive\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(string|number|bigint|boolean|symbol|any|void|never|unknown)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.primitive.tsx\"},\"type-string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template-type\"}]},\"type-tuple\":{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.square.tsx\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.tsx\"}},\"name\":\"meta.type.tuple.tsx\",\"patterns\":[{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.rest.tsx\"},{\"captures\":{\"1\":{\"name\":\"entity.name.label.tsx\"},\"2\":{\"name\":\"keyword.operator.optional.tsx\"},\"3\":{\"name\":\"punctuation.separator.label.tsx\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(\\\\?)?\\\\s*(:)\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"typeof-operator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))typeof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.expression.typeof.tsx\"}},\"end\":\"(?=[]\\\\&),:;=>?{|}]|(extends\\\\s+)|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type-arguments\"},{\"include\":\"#expression\"}]},\"undefined-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))undefined(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.undefined.tsx\"},\"var-expr\":{\"patterns\":[{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!^let|[^$._[:alnum:]]let|^var|[^$._[:alnum:]]var)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.tsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.type.tsx\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.tsx\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.type.tsx\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]])const)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.tsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.type.tsx\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.tsx\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.type.tsx\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]]|^await\\\\s+|[^$._[:alnum:]]await\\\\s+)using)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.tsx\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.tsx\"},\"2\":{\"name\":\"storage.modifier.tsx\"},\"3\":{\"name\":\"storage.type.tsx\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*((?!\\\\S)|(?=//))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.tsx\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"var-single-const\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.tsx variable.other.constant.tsx entity.name.function.tsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.tsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.tsx variable.other.constant.tsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.tsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.tsx entity.name.function.tsx\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.tsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.tsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.tsx variable.other.constant.tsx\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.tsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.tsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.tsx variable.other.readwrite.tsx\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.tsx\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.tsx\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable-type-annotation\":{\"patterns\":[{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"variable-initializer\":{\"patterns\":[{\"begin\":\"(?<![!=])(=)(?!=)(?=\\\\s*\\\\S)(?!\\\\s*.*=>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.tsx\"}},\"end\":\"(?=$|^|[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<![!=])(=)(?!=)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.tsx\"}},\"end\":\"(?=[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))|(?=^\\\\s*$)|(?<![-\\\\&*+/|])(?<=\\\\S)(?<!=)(?=\\\\s*$)\",\"patterns\":[{\"include\":\"#expression\"}]}]}},\"scopeName\":\"source.tsx\"}"));
var $7bf97d7efe7ac605$export$2e2bcd8739ae039 = [
    $7bf97d7efe7ac605$var$lang
];


const $610d3eeea77f0533$var$lang = Object.freeze(JSON.parse("{\"displayName\":\"TypeScript\",\"name\":\"typescript\",\"patterns\":[{\"include\":\"#directives\"},{\"include\":\"#statements\"},{\"include\":\"#shebang\"}],\"repository\":{\"access-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(abstract|declare|override|public|protected|private|readonly|static)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.ts\"},\"after-operator-block-as-object-literal\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[!(+,:=>?\\\\[]|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^yield|[^$._[:alnum:]]yield|^throw|[^$._[:alnum:]]throw|^in|[^$._[:alnum:]]in|^of|[^$._[:alnum:]]of|^typeof|[^$._[:alnum:]]typeof|&&|\\\\|\\\\||\\\\*)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.objectliteral.ts\",\"patterns\":[{\"include\":\"#object-member\"}]},\"array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"patterns\":[{\"include\":\"#binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"array-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"patterns\":[{\"include\":\"#binding-element-const\"},{\"include\":\"#punctuation-comma\"}]},\"array-literal\":{\"begin\":\"\\\\s*(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.square.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.ts\"}},\"name\":\"meta.array.literal.ts\",\"patterns\":[{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]},\"arrow-function\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"variable.parameter.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async)\\\\s+)?([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?==>)\",\"name\":\"meta.arrow.ts\"},{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async))?((?<![]!)}])\\\\s*(?=((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.arrow.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#arrow-return-type\"},{\"include\":\"#possibly-arrow-return-type\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.ts\"}},\"end\":\"((?<=[}\\\\S])(?<!=>)|((?!\\\\{)(?=\\\\S)))(?!/[*/])\",\"name\":\"meta.arrow.ts\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"}]}]},\"arrow-return-type\":{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.return.type.arrow.ts\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"arrow-return-type-body\":{\"patterns\":[{\"begin\":\"(?<=:)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"async-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(async)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.async.ts\"},\"binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#array-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"}]},\"binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"}]},\"boolean-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))true(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.true.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))false(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.false.ts\"}]},\"brackets\":{\"patterns\":[{\"begin\":\"\\\\{\",\"end\":\"}|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]},{\"begin\":\"\\\\[\",\"end\":\"]|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]}]},\"cast\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"meta.brace.angle.ts\"}},\"match\":\"\\\\s*(<)\\\\s*(const)\\\\s*(>)\",\"name\":\"cast.expr.ts\"},{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=^return|[^$._[:alnum:]]return|^throw|[^$._[:alnum:]]throw|^yield|[^$._[:alnum:]]yield|^await|[^$._[:alnum:]]await|^default|[^$._[:alnum:]]default|[\\\\&(*,:=>?^|]|[^$_[:alnum:]](?:\\\\+\\\\+|--)|[^+]\\\\+|[^-]-)\\\\s*(<)(?!<?=)(?!\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"}},\"name\":\"cast.expr.ts\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(?<=^)\\\\s*(<)(?=[$_[:alpha:]][$_[:alnum:]]*\\\\s*>)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"}},\"name\":\"cast.expr.ts\",\"patterns\":[{\"include\":\"#type\"}]}]},\"class-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(class)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.type.class.ts\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.ts\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-declaration-or-expression-patterns\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.class.ts\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"class-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(class)\\\\b(?=\\\\s+|[<{]|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"storage.type.class.ts\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.ts\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-or-interface-body\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#decorator\"},{\"begin\":\"(?<=:)\\\\s*\",\"end\":\"(?=[-\\\\])+,:;}\\\\s]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#string\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#access-modifier\"},{\"include\":\"#property-accessor\"},{\"include\":\"#async-modifier\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"}]},\"class-or-interface-heritage\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(extends|implements)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"end\":\"(?=\\\\{)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"include\":\"#type-parameters\"},{\"include\":\"#expressionWithoutIdentifiers\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*(\\\\s*\\\\??\\\\.\\\\s*[$_[:alpha:]][$_[:alnum:]]*)*\\\\s*)\"},{\"captures\":{\"1\":{\"name\":\"entity.other.inherited-class.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\"},{\"include\":\"#expressionPunctuations\"}]},\"comment\":{\"patterns\":[{\"begin\":\"/\\\\*\\\\*(?!/)\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.ts\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.ts\"}},\"name\":\"comment.block.documentation.ts\",\"patterns\":[{\"include\":\"#docblock\"}]},{\"begin\":\"(/\\\\*)(?:\\\\s*((@)internal)(?=\\\\s|(\\\\*/)))?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.ts\"},\"2\":{\"name\":\"storage.type.internaldeclaration.ts\"},\"3\":{\"name\":\"punctuation.decorator.internaldeclaration.ts\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.ts\"}},\"name\":\"comment.block.ts\"},{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.ts\"},\"2\":{\"name\":\"comment.line.double-slash.ts\"},\"3\":{\"name\":\"punctuation.definition.comment.ts\"},\"4\":{\"name\":\"storage.type.internaldeclaration.ts\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.ts\"}},\"contentName\":\"comment.line.double-slash.ts\",\"end\":\"(?=$)\"}]},\"control-statement\":{\"patterns\":[{\"include\":\"#switch-statement\"},{\"include\":\"#for-loop\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(catch|finally|throw|try)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.trycatch.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.loop.ts\"},\"2\":{\"name\":\"entity.name.label.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|goto)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|do|goto|while)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.loop.ts\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(return)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.flow.ts\"}},\"end\":\"(?=[;}]|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default|switch)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.switch.ts\"},{\"include\":\"#if-statement\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(else|if)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.conditional.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(with)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.with.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(package)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(debugger)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.other.debugger.ts\"}]},\"decl-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.block.ts\",\"patterns\":[{\"include\":\"#statements\"}]},\"declaration\":{\"patterns\":[{\"include\":\"#decorator\"},{\"include\":\"#var-expr\"},{\"include\":\"#function-declaration\"},{\"include\":\"#class-declaration\"},{\"include\":\"#interface-declaration\"},{\"include\":\"#enum-declaration\"},{\"include\":\"#namespace-declaration\"},{\"include\":\"#type-alias-declaration\"},{\"include\":\"#import-equals-declaration\"},{\"include\":\"#import-declaration\"},{\"include\":\"#export-declaration\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(declare|export)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.ts\"}]},\"decorator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))@\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.decorator.ts\"}},\"end\":\"(?=\\\\s)\",\"name\":\"meta.decorator.ts\",\"patterns\":[{\"include\":\"#expression\"}]},\"destructuring-const\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.ts\",\"patterns\":[{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.ts\",\"patterns\":[{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-parameter\":{\"patterns\":[{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"name\":\"meta.parameter.object-binding-pattern.ts\",\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"name\":\"meta.paramter.array-binding-pattern.ts\",\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]}]},\"destructuring-parameter-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"variable.parameter.ts\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.ts\",\"patterns\":[{\"include\":\"#object-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.ts\",\"patterns\":[{\"include\":\"#array-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-variable-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"meta.definition.variable.ts variable.other.readwrite.ts\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable-rest-const\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"meta.definition.variable.ts variable.other.constant.ts\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"directives\":{\"begin\":\"^(///)\\\\s*(?=<(reference|amd-dependency|amd-module)(\\\\s+(path|types|no-default-lib|lib|name|resolution-mode)\\\\s*=\\\\s*(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))+\\\\s*/>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.ts\"}},\"end\":\"(?=$)\",\"name\":\"comment.line.triple-slash.directive.ts\",\"patterns\":[{\"begin\":\"(<)(reference|amd-dependency|amd-module)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.directive.ts\"},\"2\":{\"name\":\"entity.name.tag.directive.ts\"}},\"end\":\"/>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.directive.ts\"}},\"name\":\"meta.tag.ts\",\"patterns\":[{\"match\":\"path|types|no-default-lib|lib|name|resolution-mode\",\"name\":\"entity.other.attribute-name.directive.ts\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.ts\"},{\"include\":\"#string\"}]}]},\"docblock\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.access-type.jsdoc\"}},\"match\":\"((@)a(?:ccess|pi))\\\\s+(p(?:rivate|rotected|ublic))\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"5\":{\"name\":\"constant.other.email.link.underline.jsdoc\"},\"6\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"match\":\"((@)author)\\\\s+([^*/<>@\\\\s](?:[^*/<>@]|\\\\*[^/])*)(?:\\\\s*(<)([^>\\\\s]+)(>))?\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"keyword.operator.control.jsdoc\"},\"5\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)borrows)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\\\\s+(as)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)example)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=@|\\\\*/)\",\"name\":\"meta.example.jsdoc\",\"patterns\":[{\"match\":\"^\\\\s\\\\*\\\\s+\"},{\"begin\":\"\\\\G(<)caption(>)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"contentName\":\"constant.other.description.jsdoc\",\"end\":\"(</)caption(>)|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}}},{\"captures\":{\"0\":{\"name\":\"source.embedded.ts\"}},\"match\":\"[^*@\\\\s](?:[^*]|\\\\*[^/])*\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.symbol-type.jsdoc\"}},\"match\":\"((@)kind)\\\\s+(class|constant|event|external|file|function|member|mixin|module|namespace|typedef)\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"4\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)see)\\\\s+(?:((?=https?://)(?:[^*\\\\s]|\\\\*[^/])+)|((?!https?://|(?:\\\\[[^]\\\\[]*])?\\\\{@(?:link|linkcode|linkplain|tutorial)\\\\b)(?:[^*/@\\\\s]|\\\\*[^/])+))\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)template)\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*(?:\\\\s*,\\\\s*[$A-Z_a-z][]$.\\\\[\\\\w]*)*)\"},{\"begin\":\"((@)template)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:arg|argument|const|constant|member|namespace|param|var))\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*)\"},{\"begin\":\"((@)typedef)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"(?:[^*/@\\\\s]|\\\\*[^/])+\",\"name\":\"entity.name.type.instance.jsdoc\"}]},{\"begin\":\"((@)(?:arg|argument|const|constant|member|namespace|param|prop|property|var))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.optional-value.begin.bracket.square.jsdoc\"},\"2\":{\"name\":\"keyword.operator.assignment.jsdoc\"},\"3\":{\"name\":\"source.embedded.ts\"},\"4\":{\"name\":\"punctuation.definition.optional-value.end.bracket.square.jsdoc\"},\"5\":{\"name\":\"invalid.illegal.syntax.jsdoc\"}},\"match\":\"(\\\\[)\\\\s*[$\\\\w]+(?:(?:\\\\[])?\\\\.[$\\\\w]+)*(?:\\\\s*(=)\\\\s*((?>\\\"(?:\\\\*(?!/)|\\\\\\\\(?!\\\")|[^*\\\\\\\\])*?\\\"|'(?:\\\\*(?!/)|\\\\\\\\(?!')|[^*\\\\\\\\])*?'|\\\\[(?:\\\\*(?!/)|[^*])*?]|(?:\\\\*(?!/)|\\\\s(?!\\\\s*])|\\\\[.*?(?:]|(?=\\\\*/))|[^]*\\\\[\\\\s])*)*))?\\\\s*(?:(])((?:[^*\\\\s]|\\\\*[^/\\\\s])+)?|(?=\\\\*/))\",\"name\":\"variable.other.jsdoc\"}]},{\"begin\":\"((@)(?:define|enum|exception|export|extends|lends|implements|modifies|namespace|private|protected|returns?|satisfies|suppress|this|throws|type|yields?))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)(?:alias|augments|callback|constructs|emits|event|fires|exports?|extends|external|function|func|host|lends|listens|interface|memberof!?|method|module|mixes|mixin|name|requires|see|this|typedef|uses))\\\\s+((?:[^*@{}\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)(?:default(?:value)?|license|version))\\\\s+(([\\\"']))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.string.begin.jsdoc\"}},\"contentName\":\"variable.other.jsdoc\",\"end\":\"(\\\\3)|(?=$|\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"variable.other.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.string.end.jsdoc\"}}},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:default(?:value)?|license|tutorial|variation|version))\\\\s+([^*\\\\s]+)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"(@)(?:abstract|access|alias|api|arg|argument|async|attribute|augments|author|beta|borrows|bubbles|callback|chainable|class|classdesc|code|config|const|constant|constructor|constructs|copyright|default|defaultvalue|define|deprecated|desc|description|dict|emits|enum|event|example|exception|exports?|extends|extension(?:_?for)?|external|externs|file|fileoverview|final|fires|for|func|function|generator|global|hideconstructor|host|ignore|implements|implicitCast|inherit[Dd]oc|inner|instance|interface|internal|kind|lends|license|listens|main|member|memberof!?|method|mixes|mixins?|modifies|module|name|namespace|noalias|nocollapse|nocompile|nosideeffects|override|overview|package|param|polymer(?:Behavior)?|preserve|private|prop|property|protected|public|read[Oo]nly|record|require[ds]|returns?|see|since|static|struct|submodule|summary|suppress|template|this|throws|todo|tutorial|type|typedef|unrestricted|uses|var|variation|version|virtual|writeOnce|yields?)\\\\b\",\"name\":\"storage.type.class.jsdoc\"},{\"include\":\"#inline-tags\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"((@)[$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s+)\"}]},\"enum-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:\\\\b(const)\\\\s+)?\\\\b(enum)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.type.enum.ts\"},\"5\":{\"name\":\"entity.name.type.enum.ts\"}},\"end\":\"(?<=})\",\"name\":\"meta.enum.declaration.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"0\":{\"name\":\"variable.other.enummember.ts\"}},\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"begin\":\"(?=(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+])))\",\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"export-declaration\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"keyword.control.as.ts\"},\"3\":{\"name\":\"storage.type.namespace.ts\"},\"4\":{\"name\":\"entity.name.type.module.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)\\\\s+(as)\\\\s+(namespace)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?(?:\\\\s*(=)|\\\\s+(default)(?=\\\\s+))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"keyword.control.type.ts\"},\"3\":{\"name\":\"keyword.operator.assignment.ts\"},\"4\":{\"name\":\"keyword.control.default.ts\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.default.ts\",\"patterns\":[{\"include\":\"#interface-declaration\"},{\"include\":\"#expression\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?\\\\b(?!(\\\\$)|(\\\\s*:))((?=\\\\s*[*{])|((?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*([,\\\\s]))(?!\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"keyword.control.type.ts\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.ts\",\"patterns\":[{\"include\":\"#import-export-declaration\"}]}]},\"expression\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-inside-possibly-arrow-parens\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"entity.name.function.ts variable.language.this.ts\"},\"4\":{\"name\":\"entity.name.function.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"4\":{\"name\":\"variable.parameter.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*[,:]|$)\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.ts\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-operators\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(await)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.flow.ts\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?=\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*\\\\*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.flow.ts\"}},\"end\":\"\\\\*\",\"endCaptures\":{\"0\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.control.flow.ts\"},\"2\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s*(\\\\*))?\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))delete(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.delete.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))in(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.in.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))of(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.of.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.instanceof.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.new.ts\"},{\"include\":\"#typeof-operator\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))void(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.void.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*($|[]),:;}]))\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.ts\"},\"2\":{\"name\":\"keyword.control.satisfies.ts\"}},\"end\":\"(?=^|[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisfies)\\\\s+)|(\\\\s+<))\",\"patterns\":[{\"include\":\"#type\"}]},{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.spread.ts\"},{\"match\":\"(?:\\\\*|(?<!\\\\()/|[-%+])=\",\"name\":\"keyword.operator.assignment.compound.ts\"},{\"match\":\"(?:[\\\\&^]|<<|>>>??|\\\\|)=\",\"name\":\"keyword.operator.assignment.compound.bitwise.ts\"},{\"match\":\"<<|>>>?\",\"name\":\"keyword.operator.bitwise.shift.ts\"},{\"match\":\"[!=]==?\",\"name\":\"keyword.operator.comparison.ts\"},{\"match\":\"<=|>=|<>|[<>]\",\"name\":\"keyword.operator.relational.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.logical.ts\"},\"2\":{\"name\":\"keyword.operator.assignment.compound.ts\"},\"3\":{\"name\":\"keyword.operator.arithmetic.ts\"}},\"match\":\"(?<=[$_[:alnum:]])(!)\\\\s*(?:(/=)|(/)(?![*/]))\"},{\"match\":\"!|&&|\\\\|\\\\||\\\\?\\\\?\",\"name\":\"keyword.operator.logical.ts\"},{\"match\":\"[\\\\&^|~]\",\"name\":\"keyword.operator.bitwise.ts\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.ts\"},{\"match\":\"--\",\"name\":\"keyword.operator.decrement.ts\"},{\"match\":\"\\\\+\\\\+\",\"name\":\"keyword.operator.increment.ts\"},{\"match\":\"[-%*+/]\",\"name\":\"keyword.operator.arithmetic.ts\"},{\"begin\":\"(?<=[]$)_[:alnum:]])\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)+(?:(/=)|(/)(?![*/])))\",\"end\":\"(/=)|(/)(?!\\\\*([^*]|(\\\\*[^/]))*\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.ts\"},\"2\":{\"name\":\"keyword.operator.arithmetic.ts\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.ts\"},\"2\":{\"name\":\"keyword.operator.arithmetic.ts\"}},\"match\":\"(?<=[]$)_[:alnum:]])\\\\s*(?:(/=)|(/)(?![*/]))\"}]},\"expressionPunctuations\":{\"patterns\":[{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-accessor\"}]},\"expressionWithoutIdentifiers\":{\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#regex\"},{\"include\":\"#comment\"},{\"include\":\"#function-expression\"},{\"include\":\"#class-expression\"},{\"include\":\"#arrow-function\"},{\"include\":\"#paren-expression-possibly-arrow\"},{\"include\":\"#cast\"},{\"include\":\"#ternary-expression\"},{\"include\":\"#new-expr\"},{\"include\":\"#instanceof-expr\"},{\"include\":\"#object-literal\"},{\"include\":\"#expression-operators\"},{\"include\":\"#function-call\"},{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#paren-expression\"}]},\"field-declaration\":{\"begin\":\"(?<!\\\\()(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s+)?(?=\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=}]|$))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"end\":\"(?=[,;}]|$|^((?!\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=]|$))))|(?<=})\",\"name\":\"meta.field.declaration.ts\",\"patterns\":[{\"include\":\"#variable-initializer\"},{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"meta.definition.property.ts entity.name.function.ts\"},\"2\":{\"name\":\"keyword.operator.optional.ts\"},\"3\":{\"name\":\"keyword.operator.definiteassignment.ts\"}},\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)(?:(\\\\?)|(!))?(?=\\\\s*\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"match\":\"#?[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.property.ts variable.object.property.ts\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.ts\"},{\"match\":\"!\",\"name\":\"keyword.operator.definiteassignment.ts\"}]},\"for-loop\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))for(?=((\\\\s+|(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*))await)?\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)?(\\\\())\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.loop.ts\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"await\",\"name\":\"keyword.control.loop.ts\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#var-expr\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"}]}]},\"function-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#return-type\"},{\"include\":\"#type-function-return-type\"},{\"include\":\"#decl-block\"},{\"match\":\"\\\\*\",\"name\":\"keyword.generator.asterisk.ts\"}]},\"function-call\":{\"patterns\":[{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"end\":\"(?<=\\\\))(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"name\":\"meta.function-call.ts\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"},{\"include\":\"#paren-expression\"}]},{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"end\":\"(?<=>)(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"name\":\"meta.function-call.ts\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"}]}]},\"function-call-optionals\":{\"patterns\":[{\"match\":\"\\\\?\\\\.\",\"name\":\"meta.function-call.ts punctuation.accessor.optional.ts\"},{\"match\":\"!\",\"name\":\"meta.function-call.ts keyword.operator.definiteassignment.ts\"}]},\"function-call-target\":{\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.ts\"}]},\"function-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.async.ts\"},\"4\":{\"name\":\"storage.type.function.ts\"},\"5\":{\"name\":\"keyword.generator.asterisk.ts\"},\"6\":{\"name\":\"meta.definition.function.ts entity.name.function.ts\"}},\"end\":\"(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|(?<=})\",\"name\":\"meta.function.ts\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#function-body\"}]},\"function-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"storage.type.function.ts\"},\"3\":{\"name\":\"keyword.generator.asterisk.ts\"},\"4\":{\"name\":\"meta.definition.function.ts entity.name.function.ts\"}},\"end\":\"(?=;)|(?<=})\",\"name\":\"meta.function.expression.ts\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#function-body\"}]},\"function-name\":{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.function.ts entity.name.function.ts\"},\"function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.begin.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.end.ts\"}},\"name\":\"meta.parameters.ts\",\"patterns\":[{\"include\":\"#function-parameters-body\"}]},\"function-parameters-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"include\":\"#parameter-name\"},{\"include\":\"#parameter-type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.ts\"}]},\"identifiers\":{\"patterns\":[{\"include\":\"#object-identifiers\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"entity.name.function.ts\"}},\"match\":\"(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"variable.other.constant.property.ts\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"variable.other.property.ts\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"match\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\",\"name\":\"variable.other.constant.ts\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"variable.other.readwrite.ts\"}]},\"if-statement\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bif\\\\s*(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))\\\\s*(?!\\\\{))\",\"end\":\"(?=;|$|})\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(if)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.ts\"},\"2\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<=\\\\))\\\\s*/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"keyword.other.ts\"}},\"name\":\"string.regexp.ts\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"include\":\"#statements\"}]}]},\"import-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type)(?!\\\\s+from))?(?!\\\\s*[(:])(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"keyword.control.import.ts\"},\"4\":{\"name\":\"keyword.control.type.ts\"}},\"end\":\"(?<!(?:^|[^$._[:alnum:]])import)(?=;|$|^)\",\"name\":\"meta.import.ts\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"begin\":\"(?<=(?:^|[^$._[:alnum:]])import)(?!\\\\s*[\\\"'])\",\"end\":\"\\\\bfrom\\\\b\",\"endCaptures\":{\"0\":{\"name\":\"keyword.control.from.ts\"}},\"patterns\":[{\"include\":\"#import-export-declaration\"}]},{\"include\":\"#import-export-declaration\"}]},\"import-equals-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(require)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"keyword.control.import.ts\"},\"4\":{\"name\":\"keyword.control.type.ts\"},\"5\":{\"name\":\"variable.other.readwrite.alias.ts\"},\"6\":{\"name\":\"keyword.operator.assignment.ts\"},\"7\":{\"name\":\"keyword.control.require.ts\"},\"8\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"name\":\"meta.import-equals.external.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(?!require\\\\b)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"keyword.control.import.ts\"},\"4\":{\"name\":\"keyword.control.type.ts\"},\"5\":{\"name\":\"variable.other.readwrite.alias.ts\"},\"6\":{\"name\":\"keyword.operator.assignment.ts\"}},\"end\":\"(?=;|$|^)\",\"name\":\"meta.import-equals.internal.ts\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.other.readwrite.ts\"}]}]},\"import-export-assert-clause\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(with)|(assert))\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.with.ts\"},\"2\":{\"name\":\"keyword.control.assert.ts\"},\"3\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object-literal.key.ts\"},{\"match\":\":\",\"name\":\"punctuation.separator.key-value.ts\"}]},\"import-export-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.block.ts\",\"patterns\":[{\"include\":\"#import-export-clause\"}]},\"import-export-clause\":{\"patterns\":[{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.ts\"},\"2\":{\"name\":\"keyword.control.default.ts\"},\"3\":{\"name\":\"constant.language.import-export-all.ts\"},\"4\":{\"name\":\"variable.other.readwrite.ts\"},\"5\":{\"name\":\"string.quoted.alias.ts\"},\"12\":{\"name\":\"keyword.control.as.ts\"},\"13\":{\"name\":\"keyword.control.default.ts\"},\"14\":{\"name\":\"variable.other.readwrite.alias.ts\"},\"15\":{\"name\":\"string.quoted.alias.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(type)\\\\s+)?(?:\\\\b(default)|(\\\\*)|\\\\b([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\\\\s+(as)\\\\s+(?:(default(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"\\\\*\",\"name\":\"constant.language.import-export-all.ts\"},{\"match\":\"\\\\b(default)\\\\b\",\"name\":\"keyword.control.default.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.ts\"},\"2\":{\"name\":\"variable.other.readwrite.alias.ts\"},\"3\":{\"name\":\"string.quoted.alias.ts\"}},\"match\":\"(?:\\\\b(type)\\\\s+)?(?:([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"}]},\"import-export-declaration\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#import-export-block\"},{\"match\":\"\\\\bfrom\\\\b\",\"name\":\"keyword.control.from.ts\"},{\"include\":\"#import-export-assert-clause\"},{\"include\":\"#import-export-clause\"}]},\"indexer-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=:)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"meta.brace.square.ts\"},\"3\":{\"name\":\"variable.parameter.ts\"}},\"end\":\"(])\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.ts\"},\"2\":{\"name\":\"keyword.operator.optional.ts\"}},\"name\":\"meta.indexer.declaration.ts\",\"patterns\":[{\"include\":\"#type-annotation\"}]},\"indexer-mapped-type-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([-+])?(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s+(in)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.modifier.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"meta.brace.square.ts\"},\"4\":{\"name\":\"entity.name.type.ts\"},\"5\":{\"name\":\"keyword.operator.expression.in.ts\"}},\"end\":\"(])([-+])?\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.ts\"},\"2\":{\"name\":\"keyword.operator.type.modifier.ts\"},\"3\":{\"name\":\"keyword.operator.optional.ts\"}},\"name\":\"meta.indexer.mappedtype.declaration.ts\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.as.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+\"},{\"include\":\"#type\"}]},\"inline-tags\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.bracket.square.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.square.end.jsdoc\"}},\"match\":\"(\\\\[)[^]]+(])(?=\\\\{@(?:link|linkcode|linkplain|tutorial))\",\"name\":\"constant.other.description.jsdoc\"},{\"begin\":\"(\\\\{)((@)(?:link(?:code|plain)?|tutorial))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"},\"2\":{\"name\":\"storage.type.class.jsdoc\"},\"3\":{\"name\":\"punctuation.definition.inline.tag.jsdoc\"}},\"end\":\"}|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"name\":\"entity.name.type.instance.jsdoc\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?=https?://)(?:[^*|}\\\\s]|\\\\*/)+)(\\\\|)?\"},{\"captures\":{\"1\":{\"name\":\"variable.other.description.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?:[^*@{|}\\\\s]|\\\\*[^/])+)(\\\\|)?\"}]}]},\"instanceof-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(instanceof)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.instanceof.ts\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|([!=]==?)|(([\\\\&^|~]\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s+instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"patterns\":[{\"include\":\"#type\"}]},\"interface-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(interface)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.type.interface.ts\"}},\"end\":\"(?<=})\",\"name\":\"meta.interface.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.interface.ts\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"jsdoctype\":{\"patterns\":[{\"begin\":\"\\\\G(\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"}},\"contentName\":\"entity.name.type.instance.jsdoc\",\"end\":\"((}))\\\\s*|(?=\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"patterns\":[{\"include\":\"#brackets\"}]}]},\"label\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.label.ts\"},\"2\":{\"name\":\"punctuation.separator.label.ts\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#decl-block\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.label.ts\"},\"2\":{\"name\":\"punctuation.separator.label.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)\"}]},\"literal\":{\"patterns\":[{\"include\":\"#numeric-literal\"},{\"include\":\"#boolean-literal\"},{\"include\":\"#null-literal\"},{\"include\":\"#undefined-literal\"},{\"include\":\"#numericConstant-literal\"},{\"include\":\"#array-literal\"},{\"include\":\"#this-literal\"},{\"include\":\"#super-literal\"}]},\"method-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?\\\\s*\\\\b(constructor)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.modifier.async.ts\"},\"5\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\s*\\\\b(new)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))|(?:(\\\\*)\\\\s*)?)(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.modifier.async.ts\"},\"5\":{\"name\":\"keyword.operator.new.ts\"},\"6\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.modifier.async.ts\"},\"5\":{\"name\":\"storage.type.property.ts\"},\"6\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]}]},\"method-declaration-name\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??)\\\\s*[(<])\",\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.method.ts entity.name.function.ts\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.ts\"}]},\"namespace-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(namespace|module)\\\\s+(?=[\\\"$'_`[:alpha:]])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.namespace.ts\"}},\"end\":\"(?<=})|(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.namespace.declaration.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.type.module.ts\"},{\"include\":\"#punctuation-accessor\"},{\"include\":\"#decl-block\"}]},\"new-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.new.ts\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"name\":\"new.expr.ts\",\"patterns\":[{\"include\":\"#expression\"}]},\"null-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))null(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.null.ts\"},\"numeric-literal\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.ts\"}},\"match\":\"\\\\b(?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.hex.ts\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.ts\"}},\"match\":\"\\\\b(?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.binary.ts\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.ts\"}},\"match\":\"\\\\b(?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.octal.ts\"},{\"captures\":{\"0\":{\"name\":\"constant.numeric.decimal.ts\"},\"1\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"2\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"3\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"4\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"5\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"6\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"7\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"8\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"9\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"10\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"11\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"12\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"13\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"14\":{\"name\":\"storage.type.numeric.bigint.ts\"}},\"match\":\"(?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)\"}]},\"numericConstant-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))NaN(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.nan.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Infinity(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.infinity.ts\"}]},\"object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element\"}]},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element-const\"}]},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-propertyName\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(:)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.destructuring.ts\"}},\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.object.property.ts\"}]},\"object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"patterns\":[{\"include\":\"#object-binding-element\"}]},\"object-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"patterns\":[{\"include\":\"#object-binding-element-const\"}]},\"object-identifiers\":{\"patterns\":[{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*\\\\??\\\\.\\\\s*prototype\\\\b(?!\\\\$))\",\"name\":\"support.class.ts\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"variable.other.constant.object.property.ts\"},\"4\":{\"name\":\"variable.other.object.property.ts\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(#?\\\\p{upper}[$_\\\\d[:upper:]]*)|(#?[$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"captures\":{\"1\":{\"name\":\"variable.other.constant.object.ts\"},\"2\":{\"name\":\"variable.other.object.ts\"}},\"match\":\"(?:(\\\\p{upper}[$_\\\\d[:upper:]]*)|([$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"}]},\"object-literal\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.objectliteral.ts\",\"patterns\":[{\"include\":\"#object-member\"}]},\"object-literal-method-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"storage.type.property.ts\"},\"3\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"storage.type.property.ts\"},\"3\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#method-declaration-name\"}]}]},\"object-member\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#object-literal-method-declaration\"},{\"begin\":\"(?=\\\\[)\",\"end\":\"(?=:)|((?<=])(?=\\\\s*[(<]))\",\"name\":\"meta.object.member.ts meta.object-literal.key.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#array-literal\"}]},{\"begin\":\"(?=[\\\"'`])\",\"end\":\"(?=:)|((?<=[\\\"'`])(?=((\\\\s*[(,<}])|(\\\\s+(as|satisifies)\\\\s+))))\",\"name\":\"meta.object.member.ts meta.object-literal.key.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?=\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)))\",\"end\":\"(?=:)|(?=\\\\s*([(,<}])|(\\\\s+as|satisifies\\\\s+))\",\"name\":\"meta.object.member.ts meta.object-literal.key.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#numeric-literal\"}]},{\"begin\":\"(?<=[]\\\"'`])(?=\\\\s*[(<])\",\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#function-body\"}]},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.ts\"},\"1\":{\"name\":\"constant.numeric.decimal.ts\"}},\"match\":\"(?![$_[:alpha:]])(\\\\d+)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.ts\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.ts\"},\"1\":{\"name\":\"entity.name.function.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/)*\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\",\"name\":\"meta.object.member.ts\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.ts\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.ts\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.ts\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.ts\",\"patterns\":[{\"include\":\"#expression\"}]},{\"captures\":{\"1\":{\"name\":\"variable.other.readwrite.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*([,}]|$))\",\"name\":\"meta.object.member.ts\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.ts\"},\"2\":{\"name\":\"keyword.control.satisfies.ts\"}},\"end\":\"(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|^|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisifies)\\\\s+))\",\"name\":\"meta.object.member.ts\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(?=[$_[:alpha:]][$_[:alnum:]]*\\\\s*=)\",\"end\":\"(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.ts\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\":\",\"beginCaptures\":{\"0\":{\"name\":\"meta.object-literal.key.ts punctuation.separator.key-value.ts\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.ts\",\"patterns\":[{\"begin\":\"(?<=:)\\\\s*(async)?(?=\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(?=<\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<=>)\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"include\":\"#possibly-arrow-return-type\"},{\"include\":\"#expression\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#decl-block\"}]},\"parameter-array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#parameter-array-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"}]},\"parameter-name\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"entity.name.function.ts variable.language.this.ts\"},\"4\":{\"name\":\"entity.name.function.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"4\":{\"name\":\"variable.parameter.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)\"}]},\"parameter-object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#parameter-binding-element\"},{\"include\":\"#paren-expression\"}]},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},\"parameter-type-annotation\":{\"patterns\":[{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?=[),])|(?==[^>])\",\"name\":\"meta.type.annotation.ts\",\"patterns\":[{\"include\":\"#type\"}]}]},\"paren-expression\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"paren-expression-possibly-arrow\":{\"patterns\":[{\"begin\":\"(?<=[(,=])\\\\s*(async)?(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"begin\":\"(?<=[(,=]|=>|^return|[^$._[:alnum:]]return)\\\\s*(async)?(?=\\\\s*((((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()|(<)|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)))\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"include\":\"#possibly-arrow-return-type\"}]},\"paren-expression-possibly-arrow-with-typeparameters\":{\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},\"possibly-arrow-return-type\":{\"begin\":\"(?<=\\\\)|^)\\\\s*(:)(?=\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*=>)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.arrow.ts meta.return.type.arrow.ts keyword.operator.type.annotation.ts\"}},\"contentName\":\"meta.arrow.ts meta.return.type.arrow.ts\",\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"property-accessor\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(accessor|get|set)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.type.property.ts\"},\"punctuation-accessor\":{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"}},\"match\":\"(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d))\"},\"punctuation-comma\":{\"match\":\",\",\"name\":\"punctuation.separator.comma.ts\"},\"punctuation-semicolon\":{\"match\":\";\",\"name\":\"punctuation.terminator.statement.ts\"},\"qstring-double\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(\\\")|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"invalid.illegal.newline.ts\"}},\"name\":\"string.quoted.double.ts\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"qstring-single\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(')|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"invalid.illegal.newline.ts\"}},\"name\":\"string.quoted.single.ts\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"regex\":{\"patterns\":[{\"begin\":\"(?<!\\\\+\\\\+|--|})(?<=[!(+,:=?\\\\[]|^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case|=>|&&|\\\\|\\\\||\\\\*/)\\\\s*(/)(?![*/])(?=(?:[^()/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)+]|\\\\(([^)\\\\\\\\]|\\\\\\\\.)+\\\\))+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"keyword.other.ts\"}},\"name\":\"string.regexp.ts\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"((?<![]$)_[:alnum:]]|\\\\+\\\\+|--|}|\\\\*/)|((?<=^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case))\\\\s*)/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"keyword.other.ts\"}},\"name\":\"string.regexp.ts\",\"patterns\":[{\"include\":\"#regexp\"}]}]},\"regex-character-class\":{\"patterns\":[{\"match\":\"\\\\\\\\[DSWdfnrstvw]|\\\\.\",\"name\":\"constant.other.character-class.regexp\"},{\"match\":\"\\\\\\\\([0-7]{3}|x\\\\h{2}|u\\\\h{4})\",\"name\":\"constant.character.numeric.regexp\"},{\"match\":\"\\\\\\\\c[A-Z]\",\"name\":\"constant.character.control.regexp\"},{\"match\":\"\\\\\\\\.\",\"name\":\"constant.character.escape.backslash.regexp\"}]},\"regexp\":{\"patterns\":[{\"match\":\"\\\\\\\\[Bb]|[$^]\",\"name\":\"keyword.control.anchor.regexp\"},{\"captures\":{\"0\":{\"name\":\"keyword.other.back-reference.regexp\"},\"1\":{\"name\":\"variable.other.regexp\"}},\"match\":\"\\\\\\\\(?:[1-9]\\\\d*|k<([$A-Z_a-z][$\\\\w]*)>)\"},{\"match\":\"[*+?]|\\\\{(\\\\d+,\\\\d+|\\\\d+,|,\\\\d+|\\\\d+)}\\\\??\",\"name\":\"keyword.operator.quantifier.regexp\"},{\"match\":\"\\\\|\",\"name\":\"keyword.operator.or.regexp\"},{\"begin\":\"(\\\\()((\\\\?=)|(\\\\?!)|(\\\\?<=)|(\\\\?<!))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"},\"2\":{\"name\":\"punctuation.definition.group.assertion.regexp\"},\"3\":{\"name\":\"meta.assertion.look-ahead.regexp\"},\"4\":{\"name\":\"meta.assertion.negative-look-ahead.regexp\"},\"5\":{\"name\":\"meta.assertion.look-behind.regexp\"},\"6\":{\"name\":\"meta.assertion.negative-look-behind.regexp\"}},\"end\":\"(\\\\))\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.assertion.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"\\\\((?:(\\\\?:)|\\\\?<([$A-Z_a-z][$\\\\w]*)>)?\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"},\"1\":{\"name\":\"punctuation.definition.group.no-capture.regexp\"},\"2\":{\"name\":\"variable.other.regexp\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"(\\\\[)(\\\\^)?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"},\"2\":{\"name\":\"keyword.operator.negation.regexp\"}},\"end\":\"(])\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"}},\"name\":\"constant.other.character-class.set.regexp\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"constant.character.numeric.regexp\"},\"2\":{\"name\":\"constant.character.control.regexp\"},\"3\":{\"name\":\"constant.character.escape.backslash.regexp\"},\"4\":{\"name\":\"constant.character.numeric.regexp\"},\"5\":{\"name\":\"constant.character.control.regexp\"},\"6\":{\"name\":\"constant.character.escape.backslash.regexp\"}},\"match\":\"(?:.|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))-(?:[^]\\\\\\\\]|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))\",\"name\":\"constant.other.character-class.range.regexp\"},{\"include\":\"#regex-character-class\"}]},{\"include\":\"#regex-character-class\"}]},\"return-type\":{\"patterns\":[{\"begin\":\"(?<=\\\\))\\\\s*(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?<![\\\\&:|])(?=$|^|[,;{}]|//)\",\"name\":\"meta.return.type.ts\",\"patterns\":[{\"include\":\"#return-type-core\"}]},{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?<![\\\\&:|])((?=[,;{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.return.type.ts\",\"patterns\":[{\"include\":\"#return-type-core\"}]}]},\"return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<=[\\\\&:|])(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"shebang\":{\"captures\":{\"1\":{\"name\":\"punctuation.definition.comment.ts\"}},\"match\":\"\\\\A(#!).*(?=$)\",\"name\":\"comment.line.shebang.ts\"},\"single-line-comment-consuming-line-ending\":{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.ts\"},\"2\":{\"name\":\"comment.line.double-slash.ts\"},\"3\":{\"name\":\"punctuation.definition.comment.ts\"},\"4\":{\"name\":\"storage.type.internaldeclaration.ts\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.ts\"}},\"contentName\":\"comment.line.double-slash.ts\",\"end\":\"(?=^)\"},\"statements\":{\"patterns\":[{\"include\":\"#declaration\"},{\"include\":\"#control-statement\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#label\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template\"}]},\"string-character-escape\":{\"match\":\"\\\\\\\\(x\\\\h{2}|u\\\\h{4}|u\\\\{\\\\h+}|[012][0-7]{0,2}|3[0-6][0-7]?|37[0-7]?|[4-7][0-7]?|.|$)\",\"name\":\"constant.character.escape.ts\"},\"super-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))super\\\\b(?!\\\\$)\",\"name\":\"variable.language.super.ts\"},\"support-function-call-identifiers\":{\"patterns\":[{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#object-identifiers\"},{\"include\":\"#punctuation-accessor\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\(\\\\s*[\\\"'`])\",\"name\":\"keyword.operator.expression.import.ts\"}]},\"support-objects\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(arguments)\\\\b(?!\\\\$)\",\"name\":\"variable.language.arguments.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(Promise)\\\\b(?!\\\\$)\",\"name\":\"support.class.promise.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.import.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"},\"4\":{\"name\":\"support.variable.property.importmeta.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(import)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(meta)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.new.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"},\"4\":{\"name\":\"support.variable.property.target.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(target)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"support.variable.property.ts\"},\"4\":{\"name\":\"support.constant.ts\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(constructor|length|prototype|__proto__)\\\\b(?!\\\\$|\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\()|(EPSILON|MAX_SAFE_INTEGER|MAX_VALUE|MIN_SAFE_INTEGER|MIN_VALUE|NEGATIVE_INFINITY|POSITIVE_INFINITY)\\\\b(?!\\\\$))\"},{\"captures\":{\"1\":{\"name\":\"support.type.object.module.ts\"},\"2\":{\"name\":\"support.type.object.module.ts\"},\"3\":{\"name\":\"punctuation.accessor.ts\"},\"4\":{\"name\":\"punctuation.accessor.optional.ts\"},\"5\":{\"name\":\"support.type.object.module.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(exports)|(module)(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(exports|id|filename|loaded|parent|children))?)\\\\b(?!\\\\$)\"}]},\"switch-statement\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bswitch\\\\s*\\\\()\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"switch-statement.expr.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(switch)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.ts\"},\"2\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"name\":\"switch-expression.expr.ts\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"(?=})\",\"name\":\"switch-block.expr.ts\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default(?=:))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.ts\"}},\"end\":\"(?=:)\",\"name\":\"case-clause.expr.ts\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(:)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"case-clause.expr.ts punctuation.definition.section.case-statement.ts\"},\"2\":{\"name\":\"meta.block.ts punctuation.definition.block.ts\"}},\"contentName\":\"meta.block.ts\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"meta.block.ts punctuation.definition.block.ts\"}},\"patterns\":[{\"include\":\"#statements\"}]},{\"captures\":{\"0\":{\"name\":\"case-clause.expr.ts punctuation.definition.section.case-statement.ts\"}},\"match\":\"(:)\"},{\"include\":\"#statements\"}]}]},\"template\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.ts\"},\"2\":{\"name\":\"string.template.ts punctuation.definition.string.template.begin.ts\"}},\"contentName\":\"string.template.ts\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.ts punctuation.definition.string.template.end.ts\"}},\"patterns\":[{\"include\":\"#template-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-call\":{\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*)(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"end\":\"(?=`)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.tagged-template.ts\"}]},{\"include\":\"#type-arguments\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?\\\\s*(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.ts\"}},\"end\":\"(?=`)\",\"patterns\":[{\"include\":\"#type-arguments\"}]}]},\"template-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.ts\"}},\"contentName\":\"meta.embedded.line.ts\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.ts\"}},\"name\":\"meta.template.expression.ts\",\"patterns\":[{\"include\":\"#expression\"}]},\"template-type\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.ts\"},\"2\":{\"name\":\"string.template.ts punctuation.definition.string.template.begin.ts\"}},\"contentName\":\"string.template.ts\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.ts punctuation.definition.string.template.end.ts\"}},\"patterns\":[{\"include\":\"#template-type-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-type-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.ts\"}},\"contentName\":\"meta.embedded.line.ts\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.ts\"}},\"name\":\"meta.template.expression.ts\",\"patterns\":[{\"include\":\"#type\"}]},\"ternary-expression\":{\"begin\":\"(?!\\\\?\\\\.\\\\s*\\\\D)(\\\\?)(?!\\\\?)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.ts\"}},\"end\":\"\\\\s*(:)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.ts\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"this-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))this\\\\b(?!\\\\$)\",\"name\":\"variable.language.this.ts\"},\"type\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#type-primitive\"},{\"include\":\"#type-builtin-literals\"},{\"include\":\"#type-parameters\"},{\"include\":\"#type-tuple\"},{\"include\":\"#type-object\"},{\"include\":\"#type-operators\"},{\"include\":\"#type-conditional\"},{\"include\":\"#type-fn-type-parameters\"},{\"include\":\"#type-paren-or-function-parameters\"},{\"include\":\"#type-function-return-type\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\"},{\"include\":\"#type-name\"}]},\"type-alias-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(type)\\\\b\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.type.ts\"},\"4\":{\"name\":\"entity.name.type.alias.ts\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.type.declaration.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"begin\":\"(=)\\\\s*(intrinsic)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.ts\"},\"2\":{\"name\":\"keyword.control.intrinsic.ts\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(=)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.ts\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-annotation\":{\"patterns\":[{\"begin\":\"(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?<![\\\\&:|])(?!\\\\s*[\\\\&|]\\\\s+)((?=^|[]),;}]|//)|(?==[^>])|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.ts\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?<![\\\\&:|])((?=[]),;}]|//)|(?==[^>])|(?=^\\\\s*$)|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.ts\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-arguments\":{\"begin\":\"<\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.begin.ts\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.end.ts\"}},\"name\":\"meta.type.parameters.ts\",\"patterns\":[{\"include\":\"#type-arguments-body\"}]},\"type-arguments-body\":{\"patterns\":[{\"captures\":{\"0\":{\"name\":\"keyword.operator.type.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(_)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"type-builtin-literals\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(this|true|false|undefined|null|object)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.builtin.ts\"},\"type-conditional\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"end\":\"(?<=:)\",\"patterns\":[{\"begin\":\"\\\\?\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.ts\"}},\"end\":\":\",\"endCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.ts\"}},\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#type\"}]}]},\"type-fn-type-parameters\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b(?=\\\\s*<)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.type.constructor.ts storage.modifier.ts\"},\"2\":{\"name\":\"meta.type.constructor.ts keyword.control.new.ts\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.control.new.ts\"}},\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.constructor.ts\",\"patterns\":[{\"include\":\"#function-parameters\"}]},{\"begin\":\"((?=\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>))))))\",\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.function.ts\",\"patterns\":[{\"include\":\"#function-parameters\"}]}]},\"type-function-return-type\":{\"patterns\":[{\"begin\":\"(=>)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.function.arrow.ts\"}},\"end\":\"(?<!=>)(?<![\\\\&|])(?=[]),:;=>?{}]|//|$)\",\"name\":\"meta.type.function.return.ts\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.ts\"}},\"end\":\"(?<!=>)(?<![\\\\&|])((?=[]),:;=>?{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.type.function.return.ts\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]}]},\"type-function-return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<==>)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"type-infer\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.infer.ts\"},\"2\":{\"name\":\"entity.name.type.ts\"},\"3\":{\"name\":\"keyword.operator.expression.extends.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(infer)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s+(extends)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))?\",\"name\":\"meta.type.infer.ts\"}]},\"type-name\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(<)\",\"captures\":{\"1\":{\"name\":\"entity.name.type.module.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"},\"4\":{\"name\":\"meta.type.parameters.ts punctuation.definition.typeparameters.begin.ts\"}},\"contentName\":\"meta.type.parameters.ts\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.ts punctuation.definition.typeparameters.end.ts\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(<)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.type.ts\"},\"2\":{\"name\":\"meta.type.parameters.ts punctuation.definition.typeparameters.begin.ts\"}},\"contentName\":\"meta.type.parameters.ts\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.ts punctuation.definition.typeparameters.end.ts\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"entity.name.type.ts\"}]},\"type-object\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.object.type.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#indexer-mapped-type-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#type-annotation\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.ts\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#type\"}]},\"type-operators\":{\"patterns\":[{\"include\":\"#typeof-operator\"},{\"include\":\"#type-infer\"},{\"begin\":\"([\\\\&|])(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.ts\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"begin\":\"[\\\\&|]\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.ts\"}},\"end\":\"(?=\\\\S)\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))keyof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.keyof.ts\"},{\"match\":\"([:?])\",\"name\":\"keyword.operator.ternary.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\()\",\"name\":\"keyword.operator.expression.import.ts\"}]},\"type-parameters\":{\"begin\":\"(<)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.begin.ts\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.end.ts\"}},\"name\":\"meta.type.parameters.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends|in|out|const)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.ts\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"(=)(?!>)\",\"name\":\"keyword.operator.assignment.ts\"}]},\"type-paren-or-function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"name\":\"meta.type.paren.cover.ts\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"entity.name.function.ts variable.language.this.ts\"},\"4\":{\"name\":\"entity.name.function.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=\\\\s*(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"4\":{\"name\":\"variable.parameter.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=:)\"},{\"include\":\"#type-annotation\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.ts\"},{\"include\":\"#type\"}]},\"type-predicate-operator\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.ts\"},\"2\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"3\":{\"name\":\"variable.parameter.ts\"},\"4\":{\"name\":\"keyword.operator.expression.is.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(asserts)\\\\s+)?(?!asserts)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s(is)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.ts\"},\"2\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"3\":{\"name\":\"variable.parameter.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(asserts)\\\\s+(?!is)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))asserts(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.type.asserts.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))is(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.is.ts\"}]},\"type-primitive\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(string|number|bigint|boolean|symbol|any|void|never|unknown)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.primitive.ts\"},\"type-string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template-type\"}]},\"type-tuple\":{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.square.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.ts\"}},\"name\":\"meta.type.tuple.ts\",\"patterns\":[{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.rest.ts\"},{\"captures\":{\"1\":{\"name\":\"entity.name.label.ts\"},\"2\":{\"name\":\"keyword.operator.optional.ts\"},\"3\":{\"name\":\"punctuation.separator.label.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(\\\\?)?\\\\s*(:)\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"typeof-operator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))typeof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.expression.typeof.ts\"}},\"end\":\"(?=[]\\\\&),:;=>?{|}]|(extends\\\\s+)|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type-arguments\"},{\"include\":\"#expression\"}]},\"undefined-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))undefined(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.undefined.ts\"},\"var-expr\":{\"patterns\":[{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!^let|[^$._[:alnum:]]let|^var|[^$._[:alnum:]]var)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.ts\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.ts\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]])const)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.ts\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.ts\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]]|^await\\\\s+|[^$._[:alnum:]]await\\\\s+)using)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.ts\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*((?!\\\\S)|(?=//))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.ts\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"var-single-const\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts variable.other.constant.ts entity.name.function.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts variable.other.constant.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts entity.name.function.ts\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts variable.other.constant.ts\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts variable.other.readwrite.ts\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable-type-annotation\":{\"patterns\":[{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"variable-initializer\":{\"patterns\":[{\"begin\":\"(?<![!=])(=)(?!=)(?=\\\\s*\\\\S)(?!\\\\s*.*=>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.ts\"}},\"end\":\"(?=$|^|[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<![!=])(=)(?!=)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.ts\"}},\"end\":\"(?=[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))|(?=^\\\\s*$)|(?<![-\\\\&*+/|])(?<=\\\\S)(?<!=)(?=\\\\s*$)\",\"patterns\":[{\"include\":\"#expression\"}]}]}},\"scopeName\":\"source.ts\",\"aliases\":[\"ts\",\"cts\",\"mts\"]}"));
var $610d3eeea77f0533$export$2e2bcd8739ae039 = [
    $610d3eeea77f0533$var$lang
];


/* Theme: github-light */ var $5f64b03bfe3858e8$export$2e2bcd8739ae039 = Object.freeze(JSON.parse("{\"colors\":{\"activityBar.activeBorder\":\"#f9826c\",\"activityBar.background\":\"#fff\",\"activityBar.border\":\"#e1e4e8\",\"activityBar.foreground\":\"#2f363d\",\"activityBar.inactiveForeground\":\"#959da5\",\"activityBarBadge.background\":\"#2188ff\",\"activityBarBadge.foreground\":\"#fff\",\"badge.background\":\"#dbedff\",\"badge.foreground\":\"#005cc5\",\"breadcrumb.activeSelectionForeground\":\"#586069\",\"breadcrumb.focusForeground\":\"#2f363d\",\"breadcrumb.foreground\":\"#6a737d\",\"breadcrumbPicker.background\":\"#fafbfc\",\"button.background\":\"#159739\",\"button.foreground\":\"#fff\",\"button.hoverBackground\":\"#138934\",\"button.secondaryBackground\":\"#e1e4e8\",\"button.secondaryForeground\":\"#1b1f23\",\"button.secondaryHoverBackground\":\"#d1d5da\",\"checkbox.background\":\"#fafbfc\",\"checkbox.border\":\"#d1d5da\",\"debugToolBar.background\":\"#fff\",\"descriptionForeground\":\"#6a737d\",\"diffEditor.insertedTextBackground\":\"#34d05822\",\"diffEditor.removedTextBackground\":\"#d73a4922\",\"dropdown.background\":\"#fafbfc\",\"dropdown.border\":\"#e1e4e8\",\"dropdown.foreground\":\"#2f363d\",\"dropdown.listBackground\":\"#fff\",\"editor.background\":\"#fff\",\"editor.findMatchBackground\":\"#ffdf5d\",\"editor.findMatchHighlightBackground\":\"#ffdf5d66\",\"editor.focusedStackFrameHighlightBackground\":\"#28a74525\",\"editor.foldBackground\":\"#d1d5da11\",\"editor.foreground\":\"#24292e\",\"editor.inactiveSelectionBackground\":\"#0366d611\",\"editor.lineHighlightBackground\":\"#f6f8fa\",\"editor.linkedEditingBackground\":\"#0366d611\",\"editor.selectionBackground\":\"#0366d625\",\"editor.selectionHighlightBackground\":\"#34d05840\",\"editor.selectionHighlightBorder\":\"#34d05800\",\"editor.stackFrameHighlightBackground\":\"#ffd33d33\",\"editor.wordHighlightBackground\":\"#34d05800\",\"editor.wordHighlightBorder\":\"#24943e99\",\"editor.wordHighlightStrongBackground\":\"#34d05800\",\"editor.wordHighlightStrongBorder\":\"#24943e50\",\"editorBracketHighlight.foreground1\":\"#005cc5\",\"editorBracketHighlight.foreground2\":\"#e36209\",\"editorBracketHighlight.foreground3\":\"#5a32a3\",\"editorBracketHighlight.foreground4\":\"#005cc5\",\"editorBracketHighlight.foreground5\":\"#e36209\",\"editorBracketHighlight.foreground6\":\"#5a32a3\",\"editorBracketMatch.background\":\"#34d05840\",\"editorBracketMatch.border\":\"#34d05800\",\"editorCursor.foreground\":\"#044289\",\"editorError.foreground\":\"#cb2431\",\"editorGroup.border\":\"#e1e4e8\",\"editorGroupHeader.tabsBackground\":\"#f6f8fa\",\"editorGroupHeader.tabsBorder\":\"#e1e4e8\",\"editorGutter.addedBackground\":\"#28a745\",\"editorGutter.deletedBackground\":\"#d73a49\",\"editorGutter.modifiedBackground\":\"#2188ff\",\"editorIndentGuide.activeBackground\":\"#d7dbe0\",\"editorIndentGuide.background\":\"#eff2f6\",\"editorLineNumber.activeForeground\":\"#24292e\",\"editorLineNumber.foreground\":\"#1b1f234d\",\"editorOverviewRuler.border\":\"#fff\",\"editorWarning.foreground\":\"#f9c513\",\"editorWhitespace.foreground\":\"#d1d5da\",\"editorWidget.background\":\"#f6f8fa\",\"errorForeground\":\"#cb2431\",\"focusBorder\":\"#2188ff\",\"foreground\":\"#444d56\",\"gitDecoration.addedResourceForeground\":\"#28a745\",\"gitDecoration.conflictingResourceForeground\":\"#e36209\",\"gitDecoration.deletedResourceForeground\":\"#d73a49\",\"gitDecoration.ignoredResourceForeground\":\"#959da5\",\"gitDecoration.modifiedResourceForeground\":\"#005cc5\",\"gitDecoration.submoduleResourceForeground\":\"#959da5\",\"gitDecoration.untrackedResourceForeground\":\"#28a745\",\"input.background\":\"#fafbfc\",\"input.border\":\"#e1e4e8\",\"input.foreground\":\"#2f363d\",\"input.placeholderForeground\":\"#959da5\",\"list.activeSelectionBackground\":\"#e2e5e9\",\"list.activeSelectionForeground\":\"#2f363d\",\"list.focusBackground\":\"#cce5ff\",\"list.hoverBackground\":\"#ebf0f4\",\"list.hoverForeground\":\"#2f363d\",\"list.inactiveFocusBackground\":\"#dbedff\",\"list.inactiveSelectionBackground\":\"#e8eaed\",\"list.inactiveSelectionForeground\":\"#2f363d\",\"notificationCenterHeader.background\":\"#e1e4e8\",\"notificationCenterHeader.foreground\":\"#6a737d\",\"notifications.background\":\"#fafbfc\",\"notifications.border\":\"#e1e4e8\",\"notifications.foreground\":\"#2f363d\",\"notificationsErrorIcon.foreground\":\"#d73a49\",\"notificationsInfoIcon.foreground\":\"#005cc5\",\"notificationsWarningIcon.foreground\":\"#e36209\",\"panel.background\":\"#f6f8fa\",\"panel.border\":\"#e1e4e8\",\"panelInput.border\":\"#e1e4e8\",\"panelTitle.activeBorder\":\"#f9826c\",\"panelTitle.activeForeground\":\"#2f363d\",\"panelTitle.inactiveForeground\":\"#6a737d\",\"pickerGroup.border\":\"#e1e4e8\",\"pickerGroup.foreground\":\"#2f363d\",\"progressBar.background\":\"#2188ff\",\"quickInput.background\":\"#fafbfc\",\"quickInput.foreground\":\"#2f363d\",\"scrollbar.shadow\":\"#6a737d33\",\"scrollbarSlider.activeBackground\":\"#959da588\",\"scrollbarSlider.background\":\"#959da533\",\"scrollbarSlider.hoverBackground\":\"#959da544\",\"settings.headerForeground\":\"#2f363d\",\"settings.modifiedItemIndicator\":\"#2188ff\",\"sideBar.background\":\"#f6f8fa\",\"sideBar.border\":\"#e1e4e8\",\"sideBar.foreground\":\"#586069\",\"sideBarSectionHeader.background\":\"#f6f8fa\",\"sideBarSectionHeader.border\":\"#e1e4e8\",\"sideBarSectionHeader.foreground\":\"#2f363d\",\"sideBarTitle.foreground\":\"#2f363d\",\"statusBar.background\":\"#fff\",\"statusBar.border\":\"#e1e4e8\",\"statusBar.debuggingBackground\":\"#f9826c\",\"statusBar.debuggingForeground\":\"#fff\",\"statusBar.foreground\":\"#586069\",\"statusBar.noFolderBackground\":\"#fff\",\"statusBarItem.prominentBackground\":\"#e8eaed\",\"statusBarItem.remoteBackground\":\"#fff\",\"statusBarItem.remoteForeground\":\"#586069\",\"tab.activeBackground\":\"#fff\",\"tab.activeBorder\":\"#fff\",\"tab.activeBorderTop\":\"#f9826c\",\"tab.activeForeground\":\"#2f363d\",\"tab.border\":\"#e1e4e8\",\"tab.hoverBackground\":\"#fff\",\"tab.inactiveBackground\":\"#f6f8fa\",\"tab.inactiveForeground\":\"#6a737d\",\"tab.unfocusedActiveBorder\":\"#fff\",\"tab.unfocusedActiveBorderTop\":\"#e1e4e8\",\"tab.unfocusedHoverBackground\":\"#fff\",\"terminal.ansiBlack\":\"#24292e\",\"terminal.ansiBlue\":\"#0366d6\",\"terminal.ansiBrightBlack\":\"#959da5\",\"terminal.ansiBrightBlue\":\"#005cc5\",\"terminal.ansiBrightCyan\":\"#3192aa\",\"terminal.ansiBrightGreen\":\"#22863a\",\"terminal.ansiBrightMagenta\":\"#5a32a3\",\"terminal.ansiBrightRed\":\"#cb2431\",\"terminal.ansiBrightWhite\":\"#d1d5da\",\"terminal.ansiBrightYellow\":\"#b08800\",\"terminal.ansiCyan\":\"#1b7c83\",\"terminal.ansiGreen\":\"#28a745\",\"terminal.ansiMagenta\":\"#5a32a3\",\"terminal.ansiRed\":\"#d73a49\",\"terminal.ansiWhite\":\"#6a737d\",\"terminal.ansiYellow\":\"#dbab09\",\"terminal.foreground\":\"#586069\",\"terminal.tab.activeBorder\":\"#f9826c\",\"terminalCursor.background\":\"#d1d5da\",\"terminalCursor.foreground\":\"#005cc5\",\"textBlockQuote.background\":\"#fafbfc\",\"textBlockQuote.border\":\"#e1e4e8\",\"textCodeBlock.background\":\"#f6f8fa\",\"textLink.activeForeground\":\"#005cc5\",\"textLink.foreground\":\"#0366d6\",\"textPreformat.foreground\":\"#586069\",\"textSeparator.foreground\":\"#d1d5da\",\"titleBar.activeBackground\":\"#fff\",\"titleBar.activeForeground\":\"#2f363d\",\"titleBar.border\":\"#e1e4e8\",\"titleBar.inactiveBackground\":\"#f6f8fa\",\"titleBar.inactiveForeground\":\"#6a737d\",\"tree.indentGuidesStroke\":\"#e1e4e8\",\"welcomePage.buttonBackground\":\"#f6f8fa\",\"welcomePage.buttonHoverBackground\":\"#e1e4e8\"},\"displayName\":\"GitHub Light\",\"name\":\"github-light\",\"semanticHighlighting\":true,\"tokenColors\":[{\"scope\":[\"comment\",\"punctuation.definition.comment\",\"string.comment\"],\"settings\":{\"foreground\":\"#6a737d\"}},{\"scope\":[\"constant\",\"entity.name.constant\",\"variable.other.constant\",\"variable.other.enummember\",\"variable.language\"],\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":[\"entity\",\"entity.name\"],\"settings\":{\"foreground\":\"#6f42c1\"}},{\"scope\":\"variable.parameter.function\",\"settings\":{\"foreground\":\"#24292e\"}},{\"scope\":\"entity.name.tag\",\"settings\":{\"foreground\":\"#22863a\"}},{\"scope\":\"keyword\",\"settings\":{\"foreground\":\"#d73a49\"}},{\"scope\":[\"storage\",\"storage.type\"],\"settings\":{\"foreground\":\"#d73a49\"}},{\"scope\":[\"storage.modifier.package\",\"storage.modifier.import\",\"storage.type.java\"],\"settings\":{\"foreground\":\"#24292e\"}},{\"scope\":[\"string\",\"punctuation.definition.string\",\"string punctuation.section.embedded source\"],\"settings\":{\"foreground\":\"#032f62\"}},{\"scope\":\"support\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":\"meta.property-name\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":\"variable\",\"settings\":{\"foreground\":\"#e36209\"}},{\"scope\":\"variable.other\",\"settings\":{\"foreground\":\"#24292e\"}},{\"scope\":\"invalid.broken\",\"settings\":{\"fontStyle\":\"italic\",\"foreground\":\"#b31d28\"}},{\"scope\":\"invalid.deprecated\",\"settings\":{\"fontStyle\":\"italic\",\"foreground\":\"#b31d28\"}},{\"scope\":\"invalid.illegal\",\"settings\":{\"fontStyle\":\"italic\",\"foreground\":\"#b31d28\"}},{\"scope\":\"invalid.unimplemented\",\"settings\":{\"fontStyle\":\"italic\",\"foreground\":\"#b31d28\"}},{\"scope\":\"carriage-return\",\"settings\":{\"background\":\"#d73a49\",\"content\":\"^M\",\"fontStyle\":\"italic underline\",\"foreground\":\"#fafbfc\"}},{\"scope\":\"message.error\",\"settings\":{\"foreground\":\"#b31d28\"}},{\"scope\":\"string variable\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":[\"source.regexp\",\"string.regexp\"],\"settings\":{\"foreground\":\"#032f62\"}},{\"scope\":[\"string.regexp.character-class\",\"string.regexp constant.character.escape\",\"string.regexp source.ruby.embedded\",\"string.regexp string.regexp.arbitrary-repitition\"],\"settings\":{\"foreground\":\"#032f62\"}},{\"scope\":\"string.regexp constant.character.escape\",\"settings\":{\"fontStyle\":\"bold\",\"foreground\":\"#22863a\"}},{\"scope\":\"support.constant\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":\"support.variable\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":\"meta.module-reference\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":\"punctuation.definition.list.begin.markdown\",\"settings\":{\"foreground\":\"#e36209\"}},{\"scope\":[\"markup.heading\",\"markup.heading entity.name\"],\"settings\":{\"fontStyle\":\"bold\",\"foreground\":\"#005cc5\"}},{\"scope\":\"markup.quote\",\"settings\":{\"foreground\":\"#22863a\"}},{\"scope\":\"markup.italic\",\"settings\":{\"fontStyle\":\"italic\",\"foreground\":\"#24292e\"}},{\"scope\":\"markup.bold\",\"settings\":{\"fontStyle\":\"bold\",\"foreground\":\"#24292e\"}},{\"scope\":[\"markup.underline\"],\"settings\":{\"fontStyle\":\"underline\"}},{\"scope\":[\"markup.strikethrough\"],\"settings\":{\"fontStyle\":\"strikethrough\"}},{\"scope\":\"markup.inline.raw\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":[\"markup.deleted\",\"meta.diff.header.from-file\",\"punctuation.definition.deleted\"],\"settings\":{\"background\":\"#ffeef0\",\"foreground\":\"#b31d28\"}},{\"scope\":[\"markup.inserted\",\"meta.diff.header.to-file\",\"punctuation.definition.inserted\"],\"settings\":{\"background\":\"#f0fff4\",\"foreground\":\"#22863a\"}},{\"scope\":[\"markup.changed\",\"punctuation.definition.changed\"],\"settings\":{\"background\":\"#ffebda\",\"foreground\":\"#e36209\"}},{\"scope\":[\"markup.ignored\",\"markup.untracked\"],\"settings\":{\"background\":\"#005cc5\",\"foreground\":\"#f6f8fa\"}},{\"scope\":\"meta.diff.range\",\"settings\":{\"fontStyle\":\"bold\",\"foreground\":\"#6f42c1\"}},{\"scope\":\"meta.diff.header\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":\"meta.separator\",\"settings\":{\"fontStyle\":\"bold\",\"foreground\":\"#005cc5\"}},{\"scope\":\"meta.output\",\"settings\":{\"foreground\":\"#005cc5\"}},{\"scope\":[\"brackethighlighter.tag\",\"brackethighlighter.curly\",\"brackethighlighter.round\",\"brackethighlighter.square\",\"brackethighlighter.angle\",\"brackethighlighter.quote\"],\"settings\":{\"foreground\":\"#586069\"}},{\"scope\":\"brackethighlighter.unmatched\",\"settings\":{\"foreground\":\"#b31d28\"}},{\"scope\":[\"constant.other.reference.link\",\"string.other.link\"],\"settings\":{\"fontStyle\":\"underline\",\"foreground\":\"#032f62\"}}],\"type\":\"light\"}"));



var $7DB8U = parcelRequire("7DB8U");
var $b1e7891750e609f8$exports = {};
'use strict';
Object.defineProperty($b1e7891750e609f8$exports, '__esModule', {
    value: true
});
var $87fa6ca2387e29c6$exports = {};
'use strict';
Object.defineProperty($87fa6ca2387e29c6$exports, '__esModule', {
    value: true
});
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $87fa6ca2387e29c6$var$isObject(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $87fa6ca2387e29c6$var$isPlainObject(o) {
    var ctor, prot;
    if ($87fa6ca2387e29c6$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($87fa6ca2387e29c6$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) return false;
    // Most likely a plain Object
    return true;
}
$87fa6ca2387e29c6$exports.isPlainObject = $87fa6ca2387e29c6$var$isPlainObject;



var $7DB8U = parcelRequire("7DB8U");
var $7d8d2177dae91fdf$exports = {};
"use strict";
var $7d8d2177dae91fdf$var$__assign = $7d8d2177dae91fdf$exports && $7d8d2177dae91fdf$exports.__assign || function() {
    $7d8d2177dae91fdf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7d8d2177dae91fdf$var$__assign.apply(this, arguments);
};
var $7d8d2177dae91fdf$var$__spreadArray = $7d8d2177dae91fdf$exports && $7d8d2177dae91fdf$exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty($7d8d2177dae91fdf$exports, "__esModule", {
    value: true
});
$7d8d2177dae91fdf$exports.prettyPrint = void 0;
var $7d8d2177dae91fdf$var$seen = [];
/**
 * Check if a value is an object or a function. Keep in mind that array, function, regexp, etc, are objects in JavaScript.
 *
 * @param value the value to check
 * @return true if the value is an object or a function
 */ function $7d8d2177dae91fdf$var$isObj(value) {
    var type = typeof value;
    return value !== null && (type === 'object' || type === 'function');
}
/**
 * Check if a value is a regular expression.
 *
 * @param value the value to check
 * @return true if the value is a regular expression
 */ function $7d8d2177dae91fdf$var$isRegexp(value) {
    return Object.prototype.toString.call(value) === '[object RegExp]';
}
/**
 * Get an array of all of the enumerable symbols for an object.
 *
 * @param object the object to get the enumerable symbols for
 */ function $7d8d2177dae91fdf$var$getOwnEnumPropSymbols(object) {
    return Object.getOwnPropertySymbols(object).filter(function(keySymbol) {
        return Object.prototype.propertyIsEnumerable.call(object, keySymbol);
    });
}
/**
 * pretty print an object
 *
 * @param input the object to pretty print
 * @param options the formatting options, transforms, and filters
 * @param pad the padding string
 */ function $7d8d2177dae91fdf$var$prettyPrint(input, options, pad) {
    if (pad === void 0) pad = '';
    // sensible option defaults
    var defaultOptions = {
        indent: '\t',
        singleQuotes: true
    };
    var combinedOptions = $7d8d2177dae91fdf$var$__assign($7d8d2177dae91fdf$var$__assign({}, defaultOptions), options);
    var tokens;
    if (combinedOptions.inlineCharacterLimit === undefined) tokens = {
        newLine: '\n',
        newLineOrSpace: '\n',
        pad: pad,
        indent: pad + combinedOptions.indent
    };
    else tokens = {
        newLine: '@@__PRETTY_PRINT_NEW_LINE__@@',
        newLineOrSpace: '@@__PRETTY_PRINT_NEW_LINE_OR_SPACE__@@',
        pad: '@@__PRETTY_PRINT_PAD__@@',
        indent: '@@__PRETTY_PRINT_INDENT__@@'
    };
    var expandWhiteSpace = function(string) {
        if (combinedOptions.inlineCharacterLimit === undefined) return string;
        var oneLined = string.replace(new RegExp(tokens.newLine, 'g'), '').replace(new RegExp(tokens.newLineOrSpace, 'g'), ' ').replace(new RegExp(tokens.pad + '|' + tokens.indent, 'g'), '');
        if (oneLined.length <= combinedOptions.inlineCharacterLimit) return oneLined;
        return string.replace(new RegExp(tokens.newLine + '|' + tokens.newLineOrSpace, 'g'), '\n').replace(new RegExp(tokens.pad, 'g'), pad).replace(new RegExp(tokens.indent, 'g'), pad + combinedOptions.indent);
    };
    if ($7d8d2177dae91fdf$var$seen.indexOf(input) !== -1) return '"[Circular]"';
    if (input === null || input === undefined || typeof input === 'number' || typeof input === 'boolean' || typeof input === 'function' || typeof input === 'symbol' || $7d8d2177dae91fdf$var$isRegexp(input)) return String(input);
    if (input instanceof Date) return "new Date('".concat(input.toISOString(), "')");
    if (Array.isArray(input)) {
        if (input.length === 0) return '[]';
        $7d8d2177dae91fdf$var$seen.push(input);
        var ret = '[' + tokens.newLine + input.map(function(el, i) {
            var eol = input.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
            var value = $7d8d2177dae91fdf$var$prettyPrint(el, combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) value = combinedOptions.transform(input, i, value);
            return tokens.indent + value + eol;
        }).join('') + tokens.pad + ']';
        $7d8d2177dae91fdf$var$seen.pop();
        return expandWhiteSpace(ret);
    }
    if ($7d8d2177dae91fdf$var$isObj(input)) {
        var objKeys_1 = $7d8d2177dae91fdf$var$__spreadArray($7d8d2177dae91fdf$var$__spreadArray([], Object.keys(input), true), $7d8d2177dae91fdf$var$getOwnEnumPropSymbols(input), true);
        if (combinedOptions.filter) objKeys_1 = objKeys_1.filter(function(el) {
            return combinedOptions.filter && combinedOptions.filter(input, el);
        });
        if (objKeys_1.length === 0) return '{}';
        $7d8d2177dae91fdf$var$seen.push(input);
        var ret = '{' + tokens.newLine + objKeys_1.map(function(el, i) {
            var eol = objKeys_1.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
            var isSymbol = typeof el === 'symbol';
            var isClassic = !isSymbol && /^[a-z$_][a-z$_0-9]*$/i.test(el.toString());
            var key = isSymbol || isClassic ? el : $7d8d2177dae91fdf$var$prettyPrint(el, combinedOptions);
            var value = $7d8d2177dae91fdf$var$prettyPrint(input[el], combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) value = combinedOptions.transform(input, el, value);
            return tokens.indent + String(key) + ': ' + value + eol;
        }).join('') + tokens.pad + '}';
        $7d8d2177dae91fdf$var$seen.pop();
        return expandWhiteSpace(ret);
    }
    input = String(input).replace(/[\r\n]/g, function(x) {
        return x === '\n' ? '\\n' : '\\r';
    });
    if (!combinedOptions.singleQuotes) {
        input = input.replace(/"/g, '\\"');
        return "\"".concat(input, "\"");
    }
    input = input.replace(/\\?'/g, '\\\'');
    return "'".concat(input, "'");
}
$7d8d2177dae91fdf$exports.prettyPrint = $7d8d2177dae91fdf$var$prettyPrint;


var $6df612c424d59fc3$exports = {};
'use strict';

$6df612c424d59fc3$exports = (parcelRequire("dhnve"));


function $b1e7891750e609f8$var$_interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
        'default': e
    };
}
function $b1e7891750e609f8$var$_interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) Object.keys(e).forEach(function(k) {
        if (k !== 'default') {
            var d = Object.getOwnPropertyDescriptor(e, k);
            Object.defineProperty(n, k, d.get ? d : {
                enumerable: true,
                get: function() {
                    return e[k];
                }
            });
        }
    });
    n["default"] = e;
    return Object.freeze(n);
}
var $b1e7891750e609f8$var$React__namespace = /*#__PURE__*/ $b1e7891750e609f8$var$_interopNamespace($7DB8U);
var $b1e7891750e609f8$var$React__default = /*#__PURE__*/ $b1e7891750e609f8$var$_interopDefaultLegacy($7DB8U);
var $b1e7891750e609f8$var$spacer = function(times, tabStop) {
    if (times === 0) return '';
    return new Array(times * tabStop).fill(' ').join('');
};
function $b1e7891750e609f8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $b1e7891750e609f8$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $b1e7891750e609f8$var$_arrayLikeToArray(r);
}
function $b1e7891750e609f8$var$_defineProperty(e, r, t) {
    return (r = $b1e7891750e609f8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b1e7891750e609f8$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $b1e7891750e609f8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b1e7891750e609f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b1e7891750e609f8$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b1e7891750e609f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b1e7891750e609f8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b1e7891750e609f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b1e7891750e609f8$var$_toConsumableArray(r) {
    return $b1e7891750e609f8$var$_arrayWithoutHoles(r) || $b1e7891750e609f8$var$_iterableToArray(r) || $b1e7891750e609f8$var$_unsupportedIterableToArray(r) || $b1e7891750e609f8$var$_nonIterableSpread();
}
function $b1e7891750e609f8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b1e7891750e609f8$var$_toPropertyKey(t) {
    var i = $b1e7891750e609f8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $b1e7891750e609f8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b1e7891750e609f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b1e7891750e609f8$var$_typeof(o);
}
function $b1e7891750e609f8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b1e7891750e609f8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b1e7891750e609f8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b1e7891750e609f8$var$safeSortObject(value, seen) {
    // return non-object value as is
    if (value === null || $b1e7891750e609f8$var$_typeof(value) !== 'object') return value;
    // return date and regexp values as is
    if (value instanceof Date || value instanceof RegExp) return value;
    // return react element as is but remove _owner key because it can lead to recursion
    if (/*#__PURE__*/ $b1e7891750e609f8$var$React__namespace.isValidElement(value)) {
        var copyObj = $b1e7891750e609f8$var$_objectSpread2({}, value);
        delete copyObj._owner;
        return copyObj;
    }
    seen.add(value);
    // make a copy of array with each item passed through the sorting algorithm
    if (Array.isArray(value)) return value.map(function(v) {
        return $b1e7891750e609f8$var$safeSortObject(v, seen);
    });
    // make a copy of object with key sorted
    return Object.keys(value).sort().reduce(function(result, key) {
        if (key === 'current' || seen.has(value[key])) // eslint-disable-next-line no-param-reassign
        result[key] = '[Circular]';
        else // eslint-disable-next-line no-param-reassign
        result[key] = $b1e7891750e609f8$var$safeSortObject(value[key], seen);
        return result;
    }, {});
}
function $b1e7891750e609f8$var$sortObject(value) {
    return $b1e7891750e609f8$var$safeSortObject(value, new WeakSet());
}
/* eslint-disable no-use-before-define */ var $b1e7891750e609f8$var$createStringTreeNode = function createStringTreeNode(value) {
    return {
        type: 'string',
        value: value
    };
};
var $b1e7891750e609f8$var$createNumberTreeNode = function createNumberTreeNode(value) {
    return {
        type: 'number',
        value: value
    };
};
var $b1e7891750e609f8$var$createReactElementTreeNode = function createReactElementTreeNode(displayName, props, defaultProps, childrens) {
    return {
        type: 'ReactElement',
        displayName: displayName,
        props: props,
        defaultProps: defaultProps,
        childrens: childrens
    };
};
var $b1e7891750e609f8$var$createReactFragmentTreeNode = function createReactFragmentTreeNode(key, childrens) {
    return {
        type: 'ReactFragment',
        key: key,
        childrens: childrens
    };
};
var $b1e7891750e609f8$var$supportFragment = Boolean($7DB8U.Fragment);
var $b1e7891750e609f8$var$getFunctionTypeName = function getFunctionTypeName(functionType) {
    if (!functionType.name || functionType.name === '_default') return 'No Display Name';
    return functionType.name;
};
var $b1e7891750e609f8$var$_getWrappedComponentDisplayName = function getWrappedComponentDisplayName(Component) {
    switch(true){
        case Boolean(Component.displayName):
            return Component.displayName;
        case Component.$$typeof === $6df612c424d59fc3$exports.Memo:
            return $b1e7891750e609f8$var$_getWrappedComponentDisplayName(Component.type);
        case Component.$$typeof === $6df612c424d59fc3$exports.ForwardRef:
            return $b1e7891750e609f8$var$_getWrappedComponentDisplayName(Component.render);
        default:
            return $b1e7891750e609f8$var$getFunctionTypeName(Component);
    }
};
// heavily inspired by:
// https://github.com/facebook/react/blob/3746eaf985dd92f8aa5f5658941d07b6b855e9d9/packages/react-devtools-shared/src/backend/renderer.js#L399-L496
var $b1e7891750e609f8$var$getReactElementDisplayName = function getReactElementDisplayName(element) {
    switch(true){
        case typeof element.type === 'string':
            return element.type;
        case typeof element.type === 'function':
            if (element.type.displayName) return element.type.displayName;
            return $b1e7891750e609f8$var$getFunctionTypeName(element.type);
        case $6df612c424d59fc3$exports.isForwardRef(element):
        case $6df612c424d59fc3$exports.isMemo(element):
            return $b1e7891750e609f8$var$_getWrappedComponentDisplayName(element.type);
        case $6df612c424d59fc3$exports.isContextConsumer(element):
            return "".concat(element.type._context.displayName || 'Context', ".Consumer");
        case $6df612c424d59fc3$exports.isContextProvider(element):
            return "".concat(element.type.displayName || 'Context', ".Provider");
        case $6df612c424d59fc3$exports.isLazy(element):
            return 'Lazy';
        case $6df612c424d59fc3$exports.isProfiler(element):
            return 'Profiler';
        case $6df612c424d59fc3$exports.isStrictMode(element):
            return 'StrictMode';
        case $6df612c424d59fc3$exports.isSuspense(element):
            return 'Suspense';
        default:
            return 'UnknownElementType';
    }
};
var $b1e7891750e609f8$var$noChildren = function noChildren(propsValue, propName) {
    return propName !== 'children';
};
var $b1e7891750e609f8$var$onlyMeaningfulChildren = function onlyMeaningfulChildren(children) {
    return children !== true && children !== false && children !== null && children !== '';
};
var $b1e7891750e609f8$var$filterProps = function filterProps(originalProps, cb) {
    var filteredProps = {};
    Object.keys(originalProps).filter(function(key) {
        return cb(originalProps[key], key);
    }).forEach(function(key) {
        return filteredProps[key] = originalProps[key];
    });
    return filteredProps;
};
var $b1e7891750e609f8$var$_parseReactElement = function parseReactElement(element, options) {
    var _options$displayName = options.displayName, displayNameFn = _options$displayName === void 0 ? $b1e7891750e609f8$var$getReactElementDisplayName : _options$displayName;
    if (typeof element === 'string') return $b1e7891750e609f8$var$createStringTreeNode(element);
    else if (typeof element === 'number') return $b1e7891750e609f8$var$createNumberTreeNode(element);
    else if (!/*#__PURE__*/ $b1e7891750e609f8$var$React__default["default"].isValidElement(element)) throw new Error("react-element-to-jsx-string: Expected a React.Element, got `".concat($b1e7891750e609f8$var$_typeof(element), "`"));
    var displayName = displayNameFn(element);
    var props = $b1e7891750e609f8$var$filterProps(element.props, $b1e7891750e609f8$var$noChildren);
    var key = element.key;
    if (typeof key === 'string' && key.search(/^\./)) // React automatically add key=".X" when there are some children
    props.key = key;
    var defaultProps = $b1e7891750e609f8$var$filterProps(element.type.defaultProps || {}, $b1e7891750e609f8$var$noChildren);
    var childrens = $b1e7891750e609f8$var$React__default["default"].Children.toArray(element.props.children).filter($b1e7891750e609f8$var$onlyMeaningfulChildren).map(function(child) {
        return $b1e7891750e609f8$var$_parseReactElement(child, options);
    });
    if ($b1e7891750e609f8$var$supportFragment && element.type === $7DB8U.Fragment) return $b1e7891750e609f8$var$createReactFragmentTreeNode(key, childrens);
    return $b1e7891750e609f8$var$createReactElementTreeNode(displayName, props, defaultProps, childrens);
};
function $b1e7891750e609f8$var$noRefCheck() {}
var $b1e7891750e609f8$var$inlineFunction = function inlineFunction(fn) {
    return fn.toString().split('\n').map(function(line) {
        return line.trim();
    }).join('');
};
var $b1e7891750e609f8$var$preserveFunctionLineBreak = function preserveFunctionLineBreak(fn) {
    return fn.toString();
};
var $b1e7891750e609f8$var$defaultFunctionValue = $b1e7891750e609f8$var$inlineFunction;
var $b1e7891750e609f8$var$formatFunction = function(fn, options) {
    var _options$functionValu = options.functionValue, functionValue = _options$functionValu === void 0 ? $b1e7891750e609f8$var$defaultFunctionValue : _options$functionValu, showFunctions = options.showFunctions;
    if (!showFunctions && functionValue === $b1e7891750e609f8$var$defaultFunctionValue) return functionValue($b1e7891750e609f8$var$noRefCheck);
    return functionValue(fn);
};
var $b1e7891750e609f8$var$formatComplexDataStructure = function(value, inline, lvl, options) {
    var normalizedValue = $b1e7891750e609f8$var$sortObject(value);
    var stringifiedValue = $7d8d2177dae91fdf$exports.prettyPrint(normalizedValue, {
        transform: function transform(currentObj, prop, originalResult) {
            var currentValue = currentObj[prop];
            if (currentValue && /*#__PURE__*/ $7DB8U.isValidElement(currentValue)) return $b1e7891750e609f8$var$formatTreeNode($b1e7891750e609f8$var$_parseReactElement(currentValue, options), true, lvl, options);
            if (typeof currentValue === 'function') return $b1e7891750e609f8$var$formatFunction(currentValue, options);
            return originalResult;
        }
    });
    if (inline) return stringifiedValue.replace(/\s+/g, ' ').replace(/{ /g, '{').replace(/ }/g, '}').replace(/\[ /g, '[').replace(/ ]/g, ']');
    // Replace tabs with spaces, and add necessary indentation in front of each new line
    return stringifiedValue.replace(/\t/g, $b1e7891750e609f8$var$spacer(1, options.tabStop)).replace(/\n([^$])/g, "\n".concat($b1e7891750e609f8$var$spacer(lvl + 1, options.tabStop), "$1"));
};
var $b1e7891750e609f8$var$escape$1 = function escape(s) {
    return s.replace(/"/g, '&quot;');
};
var $b1e7891750e609f8$var$formatPropValue = function formatPropValue(propValue, inline, lvl, options) {
    if (typeof propValue === 'number') return "{".concat(String(propValue), "}");
    if (typeof propValue === 'string') return "\"".concat($b1e7891750e609f8$var$escape$1(propValue), "\"");
    // > "Symbols (new in ECMAScript 2015, not yet supported in Flow)"
    // @see: https://flow.org/en/docs/types/primitives/
    // $FlowFixMe: Flow does not support Symbol
    if ($b1e7891750e609f8$var$_typeof(propValue) === 'symbol') {
        var symbolDescription = propValue.valueOf().toString().replace(/Symbol\((.*)\)/, '$1');
        if (!symbolDescription) return "{Symbol()}";
        return "{Symbol('".concat(symbolDescription, "')}");
    }
    if (typeof propValue === 'function') return "{".concat($b1e7891750e609f8$var$formatFunction(propValue, options), "}");
    if (/*#__PURE__*/ $7DB8U.isValidElement(propValue)) return "{".concat($b1e7891750e609f8$var$formatTreeNode($b1e7891750e609f8$var$_parseReactElement(propValue, options), true, lvl, options), "}");
    if (propValue instanceof Date) {
        if (isNaN(propValue.valueOf())) return "{new Date(NaN)}";
        return "{new Date(\"".concat(propValue.toISOString(), "\")}");
    }
    if ($87fa6ca2387e29c6$exports.isPlainObject(propValue) || Array.isArray(propValue)) return "{".concat($b1e7891750e609f8$var$formatComplexDataStructure(propValue, inline, lvl, options), "}");
    return "{".concat(String(propValue), "}");
};
var $b1e7891750e609f8$var$formatProp = function(name, hasValue, value, hasDefaultValue, defaultValue, inline, lvl, options) {
    if (!hasValue && !hasDefaultValue) throw new Error("The prop \"".concat(name, "\" has no value and no default: could not be formatted"));
    var usedValue = hasValue ? value : defaultValue;
    var useBooleanShorthandSyntax = options.useBooleanShorthandSyntax, tabStop = options.tabStop;
    var formattedPropValue = $b1e7891750e609f8$var$formatPropValue(usedValue, inline, lvl, options);
    var attributeFormattedInline = ' ';
    var attributeFormattedMultiline = "\n".concat($b1e7891750e609f8$var$spacer(lvl + 1, tabStop));
    var isMultilineAttribute = formattedPropValue.includes('\n');
    if (useBooleanShorthandSyntax && formattedPropValue === '{false}' && !hasDefaultValue) {
        // If a boolean is false and not different from it's default, we do not render the attribute
        attributeFormattedInline = '';
        attributeFormattedMultiline = '';
    } else if (useBooleanShorthandSyntax && formattedPropValue === '{true}') {
        attributeFormattedInline += "".concat(name);
        attributeFormattedMultiline += "".concat(name);
    } else {
        attributeFormattedInline += "".concat(name, "=").concat(formattedPropValue);
        attributeFormattedMultiline += "".concat(name, "=").concat(formattedPropValue);
    }
    return {
        attributeFormattedInline: attributeFormattedInline,
        attributeFormattedMultiline: attributeFormattedMultiline,
        isMultilineAttribute: isMultilineAttribute
    };
};
var $b1e7891750e609f8$var$mergeSiblingPlainStringChildrenReducer = function(previousNodes, currentNode) {
    var nodes = previousNodes.slice(0, previousNodes.length > 0 ? previousNodes.length - 1 : 0);
    var previousNode = previousNodes[previousNodes.length - 1];
    if (previousNode && (currentNode.type === 'string' || currentNode.type === 'number') && (previousNode.type === 'string' || previousNode.type === 'number')) nodes.push($b1e7891750e609f8$var$createStringTreeNode(String(previousNode.value) + String(currentNode.value)));
    else {
        if (previousNode) nodes.push(previousNode);
        nodes.push(currentNode);
    }
    return nodes;
};
var $b1e7891750e609f8$var$isKeyOrRefProps = function isKeyOrRefProps(propName) {
    return [
        'key',
        'ref'
    ].includes(propName);
};
var $b1e7891750e609f8$var$sortPropsByNames = function(shouldSortUserProps) {
    return function(props) {
        var haveKeyProp = props.includes('key');
        var haveRefProp = props.includes('ref');
        var userPropsOnly = props.filter(function(oneProp) {
            return !$b1e7891750e609f8$var$isKeyOrRefProps(oneProp);
        });
        var sortedProps = shouldSortUserProps ? $b1e7891750e609f8$var$_toConsumableArray(userPropsOnly.sort()) // We use basic lexical order
         : $b1e7891750e609f8$var$_toConsumableArray(userPropsOnly);
        if (haveRefProp) sortedProps.unshift('ref');
        if (haveKeyProp) sortedProps.unshift('key');
        return sortedProps;
    };
};
function $b1e7891750e609f8$var$createPropFilter(props, filter) {
    if (Array.isArray(filter)) return function(key) {
        return filter.indexOf(key) === -1;
    };
    else return function(key) {
        return filter(props[key], key);
    };
}
var $b1e7891750e609f8$var$compensateMultilineStringElementIndentation = function compensateMultilineStringElementIndentation(element, formattedElement, inline, lvl, options) {
    var tabStop = options.tabStop;
    if (element.type === 'string') return formattedElement.split('\n').map(function(line, offset) {
        if (offset === 0) return line;
        return "".concat($b1e7891750e609f8$var$spacer(lvl, tabStop)).concat(line);
    }).join('\n');
    return formattedElement;
};
var $b1e7891750e609f8$var$formatOneChildren = function formatOneChildren(inline, lvl, options) {
    return function(element) {
        return $b1e7891750e609f8$var$compensateMultilineStringElementIndentation(element, $b1e7891750e609f8$var$formatTreeNode(element, inline, lvl, options), inline, lvl, options);
    };
};
var $b1e7891750e609f8$var$onlyPropsWithOriginalValue = function onlyPropsWithOriginalValue(defaultProps, props) {
    return function(propName) {
        var haveDefaultValue = Object.keys(defaultProps).includes(propName);
        return !haveDefaultValue || haveDefaultValue && defaultProps[propName] !== props[propName];
    };
};
var $b1e7891750e609f8$var$isInlineAttributeTooLong = function isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) {
    if (!maxInlineAttributesLineLength) return attributes.length > 1;
    return $b1e7891750e609f8$var$spacer(lvl, tabStop).length + inlineAttributeString.length > maxInlineAttributesLineLength;
};
var $b1e7891750e609f8$var$shouldRenderMultilineAttr = function shouldRenderMultilineAttr(attributes, inlineAttributeString, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength) {
    return ($b1e7891750e609f8$var$isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) || containsMultilineAttr) && !inline;
};
var $b1e7891750e609f8$var$formatReactElementNode = function(node, inline, lvl, options) {
    var type = node.type, _node$displayName = node.displayName, displayName = _node$displayName === void 0 ? '' : _node$displayName, childrens = node.childrens, _node$props = node.props, props = _node$props === void 0 ? {} : _node$props, _node$defaultProps = node.defaultProps, defaultProps = _node$defaultProps === void 0 ? {} : _node$defaultProps;
    if (type !== 'ReactElement') throw new Error("The \"formatReactElementNode\" function could only format node of type \"ReactElement\". Given:  ".concat(type));
    var filterProps = options.filterProps, maxInlineAttributesLineLength = options.maxInlineAttributesLineLength, showDefaultProps = options.showDefaultProps, sortProps = options.sortProps, tabStop = options.tabStop;
    var out = "<".concat(displayName);
    var outInlineAttr = out;
    var outMultilineAttr = out;
    var containsMultilineAttr = false;
    var visibleAttributeNames = [];
    var propFilter = $b1e7891750e609f8$var$createPropFilter(props, filterProps);
    Object.keys(props).filter(propFilter).filter($b1e7891750e609f8$var$onlyPropsWithOriginalValue(defaultProps, props)).forEach(function(propName) {
        return visibleAttributeNames.push(propName);
    });
    Object.keys(defaultProps).filter(propFilter).filter(function() {
        return showDefaultProps;
    }).filter(function(defaultPropName) {
        return !visibleAttributeNames.includes(defaultPropName);
    }).forEach(function(defaultPropName) {
        return visibleAttributeNames.push(defaultPropName);
    });
    var attributes = $b1e7891750e609f8$var$sortPropsByNames(sortProps)(visibleAttributeNames);
    attributes.forEach(function(attributeName) {
        var _formatProp = $b1e7891750e609f8$var$formatProp(attributeName, Object.keys(props).includes(attributeName), props[attributeName], Object.keys(defaultProps).includes(attributeName), defaultProps[attributeName], inline, lvl, options), attributeFormattedInline = _formatProp.attributeFormattedInline, attributeFormattedMultiline = _formatProp.attributeFormattedMultiline, isMultilineAttribute = _formatProp.isMultilineAttribute;
        if (isMultilineAttribute) containsMultilineAttr = true;
        outInlineAttr += attributeFormattedInline;
        outMultilineAttr += attributeFormattedMultiline;
    });
    outMultilineAttr += "\n".concat($b1e7891750e609f8$var$spacer(lvl, tabStop));
    if ($b1e7891750e609f8$var$shouldRenderMultilineAttr(attributes, outInlineAttr, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength)) out = outMultilineAttr;
    else out = outInlineAttr;
    if (childrens && childrens.length > 0) {
        var newLvl = lvl + 1;
        out += '>';
        if (!inline) {
            out += '\n';
            out += $b1e7891750e609f8$var$spacer(newLvl, tabStop);
        }
        out += childrens.reduce($b1e7891750e609f8$var$mergeSiblingPlainStringChildrenReducer, []).map($b1e7891750e609f8$var$formatOneChildren(inline, newLvl, options)).join(!inline ? "\n".concat($b1e7891750e609f8$var$spacer(newLvl, tabStop)) : '');
        if (!inline) {
            out += '\n';
            out += $b1e7891750e609f8$var$spacer(newLvl - 1, tabStop);
        }
        out += "</".concat(displayName, ">");
    } else {
        if (!$b1e7891750e609f8$var$isInlineAttributeTooLong(attributes, outInlineAttr, lvl, tabStop, maxInlineAttributesLineLength)) out += ' ';
        out += '/>';
    }
    return out;
};
var $b1e7891750e609f8$var$REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX = '';
var $b1e7891750e609f8$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX = 'React.Fragment';
var $b1e7891750e609f8$var$toReactElementTreeNode = function toReactElementTreeNode(displayName, key, childrens) {
    var props = {};
    if (key) props = {
        key: key
    };
    return {
        type: 'ReactElement',
        displayName: displayName,
        props: props,
        defaultProps: {},
        childrens: childrens
    };
};
var $b1e7891750e609f8$var$isKeyedFragment = function isKeyedFragment(_ref) {
    var key = _ref.key;
    return Boolean(key);
};
var $b1e7891750e609f8$var$hasNoChildren = function hasNoChildren(_ref2) {
    var childrens = _ref2.childrens;
    return childrens.length === 0;
};
var $b1e7891750e609f8$var$formatReactFragmentNode = function(node, inline, lvl, options) {
    var type = node.type, key = node.key, childrens = node.childrens;
    if (type !== 'ReactFragment') throw new Error("The \"formatReactFragmentNode\" function could only format node of type \"ReactFragment\". Given: ".concat(type));
    var useFragmentShortSyntax = options.useFragmentShortSyntax;
    var displayName;
    if (useFragmentShortSyntax) {
        if ($b1e7891750e609f8$var$hasNoChildren(node) || $b1e7891750e609f8$var$isKeyedFragment(node)) displayName = $b1e7891750e609f8$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
        else displayName = $b1e7891750e609f8$var$REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX;
    } else displayName = $b1e7891750e609f8$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
    return $b1e7891750e609f8$var$formatReactElementNode($b1e7891750e609f8$var$toReactElementTreeNode(displayName, key, childrens), inline, lvl, options);
};
var $b1e7891750e609f8$var$jsxStopChars = [
    '<',
    '>',
    '{',
    '}'
];
var $b1e7891750e609f8$var$shouldBeEscaped = function shouldBeEscaped(s) {
    return $b1e7891750e609f8$var$jsxStopChars.some(function(jsxStopChar) {
        return s.includes(jsxStopChar);
    });
};
var $b1e7891750e609f8$var$escape = function escape(s) {
    if (!$b1e7891750e609f8$var$shouldBeEscaped(s)) return s;
    return "{`".concat(s, "`}");
};
var $b1e7891750e609f8$var$preserveTrailingSpace = function preserveTrailingSpace(s) {
    var result = s;
    if (result.endsWith(' ')) result = result.replace(/^(.*?)(\s+)$/, "$1{'$2'}");
    if (result.startsWith(' ')) result = result.replace(/^(\s+)(.*)$/, "{'$1'}$2");
    return result;
};
var $b1e7891750e609f8$var$formatTreeNode = function(node, inline, lvl, options) {
    if (node.type === 'number') return String(node.value);
    if (node.type === 'string') return node.value ? "".concat($b1e7891750e609f8$var$preserveTrailingSpace($b1e7891750e609f8$var$escape(String(node.value)))) : '';
    if (node.type === 'ReactElement') return $b1e7891750e609f8$var$formatReactElementNode(node, inline, lvl, options);
    if (node.type === 'ReactFragment') return $b1e7891750e609f8$var$formatReactFragmentNode(node, inline, lvl, options);
    throw new TypeError("Unknow format type \"".concat(node.type, "\""));
};
var $b1e7891750e609f8$var$formatTree = function(node, options) {
    return $b1e7891750e609f8$var$formatTreeNode(node, false, 0, options);
};
var $b1e7891750e609f8$var$reactElementToJsxString = function reactElementToJsxString(element) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$filterProps = _ref.filterProps, filterProps = _ref$filterProps === void 0 ? [] : _ref$filterProps, _ref$showDefaultProps = _ref.showDefaultProps, showDefaultProps = _ref$showDefaultProps === void 0 ? true : _ref$showDefaultProps, _ref$showFunctions = _ref.showFunctions, showFunctions = _ref$showFunctions === void 0 ? false : _ref$showFunctions, functionValue = _ref.functionValue, _ref$tabStop = _ref.tabStop, tabStop = _ref$tabStop === void 0 ? 2 : _ref$tabStop, _ref$useBooleanShorth = _ref.useBooleanShorthandSyntax, useBooleanShorthandSyntax = _ref$useBooleanShorth === void 0 ? true : _ref$useBooleanShorth, _ref$useFragmentShort = _ref.useFragmentShortSyntax, useFragmentShortSyntax = _ref$useFragmentShort === void 0 ? true : _ref$useFragmentShort, _ref$sortProps = _ref.sortProps, sortProps = _ref$sortProps === void 0 ? true : _ref$sortProps, maxInlineAttributesLineLength = _ref.maxInlineAttributesLineLength, displayName = _ref.displayName;
    if (!element) throw new Error('react-element-to-jsx-string: Expected a ReactElement');
    var options = {
        filterProps: filterProps,
        showDefaultProps: showDefaultProps,
        showFunctions: showFunctions,
        functionValue: functionValue,
        tabStop: tabStop,
        useBooleanShorthandSyntax: useBooleanShorthandSyntax,
        useFragmentShortSyntax: useFragmentShortSyntax,
        sortProps: sortProps,
        maxInlineAttributesLineLength: maxInlineAttributesLineLength,
        displayName: displayName
    };
    return $b1e7891750e609f8$var$formatTree($b1e7891750e609f8$var$_parseReactElement(element, options), options);
};
$b1e7891750e609f8$exports["default"] = $b1e7891750e609f8$var$reactElementToJsxString;
$b1e7891750e609f8$exports.inlineFunction = $b1e7891750e609f8$var$inlineFunction;
$b1e7891750e609f8$exports.preserveFunctionLineBreak = $b1e7891750e609f8$var$preserveFunctionLineBreak;


//#region src/error.ts
var $25dc077fd540282c$export$5003b41ce90ff8c9 = class extends Error {
    constructor(message){
        super(message);
        this.name = "ShikiError";
    }
};



// src/utils.ts
function $3ce28d198d785bf9$var$clone(something) {
    return $3ce28d198d785bf9$var$doClone(something);
}
function $3ce28d198d785bf9$var$doClone(something) {
    if (Array.isArray(something)) return $3ce28d198d785bf9$var$cloneArray(something);
    if (something instanceof RegExp) return something;
    if (typeof something === "object") return $3ce28d198d785bf9$var$cloneObj(something);
    return something;
}
function $3ce28d198d785bf9$var$cloneArray(arr) {
    let r = [];
    for(let i = 0, len = arr.length; i < len; i++)r[i] = $3ce28d198d785bf9$var$doClone(arr[i]);
    return r;
}
function $3ce28d198d785bf9$var$cloneObj(obj) {
    let r = {};
    for(let key in obj)r[key] = $3ce28d198d785bf9$var$doClone(obj[key]);
    return r;
}
function $3ce28d198d785bf9$var$mergeObjects(target, ...sources) {
    sources.forEach((source)=>{
        for(let key in source)target[key] = source[key];
    });
    return target;
}
function $3ce28d198d785bf9$var$basename(path) {
    const idx = ~path.lastIndexOf("/") || ~path.lastIndexOf("\\");
    if (idx === 0) return path;
    else if (~idx === path.length - 1) return $3ce28d198d785bf9$var$basename(path.substring(0, path.length - 1));
    else return path.substr(~idx + 1);
}
var $3ce28d198d785bf9$var$CAPTURING_REGEX_SOURCE = /\$(\d+)|\${(\d+):\/(downcase|upcase)}/g;
var $3ce28d198d785bf9$var$RegexSource = class {
    static hasCaptures(regexSource) {
        if (regexSource === null) return false;
        $3ce28d198d785bf9$var$CAPTURING_REGEX_SOURCE.lastIndex = 0;
        return $3ce28d198d785bf9$var$CAPTURING_REGEX_SOURCE.test(regexSource);
    }
    static replaceCaptures(regexSource, captureSource, captureIndices) {
        return regexSource.replace($3ce28d198d785bf9$var$CAPTURING_REGEX_SOURCE, (match, index, commandIndex, command)=>{
            let capture = captureIndices[parseInt(index || commandIndex, 10)];
            if (capture) {
                let result = captureSource.substring(capture.start, capture.end);
                while(result[0] === ".")result = result.substring(1);
                switch(command){
                    case "downcase":
                        return result.toLowerCase();
                    case "upcase":
                        return result.toUpperCase();
                    default:
                        return result;
                }
            } else return match;
        });
    }
};
function $3ce28d198d785bf9$var$strcmp(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $3ce28d198d785bf9$var$strArrCmp(a, b) {
    if (a === null && b === null) return 0;
    if (!a) return -1;
    if (!b) return 1;
    let len1 = a.length;
    let len2 = b.length;
    if (len1 === len2) {
        for(let i = 0; i < len1; i++){
            let res = $3ce28d198d785bf9$var$strcmp(a[i], b[i]);
            if (res !== 0) return res;
        }
        return 0;
    }
    return len1 - len2;
}
function $3ce28d198d785bf9$var$isValidHexColor(hex) {
    if (/^#[0-9a-f]{6}$/i.test(hex)) return true;
    if (/^#[0-9a-f]{8}$/i.test(hex)) return true;
    if (/^#[0-9a-f]{3}$/i.test(hex)) return true;
    if (/^#[0-9a-f]{4}$/i.test(hex)) return true;
    return false;
}
function $3ce28d198d785bf9$var$escapeRegExpCharacters(value) {
    return value.replace(/[\-\\\{\}\*\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, "\\$&");
}
var $3ce28d198d785bf9$var$CachedFn = class {
    constructor(fn){
        this.fn = fn;
    }
    cache = /* @__PURE__ */ new Map();
    get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        const value = this.fn(key);
        this.cache.set(key, value);
        return value;
    }
};
// src/theme.ts
var $3ce28d198d785bf9$export$14faa19a0f3bbeb2 = class {
    constructor(_colorMap, _defaults, _root){
        this._colorMap = _colorMap;
        this._defaults = _defaults;
        this._root = _root;
    }
    static createFromRawTheme(source, colorMap) {
        return this.createFromParsedTheme($3ce28d198d785bf9$var$parseTheme(source), colorMap);
    }
    static createFromParsedTheme(source, colorMap) {
        return $3ce28d198d785bf9$var$resolveParsedThemeRules(source, colorMap);
    }
    _cachedMatchRoot = new $3ce28d198d785bf9$var$CachedFn((scopeName)=>this._root.match(scopeName));
    getColorMap() {
        return this._colorMap.getColorMap();
    }
    getDefaults() {
        return this._defaults;
    }
    match(scopePath) {
        if (scopePath === null) return this._defaults;
        const scopeName = scopePath.scopeName;
        const matchingTrieElements = this._cachedMatchRoot.get(scopeName);
        const effectiveRule = matchingTrieElements.find((v)=>$3ce28d198d785bf9$var$_scopePathMatchesParentScopes(scopePath.parent, v.parentScopes));
        if (!effectiveRule) return null;
        return new $3ce28d198d785bf9$var$StyleAttributes(effectiveRule.fontStyle, effectiveRule.foreground, effectiveRule.background);
    }
};
var $3ce28d198d785bf9$var$ScopeStack = class _ScopeStack {
    constructor(parent, scopeName){
        this.parent = parent;
        this.scopeName = scopeName;
    }
    static push(path, scopeNames) {
        for (const name of scopeNames)path = new _ScopeStack(path, name);
        return path;
    }
    static from(...segments) {
        let result = null;
        for(let i = 0; i < segments.length; i++)result = new _ScopeStack(result, segments[i]);
        return result;
    }
    push(scopeName) {
        return new _ScopeStack(this, scopeName);
    }
    getSegments() {
        let item = this;
        const result = [];
        while(item){
            result.push(item.scopeName);
            item = item.parent;
        }
        result.reverse();
        return result;
    }
    toString() {
        return this.getSegments().join(" ");
    }
    extends(other) {
        if (this === other) return true;
        if (this.parent === null) return false;
        return this.parent.extends(other);
    }
    getExtensionIfDefined(base) {
        const result = [];
        let item = this;
        while(item && item !== base){
            result.push(item.scopeName);
            item = item.parent;
        }
        return item === base ? result.reverse() : void 0;
    }
};
function $3ce28d198d785bf9$var$_scopePathMatchesParentScopes(scopePath, parentScopes) {
    if (parentScopes.length === 0) return true;
    for(let index = 0; index < parentScopes.length; index++){
        let scopePattern = parentScopes[index];
        let scopeMustMatch = false;
        if (scopePattern === ">") {
            if (index === parentScopes.length - 1) return false;
            scopePattern = parentScopes[++index];
            scopeMustMatch = true;
        }
        while(scopePath){
            if ($3ce28d198d785bf9$var$_matchesScope(scopePath.scopeName, scopePattern)) break;
            if (scopeMustMatch) return false;
            scopePath = scopePath.parent;
        }
        if (!scopePath) return false;
        scopePath = scopePath.parent;
    }
    return true;
}
function $3ce28d198d785bf9$var$_matchesScope(scopeName, scopePattern) {
    return scopePattern === scopeName || scopeName.startsWith(scopePattern) && scopeName[scopePattern.length] === ".";
}
var $3ce28d198d785bf9$var$StyleAttributes = class {
    constructor(fontStyle, foregroundId, backgroundId){
        this.fontStyle = fontStyle;
        this.foregroundId = foregroundId;
        this.backgroundId = backgroundId;
    }
};
function $3ce28d198d785bf9$var$parseTheme(source) {
    if (!source) return [];
    if (!source.settings || !Array.isArray(source.settings)) return [];
    let settings = source.settings;
    let result = [], resultLen = 0;
    for(let i = 0, len = settings.length; i < len; i++){
        let entry = settings[i];
        if (!entry.settings) continue;
        let scopes;
        if (typeof entry.scope === "string") {
            let _scope = entry.scope;
            _scope = _scope.replace(/^[,]+/, "");
            _scope = _scope.replace(/[,]+$/, "");
            scopes = _scope.split(",");
        } else if (Array.isArray(entry.scope)) scopes = entry.scope;
        else scopes = [
            ""
        ];
        let fontStyle = -1 /* NotSet */ ;
        if (typeof entry.settings.fontStyle === "string") {
            fontStyle = 0 /* None */ ;
            let segments = entry.settings.fontStyle.split(" ");
            for(let j = 0, lenJ = segments.length; j < lenJ; j++){
                let segment = segments[j];
                switch(segment){
                    case "italic":
                        fontStyle = fontStyle | 1 /* Italic */ ;
                        break;
                    case "bold":
                        fontStyle = fontStyle | 2 /* Bold */ ;
                        break;
                    case "underline":
                        fontStyle = fontStyle | 4 /* Underline */ ;
                        break;
                    case "strikethrough":
                        fontStyle = fontStyle | 8 /* Strikethrough */ ;
                        break;
                }
            }
        }
        let foreground = null;
        if (typeof entry.settings.foreground === "string" && $3ce28d198d785bf9$var$isValidHexColor(entry.settings.foreground)) foreground = entry.settings.foreground;
        let background = null;
        if (typeof entry.settings.background === "string" && $3ce28d198d785bf9$var$isValidHexColor(entry.settings.background)) background = entry.settings.background;
        for(let j = 0, lenJ = scopes.length; j < lenJ; j++){
            let _scope = scopes[j].trim();
            let segments = _scope.split(" ");
            let scope = segments[segments.length - 1];
            let parentScopes = null;
            if (segments.length > 1) {
                parentScopes = segments.slice(0, segments.length - 1);
                parentScopes.reverse();
            }
            result[resultLen++] = new $3ce28d198d785bf9$var$ParsedThemeRule(scope, parentScopes, i, fontStyle, foreground, background);
        }
    }
    return result;
}
var $3ce28d198d785bf9$var$ParsedThemeRule = class {
    constructor(scope, parentScopes, index, fontStyle, foreground, background){
        this.scope = scope;
        this.parentScopes = parentScopes;
        this.index = index;
        this.fontStyle = fontStyle;
        this.foreground = foreground;
        this.background = background;
    }
};
var $3ce28d198d785bf9$export$23b468d4ca3f8c96 = /* @__PURE__ */ ((FontStyle2)=>{
    FontStyle2[FontStyle2["NotSet"] = -1] = "NotSet";
    FontStyle2[FontStyle2["None"] = 0] = "None";
    FontStyle2[FontStyle2["Italic"] = 1] = "Italic";
    FontStyle2[FontStyle2["Bold"] = 2] = "Bold";
    FontStyle2[FontStyle2["Underline"] = 4] = "Underline";
    FontStyle2[FontStyle2["Strikethrough"] = 8] = "Strikethrough";
    return FontStyle2;
})($3ce28d198d785bf9$export$23b468d4ca3f8c96 || {});
function $3ce28d198d785bf9$var$resolveParsedThemeRules(parsedThemeRules, _colorMap) {
    parsedThemeRules.sort((a, b)=>{
        let r = $3ce28d198d785bf9$var$strcmp(a.scope, b.scope);
        if (r !== 0) return r;
        r = $3ce28d198d785bf9$var$strArrCmp(a.parentScopes, b.parentScopes);
        if (r !== 0) return r;
        return a.index - b.index;
    });
    let defaultFontStyle = 0 /* None */ ;
    let defaultForeground = "#000000";
    let defaultBackground = "#ffffff";
    while(parsedThemeRules.length >= 1 && parsedThemeRules[0].scope === ""){
        let incomingDefaults = parsedThemeRules.shift();
        if (incomingDefaults.fontStyle !== -1 /* NotSet */ ) defaultFontStyle = incomingDefaults.fontStyle;
        if (incomingDefaults.foreground !== null) defaultForeground = incomingDefaults.foreground;
        if (incomingDefaults.background !== null) defaultBackground = incomingDefaults.background;
    }
    let colorMap = new $3ce28d198d785bf9$var$ColorMap(_colorMap);
    let defaults = new $3ce28d198d785bf9$var$StyleAttributes(defaultFontStyle, colorMap.getId(defaultForeground), colorMap.getId(defaultBackground));
    let root = new $3ce28d198d785bf9$var$ThemeTrieElement(new $3ce28d198d785bf9$var$ThemeTrieElementRule(0, null, -1 /* NotSet */ , 0, 0), []);
    for(let i = 0, len = parsedThemeRules.length; i < len; i++){
        let rule = parsedThemeRules[i];
        root.insert(0, rule.scope, rule.parentScopes, rule.fontStyle, colorMap.getId(rule.foreground), colorMap.getId(rule.background));
    }
    return new $3ce28d198d785bf9$export$14faa19a0f3bbeb2(colorMap, defaults, root);
}
var $3ce28d198d785bf9$var$ColorMap = class {
    _isFrozen;
    _lastColorId;
    _id2color;
    _color2id;
    constructor(_colorMap){
        this._lastColorId = 0;
        this._id2color = [];
        this._color2id = /* @__PURE__ */ Object.create(null);
        if (Array.isArray(_colorMap)) {
            this._isFrozen = true;
            for(let i = 0, len = _colorMap.length; i < len; i++){
                this._color2id[_colorMap[i]] = i;
                this._id2color[i] = _colorMap[i];
            }
        } else this._isFrozen = false;
    }
    getId(color) {
        if (color === null) return 0;
        color = color.toUpperCase();
        let value = this._color2id[color];
        if (value) return value;
        if (this._isFrozen) throw new Error(`Missing color in color map - ${color}`);
        value = ++this._lastColorId;
        this._color2id[color] = value;
        this._id2color[value] = color;
        return value;
    }
    getColorMap() {
        return this._id2color.slice(0);
    }
};
var $3ce28d198d785bf9$var$emptyParentScopes = Object.freeze([]);
var $3ce28d198d785bf9$var$ThemeTrieElementRule = class _ThemeTrieElementRule {
    scopeDepth;
    parentScopes;
    fontStyle;
    foreground;
    background;
    constructor(scopeDepth, parentScopes, fontStyle, foreground, background){
        this.scopeDepth = scopeDepth;
        this.parentScopes = parentScopes || $3ce28d198d785bf9$var$emptyParentScopes;
        this.fontStyle = fontStyle;
        this.foreground = foreground;
        this.background = background;
    }
    clone() {
        return new _ThemeTrieElementRule(this.scopeDepth, this.parentScopes, this.fontStyle, this.foreground, this.background);
    }
    static cloneArr(arr) {
        let r = [];
        for(let i = 0, len = arr.length; i < len; i++)r[i] = arr[i].clone();
        return r;
    }
    acceptOverwrite(scopeDepth, fontStyle, foreground, background) {
        if (this.scopeDepth > scopeDepth) console.log("how did this happen?");
        else this.scopeDepth = scopeDepth;
        if (fontStyle !== -1 /* NotSet */ ) this.fontStyle = fontStyle;
        if (foreground !== 0) this.foreground = foreground;
        if (background !== 0) this.background = background;
    }
};
var $3ce28d198d785bf9$var$ThemeTrieElement = class _ThemeTrieElement {
    constructor(_mainRule, rulesWithParentScopes = [], _children = {}){
        this._mainRule = _mainRule;
        this._children = _children;
        this._rulesWithParentScopes = rulesWithParentScopes;
    }
    _rulesWithParentScopes;
    static _cmpBySpecificity(a, b) {
        if (a.scopeDepth !== b.scopeDepth) return b.scopeDepth - a.scopeDepth;
        let aParentIndex = 0;
        let bParentIndex = 0;
        while(true){
            if (a.parentScopes[aParentIndex] === ">") aParentIndex++;
            if (b.parentScopes[bParentIndex] === ">") bParentIndex++;
            if (aParentIndex >= a.parentScopes.length || bParentIndex >= b.parentScopes.length) break;
            const parentScopeLengthDiff = b.parentScopes[bParentIndex].length - a.parentScopes[aParentIndex].length;
            if (parentScopeLengthDiff !== 0) return parentScopeLengthDiff;
            aParentIndex++;
            bParentIndex++;
        }
        return b.parentScopes.length - a.parentScopes.length;
    }
    match(scope) {
        if (scope !== "") {
            let dotIndex = scope.indexOf(".");
            let head;
            let tail;
            if (dotIndex === -1) {
                head = scope;
                tail = "";
            } else {
                head = scope.substring(0, dotIndex);
                tail = scope.substring(dotIndex + 1);
            }
            if (this._children.hasOwnProperty(head)) return this._children[head].match(tail);
        }
        const rules = this._rulesWithParentScopes.concat(this._mainRule);
        rules.sort(_ThemeTrieElement._cmpBySpecificity);
        return rules;
    }
    insert(scopeDepth, scope, parentScopes, fontStyle, foreground, background) {
        if (scope === "") {
            this._doInsertHere(scopeDepth, parentScopes, fontStyle, foreground, background);
            return;
        }
        let dotIndex = scope.indexOf(".");
        let head;
        let tail;
        if (dotIndex === -1) {
            head = scope;
            tail = "";
        } else {
            head = scope.substring(0, dotIndex);
            tail = scope.substring(dotIndex + 1);
        }
        let child;
        if (this._children.hasOwnProperty(head)) child = this._children[head];
        else {
            child = new _ThemeTrieElement(this._mainRule.clone(), $3ce28d198d785bf9$var$ThemeTrieElementRule.cloneArr(this._rulesWithParentScopes));
            this._children[head] = child;
        }
        child.insert(scopeDepth + 1, tail, parentScopes, fontStyle, foreground, background);
    }
    _doInsertHere(scopeDepth, parentScopes, fontStyle, foreground, background) {
        if (parentScopes === null) {
            this._mainRule.acceptOverwrite(scopeDepth, fontStyle, foreground, background);
            return;
        }
        for(let i = 0, len = this._rulesWithParentScopes.length; i < len; i++){
            let rule = this._rulesWithParentScopes[i];
            if ($3ce28d198d785bf9$var$strArrCmp(rule.parentScopes, parentScopes) === 0) {
                rule.acceptOverwrite(scopeDepth, fontStyle, foreground, background);
                return;
            }
        }
        if (fontStyle === -1 /* NotSet */ ) fontStyle = this._mainRule.fontStyle;
        if (foreground === 0) foreground = this._mainRule.foreground;
        if (background === 0) background = this._mainRule.background;
        this._rulesWithParentScopes.push(new $3ce28d198d785bf9$var$ThemeTrieElementRule(scopeDepth, parentScopes, fontStyle, foreground, background));
    }
};
// src/encodedTokenAttributes.ts
var $3ce28d198d785bf9$export$90e5db14803ea047 = class _EncodedTokenMetadata {
    static toBinaryStr(encodedTokenAttributes) {
        return encodedTokenAttributes.toString(2).padStart(32, "0");
    }
    static print(encodedTokenAttributes) {
        const languageId = _EncodedTokenMetadata.getLanguageId(encodedTokenAttributes);
        const tokenType = _EncodedTokenMetadata.getTokenType(encodedTokenAttributes);
        const fontStyle = _EncodedTokenMetadata.getFontStyle(encodedTokenAttributes);
        const foreground = _EncodedTokenMetadata.getForeground(encodedTokenAttributes);
        const background = _EncodedTokenMetadata.getBackground(encodedTokenAttributes);
        console.log({
            languageId: languageId,
            tokenType: tokenType,
            fontStyle: fontStyle,
            foreground: foreground,
            background: background
        });
    }
    static getLanguageId(encodedTokenAttributes) {
        return (encodedTokenAttributes & 255 /* LANGUAGEID_MASK */ ) >>> 0 /* LANGUAGEID_OFFSET */ ;
    }
    static getTokenType(encodedTokenAttributes) {
        return (encodedTokenAttributes & 768 /* TOKEN_TYPE_MASK */ ) >>> 8 /* TOKEN_TYPE_OFFSET */ ;
    }
    static containsBalancedBrackets(encodedTokenAttributes) {
        return (encodedTokenAttributes & 1024 /* BALANCED_BRACKETS_MASK */ ) !== 0;
    }
    static getFontStyle(encodedTokenAttributes) {
        return (encodedTokenAttributes & 30720 /* FONT_STYLE_MASK */ ) >>> 11 /* FONT_STYLE_OFFSET */ ;
    }
    static getForeground(encodedTokenAttributes) {
        return (encodedTokenAttributes & 16744448 /* FOREGROUND_MASK */ ) >>> 15 /* FOREGROUND_OFFSET */ ;
    }
    static getBackground(encodedTokenAttributes) {
        return (encodedTokenAttributes & 4278190080 /* BACKGROUND_MASK */ ) >>> 24 /* BACKGROUND_OFFSET */ ;
    }
    /**
   * Updates the fields in `metadata`.
   * A value of `0`, `NotSet` or `null` indicates that the corresponding field should be left as is.
   */ static set(encodedTokenAttributes, languageId, tokenType, containsBalancedBrackets, fontStyle, foreground, background) {
        let _languageId = _EncodedTokenMetadata.getLanguageId(encodedTokenAttributes);
        let _tokenType = _EncodedTokenMetadata.getTokenType(encodedTokenAttributes);
        let _containsBalancedBracketsBit = _EncodedTokenMetadata.containsBalancedBrackets(encodedTokenAttributes) ? 1 : 0;
        let _fontStyle = _EncodedTokenMetadata.getFontStyle(encodedTokenAttributes);
        let _foreground = _EncodedTokenMetadata.getForeground(encodedTokenAttributes);
        let _background = _EncodedTokenMetadata.getBackground(encodedTokenAttributes);
        if (languageId !== 0) _languageId = languageId;
        if (tokenType !== 8 /* NotSet */ ) _tokenType = $3ce28d198d785bf9$var$fromOptionalTokenType(tokenType);
        if (containsBalancedBrackets !== null) _containsBalancedBracketsBit = containsBalancedBrackets ? 1 : 0;
        if (fontStyle !== -1 /* NotSet */ ) _fontStyle = fontStyle;
        if (foreground !== 0) _foreground = foreground;
        if (background !== 0) _background = background;
        return (_languageId << 0 /* LANGUAGEID_OFFSET */  | _tokenType << 8 /* TOKEN_TYPE_OFFSET */  | _containsBalancedBracketsBit << 10 /* BALANCED_BRACKETS_OFFSET */  | _fontStyle << 11 /* FONT_STYLE_OFFSET */  | _foreground << 15 /* FOREGROUND_OFFSET */  | _background << 24 /* BACKGROUND_OFFSET */ ) >>> 0;
    }
};
function $3ce28d198d785bf9$var$toOptionalTokenType(standardType) {
    return standardType;
}
function $3ce28d198d785bf9$var$fromOptionalTokenType(standardType) {
    return standardType;
}
// src/matcher.ts
function $3ce28d198d785bf9$var$createMatchers(selector, matchesName) {
    const results = [];
    const tokenizer = $3ce28d198d785bf9$var$newTokenizer(selector);
    let token = tokenizer.next();
    while(token !== null){
        let priority = 0;
        if (token.length === 2 && token.charAt(1) === ":") {
            switch(token.charAt(0)){
                case "R":
                    priority = 1;
                    break;
                case "L":
                    priority = -1;
                    break;
                default:
                    console.log(`Unknown priority ${token} in scope selector`);
            }
            token = tokenizer.next();
        }
        let matcher = parseConjunction();
        results.push({
            matcher: matcher,
            priority: priority
        });
        if (token !== ",") break;
        token = tokenizer.next();
    }
    return results;
    function parseOperand() {
        if (token === "-") {
            token = tokenizer.next();
            const expressionToNegate = parseOperand();
            return (matcherInput)=>!!expressionToNegate && !expressionToNegate(matcherInput);
        }
        if (token === "(") {
            token = tokenizer.next();
            const expressionInParents = parseInnerExpression();
            if (token === ")") token = tokenizer.next();
            return expressionInParents;
        }
        if ($3ce28d198d785bf9$var$isIdentifier(token)) {
            const identifiers = [];
            do {
                identifiers.push(token);
                token = tokenizer.next();
            }while ($3ce28d198d785bf9$var$isIdentifier(token));
            return (matcherInput)=>matchesName(identifiers, matcherInput);
        }
        return null;
    }
    function parseConjunction() {
        const matchers = [];
        let matcher = parseOperand();
        while(matcher){
            matchers.push(matcher);
            matcher = parseOperand();
        }
        return (matcherInput)=>matchers.every((matcher2)=>matcher2(matcherInput));
    }
    function parseInnerExpression() {
        const matchers = [];
        let matcher = parseConjunction();
        while(matcher){
            matchers.push(matcher);
            if (token === "|" || token === ",") do token = tokenizer.next();
            while (token === "|" || token === ",");
            else break;
            matcher = parseConjunction();
        }
        return (matcherInput)=>matchers.some((matcher2)=>matcher2(matcherInput));
    }
}
function $3ce28d198d785bf9$var$isIdentifier(token) {
    return !!token && !!token.match(/[\w\.:]+/);
}
function $3ce28d198d785bf9$var$newTokenizer(input) {
    let regex = /([LR]:|[\w\.:][\w\.:\-]*|[\,\|\-\(\)])/g;
    let match = regex.exec(input);
    return {
        next: ()=>{
            if (!match) return null;
            const res = match[0];
            match = regex.exec(input);
            return res;
        }
    };
}
// src/onigLib.ts
var $3ce28d198d785bf9$export$94e52bf7f3697178 = /* @__PURE__ */ ((FindOption2)=>{
    FindOption2[FindOption2["None"] = 0] = "None";
    FindOption2[FindOption2["NotBeginString"] = 1] = "NotBeginString";
    FindOption2[FindOption2["NotEndString"] = 2] = "NotEndString";
    FindOption2[FindOption2["NotBeginPosition"] = 4] = "NotBeginPosition";
    FindOption2[FindOption2["DebugCall"] = 8] = "DebugCall";
    return FindOption2;
})($3ce28d198d785bf9$export$94e52bf7f3697178 || {});
function $3ce28d198d785bf9$export$2b6cad23a17023a7(str) {
    if (typeof str.dispose === "function") str.dispose();
}
// src/grammar/grammarDependencies.ts
var $3ce28d198d785bf9$var$TopLevelRuleReference = class {
    constructor(scopeName){
        this.scopeName = scopeName;
    }
    toKey() {
        return this.scopeName;
    }
};
var $3ce28d198d785bf9$var$TopLevelRepositoryRuleReference = class {
    constructor(scopeName, ruleName){
        this.scopeName = scopeName;
        this.ruleName = ruleName;
    }
    toKey() {
        return `${this.scopeName}#${this.ruleName}`;
    }
};
var $3ce28d198d785bf9$var$ExternalReferenceCollector = class {
    _references = [];
    _seenReferenceKeys = /* @__PURE__ */ new Set();
    get references() {
        return this._references;
    }
    visitedRule = /* @__PURE__ */ new Set();
    add(reference) {
        const key = reference.toKey();
        if (this._seenReferenceKeys.has(key)) return;
        this._seenReferenceKeys.add(key);
        this._references.push(reference);
    }
};
var $3ce28d198d785bf9$var$ScopeDependencyProcessor = class {
    constructor(repo, initialScopeName){
        this.repo = repo;
        this.initialScopeName = initialScopeName;
        this.seenFullScopeRequests.add(this.initialScopeName);
        this.Q = [
            new $3ce28d198d785bf9$var$TopLevelRuleReference(this.initialScopeName)
        ];
    }
    seenFullScopeRequests = /* @__PURE__ */ new Set();
    seenPartialScopeRequests = /* @__PURE__ */ new Set();
    Q;
    processQueue() {
        const q = this.Q;
        this.Q = [];
        const deps = new $3ce28d198d785bf9$var$ExternalReferenceCollector();
        for (const dep of q)$3ce28d198d785bf9$var$collectReferencesOfReference(dep, this.initialScopeName, this.repo, deps);
        for (const dep of deps.references)if (dep instanceof $3ce28d198d785bf9$var$TopLevelRuleReference) {
            if (this.seenFullScopeRequests.has(dep.scopeName)) continue;
            this.seenFullScopeRequests.add(dep.scopeName);
            this.Q.push(dep);
        } else {
            if (this.seenFullScopeRequests.has(dep.scopeName)) continue;
            if (this.seenPartialScopeRequests.has(dep.toKey())) continue;
            this.seenPartialScopeRequests.add(dep.toKey());
            this.Q.push(dep);
        }
    }
};
function $3ce28d198d785bf9$var$collectReferencesOfReference(reference, baseGrammarScopeName, repo, result) {
    const selfGrammar = repo.lookup(reference.scopeName);
    if (!selfGrammar) {
        if (reference.scopeName === baseGrammarScopeName) throw new Error(`No grammar provided for <${baseGrammarScopeName}>`);
        return;
    }
    const baseGrammar = repo.lookup(baseGrammarScopeName);
    if (reference instanceof $3ce28d198d785bf9$var$TopLevelRuleReference) $3ce28d198d785bf9$var$collectExternalReferencesInTopLevelRule({
        baseGrammar: baseGrammar,
        selfGrammar: selfGrammar
    }, result);
    else $3ce28d198d785bf9$var$collectExternalReferencesInTopLevelRepositoryRule(reference.ruleName, {
        baseGrammar: baseGrammar,
        selfGrammar: selfGrammar,
        repository: selfGrammar.repository
    }, result);
    const injections = repo.injections(reference.scopeName);
    if (injections) for (const injection of injections)result.add(new $3ce28d198d785bf9$var$TopLevelRuleReference(injection));
}
function $3ce28d198d785bf9$var$collectExternalReferencesInTopLevelRepositoryRule(ruleName, context, result) {
    if (context.repository && context.repository[ruleName]) {
        const rule = context.repository[ruleName];
        $3ce28d198d785bf9$var$collectExternalReferencesInRules([
            rule
        ], context, result);
    }
}
function $3ce28d198d785bf9$var$collectExternalReferencesInTopLevelRule(context, result) {
    if (context.selfGrammar.patterns && Array.isArray(context.selfGrammar.patterns)) $3ce28d198d785bf9$var$collectExternalReferencesInRules(context.selfGrammar.patterns, {
        ...context,
        repository: context.selfGrammar.repository
    }, result);
    if (context.selfGrammar.injections) $3ce28d198d785bf9$var$collectExternalReferencesInRules(Object.values(context.selfGrammar.injections), {
        ...context,
        repository: context.selfGrammar.repository
    }, result);
}
function $3ce28d198d785bf9$var$collectExternalReferencesInRules(rules, context, result) {
    for (const rule of rules){
        if (result.visitedRule.has(rule)) continue;
        result.visitedRule.add(rule);
        const patternRepository = rule.repository ? $3ce28d198d785bf9$var$mergeObjects({}, context.repository, rule.repository) : context.repository;
        if (Array.isArray(rule.patterns)) $3ce28d198d785bf9$var$collectExternalReferencesInRules(rule.patterns, {
            ...context,
            repository: patternRepository
        }, result);
        const include = rule.include;
        if (!include) continue;
        const reference = $3ce28d198d785bf9$var$parseInclude(include);
        switch(reference.kind){
            case 0 /* Base */ :
                $3ce28d198d785bf9$var$collectExternalReferencesInTopLevelRule({
                    ...context,
                    selfGrammar: context.baseGrammar
                }, result);
                break;
            case 1 /* Self */ :
                $3ce28d198d785bf9$var$collectExternalReferencesInTopLevelRule(context, result);
                break;
            case 2 /* RelativeReference */ :
                $3ce28d198d785bf9$var$collectExternalReferencesInTopLevelRepositoryRule(reference.ruleName, {
                    ...context,
                    repository: patternRepository
                }, result);
                break;
            case 3 /* TopLevelReference */ :
            case 4 /* TopLevelRepositoryReference */ :
                const selfGrammar = reference.scopeName === context.selfGrammar.scopeName ? context.selfGrammar : reference.scopeName === context.baseGrammar.scopeName ? context.baseGrammar : void 0;
                if (selfGrammar) {
                    const newContext = {
                        baseGrammar: context.baseGrammar,
                        selfGrammar: selfGrammar,
                        repository: patternRepository
                    };
                    if (reference.kind === 4 /* TopLevelRepositoryReference */ ) $3ce28d198d785bf9$var$collectExternalReferencesInTopLevelRepositoryRule(reference.ruleName, newContext, result);
                    else $3ce28d198d785bf9$var$collectExternalReferencesInTopLevelRule(newContext, result);
                } else if (reference.kind === 4 /* TopLevelRepositoryReference */ ) result.add(new $3ce28d198d785bf9$var$TopLevelRepositoryRuleReference(reference.scopeName, reference.ruleName));
                else result.add(new $3ce28d198d785bf9$var$TopLevelRuleReference(reference.scopeName));
                break;
        }
    }
}
var $3ce28d198d785bf9$var$BaseReference = class {
    kind = 0 /* Base */ ;
};
var $3ce28d198d785bf9$var$SelfReference = class {
    kind = 1 /* Self */ ;
};
var $3ce28d198d785bf9$var$RelativeReference = class {
    constructor(ruleName){
        this.ruleName = ruleName;
    }
    kind = 2 /* RelativeReference */ ;
};
var $3ce28d198d785bf9$var$TopLevelReference = class {
    constructor(scopeName){
        this.scopeName = scopeName;
    }
    kind = 3 /* TopLevelReference */ ;
};
var $3ce28d198d785bf9$var$TopLevelRepositoryReference = class {
    constructor(scopeName, ruleName){
        this.scopeName = scopeName;
        this.ruleName = ruleName;
    }
    kind = 4 /* TopLevelRepositoryReference */ ;
};
function $3ce28d198d785bf9$var$parseInclude(include) {
    if (include === "$base") return new $3ce28d198d785bf9$var$BaseReference();
    else if (include === "$self") return new $3ce28d198d785bf9$var$SelfReference();
    const indexOfSharp = include.indexOf("#");
    if (indexOfSharp === -1) return new $3ce28d198d785bf9$var$TopLevelReference(include);
    else if (indexOfSharp === 0) return new $3ce28d198d785bf9$var$RelativeReference(include.substring(1));
    else {
        const scopeName = include.substring(0, indexOfSharp);
        const ruleName = include.substring(indexOfSharp + 1);
        return new $3ce28d198d785bf9$var$TopLevelRepositoryReference(scopeName, ruleName);
    }
}
// src/rule.ts
var $3ce28d198d785bf9$var$HAS_BACK_REFERENCES = /\\(\d+)/;
var $3ce28d198d785bf9$var$BACK_REFERENCING_END = /\\(\d+)/g;
var $3ce28d198d785bf9$var$ruleIdSymbol = Symbol("RuleId");
var $3ce28d198d785bf9$var$endRuleId = -1;
var $3ce28d198d785bf9$var$whileRuleId = -2;
function $3ce28d198d785bf9$var$ruleIdFromNumber(id) {
    return id;
}
function $3ce28d198d785bf9$var$ruleIdToNumber(id) {
    return id;
}
var $3ce28d198d785bf9$var$Rule = class {
    $location;
    id;
    _nameIsCapturing;
    _name;
    _contentNameIsCapturing;
    _contentName;
    constructor($location, id, name, contentName){
        this.$location = $location;
        this.id = id;
        this._name = name || null;
        this._nameIsCapturing = $3ce28d198d785bf9$var$RegexSource.hasCaptures(this._name);
        this._contentName = contentName || null;
        this._contentNameIsCapturing = $3ce28d198d785bf9$var$RegexSource.hasCaptures(this._contentName);
    }
    get debugName() {
        const location = this.$location ? `${$3ce28d198d785bf9$var$basename(this.$location.filename)}:${this.$location.line}` : "unknown";
        return `${this.constructor.name}#${this.id} @ ${location}`;
    }
    getName(lineText, captureIndices) {
        if (!this._nameIsCapturing || this._name === null || lineText === null || captureIndices === null) return this._name;
        return $3ce28d198d785bf9$var$RegexSource.replaceCaptures(this._name, lineText, captureIndices);
    }
    getContentName(lineText, captureIndices) {
        if (!this._contentNameIsCapturing || this._contentName === null) return this._contentName;
        return $3ce28d198d785bf9$var$RegexSource.replaceCaptures(this._contentName, lineText, captureIndices);
    }
};
var $3ce28d198d785bf9$var$CaptureRule = class extends $3ce28d198d785bf9$var$Rule {
    retokenizeCapturedWithRuleId;
    constructor($location, id, name, contentName, retokenizeCapturedWithRuleId){
        super($location, id, name, contentName);
        this.retokenizeCapturedWithRuleId = retokenizeCapturedWithRuleId;
    }
    dispose() {}
    collectPatterns(grammar, out) {
        throw new Error("Not supported!");
    }
    compile(grammar, endRegexSource) {
        throw new Error("Not supported!");
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        throw new Error("Not supported!");
    }
};
var $3ce28d198d785bf9$var$MatchRule = class extends $3ce28d198d785bf9$var$Rule {
    _match;
    captures;
    _cachedCompiledPatterns;
    constructor($location, id, name, match, captures){
        super($location, id, name, null);
        this._match = new $3ce28d198d785bf9$var$RegExpSource(match, this.id);
        this.captures = captures;
        this._cachedCompiledPatterns = null;
    }
    dispose() {
        if (this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns.dispose();
            this._cachedCompiledPatterns = null;
        }
    }
    get debugMatchRegExp() {
        return `${this._match.source}`;
    }
    collectPatterns(grammar, out) {
        out.push(this._match);
    }
    compile(grammar, endRegexSource) {
        return this._getCachedCompiledPatterns(grammar).compile(grammar);
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledPatterns(grammar).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledPatterns(grammar) {
        if (!this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns = new $3ce28d198d785bf9$var$RegExpSourceList();
            this.collectPatterns(grammar, this._cachedCompiledPatterns);
        }
        return this._cachedCompiledPatterns;
    }
};
var $3ce28d198d785bf9$var$IncludeOnlyRule = class extends $3ce28d198d785bf9$var$Rule {
    hasMissingPatterns;
    patterns;
    _cachedCompiledPatterns;
    constructor($location, id, name, contentName, patterns){
        super($location, id, name, contentName);
        this.patterns = patterns.patterns;
        this.hasMissingPatterns = patterns.hasMissingPatterns;
        this._cachedCompiledPatterns = null;
    }
    dispose() {
        if (this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns.dispose();
            this._cachedCompiledPatterns = null;
        }
    }
    collectPatterns(grammar, out) {
        for (const pattern of this.patterns){
            const rule = grammar.getRule(pattern);
            rule.collectPatterns(grammar, out);
        }
    }
    compile(grammar, endRegexSource) {
        return this._getCachedCompiledPatterns(grammar).compile(grammar);
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledPatterns(grammar).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledPatterns(grammar) {
        if (!this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns = new $3ce28d198d785bf9$var$RegExpSourceList();
            this.collectPatterns(grammar, this._cachedCompiledPatterns);
        }
        return this._cachedCompiledPatterns;
    }
};
var $3ce28d198d785bf9$var$BeginEndRule = class extends $3ce28d198d785bf9$var$Rule {
    _begin;
    beginCaptures;
    _end;
    endHasBackReferences;
    endCaptures;
    applyEndPatternLast;
    hasMissingPatterns;
    patterns;
    _cachedCompiledPatterns;
    constructor($location, id, name, contentName, begin, beginCaptures, end, endCaptures, applyEndPatternLast, patterns){
        super($location, id, name, contentName);
        this._begin = new $3ce28d198d785bf9$var$RegExpSource(begin, this.id);
        this.beginCaptures = beginCaptures;
        this._end = new $3ce28d198d785bf9$var$RegExpSource(end ? end : "\uFFFF", -1);
        this.endHasBackReferences = this._end.hasBackReferences;
        this.endCaptures = endCaptures;
        this.applyEndPatternLast = applyEndPatternLast || false;
        this.patterns = patterns.patterns;
        this.hasMissingPatterns = patterns.hasMissingPatterns;
        this._cachedCompiledPatterns = null;
    }
    dispose() {
        if (this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns.dispose();
            this._cachedCompiledPatterns = null;
        }
    }
    get debugBeginRegExp() {
        return `${this._begin.source}`;
    }
    get debugEndRegExp() {
        return `${this._end.source}`;
    }
    getEndWithResolvedBackReferences(lineText, captureIndices) {
        return this._end.resolveBackReferences(lineText, captureIndices);
    }
    collectPatterns(grammar, out) {
        out.push(this._begin);
    }
    compile(grammar, endRegexSource) {
        return this._getCachedCompiledPatterns(grammar, endRegexSource).compile(grammar);
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledPatterns(grammar, endRegexSource).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledPatterns(grammar, endRegexSource) {
        if (!this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns = new $3ce28d198d785bf9$var$RegExpSourceList();
            for (const pattern of this.patterns){
                const rule = grammar.getRule(pattern);
                rule.collectPatterns(grammar, this._cachedCompiledPatterns);
            }
            if (this.applyEndPatternLast) this._cachedCompiledPatterns.push(this._end.hasBackReferences ? this._end.clone() : this._end);
            else this._cachedCompiledPatterns.unshift(this._end.hasBackReferences ? this._end.clone() : this._end);
        }
        if (this._end.hasBackReferences) {
            if (this.applyEndPatternLast) this._cachedCompiledPatterns.setSource(this._cachedCompiledPatterns.length() - 1, endRegexSource);
            else this._cachedCompiledPatterns.setSource(0, endRegexSource);
        }
        return this._cachedCompiledPatterns;
    }
};
var $3ce28d198d785bf9$var$BeginWhileRule = class extends $3ce28d198d785bf9$var$Rule {
    _begin;
    beginCaptures;
    whileCaptures;
    _while;
    whileHasBackReferences;
    hasMissingPatterns;
    patterns;
    _cachedCompiledPatterns;
    _cachedCompiledWhilePatterns;
    constructor($location, id, name, contentName, begin, beginCaptures, _while, whileCaptures, patterns){
        super($location, id, name, contentName);
        this._begin = new $3ce28d198d785bf9$var$RegExpSource(begin, this.id);
        this.beginCaptures = beginCaptures;
        this.whileCaptures = whileCaptures;
        this._while = new $3ce28d198d785bf9$var$RegExpSource(_while, $3ce28d198d785bf9$var$whileRuleId);
        this.whileHasBackReferences = this._while.hasBackReferences;
        this.patterns = patterns.patterns;
        this.hasMissingPatterns = patterns.hasMissingPatterns;
        this._cachedCompiledPatterns = null;
        this._cachedCompiledWhilePatterns = null;
    }
    dispose() {
        if (this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns.dispose();
            this._cachedCompiledPatterns = null;
        }
        if (this._cachedCompiledWhilePatterns) {
            this._cachedCompiledWhilePatterns.dispose();
            this._cachedCompiledWhilePatterns = null;
        }
    }
    get debugBeginRegExp() {
        return `${this._begin.source}`;
    }
    get debugWhileRegExp() {
        return `${this._while.source}`;
    }
    getWhileWithResolvedBackReferences(lineText, captureIndices) {
        return this._while.resolveBackReferences(lineText, captureIndices);
    }
    collectPatterns(grammar, out) {
        out.push(this._begin);
    }
    compile(grammar, endRegexSource) {
        return this._getCachedCompiledPatterns(grammar).compile(grammar);
    }
    compileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledPatterns(grammar).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledPatterns(grammar) {
        if (!this._cachedCompiledPatterns) {
            this._cachedCompiledPatterns = new $3ce28d198d785bf9$var$RegExpSourceList();
            for (const pattern of this.patterns){
                const rule = grammar.getRule(pattern);
                rule.collectPatterns(grammar, this._cachedCompiledPatterns);
            }
        }
        return this._cachedCompiledPatterns;
    }
    compileWhile(grammar, endRegexSource) {
        return this._getCachedCompiledWhilePatterns(grammar, endRegexSource).compile(grammar);
    }
    compileWhileAG(grammar, endRegexSource, allowA, allowG) {
        return this._getCachedCompiledWhilePatterns(grammar, endRegexSource).compileAG(grammar, allowA, allowG);
    }
    _getCachedCompiledWhilePatterns(grammar, endRegexSource) {
        if (!this._cachedCompiledWhilePatterns) {
            this._cachedCompiledWhilePatterns = new $3ce28d198d785bf9$var$RegExpSourceList();
            this._cachedCompiledWhilePatterns.push(this._while.hasBackReferences ? this._while.clone() : this._while);
        }
        if (this._while.hasBackReferences) this._cachedCompiledWhilePatterns.setSource(0, endRegexSource ? endRegexSource : "\uFFFF");
        return this._cachedCompiledWhilePatterns;
    }
};
var $3ce28d198d785bf9$var$RuleFactory = class _RuleFactory {
    static createCaptureRule(helper, $location, name, contentName, retokenizeCapturedWithRuleId) {
        return helper.registerRule((id)=>{
            return new $3ce28d198d785bf9$var$CaptureRule($location, id, name, contentName, retokenizeCapturedWithRuleId);
        });
    }
    static getCompiledRuleId(desc, helper, repository) {
        if (!desc.id) helper.registerRule((id)=>{
            desc.id = id;
            if (desc.match) return new $3ce28d198d785bf9$var$MatchRule(desc.$vscodeTextmateLocation, desc.id, desc.name, desc.match, _RuleFactory._compileCaptures(desc.captures, helper, repository));
            if (typeof desc.begin === "undefined") {
                if (desc.repository) repository = $3ce28d198d785bf9$var$mergeObjects({}, repository, desc.repository);
                let patterns = desc.patterns;
                if (typeof patterns === "undefined" && desc.include) patterns = [
                    {
                        include: desc.include
                    }
                ];
                return new $3ce28d198d785bf9$var$IncludeOnlyRule(desc.$vscodeTextmateLocation, desc.id, desc.name, desc.contentName, _RuleFactory._compilePatterns(patterns, helper, repository));
            }
            if (desc.while) return new $3ce28d198d785bf9$var$BeginWhileRule(desc.$vscodeTextmateLocation, desc.id, desc.name, desc.contentName, desc.begin, _RuleFactory._compileCaptures(desc.beginCaptures || desc.captures, helper, repository), desc.while, _RuleFactory._compileCaptures(desc.whileCaptures || desc.captures, helper, repository), _RuleFactory._compilePatterns(desc.patterns, helper, repository));
            return new $3ce28d198d785bf9$var$BeginEndRule(desc.$vscodeTextmateLocation, desc.id, desc.name, desc.contentName, desc.begin, _RuleFactory._compileCaptures(desc.beginCaptures || desc.captures, helper, repository), desc.end, _RuleFactory._compileCaptures(desc.endCaptures || desc.captures, helper, repository), desc.applyEndPatternLast, _RuleFactory._compilePatterns(desc.patterns, helper, repository));
        });
        return desc.id;
    }
    static _compileCaptures(captures, helper, repository) {
        let r = [];
        if (captures) {
            let maximumCaptureId = 0;
            for(const captureId in captures){
                if (captureId === "$vscodeTextmateLocation") continue;
                const numericCaptureId = parseInt(captureId, 10);
                if (numericCaptureId > maximumCaptureId) maximumCaptureId = numericCaptureId;
            }
            for(let i = 0; i <= maximumCaptureId; i++)r[i] = null;
            for(const captureId in captures){
                if (captureId === "$vscodeTextmateLocation") continue;
                const numericCaptureId = parseInt(captureId, 10);
                let retokenizeCapturedWithRuleId = 0;
                if (captures[captureId].patterns) retokenizeCapturedWithRuleId = _RuleFactory.getCompiledRuleId(captures[captureId], helper, repository);
                r[numericCaptureId] = _RuleFactory.createCaptureRule(helper, captures[captureId].$vscodeTextmateLocation, captures[captureId].name, captures[captureId].contentName, retokenizeCapturedWithRuleId);
            }
        }
        return r;
    }
    static _compilePatterns(patterns, helper, repository) {
        let r = [];
        if (patterns) for(let i = 0, len = patterns.length; i < len; i++){
            const pattern = patterns[i];
            let ruleId = -1;
            if (pattern.include) {
                const reference = $3ce28d198d785bf9$var$parseInclude(pattern.include);
                switch(reference.kind){
                    case 0 /* Base */ :
                    case 1 /* Self */ :
                        ruleId = _RuleFactory.getCompiledRuleId(repository[pattern.include], helper, repository);
                        break;
                    case 2 /* RelativeReference */ :
                        let localIncludedRule = repository[reference.ruleName];
                        if (localIncludedRule) ruleId = _RuleFactory.getCompiledRuleId(localIncludedRule, helper, repository);
                        break;
                    case 3 /* TopLevelReference */ :
                    case 4 /* TopLevelRepositoryReference */ :
                        const externalGrammarName = reference.scopeName;
                        const externalGrammarInclude = reference.kind === 4 /* TopLevelRepositoryReference */  ? reference.ruleName : null;
                        const externalGrammar = helper.getExternalGrammar(externalGrammarName, repository);
                        if (externalGrammar) {
                            if (externalGrammarInclude) {
                                let externalIncludedRule = externalGrammar.repository[externalGrammarInclude];
                                if (externalIncludedRule) ruleId = _RuleFactory.getCompiledRuleId(externalIncludedRule, helper, externalGrammar.repository);
                            } else ruleId = _RuleFactory.getCompiledRuleId(externalGrammar.repository.$self, helper, externalGrammar.repository);
                        } else ;
                        break;
                }
            } else ruleId = _RuleFactory.getCompiledRuleId(pattern, helper, repository);
            if (ruleId !== -1) {
                const rule = helper.getRule(ruleId);
                let skipRule = false;
                if (rule instanceof $3ce28d198d785bf9$var$IncludeOnlyRule || rule instanceof $3ce28d198d785bf9$var$BeginEndRule || rule instanceof $3ce28d198d785bf9$var$BeginWhileRule) {
                    if (rule.hasMissingPatterns && rule.patterns.length === 0) skipRule = true;
                }
                if (skipRule) continue;
                r.push(ruleId);
            }
        }
        return {
            patterns: r,
            hasMissingPatterns: (patterns ? patterns.length : 0) !== r.length
        };
    }
};
var $3ce28d198d785bf9$var$RegExpSource = class _RegExpSource {
    source;
    ruleId;
    hasAnchor;
    hasBackReferences;
    _anchorCache;
    constructor(regExpSource, ruleId){
        if (regExpSource && typeof regExpSource === "string") {
            const len = regExpSource.length;
            let lastPushedPos = 0;
            let output = [];
            let hasAnchor = false;
            for(let pos = 0; pos < len; pos++){
                const ch = regExpSource.charAt(pos);
                if (ch === "\\") {
                    if (pos + 1 < len) {
                        const nextCh = regExpSource.charAt(pos + 1);
                        if (nextCh === "z") {
                            output.push(regExpSource.substring(lastPushedPos, pos));
                            output.push("$(?!\\n)(?<!\\n)");
                            lastPushedPos = pos + 2;
                        } else if (nextCh === "A" || nextCh === "G") hasAnchor = true;
                        pos++;
                    }
                }
            }
            this.hasAnchor = hasAnchor;
            if (lastPushedPos === 0) this.source = regExpSource;
            else {
                output.push(regExpSource.substring(lastPushedPos, len));
                this.source = output.join("");
            }
        } else {
            this.hasAnchor = false;
            this.source = regExpSource;
        }
        if (this.hasAnchor) this._anchorCache = this._buildAnchorCache();
        else this._anchorCache = null;
        this.ruleId = ruleId;
        if (typeof this.source === "string") this.hasBackReferences = $3ce28d198d785bf9$var$HAS_BACK_REFERENCES.test(this.source);
        else this.hasBackReferences = false;
    }
    clone() {
        return new _RegExpSource(this.source, this.ruleId);
    }
    setSource(newSource) {
        if (this.source === newSource) return;
        this.source = newSource;
        if (this.hasAnchor) this._anchorCache = this._buildAnchorCache();
    }
    resolveBackReferences(lineText, captureIndices) {
        if (typeof this.source !== "string") throw new Error("This method should only be called if the source is a string");
        let capturedValues = captureIndices.map((capture)=>{
            return lineText.substring(capture.start, capture.end);
        });
        $3ce28d198d785bf9$var$BACK_REFERENCING_END.lastIndex = 0;
        return this.source.replace($3ce28d198d785bf9$var$BACK_REFERENCING_END, (match, g1)=>{
            return $3ce28d198d785bf9$var$escapeRegExpCharacters(capturedValues[parseInt(g1, 10)] || "");
        });
    }
    _buildAnchorCache() {
        if (typeof this.source !== "string") throw new Error("This method should only be called if the source is a string");
        let A0_G0_result = [];
        let A0_G1_result = [];
        let A1_G0_result = [];
        let A1_G1_result = [];
        let pos, len, ch, nextCh;
        for(pos = 0, len = this.source.length; pos < len; pos++){
            ch = this.source.charAt(pos);
            A0_G0_result[pos] = ch;
            A0_G1_result[pos] = ch;
            A1_G0_result[pos] = ch;
            A1_G1_result[pos] = ch;
            if (ch === "\\") {
                if (pos + 1 < len) {
                    nextCh = this.source.charAt(pos + 1);
                    if (nextCh === "A") {
                        A0_G0_result[pos + 1] = "\uFFFF";
                        A0_G1_result[pos + 1] = "\uFFFF";
                        A1_G0_result[pos + 1] = "A";
                        A1_G1_result[pos + 1] = "A";
                    } else if (nextCh === "G") {
                        A0_G0_result[pos + 1] = "\uFFFF";
                        A0_G1_result[pos + 1] = "G";
                        A1_G0_result[pos + 1] = "\uFFFF";
                        A1_G1_result[pos + 1] = "G";
                    } else {
                        A0_G0_result[pos + 1] = nextCh;
                        A0_G1_result[pos + 1] = nextCh;
                        A1_G0_result[pos + 1] = nextCh;
                        A1_G1_result[pos + 1] = nextCh;
                    }
                    pos++;
                }
            }
        }
        return {
            A0_G0: A0_G0_result.join(""),
            A0_G1: A0_G1_result.join(""),
            A1_G0: A1_G0_result.join(""),
            A1_G1: A1_G1_result.join("")
        };
    }
    resolveAnchors(allowA, allowG) {
        if (!this.hasAnchor || !this._anchorCache || typeof this.source !== "string") return this.source;
        if (allowA) {
            if (allowG) return this._anchorCache.A1_G1;
            else return this._anchorCache.A1_G0;
        } else {
            if (allowG) return this._anchorCache.A0_G1;
            else return this._anchorCache.A0_G0;
        }
    }
};
var $3ce28d198d785bf9$var$RegExpSourceList = class {
    _items;
    _hasAnchors;
    _cached;
    _anchorCache;
    constructor(){
        this._items = [];
        this._hasAnchors = false;
        this._cached = null;
        this._anchorCache = {
            A0_G0: null,
            A0_G1: null,
            A1_G0: null,
            A1_G1: null
        };
    }
    dispose() {
        this._disposeCaches();
    }
    _disposeCaches() {
        if (this._cached) {
            this._cached.dispose();
            this._cached = null;
        }
        if (this._anchorCache.A0_G0) {
            this._anchorCache.A0_G0.dispose();
            this._anchorCache.A0_G0 = null;
        }
        if (this._anchorCache.A0_G1) {
            this._anchorCache.A0_G1.dispose();
            this._anchorCache.A0_G1 = null;
        }
        if (this._anchorCache.A1_G0) {
            this._anchorCache.A1_G0.dispose();
            this._anchorCache.A1_G0 = null;
        }
        if (this._anchorCache.A1_G1) {
            this._anchorCache.A1_G1.dispose();
            this._anchorCache.A1_G1 = null;
        }
    }
    push(item) {
        this._items.push(item);
        this._hasAnchors = this._hasAnchors || item.hasAnchor;
    }
    unshift(item) {
        this._items.unshift(item);
        this._hasAnchors = this._hasAnchors || item.hasAnchor;
    }
    length() {
        return this._items.length;
    }
    setSource(index, newSource) {
        if (this._items[index].source !== newSource) {
            this._disposeCaches();
            this._items[index].setSource(newSource);
        }
    }
    compile(onigLib) {
        if (!this._cached) {
            let regExps = this._items.map((e)=>e.source);
            this._cached = new $3ce28d198d785bf9$var$CompiledRule(onigLib, regExps, this._items.map((e)=>e.ruleId));
        }
        return this._cached;
    }
    compileAG(onigLib, allowA, allowG) {
        if (!this._hasAnchors) return this.compile(onigLib);
        else {
            if (allowA) {
                if (allowG) {
                    if (!this._anchorCache.A1_G1) this._anchorCache.A1_G1 = this._resolveAnchors(onigLib, allowA, allowG);
                    return this._anchorCache.A1_G1;
                } else {
                    if (!this._anchorCache.A1_G0) this._anchorCache.A1_G0 = this._resolveAnchors(onigLib, allowA, allowG);
                    return this._anchorCache.A1_G0;
                }
            } else if (allowG) {
                if (!this._anchorCache.A0_G1) this._anchorCache.A0_G1 = this._resolveAnchors(onigLib, allowA, allowG);
                return this._anchorCache.A0_G1;
            } else {
                if (!this._anchorCache.A0_G0) this._anchorCache.A0_G0 = this._resolveAnchors(onigLib, allowA, allowG);
                return this._anchorCache.A0_G0;
            }
        }
    }
    _resolveAnchors(onigLib, allowA, allowG) {
        let regExps = this._items.map((e)=>e.resolveAnchors(allowA, allowG));
        return new $3ce28d198d785bf9$var$CompiledRule(onigLib, regExps, this._items.map((e)=>e.ruleId));
    }
};
var $3ce28d198d785bf9$var$CompiledRule = class {
    constructor(onigLib, regExps, rules){
        this.regExps = regExps;
        this.rules = rules;
        this.scanner = onigLib.createOnigScanner(regExps);
    }
    scanner;
    dispose() {
        if (typeof this.scanner.dispose === "function") this.scanner.dispose();
    }
    toString() {
        const r = [];
        for(let i = 0, len = this.rules.length; i < len; i++)r.push("   - " + this.rules[i] + ": " + this.regExps[i]);
        return r.join("\n");
    }
    findNextMatchSync(string, startPosition, options) {
        const result = this.scanner.findNextMatchSync(string, startPosition, options);
        if (!result) return null;
        return {
            ruleId: this.rules[result.index],
            captureIndices: result.captureIndices
        };
    }
};
// src/grammar/basicScopesAttributeProvider.ts
var $3ce28d198d785bf9$var$BasicScopeAttributes = class {
    constructor(languageId, tokenType){
        this.languageId = languageId;
        this.tokenType = tokenType;
    }
};
var $3ce28d198d785bf9$var$BasicScopeAttributesProvider = class _BasicScopeAttributesProvider {
    _defaultAttributes;
    _embeddedLanguagesMatcher;
    constructor(initialLanguageId, embeddedLanguages){
        this._defaultAttributes = new $3ce28d198d785bf9$var$BasicScopeAttributes(initialLanguageId, 8 /* NotSet */ );
        this._embeddedLanguagesMatcher = new $3ce28d198d785bf9$var$ScopeMatcher(Object.entries(embeddedLanguages || {}));
    }
    getDefaultAttributes() {
        return this._defaultAttributes;
    }
    getBasicScopeAttributes(scopeName) {
        if (scopeName === null) return _BasicScopeAttributesProvider._NULL_SCOPE_METADATA;
        return this._getBasicScopeAttributes.get(scopeName);
    }
    static _NULL_SCOPE_METADATA = new $3ce28d198d785bf9$var$BasicScopeAttributes(0, 0);
    _getBasicScopeAttributes = new $3ce28d198d785bf9$var$CachedFn((scopeName)=>{
        const languageId = this._scopeToLanguage(scopeName);
        const standardTokenType = this._toStandardTokenType(scopeName);
        return new $3ce28d198d785bf9$var$BasicScopeAttributes(languageId, standardTokenType);
    });
    /**
   * Given a produced TM scope, return the language that token describes or null if unknown.
   * e.g. source.html => html, source.css.embedded.html => css, punctuation.definition.tag.html => null
   */ _scopeToLanguage(scope) {
        return this._embeddedLanguagesMatcher.match(scope) || 0;
    }
    _toStandardTokenType(scopeName) {
        const m = scopeName.match(_BasicScopeAttributesProvider.STANDARD_TOKEN_TYPE_REGEXP);
        if (!m) return 8 /* NotSet */ ;
        switch(m[1]){
            case "comment":
                return 1 /* Comment */ ;
            case "string":
                return 2 /* String */ ;
            case "regex":
                return 3 /* RegEx */ ;
            case "meta.embedded":
                return 0 /* Other */ ;
        }
        throw new Error("Unexpected match for standard token type!");
    }
    static STANDARD_TOKEN_TYPE_REGEXP = /\b(comment|string|regex|meta\.embedded)\b/;
};
var $3ce28d198d785bf9$var$ScopeMatcher = class {
    values;
    scopesRegExp;
    constructor(values){
        if (values.length === 0) {
            this.values = null;
            this.scopesRegExp = null;
        } else {
            this.values = new Map(values);
            const escapedScopes = values.map(([scopeName, value])=>$3ce28d198d785bf9$var$escapeRegExpCharacters(scopeName));
            escapedScopes.sort();
            escapedScopes.reverse();
            this.scopesRegExp = new RegExp(`^((${escapedScopes.join(")|(")}))($|\\.)`, "");
        }
    }
    match(scope) {
        if (!this.scopesRegExp) return void 0;
        const m = scope.match(this.scopesRegExp);
        if (!m) return void 0;
        return this.values.get(m[1]);
    }
};
// src/debug.ts
var $3ce28d198d785bf9$var$DebugFlags = {
    InDebugMode: false
};
var $3ce28d198d785bf9$var$UseOnigurumaFindOptions = false;
// src/grammar/tokenizeString.ts
var $3ce28d198d785bf9$var$TokenizeStringResult = class {
    constructor(stack, stoppedEarly){
        this.stack = stack;
        this.stoppedEarly = stoppedEarly;
    }
};
function $3ce28d198d785bf9$var$_tokenizeString(grammar, lineText, isFirstLine, linePos, stack, lineTokens, checkWhileConditions, timeLimit) {
    const lineLength = lineText.content.length;
    let STOP = false;
    let anchorPosition = -1;
    if (checkWhileConditions) {
        const whileCheckResult = $3ce28d198d785bf9$var$_checkWhileConditions(grammar, lineText, isFirstLine, linePos, stack, lineTokens);
        stack = whileCheckResult.stack;
        linePos = whileCheckResult.linePos;
        isFirstLine = whileCheckResult.isFirstLine;
        anchorPosition = whileCheckResult.anchorPosition;
    }
    const startTime = Date.now();
    while(!STOP){
        if (timeLimit !== 0) {
            const elapsedTime = Date.now() - startTime;
            if (elapsedTime > timeLimit) return new $3ce28d198d785bf9$var$TokenizeStringResult(stack, true);
        }
        scanNext();
    }
    return new $3ce28d198d785bf9$var$TokenizeStringResult(stack, false);
    function scanNext() {
        const r = $3ce28d198d785bf9$var$matchRuleOrInjections(grammar, lineText, isFirstLine, linePos, stack, anchorPosition);
        if (!r) {
            lineTokens.produce(stack, lineLength);
            STOP = true;
            return;
        }
        const captureIndices = r.captureIndices;
        const matchedRuleId = r.matchedRuleId;
        const hasAdvanced = captureIndices && captureIndices.length > 0 ? captureIndices[0].end > linePos : false;
        if (matchedRuleId === $3ce28d198d785bf9$var$endRuleId) {
            const poppedRule = stack.getRule(grammar);
            lineTokens.produce(stack, captureIndices[0].start);
            stack = stack.withContentNameScopesList(stack.nameScopesList);
            $3ce28d198d785bf9$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, poppedRule.endCaptures, captureIndices);
            lineTokens.produce(stack, captureIndices[0].end);
            const popped = stack;
            stack = stack.parent;
            anchorPosition = popped.getAnchorPos();
            if (!hasAdvanced && popped.getEnterPos() === linePos) {
                stack = popped;
                lineTokens.produce(stack, lineLength);
                STOP = true;
                return;
            }
        } else {
            const _rule = grammar.getRule(matchedRuleId);
            lineTokens.produce(stack, captureIndices[0].start);
            const beforePush = stack;
            const scopeName = _rule.getName(lineText.content, captureIndices);
            const nameScopesList = stack.contentNameScopesList.pushAttributed(scopeName, grammar);
            stack = stack.push(matchedRuleId, linePos, anchorPosition, captureIndices[0].end === lineLength, null, nameScopesList, nameScopesList);
            if (_rule instanceof $3ce28d198d785bf9$var$BeginEndRule) {
                const pushedRule = _rule;
                $3ce28d198d785bf9$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, pushedRule.beginCaptures, captureIndices);
                lineTokens.produce(stack, captureIndices[0].end);
                anchorPosition = captureIndices[0].end;
                const contentName = pushedRule.getContentName(lineText.content, captureIndices);
                const contentNameScopesList = nameScopesList.pushAttributed(contentName, grammar);
                stack = stack.withContentNameScopesList(contentNameScopesList);
                if (pushedRule.endHasBackReferences) stack = stack.withEndRule(pushedRule.getEndWithResolvedBackReferences(lineText.content, captureIndices));
                if (!hasAdvanced && beforePush.hasSameRuleAs(stack)) {
                    stack = stack.pop();
                    lineTokens.produce(stack, lineLength);
                    STOP = true;
                    return;
                }
            } else if (_rule instanceof $3ce28d198d785bf9$var$BeginWhileRule) {
                const pushedRule = _rule;
                $3ce28d198d785bf9$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, pushedRule.beginCaptures, captureIndices);
                lineTokens.produce(stack, captureIndices[0].end);
                anchorPosition = captureIndices[0].end;
                const contentName = pushedRule.getContentName(lineText.content, captureIndices);
                const contentNameScopesList = nameScopesList.pushAttributed(contentName, grammar);
                stack = stack.withContentNameScopesList(contentNameScopesList);
                if (pushedRule.whileHasBackReferences) stack = stack.withEndRule(pushedRule.getWhileWithResolvedBackReferences(lineText.content, captureIndices));
                if (!hasAdvanced && beforePush.hasSameRuleAs(stack)) {
                    stack = stack.pop();
                    lineTokens.produce(stack, lineLength);
                    STOP = true;
                    return;
                }
            } else {
                const matchingRule = _rule;
                $3ce28d198d785bf9$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, matchingRule.captures, captureIndices);
                lineTokens.produce(stack, captureIndices[0].end);
                stack = stack.pop();
                if (!hasAdvanced) {
                    stack = stack.safePop();
                    lineTokens.produce(stack, lineLength);
                    STOP = true;
                    return;
                }
            }
        }
        if (captureIndices[0].end > linePos) {
            linePos = captureIndices[0].end;
            isFirstLine = false;
        }
    }
}
function $3ce28d198d785bf9$var$_checkWhileConditions(grammar, lineText, isFirstLine, linePos, stack, lineTokens) {
    let anchorPosition = stack.beginRuleCapturedEOL ? 0 : -1;
    const whileRules = [];
    for(let node = stack; node; node = node.pop()){
        const nodeRule = node.getRule(grammar);
        if (nodeRule instanceof $3ce28d198d785bf9$var$BeginWhileRule) whileRules.push({
            rule: nodeRule,
            stack: node
        });
    }
    for(let whileRule = whileRules.pop(); whileRule; whileRule = whileRules.pop()){
        const { ruleScanner: ruleScanner, findOptions: findOptions } = $3ce28d198d785bf9$var$prepareRuleWhileSearch(whileRule.rule, grammar, whileRule.stack.endRule, isFirstLine, linePos === anchorPosition);
        const r = ruleScanner.findNextMatchSync(lineText, linePos, findOptions);
        if (r) {
            const matchedRuleId = r.ruleId;
            if (matchedRuleId !== $3ce28d198d785bf9$var$whileRuleId) {
                stack = whileRule.stack.pop();
                break;
            }
            if (r.captureIndices && r.captureIndices.length) {
                lineTokens.produce(whileRule.stack, r.captureIndices[0].start);
                $3ce28d198d785bf9$var$handleCaptures(grammar, lineText, isFirstLine, whileRule.stack, lineTokens, whileRule.rule.whileCaptures, r.captureIndices);
                lineTokens.produce(whileRule.stack, r.captureIndices[0].end);
                anchorPosition = r.captureIndices[0].end;
                if (r.captureIndices[0].end > linePos) {
                    linePos = r.captureIndices[0].end;
                    isFirstLine = false;
                }
            }
        } else {
            stack = whileRule.stack.pop();
            break;
        }
    }
    return {
        stack: stack,
        linePos: linePos,
        anchorPosition: anchorPosition,
        isFirstLine: isFirstLine
    };
}
function $3ce28d198d785bf9$var$matchRuleOrInjections(grammar, lineText, isFirstLine, linePos, stack, anchorPosition) {
    const matchResult = $3ce28d198d785bf9$var$matchRule(grammar, lineText, isFirstLine, linePos, stack, anchorPosition);
    const injections = grammar.getInjections();
    if (injections.length === 0) return matchResult;
    const injectionResult = $3ce28d198d785bf9$var$matchInjections(injections, grammar, lineText, isFirstLine, linePos, stack, anchorPosition);
    if (!injectionResult) return matchResult;
    if (!matchResult) return injectionResult;
    const matchResultScore = matchResult.captureIndices[0].start;
    const injectionResultScore = injectionResult.captureIndices[0].start;
    if (injectionResultScore < matchResultScore || injectionResult.priorityMatch && injectionResultScore === matchResultScore) return injectionResult;
    return matchResult;
}
function $3ce28d198d785bf9$var$matchRule(grammar, lineText, isFirstLine, linePos, stack, anchorPosition) {
    const rule = stack.getRule(grammar);
    const { ruleScanner: ruleScanner, findOptions: findOptions } = $3ce28d198d785bf9$var$prepareRuleSearch(rule, grammar, stack.endRule, isFirstLine, linePos === anchorPosition);
    const r = ruleScanner.findNextMatchSync(lineText, linePos, findOptions);
    if (r) return {
        captureIndices: r.captureIndices,
        matchedRuleId: r.ruleId
    };
    return null;
}
function $3ce28d198d785bf9$var$matchInjections(injections, grammar, lineText, isFirstLine, linePos, stack, anchorPosition) {
    let bestMatchRating = Number.MAX_VALUE;
    let bestMatchCaptureIndices = null;
    let bestMatchRuleId;
    let bestMatchResultPriority = 0;
    const scopes = stack.contentNameScopesList.getScopeNames();
    for(let i = 0, len = injections.length; i < len; i++){
        const injection = injections[i];
        if (!injection.matcher(scopes)) continue;
        const rule = grammar.getRule(injection.ruleId);
        const { ruleScanner: ruleScanner, findOptions: findOptions } = $3ce28d198d785bf9$var$prepareRuleSearch(rule, grammar, null, isFirstLine, linePos === anchorPosition);
        const matchResult = ruleScanner.findNextMatchSync(lineText, linePos, findOptions);
        if (!matchResult) continue;
        const matchRating = matchResult.captureIndices[0].start;
        if (matchRating >= bestMatchRating) continue;
        bestMatchRating = matchRating;
        bestMatchCaptureIndices = matchResult.captureIndices;
        bestMatchRuleId = matchResult.ruleId;
        bestMatchResultPriority = injection.priority;
        if (bestMatchRating === linePos) break;
    }
    if (bestMatchCaptureIndices) return {
        priorityMatch: bestMatchResultPriority === -1,
        captureIndices: bestMatchCaptureIndices,
        matchedRuleId: bestMatchRuleId
    };
    return null;
}
function $3ce28d198d785bf9$var$prepareRuleSearch(rule, grammar, endRegexSource, allowA, allowG) {
    if ($3ce28d198d785bf9$var$UseOnigurumaFindOptions) {
        const ruleScanner2 = rule.compile(grammar, endRegexSource);
        const findOptions = $3ce28d198d785bf9$var$getFindOptions(allowA, allowG);
        return {
            ruleScanner: ruleScanner2,
            findOptions: findOptions
        };
    }
    const ruleScanner = rule.compileAG(grammar, endRegexSource, allowA, allowG);
    return {
        ruleScanner: ruleScanner,
        findOptions: 0 /* None */ 
    };
}
function $3ce28d198d785bf9$var$prepareRuleWhileSearch(rule, grammar, endRegexSource, allowA, allowG) {
    if ($3ce28d198d785bf9$var$UseOnigurumaFindOptions) {
        const ruleScanner2 = rule.compileWhile(grammar, endRegexSource);
        const findOptions = $3ce28d198d785bf9$var$getFindOptions(allowA, allowG);
        return {
            ruleScanner: ruleScanner2,
            findOptions: findOptions
        };
    }
    const ruleScanner = rule.compileWhileAG(grammar, endRegexSource, allowA, allowG);
    return {
        ruleScanner: ruleScanner,
        findOptions: 0 /* None */ 
    };
}
function $3ce28d198d785bf9$var$getFindOptions(allowA, allowG) {
    let options = 0 /* None */ ;
    if (!allowA) options |= 1 /* NotBeginString */ ;
    if (!allowG) options |= 4 /* NotBeginPosition */ ;
    return options;
}
function $3ce28d198d785bf9$var$handleCaptures(grammar, lineText, isFirstLine, stack, lineTokens, captures, captureIndices) {
    if (captures.length === 0) return;
    const lineTextContent = lineText.content;
    const len = Math.min(captures.length, captureIndices.length);
    const localStack = [];
    const maxEnd = captureIndices[0].end;
    for(let i = 0; i < len; i++){
        const captureRule = captures[i];
        if (captureRule === null) continue;
        const captureIndex = captureIndices[i];
        if (captureIndex.length === 0) continue;
        if (captureIndex.start > maxEnd) break;
        while(localStack.length > 0 && localStack[localStack.length - 1].endPos <= captureIndex.start){
            lineTokens.produceFromScopes(localStack[localStack.length - 1].scopes, localStack[localStack.length - 1].endPos);
            localStack.pop();
        }
        if (localStack.length > 0) lineTokens.produceFromScopes(localStack[localStack.length - 1].scopes, captureIndex.start);
        else lineTokens.produce(stack, captureIndex.start);
        if (captureRule.retokenizeCapturedWithRuleId) {
            const scopeName = captureRule.getName(lineTextContent, captureIndices);
            const nameScopesList = stack.contentNameScopesList.pushAttributed(scopeName, grammar);
            const contentName = captureRule.getContentName(lineTextContent, captureIndices);
            const contentNameScopesList = nameScopesList.pushAttributed(contentName, grammar);
            const stackClone = stack.push(captureRule.retokenizeCapturedWithRuleId, captureIndex.start, -1, false, null, nameScopesList, contentNameScopesList);
            const onigSubStr = grammar.createOnigString(lineTextContent.substring(0, captureIndex.end));
            $3ce28d198d785bf9$var$_tokenizeString(grammar, onigSubStr, isFirstLine && captureIndex.start === 0, captureIndex.start, stackClone, lineTokens, false, /* no time limit */ 0);
            $3ce28d198d785bf9$export$2b6cad23a17023a7(onigSubStr);
            continue;
        }
        const captureRuleScopeName = captureRule.getName(lineTextContent, captureIndices);
        if (captureRuleScopeName !== null) {
            const base = localStack.length > 0 ? localStack[localStack.length - 1].scopes : stack.contentNameScopesList;
            const captureRuleScopesList = base.pushAttributed(captureRuleScopeName, grammar);
            localStack.push(new $3ce28d198d785bf9$var$LocalStackElement(captureRuleScopesList, captureIndex.end));
        }
    }
    while(localStack.length > 0){
        lineTokens.produceFromScopes(localStack[localStack.length - 1].scopes, localStack[localStack.length - 1].endPos);
        localStack.pop();
    }
}
var $3ce28d198d785bf9$var$LocalStackElement = class {
    scopes;
    endPos;
    constructor(scopes, endPos){
        this.scopes = scopes;
        this.endPos = endPos;
    }
};
// src/grammar/grammar.ts
function $3ce28d198d785bf9$var$createGrammar(scopeName, grammar, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors, grammarRepository, onigLib) {
    return new $3ce28d198d785bf9$var$Grammar(scopeName, grammar, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors, grammarRepository, onigLib);
}
function $3ce28d198d785bf9$var$collectInjections(result, selector, rule, ruleFactoryHelper, grammar) {
    const matchers = $3ce28d198d785bf9$var$createMatchers(selector, $3ce28d198d785bf9$var$nameMatcher);
    const ruleId = $3ce28d198d785bf9$var$RuleFactory.getCompiledRuleId(rule, ruleFactoryHelper, grammar.repository);
    for (const matcher of matchers)result.push({
        debugSelector: selector,
        matcher: matcher.matcher,
        ruleId: ruleId,
        grammar: grammar,
        priority: matcher.priority
    });
}
function $3ce28d198d785bf9$var$nameMatcher(identifers, scopes) {
    if (scopes.length < identifers.length) return false;
    let lastIndex = 0;
    return identifers.every((identifier)=>{
        for(let i = lastIndex; i < scopes.length; i++)if ($3ce28d198d785bf9$var$scopesAreMatching(scopes[i], identifier)) {
            lastIndex = i + 1;
            return true;
        }
        return false;
    });
}
function $3ce28d198d785bf9$var$scopesAreMatching(thisScopeName, scopeName) {
    if (!thisScopeName) return false;
    if (thisScopeName === scopeName) return true;
    const len = scopeName.length;
    return thisScopeName.length > len && thisScopeName.substr(0, len) === scopeName && thisScopeName[len] === ".";
}
var $3ce28d198d785bf9$var$Grammar = class {
    constructor(_rootScopeName, grammar, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors, grammarRepository, _onigLib){
        this._rootScopeName = _rootScopeName;
        this.balancedBracketSelectors = balancedBracketSelectors;
        this._onigLib = _onigLib;
        this._basicScopeAttributesProvider = new $3ce28d198d785bf9$var$BasicScopeAttributesProvider(initialLanguage, embeddedLanguages);
        this._rootId = -1;
        this._lastRuleId = 0;
        this._ruleId2desc = [
            null
        ];
        this._includedGrammars = {};
        this._grammarRepository = grammarRepository;
        this._grammar = $3ce28d198d785bf9$var$initGrammar(grammar, null);
        this._injections = null;
        this._tokenTypeMatchers = [];
        if (tokenTypes) for (const selector of Object.keys(tokenTypes)){
            const matchers = $3ce28d198d785bf9$var$createMatchers(selector, $3ce28d198d785bf9$var$nameMatcher);
            for (const matcher of matchers)this._tokenTypeMatchers.push({
                matcher: matcher.matcher,
                type: tokenTypes[selector]
            });
        }
    }
    _rootId;
    _lastRuleId;
    _ruleId2desc;
    _includedGrammars;
    _grammarRepository;
    _grammar;
    _injections;
    _basicScopeAttributesProvider;
    _tokenTypeMatchers;
    get themeProvider() {
        return this._grammarRepository;
    }
    dispose() {
        for (const rule of this._ruleId2desc)if (rule) rule.dispose();
    }
    createOnigScanner(sources) {
        return this._onigLib.createOnigScanner(sources);
    }
    createOnigString(sources) {
        return this._onigLib.createOnigString(sources);
    }
    getMetadataForScope(scope) {
        return this._basicScopeAttributesProvider.getBasicScopeAttributes(scope);
    }
    _collectInjections() {
        const grammarRepository = {
            lookup: (scopeName2)=>{
                if (scopeName2 === this._rootScopeName) return this._grammar;
                return this.getExternalGrammar(scopeName2);
            },
            injections: (scopeName2)=>{
                return this._grammarRepository.injections(scopeName2);
            }
        };
        const result = [];
        const scopeName = this._rootScopeName;
        const grammar = grammarRepository.lookup(scopeName);
        if (grammar) {
            const rawInjections = grammar.injections;
            if (rawInjections) for(let expression in rawInjections)$3ce28d198d785bf9$var$collectInjections(result, expression, rawInjections[expression], this, grammar);
            const injectionScopeNames = this._grammarRepository.injections(scopeName);
            if (injectionScopeNames) injectionScopeNames.forEach((injectionScopeName)=>{
                const injectionGrammar = this.getExternalGrammar(injectionScopeName);
                if (injectionGrammar) {
                    const selector = injectionGrammar.injectionSelector;
                    if (selector) $3ce28d198d785bf9$var$collectInjections(result, selector, injectionGrammar, this, injectionGrammar);
                }
            });
        }
        result.sort((i1, i2)=>i1.priority - i2.priority);
        return result;
    }
    getInjections() {
        if (this._injections === null) this._injections = this._collectInjections();
        return this._injections;
    }
    registerRule(factory) {
        const id = ++this._lastRuleId;
        const result = factory($3ce28d198d785bf9$var$ruleIdFromNumber(id));
        this._ruleId2desc[id] = result;
        return result;
    }
    getRule(ruleId) {
        return this._ruleId2desc[$3ce28d198d785bf9$var$ruleIdToNumber(ruleId)];
    }
    getExternalGrammar(scopeName, repository) {
        if (this._includedGrammars[scopeName]) return this._includedGrammars[scopeName];
        else if (this._grammarRepository) {
            const rawIncludedGrammar = this._grammarRepository.lookup(scopeName);
            if (rawIncludedGrammar) {
                this._includedGrammars[scopeName] = $3ce28d198d785bf9$var$initGrammar(rawIncludedGrammar, repository && repository.$base);
                return this._includedGrammars[scopeName];
            }
        }
        return void 0;
    }
    tokenizeLine(lineText, prevState, timeLimit = 0) {
        const r = this._tokenize(lineText, prevState, false, timeLimit);
        return {
            tokens: r.lineTokens.getResult(r.ruleStack, r.lineLength),
            ruleStack: r.ruleStack,
            stoppedEarly: r.stoppedEarly
        };
    }
    tokenizeLine2(lineText, prevState, timeLimit = 0) {
        const r = this._tokenize(lineText, prevState, true, timeLimit);
        return {
            tokens: r.lineTokens.getBinaryResult(r.ruleStack, r.lineLength),
            ruleStack: r.ruleStack,
            stoppedEarly: r.stoppedEarly
        };
    }
    _tokenize(lineText, prevState, emitBinaryTokens, timeLimit) {
        if (this._rootId === -1) {
            this._rootId = $3ce28d198d785bf9$var$RuleFactory.getCompiledRuleId(this._grammar.repository.$self, this, this._grammar.repository);
            this.getInjections();
        }
        let isFirstLine;
        if (!prevState || prevState === $3ce28d198d785bf9$var$StateStackImpl.NULL) {
            isFirstLine = true;
            const rawDefaultMetadata = this._basicScopeAttributesProvider.getDefaultAttributes();
            const defaultStyle = this.themeProvider.getDefaults();
            const defaultMetadata = $3ce28d198d785bf9$export$90e5db14803ea047.set(0, rawDefaultMetadata.languageId, rawDefaultMetadata.tokenType, null, defaultStyle.fontStyle, defaultStyle.foregroundId, defaultStyle.backgroundId);
            const rootScopeName = this.getRule(this._rootId).getName(null, null);
            let scopeList;
            if (rootScopeName) scopeList = $3ce28d198d785bf9$var$AttributedScopeStack.createRootAndLookUpScopeName(rootScopeName, defaultMetadata, this);
            else scopeList = $3ce28d198d785bf9$var$AttributedScopeStack.createRoot("unknown", defaultMetadata);
            prevState = new $3ce28d198d785bf9$var$StateStackImpl(null, this._rootId, -1, -1, false, null, scopeList, scopeList);
        } else {
            isFirstLine = false;
            prevState.reset();
        }
        lineText = lineText + "\n";
        const onigLineText = this.createOnigString(lineText);
        const lineLength = onigLineText.content.length;
        const lineTokens = new $3ce28d198d785bf9$var$LineTokens(emitBinaryTokens, lineText, this._tokenTypeMatchers, this.balancedBracketSelectors);
        const r = $3ce28d198d785bf9$var$_tokenizeString(this, onigLineText, isFirstLine, 0, prevState, lineTokens, true, timeLimit);
        $3ce28d198d785bf9$export$2b6cad23a17023a7(onigLineText);
        return {
            lineLength: lineLength,
            lineTokens: lineTokens,
            ruleStack: r.stack,
            stoppedEarly: r.stoppedEarly
        };
    }
};
function $3ce28d198d785bf9$var$initGrammar(grammar, base) {
    grammar = $3ce28d198d785bf9$var$clone(grammar);
    grammar.repository = grammar.repository || {};
    grammar.repository.$self = {
        $vscodeTextmateLocation: grammar.$vscodeTextmateLocation,
        patterns: grammar.patterns,
        name: grammar.scopeName
    };
    grammar.repository.$base = base || grammar.repository.$self;
    return grammar;
}
var $3ce28d198d785bf9$var$AttributedScopeStack = class _AttributedScopeStack {
    /**
   * Invariant:
   * ```
   * if (parent && !scopePath.extends(parent.scopePath)) {
   * 	throw new Error();
   * }
   * ```
   */ constructor(parent, scopePath, tokenAttributes){
        this.parent = parent;
        this.scopePath = scopePath;
        this.tokenAttributes = tokenAttributes;
    }
    static fromExtension(namesScopeList, contentNameScopesList) {
        let current = namesScopeList;
        let scopeNames = namesScopeList?.scopePath ?? null;
        for (const frame of contentNameScopesList){
            scopeNames = $3ce28d198d785bf9$var$ScopeStack.push(scopeNames, frame.scopeNames);
            current = new _AttributedScopeStack(current, scopeNames, frame.encodedTokenAttributes);
        }
        return current;
    }
    static createRoot(scopeName, tokenAttributes) {
        return new _AttributedScopeStack(null, new $3ce28d198d785bf9$var$ScopeStack(null, scopeName), tokenAttributes);
    }
    static createRootAndLookUpScopeName(scopeName, tokenAttributes, grammar) {
        const rawRootMetadata = grammar.getMetadataForScope(scopeName);
        const scopePath = new $3ce28d198d785bf9$var$ScopeStack(null, scopeName);
        const rootStyle = grammar.themeProvider.themeMatch(scopePath);
        const resolvedTokenAttributes = _AttributedScopeStack.mergeAttributes(tokenAttributes, rawRootMetadata, rootStyle);
        return new _AttributedScopeStack(null, scopePath, resolvedTokenAttributes);
    }
    get scopeName() {
        return this.scopePath.scopeName;
    }
    toString() {
        return this.getScopeNames().join(" ");
    }
    equals(other) {
        return _AttributedScopeStack.equals(this, other);
    }
    static equals(a, b) {
        do {
            if (a === b) return true;
            if (!a && !b) return true;
            if (!a || !b) return false;
            if (a.scopeName !== b.scopeName || a.tokenAttributes !== b.tokenAttributes) return false;
            a = a.parent;
            b = b.parent;
        }while (true);
    }
    static mergeAttributes(existingTokenAttributes, basicScopeAttributes, styleAttributes) {
        let fontStyle = -1 /* NotSet */ ;
        let foreground = 0;
        let background = 0;
        if (styleAttributes !== null) {
            fontStyle = styleAttributes.fontStyle;
            foreground = styleAttributes.foregroundId;
            background = styleAttributes.backgroundId;
        }
        return $3ce28d198d785bf9$export$90e5db14803ea047.set(existingTokenAttributes, basicScopeAttributes.languageId, basicScopeAttributes.tokenType, null, fontStyle, foreground, background);
    }
    pushAttributed(scopePath, grammar) {
        if (scopePath === null) return this;
        if (scopePath.indexOf(" ") === -1) return _AttributedScopeStack._pushAttributed(this, scopePath, grammar);
        const scopes = scopePath.split(/ /g);
        let result = this;
        for (const scope of scopes)result = _AttributedScopeStack._pushAttributed(result, scope, grammar);
        return result;
    }
    static _pushAttributed(target, scopeName, grammar) {
        const rawMetadata = grammar.getMetadataForScope(scopeName);
        const newPath = target.scopePath.push(scopeName);
        const scopeThemeMatchResult = grammar.themeProvider.themeMatch(newPath);
        const metadata = _AttributedScopeStack.mergeAttributes(target.tokenAttributes, rawMetadata, scopeThemeMatchResult);
        return new _AttributedScopeStack(target, newPath, metadata);
    }
    getScopeNames() {
        return this.scopePath.getSegments();
    }
    getExtensionIfDefined(base) {
        const result = [];
        let self = this;
        while(self && self !== base){
            result.push({
                encodedTokenAttributes: self.tokenAttributes,
                scopeNames: self.scopePath.getExtensionIfDefined(self.parent?.scopePath ?? null)
            });
            self = self.parent;
        }
        return self === base ? result.reverse() : void 0;
    }
};
var $3ce28d198d785bf9$var$StateStackImpl = class _StateStackImpl {
    /**
   * Invariant:
   * ```
   * if (contentNameScopesList !== nameScopesList && contentNameScopesList?.parent !== nameScopesList) {
   * 	throw new Error();
   * }
   * if (this.parent && !nameScopesList.extends(this.parent.contentNameScopesList)) {
   * 	throw new Error();
   * }
   * ```
   */ constructor(parent, ruleId, enterPos, anchorPos, beginRuleCapturedEOL, endRule, nameScopesList, contentNameScopesList){
        this.parent = parent;
        this.ruleId = ruleId;
        this.beginRuleCapturedEOL = beginRuleCapturedEOL;
        this.endRule = endRule;
        this.nameScopesList = nameScopesList;
        this.contentNameScopesList = contentNameScopesList;
        this.depth = this.parent ? this.parent.depth + 1 : 1;
        this._enterPos = enterPos;
        this._anchorPos = anchorPos;
    }
    _stackElementBrand = void 0;
    // TODO remove me
    static NULL = new _StateStackImpl(null, 0, 0, 0, false, null, null, null);
    /**
   * The position on the current line where this state was pushed.
   * This is relevant only while tokenizing a line, to detect endless loops.
   * Its value is meaningless across lines.
   */ _enterPos;
    /**
   * The captured anchor position when this stack element was pushed.
   * This is relevant only while tokenizing a line, to restore the anchor position when popping.
   * Its value is meaningless across lines.
   */ _anchorPos;
    /**
   * The depth of the stack.
   */ depth;
    equals(other) {
        if (other === null) return false;
        return _StateStackImpl._equals(this, other);
    }
    static _equals(a, b) {
        if (a === b) return true;
        if (!this._structuralEquals(a, b)) return false;
        return $3ce28d198d785bf9$var$AttributedScopeStack.equals(a.contentNameScopesList, b.contentNameScopesList);
    }
    /**
   * A structural equals check. Does not take into account `scopes`.
   */ static _structuralEquals(a, b) {
        do {
            if (a === b) return true;
            if (!a && !b) return true;
            if (!a || !b) return false;
            if (a.depth !== b.depth || a.ruleId !== b.ruleId || a.endRule !== b.endRule) return false;
            a = a.parent;
            b = b.parent;
        }while (true);
    }
    clone() {
        return this;
    }
    static _reset(el) {
        while(el){
            el._enterPos = -1;
            el._anchorPos = -1;
            el = el.parent;
        }
    }
    reset() {
        _StateStackImpl._reset(this);
    }
    pop() {
        return this.parent;
    }
    safePop() {
        if (this.parent) return this.parent;
        return this;
    }
    push(ruleId, enterPos, anchorPos, beginRuleCapturedEOL, endRule, nameScopesList, contentNameScopesList) {
        return new _StateStackImpl(this, ruleId, enterPos, anchorPos, beginRuleCapturedEOL, endRule, nameScopesList, contentNameScopesList);
    }
    getEnterPos() {
        return this._enterPos;
    }
    getAnchorPos() {
        return this._anchorPos;
    }
    getRule(grammar) {
        return grammar.getRule(this.ruleId);
    }
    toString() {
        const r = [];
        this._writeString(r, 0);
        return "[" + r.join(",") + "]";
    }
    _writeString(res, outIndex) {
        if (this.parent) outIndex = this.parent._writeString(res, outIndex);
        res[outIndex++] = `(${this.ruleId}, ${this.nameScopesList?.toString()}, ${this.contentNameScopesList?.toString()})`;
        return outIndex;
    }
    withContentNameScopesList(contentNameScopeStack) {
        if (this.contentNameScopesList === contentNameScopeStack) return this;
        return this.parent.push(this.ruleId, this._enterPos, this._anchorPos, this.beginRuleCapturedEOL, this.endRule, this.nameScopesList, contentNameScopeStack);
    }
    withEndRule(endRule) {
        if (this.endRule === endRule) return this;
        return new _StateStackImpl(this.parent, this.ruleId, this._enterPos, this._anchorPos, this.beginRuleCapturedEOL, endRule, this.nameScopesList, this.contentNameScopesList);
    }
    // Used to warn of endless loops
    hasSameRuleAs(other) {
        let el = this;
        while(el && el._enterPos === other._enterPos){
            if (el.ruleId === other.ruleId) return true;
            el = el.parent;
        }
        return false;
    }
    toStateStackFrame() {
        return {
            ruleId: $3ce28d198d785bf9$var$ruleIdToNumber(this.ruleId),
            beginRuleCapturedEOL: this.beginRuleCapturedEOL,
            endRule: this.endRule,
            nameScopesList: this.nameScopesList?.getExtensionIfDefined(this.parent?.nameScopesList ?? null) ?? [],
            contentNameScopesList: this.contentNameScopesList?.getExtensionIfDefined(this.nameScopesList) ?? []
        };
    }
    static pushFrame(self, frame) {
        const namesScopeList = $3ce28d198d785bf9$var$AttributedScopeStack.fromExtension(self?.nameScopesList ?? null, frame.nameScopesList);
        return new _StateStackImpl(self, $3ce28d198d785bf9$var$ruleIdFromNumber(frame.ruleId), frame.enterPos ?? -1, frame.anchorPos ?? -1, frame.beginRuleCapturedEOL, frame.endRule, namesScopeList, $3ce28d198d785bf9$var$AttributedScopeStack.fromExtension(namesScopeList, frame.contentNameScopesList));
    }
};
var $3ce28d198d785bf9$var$BalancedBracketSelectors = class {
    balancedBracketScopes;
    unbalancedBracketScopes;
    allowAny = false;
    constructor(balancedBracketScopes, unbalancedBracketScopes){
        this.balancedBracketScopes = balancedBracketScopes.flatMap((selector)=>{
            if (selector === "*") {
                this.allowAny = true;
                return [];
            }
            return $3ce28d198d785bf9$var$createMatchers(selector, $3ce28d198d785bf9$var$nameMatcher).map((m)=>m.matcher);
        });
        this.unbalancedBracketScopes = unbalancedBracketScopes.flatMap((selector)=>$3ce28d198d785bf9$var$createMatchers(selector, $3ce28d198d785bf9$var$nameMatcher).map((m)=>m.matcher));
    }
    get matchesAlways() {
        return this.allowAny && this.unbalancedBracketScopes.length === 0;
    }
    get matchesNever() {
        return this.balancedBracketScopes.length === 0 && !this.allowAny;
    }
    match(scopes) {
        for (const excluder of this.unbalancedBracketScopes){
            if (excluder(scopes)) return false;
        }
        for (const includer of this.balancedBracketScopes){
            if (includer(scopes)) return true;
        }
        return this.allowAny;
    }
};
var $3ce28d198d785bf9$var$LineTokens = class {
    constructor(emitBinaryTokens, lineText, tokenTypeOverrides, balancedBracketSelectors){
        this.balancedBracketSelectors = balancedBracketSelectors;
        this._emitBinaryTokens = emitBinaryTokens;
        this._tokenTypeOverrides = tokenTypeOverrides;
        this._lineText = null;
        this._tokens = [];
        this._binaryTokens = [];
        this._lastTokenEndIndex = 0;
    }
    _emitBinaryTokens;
    /**
   * defined only if `false`.
   */ _lineText;
    /**
   * used only if `_emitBinaryTokens` is false.
   */ _tokens;
    /**
   * used only if `_emitBinaryTokens` is true.
   */ _binaryTokens;
    _lastTokenEndIndex;
    _tokenTypeOverrides;
    produce(stack, endIndex) {
        this.produceFromScopes(stack.contentNameScopesList, endIndex);
    }
    produceFromScopes(scopesList, endIndex) {
        if (this._lastTokenEndIndex >= endIndex) return;
        if (this._emitBinaryTokens) {
            let metadata = scopesList?.tokenAttributes ?? 0;
            let containsBalancedBrackets = false;
            if (this.balancedBracketSelectors?.matchesAlways) containsBalancedBrackets = true;
            if (this._tokenTypeOverrides.length > 0 || this.balancedBracketSelectors && !this.balancedBracketSelectors.matchesAlways && !this.balancedBracketSelectors.matchesNever) {
                const scopes2 = scopesList?.getScopeNames() ?? [];
                for (const tokenType of this._tokenTypeOverrides)if (tokenType.matcher(scopes2)) metadata = $3ce28d198d785bf9$export$90e5db14803ea047.set(metadata, 0, $3ce28d198d785bf9$var$toOptionalTokenType(tokenType.type), null, -1 /* NotSet */ , 0, 0);
                if (this.balancedBracketSelectors) containsBalancedBrackets = this.balancedBracketSelectors.match(scopes2);
            }
            if (containsBalancedBrackets) metadata = $3ce28d198d785bf9$export$90e5db14803ea047.set(metadata, 0, 8 /* NotSet */ , containsBalancedBrackets, -1 /* NotSet */ , 0, 0);
            if (this._binaryTokens.length > 0 && this._binaryTokens[this._binaryTokens.length - 1] === metadata) {
                this._lastTokenEndIndex = endIndex;
                return;
            }
            this._binaryTokens.push(this._lastTokenEndIndex);
            this._binaryTokens.push(metadata);
            this._lastTokenEndIndex = endIndex;
            return;
        }
        const scopes = scopesList?.getScopeNames() ?? [];
        this._tokens.push({
            startIndex: this._lastTokenEndIndex,
            endIndex: endIndex,
            scopes: // value: lineText.substring(lastTokenEndIndex, endIndex),
            scopes
        });
        this._lastTokenEndIndex = endIndex;
    }
    getResult(stack, lineLength) {
        if (this._tokens.length > 0 && this._tokens[this._tokens.length - 1].startIndex === lineLength - 1) this._tokens.pop();
        if (this._tokens.length === 0) {
            this._lastTokenEndIndex = -1;
            this.produce(stack, lineLength);
            this._tokens[this._tokens.length - 1].startIndex = 0;
        }
        return this._tokens;
    }
    getBinaryResult(stack, lineLength) {
        if (this._binaryTokens.length > 0 && this._binaryTokens[this._binaryTokens.length - 2] === lineLength - 1) {
            this._binaryTokens.pop();
            this._binaryTokens.pop();
        }
        if (this._binaryTokens.length === 0) {
            this._lastTokenEndIndex = -1;
            this.produce(stack, lineLength);
            this._binaryTokens[this._binaryTokens.length - 2] = 0;
        }
        const result = new Uint32Array(this._binaryTokens.length);
        for(let i = 0, len = this._binaryTokens.length; i < len; i++)result[i] = this._binaryTokens[i];
        return result;
    }
};
// src/registry.ts
var $3ce28d198d785bf9$var$SyncRegistry = class {
    constructor(theme, _onigLib){
        this._onigLib = _onigLib;
        this._theme = theme;
    }
    _grammars = /* @__PURE__ */ new Map();
    _rawGrammars = /* @__PURE__ */ new Map();
    _injectionGrammars = /* @__PURE__ */ new Map();
    _theme;
    dispose() {
        for (const grammar of this._grammars.values())grammar.dispose();
    }
    setTheme(theme) {
        this._theme = theme;
    }
    getColorMap() {
        return this._theme.getColorMap();
    }
    /**
   * Add `grammar` to registry and return a list of referenced scope names
   */ addGrammar(grammar, injectionScopeNames) {
        this._rawGrammars.set(grammar.scopeName, grammar);
        if (injectionScopeNames) this._injectionGrammars.set(grammar.scopeName, injectionScopeNames);
    }
    /**
   * Lookup a raw grammar.
   */ lookup(scopeName) {
        return this._rawGrammars.get(scopeName);
    }
    /**
   * Returns the injections for the given grammar
   */ injections(targetScope) {
        return this._injectionGrammars.get(targetScope);
    }
    /**
   * Get the default theme settings
   */ getDefaults() {
        return this._theme.getDefaults();
    }
    /**
   * Match a scope in the theme.
   */ themeMatch(scopePath) {
        return this._theme.match(scopePath);
    }
    /**
   * Lookup a grammar.
   */ grammarForScopeName(scopeName, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors) {
        if (!this._grammars.has(scopeName)) {
            let rawGrammar = this._rawGrammars.get(scopeName);
            if (!rawGrammar) return null;
            this._grammars.set(scopeName, $3ce28d198d785bf9$var$createGrammar(scopeName, rawGrammar, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors, this, this._onigLib));
        }
        return this._grammars.get(scopeName);
    }
};
// src/index.ts
var $3ce28d198d785bf9$export$4d9facee29974f3 = class {
    _options;
    _syncRegistry;
    _ensureGrammarCache;
    constructor(options){
        this._options = options;
        this._syncRegistry = new $3ce28d198d785bf9$var$SyncRegistry($3ce28d198d785bf9$export$14faa19a0f3bbeb2.createFromRawTheme(options.theme, options.colorMap), options.onigLib);
        this._ensureGrammarCache = /* @__PURE__ */ new Map();
    }
    dispose() {
        this._syncRegistry.dispose();
    }
    /**
   * Change the theme. Once called, no previous `ruleStack` should be used anymore.
   */ setTheme(theme, colorMap) {
        this._syncRegistry.setTheme($3ce28d198d785bf9$export$14faa19a0f3bbeb2.createFromRawTheme(theme, colorMap));
    }
    /**
   * Returns a lookup array for color ids.
   */ getColorMap() {
        return this._syncRegistry.getColorMap();
    }
    /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   * Please do not use language id 0.
   */ loadGrammarWithEmbeddedLanguages(initialScopeName, initialLanguage, embeddedLanguages) {
        return this.loadGrammarWithConfiguration(initialScopeName, initialLanguage, {
            embeddedLanguages: embeddedLanguages
        });
    }
    /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   * Please do not use language id 0.
   */ loadGrammarWithConfiguration(initialScopeName, initialLanguage, configuration) {
        return this._loadGrammar(initialScopeName, initialLanguage, configuration.embeddedLanguages, configuration.tokenTypes, new $3ce28d198d785bf9$var$BalancedBracketSelectors(configuration.balancedBracketSelectors || [], configuration.unbalancedBracketSelectors || []));
    }
    /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   */ loadGrammar(initialScopeName) {
        return this._loadGrammar(initialScopeName, 0, null, null, null);
    }
    _loadGrammar(initialScopeName, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors) {
        const dependencyProcessor = new $3ce28d198d785bf9$var$ScopeDependencyProcessor(this._syncRegistry, initialScopeName);
        while(dependencyProcessor.Q.length > 0){
            dependencyProcessor.Q.map((request)=>this._loadSingleGrammar(request.scopeName));
            dependencyProcessor.processQueue();
        }
        return this._grammarForScopeName(initialScopeName, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors);
    }
    _loadSingleGrammar(scopeName) {
        if (!this._ensureGrammarCache.has(scopeName)) {
            this._doLoadSingleGrammar(scopeName);
            this._ensureGrammarCache.set(scopeName, true);
        }
    }
    _doLoadSingleGrammar(scopeName) {
        const grammar = this._options.loadGrammar(scopeName);
        if (grammar) {
            const injections = typeof this._options.getInjections === "function" ? this._options.getInjections(scopeName) : void 0;
            this._syncRegistry.addGrammar(grammar, injections);
        }
    }
    /**
   * Adds a rawGrammar.
   */ addGrammar(rawGrammar, injections = [], initialLanguage = 0, embeddedLanguages = null) {
        this._syncRegistry.addGrammar(rawGrammar, injections);
        return this._grammarForScopeName(rawGrammar.scopeName, initialLanguage, embeddedLanguages);
    }
    /**
   * Get the grammar for `scopeName`. The grammar must first be created via `loadGrammar` or `addGrammar`.
   */ _grammarForScopeName(scopeName, initialLanguage = 0, embeddedLanguages = null, tokenTypes = null, balancedBracketSelectors = null) {
        return this._syncRegistry.grammarForScopeName(scopeName, initialLanguage, embeddedLanguages, tokenTypes, balancedBracketSelectors);
    }
};
var $3ce28d198d785bf9$export$17227441e89ee693 = $3ce28d198d785bf9$var$StateStackImpl.NULL;


//#region src/utils/colors.ts
function $e150f61536b1a01a$export$2f5d8722891c6610(theme, options) {
    const replacements = typeof theme === "string" ? {} : {
        ...theme.colorReplacements
    };
    const themeName = typeof theme === "string" ? theme : theme.name;
    for (const [key, value] of Object.entries(options?.colorReplacements || {}))if (typeof value === "string") replacements[key] = value;
    else if (key === themeName) Object.assign(replacements, value);
    return replacements;
}
function $e150f61536b1a01a$export$ef30c5cede3b6b4a(color, replacements) {
    if (!color) return color;
    return replacements?.[color?.toLowerCase()] || color;
}
//#endregion
//#region src/utils/general.ts
function $e150f61536b1a01a$export$45b10814cc054894(x) {
    return Array.isArray(x) ? x : [
        x
    ];
}
/**
* Normalize a getter to a promise.
*/ async function $e150f61536b1a01a$export$4643bb4b0bbd3390(p) {
    return Promise.resolve(typeof p === "function" ? p() : p).then((r)=>r.default || r);
}
/**
* Check if the language is plaintext that is ignored by Shiki.
*
* Hard-coded plain text languages: `plaintext`, `txt`, `text`, `plain`.
*/ function $e150f61536b1a01a$export$f98db15a0683bb96(lang) {
    return !lang || [
        "plaintext",
        "txt",
        "text",
        "plain"
    ].includes(lang);
}
/**
* Check if the language is specially handled or bypassed by Shiki.
*
* Hard-coded languages: `ansi` and plaintexts like `plaintext`, `txt`, `text`, `plain`.
*/ function $e150f61536b1a01a$export$5c3e2a1e13c5c906(lang) {
    return lang === "ansi" || $e150f61536b1a01a$export$f98db15a0683bb96(lang);
}
/**
* Check if the theme is specially handled or bypassed by Shiki.
*
* Hard-coded themes: `none`.
*/ function $e150f61536b1a01a$export$3e6bc683d2a50c25(theme) {
    return theme === "none";
}
/**
* Check if the theme is specially handled or bypassed by Shiki.
*
* Hard-coded themes: `none`.
*/ function $e150f61536b1a01a$export$cd4537af2d43769e(theme) {
    return $e150f61536b1a01a$export$3e6bc683d2a50c25(theme);
}
//#endregion
//#region src/utils/strings.ts
/**
* Split a string into lines, each line preserves the line ending.
*
* @param code - The code string to split into lines
* @param preserveEnding - Whether to preserve line endings in the result
* @returns Array of tuples containing [line content, offset index]
*
* @example
* ```ts
* splitLines('hello\nworld', false)
* // => [['hello', 0], ['world', 6]]
*
* splitLines('hello\nworld', true)
* // => [['hello\n', 0], ['world', 6]]
* ```
*/ const $e150f61536b1a01a$var$RE_NEWLINE = /(\r?\n)/g;
function $e150f61536b1a01a$export$88c07fe39db9eaa1(code, preserveEnding = false) {
    if (code.length === 0) return [
        [
            "",
            0
        ]
    ];
    const parts = code.split($e150f61536b1a01a$var$RE_NEWLINE);
    let index = 0;
    const lines = [];
    for(let i = 0; i < parts.length; i += 2){
        const line = preserveEnding ? parts[i] + (parts[i + 1] || "") : parts[i];
        lines.push([
            line,
            index
        ]);
        index += parts[i].length;
        index += parts[i + 1]?.length || 0;
    }
    return lines;
}
//#endregion
//#region src/textmate/normalize-theme.ts
/**
* https://github.com/microsoft/vscode/blob/f7f05dee53fb33fe023db2e06e30a89d3094488f/src/vs/platform/theme/common/colorRegistry.ts#L258-L268
*/ const $e150f61536b1a01a$var$VSCODE_FALLBACK_EDITOR_FG = {
    light: "#333333",
    dark: "#bbbbbb"
};
const $e150f61536b1a01a$var$VSCODE_FALLBACK_EDITOR_BG = {
    light: "#fffffe",
    dark: "#1e1e1e"
};
const $e150f61536b1a01a$var$RESOLVED_KEY = "__shiki_resolved";
/**
* Normalize a textmate theme to shiki theme
*/ function $e150f61536b1a01a$export$7cb37fb596e67020(rawTheme) {
    if (rawTheme?.[$e150f61536b1a01a$var$RESOLVED_KEY]) return rawTheme;
    const theme = {
        ...rawTheme
    };
    if (theme.tokenColors && !theme.settings) {
        theme.settings = theme.tokenColors;
        delete theme.tokenColors;
    }
    theme.type ||= "dark";
    theme.colorReplacements = {
        ...theme.colorReplacements
    };
    theme.settings ||= [];
    let { bg: bg, fg: fg } = theme;
    if (!bg || !fg) {
        /**
		* First try:
		* Theme might contain a global `tokenColor` without `name` or `scope`
		* Used as default value for foreground/background
		*/ const globalSetting = theme.settings ? theme.settings.find((s)=>!s.name && !s.scope) : void 0;
        if (globalSetting?.settings?.foreground) fg = globalSetting.settings.foreground;
        if (globalSetting?.settings?.background) bg = globalSetting.settings.background;
        /**
		* Second try:
		* If there's no global `tokenColor` without `name` or `scope`
		* Use `editor.foreground` and `editor.background`
		*/ if (!fg && theme?.colors?.["editor.foreground"]) fg = theme.colors["editor.foreground"];
        if (!bg && theme?.colors?.["editor.background"]) bg = theme.colors["editor.background"];
        /**
		* Last try:
		* If there's no fg/bg color specified in theme, use default
		*/ if (!fg) fg = theme.type === "light" ? $e150f61536b1a01a$var$VSCODE_FALLBACK_EDITOR_FG.light : $e150f61536b1a01a$var$VSCODE_FALLBACK_EDITOR_FG.dark;
        if (!bg) bg = theme.type === "light" ? $e150f61536b1a01a$var$VSCODE_FALLBACK_EDITOR_BG.light : $e150f61536b1a01a$var$VSCODE_FALLBACK_EDITOR_BG.dark;
        theme.fg = fg;
        theme.bg = bg;
    }
    if (!(theme.settings[0] && theme.settings[0].settings && !theme.settings[0].scope)) theme.settings.unshift({
        settings: {
            foreground: theme.fg,
            background: theme.bg
        }
    });
    let replacementCount = 0;
    const replacementMap = /* @__PURE__ */ new Map();
    function getReplacementColor(value) {
        if (replacementMap.has(value)) return replacementMap.get(value);
        replacementCount += 1;
        const hex = `#${replacementCount.toString(16).padStart(8, "0").toLowerCase()}`;
        if (theme.colorReplacements?.[`#${hex}`]) return getReplacementColor(value);
        replacementMap.set(value, hex);
        return hex;
    }
    theme.settings = theme.settings.map((setting)=>{
        const replaceFg = setting.settings?.foreground && !setting.settings.foreground.startsWith("#");
        const replaceBg = setting.settings?.background && !setting.settings.background.startsWith("#");
        if (!replaceFg && !replaceBg) return setting;
        const clone = {
            ...setting,
            settings: {
                ...setting.settings
            }
        };
        if (replaceFg) {
            const replacement = getReplacementColor(setting.settings.foreground);
            theme.colorReplacements[replacement] = setting.settings.foreground;
            clone.settings.foreground = replacement;
        }
        if (replaceBg) {
            const replacement = getReplacementColor(setting.settings.background);
            theme.colorReplacements[replacement] = setting.settings.background;
            clone.settings.background = replacement;
        }
        return clone;
    });
    for (const key of Object.keys(theme.colors || {}))if (key === "editor.foreground" || key === "editor.background" || key.startsWith("terminal.ansi")) {
        if (!theme.colors[key]?.startsWith("#")) {
            const replacement = getReplacementColor(theme.colors[key]);
            theme.colorReplacements[replacement] = theme.colors[key];
            theme.colors[key] = replacement;
        }
    }
    Object.defineProperty(theme, $e150f61536b1a01a$var$RESOLVED_KEY, {
        enumerable: false,
        writable: false,
        value: true
    });
    return theme;
}
//#endregion
//#region src/textmate/getters-resolve.ts
/**
* Resolve
*/ async function $e150f61536b1a01a$export$dfde3265a92833f6(langs) {
    return [
        ...new Set((await Promise.all(langs.filter((l)=>!$e150f61536b1a01a$export$5c3e2a1e13c5c906(l)).map(async (lang)=>await $e150f61536b1a01a$export$4643bb4b0bbd3390(lang).then((r)=>Array.isArray(r) ? r : [
                    r
                ])))).flat())
    ];
}
async function $e150f61536b1a01a$export$94455fe17f38f5a8(themes) {
    return (await Promise.all(themes.map(async (theme)=>$e150f61536b1a01a$export$cd4537af2d43769e(theme) ? null : $e150f61536b1a01a$export$7cb37fb596e67020(await $e150f61536b1a01a$export$4643bb4b0bbd3390(theme))))).filter((i)=>!!i);
}
//#endregion
//#region src/utils/alias.ts
function $e150f61536b1a01a$export$bdd8de43c0c06bf(name, alias) {
    if (!alias) return name;
    if (alias[name]) {
        const resolved = /* @__PURE__ */ new Set([
            name
        ]);
        while(alias[name]){
            name = alias[name];
            if (resolved.has(name)) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Circular alias \`${[
                ...resolved
            ].join(" -> ")} -> ${name}\``);
            resolved.add(name);
        }
    }
    return name;
}
//#endregion
//#region src/textmate/registry.ts
var $e150f61536b1a01a$export$4d9facee29974f3 = class extends (0, $3ce28d198d785bf9$export$4d9facee29974f3) {
    _resolver;
    _themes;
    _langs;
    _alias;
    _resolvedThemes = /* @__PURE__ */ new Map();
    _resolvedGrammars = /* @__PURE__ */ new Map();
    _langMap = /* @__PURE__ */ new Map();
    _langGraph = /* @__PURE__ */ new Map();
    _textmateThemeCache = /* @__PURE__ */ new WeakMap();
    _loadedThemesCache = null;
    _loadedLanguagesCache = null;
    constructor(_resolver, _themes, _langs, _alias = {}){
        super(_resolver);
        this._resolver = _resolver;
        this._themes = _themes;
        this._langs = _langs;
        this._alias = _alias;
        this._themes.map((t)=>this.loadTheme(t));
        this.loadLanguages(this._langs);
    }
    getTheme(theme) {
        if (typeof theme === "string") return this._resolvedThemes.get(theme);
        else return this.loadTheme(theme);
    }
    loadTheme(theme) {
        const _theme = $e150f61536b1a01a$export$7cb37fb596e67020(theme);
        if (_theme.name) {
            this._resolvedThemes.set(_theme.name, _theme);
            this._loadedThemesCache = null;
        }
        return _theme;
    }
    getLoadedThemes() {
        if (!this._loadedThemesCache) this._loadedThemesCache = [
            ...this._resolvedThemes.keys()
        ];
        return this._loadedThemesCache;
    }
    setTheme(theme) {
        let textmateTheme = this._textmateThemeCache.get(theme);
        if (!textmateTheme) {
            textmateTheme = (0, $3ce28d198d785bf9$export$14faa19a0f3bbeb2).createFromRawTheme(theme);
            this._textmateThemeCache.set(theme, textmateTheme);
        }
        this._syncRegistry.setTheme(textmateTheme);
    }
    getGrammar(name) {
        name = $e150f61536b1a01a$export$bdd8de43c0c06bf(name, this._alias);
        return this._resolvedGrammars.get(name);
    }
    loadLanguage(lang) {
        if (this.getGrammar(lang.name)) return;
        const embeddedLazilyBy = new Set([
            ...this._langMap.values()
        ].filter((i)=>i.embeddedLangsLazy?.includes(lang.name)));
        this._resolver.addLanguage(lang);
        const grammarConfig = {
            balancedBracketSelectors: lang.balancedBracketSelectors || [
                "*"
            ],
            unbalancedBracketSelectors: lang.unbalancedBracketSelectors || []
        };
        this._syncRegistry._rawGrammars.set(lang.scopeName, lang);
        const g = this.loadGrammarWithConfiguration(lang.scopeName, 1, grammarConfig);
        g.name = lang.name;
        this._resolvedGrammars.set(lang.name, g);
        if (lang.aliases) lang.aliases.forEach((alias)=>{
            this._alias[alias] = lang.name;
        });
        this._loadedLanguagesCache = null;
        if (embeddedLazilyBy.size) for (const e of embeddedLazilyBy){
            this._resolvedGrammars.delete(e.name);
            this._loadedLanguagesCache = null;
            this._syncRegistry?._injectionGrammars?.delete(e.scopeName);
            this._syncRegistry?._grammars?.delete(e.scopeName);
            this.loadLanguage(this._langMap.get(e.name));
        }
    }
    dispose() {
        super.dispose();
        this._resolvedThemes.clear();
        this._resolvedGrammars.clear();
        this._langMap.clear();
        this._langGraph.clear();
        this._loadedThemesCache = null;
    }
    loadLanguages(langs) {
        for (const lang of langs)this.resolveEmbeddedLanguages(lang);
        const langsGraphArray = [
            ...this._langGraph.entries()
        ];
        const missingLangs = langsGraphArray.filter(([_, lang])=>!lang);
        if (missingLangs.length) {
            const dependents = langsGraphArray.filter(([_, lang])=>{
                if (!lang) return false;
                return (lang.embeddedLanguages || lang.embeddedLangs)?.some((l)=>missingLangs.map(([name])=>name).includes(l));
            }).filter((lang)=>!missingLangs.includes(lang));
            throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Missing languages ${missingLangs.map(([name])=>`\`${name}\``).join(", ")}, required by ${dependents.map(([name])=>`\`${name}\``).join(", ")}`);
        }
        for (const [_, lang] of langsGraphArray)this._resolver.addLanguage(lang);
        for (const [_, lang] of langsGraphArray)this.loadLanguage(lang);
    }
    getLoadedLanguages() {
        if (!this._loadedLanguagesCache) this._loadedLanguagesCache = [
            .../* @__PURE__ */ new Set([
                ...this._resolvedGrammars.keys(),
                ...Object.keys(this._alias)
            ])
        ];
        return this._loadedLanguagesCache;
    }
    resolveEmbeddedLanguages(lang) {
        this._langMap.set(lang.name, lang);
        this._langGraph.set(lang.name, lang);
        const embedded = lang.embeddedLanguages ?? lang.embeddedLangs;
        if (embedded) for (const embeddedLang of embedded)this._langGraph.set(embeddedLang, this._langMap.get(embeddedLang));
    }
};
//#endregion
//#region src/textmate/resolver.ts
var $e150f61536b1a01a$export$8b4c839865b08288 = class {
    _langs = /* @__PURE__ */ new Map();
    _scopeToLang = /* @__PURE__ */ new Map();
    _injections = /* @__PURE__ */ new Map();
    _onigLib;
    constructor(engine, langs){
        this._onigLib = {
            createOnigScanner: (patterns)=>engine.createScanner(patterns),
            createOnigString: (s)=>engine.createString(s)
        };
        langs.forEach((i)=>this.addLanguage(i));
    }
    get onigLib() {
        return this._onigLib;
    }
    getLangRegistration(langIdOrAlias) {
        return this._langs.get(langIdOrAlias);
    }
    loadGrammar(scopeName) {
        return this._scopeToLang.get(scopeName);
    }
    addLanguage(l) {
        this._langs.set(l.name, l);
        if (l.aliases) l.aliases.forEach((a)=>{
            this._langs.set(a, l);
        });
        this._scopeToLang.set(l.scopeName, l);
        if (l.injectTo) l.injectTo.forEach((i)=>{
            if (!this._injections.get(i)) this._injections.set(i, []);
            this._injections.get(i).push(l.scopeName);
        });
    }
    getInjections(scopeName) {
        const scopeParts = scopeName.split(".");
        let injections = [];
        for(let i = 1; i <= scopeParts.length; i++){
            const subScopeName = scopeParts.slice(0, i).join(".");
            injections = [
                ...injections,
                ...this._injections.get(subScopeName) || []
            ];
        }
        return injections;
    }
};
//#endregion
//#region src/constructors/primitive.ts
let $e150f61536b1a01a$var$instancesCount = 0;
/**
* Get the minimal shiki primitive instance.
*
* Requires to provide the engine and all themes and languages upfront.
*/ function $e150f61536b1a01a$export$993d8e1d5e5fb61b(options) {
    $e150f61536b1a01a$var$instancesCount += 1;
    if (options.warnings !== false && $e150f61536b1a01a$var$instancesCount >= 10 && $e150f61536b1a01a$var$instancesCount % 10 === 0) console.warn(`[Shiki] ${$e150f61536b1a01a$var$instancesCount} instances have been created. Shiki is supposed to be used as a singleton, consider refactoring your code to cache your highlighter instance; Or call \`highlighter.dispose()\` to release unused instances.`);
    let isDisposed = false;
    if (!options.engine) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)("`engine` option is required for synchronous mode");
    const langs = (options.langs || []).flat(1);
    const themes = (options.themes || []).flat(1).map($e150f61536b1a01a$export$7cb37fb596e67020);
    const _registry = new $e150f61536b1a01a$export$4d9facee29974f3(new $e150f61536b1a01a$export$8b4c839865b08288(options.engine, langs), themes, langs, options.langAlias);
    let _lastTheme;
    function resolveLangAlias$1(name) {
        return $e150f61536b1a01a$export$bdd8de43c0c06bf(name, options.langAlias);
    }
    function getLanguage(name) {
        ensureNotDisposed();
        const _lang = _registry.getGrammar(typeof name === "string" ? name : name.name);
        if (!_lang) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Language \`${name}\` not found, you may need to load it first`);
        return _lang;
    }
    function getTheme(name) {
        if (name === "none") return {
            bg: "",
            fg: "",
            name: "none",
            settings: [],
            type: "dark"
        };
        ensureNotDisposed();
        const _theme = _registry.getTheme(name);
        if (!_theme) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Theme \`${name}\` not found, you may need to load it first`);
        return _theme;
    }
    function setTheme(name) {
        ensureNotDisposed();
        const theme = getTheme(name);
        if (_lastTheme !== name) {
            _registry.setTheme(theme);
            _lastTheme = name;
        }
        return {
            theme: theme,
            colorMap: _registry.getColorMap()
        };
    }
    function getLoadedThemes() {
        ensureNotDisposed();
        return _registry.getLoadedThemes();
    }
    function getLoadedLanguages() {
        ensureNotDisposed();
        return _registry.getLoadedLanguages();
    }
    function loadLanguageSync(...langs) {
        ensureNotDisposed();
        _registry.loadLanguages(langs.flat(1));
    }
    async function loadLanguage(...langs) {
        return loadLanguageSync(await $e150f61536b1a01a$export$dfde3265a92833f6(langs));
    }
    function loadThemeSync(...themes) {
        ensureNotDisposed();
        for (const theme of themes.flat(1))_registry.loadTheme(theme);
    }
    async function loadTheme(...themes) {
        ensureNotDisposed();
        return loadThemeSync(await $e150f61536b1a01a$export$94455fe17f38f5a8(themes));
    }
    function ensureNotDisposed() {
        if (isDisposed) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)("Shiki instance has been disposed");
    }
    function dispose() {
        if (isDisposed) return;
        isDisposed = true;
        _registry.dispose();
        $e150f61536b1a01a$var$instancesCount -= 1;
    }
    return {
        setTheme: setTheme,
        getTheme: getTheme,
        getLanguage: getLanguage,
        getLoadedThemes: getLoadedThemes,
        getLoadedLanguages: getLoadedLanguages,
        resolveLangAlias: resolveLangAlias$1,
        loadLanguage: loadLanguage,
        loadLanguageSync: loadLanguageSync,
        loadTheme: loadTheme,
        loadThemeSync: loadThemeSync,
        dispose: dispose,
        [Symbol.dispose]: dispose
    };
}
/**
* @deprecated Use `createShikiPrimitive` instead.
*/ const $e150f61536b1a01a$export$b748e45347fc3413 = $e150f61536b1a01a$export$993d8e1d5e5fb61b;
//#endregion
//#region src/constructors/async.ts
/**
* Get the minimal shiki primitive instance.
*/ async function $e150f61536b1a01a$export$7118aaae6ff863ad(options) {
    if (!options.engine) console.warn("`engine` option is required. Use `createOnigurumaEngine` or `createJavaScriptRegexEngine` to create an engine.");
    const [themes, langs, engine] = await Promise.all([
        $e150f61536b1a01a$export$94455fe17f38f5a8(options.themes || []),
        $e150f61536b1a01a$export$dfde3265a92833f6(options.langs || []),
        options.engine
    ]);
    return $e150f61536b1a01a$export$993d8e1d5e5fb61b({
        ...options,
        themes: themes,
        langs: langs,
        engine: engine
    });
}
/**
* @deprecated Use `createShikiPrimitiveAsync` instead.
*/ const $e150f61536b1a01a$export$e584c153725e36c2 = $e150f61536b1a01a$export$7118aaae6ff863ad;
//#endregion
//#region src/textmate/grammar-state.ts
const $e150f61536b1a01a$var$_grammarStateMap = /* @__PURE__ */ new WeakMap();
function $e150f61536b1a01a$export$85116f33c2060a4b(keys, state) {
    $e150f61536b1a01a$var$_grammarStateMap.set(keys, state);
}
function $e150f61536b1a01a$export$47937e5383997945(keys) {
    return $e150f61536b1a01a$var$_grammarStateMap.get(keys);
}
/**
* GrammarState is a special reference object that holds the state of a grammar.
*
* It's used to highlight code snippets that are part of the target language.
*/ var $e150f61536b1a01a$export$6828086307020659 = class GrammarState {
    /**
	* Theme to Stack mapping
	*/ _stacks = {};
    lang;
    get themes() {
        return Object.keys(this._stacks);
    }
    get theme() {
        return this.themes[0];
    }
    get _stack() {
        return this._stacks[this.theme];
    }
    /**
	* Static method to create a initial grammar state.
	*/ static initial(lang, themes) {
        return new GrammarState(Object.fromEntries($e150f61536b1a01a$export$45b10814cc054894(themes).map((theme)=>[
                theme,
                (0, $3ce28d198d785bf9$export$17227441e89ee693)
            ])), lang);
    }
    constructor(...args){
        if (args.length === 2) {
            const [stacksMap, lang] = args;
            this.lang = lang;
            this._stacks = stacksMap;
        } else {
            const [stack, lang, theme] = args;
            this.lang = lang;
            this._stacks = {
                [theme]: stack
            };
        }
    }
    /**
	* Get the internal stack object.
	* @internal
	*/ getInternalStack(theme = this.theme) {
        return this._stacks[theme];
    }
    getScopes(theme = this.theme) {
        return $e150f61536b1a01a$var$getScopes(this._stacks[theme]);
    }
    toJSON() {
        return {
            lang: this.lang,
            theme: this.theme,
            themes: this.themes,
            scopes: this.getScopes()
        };
    }
};
function $e150f61536b1a01a$var$getScopes(stack) {
    const scopes = [];
    const visited = /* @__PURE__ */ new Set();
    function pushScope(stack) {
        if (visited.has(stack)) return;
        visited.add(stack);
        const name = stack?.nameScopesList?.scopeName;
        if (name) scopes.push(name);
        if (stack.parent) pushScope(stack.parent);
    }
    pushScope(stack);
    return scopes;
}
function $e150f61536b1a01a$export$5d3db558cc5e415b(state, theme) {
    if (!(state instanceof $e150f61536b1a01a$export$6828086307020659)) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)("Invalid grammar state");
    return state.getInternalStack(theme);
}
//#endregion
//#region src/highlight/code-to-tokens-base.ts
const $e150f61536b1a01a$var$RE_COMMA = /,/;
const $e150f61536b1a01a$var$RE_SPACE = / /;
/**
* Code to tokens, with a simple theme.
*/ function $e150f61536b1a01a$export$9fcc555cdbb165d8(primitive, code, options = {}) {
    const { theme: themeName = primitive.getLoadedThemes()[0] } = options;
    if ($e150f61536b1a01a$export$f98db15a0683bb96(primitive.resolveLangAlias(options.lang || "text")) || $e150f61536b1a01a$export$3e6bc683d2a50c25(themeName)) return $e150f61536b1a01a$export$88c07fe39db9eaa1(code).map((line)=>[
            {
                content: line[0],
                offset: line[1]
            }
        ]);
    const { theme: theme, colorMap: colorMap } = primitive.setTheme(themeName);
    const _grammar = primitive.getLanguage(options.lang || "text");
    if (options.grammarState) {
        if (options.grammarState.lang !== _grammar.name) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Grammar state language "${options.grammarState.lang}" does not match highlight language "${_grammar.name}"`);
        if (!options.grammarState.themes.includes(theme.name)) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Grammar state themes "${options.grammarState.themes}" do not contain highlight theme "${theme.name}"`);
    }
    return $e150f61536b1a01a$export$54c7d59470f3dc59(code, _grammar, theme, colorMap, options);
}
function $e150f61536b1a01a$export$e79a48b8b5fd83c5(...args) {
    if (args.length === 2) return $e150f61536b1a01a$export$47937e5383997945(args[1]);
    const [primitive, code, options = {}] = args;
    const { lang: lang = "text", theme: themeName = primitive.getLoadedThemes()[0] } = options;
    if ($e150f61536b1a01a$export$f98db15a0683bb96(lang) || $e150f61536b1a01a$export$3e6bc683d2a50c25(themeName)) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)("Plain language does not have grammar state");
    if (lang === "ansi") throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)("ANSI language does not have grammar state");
    const { theme: theme, colorMap: colorMap } = primitive.setTheme(themeName);
    const _grammar = primitive.getLanguage(lang);
    return new $e150f61536b1a01a$export$6828086307020659($e150f61536b1a01a$var$_tokenizeWithTheme(code, _grammar, theme, colorMap, options).stateStack, _grammar.name, theme.name);
}
function $e150f61536b1a01a$export$54c7d59470f3dc59(code, grammar, theme, colorMap, options) {
    const result = $e150f61536b1a01a$var$_tokenizeWithTheme(code, grammar, theme, colorMap, options);
    const grammarState = new $e150f61536b1a01a$export$6828086307020659(result.stateStack, grammar.name, theme.name);
    $e150f61536b1a01a$export$85116f33c2060a4b(result.tokens, grammarState);
    return result.tokens;
}
function $e150f61536b1a01a$var$_tokenizeWithTheme(code, grammar, theme, colorMap, options) {
    const colorReplacements = $e150f61536b1a01a$export$2f5d8722891c6610(theme, options);
    const { tokenizeMaxLineLength: tokenizeMaxLineLength = 0, tokenizeTimeLimit: tokenizeTimeLimit = 500, includeExplanation: includeExplanation = false } = options;
    const lines = $e150f61536b1a01a$export$88c07fe39db9eaa1(code);
    let stateStack = options.grammarState ? $e150f61536b1a01a$export$5d3db558cc5e415b(options.grammarState, theme.name) ?? (0, $3ce28d198d785bf9$export$17227441e89ee693) : options.grammarContextCode != null ? $e150f61536b1a01a$var$_tokenizeWithTheme(options.grammarContextCode, grammar, theme, colorMap, {
        ...options,
        grammarState: void 0,
        grammarContextCode: void 0
    }).stateStack : (0, $3ce28d198d785bf9$export$17227441e89ee693);
    let actual = [];
    const final = [];
    for(let i = 0, len = lines.length; i < len; i++){
        const [line, lineOffset] = lines[i];
        if (line === "") {
            actual = [];
            final.push([]);
            continue;
        }
        if (tokenizeMaxLineLength > 0 && line.length >= tokenizeMaxLineLength) {
            actual = [];
            final.push([
                {
                    content: line,
                    offset: lineOffset,
                    color: "",
                    fontStyle: 0
                }
            ]);
            continue;
        }
        let resultWithScopes;
        let tokensWithScopes;
        let tokensWithScopesIndex;
        if (includeExplanation && includeExplanation !== "tokenType") {
            resultWithScopes = grammar.tokenizeLine(line, stateStack, tokenizeTimeLimit);
            tokensWithScopes = resultWithScopes.tokens;
            tokensWithScopesIndex = 0;
        }
        const result = grammar.tokenizeLine2(line, stateStack, tokenizeTimeLimit);
        const tokensLength = result.tokens.length / 2;
        for(let j = 0; j < tokensLength; j++){
            const startIndex = result.tokens[2 * j];
            const nextStartIndex = j + 1 < tokensLength ? result.tokens[2 * j + 2] : line.length;
            if (startIndex === nextStartIndex) continue;
            const metadata = result.tokens[2 * j + 1];
            const color = $e150f61536b1a01a$export$ef30c5cede3b6b4a(colorMap[(0, $3ce28d198d785bf9$export$90e5db14803ea047).getForeground(metadata)], colorReplacements);
            const fontStyle = (0, $3ce28d198d785bf9$export$90e5db14803ea047).getFontStyle(metadata);
            const token = {
                content: line.substring(startIndex, nextStartIndex),
                offset: lineOffset + startIndex,
                color: color,
                fontStyle: fontStyle
            };
            if (includeExplanation === "tokenType") token.type = (0, $3ce28d198d785bf9$export$90e5db14803ea047).getTokenType(metadata);
            else if (includeExplanation) {
                const themeSettingsSelectors = [];
                if (includeExplanation !== "scopeName") for (const setting of theme.settings){
                    let selectors;
                    switch(typeof setting.scope){
                        case "string":
                            selectors = setting.scope.split($e150f61536b1a01a$var$RE_COMMA).map((scope)=>scope.trim());
                            break;
                        case "object":
                            selectors = setting.scope;
                            break;
                        default:
                            continue;
                    }
                    themeSettingsSelectors.push({
                        settings: setting,
                        selectors: selectors.map((selector)=>selector.split($e150f61536b1a01a$var$RE_SPACE))
                    });
                }
                token.explanation = [];
                let offset = 0;
                while(startIndex + offset < nextStartIndex){
                    const tokenWithScopes = tokensWithScopes[tokensWithScopesIndex];
                    const tokenWithScopesText = line.substring(tokenWithScopes.startIndex, tokenWithScopes.endIndex);
                    offset += tokenWithScopesText.length;
                    token.explanation.push({
                        content: tokenWithScopesText,
                        scopes: includeExplanation === "scopeName" ? $e150f61536b1a01a$var$explainThemeScopesNameOnly(tokenWithScopes.scopes) : $e150f61536b1a01a$var$explainThemeScopesFull(themeSettingsSelectors, tokenWithScopes.scopes)
                    });
                    tokensWithScopesIndex += 1;
                }
            }
            actual.push(token);
        }
        final.push(actual);
        actual = [];
        stateStack = result.ruleStack;
    }
    return {
        tokens: final,
        stateStack: stateStack
    };
}
function $e150f61536b1a01a$var$explainThemeScopesNameOnly(scopes) {
    return scopes.map((scope)=>({
            scopeName: scope
        }));
}
function $e150f61536b1a01a$var$explainThemeScopesFull(themeSelectors, scopes) {
    const result = [];
    for(let i = 0, len = scopes.length; i < len; i++){
        const scope = scopes[i];
        result[i] = {
            scopeName: scope,
            themeMatches: $e150f61536b1a01a$var$explainThemeScope(themeSelectors, scope, scopes.slice(0, i))
        };
    }
    return result;
}
function $e150f61536b1a01a$var$matchesOne(selector, scope) {
    return selector === scope || scope.substring(0, selector.length) === selector && scope[selector.length] === ".";
}
function $e150f61536b1a01a$var$matches(selectors, scope, parentScopes) {
    if (!$e150f61536b1a01a$var$matchesOne(selectors.at(-1), scope)) return false;
    let selectorParentIndex = selectors.length - 2;
    let parentIndex = parentScopes.length - 1;
    while(selectorParentIndex >= 0 && parentIndex >= 0){
        if ($e150f61536b1a01a$var$matchesOne(selectors[selectorParentIndex], parentScopes[parentIndex])) selectorParentIndex -= 1;
        parentIndex -= 1;
    }
    if (selectorParentIndex === -1) return true;
    return false;
}
function $e150f61536b1a01a$var$explainThemeScope(themeSettingsSelectors, scope, parentScopes) {
    const result = [];
    for (const { selectors: selectors, settings: settings } of themeSettingsSelectors)for (const selectorPieces of selectors)if ($e150f61536b1a01a$var$matches(selectorPieces, scope, parentScopes)) {
        result.push(settings);
        break;
    }
    return result;
}
//#endregion
//#region src/highlight/code-to-tokens-themes.ts
/**
* Get tokens with multiple themes
*/ function $e150f61536b1a01a$export$99552db3190ba9d3(primitive, code, options, codeToTokensBaseFn = $e150f61536b1a01a$export$9fcc555cdbb165d8) {
    const themes = Object.entries(options.themes).filter((i)=>i[1]).map((i)=>({
            color: i[0],
            theme: i[1]
        }));
    const themedTokens = themes.map((t)=>{
        const tokens = codeToTokensBaseFn(primitive, code, {
            ...options,
            theme: t.theme
        });
        return {
            tokens: tokens,
            state: $e150f61536b1a01a$export$47937e5383997945(tokens),
            theme: typeof t.theme === "string" ? t.theme : t.theme.name
        };
    });
    const tokens = $e150f61536b1a01a$export$cbd2f44183624b07(...themedTokens.map((i)=>i.tokens));
    const mergedTokens = tokens[0].map((line, lineIdx)=>line.map((_token, tokenIdx)=>{
            const mergedToken = {
                content: _token.content,
                variants: {},
                offset: _token.offset
            };
            if ("includeExplanation" in options && options.includeExplanation) mergedToken.explanation = _token.explanation;
            tokens.forEach((t, themeIdx)=>{
                const { content: _, explanation: __, offset: ___, ...styles } = t[lineIdx][tokenIdx];
                mergedToken.variants[themes[themeIdx].color] = styles;
            });
            return mergedToken;
        }));
    const mergedGrammarState = themedTokens[0].state ? new $e150f61536b1a01a$export$6828086307020659(Object.fromEntries(themedTokens.map((s)=>[
            s.theme,
            s.state?.getInternalStack(s.theme)
        ])), themedTokens[0].state.lang) : void 0;
    if (mergedGrammarState) $e150f61536b1a01a$export$85116f33c2060a4b(mergedTokens, mergedGrammarState);
    return mergedTokens;
}
/**
* Break tokens from multiple themes into same tokenization.
*
* For example, given two themes that tokenize `console.log("hello")` as:
*
* - `console . log (" hello ")` (6 tokens)
* - `console .log ( "hello" )` (5 tokens)
*
* This function will return:
*
* - `console . log ( " hello " )` (8 tokens)
* - `console . log ( " hello " )` (8 tokens)
*/ function $e150f61536b1a01a$export$cbd2f44183624b07(...themes) {
    const outThemes = themes.map(()=>[]);
    const count = themes.length;
    for(let i = 0; i < themes[0].length; i++){
        const lines = themes.map((t)=>t[i]);
        const outLines = outThemes.map(()=>[]);
        outThemes.forEach((t, i)=>t.push(outLines[i]));
        const indexes = lines.map(()=>0);
        const current = lines.map((l)=>l[0]);
        while(current.every((t)=>t)){
            const minLength = Math.min(...current.map((t)=>t.content.length));
            for(let n = 0; n < count; n++){
                const token = current[n];
                if (token.content.length === minLength) {
                    outLines[n].push(token);
                    indexes[n] += 1;
                    current[n] = lines[n][indexes[n]];
                } else {
                    outLines[n].push({
                        ...token,
                        content: token.content.slice(0, minLength)
                    });
                    current[n] = {
                        ...token,
                        content: token.content.slice(minLength),
                        offset: token.offset + minLength
                    };
                }
            }
        }
    }
    return outThemes;
}



/**
 * @import {Nodes, Parents, RootContent} from 'hast'
 * @import {Schema} from 'property-information'
 * @import {Options as StringifyEntitiesOptions} from 'stringify-entities'
 */ /**
 * @typedef {Omit<StringifyEntitiesOptions, 'attribute' | 'escapeOnly' | 'subset'>} CharacterReferences
 *
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [allowDangerousCharacters=false]
 *   Do not encode some characters which cause XSS vulnerabilities in older
 *   browsers (default: `false`).
 *
 *   > ⚠️ **Danger**: only set this if you completely trust the content.
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Allow `raw` nodes and insert them as raw HTML (default: `false`).
 *
 *   When `false`, `Raw` nodes are encoded.
 *
 *   > ⚠️ **Danger**: only set this if you completely trust the content.
 * @property {boolean | null | undefined} [allowParseErrors=false]
 *   Do not encode characters which cause parse errors (even though they work),
 *   to save bytes (default: `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [bogusComments=false]
 *   Use “bogus comments” instead of comments to save byes: `<?charlie>`
 *   instead of `<!--charlie-->` (default: `false`).
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {CharacterReferences | null | undefined} [characterReferences]
 *   Configure how to serialize character references (optional).
 * @property {boolean | null | undefined} [closeEmptyElements=false]
 *   Close SVG elements without any content with slash (`/`) on the opening tag
 *   instead of an end tag: `<circle />` instead of `<circle></circle>`
 *   (default: `false`).
 *
 *   See `tightSelfClosing` to control whether a space is used before the
 *   slash.
 *
 *   Not used in the HTML space.
 * @property {boolean | null | undefined} [closeSelfClosing=false]
 *   Close self-closing nodes with an extra slash (`/`): `<img />` instead of
 *   `<img>` (default: `false`).
 *
 *   See `tightSelfClosing` to control whether a space is used before the
 *   slash.
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [collapseEmptyAttributes=false]
 *   Collapse empty attributes: get `class` instead of `class=""` (default:
 *   `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: boolean attributes (such as `hidden`) are always collapsed.
 * @property {boolean | null | undefined} [omitOptionalTags=false]
 *   Omit optional opening and closing tags (default: `false`).
 *
 *   For example, in `<ol><li>one</li><li>two</li></ol>`, both `</li>` closing
 *   tags can be omitted.
 *   The first because it’s followed by another `li`, the last because it’s
 *   followed by nothing.
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [preferUnquoted=false]
 *   Leave attributes unquoted if that results in less bytes (default: `false`).
 *
 *   Not used in the SVG space.
 * @property {boolean | null | undefined} [quoteSmart=false]
 *   Use the other quote if that results in less bytes (default: `false`).
 * @property {Quote | null | undefined} [quote='"']
 *   Preferred quote to use (default: `'"'`).
 * @property {Space | null | undefined} [space='html']
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it (default: `'html'`).
 *
 *   > 👉 **Note**: hast is not XML.
 *   > It supports SVG as embedded in HTML.
 *   > It does not support the features available in XML.
 *   > Passing SVG might break but fragments of modern SVG should be fine.
 *   > Use [`xast`][xast] if you need to support SVG as XML.
 * @property {boolean | null | undefined} [tightAttributes=false]
 *   Join attributes together, without whitespace, if possible: get
 *   `class="a b"title="c d"` instead of `class="a b" title="c d"` to save
 *   bytes (default: `false`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [tightCommaSeparatedLists=false]
 *   Join known comma-separated attribute values with just a comma (`,`),
 *   instead of padding them on the right as well (`,␠`, where `␠` represents a
 *   space) (default: `false`).
 * @property {boolean | null | undefined} [tightDoctype=false]
 *   Drop unneeded spaces in doctypes: `<!doctypehtml>` instead of
 *   `<!doctype html>` to save bytes (default: `false`).
 *
 *   > 👉 **Note**: intentionally creates parse errors in markup (how parse
 *   > errors are handled is well defined, so this works but isn’t pretty).
 * @property {boolean | null | undefined} [tightSelfClosing=false]
 *   Do not use an extra space when closing self-closing elements: `<img/>`
 *   instead of `<img />` (default: `false`).
 *
 *   > 👉 **Note**: only used if `closeSelfClosing: true` or
 *   > `closeEmptyElements: true`.
 * @property {boolean | null | undefined} [upperDoctype=false]
 *   Use a `<!DOCTYPE…` instead of `<!doctype…` (default: `false`).
 *
 *   Useless except for XHTML.
 * @property {ReadonlyArray<string> | null | undefined} [voids]
 *   Tag names of elements to serialize without closing tag (default: `html-void-elements`).
 *
 *   Not used in the SVG space.
 *
 *   > 👉 **Note**: It’s highly unlikely that you want to pass this, because
 *   > hast is not for XML, and HTML will not add more void elements.
 *
 * @typedef {'"' | "'"} Quote
 *   HTML quotes for attribute values.
 *
 * @typedef {Omit<Required<{[key in keyof Options]: Exclude<Options[key], null | undefined>}>, 'space' | 'quote'>} Settings
 *
 * @typedef {'html' | 'svg'} Space
 *   Namespace.
 *
 * @typedef State
 *   Info passed around about the current state.
 * @property {(node: Parents | undefined) => string} all
 *   Serialize the children of a parent node.
 * @property {Quote} alternative
 *   Alternative quote.
 * @property {(node: Nodes, index: number | undefined, parent: Parents | undefined) => string} one
 *   Serialize one node.
 * @property {Quote} quote
 *   Preferred quote.
 * @property {Schema} schema
 *   Current schema.
 * @property {Settings} settings
 *   User configuration.
 */ /**
 * List of HTML void tag names.
 *
 * @type {Array<string>}
 */ const $aa609dabe8f29803$export$762508062d068de = [
    'area',
    'base',
    'basefont',
    'bgsound',
    'br',
    'col',
    'command',
    'embed',
    'frame',
    'hr',
    'image',
    'img',
    'input',
    'keygen',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr'
];


// Note: types exposed from `index.d.ts`.
/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */ /** @type {SchemaType} */ class $5b6f5f4bade80e38$export$19342e026b58ebb7 {
    /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */ constructor(property, normal, space){
        this.normal = normal;
        this.property = property;
        if (space) this.space = space;
    }
}
$5b6f5f4bade80e38$export$19342e026b58ebb7.prototype.normal = {};
$5b6f5f4bade80e38$export$19342e026b58ebb7.prototype.property = {};
$5b6f5f4bade80e38$export$19342e026b58ebb7.prototype.space = undefined;


function $61ded5fe6f037163$export$4950aa0f605343fb(definitions, space) {
    /** @type {Record<string, Info>} */ const property = {};
    /** @type {Record<string, string>} */ const normal = {};
    for (const definition of definitions){
        Object.assign(property, definition.property);
        Object.assign(normal, definition.normal);
    }
    return new (0, $5b6f5f4bade80e38$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @typedef Definition
 *   Definition of a schema.
 * @property {Record<string, string> | undefined} [attributes]
 *   Normalzed names to special attribute case.
 * @property {ReadonlyArray<string> | undefined} [mustUseProperty]
 *   Normalized names that must be set as properties.
 * @property {Record<string, number | null>} properties
 *   Property names to their types.
 * @property {Space | undefined} [space]
 *   Space.
 * @property {Transform} transform
 *   Transform a property name.
 */ /**
 * @callback Transform
 *   Transform.
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Attribute.
 */ /**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */ function $ba2c06c56b858c9f$export$a3295358bff77e(value) {
    return value.toLowerCase();
}


/**
 * @import {Space} from 'property-information'
 */ /**
 * @import {Info as InfoType} from 'property-information'
 */ /** @type {InfoType} */ class $931174b915b83d11$export$c4868e4a24d48fad {
    /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */ constructor(property, attribute){
        this.attribute = attribute;
        this.property = property;
    }
}
$931174b915b83d11$export$c4868e4a24d48fad.prototype.attribute = '';
$931174b915b83d11$export$c4868e4a24d48fad.prototype.booleanish = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.boolean = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.defined = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.number = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.property = '';
$931174b915b83d11$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$931174b915b83d11$export$c4868e4a24d48fad.prototype.space = undefined;


var $f295bb9197e9852c$exports = {};

$parcel$export($f295bb9197e9852c$exports, "boolean", () => $f295bb9197e9852c$export$4a21f16c33752377);
$parcel$export($f295bb9197e9852c$exports, "booleanish", () => $f295bb9197e9852c$export$55e9e1fbc638dc8f);
$parcel$export($f295bb9197e9852c$exports, "overloadedBoolean", () => $f295bb9197e9852c$export$242ac3d3042558aa);
$parcel$export($f295bb9197e9852c$exports, "number", () => $f295bb9197e9852c$export$98e628dec113755e);
$parcel$export($f295bb9197e9852c$exports, "spaceSeparated", () => $f295bb9197e9852c$export$ab8645c862eb5a3e);
$parcel$export($f295bb9197e9852c$exports, "commaSeparated", () => $f295bb9197e9852c$export$9c8d678629b3d3);
$parcel$export($f295bb9197e9852c$exports, "commaOrSpaceSeparated", () => $f295bb9197e9852c$export$2ad25cfebf36cacd);
let $f295bb9197e9852c$var$powers = 0;
const $f295bb9197e9852c$export$4a21f16c33752377 = $f295bb9197e9852c$var$increment();
const $f295bb9197e9852c$export$55e9e1fbc638dc8f = $f295bb9197e9852c$var$increment();
const $f295bb9197e9852c$export$242ac3d3042558aa = $f295bb9197e9852c$var$increment();
const $f295bb9197e9852c$export$98e628dec113755e = $f295bb9197e9852c$var$increment();
const $f295bb9197e9852c$export$ab8645c862eb5a3e = $f295bb9197e9852c$var$increment();
const $f295bb9197e9852c$export$9c8d678629b3d3 = $f295bb9197e9852c$var$increment();
const $f295bb9197e9852c$export$2ad25cfebf36cacd = $f295bb9197e9852c$var$increment();
function $f295bb9197e9852c$var$increment() {
    return 2 ** ++$f295bb9197e9852c$var$powers;
}


const $fde6eb78b575b4e1$var$checks = /** @type {ReadonlyArray<keyof typeof types>} */ Object.keys($f295bb9197e9852c$exports);
class $fde6eb78b575b4e1$export$ea6b9f0064e88c9b extends (0, $931174b915b83d11$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $fde6eb78b575b4e1$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $fde6eb78b575b4e1$var$checks.length){
            const check = $fde6eb78b575b4e1$var$checks[index];
            $fde6eb78b575b4e1$var$mark(this, $fde6eb78b575b4e1$var$checks[index], (mask & $f295bb9197e9852c$exports[check]) === $f295bb9197e9852c$exports[check]);
        }
    }
}
$fde6eb78b575b4e1$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */ function $fde6eb78b575b4e1$var$mark(values, key, value) {
    if (value) values[key] = value;
}



function $bd8fc82c7dbd2264$export$185802fd694ee1f5(definition) {
    /** @type {Record<string, Info>} */ const properties = {};
    /** @type {Record<string, string>} */ const normals = {};
    for (const [property, value] of Object.entries(definition.properties)){
        const info = new (0, $fde6eb78b575b4e1$export$ea6b9f0064e88c9b)(property, definition.transform(definition.attributes || {}, property), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(property)) info.mustUseProperty = true;
        properties[property] = info;
        normals[(0, $ba2c06c56b858c9f$export$a3295358bff77e)(property)] = property;
        normals[(0, $ba2c06c56b858c9f$export$a3295358bff77e)(info.attribute)] = property;
    }
    return new (0, $5b6f5f4bade80e38$export$19342e026b58ebb7)(properties, normals, definition.space);
}



const $a7a872812b997c09$export$4d2d26490572750a = (0, $bd8fc82c7dbd2264$export$185802fd694ee1f5)({
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaColIndex: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaColSpan: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaControls: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        ariaLevel: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaPressed: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaRowIndex: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaRowSpan: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaSelected: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaValueMin: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaValueNow: (0, $f295bb9197e9852c$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    },
    transform (_, property) {
        return property === 'role' ? property : 'aria-' + property.slice(4).toLowerCase();
    }
});


/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */ function $e47247141b1c434c$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $a8641c7a75429d5d$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $e47247141b1c434c$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}




const $cb6d793047917c76$export$c0bb0b647f701bb5 = (0, $bd8fc82c7dbd2264$export$185802fd694ee1f5)({
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $f295bb9197e9852c$export$9c8d678629b3d3),
        acceptCharset: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        accessKey: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        allowPaymentRequest: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        allowUserMedia: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        alpha: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        autoFocus: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        autoPlay: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        blocking: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        cite: null,
        className: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        closedBy: null,
        colorSpace: null,
        cols: (0, $f295bb9197e9852c$export$98e628dec113755e),
        colSpan: (0, $f295bb9197e9852c$export$98e628dec113755e),
        command: null,
        commandFor: null,
        content: null,
        contentEditable: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        controls: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        controlsList: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        coords: (0, $f295bb9197e9852c$export$98e628dec113755e) | (0, $f295bb9197e9852c$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        defer: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        download: (0, $f295bb9197e9852c$export$242ac3d3042558aa),
        draggable: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        height: (0, $f295bb9197e9852c$export$98e628dec113755e),
        hidden: (0, $f295bb9197e9852c$export$242ac3d3042558aa),
        high: (0, $f295bb9197e9852c$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        httpEquiv: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        itemRef: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        itemScope: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        itemType: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        low: (0, $f295bb9197e9852c$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $f295bb9197e9852c$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $f295bb9197e9852c$export$98e628dec113755e),
        multiple: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        muted: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        noValidate: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        optimum: (0, $f295bb9197e9852c$export$98e628dec113755e),
        pattern: null,
        ping: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        required: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        reversed: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        rows: (0, $f295bb9197e9852c$export$98e628dec113755e),
        rowSpan: (0, $f295bb9197e9852c$export$98e628dec113755e),
        sandbox: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        seamless: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        selected: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        shadowRootClonable: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        shadowRootCustomElementRegistry: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        shadowRootMode: null,
        shadowRootSerializable: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        shape: null,
        size: (0, $f295bb9197e9852c$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $f295bb9197e9852c$export$98e628dec113755e),
        spellCheck: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $f295bb9197e9852c$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $f295bb9197e9852c$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        useMap: null,
        value: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        width: (0, $f295bb9197e9852c$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $f295bb9197e9852c$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $f295bb9197e9852c$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        declare: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $f295bb9197e9852c$export$98e628dec113755e),
        leftMargin: (0, $f295bb9197e9852c$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $f295bb9197e9852c$export$98e628dec113755e),
        marginWidth: (0, $f295bb9197e9852c$export$98e628dec113755e),
        noResize: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        noHref: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        noShade: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        noWrap: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $f295bb9197e9852c$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $f295bb9197e9852c$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $f295bb9197e9852c$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $f295bb9197e9852c$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        credentialless: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        disablePictureInPicture: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        disableRemotePlayback: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        exportParts: (0, $f295bb9197e9852c$export$9c8d678629b3d3),
        part: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        prefix: null,
        property: null,
        results: (0, $f295bb9197e9852c$export$98e628dec113755e),
        security: null,
        unselectable: null
    },
    space: 'html',
    transform: (0, $a8641c7a75429d5d$export$32b9e4cec9c208e1)
});





const $e49bd033a0fe3be1$export$7ed1367e7fa1ad68 = (0, $bd8fc82c7dbd2264$export$185802fd694ee1f5)({
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        maskType: 'mask-type',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    properties: {
        about: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        accentHeight: (0, $f295bb9197e9852c$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $f295bb9197e9852c$export$98e628dec113755e),
        amplitude: (0, $f295bb9197e9852c$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $f295bb9197e9852c$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $f295bb9197e9852c$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $f295bb9197e9852c$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $f295bb9197e9852c$export$98e628dec113755e),
        className: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $f295bb9197e9852c$export$98e628dec113755e),
        diffuseConstant: (0, $f295bb9197e9852c$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $f295bb9197e9852c$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $f295bb9197e9852c$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $f295bb9197e9852c$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $f295bb9197e9852c$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $f295bb9197e9852c$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $f295bb9197e9852c$export$9c8d678629b3d3),
        g2: (0, $f295bb9197e9852c$export$9c8d678629b3d3),
        glyphName: (0, $f295bb9197e9852c$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $f295bb9197e9852c$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $f295bb9197e9852c$export$98e628dec113755e),
        horizOriginX: (0, $f295bb9197e9852c$export$98e628dec113755e),
        horizOriginY: (0, $f295bb9197e9852c$export$98e628dec113755e),
        id: null,
        ideographic: (0, $f295bb9197e9852c$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $f295bb9197e9852c$export$98e628dec113755e),
        k: (0, $f295bb9197e9852c$export$98e628dec113755e),
        k1: (0, $f295bb9197e9852c$export$98e628dec113755e),
        k2: (0, $f295bb9197e9852c$export$98e628dec113755e),
        k3: (0, $f295bb9197e9852c$export$98e628dec113755e),
        k4: (0, $f295bb9197e9852c$export$98e628dec113755e),
        kernelMatrix: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $f295bb9197e9852c$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskType: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $f295bb9197e9852c$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $f295bb9197e9852c$export$98e628dec113755e),
        overlineThickness: (0, $f295bb9197e9852c$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $f295bb9197e9852c$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $f295bb9197e9852c$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $f295bb9197e9852c$export$98e628dec113755e),
        pointsAtY: (0, $f295bb9197e9852c$export$98e628dec113755e),
        pointsAtZ: (0, $f295bb9197e9852c$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        rev: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        requiredFonts: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        requiredFormats: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $f295bb9197e9852c$export$98e628dec113755e),
        specularExponent: (0, $f295bb9197e9852c$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $f295bb9197e9852c$export$98e628dec113755e),
        strikethroughThickness: (0, $f295bb9197e9852c$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $f295bb9197e9852c$export$98e628dec113755e),
        strokeOpacity: (0, $f295bb9197e9852c$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $f295bb9197e9852c$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        tabIndex: (0, $f295bb9197e9852c$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $f295bb9197e9852c$export$98e628dec113755e),
        targetY: (0, $f295bb9197e9852c$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $f295bb9197e9852c$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $f295bb9197e9852c$export$98e628dec113755e),
        underlineThickness: (0, $f295bb9197e9852c$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $f295bb9197e9852c$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $f295bb9197e9852c$export$98e628dec113755e),
        vMathematical: (0, $f295bb9197e9852c$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $f295bb9197e9852c$export$98e628dec113755e),
        vIdeographic: (0, $f295bb9197e9852c$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $f295bb9197e9852c$export$98e628dec113755e),
        vertOriginX: (0, $f295bb9197e9852c$export$98e628dec113755e),
        vertOriginY: (0, $f295bb9197e9852c$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $f295bb9197e9852c$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    },
    space: 'svg',
    transform: (0, $e47247141b1c434c$export$5b10b3bc32d7efbc)
});



const $ec16e1a70aace7f3$export$2bd1230ec7600845 = (0, $bd8fc82c7dbd2264$export$185802fd694ee1f5)({
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    },
    space: 'xlink',
    transform (_, property) {
        return 'xlink:' + property.slice(5).toLowerCase();
    }
});




const $d7385802919f055d$export$e20c24a128671213 = (0, $bd8fc82c7dbd2264$export$185802fd694ee1f5)({
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    properties: {
        xmlnsXLink: null,
        xmlns: null
    },
    space: 'xmlns',
    transform: (0, $a8641c7a75429d5d$export$32b9e4cec9c208e1)
});



const $77e09804dbfc627e$export$f2913fe8983302e = (0, $bd8fc82c7dbd2264$export$185802fd694ee1f5)({
    properties: {
        xmlBase: null,
        xmlLang: null,
        xmlSpace: null
    },
    space: 'xml',
    transform (_, property) {
        return 'xml:' + property.slice(3).toLowerCase();
    }
});



/**
 * @import {Schema} from 'property-information'
 */ 


const $bf985dcc478ecc33$var$cap = /[A-Z]/g;
const $bf985dcc478ecc33$var$dash = /-[a-z]/g;
const $bf985dcc478ecc33$var$valid = /^data[-\w.:]+$/i;
function $bf985dcc478ecc33$export$71aa6c912b956294(schema, value) {
    const normal = (0, $ba2c06c56b858c9f$export$a3295358bff77e)(value);
    let property = value;
    let Type = (0, $931174b915b83d11$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $bf985dcc478ecc33$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($bf985dcc478ecc33$var$dash, $bf985dcc478ecc33$var$camelcase);
            property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$bf985dcc478ecc33$var$dash.test(rest)) {
                let dashes = rest.replace($bf985dcc478ecc33$var$cap, $bf985dcc478ecc33$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $fde6eb78b575b4e1$export$ea6b9f0064e88c9b);
    }
    return new Type(property, value);
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */ function $bf985dcc478ecc33$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */ function $bf985dcc478ecc33$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}



const $4a602dd2fd780674$export$c0bb0b647f701bb5 = (0, $61ded5fe6f037163$export$4950aa0f605343fb)([
    (0, $a7a872812b997c09$export$4d2d26490572750a),
    (0, $cb6d793047917c76$export$c0bb0b647f701bb5),
    (0, $ec16e1a70aace7f3$export$2bd1230ec7600845),
    (0, $d7385802919f055d$export$e20c24a128671213),
    (0, $77e09804dbfc627e$export$f2913fe8983302e)
], 'html');
const $4a602dd2fd780674$export$7ed1367e7fa1ad68 = (0, $61ded5fe6f037163$export$4950aa0f605343fb)([
    (0, $a7a872812b997c09$export$4d2d26490572750a),
    (0, $e49bd033a0fe3be1$export$7ed1367e7fa1ad68),
    (0, $ec16e1a70aace7f3$export$2bd1230ec7600845),
    (0, $d7385802919f055d$export$e20c24a128671213),
    (0, $77e09804dbfc627e$export$f2913fe8983302e)
], 'svg');


/**
 * @import {Nodes, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */ /**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */ const $d8755cce0f2ae50e$var$own = {}.hasOwnProperty;
function $d8755cce0f2ae50e$export$d6a12bfbbedf6185(key, options) {
    const settings = options || {};
    /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */ function one(value, ...parameters) {
        /** @type {Handler|undefined} */ let fn = one.invalid;
        const handlers = one.handlers;
        if (value && $d8755cce0f2ae50e$var$own.call(value, key)) {
            // @ts-expect-error Indexable.
            const id = String(value[key]);
            // @ts-expect-error Indexable.
            fn = $d8755cce0f2ae50e$var$own.call(handlers, id) ? handlers[id] : one.unknown;
        }
        if (fn) return fn.call(this, value, ...parameters);
    }
    one.handlers = settings.handlers || {};
    one.invalid = settings.invalid;
    one.unknown = settings.unknown;
    // @ts-expect-error: matches!
    return one;
}


/**
 * @import {Comment, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * @typedef {import('./core.js').CoreOptions & import('./util/format-smart.js').FormatSmartOptions} Options
 * @typedef {import('./core.js').CoreOptions} LightOptions
 */ /**
 * @typedef CoreOptions
 * @property {ReadonlyArray<string>} [subset=[]]
 *   Whether to only escape the given subset of characters.
 * @property {boolean} [escapeOnly=false]
 *   Whether to only escape possibly dangerous characters.
 *   Those characters are `"`, `&`, `'`, `<`, `>`, and `` ` ``.
 *
 * @typedef FormatOptions
 * @property {(code: number, next: number, options: CoreWithFormatOptions) => string} format
 *   Format strategy.
 *
 * @typedef {CoreOptions & FormatOptions & import('./util/format-smart.js').FormatSmartOptions} CoreWithFormatOptions
 */ const $be83e113c792aa3e$var$defaultSubsetRegex = /["&'<>`]/g;
const $be83e113c792aa3e$var$surrogatePairsRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
const $be83e113c792aa3e$var$controlCharactersRegex = // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
/[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
const $be83e113c792aa3e$var$regexEscapeRegex = /[|\\{}()[\]^$+*?.]/g;
/** @type {WeakMap<ReadonlyArray<string>, RegExp>} */ const $be83e113c792aa3e$var$subsetToRegexCache = new WeakMap();
function $be83e113c792aa3e$export$b75f8c4f8f3fbd14(value, options) {
    value = value.replace(options.subset ? $be83e113c792aa3e$var$charactersToExpressionCached(options.subset) : $be83e113c792aa3e$var$defaultSubsetRegex, basic);
    if (options.subset || options.escapeOnly) return value;
    return value// Surrogate pairs.
    .replace($be83e113c792aa3e$var$surrogatePairsRegex, surrogate)// BMP control characters (C0 except for LF, CR, SP; DEL; and some more
    // non-ASCII ones).
    .replace($be83e113c792aa3e$var$controlCharactersRegex, basic);
    /**
   * @param {string} pair
   * @param {number} index
   * @param {string} all
   */ function surrogate(pair, index, all) {
        return options.format((pair.charCodeAt(0) - 0xd800) * 0x400 + pair.charCodeAt(1) - 0xdc00 + 0x10000, all.charCodeAt(index + 2), options);
    }
    /**
   * @param {string} character
   * @param {number} index
   * @param {string} all
   */ function basic(character, index, all) {
        return options.format(character.charCodeAt(0), all.charCodeAt(index + 1), options);
    }
}
/**
 * A wrapper function that caches the result of `charactersToExpression` with a WeakMap.
 * This can improve performance when tooling calls `charactersToExpression` repeatedly
 * with the same subset.
 *
 * @param {ReadonlyArray<string>} subset
 * @returns {RegExp}
 */ function $be83e113c792aa3e$var$charactersToExpressionCached(subset) {
    let cached = $be83e113c792aa3e$var$subsetToRegexCache.get(subset);
    if (!cached) {
        cached = $be83e113c792aa3e$var$charactersToExpression(subset);
        $be83e113c792aa3e$var$subsetToRegexCache.set(subset, cached);
    }
    return cached;
}
/**
 * @param {ReadonlyArray<string>} subset
 * @returns {RegExp}
 */ function $be83e113c792aa3e$var$charactersToExpression(subset) {
    /** @type {Array<string>} */ const groups = [];
    let index = -1;
    while(++index < subset.length)groups.push(subset[index].replace($be83e113c792aa3e$var$regexEscapeRegex, '\\$&'));
    return new RegExp('(?:' + groups.join('|') + ')', 'g');
}


/**
 * @typedef FormatSmartOptions
 * @property {boolean} [useNamedReferences=false]
 *   Prefer named character references (`&amp;`) where possible.
 * @property {boolean} [useShortestReferences=false]
 *   Prefer the shortest possible reference, if that results in less bytes.
 *   **Note**: `useNamedReferences` can be omitted when using `useShortestReferences`.
 * @property {boolean} [omitOptionalSemicolons=false]
 *   Whether to omit semicolons when possible.
 *   **Note**: This creates what HTML calls “parse errors” but is otherwise still valid HTML — don’t use this except when building a minifier.
 *   Omitting semicolons is possible for certain named and numeric references in some cases.
 * @property {boolean} [attribute=false]
 *   Create character references which don’t fail in attributes.
 *   **Note**: `attribute` only applies when operating dangerously with
 *   `omitOptionalSemicolons: true`.
 */ const $df81b310ceb23cda$var$hexadecimalRegex = /[\dA-Fa-f]/;
function $df81b310ceb23cda$export$ef12b12fd64fa3cc(code, next, omit) {
    const value = '&#x' + code.toString(16).toUpperCase();
    return omit && next && !$df81b310ceb23cda$var$hexadecimalRegex.test(String.fromCharCode(next)) ? value : value + ';';
}


const $05dab367b75fcb8f$var$decimalRegex = /\d/;
function $05dab367b75fcb8f$export$63ad841d70774900(code, next, omit) {
    const value = '&#' + String(code);
    return omit && next && !$05dab367b75fcb8f$var$decimalRegex.test(String.fromCharCode(next)) ? value : value + ';';
}


/**
 * List of legacy HTML named character references that don’t need a trailing semicolon.
 *
 * @type {Array<string>}
 */ const $de999355bf6886a7$export$9545335bdecb4b8c = [
    'AElig',
    'AMP',
    'Aacute',
    'Acirc',
    'Agrave',
    'Aring',
    'Atilde',
    'Auml',
    'COPY',
    'Ccedil',
    'ETH',
    'Eacute',
    'Ecirc',
    'Egrave',
    'Euml',
    'GT',
    'Iacute',
    'Icirc',
    'Igrave',
    'Iuml',
    'LT',
    'Ntilde',
    'Oacute',
    'Ocirc',
    'Ograve',
    'Oslash',
    'Otilde',
    'Ouml',
    'QUOT',
    'REG',
    'THORN',
    'Uacute',
    'Ucirc',
    'Ugrave',
    'Uuml',
    'Yacute',
    'aacute',
    'acirc',
    'acute',
    'aelig',
    'agrave',
    'amp',
    'aring',
    'atilde',
    'auml',
    'brvbar',
    'ccedil',
    'cedil',
    'cent',
    'copy',
    'curren',
    'deg',
    'divide',
    'eacute',
    'ecirc',
    'egrave',
    'eth',
    'euml',
    'frac12',
    'frac14',
    'frac34',
    'gt',
    'iacute',
    'icirc',
    'iexcl',
    'igrave',
    'iquest',
    'iuml',
    'laquo',
    'lt',
    'macr',
    'micro',
    'middot',
    'nbsp',
    'not',
    'ntilde',
    'oacute',
    'ocirc',
    'ograve',
    'ordf',
    'ordm',
    'oslash',
    'otilde',
    'ouml',
    'para',
    'plusmn',
    'pound',
    'quot',
    'raquo',
    'reg',
    'sect',
    'shy',
    'sup1',
    'sup2',
    'sup3',
    'szlig',
    'thorn',
    'times',
    'uacute',
    'ucirc',
    'ugrave',
    'uml',
    'uuml',
    'yacute',
    'yen',
    'yuml'
];


/**
 * Map of named character references from HTML 4.
 *
 * @type {Record<string, string>}
 */ const $31f92da27c931dcb$export$40952e41c47e8e55 = {
    nbsp: "\xa0",
    iexcl: "\xa1",
    cent: "\xa2",
    pound: "\xa3",
    curren: "\xa4",
    yen: "\xa5",
    brvbar: "\xa6",
    sect: "\xa7",
    uml: "\xa8",
    copy: "\xa9",
    ordf: "\xaa",
    laquo: "\xab",
    not: "\xac",
    shy: "\xad",
    reg: "\xae",
    macr: "\xaf",
    deg: "\xb0",
    plusmn: "\xb1",
    sup2: "\xb2",
    sup3: "\xb3",
    acute: "\xb4",
    micro: "\xb5",
    para: "\xb6",
    middot: "\xb7",
    cedil: "\xb8",
    sup1: "\xb9",
    ordm: "\xba",
    raquo: "\xbb",
    frac14: "\xbc",
    frac12: "\xbd",
    frac34: "\xbe",
    iquest: "\xbf",
    Agrave: "\xc0",
    Aacute: "\xc1",
    Acirc: "\xc2",
    Atilde: "\xc3",
    Auml: "\xc4",
    Aring: "\xc5",
    AElig: "\xc6",
    Ccedil: "\xc7",
    Egrave: "\xc8",
    Eacute: "\xc9",
    Ecirc: "\xca",
    Euml: "\xcb",
    Igrave: "\xcc",
    Iacute: "\xcd",
    Icirc: "\xce",
    Iuml: "\xcf",
    ETH: "\xd0",
    Ntilde: "\xd1",
    Ograve: "\xd2",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Otilde: "\xd5",
    Ouml: "\xd6",
    times: "\xd7",
    Oslash: "\xd8",
    Ugrave: "\xd9",
    Uacute: "\xda",
    Ucirc: "\xdb",
    Uuml: "\xdc",
    Yacute: "\xdd",
    THORN: "\xde",
    szlig: "\xdf",
    agrave: "\xe0",
    aacute: "\xe1",
    acirc: "\xe2",
    atilde: "\xe3",
    auml: "\xe4",
    aring: "\xe5",
    aelig: "\xe6",
    ccedil: "\xe7",
    egrave: "\xe8",
    eacute: "\xe9",
    ecirc: "\xea",
    euml: "\xeb",
    igrave: "\xec",
    iacute: "\xed",
    icirc: "\xee",
    iuml: "\xef",
    eth: "\xf0",
    ntilde: "\xf1",
    ograve: "\xf2",
    oacute: "\xf3",
    ocirc: "\xf4",
    otilde: "\xf5",
    ouml: "\xf6",
    divide: "\xf7",
    oslash: "\xf8",
    ugrave: "\xf9",
    uacute: "\xfa",
    ucirc: "\xfb",
    uuml: "\xfc",
    yacute: "\xfd",
    thorn: "\xfe",
    yuml: "\xff",
    fnof: "\u0192",
    Alpha: "\u0391",
    Beta: "\u0392",
    Gamma: "\u0393",
    Delta: "\u0394",
    Epsilon: "\u0395",
    Zeta: "\u0396",
    Eta: "\u0397",
    Theta: "\u0398",
    Iota: "\u0399",
    Kappa: "\u039A",
    Lambda: "\u039B",
    Mu: "\u039C",
    Nu: "\u039D",
    Xi: "\u039E",
    Omicron: "\u039F",
    Pi: "\u03A0",
    Rho: "\u03A1",
    Sigma: "\u03A3",
    Tau: "\u03A4",
    Upsilon: "\u03A5",
    Phi: "\u03A6",
    Chi: "\u03A7",
    Psi: "\u03A8",
    Omega: "\u03A9",
    alpha: "\u03B1",
    beta: "\u03B2",
    gamma: "\u03B3",
    delta: "\u03B4",
    epsilon: "\u03B5",
    zeta: "\u03B6",
    eta: "\u03B7",
    theta: "\u03B8",
    iota: "\u03B9",
    kappa: "\u03BA",
    lambda: "\u03BB",
    mu: "\u03BC",
    nu: "\u03BD",
    xi: "\u03BE",
    omicron: "\u03BF",
    pi: "\u03C0",
    rho: "\u03C1",
    sigmaf: "\u03C2",
    sigma: "\u03C3",
    tau: "\u03C4",
    upsilon: "\u03C5",
    phi: "\u03C6",
    chi: "\u03C7",
    psi: "\u03C8",
    omega: "\u03C9",
    thetasym: "\u03D1",
    upsih: "\u03D2",
    piv: "\u03D6",
    bull: "\u2022",
    hellip: "\u2026",
    prime: "\u2032",
    Prime: "\u2033",
    oline: "\u203E",
    frasl: "\u2044",
    weierp: "\u2118",
    image: "\u2111",
    real: "\u211C",
    trade: "\u2122",
    alefsym: "\u2135",
    larr: "\u2190",
    uarr: "\u2191",
    rarr: "\u2192",
    darr: "\u2193",
    harr: "\u2194",
    crarr: "\u21B5",
    lArr: "\u21D0",
    uArr: "\u21D1",
    rArr: "\u21D2",
    dArr: "\u21D3",
    hArr: "\u21D4",
    forall: "\u2200",
    part: "\u2202",
    exist: "\u2203",
    empty: "\u2205",
    nabla: "\u2207",
    isin: "\u2208",
    notin: "\u2209",
    ni: "\u220B",
    prod: "\u220F",
    sum: "\u2211",
    minus: "\u2212",
    lowast: "\u2217",
    radic: "\u221A",
    prop: "\u221D",
    infin: "\u221E",
    ang: "\u2220",
    and: "\u2227",
    or: "\u2228",
    cap: "\u2229",
    cup: "\u222A",
    int: "\u222B",
    there4: "\u2234",
    sim: "\u223C",
    cong: "\u2245",
    asymp: "\u2248",
    ne: "\u2260",
    equiv: "\u2261",
    le: "\u2264",
    ge: "\u2265",
    sub: "\u2282",
    sup: "\u2283",
    nsub: "\u2284",
    sube: "\u2286",
    supe: "\u2287",
    oplus: "\u2295",
    otimes: "\u2297",
    perp: "\u22A5",
    sdot: "\u22C5",
    lceil: "\u2308",
    rceil: "\u2309",
    lfloor: "\u230A",
    rfloor: "\u230B",
    lang: "\u2329",
    rang: "\u232A",
    loz: "\u25CA",
    spades: "\u2660",
    clubs: "\u2663",
    hearts: "\u2665",
    diams: "\u2666",
    quot: '"',
    amp: '&',
    lt: '<',
    gt: '>',
    OElig: "\u0152",
    oelig: "\u0153",
    Scaron: "\u0160",
    scaron: "\u0161",
    Yuml: "\u0178",
    circ: "\u02C6",
    tilde: "\u02DC",
    ensp: "\u2002",
    emsp: "\u2003",
    thinsp: "\u2009",
    zwnj: "\u200C",
    zwj: "\u200D",
    lrm: "\u200E",
    rlm: "\u200F",
    ndash: "\u2013",
    mdash: "\u2014",
    lsquo: "\u2018",
    rsquo: "\u2019",
    sbquo: "\u201A",
    ldquo: "\u201C",
    rdquo: "\u201D",
    bdquo: "\u201E",
    dagger: "\u2020",
    Dagger: "\u2021",
    permil: "\u2030",
    lsaquo: "\u2039",
    rsaquo: "\u203A",
    euro: "\u20AC"
};


/**
 * List of legacy (that don’t need a trailing `;`) named references which could,
 * depending on what follows them, turn into a different meaning
 *
 * @type {Array<string>}
 */ const $4539a3a1194c77d4$export$39b76096d2f1d598 = [
    'cent',
    'copy',
    'divide',
    'gt',
    'lt',
    'not',
    'para',
    'times'
];


const $2509c2fe35eb8a8e$var$own = {}.hasOwnProperty;
/**
 * `characterEntitiesHtml4` but inverted.
 *
 * @type {Record<string, string>}
 */ const $2509c2fe35eb8a8e$var$characters = {};
/** @type {string} */ let $2509c2fe35eb8a8e$var$key;
for($2509c2fe35eb8a8e$var$key in 0, $31f92da27c931dcb$export$40952e41c47e8e55)if ($2509c2fe35eb8a8e$var$own.call((0, $31f92da27c931dcb$export$40952e41c47e8e55), $2509c2fe35eb8a8e$var$key)) $2509c2fe35eb8a8e$var$characters[(0, $31f92da27c931dcb$export$40952e41c47e8e55)[$2509c2fe35eb8a8e$var$key]] = $2509c2fe35eb8a8e$var$key;
const $2509c2fe35eb8a8e$var$notAlphanumericRegex = /[^\dA-Za-z]/;
function $2509c2fe35eb8a8e$export$b1e14dcd42472e57(code, next, omit, attribute) {
    const character = String.fromCharCode(code);
    if ($2509c2fe35eb8a8e$var$own.call($2509c2fe35eb8a8e$var$characters, character)) {
        const name = $2509c2fe35eb8a8e$var$characters[character];
        const value = '&' + name;
        if (omit && (0, $de999355bf6886a7$export$9545335bdecb4b8c).includes(name) && !(0, $4539a3a1194c77d4$export$39b76096d2f1d598).includes(name) && (!attribute || next && next !== 61 /* `=` */  && $2509c2fe35eb8a8e$var$notAlphanumericRegex.test(String.fromCharCode(next)))) return value;
        return value + ';';
    }
    return '';
}


function $c8f16a60635b4c95$export$f53904683bee23d7(code, next, options) {
    let numeric = (0, $df81b310ceb23cda$export$ef12b12fd64fa3cc)(code, next, options.omitOptionalSemicolons);
    /** @type {string|undefined} */ let named;
    if (options.useNamedReferences || options.useShortestReferences) named = (0, $2509c2fe35eb8a8e$export$b1e14dcd42472e57)(code, next, options.omitOptionalSemicolons, options.attribute);
    // Use the shortest numeric reference when requested.
    // A simple algorithm would use decimal for all code points under 100, as
    // those are shorter than hexadecimal:
    //
    // * `&#99;` vs `&#x63;` (decimal shorter)
    // * `&#100;` vs `&#x64;` (equal)
    //
    // However, because we take `next` into consideration when `omit` is used,
    // And it would be possible that decimals are shorter on bigger values as
    // well if `next` is hexadecimal but not decimal, we instead compare both.
    if ((options.useShortestReferences || !named) && options.useShortestReferences) {
        const decimal = (0, $05dab367b75fcb8f$export$63ad841d70774900)(code, next, options.omitOptionalSemicolons);
        if (decimal.length < numeric.length) numeric = decimal;
    }
    return named && (!options.useShortestReferences || named.length < numeric.length) ? named : numeric;
}


/**
 * The smallest way to encode a character.
 *
 * @param {number} code
 * @returns {string}
 */ function $4a5926d13de942f8$export$83cfa611e0071208(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


function $51ed71ac0e17212a$export$aca9de459d63ca2e(value, options) {
    return (0, $be83e113c792aa3e$export$b75f8c4f8f3fbd14)(value, Object.assign({
        format: (0, $c8f16a60635b4c95$export$f53904683bee23d7)
    }, options));
}
function $51ed71ac0e17212a$export$a2577b9dadf100a3(value, options) {
    return (0, $be83e113c792aa3e$export$b75f8c4f8f3fbd14)(value, Object.assign({
        format: (0, $4a5926d13de942f8$export$83cfa611e0071208)
    }, options));
}


const $e81367c0d9e28649$var$htmlCommentRegex = /^>|^->|<!--|-->|--!>|<!-$/g;
// Declare arrays as variables so it can be cached by `stringifyEntities`
const $e81367c0d9e28649$var$bogusCommentEntitySubset = [
    '>'
];
const $e81367c0d9e28649$var$commentEntitySubset = [
    '<',
    '>'
];
function $e81367c0d9e28649$export$4a34f930e789283c(node, _1, _2, state) {
    // See: <https://html.spec.whatwg.org/multipage/syntax.html#comments>
    return state.settings.bogusComments ? '<?' + (0, $51ed71ac0e17212a$export$aca9de459d63ca2e)(node.value, Object.assign({}, state.settings.characterReferences, {
        subset: $e81367c0d9e28649$var$bogusCommentEntitySubset
    })) + '>' : '<!--' + node.value.replace($e81367c0d9e28649$var$htmlCommentRegex, encode) + '-->';
    /**
   * @param {string} $0
   */ function encode($0) {
        return (0, $51ed71ac0e17212a$export$aca9de459d63ca2e)($0, Object.assign({}, state.settings.characterReferences, {
            subset: $e81367c0d9e28649$var$commentEntitySubset
        }));
    }
}


/**
 * @import {Doctype, Parents} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * Serialize a doctype.
 *
 * @param {Doctype} _1
 *   Node to handle.
 * @param {number | undefined} _2
 *   Index of `node` in `parent.
 * @param {Parents | undefined} _3
 *   Parent of `node`.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {string}
 *   Serialized node.
 */ function $892d0aa686fc15c4$export$3c172dfa1c27da99(_1, _2, _3, state) {
    return '<!' + (state.settings.upperDoctype ? 'DOCTYPE' : 'doctype') + (state.settings.tightDoctype ? '' : ' ') + 'html>';
}


/**
 * @import {Element, Parents, Properties} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $0a2ba9e7c068e553$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== 'string') throw new TypeError('Expected character');
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}


/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $7ae77a5ec40be267$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || '');
    let index = input.indexOf(',');
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $7ae77a5ec40be267$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === '' ? [
        ...values,
        ''
    ] : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}



/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $71c7202b4e4c47aa$export$98e6a39c04603d36(value) {
    const input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $71c7202b4e4c47aa$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}



/**
 * @import {Element, Parents} from 'hast'
 */ /**
 * @typedef {import('hast').Nodes} Nodes
 */ // HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $fd7a7f8b3a6986d8$var$re = /[ \t\n\f\r]/g;
function $fd7a7f8b3a6986d8$export$7af1228ff777d175(thing) {
    return typeof thing === 'object' ? thing.type === 'text' ? $fd7a7f8b3a6986d8$var$empty(thing.value) : false : $fd7a7f8b3a6986d8$var$empty(thing);
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $fd7a7f8b3a6986d8$var$empty(value) {
    return value.replace($fd7a7f8b3a6986d8$var$re, '') === '';
}


/**
 * @import {Parents, RootContent} from 'hast'
 */ 
const $4028a14ad7e5b42e$export$a0f7cf204d8f22ba = $4028a14ad7e5b42e$var$siblings(1);
const $4028a14ad7e5b42e$export$b103c35f55382246 = $4028a14ad7e5b42e$var$siblings(-1);
/** @type {Array<RootContent>} */ const $4028a14ad7e5b42e$var$emptyChildren = [];
/**
 * Factory to check siblings in a direction.
 *
 * @param {number} increment
 */ function $4028a14ad7e5b42e$var$siblings(increment) {
    return sibling;
    /**
   * Find applicable siblings in a direction.
   *
   * @template {Parents} Parent
   *   Parent type.
   * @param {Parent | undefined} parent
   *   Parent.
   * @param {number | undefined} index
   *   Index of child in `parent`.
   * @param {boolean | undefined} [includeWhitespace=false]
   *   Whether to include whitespace (default: `false`).
   * @returns {Parent extends {children: Array<infer Child>} ? Child | undefined : never}
   *   Child of parent.
   */ function sibling(parent, index, includeWhitespace) {
        const siblings = parent ? parent.children : $4028a14ad7e5b42e$var$emptyChildren;
        let offset = (index || 0) + increment;
        let next = siblings[offset];
        if (!includeWhitespace) while(next && (0, $fd7a7f8b3a6986d8$export$7af1228ff777d175)(next)){
            offset += increment;
            next = siblings[offset];
        }
        // @ts-expect-error: it’s a correct child.
        return next;
    }
}


/**
 * @import {Element, Parents} from 'hast'
 */ /**
 * @callback OmitHandle
 *   Check if a tag can be omitted.
 * @param {Element} element
 *   Element to check.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether to omit a tag.
 *
 */ const $f4eb25417ae3fbc0$var$own = {}.hasOwnProperty;
function $f4eb25417ae3fbc0$export$67d072dabf9c1c63(handlers) {
    return omit;
    /**
   * Check if a given node can have a tag omitted.
   *
   * @type {OmitHandle}
   */ function omit(node, index, parent) {
        return $f4eb25417ae3fbc0$var$own.call(handlers, node.tagName) && handlers[node.tagName](node, index, parent);
    }
}


const $feba5139081efb7b$export$4e69df80cd44263b = (0, $f4eb25417ae3fbc0$export$67d072dabf9c1c63)({
    body: $feba5139081efb7b$var$body,
    caption: $feba5139081efb7b$var$headOrColgroupOrCaption,
    colgroup: $feba5139081efb7b$var$headOrColgroupOrCaption,
    dd: $feba5139081efb7b$var$dd,
    dt: $feba5139081efb7b$var$dt,
    head: $feba5139081efb7b$var$headOrColgroupOrCaption,
    html: $feba5139081efb7b$var$html,
    li: $feba5139081efb7b$var$li,
    optgroup: $feba5139081efb7b$var$optgroup,
    option: $feba5139081efb7b$var$option,
    p: $feba5139081efb7b$var$p,
    rp: $feba5139081efb7b$var$rubyElement,
    rt: $feba5139081efb7b$var$rubyElement,
    tbody: $feba5139081efb7b$var$tbody,
    td: $feba5139081efb7b$var$cells,
    tfoot: $feba5139081efb7b$var$tfoot,
    th: $feba5139081efb7b$var$cells,
    thead: $feba5139081efb7b$var$thead,
    tr: $feba5139081efb7b$var$tr
});
/**
 * Macro for `</head>`, `</colgroup>`, and `</caption>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$headOrColgroupOrCaption(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index, true);
    return !next || next.type !== 'comment' && !(next.type === 'text' && (0, $fd7a7f8b3a6986d8$export$7af1228ff777d175)(next.value.charAt(0)));
}
/**
 * Whether to omit `</html>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$html(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type !== 'comment';
}
/**
 * Whether to omit `</body>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$body(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type !== 'comment';
}
/**
 * Whether to omit `</p>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$p(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return next ? next.type === 'element' && (next.tagName === 'address' || next.tagName === 'article' || next.tagName === 'aside' || next.tagName === 'blockquote' || next.tagName === 'details' || next.tagName === 'div' || next.tagName === 'dl' || next.tagName === 'fieldset' || next.tagName === 'figcaption' || next.tagName === 'figure' || next.tagName === 'footer' || next.tagName === 'form' || next.tagName === 'h1' || next.tagName === 'h2' || next.tagName === 'h3' || next.tagName === 'h4' || next.tagName === 'h5' || next.tagName === 'h6' || next.tagName === 'header' || next.tagName === 'hgroup' || next.tagName === 'hr' || next.tagName === 'main' || next.tagName === 'menu' || next.tagName === 'nav' || next.tagName === 'ol' || next.tagName === 'p' || next.tagName === 'pre' || next.tagName === 'section' || next.tagName === 'table' || next.tagName === 'ul') : !parent || // Confusing parent.
    !(parent.type === 'element' && (parent.tagName === 'a' || parent.tagName === 'audio' || parent.tagName === 'del' || parent.tagName === 'ins' || parent.tagName === 'map' || parent.tagName === 'noscript' || parent.tagName === 'video'));
}
/**
 * Whether to omit `</li>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$li(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'li';
}
/**
 * Whether to omit `</dt>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$dt(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return Boolean(next && next.type === 'element' && (next.tagName === 'dt' || next.tagName === 'dd'));
}
/**
 * Whether to omit `</dd>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$dd(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'dt' || next.tagName === 'dd');
}
/**
 * Whether to omit `</rt>` or `</rp>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$rubyElement(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'rp' || next.tagName === 'rt');
}
/**
 * Whether to omit `</optgroup>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$optgroup(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'optgroup';
}
/**
 * Whether to omit `</option>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$option(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'option' || next.tagName === 'optgroup');
}
/**
 * Whether to omit `</thead>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$thead(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return Boolean(next && next.type === 'element' && (next.tagName === 'tbody' || next.tagName === 'tfoot'));
}
/**
 * Whether to omit `</tbody>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$tbody(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'tbody' || next.tagName === 'tfoot');
}
/**
 * Whether to omit `</tfoot>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$tfoot(_, index, parent) {
    return !(0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
}
/**
 * Whether to omit `</tr>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$tr(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && next.tagName === 'tr';
}
/**
 * Whether to omit `</td>` or `</th>`.
 *
 * @param {Element} _
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the closing tag can be omitted.
 */ function $feba5139081efb7b$var$cells(_, index, parent) {
    const next = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(parent, index);
    return !next || next.type === 'element' && (next.tagName === 'td' || next.tagName === 'th');
}


/**
 * @import {Element, Parents} from 'hast'
 */ 



const $bd647600c029e7d0$export$47fa9d71658d4a69 = (0, $f4eb25417ae3fbc0$export$67d072dabf9c1c63)({
    body: $bd647600c029e7d0$var$body,
    colgroup: $bd647600c029e7d0$var$colgroup,
    head: $bd647600c029e7d0$var$head,
    html: $bd647600c029e7d0$var$html,
    tbody: $bd647600c029e7d0$var$tbody
});
/**
 * Whether to omit `<html>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $bd647600c029e7d0$var$html(node) {
    const head = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(node, -1);
    return !head || head.type !== 'comment';
}
/**
 * Whether to omit `<head>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $bd647600c029e7d0$var$head(node) {
    /** @type {Set<string>} */ const seen = new Set();
    // Whether `srcdoc` or not,
    // make sure the content model at least doesn’t have too many `base`s/`title`s.
    for (const child of node.children)if (child.type === 'element' && (child.tagName === 'base' || child.tagName === 'title')) {
        if (seen.has(child.tagName)) return false;
        seen.add(child.tagName);
    }
    // “May be omitted if the element is empty,
    // or if the first thing inside the head element is an element.”
    const child = node.children[0];
    return !child || child.type === 'element';
}
/**
 * Whether to omit `<body>`.
 *
 * @param {Element} node
 *   Element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $bd647600c029e7d0$var$body(node) {
    const head = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(node, -1, true);
    return !head || head.type !== 'comment' && !(head.type === 'text' && (0, $fd7a7f8b3a6986d8$export$7af1228ff777d175)(head.value.charAt(0))) && !(head.type === 'element' && (head.tagName === 'meta' || head.tagName === 'link' || head.tagName === 'script' || head.tagName === 'style' || head.tagName === 'template'));
}
/**
 * Whether to omit `<colgroup>`.
 * The spec describes some logic for the opening tag, but it’s easier to
 * implement in the closing tag, to the same effect, so we handle it there
 * instead.
 *
 * @param {Element} node
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $bd647600c029e7d0$var$colgroup(node, index, parent) {
    const previous = (0, $4028a14ad7e5b42e$export$b103c35f55382246)(parent, index);
    const head = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(node, -1, true);
    // Previous colgroup was already omitted.
    if (parent && previous && previous.type === 'element' && previous.tagName === 'colgroup' && (0, $feba5139081efb7b$export$4e69df80cd44263b)(previous, parent.children.indexOf(previous), parent)) return false;
    return Boolean(head && head.type === 'element' && head.tagName === 'col');
}
/**
 * Whether to omit `<tbody>`.
 *
 * @param {Element} node
 *   Element.
 * @param {number | undefined} index
 *   Index of element in parent.
 * @param {Parents | undefined} parent
 *   Parent of element.
 * @returns {boolean}
 *   Whether the opening tag can be omitted.
 */ function $bd647600c029e7d0$var$tbody(node, index, parent) {
    const previous = (0, $4028a14ad7e5b42e$export$b103c35f55382246)(parent, index);
    const head = (0, $4028a14ad7e5b42e$export$a0f7cf204d8f22ba)(node, -1);
    // Previous table section was already omitted.
    if (parent && previous && previous.type === 'element' && (previous.tagName === 'thead' || previous.tagName === 'tbody') && (0, $feba5139081efb7b$export$4e69df80cd44263b)(previous, parent.children.indexOf(previous), parent)) return false;
    return Boolean(head && head.type === 'element' && head.tagName === 'tr');
}


/**
 * Maps of subsets.
 *
 * Each value is a matrix of tuples.
 * The value at `0` causes parse errors, the value at `1` is valid.
 * Of both, the value at `0` is unsafe, and the value at `1` is safe.
 *
 * @type {Record<'double' | 'name' | 'single' | 'unquoted', Array<[Array<string>, Array<string>]>>}
 */ const $82a2b91dde661e6d$var$constants = {
    // See: <https://html.spec.whatwg.org/#attribute-name-state>.
    name: [
        [
            '\t\n\f\r &/=>'.split(''),
            '\t\n\f\r "&\'/=>`'.split('')
        ],
        [
            '\0\t\n\f\r "&\'/<=>'.split(''),
            '\0\t\n\f\r "&\'/<=>`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
    unquoted: [
        [
            '\t\n\f\r &>'.split(''),
            '\0\t\n\f\r "&\'<=>`'.split('')
        ],
        [
            '\0\t\n\f\r "&\'<=>`'.split(''),
            '\0\t\n\f\r "&\'<=>`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
    single: [
        [
            "&'".split(''),
            '"&\'`'.split('')
        ],
        [
            "\0&'".split(''),
            '\0"&\'`'.split('')
        ]
    ],
    // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
    double: [
        [
            '"&'.split(''),
            '"&\'`'.split('')
        ],
        [
            '\0"&'.split(''),
            '\0"&\'`'.split('')
        ]
    ]
};
function $82a2b91dde661e6d$export$8454457683f90105(node, index, parent, state) {
    const schema = state.schema;
    const omit = schema.space === 'svg' ? false : state.settings.omitOptionalTags;
    let selfClosing = schema.space === 'svg' ? state.settings.closeEmptyElements : state.settings.voids.includes(node.tagName.toLowerCase());
    /** @type {Array<string>} */ const parts = [];
    /** @type {string} */ let last;
    if (schema.space === 'html' && node.tagName === 'svg') state.schema = (0, $4a602dd2fd780674$export$7ed1367e7fa1ad68);
    const attributes = $82a2b91dde661e6d$var$serializeAttributes(state, node.properties);
    const content = state.all(schema.space === 'html' && node.tagName === 'template' ? node.content : node);
    state.schema = schema;
    // If the node is categorised as void, but it has children, remove the
    // categorisation.
    // This enables for example `menuitem`s, which are void in W3C HTML but not
    // void in WHATWG HTML, to be stringified properly.
    // Note: `menuitem` has since been removed from the HTML spec, and so is no
    // longer void.
    if (content) selfClosing = false;
    if (attributes || !omit || !(0, $bd647600c029e7d0$export$47fa9d71658d4a69)(node, index, parent)) {
        parts.push('<', node.tagName, attributes ? ' ' + attributes : '');
        if (selfClosing && (schema.space === 'svg' || state.settings.closeSelfClosing)) {
            last = attributes.charAt(attributes.length - 1);
            if (!state.settings.tightSelfClosing || last === '/' || last && last !== '"' && last !== "'") parts.push(' ');
            parts.push('/');
        }
        parts.push('>');
    }
    parts.push(content);
    if (!selfClosing && (!omit || !(0, $feba5139081efb7b$export$4e69df80cd44263b)(node, index, parent))) parts.push('</' + node.tagName + '>');
    return parts.join('');
}
/**
 * @param {State} state
 * @param {Properties | null | undefined} properties
 * @returns {string}
 */ function $82a2b91dde661e6d$var$serializeAttributes(state, properties) {
    /** @type {Array<string>} */ const values = [];
    let index = -1;
    /** @type {string} */ let key;
    if (properties) {
        for(key in properties)if (properties[key] !== null && properties[key] !== undefined) {
            const value = $82a2b91dde661e6d$var$serializeAttribute(state, key, properties[key]);
            if (value) values.push(value);
        }
    }
    while(++index < values.length){
        const last = state.settings.tightAttributes ? values[index].charAt(values[index].length - 1) : undefined;
        // In tight mode, don’t add a space after quoted attributes.
        if (index !== values.length - 1 && last !== '"' && last !== "'") values[index] += ' ';
    }
    return values.join('');
}
/**
 * @param {State} state
 * @param {string} key
 * @param {Properties[keyof Properties]} value
 * @returns {string}
 */ function $82a2b91dde661e6d$var$serializeAttribute(state, key, value) {
    const info = (0, $bf985dcc478ecc33$export$71aa6c912b956294)(state.schema, key);
    const x = state.settings.allowParseErrors && state.schema.space === 'html' ? 0 : 1;
    const y = state.settings.allowDangerousCharacters ? 0 : 1;
    let quote = state.quote;
    /** @type {string | undefined} */ let result;
    if (info.overloadedBoolean && (value === info.attribute || value === '')) value = true;
    else if ((info.boolean || info.overloadedBoolean) && (typeof value !== 'string' || value === info.attribute || value === '')) value = Boolean(value);
    if (value === null || value === undefined || value === false || typeof value === 'number' && Number.isNaN(value)) return '';
    const name = (0, $51ed71ac0e17212a$export$aca9de459d63ca2e)(info.attribute, Object.assign({}, state.settings.characterReferences, {
        // Always encode without parse errors in non-HTML.
        subset: $82a2b91dde661e6d$var$constants.name[x][y]
    }));
    // No value.
    // There is currently only one boolean property in SVG: `[download]` on
    // `<a>`.
    // This property does not seem to work in browsers (Firefox, Safari, Chrome),
    // so I can’t test if dropping the value works.
    // But I assume that it should:
    //
    // ```html
    // <!doctype html>
    // <svg viewBox="0 0 100 100">
    //   <a href=https://example.com download>
    //     <circle cx=50 cy=40 r=35 />
    //   </a>
    // </svg>
    // ```
    //
    // See: <https://github.com/wooorm/property-information/blob/main/lib/svg.js>
    if (value === true) return name;
    // `spaces` doesn’t accept a second argument, but it’s given here just to
    // keep the code cleaner.
    value = Array.isArray(value) ? (info.commaSeparated ? (0, $7ae77a5ec40be267$export$fac44ee5b035f737) : (0, $71c7202b4e4c47aa$export$fac44ee5b035f737))(value, {
        padLeft: !state.settings.tightCommaSeparatedLists
    }) : String(value);
    if (state.settings.collapseEmptyAttributes && !value) return name;
    // Check unquoted value.
    if (state.settings.preferUnquoted) result = (0, $51ed71ac0e17212a$export$aca9de459d63ca2e)(value, Object.assign({}, state.settings.characterReferences, {
        attribute: true,
        subset: $82a2b91dde661e6d$var$constants.unquoted[x][y]
    }));
    // If we don’t want unquoted, or if `value` contains character references when
    // unquoted…
    if (result !== value) {
        // If the alternative is less common than `quote`, switch.
        if (state.settings.quoteSmart && (0, $0a2ba9e7c068e553$export$fa42eaa97a352e23)(value, quote) > (0, $0a2ba9e7c068e553$export$fa42eaa97a352e23)(value, state.alternative)) quote = state.alternative;
        result = quote + (0, $51ed71ac0e17212a$export$aca9de459d63ca2e)(value, Object.assign({}, state.settings.characterReferences, {
            // Always encode without parse errors in non-HTML.
            subset: (quote === "'" ? $82a2b91dde661e6d$var$constants.single : $82a2b91dde661e6d$var$constants.double)[x][y],
            attribute: true
        })) + quote;
    }
    // Don’t add a `=` for unquoted empties.
    return name + (result ? '=' + result : result);
}


/**
 * @import {Parents} from 'hast'
 * @import {Raw} from 'mdast-util-to-hast'
 * @import {State} from '../index.js'
 */ /**
 * @import {Parents, Text} from 'hast'
 * @import {Raw} from 'mdast-util-to-hast'
 * @import {State} from '../index.js'
 */ 
// Declare array as variable so it can be cached by `stringifyEntities`
const $50b699f262121f17$var$textEntitySubset = [
    '<',
    '&'
];
function $50b699f262121f17$export$6f093cfa640b7166(node, _, parent, state) {
    // Check if content of `node` should be escaped.
    return parent && parent.type === 'element' && (parent.tagName === 'script' || parent.tagName === 'style') ? node.value : (0, $51ed71ac0e17212a$export$aca9de459d63ca2e)(node.value, Object.assign({}, state.settings.characterReferences, {
        subset: $50b699f262121f17$var$textEntitySubset
    }));
}


function $775880d0a9609b89$export$1776c186c69df29e(node, index, parent, state) {
    return state.settings.allowDangerousHtml ? node.value : (0, $50b699f262121f17$export$6f093cfa640b7166)(node, index, parent, state);
}


/**
 * @import {Parents, Root} from 'hast'
 * @import {State} from '../index.js'
 */ /**
 * Serialize a root.
 *
 * @param {Root} node
 *   Node to handle.
 * @param {number | undefined} _1
 *   Index of `node` in `parent.
 * @param {Parents | undefined} _2
 *   Parent of `node`.
 * @param {State} state
 *   Info passed around about the current state.
 * @returns {string}
 *   Serialized node.
 */ function $e9951500f110139c$export$e8e78c978b129247(node, _1, _2, state) {
    return state.all(node);
}



const $f16bb97f0156693a$export$8f34ce051745d39e = (0, $d8755cce0f2ae50e$export$d6a12bfbbedf6185)('type', {
    invalid: $f16bb97f0156693a$var$invalid,
    unknown: $f16bb97f0156693a$var$unknown,
    handlers: {
        comment: $e81367c0d9e28649$export$4a34f930e789283c,
        doctype: $892d0aa686fc15c4$export$3c172dfa1c27da99,
        element: $82a2b91dde661e6d$export$8454457683f90105,
        raw: $775880d0a9609b89$export$1776c186c69df29e,
        root: $e9951500f110139c$export$e8e78c978b129247,
        text: $50b699f262121f17$export$6f093cfa640b7166
    }
});
/**
 * Fail when a non-node is found in the tree.
 *
 * @param {unknown} node
 *   Unknown value.
 * @returns {never}
 *   Never.
 */ function $f16bb97f0156693a$var$invalid(node) {
    throw new Error('Expected node, not `' + node + '`');
}
/**
 * Fail when a node with an unknown type is found in the tree.
 *
 * @param {unknown} node_
 *  Unknown node.
 * @returns {never}
 *   Never.
 */ function $f16bb97f0156693a$var$unknown(node_) {
    // `type` is guaranteed by runtime JS.
    const node = /** @type {Nodes} */ node_;
    throw new Error('Cannot compile unknown node `' + node.type + '`');
}


/** @type {Options} */ const $3ac6c8c7f8865417$var$emptyOptions = {};
/** @type {CharacterReferences} */ const $3ac6c8c7f8865417$var$emptyCharacterReferences = {};
/** @type {Array<never>} */ const $3ac6c8c7f8865417$var$emptyChildren = [];
function $3ac6c8c7f8865417$export$a10125c086a4df16(tree, options) {
    const options_ = options || $3ac6c8c7f8865417$var$emptyOptions;
    const quote = options_.quote || '"';
    const alternative = quote === '"' ? "'" : '"';
    if (quote !== '"' && quote !== "'") throw new Error('Invalid quote `' + quote + '`, expected `\'` or `"`');
    /** @type {State} */ const state = {
        one: $3ac6c8c7f8865417$var$one,
        all: $3ac6c8c7f8865417$export$84bf76cd7afc7469,
        settings: {
            omitOptionalTags: options_.omitOptionalTags || false,
            allowParseErrors: options_.allowParseErrors || false,
            allowDangerousCharacters: options_.allowDangerousCharacters || false,
            quoteSmart: options_.quoteSmart || false,
            preferUnquoted: options_.preferUnquoted || false,
            tightAttributes: options_.tightAttributes || false,
            upperDoctype: options_.upperDoctype || false,
            tightDoctype: options_.tightDoctype || false,
            bogusComments: options_.bogusComments || false,
            tightCommaSeparatedLists: options_.tightCommaSeparatedLists || false,
            tightSelfClosing: options_.tightSelfClosing || false,
            collapseEmptyAttributes: options_.collapseEmptyAttributes || false,
            allowDangerousHtml: options_.allowDangerousHtml || false,
            voids: options_.voids || (0, $aa609dabe8f29803$export$762508062d068de),
            characterReferences: options_.characterReferences || $3ac6c8c7f8865417$var$emptyCharacterReferences,
            closeSelfClosing: options_.closeSelfClosing || false,
            closeEmptyElements: options_.closeEmptyElements || false
        },
        schema: options_.space === 'svg' ? (0, $4a602dd2fd780674$export$7ed1367e7fa1ad68) : (0, $4a602dd2fd780674$export$c0bb0b647f701bb5),
        quote: quote,
        alternative: alternative
    };
    return state.one(Array.isArray(tree) ? {
        type: 'root',
        children: tree
    } : tree, undefined, undefined);
}
/**
 * Serialize a node.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {Nodes} node
 *   Node to handle.
 * @param {number | undefined} index
 *   Index of `node` in `parent.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {string}
 *   Serialized node.
 */ function $3ac6c8c7f8865417$var$one(node, index, parent) {
    return (0, $f16bb97f0156693a$export$8f34ce051745d39e)(node, index, parent, this);
}
function $3ac6c8c7f8865417$export$84bf76cd7afc7469(parent) {
    /** @type {Array<string>} */ const results = [];
    const children = parent && parent.children || $3ac6c8c7f8865417$var$emptyChildren;
    let index = -1;
    while(++index < children.length)results[index] = this.one(children[index], index, parent);
    return results.join('');
}


//#region src/utils/hast.ts
const $2eb9c19caa629d78$var$RE_WHITESPACE = /\s+/g;
/**
* Utility to append class to a hast node
*
* If the `property.class` is a string, it will be splitted by space and converted to an array.
*/ function $2eb9c19caa629d78$export$12efa744f94fc0a9(node, className) {
    if (!className) return node;
    node.properties ||= {};
    node.properties.class ||= [];
    if (typeof node.properties.class === "string") node.properties.class = node.properties.class.split($2eb9c19caa629d78$var$RE_WHITESPACE);
    if (!Array.isArray(node.properties.class)) node.properties.class = [];
    const targets = Array.isArray(className) ? className : className.split($2eb9c19caa629d78$var$RE_WHITESPACE);
    for (const c of targets)if (c && !node.properties.class.includes(c)) node.properties.class.push(c);
    return node;
}
//#endregion
//#region src/utils/strings.ts
const $2eb9c19caa629d78$var$RE_LANG_ATTR = /:?lang=["']([^"']+)["']/g;
const $2eb9c19caa629d78$var$RE_CODE_FENCE = /(?:```|~~~)([\w-]+)/g;
const $2eb9c19caa629d78$var$RE_LATEX_BEGIN = /\\begin\{([\w-]+)\}/g;
const $2eb9c19caa629d78$var$RE_SCRIPT_LANG = /<script\s+(?:type|lang)=["']([^"']+)["']/gi;
const $2eb9c19caa629d78$var$RE_FRONTMATTER = /^\s*---\r?\n[\s\S]*?\r?\n---(?:\r?\n|\s*$)/;
/**
* Creates a converter between index and position in a code block.
*
* Overflow/underflow are unchecked.
*/ function $2eb9c19caa629d78$export$a1eb53fafbd3302c(code) {
    const lines = (0, $e150f61536b1a01a$export$88c07fe39db9eaa1)(code, true).map(([line])=>line);
    function indexToPos(index) {
        if (index === code.length) return {
            line: lines.length - 1,
            character: lines.at(-1).length
        };
        let character = index;
        let line = 0;
        for (const lineText of lines){
            if (character < lineText.length) break;
            character -= lineText.length;
            line++;
        }
        return {
            line: line,
            character: character
        };
    }
    function posToIndex(line, character) {
        let index = 0;
        for(let i = 0; i < line; i++)index += lines[i].length;
        index += character;
        return index;
    }
    return {
        lines: lines,
        indexToPos: indexToPos,
        posToIndex: posToIndex
    };
}
/**
* Guess embedded languages from given code and highlighter.
*
* When highlighter is provided, only bundled languages will be included.
*
* @param code - The code string to analyze
* @param _lang - The primary language of the code (currently unused)
* @param highlighter - Optional highlighter instance to validate languages
* @returns Array of detected language identifiers
*
* @example
* ```ts
* // Detects 'javascript' from Vue SFC
* guessEmbeddedLanguages('<script lang="javascript">')
*
* // Detects 'python' from markdown code block
* guessEmbeddedLanguages('```python\nprint("hi")\n```')
* ```
*/ function $2eb9c19caa629d78$export$5f773a1df8c6e1aa(code, _lang, highlighter) {
    const langs = /* @__PURE__ */ new Set();
    for (const match of code.matchAll($2eb9c19caa629d78$var$RE_LANG_ATTR)){
        const lang = match[1].toLowerCase().trim();
        if (lang) langs.add(lang);
    }
    for (const match of code.matchAll($2eb9c19caa629d78$var$RE_CODE_FENCE)){
        const lang = match[1].toLowerCase().trim();
        if (lang) langs.add(lang);
    }
    for (const match of code.matchAll($2eb9c19caa629d78$var$RE_LATEX_BEGIN)){
        const lang = match[1].toLowerCase().trim();
        if (lang) langs.add(lang);
    }
    for (const match of code.matchAll($2eb9c19caa629d78$var$RE_SCRIPT_LANG)){
        const fullType = match[1].toLowerCase().trim();
        const lang = fullType.includes("/") ? fullType.split("/").pop() : fullType;
        if (lang) langs.add(lang);
    }
    if ($2eb9c19caa629d78$var$RE_FRONTMATTER.test(code)) langs.add("yaml");
    if (!highlighter) return [
        ...langs
    ];
    const bundle = highlighter.getBundledLanguages();
    return [
        ...langs
    ].filter((l)=>l && bundle[l]);
}
const $2eb9c19caa629d78$var$COLOR_KEYS = [
    "color",
    "background-color"
];
//#endregion
//#region src/utils/tokens.ts
/**
* Split a token into multiple tokens by given offsets.
*
* The offsets are relative to the token, and should be sorted.
*/ function $2eb9c19caa629d78$export$b3cd5664f2c9e388(token, offsets) {
    let lastOffset = 0;
    const tokens = [];
    for (const offset of offsets){
        if (offset > lastOffset) tokens.push({
            ...token,
            content: token.content.slice(lastOffset, offset),
            offset: token.offset + lastOffset
        });
        lastOffset = offset;
    }
    if (lastOffset < token.content.length) tokens.push({
        ...token,
        content: token.content.slice(lastOffset),
        offset: token.offset + lastOffset
    });
    return tokens;
}
function $2eb9c19caa629d78$var$findFirstBreakpointAfter(breakpoints, offset) {
    let start = 0;
    let end = breakpoints.length;
    while(start < end){
        const middle = start + (end - start >> 1);
        if (breakpoints[middle] <= offset) start = middle + 1;
        else end = middle;
    }
    return start;
}
/**
* Split 2D tokens array by given breakpoints.
*/ function $2eb9c19caa629d78$export$d3e0fdeef870cacb(tokens, breakpoints) {
    const sorted = [
        ...breakpoints instanceof Set ? breakpoints : new Set(breakpoints)
    ].sort((a, b)=>a - b);
    if (!sorted.length) return tokens;
    return tokens.map((line)=>{
        return line.flatMap((token)=>{
            const tokenEnd = token.offset + token.content.length;
            const start = $2eb9c19caa629d78$var$findFirstBreakpointAfter(sorted, token.offset);
            let end = start;
            while(end < sorted.length && sorted[end] < tokenEnd)end++;
            if (start === end) return token;
            const breakpointsInToken = sorted.slice(start, end);
            for(let index = 0; index < breakpointsInToken.length; index++)breakpointsInToken[index] -= token.offset;
            return $2eb9c19caa629d78$export$b3cd5664f2c9e388(token, breakpointsInToken);
        });
    });
}
function $2eb9c19caa629d78$export$5a4c68029315ecd7(merged, variantsOrder, cssVariablePrefix, defaultColor, colorsRendering = "css-vars") {
    const token = {
        content: merged.content,
        explanation: merged.explanation,
        offset: merged.offset
    };
    const styles = variantsOrder.map((t)=>$2eb9c19caa629d78$export$94ffab218337d127(merged.variants[t]));
    const styleKeys = new Set(styles.flatMap((t)=>Object.keys(t)));
    const mergedStyles = {};
    const varKey = (idx, key)=>{
        const keyName = key === "color" ? "" : key === "background-color" ? "-bg" : `-${key}`;
        return cssVariablePrefix + variantsOrder[idx] + (key === "color" ? "" : keyName);
    };
    styles.forEach((cur, idx)=>{
        for (const key of styleKeys){
            const value = cur[key] || "inherit";
            if (idx === 0 && defaultColor && $2eb9c19caa629d78$var$COLOR_KEYS.includes(key)) {
                if (defaultColor === "light-dark()" && styles.length > 1) {
                    const lightIndex = variantsOrder.findIndex((t)=>t === "light");
                    const darkIndex = variantsOrder.findIndex((t)=>t === "dark");
                    if (lightIndex === -1 || darkIndex === -1) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)("When using `defaultColor: \"light-dark()\"`, you must provide both `light` and `dark` themes");
                    const lightValue = styles[lightIndex][key] || "inherit";
                    const darkValue = styles[darkIndex][key] || "inherit";
                    mergedStyles[key] = `light-dark(${lightValue}, ${darkValue})`;
                    if (colorsRendering === "css-vars") mergedStyles[varKey(idx, key)] = value;
                } else mergedStyles[key] = value;
            } else if (colorsRendering === "css-vars") mergedStyles[varKey(idx, key)] = value;
        }
    });
    token.htmlStyle = mergedStyles;
    return token;
}
function $2eb9c19caa629d78$export$94ffab218337d127(token) {
    const styles = {};
    if (token.color) styles.color = token.color;
    if (token.bgColor) styles["background-color"] = token.bgColor;
    if (token.fontStyle) {
        if (token.fontStyle & (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).Italic) styles["font-style"] = "italic";
        if (token.fontStyle & (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).Bold) styles["font-weight"] = "bold";
        const decorations = [];
        if (token.fontStyle & (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).Underline) decorations.push("underline");
        if (token.fontStyle & (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).Strikethrough) decorations.push("line-through");
        if (decorations.length) styles["text-decoration"] = decorations.join(" ");
    }
    return styles;
}
function $2eb9c19caa629d78$export$10559b52119e8d5f(token) {
    if (typeof token === "string") return token;
    return Object.entries(token).map(([key, value])=>`${key}:${value}`).join(";");
}
//#endregion
//#region src/transformer-decorations.ts
/**
* A built-in transformer to add decorations to the highlighted code.
*/ function $2eb9c19caa629d78$export$b094ad6c92e029a8() {
    const map = /* @__PURE__ */ new WeakMap();
    function getContext(shiki) {
        if (!map.has(shiki.meta)) {
            const converter = $2eb9c19caa629d78$export$a1eb53fafbd3302c(shiki.source);
            function normalizePosition(p) {
                if (typeof p === "number") {
                    if (p < 0 || p > shiki.source.length) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Invalid decoration offset: ${p}. Code length: ${shiki.source.length}`);
                    return {
                        ...converter.indexToPos(p),
                        offset: p
                    };
                } else {
                    const line = converter.lines[p.line];
                    if (line === void 0) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Invalid decoration position ${JSON.stringify(p)}. Lines length: ${converter.lines.length}`);
                    let character = p.character;
                    if (character < 0) character = line.length + character;
                    if (character < 0 || character > line.length) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Invalid decoration position ${JSON.stringify(p)}. Line ${p.line} length: ${line.length}`);
                    return {
                        ...p,
                        character: character,
                        offset: converter.posToIndex(p.line, character)
                    };
                }
            }
            const decorations = (shiki.options.decorations || []).map((d)=>({
                    ...d,
                    start: normalizePosition(d.start),
                    end: normalizePosition(d.end)
                }));
            $2eb9c19caa629d78$var$verifyIntersections(decorations);
            map.set(shiki.meta, {
                decorations: decorations,
                converter: converter,
                source: shiki.source
            });
        }
        return map.get(shiki.meta);
    }
    return {
        name: "shiki:decorations",
        tokens (tokens) {
            if (!this.options.decorations?.length) return;
            return $2eb9c19caa629d78$export$d3e0fdeef870cacb(tokens, getContext(this).decorations.flatMap((d)=>[
                    d.start.offset,
                    d.end.offset
                ]));
        },
        code (codeEl) {
            if (!this.options.decorations?.length) return;
            const ctx = getContext(this);
            const lines = [
                ...codeEl.children
            ].filter((i)=>i.type === "element" && i.tagName === "span");
            if (lines.length !== ctx.converter.lines.length) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Number of lines in code element (${lines.length}) does not match the number of lines in the source (${ctx.converter.lines.length}). Failed to apply decorations.`);
            function applyLineSection(line, start, end, decoration) {
                const lineEl = lines[line];
                let text = "";
                let startIndex = -1;
                let endIndex = -1;
                if (start === 0) startIndex = 0;
                if (end === 0) endIndex = 0;
                if (end === Number.POSITIVE_INFINITY) endIndex = lineEl.children.length;
                if (startIndex === -1 || endIndex === -1) for(let i = 0; i < lineEl.children.length; i++){
                    text += $2eb9c19caa629d78$var$stringify(lineEl.children[i]);
                    if (startIndex === -1 && text.length === start) startIndex = i + 1;
                    if (endIndex === -1 && text.length === end) endIndex = i + 1;
                }
                if (startIndex === -1) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Failed to find start index for decoration ${JSON.stringify(decoration.start)}`);
                if (endIndex === -1) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Failed to find end index for decoration ${JSON.stringify(decoration.end)}`);
                const children = lineEl.children.slice(startIndex, endIndex);
                if (!decoration.alwaysWrap && children.length === lineEl.children.length) applyDecoration(lineEl, decoration, "line");
                else if (!decoration.alwaysWrap && children.length === 1 && children[0].type === "element") applyDecoration(children[0], decoration, "token");
                else {
                    const wrapper = {
                        type: "element",
                        tagName: "span",
                        properties: {},
                        children: children
                    };
                    applyDecoration(wrapper, decoration, "wrapper");
                    lineEl.children.splice(startIndex, children.length, wrapper);
                }
            }
            function applyLine(line, decoration) {
                lines[line] = applyDecoration(lines[line], decoration, "line");
            }
            function applyDecoration(el, decoration, type) {
                const properties = decoration.properties || {};
                const transform = decoration.transform || ((i)=>i);
                el.tagName = decoration.tagName || "span";
                el.properties = {
                    ...el.properties,
                    ...properties,
                    class: el.properties.class
                };
                if (decoration.properties?.class) $2eb9c19caa629d78$export$12efa744f94fc0a9(el, decoration.properties.class);
                el = transform(el, type) || el;
                return el;
            }
            const lineApplies = [];
            const sorted = ctx.decorations.sort((a, b)=>b.start.offset - a.start.offset || a.end.offset - b.end.offset);
            for (const decoration of sorted){
                const { start: start, end: end } = decoration;
                if (start.line === end.line) applyLineSection(start.line, start.character, end.character, decoration);
                else if (start.line < end.line) {
                    applyLineSection(start.line, start.character, Number.POSITIVE_INFINITY, decoration);
                    for(let i = start.line + 1; i < end.line; i++)lineApplies.unshift(()=>applyLine(i, decoration));
                    applyLineSection(end.line, 0, end.character, decoration);
                }
            }
            lineApplies.forEach((i)=>i());
        }
    };
}
function $2eb9c19caa629d78$var$verifyIntersections(items) {
    for(let i = 0; i < items.length; i++){
        const foo = items[i];
        if (foo.start.offset > foo.end.offset) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Invalid decoration range: ${JSON.stringify(foo.start)} - ${JSON.stringify(foo.end)}`);
        for(let j = i + 1; j < items.length; j++){
            const bar = items[j];
            const isFooHasBarStart = foo.start.offset <= bar.start.offset && bar.start.offset < foo.end.offset;
            const isFooHasBarEnd = foo.start.offset < bar.end.offset && bar.end.offset <= foo.end.offset;
            const isBarHasFooStart = bar.start.offset <= foo.start.offset && foo.start.offset < bar.end.offset;
            const isBarHasFooEnd = bar.start.offset < foo.end.offset && foo.end.offset <= bar.end.offset;
            if (isFooHasBarStart || isFooHasBarEnd || isBarHasFooStart || isBarHasFooEnd) {
                if (isFooHasBarStart && isFooHasBarEnd) continue;
                if (isBarHasFooStart && isBarHasFooEnd) continue;
                if (isBarHasFooStart && foo.start.offset === foo.end.offset) continue;
                if (isFooHasBarEnd && bar.start.offset === bar.end.offset) continue;
                throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Decorations ${JSON.stringify(foo.start)} and ${JSON.stringify(bar.start)} intersect.`);
            }
        }
    }
}
function $2eb9c19caa629d78$var$stringify(el) {
    if (el.type === "text") return el.value;
    if (el.type === "element") return el.children.map($2eb9c19caa629d78$var$stringify).join("");
    return "";
}
//#endregion
//#region src/highlight/_get-transformers.ts
const $2eb9c19caa629d78$var$builtInTransformers = [
    /* @__PURE__ */ $2eb9c19caa629d78$export$b094ad6c92e029a8()
];
function $2eb9c19caa629d78$var$getTransformers(options) {
    const transformers = $2eb9c19caa629d78$var$sortTransformersByEnforcement(options.transformers || []);
    return [
        ...transformers.pre,
        ...transformers.normal,
        ...transformers.post,
        ...$2eb9c19caa629d78$var$builtInTransformers
    ];
}
function $2eb9c19caa629d78$var$sortTransformersByEnforcement(transformers) {
    const pre = [];
    const post = [];
    const normal = [];
    for (const transformer of transformers)switch(transformer.enforce){
        case "pre":
            pre.push(transformer);
            break;
        case "post":
            post.push(transformer);
            break;
        default:
            normal.push(transformer);
    }
    return {
        pre: pre,
        post: post,
        normal: normal
    };
}
//#endregion
//#region ../../node_modules/.pnpm/ansi-sequence-parser@1.1.3/node_modules/ansi-sequence-parser/dist/index.js
var $2eb9c19caa629d78$var$namedColors = [
    "black",
    "red",
    "green",
    "yellow",
    "blue",
    "magenta",
    "cyan",
    "white",
    "brightBlack",
    "brightRed",
    "brightGreen",
    "brightYellow",
    "brightBlue",
    "brightMagenta",
    "brightCyan",
    "brightWhite"
];
var $2eb9c19caa629d78$var$decorations = {
    1: "bold",
    2: "dim",
    3: "italic",
    4: "underline",
    7: "reverse",
    8: "hidden",
    9: "strikethrough"
};
function $2eb9c19caa629d78$var$findSequence(value, position) {
    const nextEscape = value.indexOf("\x1B", position);
    if (nextEscape !== -1) {
        if (value[nextEscape + 1] === "[") {
            const nextClose = value.indexOf("m", nextEscape);
            if (nextClose !== -1) return {
                sequence: value.substring(nextEscape + 2, nextClose).split(";"),
                startPosition: nextEscape,
                position: nextClose + 1
            };
        }
    }
    return {
        position: value.length
    };
}
function $2eb9c19caa629d78$var$parseColor(sequence) {
    const colorMode = sequence.shift();
    if (colorMode === "2") {
        const rgb = sequence.splice(0, 3).map((x)=>Number.parseInt(x));
        if (rgb.length !== 3 || rgb.some((x)=>Number.isNaN(x))) return;
        return {
            type: "rgb",
            rgb: rgb
        };
    } else if (colorMode === "5") {
        const index = sequence.shift();
        if (index) return {
            type: "table",
            index: Number(index)
        };
    }
}
function $2eb9c19caa629d78$var$parseSequence(sequence) {
    const commands = [];
    while(sequence.length > 0){
        const code = sequence.shift();
        if (!code) continue;
        const codeInt = Number.parseInt(code);
        if (Number.isNaN(codeInt)) continue;
        if (codeInt === 0) commands.push({
            type: "resetAll"
        });
        else if (codeInt <= 9) {
            if ($2eb9c19caa629d78$var$decorations[codeInt]) commands.push({
                type: "setDecoration",
                value: $2eb9c19caa629d78$var$decorations[codeInt]
            });
        } else if (codeInt <= 29) {
            const decoration = $2eb9c19caa629d78$var$decorations[codeInt - 20];
            if (decoration) {
                commands.push({
                    type: "resetDecoration",
                    value: decoration
                });
                if (decoration === "dim") commands.push({
                    type: "resetDecoration",
                    value: "bold"
                });
            }
        } else if (codeInt <= 37) commands.push({
            type: "setForegroundColor",
            value: {
                type: "named",
                name: $2eb9c19caa629d78$var$namedColors[codeInt - 30]
            }
        });
        else if (codeInt === 38) {
            const color = $2eb9c19caa629d78$var$parseColor(sequence);
            if (color) commands.push({
                type: "setForegroundColor",
                value: color
            });
        } else if (codeInt === 39) commands.push({
            type: "resetForegroundColor"
        });
        else if (codeInt <= 47) commands.push({
            type: "setBackgroundColor",
            value: {
                type: "named",
                name: $2eb9c19caa629d78$var$namedColors[codeInt - 40]
            }
        });
        else if (codeInt === 48) {
            const color = $2eb9c19caa629d78$var$parseColor(sequence);
            if (color) commands.push({
                type: "setBackgroundColor",
                value: color
            });
        } else if (codeInt === 49) commands.push({
            type: "resetBackgroundColor"
        });
        else if (codeInt === 53) commands.push({
            type: "setDecoration",
            value: "overline"
        });
        else if (codeInt === 55) commands.push({
            type: "resetDecoration",
            value: "overline"
        });
        else if (codeInt >= 90 && codeInt <= 97) commands.push({
            type: "setForegroundColor",
            value: {
                type: "named",
                name: $2eb9c19caa629d78$var$namedColors[codeInt - 90 + 8]
            }
        });
        else if (codeInt >= 100 && codeInt <= 107) commands.push({
            type: "setBackgroundColor",
            value: {
                type: "named",
                name: $2eb9c19caa629d78$var$namedColors[codeInt - 100 + 8]
            }
        });
    }
    return commands;
}
function $2eb9c19caa629d78$var$createAnsiSequenceParser() {
    let foreground = null;
    let background = null;
    let decorations2 = /* @__PURE__ */ new Set();
    return {
        parse (value) {
            const tokens = [];
            let position = 0;
            do {
                const findResult = $2eb9c19caa629d78$var$findSequence(value, position);
                const text = findResult.sequence ? value.substring(position, findResult.startPosition) : value.substring(position);
                if (text.length > 0) tokens.push({
                    value: text,
                    foreground: foreground,
                    background: background,
                    decorations: new Set(decorations2)
                });
                if (findResult.sequence) {
                    const commands = $2eb9c19caa629d78$var$parseSequence(findResult.sequence);
                    for (const styleToken of commands)if (styleToken.type === "resetAll") {
                        foreground = null;
                        background = null;
                        decorations2.clear();
                    } else if (styleToken.type === "resetForegroundColor") foreground = null;
                    else if (styleToken.type === "resetBackgroundColor") background = null;
                    else if (styleToken.type === "resetDecoration") decorations2.delete(styleToken.value);
                    for (const styleToken of commands)if (styleToken.type === "setForegroundColor") foreground = styleToken.value;
                    else if (styleToken.type === "setBackgroundColor") background = styleToken.value;
                    else if (styleToken.type === "setDecoration") decorations2.add(styleToken.value);
                }
                position = findResult.position;
            }while (position < value.length);
            return tokens;
        }
    };
}
var $2eb9c19caa629d78$var$defaultNamedColorsMap = {
    black: "#000000",
    red: "#bb0000",
    green: "#00bb00",
    yellow: "#bbbb00",
    blue: "#0000bb",
    magenta: "#ff00ff",
    cyan: "#00bbbb",
    white: "#eeeeee",
    brightBlack: "#555555",
    brightRed: "#ff5555",
    brightGreen: "#00ff00",
    brightYellow: "#ffff55",
    brightBlue: "#5555ff",
    brightMagenta: "#ff55ff",
    brightCyan: "#55ffff",
    brightWhite: "#ffffff"
};
function $2eb9c19caa629d78$var$createColorPalette(namedColorsMap = $2eb9c19caa629d78$var$defaultNamedColorsMap) {
    function namedColor(name) {
        return namedColorsMap[name];
    }
    function rgbColor(rgb) {
        return `#${rgb.map((x)=>Math.max(0, Math.min(x, 255)).toString(16).padStart(2, "0")).join("")}`;
    }
    let colorTable;
    function getColorTable() {
        if (colorTable) return colorTable;
        colorTable = [];
        for(let i = 0; i < $2eb9c19caa629d78$var$namedColors.length; i++)colorTable.push(namedColor($2eb9c19caa629d78$var$namedColors[i]));
        let levels = [
            0,
            95,
            135,
            175,
            215,
            255
        ];
        for(let r = 0; r < 6; r++)for(let g = 0; g < 6; g++)for(let b = 0; b < 6; b++)colorTable.push(rgbColor([
            levels[r],
            levels[g],
            levels[b]
        ]));
        let level = 8;
        for(let i = 0; i < 24; i++, level += 10)colorTable.push(rgbColor([
            level,
            level,
            level
        ]));
        return colorTable;
    }
    function tableColor(index) {
        return getColorTable()[index];
    }
    function value(color) {
        switch(color.type){
            case "named":
                return namedColor(color.name);
            case "rgb":
                return rgbColor(color.rgb);
            case "table":
                return tableColor(color.index);
        }
    }
    return {
        value: value
    };
}
//#endregion
//#region src/highlight/code-to-tokens-ansi.ts
const $2eb9c19caa629d78$var$RE_HEX_COLOR = /#([0-9a-f]{3,8})/i;
const $2eb9c19caa629d78$var$RE_CSS_VAR_ANSI = /var\((--[\w-]+-ansi-[\w-]+)\)/;
/**
* Default ANSI palette (VSCode compatible fallbacks)
* Used when the theme does not define terminal.ansi* colors.
*/ const $2eb9c19caa629d78$var$defaultAnsiColors = {
    black: "#000000",
    red: "#cd3131",
    green: "#0DBC79",
    yellow: "#E5E510",
    blue: "#2472C8",
    magenta: "#BC3FBC",
    cyan: "#11A8CD",
    white: "#E5E5E5",
    brightBlack: "#666666",
    brightRed: "#F14C4C",
    brightGreen: "#23D18B",
    brightYellow: "#F5F543",
    brightBlue: "#3B8EEA",
    brightMagenta: "#D670D6",
    brightCyan: "#29B8DB",
    brightWhite: "#FFFFFF"
};
function $2eb9c19caa629d78$export$1e0554f7c12b87ed(theme, fileContents, options) {
    const colorReplacements = (0, $e150f61536b1a01a$export$2f5d8722891c6610)(theme, options);
    const lines = (0, $e150f61536b1a01a$export$88c07fe39db9eaa1)(fileContents);
    const colorPalette = $2eb9c19caa629d78$var$createColorPalette(Object.fromEntries($2eb9c19caa629d78$var$namedColors.map((name)=>{
        const key = `terminal.ansi${name[0].toUpperCase()}${name.substring(1)}`;
        return [
            name,
            theme.colors?.[key] || $2eb9c19caa629d78$var$defaultAnsiColors[name]
        ];
    })));
    const parser = $2eb9c19caa629d78$var$createAnsiSequenceParser();
    return lines.map((line)=>parser.parse(line[0]).map((token)=>{
            let color;
            let bgColor;
            if (token.decorations.has("reverse")) {
                color = token.background ? colorPalette.value(token.background) : theme.bg;
                bgColor = token.foreground ? colorPalette.value(token.foreground) : theme.fg;
            } else {
                color = token.foreground ? colorPalette.value(token.foreground) : theme.fg;
                bgColor = token.background ? colorPalette.value(token.background) : void 0;
            }
            color = (0, $e150f61536b1a01a$export$ef30c5cede3b6b4a)(color, colorReplacements);
            bgColor = (0, $e150f61536b1a01a$export$ef30c5cede3b6b4a)(bgColor, colorReplacements);
            if (token.decorations.has("dim")) color = $2eb9c19caa629d78$var$dimColor(color);
            let fontStyle = (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).None;
            if (token.decorations.has("bold")) fontStyle |= (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).Bold;
            if (token.decorations.has("italic")) fontStyle |= (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).Italic;
            if (token.decorations.has("underline")) fontStyle |= (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).Underline;
            if (token.decorations.has("strikethrough")) fontStyle |= (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).Strikethrough;
            return {
                content: token.value,
                offset: line[1],
                color: color,
                bgColor: bgColor,
                fontStyle: fontStyle
            };
        }));
}
/**
* Adds 50% alpha to a hex color string or the "-dim" postfix to a CSS variable
*/ function $2eb9c19caa629d78$var$dimColor(color) {
    const hexMatch = color.match($2eb9c19caa629d78$var$RE_HEX_COLOR);
    if (hexMatch) {
        const hex = hexMatch[1];
        if (hex.length === 8) {
            const alpha = Math.round(Number.parseInt(hex.slice(6, 8), 16) / 2).toString(16).padStart(2, "0");
            return `#${hex.slice(0, 6)}${alpha}`;
        } else if (hex.length === 6) return `#${hex}80`;
        else if (hex.length === 4) {
            const r = hex[0];
            const g = hex[1];
            const b = hex[2];
            const a = hex[3];
            return `#${r}${r}${g}${g}${b}${b}${Math.round(Number.parseInt(`${a}${a}`, 16) / 2).toString(16).padStart(2, "0")}`;
        } else if (hex.length === 3) {
            const r = hex[0];
            const g = hex[1];
            const b = hex[2];
            return `#${r}${r}${g}${g}${b}${b}80`;
        }
    }
    const cssVarMatch = color.match($2eb9c19caa629d78$var$RE_CSS_VAR_ANSI);
    if (cssVarMatch) return `var(${cssVarMatch[1]}-dim)`;
    return color;
}
//#endregion
//#region src/highlight/code-to-tokens-base.ts
/**
* Code to tokens, with a simple theme.
* This wraps the tokenizer's implementation to add ANSI support.
*/ function $2eb9c19caa629d78$export$9fcc555cdbb165d8(primitive, code, options = {}) {
    const lang = primitive.resolveLangAlias(options.lang || "text");
    const { theme: themeName = primitive.getLoadedThemes()[0] } = options;
    if (!(0, $e150f61536b1a01a$export$f98db15a0683bb96)(lang) && !(0, $e150f61536b1a01a$export$3e6bc683d2a50c25)(themeName) && lang === "ansi") {
        const { theme: theme } = primitive.setTheme(themeName);
        return $2eb9c19caa629d78$export$1e0554f7c12b87ed(theme, code, options);
    }
    return (0, $e150f61536b1a01a$export$9fcc555cdbb165d8)(primitive, code, options);
}
//#endregion
//#region src/highlight/code-to-tokens.ts
/**
* High-level code-to-tokens API.
*
* It will use `codeToTokensWithThemes` or `codeToTokensBase` based on the options.
*/ function $2eb9c19caa629d78$export$93965dfc9a82f052(primitive, code, options) {
    let bg;
    let fg;
    let tokens;
    let themeName;
    let rootStyle;
    let grammarState;
    if ("themes" in options) {
        const { defaultColor: defaultColor = "light", cssVariablePrefix: cssVariablePrefix = "--shiki-", colorsRendering: colorsRendering = "css-vars" } = options;
        const themes = Object.entries(options.themes).filter((i)=>i[1]).map((i)=>({
                color: i[0],
                theme: i[1]
            })).sort((a, b)=>a.color === defaultColor ? -1 : b.color === defaultColor ? 1 : 0);
        if (themes.length === 0) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)("`themes` option must not be empty");
        const themeTokens = (0, $e150f61536b1a01a$export$99552db3190ba9d3)(primitive, code, options, $2eb9c19caa629d78$export$9fcc555cdbb165d8);
        grammarState = (0, $e150f61536b1a01a$export$47937e5383997945)(themeTokens);
        if (defaultColor && "light-dark()" !== defaultColor && !themes.some((t)=>t.color === defaultColor)) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`\`themes\` option must contain the defaultColor key \`${defaultColor}\``);
        const themeRegs = themes.map((t)=>primitive.getTheme(t.theme));
        const themesOrder = themes.map((t)=>t.color);
        tokens = themeTokens.map((line)=>line.map((token)=>$2eb9c19caa629d78$export$5a4c68029315ecd7(token, themesOrder, cssVariablePrefix, defaultColor, colorsRendering)));
        if (grammarState) (0, $e150f61536b1a01a$export$85116f33c2060a4b)(tokens, grammarState);
        const themeColorReplacements = themes.map((t)=>(0, $e150f61536b1a01a$export$2f5d8722891c6610)(t.theme, options));
        fg = $2eb9c19caa629d78$var$mapThemeColors(themes, themeRegs, themeColorReplacements, cssVariablePrefix, defaultColor, "fg", colorsRendering);
        bg = $2eb9c19caa629d78$var$mapThemeColors(themes, themeRegs, themeColorReplacements, cssVariablePrefix, defaultColor, "bg", colorsRendering);
        themeName = `shiki-themes ${themeRegs.map((t)=>t.name).join(" ")}`;
        rootStyle = defaultColor ? void 0 : [
            fg,
            bg
        ].join(";");
    } else if ("theme" in options) {
        const colorReplacements = (0, $e150f61536b1a01a$export$2f5d8722891c6610)(options.theme, options);
        tokens = $2eb9c19caa629d78$export$9fcc555cdbb165d8(primitive, code, options);
        const _theme = primitive.getTheme(options.theme);
        bg = (0, $e150f61536b1a01a$export$ef30c5cede3b6b4a)(_theme.bg, colorReplacements);
        fg = (0, $e150f61536b1a01a$export$ef30c5cede3b6b4a)(_theme.fg, colorReplacements);
        themeName = _theme.name;
        grammarState = (0, $e150f61536b1a01a$export$47937e5383997945)(tokens);
    } else throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)("Invalid options, either `theme` or `themes` must be provided");
    return {
        tokens: tokens,
        fg: fg,
        bg: bg,
        themeName: themeName,
        rootStyle: rootStyle,
        grammarState: grammarState
    };
}
function $2eb9c19caa629d78$var$mapThemeColors(themes, themeRegs, themeColorReplacements, cssVariablePrefix, defaultColor, property, colorsRendering) {
    return themes.map((t, idx)=>{
        const value = (0, $e150f61536b1a01a$export$ef30c5cede3b6b4a)(themeRegs[idx][property], themeColorReplacements[idx]) || "inherit";
        const cssVar = `${cssVariablePrefix + t.color}${property === "bg" ? "-bg" : ""}:${value}`;
        if (idx === 0 && defaultColor) {
            if (defaultColor === "light-dark()" && themes.length > 1) {
                const lightIndex = themes.findIndex((t)=>t.color === "light");
                const darkIndex = themes.findIndex((t)=>t.color === "dark");
                if (lightIndex === -1 || darkIndex === -1) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)("When using `defaultColor: \"light-dark()\"`, you must provide both `light` and `dark` themes");
                return `light-dark(${(0, $e150f61536b1a01a$export$ef30c5cede3b6b4a)(themeRegs[lightIndex][property], themeColorReplacements[lightIndex]) || "inherit"}, ${(0, $e150f61536b1a01a$export$ef30c5cede3b6b4a)(themeRegs[darkIndex][property], themeColorReplacements[darkIndex]) || "inherit"});${cssVar}`;
            }
            return value;
        }
        if (colorsRendering === "css-vars") return cssVar;
        return null;
    }).filter((i)=>!!i).join(";");
}
//#endregion
//#region src/highlight/code-to-hast.ts
const $2eb9c19caa629d78$var$RE_WHITESPACE_ONLY = /^\s+$/;
const $2eb9c19caa629d78$var$RE_LEADING_TRAILING_WHITESPACE = /^(\s*)(.*?)(\s*)$/;
function $2eb9c19caa629d78$export$9b49c0a3202a858c(primitive, code, options, transformerContext = {
    meta: {},
    options: options,
    codeToHast: (_code, _options)=>$2eb9c19caa629d78$export$9b49c0a3202a858c(primitive, _code, _options),
    codeToTokens: (_code, _options)=>$2eb9c19caa629d78$export$93965dfc9a82f052(primitive, _code, _options)
}) {
    let input = code;
    for (const transformer of $2eb9c19caa629d78$var$getTransformers(options))input = transformer.preprocess?.call(transformerContext, input, options) || input;
    let { tokens: tokens, fg: fg, bg: bg, themeName: themeName, rootStyle: rootStyle, grammarState: grammarState } = $2eb9c19caa629d78$export$93965dfc9a82f052(primitive, input, options);
    const { mergeWhitespaces: mergeWhitespaces = true, mergeSameStyleTokens: mergeSameStyleTokens = false } = options;
    if (mergeWhitespaces === true) tokens = $2eb9c19caa629d78$var$mergeWhitespaceTokens(tokens);
    else if (mergeWhitespaces === "never") tokens = $2eb9c19caa629d78$var$splitWhitespaceTokens(tokens);
    if (mergeSameStyleTokens) tokens = $2eb9c19caa629d78$var$mergeAdjacentStyledTokens(tokens);
    const contextSource = {
        ...transformerContext,
        get source () {
            return input;
        }
    };
    for (const transformer of $2eb9c19caa629d78$var$getTransformers(options))tokens = transformer.tokens?.call(contextSource, tokens) || tokens;
    return $2eb9c19caa629d78$export$ac3d0a92e97ad33e(tokens, {
        ...options,
        fg: fg,
        bg: bg,
        themeName: themeName,
        rootStyle: options.rootStyle === false ? false : options.rootStyle ?? rootStyle
    }, contextSource, grammarState);
}
function $2eb9c19caa629d78$export$ac3d0a92e97ad33e(tokens, options, transformerContext, grammarState = (0, $e150f61536b1a01a$export$47937e5383997945)(tokens)) {
    const transformers = $2eb9c19caa629d78$var$getTransformers(options);
    const lines = [];
    const root = {
        type: "root",
        children: []
    };
    const { structure: structure = "classic", tabindex: tabindex = "0" } = options;
    const properties = {
        class: `shiki ${options.themeName || ""}`
    };
    if (options.rootStyle !== false) {
        if (options.rootStyle != null) properties.style = options.rootStyle;
        else properties.style = `background-color:${options.bg};color:${options.fg}`;
    }
    if (tabindex !== false && tabindex != null) properties.tabindex = tabindex.toString();
    for (const [key, value] of Object.entries(options.meta || {}))if (!key.startsWith("_")) properties[key] = value;
    let preNode = {
        type: "element",
        tagName: "pre",
        properties: properties,
        children: [],
        data: options.data
    };
    let codeNode = {
        type: "element",
        tagName: "code",
        properties: {},
        children: lines
    };
    const lineNodes = [];
    const context = {
        ...transformerContext,
        structure: structure,
        addClassToHast: $2eb9c19caa629d78$export$12efa744f94fc0a9,
        get source () {
            return transformerContext.source;
        },
        get tokens () {
            return tokens;
        },
        get options () {
            return options;
        },
        get root () {
            return root;
        },
        get pre () {
            return preNode;
        },
        get code () {
            return codeNode;
        },
        get lines () {
            return lineNodes;
        }
    };
    tokens.forEach((line, idx)=>{
        if (idx) {
            if (structure === "inline") root.children.push({
                type: "element",
                tagName: "br",
                properties: {},
                children: []
            });
            else if (structure === "classic") lines.push({
                type: "text",
                value: "\n"
            });
        }
        let lineNode = {
            type: "element",
            tagName: "span",
            properties: {
                class: "line"
            },
            children: []
        };
        let col = 0;
        for (const token of line){
            let tokenNode = {
                type: "element",
                tagName: "span",
                properties: {
                    ...token.htmlAttrs
                },
                children: [
                    {
                        type: "text",
                        value: token.content
                    }
                ]
            };
            const style = $2eb9c19caa629d78$export$10559b52119e8d5f(token.htmlStyle || $2eb9c19caa629d78$export$94ffab218337d127(token));
            if (style) tokenNode.properties.style = style;
            for (const transformer of transformers)tokenNode = transformer?.span?.call(context, tokenNode, idx + 1, col, lineNode, token) || tokenNode;
            if (structure === "inline") root.children.push(tokenNode);
            else if (structure === "classic") lineNode.children.push(tokenNode);
            col += token.content.length;
        }
        if (structure === "classic") {
            for (const transformer of transformers)lineNode = transformer?.line?.call(context, lineNode, idx + 1) || lineNode;
            lineNodes.push(lineNode);
            lines.push(lineNode);
        } else if (structure === "inline") lineNodes.push(lineNode);
    });
    if (structure === "classic") {
        for (const transformer of transformers)codeNode = transformer?.code?.call(context, codeNode) || codeNode;
        preNode.children.push(codeNode);
        for (const transformer of transformers)preNode = transformer?.pre?.call(context, preNode) || preNode;
        root.children.push(preNode);
    } else if (structure === "inline") {
        const syntheticLines = [];
        let currentLine = {
            type: "element",
            tagName: "span",
            properties: {
                class: "line"
            },
            children: []
        };
        for (const child of root.children)if (child.type === "element" && child.tagName === "br") {
            syntheticLines.push(currentLine);
            currentLine = {
                type: "element",
                tagName: "span",
                properties: {
                    class: "line"
                },
                children: []
            };
        } else if (child.type === "element" || child.type === "text") currentLine.children.push(child);
        syntheticLines.push(currentLine);
        let transformedCode = {
            type: "element",
            tagName: "code",
            properties: {},
            children: syntheticLines
        };
        for (const transformer of transformers)transformedCode = transformer?.code?.call(context, transformedCode) || transformedCode;
        root.children = [];
        for(let i = 0; i < transformedCode.children.length; i++){
            if (i > 0) root.children.push({
                type: "element",
                tagName: "br",
                properties: {},
                children: []
            });
            const line = transformedCode.children[i];
            if (line.type === "element") root.children.push(...line.children);
        }
    }
    let result = root;
    for (const transformer of transformers)result = transformer?.root?.call(context, result) || result;
    if (grammarState) (0, $e150f61536b1a01a$export$85116f33c2060a4b)(result, grammarState);
    return result;
}
function $2eb9c19caa629d78$var$mergeWhitespaceTokens(tokens) {
    return tokens.map((line)=>{
        const newLine = [];
        let carryOnContent = "";
        let firstOffset;
        line.forEach((token, idx)=>{
            const couldMerge = !(token.fontStyle && (token.fontStyle & (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).Underline || token.fontStyle & (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).Strikethrough));
            if (couldMerge && $2eb9c19caa629d78$var$RE_WHITESPACE_ONLY.test(token.content) && line[idx + 1]) {
                if (firstOffset === void 0) firstOffset = token.offset;
                carryOnContent += token.content;
            } else if (carryOnContent) {
                if (couldMerge) newLine.push({
                    ...token,
                    offset: firstOffset,
                    content: carryOnContent + token.content
                });
                else newLine.push({
                    content: carryOnContent,
                    offset: firstOffset
                }, token);
                firstOffset = void 0;
                carryOnContent = "";
            } else newLine.push(token);
        });
        return newLine;
    });
}
function $2eb9c19caa629d78$var$splitWhitespaceTokens(tokens) {
    return tokens.map((line)=>{
        return line.flatMap((token)=>{
            if ($2eb9c19caa629d78$var$RE_WHITESPACE_ONLY.test(token.content)) return token;
            const match = token.content.match($2eb9c19caa629d78$var$RE_LEADING_TRAILING_WHITESPACE);
            if (!match) return token;
            const [, leading, content, trailing] = match;
            if (!leading && !trailing) return token;
            const expanded = [
                {
                    ...token,
                    offset: token.offset + leading.length,
                    content: content
                }
            ];
            if (leading) expanded.unshift({
                content: leading,
                offset: token.offset
            });
            if (trailing) expanded.push({
                content: trailing,
                offset: token.offset + leading.length + content.length
            });
            return expanded;
        });
    });
}
function $2eb9c19caa629d78$var$mergeAdjacentStyledTokens(tokens) {
    return tokens.map((line)=>{
        const newLine = [];
        for (const token of line){
            if (newLine.length === 0) {
                newLine.push({
                    ...token
                });
                continue;
            }
            const prevToken = newLine.at(-1);
            const prevStyle = $2eb9c19caa629d78$export$10559b52119e8d5f(prevToken.htmlStyle || $2eb9c19caa629d78$export$94ffab218337d127(prevToken));
            const currentStyle = $2eb9c19caa629d78$export$10559b52119e8d5f(token.htmlStyle || $2eb9c19caa629d78$export$94ffab218337d127(token));
            const isPrevDecorated = prevToken.fontStyle && (prevToken.fontStyle & (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).Underline || prevToken.fontStyle & (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).Strikethrough);
            const isDecorated = token.fontStyle && (token.fontStyle & (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).Underline || token.fontStyle & (0, $3ce28d198d785bf9$export$23b468d4ca3f8c96).Strikethrough);
            if (!isPrevDecorated && !isDecorated && prevStyle === currentStyle) prevToken.content += token.content;
            else newLine.push({
                ...token
            });
        }
        return newLine;
    });
}
//#endregion
//#region src/highlight/code-to-html.ts
const $2eb9c19caa629d78$export$4f3973dc2959ebf3 = (0, $3ac6c8c7f8865417$export$a10125c086a4df16);
/**
* Get highlighted code in HTML.
*/ function $2eb9c19caa629d78$export$74ba11990fba86b4(primitive, code, options) {
    const context = {
        meta: {},
        options: options,
        codeToHast: (_code, _options)=>$2eb9c19caa629d78$export$9b49c0a3202a858c(primitive, _code, _options),
        codeToTokens: (_code, _options)=>$2eb9c19caa629d78$export$93965dfc9a82f052(primitive, _code, _options)
    };
    let result = $2eb9c19caa629d78$export$4f3973dc2959ebf3($2eb9c19caa629d78$export$9b49c0a3202a858c(primitive, code, options, context));
    for (const transformer of $2eb9c19caa629d78$var$getTransformers(options))result = transformer.postprocess?.call(context, result, options) || result;
    return result;
}
//#endregion
//#region src/constructors/highlighter.ts
/**
* Create a Shiki core highlighter instance, with no languages or themes bundled.
* Wasm and each language and theme must be loaded manually.
*
* @see http://shiki.style/guide/bundles#fine-grained-bundle
*/ async function $2eb9c19caa629d78$export$731e59ef5bc9b980(options) {
    const primitive = await (0, $e150f61536b1a01a$export$7118aaae6ff863ad)(options);
    return {
        getLastGrammarState: (...args)=>(0, $e150f61536b1a01a$export$e79a48b8b5fd83c5)(primitive, ...args),
        codeToTokensBase: (code, options)=>$2eb9c19caa629d78$export$9fcc555cdbb165d8(primitive, code, options),
        codeToTokensWithThemes: (code, options)=>(0, $e150f61536b1a01a$export$99552db3190ba9d3)(primitive, code, options),
        codeToTokens: (code, options)=>$2eb9c19caa629d78$export$93965dfc9a82f052(primitive, code, options),
        codeToHast: (code, options)=>$2eb9c19caa629d78$export$9b49c0a3202a858c(primitive, code, options),
        codeToHtml: (code, options)=>$2eb9c19caa629d78$export$74ba11990fba86b4(primitive, code, options),
        getBundledLanguages: ()=>({}),
        getBundledThemes: ()=>({}),
        ...primitive,
        getInternalContext: ()=>primitive
    };
}
/**
* Create a Shiki core highlighter instance, with no languages or themes bundled.
* Wasm and each language and theme must be loaded manually.
*
* Synchronous version of `createHighlighterCore`, which requires to provide the engine and all themes and languages upfront.
*
* @see http://shiki.style/guide/bundles#fine-grained-bundle
*/ function $2eb9c19caa629d78$export$f38e8c16be9dd57d(options) {
    const internal = (0, $e150f61536b1a01a$export$993d8e1d5e5fb61b)(options);
    return {
        getLastGrammarState: (...args)=>(0, $e150f61536b1a01a$export$e79a48b8b5fd83c5)(internal, ...args),
        codeToTokensBase: (code, options)=>$2eb9c19caa629d78$export$9fcc555cdbb165d8(internal, code, options),
        codeToTokensWithThemes: (code, options)=>(0, $e150f61536b1a01a$export$99552db3190ba9d3)(internal, code, options),
        codeToTokens: (code, options)=>$2eb9c19caa629d78$export$93965dfc9a82f052(internal, code, options),
        codeToHast: (code, options)=>$2eb9c19caa629d78$export$9b49c0a3202a858c(internal, code, options),
        codeToHtml: (code, options)=>$2eb9c19caa629d78$export$74ba11990fba86b4(internal, code, options),
        getBundledLanguages: ()=>({}),
        getBundledThemes: ()=>({}),
        ...internal,
        getInternalContext: ()=>internal
    };
}
function $2eb9c19caa629d78$export$708f4903c06f244f(createHighlighter) {
    let _shiki;
    async function getSingletonHighlighterCore(options) {
        if (!_shiki) {
            _shiki = createHighlighter({
                ...options,
                themes: options.themes || [],
                langs: options.langs || []
            });
            return _shiki;
        } else {
            const s = await _shiki;
            await Promise.all([
                s.loadTheme(...options.themes || []),
                s.loadLanguage(...options.langs || [])
            ]);
            return s;
        }
    }
    return getSingletonHighlighterCore;
}
const $2eb9c19caa629d78$export$ebfcaa8c37a8db2c = /* @__PURE__ */ $2eb9c19caa629d78$export$708f4903c06f244f($2eb9c19caa629d78$export$731e59ef5bc9b980);
//#endregion
//#region src/constructors/bundle-factory.ts
function $2eb9c19caa629d78$export$8ca362031a26944a(options) {
    const bundledLanguages = options.langs;
    const bundledThemes = options.themes;
    const engine = options.engine;
    async function createHighlighter(options) {
        function resolveLang(lang) {
            if (typeof lang === "string") {
                lang = options.langAlias?.[lang] || lang;
                if ((0, $e150f61536b1a01a$export$5c3e2a1e13c5c906)(lang)) return [];
                const bundle = bundledLanguages[lang];
                if (!bundle) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Language \`${lang}\` is not included in this bundle. You may want to load it from external source.`);
                return bundle;
            }
            return lang;
        }
        function resolveTheme(theme) {
            if ((0, $e150f61536b1a01a$export$cd4537af2d43769e)(theme)) return "none";
            if (typeof theme === "string") {
                const bundle = bundledThemes[theme];
                if (!bundle) throw new (0, $25dc077fd540282c$export$5003b41ce90ff8c9)(`Theme \`${theme}\` is not included in this bundle. You may want to load it from external source.`);
                return bundle;
            }
            return theme;
        }
        const _themes = (options.themes ?? []).map((i)=>resolveTheme(i));
        const langs = (options.langs ?? []).map((i)=>resolveLang(i));
        const core = await $2eb9c19caa629d78$export$731e59ef5bc9b980({
            engine: options.engine ?? engine(),
            ...options,
            themes: _themes,
            langs: langs
        });
        return {
            ...core,
            loadLanguage (...langs) {
                return core.loadLanguage(...langs.map(resolveLang));
            },
            loadTheme (...themes) {
                return core.loadTheme(...themes.map(resolveTheme));
            },
            getBundledLanguages () {
                return bundledLanguages;
            },
            getBundledThemes () {
                return bundledThemes;
            }
        };
    }
    return createHighlighter;
}
function $2eb9c19caa629d78$export$c08cf9c73e9e5934(createHighlighter) {
    let _shiki;
    async function getSingletonHighlighter(options = {}) {
        if (!_shiki) {
            _shiki = createHighlighter({
                ...options,
                themes: [],
                langs: []
            });
            const s = await _shiki;
            await Promise.all([
                s.loadTheme(...options.themes || []),
                s.loadLanguage(...options.langs || [])
            ]);
            return s;
        } else {
            const s = await _shiki;
            await Promise.all([
                s.loadTheme(...options.themes || []),
                s.loadLanguage(...options.langs || [])
            ]);
            return s;
        }
    }
    return getSingletonHighlighter;
}
function $2eb9c19caa629d78$export$3706d1cd2b0dba33(createHighlighter, config) {
    const getSingletonHighlighter = $2eb9c19caa629d78$export$c08cf9c73e9e5934(createHighlighter);
    async function get(code, options) {
        const shiki = await getSingletonHighlighter({
            langs: [
                options.lang
            ],
            themes: "theme" in options ? [
                options.theme
            ] : Object.values(options.themes)
        });
        const langs = await config?.guessEmbeddedLanguages?.(code, options.lang, shiki);
        if (langs) await shiki.loadLanguage(...langs);
        return shiki;
    }
    return {
        getSingletonHighlighter (options) {
            return getSingletonHighlighter(options);
        },
        async codeToHtml (code, options) {
            return (await get(code, options)).codeToHtml(code, options);
        },
        async codeToHast (code, options) {
            return (await get(code, options)).codeToHast(code, options);
        },
        async codeToTokens (code, options) {
            return (await get(code, options)).codeToTokens(code, options);
        },
        async codeToTokensBase (code, options) {
            return (await get(code, options)).codeToTokensBase(code, options);
        },
        async codeToTokensWithThemes (code, options) {
            return (await get(code, options)).codeToTokensWithThemes(code, options);
        },
        async getLastGrammarState (code, options) {
            return (await getSingletonHighlighter({
                langs: [
                    options.lang
                ],
                themes: [
                    options.theme
                ]
            })).getLastGrammarState(code, options);
        }
    };
}
//#endregion
//#region src/theme-css-variables.ts
/**
* A factory function to create a css-variable-based theme
*
* @see https://shiki.style/guide/theme-colors#css-variables-theme
*/ function $2eb9c19caa629d78$export$73f45de8f69a7c80(options = {}) {
    const { name: name = "css-variables", variablePrefix: variablePrefix = "--shiki-", fontStyle: fontStyle = true } = options;
    const variable = (name)=>{
        if (options.variableDefaults?.[name]) return `var(${variablePrefix}${name}, ${options.variableDefaults[name]})`;
        return `var(${variablePrefix}${name})`;
    };
    const theme = {
        name: name,
        type: "dark",
        colors: {
            "editor.foreground": variable("foreground"),
            "editor.background": variable("background"),
            "terminal.ansiBlack": variable("ansi-black"),
            "terminal.ansiRed": variable("ansi-red"),
            "terminal.ansiGreen": variable("ansi-green"),
            "terminal.ansiYellow": variable("ansi-yellow"),
            "terminal.ansiBlue": variable("ansi-blue"),
            "terminal.ansiMagenta": variable("ansi-magenta"),
            "terminal.ansiCyan": variable("ansi-cyan"),
            "terminal.ansiWhite": variable("ansi-white"),
            "terminal.ansiBrightBlack": variable("ansi-bright-black"),
            "terminal.ansiBrightRed": variable("ansi-bright-red"),
            "terminal.ansiBrightGreen": variable("ansi-bright-green"),
            "terminal.ansiBrightYellow": variable("ansi-bright-yellow"),
            "terminal.ansiBrightBlue": variable("ansi-bright-blue"),
            "terminal.ansiBrightMagenta": variable("ansi-bright-magenta"),
            "terminal.ansiBrightCyan": variable("ansi-bright-cyan"),
            "terminal.ansiBrightWhite": variable("ansi-bright-white")
        },
        tokenColors: [
            {
                scope: [
                    "keyword.operator.accessor",
                    "meta.group.braces.round.function.arguments",
                    "meta.template.expression",
                    "markup.fenced_code meta.embedded.block"
                ],
                settings: {
                    foreground: variable("foreground")
                }
            },
            {
                scope: "emphasis",
                settings: {
                    fontStyle: "italic"
                }
            },
            {
                scope: [
                    "strong",
                    "markup.heading.markdown",
                    "markup.bold.markdown"
                ],
                settings: {
                    fontStyle: "bold"
                }
            },
            {
                scope: [
                    "markup.italic.markdown"
                ],
                settings: {
                    fontStyle: "italic"
                }
            },
            {
                scope: "meta.link.inline.markdown",
                settings: {
                    fontStyle: "underline",
                    foreground: variable("token-link")
                }
            },
            {
                scope: [
                    "string",
                    "markup.fenced_code",
                    "markup.inline"
                ],
                settings: {
                    foreground: variable("token-string")
                }
            },
            {
                scope: [
                    "comment",
                    "string.quoted.docstring.multi"
                ],
                settings: {
                    foreground: variable("token-comment")
                }
            },
            {
                scope: [
                    "constant.numeric",
                    "constant.language",
                    "constant.other.placeholder",
                    "constant.character.format.placeholder",
                    "variable.language.this",
                    "variable.other.object",
                    "variable.other.class",
                    "variable.other.constant",
                    "meta.property-name",
                    "meta.property-value",
                    "support"
                ],
                settings: {
                    foreground: variable("token-constant")
                }
            },
            {
                scope: [
                    "keyword",
                    "storage.modifier",
                    "storage.type",
                    "storage.control.clojure",
                    "entity.name.function.clojure",
                    "entity.name.tag.yaml",
                    "support.function.node",
                    "support.type.property-name.json",
                    "punctuation.separator.key-value",
                    "punctuation.definition.template-expression"
                ],
                settings: {
                    foreground: variable("token-keyword")
                }
            },
            {
                scope: "variable.parameter.function",
                settings: {
                    foreground: variable("token-parameter")
                }
            },
            {
                scope: [
                    "support.function",
                    "entity.name.type",
                    "entity.other.inherited-class",
                    "meta.function-call",
                    "meta.instance.constructor",
                    "entity.other.attribute-name",
                    "entity.name.function",
                    "constant.keyword.clojure"
                ],
                settings: {
                    foreground: variable("token-function")
                }
            },
            {
                scope: [
                    "entity.name.tag",
                    "string.quoted",
                    "string.regexp",
                    "string.interpolated",
                    "string.template",
                    "string.unquoted.plain.out.yaml",
                    "keyword.other.template"
                ],
                settings: {
                    foreground: variable("token-string-expression")
                }
            },
            {
                scope: [
                    "punctuation.definition.arguments",
                    "punctuation.definition.dict",
                    "punctuation.separator",
                    "meta.function-call.arguments"
                ],
                settings: {
                    foreground: variable("token-punctuation")
                }
            },
            {
                scope: [
                    "markup.underline.link",
                    "punctuation.definition.metadata.markdown"
                ],
                settings: {
                    foreground: variable("token-link")
                }
            },
            {
                scope: [
                    "beginning.punctuation.definition.list.markdown"
                ],
                settings: {
                    foreground: variable("token-string")
                }
            },
            {
                scope: [
                    "punctuation.definition.string.begin.markdown",
                    "punctuation.definition.string.end.markdown",
                    "string.other.link.title.markdown",
                    "string.other.link.description.markdown"
                ],
                settings: {
                    foreground: variable("token-keyword")
                }
            },
            {
                scope: [
                    "markup.inserted",
                    "meta.diff.header.to-file",
                    "punctuation.definition.inserted"
                ],
                settings: {
                    foreground: variable("token-inserted")
                }
            },
            {
                scope: [
                    "markup.deleted",
                    "meta.diff.header.from-file",
                    "punctuation.definition.deleted"
                ],
                settings: {
                    foreground: variable("token-deleted")
                }
            },
            {
                scope: [
                    "markup.changed",
                    "punctuation.definition.changed"
                ],
                settings: {
                    foreground: variable("token-changed")
                }
            }
        ]
    };
    if (!fontStyle) theme.tokenColors = theme.tokenColors?.map((tokenColor)=>{
        if (tokenColor.settings?.fontStyle) delete tokenColor.settings.fontStyle;
        return tokenColor;
    });
    return theme;
}


//#region src/scanner.ts
const $7bf9254e713c94eb$var$MAX = 4294967295;
var $7bf9254e713c94eb$export$625550452a3fa3ec = class {
    patterns;
    options;
    regexps;
    constructor(patterns, options = {}){
        this.patterns = patterns;
        this.options = options;
        const { forgiving: forgiving = false, cache: cache, regexConstructor: regexConstructor } = options;
        if (!regexConstructor) throw new Error("Option `regexConstructor` is not provided");
        this.regexps = patterns.map((p)=>{
            if (typeof p !== "string") return p;
            const cached = cache?.get(p);
            if (cached) {
                if (cached instanceof RegExp) return cached;
                if (forgiving) return null;
                throw cached;
            }
            try {
                const regex = regexConstructor(p);
                cache?.set(p, regex);
                return regex;
            } catch (e) {
                cache?.set(p, e);
                if (forgiving) return null;
                throw e;
            }
        });
    }
    findNextMatchSync(string, startPosition, _options) {
        const str = typeof string === "string" ? string : string.content;
        const pending = [];
        function toResult(index, match, offset = 0) {
            return {
                index: index,
                captureIndices: match.indices.map((indice)=>{
                    if (indice == null) return {
                        start: $7bf9254e713c94eb$var$MAX,
                        end: $7bf9254e713c94eb$var$MAX,
                        length: 0
                    };
                    return {
                        start: indice[0] + offset,
                        end: indice[1] + offset,
                        length: indice[1] - indice[0]
                    };
                })
            };
        }
        for(let i = 0; i < this.regexps.length; i++){
            const regexp = this.regexps[i];
            if (!regexp) continue;
            try {
                regexp.lastIndex = startPosition;
                const match = regexp.exec(str);
                if (!match) continue;
                if (match.index === startPosition) return toResult(i, match, 0);
                pending.push([
                    i,
                    match,
                    0
                ]);
            } catch (e) {
                if (this.options.forgiving) continue;
                throw e;
            }
        }
        if (pending.length) {
            const minIndex = Math.min(...pending.map((m)=>m[1].index));
            for (const [i, match, offset] of pending)if (match.index === minIndex) return toResult(i, match, offset);
        }
        return null;
    }
};


// src/utils.js
"use strict";
function $aaf1636a16b777ee$export$3226cf1d9b7b4bea(e) {
    if ([
        ...e
    ].length !== 1) throw new Error(`Expected "${e}" to be a single code point`);
    return e.codePointAt(0);
}
function $aaf1636a16b777ee$export$c4ed59b257196722(e, t, n) {
    return e.has(t) || e.set(t, n), e.get(t);
}
const $aaf1636a16b777ee$export$7b650c03beb4e566 = new Set([
    "alnum",
    "alpha",
    "ascii",
    "blank",
    "cntrl",
    "digit",
    "graph",
    "lower",
    "print",
    "punct",
    "space",
    "upper",
    "word",
    "xdigit"
]), $aaf1636a16b777ee$export$43caf9889c228507 = String.raw;
function $aaf1636a16b777ee$export$3b765e00c48ca2ba(e, t) {
    if (e == null) throw new Error(t ?? "Value expected");
    return e;
}


"use strict";
const $fbb0773712f256a7$var$m = (0, $aaf1636a16b777ee$export$43caf9889c228507)`\[\^?`, $fbb0773712f256a7$var$b = `c.? | C(?:-.?)?|${(0, $aaf1636a16b777ee$export$43caf9889c228507)`[pP]\{(?:\^?[-\x20_]*[A-Za-z][-\x20\w]*\})?`}|${(0, $aaf1636a16b777ee$export$43caf9889c228507)`x[89A-Fa-f]\p{AHex}(?:\\x[89A-Fa-f]\p{AHex})*`}|${(0, $aaf1636a16b777ee$export$43caf9889c228507)`u(?:\p{AHex}{4})? | x\{[^\}]*\}? | x\p{AHex}{0,2}`}|${(0, $aaf1636a16b777ee$export$43caf9889c228507)`o\{[^\}]*\}?`}|${(0, $aaf1636a16b777ee$export$43caf9889c228507)`\d{1,3}`}`, $fbb0773712f256a7$var$y = /[?*+][?+]?|\{(?:\d+(?:,\d*)?|,\d+)\}\??/, $fbb0773712f256a7$var$C = new RegExp((0, $aaf1636a16b777ee$export$43caf9889c228507)`
  \\ (?:
    ${$fbb0773712f256a7$var$b}
    | [gk]<[^>]*>?
    | [gk]'[^']*'?
    | .
  )
  | \( (?:
    \? (?:
      [:=!>({]
      | <[=!]
      | <[^>]*>
      | '[^']*'
      | ~\|?
      | #(?:[^)\\]|\\.?)*
      | [^:)]*[:)]
    )?
    | \*[^\)]*\)?
  )?
  | (?:${$fbb0773712f256a7$var$y.source})+
  | ${$fbb0773712f256a7$var$m}
  | .
`.replace(/\s+/g, ""), "gsu"), $fbb0773712f256a7$var$T = new RegExp((0, $aaf1636a16b777ee$export$43caf9889c228507)`
  \\ (?:
    ${$fbb0773712f256a7$var$b}
    | .
  )
  | \[:(?:\^?\p{Alpha}+|\^):\]
  | ${$fbb0773712f256a7$var$m}
  | &&
  | .
`.replace(/\s+/g, ""), "gsu");
function $fbb0773712f256a7$export$660b2ee2d4fb4eff(e, n = {}) {
    const t = {
        flags: "",
        ...n,
        rules: {
            captureGroup: !1,
            singleline: !1,
            ...n.rules
        }
    };
    if (typeof e != "string") throw new Error("String expected as pattern");
    const o = $fbb0773712f256a7$var$Y(t.flags), s = [
        o.extended
    ], a = {
        captureGroup: t.rules.captureGroup,
        getCurrentModX () {
            return s.at(-1);
        },
        numOpenGroups: 0,
        popModX () {
            s.pop();
        },
        pushModX (u) {
            s.push(u);
        },
        replaceCurrentModX (u) {
            s[s.length - 1] = u;
        },
        singleline: t.rules.singleline
    };
    let r = [], i;
    for($fbb0773712f256a7$var$C.lastIndex = 0; i = $fbb0773712f256a7$var$C.exec(e);){
        const u = $fbb0773712f256a7$var$F(a, e, i[0], $fbb0773712f256a7$var$C.lastIndex);
        u.tokens ? r.push(...u.tokens) : u.token && r.push(u.token), u.lastIndex !== void 0 && ($fbb0773712f256a7$var$C.lastIndex = u.lastIndex);
    }
    const l = [];
    let c = 0;
    r.filter((u)=>u.type === "GroupOpen").forEach((u)=>{
        u.kind === "capturing" ? u.number = ++c : u.raw === "(" && l.push(u);
    }), c || l.forEach((u, S)=>{
        u.kind = "capturing", u.number = S + 1;
    });
    const g = c || l.length;
    return {
        tokens: r.map((u)=>u.type === "EscapedNumber" ? $fbb0773712f256a7$var$ee(u, g) : u).flat(),
        flags: o
    };
}
function $fbb0773712f256a7$var$F(e, n, t, o) {
    const [s, a] = t;
    if (t === "[" || t === "[^") {
        const r = $fbb0773712f256a7$var$K(n, t, o);
        return {
            tokens: r.tokens,
            lastIndex: r.lastIndex
        };
    }
    if (s === "\\") {
        if ("AbBGyYzZ".includes(a)) return {
            token: $fbb0773712f256a7$var$w(t, t)
        };
        if (/^\\g[<']/.test(t)) {
            if (!/^\\g(?:<[^>]+>|'[^']+')$/.test(t)) throw new Error(`Invalid group name "${t}"`);
            return {
                token: $fbb0773712f256a7$var$R(t)
            };
        }
        if (/^\\k[<']/.test(t)) {
            if (!/^\\k(?:<[^>]+>|'[^']+')$/.test(t)) throw new Error(`Invalid group name "${t}"`);
            return {
                token: $fbb0773712f256a7$var$A(t)
            };
        }
        if (a === "K") return {
            token: $fbb0773712f256a7$var$I("keep", t)
        };
        if (a === "N" || a === "R") return {
            token: $fbb0773712f256a7$var$k("newline", t, {
                negate: a === "N"
            })
        };
        if (a === "O") return {
            token: $fbb0773712f256a7$var$k("any", t)
        };
        if (a === "X") return {
            token: $fbb0773712f256a7$var$k("text_segment", t)
        };
        const r = $fbb0773712f256a7$var$x(t, {
            inCharClass: !1
        });
        return Array.isArray(r) ? {
            tokens: r
        } : {
            token: r
        };
    }
    if (s === "(") {
        if (a === "*") return {
            token: $fbb0773712f256a7$var$j(t)
        };
        if (t === "(?{") throw new Error(`Unsupported callout "${t}"`);
        if (t.startsWith("(?#")) {
            if (n[o] !== ")") throw new Error('Unclosed comment group "(?#"');
            return {
                lastIndex: o + 1
            };
        }
        if (/^\(\?[-imx]+[:)]$/.test(t)) return {
            token: $fbb0773712f256a7$var$L(t, e)
        };
        if (e.pushModX(e.getCurrentModX()), e.numOpenGroups++, t === "(" && !e.captureGroup || t === "(?:") return {
            token: $fbb0773712f256a7$var$f("group", t)
        };
        if (t === "(?>") return {
            token: $fbb0773712f256a7$var$f("atomic", t)
        };
        if (t === "(?=" || t === "(?!" || t === "(?<=" || t === "(?<!") return {
            token: $fbb0773712f256a7$var$f(t[2] === "<" ? "lookbehind" : "lookahead", t, {
                negate: t.endsWith("!")
            })
        };
        if (t === "(" && e.captureGroup || t.startsWith("(?<") && t.endsWith(">") || t.startsWith("(?'") && t.endsWith("'")) return {
            token: $fbb0773712f256a7$var$f("capturing", t, {
                ...t !== "(" && {
                    name: t.slice(3, -1)
                }
            })
        };
        if (t.startsWith("(?~")) {
            if (t === "(?~|") throw new Error(`Unsupported absence function kind "${t}"`);
            return {
                token: $fbb0773712f256a7$var$f("absence_repeater", t)
            };
        }
        throw t === "(?(" ? new Error(`Unsupported conditional "${t}"`) : new Error(`Invalid or unsupported group option "${t}"`);
    }
    if (t === ")") {
        if (e.popModX(), e.numOpenGroups--, e.numOpenGroups < 0) throw new Error('Unmatched ")"');
        return {
            token: $fbb0773712f256a7$var$Q(t)
        };
    }
    if (e.getCurrentModX()) {
        if (t === "#") {
            const r = n.indexOf(`
`, o);
            return {
                lastIndex: r === -1 ? n.length : r
            };
        }
        if (/^\s$/.test(t)) {
            const r = /\s+/y;
            return r.lastIndex = o, {
                lastIndex: r.exec(n) ? r.lastIndex : o
            };
        }
    }
    if (t === ".") return {
        token: $fbb0773712f256a7$var$k("dot", t)
    };
    if (t === "^" || t === "$") {
        const r = e.singleline ? ({
            "^": (0, $aaf1636a16b777ee$export$43caf9889c228507)`\A`,
            $: (0, $aaf1636a16b777ee$export$43caf9889c228507)`\Z`
        })[t] : t;
        return {
            token: $fbb0773712f256a7$var$w(r, t)
        };
    }
    return t === "|" ? {
        token: $fbb0773712f256a7$var$P(t)
    } : $fbb0773712f256a7$var$y.test(t) ? {
        tokens: $fbb0773712f256a7$var$te(t)
    } : {
        token: $fbb0773712f256a7$var$d((0, $aaf1636a16b777ee$export$3226cf1d9b7b4bea)(t), t)
    };
}
function $fbb0773712f256a7$var$K(e, n, t) {
    const o = [
        $fbb0773712f256a7$var$E(n[1] === "^", n)
    ];
    let s = 1, a;
    for($fbb0773712f256a7$var$T.lastIndex = t; a = $fbb0773712f256a7$var$T.exec(e);){
        const r = a[0];
        if (r[0] === "[" && r[1] !== ":") s++, o.push($fbb0773712f256a7$var$E(r[1] === "^", r));
        else if (r === "]") {
            if (o.at(-1).type === "CharacterClassOpen") o.push($fbb0773712f256a7$var$d(93, r));
            else if (s--, o.push($fbb0773712f256a7$var$z(r)), !s) break;
        } else {
            const i = $fbb0773712f256a7$var$X(r);
            Array.isArray(i) ? o.push(...i) : o.push(i);
        }
    }
    return {
        tokens: o,
        lastIndex: $fbb0773712f256a7$var$T.lastIndex || e.length
    };
}
function $fbb0773712f256a7$var$X(e) {
    if (e[0] === "\\") return $fbb0773712f256a7$var$x(e, {
        inCharClass: !0
    });
    if (e[0] === "[") {
        const n = /\[:(?<negate>\^?)(?<name>[a-z]+):\]/.exec(e);
        if (!n || !(0, $aaf1636a16b777ee$export$7b650c03beb4e566).has(n.groups.name)) throw new Error(`Invalid POSIX class "${e}"`);
        return $fbb0773712f256a7$var$k("posix", e, {
            value: n.groups.name,
            negate: !!n.groups.negate
        });
    }
    return e === "-" ? $fbb0773712f256a7$var$U(e) : e === "&&" ? $fbb0773712f256a7$var$H(e) : $fbb0773712f256a7$var$d((0, $aaf1636a16b777ee$export$3226cf1d9b7b4bea)(e), e);
}
function $fbb0773712f256a7$var$x(e, { inCharClass: n }) {
    const t = e[1];
    if (t === "c" || t === "C") return $fbb0773712f256a7$var$Z(e);
    if ("dDhHsSwW".includes(t)) return $fbb0773712f256a7$var$q(e);
    if (e.startsWith((0, $aaf1636a16b777ee$export$43caf9889c228507)`\o{`)) throw new Error(`Incomplete, invalid, or unsupported octal code point "${e}"`);
    if (/^\\[pP]\{/.test(e)) {
        if (e.length === 3) throw new Error(`Incomplete or invalid Unicode property "${e}"`);
        return $fbb0773712f256a7$var$V(e);
    }
    if (/^\\x[89A-Fa-f]\p{AHex}/u.test(e)) try {
        const o = e.split(/\\x/).slice(1).map((i)=>parseInt(i, 16)), s = new TextDecoder("utf-8", {
            ignoreBOM: !0,
            fatal: !0
        }).decode(new Uint8Array(o)), a = new TextEncoder;
        return [
            ...s
        ].map((i)=>{
            const l = [
                ...a.encode(i)
            ].map((c)=>`\\x${c.toString(16)}`).join("");
            return $fbb0773712f256a7$var$d((0, $aaf1636a16b777ee$export$3226cf1d9b7b4bea)(i), l);
        });
    } catch  {
        throw new Error(`Multibyte code "${e}" incomplete or invalid in Oniguruma`);
    }
    if (t === "u" || t === "x") return $fbb0773712f256a7$var$d($fbb0773712f256a7$var$J(e), e);
    if ($fbb0773712f256a7$var$$.has(t)) return $fbb0773712f256a7$var$d($fbb0773712f256a7$var$$.get(t), e);
    if (/\d/.test(t)) return $fbb0773712f256a7$var$W(n, e);
    if (e === "\\") throw new Error((0, $aaf1636a16b777ee$export$43caf9889c228507)`Incomplete escape "\"`);
    if (t === "M") throw new Error(`Unsupported meta "${e}"`);
    if ([
        ...e
    ].length === 2) return $fbb0773712f256a7$var$d(e.codePointAt(1), e);
    throw new Error(`Unexpected escape "${e}"`);
}
function $fbb0773712f256a7$var$P(e) {
    return {
        type: "Alternator",
        raw: e
    };
}
function $fbb0773712f256a7$var$w(e, n) {
    return {
        type: "Assertion",
        kind: e,
        raw: n
    };
}
function $fbb0773712f256a7$var$A(e) {
    return {
        type: "Backreference",
        raw: e
    };
}
function $fbb0773712f256a7$var$d(e, n) {
    return {
        type: "Character",
        value: e,
        raw: n
    };
}
function $fbb0773712f256a7$var$z(e) {
    return {
        type: "CharacterClassClose",
        raw: e
    };
}
function $fbb0773712f256a7$var$U(e) {
    return {
        type: "CharacterClassHyphen",
        raw: e
    };
}
function $fbb0773712f256a7$var$H(e) {
    return {
        type: "CharacterClassIntersector",
        raw: e
    };
}
function $fbb0773712f256a7$var$E(e, n) {
    return {
        type: "CharacterClassOpen",
        negate: e,
        raw: n
    };
}
function $fbb0773712f256a7$var$k(e, n, t = {}) {
    return {
        type: "CharacterSet",
        kind: e,
        ...t,
        raw: n
    };
}
function $fbb0773712f256a7$var$I(e, n, t = {}) {
    return e === "keep" ? {
        type: "Directive",
        kind: e,
        raw: n
    } : {
        type: "Directive",
        kind: e,
        flags: (0, $aaf1636a16b777ee$export$3b765e00c48ca2ba)(t.flags),
        raw: n
    };
}
function $fbb0773712f256a7$var$W(e, n) {
    return {
        type: "EscapedNumber",
        inCharClass: e,
        raw: n
    };
}
function $fbb0773712f256a7$var$Q(e) {
    return {
        type: "GroupClose",
        raw: e
    };
}
function $fbb0773712f256a7$var$f(e, n, t = {}) {
    return {
        type: "GroupOpen",
        kind: e,
        ...t,
        raw: n
    };
}
function $fbb0773712f256a7$var$D(e, n, t, o) {
    return {
        type: "NamedCallout",
        kind: e,
        tag: n,
        arguments: t,
        raw: o
    };
}
function $fbb0773712f256a7$var$_(e, n, t, o) {
    return {
        type: "Quantifier",
        kind: e,
        min: n,
        max: t,
        raw: o
    };
}
function $fbb0773712f256a7$var$R(e) {
    return {
        type: "Subroutine",
        raw: e
    };
}
const $fbb0773712f256a7$var$B = new Set([
    "COUNT",
    "CMP",
    "ERROR",
    "FAIL",
    "MAX",
    "MISMATCH",
    "SKIP",
    "TOTAL_COUNT"
]), $fbb0773712f256a7$var$$ = new Map([
    [
        "a",
        7
    ],
    [
        "b",
        8
    ],
    [
        "e",
        27
    ],
    [
        "f",
        12
    ],
    [
        "n",
        10
    ],
    [
        "r",
        13
    ],
    [
        "t",
        9
    ],
    [
        "v",
        11
    ]
]);
function $fbb0773712f256a7$var$Z(e) {
    const n = e[1] === "c" ? e[2] : e[3];
    if (!n || !/[A-Za-z]/.test(n)) throw new Error(`Unsupported control character "${e}"`);
    return $fbb0773712f256a7$var$d((0, $aaf1636a16b777ee$export$3226cf1d9b7b4bea)(n.toUpperCase()) - 64, e);
}
function $fbb0773712f256a7$var$L(e, n) {
    let { on: t, off: o } = /^\(\?(?<on>[imx]*)(?:-(?<off>[-imx]*))?/.exec(e).groups;
    o ??= "";
    const s = (n.getCurrentModX() || t.includes("x")) && !o.includes("x"), a = $fbb0773712f256a7$var$v(t), r = $fbb0773712f256a7$var$v(o), i = {};
    if (a && (i.enable = a), r && (i.disable = r), e.endsWith(")")) return n.replaceCurrentModX(s), $fbb0773712f256a7$var$I("flags", e, {
        flags: i
    });
    if (e.endsWith(":")) return n.pushModX(s), n.numOpenGroups++, $fbb0773712f256a7$var$f("group", e, {
        ...(a || r) && {
            flags: i
        }
    });
    throw new Error(`Unexpected flag modifier "${e}"`);
}
function $fbb0773712f256a7$var$j(e) {
    const n = /\(\*(?<name>[A-Za-z_]\w*)?(?:\[(?<tag>(?:[A-Za-z_]\w*)?)\])?(?:\{(?<args>[^}]*)\})?\)/.exec(e);
    if (!n) throw new Error(`Incomplete or invalid named callout "${e}"`);
    const { name: t, tag: o, args: s } = n.groups;
    if (!t) throw new Error(`Invalid named callout "${e}"`);
    if (o === "") throw new Error(`Named callout tag with empty value not allowed "${e}"`);
    const a = s ? s.split(",").filter((g)=>g !== "").map((g)=>/^[+-]?\d+$/.test(g) ? +g : g) : [], [r, i, l] = a, c = $fbb0773712f256a7$var$B.has(t) ? t.toLowerCase() : "custom";
    switch(c){
        case "fail":
        case "mismatch":
        case "skip":
            if (a.length > 0) throw new Error(`Named callout arguments not allowed "${a}"`);
            break;
        case "error":
            if (a.length > 1) throw new Error(`Named callout allows only one argument "${a}"`);
            if (typeof r == "string") throw new Error(`Named callout argument must be a number "${r}"`);
            break;
        case "max":
            if (!a.length || a.length > 2) throw new Error(`Named callout must have one or two arguments "${a}"`);
            if (typeof r == "string" && !/^[A-Za-z_]\w*$/.test(r)) throw new Error(`Named callout argument one must be a tag or number "${r}"`);
            if (a.length === 2 && (typeof i == "number" || !/^[<>X]$/.test(i))) throw new Error(`Named callout optional argument two must be '<', '>', or 'X' "${i}"`);
            break;
        case "count":
        case "total_count":
            if (a.length > 1) throw new Error(`Named callout allows only one argument "${a}"`);
            if (a.length === 1 && (typeof r == "number" || !/^[<>X]$/.test(r))) throw new Error(`Named callout optional argument must be '<', '>', or 'X' "${r}"`);
            break;
        case "cmp":
            if (a.length !== 3) throw new Error(`Named callout must have three arguments "${a}"`);
            if (typeof r == "string" && !/^[A-Za-z_]\w*$/.test(r)) throw new Error(`Named callout argument one must be a tag or number "${r}"`);
            if (typeof i == "number" || !/^(?:[<>!=]=|[<>])$/.test(i)) throw new Error(`Named callout argument two must be '==', '!=', '>', '<', '>=', or '<=' "${i}"`);
            if (typeof l == "string" && !/^[A-Za-z_]\w*$/.test(l)) throw new Error(`Named callout argument three must be a tag or number "${l}"`);
            break;
        case "custom":
            throw new Error(`Undefined callout name "${t}"`);
        default:
            throw new Error(`Unexpected named callout kind "${c}"`);
    }
    return $fbb0773712f256a7$var$D(c, o ?? null, s?.split(",") ?? null, e);
}
function $fbb0773712f256a7$var$O(e) {
    let n = null, t, o;
    if (e[0] === "{") {
        const { minStr: s, maxStr: a } = /^\{(?<minStr>\d*)(?:,(?<maxStr>\d*))?/.exec(e).groups, r = 1e5;
        if (+s > r || a && +a > r) throw new Error("Quantifier value unsupported in Oniguruma");
        if (t = +s, o = a === void 0 ? +s : a === "" ? 1 / 0 : +a, t > o && (n = "possessive", [t, o] = [
            o,
            t
        ]), e.endsWith("?")) {
            if (n === "possessive") throw new Error('Unsupported possessive interval quantifier chain with "?"');
            n = "lazy";
        } else n || (n = "greedy");
    } else t = e[0] === "+" ? 1 : 0, o = e[0] === "?" ? 1 : 1 / 0, n = e[1] === "+" ? "possessive" : e[1] === "?" ? "lazy" : "greedy";
    return $fbb0773712f256a7$var$_(n, t, o, e);
}
function $fbb0773712f256a7$var$q(e) {
    const n = e[1].toLowerCase();
    return $fbb0773712f256a7$var$k({
        d: "digit",
        h: "hex",
        s: "space",
        w: "word"
    }[n], e, {
        negate: e[1] !== n
    });
}
function $fbb0773712f256a7$var$V(e) {
    const { p: n, neg: t, value: o } = /^\\(?<p>[pP])\{(?<neg>\^?)(?<value>[^}]+)/.exec(e).groups;
    return $fbb0773712f256a7$var$k("property", e, {
        value: o,
        negate: n === "P" && !t || n === "p" && !!t
    });
}
function $fbb0773712f256a7$var$v(e) {
    const n = {};
    return e.includes("i") && (n.ignoreCase = !0), e.includes("m") && (n.dotAll = !0), e.includes("x") && (n.extended = !0), Object.keys(n).length ? n : null;
}
function $fbb0773712f256a7$var$Y(e) {
    const n = {
        ignoreCase: !1,
        dotAll: !1,
        extended: !1,
        digitIsAscii: !1,
        posixIsAscii: !1,
        spaceIsAscii: !1,
        wordIsAscii: !1,
        textSegmentMode: null
    };
    for(let t = 0; t < e.length; t++){
        const o = e[t];
        if (!"imxDPSWy".includes(o)) throw new Error(`Invalid flag "${o}"`);
        if (o === "y") {
            if (!/^y{[gw]}/.test(e.slice(t))) throw new Error('Invalid or unspecified flag "y" mode');
            n.textSegmentMode = e[t + 2] === "g" ? "grapheme" : "word", t += 3;
            continue;
        }
        n[({
            i: "ignoreCase",
            m: "dotAll",
            x: "extended",
            D: "digitIsAscii",
            P: "posixIsAscii",
            S: "spaceIsAscii",
            W: "wordIsAscii"
        })[o]] = !0;
    }
    return n;
}
function $fbb0773712f256a7$var$J(e) {
    if (/^(?:\\u(?!\p{AHex}{4})|\\x(?!\p{AHex}{1,2}|\{\p{AHex}{1,8}\}))/u.test(e)) throw new Error(`Incomplete or invalid escape "${e}"`);
    const n = e[2] === "{" ? /^\\x\{\s*(?<hex>\p{AHex}+)/u.exec(e).groups.hex : e.slice(2);
    return parseInt(n, 16);
}
function $fbb0773712f256a7$var$ee(e, n) {
    const { raw: t, inCharClass: o } = e, s = t.slice(1);
    if (!o && (s !== "0" && s.length === 1 || s[0] !== "0" && +s <= n)) return [
        $fbb0773712f256a7$var$A(t)
    ];
    const a = [], r = s.match(/^[0-7]+|\d/g);
    for(let i = 0; i < r.length; i++){
        const l = r[i];
        let c;
        if (i === 0 && l !== "8" && l !== "9") {
            if (c = parseInt(l, 8), c > 127) throw new Error((0, $aaf1636a16b777ee$export$43caf9889c228507)`Octal encoded byte above 177 unsupported "${t}"`);
        } else c = (0, $aaf1636a16b777ee$export$3226cf1d9b7b4bea)(l);
        a.push($fbb0773712f256a7$var$d(c, (i === 0 ? "\\" : "") + l));
    }
    return a;
}
function $fbb0773712f256a7$var$te(e) {
    const n = [], t = new RegExp($fbb0773712f256a7$var$y, "gy");
    let o;
    for(; o = t.exec(e);){
        const s = o[0];
        if (s[0] === "{") {
            const a = /^\{(?<min>\d+),(?<max>\d+)\}\??$/.exec(s);
            if (a) {
                const { min: r, max: i } = a.groups;
                if (+r > +i && s.endsWith("?")) {
                    t.lastIndex--, n.push($fbb0773712f256a7$var$O(s.slice(0, -1)));
                    continue;
                }
            }
        }
        n.push($fbb0773712f256a7$var$O(s));
    }
    return n;
}



"use strict";
function $afa8d6abbb644392$export$dcb3ae0c3f199df3(e, t) {
    if (!Array.isArray(e.body)) throw new Error("Expected node with body array");
    if (e.body.length !== 1) return !1;
    const r = e.body[0];
    return !t || Object.keys(t).every((n)=>t[n] === r[n]);
}
function $afa8d6abbb644392$export$bce313fa0917d31c(e) {
    return !(!$afa8d6abbb644392$var$i.has(e.type) || e.type === "AbsenceFunction" && e.kind !== "repeater");
}
const $afa8d6abbb644392$var$i = new Set([
    "AbsenceFunction",
    "CapturingGroup",
    "Group",
    "LookaroundAssertion",
    "Regex"
]);
function $afa8d6abbb644392$export$ba95449642bd2f29(e) {
    return $afa8d6abbb644392$var$y.has(e.type);
}
const $afa8d6abbb644392$var$y = new Set([
    "AbsenceFunction",
    "Backreference",
    "CapturingGroup",
    "Character",
    "CharacterClass",
    "CharacterSet",
    "Group",
    "Quantifier",
    "Subroutine"
]);


"use strict";
function $81a53fa315512537$export$98e6a39c04603d36(e, r = {}) {
    const n = {
        flags: "",
        normalizeUnknownPropertyNames: !1,
        skipBackrefValidation: !1,
        skipLookbehindValidation: !1,
        skipPropertyNameValidation: !1,
        unicodePropertyMap: null,
        ...r,
        rules: {
            captureGroup: !1,
            singleline: !1,
            ...r.rules
        }
    }, o = (0, $fbb0773712f256a7$export$660b2ee2d4fb4eff)(e, {
        flags: n.flags,
        rules: {
            captureGroup: n.rules.captureGroup,
            singleline: n.rules.singleline
        }
    }), i = (p, N)=>{
        const u = o.tokens[t.nextIndex];
        switch(t.parent = p, t.nextIndex++, u.type){
            case "Alternator":
                return $81a53fa315512537$export$4506b1bb0cf5d8dd();
            case "Assertion":
                return $81a53fa315512537$var$W(u);
            case "Backreference":
                return $81a53fa315512537$var$X(u, t);
            case "Character":
                return $81a53fa315512537$export$4d63783c2be0a38c(u.value, {
                    useLastValid: !!N.isCheckingRangeEnd
                });
            case "CharacterClassHyphen":
                return $81a53fa315512537$var$ee(u, t, N);
            case "CharacterClassOpen":
                return $81a53fa315512537$var$re(u, t, N);
            case "CharacterSet":
                return $81a53fa315512537$var$ne(u, t);
            case "Directive":
                return $81a53fa315512537$export$5b526547d047f0c5(u.kind, {
                    flags: u.flags
                });
            case "GroupOpen":
                return $81a53fa315512537$var$te(u, t, N);
            case "NamedCallout":
                return $81a53fa315512537$export$c55dc041d92a68d5(u.kind, u.tag, u.arguments);
            case "Quantifier":
                return $81a53fa315512537$var$oe(u, t);
            case "Subroutine":
                return $81a53fa315512537$var$ae(u, t);
            default:
                throw new Error(`Unexpected token type "${u.type}"`);
        }
    }, t = {
        capturingGroups: [],
        hasNumberedRef: !1,
        namedGroupsByName: new Map,
        nextIndex: 0,
        normalizeUnknownPropertyNames: n.normalizeUnknownPropertyNames,
        parent: null,
        skipBackrefValidation: n.skipBackrefValidation,
        skipLookbehindValidation: n.skipLookbehindValidation,
        skipPropertyNameValidation: n.skipPropertyNameValidation,
        subroutines: [],
        tokens: o.tokens,
        unicodePropertyMap: n.unicodePropertyMap,
        walk: i
    }, d = $81a53fa315512537$export$98d2929ccc6bd916($81a53fa315512537$export$bf8c332f00a76460(o.flags));
    let s = d.body[0];
    for(; t.nextIndex < o.tokens.length;){
        const p = i(s, {});
        p.type === "Alternative" ? (d.body.push(p), s = p) : s.body.push(p);
    }
    const { capturingGroups: a, hasNumberedRef: l, namedGroupsByName: c, subroutines: f } = t;
    if (l && c.size && !n.rules.captureGroup) throw new Error("Numbered backref/subroutine not allowed when using named capture");
    for (const { ref: p } of f)if (typeof p == "number") {
        if (p > a.length) throw new Error("Subroutine uses a group number that's not defined");
        p && (a[p - 1].isSubroutined = !0);
    } else if (c.has(p)) {
        if (c.get(p).length > 1) throw new Error((0, $aaf1636a16b777ee$export$43caf9889c228507)`Subroutine uses a duplicate group name "\g<${p}>"`);
        c.get(p)[0].isSubroutined = !0;
    } else throw new Error((0, $aaf1636a16b777ee$export$43caf9889c228507)`Subroutine uses a group name that's not defined "\g<${p}>"`);
    return d;
}
function $81a53fa315512537$var$W({ kind: e }) {
    return $81a53fa315512537$export$987f29926deb46c2((0, $aaf1636a16b777ee$export$3b765e00c48ca2ba)({
        "^": "line_start",
        $: "line_end",
        "\\A": "string_start",
        "\\b": "word_boundary",
        "\\B": "word_boundary",
        "\\G": "search_start",
        "\\y": "text_segment_boundary",
        "\\Y": "text_segment_boundary",
        "\\z": "string_end",
        "\\Z": "string_end_newline"
    }[e], `Unexpected assertion kind "${e}"`), {
        negate: e === (0, $aaf1636a16b777ee$export$43caf9889c228507)`\B` || e === (0, $aaf1636a16b777ee$export$43caf9889c228507)`\Y`
    });
}
function $81a53fa315512537$var$X({ raw: e }, r) {
    const n = /^\\k[<']/.test(e), o = n ? e.slice(3, -1) : e.slice(1), i = (t, d = !1)=>{
        const s = r.capturingGroups.length;
        let a = !1;
        if (t > s) {
            if (r.skipBackrefValidation) a = !0;
            else throw new Error(`Not enough capturing groups defined to the left "${e}"`);
        }
        return r.hasNumberedRef = !0, $81a53fa315512537$export$19ee8a21aa784111(d ? s + 1 - t : t, {
            orphan: a
        });
    };
    if (n) {
        const t = /^(?<sign>-?)0*(?<num>[1-9]\d*)$/.exec(o);
        if (t) return i(+t.groups.num, !!t.groups.sign);
        if (/[-+]/.test(o)) throw new Error(`Invalid backref name "${e}"`);
        if (!r.namedGroupsByName.has(o)) throw new Error(`Group name not defined to the left "${e}"`);
        return $81a53fa315512537$export$19ee8a21aa784111(o);
    }
    return i(+o);
}
function $81a53fa315512537$var$ee(e, r, n) {
    const { tokens: o, walk: i } = r, t = r.parent, d = t.body.at(-1), s = o[r.nextIndex];
    if (!n.isCheckingRangeEnd && d && d.type !== "CharacterClass" && d.type !== "CharacterClassRange" && s && s.type !== "CharacterClassOpen" && s.type !== "CharacterClassClose" && s.type !== "CharacterClassIntersector") {
        const a = i(t, {
            ...n,
            isCheckingRangeEnd: !0
        });
        if (d.type === "Character" && a.type === "Character") return t.body.pop(), $81a53fa315512537$export$4249e19df10db8da(d, a);
        throw new Error("Invalid character class range");
    }
    return $81a53fa315512537$export$4d63783c2be0a38c((0, $aaf1636a16b777ee$export$3226cf1d9b7b4bea)("-"));
}
function $81a53fa315512537$var$re({ negate: e }, r, n) {
    const { tokens: o, walk: i } = r, t = [
        $81a53fa315512537$export$9e021a2c1a31ab55()
    ], d = o[r.nextIndex];
    let s = $81a53fa315512537$var$z(d);
    for(; s.type !== "CharacterClassClose";){
        if (s.type === "CharacterClassIntersector") t.push($81a53fa315512537$export$9e021a2c1a31ab55()), r.nextIndex++;
        else {
            const l = t.at(-1);
            l.body.push(i(l, n));
        }
        s = $81a53fa315512537$var$z(o[r.nextIndex], d);
    }
    const a = $81a53fa315512537$export$9e021a2c1a31ab55({
        negate: e
    });
    return t.length === 1 ? a.body = t[0].body : (a.kind = "intersection", a.body = t.map((l)=>l.body.length === 1 ? l.body[0] : l)), r.nextIndex++, a;
}
function $81a53fa315512537$var$ne({ kind: e, negate: r, value: n }, o) {
    const { normalizeUnknownPropertyNames: i, skipPropertyNameValidation: t, unicodePropertyMap: d } = o;
    if (e === "property") {
        const s = $81a53fa315512537$export$74643d1fe038be1a(n);
        if ((0, $aaf1636a16b777ee$export$7b650c03beb4e566).has(s) && !d?.has(s)) e = "posix", n = s;
        else return $81a53fa315512537$export$3968c6d753b95879(n, {
            negate: r,
            normalizeUnknownPropertyNames: i,
            skipPropertyNameValidation: t,
            unicodePropertyMap: d
        });
    }
    return e === "posix" ? $81a53fa315512537$export$7a84b53e0fed4c59(n, {
        negate: r
    }) : $81a53fa315512537$export$247758b45a713079(e, {
        negate: r
    });
}
function $81a53fa315512537$var$te(e, r, n) {
    const { tokens: o, capturingGroups: i, namedGroupsByName: t, skipLookbehindValidation: d, walk: s } = r, a = $81a53fa315512537$var$ie(e), l = a.type === "AbsenceFunction", c = $81a53fa315512537$var$$(a), f = c && a.negate;
    if (a.type === "CapturingGroup" && (i.push(a), a.name && (0, $aaf1636a16b777ee$export$c4ed59b257196722)(t, a.name, []).push(a)), l && n.isInAbsenceFunction) throw new Error("Nested absence function not supported by Oniguruma");
    let p = $81a53fa315512537$var$D(o[r.nextIndex]);
    for(; p.type !== "GroupClose";){
        if (p.type === "Alternator") a.body.push($81a53fa315512537$export$4506b1bb0cf5d8dd()), r.nextIndex++;
        else {
            const N = a.body.at(-1), u = s(N, {
                ...n,
                isInAbsenceFunction: n.isInAbsenceFunction || l,
                isInLookbehind: n.isInLookbehind || c,
                isInNegLookbehind: n.isInNegLookbehind || f
            });
            if (N.body.push(u), (c || n.isInLookbehind) && !d) {
                const v = "Lookbehind includes a pattern not allowed by Oniguruma";
                if (f || n.isInNegLookbehind) {
                    if ($81a53fa315512537$var$M(u) || u.type === "CapturingGroup") throw new Error(v);
                } else if ($81a53fa315512537$var$M(u) || $81a53fa315512537$var$$(u) && u.negate) throw new Error(v);
            }
        }
        p = $81a53fa315512537$var$D(o[r.nextIndex]);
    }
    return r.nextIndex++, a;
}
function $81a53fa315512537$var$oe({ kind: e, min: r, max: n }, o) {
    const i = o.parent, t = i.body.at(-1);
    if (!t || !(0, $afa8d6abbb644392$export$ba95449642bd2f29)(t)) throw new Error("Quantifier requires a repeatable token");
    const d = $81a53fa315512537$export$169ce51b0f523e68(e, r, n, t);
    return i.body.pop(), d;
}
function $81a53fa315512537$var$ae({ raw: e }, r) {
    const { capturingGroups: n, subroutines: o } = r;
    let i = e.slice(3, -1);
    const t = /^(?<sign>[-+]?)0*(?<num>[1-9]\d*)$/.exec(i);
    if (t) {
        const s = +t.groups.num, a = n.length;
        if (r.hasNumberedRef = !0, i = ({
            "": s,
            "+": a + s,
            "-": a + 1 - s
        })[t.groups.sign], i < 1) throw new Error("Invalid subroutine number");
    } else i === "0" && (i = 0);
    const d = $81a53fa315512537$export$3b50b5d6d0004cab(i);
    return o.push(d), d;
}
function $81a53fa315512537$export$1f057c6c5c67512c(e, r) {
    if (e !== "repeater") throw new Error(`Unexpected absence function kind "${e}"`);
    return {
        type: "AbsenceFunction",
        kind: e,
        body: $81a53fa315512537$var$h(r?.body)
    };
}
function $81a53fa315512537$export$4506b1bb0cf5d8dd(e) {
    return {
        type: "Alternative",
        body: $81a53fa315512537$var$V(e?.body)
    };
}
function $81a53fa315512537$export$987f29926deb46c2(e, r) {
    const n = {
        type: "Assertion",
        kind: e
    };
    return (e === "word_boundary" || e === "text_segment_boundary") && (n.negate = !!r?.negate), n;
}
function $81a53fa315512537$export$19ee8a21aa784111(e, r) {
    const n = !!r?.orphan;
    return {
        type: "Backreference",
        ref: e,
        ...n && {
            orphan: n
        }
    };
}
function $81a53fa315512537$export$e8bb25176ecaca85(e, r) {
    const n = {
        name: void 0,
        isSubroutined: !1,
        ...r
    };
    if (n.name !== void 0 && !$81a53fa315512537$var$se(n.name)) throw new Error(`Group name "${n.name}" invalid in Oniguruma`);
    return {
        type: "CapturingGroup",
        number: e,
        ...n.name && {
            name: n.name
        },
        ...n.isSubroutined && {
            isSubroutined: n.isSubroutined
        },
        body: $81a53fa315512537$var$h(r?.body)
    };
}
function $81a53fa315512537$export$4d63783c2be0a38c(e, r) {
    const n = {
        useLastValid: !1,
        ...r
    };
    if (e > 1114111) {
        const o = e.toString(16);
        if (n.useLastValid) e = 1114111;
        else throw e > 1310719 ? new Error(`Invalid code point out of range "\\x{${o}}"`) : new Error(`Invalid code point out of range in JS "\\x{${o}}"`);
    }
    return {
        type: "Character",
        value: e
    };
}
function $81a53fa315512537$export$9e021a2c1a31ab55(e) {
    const r = {
        kind: "union",
        negate: !1,
        ...e
    };
    return {
        type: "CharacterClass",
        kind: r.kind,
        negate: r.negate,
        body: $81a53fa315512537$var$V(e?.body)
    };
}
function $81a53fa315512537$export$4249e19df10db8da(e, r) {
    if (r.value < e.value) throw new Error("Character class range out of order");
    return {
        type: "CharacterClassRange",
        min: e,
        max: r
    };
}
function $81a53fa315512537$export$247758b45a713079(e, r) {
    const n = !!r?.negate, o = {
        type: "CharacterSet",
        kind: e
    };
    return (e === "digit" || e === "hex" || e === "newline" || e === "space" || e === "word") && (o.negate = n), (e === "text_segment" || e === "newline" && !n) && (o.variableLength = !0), o;
}
function $81a53fa315512537$export$5b526547d047f0c5(e, r = {}) {
    if (e === "keep") return {
        type: "Directive",
        kind: e
    };
    if (e === "flags") return {
        type: "Directive",
        kind: e,
        flags: (0, $aaf1636a16b777ee$export$3b765e00c48ca2ba)(r.flags)
    };
    throw new Error(`Unexpected directive kind "${e}"`);
}
function $81a53fa315512537$export$bf8c332f00a76460(e) {
    return {
        type: "Flags",
        ...e
    };
}
function $81a53fa315512537$export$856f728536d122cb(e) {
    const r = e?.atomic, n = e?.flags;
    if (r && n) throw new Error("Atomic group cannot have flags");
    return {
        type: "Group",
        ...r && {
            atomic: r
        },
        ...n && {
            flags: n
        },
        body: $81a53fa315512537$var$h(e?.body)
    };
}
function $81a53fa315512537$export$a1c731c64d750557(e) {
    const r = {
        behind: !1,
        negate: !1,
        ...e
    };
    return {
        type: "LookaroundAssertion",
        kind: r.behind ? "lookbehind" : "lookahead",
        negate: r.negate,
        body: $81a53fa315512537$var$h(e?.body)
    };
}
function $81a53fa315512537$export$c55dc041d92a68d5(e, r, n) {
    return {
        type: "NamedCallout",
        kind: e,
        tag: r,
        arguments: n
    };
}
function $81a53fa315512537$export$7a84b53e0fed4c59(e, r) {
    const n = !!r?.negate;
    if (!(0, $aaf1636a16b777ee$export$7b650c03beb4e566).has(e)) throw new Error(`Invalid POSIX class "${e}"`);
    return {
        type: "CharacterSet",
        kind: "posix",
        value: e,
        negate: n
    };
}
function $81a53fa315512537$export$169ce51b0f523e68(e, r, n, o) {
    if (r > n) throw new Error("Invalid reversed quantifier range");
    return {
        type: "Quantifier",
        kind: e,
        min: r,
        max: n,
        body: o
    };
}
function $81a53fa315512537$export$98d2929ccc6bd916(e, r) {
    return {
        type: "Regex",
        body: $81a53fa315512537$var$h(r?.body),
        flags: e
    };
}
function $81a53fa315512537$export$3b50b5d6d0004cab(e) {
    return {
        type: "Subroutine",
        ref: e
    };
}
function $81a53fa315512537$export$3968c6d753b95879(e, r) {
    const n = {
        negate: !1,
        normalizeUnknownPropertyNames: !1,
        skipPropertyNameValidation: !1,
        unicodePropertyMap: null,
        ...r
    };
    let o = n.unicodePropertyMap?.get($81a53fa315512537$export$74643d1fe038be1a(e));
    if (!o) {
        if (n.normalizeUnknownPropertyNames) o = $81a53fa315512537$var$de(e);
        else if (n.unicodePropertyMap && !n.skipPropertyNameValidation) throw new Error((0, $aaf1636a16b777ee$export$43caf9889c228507)`Invalid Unicode property "\p{${e}}"`);
    }
    return {
        type: "CharacterSet",
        kind: "property",
        value: o ?? e,
        negate: n.negate
    };
}
function $81a53fa315512537$var$ie({ flags: e, kind: r, name: n, negate: o, number: i }) {
    switch(r){
        case "absence_repeater":
            return $81a53fa315512537$export$1f057c6c5c67512c("repeater");
        case "atomic":
            return $81a53fa315512537$export$856f728536d122cb({
                atomic: !0
            });
        case "capturing":
            return $81a53fa315512537$export$e8bb25176ecaca85(i, {
                name: n
            });
        case "group":
            return $81a53fa315512537$export$856f728536d122cb({
                flags: e
            });
        case "lookahead":
        case "lookbehind":
            return $81a53fa315512537$export$a1c731c64d750557({
                behind: r === "lookbehind",
                negate: o
            });
        default:
            throw new Error(`Unexpected group kind "${r}"`);
    }
}
function $81a53fa315512537$var$h(e) {
    if (e === void 0) e = [
        $81a53fa315512537$export$4506b1bb0cf5d8dd()
    ];
    else if (!Array.isArray(e) || !e.length || !e.every((r)=>r.type === "Alternative")) throw new Error("Invalid body; expected array of one or more Alternative nodes");
    return e;
}
function $81a53fa315512537$var$V(e) {
    if (e === void 0) e = [];
    else if (!Array.isArray(e) || !e.every((r)=>!!r.type)) throw new Error("Invalid body; expected array of nodes");
    return e;
}
function $81a53fa315512537$var$M(e) {
    return e.type === "LookaroundAssertion" && e.kind === "lookahead";
}
function $81a53fa315512537$var$$(e) {
    return e.type === "LookaroundAssertion" && e.kind === "lookbehind";
}
function $81a53fa315512537$var$se(e) {
    return /^[\p{Alpha}\p{Pc}][^)]*$/u.test(e);
}
function $81a53fa315512537$var$de(e) {
    return e.trim().replace(/[- _]+/g, "_").replace(/[A-Z][a-z]+(?=[A-Z])/g, "$&_").replace(/[A-Za-z]+/g, (r)=>r[0].toUpperCase() + r.slice(1).toLowerCase());
}
function $81a53fa315512537$export$74643d1fe038be1a(e) {
    return e.replace(/[- _]+/g, "").toLowerCase();
}
function $81a53fa315512537$var$z(e, r) {
    const n = r;
    return (0, $aaf1636a16b777ee$export$3b765e00c48ca2ba)(e, `Unclosed character class${n?.type === "Character" && n.value === 93 && n.raw === "]" ? ' (started with "]")' : ""}`);
}
function $81a53fa315512537$var$D(e) {
    return (0, $aaf1636a16b777ee$export$3b765e00c48ca2ba)(e, "Unclosed group");
}



"use strict";
function $ad81d75b55705a46$export$df3f009e3d155b20(a, v, N = null) {
    function b(e, s) {
        for(let t = 0; t < e.length; t++){
            const r = n(e[t], s, t, e);
            t = Math.max(-1, t + r);
        }
    }
    function n(e, s = null, t = null, r = null) {
        let i = 0, c = !1;
        const d = {
            node: e,
            parent: s,
            key: t,
            container: r,
            root: a,
            remove () {
                $ad81d75b55705a46$var$x(r).splice(Math.max(0, $ad81d75b55705a46$var$l(t) + i), 1), i--, c = !0;
            },
            removeAllNextSiblings () {
                return $ad81d75b55705a46$var$x(r).splice($ad81d75b55705a46$var$l(t) + 1);
            },
            removeAllPrevSiblings () {
                const o = $ad81d75b55705a46$var$l(t) + i;
                return i -= o, $ad81d75b55705a46$var$x(r).splice(0, Math.max(0, o));
            },
            replaceWith (o, m = {}) {
                const y = !!m.traverse;
                r ? r[Math.max(0, $ad81d75b55705a46$var$l(t) + i)] = o : (0, $aaf1636a16b777ee$export$3b765e00c48ca2ba)(s, "Can't replace root node")[t] = o, y && n(o, s, t, r), c = !0;
            },
            replaceWithMultiple (o, m = {}) {
                const y = !!m.traverse;
                if ($ad81d75b55705a46$var$x(r).splice(Math.max(0, $ad81d75b55705a46$var$l(t) + i), 1, ...o), i += o.length - 1, y) {
                    let g = 0;
                    for(let p = 0; p < o.length; p++)g += n(o[p], s, $ad81d75b55705a46$var$l(t) + p + g, r);
                }
                c = !0;
            },
            skip () {
                c = !0;
            }
        }, { type: f } = e, u = v["*"], h = v[f], R = typeof u == "function" ? u : u?.enter, P = typeof h == "function" ? h : h?.enter;
        if (R?.(d, N), P?.(d, N), !c) switch(f){
            case "AbsenceFunction":
            case "Alternative":
            case "CapturingGroup":
            case "CharacterClass":
            case "Group":
            case "LookaroundAssertion":
                b(e.body, e);
                break;
            case "Assertion":
            case "Backreference":
            case "Character":
            case "CharacterSet":
            case "Directive":
            case "Flags":
            case "NamedCallout":
            case "Subroutine":
                break;
            case "CharacterClassRange":
                n(e.min, e, "min"), n(e.max, e, "max");
                break;
            case "Quantifier":
                n(e.body, e, "body");
                break;
            case "Regex":
                b(e.body, e), n(e.flags, e, "flags");
                break;
            default:
                throw new Error(`Unexpected node type "${f}"`);
        }
        return h?.exit?.(d, N), u?.exit?.(d, N), i;
    }
    return n(a), a;
}
function $ad81d75b55705a46$var$x(a) {
    if (!Array.isArray(a)) throw new Error("Container expected");
    return a;
}
function $ad81d75b55705a46$var$l(a) {
    if (typeof a != "number") throw new Error("Numeric key expected");
    return a;
}


// Separating some utils for improved tree shaking of the `./internals` export
const $2a8494b0b0ef7575$export$aad7db1ad7d1ebf6 = String.raw`\(\?(?:[:=!>A-Za-z\-]|<[=!]|\(DEFINE\))`;
/**
Updates the array in place by incrementing each value greater than or equal to the threshold.
@param {Array<number>} arr
@param {number} threshold
*/ function $2a8494b0b0ef7575$export$36c21f3893d5d884(arr, threshold) {
    for(let i = 0; i < arr.length; i++)if (arr[i] >= threshold) arr[i]++;
}
/**
@param {string} str
@param {number} pos
@param {string} oldValue
@param {string} newValue
@returns {string}
*/ function $2a8494b0b0ef7575$export$77102e08492d3f08(str, pos, oldValue, newValue) {
    return str.slice(0, pos) + newValue + str.slice(pos + oldValue.length);
}


// Constant properties for tracking regex syntax context
const $894c91b37ef60176$export$841858b892ce1f4c = Object.freeze({
    DEFAULT: 'DEFAULT',
    CHAR_CLASS: 'CHAR_CLASS'
});
function $894c91b37ef60176$export$cc028768286a8626(expression, needle, replacement, context) {
    const re = new RegExp(String.raw`${needle}|(?<$skip>\[\^?|\\?.)`, 'gsu');
    const negated = [
        false
    ];
    let numCharClassesOpen = 0;
    let result = '';
    for (const match of expression.matchAll(re)){
        const { 0: m, groups: { $skip: $skip } } = match;
        if (!$skip && (!context || context === $894c91b37ef60176$export$841858b892ce1f4c.DEFAULT === !numCharClassesOpen)) {
            if (replacement instanceof Function) result += replacement(match, {
                context: numCharClassesOpen ? $894c91b37ef60176$export$841858b892ce1f4c.CHAR_CLASS : $894c91b37ef60176$export$841858b892ce1f4c.DEFAULT,
                negated: negated[negated.length - 1]
            });
            else result += replacement;
            continue;
        }
        if (m[0] === '[') {
            numCharClassesOpen++;
            negated.push(m[1] === '^');
        } else if (m === ']' && numCharClassesOpen) {
            numCharClassesOpen--;
            negated.pop();
        }
        result += m;
    }
    return result;
}
function $894c91b37ef60176$export$7bfdeaa3faf4ba53(expression, needle, callback, context) {
    // Do this the easy way
    $894c91b37ef60176$export$cc028768286a8626(expression, needle, callback, context);
}
function $894c91b37ef60176$export$e12e3c9be364c7a2(expression, needle, pos = 0, context) {
    // Quick partial test; avoid the loop if not needed
    if (!new RegExp(needle, 'su').test(expression)) return null;
    const re = new RegExp(`${needle}|(?<$skip>\\\\?.)`, 'gsu');
    re.lastIndex = pos;
    let numCharClassesOpen = 0;
    let match;
    while(match = re.exec(expression)){
        const { 0: m, groups: { $skip: $skip } } = match;
        if (!$skip && (!context || context === $894c91b37ef60176$export$841858b892ce1f4c.DEFAULT === !numCharClassesOpen)) return match;
        if (m === '[') numCharClassesOpen++;
        else if (m === ']' && numCharClassesOpen) numCharClassesOpen--;
        // Avoid an infinite loop on zero-length matches
        if (re.lastIndex == match.index) re.lastIndex++;
    }
    return null;
}
function $894c91b37ef60176$export$4d52bbdae9cd6e0c(expression, needle, context) {
    // Do this the easy way
    return !!$894c91b37ef60176$export$e12e3c9be364c7a2(expression, needle, 0, context);
}
function $894c91b37ef60176$export$6eaa51400fdf7c32(expression, contentsStartPos) {
    const token = /\\?./gsu;
    token.lastIndex = contentsStartPos;
    let contentsEndPos = expression.length;
    let numCharClassesOpen = 0;
    // Starting search within an open group, after the group's opening
    let numGroupsOpen = 1;
    let match;
    while(match = token.exec(expression)){
        const [m] = match;
        if (m === '[') numCharClassesOpen++;
        else if (!numCharClassesOpen) {
            if (m === '(') numGroupsOpen++;
            else if (m === ')') {
                numGroupsOpen--;
                if (!numGroupsOpen) {
                    contentsEndPos = match.index;
                    break;
                }
            }
        } else if (m === ']') numCharClassesOpen--;
    }
    return expression.slice(contentsStartPos, contentsEndPos);
}


/**
@import {PluginData, PluginResult} from './regex.js';
*/ const $e7b0758e094fae76$var$atomicPluginToken = new RegExp(String.raw`(?<noncapturingStart>${(0, $2a8494b0b0ef7575$export$aad7db1ad7d1ebf6)})|(?<capturingStart>\((?:\?<[^>]+>)?)|\\?.`, 'gsu');
/**
Apply transformations for atomic groups: `(?>…)`.
@param {string} expression
@param {PluginData} [data]
@returns {Required<PluginResult>}
*/ function $e7b0758e094fae76$export$a573bc8e40d39511(expression, data) {
    const hiddenCaptures = data?.hiddenCaptures ?? [];
    // Capture transfer is used by <github.com/slevithan/oniguruma-to-es>
    let captureTransfers = data?.captureTransfers ?? new Map();
    if (!/\(\?>/.test(expression)) return {
        pattern: expression,
        captureTransfers: captureTransfers,
        hiddenCaptures: hiddenCaptures
    };
    const aGDelim = '(?>';
    const emulatedAGDelim = '(?:(?=(';
    const captureNumMap = [
        0
    ];
    const addedHiddenCaptures = [];
    let numCapturesBeforeAG = 0;
    let numAGs = 0;
    let aGPos = NaN;
    let hasProcessedAG;
    do {
        hasProcessedAG = false;
        let numCharClassesOpen = 0;
        let numGroupsOpenInAG = 0;
        let inAG = false;
        let match;
        $e7b0758e094fae76$var$atomicPluginToken.lastIndex = Number.isNaN(aGPos) ? 0 : aGPos + emulatedAGDelim.length;
        while(match = $e7b0758e094fae76$var$atomicPluginToken.exec(expression)){
            const { 0: m, index: index, groups: { capturingStart: capturingStart, noncapturingStart: noncapturingStart } } = match;
            if (m === '[') numCharClassesOpen++;
            else if (!numCharClassesOpen) {
                if (m === aGDelim && !inAG) {
                    aGPos = index;
                    inAG = true;
                } else if (inAG && noncapturingStart) numGroupsOpenInAG++;
                else if (capturingStart) {
                    if (inAG) numGroupsOpenInAG++;
                    else {
                        numCapturesBeforeAG++;
                        captureNumMap.push(numCapturesBeforeAG + numAGs);
                    }
                } else if (m === ')' && inAG) {
                    if (!numGroupsOpenInAG) {
                        numAGs++;
                        const addedCaptureNum = numCapturesBeforeAG + numAGs;
                        // Replace `expression` and use `<$$N>` as a temporary wrapper for the backref so it
                        // can avoid backref renumbering afterward. Wrap the whole substitution (including the
                        // lookahead and following backref) in a noncapturing group to handle following
                        // quantifiers and literal digits
                        expression = `${expression.slice(0, aGPos)}${emulatedAGDelim}${expression.slice(aGPos + aGDelim.length, index)}))<$$${addedCaptureNum}>)${expression.slice(index + 1)}`;
                        hasProcessedAG = true;
                        addedHiddenCaptures.push(addedCaptureNum);
                        (0, $2a8494b0b0ef7575$export$36c21f3893d5d884)(hiddenCaptures, addedCaptureNum);
                        if (captureTransfers.size) {
                            const newCaptureTransfers = new Map();
                            captureTransfers.forEach((from, to)=>{
                                newCaptureTransfers.set(to >= addedCaptureNum ? to + 1 : to, from.map((f)=>f >= addedCaptureNum ? f + 1 : f));
                            });
                            captureTransfers = newCaptureTransfers;
                        }
                        break;
                    }
                    numGroupsOpenInAG--;
                }
            } else if (m === ']') numCharClassesOpen--;
        }
    // Start over from the beginning of the atomic group's contents, in case the processed group
    // contains additional atomic groups
    }while (hasProcessedAG);
    hiddenCaptures.push(...addedHiddenCaptures);
    // Second pass to adjust numbered backrefs
    expression = (0, $894c91b37ef60176$export$cc028768286a8626)(expression, String.raw`\\(?<backrefNum>[1-9]\d*)|<\$\$(?<wrappedBackrefNum>\d+)>`, ({ 0: m, groups: { backrefNum: backrefNum, wrappedBackrefNum: wrappedBackrefNum } })=>{
        if (backrefNum) {
            const bNum = +backrefNum;
            if (bNum > captureNumMap.length - 1) throw new Error(`Backref "${m}" greater than number of captures`);
            return `\\${captureNumMap[bNum]}`;
        }
        return `\\${wrappedBackrefNum}`;
    }, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT);
    return {
        pattern: expression,
        captureTransfers: captureTransfers,
        hiddenCaptures: hiddenCaptures
    };
}
const $e7b0758e094fae76$var$baseQuantifier = String.raw`(?:[?*+]|\{\d+(?:,\d*)?\})`;
// Complete tokenizer for base syntax; doesn't (need to) know about character-class-only syntax
const $e7b0758e094fae76$var$possessivePluginToken = new RegExp(String.raw`
\\(?: \d+
  | c[A-Za-z]
  | [gk]<[^>]+>
  | [pPu]\{[^\}]+\}
  | u[A-Fa-f\d]{4}
  | x[A-Fa-f\d]{2}
  )
| \((?: \? (?: [:=!>]
  | <(?:[=!]|[^>]+>)
  | [A-Za-z\-]+:
  | \(DEFINE\)
  ))?
| (?<qBase>${$e7b0758e094fae76$var$baseQuantifier})(?<qMod>[?+]?)(?<invalidQ>[?*+\{]?)
| \\?.
`.replace(/\s+/g, ''), 'gsu');
/**
Transform posessive quantifiers into atomic groups. The posessessive quantifiers are:
`?+`, `*+`, `++`, `{N}+`, `{N,}+`, `{N,N}+`.
This follows Java, PCRE, Perl, and Python.
Possessive quantifiers in Oniguruma and Onigmo are only: `?+`, `*+`, `++`.
@param {string} expression
@returns {PluginResult}
*/ function $e7b0758e094fae76$export$777a2fba7d8a1541(expression) {
    if (!new RegExp(`${$e7b0758e094fae76$var$baseQuantifier}\\+`).test(expression)) return {
        pattern: expression
    };
    const openGroupIndices = [];
    let lastGroupIndex = null;
    let lastCharClassIndex = null;
    let lastToken = '';
    let numCharClassesOpen = 0;
    let match;
    $e7b0758e094fae76$var$possessivePluginToken.lastIndex = 0;
    while(match = $e7b0758e094fae76$var$possessivePluginToken.exec(expression)){
        const { 0: m, index: index, groups: { qBase: qBase, qMod: qMod, invalidQ: invalidQ } } = match;
        if (m === '[') {
            if (!numCharClassesOpen) lastCharClassIndex = index;
            numCharClassesOpen++;
        } else if (m === ']') {
            if (numCharClassesOpen) numCharClassesOpen--;
            else lastCharClassIndex = null;
        } else if (!numCharClassesOpen) {
            if (qMod === '+' && lastToken && !lastToken.startsWith('(')) {
                // Invalid following quantifier would become valid via the wrapping group
                if (invalidQ) throw new Error(`Invalid quantifier "${m}"`);
                let charsAdded = -1; // -1 for removed trailing `+`
                // Possessivizing fixed repetition quantifiers like `{2}` does't change their behavior, so
                // avoid doing so (convert them to greedy)
                if (/^\{\d+\}$/.test(qBase)) expression = (0, $2a8494b0b0ef7575$export$77102e08492d3f08)(expression, index + qBase.length, qMod, '');
                else {
                    if (lastToken === ')' || lastToken === ']') {
                        const nodeIndex = lastToken === ')' ? lastGroupIndex : lastCharClassIndex;
                        // Unmatched `)` would break out of the wrapping group and mess with handling.
                        // Unmatched `]` wouldn't be a problem, but it's unnecessary to have dedicated support
                        // for unescaped `]++` since this won't work with flag u or v anyway
                        if (nodeIndex === null) throw new Error(`Invalid unmatched "${lastToken}"`);
                        expression = `${expression.slice(0, nodeIndex)}(?>${expression.slice(nodeIndex, index)}${qBase})${expression.slice(index + m.length)}`;
                    } else expression = `${expression.slice(0, index - lastToken.length)}(?>${lastToken}${qBase})${expression.slice(index + m.length)}`;
                    charsAdded += 4; // `(?>)`
                }
                $e7b0758e094fae76$var$possessivePluginToken.lastIndex += charsAdded;
            } else if (m[0] === '(') openGroupIndices.push(index);
            else if (m === ')') lastGroupIndex = openGroupIndices.length ? openGroupIndices.pop() : null;
        }
        lastToken = m;
    }
    return {
        pattern: expression
    };
}


/**
Works the same as JavaScript's native `RegExp` constructor in all contexts, but automatically
adjusts subpattern matches and indices (with flag `d`) to account for captures added as part of
emulating extended syntax.
*/ class $5fd7d2ae13cd21b1$export$7c3361faba0d4671 extends RegExp {
    // Avoid `#private` to allow for subclassing
    /**
  @private
  @type {Map<number, {
    hidden: true;
  }>}
  */ _captureMap;
    /**
  @overload
  @param {string} expression
  @param {string} [flags]
  @param {{
    hiddenCaptures?: Array<number>;
  }} [options]
  */ /**
  @overload
  @param {RegExpSubclass} expression
  @param {string} [flags]
  */ constructor(expression, flags, options){
        // Argument `options` isn't provided when regexes are copied via `new RegExpSubclass(regexp)`,
        // including as part of the internal handling of string methods `matchAll` and `split`
        if (expression instanceof RegExp) {
            if (options) throw new Error('Cannot provide options when copying a regexp');
            super(expression, flags);
            if (expression instanceof $5fd7d2ae13cd21b1$export$7c3361faba0d4671) this._captureMap = expression._captureMap;
            else this._captureMap = new Map();
        } else {
            super(expression, flags);
            const hiddenCaptures = options?.hiddenCaptures ?? [];
            this._captureMap = $5fd7d2ae13cd21b1$var$createCaptureMap(hiddenCaptures);
        }
    }
    /**
  Called internally by all String/RegExp methods that use regexes.
  @override
  @param {string} str
  @returns {RegExpExecArray | null}
  */ exec(str) {
        const match = super.exec(str);
        if (!match || !this._captureMap.size) return match;
        const matchCopy = [
            ...match
        ];
        // Empty all but the first value of the array while preserving its other properties
        match.length = 1;
        let indicesCopy;
        if (this.hasIndices) {
            indicesCopy = [
                ...match.indices
            ];
            match.indices.length = 1;
        }
        for(let i = 1; i < matchCopy.length; i++)if (!this._captureMap.get(i)?.hidden) {
            match.push(matchCopy[i]);
            if (this.hasIndices) match.indices.push(indicesCopy[i]);
        }
        return match;
    }
}
/**
Build the capturing group map, with hidden captures marked to indicate their submatches shouldn't
appear in match results.
@param {Array<number>} hiddenCaptures
@returns {Map<number, {
  hidden: true;
}>}
*/ function $5fd7d2ae13cd21b1$var$createCaptureMap(hiddenCaptures) {
    const captureMap = new Map();
    for (const num of hiddenCaptures)captureMap.set(num, {
        hidden: true
    });
    return captureMap;
}





const $f998c33fe6f5a8d0$var$r = String.raw;
const $f998c33fe6f5a8d0$var$gRToken = $f998c33fe6f5a8d0$var$r`\\g<(?<gRNameOrNum>[^>&]+)&R=(?<gRDepth>[^>]+)>`;
const $f998c33fe6f5a8d0$var$recursiveToken = $f998c33fe6f5a8d0$var$r`\(\?R=(?<rDepth>[^\)]+)\)|${$f998c33fe6f5a8d0$var$gRToken}`;
const $f998c33fe6f5a8d0$var$namedCaptureDelim = $f998c33fe6f5a8d0$var$r`\(\?<(?![=!])(?<captureName>[^>]+)>`;
const $f998c33fe6f5a8d0$var$captureDelim = $f998c33fe6f5a8d0$var$r`${$f998c33fe6f5a8d0$var$namedCaptureDelim}|(?<unnamed>\()(?!\?)`;
const $f998c33fe6f5a8d0$var$token = new RegExp($f998c33fe6f5a8d0$var$r`${$f998c33fe6f5a8d0$var$namedCaptureDelim}|${$f998c33fe6f5a8d0$var$recursiveToken}|\(\?|\\?.`, 'gsu');
const $f998c33fe6f5a8d0$var$overlappingRecursionMsg = 'Cannot use multiple overlapping recursions';
/**
@param {string} pattern
@param {{
  flags?: string;
  captureTransfers?: Map<number, Array<number>>;
  hiddenCaptures?: Array<number>;
  mode?: 'plugin' | 'external';
}} [data]
@returns {{
  pattern: string;
  captureTransfers: Map<number, Array<number>>;
  hiddenCaptures: Array<number>;
}}
*/ function $f998c33fe6f5a8d0$export$74c5cab0f9a94551(pattern, data) {
    const { hiddenCaptures: hiddenCaptures, mode: mode } = {
        hiddenCaptures: [],
        mode: 'plugin',
        ...data
    };
    // Capture transfer is used by <github.com/slevithan/oniguruma-to-es>
    let captureTransfers = data?.captureTransfers ?? new Map();
    // Keep the initial fail-check (which avoids unneeded processing) as fast as possible by testing
    // without the accuracy improvement of using `hasUnescaped` with `Context.DEFAULT`
    if (!new RegExp($f998c33fe6f5a8d0$var$recursiveToken, 'su').test(pattern)) return {
        pattern: pattern,
        captureTransfers: captureTransfers,
        hiddenCaptures: hiddenCaptures
    };
    if (mode === 'plugin' && (0, $894c91b37ef60176$export$4d52bbdae9cd6e0c)(pattern, $f998c33fe6f5a8d0$var$r`\(\?\(DEFINE\)`, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT)) throw new Error('DEFINE groups cannot be used with recursion');
    const addedHiddenCaptures = [];
    const hasNumberedBackref = (0, $894c91b37ef60176$export$4d52bbdae9cd6e0c)(pattern, $f998c33fe6f5a8d0$var$r`\\[1-9]`, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT);
    const groupContentsStartPos = new Map();
    const openGroups = [];
    let hasRecursed = false;
    let numCharClassesOpen = 0;
    let numCapturesPassed = 0;
    let match;
    $f998c33fe6f5a8d0$var$token.lastIndex = 0;
    while(match = $f998c33fe6f5a8d0$var$token.exec(pattern)){
        const { 0: m, groups: { captureName: captureName, rDepth: rDepth, gRNameOrNum: gRNameOrNum, gRDepth: gRDepth } } = match;
        if (m === '[') numCharClassesOpen++;
        else if (!numCharClassesOpen) {
            // `(?R=N)`
            if (rDepth) {
                $f998c33fe6f5a8d0$var$assertMaxInBounds(rDepth);
                if (hasRecursed) throw new Error($f998c33fe6f5a8d0$var$overlappingRecursionMsg);
                if (hasNumberedBackref) // Could add support for numbered backrefs with extra effort, but it's probably not worth
                // it. To trigger this error, the regex must include recursion and one of the following:
                // - An interpolated regex that contains a numbered backref (since other numbered
                //   backrefs are prevented by implicit flag n).
                // - A numbered backref, when flag n is explicitly disabled.
                // Note that Regex+'s extended syntax (atomic groups and sometimes subroutines) can also
                // add numbered backrefs, but those work fine because external plugins like this one run
                // *before* the transformation of built-in syntax extensions
                throw new Error(// When used in `external` mode by transpilers other than Regex+, backrefs might have
                // gone through conversion from named to numbered, so avoid a misleading error
                `${mode === 'external' ? 'Backrefs' : 'Numbered backrefs'} cannot be used with global recursion`);
                const left = pattern.slice(0, match.index);
                const right = pattern.slice($f998c33fe6f5a8d0$var$token.lastIndex);
                if ((0, $894c91b37ef60176$export$4d52bbdae9cd6e0c)(right, $f998c33fe6f5a8d0$var$recursiveToken, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT)) throw new Error($f998c33fe6f5a8d0$var$overlappingRecursionMsg);
                const reps = +rDepth - 1;
                pattern = $f998c33fe6f5a8d0$var$makeRecursive(left, right, reps, false, hiddenCaptures, addedHiddenCaptures, numCapturesPassed);
                captureTransfers = $f998c33fe6f5a8d0$var$mapCaptureTransfers(captureTransfers, left, reps, addedHiddenCaptures.length, 0, numCapturesPassed);
                break;
            // `\g<name&R=N>`, `\g<number&R=N>`
            } else if (gRNameOrNum) {
                $f998c33fe6f5a8d0$var$assertMaxInBounds(gRDepth);
                let isWithinReffedGroup = false;
                for (const g of openGroups)if (g.name === gRNameOrNum || g.num === +gRNameOrNum) {
                    isWithinReffedGroup = true;
                    if (g.hasRecursedWithin) throw new Error($f998c33fe6f5a8d0$var$overlappingRecursionMsg);
                    break;
                }
                if (!isWithinReffedGroup) throw new Error($f998c33fe6f5a8d0$var$r`Recursive \g cannot be used outside the referenced group "${mode === 'external' ? gRNameOrNum : $f998c33fe6f5a8d0$var$r`\g<${gRNameOrNum}&R=${gRDepth}>`}"`);
                const startPos = groupContentsStartPos.get(gRNameOrNum);
                const groupContents = (0, $894c91b37ef60176$export$6eaa51400fdf7c32)(pattern, startPos);
                if (hasNumberedBackref && (0, $894c91b37ef60176$export$4d52bbdae9cd6e0c)(groupContents, $f998c33fe6f5a8d0$var$r`${$f998c33fe6f5a8d0$var$namedCaptureDelim}|\((?!\?)`, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT)) throw new Error(// When used in `external` mode by transpilers other than Regex+, backrefs might have
                // gone through conversion from named to numbered, so avoid a misleading error
                `${mode === 'external' ? 'Backrefs' : 'Numbered backrefs'} cannot be used with recursion of capturing groups`);
                const groupContentsLeft = pattern.slice(startPos, match.index);
                const groupContentsRight = groupContents.slice(groupContentsLeft.length + m.length);
                const numAddedHiddenCapturesPreExpansion = addedHiddenCaptures.length;
                const reps = +gRDepth - 1;
                const expansion = $f998c33fe6f5a8d0$var$makeRecursive(groupContentsLeft, groupContentsRight, reps, true, hiddenCaptures, addedHiddenCaptures, numCapturesPassed);
                captureTransfers = $f998c33fe6f5a8d0$var$mapCaptureTransfers(captureTransfers, groupContentsLeft, reps, addedHiddenCaptures.length - numAddedHiddenCapturesPreExpansion, numAddedHiddenCapturesPreExpansion, numCapturesPassed);
                const pre = pattern.slice(0, startPos);
                const post = pattern.slice(startPos + groupContents.length);
                // Modify the string we're looping over
                pattern = `${pre}${expansion}${post}`;
                // Step forward for the next loop iteration
                $f998c33fe6f5a8d0$var$token.lastIndex += expansion.length - m.length - groupContentsLeft.length - groupContentsRight.length;
                openGroups.forEach((g)=>g.hasRecursedWithin = true);
                hasRecursed = true;
            } else if (captureName) {
                numCapturesPassed++;
                groupContentsStartPos.set(String(numCapturesPassed), $f998c33fe6f5a8d0$var$token.lastIndex);
                groupContentsStartPos.set(captureName, $f998c33fe6f5a8d0$var$token.lastIndex);
                openGroups.push({
                    num: numCapturesPassed,
                    name: captureName
                });
            } else if (m[0] === '(') {
                const isUnnamedCapture = m === '(';
                if (isUnnamedCapture) {
                    numCapturesPassed++;
                    groupContentsStartPos.set(String(numCapturesPassed), $f998c33fe6f5a8d0$var$token.lastIndex);
                }
                openGroups.push(isUnnamedCapture ? {
                    num: numCapturesPassed
                } : {});
            } else if (m === ')') openGroups.pop();
        } else if (m === ']') numCharClassesOpen--;
    }
    hiddenCaptures.push(...addedHiddenCaptures);
    return {
        pattern: pattern,
        captureTransfers: captureTransfers,
        hiddenCaptures: hiddenCaptures
    };
}
/**
@param {string} max
*/ function $f998c33fe6f5a8d0$var$assertMaxInBounds(max) {
    const errMsg = `Max depth must be integer between 2 and 100; used ${max}`;
    if (!/^[1-9]\d*$/.test(max)) throw new Error(errMsg);
    max = +max;
    if (max < 2 || max > 100) throw new Error(errMsg);
}
/**
@param {string} left
@param {string} right
@param {number} reps
@param {boolean} isSubpattern
@param {Array<number>} hiddenCaptures
@param {Array<number>} addedHiddenCaptures
@param {number} numCapturesPassed
@returns {string}
*/ function $f998c33fe6f5a8d0$var$makeRecursive(left, right, reps, isSubpattern, hiddenCaptures, addedHiddenCaptures, numCapturesPassed) {
    const namesInRecursed = new Set();
    // Can skip this work if not needed
    if (isSubpattern) (0, $894c91b37ef60176$export$7bfdeaa3faf4ba53)(left + right, $f998c33fe6f5a8d0$var$namedCaptureDelim, ({ groups: { captureName: captureName } })=>{
        namesInRecursed.add(captureName);
    }, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT);
    const rest = [
        reps,
        isSubpattern ? namesInRecursed : null,
        hiddenCaptures,
        addedHiddenCaptures,
        numCapturesPassed
    ];
    // Depth 2: 'left(?:left(?:)right)right'
    // Depth 3: 'left(?:left(?:left(?:)right)right)right'
    // Empty group in the middle separates tokens and absorbs a following quantifier if present
    return `${left}${$f998c33fe6f5a8d0$var$repeatWithDepth(`(?:${left}`, 'forward', ...rest)}(?:)${$f998c33fe6f5a8d0$var$repeatWithDepth(`${right})`, 'backward', ...rest)}${right}`;
}
/**
@param {string} pattern
@param {'forward' | 'backward'} direction
@param {number} reps
@param {Set<string> | null} namesInRecursed
@param {Array<number>} hiddenCaptures
@param {Array<number>} addedHiddenCaptures
@param {number} numCapturesPassed
@returns {string}
*/ function $f998c33fe6f5a8d0$var$repeatWithDepth(pattern, direction, reps, namesInRecursed, hiddenCaptures, addedHiddenCaptures, numCapturesPassed) {
    const startNum = 2;
    const getDepthNum = (i)=>direction === 'forward' ? i + startNum : reps - i + startNum - 1;
    let result = '';
    for(let i = 0; i < reps; i++){
        const depthNum = getDepthNum(i);
        result += (0, $894c91b37ef60176$export$cc028768286a8626)(pattern, $f998c33fe6f5a8d0$var$r`${$f998c33fe6f5a8d0$var$captureDelim}|\\k<(?<backref>[^>]+)>`, ({ 0: m, groups: { captureName: captureName, unnamed: unnamed, backref: backref } })=>{
            if (backref && namesInRecursed && !namesInRecursed.has(backref)) // Don't alter backrefs to groups outside the recursed subpattern
            return m;
            const suffix = `_$${depthNum}`;
            if (unnamed || captureName) {
                const addedCaptureNum = numCapturesPassed + addedHiddenCaptures.length + 1;
                addedHiddenCaptures.push(addedCaptureNum);
                $f998c33fe6f5a8d0$var$incrementIfAtLeast(hiddenCaptures, addedCaptureNum);
                return unnamed ? m : `(?<${captureName}${suffix}>`;
            }
            return $f998c33fe6f5a8d0$var$r`\k<${backref}${suffix}>`;
        }, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT);
    }
    return result;
}
/**
Updates the array in place by incrementing each value greater than or equal to the threshold.
@param {Array<number>} arr
@param {number} threshold
*/ function $f998c33fe6f5a8d0$var$incrementIfAtLeast(arr, threshold) {
    for(let i = 0; i < arr.length; i++)if (arr[i] >= threshold) arr[i]++;
}
/**
@param {Map<number, Array<number>>} captureTransfers
@param {string} left
@param {number} reps
@param {number} numCapturesAddedInExpansion
@param {number} numAddedHiddenCapturesPreExpansion
@param {number} numCapturesPassed
@returns {Map<number, Array<number>>}
*/ function $f998c33fe6f5a8d0$var$mapCaptureTransfers(captureTransfers, left, reps, numCapturesAddedInExpansion, numAddedHiddenCapturesPreExpansion, numCapturesPassed) {
    if (captureTransfers.size && numCapturesAddedInExpansion) {
        let numCapturesInLeft = 0;
        (0, $894c91b37ef60176$export$7bfdeaa3faf4ba53)(left, $f998c33fe6f5a8d0$var$captureDelim, ()=>numCapturesInLeft++, (0, $894c91b37ef60176$export$841858b892ce1f4c).DEFAULT);
        // Is 0 for global recursion
        const recursionDelimCaptureNum = numCapturesPassed - numCapturesInLeft + numAddedHiddenCapturesPreExpansion;
        const newCaptureTransfers = new Map();
        captureTransfers.forEach((from, to)=>{
            const numCapturesInRight = (numCapturesAddedInExpansion - numCapturesInLeft * reps) / reps;
            const numCapturesAddedInLeft = numCapturesInLeft * reps;
            const newTo = to > recursionDelimCaptureNum + numCapturesInLeft ? to + numCapturesAddedInExpansion : to;
            const newFrom = [];
            for (const f of from){
                // Before the recursed subpattern
                if (f <= recursionDelimCaptureNum) newFrom.push(f);
                else if (f > recursionDelimCaptureNum + numCapturesInLeft + numCapturesInRight) newFrom.push(f + numCapturesAddedInExpansion);
                else if (f <= recursionDelimCaptureNum + numCapturesInLeft) for(let i = 0; i <= reps; i++)newFrom.push(f + numCapturesInLeft * i);
                else for(let i = 0; i <= reps; i++)newFrom.push(f + numCapturesAddedInLeft + numCapturesInRight * i);
            }
            newCaptureTransfers.set(newTo, newFrom);
        });
        return newCaptureTransfers;
    }
    return captureTransfers;
}


var $c0ef9b2f1330c5f8$var$cp = String.fromCodePoint;
var $c0ef9b2f1330c5f8$var$r = String.raw;
var $c0ef9b2f1330c5f8$var$envFlags = {};
var $c0ef9b2f1330c5f8$var$globalRegExp = globalThis.RegExp;
$c0ef9b2f1330c5f8$var$envFlags.flagGroups = (()=>{
    try {
        new $c0ef9b2f1330c5f8$var$globalRegExp("(?i:)");
    } catch  {
        return false;
    }
    return true;
})();
$c0ef9b2f1330c5f8$var$envFlags.unicodeSets = (()=>{
    try {
        new $c0ef9b2f1330c5f8$var$globalRegExp("[[]]", "v");
    } catch  {
        return false;
    }
    return true;
})();
$c0ef9b2f1330c5f8$var$envFlags.bugFlagVLiteralHyphenIsRange = $c0ef9b2f1330c5f8$var$envFlags.unicodeSets ? (()=>{
    try {
        new $c0ef9b2f1330c5f8$var$globalRegExp($c0ef9b2f1330c5f8$var$r`[\d\-a]`, "v");
    } catch  {
        return true;
    }
    return false;
})() : false;
$c0ef9b2f1330c5f8$var$envFlags.bugNestedClassIgnoresNegation = $c0ef9b2f1330c5f8$var$envFlags.unicodeSets && new $c0ef9b2f1330c5f8$var$globalRegExp("[[^a]]", "v").test("a");
function $c0ef9b2f1330c5f8$var$getNewCurrentFlags(current, { enable: enable, disable: disable }) {
    return {
        dotAll: !disable?.dotAll && !!(enable?.dotAll || current.dotAll),
        ignoreCase: !disable?.ignoreCase && !!(enable?.ignoreCase || current.ignoreCase)
    };
}
function $c0ef9b2f1330c5f8$var$getOrInsert(map, key, defaultValue) {
    if (!map.has(key)) map.set(key, defaultValue);
    return map.get(key);
}
function $c0ef9b2f1330c5f8$var$isMinTarget(target, min) {
    return $c0ef9b2f1330c5f8$var$EsVersion[target] >= $c0ef9b2f1330c5f8$var$EsVersion[min];
}
function $c0ef9b2f1330c5f8$var$throwIfNullish(value, msg) {
    if (value == null) throw new Error(msg ?? "Value expected");
    return value;
}
// src/options.js
var $c0ef9b2f1330c5f8$var$EsVersion = {
    ES2025: 2025,
    ES2024: 2024,
    ES2018: 2018
};
var $c0ef9b2f1330c5f8$var$Target = /** @type {const} */ {
    auto: "auto",
    ES2025: "ES2025",
    ES2024: "ES2024",
    ES2018: "ES2018"
};
function $c0ef9b2f1330c5f8$var$getOptions(options = {}) {
    if (({}).toString.call(options) !== "[object Object]") throw new Error("Unexpected options");
    if (options.target !== void 0 && !$c0ef9b2f1330c5f8$var$Target[options.target]) throw new Error(`Unexpected target "${options.target}"`);
    const opts = {
        // Sets the level of emulation rigor/strictness.
        accuracy: "default",
        // Disables advanced emulation that relies on returning a `RegExp` subclass, resulting in
        // certain patterns not being emulatable.
        avoidSubclass: false,
        // Oniguruma flags; a string with `i`, `m`, `x`, `D`, `S`, `W`, `y{g}` in any order (all
        // optional). Oniguruma's `m` is equivalent to JavaScript's `s` (`dotAll`).
        flags: "",
        // Include JavaScript flag `g` (`global`) in the result.
        global: false,
        // Include JavaScript flag `d` (`hasIndices`) in the result.
        hasIndices: false,
        // Delay regex construction until first use if the transpiled pattern is at least this length.
        lazyCompileLength: Infinity,
        // JavaScript version used for generated regexes. Using `auto` detects the best value based on
        // your environment. Later targets allow faster processing, simpler generated source, and
        // support for additional features.
        target: "auto",
        // Disables minifications that simplify the pattern without changing the meaning.
        verbose: false,
        ...options,
        // Advanced options that override standard behavior, error checking, and flags when enabled.
        rules: {
            // Useful with TextMate grammars that merge backreferences across patterns.
            allowOrphanBackrefs: false,
            // Use ASCII `\b` and `\B`, which increases search performance of generated regexes.
            asciiWordBoundaries: false,
            // Allow unnamed captures and numbered calls (backreferences and subroutines) when using
            // named capture. This is Oniguruma option `ONIG_OPTION_CAPTURE_GROUP`; on by default in
            // `vscode-oniguruma`.
            captureGroup: false,
            // Change the recursion depth limit from Oniguruma's `20` to an integer `2`–`20`.
            recursionLimit: 20,
            // `^` as `\A`; `$` as`\Z`. Improves search performance of generated regexes without changing
            // the meaning if searching line by line. This is Oniguruma option `ONIG_OPTION_SINGLELINE`.
            singleline: false,
            ...options.rules
        }
    };
    if (opts.target === "auto") opts.target = $c0ef9b2f1330c5f8$var$envFlags.flagGroups ? "ES2025" : $c0ef9b2f1330c5f8$var$envFlags.unicodeSets ? "ES2024" : "ES2018";
    return opts;
}
var $c0ef9b2f1330c5f8$var$asciiSpaceChar = "[	-\r ]";
var $c0ef9b2f1330c5f8$var$CharsWithoutIgnoreCaseExpansion = /* @__PURE__ */ new Set([
    $c0ef9b2f1330c5f8$var$cp(304),
    // İ
    $c0ef9b2f1330c5f8$var$cp(305)
]);
var $c0ef9b2f1330c5f8$var$defaultWordChar = $c0ef9b2f1330c5f8$var$r`[\p{L}\p{M}\p{N}\p{Pc}]`;
function $c0ef9b2f1330c5f8$var$getIgnoreCaseMatchChars(char) {
    if ($c0ef9b2f1330c5f8$var$CharsWithoutIgnoreCaseExpansion.has(char)) return [
        char
    ];
    const set = /* @__PURE__ */ new Set();
    const lower = char.toLowerCase();
    const upper = lower.toUpperCase();
    const title = $c0ef9b2f1330c5f8$var$LowerToTitleCaseMap.get(lower);
    const altLower = $c0ef9b2f1330c5f8$var$LowerToAlternativeLowerCaseMap.get(lower);
    const altUpper = $c0ef9b2f1330c5f8$var$LowerToAlternativeUpperCaseMap.get(lower);
    if ([
        ...upper
    ].length === 1) set.add(upper);
    altUpper && set.add(altUpper);
    title && set.add(title);
    set.add(lower);
    altLower && set.add(altLower);
    return [
        ...set
    ];
}
var $c0ef9b2f1330c5f8$var$JsUnicodePropertyMap = /* @__PURE__ */ new Map(`C Other
Cc Control cntrl
Cf Format
Cn Unassigned
Co Private_Use
Cs Surrogate
L Letter
LC Cased_Letter
Ll Lowercase_Letter
Lm Modifier_Letter
Lo Other_Letter
Lt Titlecase_Letter
Lu Uppercase_Letter
M Mark Combining_Mark
Mc Spacing_Mark
Me Enclosing_Mark
Mn Nonspacing_Mark
N Number
Nd Decimal_Number digit
Nl Letter_Number
No Other_Number
P Punctuation punct
Pc Connector_Punctuation
Pd Dash_Punctuation
Pe Close_Punctuation
Pf Final_Punctuation
Pi Initial_Punctuation
Po Other_Punctuation
Ps Open_Punctuation
S Symbol
Sc Currency_Symbol
Sk Modifier_Symbol
Sm Math_Symbol
So Other_Symbol
Z Separator
Zl Line_Separator
Zp Paragraph_Separator
Zs Space_Separator
ASCII
ASCII_Hex_Digit AHex
Alphabetic Alpha
Any
Assigned
Bidi_Control Bidi_C
Bidi_Mirrored Bidi_M
Case_Ignorable CI
Cased
Changes_When_Casefolded CWCF
Changes_When_Casemapped CWCM
Changes_When_Lowercased CWL
Changes_When_NFKC_Casefolded CWKCF
Changes_When_Titlecased CWT
Changes_When_Uppercased CWU
Dash
Default_Ignorable_Code_Point DI
Deprecated Dep
Diacritic Dia
Emoji
Emoji_Component EComp
Emoji_Modifier EMod
Emoji_Modifier_Base EBase
Emoji_Presentation EPres
Extended_Pictographic ExtPict
Extender Ext
Grapheme_Base Gr_Base
Grapheme_Extend Gr_Ext
Hex_Digit Hex
IDS_Binary_Operator IDSB
IDS_Trinary_Operator IDST
ID_Continue IDC
ID_Start IDS
Ideographic Ideo
Join_Control Join_C
Logical_Order_Exception LOE
Lowercase Lower
Math
Noncharacter_Code_Point NChar
Pattern_Syntax Pat_Syn
Pattern_White_Space Pat_WS
Quotation_Mark QMark
Radical
Regional_Indicator RI
Sentence_Terminal STerm
Soft_Dotted SD
Terminal_Punctuation Term
Unified_Ideograph UIdeo
Uppercase Upper
Variation_Selector VS
White_Space space
XID_Continue XIDC
XID_Start XIDS`.split(/\s/).map((p)=>[
        (0, $81a53fa315512537$export$74643d1fe038be1a)(p),
        p
    ]));
var $c0ef9b2f1330c5f8$var$LowerToAlternativeLowerCaseMap = /* @__PURE__ */ new Map([
    [
        "s",
        $c0ef9b2f1330c5f8$var$cp(383)
    ],
    // s, ſ
    [
        $c0ef9b2f1330c5f8$var$cp(383),
        "s"
    ]
]);
var $c0ef9b2f1330c5f8$var$LowerToAlternativeUpperCaseMap = /* @__PURE__ */ new Map([
    [
        $c0ef9b2f1330c5f8$var$cp(223),
        $c0ef9b2f1330c5f8$var$cp(7838)
    ],
    // ß, ẞ
    [
        $c0ef9b2f1330c5f8$var$cp(107),
        $c0ef9b2f1330c5f8$var$cp(8490)
    ],
    // k, K (Kelvin)
    [
        $c0ef9b2f1330c5f8$var$cp(229),
        $c0ef9b2f1330c5f8$var$cp(8491)
    ],
    // å, Å (Angstrom)
    [
        $c0ef9b2f1330c5f8$var$cp(969),
        $c0ef9b2f1330c5f8$var$cp(8486)
    ]
]);
var $c0ef9b2f1330c5f8$var$LowerToTitleCaseMap = new Map([
    $c0ef9b2f1330c5f8$var$titleEntry(453),
    $c0ef9b2f1330c5f8$var$titleEntry(456),
    $c0ef9b2f1330c5f8$var$titleEntry(459),
    $c0ef9b2f1330c5f8$var$titleEntry(498),
    ...$c0ef9b2f1330c5f8$var$titleRange(8072, 8079),
    ...$c0ef9b2f1330c5f8$var$titleRange(8088, 8095),
    ...$c0ef9b2f1330c5f8$var$titleRange(8104, 8111),
    $c0ef9b2f1330c5f8$var$titleEntry(8124),
    $c0ef9b2f1330c5f8$var$titleEntry(8140),
    $c0ef9b2f1330c5f8$var$titleEntry(8188)
]);
var $c0ef9b2f1330c5f8$var$PosixClassMap = /* @__PURE__ */ new Map([
    [
        "alnum",
        $c0ef9b2f1330c5f8$var$r`[\p{Alpha}\p{Nd}]`
    ],
    [
        "alpha",
        $c0ef9b2f1330c5f8$var$r`\p{Alpha}`
    ],
    [
        "ascii",
        $c0ef9b2f1330c5f8$var$r`\p{ASCII}`
    ],
    [
        "blank",
        $c0ef9b2f1330c5f8$var$r`[\p{Zs}\t]`
    ],
    [
        "cntrl",
        $c0ef9b2f1330c5f8$var$r`\p{Cc}`
    ],
    [
        "digit",
        $c0ef9b2f1330c5f8$var$r`\p{Nd}`
    ],
    [
        "graph",
        $c0ef9b2f1330c5f8$var$r`[\P{space}&&\P{Cc}&&\P{Cn}&&\P{Cs}]`
    ],
    [
        "lower",
        $c0ef9b2f1330c5f8$var$r`\p{Lower}`
    ],
    [
        "print",
        $c0ef9b2f1330c5f8$var$r`[[\P{space}&&\P{Cc}&&\P{Cn}&&\P{Cs}]\p{Zs}]`
    ],
    [
        "punct",
        $c0ef9b2f1330c5f8$var$r`[\p{P}\p{S}]`
    ],
    // Updated value from Onig 6.9.9; changed from Unicode `\p{punct}`
    [
        "space",
        $c0ef9b2f1330c5f8$var$r`\p{space}`
    ],
    [
        "upper",
        $c0ef9b2f1330c5f8$var$r`\p{Upper}`
    ],
    [
        "word",
        $c0ef9b2f1330c5f8$var$r`[\p{Alpha}\p{M}\p{Nd}\p{Pc}]`
    ],
    [
        "xdigit",
        $c0ef9b2f1330c5f8$var$r`\p{AHex}`
    ]
]);
function $c0ef9b2f1330c5f8$var$range(start, end) {
    const range2 = [];
    for(let i = start; i <= end; i++)range2.push(i);
    return range2;
}
function $c0ef9b2f1330c5f8$var$titleEntry(codePoint) {
    const char = $c0ef9b2f1330c5f8$var$cp(codePoint);
    return [
        char.toLowerCase(),
        char
    ];
}
function $c0ef9b2f1330c5f8$var$titleRange(start, end) {
    return $c0ef9b2f1330c5f8$var$range(start, end).map((codePoint)=>$c0ef9b2f1330c5f8$var$titleEntry(codePoint));
}
var $c0ef9b2f1330c5f8$var$UnicodePropertiesWithSpecificCase = /* @__PURE__ */ new Set([
    "Lower",
    "Lowercase",
    "Upper",
    "Uppercase",
    "Ll",
    "Lowercase_Letter",
    "Lt",
    "Titlecase_Letter",
    "Lu",
    "Uppercase_Letter"
]);
function $c0ef9b2f1330c5f8$var$transform(ast, options) {
    const opts = {
        // A couple edge cases exist where options `accuracy` and `bestEffortTarget` are used:
        // - `CharacterSet` kind `text_segment` (`\X`): An exact representation would require heavy
        //   Unicode data; a best-effort approximation requires knowing the target.
        // - `CharacterSet` kind `posix` with values `graph` and `print`: Their complex Unicode
        //   representations would be hard to change to ASCII versions after the fact in the generator
        //   based on `target`/`accuracy`, so produce the appropriate structure here.
        accuracy: "default",
        asciiWordBoundaries: false,
        avoidSubclass: false,
        bestEffortTarget: "ES2025",
        ...options
    };
    $c0ef9b2f1330c5f8$var$addParentProperties(ast);
    const firstPassState = {
        accuracy: opts.accuracy,
        asciiWordBoundaries: opts.asciiWordBoundaries,
        avoidSubclass: opts.avoidSubclass,
        flagDirectivesByAlt: /* @__PURE__ */ new Map(),
        jsGroupNameMap: /* @__PURE__ */ new Map(),
        minTargetEs2024: $c0ef9b2f1330c5f8$var$isMinTarget(opts.bestEffortTarget, "ES2024"),
        passedLookbehind: false,
        strategy: null,
        // Subroutines can appear before the groups they ref, so collect reffed nodes for a second pass 
        subroutineRefMap: /* @__PURE__ */ new Map(),
        supportedGNodes: /* @__PURE__ */ new Set(),
        digitIsAscii: ast.flags.digitIsAscii,
        spaceIsAscii: ast.flags.spaceIsAscii,
        wordIsAscii: ast.flags.wordIsAscii
    };
    (0, $ad81d75b55705a46$export$df3f009e3d155b20)(ast, $c0ef9b2f1330c5f8$var$FirstPassVisitor, firstPassState);
    const globalFlags = {
        dotAll: ast.flags.dotAll,
        ignoreCase: ast.flags.ignoreCase
    };
    const secondPassState = {
        currentFlags: globalFlags,
        prevFlags: null,
        globalFlags: globalFlags,
        groupOriginByCopy: /* @__PURE__ */ new Map(),
        groupsByName: /* @__PURE__ */ new Map(),
        multiplexCapturesToLeftByRef: /* @__PURE__ */ new Map(),
        openRefs: /* @__PURE__ */ new Map(),
        reffedNodesByReferencer: /* @__PURE__ */ new Map(),
        subroutineRefMap: firstPassState.subroutineRefMap
    };
    (0, $ad81d75b55705a46$export$df3f009e3d155b20)(ast, $c0ef9b2f1330c5f8$var$SecondPassVisitor, secondPassState);
    const thirdPassState = {
        groupsByName: secondPassState.groupsByName,
        highestOrphanBackref: 0,
        numCapturesToLeft: 0,
        reffedNodesByReferencer: secondPassState.reffedNodesByReferencer
    };
    (0, $ad81d75b55705a46$export$df3f009e3d155b20)(ast, $c0ef9b2f1330c5f8$var$ThirdPassVisitor, thirdPassState);
    ast._originMap = secondPassState.groupOriginByCopy;
    ast._strategy = firstPassState.strategy;
    return ast;
}
var $c0ef9b2f1330c5f8$var$FirstPassVisitor = {
    AbsenceFunction ({ node: node, parent: parent, replaceWith: replaceWith }) {
        const { body: body, kind: kind } = node;
        if (kind === "repeater") {
            const innerGroup = (0, $81a53fa315512537$export$856f728536d122cb)();
            innerGroup.body[0].body.push(// Insert own alts as `body`
            (0, $81a53fa315512537$export$a1c731c64d750557)({
                negate: true,
                body: body
            }), (0, $81a53fa315512537$export$3968c6d753b95879)("Any"));
            const outerGroup = (0, $81a53fa315512537$export$856f728536d122cb)();
            outerGroup.body[0].body.push((0, $81a53fa315512537$export$169ce51b0f523e68)("greedy", 0, Infinity, innerGroup));
            replaceWith($c0ef9b2f1330c5f8$var$setParentDeep(outerGroup, parent), {
                traverse: true
            });
        } else throw new Error(`Unsupported absence function "(?~|"`);
    },
    Alternative: {
        enter ({ node: node, parent: parent, key: key }, { flagDirectivesByAlt: flagDirectivesByAlt }) {
            const flagDirectives = node.body.filter((el)=>el.kind === "flags");
            for(let i = key + 1; i < parent.body.length; i++){
                const forwardSiblingAlt = parent.body[i];
                $c0ef9b2f1330c5f8$var$getOrInsert(flagDirectivesByAlt, forwardSiblingAlt, []).push(...flagDirectives);
            }
        },
        exit ({ node: node }, { flagDirectivesByAlt: flagDirectivesByAlt }) {
            if (flagDirectivesByAlt.get(node)?.length) {
                const flags = $c0ef9b2f1330c5f8$var$getCombinedFlagModsFromFlagNodes(flagDirectivesByAlt.get(node));
                if (flags) {
                    const flagGroup = (0, $81a53fa315512537$export$856f728536d122cb)({
                        flags: flags
                    });
                    flagGroup.body[0].body = node.body;
                    node.body = [
                        $c0ef9b2f1330c5f8$var$setParentDeep(flagGroup, node)
                    ];
                }
            }
        }
    },
    Assertion ({ node: node, parent: parent, key: key, container: container, root: root, remove: remove, replaceWith: replaceWith }, state) {
        const { kind: kind, negate: negate } = node;
        const { asciiWordBoundaries: asciiWordBoundaries, avoidSubclass: avoidSubclass, supportedGNodes: supportedGNodes, wordIsAscii: wordIsAscii } = state;
        if (kind === "text_segment_boundary") throw new Error(`Unsupported text segment boundary "\\${negate ? "Y" : "y"}"`);
        else if (kind === "line_end") replaceWith($c0ef9b2f1330c5f8$var$setParentDeep((0, $81a53fa315512537$export$a1c731c64d750557)({
            body: [
                (0, $81a53fa315512537$export$4506b1bb0cf5d8dd)({
                    body: [
                        (0, $81a53fa315512537$export$987f29926deb46c2)("string_end")
                    ]
                }),
                (0, $81a53fa315512537$export$4506b1bb0cf5d8dd)({
                    body: [
                        (0, $81a53fa315512537$export$4d63783c2be0a38c)(10)
                    ]
                })
            ]
        }), parent));
        else if (kind === "line_start") replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$parseFragment($c0ef9b2f1330c5f8$var$r`(?<=\A|\n(?!\z))`, {
            skipLookbehindValidation: true
        }), parent));
        else if (kind === "search_start") {
            if (supportedGNodes.has(node)) {
                root.flags.sticky = true;
                remove();
            } else {
                const prev = container[key - 1];
                if (prev && $c0ef9b2f1330c5f8$var$isAlwaysNonZeroLength(prev)) replaceWith($c0ef9b2f1330c5f8$var$setParentDeep((0, $81a53fa315512537$export$a1c731c64d750557)({
                    negate: true
                }), parent));
                else if (avoidSubclass) throw new Error($c0ef9b2f1330c5f8$var$r`Uses "\G" in a way that requires a subclass`);
                else {
                    replaceWith($c0ef9b2f1330c5f8$var$setParent((0, $81a53fa315512537$export$987f29926deb46c2)("string_start"), parent));
                    state.strategy = "clip_search";
                }
            }
        } else if (kind === "string_end" || kind === "string_start") ;
        else if (kind === "string_end_newline") replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$parseFragment($c0ef9b2f1330c5f8$var$r`(?=\n?\z)`), parent));
        else if (kind === "word_boundary") {
            if (!wordIsAscii && !asciiWordBoundaries) {
                const b = `(?:(?<=${$c0ef9b2f1330c5f8$var$defaultWordChar})(?!${$c0ef9b2f1330c5f8$var$defaultWordChar})|(?<!${$c0ef9b2f1330c5f8$var$defaultWordChar})(?=${$c0ef9b2f1330c5f8$var$defaultWordChar}))`;
                const B = `(?:(?<=${$c0ef9b2f1330c5f8$var$defaultWordChar})(?=${$c0ef9b2f1330c5f8$var$defaultWordChar})|(?<!${$c0ef9b2f1330c5f8$var$defaultWordChar})(?!${$c0ef9b2f1330c5f8$var$defaultWordChar}))`;
                replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$parseFragment(negate ? B : b), parent));
            }
        } else throw new Error(`Unexpected assertion kind "${kind}"`);
    },
    Backreference ({ node: node }, { jsGroupNameMap: jsGroupNameMap }) {
        let { ref: ref } = node;
        if (typeof ref === "string" && !$c0ef9b2f1330c5f8$var$isValidJsGroupName(ref)) {
            ref = $c0ef9b2f1330c5f8$var$getAndStoreJsGroupName(ref, jsGroupNameMap);
            node.ref = ref;
        }
    },
    CapturingGroup ({ node: node }, { jsGroupNameMap: jsGroupNameMap, subroutineRefMap: subroutineRefMap }) {
        let { name: name } = node;
        if (name && !$c0ef9b2f1330c5f8$var$isValidJsGroupName(name)) {
            name = $c0ef9b2f1330c5f8$var$getAndStoreJsGroupName(name, jsGroupNameMap);
            node.name = name;
        }
        subroutineRefMap.set(node.number, node);
        if (name) subroutineRefMap.set(name, node);
    },
    CharacterClassRange ({ node: node, parent: parent, replaceWith: replaceWith }) {
        if (parent.kind === "intersection") {
            const cc = (0, $81a53fa315512537$export$9e021a2c1a31ab55)({
                body: [
                    node
                ]
            });
            replaceWith($c0ef9b2f1330c5f8$var$setParentDeep(cc, parent), {
                traverse: true
            });
        }
    },
    CharacterSet ({ node: node, parent: parent, replaceWith: replaceWith }, { accuracy: accuracy, minTargetEs2024: minTargetEs2024, digitIsAscii: digitIsAscii, spaceIsAscii: spaceIsAscii, wordIsAscii: wordIsAscii }) {
        const { kind: kind, negate: negate, value: value } = node;
        if (digitIsAscii && (kind === "digit" || value === "digit")) {
            replaceWith($c0ef9b2f1330c5f8$var$setParent((0, $81a53fa315512537$export$247758b45a713079)("digit", {
                negate: negate
            }), parent));
            return;
        }
        if (spaceIsAscii && (kind === "space" || value === "space")) {
            replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$setNegate($c0ef9b2f1330c5f8$var$parseFragment($c0ef9b2f1330c5f8$var$asciiSpaceChar), negate), parent));
            return;
        }
        if (wordIsAscii && (kind === "word" || value === "word")) {
            replaceWith($c0ef9b2f1330c5f8$var$setParent((0, $81a53fa315512537$export$247758b45a713079)("word", {
                negate: negate
            }), parent));
            return;
        }
        if (kind === "any") replaceWith($c0ef9b2f1330c5f8$var$setParent((0, $81a53fa315512537$export$3968c6d753b95879)("Any"), parent));
        else if (kind === "digit") replaceWith($c0ef9b2f1330c5f8$var$setParent((0, $81a53fa315512537$export$3968c6d753b95879)("Nd", {
            negate: negate
        }), parent));
        else if (kind === "dot") ;
        else if (kind === "text_segment") {
            if (accuracy === "strict") throw new Error($c0ef9b2f1330c5f8$var$r`Use of "\X" requires non-strict accuracy`);
            const eBase = "\\p{Emoji}(?:\\p{EMod}|\\uFE0F\\u20E3?|[\\x{E0020}-\\x{E007E}]+\\x{E007F})?";
            const emoji = $c0ef9b2f1330c5f8$var$r`\p{RI}{2}|${eBase}(?:\u200D${eBase})*`;
            replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$parseFragment(// Close approximation of an extended grapheme cluster; see <unicode.org/reports/tr29/>
            $c0ef9b2f1330c5f8$var$r`(?>\r\n|${minTargetEs2024 ? $c0ef9b2f1330c5f8$var$r`\p{RGI_Emoji}` : emoji}|\P{M}\p{M}*)`, // Allow JS property `RGI_Emoji` through
            {
                skipPropertyNameValidation: true
            }), parent));
        } else if (kind === "hex") replaceWith($c0ef9b2f1330c5f8$var$setParent((0, $81a53fa315512537$export$3968c6d753b95879)("AHex", {
            negate: negate
        }), parent));
        else if (kind === "newline") replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$parseFragment(negate ? "[^\n]" : "(?>\r\n?|[\n\v\f\x85\u2028\u2029])"), parent));
        else if (kind === "posix") {
            if (!minTargetEs2024 && (value === "graph" || value === "print")) {
                if (accuracy === "strict") throw new Error(`POSIX class "${value}" requires min target ES2024 or non-strict accuracy`);
                let ascii = {
                    graph: "!-~",
                    print: " -~"
                }[value];
                if (negate) ascii = `\0-${$c0ef9b2f1330c5f8$var$cp(ascii.codePointAt(0) - 1)}${$c0ef9b2f1330c5f8$var$cp(ascii.codePointAt(2) + 1)}-\u{10FFFF}`;
                replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$parseFragment(`[${ascii}]`), parent));
            } else replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$setNegate($c0ef9b2f1330c5f8$var$parseFragment($c0ef9b2f1330c5f8$var$PosixClassMap.get(value)), negate), parent));
        } else if (kind === "property") {
            if (!$c0ef9b2f1330c5f8$var$JsUnicodePropertyMap.has((0, $81a53fa315512537$export$74643d1fe038be1a)(value))) node.key = "sc";
        } else if (kind === "space") replaceWith($c0ef9b2f1330c5f8$var$setParent((0, $81a53fa315512537$export$3968c6d753b95879)("space", {
            negate: negate
        }), parent));
        else if (kind === "word") replaceWith($c0ef9b2f1330c5f8$var$setParentDeep($c0ef9b2f1330c5f8$var$setNegate($c0ef9b2f1330c5f8$var$parseFragment($c0ef9b2f1330c5f8$var$defaultWordChar), negate), parent));
        else throw new Error(`Unexpected character set kind "${kind}"`);
    },
    Directive ({ node: node, parent: parent, root: root, remove: remove, replaceWith: replaceWith, removeAllPrevSiblings: removeAllPrevSiblings, removeAllNextSiblings: removeAllNextSiblings }) {
        const { kind: kind, flags: flags } = node;
        if (kind === "flags") {
            if (!flags.enable && !flags.disable) remove();
            else {
                const flagGroup = (0, $81a53fa315512537$export$856f728536d122cb)({
                    flags: flags
                });
                flagGroup.body[0].body = removeAllNextSiblings();
                replaceWith($c0ef9b2f1330c5f8$var$setParentDeep(flagGroup, parent), {
                    traverse: true
                });
            }
        } else if (kind === "keep") {
            const firstAlt = root.body[0];
            const hasWrapperGroup = root.body.length === 1 && // Not emulatable if within a `CapturingGroup`
            (0, $afa8d6abbb644392$export$dcb3ae0c3f199df3)(firstAlt, {
                type: "Group"
            }) && firstAlt.body[0].body.length === 1;
            const topLevel = hasWrapperGroup ? firstAlt.body[0] : root;
            if (parent.parent !== topLevel || topLevel.body.length > 1) throw new Error($c0ef9b2f1330c5f8$var$r`Uses "\K" in a way that's unsupported`);
            const lookbehind = (0, $81a53fa315512537$export$a1c731c64d750557)({
                behind: true
            });
            lookbehind.body[0].body = removeAllPrevSiblings();
            replaceWith($c0ef9b2f1330c5f8$var$setParentDeep(lookbehind, parent));
        } else throw new Error(`Unexpected directive kind "${kind}"`);
    },
    Flags ({ node: node, parent: parent }) {
        if (node.posixIsAscii) throw new Error('Unsupported flag "P"');
        if (node.textSegmentMode === "word") throw new Error('Unsupported flag "y{w}"');
        [
            "digitIsAscii",
            // Flag D
            "extended",
            // Flag x
            "posixIsAscii",
            // Flag P
            "spaceIsAscii",
            // Flag S
            "wordIsAscii",
            // Flag W
            "textSegmentMode"
        ].forEach((f)=>delete node[f]);
        Object.assign(node, {
            // JS flag g; no Onig equiv
            global: false,
            // JS flag d; no Onig equiv
            hasIndices: false,
            // JS flag m; no Onig equiv but its behavior is always on in Onig. Onig's only line break
            // char is line feed, unlike JS, so this flag isn't used since it would produce inaccurate
            // results (also allows `^` and `$` to be used in the generator for string start and end)
            multiline: false,
            // JS flag y; no Onig equiv, but used for `\G` emulation
            sticky: node.sticky ?? false
        });
        parent.options = {
            disable: {
                // Onig uses different rules for flag x than Regex+, so disable the implicit flag
                x: true,
                // Onig has no flag to control "named capture only" mode but contextually applies its
                // behavior when named capturing is used, so disable Regex+'s implicit flag for it
                n: true
            },
            force: {
                // Always add flag v because we're generating an AST that relies on it (it enables JS
                // support for Onig features nested classes, intersection, Unicode properties, etc.).
                // However, the generator might disable flag v based on its `target` option
                v: true
            }
        };
    },
    Group ({ node: node }) {
        if (!node.flags) return;
        const { enable: enable, disable: disable } = node.flags;
        enable?.extended && delete enable.extended;
        disable?.extended && delete disable.extended;
        enable?.dotAll && disable?.dotAll && delete enable.dotAll;
        enable?.ignoreCase && disable?.ignoreCase && delete enable.ignoreCase;
        enable && !Object.keys(enable).length && delete node.flags.enable;
        disable && !Object.keys(disable).length && delete node.flags.disable;
        !node.flags.enable && !node.flags.disable && delete node.flags;
    },
    LookaroundAssertion ({ node: node }, state) {
        const { kind: kind } = node;
        if (kind === "lookbehind") state.passedLookbehind = true;
    },
    NamedCallout ({ node: node, parent: parent, replaceWith: replaceWith }) {
        const { kind: kind } = node;
        if (kind === "fail") replaceWith($c0ef9b2f1330c5f8$var$setParentDeep((0, $81a53fa315512537$export$a1c731c64d750557)({
            negate: true
        }), parent));
        else throw new Error(`Unsupported named callout "(*${kind.toUpperCase()}"`);
    },
    Quantifier ({ node: node }) {
        if (node.body.type === "Quantifier") {
            const group = (0, $81a53fa315512537$export$856f728536d122cb)();
            group.body[0].body.push(node.body);
            node.body = $c0ef9b2f1330c5f8$var$setParentDeep(group, node);
        }
    },
    Regex: {
        enter ({ node: node }, { supportedGNodes: supportedGNodes }) {
            const leadingGs = [];
            let hasAltWithLeadG = false;
            let hasAltWithoutLeadG = false;
            for (const alt of node.body)if (alt.body.length === 1 && alt.body[0].kind === "search_start") alt.body.pop();
            else {
                const leadingG = $c0ef9b2f1330c5f8$var$getLeadingG(alt.body);
                if (leadingG) {
                    hasAltWithLeadG = true;
                    Array.isArray(leadingG) ? leadingGs.push(...leadingG) : leadingGs.push(leadingG);
                } else hasAltWithoutLeadG = true;
            }
            if (hasAltWithLeadG && !hasAltWithoutLeadG) leadingGs.forEach((g)=>supportedGNodes.add(g));
        },
        exit (_, { accuracy: accuracy, passedLookbehind: passedLookbehind, strategy: strategy }) {
            if (accuracy === "strict" && passedLookbehind && strategy) throw new Error($c0ef9b2f1330c5f8$var$r`Uses "\G" in a way that requires non-strict accuracy`);
        }
    },
    Subroutine ({ node: node }, { jsGroupNameMap: jsGroupNameMap }) {
        let { ref: ref } = node;
        if (typeof ref === "string" && !$c0ef9b2f1330c5f8$var$isValidJsGroupName(ref)) {
            ref = $c0ef9b2f1330c5f8$var$getAndStoreJsGroupName(ref, jsGroupNameMap);
            node.ref = ref;
        }
    }
};
var $c0ef9b2f1330c5f8$var$SecondPassVisitor = {
    Backreference ({ node: node }, { multiplexCapturesToLeftByRef: multiplexCapturesToLeftByRef, reffedNodesByReferencer: reffedNodesByReferencer }) {
        const { orphan: orphan, ref: ref } = node;
        if (!orphan) reffedNodesByReferencer.set(node, [
            ...multiplexCapturesToLeftByRef.get(ref).map(({ node: node2 })=>node2)
        ]);
    },
    CapturingGroup: {
        enter ({ node: node, parent: parent, replaceWith: replaceWith, skip: skip }, { groupOriginByCopy: groupOriginByCopy, groupsByName: groupsByName, multiplexCapturesToLeftByRef: multiplexCapturesToLeftByRef, openRefs: openRefs, reffedNodesByReferencer: reffedNodesByReferencer }) {
            const origin = groupOriginByCopy.get(node);
            if (origin && openRefs.has(node.number)) {
                const recursion2 = $c0ef9b2f1330c5f8$var$setParent($c0ef9b2f1330c5f8$var$createRecursion(node.number), parent);
                reffedNodesByReferencer.set(recursion2, openRefs.get(node.number));
                replaceWith(recursion2);
                return;
            }
            openRefs.set(node.number, node);
            multiplexCapturesToLeftByRef.set(node.number, []);
            if (node.name) $c0ef9b2f1330c5f8$var$getOrInsert(multiplexCapturesToLeftByRef, node.name, []);
            const multiplexNodes = multiplexCapturesToLeftByRef.get(node.name ?? node.number);
            for(let i = 0; i < multiplexNodes.length; i++){
                const multiplex = multiplexNodes[i];
                if (// This group is from subroutine expansion, and there's a multiplex value from either the
                // origin node or a prior subroutine expansion group with the same origin
                origin === multiplex.node || origin && origin === multiplex.origin || // This group is not from subroutine expansion, and it comes after a subroutine expansion
                // group that refers to this group
                node === multiplex.origin) {
                    multiplexNodes.splice(i, 1);
                    break;
                }
            }
            multiplexCapturesToLeftByRef.get(node.number).push({
                node: node,
                origin: origin
            });
            if (node.name) multiplexCapturesToLeftByRef.get(node.name).push({
                node: node,
                origin: origin
            });
            if (node.name) {
                const groupsWithSameName = $c0ef9b2f1330c5f8$var$getOrInsert(groupsByName, node.name, /* @__PURE__ */ new Map());
                let hasDuplicateNameToRemove = false;
                if (origin) hasDuplicateNameToRemove = true;
                else {
                    for (const groupInfo of groupsWithSameName.values())if (!groupInfo.hasDuplicateNameToRemove) {
                        hasDuplicateNameToRemove = true;
                        break;
                    }
                }
                groupsByName.get(node.name).set(node, {
                    node: node,
                    hasDuplicateNameToRemove: hasDuplicateNameToRemove
                });
            }
        },
        exit ({ node: node }, { openRefs: openRefs }) {
            if (openRefs.get(node.number) === node) openRefs.delete(node.number);
        }
    },
    Group: {
        enter ({ node: node }, state) {
            state.prevFlags = state.currentFlags;
            if (node.flags) state.currentFlags = $c0ef9b2f1330c5f8$var$getNewCurrentFlags(state.currentFlags, node.flags);
        },
        exit (_, state) {
            state.currentFlags = state.prevFlags;
        }
    },
    Subroutine ({ node: node, parent: parent, replaceWith: replaceWith }, state) {
        const { isRecursive: isRecursive, ref: ref } = node;
        if (isRecursive) {
            let reffed = parent;
            while(reffed = reffed.parent){
                if (reffed.type === "CapturingGroup" && (reffed.name === ref || reffed.number === ref)) break;
            }
            state.reffedNodesByReferencer.set(node, reffed);
            return;
        }
        const reffedGroupNode = state.subroutineRefMap.get(ref);
        const isGlobalRecursion = ref === 0;
        const expandedSubroutine = isGlobalRecursion ? $c0ef9b2f1330c5f8$var$createRecursion(0) : // The reffed group might itself contain subroutines, which are expanded during sub-traversal
        $c0ef9b2f1330c5f8$var$cloneCapturingGroup(reffedGroupNode, state.groupOriginByCopy, null);
        let replacement = expandedSubroutine;
        if (!isGlobalRecursion) {
            const reffedGroupFlagMods = $c0ef9b2f1330c5f8$var$getCombinedFlagModsFromFlagNodes($c0ef9b2f1330c5f8$var$getAllParents(reffedGroupNode, (p)=>p.type === "Group" && !!p.flags));
            const reffedGroupFlags = reffedGroupFlagMods ? $c0ef9b2f1330c5f8$var$getNewCurrentFlags(state.globalFlags, reffedGroupFlagMods) : state.globalFlags;
            if (!$c0ef9b2f1330c5f8$var$areFlagsEqual(reffedGroupFlags, state.currentFlags)) {
                replacement = (0, $81a53fa315512537$export$856f728536d122cb)({
                    flags: $c0ef9b2f1330c5f8$var$getFlagModsFromFlags(reffedGroupFlags)
                });
                replacement.body[0].body.push(expandedSubroutine);
            }
        }
        replaceWith($c0ef9b2f1330c5f8$var$setParentDeep(replacement, parent), {
            traverse: !isGlobalRecursion
        });
    }
};
var $c0ef9b2f1330c5f8$var$ThirdPassVisitor = {
    Backreference ({ node: node, parent: parent, replaceWith: replaceWith }, state) {
        if (node.orphan) {
            state.highestOrphanBackref = Math.max(state.highestOrphanBackref, node.ref);
            return;
        }
        const reffedNodes = state.reffedNodesByReferencer.get(node);
        const participants = reffedNodes.filter((reffed)=>$c0ef9b2f1330c5f8$var$canParticipateWithNode(reffed, node));
        if (!participants.length) replaceWith($c0ef9b2f1330c5f8$var$setParentDeep((0, $81a53fa315512537$export$a1c731c64d750557)({
            negate: true
        }), parent));
        else if (participants.length > 1) {
            const group = (0, $81a53fa315512537$export$856f728536d122cb)({
                atomic: true,
                body: participants.reverse().map((reffed)=>(0, $81a53fa315512537$export$4506b1bb0cf5d8dd)({
                        body: [
                            (0, $81a53fa315512537$export$19ee8a21aa784111)(reffed.number)
                        ]
                    }))
            });
            replaceWith($c0ef9b2f1330c5f8$var$setParentDeep(group, parent));
        } else node.ref = participants[0].number;
    },
    CapturingGroup ({ node: node }, state) {
        node.number = ++state.numCapturesToLeft;
        if (node.name) {
            if (state.groupsByName.get(node.name).get(node).hasDuplicateNameToRemove) delete node.name;
        }
    },
    Regex: {
        exit ({ node: node }, state) {
            const numCapsNeeded = Math.max(state.highestOrphanBackref - state.numCapturesToLeft, 0);
            for(let i = 0; i < numCapsNeeded; i++){
                const emptyCapture = (0, $81a53fa315512537$export$e8bb25176ecaca85)();
                node.body.at(-1).body.push(emptyCapture);
            }
        }
    },
    Subroutine ({ node: node }, state) {
        if (!node.isRecursive || node.ref === 0) return;
        node.ref = state.reffedNodesByReferencer.get(node).number;
    }
};
function $c0ef9b2f1330c5f8$var$addParentProperties(root) {
    (0, $ad81d75b55705a46$export$df3f009e3d155b20)(root, {
        "*" ({ node: node, parent: parent }) {
            node.parent = parent;
        }
    });
}
function $c0ef9b2f1330c5f8$var$areFlagsEqual(a, b) {
    return a.dotAll === b.dotAll && a.ignoreCase === b.ignoreCase;
}
function $c0ef9b2f1330c5f8$var$canParticipateWithNode(capture, node) {
    let rightmostPoint = node;
    do {
        if (rightmostPoint.type === "Regex") return false;
        if (rightmostPoint.type === "Alternative") continue;
        if (rightmostPoint === capture) return false;
        const kidsOfParent = $c0ef9b2f1330c5f8$var$getKids(rightmostPoint.parent);
        for (const kid of kidsOfParent){
            if (kid === rightmostPoint) break;
            if (kid === capture || $c0ef9b2f1330c5f8$var$isAncestorOf(kid, capture)) return true;
        }
    }while (rightmostPoint = rightmostPoint.parent);
    throw new Error("Unexpected path");
}
function $c0ef9b2f1330c5f8$var$cloneCapturingGroup(obj, originMap, up, up2) {
    const store = Array.isArray(obj) ? [] : {};
    for (const [key, value] of Object.entries(obj)){
        if (key === "parent") store.parent = Array.isArray(up) ? up2 : up;
        else if (value && typeof value === "object") store[key] = $c0ef9b2f1330c5f8$var$cloneCapturingGroup(value, originMap, store, up);
        else {
            if (key === "type" && value === "CapturingGroup") originMap.set(store, originMap.get(obj) ?? obj);
            store[key] = value;
        }
    }
    return store;
}
function $c0ef9b2f1330c5f8$var$createRecursion(ref) {
    const node = (0, $81a53fa315512537$export$3b50b5d6d0004cab)(ref);
    node.isRecursive = true;
    return node;
}
function $c0ef9b2f1330c5f8$var$getAllParents(node, filterFn) {
    const results = [];
    while(node = node.parent)if (!filterFn || filterFn(node)) results.push(node);
    return results;
}
function $c0ef9b2f1330c5f8$var$getAndStoreJsGroupName(name, map) {
    if (map.has(name)) return map.get(name);
    const jsName = `$${map.size}_${name.replace(/^[^$_\p{IDS}]|[^$\u200C\u200D\p{IDC}]/ug, "_")}`;
    map.set(name, jsName);
    return jsName;
}
function $c0ef9b2f1330c5f8$var$getCombinedFlagModsFromFlagNodes(flagNodes) {
    const flagProps = [
        "dotAll",
        "ignoreCase"
    ];
    const combinedFlags = {
        enable: {},
        disable: {}
    };
    flagNodes.forEach(({ flags: flags })=>{
        flagProps.forEach((prop)=>{
            if (flags.enable?.[prop]) {
                delete combinedFlags.disable[prop];
                combinedFlags.enable[prop] = true;
            }
            if (flags.disable?.[prop]) combinedFlags.disable[prop] = true;
        });
    });
    if (!Object.keys(combinedFlags.enable).length) delete combinedFlags.enable;
    if (!Object.keys(combinedFlags.disable).length) delete combinedFlags.disable;
    if (combinedFlags.enable || combinedFlags.disable) return combinedFlags;
    return null;
}
function $c0ef9b2f1330c5f8$var$getFlagModsFromFlags({ dotAll: dotAll, ignoreCase: ignoreCase }) {
    const mods = {};
    if (dotAll || ignoreCase) {
        mods.enable = {};
        dotAll && (mods.enable.dotAll = true);
        ignoreCase && (mods.enable.ignoreCase = true);
    }
    if (!dotAll || !ignoreCase) {
        mods.disable = {};
        !dotAll && (mods.disable.dotAll = true);
        !ignoreCase && (mods.disable.ignoreCase = true);
    }
    return mods;
}
function $c0ef9b2f1330c5f8$var$getKids(node) {
    if (!node) throw new Error("Node expected");
    const { body: body } = node;
    return Array.isArray(body) ? body : body ? [
        body
    ] : null;
}
function $c0ef9b2f1330c5f8$var$getLeadingG(els) {
    const firstToConsider = els.find((el)=>el.kind === "search_start" || $c0ef9b2f1330c5f8$var$isLoneGLookaround(el, {
            negate: false
        }) || !$c0ef9b2f1330c5f8$var$isAlwaysZeroLength(el));
    if (!firstToConsider) return null;
    if (firstToConsider.kind === "search_start") return firstToConsider;
    if (firstToConsider.type === "LookaroundAssertion") return firstToConsider.body[0].body[0];
    if (firstToConsider.type === "CapturingGroup" || firstToConsider.type === "Group") {
        const gNodesForGroup = [];
        for (const alt of firstToConsider.body){
            const leadingG = $c0ef9b2f1330c5f8$var$getLeadingG(alt.body);
            if (!leadingG) return null;
            Array.isArray(leadingG) ? gNodesForGroup.push(...leadingG) : gNodesForGroup.push(leadingG);
        }
        return gNodesForGroup;
    }
    return null;
}
function $c0ef9b2f1330c5f8$var$isAncestorOf(node, descendant) {
    const kids = $c0ef9b2f1330c5f8$var$getKids(node) ?? [];
    for (const kid of kids){
        if (kid === descendant || $c0ef9b2f1330c5f8$var$isAncestorOf(kid, descendant)) return true;
    }
    return false;
}
function $c0ef9b2f1330c5f8$var$isAlwaysZeroLength({ type: type }) {
    return type === "Assertion" || type === "Directive" || type === "LookaroundAssertion";
}
function $c0ef9b2f1330c5f8$var$isAlwaysNonZeroLength(node) {
    const types = [
        "Character",
        "CharacterClass",
        "CharacterSet"
    ];
    return types.includes(node.type) || node.type === "Quantifier" && node.min && types.includes(node.body.type);
}
function $c0ef9b2f1330c5f8$var$isLoneGLookaround(node, options) {
    const opts = {
        negate: null,
        ...options
    };
    return node.type === "LookaroundAssertion" && (opts.negate === null || node.negate === opts.negate) && node.body.length === 1 && (0, $afa8d6abbb644392$export$dcb3ae0c3f199df3)(node.body[0], {
        type: "Assertion",
        kind: "search_start"
    });
}
function $c0ef9b2f1330c5f8$var$isValidJsGroupName(name) {
    return /^[$_\p{IDS}][$\u200C\u200D\p{IDC}]*$/u.test(name);
}
function $c0ef9b2f1330c5f8$var$parseFragment(pattern, options) {
    const ast = (0, $81a53fa315512537$export$98e6a39c04603d36)(pattern, {
        ...options,
        // Providing a custom set of Unicode property names avoids converting some JS Unicode
        // properties (ex: `\p{Alpha}`) to Onig POSIX classes
        unicodePropertyMap: $c0ef9b2f1330c5f8$var$JsUnicodePropertyMap
    });
    const alts = ast.body;
    if (alts.length > 1 || alts[0].body.length > 1) return (0, $81a53fa315512537$export$856f728536d122cb)({
        body: alts
    });
    return alts[0].body[0];
}
function $c0ef9b2f1330c5f8$var$setNegate(node, negate) {
    node.negate = negate;
    return node;
}
function $c0ef9b2f1330c5f8$var$setParent(node, parent) {
    node.parent = parent;
    return node;
}
function $c0ef9b2f1330c5f8$var$setParentDeep(node, parent) {
    $c0ef9b2f1330c5f8$var$addParentProperties(node);
    node.parent = parent;
    return node;
}
function $c0ef9b2f1330c5f8$var$generate(ast, options) {
    const opts = $c0ef9b2f1330c5f8$var$getOptions(options);
    const minTargetEs2024 = $c0ef9b2f1330c5f8$var$isMinTarget(opts.target, "ES2024");
    const minTargetEs2025 = $c0ef9b2f1330c5f8$var$isMinTarget(opts.target, "ES2025");
    const recursionLimit = opts.rules.recursionLimit;
    if (!Number.isInteger(recursionLimit) || recursionLimit < 2 || recursionLimit > 20) throw new Error("Invalid recursionLimit; use 2-20");
    let hasCaseInsensitiveNode = null;
    let hasCaseSensitiveNode = null;
    if (!minTargetEs2025) {
        const iStack = [
            ast.flags.ignoreCase
        ];
        (0, $ad81d75b55705a46$export$df3f009e3d155b20)(ast, $c0ef9b2f1330c5f8$var$FlagModifierVisitor, {
            getCurrentModI: ()=>iStack.at(-1),
            popModI () {
                iStack.pop();
            },
            pushModI (isIOn) {
                iStack.push(isIOn);
            },
            setHasCasedChar () {
                if (iStack.at(-1)) hasCaseInsensitiveNode = true;
                else hasCaseSensitiveNode = true;
            }
        });
    }
    const appliedGlobalFlags = {
        dotAll: ast.flags.dotAll,
        // - Turn global flag i on if a case insensitive node was used and no case sensitive nodes were
        //   used (to avoid unnecessary node expansion).
        // - Turn global flag i off if a case sensitive node was used (since case sensitivity can't be
        //   forced without the use of ES2025 flag groups)
        ignoreCase: !!((ast.flags.ignoreCase || hasCaseInsensitiveNode) && !hasCaseSensitiveNode)
    };
    let lastNode = ast;
    const state = {
        accuracy: opts.accuracy,
        appliedGlobalFlags: appliedGlobalFlags,
        captureMap: /* @__PURE__ */ new Map(),
        currentFlags: {
            dotAll: ast.flags.dotAll,
            ignoreCase: ast.flags.ignoreCase
        },
        inCharClass: false,
        lastNode: lastNode,
        originMap: ast._originMap,
        recursionLimit: recursionLimit,
        useAppliedIgnoreCase: !!(!minTargetEs2025 && hasCaseInsensitiveNode && hasCaseSensitiveNode),
        useFlagMods: minTargetEs2025,
        useFlagV: minTargetEs2024,
        verbose: opts.verbose
    };
    function gen(node) {
        state.lastNode = lastNode;
        lastNode = node;
        const fn = $c0ef9b2f1330c5f8$var$throwIfNullish($c0ef9b2f1330c5f8$var$generator[node.type], `Unexpected node type "${node.type}"`);
        return fn(node, state, gen);
    }
    const result = {
        pattern: ast.body.map(gen).join("|"),
        // Could reset `lastNode` at this point via `lastNode = ast`, but it isn't needed by flags
        flags: gen(ast.flags),
        options: {
            ...ast.options
        }
    };
    if (!minTargetEs2024) {
        delete result.options.force.v;
        result.options.disable.v = true;
        result.options.unicodeSetsPlugin = null;
    }
    result._captureTransfers = /* @__PURE__ */ new Map();
    result._hiddenCaptures = [];
    state.captureMap.forEach((value, key)=>{
        if (value.hidden) result._hiddenCaptures.push(key);
        if (value.transferTo) $c0ef9b2f1330c5f8$var$getOrInsert(result._captureTransfers, value.transferTo, []).push(key);
    });
    return result;
}
var $c0ef9b2f1330c5f8$var$FlagModifierVisitor = {
    "*": {
        enter ({ node: node }, state) {
            if ($c0ef9b2f1330c5f8$var$isAnyGroup(node)) {
                const currentModI = state.getCurrentModI();
                state.pushModI(node.flags ? $c0ef9b2f1330c5f8$var$getNewCurrentFlags({
                    ignoreCase: currentModI
                }, node.flags).ignoreCase : currentModI);
            }
        },
        exit ({ node: node }, state) {
            if ($c0ef9b2f1330c5f8$var$isAnyGroup(node)) state.popModI();
        }
    },
    Backreference (_, state) {
        state.setHasCasedChar();
    },
    Character ({ node: node }, state) {
        if ($c0ef9b2f1330c5f8$var$charHasCase($c0ef9b2f1330c5f8$var$cp(node.value))) state.setHasCasedChar();
    },
    CharacterClassRange ({ node: node, skip: skip }, state) {
        skip();
        if ($c0ef9b2f1330c5f8$var$getCasesOutsideCharClassRange(node, {
            firstOnly: true
        }).length) state.setHasCasedChar();
    },
    CharacterSet ({ node: node }, state) {
        if (node.kind === "property" && $c0ef9b2f1330c5f8$var$UnicodePropertiesWithSpecificCase.has(node.value)) state.setHasCasedChar();
    }
};
var $c0ef9b2f1330c5f8$var$generator = {
    /**
  @param {AlternativeNode} node
  */ Alternative ({ body: body }, _, gen) {
        return body.map(gen).join("");
    },
    /**
  @param {AssertionNode} node
  */ Assertion ({ kind: kind, negate: negate }) {
        if (kind === "string_end") return "$";
        if (kind === "string_start") return "^";
        if (kind === "word_boundary") return negate ? $c0ef9b2f1330c5f8$var$r`\B` : $c0ef9b2f1330c5f8$var$r`\b`;
        throw new Error(`Unexpected assertion kind "${kind}"`);
    },
    /**
  @param {BackreferenceNode} node
  */ Backreference ({ ref: ref }, state) {
        if (typeof ref !== "number") throw new Error("Unexpected named backref in transformed AST");
        if (!state.useFlagMods && state.accuracy === "strict" && state.currentFlags.ignoreCase && !state.captureMap.get(ref).ignoreCase) throw new Error("Use of case-insensitive backref to case-sensitive group requires target ES2025 or non-strict accuracy");
        return "\\" + ref;
    },
    /**
  @param {CapturingGroupNode} node
  */ CapturingGroup (node, state, gen) {
        const { body: body, name: name, number: number } = node;
        const data = {
            ignoreCase: state.currentFlags.ignoreCase
        };
        const origin = state.originMap.get(node);
        if (origin) {
            data.hidden = true;
            if (number > origin.number) data.transferTo = origin.number;
        }
        state.captureMap.set(number, data);
        return `(${name ? `?<${name}>` : ""}${body.map(gen).join("|")})`;
    },
    /**
  @param {CharacterNode} node
  */ Character ({ value: value }, state) {
        const char = $c0ef9b2f1330c5f8$var$cp(value);
        const escaped = $c0ef9b2f1330c5f8$var$getCharEscape(value, {
            escDigit: state.lastNode.type === "Backreference",
            inCharClass: state.inCharClass,
            useFlagV: state.useFlagV
        });
        if (escaped !== char) return escaped;
        if (state.useAppliedIgnoreCase && state.currentFlags.ignoreCase && $c0ef9b2f1330c5f8$var$charHasCase(char)) {
            const cases = $c0ef9b2f1330c5f8$var$getIgnoreCaseMatchChars(char);
            return state.inCharClass ? cases.join("") : cases.length > 1 ? `[${cases.join("")}]` : cases[0];
        }
        return char;
    },
    /**
  @param {CharacterClassNode} node
  */ CharacterClass (node, state, gen) {
        const { kind: kind, negate: negate, parent: parent } = node;
        let { body: body } = node;
        if (kind === "intersection" && !state.useFlagV) throw new Error("Use of character class intersection requires min target ES2024");
        if ($c0ef9b2f1330c5f8$var$envFlags.bugFlagVLiteralHyphenIsRange && state.useFlagV && body.some($c0ef9b2f1330c5f8$var$isLiteralHyphen)) body = [
            (0, $81a53fa315512537$export$4d63783c2be0a38c)(45),
            ...body.filter((kid)=>!$c0ef9b2f1330c5f8$var$isLiteralHyphen(kid))
        ];
        const genClass = ()=>`[${negate ? "^" : ""}${body.map(gen).join(kind === "intersection" ? "&&" : "")}]`;
        if (!state.inCharClass) {
            if (// Already established `kind !== 'intersection'` if `!state.useFlagV`; don't check again
            (!state.useFlagV || $c0ef9b2f1330c5f8$var$envFlags.bugNestedClassIgnoresNegation) && !negate) {
                const negatedChildClasses = body.filter((kid)=>kid.type === "CharacterClass" && kid.kind === "union" && kid.negate);
                if (negatedChildClasses.length) {
                    const group = (0, $81a53fa315512537$export$856f728536d122cb)();
                    const groupFirstAlt = group.body[0];
                    group.parent = parent;
                    groupFirstAlt.parent = group;
                    body = body.filter((kid)=>!negatedChildClasses.includes(kid));
                    node.body = body;
                    if (body.length) {
                        node.parent = groupFirstAlt;
                        groupFirstAlt.body.push(node);
                    } else group.body.pop();
                    negatedChildClasses.forEach((cc)=>{
                        const newAlt = (0, $81a53fa315512537$export$4506b1bb0cf5d8dd)({
                            body: [
                                cc
                            ]
                        });
                        cc.parent = newAlt;
                        newAlt.parent = group;
                        group.body.push(newAlt);
                    });
                    return gen(group);
                }
            }
            state.inCharClass = true;
            const result = genClass();
            state.inCharClass = false;
            return result;
        }
        const firstEl = body[0];
        if (// Already established that the parent is a char class via `inCharClass`; don't check again
        kind === "union" && !negate && firstEl && // Allows many nested classes to work with `target` ES2018 which doesn't support nesting
        ((!state.useFlagV || !state.verbose) && parent.kind === "union" && !($c0ef9b2f1330c5f8$var$envFlags.bugFlagVLiteralHyphenIsRange && state.useFlagV) || !state.verbose && parent.kind === "intersection" && // JS doesn't allow intersection with union or ranges
        body.length === 1 && firstEl.type !== "CharacterClassRange")) return body.map(gen).join("");
        if (!state.useFlagV && parent.type === "CharacterClass") throw new Error("Uses nested character class in a way that requires min target ES2024");
        return genClass();
    },
    /**
  @param {CharacterClassRangeNode} node
  */ CharacterClassRange (node, state) {
        const min = node.min.value;
        const max = node.max.value;
        const escOpts = {
            escDigit: false,
            inCharClass: true,
            useFlagV: state.useFlagV
        };
        const minStr = $c0ef9b2f1330c5f8$var$getCharEscape(min, escOpts);
        const maxStr = $c0ef9b2f1330c5f8$var$getCharEscape(max, escOpts);
        const extraChars = /* @__PURE__ */ new Set();
        if (state.useAppliedIgnoreCase && state.currentFlags.ignoreCase) {
            const charsOutsideRange = $c0ef9b2f1330c5f8$var$getCasesOutsideCharClassRange(node);
            const ranges = $c0ef9b2f1330c5f8$var$getCodePointRangesFromChars(charsOutsideRange);
            ranges.forEach((value)=>{
                extraChars.add(Array.isArray(value) ? `${$c0ef9b2f1330c5f8$var$getCharEscape(value[0], escOpts)}-${$c0ef9b2f1330c5f8$var$getCharEscape(value[1], escOpts)}` : $c0ef9b2f1330c5f8$var$getCharEscape(value, escOpts));
            });
        }
        return `${minStr}-${maxStr}${[
            ...extraChars
        ].join("")}`;
    },
    /**
  @param {CharacterSetNode} node
  */ CharacterSet ({ kind: kind, negate: negate, value: value, key: key }, state) {
        if (kind === "dot") return state.currentFlags.dotAll ? state.appliedGlobalFlags.dotAll || state.useFlagMods ? "." : "[^]" : // Onig's only line break char is line feed, unlike JS
        $c0ef9b2f1330c5f8$var$r`[^\n]`;
        if (kind === "digit") return negate ? $c0ef9b2f1330c5f8$var$r`\D` : $c0ef9b2f1330c5f8$var$r`\d`;
        if (kind === "property") {
            if (state.useAppliedIgnoreCase && state.currentFlags.ignoreCase && $c0ef9b2f1330c5f8$var$UnicodePropertiesWithSpecificCase.has(value)) throw new Error(`Unicode property "${value}" can't be case-insensitive when other chars have specific case`);
            return `${negate ? $c0ef9b2f1330c5f8$var$r`\P` : $c0ef9b2f1330c5f8$var$r`\p`}{${key ? `${key}=` : ""}${value}}`;
        }
        if (kind === "word") return negate ? $c0ef9b2f1330c5f8$var$r`\W` : $c0ef9b2f1330c5f8$var$r`\w`;
        throw new Error(`Unexpected character set kind "${kind}"`);
    },
    /**
  @param {FlagsNode} node
  */ Flags (node, state) {
        return(// The transformer should never turn on the properties for flags d, g, m since Onig doesn't
        // have equivs. Flag m is never used since Onig uses different line break chars than JS
        // (node.hasIndices ? 'd' : '') +
        // (node.global ? 'g' : '') +
        // (node.multiline ? 'm' : '') +
        (state.appliedGlobalFlags.ignoreCase ? "i" : "") + (node.dotAll ? "s" : "") + (node.sticky ? "y" : ""));
    },
    /**
  @param {GroupNode} node
  */ Group ({ atomic: atomic2, body: body, flags: flags, parent: parent }, state, gen) {
        const currentFlags = state.currentFlags;
        if (flags) state.currentFlags = $c0ef9b2f1330c5f8$var$getNewCurrentFlags(currentFlags, flags);
        const contents = body.map(gen).join("|");
        const result = !state.verbose && body.length === 1 && // Single alt
        parent.type !== "Quantifier" && !atomic2 && (!state.useFlagMods || !flags) ? contents : `(?${$c0ef9b2f1330c5f8$var$getGroupPrefix(atomic2, flags, state.useFlagMods)}${contents})`;
        state.currentFlags = currentFlags;
        return result;
    },
    /**
  @param {LookaroundAssertionNode} node
  */ LookaroundAssertion ({ body: body, kind: kind, negate: negate }, _, gen) {
        const prefix = `${kind === "lookahead" ? "" : "<"}${negate ? "!" : "="}`;
        return `(?${prefix}${body.map(gen).join("|")})`;
    },
    /**
  @param {QuantifierNode} node
  */ Quantifier (node, _, gen) {
        return gen(node.body) + $c0ef9b2f1330c5f8$var$getQuantifierStr(node);
    },
    /**
  @param {SubroutineNode & {isRecursive: true}} node
  */ Subroutine ({ isRecursive: isRecursive, ref: ref }, state) {
        if (!isRecursive) throw new Error("Unexpected non-recursive subroutine in transformed AST");
        const limit = state.recursionLimit;
        return ref === 0 ? `(?R=${limit})` : $c0ef9b2f1330c5f8$var$r`\g<${ref}&R=${limit}>`;
    }
};
var $c0ef9b2f1330c5f8$var$BaseEscapeChars = /* @__PURE__ */ new Set([
    "$",
    "(",
    ")",
    "*",
    "+",
    ".",
    "?",
    "[",
    "\\",
    "]",
    "^",
    "{",
    "|",
    "}"
]);
var $c0ef9b2f1330c5f8$var$CharClassEscapeChars = /* @__PURE__ */ new Set([
    "-",
    "\\",
    "]",
    "^",
    // Literal `[` doesn't require escaping with flag u, but this can help work around regex source
    // linters and regex syntax processors that expect unescaped `[` to create a nested class
    "["
]);
var $c0ef9b2f1330c5f8$var$CharClassEscapeCharsFlagV = /* @__PURE__ */ new Set([
    "(",
    ")",
    "-",
    "/",
    "[",
    "\\",
    "]",
    "^",
    "{",
    "|",
    "}",
    // Double punctuators; also includes already-listed `-` and `^`
    "!",
    "#",
    "$",
    "%",
    "&",
    "*",
    "+",
    ",",
    ".",
    ":",
    ";",
    "<",
    "=",
    ">",
    "?",
    "@",
    "`",
    "~"
]);
var $c0ef9b2f1330c5f8$var$CharCodeEscapeMap = /* @__PURE__ */ new Map([
    [
        9,
        $c0ef9b2f1330c5f8$var$r`\t`
    ],
    // horizontal tab
    [
        10,
        $c0ef9b2f1330c5f8$var$r`\n`
    ],
    // line feed
    [
        11,
        $c0ef9b2f1330c5f8$var$r`\v`
    ],
    // vertical tab
    [
        12,
        $c0ef9b2f1330c5f8$var$r`\f`
    ],
    // form feed
    [
        13,
        $c0ef9b2f1330c5f8$var$r`\r`
    ],
    // carriage return
    [
        8232,
        $c0ef9b2f1330c5f8$var$r`\u2028`
    ],
    // line separator
    [
        8233,
        $c0ef9b2f1330c5f8$var$r`\u2029`
    ],
    // paragraph separator
    [
        65279,
        $c0ef9b2f1330c5f8$var$r`\uFEFF`
    ]
]);
var $c0ef9b2f1330c5f8$var$casedRe = /^\p{Cased}$/u;
function $c0ef9b2f1330c5f8$var$charHasCase(char) {
    return $c0ef9b2f1330c5f8$var$casedRe.test(char);
}
function $c0ef9b2f1330c5f8$var$getCasesOutsideCharClassRange(node, options) {
    const firstOnly = !!options?.firstOnly;
    const min = node.min.value;
    const max = node.max.value;
    const found = [];
    if (min < 65 && (max === 65535 || max >= 131071) || min === 65536 && max >= 131071) return found;
    for(let i = min; i <= max; i++){
        const char = $c0ef9b2f1330c5f8$var$cp(i);
        if (!$c0ef9b2f1330c5f8$var$charHasCase(char)) continue;
        const charsOutsideRange = $c0ef9b2f1330c5f8$var$getIgnoreCaseMatchChars(char).filter((caseOfChar)=>{
            const num = caseOfChar.codePointAt(0);
            return num < min || num > max;
        });
        if (charsOutsideRange.length) {
            found.push(...charsOutsideRange);
            if (firstOnly) break;
        }
    }
    return found;
}
function $c0ef9b2f1330c5f8$var$getCharEscape(codePoint, { escDigit: escDigit, inCharClass: inCharClass, useFlagV: useFlagV }) {
    if ($c0ef9b2f1330c5f8$var$CharCodeEscapeMap.has(codePoint)) return $c0ef9b2f1330c5f8$var$CharCodeEscapeMap.get(codePoint);
    if (// Control chars, etc.; condition modeled on the Chrome developer console's display for strings
    codePoint < 32 || codePoint > 126 && codePoint < 160 || // Unicode planes 4-16; unassigned, special purpose, and private use area
    codePoint > 262143 || // Avoid corrupting a preceding backref by immediately following it with a literal digit
    escDigit && $c0ef9b2f1330c5f8$var$isDigitCharCode(codePoint)) return codePoint > 255 ? `\\u{${codePoint.toString(16).toUpperCase()}}` : `\\x${codePoint.toString(16).toUpperCase().padStart(2, "0")}`;
    const escapeChars = inCharClass ? useFlagV ? $c0ef9b2f1330c5f8$var$CharClassEscapeCharsFlagV : $c0ef9b2f1330c5f8$var$CharClassEscapeChars : $c0ef9b2f1330c5f8$var$BaseEscapeChars;
    const char = $c0ef9b2f1330c5f8$var$cp(codePoint);
    return (escapeChars.has(char) ? "\\" : "") + char;
}
function $c0ef9b2f1330c5f8$var$getCodePointRangesFromChars(chars) {
    const codePoints = chars.map((char)=>char.codePointAt(0)).sort((a, b)=>a - b);
    const values = [];
    let start = null;
    for(let i = 0; i < codePoints.length; i++){
        if (codePoints[i + 1] === codePoints[i] + 1) start ??= codePoints[i];
        else if (start === null) values.push(codePoints[i]);
        else {
            values.push([
                start,
                codePoints[i]
            ]);
            start = null;
        }
    }
    return values;
}
function $c0ef9b2f1330c5f8$var$getGroupPrefix(atomic2, flagMods, useFlagMods) {
    if (atomic2) return ">";
    let mods = "";
    if (flagMods && useFlagMods) {
        const { enable: enable, disable: disable } = flagMods;
        mods = (enable?.ignoreCase ? "i" : "") + (enable?.dotAll ? "s" : "") + (disable ? "-" : "") + (disable?.ignoreCase ? "i" : "") + (disable?.dotAll ? "s" : "");
    }
    return `${mods}:`;
}
function $c0ef9b2f1330c5f8$var$getQuantifierStr({ kind: kind, max: max, min: min }) {
    let base;
    if (!min && max === 1) base = "?";
    else if (!min && max === Infinity) base = "*";
    else if (min === 1 && max === Infinity) base = "+";
    else if (min === max) base = `{${min}}`;
    else base = `{${min},${max === Infinity ? "" : max}}`;
    return base + ({
        greedy: "",
        lazy: "?",
        possessive: "+"
    })[kind];
}
function $c0ef9b2f1330c5f8$var$isAnyGroup({ type: type }) {
    return type === "CapturingGroup" || type === "Group" || type === "LookaroundAssertion";
}
function $c0ef9b2f1330c5f8$var$isDigitCharCode(value) {
    return value > 47 && value < 58;
}
function $c0ef9b2f1330c5f8$var$isLiteralHyphen({ type: type, value: value }) {
    return type === "Character" && value === 45;
}
// src/subclass.js
var $c0ef9b2f1330c5f8$export$121cb31e8b3a6ab5 = class _EmulatedRegExp extends RegExp {
    /**
  @type {Map<number, {
    hidden?: true;
    transferTo?: number;
  }>}
  */ #captureMap = /* @__PURE__ */ new Map();
    /**
  @type {RegExp | EmulatedRegExp | null}
  */ #compiled = null;
    /**
  @type {string}
  */ #pattern;
    /**
  @type {Map<number, string>?}
  */ #nameMap = null;
    /**
  @type {string?}
  */ #strategy = null;
    /**
  Can be used to serialize the instance.
  @type {EmulatedRegExpOptions}
  */ rawOptions = {};
    // Override the getter with one that works with lazy-compiled regexes
    get source() {
        return this.#pattern || "(?:)";
    }
    /**
  @overload
  @param {string} pattern
  @param {string} [flags]
  @param {EmulatedRegExpOptions} [options]
  */ /**
  @overload
  @param {EmulatedRegExp} pattern
  @param {string} [flags]
  */ constructor(pattern, flags, options){
        const lazyCompile = !!options?.lazyCompile;
        if (pattern instanceof RegExp) {
            if (options) throw new Error("Cannot provide options when copying a regexp");
            const re = pattern;
            super(re, flags);
            this.#pattern = re.source;
            if (re instanceof _EmulatedRegExp) {
                this.#captureMap = re.#captureMap;
                this.#nameMap = re.#nameMap;
                this.#strategy = re.#strategy;
                this.rawOptions = re.rawOptions;
            }
        } else {
            const opts = {
                hiddenCaptures: [],
                strategy: null,
                transfers: [],
                ...options
            };
            super(lazyCompile ? "" : pattern, flags);
            this.#pattern = pattern;
            this.#captureMap = $c0ef9b2f1330c5f8$var$createCaptureMap(opts.hiddenCaptures, opts.transfers);
            this.#strategy = opts.strategy;
            this.rawOptions = options ?? {};
        }
        if (!lazyCompile) this.#compiled = this;
    }
    /**
  Called internally by all String/RegExp methods that use regexes.
  @override
  @param {string} str
  @returns {RegExpExecArray?}
  */ exec(str) {
        if (!this.#compiled) {
            const { lazyCompile: lazyCompile, ...rest } = this.rawOptions;
            this.#compiled = new _EmulatedRegExp(this.#pattern, this.flags, rest);
        }
        const useLastIndex = this.global || this.sticky;
        const pos = this.lastIndex;
        if (this.#strategy === "clip_search" && useLastIndex && pos) {
            this.lastIndex = 0;
            const match = this.#execCore(str.slice(pos));
            if (match) {
                $c0ef9b2f1330c5f8$var$adjustMatchDetailsForOffset(match, pos, str, this.hasIndices);
                this.lastIndex += pos;
            }
            return match;
        }
        return this.#execCore(str);
    }
    /**
  Adds support for hidden and transfer captures.
  @param {string} str
  @returns
  */ #execCore(str) {
        this.#compiled.lastIndex = this.lastIndex;
        const match = super.exec.call(this.#compiled, str);
        this.lastIndex = this.#compiled.lastIndex;
        if (!match || !this.#captureMap.size) return match;
        const matchCopy = [
            ...match
        ];
        match.length = 1;
        let indicesCopy;
        if (this.hasIndices) {
            indicesCopy = [
                ...match.indices
            ];
            match.indices.length = 1;
        }
        const mappedNums = [
            0
        ];
        for(let i = 1; i < matchCopy.length; i++){
            const { hidden: hidden, transferTo: transferTo } = this.#captureMap.get(i) ?? {};
            if (hidden) mappedNums.push(null);
            else {
                mappedNums.push(match.length);
                match.push(matchCopy[i]);
                if (this.hasIndices) match.indices.push(indicesCopy[i]);
            }
            if (transferTo && matchCopy[i] !== void 0) {
                const to = mappedNums[transferTo];
                if (!to) throw new Error(`Invalid capture transfer to "${to}"`);
                match[to] = matchCopy[i];
                if (this.hasIndices) match.indices[to] = indicesCopy[i];
                if (match.groups) {
                    if (!this.#nameMap) this.#nameMap = $c0ef9b2f1330c5f8$var$createNameMap(this.source);
                    const name = this.#nameMap.get(transferTo);
                    if (name) {
                        match.groups[name] = matchCopy[i];
                        if (this.hasIndices) match.indices.groups[name] = indicesCopy[i];
                    }
                }
            }
        }
        return match;
    }
};
function $c0ef9b2f1330c5f8$var$adjustMatchDetailsForOffset(match, offset, input, hasIndices) {
    match.index += offset;
    match.input = input;
    if (hasIndices) {
        const indices = match.indices;
        for(let i = 0; i < indices.length; i++){
            const arr = indices[i];
            if (arr) indices[i] = [
                arr[0] + offset,
                arr[1] + offset
            ];
        }
        const groupIndices = indices.groups;
        if (groupIndices) Object.keys(groupIndices).forEach((key)=>{
            const arr = groupIndices[key];
            if (arr) groupIndices[key] = [
                arr[0] + offset,
                arr[1] + offset
            ];
        });
    }
}
function $c0ef9b2f1330c5f8$var$createCaptureMap(hiddenCaptures, transfers) {
    const captureMap = /* @__PURE__ */ new Map();
    for (const num of hiddenCaptures)captureMap.set(num, {
        hidden: true
    });
    for (const [to, from] of transfers)for (const num of from)$c0ef9b2f1330c5f8$var$getOrInsert(captureMap, num, {}).transferTo = to;
    return captureMap;
}
function $c0ef9b2f1330c5f8$var$createNameMap(pattern) {
    const re = /(?<capture>\((?:\?<(?![=!])(?<name>[^>]+)>|(?!\?)))|\\?./gsu;
    const map = /* @__PURE__ */ new Map();
    let numCharClassesOpen = 0;
    let numCaptures = 0;
    let match;
    while(match = re.exec(pattern)){
        const { 0: m, groups: { capture: capture, name: name } } = match;
        if (m === "[") numCharClassesOpen++;
        else if (!numCharClassesOpen) {
            if (capture) {
                numCaptures++;
                if (name) map.set(numCaptures, name);
            }
        } else if (m === "]") numCharClassesOpen--;
    }
    return map;
}
function $c0ef9b2f1330c5f8$export$238374f1b270e387(pattern, options) {
    const d = $c0ef9b2f1330c5f8$export$7a4833dc970906e0(pattern, options);
    if (d.options) return new $c0ef9b2f1330c5f8$export$121cb31e8b3a6ab5(d.pattern, d.flags, d.options);
    return new RegExp(d.pattern, d.flags);
}
function $c0ef9b2f1330c5f8$export$7a4833dc970906e0(pattern, options) {
    const opts = $c0ef9b2f1330c5f8$var$getOptions(options);
    const onigurumaAst = (0, $81a53fa315512537$export$98e6a39c04603d36)(pattern, {
        flags: opts.flags,
        normalizeUnknownPropertyNames: true,
        rules: {
            captureGroup: opts.rules.captureGroup,
            singleline: opts.rules.singleline
        },
        skipBackrefValidation: opts.rules.allowOrphanBackrefs,
        unicodePropertyMap: $c0ef9b2f1330c5f8$var$JsUnicodePropertyMap
    });
    const regexPlusAst = $c0ef9b2f1330c5f8$var$transform(onigurumaAst, {
        accuracy: opts.accuracy,
        asciiWordBoundaries: opts.rules.asciiWordBoundaries,
        avoidSubclass: opts.avoidSubclass,
        bestEffortTarget: opts.target
    });
    const generated = $c0ef9b2f1330c5f8$var$generate(regexPlusAst, opts);
    const recursionResult = (0, $f998c33fe6f5a8d0$export$74c5cab0f9a94551)(generated.pattern, {
        captureTransfers: generated._captureTransfers,
        hiddenCaptures: generated._hiddenCaptures,
        mode: "external"
    });
    const possessiveResult = (0, $e7b0758e094fae76$export$777a2fba7d8a1541)(recursionResult.pattern);
    const atomicResult = (0, $e7b0758e094fae76$export$a573bc8e40d39511)(possessiveResult.pattern, {
        captureTransfers: recursionResult.captureTransfers,
        hiddenCaptures: recursionResult.hiddenCaptures
    });
    const details = {
        pattern: atomicResult.pattern,
        flags: `${opts.hasIndices ? "d" : ""}${opts.global ? "g" : ""}${generated.flags}${generated.options.disable.v ? "u" : "v"}`
    };
    if (opts.avoidSubclass) {
        if (opts.lazyCompileLength !== Infinity) throw new Error("Lazy compilation requires subclass");
    } else {
        const hiddenCaptures = atomicResult.hiddenCaptures.sort((a, b)=>a - b);
        const transfers = Array.from(atomicResult.captureTransfers);
        const strategy = regexPlusAst._strategy;
        const lazyCompile = details.pattern.length >= opts.lazyCompileLength;
        if (hiddenCaptures.length || transfers.length || strategy || lazyCompile) details.options = {
            ...hiddenCaptures.length && {
                hiddenCaptures: hiddenCaptures
            },
            ...transfers.length && {
                transfers: transfers
            },
            ...strategy && {
                strategy: strategy
            },
            ...lazyCompile && {
                lazyCompile: lazyCompile
            }
        };
    }
    return details;
}


//#region src/engine-compile.ts
/**
* The default regex constructor for the JavaScript RegExp engine.
*/ function $f3031abad2acf3a6$export$70b386be05242d0f(pattern, options) {
    return (0, $c0ef9b2f1330c5f8$export$238374f1b270e387)(pattern, {
        global: true,
        hasIndices: true,
        lazyCompileLength: 3e3,
        rules: {
            allowOrphanBackrefs: true,
            asciiWordBoundaries: true,
            captureGroup: true,
            recursionLimit: 5,
            singleline: true
        },
        ...options
    });
}
/**
* Use the modern JavaScript RegExp engine to implement the OnigScanner.
*
* As Oniguruma supports some features that can't be emulated using native JavaScript regexes, some
* patterns are not supported. Errors will be thrown when parsing TextMate grammars with
* unsupported patterns, and when the grammar includes patterns that use invalid Oniguruma syntax.
* Set `forgiving` to `true` to ignore these errors and skip any unsupported or invalid patterns.
*/ function $f3031abad2acf3a6$export$d1f38b498ee0de14(options = {}) {
    const _options = {
        target: "auto",
        cache: /* @__PURE__ */ new Map(),
        ...options
    };
    _options.regexConstructor ||= (pattern)=>$f3031abad2acf3a6$export$70b386be05242d0f(pattern, {
            target: _options.target
        });
    return {
        createScanner (patterns) {
            return new (0, $7bf9254e713c94eb$export$625550452a3fa3ec)(patterns, _options);
        },
        createString (s) {
            return {
                content: s
            };
        }
    };
}


var $f3be3fdd0ed40ade$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f3be3fdd0ed40ade$var$highlighter = (0, $2eb9c19caa629d78$export$f38e8c16be9dd57d)({
    themes: [
        (0, $5f64b03bfe3858e8$export$2e2bcd8739ae039)
    ],
    langs: [
        (0, $fd0801c4416ab412$export$2e2bcd8739ae039),
        (0, $efe74ad407a81fb4$export$2e2bcd8739ae039),
        (0, $610d3eeea77f0533$export$2e2bcd8739ae039),
        (0, $7bf97d7efe7ac605$export$2e2bcd8739ae039)
    ],
    engine: (0, $f3031abad2acf3a6$export$d1f38b498ee0de14)()
});
const $f3be3fdd0ed40ade$export$6c415d1fdae3dfdb = (_a)=>{
    var { className: className = '', language: language, children: children } = _a, props = $f3be3fdd0ed40ade$var$__rest(_a, [
        "className",
        "language",
        "children"
    ]);
    const sourceCode = typeof children === 'string' ? children : (0, (/*@__PURE__*/$parcel$interopDefault($b1e7891750e609f8$exports)))(/*#__PURE__*/ (0, $7DB8U.isValidElement)(children) ? children : (0, $e830bf8f8acfe41d$exports.jsx)((0, $e830bf8f8acfe41d$exports.Fragment), {
        children: children
    }));
    const __html = $f3be3fdd0ed40ade$var$highlighter.codeToHtml(sourceCode, {
        lang: language,
        theme: 'github-light',
        structure: 'inline'
    });
    return (0, $e830bf8f8acfe41d$exports.jsx)("pre", Object.assign({
        className: `m-0 language-${language} ${className}`
    }, props, {
        children: (0, $e830bf8f8acfe41d$exports.jsx)("code", {
            dangerouslySetInnerHTML: {
                __html: __html
            },
            className: `language-${language}`
        })
    }));
};


var $49d7ea4d7974a6fe$exports = {};

$parcel$export($49d7ea4d7974a6fe$exports, "VariantColors", () => $49d7ea4d7974a6fe$export$50b010be9260e56b);
$parcel$export($49d7ea4d7974a6fe$exports, "text2color", () => $49d7ea4d7974a6fe$export$b480d00b75c9ac2d);
const $49d7ea4d7974a6fe$export$50b010be9260e56b = [
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
    'dark',
    'light'
];
function $49d7ea4d7974a6fe$export$b480d00b75c9ac2d(raw, excludeColors = []) {
    const colors = excludeColors[0] ? $49d7ea4d7974a6fe$export$50b010be9260e56b.filter((color)=>!excludeColors.find((c)=>c === color)) : $49d7ea4d7974a6fe$export$50b010be9260e56b, sum = [
        ...raw
    ].reduce((sum, char)=>sum + char.charCodeAt(0), 0);
    return colors[sum % colors.length];
}


var $6dcd5678f67c6b02$exports = {};

$parcel$export($6dcd5678f67c6b02$exports, "Countdown", () => $6dcd5678f67c6b02$export$53819c0e58f98d49);




var $dYe7D = parcelRequire("dYe7D");


var $7DB8U = parcelRequire("7DB8U");
function $1ec569b22aebf9e3$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports = {};
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $1ec569b22aebf9e3$export$61cc6ed0f143570b;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $1ec569b22aebf9e3$export$dd1bc94b04021eeb;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $1ec569b22aebf9e3$export$a09f818797e212c4;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $1ec569b22aebf9e3$export$170f4e08cad8229d;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $1ec569b22aebf9e3$export$2a489b3f92f4996a;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $1ec569b22aebf9e3$export$67a6ce548ae77071;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $1ec569b22aebf9e3$export$a48f0734ac7c2329;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $1ec569b22aebf9e3$export$3f34ca2fef821bbd;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $1ec569b22aebf9e3$export$86f54f62aa7a7514;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $1ec569b22aebf9e3$export$89912e019eef22aa;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "encodeBase64", function() {
    return $1ec569b22aebf9e3$export$8fb536984ec8b4d7;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "toBase64", function() {
    return $1ec569b22aebf9e3$export$37cc283d8fbd3462;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "decodeBase64", function() {
    return $1ec569b22aebf9e3$export$94fdf11bafc8de6b;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $1ec569b22aebf9e3$export$1c8ba402144543e5;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $1ec569b22aebf9e3$export$2ddabb89308e1a22;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $1ec569b22aebf9e3$export$14527669107aa301;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $1ec569b22aebf9e3$export$3f063810d7bf01bd;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $1ec569b22aebf9e3$export$b5a4d6f439a5044d;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $1ec569b22aebf9e3$export$b119cc7e1840e59c;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $1ec569b22aebf9e3$export$7b85fd78dd236198;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $1ec569b22aebf9e3$export$697c3df919c0e61a;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $1ec569b22aebf9e3$export$1d012a0dff3dab06;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $1ec569b22aebf9e3$export$e6b5ff3168b5942b;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "clone", function() {
    return $1ec569b22aebf9e3$export$9cd59f9826255e47;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "treeFrom", function() {
    return $1ec569b22aebf9e3$export$fbc9cd6af26fa64f;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $1ec569b22aebf9e3$export$69a3209f1a06c04d;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $1ec569b22aebf9e3$export$86c18c6347f4a8c4;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $1ec569b22aebf9e3$export$dce9414bed0662c;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $1ec569b22aebf9e3$export$271f7c16f175f804;
});
var $1ec569b22aebf9e3$var$$6a9944941b4c1893$exports = {};
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$6a9944941b4c1893$exports, "sum", function() {
    return $1ec569b22aebf9e3$export$8a63f25cc62965f1;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $1ec569b22aebf9e3$export$e1f36757ecda301d;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $1ec569b22aebf9e3$export$8e694e1eafd55acb;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $1ec569b22aebf9e3$export$57d7c52a66287430;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $1ec569b22aebf9e3$export$2b4693832ca3ce16;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $1ec569b22aebf9e3$export$5b784e078da1ce6;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $1ec569b22aebf9e3$export$17ec9c9f4f23588c;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $1ec569b22aebf9e3$export$595dbf49c602a1f;
});
function $1ec569b22aebf9e3$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $1ec569b22aebf9e3$export$e1f36757ecda301d(...data) {
    return $1ec569b22aebf9e3$export$8a63f25cc62965f1(...data) / data.length;
}
function $1ec569b22aebf9e3$export$8e694e1eafd55acb(data, sample = false) {
    const average = $1ec569b22aebf9e3$export$e1f36757ecda301d(...data);
    const summary = $1ec569b22aebf9e3$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $1ec569b22aebf9e3$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($1ec569b22aebf9e3$export$8e694e1eafd55acb(data, sample));
}
function $1ec569b22aebf9e3$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($1ec569b22aebf9e3$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $1ec569b22aebf9e3$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf('.') + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
function $1ec569b22aebf9e3$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf('.');
    if (floatOffset < 0) return length ? `${text}.${'0'.repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $1ec569b22aebf9e3$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
class $1ec569b22aebf9e3$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}
const $1ec569b22aebf9e3$export$61cc6ed0f143570b = (value)=>!(value != null) || Number.isNaN(value);
const $1ec569b22aebf9e3$export$dd1bc94b04021eeb = (value)=>$1ec569b22aebf9e3$export$61cc6ed0f143570b(value) || (typeof value === 'object' ? !Object.keys(value).length : value === '');
const $1ec569b22aebf9e3$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
const $1ec569b22aebf9e3$export$170f4e08cad8229d = (Sub, Super)=>Sub.prototype instanceof Super;
function $1ec569b22aebf9e3$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
const $1ec569b22aebf9e3$export$67a6ce548ae77071 = (raw)=>/^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + '', undefined, {
        numeric: true
    }) > 0;
const $1ec569b22aebf9e3$export$a48f0734ac7c2329 = (raw)=>raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, 'xx').length;
const $1ec569b22aebf9e3$export$3f34ca2fef821bbd = (raw)=>raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? '-' : ''}${(match[1] || match[0]).toLowerCase()}`);
const $1ec569b22aebf9e3$export$86f54f62aa7a7514 = (raw, large = false)=>raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
const $1ec569b22aebf9e3$export$89912e019eef22aa = ()=>(Date.now() + parseInt((Math.random() + '').slice(2))).toString(36);
const $1ec569b22aebf9e3$export$8fb536984ec8b4d7 = (input)=>new TextEncoder().encode(input).toBase64();
async function $1ec569b22aebf9e3$export$37cc283d8fbd3462(input) {
    if (typeof input === 'string') return $1ec569b22aebf9e3$export$8fb536984ec8b4d7(input);
    if (input instanceof Blob) input = await input.arrayBuffer();
    return new Uint8Array(input).toBase64();
}
const $1ec569b22aebf9e3$export$94fdf11bafc8de6b = (input)=>new TextDecoder().decode(Uint8Array.fromBase64(input));
const $1ec569b22aebf9e3$export$1c8ba402144543e5 = (values, keys)=>Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
var $1ec569b22aebf9e3$export$2ddabb89308e1a22 = /*#__PURE__*/ function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
    return DiffStatus;
}({});
function $1ec569b22aebf9e3$export$14527669107aa301(oldList, newList) {
    const oldSet = new Set(oldList), newSet = new Set(newList);
    const map = {};
    for (const item of oldSet.difference(newSet))map[item] = -1;
    for (const item of oldSet.intersection(newSet))map[item] = 0;
    for (const item of newSet.difference(oldSet))map[item] = 1;
    return {
        map: map,
        group: $1ec569b22aebf9e3$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $1ec569b22aebf9e3$export$b5a4d6f439a5044d(data) {
    if ($1ec569b22aebf9e3$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === 'number' && length >= 0 && ~~length === length;
}
const $1ec569b22aebf9e3$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $1ec569b22aebf9e3$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($1ec569b22aebf9e3$export$61cc6ed0f143570b(data)) return Array();
    if ($1ec569b22aebf9e3$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $1ec569b22aebf9e3$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $1ec569b22aebf9e3$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $1ec569b22aebf9e3$export$1d012a0dff3dab06(list, iteratee) {
    const group = $1ec569b22aebf9e3$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $1ec569b22aebf9e3$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $1ec569b22aebf9e3$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $1ec569b22aebf9e3$export$9cd59f9826255e47(data) {
    try {
        return globalThis.structuredClone(data);
    } catch  {
        return JSON.parse(JSON.stringify(data));
    }
}
function $1ec569b22aebf9e3$export$fbc9cd6af26fa64f(list, idKey = 'id', parentIdKey = 'parentId', childrenKey = 'children') {
    list = $1ec569b22aebf9e3$export$9cd59f9826255e47(list);
    const map = {};
    const roots = [];
    for (const item of list)map[item[idKey]] = item;
    for (const item of list){
        const parent = map[item[parentIdKey]];
        if (!parent) roots.push(item);
        else {
            parent[childrenKey] ||= [];
            parent[childrenKey].push(item);
        }
    }
    if (!roots[0]) throw new ReferenceError('No root node is found');
    return roots;
}
function $1ec569b22aebf9e3$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $1ec569b22aebf9e3$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol('done'), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $1ec569b22aebf9e3$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $1ec569b22aebf9e3$export$271f7c16f175f804 extends $1ec569b22aebf9e3$export$595dbf49c602a1f {
    constructor(...args){
        super(...args), this.units = [
            '',
            'K',
            'M',
            'G',
            'T',
            'P',
            'E',
            'Z',
            'Y'
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + 'B'
            }));
    }
}
var $1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports = {};
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $1ec569b22aebf9e3$export$c489aa6f7fd82b1a;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $1ec569b22aebf9e3$export$cbd942915f33be50;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $1ec569b22aebf9e3$export$9b886f8493244014;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $1ec569b22aebf9e3$export$e99cbb807a5bb10d;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $1ec569b22aebf9e3$export$7a9a31a911eb9a20;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $1ec569b22aebf9e3$export$fca4f8121099df57;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $1ec569b22aebf9e3$export$6ce2f08d515512;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $1ec569b22aebf9e3$export$951c8378cdfec6e6;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $1ec569b22aebf9e3$export$1a4097b876a13bf7;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $1ec569b22aebf9e3$export$d9bcbd5e1ff81430;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $1ec569b22aebf9e3$export$506c8e8f8c8edda;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $1ec569b22aebf9e3$export$3ae94a2503e890a1;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "changeYear", function() {
    return $1ec569b22aebf9e3$export$7e1c707225b48c34;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $1ec569b22aebf9e3$export$62ad822b3a5fd9a0;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "changeDate", function() {
    return $1ec569b22aebf9e3$export$9e85258502147ffb;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$f872d8bba1c0f79f$exports, "makeDateRange", function() {
    return $1ec569b22aebf9e3$export$3c1f2e5bc03748e2;
});
const $1ec569b22aebf9e3$export$c489aa6f7fd82b1a = 1000;
const $1ec569b22aebf9e3$export$cbd942915f33be50 = $1ec569b22aebf9e3$export$c489aa6f7fd82b1a * 60;
const $1ec569b22aebf9e3$export$9b886f8493244014 = $1ec569b22aebf9e3$export$cbd942915f33be50 * 15;
const $1ec569b22aebf9e3$export$e99cbb807a5bb10d = $1ec569b22aebf9e3$export$9b886f8493244014 * 4;
const $1ec569b22aebf9e3$export$7a9a31a911eb9a20 = $1ec569b22aebf9e3$export$e99cbb807a5bb10d * 24;
const $1ec569b22aebf9e3$export$fca4f8121099df57 = $1ec569b22aebf9e3$export$7a9a31a911eb9a20 * 7;
const $1ec569b22aebf9e3$export$6ce2f08d515512 = $1ec569b22aebf9e3$export$7a9a31a911eb9a20 * 365;
const $1ec569b22aebf9e3$export$951c8378cdfec6e6 = $1ec569b22aebf9e3$export$6ce2f08d515512 / 12;
const $1ec569b22aebf9e3$export$1a4097b876a13bf7 = $1ec569b22aebf9e3$export$951c8378cdfec6e6 * 3;
class $1ec569b22aebf9e3$export$d9bcbd5e1ff81430 extends $1ec569b22aebf9e3$export$595dbf49c602a1f {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args), this.units = [
            {
                base: $1ec569b22aebf9e3$export$c489aa6f7fd82b1a,
                name: 's'
            },
            {
                base: $1ec569b22aebf9e3$export$cbd942915f33be50,
                name: 'm'
            },
            {
                base: $1ec569b22aebf9e3$export$e99cbb807a5bb10d,
                name: 'H'
            },
            {
                base: $1ec569b22aebf9e3$export$7a9a31a911eb9a20,
                name: 'D'
            },
            {
                base: $1ec569b22aebf9e3$export$fca4f8121099df57,
                name: 'W'
            },
            {
                base: $1ec569b22aebf9e3$export$951c8378cdfec6e6,
                name: 'M'
            },
            {
                base: $1ec569b22aebf9e3$export$6ce2f08d515512,
                name: 'Y'
            }
        ];
    }
}
function $1ec569b22aebf9e3$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $1ec569b22aebf9e3$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $1ec569b22aebf9e3$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + '';
    return (template)=>(value.length < template.length ? value.padStart(template.length, '0') : value).slice(-Math.max(template.length, 2));
}
function $1ec569b22aebf9e3$export$3ae94a2503e890a1(time = new Date(), template = 'YYYY-MM-DD HH:mm:ss') {
    const date = new Date(time);
    const localDate = new Date(+date - date.getTimezoneOffset() * $1ec569b22aebf9e3$export$cbd942915f33be50);
    const [year, month, day, hour, minute, second, millisecond] = localDate.toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $1ec569b22aebf9e3$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $1ec569b22aebf9e3$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $1ec569b22aebf9e3$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $1ec569b22aebf9e3$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $1ec569b22aebf9e3$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $1ec569b22aebf9e3$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $1ec569b22aebf9e3$export$7e1c707225b48c34(date, delta) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + delta);
    return date;
}
function $1ec569b22aebf9e3$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date = $1ec569b22aebf9e3$export$7e1c707225b48c34(date, Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
const $1ec569b22aebf9e3$export$9e85258502147ffb = (date, unit, delta)=>unit === $1ec569b22aebf9e3$export$6ce2f08d515512 ? $1ec569b22aebf9e3$export$7e1c707225b48c34(date, delta) : unit === $1ec569b22aebf9e3$export$951c8378cdfec6e6 ? $1ec569b22aebf9e3$export$62ad822b3a5fd9a0(date, delta) : new Date(+new Date(date) + delta * unit);
const $1ec569b22aebf9e3$var$$f872d8bba1c0f79f$var$DateLength2Unit = {
    4: $1ec569b22aebf9e3$export$6ce2f08d515512,
    7: $1ec569b22aebf9e3$export$951c8378cdfec6e6,
    10: $1ec569b22aebf9e3$export$7a9a31a911eb9a20,
    13: $1ec569b22aebf9e3$export$e99cbb807a5bb10d,
    16: $1ec569b22aebf9e3$export$cbd942915f33be50,
    19: $1ec569b22aebf9e3$export$c489aa6f7fd82b1a
};
function $1ec569b22aebf9e3$export$3c1f2e5bc03748e2(value) {
    const defaultValue = `2025-01-01T00:00:00.000Z`;
    const startedAt = new Date(value + defaultValue.slice(value.length));
    const endedAt = $1ec569b22aebf9e3$export$9e85258502147ffb(startedAt, $1ec569b22aebf9e3$var$$f872d8bba1c0f79f$var$DateLength2Unit[value.length], 1);
    return [
        startedAt,
        endedAt
    ];
}
var $1ec569b22aebf9e3$var$$ba0e5dc395660a7c$exports = {};
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $1ec569b22aebf9e3$export$27924e57e9afff7f;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $1ec569b22aebf9e3$export$7ea17d45ecdcf634;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$ba0e5dc395660a7c$exports, "stringifyTextTable", function() {
    return $1ec569b22aebf9e3$export$bf304e455230454a;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $1ec569b22aebf9e3$export$bb8626e4916f587b;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$ba0e5dc395660a7c$exports, "parseTextTableAsync", function() {
    return $1ec569b22aebf9e3$export$88182f6768071c72;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$ba0e5dc395660a7c$exports, "readTextTable", function() {
    return $1ec569b22aebf9e3$export$2427785258f88523;
});
function $1ec569b22aebf9e3$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === 'string' && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== 'string' || $1ec569b22aebf9e3$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $1ec569b22aebf9e3$export$7ea17d45ecdcf634(raw) {
    const parsed = $1ec569b22aebf9e3$export$27924e57e9afff7f(raw);
    if (typeof parsed !== 'string') return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + '' !== parsed ? parsed : number;
}
const $1ec569b22aebf9e3$export$bf304e455230454a = (data, separator = ',')=>[
        Object.keys(data[0]).join(separator),
        ...data.map((item)=>Object.values(item).map((value)=>JSON.stringify(value)).join(separator))
    ].join('\n');
function $1ec569b22aebf9e3$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $1ec569b22aebf9e3$var$$ba0e5dc395660a7c$var$parseRow(row, separator = ',') {
    const list = [];
    do {
        let value;
        if (row[0] === '"' || row[0] === "'") {
            value = $1ec569b22aebf9e3$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
            row = row.slice(value.length + 3);
        } else {
            const index = row.indexOf(separator);
            if (index > -1) {
                value = row.slice(0, index);
                row = row.slice(index + 1);
            } else {
                value = row;
                row = '';
            }
        }
        list.push($1ec569b22aebf9e3$export$7ea17d45ecdcf634(value.trim()));
    }while (row);
    return list;
}
function $1ec569b22aebf9e3$export$bb8626e4916f587b(raw, header, separator = ',') {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>$1ec569b22aebf9e3$var$$ba0e5dc395660a7c$var$parseRow(row, separator));
    return !header ? data : data.slice(1).map((row)=>$1ec569b22aebf9e3$export$1c8ba402144543e5(row, data[0]));
}
const $1ec569b22aebf9e3$export$88182f6768071c72 = async (raw)=>Array.fromAsync($1ec569b22aebf9e3$export$2427785258f88523(raw[Symbol.iterator]()));
async function* $1ec569b22aebf9e3$var$$ba0e5dc395660a7c$var$characterStream(chunks) {
    for await (const chunk of chunks)yield* chunk;
}
async function* $1ec569b22aebf9e3$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator = ',') {
    let inQuote = false;
    let quoteChar = '';
    let prevChar = '';
    let cellBuffer = '';
    let currentRow = [];
    const completeCell = ()=>{
        currentRow.push($1ec569b22aebf9e3$export$7ea17d45ecdcf634(cellBuffer.trim()));
        cellBuffer = '';
    };
    for await (const char of chars){
        if (char === '\n' || char === '\r') {
            if (char === '\n' && prevChar === '\r') {
                prevChar = char;
                continue;
            }
            completeCell();
            if (currentRow.length > 1 || currentRow[0]) yield currentRow;
            currentRow = [];
        } else if ((char === '"' || char === "'") && !inQuote && cellBuffer.trim() === '') {
            inQuote = true;
            quoteChar = char;
        } else if (char === quoteChar && inQuote) {
            inQuote = false;
            quoteChar = '';
        } else if (inQuote) cellBuffer += char;
        else if (char === separator) completeCell();
        else cellBuffer += char;
        prevChar = char;
    }
    if (cellBuffer || currentRow.length > 0) {
        completeCell();
        if (currentRow.length > 1 || currentRow[0]) yield currentRow;
    }
}
async function* $1ec569b22aebf9e3$export$2427785258f88523(chunks, header, separator = ',') {
    let headerRow;
    let isFirstRow = true;
    const chars = $1ec569b22aebf9e3$var$$ba0e5dc395660a7c$var$characterStream(chunks);
    for await (const row of $1ec569b22aebf9e3$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator))if (header && isFirstRow) {
        headerRow = row;
        isFirstRow = false;
    } else yield header && headerRow ? $1ec569b22aebf9e3$export$1c8ba402144543e5(row, headerRow) : row;
}
var $1ec569b22aebf9e3$var$$083124ac4b1a50a0$exports = {};
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $1ec569b22aebf9e3$export$71e6483fc2b024eb;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $1ec569b22aebf9e3$export$eb9b2aadbe449a20;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $1ec569b22aebf9e3$export$13397a83aa5915d6;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $1ec569b22aebf9e3$export$fd89523fba250fa4;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $1ec569b22aebf9e3$export$504fbde693c1771c;
});
const $1ec569b22aebf9e3$export$71e6483fc2b024eb = (URI)=>new URL(URI, document.baseURI).origin !== location.origin;
function $1ec569b22aebf9e3$export$eb9b2aadbe449a20(raw = globalThis.location?.search || '', toBuiltIn = true) {
    const rawData = raw.split('#').map((URI)=>{
        const [before, after] = URI.split('?');
        return new URLSearchParams(after || (before.includes('=') ? before : ''));
    }).join('&');
    const data = new URLSearchParams(rawData);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($1ec569b22aebf9e3$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $1ec569b22aebf9e3$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === 'string' ? value : $1ec569b22aebf9e3$export$b5a4d6f439a5044d(value) ? $1ec569b22aebf9e3$export$7b85fd78dd236198(value) + '' : JSON.stringify(value);
function $1ec569b22aebf9e3$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$1ec569b22aebf9e3$export$dd1bc94b04021eeb(value) && [
            key,
            $1ec569b22aebf9e3$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
const $1ec569b22aebf9e3$export$fd89523fba250fa4 = async (URI)=>(await fetch(URI + '')).blob();
const $1ec569b22aebf9e3$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $1ec569b22aebf9e3$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $1ec569b22aebf9e3$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    return new Blob([
        base64 ? Uint8Array.fromBase64(data) : data
    ], {
        type: type
    });
}
var $1ec569b22aebf9e3$var$$d677628cc2ac1e37$exports = {};
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$d677628cc2ac1e37$exports, "parseCookie", function() {
    return $1ec569b22aebf9e3$export$d0eaf3e94be578f6;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$d677628cc2ac1e37$exports, "setCookie", function() {
    return $1ec569b22aebf9e3$export$110700823644f4a6;
});
const $1ec569b22aebf9e3$export$d0eaf3e94be578f6 = (value = globalThis.document?.cookie)=>value ? Object.fromEntries(value.split(/;\s*/).map((item)=>item.split('='))) : {};
function $1ec569b22aebf9e3$export$110700823644f4a6(key, value, attributes = {}) {
    const data = `${key}=${value}`, option = Object.entries(attributes).map(([key, value])=>typeof value === 'boolean' ? value ? key : '' : `${key}=${value}`).filter(Boolean).join('; ');
    document.cookie = `${data}; expires=${new Date(0)}`;
    return document.cookie = `${data}; ${option}`;
}
var $1ec569b22aebf9e3$var$$50872bf213056663$exports = {};
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $1ec569b22aebf9e3$export$1b9ac4d3de3ffd2e;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$50872bf213056663$exports, "makeSHA", function() {
    return $1ec569b22aebf9e3$export$d51f3b55e8d1aa73;
});
const $1ec569b22aebf9e3$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $1ec569b22aebf9e3$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $1ec569b22aebf9e3$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return '0x' + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === 'object') {
    if ('msCrypto' in globalThis) {
        // @ts-expect-error — msCrypto is a non-standard API
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    // @ts-expect-error — webkitSubtle is a non-standard API
    if (!crypto1?.subtle && crypto1?.['webkitSubtle']) crypto1.subtle = crypto1['webkitSubtle'];
}
async function $1ec569b22aebf9e3$export$d51f3b55e8d1aa73(raw, algorithm = 'SHA-1') {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return new Uint8Array(buffer).toHex();
}
var $1ec569b22aebf9e3$var$$93a3089d2937b23f$exports = {};
var $1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports = {};
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "XMLNamespace", function() {
    return $1ec569b22aebf9e3$export$f5a4056b78c72efa;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $1ec569b22aebf9e3$export$2ee022bbbc550b25;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $1ec569b22aebf9e3$export$a549dd5cef7f8327;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $1ec569b22aebf9e3$export$8eece510bcb9c62c;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $1ec569b22aebf9e3$export$b8a1af58c024fefd;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $1ec569b22aebf9e3$export$a2cf0d4bb6e06de4;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $1ec569b22aebf9e3$export$d66b332881d9723f;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $1ec569b22aebf9e3$export$b0709844452f8b6b;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $1ec569b22aebf9e3$export$5118471ee5d5453b;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "inViewport", function() {
    return $1ec569b22aebf9e3$export$6e196edbcc00e5bc;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $1ec569b22aebf9e3$export$be4650432daa84fd;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $1ec569b22aebf9e3$export$578e38b4a3e0b255;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $1ec569b22aebf9e3$export$7cd14c57bbb84350;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $1ec569b22aebf9e3$export$5100419dfae0456d;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $1ec569b22aebf9e3$export$28d9d24a8cd0ffc2;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $1ec569b22aebf9e3$export$3f99968195accfaf;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $1ec569b22aebf9e3$export$eafdbaa868ea9975;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $1ec569b22aebf9e3$export$36a0c1ca2ae264fa;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $1ec569b22aebf9e3$export$86d7c59254d6a2c9;
});
const $1ec569b22aebf9e3$export$f5a4056b78c72efa = {
    html: 'http://www.w3.org/1999/xhtml',
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
const $1ec569b22aebf9e3$var$$3e0a089cc13f69ad$var$templateMap = {};
function $1ec569b22aebf9e3$export$2ee022bbbc550b25(tagName) {
    if ($1ec569b22aebf9e3$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $1ec569b22aebf9e3$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement('template');
    spawn.innerHTML = `<${tagName} />`;
    return $1ec569b22aebf9e3$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $1ec569b22aebf9e3$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes('-')) return 'html';
    const [prefix, localName] = tagName.split(':');
    if (localName) return prefix === 'html' ? 'html' : 'xml';
    const node = $1ec569b22aebf9e3$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? 'html' : 'xml';
}
const $1ec569b22aebf9e3$export$8eece510bcb9c62c = (Class)=>$1ec569b22aebf9e3$export$170f4e08cad8229d(Class, HTMLElement);
const $1ec569b22aebf9e3$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $1ec569b22aebf9e3$export$b8a1af58c024fefd(Class) {
    const name = $1ec569b22aebf9e3$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $1ec569b22aebf9e3$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $1ec569b22aebf9e3$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                'sizes'
            ]
        ],
        [
            HTMLIFrameElement,
            [
                'sandbox'
            ]
        ],
        [
            HTMLObjectElement,
            [
                'form'
            ]
        ],
        [
            HTMLInputElement,
            [
                'form',
                'list'
            ]
        ],
        [
            HTMLButtonElement,
            [
                'form'
            ]
        ],
        [
            HTMLSelectElement,
            [
                'form'
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                'form'
            ]
        ],
        [
            HTMLOutputElement,
            [
                'form'
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                'form'
            ]
        ]
    ];
    const template = $1ec569b22aebf9e3$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $1ec569b22aebf9e3$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement('template');
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
const $1ec569b22aebf9e3$export$b0709844452f8b6b = (node)=>new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');
function* $1ec569b22aebf9e3$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($1ec569b22aebf9e3$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $1ec569b22aebf9e3$export$5118471ee5d5453b(node, type);
}
function $1ec569b22aebf9e3$export$6e196edbcc00e5bc(element) {
    const { left: left, top: top } = element.getBoundingClientRect();
    return document.elementFromPoint(left, top) === element;
}
function $1ec569b22aebf9e3$export$be4650432daa84fd(root) {
    var text = '';
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $1ec569b22aebf9e3$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement?.getAttribute('aria-hidden') !== 'true') {
        const { width: width, height: height } = parentElement?.getBoundingClientRect() ?? {};
        if (width && height) text += nodeValue?.trim().replace(/\s+/g, ' ');
    }
    return text;
}
function $1ec569b22aebf9e3$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $1ec569b22aebf9e3$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement('link');
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? 'alternate ' : '') + 'stylesheet';
        link.href = URI;
        document.head.append(link);
    });
}
function $1ec569b22aebf9e3$export$5100419dfae0456d(data, depth = 0, indent = '    ') {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== 'object' ? `${padding}${$1ec569b22aebf9e3$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$1ec569b22aebf9e3$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join('\n');
}
function $1ec569b22aebf9e3$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $1ec569b22aebf9e3$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        'meta',
        'title',
        'link',
        'script'
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $1ec569b22aebf9e3$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === 'top') window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: 'smooth',
        block: align,
        inline: justify
    });
}
const $1ec569b22aebf9e3$export$eafdbaa868ea9975 = (box, handler, depth = 6)=>Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ''), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, '-');
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
function $1ec569b22aebf9e3$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === 'visible' ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener('visibilitychange', ()=>change(document.visibilityState === 'visible' ? last | 1 : last & 2));
}
function $1ec569b22aebf9e3$export$86d7c59254d6a2c9(form) {
    const { elements: elements } = form, data = {};
    for (const field of elements){
        let { name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        const type = field.type;
        if (!name || value === '') continue;
        const box = type !== 'fieldset' && field.closest('fieldset');
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case 'radio':
            case 'checkbox':
                if (checked) parsedValue = !defaultValue || $1ec569b22aebf9e3$export$7ea17d45ecdcf634(defaultValue);
                else if ($1ec569b22aebf9e3$export$b5a4d6f439a5044d(elements.namedItem(name))) continue;
                else parsedValue = false;
                break;
            case 'select-multiple':
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$1ec569b22aebf9e3$export$7ea17d45ecdcf634(value));
                break;
            case 'fieldset':
                parsedValue = $1ec569b22aebf9e3$export$86d7c59254d6a2c9(field);
                break;
            case 'file':
                parsedValue = files && Array.from(files);
                break;
            case 'date':
            case 'datetime-local':
            case 'month':
            case 'hidden':
            case 'number':
            case 'range':
            case 'select-one':
                parsedValue = $1ec569b22aebf9e3$export$7ea17d45ecdcf634(value);
        }
        const record = data;
        if (name in data) record[name] = [].concat(record[name], parsedValue);
        else record[name] = !(parsedValue instanceof Array) || !$1ec569b22aebf9e3$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $1ec569b22aebf9e3$var$$bb23e0c794fefbef$exports = {};
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $1ec569b22aebf9e3$export$e772c8ff12451969;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $1ec569b22aebf9e3$export$57207d71b8c929c8;
});
function $1ec569b22aebf9e3$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $1ec569b22aebf9e3$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $1ec569b22aebf9e3$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $1ec569b22aebf9e3$var$$19ed8aeb7905a045$exports = {};
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $1ec569b22aebf9e3$export$10b1921597150314;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $1ec569b22aebf9e3$export$3e2b244719956741;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $1ec569b22aebf9e3$export$1d1d2ed6b55cf67f;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $1ec569b22aebf9e3$export$2155c0b5a4b77fb8;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $1ec569b22aebf9e3$export$9d97473344489dfc;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $1ec569b22aebf9e3$export$d635d04af3887bbe;
});
function $1ec569b22aebf9e3$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $1ec569b22aebf9e3$export$3e2b244719956741 = typeof window !== 'undefined' ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener('DOMContentLoaded', done);
        window.removeEventListener('load', done);
        resolve();
    }
    document?.addEventListener('DOMContentLoaded', done);
    window.addEventListener('load', done);
    setTimeout(function check() {
        document?.readyState === 'complete' ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $1ec569b22aebf9e3$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + 'end', end);
            element.removeEventListener(scope + 'cancel', cancel);
        }
        element.addEventListener(scope + 'end', end);
        element.addEventListener(scope + 'cancel', cancel);
    });
}
function $1ec569b22aebf9e3$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener('message', server);
    return ()=>globalThis.removeEventListener('message', server);
}
function $1ec569b22aebf9e3$export$9d97473344489dfc(target, origin = '*') {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $1ec569b22aebf9e3$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener('message', handler);
            }
            globalThis.addEventListener('message', handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $1ec569b22aebf9e3$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener('statechange', function() {
                if (this.state === 'installed' && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $1ec569b22aebf9e3$var$$7a08303ce13c49c5$exports = {};
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $1ec569b22aebf9e3$export$1b88f6b6d432a52a;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $1ec569b22aebf9e3$export$b70f6380221b1350;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $1ec569b22aebf9e3$export$75d6cbe4503e149;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $1ec569b22aebf9e3$export$b2618d51188815c2;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $1ec569b22aebf9e3$export$490814474ddbb428;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $1ec569b22aebf9e3$export$3ea201dffb50dfef;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $1ec569b22aebf9e3$export$d1012c7198c6b460;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $1ec569b22aebf9e3$export$a35a418b7b17958e;
});
class $1ec569b22aebf9e3$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - (from.z ?? 0), 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = (to.z ?? 0) - (from.z ?? 0);
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? 'right' : 'left';
            case YL:
                return YD > 0 ? 'forward' : 'backward';
            case ZL:
                return ZD > 0 ? 'up' : 'down';
        }
    }
}
function $1ec569b22aebf9e3$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $1ec569b22aebf9e3$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $1ec569b22aebf9e3$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === 'animation' ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === 'ms' ? 1 : 1000);
}
function $1ec569b22aebf9e3$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $1ec569b22aebf9e3$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $1ec569b22aebf9e3$export$75d6cbe4503e149(type, element)))
    ]);
}
function $1ec569b22aebf9e3$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $1ec569b22aebf9e3$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $1ec569b22aebf9e3$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $1ec569b22aebf9e3$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = 'none';
}
function $1ec569b22aebf9e3$export$490814474ddbb428(element, className, display = 'block') {
    return $1ec569b22aebf9e3$var$$7a08303ce13c49c5$var$fadeIn('transition', element, className, display);
}
function $1ec569b22aebf9e3$export$3ea201dffb50dfef(element, className, display = 'block') {
    return $1ec569b22aebf9e3$var$$7a08303ce13c49c5$var$fadeIn('animation', element, className, display);
}
function $1ec569b22aebf9e3$export$d1012c7198c6b460(element, className, remove) {
    return $1ec569b22aebf9e3$var$$7a08303ce13c49c5$var$fadeOut('transition', element, className, remove);
}
function $1ec569b22aebf9e3$export$a35a418b7b17958e(element, className, remove) {
    return $1ec569b22aebf9e3$var$$7a08303ce13c49c5$var$fadeOut('animation', element, className, remove);
}
var $1ec569b22aebf9e3$var$$69bd9f0117925302$exports = {};
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$69bd9f0117925302$exports, "describe", function() {
    return $1ec569b22aebf9e3$export$cd5450f3a47e3789;
});
$1ec569b22aebf9e3$var$$parcel$export($1ec569b22aebf9e3$var$$69bd9f0117925302$exports, "it", function() {
    return $1ec569b22aebf9e3$export$3486a10f30cf1ee4;
});
async function $1ec569b22aebf9e3$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $1ec569b22aebf9e3$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = '    ' + title;
    console.time(title);
    const expect = (status)=>{
        const assert = typeof status === 'function' ? status : undefined;
        status = assert?.() ?? status;
        if (!status) throw new Error(`Assertion failed: ${title}\n\n${assert || ''}`);
    };
    const timeOut = ()=>$1ec569b22aebf9e3$export$e772c8ff12451969(secondsOut).then(()=>Promise.reject(new RangeError('Timed out')));
    try {
        return await Promise.race([
            userCase(expect),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}


function $4d5bac995c3494f7$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $4d5bac995c3494f7$var$$c8e09632ab7a900a$exports = {};
$4d5bac995c3494f7$var$$parcel$export($4d5bac995c3494f7$var$$c8e09632ab7a900a$exports, "isEqualProps", function() {
    return $4d5bac995c3494f7$export$7112c88e033533b8;
});
$4d5bac995c3494f7$var$$parcel$export($4d5bac995c3494f7$var$$c8e09632ab7a900a$exports, "reaction", function() {
    return $4d5bac995c3494f7$export$7203b476385689ae;
});
$4d5bac995c3494f7$var$$parcel$export($4d5bac995c3494f7$var$$c8e09632ab7a900a$exports, "ObservedComponent", function() {
    return $4d5bac995c3494f7$export$bf180ef329d1efd8;
});
var $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
const $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$ref = (0, $fecbc4a33bb0f224$export$431518ad42ffb7bd) || Reflect.get((0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a), 'ref', (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a));
const $4d5bac995c3494f7$export$7112c88e033533b8 = (a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($dYe7D)))(a, b, (a, b, key)=>[
            '_owner',
            '$$typeof'
        ].includes(key) || undefined);
const $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$reactionMap = new WeakMap();
const $4d5bac995c3494f7$export$7203b476385689ae = (expression)=>(effect, { addInitializer: addInitializer })=>addInitializer(function() {
            const reactions = $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$reactionMap.get(this) || [];
            reactions.push({
                expression: expression,
                effect: effect
            });
            $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$reactionMap.set(this, reactions);
        });
/**
 * @see {@link https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations}
 * @see {@link https://github.com/idea2app/MobX-React-helper?tab=readme-ov-file#observable-props-state--context}
 */ let $4d5bac995c3494f7$export$bf180ef329d1efd8 = (()=>{
    var _a, _ObservedComponent_disposers, _ObservedComponent_observedProps_accessor_storage, _ObservedComponent_observedState_accessor_storage, _ObservedComponent_observedContext_accessor_storage;
    let _classSuper = (0, $7DB8U.Component);
    let _observedProps_decorators;
    let _observedProps_initializers = [];
    let _observedProps_extraInitializers = [];
    let _observedState_decorators;
    let _observedState_initializers = [];
    let _observedState_extraInitializers = [];
    let _observedContext_decorators;
    let _observedContext_initializers = [];
    let _observedContext_extraInitializers = [];
    return _a = class ObservedComponent extends _classSuper {
        constructor(){
            super(...arguments);
            _ObservedComponent_observedProps_accessor_storage.set(this, $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__runInitializers(this, _observedProps_initializers, this.props));
            _ObservedComponent_observedState_accessor_storage.set(this, ($4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__runInitializers(this, _observedProps_extraInitializers), $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__runInitializers(this, _observedState_initializers, this.state)));
            _ObservedComponent_observedContext_accessor_storage.set(this, ($4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__runInitializers(this, _observedState_extraInitializers), $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__runInitializers(this, _observedContext_initializers, this.context)));
            _ObservedComponent_disposers.set(this, $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__runInitializers(this, _observedContext_extraInitializers));
        }
        get observedProps() {
            return $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__classPrivateFieldGet(this, _ObservedComponent_observedProps_accessor_storage, "f");
        }
        set observedProps(value) {
            $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__classPrivateFieldSet(this, _ObservedComponent_observedProps_accessor_storage, value, "f");
        }
        get observedState() {
            return $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__classPrivateFieldGet(this, _ObservedComponent_observedState_accessor_storage, "f");
        }
        set observedState(value) {
            $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__classPrivateFieldSet(this, _ObservedComponent_observedState_accessor_storage, value, "f");
        }
        get observedContext() {
            return $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__classPrivateFieldGet(this, _ObservedComponent_observedContext_accessor_storage, "f");
        }
        set observedContext(value) {
            $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__classPrivateFieldSet(this, _ObservedComponent_observedContext_accessor_storage, value, "f");
        }
        componentDidMount() {
            var _b;
            $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__classPrivateFieldSet(this, _ObservedComponent_disposers, (_b = $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$reactionMap.get(this)) === null || _b === void 0 ? void 0 : _b.map(({ expression: expression, effect: effect })=>(0, $fecbc4a33bb0f224$export$7203b476385689ae)((reaction)=>expression(this, reaction), effect.bind(this))), "f");
        }
        componentWillUnmount() {
            var _b;
            (_b = $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__classPrivateFieldGet(this, _ObservedComponent_disposers, "f")) === null || _b === void 0 || _b.forEach((disposer)=>disposer());
        }
        componentDidUpdate(prevProps, prevState, snapshot) {
            var _b;
            if (!$4d5bac995c3494f7$export$7112c88e033533b8(prevProps, this.props)) this.observedProps = Object.assign({}, this.props);
            if (!$4d5bac995c3494f7$export$7112c88e033533b8(prevState, this.state)) this.observedState = Object.assign({}, this.state);
            if (this.observedContext !== this.context) this.observedContext = this.context;
            (_b = super.componentDidUpdate) === null || _b === void 0 || _b.call(this, prevProps, prevState, snapshot);
        }
    }, _ObservedComponent_disposers = new WeakMap(), _ObservedComponent_observedProps_accessor_storage = new WeakMap(), _ObservedComponent_observedState_accessor_storage = new WeakMap(), _ObservedComponent_observedContext_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _observedProps_decorators = [
            $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$ref
        ];
        _observedState_decorators = [
            $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$ref
        ];
        _observedContext_decorators = [
            $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$ref
        ];
        $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__esDecorate(_a, null, _observedProps_decorators, {
            kind: "accessor",
            name: "observedProps",
            static: false,
            private: false,
            access: {
                has: (obj)=>"observedProps" in obj,
                get: (obj)=>obj.observedProps,
                set: (obj, value)=>{
                    obj.observedProps = value;
                }
            },
            metadata: _metadata
        }, _observedProps_initializers, _observedProps_extraInitializers);
        $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__esDecorate(_a, null, _observedState_decorators, {
            kind: "accessor",
            name: "observedState",
            static: false,
            private: false,
            access: {
                has: (obj)=>"observedState" in obj,
                get: (obj)=>obj.observedState,
                set: (obj, value)=>{
                    obj.observedState = value;
                }
            },
            metadata: _metadata
        }, _observedState_initializers, _observedState_extraInitializers);
        $4d5bac995c3494f7$var$$c8e09632ab7a900a$var$__esDecorate(_a, null, _observedContext_decorators, {
            kind: "accessor",
            name: "observedContext",
            static: false,
            private: false,
            access: {
                has: (obj)=>"observedContext" in obj,
                get: (obj)=>obj.observedContext,
                set: (obj, value)=>{
                    obj.observedContext = value;
                }
            },
            metadata: _metadata
        }, _observedContext_initializers, _observedContext_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $4d5bac995c3494f7$var$$329ff9b0b89f7d62$exports = {};
$4d5bac995c3494f7$var$$parcel$export($4d5bac995c3494f7$var$$329ff9b0b89f7d62$exports, "FormComponent", function() {
    return $4d5bac995c3494f7$export$cec7cafc710f5d68;
});
var $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
/**
 * @see {@link https://github.com/idea2app/MobX-React-helper?tab=readme-ov-file#abstract-form-component}
 */ let $4d5bac995c3494f7$export$cec7cafc710f5d68 = (()=>{
    var _a, _FormComponent_defaultValueDisposer, _FormComponent_changeEventDisposer, _FormComponent_useDefault, _FormComponent_innerValue_accessor_storage;
    let _classSuper = $4d5bac995c3494f7$export$bf180ef329d1efd8;
    let _instanceExtraInitializers = [];
    let _innerValue_decorators;
    let _innerValue_initializers = [];
    let _innerValue_extraInitializers = [];
    let _get_value_decorators;
    return _a = class FormComponent extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "ref", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__runInitializers(this, _instanceExtraInitializers), (0, $7DB8U.createRef)())
            });
            _FormComponent_innerValue_accessor_storage.set(this, $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__runInitializers(this, _innerValue_initializers, this.props.defaultValue));
            _FormComponent_defaultValueDisposer.set(this, $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__runInitializers(this, _innerValue_extraInitializers));
            _FormComponent_changeEventDisposer.set(this, void 0);
            _FormComponent_useDefault.set(this, (value)=>{
                if (!(0, $1ec569b22aebf9e3$export$dd1bc94b04021eeb)(value) && (0, $1ec569b22aebf9e3$export$dd1bc94b04021eeb)(this.innerValue)) this.innerValue = value;
            });
            Object.defineProperty(this, "emitValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (value)=>{
                    var _b, _c;
                    return (_c = (_b = this.observedProps).onChange) === null || _c === void 0 ? void 0 : _c.call(_b, value && typeof value === 'object' ? (0, $fecbc4a33bb0f224$export$f08965dd1304d490)(value) : value);
                }
            });
            Object.defineProperty(this, "reset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>this.innerValue = this.props.defaultValue
            });
        }
        get innerValue() {
            return $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__classPrivateFieldGet(this, _FormComponent_innerValue_accessor_storage, "f");
        }
        set innerValue(value) {
            $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__classPrivateFieldSet(this, _FormComponent_innerValue_accessor_storage, value, "f");
        }
        get value() {
            var _b;
            return (_b = this.observedProps.value) !== null && _b !== void 0 ? _b : this.innerValue;
        }
        componentDidMount() {
            var _b, _c;
            $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__classPrivateFieldSet(this, _FormComponent_defaultValueDisposer, (0, $fecbc4a33bb0f224$export$7203b476385689ae)(()=>this.observedProps.defaultValue, $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__classPrivateFieldGet(this, _FormComponent_useDefault, "f")), "f");
            $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__classPrivateFieldSet(this, _FormComponent_changeEventDisposer, (0, $fecbc4a33bb0f224$export$7203b476385689ae)(()=>this.innerValue, this.emitValue), "f");
            (_c = (_b = this.ref.current) === null || _b === void 0 ? void 0 : _b.form) === null || _c === void 0 || _c.addEventListener('reset', this.reset);
        }
        componentWillUnmount() {
            var _b, _c, _d, _e;
            (_b = $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__classPrivateFieldGet(this, _FormComponent_defaultValueDisposer, "f")) === null || _b === void 0 || _b.call(this);
            $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__classPrivateFieldSet(this, _FormComponent_defaultValueDisposer, undefined, "f");
            (_c = $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__classPrivateFieldGet(this, _FormComponent_changeEventDisposer, "f")) === null || _c === void 0 || _c.call(this);
            $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__classPrivateFieldSet(this, _FormComponent_changeEventDisposer, undefined, "f");
            (_e = (_d = this.ref.current) === null || _d === void 0 ? void 0 : _d.form) === null || _e === void 0 || _e.removeEventListener('reset', this.reset);
        }
    }, _FormComponent_defaultValueDisposer = new WeakMap(), _FormComponent_changeEventDisposer = new WeakMap(), _FormComponent_useDefault = new WeakMap(), _FormComponent_innerValue_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _innerValue_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        _get_value_decorators = [
            (0, $fecbc4a33bb0f224$export$2983e091f1a1e8e2)
        ];
        $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__esDecorate(_a, null, _innerValue_decorators, {
            kind: "accessor",
            name: "innerValue",
            static: false,
            private: false,
            access: {
                has: (obj)=>"innerValue" in obj,
                get: (obj)=>obj.innerValue,
                set: (obj, value)=>{
                    obj.innerValue = value;
                }
            },
            metadata: _metadata
        }, _innerValue_initializers, _innerValue_extraInitializers);
        $4d5bac995c3494f7$var$$329ff9b0b89f7d62$var$__esDecorate(_a, null, _get_value_decorators, {
            kind: "getter",
            name: "value",
            static: false,
            private: false,
            access: {
                has: (obj)=>"value" in obj,
                get: (obj)=>obj.value
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();



var $6dcd5678f67c6b02$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $6dcd5678f67c6b02$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $6dcd5678f67c6b02$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $6dcd5678f67c6b02$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6dcd5678f67c6b02$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6dcd5678f67c6b02$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * Migrate from https://bootstrap.web-cell.dev/#Calendar/CountDown
 */ let $6dcd5678f67c6b02$export$53819c0e58f98d49 = (()=>{
    var _Countdown_rest_accessor_storage;
    let _classDecorators = [
        (0, $2c52cd3eacadeaca$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $4d5bac995c3494f7$export$bf180ef329d1efd8);
    let _instanceExtraInitializers = [];
    let _rest_decorators;
    let _rest_initializers = [];
    let _rest_extraInitializers = [];
    let _get_timeSections_decorators;
    let _initTimer_decorators;
    var Countdown = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _Countdown_rest_accessor_storage.set(this, ($6dcd5678f67c6b02$var$__runInitializers(this, _instanceExtraInitializers), $6dcd5678f67c6b02$var$__runInitializers(this, _rest_initializers, 0)));
            Object.defineProperty(this, "timer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($6dcd5678f67c6b02$var$__runInitializers(this, _rest_extraInitializers), 0)
            });
            Object.defineProperty(this, "tick", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    const { onEnd: onEnd, endTime: endTime } = this.props, rest = this.endTimestamp - Date.now();
                    if (rest > 0) this.rest = rest;
                    else {
                        this.rest = 0;
                        this.stop();
                        onEnd === null || onEnd === void 0 || onEnd(endTime);
                    }
                }
            });
        }
        get rest() {
            return $6dcd5678f67c6b02$var$__classPrivateFieldGet(this, _Countdown_rest_accessor_storage, "f");
        }
        set rest(value) {
            $6dcd5678f67c6b02$var$__classPrivateFieldSet(this, _Countdown_rest_accessor_storage, value, "f");
        }
        get endTimestamp() {
            return +new Date(this.props.endTime || Date.now());
        }
        get timeSections() {
            const { units: units } = this.observedProps;
            let { rest: rest } = this;
            return units.reduce((list, { label: label }, index)=>{
                const scale = units.slice(index).map(({ scale: scale })=>scale).reduce((sum, scale)=>sum * scale, 1);
                const value = ~~(rest / scale);
                rest -= value * scale;
                list.push({
                    value: value,
                    label: label
                });
                return list;
            }, []);
        }
        stop() {
            if (this.timer) {
                window.clearInterval(this.timer);
                this.timer = 0;
            }
        }
        componentDidMount() {
            super.componentDidMount();
            this.initTimer();
        }
        initTimer() {
            this.stop();
            this.tick();
            this.timer = window.setInterval(this.tick, (0, $1ec569b22aebf9e3$export$c489aa6f7fd82b1a));
        }
        componentWillUnmount() {
            super.componentWillUnmount();
            this.stop();
        }
        render() {
            const _a = this.props, { className: className = '', itemClassName: itemClassName = 'border rounded px-4 py-3 d-flex flex-column justify-content-center align-items-center', units: _u, endTime: _e, onEnd: _o } = _a, props = $6dcd5678f67c6b02$var$__rest(_a, [
                "className",
                "itemClassName",
                "units",
                "endTime",
                "onEnd"
            ]);
            const { timeSections: timeSections } = this;
            return (0, $e830bf8f8acfe41d$exports.jsx)("ol", Object.assign({
                className: `list-unstyled m-0 ${className}`
            }, props, {
                children: timeSections.map(({ value: value, label: label })=>(0, $e830bf8f8acfe41d$exports.jsxs)("li", {
                        className: itemClassName,
                        children: [
                            (0, $e830bf8f8acfe41d$exports.jsx)("strong", {
                                children: (value + '').padStart(2, '0')
                            }),
                            (0, $e830bf8f8acfe41d$exports.jsx)("span", {
                                children: label
                            })
                        ]
                    }, label))
            }));
        }
    };
    _Countdown_rest_accessor_storage = new WeakMap();
    $6dcd5678f67c6b02$var$__setFunctionName(_classThis, "Countdown");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _rest_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        _get_timeSections_decorators = [
            (0, $fecbc4a33bb0f224$export$2983e091f1a1e8e2)
        ];
        _initTimer_decorators = [
            (0, $4d5bac995c3494f7$export$7203b476385689ae)((_this)=>_this.observedProps.endTime)
        ];
        $6dcd5678f67c6b02$var$__esDecorate(_classThis, null, _rest_decorators, {
            kind: "accessor",
            name: "rest",
            static: false,
            private: false,
            access: {
                has: (obj)=>"rest" in obj,
                get: (obj)=>obj.rest,
                set: (obj, value)=>{
                    obj.rest = value;
                }
            },
            metadata: _metadata
        }, _rest_initializers, _rest_extraInitializers);
        $6dcd5678f67c6b02$var$__esDecorate(_classThis, null, _get_timeSections_decorators, {
            kind: "getter",
            name: "timeSections",
            static: false,
            private: false,
            access: {
                has: (obj)=>"timeSections" in obj,
                get: (obj)=>obj.timeSections
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6dcd5678f67c6b02$var$__esDecorate(_classThis, null, _initTimer_decorators, {
            kind: "method",
            name: "initTimer",
            static: false,
            private: false,
            access: {
                has: (obj)=>"initTimer" in obj,
                get: (obj)=>obj.initTimer
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6dcd5678f67c6b02$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Countdown = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'Countdown'
    });
    (()=>{
        $6dcd5678f67c6b02$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Countdown = _classThis;
})();


var $5f36cffaa267c314$exports = {};

$parcel$export($5f36cffaa267c314$exports, "DialogClose", () => $5f36cffaa267c314$export$fba2fb7cd781b7ac);
$parcel$export($5f36cffaa267c314$exports, "Dialog", () => $5f36cffaa267c314$export$3ddf2d174ce01153);

function $7db8a787aa9e39e9$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $7db8a787aa9e39e9$var$$22de11b45b0eeb97$exports = {};
$7db8a787aa9e39e9$var$$parcel$export($7db8a787aa9e39e9$var$$22de11b45b0eeb97$exports, "Defer", function() {
    return $7db8a787aa9e39e9$export$c7e91f8aec23ae14;
});
$7db8a787aa9e39e9$var$$parcel$export($7db8a787aa9e39e9$var$$22de11b45b0eeb97$exports, "makeDefer", function() {
    return $7db8a787aa9e39e9$export$51ca94569b882c51;
});
class $7db8a787aa9e39e9$export$c7e91f8aec23ae14 {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
const $7db8a787aa9e39e9$export$51ca94569b882c51 = ()=>new $7db8a787aa9e39e9$export$c7e91f8aec23ae14();
var $7db8a787aa9e39e9$var$$e3640f413e0c36e7$exports = {};
$7db8a787aa9e39e9$var$$parcel$export($7db8a787aa9e39e9$var$$e3640f413e0c36e7$exports, "Observable", function() {
    return $7db8a787aa9e39e9$export$77cea355fa80b5f4;
});
if (!Symbol.observable) Reflect.set(Symbol, 'observable', Symbol('observable'));
class $7db8a787aa9e39e9$export$77cea355fa80b5f4 {
    constructor(subscriber){
        this.subscriber = subscriber;
    }
    [Symbol.observable]() {
        return this;
    }
    async *[Symbol.asyncIterator]() {
        var queue = [
            new $7db8a787aa9e39e9$export$c7e91f8aec23ae14()
        ], canceler, done = false;
        const observer = {
            next (value) {
                if (done) return;
                queue[queue.length - 1].resolve(value);
                queue.push(new $7db8a787aa9e39e9$export$c7e91f8aec23ae14());
            },
            error (reason) {
                if (!done) {
                    queue[queue.length - 1].reject(reason);
                    done = true;
                }
                if (canceler) canceler();
            },
            complete () {
                if (!done) {
                    queue[queue.length - 1].resolve();
                    done = true;
                }
                if (canceler) canceler();
            }
        };
        canceler = this.subscriber(observer);
        do {
            yield queue[0].promise;
            queue.shift();
        }while (queue[0]);
    }
    static fromStream(list) {
        return new this(({ next: next, complete: complete, error: error })=>{
            var stopped = false;
            (async ()=>{
                try {
                    for await (const item of list)if (!stopped) next(item);
                    else break;
                    if (!stopped) complete();
                } catch (bug) {
                    if (!stopped) error(bug instanceof Error || typeof bug === 'string' ? bug : new Error(bug + ''));
                }
            })();
            return ()=>stopped = true;
        });
    }
    static of(...items) {
        return this.fromStream(items);
    }
    async toPromise() {
        const stack = [];
        for await (const item of this){
            stack.push(item);
            if (stack.length > 2) stack.shift();
        }
        return stack[0];
    }
    subscribe(onNext, onError, onComplete) {
        var stop = false;
        (async ()=>{
            try {
                for await (const item of this)if (!stop) onNext(item);
                else break;
                if (onComplete instanceof Function) onComplete();
            } catch (error) {
                if (onError instanceof Function) onError(error instanceof Error || typeof error === 'string' ? error : new Error(error + ''));
            }
        })();
        return {
            unsubscribe: ()=>stop = true,
            get closed () {
                return stop;
            }
        };
    }
    static from(observable) {
        if (Symbol.iterator in observable) return this.of(...observable);
        if (Symbol.asyncIterator in observable) return this.fromStream(observable);
        return new this(({ next: next, error: error, complete: complete })=>observable.subscribe(next, error, complete).unsubscribe);
    }
    static fromEvent(target, name) {
        return new this(({ next: next, error: error })=>{
            if (typeof target.on === 'function') target.on(name, next).on('error', error);
            else {
                target.addEventListener(name, next);
                target.addEventListener('error', error);
            }
            return ()=>{
                if (typeof target.off === 'function') target.off(name, next).off('error', error);
                else {
                    target.removeEventListener(name, next);
                    target.removeEventListener('error', error);
                }
            };
        });
    }
}
var $7db8a787aa9e39e9$var$$603f33a01a36ab56$exports = {};
$7db8a787aa9e39e9$var$$parcel$export($7db8a787aa9e39e9$var$$603f33a01a36ab56$exports, "createQueue", function() {
    return $7db8a787aa9e39e9$export$d16acf4b6e75743d;
});
function $7db8a787aa9e39e9$export$d16acf4b6e75743d() {
    var feedNext, stop;
    const observable = new $7db8a787aa9e39e9$export$77cea355fa80b5f4(({ next: next, complete: complete })=>{
        feedNext = next, stop = complete;
    });
    return {
        process (data) {
            const defer = new $7db8a787aa9e39e9$export$c7e91f8aec23ae14();
            if (!feedNext) throw Error("Can't process data before Queue consuming");
            feedNext({
                defer: defer,
                data: data
            });
            return defer.promise;
        },
        destroy () {
            if (!stop) throw Error("Can't stop a Queue before Queue consuming");
            stop();
        },
        observable: observable
    };
}




var $5f36cffaa267c314$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5f36cffaa267c314$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5f36cffaa267c314$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5f36cffaa267c314$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
class $5f36cffaa267c314$export$fba2fb7cd781b7ac extends Error {
    constructor(message = 'Dialog closed'){
        super(message);
    }
}
let $5f36cffaa267c314$export$3ddf2d174ce01153 = (()=>{
    var _a, _Dialog_input_accessor_storage, _Dialog_defer_accessor_storage;
    let _input_decorators;
    let _input_initializers = [];
    let _input_extraInitializers = [];
    let _defer_decorators;
    let _defer_initializers = [];
    let _defer_extraInitializers = [];
    return _a = class Dialog {
        get input() {
            return $5f36cffaa267c314$var$__classPrivateFieldGet(this, _Dialog_input_accessor_storage, "f");
        }
        set input(value) {
            $5f36cffaa267c314$var$__classPrivateFieldSet(this, _Dialog_input_accessor_storage, value, "f");
        }
        get defer() {
            return $5f36cffaa267c314$var$__classPrivateFieldGet(this, _Dialog_defer_accessor_storage, "f");
        }
        set defer(value) {
            $5f36cffaa267c314$var$__classPrivateFieldSet(this, _Dialog_defer_accessor_storage, value, "f");
        }
        constructor(Factory){
            _Dialog_input_accessor_storage.set(this, $5f36cffaa267c314$var$__runInitializers(this, _input_initializers, {}));
            _Dialog_defer_accessor_storage.set(this, ($5f36cffaa267c314$var$__runInitializers(this, _input_extraInitializers), $5f36cffaa267c314$var$__runInitializers(this, _defer_initializers, void 0)));
            Object.defineProperty(this, "Component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $5f36cffaa267c314$var$__runInitializers(this, _defer_extraInitializers)
            });
            this.Component = (0, $2c52cd3eacadeaca$export$b6ae1bc530f4c149)((props)=>(0, $e830bf8f8acfe41d$exports.jsx)(Factory, Object.assign({}, props, this.input, {
                    defer: this.defer
                })));
            this.Component.displayName = 'DialogComponent';
        }
        open(input) {
            if (input) this.input = input;
            this.defer = new (0, $7db8a787aa9e39e9$export$c7e91f8aec23ae14)();
            this.defer.promise.finally(()=>this.defer = undefined);
            return this.defer.promise;
        }
    }, _Dialog_input_accessor_storage = new WeakMap(), _Dialog_defer_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _input_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        _defer_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        $5f36cffaa267c314$var$__esDecorate(_a, null, _input_decorators, {
            kind: "accessor",
            name: "input",
            static: false,
            private: false,
            access: {
                has: (obj)=>"input" in obj,
                get: (obj)=>obj.input,
                set: (obj, value)=>{
                    obj.input = value;
                }
            },
            metadata: _metadata
        }, _input_initializers, _input_extraInitializers);
        $5f36cffaa267c314$var$__esDecorate(_a, null, _defer_decorators, {
            kind: "accessor",
            name: "defer",
            static: false,
            private: false,
            access: {
                has: (obj)=>"defer" in obj,
                get: (obj)=>obj.defer,
                set: (obj, value)=>{
                    obj.defer = value;
                }
            },
            metadata: _metadata
        }, _defer_initializers, _defer_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();


var $bc1896828996898b$exports = {};

$parcel$export($bc1896828996898b$exports, "Editor", () => $bc1896828996898b$export$7cda8d932e2f33c0);




var $7DB8U = parcelRequire("7DB8U");


function $6f4c47be9f00b961$export$da8ca15f4115b46e() {
    if (typeof window !== 'undefined') {
        const Component = (parcelRequire("14lt5"));
        return Component.default || Component;
    } else {
        const Component = (parcelRequire("4Jk9A"));
        return Component.default || Component;
    }
}


var $bc1896828996898b$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $bc1896828996898b$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $bc1896828996898b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bc1896828996898b$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $bc1896828996898b$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $bc1896828996898b$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $bc1896828996898b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $bc1896828996898b$var$ReactEditorJS = (0, $6f4c47be9f00b961$export$da8ca15f4115b46e)();
let $bc1896828996898b$export$7cda8d932e2f33c0 = (()=>{
    var _Editor_innerValue_accessor_storage;
    let _classDecorators = [
        (0, $2c52cd3eacadeaca$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $7DB8U.Component);
    let _innerValue_decorators;
    let _innerValue_initializers = [];
    let _innerValue_extraInitializers = [];
    var Editor = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "core", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _Editor_innerValue_accessor_storage.set(this, $bc1896828996898b$var$__runInitializers(this, _innerValue_initializers, this.props.defaultValue));
            Object.defineProperty(this, "save", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($bc1896828996898b$var$__runInitializers(this, _innerValue_extraInitializers), ()=>$bc1896828996898b$var$__awaiter(this, void 0, void 0, function*() {
                        return this.core && (this.innerValue = yield this.core.save());
                    }))
            });
        }
        get innerValue() {
            return $bc1896828996898b$var$__classPrivateFieldGet(this, _Editor_innerValue_accessor_storage, "f");
        }
        set innerValue(value) {
            $bc1896828996898b$var$__classPrivateFieldSet(this, _Editor_innerValue_accessor_storage, value, "f");
        }
        render() {
            const _a = this.props, { name: name, required: required, children: children } = _a, editorProps = $bc1896828996898b$var$__rest(_a, [
                "name",
                "required",
                "children"
            ]), { innerValue: innerValue } = this;
            return (0, $e830bf8f8acfe41d$exports.jsxs)("div", {
                className: "form-control",
                tabIndex: -1,
                onBlur: this.save,
                children: [
                    (0, $e830bf8f8acfe41d$exports.jsx)("input", {
                        hidden: true,
                        name: name,
                        required: required,
                        value: JSON.stringify(innerValue)
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)($bc1896828996898b$var$ReactEditorJS, Object.assign({}, editorProps, {
                        onInitialize: (core)=>{
                            var _a;
                            this.core = core;
                            (_a = editorProps.onInitialize) === null || _a === void 0 || _a.call(editorProps, core);
                        }
                    }))
                ]
            });
        }
    };
    _Editor_innerValue_accessor_storage = new WeakMap();
    $bc1896828996898b$var$__setFunctionName(_classThis, "Editor");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _innerValue_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        $bc1896828996898b$var$__esDecorate(_classThis, null, _innerValue_decorators, {
            kind: "accessor",
            name: "innerValue",
            static: false,
            private: false,
            access: {
                has: (obj)=>"innerValue" in obj,
                get: (obj)=>obj.innerValue,
                set: (obj, value)=>{
                    obj.innerValue = value;
                }
            },
            metadata: _metadata
        }, _innerValue_initializers, _innerValue_extraInitializers);
        $bc1896828996898b$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Editor = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'Editor'
    });
    (()=>{
        $bc1896828996898b$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Editor = _classThis;
})();


var $f3dbfd93bcb031cd$exports = {};

$parcel$export($f3dbfd93bcb031cd$exports, "parser", () => $f3dbfd93bcb031cd$export$8f49e4af10703ce3);
$parcel$export($f3dbfd93bcb031cd$exports, "EditorHTML", () => $f3dbfd93bcb031cd$export$f9c5335a01b13a5a);

var $70d150f8dfa3d626$exports = {};
"use strict";
var $70d150f8dfa3d626$var$e = {
    code: ({ data: e })=>`<pre><code>${e.code}</code></pre>`,
    embed: ({ data: e })=>{
        const t = e.service;
        return "vimeo" === t ? `<iframe src="${e.embed}" height="${e.height}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>` : "youtube" === t ? `<iframe width="${e.width}" height="${e.height}" src="${e.embed}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>` : (console.error("[editorjs-html]: Only Youtube & Vimeo embeds are available by default. Write your own embed parser for other options."), "");
    },
    header: ({ data: e })=>`<h${e.level}>${e.text}</h${e.level}>`,
    image: ({ data: e })=>{
        const t = e.caption ? e.caption : "Image";
        return `<img src="${e?.file?.url || e?.url}" alt="${t}" />`;
    },
    list: ({ data: e })=>{
        const t = "unordered" === e.style ? "ul" : "ol", r = (e, t)=>{
            const o = e.map((e)=>{
                if (!e.content && !e.items) return `<li>${e}</li>`;
                let o = "";
                return e.items?.length && (o = r(e.items, t)), e.content ? `<li>${e.content}${o}</li>` : void 0;
            });
            return `<${t}>${o.join("")}</${t}>`;
        };
        return r(e.items, t);
    },
    paragraph: ({ data: e })=>{
        const t = e.alignment || e.align;
        return t ? `<p style="text-align:${t}"> ${e.text} </p>` : `<p>${e.text}</p>`;
    },
    quote: ({ data: e })=>`<blockquote>${e.text}</blockquote> - ${e.caption}`,
    delimiter: ({ data: e })=>"<br/>"
};
$70d150f8dfa3d626$exports = (t = {}, r = {
    strict: !1
})=>{
    const o = {
        ...$70d150f8dfa3d626$var$e,
        ...t
    };
    return {
        parse: (e)=>(({ blocks: e }, t, r)=>e.reduce((e, o)=>{
                    if (o.type in t) return e + t[o.type](o);
                    const i = `[editorjs-html]: Parser function for ${o.type} does not exist`;
                    if (r.strict) throw new Error(i);
                    return console.error(i), e;
                }, ""))(e, o, r),
        parseBlock: (e)=>((e, t, r)=>{
                if (e.type in t) return t[e.type](e);
                const o = `[editorjs-html]: Parser function for ${e.type} does not exist`;
                if (r.strict) throw new Error(o);
                console.error(o);
            })(e, o, r)
    };
};


var $f3dbfd93bcb031cd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f3dbfd93bcb031cd$export$8f49e4af10703ce3 = (0, (/*@__PURE__*/$parcel$interopDefault($70d150f8dfa3d626$exports)))({
    link: ({ data: { link: link } })=>`<a href="${link}">${link}</a>`
});
const $f3dbfd93bcb031cd$export$f9c5335a01b13a5a = (_a)=>{
    var { data: data } = _a, props = $f3dbfd93bcb031cd$var$__rest(_a, [
        "data"
    ]);
    return (0, $e830bf8f8acfe41d$exports.jsx)("article", Object.assign({}, props, {
        dangerouslySetInnerHTML: {
            __html: $f3dbfd93bcb031cd$export$8f49e4af10703ce3.parse(data)
        }
    }));
};
$f3dbfd93bcb031cd$export$f9c5335a01b13a5a.displayName = 'EditorHTML';


var $cfdbb1e29b9af572$exports = {};

$parcel$export($cfdbb1e29b9af572$exports, "HorizontalMarquee", () => $cfdbb1e29b9af572$export$4eb895ecfe5a67d5);
$parcel$export($cfdbb1e29b9af572$exports, "HorizontalMarqueeBox", () => $cfdbb1e29b9af572$export$e22877062eb47c32);

var $0d73e7d69a878bc2$export$fad3c8302a7540c6;
var $0d73e7d69a878bc2$export$5f81b96ae5b0befd;
var $0d73e7d69a878bc2$export$1a22ace05a045e3f;
var $0d73e7d69a878bc2$export$c7aa240077ad8340;
var $0d73e7d69a878bc2$export$5add10f2a1e13991;
$0d73e7d69a878bc2$export$fad3c8302a7540c6 = `_4_3lnG_scrollContainer`;
$0d73e7d69a878bc2$export$5f81b96ae5b0befd = `_4_3lnG_scrollHeightWrap`;
$0d73e7d69a878bc2$export$1a22ace05a045e3f = `_4_3lnG_scrollItem`;
$0d73e7d69a878bc2$export$1a22ace05a045e3f;
$0d73e7d69a878bc2$export$c7aa240077ad8340 = `_4_3lnG_scrollWrap`;
$0d73e7d69a878bc2$export$c7aa240077ad8340;
$0d73e7d69a878bc2$export$5add10f2a1e13991 = `_4_3lnG_unScrollItem`;


var $cfdbb1e29b9af572$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $cfdbb1e29b9af572$export$4eb895ecfe5a67d5 = (_a)=>{
    var { className: className = '', children: children, maxWidth: maxWidth = '100%', duration: duration, height: height } = _a, props = $cfdbb1e29b9af572$var$__rest(_a, [
        "className",
        "children",
        "maxWidth",
        "duration",
        "height"
    ]);
    return (0, $e830bf8f8acfe41d$exports.jsx)("div", Object.assign({
        className: `overflow-hidden mw-100 ${className}`
    }, props, {
        children: (0, $e830bf8f8acfe41d$exports.jsx)("div", {
            className: `d-inline-block align-top text-nowrap ${$0d73e7d69a878bc2$export$c7aa240077ad8340}`,
            style: {
                maxWidth: maxWidth,
                animationDuration: duration,
                height: height,
                lineHeight: height
            },
            children: (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                className: `d-inline-block ${$0d73e7d69a878bc2$export$1a22ace05a045e3f}`,
                style: {
                    animationDuration: duration
                },
                children: children
            })
        })
    }));
};
const $cfdbb1e29b9af572$export$e22877062eb47c32 = ({ children: children, maxWidth: maxWidth, duration: duration, height: height })=>height ? (0, $e830bf8f8acfe41d$exports.jsx)("div", {
        className: `overflow-hidden ${$0d73e7d69a878bc2$export$5f81b96ae5b0befd}`,
        // @ts-expect-error remove after React 19 released
        style: {
            maxWidth: maxWidth,
            '--scroll-height': height
        },
        children: (0, $e830bf8f8acfe41d$exports.jsxs)("div", {
            className: `d-inline-block overflow-hidden mw-100 ${$0d73e7d69a878bc2$export$fad3c8302a7540c6}`,
            children: [
                (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                    className: `d-block overflow-hidden text-wrap text-break ${$0d73e7d69a878bc2$export$5add10f2a1e13991}`,
                    children: children
                }),
                (0, $e830bf8f8acfe41d$exports.jsx)($cfdbb1e29b9af572$export$4eb895ecfe5a67d5, {
                    duration: duration,
                    children: children
                })
            ]
        })
    }) : (0, $e830bf8f8acfe41d$exports.jsx)($cfdbb1e29b9af572$export$4eb895ecfe5a67d5, {
        maxWidth: maxWidth,
        duration: duration,
        height: height,
        children: children
    });
$cfdbb1e29b9af572$export$4eb895ecfe5a67d5.displayName = 'HorizontalMarquee';


var $a9e058be8650f0e1$exports = {};

$parcel$export($a9e058be8650f0e1$exports, "Icon", () => $a9e058be8650f0e1$export$f04a61298a47a40f);


var $a9e058be8650f0e1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $a9e058be8650f0e1$export$f04a61298a47a40f = (_a)=>{
    var { className: className, style: style, name: name, size: size } = _a, props = $a9e058be8650f0e1$var$__rest(_a, [
        "className",
        "style",
        "name",
        "size"
    ]);
    return (0, $e830bf8f8acfe41d$exports.jsx)("span", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`bi-${name}`, className),
        style: Object.assign({
            fontSize: size && `${size}rem`
        }, style)
    }, props));
};
$a9e058be8650f0e1$export$f04a61298a47a40f.displayName = 'Icon';


var $e5a57d506e25a9c5$exports = {};

$parcel$export($e5a57d506e25a9c5$exports, "LiveTSX", () => $e5a57d506e25a9c5$export$965592ed152e8e7f);


var $7DB8U = parcelRequire("7DB8U");


var $7DB8U = parcelRequire("7DB8U");
function $ee9d4e7b280b4edb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ee9d4e7b280b4edb$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ee9d4e7b280b4edb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ee9d4e7b280b4edb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ee9d4e7b280b4edb$export$2e2bcd8739ae039 = $ee9d4e7b280b4edb$export$4f5d2d50c9deca37;


var $62601dcfdc5761fa$var$__create = Object.create;
var $62601dcfdc5761fa$var$__defProp = Object.defineProperty;
var $62601dcfdc5761fa$var$__defProps = Object.defineProperties;
var $62601dcfdc5761fa$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $62601dcfdc5761fa$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $62601dcfdc5761fa$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $62601dcfdc5761fa$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $62601dcfdc5761fa$var$__getProtoOf = Object.getPrototypeOf;
var $62601dcfdc5761fa$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $62601dcfdc5761fa$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $62601dcfdc5761fa$var$__defNormalProp = (obj, key, value)=>key in obj ? $62601dcfdc5761fa$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $62601dcfdc5761fa$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($62601dcfdc5761fa$var$__hasOwnProp.call(b, prop)) $62601dcfdc5761fa$var$__defNormalProp(a, prop, b[prop]);
    if ($62601dcfdc5761fa$var$__getOwnPropSymbols) {
        for (var prop of $62601dcfdc5761fa$var$__getOwnPropSymbols(b))if ($62601dcfdc5761fa$var$__propIsEnum.call(b, prop)) $62601dcfdc5761fa$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $62601dcfdc5761fa$var$__spreadProps = (a, b)=>$62601dcfdc5761fa$var$__defProps(a, $62601dcfdc5761fa$var$__getOwnPropDescs(b));
var $62601dcfdc5761fa$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($62601dcfdc5761fa$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $62601dcfdc5761fa$var$__getOwnPropSymbols) {
        for (var prop of $62601dcfdc5761fa$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $62601dcfdc5761fa$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $62601dcfdc5761fa$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$62601dcfdc5761fa$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $62601dcfdc5761fa$var$__export = (target, all)=>{
    for(var name in all)$62601dcfdc5761fa$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $62601dcfdc5761fa$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $62601dcfdc5761fa$var$__getOwnPropNames(from))if (!$62601dcfdc5761fa$var$__hasOwnProp.call(to, key) && key !== except) $62601dcfdc5761fa$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $62601dcfdc5761fa$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $62601dcfdc5761fa$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $62601dcfdc5761fa$var$__create($62601dcfdc5761fa$var$__getProtoOf(mod)) : {}, $62601dcfdc5761fa$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $62601dcfdc5761fa$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
// ../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js
var $62601dcfdc5761fa$var$require_prism = $62601dcfdc5761fa$var$__commonJS({
    "../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js" (exports, module) {
        var Prism2 = function() {
            var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
            var uniqueId = 0;
            var plainTextGrammar = {};
            var _ = {
                /**
         * A namespace for utility methods.
         *
         * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
         * change or disappear at any time.
         *
         * @namespace
         * @memberof Prism
         */ util: {
                    encode: function encode(tokens) {
                        if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                        else if (Array.isArray(tokens)) return tokens.map(encode);
                        else return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
                    },
                    /**
           * Returns the name of the type of the given value.
           *
           * @param {any} o
           * @returns {string}
           * @example
           * type(null)      === 'Null'
           * type(undefined) === 'Undefined'
           * type(123)       === 'Number'
           * type('foo')     === 'String'
           * type(true)      === 'Boolean'
           * type([1, 2])    === 'Array'
           * type({})        === 'Object'
           * type(String)    === 'Function'
           * type(/abc+/)    === 'RegExp'
           */ type: function(o) {
                        return Object.prototype.toString.call(o).slice(8, -1);
                    },
                    /**
           * Returns a unique number for the given object. Later calls will still return the same number.
           *
           * @param {Object} obj
           * @returns {number}
           */ objId: function(obj) {
                        if (!obj["__id"]) Object.defineProperty(obj, "__id", {
                            value: ++uniqueId
                        });
                        return obj["__id"];
                    },
                    /**
           * Creates a deep clone of the given object.
           *
           * The main intended use of this function is to clone language definitions.
           *
           * @param {T} o
           * @param {Record<number, any>} [visited]
           * @returns {T}
           * @template T
           */ clone: function deepClone(o, visited) {
                        visited = visited || {};
                        var clone;
                        var id;
                        switch(_.util.type(o)){
                            case "Object":
                                id = _.util.objId(o);
                                if (visited[id]) return visited[id];
                                clone = /** @type {Record<string, any>} */ {};
                                visited[id] = clone;
                                for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                                return /** @type {any} */ clone;
                            case "Array":
                                id = _.util.objId(o);
                                if (visited[id]) return visited[id];
                                clone = [];
                                visited[id] = clone;
                                /** @type {Array} */ /** @type {any} */ o.forEach(function(v, i) {
                                    clone[i] = deepClone(v, visited);
                                });
                                return /** @type {any} */ clone;
                            default:
                                return o;
                        }
                    },
                    /**
           * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
           *
           * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
           *
           * @param {Element} element
           * @returns {string}
           */ getLanguage: function(element) {
                        while(element){
                            var m = lang.exec(element.className);
                            if (m) return m[1].toLowerCase();
                            element = element.parentElement;
                        }
                        return "none";
                    },
                    /**
           * Sets the Prism `language-xxxx` class of the given element.
           *
           * @param {Element} element
           * @param {string} language
           * @returns {void}
           */ setLanguage: function(element, language) {
                        element.className = element.className.replace(RegExp(lang, "gi"), "");
                        element.classList.add("language-" + language);
                    },
                    /**
           * Returns whether a given class is active for `element`.
           *
           * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
           * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
           * given class is just the given class with a `no-` prefix.
           *
           * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
           * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
           * ancestors have the given class or the negated version of it, then the default activation will be returned.
           *
           * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
           * version of it, the class is considered active.
           *
           * @param {Element} element
           * @param {string} className
           * @param {boolean} [defaultActivation=false]
           * @returns {boolean}
           */ isActive: function(element, className, defaultActivation) {
                        var no = "no-" + className;
                        while(element){
                            var classList = element.classList;
                            if (classList.contains(className)) return true;
                            if (classList.contains(no)) return false;
                            element = element.parentElement;
                        }
                        return !!defaultActivation;
                    }
                },
                /**
         * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
         *
         * @namespace
         * @memberof Prism
         * @public
         */ languages: {
                    /**
           * The grammar for plain, unformatted text.
           */ plain: plainTextGrammar,
                    plaintext: plainTextGrammar,
                    text: plainTextGrammar,
                    txt: plainTextGrammar,
                    /**
           * Creates a deep copy of the language with the given id and appends the given tokens.
           *
           * If a token in `redef` also appears in the copied language, then the existing token in the copied language
           * will be overwritten at its original position.
           *
           * ## Best practices
           *
           * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
           * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
           * understand the language definition because, normally, the order of tokens matters in Prism grammars.
           *
           * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
           * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
           *
           * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
           * @param {Grammar} redef The new tokens to append.
           * @returns {Grammar} The new language created.
           * @public
           * @example
           * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
           *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
           *     // at its original position
           *     'comment': { ... },
           *     // CSS doesn't have a 'color' token, so this token will be appended
           *     'color': /\b(?:red|green|blue)\b/
           * });
           */ extend: function(id, redef) {
                        var lang2 = _.util.clone(_.languages[id]);
                        for(var key in redef)lang2[key] = redef[key];
                        return lang2;
                    },
                    /**
           * Inserts tokens _before_ another token in a language definition or any other grammar.
           *
           * ## Usage
           *
           * This helper method makes it easy to modify existing languages. For example, the CSS language definition
           * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
           * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
           * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
           * this:
           *
           * ```js
           * Prism.languages.markup.style = {
           *     // token
           * };
           * ```
           *
           * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
           * before existing tokens. For the CSS example above, you would use it like this:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'cdata', {
           *     'style': {
           *         // token
           *     }
           * });
           * ```
           *
           * ## Special cases
           *
           * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
           * will be ignored.
           *
           * This behavior can be used to insert tokens after `before`:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'comment', {
           *     'comment': Prism.languages.markup.comment,
           *     // tokens after 'comment'
           * });
           * ```
           *
           * ## Limitations
           *
           * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
           * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
           * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
           * deleting properties which is necessary to insert at arbitrary positions.
           *
           * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
           * Instead, it will create a new object and replace all references to the target object with the new one. This
           * can be done without temporarily deleting properties, so the iteration order is well-defined.
           *
           * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
           * you hold the target object in a variable, then the value of the variable will not change.
           *
           * ```js
           * var oldMarkup = Prism.languages.markup;
           * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
           *
           * assert(oldMarkup !== Prism.languages.markup);
           * assert(newMarkup === Prism.languages.markup);
           * ```
           *
           * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
           * object to be modified.
           * @param {string} before The key to insert before.
           * @param {Grammar} insert An object containing the key-value pairs to be inserted.
           * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
           * object to be modified.
           *
           * Defaults to `Prism.languages`.
           * @returns {Grammar} The new grammar object.
           * @public
           */ insertBefore: function(inside, before, insert, root) {
                        root = root || /** @type {any} */ _.languages;
                        var grammar = root[inside];
                        var ret = {};
                        for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                            if (token == before) {
                                for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                            }
                            if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                        }
                        var old = root[inside];
                        root[inside] = ret;
                        _.languages.DFS(_.languages, function(key, value) {
                            if (value === old && key != inside) this[key] = ret;
                        });
                        return ret;
                    },
                    // Traverse a language definition with Depth First Search
                    DFS: function DFS(o, callback, type, visited) {
                        visited = visited || {};
                        var objId = _.util.objId;
                        for(var i in o)if (o.hasOwnProperty(i)) {
                            callback.call(o, i, o[i], type || i);
                            var property = o[i];
                            var propertyType = _.util.type(property);
                            if (propertyType === "Object" && !visited[objId(property)]) {
                                visited[objId(property)] = true;
                                DFS(property, callback, null, visited);
                            } else if (propertyType === "Array" && !visited[objId(property)]) {
                                visited[objId(property)] = true;
                                DFS(property, callback, i, visited);
                            }
                        }
                    }
                },
                plugins: {},
                /**
         * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
         * and the language definitions to use, and returns a string with the HTML produced.
         *
         * The following hooks will be run:
         * 1. `before-tokenize`
         * 2. `after-tokenize`
         * 3. `wrap`: On each {@link Token}.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @param {string} language The name of the language definition passed to `grammar`.
         * @returns {string} The highlighted HTML.
         * @memberof Prism
         * @public
         * @example
         * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
         */ highlight: function(text, grammar, language) {
                    var env = {
                        code: text,
                        grammar: grammar,
                        language: language
                    };
                    _.hooks.run("before-tokenize", env);
                    if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
                    env.tokens = _.tokenize(env.code, env.grammar);
                    _.hooks.run("after-tokenize", env);
                    return Token.stringify(_.util.encode(env.tokens), env.language);
                },
                /**
         * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
         * and the language definitions to use, and returns an array with the tokenized code.
         *
         * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
         *
         * This method could be useful in other contexts as well, as a very crude parser.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @returns {TokenStream} An array of strings and tokens, a token stream.
         * @memberof Prism
         * @public
         * @example
         * let code = `var foo = 0;`;
         * let tokens = Prism.tokenize(code, Prism.languages.javascript);
         * tokens.forEach(token => {
         *     if (token instanceof Prism.Token && token.type === 'number') {
         *         console.log(`Found numeric literal: ${token.content}`);
         *     }
         * });
         */ tokenize: function(text, grammar) {
                    var rest = grammar.rest;
                    if (rest) {
                        for(var token in rest)grammar[token] = rest[token];
                        delete grammar.rest;
                    }
                    var tokenList = new LinkedList();
                    addAfter(tokenList, tokenList.head, text);
                    matchGrammar(text, tokenList, grammar, tokenList.head, 0);
                    return toArray(tokenList);
                },
                /**
         * @namespace
         * @memberof Prism
         * @public
         */ hooks: {
                    all: {},
                    /**
           * Adds the given callback to the list of callbacks for the given hook.
           *
           * The callback will be invoked when the hook it is registered for is run.
           * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
           *
           * One callback function can be registered to multiple hooks and the same hook multiple times.
           *
           * @param {string} name The name of the hook.
           * @param {HookCallback} callback The callback function which is given environment variables.
           * @public
           */ add: function(name, callback) {
                        var hooks2 = _.hooks.all;
                        hooks2[name] = hooks2[name] || [];
                        hooks2[name].push(callback);
                    },
                    /**
           * Runs a hook invoking all registered callbacks with the given environment variables.
           *
           * Callbacks will be invoked synchronously and in the order in which they were registered.
           *
           * @param {string} name The name of the hook.
           * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
           * @public
           */ run: function(name, env) {
                        var callbacks = _.hooks.all[name];
                        if (!callbacks || !callbacks.length) return;
                        for(var i = 0, callback; callback = callbacks[i++];)callback(env);
                    }
                },
                Token: Token
            };
            function Token(type, content, alias, matchedStr) {
                this.type = type;
                this.content = content;
                this.alias = alias;
                this.length = (matchedStr || "").length | 0;
            }
            Token.stringify = function stringify(o, language) {
                if (typeof o == "string") return o;
                if (Array.isArray(o)) {
                    var s = "";
                    o.forEach(function(e) {
                        s += stringify(e, language);
                    });
                    return s;
                }
                var env = {
                    type: o.type,
                    content: stringify(o.content, language),
                    tag: "span",
                    classes: [
                        "token",
                        o.type
                    ],
                    attributes: {},
                    language: language
                };
                var aliases = o.alias;
                if (aliases) {
                    if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
                    else env.classes.push(aliases);
                }
                _.hooks.run("wrap", env);
                var attributes = "";
                for(var name in env.attributes)attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
                return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
            };
            function matchPattern(pattern, pos, text, lookbehind) {
                pattern.lastIndex = pos;
                var match = pattern.exec(text);
                if (match && lookbehind && match[1]) {
                    var lookbehindLength = match[1].length;
                    match.index += lookbehindLength;
                    match[0] = match[0].slice(lookbehindLength);
                }
                return match;
            }
            function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
                for(var token in grammar){
                    if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
                    var patterns = grammar[token];
                    patterns = Array.isArray(patterns) ? patterns : [
                        patterns
                    ];
                    for(var j = 0; j < patterns.length; ++j){
                        if (rematch && rematch.cause == token + "," + j) return;
                        var patternObj = patterns[j];
                        var inside = patternObj.inside;
                        var lookbehind = !!patternObj.lookbehind;
                        var greedy = !!patternObj.greedy;
                        var alias = patternObj.alias;
                        if (greedy && !patternObj.pattern.global) {
                            var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                            patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
                        }
                        var pattern = patternObj.pattern || patternObj;
                        for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                            if (rematch && pos >= rematch.reach) break;
                            var str = currentNode.value;
                            if (tokenList.length > text.length) return;
                            if (str instanceof Token) continue;
                            var removeCount = 1;
                            var match;
                            if (greedy) {
                                match = matchPattern(pattern, pos, text, lookbehind);
                                if (!match || match.index >= text.length) break;
                                var from = match.index;
                                var to = match.index + match[0].length;
                                var p = pos;
                                p += currentNode.value.length;
                                while(from >= p){
                                    currentNode = currentNode.next;
                                    p += currentNode.value.length;
                                }
                                p -= currentNode.value.length;
                                pos = p;
                                if (currentNode.value instanceof Token) continue;
                                for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next){
                                    removeCount++;
                                    p += k.value.length;
                                }
                                removeCount--;
                                str = text.slice(pos, p);
                                match.index -= pos;
                            } else {
                                match = matchPattern(pattern, 0, str, lookbehind);
                                if (!match) continue;
                            }
                            var from = match.index;
                            var matchStr = match[0];
                            var before = str.slice(0, from);
                            var after = str.slice(from + matchStr.length);
                            var reach = pos + str.length;
                            if (rematch && reach > rematch.reach) rematch.reach = reach;
                            var removeFrom = currentNode.prev;
                            if (before) {
                                removeFrom = addAfter(tokenList, removeFrom, before);
                                pos += before.length;
                            }
                            removeRange(tokenList, removeFrom, removeCount);
                            var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                            currentNode = addAfter(tokenList, removeFrom, wrapped);
                            if (after) addAfter(tokenList, currentNode, after);
                            if (removeCount > 1) {
                                var nestedRematch = {
                                    cause: token + "," + j,
                                    reach: reach
                                };
                                matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                                if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                            }
                        }
                    }
                }
            }
            function LinkedList() {
                var head = {
                    value: null,
                    prev: null,
                    next: null
                };
                var tail = {
                    value: null,
                    prev: head,
                    next: null
                };
                head.next = tail;
                this.head = head;
                this.tail = tail;
                this.length = 0;
            }
            function addAfter(list, node, value) {
                var next = node.next;
                var newNode = {
                    value: value,
                    prev: node,
                    next: next
                };
                node.next = newNode;
                next.prev = newNode;
                list.length++;
                return newNode;
            }
            function removeRange(list, node, count) {
                var next = node.next;
                for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
                node.next = next;
                next.prev = node;
                list.length -= i;
            }
            function toArray(list) {
                var array = [];
                var node = list.head.next;
                while(node !== list.tail){
                    array.push(node.value);
                    node = node.next;
                }
                return array;
            }
            return _;
        }();
        module.exports = Prism2;
        Prism2.default = Prism2;
    }
});
// src/prism-langs.ts
var $62601dcfdc5761fa$export$dc7257ffb0972f87 = $62601dcfdc5761fa$var$__toESM($62601dcfdc5761fa$var$require_prism());
$62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup = {
    comment: {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    prolog: {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    doctype: {
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            "internal-subset": {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null
            },
            string: {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            punctuation: /^<!|>$|[[\]]/,
            "doctype-tag": /^DOCTYPE/i,
            name: /[^\s<>'"]+/
        }
    },
    cdata: {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            tag: {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    punctuation: /^<\/?/,
                    namespace: /^[^\s>\/:]+:/
                }
            },
            "special-attr": [],
            "attr-value": {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    punctuation: [
                        {
                            pattern: /^=/,
                            alias: "attr-equals"
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            punctuation: /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    namespace: /^[^\s>\/:]+:/
                }
            }
        }
    },
    entity: [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
    ]
}, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup.tag.inside["attr-value"].inside.entity = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup.entity, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup.doctype.inside["internal-subset"].inside = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup, $62601dcfdc5761fa$export$dc7257ffb0972f87.hooks.add("wrap", function(e) {
    "entity" === e.type && (e.attributes.title = e.content.replace(/&amp;/, "&"));
}), Object.defineProperty($62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup.tag, "addInlined", {
    value: function(e, n) {
        var t = {}, t = (t["language-" + n] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $62601dcfdc5761fa$export$dc7257ffb0972f87.languages[n]
        }, t.cdata = /^<!\[CDATA\[|\]\]>$/i, {
            "included-cdata": {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: t
            }
        }), n = (t["language-" + n] = {
            pattern: /[\s\S]+/,
            inside: $62601dcfdc5761fa$export$dc7257ffb0972f87.languages[n]
        }, {});
        n[e] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return e;
            }), "i"),
            lookbehind: true,
            greedy: true,
            inside: t
        }, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.insertBefore("markup", "cdata", n);
    }
}), Object.defineProperty($62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup.tag, "addAttribute", {
    value: function(e, n) {
        $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup.tag.inside["special-attr"].push({
            pattern: RegExp(/(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
            lookbehind: true,
            inside: {
                "attr-name": /^[^\s=]+/,
                "attr-value": {
                    pattern: /=[\s\S]+/,
                    inside: {
                        value: {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                n,
                                "language-" + n
                            ],
                            inside: $62601dcfdc5761fa$export$dc7257ffb0972f87.languages[n]
                        },
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: "attr-equals"
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.html = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.mathml = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.svg = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.xml = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.extend("markup", {}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.ssml = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.xml, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.atom = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.xml, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.rss = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.xml, function(e) {
    var n = {
        pattern: /\\[\\(){}[\]^$+*?|.]/,
        alias: "escape"
    }, t = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/, a = "(?:[^\\\\-]|" + t.source + ")", a = RegExp(a + "-" + a), r = {
        pattern: /(<|')[^<>']+(?=[>']$)/,
        lookbehind: true,
        alias: "variable"
    };
    e.languages.regex = {
        "char-class": {
            pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
            lookbehind: true,
            inside: {
                "char-class-negation": {
                    pattern: /(^\[)\^/,
                    lookbehind: true,
                    alias: "operator"
                },
                "char-class-punctuation": {
                    pattern: /^\[|\]$/,
                    alias: "punctuation"
                },
                range: {
                    pattern: a,
                    inside: {
                        escape: t,
                        "range-punctuation": {
                            pattern: /-/,
                            alias: "operator"
                        }
                    }
                },
                "special-escape": n,
                "char-set": {
                    pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
                    alias: "class-name"
                },
                escape: t
            }
        },
        "special-escape": n,
        "char-set": {
            pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
            alias: "class-name"
        },
        backreference: [
            {
                pattern: /\\(?![123][0-7]{2})[1-9]/,
                alias: "keyword"
            },
            {
                pattern: /\\k<[^<>']+>/,
                alias: "keyword",
                inside: {
                    "group-name": r
                }
            }
        ],
        anchor: {
            pattern: /[$^]|\\[ABbGZz]/,
            alias: "function"
        },
        escape: t,
        group: [
            {
                pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
                alias: "punctuation",
                inside: {
                    "group-name": r
                }
            },
            {
                pattern: /\)/,
                alias: "punctuation"
            }
        ],
        quantifier: {
            pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
            alias: "number"
        },
        alternation: {
            pattern: /\|/,
            alias: "keyword"
        }
    };
}($62601dcfdc5761fa$export$dc7257ffb0972f87), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.clike = {
    comment: [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            punctuation: /[.\\]/
        }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
}, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.javascript = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.extend("clike", {
    "class-name": [
        $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.clike["class-name"],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    keyword: [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
        pattern: RegExp(/(^|[^\w$])/.source + "(?:" + /NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source + ")" + /(?![\w$])/.source),
        lookbehind: true
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.insertBefore("javascript", "keyword", {
    regex: {
        pattern: RegExp(/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            "regex-source": {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: "language-regex",
                inside: $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.regex
            },
            "regex-delimiter": /^\/|\/$/,
            "regex-flags": /^[a-z]+$/
        }
    },
    "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
    },
    parameter: [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.javascript
        }
    ],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.insertBefore("javascript", "string", {
    hashbang: {
        pattern: /^#!.*/,
        greedy: true,
        alias: "comment"
    },
    "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
            },
            interpolation: {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    "interpolation-punctuation": {
                        pattern: /^\$\{|\}$/,
                        alias: "punctuation"
                    },
                    rest: $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.javascript
                }
            },
            string: /[\s\S]+/
        }
    },
    "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: "property"
    }
}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.insertBefore("javascript", "operator", {
    "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: "property"
    }
}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup && ($62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup.tag.addInlined("script", "javascript"), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.js = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.javascript, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.actionscript = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.extend("javascript", {
    keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
    operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.actionscript["class-name"].alias = "function", delete $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.actionscript.parameter, delete $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.actionscript["literal-property"], $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup && $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.insertBefore("actionscript", "string", {
    xml: {
        pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
        lookbehind: true,
        inside: $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markup
    }
}), function(e) {
    var n = /#(?!\{).+/, t = {
        pattern: /#\{[^}]+\}/,
        alias: "variable"
    };
    e.languages.coffeescript = e.languages.extend("javascript", {
        comment: n,
        string: [
            {
                pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                greedy: true
            },
            {
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                greedy: true,
                inside: {
                    interpolation: t
                }
            }
        ],
        keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
        "class-member": {
            pattern: /@(?!\d)\w+/,
            alias: "variable"
        }
    }), e.languages.insertBefore("coffeescript", "comment", {
        "multiline-comment": {
            pattern: /###[\s\S]+?###/,
            alias: "comment"
        },
        "block-regex": {
            pattern: /\/{3}[\s\S]*?\/{3}/,
            alias: "regex",
            inside: {
                comment: n,
                interpolation: t
            }
        }
    }), e.languages.insertBefore("coffeescript", "string", {
        "inline-javascript": {
            pattern: /`(?:\\[\s\S]|[^\\`])*`/,
            inside: {
                delimiter: {
                    pattern: /^`|`$/,
                    alias: "punctuation"
                },
                script: {
                    pattern: /[\s\S]+/,
                    alias: "language-javascript",
                    inside: e.languages.javascript
                }
            }
        },
        "multiline-string": [
            {
                pattern: /'''[\s\S]*?'''/,
                greedy: true,
                alias: "string"
            },
            {
                pattern: /"""[\s\S]*?"""/,
                greedy: true,
                alias: "string",
                inside: {
                    interpolation: t
                }
            }
        ]
    }), e.languages.insertBefore("coffeescript", "keyword", {
        property: /(?!\d)\w+(?=\s*:(?!:))/
    }), delete e.languages.coffeescript["template-string"], e.languages.coffee = e.languages.coffeescript;
}($62601dcfdc5761fa$export$dc7257ffb0972f87), function(l) {
    var e = l.languages.javadoclike = {
        parameter: {
            pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
            lookbehind: true
        },
        keyword: {
            pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
            lookbehind: true
        },
        punctuation: /[{}]/
    };
    Object.defineProperty(e, "addSupport", {
        value: function(e2, o) {
            (e2 = "string" == typeof e2 ? [
                e2
            ] : e2).forEach(function(e3) {
                var n = function(e4) {
                    e4.inside || (e4.inside = {}), e4.inside.rest = o;
                }, t = "doc-comment";
                if (a = l.languages[e3]) {
                    var a, r = a[t];
                    if ((r = r ? r : (a = l.languages.insertBefore(e3, "comment", {
                        "doc-comment": {
                            pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
                            lookbehind: true,
                            alias: "comment"
                        }
                    }))[t]) instanceof RegExp && (r = a[t] = {
                        pattern: r
                    }), Array.isArray(r)) for(var s = 0, i = r.length; s < i; s++)r[s] instanceof RegExp && (r[s] = {
                        pattern: r[s]
                    }), n(r[s]);
                    else n(r);
                }
            });
        }
    }), e.addSupport([
        "java",
        "javascript",
        "php"
    ], e);
}($62601dcfdc5761fa$export$dc7257ffb0972f87), function(e) {
    var n = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/, n = (e.languages.css = {
        comment: /\/\*[\s\S]*?\*\//,
        atrule: {
            pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + n.source + ")*?" + /(?:;|(?=\s*\{))/.source),
            inside: {
                rule: /^@[\w-]+/,
                "selector-function-argument": {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: "selector"
                },
                keyword: {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        url: {
            pattern: RegExp("\\burl\\((?:" + n.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
            greedy: true,
            inside: {
                function: /^url/i,
                punctuation: /^\(|\)$/,
                string: {
                    pattern: RegExp("^" + n.source + "$"),
                    alias: "url"
                }
            }
        },
        selector: {
            pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + n.source + ")*(?=\\s*\\{)"),
            lookbehind: true
        },
        string: {
            pattern: n,
            greedy: true
        },
        property: {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        important: /!important\b/i,
        function: {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        punctuation: /[(){};:,]/
    }, e.languages.css.atrule.inside.rest = e.languages.css, e.languages.markup);
    n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
}($62601dcfdc5761fa$export$dc7257ffb0972f87), function(e) {
    var n = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, n = (e.languages.css.selector = {
        pattern: e.languages.css.selector.pattern,
        lookbehind: true,
        inside: n = {
            "pseudo-element": /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
            "pseudo-class": /:[-\w]+/,
            class: /\.[-\w]+/,
            id: /#[-\w]+/,
            attribute: {
                pattern: RegExp(`\\[(?:[^[\\]"']|` + n.source + ")*\\]"),
                greedy: true,
                inside: {
                    punctuation: /^\[|\]$/,
                    "case-sensitivity": {
                        pattern: /(\s)[si]$/i,
                        lookbehind: true,
                        alias: "keyword"
                    },
                    namespace: {
                        pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                        lookbehind: true,
                        inside: {
                            punctuation: /\|$/
                        }
                    },
                    "attr-name": {
                        pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                        lookbehind: true
                    },
                    "attr-value": [
                        n,
                        {
                            pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                            lookbehind: true
                        }
                    ],
                    operator: /[|~*^$]?=/
                }
            },
            "n-th": [
                {
                    pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
                    lookbehind: true,
                    inside: {
                        number: /[\dn]+/,
                        operator: /[+-]/
                    }
                },
                {
                    pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
                    lookbehind: true
                }
            ],
            combinator: />|\+|~|\|\|/,
            punctuation: /[(),]/
        }
    }, e.languages.css.atrule.inside["selector-function-argument"].inside = n, e.languages.insertBefore("css", "property", {
        variable: {
            pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
            lookbehind: true
        }
    }), {
        pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
        lookbehind: true
    }), t = {
        pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
        lookbehind: true
    };
    e.languages.insertBefore("css", "function", {
        operator: {
            pattern: /(\s)[+\-*\/](?=\s)/,
            lookbehind: true
        },
        hexcode: {
            pattern: /\B#[\da-f]{3,8}\b/i,
            alias: "color"
        },
        color: [
            {
                pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|RebeccaPurple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
                lookbehind: true
            },
            {
                pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                inside: {
                    unit: n,
                    number: t,
                    function: /[\w-]+(?=\()/,
                    punctuation: /[(),]/
                }
            }
        ],
        entity: /\\[\da-f]{1,8}/i,
        unit: n,
        number: t
    });
}($62601dcfdc5761fa$export$dc7257ffb0972f87), function(e) {
    var n = /[*&][^\s[\]{},]+/, t = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, a = "(?:" + t.source + "(?:[ 	]+" + n.source + ")?|" + n.source + "(?:[ 	]+" + t.source + ")?)", r = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
        return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
    }), s = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
    function i(e2, n2) {
        n2 = (n2 || "").replace(/m/g, "") + "m";
        var t2 = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
            return a;
        }).replace(/<<value>>/g, function() {
            return e2;
        });
        return RegExp(t2, n2);
    }
    e.languages.yaml = {
        scalar: {
            pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
                return a;
            })),
            lookbehind: true,
            alias: "string"
        },
        comment: /#.*/,
        key: {
            pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
                return a;
            }).replace(/<<key>>/g, function() {
                return "(?:" + r + "|" + s + ")";
            })),
            lookbehind: true,
            greedy: true,
            alias: "atrule"
        },
        directive: {
            pattern: /(^[ \t]*)%.+/m,
            lookbehind: true,
            alias: "important"
        },
        datetime: {
            pattern: i(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
            lookbehind: true,
            alias: "number"
        },
        boolean: {
            pattern: i(/false|true/.source, "i"),
            lookbehind: true,
            alias: "important"
        },
        null: {
            pattern: i(/null|~/.source, "i"),
            lookbehind: true,
            alias: "important"
        },
        string: {
            pattern: i(s),
            lookbehind: true,
            greedy: true
        },
        number: {
            pattern: i(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, "i"),
            lookbehind: true
        },
        tag: t,
        important: n,
        punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
    }, e.languages.yml = e.languages.yaml;
}($62601dcfdc5761fa$export$dc7257ffb0972f87), function(o) {
    var n = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
    function e(e2) {
        return e2 = e2.replace(/<inner>/g, function() {
            return n;
        }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + e2 + ")");
    }
    var t = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, a = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
        return t;
    }), r = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source, l = (o.languages.markdown = o.languages.extend("markup", {}), o.languages.insertBefore("markdown", "prolog", {
        "front-matter-block": {
            pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
            lookbehind: true,
            greedy: true,
            inside: {
                punctuation: /^---|---$/,
                "front-matter": {
                    pattern: /\S+(?:\s+\S+)*/,
                    alias: [
                        "yaml",
                        "language-yaml"
                    ],
                    inside: o.languages.yaml
                }
            }
        },
        blockquote: {
            pattern: /^>(?:[\t ]*>)*/m,
            alias: "punctuation"
        },
        table: {
            pattern: RegExp("^" + a + r + "(?:" + a + ")*", "m"),
            inside: {
                "table-data-rows": {
                    pattern: RegExp("^(" + a + r + ")(?:" + a + ")*$"),
                    lookbehind: true,
                    inside: {
                        "table-data": {
                            pattern: RegExp(t),
                            inside: o.languages.markdown
                        },
                        punctuation: /\|/
                    }
                },
                "table-line": {
                    pattern: RegExp("^(" + a + ")" + r + "$"),
                    lookbehind: true,
                    inside: {
                        punctuation: /\||:?-{3,}:?/
                    }
                },
                "table-header-row": {
                    pattern: RegExp("^" + a + "$"),
                    inside: {
                        "table-header": {
                            pattern: RegExp(t),
                            alias: "important",
                            inside: o.languages.markdown
                        },
                        punctuation: /\|/
                    }
                }
            }
        },
        code: [
            {
                pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                lookbehind: true,
                alias: "keyword"
            },
            {
                pattern: /^```[\s\S]*?^```$/m,
                greedy: true,
                inside: {
                    "code-block": {
                        pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                        lookbehind: true
                    },
                    "code-language": {
                        pattern: /^(```).+/,
                        lookbehind: true
                    },
                    punctuation: /```/
                }
            }
        ],
        title: [
            {
                pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                alias: "important",
                inside: {
                    punctuation: /==+$|--+$/
                }
            },
            {
                pattern: /(^\s*)#.+/m,
                lookbehind: true,
                alias: "important",
                inside: {
                    punctuation: /^#+|#+$/
                }
            }
        ],
        hr: {
            pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
            lookbehind: true,
            alias: "punctuation"
        },
        list: {
            pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
            lookbehind: true,
            alias: "punctuation"
        },
        "url-reference": {
            pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
            inside: {
                variable: {
                    pattern: /^(!?\[)[^\]]+/,
                    lookbehind: true
                },
                string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                punctuation: /^[\[\]!:]|[<>]/
            },
            alias: "url"
        },
        bold: {
            pattern: e(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^..)[\s\S]+(?=..$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /\*\*|__/
            }
        },
        italic: {
            pattern: e(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^.)[\s\S]+(?=.$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /[*_]/
            }
        },
        strike: {
            pattern: e(/(~~?)(?:(?!~)<inner>)+\2/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^~~?)[\s\S]+(?=\1$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /~~?/
            }
        },
        "code-snippet": {
            pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
            lookbehind: true,
            greedy: true,
            alias: [
                "code",
                "keyword"
            ]
        },
        url: {
            pattern: e(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                operator: /^!/,
                content: {
                    pattern: /(^\[)[^\]]+(?=\])/,
                    lookbehind: true,
                    inside: {}
                },
                variable: {
                    pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                    lookbehind: true
                },
                url: {
                    pattern: /(^\]\()[^\s)]+/,
                    lookbehind: true
                },
                string: {
                    pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                    lookbehind: true
                }
            }
        }
    }), [
        "url",
        "bold",
        "italic",
        "strike"
    ].forEach(function(n2) {
        [
            "url",
            "bold",
            "italic",
            "strike",
            "code-snippet"
        ].forEach(function(e2) {
            n2 !== e2 && (o.languages.markdown[n2].inside.content.inside[e2] = o.languages.markdown[e2]);
        });
    }), o.hooks.add("after-tokenize", function(e2) {
        "markdown" !== e2.language && "md" !== e2.language || !function e3(n2) {
            if (n2 && "string" != typeof n2) for(var t2 = 0, a2 = n2.length; t2 < a2; t2++){
                var r2, s = n2[t2];
                "code" !== s.type ? e3(s.content) : (r2 = s.content[1], s = s.content[3], r2 && s && "code-language" === r2.type && "code-block" === s.type && "string" == typeof r2.content && (r2 = r2.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp"), r2 = "language-" + (r2 = (/[a-z][\w-]*/i.exec(r2) || [
                    ""
                ])[0].toLowerCase()), s.alias ? "string" == typeof s.alias ? s.alias = [
                    s.alias,
                    r2
                ] : s.alias.push(r2) : s.alias = [
                    r2
                ]));
            }
        }(e2.tokens);
    }), o.hooks.add("wrap", function(e2) {
        if ("code-block" === e2.type) {
            for(var n2 = "", t2 = 0, a2 = e2.classes.length; t2 < a2; t2++){
                var r2 = e2.classes[t2], r2 = /language-(.+)/.exec(r2);
                if (r2) {
                    n2 = r2[1];
                    break;
                }
            }
            var s, i = o.languages[n2];
            i ? e2.content = o.highlight(function(e3) {
                e3 = e3.replace(l, "");
                return e3 = e3.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(e4, n3) {
                    var t3;
                    return "#" === (n3 = n3.toLowerCase())[0] ? (t3 = "x" === n3[1] ? parseInt(n3.slice(2), 16) : Number(n3.slice(1)), c(t3)) : u[n3] || e4;
                });
            }(e2.content), i, n2) : n2 && "none" !== n2 && o.plugins.autoloader && (s = "md-" + /* @__PURE__ */ new Date().valueOf() + "-" + Math.floor(1e16 * Math.random()), e2.attributes.id = s, o.plugins.autoloader.loadLanguages(n2, function() {
                var e3 = document.getElementById(s);
                e3 && (e3.innerHTML = o.highlight(e3.textContent, o.languages[n2], n2));
            }));
        }
    }), RegExp(o.languages.markup.tag.pattern.source, "gi")), u = {
        amp: "&",
        lt: "<",
        gt: ">",
        quot: '"'
    }, c = String.fromCodePoint || String.fromCharCode;
    o.languages.md = o.languages.markdown;
}($62601dcfdc5761fa$export$dc7257ffb0972f87), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.graphql = {
    comment: /#.*/,
    description: {
        pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
        greedy: true,
        alias: "string",
        inside: {
            "language-markdown": {
                pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
                lookbehind: true,
                inside: $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.markdown
            }
        }
    },
    string: {
        pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
        greedy: true
    },
    number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    boolean: /\b(?:false|true)\b/,
    variable: /\$[a-z_]\w*/i,
    directive: {
        pattern: /@[a-z_]\w*/i,
        alias: "function"
    },
    "attr-name": {
        pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
        greedy: true
    },
    "atom-input": {
        pattern: /\b[A-Z]\w*Input\b/,
        alias: "class-name"
    },
    scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
    constant: /\b[A-Z][A-Z_\d]*\b/,
    "class-name": {
        pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
        lookbehind: true
    },
    fragment: {
        pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    "definition-mutation": {
        pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    "definition-query": {
        pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
    operator: /[!=|&]|\.{3}/,
    "property-query": /\w+(?=\s*\()/,
    object: /\w+(?=\s*\{)/,
    punctuation: /[!(){}\[\]:=,]/,
    property: /\w+/
}, $62601dcfdc5761fa$export$dc7257ffb0972f87.hooks.add("after-tokenize", function(e) {
    if ("graphql" === e.language) for(var i = e.tokens.filter(function(e2) {
        return "string" != typeof e2 && "comment" !== e2.type && "scalar" !== e2.type;
    }), o = 0; o < i.length;){
        var n = i[o++];
        if ("keyword" === n.type && "mutation" === n.content) {
            var t = [];
            if (p([
                "definition-mutation",
                "punctuation"
            ]) && "(" === c(1).content) {
                o += 2;
                var a = d(/^\($/, /^\)$/);
                if (-1 === a) continue;
                for(; o < a; o++){
                    var r = c(0);
                    "variable" === r.type && (g(r, "variable-input"), t.push(r.content));
                }
                o = a + 1;
            }
            if (p([
                "punctuation",
                "property-query"
            ]) && "{" === c(0).content && (o++, g(c(0), "property-mutation"), 0 < t.length)) {
                var s = d(/^\{$/, /^\}$/);
                if (-1 !== s) for(var l = o; l < s; l++){
                    var u = i[l];
                    "variable" === u.type && 0 <= t.indexOf(u.content) && g(u, "variable-input");
                }
            }
        }
    }
    function c(e2) {
        return i[o + e2];
    }
    function p(e2, n2) {
        n2 = n2 || 0;
        for(var t2 = 0; t2 < e2.length; t2++){
            var a2 = c(t2 + n2);
            if (!a2 || a2.type !== e2[t2]) return;
        }
        return 1;
    }
    function d(e2, n2) {
        for(var t2 = 1, a2 = o; a2 < i.length; a2++){
            var r2 = i[a2], s2 = r2.content;
            if ("punctuation" === r2.type && "string" == typeof s2) {
                if (e2.test(s2)) t2++;
                else if (n2.test(s2) && 0 === --t2) return a2;
            }
        }
        return -1;
    }
    function g(e2, n2) {
        var t2 = e2.alias;
        t2 ? Array.isArray(t2) || (e2.alias = t2 = [
            t2
        ]) : e2.alias = t2 = [], t2.push(n2);
    }
}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.sql = {
    comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: true
    },
    variable: [
        {
            pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
            greedy: true
        },
        /@[\w.$]+/
    ],
    string: {
        pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
        greedy: true,
        lookbehind: true
    },
    identifier: {
        pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
        greedy: true,
        lookbehind: true,
        inside: {
            punctuation: /^`|`$/
        }
    },
    function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
    keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
    number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    punctuation: /[;[\]()`,.]/
}, function(b) {
    var e = b.languages.javascript["template-string"], t = e.pattern.source, m = e.inside.interpolation, f = m.inside["interpolation-punctuation"], s = m.pattern.source;
    function n(e2, n2) {
        if (b.languages[e2]) return {
            pattern: RegExp("((?:" + n2 + ")\\s*)" + t),
            lookbehind: true,
            greedy: true,
            inside: {
                "template-punctuation": {
                    pattern: /^`|`$/,
                    alias: "string"
                },
                "embedded-code": {
                    pattern: /[\s\S]+/,
                    alias: e2
                }
            }
        };
    }
    function h(e2, n2, t2) {
        e2 = {
            code: e2,
            grammar: n2,
            language: t2
        };
        return b.hooks.run("before-tokenize", e2), e2.tokens = b.tokenize(e2.code, e2.grammar), b.hooks.run("after-tokenize", e2), e2.tokens;
    }
    function l(a2, e2, r) {
        var n2 = b.tokenize(a2, {
            interpolation: {
                pattern: RegExp(s),
                lookbehind: true
            }
        }), p = 0, d = {}, n2 = h(n2.map(function(e3) {
            if ("string" == typeof e3) return e3;
            for(var n3, t2, e3 = e3.content; -1 !== a2.indexOf((t2 = p++, n3 = "___" + r.toUpperCase() + "_" + t2 + "___")););
            return d[n3] = e3, n3;
        }).join(""), e2, r), g = Object.keys(d);
        return p = 0, function e3(n3) {
            for(var t2 = 0; t2 < n3.length; t2++){
                if (p >= g.length) return;
                var a3, r2, s2, i, o, l2, u2, c = n3[t2];
                "string" == typeof c || "string" == typeof c.content ? (a3 = g[p], -1 !== (u2 = (l2 = "string" == typeof c ? c : c.content).indexOf(a3)) && (++p, r2 = l2.substring(0, u2), o = d[a3], s2 = void 0, (i = {})["interpolation-punctuation"] = f, 3 === (i = b.tokenize(o, i)).length && ((s2 = [
                    1,
                    1
                ]).push.apply(s2, h(i[1], b.languages.javascript, "javascript")), i.splice.apply(i, s2)), s2 = new b.Token("interpolation", i, m.alias, o), i = l2.substring(u2 + a3.length), o = [], r2 && o.push(r2), o.push(s2), i && (e3(l2 = [
                    i
                ]), o.push.apply(o, l2)), "string" == typeof c ? (n3.splice.apply(n3, [
                    t2,
                    1
                ].concat(o)), t2 += o.length - 1) : c.content = o)) : (u2 = c.content, Array.isArray(u2) ? e3(u2) : e3([
                    u2
                ]));
            }
        }(n2), new b.Token(r, n2, "language-" + r, a2);
    }
    b.languages.javascript["template-string"] = [
        n("css", /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source),
        n("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
        n("svg", /\bsvg/.source),
        n("markdown", /\b(?:markdown|md)/.source),
        n("graphql", /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source),
        n("sql", /\bsql/.source),
        e
    ].filter(Boolean);
    var a = {
        javascript: true,
        js: true,
        typescript: true,
        ts: true,
        jsx: true,
        tsx: true
    };
    function u(e2) {
        return "string" == typeof e2 ? e2 : Array.isArray(e2) ? e2.map(u).join("") : u(e2.content);
    }
    b.hooks.add("after-tokenize", function(e2) {
        e2.language in a && !function e3(n2) {
            for(var t2 = 0, a2 = n2.length; t2 < a2; t2++){
                var r, s2, i, o = n2[t2];
                "string" != typeof o && (r = o.content, Array.isArray(r) ? "template-string" === o.type ? (o = r[1], 3 === r.length && "string" != typeof o && "embedded-code" === o.type && (s2 = u(o), o = o.alias, o = Array.isArray(o) ? o[0] : o, i = b.languages[o]) && (r[1] = l(s2, i, o))) : e3(r) : "string" != typeof r && e3([
                    r
                ]));
            }
        }(e2.tokens);
    });
}($62601dcfdc5761fa$export$dc7257ffb0972f87), function(e) {
    e.languages.typescript = e.languages.extend("javascript", {
        "class-name": {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
            lookbehind: true,
            greedy: true,
            inside: null
        },
        builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    }), e.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
    var n = e.languages.extend("typescript", {});
    delete n["class-name"], e.languages.typescript["class-name"].inside = n, e.languages.insertBefore("typescript", "function", {
        decorator: {
            pattern: /@[$\w\xA0-\uFFFF]+/,
            inside: {
                at: {
                    pattern: /^@/,
                    alias: "operator"
                },
                function: /^[\s\S]+/
            }
        },
        "generic-function": {
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
            greedy: true,
            inside: {
                function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                generic: {
                    pattern: /<[\s\S]+/,
                    alias: "class-name",
                    inside: n
                }
            }
        }
    }), e.languages.ts = e.languages.typescript;
}($62601dcfdc5761fa$export$dc7257ffb0972f87), function(e) {
    var n = e.languages.javascript, t = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source, a = "(@(?:arg|argument|param|property)\\s+(?:" + t + "\\s+)?)";
    e.languages.jsdoc = e.languages.extend("javadoclike", {
        parameter: {
            pattern: RegExp(a + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source),
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        }
    }), e.languages.insertBefore("jsdoc", "keyword", {
        "optional-parameter": {
            pattern: RegExp(a + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source),
            lookbehind: true,
            inside: {
                parameter: {
                    pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                code: {
                    pattern: /(=)[\s\S]*(?=\]$)/,
                    lookbehind: true,
                    inside: n,
                    alias: "language-javascript"
                },
                punctuation: /[=[\]]/
            }
        },
        "class-name": [
            {
                pattern: RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
                    return t;
                })),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                pattern: RegExp("(@[a-z]+\\s+)" + t),
                lookbehind: true,
                inside: {
                    string: n.string,
                    number: n.number,
                    boolean: n.boolean,
                    keyword: e.languages.typescript.keyword,
                    operator: /=>|\.\.\.|[&|?:*]/,
                    punctuation: /[.,;=<>{}()[\]]/
                }
            }
        ],
        example: {
            pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
            lookbehind: true,
            inside: {
                code: {
                    pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
                    lookbehind: true,
                    inside: n,
                    alias: "language-javascript"
                }
            }
        }
    }), e.languages.javadoclike.addSupport("javascript", e.languages.jsdoc);
}($62601dcfdc5761fa$export$dc7257ffb0972f87), function(e) {
    e.languages.flow = e.languages.extend("javascript", {}), e.languages.insertBefore("flow", "keyword", {
        type: [
            {
                pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|[Ss]ymbol|any|mixed|null|void)\b/,
                alias: "class-name"
            }
        ]
    }), e.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete e.languages.flow.parameter, e.languages.insertBefore("flow", "operator", {
        "flow-punctuation": {
            pattern: /\{\||\|\}/,
            alias: "punctuation"
        }
    }), Array.isArray(e.languages.flow.keyword) || (e.languages.flow.keyword = [
        e.languages.flow.keyword
    ]), e.languages.flow.keyword.unshift({
        pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
        lookbehind: true
    }, {
        pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
        lookbehind: true
    });
}($62601dcfdc5761fa$export$dc7257ffb0972f87), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.n4js = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.extend("javascript", {
    keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.insertBefore("n4js", "constant", {
    annotation: {
        pattern: /@+\w+/,
        alias: "operator"
    }
}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.n4jsd = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.n4js, function(e) {
    function n(e2, n2) {
        return RegExp(e2.replace(/<ID>/g, function() {
            return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
        }), n2);
    }
    e.languages.insertBefore("javascript", "function-variable", {
        "method-variable": {
            pattern: RegExp("(\\.\\s*)" + e.languages.javascript["function-variable"].pattern.source),
            lookbehind: true,
            alias: [
                "function-variable",
                "method",
                "function",
                "property-access"
            ]
        }
    }), e.languages.insertBefore("javascript", "function", {
        method: {
            pattern: RegExp("(\\.\\s*)" + e.languages.javascript.function.source),
            lookbehind: true,
            alias: [
                "function",
                "property-access"
            ]
        }
    }), e.languages.insertBefore("javascript", "constant", {
        "known-class-name": [
            {
                pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
                alias: "class-name"
            },
            {
                pattern: /\b(?:[A-Z]\w*)Error\b/,
                alias: "class-name"
            }
        ]
    }), e.languages.insertBefore("javascript", "keyword", {
        imports: {
            pattern: n(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source),
            lookbehind: true,
            inside: e.languages.javascript
        },
        exports: {
            pattern: n(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source),
            lookbehind: true,
            inside: e.languages.javascript
        }
    }), e.languages.javascript.keyword.unshift({
        pattern: /\b(?:as|default|export|from|import)\b/,
        alias: "module"
    }, {
        pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
        alias: "control-flow"
    }, {
        pattern: /\bnull\b/,
        alias: [
            "null",
            "nil"
        ]
    }, {
        pattern: /\bundefined\b/,
        alias: "nil"
    }), e.languages.insertBefore("javascript", "operator", {
        spread: {
            pattern: /\.{3}/,
            alias: "operator"
        },
        arrow: {
            pattern: /=>/,
            alias: "operator"
        }
    }), e.languages.insertBefore("javascript", "punctuation", {
        "property-access": {
            pattern: n(/(\.\s*)#?<ID>/.source),
            lookbehind: true
        },
        "maybe-class-name": {
            pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
            lookbehind: true
        },
        dom: {
            pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
            alias: "variable"
        },
        console: {
            pattern: /\bconsole(?=\s*\.)/,
            alias: "class-name"
        }
    });
    for(var t = [
        "function",
        "function-variable",
        "method",
        "method-variable",
        "property-access"
    ], a = 0; a < t.length; a++){
        var r = t[a], s = e.languages.javascript[r], r = (s = "RegExp" === e.util.type(s) ? e.languages.javascript[r] = {
            pattern: s
        } : s).inside || {};
        (s.inside = r)["maybe-class-name"] = /^[A-Z][\s\S]*/;
    }
}($62601dcfdc5761fa$export$dc7257ffb0972f87), function(s) {
    var e = s.util.clone(s.languages.javascript), t = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, a = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, r = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
    function n(e2, n2) {
        return e2 = e2.replace(/<S>/g, function() {
            return t;
        }).replace(/<BRACES>/g, function() {
            return a;
        }).replace(/<SPREAD>/g, function() {
            return r;
        }), RegExp(e2, n2);
    }
    r = n(r).source, s.languages.jsx = s.languages.extend("markup", e), s.languages.jsx.tag.pattern = n(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), s.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, s.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, s.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, s.languages.jsx.tag.inside.comment = e.comment, s.languages.insertBefore("inside", "attr-name", {
        spread: {
            pattern: n(/<SPREAD>/.source),
            inside: s.languages.jsx
        }
    }, s.languages.jsx.tag), s.languages.insertBefore("inside", "special-attr", {
        script: {
            pattern: n(/=<BRACES>/.source),
            alias: "language-javascript",
            inside: {
                "script-punctuation": {
                    pattern: /^=(?=\{)/,
                    alias: "punctuation"
                },
                rest: s.languages.jsx
            }
        }
    }, s.languages.jsx.tag);
    function i(e2) {
        for(var n2 = [], t2 = 0; t2 < e2.length; t2++){
            var a2 = e2[t2], r2 = false;
            "string" != typeof a2 && ("tag" === a2.type && a2.content[0] && "tag" === a2.content[0].type ? "</" === a2.content[0].content[0].content ? 0 < n2.length && n2[n2.length - 1].tagName === o(a2.content[0].content[1]) && n2.pop() : "/>" !== a2.content[a2.content.length - 1].content && n2.push({
                tagName: o(a2.content[0].content[1]),
                openedBraces: 0
            }) : 0 < n2.length && "punctuation" === a2.type && "{" === a2.content ? n2[n2.length - 1].openedBraces++ : 0 < n2.length && 0 < n2[n2.length - 1].openedBraces && "punctuation" === a2.type && "}" === a2.content ? n2[n2.length - 1].openedBraces-- : r2 = true), (r2 || "string" == typeof a2) && 0 < n2.length && 0 === n2[n2.length - 1].openedBraces && (r2 = o(a2), t2 < e2.length - 1 && ("string" == typeof e2[t2 + 1] || "plain-text" === e2[t2 + 1].type) && (r2 += o(e2[t2 + 1]), e2.splice(t2 + 1, 1)), 0 < t2 && ("string" == typeof e2[t2 - 1] || "plain-text" === e2[t2 - 1].type) && (r2 = o(e2[t2 - 1]) + r2, e2.splice(t2 - 1, 1), t2--), e2[t2] = new s.Token("plain-text", r2, null, r2)), a2.content && "string" != typeof a2.content && i(a2.content);
        }
    }
    var o = function(e2) {
        return e2 ? "string" == typeof e2 ? e2 : "string" == typeof e2.content ? e2.content : e2.content.map(o).join("") : "";
    };
    s.hooks.add("after-tokenize", function(e2) {
        "jsx" !== e2.language && "tsx" !== e2.language || i(e2.tokens);
    });
}($62601dcfdc5761fa$export$dc7257ffb0972f87), function(e) {
    var n = e.util.clone(e.languages.typescript), n = (e.languages.tsx = e.languages.extend("jsx", n), delete e.languages.tsx.parameter, delete e.languages.tsx["literal-property"], e.languages.tsx.tag);
    n.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + "(?:" + n.pattern.source + ")", n.pattern.flags), n.lookbehind = true;
}($62601dcfdc5761fa$export$dc7257ffb0972f87), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.swift = {
    comment: {
        pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
        lookbehind: true,
        greedy: true
    },
    "string-literal": [
        {
            pattern: RegExp(/(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null
                },
                "interpolation-punctuation": {
                    pattern: /^\)|\\\($/,
                    alias: "punctuation"
                },
                punctuation: /\\(?=[\r\n])/,
                string: /[\s\S]+/
            }
        },
        {
            pattern: RegExp(/(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null
                },
                "interpolation-punctuation": {
                    pattern: /^\)|\\#+\($/,
                    alias: "punctuation"
                },
                string: /[\s\S]+/
            }
        }
    ],
    directive: {
        pattern: RegExp(/#/.source + "(?:" + /(?:elseif|if)\b/.source + "(?:[ 	]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+|" + /(?:else|endif)\b/.source + ")"),
        alias: "property",
        inside: {
            "directive-name": /^#\w+/,
            boolean: /\b(?:false|true)\b/,
            number: /\b\d+(?:\.\d+)*\b/,
            operator: /!|&&|\|\||[<>]=?/,
            punctuation: /[(),]/
        }
    },
    literal: {
        pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
        alias: "constant"
    },
    "other-directive": {
        pattern: /#\w+\b/,
        alias: "property"
    },
    attribute: {
        pattern: /@\w+/,
        alias: "atrule"
    },
    "function-definition": {
        pattern: /(\bfunc\s+)\w+/,
        lookbehind: true,
        alias: "function"
    },
    label: {
        pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
        lookbehind: true,
        alias: "important"
    },
    keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
    boolean: /\b(?:false|true)\b/,
    nil: {
        pattern: /\bnil\b/,
        alias: "constant"
    },
    "short-argument": /\$\d+\b/,
    omit: {
        pattern: /\b_\b/,
        alias: "keyword"
    },
    number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
    punctuation: /[{}[\]();,.:\\]/
}, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.swift["string-literal"].forEach(function(e) {
    e.inside.interpolation.inside = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.swift;
}), function(e) {
    e.languages.kotlin = e.languages.extend("clike", {
        keyword: {
            pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
            lookbehind: true
        },
        function: [
            {
                pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
                greedy: true
            },
            {
                pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
                lookbehind: true,
                greedy: true
            }
        ],
        number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
        operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
    }), delete e.languages.kotlin["class-name"];
    var n = {
        "interpolation-punctuation": {
            pattern: /^\$\{?|\}$/,
            alias: "punctuation"
        },
        expression: {
            pattern: /[\s\S]+/,
            inside: e.languages.kotlin
        }
    };
    e.languages.insertBefore("kotlin", "string", {
        "string-literal": [
            {
                pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
                alias: "multiline",
                inside: {
                    interpolation: {
                        pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                        inside: n
                    },
                    string: /[\s\S]+/
                }
            },
            {
                pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
                alias: "singleline",
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                        lookbehind: true,
                        inside: n
                    },
                    string: /[\s\S]+/
                }
            }
        ],
        char: {
            pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
            greedy: true
        }
    }), delete e.languages.kotlin.string, e.languages.insertBefore("kotlin", "keyword", {
        annotation: {
            pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
            alias: "builtin"
        }
    }), e.languages.insertBefore("kotlin", "function", {
        label: {
            pattern: /\b\w+@|@\w+\b/,
            alias: "symbol"
        }
    }), e.languages.kt = e.languages.kotlin, e.languages.kts = e.languages.kotlin;
}($62601dcfdc5761fa$export$dc7257ffb0972f87), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.c = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.extend("clike", {
    comment: {
        pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
        lookbehind: true
    },
    keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.insertBefore("c", "string", {
    char: {
        pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
        greedy: true
    }
}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.insertBefore("c", "string", {
    macro: {
        pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: true,
        greedy: true,
        alias: "property",
        inside: {
            string: [
                {
                    pattern: /^(#\s*include\s*)<[^>]+>/,
                    lookbehind: true
                },
                $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.c.string
            ],
            char: $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.c.char,
            comment: $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.c.comment,
            "macro-name": [
                {
                    pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                    lookbehind: true
                },
                {
                    pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                    lookbehind: true,
                    alias: "function"
                }
            ],
            directive: {
                pattern: /^(#\s*)[a-z]+/,
                lookbehind: true,
                alias: "keyword"
            },
            "directive-hash": /^#/,
            punctuation: /##|\\(?=[\r\n])/,
            expression: {
                pattern: /\S[\s\S]*/,
                inside: $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.c
            }
        }
    }
}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.insertBefore("c", "function", {
    constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
}), delete $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.c.boolean, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.objectivec = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.extend("c", {
    string: {
        pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
}), delete $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.objectivec["class-name"], $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.objc = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.objectivec, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.reason = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.extend("clike", {
    string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
        greedy: true
    },
    "class-name": /\b[A-Z]\w*/,
    keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
    operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.insertBefore("reason", "class-name", {
    char: {
        pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
        greedy: true
    },
    constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
    label: {
        pattern: /\b[a-z]\w*(?=::)/,
        alias: "symbol"
    }
}), delete $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.reason.function, function(e) {
    for(var n = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, t = 0; t < 2; t++)n = n.replace(/<self>/g, function() {
        return n;
    });
    n = n.replace(/<self>/g, function() {
        return /[^\s\S]/.source;
    }), e.languages.rust = {
        comment: [
            {
                pattern: RegExp(/(^|[^\\])/.source + n),
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
            greedy: true
        },
        char: {
            pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
            greedy: true
        },
        attribute: {
            pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
            greedy: true,
            alias: "attr-name",
            inside: {
                string: null
            }
        },
        "closure-params": {
            pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
            lookbehind: true,
            greedy: true,
            inside: {
                "closure-punctuation": {
                    pattern: /^\||\|$/,
                    alias: "punctuation"
                },
                rest: null
            }
        },
        "lifetime-annotation": {
            pattern: /'\w+/,
            alias: "symbol"
        },
        "fragment-specifier": {
            pattern: /(\$\w+:)[a-z]+/,
            lookbehind: true,
            alias: "punctuation"
        },
        variable: /\$\w+/,
        "function-definition": {
            pattern: /(\bfn\s+)\w+/,
            lookbehind: true,
            alias: "function"
        },
        "type-definition": {
            pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
            lookbehind: true,
            alias: "class-name"
        },
        "module-declaration": [
            {
                pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                lookbehind: true,
                alias: "namespace"
            },
            {
                pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                lookbehind: true,
                alias: "namespace",
                inside: {
                    punctuation: /::/
                }
            }
        ],
        keyword: [
            /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
            /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
        ],
        function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
        macro: {
            pattern: /\b\w+!/,
            alias: "property"
        },
        constant: /\b[A-Z_][A-Z_\d]+\b/,
        "class-name": /\b[A-Z]\w*\b/,
        namespace: {
            pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
            inside: {
                punctuation: /::/
            }
        },
        number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
        boolean: /\b(?:false|true)\b/,
        punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
        operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    }, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
}($62601dcfdc5761fa$export$dc7257ffb0972f87), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.go = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.extend("clike", {
    string: {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
        lookbehind: true,
        greedy: true
    },
    keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
    boolean: /\b(?:_|false|iota|nil|true)\b/,
    number: [
        /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
        /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
    ],
    operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
    builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
}), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.insertBefore("go", "string", {
    char: {
        pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
        greedy: true
    }
}), delete $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.go["class-name"], function(e) {
    var n = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, t = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
        return n.source;
    });
    e.languages.cpp = e.languages.extend("c", {
        "class-name": [
            {
                pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                    return n.source;
                })),
                lookbehind: true
            },
            /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
            /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
            /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
        ],
        keyword: n,
        number: {
            pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
            greedy: true
        },
        operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
        boolean: /\b(?:false|true)\b/
    }), e.languages.insertBefore("cpp", "string", {
        module: {
            pattern: RegExp(/(\b(?:import|module)\s+)/.source + "(?:" + /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
                return t;
            }) + ")"),
            lookbehind: true,
            greedy: true,
            inside: {
                string: /^[<"][\s\S]+/,
                operator: /:/,
                punctuation: /\./
            }
        },
        "raw-string": {
            pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
            alias: "string",
            greedy: true
        }
    }), e.languages.insertBefore("cpp", "keyword", {
        "generic-function": {
            pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
            inside: {
                function: /^\w+/,
                generic: {
                    pattern: /<[\s\S]+/,
                    alias: "class-name",
                    inside: e.languages.cpp
                }
            }
        }
    }), e.languages.insertBefore("cpp", "operator", {
        "double-colon": {
            pattern: /::/,
            alias: "punctuation"
        }
    }), e.languages.insertBefore("cpp", "class-name", {
        "base-clause": {
            pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
            lookbehind: true,
            greedy: true,
            inside: e.languages.extend("cpp", {})
        }
    }), e.languages.insertBefore("inside", "double-colon", {
        "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
    }, e.languages.cpp["base-clause"]);
}($62601dcfdc5761fa$export$dc7257ffb0972f87), $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.python = {
    comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true,
        greedy: true
    },
    "string-interpolation": {
        pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
        greedy: true,
        inside: {
            interpolation: {
                pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                lookbehind: true,
                inside: {
                    "format-spec": {
                        pattern: /(:)[^:(){}]+(?=\}$)/,
                        lookbehind: true
                    },
                    "conversion-option": {
                        pattern: /![sra](?=[:}]$)/,
                        alias: "punctuation"
                    },
                    rest: null
                }
            },
            string: /[\s\S]+/
        }
    },
    "triple-quoted-string": {
        pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
        greedy: true,
        alias: "string"
    },
    string: {
        pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: true
    },
    function: {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: true
    },
    "class-name": {
        pattern: /(\bclass\s+)\w+/i,
        lookbehind: true
    },
    decorator: {
        pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
        lookbehind: true,
        alias: [
            "annotation",
            "punctuation"
        ],
        inside: {
            punctuation: /\./
        }
    },
    keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    boolean: /\b(?:False|None|True)\b/,
    number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    punctuation: /[{}[\];(),.:]/
}, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.python["string-interpolation"].inside.interpolation.inside.rest = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.python, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.py = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.python, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.json = {
    property: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
        lookbehind: true,
        greedy: true
    },
    string: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
        lookbehind: true,
        greedy: true
    },
    comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    punctuation: /[{}[\],]/,
    operator: /:/,
    boolean: /\b(?:false|true)\b/,
    null: {
        pattern: /\bnull\b/,
        alias: "keyword"
    }
}, $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.webmanifest = $62601dcfdc5761fa$export$dc7257ffb0972f87.languages.json;
// src/themes/index.ts
var $62601dcfdc5761fa$export$d9a33280f07116d9 = {};
$62601dcfdc5761fa$var$__export($62601dcfdc5761fa$export$d9a33280f07116d9, {
    dracula: ()=>$62601dcfdc5761fa$var$dracula_default,
    duotoneDark: ()=>$62601dcfdc5761fa$var$duotoneDark_default,
    duotoneLight: ()=>$62601dcfdc5761fa$var$duotoneLight_default,
    github: ()=>$62601dcfdc5761fa$var$github_default,
    gruvboxMaterialDark: ()=>$62601dcfdc5761fa$var$gruvboxMaterialDark_default,
    gruvboxMaterialLight: ()=>$62601dcfdc5761fa$var$gruvboxMaterialLight_default,
    jettwaveDark: ()=>$62601dcfdc5761fa$var$jettwaveDark_default,
    jettwaveLight: ()=>$62601dcfdc5761fa$var$jettwaveLight_default,
    nightOwl: ()=>$62601dcfdc5761fa$var$nightOwl_default,
    nightOwlLight: ()=>$62601dcfdc5761fa$var$nightOwlLight_default,
    oceanicNext: ()=>$62601dcfdc5761fa$var$oceanicNext_default,
    okaidia: ()=>$62601dcfdc5761fa$var$okaidia_default,
    oneDark: ()=>$62601dcfdc5761fa$var$oneDark_default,
    oneLight: ()=>$62601dcfdc5761fa$var$oneLight_default,
    palenight: ()=>$62601dcfdc5761fa$var$palenight_default,
    shadesOfPurple: ()=>$62601dcfdc5761fa$var$shadesOfPurple_default,
    synthwave84: ()=>$62601dcfdc5761fa$var$synthwave84_default,
    ultramin: ()=>$62601dcfdc5761fa$var$ultramin_default,
    vsDark: ()=>$62601dcfdc5761fa$var$vsDark_default,
    vsLight: ()=>$62601dcfdc5761fa$var$vsLight_default
});
// src/themes/dracula.ts
var $62601dcfdc5761fa$var$theme = {
    plain: {
        color: "#F8F8F2",
        backgroundColor: "#282A36"
    },
    styles: [
        {
            types: [
                "prolog",
                "constant",
                "builtin"
            ],
            style: {
                color: "rgb(189, 147, 249)"
            }
        },
        {
            types: [
                "inserted",
                "function"
            ],
            style: {
                color: "rgb(80, 250, 123)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgb(255, 85, 85)"
            }
        },
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(255, 184, 108)"
            }
        },
        {
            types: [
                "punctuation",
                "symbol"
            ],
            style: {
                color: "rgb(248, 248, 242)"
            }
        },
        {
            types: [
                "string",
                "char",
                "tag",
                "selector"
            ],
            style: {
                color: "rgb(255, 121, 198)"
            }
        },
        {
            types: [
                "keyword",
                "variable"
            ],
            style: {
                color: "rgb(189, 147, 249)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(98, 114, 164)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(241, 250, 140)"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$dracula_default = $62601dcfdc5761fa$var$theme;
// src/themes/duotoneDark.ts
var $62601dcfdc5761fa$var$theme2 = {
    plain: {
        backgroundColor: "#2a2734",
        color: "#9a86fd"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata",
                "punctuation"
            ],
            style: {
                color: "#6c6783"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "operator",
                "number"
            ],
            style: {
                color: "#e09142"
            }
        },
        {
            types: [
                "property",
                "function"
            ],
            style: {
                color: "#9a86fd"
            }
        },
        {
            types: [
                "tag-id",
                "selector",
                "atrule-id"
            ],
            style: {
                color: "#eeebff"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#c4b9fe"
            }
        },
        {
            types: [
                "boolean",
                "string",
                "entity",
                "url",
                "attr-value",
                "keyword",
                "control",
                "directive",
                "unit",
                "statement",
                "regex",
                "atrule",
                "placeholder",
                "variable"
            ],
            style: {
                color: "#ffcc99"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "#c4b9fe"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$duotoneDark_default = $62601dcfdc5761fa$var$theme2;
// src/themes/duotoneLight.ts
var $62601dcfdc5761fa$var$theme3 = {
    plain: {
        backgroundColor: "#faf8f5",
        color: "#728fcb"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata",
                "punctuation"
            ],
            style: {
                color: "#b6ad9a"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "operator",
                "number"
            ],
            style: {
                color: "#063289"
            }
        },
        {
            types: [
                "property",
                "function"
            ],
            style: {
                color: "#b29762"
            }
        },
        {
            types: [
                "tag-id",
                "selector",
                "atrule-id"
            ],
            style: {
                color: "#2d2006"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#896724"
            }
        },
        {
            types: [
                "boolean",
                "string",
                "entity",
                "url",
                "attr-value",
                "keyword",
                "control",
                "directive",
                "unit",
                "statement",
                "regex",
                "atrule"
            ],
            style: {
                color: "#728fcb"
            }
        },
        {
            types: [
                "placeholder",
                "variable"
            ],
            style: {
                color: "#93abdc"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "#896724"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$duotoneLight_default = $62601dcfdc5761fa$var$theme3;
// src/themes/github.ts
var $62601dcfdc5761fa$var$theme4 = {
    plain: {
        color: "#393A34",
        backgroundColor: "#f6f8fa"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata"
            ],
            style: {
                color: "#999988",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "string",
                "attr-value"
            ],
            style: {
                color: "#e3116c"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#393A34"
            }
        },
        {
            types: [
                "entity",
                "url",
                "symbol",
                "number",
                "boolean",
                "variable",
                "constant",
                "property",
                "regex",
                "inserted"
            ],
            style: {
                color: "#36acaa"
            }
        },
        {
            types: [
                "atrule",
                "keyword",
                "attr-name",
                "selector"
            ],
            style: {
                color: "#00a4db"
            }
        },
        {
            types: [
                "function",
                "deleted",
                "tag"
            ],
            style: {
                color: "#d73a49"
            }
        },
        {
            types: [
                "function-variable"
            ],
            style: {
                color: "#6f42c1"
            }
        },
        {
            types: [
                "tag",
                "selector",
                "keyword"
            ],
            style: {
                color: "#00009f"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$github_default = $62601dcfdc5761fa$var$theme4;
// src/themes/nightOwl.ts
var $62601dcfdc5761fa$var$theme5 = {
    plain: {
        color: "#d6deeb",
        backgroundColor: "#011627"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted",
                "attr-name"
            ],
            style: {
                color: "rgb(173, 219, 103)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(99, 119, 119)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "rgb(173, 219, 103)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(214, 222, 235)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(247, 140, 108)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function"
            ],
            style: {
                color: "rgb(130, 170, 255)"
            }
        },
        {
            // This was manually added after the auto-generation
            // so that punctuations are not italicised
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(199, 146, 234)"
            }
        },
        {
            types: [
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(199, 146, 234)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(255, 203, 139)"
            }
        },
        {
            types: [
                "tag",
                "operator",
                "keyword"
            ],
            style: {
                color: "rgb(127, 219, 202)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(255, 88, 116)"
            }
        },
        {
            types: [
                "property"
            ],
            style: {
                color: "rgb(128, 203, 196)"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$nightOwl_default = $62601dcfdc5761fa$var$theme5;
// src/themes/nightOwlLight.ts
var $62601dcfdc5761fa$var$theme6 = {
    plain: {
        color: "#403f53",
        backgroundColor: "#FBFBFB"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted",
                "attr-name"
            ],
            style: {
                color: "rgb(72, 118, 214)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(152, 159, 177)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "builtin",
                "char",
                "constant",
                "url"
            ],
            style: {
                color: "rgb(72, 118, 214)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(201, 103, 101)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(170, 9, 130)"
            }
        },
        {
            // This was manually added after the auto-generation
            // so that punctuations are not italicised
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(153, 76, 195)"
            }
        },
        {
            types: [
                "function",
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(153, 76, 195)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(17, 17, 17)"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "rgb(153, 76, 195)"
            }
        },
        {
            types: [
                "operator",
                "property",
                "keyword",
                "namespace"
            ],
            style: {
                color: "rgb(12, 150, 155)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(188, 84, 84)"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$nightOwlLight_default = $62601dcfdc5761fa$var$theme6;
// src/themes/oceanicNext.ts
var $62601dcfdc5761fa$var$colors = {
    char: "#D8DEE9",
    comment: "#999999",
    keyword: "#c5a5c5",
    primitive: "#5a9bcf",
    string: "#8dc891",
    variable: "#d7deea",
    boolean: "#ff8b50",
    punctuation: "#5FB3B3",
    tag: "#fc929e",
    function: "#79b6f2",
    className: "#FAC863",
    method: "#6699CC",
    operator: "#fc929e"
};
var $62601dcfdc5761fa$var$theme7 = {
    plain: {
        backgroundColor: "#282c34",
        color: "#ffffff"
    },
    styles: [
        {
            types: [
                "attr-name"
            ],
            style: {
                color: $62601dcfdc5761fa$var$colors.keyword
            }
        },
        {
            types: [
                "attr-value"
            ],
            style: {
                color: $62601dcfdc5761fa$var$colors.string
            }
        },
        {
            types: [
                "comment",
                "block-comment",
                "prolog",
                "doctype",
                "cdata",
                "shebang"
            ],
            style: {
                color: $62601dcfdc5761fa$var$colors.comment
            }
        },
        {
            types: [
                "property",
                "number",
                "function-name",
                "constant",
                "symbol",
                "deleted"
            ],
            style: {
                color: $62601dcfdc5761fa$var$colors.primitive
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: $62601dcfdc5761fa$var$colors.boolean
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: $62601dcfdc5761fa$var$colors.tag
            }
        },
        {
            types: [
                "string"
            ],
            style: {
                color: $62601dcfdc5761fa$var$colors.string
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: $62601dcfdc5761fa$var$colors.string
            }
        },
        {
            types: [
                "selector",
                "char",
                "builtin",
                "inserted"
            ],
            style: {
                color: $62601dcfdc5761fa$var$colors.char
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: $62601dcfdc5761fa$var$colors.function
            }
        },
        {
            types: [
                "operator",
                "entity",
                "url",
                "variable"
            ],
            style: {
                color: $62601dcfdc5761fa$var$colors.variable
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: $62601dcfdc5761fa$var$colors.keyword
            }
        },
        {
            types: [
                "atrule",
                "class-name"
            ],
            style: {
                color: $62601dcfdc5761fa$var$colors.className
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                fontWeight: "400"
            }
        },
        {
            types: [
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        }
    ]
};
var $62601dcfdc5761fa$var$oceanicNext_default = $62601dcfdc5761fa$var$theme7;
// src/themes/okaidia.ts
var $62601dcfdc5761fa$var$theme8 = {
    plain: {
        color: "#f8f8f2",
        backgroundColor: "#272822"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "#f92672",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "rgb(173, 219, 103)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#8292a2",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "#a6e22e"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "#f8f8f2"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "#ae81ff"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function",
                "class-name"
            ],
            style: {
                color: "#e6db74"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "#f8f8f2"
            }
        },
        {
            types: [
                "selector",
                "doctype"
            ],
            style: {
                color: "#a6e22e",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "tag",
                "operator",
                "keyword"
            ],
            style: {
                color: "#66d9ef"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "#ae81ff"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)",
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "property"
            ],
            style: {
                color: "#f92672"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#a6e22e !important"
            }
        },
        {
            types: [
                "doctype"
            ],
            style: {
                color: "#8292a2"
            }
        },
        {
            types: [
                "rule"
            ],
            style: {
                color: "#e6db74"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$okaidia_default = $62601dcfdc5761fa$var$theme8;
// src/themes/palenight.ts
var $62601dcfdc5761fa$var$theme9 = {
    plain: {
        color: "#bfc7d5",
        backgroundColor: "#292d3e"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(105, 112, 152)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "inserted"
            ],
            style: {
                color: "rgb(195, 232, 141)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(247, 140, 108)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function"
            ],
            style: {
                color: "rgb(130, 170, 255)"
            }
        },
        {
            types: [
                "punctuation",
                "selector"
            ],
            style: {
                color: "rgb(199, 146, 234)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(191, 199, 213)"
            }
        },
        {
            types: [
                "class-name",
                "attr-name"
            ],
            style: {
                color: "rgb(255, 203, 107)"
            }
        },
        {
            types: [
                "tag",
                "deleted"
            ],
            style: {
                color: "rgb(255, 85, 114)"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "rgb(137, 221, 255)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(255, 88, 116)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "doctype"
            ],
            style: {
                color: "rgb(199, 146, 234)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "rgb(221, 221, 221)"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$palenight_default = $62601dcfdc5761fa$var$theme9;
// src/themes/shadesOfPurple.ts
var $62601dcfdc5761fa$var$theme10 = {
    plain: {
        color: "#9EFEFF",
        backgroundColor: "#2D2A55"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(255, 238, 128)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "rgb(173, 219, 103)"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(179, 98, 255)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(255, 255, 255)"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "rgb(255, 98, 140)"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "rgb(165, 255, 144)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(255, 238, 128)"
            }
        },
        {
            types: [
                "number",
                "boolean"
            ],
            style: {
                color: "rgb(255, 98, 140)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(255, 180, 84)"
            }
        },
        {
            types: [
                "keyword",
                "operator",
                "property",
                "namespace",
                "tag",
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(255, 157, 0)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function",
                "class-name"
            ],
            style: {
                color: "rgb(250, 208, 0)"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$shadesOfPurple_default = $62601dcfdc5761fa$var$theme10;
// src/themes/synthwave84.ts
var $62601dcfdc5761fa$var$theme11 = {
    plain: {
        backgroundColor: "linear-gradient(to bottom, #2a2139 75%, #34294f)",
        backgroundImage: "#34294f",
        color: "#f92aad",
        textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
    },
    styles: [
        {
            types: [
                "comment",
                "block-comment",
                "prolog",
                "doctype",
                "cdata"
            ],
            style: {
                color: "#495495",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "#ccc"
            }
        },
        {
            types: [
                "tag",
                "attr-name",
                "namespace",
                "number",
                "unit",
                "hexcode",
                "deleted"
            ],
            style: {
                color: "#e2777a"
            }
        },
        {
            types: [
                "property",
                "selector"
            ],
            style: {
                color: "#72f1b8",
                textShadow: "0 0 2px #100c0f, 0 0 10px #257c5575, 0 0 35px #21272475"
            }
        },
        {
            types: [
                "function-name"
            ],
            style: {
                color: "#6196cc"
            }
        },
        {
            types: [
                "boolean",
                "selector-id",
                "function"
            ],
            style: {
                color: "#fdfdfd",
                textShadow: "0 0 2px #001716, 0 0 3px #03edf975, 0 0 5px #03edf975, 0 0 8px #03edf975"
            }
        },
        {
            types: [
                "class-name",
                "maybe-class-name",
                "builtin"
            ],
            style: {
                color: "#fff5f6",
                textShadow: "0 0 2px #000, 0 0 10px #fc1f2c75, 0 0 5px #fc1f2c75, 0 0 25px #fc1f2c75"
            }
        },
        {
            types: [
                "constant",
                "symbol"
            ],
            style: {
                color: "#f92aad",
                textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
            }
        },
        {
            types: [
                "important",
                "atrule",
                "keyword",
                "selector-class"
            ],
            style: {
                color: "#f4eee4",
                textShadow: "0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575"
            }
        },
        {
            types: [
                "string",
                "char",
                "attr-value",
                "regex",
                "variable"
            ],
            style: {
                color: "#f87c32"
            }
        },
        {
            types: [
                "parameter"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "entity",
                "url"
            ],
            style: {
                color: "#67cdcc"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "ffffffee"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "entity"
            ],
            style: {
                cursor: "help"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "green"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$synthwave84_default = $62601dcfdc5761fa$var$theme11;
// src/themes/ultramin.ts
var $62601dcfdc5761fa$var$theme12 = {
    plain: {
        color: "#282a2e",
        backgroundColor: "#ffffff"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(197, 200, 198)"
            }
        },
        {
            types: [
                "string",
                "number",
                "builtin",
                "variable"
            ],
            style: {
                color: "rgb(150, 152, 150)"
            }
        },
        {
            types: [
                "class-name",
                "function",
                "tag",
                "attr-name"
            ],
            style: {
                color: "rgb(40, 42, 46)"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$ultramin_default = $62601dcfdc5761fa$var$theme12;
// src/themes/vsDark.ts
var $62601dcfdc5761fa$var$theme13 = {
    plain: {
        color: "#9CDCFE",
        backgroundColor: "#1E1E1E"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "rgb(0, 0, 128)"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(106, 153, 85)"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "rgb(86, 156, 214)"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "rgb(181, 206, 168)"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "rgb(100, 102, 149)"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "rgb(156, 220, 254)"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "rgb(206, 145, 120)"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "rgb(215, 186, 125)"
            }
        },
        {
            // Fix tag color
            types: [
                "tag"
            ],
            style: {
                color: "rgb(78, 201, 176)"
            }
        },
        {
            // Fix tag color for HTML
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "rgb(86, 156, 214)"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "rgb(212, 212, 212)"
            }
        },
        {
            // Fix punctuation color for HTML
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "rgb(220, 220, 170)"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(78, 201, 176)"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "rgb(209, 105, 105)"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$vsDark_default = $62601dcfdc5761fa$var$theme13;
// src/themes/vsLight.ts
var $62601dcfdc5761fa$var$theme14 = {
    plain: {
        color: "#000000",
        backgroundColor: "#ffffff"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(0, 128, 0)"
            }
        },
        {
            types: [
                "builtin"
            ],
            style: {
                color: "rgb(0, 112, 193)"
            }
        },
        {
            types: [
                "number",
                "variable",
                "inserted"
            ],
            style: {
                color: "rgb(9, 134, 88)"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "rgb(0, 0, 0)"
            }
        },
        {
            types: [
                "constant",
                "char"
            ],
            style: {
                color: "rgb(129, 31, 63)"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "rgb(128, 0, 0)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(255, 0, 0)"
            }
        },
        {
            types: [
                "deleted",
                "string"
            ],
            style: {
                color: "rgb(163, 21, 21)"
            }
        },
        {
            types: [
                "changed",
                "punctuation"
            ],
            style: {
                color: "rgb(4, 81, 165)"
            }
        },
        {
            types: [
                "function",
                "keyword"
            ],
            style: {
                color: "rgb(0, 0, 255)"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(38, 127, 153)"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$vsLight_default = $62601dcfdc5761fa$var$theme14;
// src/themes/jettwaveDark.ts
var $62601dcfdc5761fa$var$theme15 = {
    plain: {
        color: "#f8fafc",
        backgroundColor: "#011627"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "#000080"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#6A9955"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "#569CD6"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "#B5CEA8"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "#f8fafc"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "#9CDCFE"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "#cbd5e1"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "#D7BA7D"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#D4D4D4"
            }
        },
        {
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "#7dd3fc"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "#D16969"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$jettwaveDark_default = $62601dcfdc5761fa$var$theme15;
// src/themes/jettwaveLight.ts
var $62601dcfdc5761fa$var$theme16 = {
    plain: {
        color: "#0f172a",
        backgroundColor: "#f1f5f9"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "#000080"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#6A9955"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "#0c4a6e"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "#B5CEA8"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "#0f172a"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "#0c4a6e"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "#64748b"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "#D7BA7D"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#475569"
            }
        },
        {
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "#0e7490"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "#D16969"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$jettwaveLight_default = $62601dcfdc5761fa$var$theme16;
// src/themes/oneDark.ts
var $62601dcfdc5761fa$var$theme17 = {
    plain: {
        backgroundColor: "hsl(220, 13%, 18%)",
        color: "hsl(220, 14%, 71%)",
        textShadow: "0 1px rgba(0, 0, 0, 0.3)"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "cdata"
            ],
            style: {
                color: "hsl(220, 10%, 40%)"
            }
        },
        {
            types: [
                "doctype",
                "punctuation",
                "entity"
            ],
            style: {
                color: "hsl(220, 14%, 71%)"
            }
        },
        {
            types: [
                "attr-name",
                "class-name",
                "maybe-class-name",
                "boolean",
                "constant",
                "number",
                "atrule"
            ],
            style: {
                color: "hsl(29, 54%, 61%)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: "hsl(286, 60%, 67%)"
            }
        },
        {
            types: [
                "property",
                "tag",
                "symbol",
                "deleted",
                "important"
            ],
            style: {
                color: "hsl(355, 65%, 65%)"
            }
        },
        {
            types: [
                "selector",
                "string",
                "char",
                "builtin",
                "inserted",
                "regex",
                "attr-value"
            ],
            style: {
                color: "hsl(95, 38%, 62%)"
            }
        },
        {
            types: [
                "variable",
                "operator",
                "function"
            ],
            style: {
                color: "hsl(207, 82%, 66%)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "hsl(187, 47%, 55%)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "hsl(220, 14%, 71%)"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$oneDark_default = $62601dcfdc5761fa$var$theme17;
// src/themes/oneLight.ts
var $62601dcfdc5761fa$var$theme18 = {
    plain: {
        backgroundColor: "hsl(230, 1%, 98%)",
        color: "hsl(230, 8%, 24%)"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "cdata"
            ],
            style: {
                color: "hsl(230, 4%, 64%)"
            }
        },
        {
            types: [
                "doctype",
                "punctuation",
                "entity"
            ],
            style: {
                color: "hsl(230, 8%, 24%)"
            }
        },
        {
            types: [
                "attr-name",
                "class-name",
                "boolean",
                "constant",
                "number",
                "atrule"
            ],
            style: {
                color: "hsl(35, 99%, 36%)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: "hsl(301, 63%, 40%)"
            }
        },
        {
            types: [
                "property",
                "tag",
                "symbol",
                "deleted",
                "important"
            ],
            style: {
                color: "hsl(5, 74%, 59%)"
            }
        },
        {
            types: [
                "selector",
                "string",
                "char",
                "builtin",
                "inserted",
                "regex",
                "attr-value",
                "punctuation"
            ],
            style: {
                color: "hsl(119, 34%, 47%)"
            }
        },
        {
            types: [
                "variable",
                "operator",
                "function"
            ],
            style: {
                color: "hsl(221, 87%, 60%)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "hsl(198, 99%, 37%)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "hsl(230, 8%, 24%)"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$oneLight_default = $62601dcfdc5761fa$var$theme18;
// src/themes/gruvboxMaterialDark.ts
var $62601dcfdc5761fa$var$theme19 = {
    plain: {
        color: "#ebdbb2",
        backgroundColor: "#292828"
    },
    styles: [
        {
            types: [
                "imports",
                "class-name",
                "maybe-class-name",
                "constant",
                "doctype",
                "builtin",
                "function"
            ],
            style: {
                color: "#d8a657"
            }
        },
        {
            types: [
                "property-access"
            ],
            style: {
                color: "#7daea3"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#e78a4e"
            }
        },
        {
            types: [
                "attr-name",
                "char",
                "url",
                "regex"
            ],
            style: {
                color: "#a9b665"
            }
        },
        {
            types: [
                "attr-value",
                "string"
            ],
            style: {
                color: "#89b482"
            }
        },
        {
            types: [
                "comment",
                "prolog",
                "cdata",
                "operator",
                "inserted"
            ],
            style: {
                color: "#a89984"
            }
        },
        {
            types: [
                "delimiter",
                "boolean",
                "keyword",
                "selector",
                "important",
                "atrule",
                "property",
                "variable",
                "deleted"
            ],
            style: {
                color: "#ea6962"
            }
        },
        {
            types: [
                "entity",
                "number",
                "symbol"
            ],
            style: {
                color: "#d3869b"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$gruvboxMaterialDark_default = $62601dcfdc5761fa$var$theme19;
// src/themes/gruvboxMaterialLight.ts
var $62601dcfdc5761fa$var$theme20 = {
    plain: {
        color: "#654735",
        backgroundColor: "#f9f5d7"
    },
    styles: [
        {
            types: [
                "delimiter",
                "boolean",
                "keyword",
                "selector",
                "important",
                "atrule",
                "property",
                "variable",
                "deleted"
            ],
            style: {
                color: "#af2528"
            }
        },
        {
            types: [
                "imports",
                "class-name",
                "maybe-class-name",
                "constant",
                "doctype",
                "builtin"
            ],
            style: {
                color: "#b4730e"
            }
        },
        {
            types: [
                "string",
                "attr-value"
            ],
            style: {
                color: "#477a5b"
            }
        },
        {
            types: [
                "property-access"
            ],
            style: {
                color: "#266b79"
            }
        },
        {
            types: [
                "function",
                "attr-name",
                "char",
                "url"
            ],
            style: {
                color: "#72761e"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#b94c07"
            }
        },
        {
            types: [
                "comment",
                "prolog",
                "cdata",
                "operator",
                "inserted"
            ],
            style: {
                color: "#a89984"
            }
        },
        {
            types: [
                "entity",
                "number",
                "symbol"
            ],
            style: {
                color: "#924f79"
            }
        }
    ]
};
var $62601dcfdc5761fa$var$gruvboxMaterialLight_default = $62601dcfdc5761fa$var$theme20;
var $62601dcfdc5761fa$var$useGetLineProps = (themeDictionary)=>(0, $7DB8U.useCallback)((_a)=>{
        var _b = _a, { className: className, style: style, line: line } = _b, rest = $62601dcfdc5761fa$var$__objRest(_b, [
            "className",
            "style",
            "line"
        ]);
        const output = $62601dcfdc5761fa$var$__spreadProps($62601dcfdc5761fa$var$__spreadValues({}, rest), {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)("token-line", className)
        });
        if (typeof themeDictionary === "object" && "plain" in themeDictionary) output.style = themeDictionary.plain;
        if (typeof style === "object") output.style = $62601dcfdc5761fa$var$__spreadValues($62601dcfdc5761fa$var$__spreadValues({}, output.style || {}), style);
        return output;
    }, [
        themeDictionary
    ]);
var $62601dcfdc5761fa$var$useGetTokenProps = (themeDictionary)=>{
    const styleForToken = (0, $7DB8U.useCallback)(({ types: types, empty: empty })=>{
        if (themeDictionary == null) return void 0;
        else if (types.length === 1 && types[0] === "plain") return empty != null ? {
            display: "inline-block"
        } : void 0;
        else if (types.length === 1 && empty != null) return themeDictionary[types[0]];
        return Object.assign(empty != null ? {
            display: "inline-block"
        } : {}, ...types.map((type)=>themeDictionary[type]));
    }, [
        themeDictionary
    ]);
    return (0, $7DB8U.useCallback)((_a)=>{
        var _b = _a, { token: token, className: className, style: style } = _b, rest = $62601dcfdc5761fa$var$__objRest(_b, [
            "token",
            "className",
            "style"
        ]);
        const output = $62601dcfdc5761fa$var$__spreadProps($62601dcfdc5761fa$var$__spreadValues({}, rest), {
            className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)("token", ...token.types, className),
            children: token.content,
            style: styleForToken(token)
        });
        if (style != null) output.style = $62601dcfdc5761fa$var$__spreadValues($62601dcfdc5761fa$var$__spreadValues({}, output.style || {}), style);
        return output;
    }, [
        styleForToken
    ]);
};
// src/utils/normalizeTokens.ts
var $62601dcfdc5761fa$var$newlineRe = /\r\n|\r|\n/;
var $62601dcfdc5761fa$var$normalizeEmptyLines = (line)=>{
    if (line.length === 0) line.push({
        types: [
            "plain"
        ],
        content: "\n",
        empty: true
    });
    else if (line.length === 1 && line[0].content === "") {
        line[0].content = "\n";
        line[0].empty = true;
    }
};
var $62601dcfdc5761fa$var$appendTypes = (types, add)=>{
    const typesSize = types.length;
    if (typesSize > 0 && types[typesSize - 1] === add) return types;
    return types.concat(add);
};
var $62601dcfdc5761fa$var$normalizeTokens = (tokens)=>{
    const typeArrStack = [
        []
    ];
    const tokenArrStack = [
        tokens
    ];
    const tokenArrIndexStack = [
        0
    ];
    const tokenArrSizeStack = [
        tokens.length
    ];
    let i = 0;
    let stackIndex = 0;
    let currentLine = [];
    const acc = [
        currentLine
    ];
    while(stackIndex > -1){
        while((i = tokenArrIndexStack[stackIndex]++) < tokenArrSizeStack[stackIndex]){
            let content;
            let types = typeArrStack[stackIndex];
            const tokenArr = tokenArrStack[stackIndex];
            const token = tokenArr[i];
            if (typeof token === "string") {
                types = stackIndex > 0 ? types : [
                    "plain"
                ];
                content = token;
            } else {
                types = $62601dcfdc5761fa$var$appendTypes(types, token.type);
                if (token.alias) types = $62601dcfdc5761fa$var$appendTypes(types, token.alias);
                content = token.content;
            }
            if (typeof content !== "string") {
                stackIndex++;
                typeArrStack.push(types);
                tokenArrStack.push(content);
                tokenArrIndexStack.push(0);
                tokenArrSizeStack.push(content.length);
                continue;
            }
            const splitByNewlines = content.split($62601dcfdc5761fa$var$newlineRe);
            const newlineCount = splitByNewlines.length;
            currentLine.push({
                types: types,
                content: splitByNewlines[0]
            });
            for(let i2 = 1; i2 < newlineCount; i2++){
                $62601dcfdc5761fa$var$normalizeEmptyLines(currentLine);
                acc.push(currentLine = []);
                currentLine.push({
                    types: types,
                    content: splitByNewlines[i2]
                });
            }
        }
        stackIndex--;
        typeArrStack.pop();
        tokenArrStack.pop();
        tokenArrIndexStack.pop();
        tokenArrSizeStack.pop();
    }
    $62601dcfdc5761fa$var$normalizeEmptyLines(currentLine);
    return acc;
};
var $62601dcfdc5761fa$export$2dc420fd853fdcc4 = $62601dcfdc5761fa$var$normalizeTokens;
var $62601dcfdc5761fa$export$7b94e077f7691ca1 = ({ prism: prism, code: code, grammar: grammar, language: language })=>{
    return (0, $7DB8U.useMemo)(()=>{
        if (grammar == null) return $62601dcfdc5761fa$export$2dc420fd853fdcc4([
            code
        ]);
        const prismConfig = {
            code: code,
            grammar: grammar,
            language: language,
            tokens: []
        };
        prism.hooks.run("before-tokenize", prismConfig);
        prismConfig.tokens = prism.tokenize(code, grammar);
        prism.hooks.run("after-tokenize", prismConfig);
        return $62601dcfdc5761fa$export$2dc420fd853fdcc4(prismConfig.tokens);
    }, [
        code,
        grammar,
        language,
        // prism is a stable import
        prism
    ]);
};
// src/utils/themeToDict.ts
var $62601dcfdc5761fa$var$themeToDict = (theme21, language)=>{
    const { plain: plain } = theme21;
    const themeDict = theme21.styles.reduce((acc, themeEntry)=>{
        const { languages: languages2, style: style } = themeEntry;
        if (languages2 && !languages2.includes(language)) return acc;
        themeEntry.types.forEach((type)=>{
            const accStyle = $62601dcfdc5761fa$var$__spreadValues($62601dcfdc5761fa$var$__spreadValues({}, acc[type]), style);
            acc[type] = accStyle;
        });
        return acc;
    }, {});
    themeDict.root = plain;
    themeDict.plain = $62601dcfdc5761fa$var$__spreadProps($62601dcfdc5761fa$var$__spreadValues({}, plain), {
        backgroundColor: void 0
    });
    return themeDict;
};
var $62601dcfdc5761fa$var$themeToDict_default = $62601dcfdc5761fa$var$themeToDict;
// src/components/highlight.ts
var $62601dcfdc5761fa$var$Highlight = ({ children: children, language: _language, code: code, theme: theme21, prism: prism })=>{
    const language = _language.toLowerCase();
    const themeDictionary = $62601dcfdc5761fa$var$themeToDict_default(theme21, language);
    const getLineProps = $62601dcfdc5761fa$var$useGetLineProps(themeDictionary);
    const getTokenProps = $62601dcfdc5761fa$var$useGetTokenProps(themeDictionary);
    const grammar = prism.languages[language];
    const tokens = $62601dcfdc5761fa$export$7b94e077f7691ca1({
        prism: prism,
        language: language,
        code: code,
        grammar: grammar
    });
    return children({
        tokens: tokens,
        className: `prism-code language-${language}`,
        style: themeDictionary != null ? themeDictionary.root : {},
        getLineProps: getLineProps,
        getTokenProps: getTokenProps
    });
};
// src/index.ts
var $62601dcfdc5761fa$export$39dbc3f558091353 = (props)=>(0, $7DB8U.createElement)($62601dcfdc5761fa$var$Highlight, $62601dcfdc5761fa$var$__spreadProps($62601dcfdc5761fa$var$__spreadValues({}, props), {
        prism: props.prism || $62601dcfdc5761fa$export$dc7257ffb0972f87,
        theme: props.theme || $62601dcfdc5761fa$var$vsDark_default,
        code: props.code,
        language: props.language
    }));
 /*! Bundled license information:

prismjs/prism.js:
  (**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   *)
*/ 


var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");
var $5712f090dbad2673$var$m = {
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
};
function $5712f090dbad2673$var$p(c) {
    var a = window.getSelection();
    a.empty();
    a.addRange(c);
}
function $5712f090dbad2673$var$q(c) {
    return (c.metaKey || c.ctrlKey) && !c.altKey && "KeyZ" === c.code;
}
function $5712f090dbad2673$var$r(c) {
    c = [
        c.firstChild
    ];
    for(var b, a = ""; b = c.pop();)b.nodeType === Node.TEXT_NODE ? a += b.textContent : b.nodeType === Node.ELEMENT_NODE && "BR" === b.nodeName && (a += "\n"), b.nextSibling && c.push(b.nextSibling), b.firstChild && c.push(b.firstChild);
    "\n" !== a[a.length - 1] && (a += "\n");
    return a;
}
function $5712f090dbad2673$var$w(c) {
    var a = window.getSelection().getRangeAt(0), b = a.collapsed ? 0 : a.toString().length, f = document.createRange();
    f.setStart(c, 0);
    f.setEnd(a.startContainer, a.startOffset);
    return {
        position: c = (f = f.toString()).length,
        extent: b,
        content: f = (f = f.split("\n"))[a = f.length - 1],
        line: a
    };
}
function $5712f090dbad2673$var$C(c, a, b) {
    0 >= a && (a = 0);
    if (!b || 0 > b) b = a;
    var f = document.createRange();
    c = [
        c.firstChild
    ];
    for(var d, l = 0, g = a; d = c[c.length - 1];){
        if (d.nodeType === Node.TEXT_NODE) {
            if (l + d.textContent.length >= g) {
                var h = g - l;
                if (g === a) {
                    if (g = f, h < d.textContent.length ? g.setStart(d, h) : g.setStartAfter(d), b !== a) {
                        g = b;
                        continue;
                    } else break;
                } else {
                    a = f;
                    h < (b = d).textContent.length ? a.setEnd(b, h) : a.setEndAfter(b);
                    break;
                }
            }
            l += d.textContent.length;
        } else if (d.nodeType === Node.ELEMENT_NODE && "BR" === d.nodeName) {
            if (l + 1 >= g) {
                if (g === a) {
                    if (h = f, 0 < d.textContent.length ? h.setStart(d, 0) : h.setStartAfter(d), b !== a) {
                        g = b;
                        continue;
                    } else break;
                } else {
                    a = f;
                    0 < (b = d).textContent.length ? a.setEnd(b, 0) : a.setEndAfter(b);
                    break;
                }
            }
            l++;
        }
        c.pop();
        d.nextSibling && c.push(d.nextSibling);
        d.firstChild && c.push(d.firstChild);
    }
    return f;
}
function $5712f090dbad2673$export$52a148af2bad544(c, a, b) {
    function f(k) {
        var b = c.current;
        if (b) {
            var a = $5712f090dbad2673$var$w(b);
            b = $5712f090dbad2673$var$r(b);
            a.position += k.length - b.length;
            e.position = a;
            e.onChange(k, a);
        }
    }
    function l(k, b) {
        var e = c.current;
        if (e) {
            var a = window.getSelection().getRangeAt(0);
            a.deleteContents();
            a.collapse();
            var d = b || 0;
            (a = $5712f090dbad2673$var$C(e, b = (a = $5712f090dbad2673$var$w(e)).position + (0 > d ? d : 0), a.position + (0 < d ? d : 0))).deleteContents();
            k && a.insertNode(document.createTextNode(k));
            $5712f090dbad2673$var$p($5712f090dbad2673$var$C(e, b + k.length));
        }
    }
    function d(b) {
        var a = c.current;
        if (a) {
            a.focus();
            var e = 0;
            if ("number" == typeof b) e = b;
            else {
                var k = $5712f090dbad2673$var$r(a).split("\n").slice(0, b.row);
                b.row && (e += k.join("\n").length + 1);
                e += b.column;
            }
            $5712f090dbad2673$var$p($5712f090dbad2673$var$C(a, e));
        }
    }
    function g() {
        var b = c.current;
        return {
            text: $5712f090dbad2673$var$r(b),
            position: b = $5712f090dbad2673$var$w(b)
        };
    }
    function h() {
        e.observer.disconnect();
    }
    b || (b = {});
    var D = (0, $7DB8U.useState)([])[1], e = (0, $7DB8U.useState)(function() {
        var e = {
            observer: null,
            disconnected: !1,
            onChange: a,
            queue: [],
            history: [],
            historyAt: -1,
            position: null
        };
        "undefined" != typeof MutationObserver && (e.observer = new MutationObserver(function b(b) {
            var a;
            (a = e.queue).push.apply(a, b);
        }));
        return e;
    })[0], n = (0, $7DB8U.useMemo)(function() {
        return {
            update: f,
            insert: l,
            move: d,
            getState: g
        };
    }, []);
    if ("object" != typeof navigator) return n;
    (0, $7DB8U.useLayoutEffect)(function() {
        e.onChange = a;
        if (c.current && !b.disabled) {
            e.disconnected = !1;
            e.observer.observe(c.current, $5712f090dbad2673$var$m);
            if (e.position) {
                var k = e.position, d = k.position;
                $5712f090dbad2673$var$p($5712f090dbad2673$var$C(c.current, d, d + k.extent));
            }
            return h;
        }
    });
    (0, $7DB8U.useLayoutEffect)(function() {
        if (!c.current || b.disabled) e.history.length = 0, e.historyAt = -1;
        else {
            var a = c.current;
            if (e.position) {
                a.focus();
                var d = e.position, f = d.position;
                $5712f090dbad2673$var$p($5712f090dbad2673$var$C(a, f, f + d.extent));
            }
            var g = a.style.whiteSpace, h = a.contentEditable, l = !0;
            try {
                a.contentEditable = "plaintext-only";
            } catch (u) {
                a.contentEditable = "true", l = !1;
            }
            "pre" !== g && (a.style.whiteSpace = "pre-wrap");
            b.indentation && (a.style.tabSize = a.style.MozTabSize = "" + b.indentation);
            d = "" + " ".repeat(b.indentation || 0);
            var x, E = new RegExp("^(?:" + d + ")"), F = new RegExp("^(?:" + d + ")*(" + d + ")$"), t = function(b) {
                if (c.current && e.position) {
                    var u = $5712f090dbad2673$var$r(a), d = $5712f090dbad2673$var$w(a), f = (new Date).valueOf(), g = e.history[e.historyAt];
                    !b && 500 > f - x || g && g[1] === u ? x = f : (b = ++e.historyAt, e.history[b] = [
                        d,
                        u
                    ], e.history.splice(b + 1), 500 < b && (e.historyAt--, e.history.shift()));
                }
            }, v = function() {
                var b;
                (b = e.queue).push.apply(b, e.observer.takeRecords());
                b = $5712f090dbad2673$var$w(a);
                if (e.queue.length) {
                    e.observer.disconnect();
                    e.disconnected = !0;
                    var d = $5712f090dbad2673$var$r(a);
                    e.position = b;
                    for(var c, f; c = e.queue.pop();){
                        null !== c.oldValue && (c.target.textContent = c.oldValue);
                        for(f = c.removedNodes.length - 1; 0 <= f; f--)c.target.insertBefore(c.removedNodes[f], c.nextSibling);
                        for(f = c.addedNodes.length - 1; 0 <= f; f--)c.addedNodes[f].parentNode && c.target.removeChild(c.addedNodes[f]);
                    }
                    e.onChange(d, b);
                }
            }, y = function(c) {
                if (!c.defaultPrevented && c.target === a) {
                    if (e.disconnected) return c.preventDefault(), D([]);
                    if ($5712f090dbad2673$var$q(c)) c.preventDefault(), c.shiftKey ? (c = ++e.historyAt, (c = e.history[c]) || (e.historyAt = e.history.length - 1)) : (c = --e.historyAt, (c = e.history[c]) || (e.historyAt = 0)), c && (e.observer.disconnect(), e.disconnected = !0, e.position = c[0], e.onChange(c[1], c[0]));
                    else {
                        t();
                        if ("Enter" === c.key) {
                            c.preventDefault();
                            var d = $5712f090dbad2673$var$w(a), f = /\S/g.exec(d.content);
                            d = "\n" + d.content.slice(0, f ? f.index : d.content.length);
                            n.insert(d);
                        } else if ((!l || b.indentation) && "Backspace" === c.key) c.preventDefault(), window.getSelection().getRangeAt(0).collapsed ? (d = $5712f090dbad2673$var$w(a), d = F.exec(d.content), n.insert("", d ? -d[1].length : -1)) : n.insert("", 0);
                        else if (b.indentation && "Tab" === c.key) {
                            c.preventDefault();
                            f = (d = $5712f090dbad2673$var$w(a)).position - d.content.length;
                            var g = $5712f090dbad2673$var$r(a);
                            d = c.shiftKey ? g.slice(0, f) + d.content.replace(E, "") + g.slice(f + d.content.length) : g.slice(0, f) + (b.indentation ? " ".repeat(b.indentation) : "\t") + g.slice(f);
                            n.update(d);
                        }
                        c.repeat && v();
                    }
                }
            }, z = function(b) {
                b.defaultPrevented || b.isComposing || ($5712f090dbad2673$var$q(b) || t(), v(), a.focus());
            }, A = function(b) {
                e.position = window.getSelection().rangeCount && b.target === a ? $5712f090dbad2673$var$w(a) : null;
            }, B = function(a) {
                a.preventDefault();
                t(!0);
                n.insert(a.clipboardData.getData("text/plain"));
                t(!0);
                v();
            };
            document.addEventListener("selectstart", A);
            window.addEventListener("keydown", y);
            a.addEventListener("paste", B);
            a.addEventListener("keyup", z);
            return function() {
                document.removeEventListener("selectstart", A);
                window.removeEventListener("keydown", y);
                a.removeEventListener("paste", B);
                a.removeEventListener("keyup", z);
                a.style.whiteSpace = g;
                a.contentEditable = h;
            };
        }
    }, [
        c.current,
        b.disabled,
        b.indentation
    ]);
    return n;
}



/* eslint max-len: 0 */ var $67eb7b9d79b9f423$export$ee633ab6cd0138cc;
(function(ContextualKeyword) {
    const NONE = 0;
    ContextualKeyword[ContextualKeyword["NONE"] = NONE] = "NONE";
    const _abstract = NONE + 1;
    ContextualKeyword[ContextualKeyword["_abstract"] = _abstract] = "_abstract";
    const _accessor = _abstract + 1;
    ContextualKeyword[ContextualKeyword["_accessor"] = _accessor] = "_accessor";
    const _as = _accessor + 1;
    ContextualKeyword[ContextualKeyword["_as"] = _as] = "_as";
    const _assert = _as + 1;
    ContextualKeyword[ContextualKeyword["_assert"] = _assert] = "_assert";
    const _asserts = _assert + 1;
    ContextualKeyword[ContextualKeyword["_asserts"] = _asserts] = "_asserts";
    const _async = _asserts + 1;
    ContextualKeyword[ContextualKeyword["_async"] = _async] = "_async";
    const _await = _async + 1;
    ContextualKeyword[ContextualKeyword["_await"] = _await] = "_await";
    const _checks = _await + 1;
    ContextualKeyword[ContextualKeyword["_checks"] = _checks] = "_checks";
    const _constructor = _checks + 1;
    ContextualKeyword[ContextualKeyword["_constructor"] = _constructor] = "_constructor";
    const _declare = _constructor + 1;
    ContextualKeyword[ContextualKeyword["_declare"] = _declare] = "_declare";
    const _enum = _declare + 1;
    ContextualKeyword[ContextualKeyword["_enum"] = _enum] = "_enum";
    const _exports = _enum + 1;
    ContextualKeyword[ContextualKeyword["_exports"] = _exports] = "_exports";
    const _from = _exports + 1;
    ContextualKeyword[ContextualKeyword["_from"] = _from] = "_from";
    const _get = _from + 1;
    ContextualKeyword[ContextualKeyword["_get"] = _get] = "_get";
    const _global = _get + 1;
    ContextualKeyword[ContextualKeyword["_global"] = _global] = "_global";
    const _implements = _global + 1;
    ContextualKeyword[ContextualKeyword["_implements"] = _implements] = "_implements";
    const _infer = _implements + 1;
    ContextualKeyword[ContextualKeyword["_infer"] = _infer] = "_infer";
    const _interface = _infer + 1;
    ContextualKeyword[ContextualKeyword["_interface"] = _interface] = "_interface";
    const _is = _interface + 1;
    ContextualKeyword[ContextualKeyword["_is"] = _is] = "_is";
    const _keyof = _is + 1;
    ContextualKeyword[ContextualKeyword["_keyof"] = _keyof] = "_keyof";
    const _mixins = _keyof + 1;
    ContextualKeyword[ContextualKeyword["_mixins"] = _mixins] = "_mixins";
    const _module = _mixins + 1;
    ContextualKeyword[ContextualKeyword["_module"] = _module] = "_module";
    const _namespace = _module + 1;
    ContextualKeyword[ContextualKeyword["_namespace"] = _namespace] = "_namespace";
    const _of = _namespace + 1;
    ContextualKeyword[ContextualKeyword["_of"] = _of] = "_of";
    const _opaque = _of + 1;
    ContextualKeyword[ContextualKeyword["_opaque"] = _opaque] = "_opaque";
    const _out = _opaque + 1;
    ContextualKeyword[ContextualKeyword["_out"] = _out] = "_out";
    const _override = _out + 1;
    ContextualKeyword[ContextualKeyword["_override"] = _override] = "_override";
    const _private = _override + 1;
    ContextualKeyword[ContextualKeyword["_private"] = _private] = "_private";
    const _protected = _private + 1;
    ContextualKeyword[ContextualKeyword["_protected"] = _protected] = "_protected";
    const _proto = _protected + 1;
    ContextualKeyword[ContextualKeyword["_proto"] = _proto] = "_proto";
    const _public = _proto + 1;
    ContextualKeyword[ContextualKeyword["_public"] = _public] = "_public";
    const _readonly = _public + 1;
    ContextualKeyword[ContextualKeyword["_readonly"] = _readonly] = "_readonly";
    const _require = _readonly + 1;
    ContextualKeyword[ContextualKeyword["_require"] = _require] = "_require";
    const _satisfies = _require + 1;
    ContextualKeyword[ContextualKeyword["_satisfies"] = _satisfies] = "_satisfies";
    const _set = _satisfies + 1;
    ContextualKeyword[ContextualKeyword["_set"] = _set] = "_set";
    const _static = _set + 1;
    ContextualKeyword[ContextualKeyword["_static"] = _static] = "_static";
    const _symbol = _static + 1;
    ContextualKeyword[ContextualKeyword["_symbol"] = _symbol] = "_symbol";
    const _type = _symbol + 1;
    ContextualKeyword[ContextualKeyword["_type"] = _type] = "_type";
    const _unique = _type + 1;
    ContextualKeyword[ContextualKeyword["_unique"] = _unique] = "_unique";
    const _using = _unique + 1;
    ContextualKeyword[ContextualKeyword["_using"] = _using] = "_using";
})($67eb7b9d79b9f423$export$ee633ab6cd0138cc || ($67eb7b9d79b9f423$export$ee633ab6cd0138cc = {}));


// Generated file, do not edit! Run "yarn generate" to re-generate this file.
/* istanbul ignore file */ /**
 * Enum of all token types, with bit fields to signify meaningful properties.
 */ var $f33b9d3e01f21be3$export$f435f793048e7a0f;
(function(TokenType) {
    // Precedence 0 means not an operator; otherwise it is a positive number up to 12.
    const PRECEDENCE_MASK = 0xf;
    TokenType[TokenType["PRECEDENCE_MASK"] = PRECEDENCE_MASK] = "PRECEDENCE_MASK";
    const IS_KEYWORD = 16;
    TokenType[TokenType["IS_KEYWORD"] = IS_KEYWORD] = "IS_KEYWORD";
    const IS_ASSIGN = 32;
    TokenType[TokenType["IS_ASSIGN"] = IS_ASSIGN] = "IS_ASSIGN";
    const IS_RIGHT_ASSOCIATIVE = 64;
    TokenType[TokenType["IS_RIGHT_ASSOCIATIVE"] = IS_RIGHT_ASSOCIATIVE] = "IS_RIGHT_ASSOCIATIVE";
    const IS_PREFIX = 128;
    TokenType[TokenType["IS_PREFIX"] = IS_PREFIX] = "IS_PREFIX";
    const IS_POSTFIX = 256;
    TokenType[TokenType["IS_POSTFIX"] = IS_POSTFIX] = "IS_POSTFIX";
    const IS_EXPRESSION_START = 512;
    TokenType[TokenType["IS_EXPRESSION_START"] = IS_EXPRESSION_START] = "IS_EXPRESSION_START";
    const num = 512;
    TokenType[TokenType["num"] = num] = "num"; // num startsExpr
    const bigint = 1536;
    TokenType[TokenType["bigint"] = bigint] = "bigint"; // bigint startsExpr
    const decimal = 2560;
    TokenType[TokenType["decimal"] = decimal] = "decimal"; // decimal startsExpr
    const regexp = 3584;
    TokenType[TokenType["regexp"] = regexp] = "regexp"; // regexp startsExpr
    const string = 4608;
    TokenType[TokenType["string"] = string] = "string"; // string startsExpr
    const name = 5632;
    TokenType[TokenType["name"] = name] = "name"; // name startsExpr
    const eof = 6144;
    TokenType[TokenType["eof"] = eof] = "eof"; // eof
    const bracketL = 7680;
    TokenType[TokenType["bracketL"] = bracketL] = "bracketL"; // [ startsExpr
    const bracketR = 8192;
    TokenType[TokenType["bracketR"] = bracketR] = "bracketR"; // ]
    const braceL = 9728;
    TokenType[TokenType["braceL"] = braceL] = "braceL"; // { startsExpr
    const braceBarL = 10752;
    TokenType[TokenType["braceBarL"] = braceBarL] = "braceBarL"; // {| startsExpr
    const braceR = 11264;
    TokenType[TokenType["braceR"] = braceR] = "braceR"; // }
    const braceBarR = 12288;
    TokenType[TokenType["braceBarR"] = braceBarR] = "braceBarR"; // |}
    const parenL = 13824;
    TokenType[TokenType["parenL"] = parenL] = "parenL"; // ( startsExpr
    const parenR = 14336;
    TokenType[TokenType["parenR"] = parenR] = "parenR"; // )
    const comma = 15360;
    TokenType[TokenType["comma"] = comma] = "comma"; // ,
    const semi = 16384;
    TokenType[TokenType["semi"] = semi] = "semi"; // ;
    const colon = 17408;
    TokenType[TokenType["colon"] = colon] = "colon"; // :
    const doubleColon = 18432;
    TokenType[TokenType["doubleColon"] = doubleColon] = "doubleColon"; // ::
    const dot = 19456;
    TokenType[TokenType["dot"] = dot] = "dot"; // .
    const question = 20480;
    TokenType[TokenType["question"] = question] = "question"; // ?
    const questionDot = 21504;
    TokenType[TokenType["questionDot"] = questionDot] = "questionDot"; // ?.
    const arrow = 22528;
    TokenType[TokenType["arrow"] = arrow] = "arrow"; // =>
    const template = 23552;
    TokenType[TokenType["template"] = template] = "template"; // template
    const ellipsis = 24576;
    TokenType[TokenType["ellipsis"] = ellipsis] = "ellipsis"; // ...
    const backQuote = 25600;
    TokenType[TokenType["backQuote"] = backQuote] = "backQuote"; // `
    const dollarBraceL = 27136;
    TokenType[TokenType["dollarBraceL"] = dollarBraceL] = "dollarBraceL"; // ${ startsExpr
    const at = 27648;
    TokenType[TokenType["at"] = at] = "at"; // @
    const hash = 29184;
    TokenType[TokenType["hash"] = hash] = "hash"; // # startsExpr
    const eq = 29728;
    TokenType[TokenType["eq"] = eq] = "eq"; // = isAssign
    const assign = 30752;
    TokenType[TokenType["assign"] = assign] = "assign"; // _= isAssign
    const preIncDec = 32640;
    TokenType[TokenType["preIncDec"] = preIncDec] = "preIncDec"; // ++/-- prefix postfix startsExpr
    const postIncDec = 33664;
    TokenType[TokenType["postIncDec"] = postIncDec] = "postIncDec"; // ++/-- prefix postfix startsExpr
    const bang = 34432;
    TokenType[TokenType["bang"] = bang] = "bang"; // ! prefix startsExpr
    const tilde = 35456;
    TokenType[TokenType["tilde"] = tilde] = "tilde"; // ~ prefix startsExpr
    const pipeline = 35841;
    TokenType[TokenType["pipeline"] = pipeline] = "pipeline"; // |> prec:1
    const nullishCoalescing = 36866;
    TokenType[TokenType["nullishCoalescing"] = nullishCoalescing] = "nullishCoalescing"; // ?? prec:2
    const logicalOR = 37890;
    TokenType[TokenType["logicalOR"] = logicalOR] = "logicalOR"; // || prec:2
    const logicalAND = 38915;
    TokenType[TokenType["logicalAND"] = logicalAND] = "logicalAND"; // && prec:3
    const bitwiseOR = 39940;
    TokenType[TokenType["bitwiseOR"] = bitwiseOR] = "bitwiseOR"; // | prec:4
    const bitwiseXOR = 40965;
    TokenType[TokenType["bitwiseXOR"] = bitwiseXOR] = "bitwiseXOR"; // ^ prec:5
    const bitwiseAND = 41990;
    TokenType[TokenType["bitwiseAND"] = bitwiseAND] = "bitwiseAND"; // & prec:6
    const equality = 43015;
    TokenType[TokenType["equality"] = equality] = "equality"; // ==/!= prec:7
    const lessThan = 44040;
    TokenType[TokenType["lessThan"] = lessThan] = "lessThan"; // < prec:8
    const greaterThan = 45064;
    TokenType[TokenType["greaterThan"] = greaterThan] = "greaterThan"; // > prec:8
    const relationalOrEqual = 46088;
    TokenType[TokenType["relationalOrEqual"] = relationalOrEqual] = "relationalOrEqual"; // <=/>= prec:8
    const bitShiftL = 47113;
    TokenType[TokenType["bitShiftL"] = bitShiftL] = "bitShiftL"; // << prec:9
    const bitShiftR = 48137;
    TokenType[TokenType["bitShiftR"] = bitShiftR] = "bitShiftR"; // >>/>>> prec:9
    const plus = 49802;
    TokenType[TokenType["plus"] = plus] = "plus"; // + prec:10 prefix startsExpr
    const minus = 50826;
    TokenType[TokenType["minus"] = minus] = "minus"; // - prec:10 prefix startsExpr
    const modulo = 51723;
    TokenType[TokenType["modulo"] = modulo] = "modulo"; // % prec:11 startsExpr
    const star = 52235;
    TokenType[TokenType["star"] = star] = "star"; // * prec:11
    const slash = 53259;
    TokenType[TokenType["slash"] = slash] = "slash"; // / prec:11
    const exponent = 54348;
    TokenType[TokenType["exponent"] = exponent] = "exponent"; // ** prec:12 rightAssociative
    const jsxName = 55296;
    TokenType[TokenType["jsxName"] = jsxName] = "jsxName"; // jsxName
    const jsxText = 56320;
    TokenType[TokenType["jsxText"] = jsxText] = "jsxText"; // jsxText
    const jsxEmptyText = 57344;
    TokenType[TokenType["jsxEmptyText"] = jsxEmptyText] = "jsxEmptyText"; // jsxEmptyText
    const jsxTagStart = 58880;
    TokenType[TokenType["jsxTagStart"] = jsxTagStart] = "jsxTagStart"; // jsxTagStart startsExpr
    const jsxTagEnd = 59392;
    TokenType[TokenType["jsxTagEnd"] = jsxTagEnd] = "jsxTagEnd"; // jsxTagEnd
    const typeParameterStart = 60928;
    TokenType[TokenType["typeParameterStart"] = typeParameterStart] = "typeParameterStart"; // typeParameterStart startsExpr
    const nonNullAssertion = 61440;
    TokenType[TokenType["nonNullAssertion"] = nonNullAssertion] = "nonNullAssertion"; // nonNullAssertion
    const _break = 62480;
    TokenType[TokenType["_break"] = _break] = "_break"; // break keyword
    const _case = 63504;
    TokenType[TokenType["_case"] = _case] = "_case"; // case keyword
    const _catch = 64528;
    TokenType[TokenType["_catch"] = _catch] = "_catch"; // catch keyword
    const _continue = 65552;
    TokenType[TokenType["_continue"] = _continue] = "_continue"; // continue keyword
    const _debugger = 66576;
    TokenType[TokenType["_debugger"] = _debugger] = "_debugger"; // debugger keyword
    const _default = 67600;
    TokenType[TokenType["_default"] = _default] = "_default"; // default keyword
    const _do = 68624;
    TokenType[TokenType["_do"] = _do] = "_do"; // do keyword
    const _else = 69648;
    TokenType[TokenType["_else"] = _else] = "_else"; // else keyword
    const _finally = 70672;
    TokenType[TokenType["_finally"] = _finally] = "_finally"; // finally keyword
    const _for = 71696;
    TokenType[TokenType["_for"] = _for] = "_for"; // for keyword
    const _function = 73232;
    TokenType[TokenType["_function"] = _function] = "_function"; // function keyword startsExpr
    const _if = 73744;
    TokenType[TokenType["_if"] = _if] = "_if"; // if keyword
    const _return = 74768;
    TokenType[TokenType["_return"] = _return] = "_return"; // return keyword
    const _switch = 75792;
    TokenType[TokenType["_switch"] = _switch] = "_switch"; // switch keyword
    const _throw = 77456;
    TokenType[TokenType["_throw"] = _throw] = "_throw"; // throw keyword prefix startsExpr
    const _try = 77840;
    TokenType[TokenType["_try"] = _try] = "_try"; // try keyword
    const _var = 78864;
    TokenType[TokenType["_var"] = _var] = "_var"; // var keyword
    const _let = 79888;
    TokenType[TokenType["_let"] = _let] = "_let"; // let keyword
    const _const = 80912;
    TokenType[TokenType["_const"] = _const] = "_const"; // const keyword
    const _while = 81936;
    TokenType[TokenType["_while"] = _while] = "_while"; // while keyword
    const _with = 82960;
    TokenType[TokenType["_with"] = _with] = "_with"; // with keyword
    const _new = 84496;
    TokenType[TokenType["_new"] = _new] = "_new"; // new keyword startsExpr
    const _this = 85520;
    TokenType[TokenType["_this"] = _this] = "_this"; // this keyword startsExpr
    const _super = 86544;
    TokenType[TokenType["_super"] = _super] = "_super"; // super keyword startsExpr
    const _class = 87568;
    TokenType[TokenType["_class"] = _class] = "_class"; // class keyword startsExpr
    const _extends = 88080;
    TokenType[TokenType["_extends"] = _extends] = "_extends"; // extends keyword
    const _export = 89104;
    TokenType[TokenType["_export"] = _export] = "_export"; // export keyword
    const _import = 90640;
    TokenType[TokenType["_import"] = _import] = "_import"; // import keyword startsExpr
    const _yield = 91664;
    TokenType[TokenType["_yield"] = _yield] = "_yield"; // yield keyword startsExpr
    const _null = 92688;
    TokenType[TokenType["_null"] = _null] = "_null"; // null keyword startsExpr
    const _true = 93712;
    TokenType[TokenType["_true"] = _true] = "_true"; // true keyword startsExpr
    const _false = 94736;
    TokenType[TokenType["_false"] = _false] = "_false"; // false keyword startsExpr
    const _in = 95256;
    TokenType[TokenType["_in"] = _in] = "_in"; // in prec:8 keyword
    const _instanceof = 96280;
    TokenType[TokenType["_instanceof"] = _instanceof] = "_instanceof"; // instanceof prec:8 keyword
    const _typeof = 97936;
    TokenType[TokenType["_typeof"] = _typeof] = "_typeof"; // typeof keyword prefix startsExpr
    const _void = 98960;
    TokenType[TokenType["_void"] = _void] = "_void"; // void keyword prefix startsExpr
    const _delete = 99984;
    TokenType[TokenType["_delete"] = _delete] = "_delete"; // delete keyword prefix startsExpr
    const _async = 100880;
    TokenType[TokenType["_async"] = _async] = "_async"; // async keyword startsExpr
    const _get = 101904;
    TokenType[TokenType["_get"] = _get] = "_get"; // get keyword startsExpr
    const _set = 102928;
    TokenType[TokenType["_set"] = _set] = "_set"; // set keyword startsExpr
    const _declare = 103952;
    TokenType[TokenType["_declare"] = _declare] = "_declare"; // declare keyword startsExpr
    const _readonly = 104976;
    TokenType[TokenType["_readonly"] = _readonly] = "_readonly"; // readonly keyword startsExpr
    const _abstract = 106000;
    TokenType[TokenType["_abstract"] = _abstract] = "_abstract"; // abstract keyword startsExpr
    const _static = 107024;
    TokenType[TokenType["_static"] = _static] = "_static"; // static keyword startsExpr
    const _public = 107536;
    TokenType[TokenType["_public"] = _public] = "_public"; // public keyword
    const _private = 108560;
    TokenType[TokenType["_private"] = _private] = "_private"; // private keyword
    const _protected = 109584;
    TokenType[TokenType["_protected"] = _protected] = "_protected"; // protected keyword
    const _override = 110608;
    TokenType[TokenType["_override"] = _override] = "_override"; // override keyword
    const _as = 112144;
    TokenType[TokenType["_as"] = _as] = "_as"; // as keyword startsExpr
    const _enum = 113168;
    TokenType[TokenType["_enum"] = _enum] = "_enum"; // enum keyword startsExpr
    const _type = 114192;
    TokenType[TokenType["_type"] = _type] = "_type"; // type keyword startsExpr
    const _implements = 115216;
    TokenType[TokenType["_implements"] = _implements] = "_implements"; // implements keyword startsExpr
})($f33b9d3e01f21be3$export$f435f793048e7a0f || ($f33b9d3e01f21be3$export$f435f793048e7a0f = {}));
function $f33b9d3e01f21be3$export$b78065ce79336a93(tokenType) {
    switch(tokenType){
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.num:
            return "num";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bigint:
            return "bigint";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.decimal:
            return "decimal";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.regexp:
            return "regexp";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.string:
            return "string";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.name:
            return "name";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.eof:
            return "eof";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bracketL:
            return "[";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bracketR:
            return "]";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.braceL:
            return "{";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.braceBarL:
            return "{|";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.braceR:
            return "}";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.braceBarR:
            return "|}";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.parenL:
            return "(";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.parenR:
            return ")";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.comma:
            return ",";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.semi:
            return ";";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.colon:
            return ":";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.doubleColon:
            return "::";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.dot:
            return ".";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.question:
            return "?";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.questionDot:
            return "?.";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.arrow:
            return "=>";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.template:
            return "template";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.ellipsis:
            return "...";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.backQuote:
            return "`";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.dollarBraceL:
            return "${";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.at:
            return "@";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.hash:
            return "#";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.eq:
            return "=";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.assign:
            return "_=";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.preIncDec:
            return "++/--";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.postIncDec:
            return "++/--";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bang:
            return "!";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.tilde:
            return "~";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.pipeline:
            return "|>";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.nullishCoalescing:
            return "??";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.logicalOR:
            return "||";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.logicalAND:
            return "&&";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bitwiseOR:
            return "|";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bitwiseXOR:
            return "^";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bitwiseAND:
            return "&";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.equality:
            return "==/!=";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.lessThan:
            return "<";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.greaterThan:
            return ">";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.relationalOrEqual:
            return "<=/>=";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bitShiftL:
            return "<<";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.bitShiftR:
            return ">>/>>>";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.plus:
            return "+";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.minus:
            return "-";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.modulo:
            return "%";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.star:
            return "*";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.slash:
            return "/";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.exponent:
            return "**";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.jsxName:
            return "jsxName";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.jsxText:
            return "jsxText";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.jsxEmptyText:
            return "jsxEmptyText";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.jsxTagStart:
            return "jsxTagStart";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.jsxTagEnd:
            return "jsxTagEnd";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.typeParameterStart:
            return "typeParameterStart";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f.nonNullAssertion:
            return "nonNullAssertion";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._break:
            return "break";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._case:
            return "case";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._catch:
            return "catch";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._continue:
            return "continue";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._debugger:
            return "debugger";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._default:
            return "default";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._do:
            return "do";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._else:
            return "else";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._finally:
            return "finally";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._for:
            return "for";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._function:
            return "function";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._if:
            return "if";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._return:
            return "return";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._switch:
            return "switch";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._throw:
            return "throw";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._try:
            return "try";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._var:
            return "var";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._let:
            return "let";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._const:
            return "const";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._while:
            return "while";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._with:
            return "with";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._new:
            return "new";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._this:
            return "this";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._super:
            return "super";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._class:
            return "class";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._extends:
            return "extends";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._export:
            return "export";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._import:
            return "import";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._yield:
            return "yield";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._null:
            return "null";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._true:
            return "true";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._false:
            return "false";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._in:
            return "in";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._instanceof:
            return "instanceof";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._typeof:
            return "typeof";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._void:
            return "void";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._delete:
            return "delete";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._async:
            return "async";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._get:
            return "get";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._set:
            return "set";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._declare:
            return "declare";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._readonly:
            return "readonly";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._abstract:
            return "abstract";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._static:
            return "static";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._public:
            return "public";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._private:
            return "private";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._protected:
            return "protected";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._override:
            return "override";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._as:
            return "as";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._enum:
            return "enum";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._type:
            return "type";
        case $f33b9d3e01f21be3$export$f435f793048e7a0f._implements:
            return "implements";
        default:
            return "";
    }
}


class $93c505350c167057$export$775b6bb06e53a214 {
    constructor(startTokenIndex, endTokenIndex, isFunctionScope){
        this.startTokenIndex = startTokenIndex;
        this.endTokenIndex = endTokenIndex;
        this.isFunctionScope = isFunctionScope;
    }
}
class $93c505350c167057$export$43b973415d9649ac {
    constructor(potentialArrowAt, noAnonFunctionType, inDisallowConditionalTypesContext, tokensLength, scopesLength, pos, type, contextualKeyword, start, end, isType, scopeDepth, error){
        this.potentialArrowAt = potentialArrowAt;
        this.noAnonFunctionType = noAnonFunctionType;
        this.inDisallowConditionalTypesContext = inDisallowConditionalTypesContext;
        this.tokensLength = tokensLength;
        this.scopesLength = scopesLength;
        this.pos = pos;
        this.type = type;
        this.contextualKeyword = contextualKeyword;
        this.start = start;
        this.end = end;
        this.isType = isType;
        this.scopeDepth = scopeDepth;
        this.error = error;
    }
}
class $93c505350c167057$export$2e2bcd8739ae039 {
    constructor(){
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init3.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init4.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init5.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init6.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init7.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init8.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init9.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init10.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init11.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init12.call(this);
        $93c505350c167057$export$2e2bcd8739ae039.prototype.__init13.call(this);
    }
    // Used to signify the start of a potential arrow function
    __init() {
        this.potentialArrowAt = -1;
    }
    // Used by Flow to handle an edge case involving function type parsing.
    __init2() {
        this.noAnonFunctionType = false;
    }
    // Used by TypeScript to handle ambiguities when parsing conditional types.
    __init3() {
        this.inDisallowConditionalTypesContext = false;
    }
    // Token store.
    __init4() {
        this.tokens = [];
    }
    // Array of all observed scopes, ordered by their ending position.
    __init5() {
        this.scopes = [];
    }
    // The current position of the tokenizer in the input.
    __init6() {
        this.pos = 0;
    }
    // Information about the current token.
    __init7() {
        this.type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eof;
    }
    __init8() {
        this.contextualKeyword = (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc).NONE;
    }
    __init9() {
        this.start = 0;
    }
    __init10() {
        this.end = 0;
    }
    __init11() {
        this.isType = false;
    }
    __init12() {
        this.scopeDepth = 0;
    }
    /**
   * If the parser is in an error state, then the token is always tt.eof and all functions can
   * keep executing but should be written so they don't get into an infinite loop in this situation.
   *
   * This approach, combined with the ability to snapshot and restore state, allows us to implement
   * backtracking without exceptions and without needing to explicitly propagate error states
   * everywhere.
   */ __init13() {
        this.error = null;
    }
    snapshot() {
        return new $93c505350c167057$export$43b973415d9649ac(this.potentialArrowAt, this.noAnonFunctionType, this.inDisallowConditionalTypesContext, this.tokens.length, this.scopes.length, this.pos, this.type, this.contextualKeyword, this.start, this.end, this.isType, this.scopeDepth, this.error);
    }
    restoreFromSnapshot(snapshot) {
        this.potentialArrowAt = snapshot.potentialArrowAt;
        this.noAnonFunctionType = snapshot.noAnonFunctionType;
        this.inDisallowConditionalTypesContext = snapshot.inDisallowConditionalTypesContext;
        this.tokens.length = snapshot.tokensLength;
        this.scopes.length = snapshot.scopesLength;
        this.pos = snapshot.pos;
        this.type = snapshot.type;
        this.contextualKeyword = snapshot.contextualKeyword;
        this.start = snapshot.start;
        this.end = snapshot.end;
        this.isType = snapshot.isType;
        this.scopeDepth = snapshot.scopeDepth;
        this.error = snapshot.error;
    }
}


var $bc8ae66faf70da33$export$dbe39bbf2ade60d5;
(function(charCodes) {
    const backSpace = 8;
    charCodes[charCodes["backSpace"] = backSpace] = "backSpace";
    const lineFeed = 10;
    charCodes[charCodes["lineFeed"] = lineFeed] = "lineFeed"; //  '\n'
    const tab = 9;
    charCodes[charCodes["tab"] = tab] = "tab"; //  '\t'
    const carriageReturn = 13;
    charCodes[charCodes["carriageReturn"] = carriageReturn] = "carriageReturn"; //  '\r'
    const shiftOut = 14;
    charCodes[charCodes["shiftOut"] = shiftOut] = "shiftOut";
    const space = 32;
    charCodes[charCodes["space"] = space] = "space";
    const exclamationMark = 33;
    charCodes[charCodes["exclamationMark"] = exclamationMark] = "exclamationMark"; //  '!'
    const quotationMark = 34;
    charCodes[charCodes["quotationMark"] = quotationMark] = "quotationMark"; //  '"'
    const numberSign = 35;
    charCodes[charCodes["numberSign"] = numberSign] = "numberSign"; //  '#'
    const dollarSign = 36;
    charCodes[charCodes["dollarSign"] = dollarSign] = "dollarSign"; //  '$'
    const percentSign = 37;
    charCodes[charCodes["percentSign"] = percentSign] = "percentSign"; //  '%'
    const ampersand = 38;
    charCodes[charCodes["ampersand"] = ampersand] = "ampersand"; //  '&'
    const apostrophe = 39;
    charCodes[charCodes["apostrophe"] = apostrophe] = "apostrophe"; //  '''
    const leftParenthesis = 40;
    charCodes[charCodes["leftParenthesis"] = leftParenthesis] = "leftParenthesis"; //  '('
    const rightParenthesis = 41;
    charCodes[charCodes["rightParenthesis"] = rightParenthesis] = "rightParenthesis"; //  ')'
    const asterisk = 42;
    charCodes[charCodes["asterisk"] = asterisk] = "asterisk"; //  '*'
    const plusSign = 43;
    charCodes[charCodes["plusSign"] = plusSign] = "plusSign"; //  '+'
    const comma = 44;
    charCodes[charCodes["comma"] = comma] = "comma"; //  ','
    const dash = 45;
    charCodes[charCodes["dash"] = dash] = "dash"; //  '-'
    const dot = 46;
    charCodes[charCodes["dot"] = dot] = "dot"; //  '.'
    const slash = 47;
    charCodes[charCodes["slash"] = slash] = "slash"; //  '/'
    const digit0 = 48;
    charCodes[charCodes["digit0"] = digit0] = "digit0"; //  '0'
    const digit1 = 49;
    charCodes[charCodes["digit1"] = digit1] = "digit1"; //  '1'
    const digit2 = 50;
    charCodes[charCodes["digit2"] = digit2] = "digit2"; //  '2'
    const digit3 = 51;
    charCodes[charCodes["digit3"] = digit3] = "digit3"; //  '3'
    const digit4 = 52;
    charCodes[charCodes["digit4"] = digit4] = "digit4"; //  '4'
    const digit5 = 53;
    charCodes[charCodes["digit5"] = digit5] = "digit5"; //  '5'
    const digit6 = 54;
    charCodes[charCodes["digit6"] = digit6] = "digit6"; //  '6'
    const digit7 = 55;
    charCodes[charCodes["digit7"] = digit7] = "digit7"; //  '7'
    const digit8 = 56;
    charCodes[charCodes["digit8"] = digit8] = "digit8"; //  '8'
    const digit9 = 57;
    charCodes[charCodes["digit9"] = digit9] = "digit9"; //  '9'
    const colon = 58;
    charCodes[charCodes["colon"] = colon] = "colon"; //  ':'
    const semicolon = 59;
    charCodes[charCodes["semicolon"] = semicolon] = "semicolon"; //  ';'
    const lessThan = 60;
    charCodes[charCodes["lessThan"] = lessThan] = "lessThan"; //  '<'
    const equalsTo = 61;
    charCodes[charCodes["equalsTo"] = equalsTo] = "equalsTo"; //  '='
    const greaterThan = 62;
    charCodes[charCodes["greaterThan"] = greaterThan] = "greaterThan"; //  '>'
    const questionMark = 63;
    charCodes[charCodes["questionMark"] = questionMark] = "questionMark"; //  '?'
    const atSign = 64;
    charCodes[charCodes["atSign"] = atSign] = "atSign"; //  '@'
    const uppercaseA = 65;
    charCodes[charCodes["uppercaseA"] = uppercaseA] = "uppercaseA"; //  'A'
    const uppercaseB = 66;
    charCodes[charCodes["uppercaseB"] = uppercaseB] = "uppercaseB"; //  'B'
    const uppercaseC = 67;
    charCodes[charCodes["uppercaseC"] = uppercaseC] = "uppercaseC"; //  'C'
    const uppercaseD = 68;
    charCodes[charCodes["uppercaseD"] = uppercaseD] = "uppercaseD"; //  'D'
    const uppercaseE = 69;
    charCodes[charCodes["uppercaseE"] = uppercaseE] = "uppercaseE"; //  'E'
    const uppercaseF = 70;
    charCodes[charCodes["uppercaseF"] = uppercaseF] = "uppercaseF"; //  'F'
    const uppercaseG = 71;
    charCodes[charCodes["uppercaseG"] = uppercaseG] = "uppercaseG"; //  'G'
    const uppercaseH = 72;
    charCodes[charCodes["uppercaseH"] = uppercaseH] = "uppercaseH"; //  'H'
    const uppercaseI = 73;
    charCodes[charCodes["uppercaseI"] = uppercaseI] = "uppercaseI"; //  'I'
    const uppercaseJ = 74;
    charCodes[charCodes["uppercaseJ"] = uppercaseJ] = "uppercaseJ"; //  'J'
    const uppercaseK = 75;
    charCodes[charCodes["uppercaseK"] = uppercaseK] = "uppercaseK"; //  'K'
    const uppercaseL = 76;
    charCodes[charCodes["uppercaseL"] = uppercaseL] = "uppercaseL"; //  'L'
    const uppercaseM = 77;
    charCodes[charCodes["uppercaseM"] = uppercaseM] = "uppercaseM"; //  'M'
    const uppercaseN = 78;
    charCodes[charCodes["uppercaseN"] = uppercaseN] = "uppercaseN"; //  'N'
    const uppercaseO = 79;
    charCodes[charCodes["uppercaseO"] = uppercaseO] = "uppercaseO"; //  'O'
    const uppercaseP = 80;
    charCodes[charCodes["uppercaseP"] = uppercaseP] = "uppercaseP"; //  'P'
    const uppercaseQ = 81;
    charCodes[charCodes["uppercaseQ"] = uppercaseQ] = "uppercaseQ"; //  'Q'
    const uppercaseR = 82;
    charCodes[charCodes["uppercaseR"] = uppercaseR] = "uppercaseR"; //  'R'
    const uppercaseS = 83;
    charCodes[charCodes["uppercaseS"] = uppercaseS] = "uppercaseS"; //  'S'
    const uppercaseT = 84;
    charCodes[charCodes["uppercaseT"] = uppercaseT] = "uppercaseT"; //  'T'
    const uppercaseU = 85;
    charCodes[charCodes["uppercaseU"] = uppercaseU] = "uppercaseU"; //  'U'
    const uppercaseV = 86;
    charCodes[charCodes["uppercaseV"] = uppercaseV] = "uppercaseV"; //  'V'
    const uppercaseW = 87;
    charCodes[charCodes["uppercaseW"] = uppercaseW] = "uppercaseW"; //  'W'
    const uppercaseX = 88;
    charCodes[charCodes["uppercaseX"] = uppercaseX] = "uppercaseX"; //  'X'
    const uppercaseY = 89;
    charCodes[charCodes["uppercaseY"] = uppercaseY] = "uppercaseY"; //  'Y'
    const uppercaseZ = 90;
    charCodes[charCodes["uppercaseZ"] = uppercaseZ] = "uppercaseZ"; //  'Z'
    const leftSquareBracket = 91;
    charCodes[charCodes["leftSquareBracket"] = leftSquareBracket] = "leftSquareBracket"; //  '['
    const backslash = 92;
    charCodes[charCodes["backslash"] = backslash] = "backslash"; //  '\    '
    const rightSquareBracket = 93;
    charCodes[charCodes["rightSquareBracket"] = rightSquareBracket] = "rightSquareBracket"; //  ']'
    const caret = 94;
    charCodes[charCodes["caret"] = caret] = "caret"; //  '^'
    const underscore = 95;
    charCodes[charCodes["underscore"] = underscore] = "underscore"; //  '_'
    const graveAccent = 96;
    charCodes[charCodes["graveAccent"] = graveAccent] = "graveAccent"; //  '`'
    const lowercaseA = 97;
    charCodes[charCodes["lowercaseA"] = lowercaseA] = "lowercaseA"; //  'a'
    const lowercaseB = 98;
    charCodes[charCodes["lowercaseB"] = lowercaseB] = "lowercaseB"; //  'b'
    const lowercaseC = 99;
    charCodes[charCodes["lowercaseC"] = lowercaseC] = "lowercaseC"; //  'c'
    const lowercaseD = 100;
    charCodes[charCodes["lowercaseD"] = lowercaseD] = "lowercaseD"; //  'd'
    const lowercaseE = 101;
    charCodes[charCodes["lowercaseE"] = lowercaseE] = "lowercaseE"; //  'e'
    const lowercaseF = 102;
    charCodes[charCodes["lowercaseF"] = lowercaseF] = "lowercaseF"; //  'f'
    const lowercaseG = 103;
    charCodes[charCodes["lowercaseG"] = lowercaseG] = "lowercaseG"; //  'g'
    const lowercaseH = 104;
    charCodes[charCodes["lowercaseH"] = lowercaseH] = "lowercaseH"; //  'h'
    const lowercaseI = 105;
    charCodes[charCodes["lowercaseI"] = lowercaseI] = "lowercaseI"; //  'i'
    const lowercaseJ = 106;
    charCodes[charCodes["lowercaseJ"] = lowercaseJ] = "lowercaseJ"; //  'j'
    const lowercaseK = 107;
    charCodes[charCodes["lowercaseK"] = lowercaseK] = "lowercaseK"; //  'k'
    const lowercaseL = 108;
    charCodes[charCodes["lowercaseL"] = lowercaseL] = "lowercaseL"; //  'l'
    const lowercaseM = 109;
    charCodes[charCodes["lowercaseM"] = lowercaseM] = "lowercaseM"; //  'm'
    const lowercaseN = 110;
    charCodes[charCodes["lowercaseN"] = lowercaseN] = "lowercaseN"; //  'n'
    const lowercaseO = 111;
    charCodes[charCodes["lowercaseO"] = lowercaseO] = "lowercaseO"; //  'o'
    const lowercaseP = 112;
    charCodes[charCodes["lowercaseP"] = lowercaseP] = "lowercaseP"; //  'p'
    const lowercaseQ = 113;
    charCodes[charCodes["lowercaseQ"] = lowercaseQ] = "lowercaseQ"; //  'q'
    const lowercaseR = 114;
    charCodes[charCodes["lowercaseR"] = lowercaseR] = "lowercaseR"; //  'r'
    const lowercaseS = 115;
    charCodes[charCodes["lowercaseS"] = lowercaseS] = "lowercaseS"; //  's'
    const lowercaseT = 116;
    charCodes[charCodes["lowercaseT"] = lowercaseT] = "lowercaseT"; //  't'
    const lowercaseU = 117;
    charCodes[charCodes["lowercaseU"] = lowercaseU] = "lowercaseU"; //  'u'
    const lowercaseV = 118;
    charCodes[charCodes["lowercaseV"] = lowercaseV] = "lowercaseV"; //  'v'
    const lowercaseW = 119;
    charCodes[charCodes["lowercaseW"] = lowercaseW] = "lowercaseW"; //  'w'
    const lowercaseX = 120;
    charCodes[charCodes["lowercaseX"] = lowercaseX] = "lowercaseX"; //  'x'
    const lowercaseY = 121;
    charCodes[charCodes["lowercaseY"] = lowercaseY] = "lowercaseY"; //  'y'
    const lowercaseZ = 122;
    charCodes[charCodes["lowercaseZ"] = lowercaseZ] = "lowercaseZ"; //  'z'
    const leftCurlyBrace = 123;
    charCodes[charCodes["leftCurlyBrace"] = leftCurlyBrace] = "leftCurlyBrace"; //  '{'
    const verticalBar = 124;
    charCodes[charCodes["verticalBar"] = verticalBar] = "verticalBar"; //  '|'
    const rightCurlyBrace = 125;
    charCodes[charCodes["rightCurlyBrace"] = rightCurlyBrace] = "rightCurlyBrace"; //  '}'
    const tilde = 126;
    charCodes[charCodes["tilde"] = tilde] = "tilde"; //  '~'
    const nonBreakingSpace = 160;
    charCodes[charCodes["nonBreakingSpace"] = nonBreakingSpace] = "nonBreakingSpace";
    // eslint-disable-next-line no-irregular-whitespace
    const oghamSpaceMark = 5760;
    charCodes[charCodes["oghamSpaceMark"] = oghamSpaceMark] = "oghamSpaceMark"; // ' '
    const lineSeparator = 8232;
    charCodes[charCodes["lineSeparator"] = lineSeparator] = "lineSeparator";
    const paragraphSeparator = 8233;
    charCodes[charCodes["paragraphSeparator"] = paragraphSeparator] = "paragraphSeparator";
})($bc8ae66faf70da33$export$dbe39bbf2ade60d5 || ($bc8ae66faf70da33$export$dbe39bbf2ade60d5 = {}));
function $bc8ae66faf70da33$export$727d9dbc4fbb948f(code) {
    return code >= $bc8ae66faf70da33$export$dbe39bbf2ade60d5.digit0 && code <= $bc8ae66faf70da33$export$dbe39bbf2ade60d5.digit9 || code >= $bc8ae66faf70da33$export$dbe39bbf2ade60d5.lowercaseA && code <= $bc8ae66faf70da33$export$dbe39bbf2ade60d5.lowercaseF || code >= $bc8ae66faf70da33$export$dbe39bbf2ade60d5.uppercaseA && code <= $bc8ae66faf70da33$export$dbe39bbf2ade60d5.uppercaseF;
}


let $e406deb3d43fd58b$export$43bb667a94af025a;
let $e406deb3d43fd58b$export$757c2735689d2de8;
let $e406deb3d43fd58b$export$92e334f8fe49aa94;
let $e406deb3d43fd58b$export$ca000e230c0caa3e;
let $e406deb3d43fd58b$export$b7e3ae3d7c15e42e;
let $e406deb3d43fd58b$export$d854af1c30ac0f3a;
function $e406deb3d43fd58b$export$d0c215ddd78b3d24() {
    return $e406deb3d43fd58b$export$d854af1c30ac0f3a++;
}
function $e406deb3d43fd58b$export$2ca6ff5cad32970a(error) {
    if ("pos" in error) {
        const loc = $e406deb3d43fd58b$export$66bfa486b735c2f7(error.pos);
        error.message += ` (${loc.line}:${loc.column})`;
        error.loc = loc;
    }
    return error;
}
class $e406deb3d43fd58b$export$f564f979629709cc {
    constructor(line, column){
        this.line = line;
        this.column = column;
    }
}
function $e406deb3d43fd58b$export$66bfa486b735c2f7(pos) {
    let line = 1;
    let column = 1;
    for(let i = 0; i < pos; i++)if ($e406deb3d43fd58b$export$b7e3ae3d7c15e42e.charCodeAt(i) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed) {
        line++;
        column = 1;
    } else column++;
    return new $e406deb3d43fd58b$export$f564f979629709cc(line, column);
}
function $e406deb3d43fd58b$export$84bb9899435eeb61(inputCode, isJSXEnabledArg, isTypeScriptEnabledArg, isFlowEnabledArg) {
    $e406deb3d43fd58b$export$b7e3ae3d7c15e42e = inputCode;
    $e406deb3d43fd58b$export$ca000e230c0caa3e = new (0, $93c505350c167057$export$2e2bcd8739ae039)();
    $e406deb3d43fd58b$export$d854af1c30ac0f3a = 1;
    $e406deb3d43fd58b$export$43bb667a94af025a = isJSXEnabledArg;
    $e406deb3d43fd58b$export$757c2735689d2de8 = isTypeScriptEnabledArg;
    $e406deb3d43fd58b$export$92e334f8fe49aa94 = isFlowEnabledArg;
}






function $485552d236f25875$export$d382681f238736f1(contextualKeyword) {
    return (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === contextualKeyword;
}
function $485552d236f25875$export$d1b5391c35999eba(contextualKeyword) {
    const l = (0, $19e70491d10f11e8$export$ef1b94c514fc060a)();
    return l.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && l.contextualKeyword === contextualKeyword;
}
function $485552d236f25875$export$b8f8f7fffeb6fb36(contextualKeyword) {
    return (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === contextualKeyword && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
}
function $485552d236f25875$export$b8ead11dfed96f19(contextualKeyword) {
    if (!$485552d236f25875$export$b8f8f7fffeb6fb36(contextualKeyword)) $485552d236f25875$export$4c195bc1a97b6f7f();
}
function $485552d236f25875$export$1c0919cee6560c3() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eof) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) || $485552d236f25875$export$942fa35f3a7c108c();
}
function $485552d236f25875$export$942fa35f3a7c108c() {
    const prevToken = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1];
    const lastTokEnd = prevToken ? prevToken.end : 0;
    for(let i = lastTokEnd; i < (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start; i++){
        const code = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(i);
        if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).carriageReturn || code === 0x2028 || code === 0x2029) return true;
    }
    return false;
}
function $485552d236f25875$export$a4f1ee8cbd9b31ba() {
    const nextStart = (0, $19e70491d10f11e8$export$1678d89ce52f4a6)();
    for(let i = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).end; i < nextStart; i++){
        const code = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(i);
        if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).carriageReturn || code === 0x2028 || code === 0x2029) return true;
    }
    return false;
}
function $485552d236f25875$export$12d132b6e81066e4() {
    return (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi) || $485552d236f25875$export$1c0919cee6560c3();
}
function $485552d236f25875$export$62fa27d385e555f3() {
    if (!$485552d236f25875$export$12d132b6e81066e4()) $485552d236f25875$export$4c195bc1a97b6f7f('Unexpected token, expected ";"');
}
function $485552d236f25875$export$3570f33b1a1f3329(type) {
    const matched = (0, $19e70491d10f11e8$export$3106cdec37e36f77)(type);
    if (!matched) $485552d236f25875$export$4c195bc1a97b6f7f(`Unexpected token, expected "${(0, $f33b9d3e01f21be3$export$b78065ce79336a93)(type)}"`);
}
function $485552d236f25875$export$4c195bc1a97b6f7f(message = "Unexpected token", pos = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start) {
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const err = new SyntaxError(message);
    err.pos = pos;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error = err;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length;
    (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eof);
}





const $9f5f7917291107a0$export$518c7e3eadd435e0 = [
    0x0009,
    0x000b,
    0x000c,
    (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).space,
    (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).nonBreakingSpace,
    (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).oghamSpaceMark,
    0x2000,
    0x2001,
    0x2002,
    0x2003,
    0x2004,
    0x2005,
    0x2006,
    0x2007,
    0x2008,
    0x2009,
    0x200a,
    0x202f,
    0x205f,
    0x3000,
    0xfeff
];
const $9f5f7917291107a0$export$4856bde7911f0623 = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
const $9f5f7917291107a0$export$4347b22d2e0ca480 = new Uint8Array(65536);
for (const char of $9f5f7917291107a0$export$518c7e3eadd435e0)$9f5f7917291107a0$export$4347b22d2e0ca480[char] = 1;


function $231ac6b14e19c571$var$computeIsIdentifierChar(code) {
    if (code < 48) return code === 36;
    if (code < 58) return true;
    if (code < 65) return false;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    if (code < 128) return false;
    throw new Error("Should not be called with non-ASCII char code.");
}
const $231ac6b14e19c571$export$d19df39e3926cfef = new Uint8Array(65536);
for(let i = 0; i < 128; i++)$231ac6b14e19c571$export$d19df39e3926cfef[i] = $231ac6b14e19c571$var$computeIsIdentifierChar(i) ? 1 : 0;
for(let i = 128; i < 65536; i++)$231ac6b14e19c571$export$d19df39e3926cfef[i] = 1;
// Aside from whitespace and newlines, all characters outside the ASCII space are either
// identifier characters or invalid. Since we're not performing code validation, we can just
// treat all invalid characters as identifier characters.
for (const whitespaceChar of (0, $9f5f7917291107a0$export$518c7e3eadd435e0))$231ac6b14e19c571$export$d19df39e3926cfef[whitespaceChar] = 0;
$231ac6b14e19c571$export$d19df39e3926cfef[0x2028] = 0;
$231ac6b14e19c571$export$d19df39e3926cfef[0x2029] = 0;
const $231ac6b14e19c571$export$dc1d1d7d9fdffb8 = $231ac6b14e19c571$export$d19df39e3926cfef.slice();
for(let numChar = (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0; numChar <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9; numChar++)$231ac6b14e19c571$export$dc1d1d7d9fdffb8[numChar] = 0;








// Generated file, do not edit! Run "yarn generate" to re-generate this file.


const $9136c7bb1d2831a5$export$cb39af7c41e25635 = new Int32Array([
    // ""
    -1,
    27,
    783,
    918,
    1755,
    2376,
    2862,
    3483,
    -1,
    3699,
    -1,
    4617,
    4752,
    4833,
    5130,
    5508,
    5940,
    -1,
    6480,
    6939,
    7749,
    8181,
    8451,
    8613,
    -1,
    8829,
    -1,
    // "a"
    -1,
    -1,
    54,
    243,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    432,
    -1,
    -1,
    -1,
    675,
    -1,
    -1,
    -1,
    // "ab"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    81,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abs"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    108,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abst"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    135,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstr"
    -1,
    162,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstra"
    -1,
    -1,
    -1,
    189,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstrac"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    216,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstract"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ac"
    -1,
    -1,
    -1,
    270,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "acc"
    -1,
    -1,
    -1,
    -1,
    -1,
    297,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "acce"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    324,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "acces"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    351,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "access"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    378,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "accesso"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    405,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "accessor"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._accessor << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "as"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    459,
    -1,
    -1,
    -1,
    -1,
    -1,
    594,
    -1,
    // "ass"
    -1,
    -1,
    -1,
    -1,
    -1,
    486,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asse"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    513,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asser"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    540,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "assert"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._assert << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    567,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asserts"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._asserts << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asy"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    621,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asyn"
    -1,
    -1,
    -1,
    648,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "async"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "aw"
    -1,
    702,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "awa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    729,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "awai"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    756,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "await"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._await << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "b"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    810,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "br"
    -1,
    -1,
    -1,
    -1,
    -1,
    837,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "bre"
    -1,
    864,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "brea"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    891,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "break"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._break << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "c"
    -1,
    945,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1107,
    -1,
    -1,
    -1,
    1242,
    -1,
    -1,
    1350,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ca"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    972,
    1026,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cas"
    -1,
    -1,
    -1,
    -1,
    -1,
    999,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "case"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._case << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cat"
    -1,
    -1,
    -1,
    1053,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "catc"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1080,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "catch"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._catch << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ch"
    -1,
    -1,
    -1,
    -1,
    -1,
    1134,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "che"
    -1,
    -1,
    -1,
    1161,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "chec"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1188,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "check"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1215,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "checks"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._checks << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cl"
    -1,
    1269,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cla"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1296,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "clas"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1323,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "class"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "co"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1377,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "con"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1404,
    1620,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cons"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1431,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "const"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1458,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1485,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constru"
    -1,
    -1,
    -1,
    1512,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "construc"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1539,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "construct"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1566,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constructo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1593,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constructor"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._constructor << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cont"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1647,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "conti"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1674,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "contin"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1701,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "continu"
    -1,
    -1,
    -1,
    -1,
    -1,
    1728,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "continue"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._continue << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "d"
    -1,
    -1,
    -1,
    -1,
    -1,
    1782,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2349,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "de"
    -1,
    -1,
    1809,
    1971,
    -1,
    -1,
    2106,
    -1,
    -1,
    -1,
    -1,
    -1,
    2241,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "deb"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1836,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1863,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debug"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1890,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debugg"
    -1,
    -1,
    -1,
    -1,
    -1,
    1917,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debugge"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1944,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debugger"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._debugger << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "dec"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1998,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "decl"
    -1,
    2025,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "decla"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2052,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "declar"
    -1,
    -1,
    -1,
    -1,
    -1,
    2079,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "declare"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "def"
    -1,
    2133,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "defa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2160,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "defau"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2187,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "defaul"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2214,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "default"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "del"
    -1,
    -1,
    -1,
    -1,
    -1,
    2268,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "dele"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2295,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "delet"
    -1,
    -1,
    -1,
    -1,
    -1,
    2322,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "delete"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._delete << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "do"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._do << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "e"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2403,
    -1,
    2484,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2565,
    -1,
    -1,
    // "el"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2430,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "els"
    -1,
    -1,
    -1,
    -1,
    -1,
    2457,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "else"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._else << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "en"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2511,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "enu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2538,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "enum"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ex"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2592,
    -1,
    -1,
    -1,
    2727,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exp"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2619,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "expo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2646,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "expor"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2673,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "export"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2700,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exports"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._exports << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ext"
    -1,
    -1,
    -1,
    -1,
    -1,
    2754,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exte"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2781,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exten"
    -1,
    -1,
    -1,
    -1,
    2808,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "extend"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2835,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "extends"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "f"
    -1,
    2889,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2997,
    -1,
    -1,
    -1,
    -1,
    -1,
    3159,
    -1,
    -1,
    3213,
    -1,
    -1,
    3294,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2916,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fal"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2943,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fals"
    -1,
    -1,
    -1,
    -1,
    -1,
    2970,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "false"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._false << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3024,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fin"
    -1,
    3051,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fina"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3078,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "final"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3105,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "finall"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3132,
    -1,
    // "finally"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._finally << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3186,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "for"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._for << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3240,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fro"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3267,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "from"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3321,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fun"
    -1,
    -1,
    -1,
    3348,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "func"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3375,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "funct"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3402,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "functi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3429,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "functio"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3456,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "function"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "g"
    -1,
    -1,
    -1,
    -1,
    -1,
    3510,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3564,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ge"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3537,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "get"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._get << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "gl"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3591,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "glo"
    -1,
    -1,
    3618,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "glob"
    -1,
    3645,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "globa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3672,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "global"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._global << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "i"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3726,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3753,
    4077,
    -1,
    -1,
    -1,
    -1,
    4590,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "if"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._if << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "im"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3780,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "imp"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3807,
    -1,
    -1,
    3996,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impl"
    -1,
    -1,
    -1,
    -1,
    -1,
    3834,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "imple"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3861,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implem"
    -1,
    -1,
    -1,
    -1,
    -1,
    3888,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impleme"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3915,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implemen"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3942,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implement"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3969,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implements"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._implements << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4023,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impor"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4050,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "import"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "in"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4104,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4185,
    4401,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inf"
    -1,
    -1,
    -1,
    -1,
    -1,
    4131,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "infe"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4158,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "infer"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._infer << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ins"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4212,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inst"
    -1,
    4239,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "insta"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4266,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instan"
    -1,
    -1,
    -1,
    4293,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instanc"
    -1,
    -1,
    -1,
    -1,
    -1,
    4320,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instance"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4347,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instanceo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4374,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instanceof"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._instanceof << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "int"
    -1,
    -1,
    -1,
    -1,
    -1,
    4428,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inte"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4455,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inter"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4482,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interf"
    -1,
    4509,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interfa"
    -1,
    -1,
    -1,
    4536,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interfac"
    -1,
    -1,
    -1,
    -1,
    -1,
    4563,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interface"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "is"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._is << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "k"
    -1,
    -1,
    -1,
    -1,
    -1,
    4644,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ke"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4671,
    -1,
    // "key"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4698,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "keyo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4725,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "keyof"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._keyof << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "l"
    -1,
    -1,
    -1,
    -1,
    -1,
    4779,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "le"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4806,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "let"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "m"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4860,
    -1,
    -1,
    -1,
    -1,
    -1,
    4995,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4887,
    -1,
    -1,
    // "mix"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4914,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mixi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4941,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mixin"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4968,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mixins"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._mixins << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mo"
    -1,
    -1,
    -1,
    -1,
    5022,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mod"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5049,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "modu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5076,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "modul"
    -1,
    -1,
    -1,
    -1,
    -1,
    5103,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "module"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "n"
    -1,
    5157,
    -1,
    -1,
    -1,
    5373,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5427,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "na"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5184,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "nam"
    -1,
    -1,
    -1,
    -1,
    -1,
    5211,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "name"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5238,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "names"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5265,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namesp"
    -1,
    5292,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namespa"
    -1,
    -1,
    -1,
    5319,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namespac"
    -1,
    -1,
    -1,
    -1,
    -1,
    5346,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namespace"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._namespace << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ne"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5400,
    -1,
    -1,
    -1,
    // "new"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "nu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5454,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "nul"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5481,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "null"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._null << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "o"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5535,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5562,
    -1,
    -1,
    -1,
    -1,
    5697,
    5751,
    -1,
    -1,
    -1,
    -1,
    // "of"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._of << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "op"
    -1,
    5589,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5616,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opaq"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5643,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opaqu"
    -1,
    -1,
    -1,
    -1,
    -1,
    5670,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opaque"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ou"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5724,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "out"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._out << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ov"
    -1,
    -1,
    -1,
    -1,
    -1,
    5778,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ove"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5805,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "over"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5832,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "overr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5859,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "overri"
    -1,
    -1,
    -1,
    -1,
    5886,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "overrid"
    -1,
    -1,
    -1,
    -1,
    -1,
    5913,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "override"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._override << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "p"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5967,
    -1,
    -1,
    6345,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5994,
    -1,
    -1,
    -1,
    -1,
    -1,
    6129,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pri"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6021,
    -1,
    -1,
    -1,
    -1,
    // "priv"
    -1,
    6048,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "priva"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6075,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "privat"
    -1,
    -1,
    -1,
    -1,
    -1,
    6102,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "private"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._private << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pro"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6156,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "prot"
    -1,
    -1,
    -1,
    -1,
    -1,
    6183,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6318,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "prote"
    -1,
    -1,
    -1,
    6210,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protec"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6237,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protect"
    -1,
    -1,
    -1,
    -1,
    -1,
    6264,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protecte"
    -1,
    -1,
    -1,
    -1,
    6291,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protected"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._protected << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "proto"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._proto << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pu"
    -1,
    -1,
    6372,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pub"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6399,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "publ"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6426,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "publi"
    -1,
    -1,
    -1,
    6453,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "public"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._public << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "r"
    -1,
    -1,
    -1,
    -1,
    -1,
    6507,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "re"
    -1,
    6534,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6696,
    -1,
    -1,
    6831,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "rea"
    -1,
    -1,
    -1,
    -1,
    6561,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "read"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6588,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "reado"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6615,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "readon"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6642,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "readonl"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6669,
    -1,
    // "readonly"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "req"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6723,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "requ"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6750,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "requi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6777,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "requir"
    -1,
    -1,
    -1,
    -1,
    -1,
    6804,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "require"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._require << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ret"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6858,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "retu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6885,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "retur"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6912,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "return"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._return << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "s"
    -1,
    6966,
    -1,
    -1,
    -1,
    7182,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7236,
    7371,
    -1,
    7479,
    -1,
    7614,
    -1,
    // "sa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6993,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sat"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7020,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sati"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7047,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satis"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7074,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisf"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7101,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisfi"
    -1,
    -1,
    -1,
    -1,
    -1,
    7128,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisfie"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7155,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisfies"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._satisfies << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "se"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7209,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "set"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._set << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "st"
    -1,
    7263,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sta"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7290,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "stat"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7317,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "stati"
    -1,
    -1,
    -1,
    7344,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "static"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._static << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "su"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7398,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sup"
    -1,
    -1,
    -1,
    -1,
    -1,
    7425,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "supe"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7452,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "super"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._super << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sw"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7506,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "swi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7533,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "swit"
    -1,
    -1,
    -1,
    7560,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "switc"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7587,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "switch"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._switch << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sy"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7641,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sym"
    -1,
    -1,
    7668,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "symb"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7695,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "symbo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7722,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "symbol"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._symbol << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "t"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7776,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7938,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8046,
    -1,
    // "th"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7803,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7857,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "thi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7830,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "this"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "thr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7884,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "thro"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7911,
    -1,
    -1,
    -1,
    // "throw"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._throw << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "tr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7965,
    -1,
    -1,
    -1,
    8019,
    -1,
    // "tru"
    -1,
    -1,
    -1,
    -1,
    -1,
    7992,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "true"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._true << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "try"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._try << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ty"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8073,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "typ"
    -1,
    -1,
    -1,
    -1,
    -1,
    8100,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "type"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8127,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "typeo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8154,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "typeof"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "u"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8208,
    -1,
    -1,
    -1,
    -1,
    8343,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "un"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8235,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "uni"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8262,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "uniq"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8289,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "uniqu"
    -1,
    -1,
    -1,
    -1,
    -1,
    8316,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "unique"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._unique << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "us"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8370,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "usi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8397,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "usin"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8424,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "using"
    (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._using << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "v"
    -1,
    8478,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8532,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "va"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8505,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "var"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "vo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8559,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "voi"
    -1,
    -1,
    -1,
    -1,
    8586,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "void"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._void << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "w"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8640,
    8748,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "wh"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8667,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "whi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8694,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "whil"
    -1,
    -1,
    -1,
    -1,
    -1,
    8721,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "while"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._while << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "wi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8775,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "wit"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8802,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "with"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._with << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "y"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8856,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yi"
    -1,
    -1,
    -1,
    -1,
    -1,
    8883,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yie"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8910,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yiel"
    -1,
    -1,
    -1,
    -1,
    8937,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yield"
    ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._yield << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1
]);



function $8d883a7764d8b084$export$2e2bcd8739ae039() {
    let treePos = 0;
    let code = 0;
    let pos = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    while(pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length){
        code = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(pos);
        if (code < (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseA || code > (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseZ) break;
        const next = (0, $9136c7bb1d2831a5$export$cb39af7c41e25635)[treePos + (code - (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseA) + 1];
        if (next === -1) break;
        else {
            treePos = next;
            pos++;
        }
    }
    const keywordValue = (0, $9136c7bb1d2831a5$export$cb39af7c41e25635)[treePos];
    if (keywordValue > -1 && !(0, $231ac6b14e19c571$export$d19df39e3926cfef)[code]) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos = pos;
        if (keywordValue & 1) (0, $19e70491d10f11e8$export$58122cd1933ef607)(keywordValue >>> 1);
        else (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, keywordValue >>> 1);
        return;
    }
    while(pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length){
        const ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(pos);
        if ((0, $231ac6b14e19c571$export$d19df39e3926cfef)[ch]) pos++;
        else if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).backslash) {
            // \u
            pos += 2;
            if ((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(pos) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftCurlyBrace) {
                while(pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(pos) !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).rightCurlyBrace)pos++;
                pos++;
            }
        } else if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).atSign && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(pos + 1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).atSign) pos += 2;
        else break;
    }
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos = pos;
    (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
}



var $19e70491d10f11e8$export$99f888ada3c99de3;
(function(IdentifierRole) {
    const Access = 0;
    IdentifierRole[IdentifierRole["Access"] = Access] = "Access";
    const ExportAccess = Access + 1;
    IdentifierRole[IdentifierRole["ExportAccess"] = ExportAccess] = "ExportAccess";
    const TopLevelDeclaration = ExportAccess + 1;
    IdentifierRole[IdentifierRole["TopLevelDeclaration"] = TopLevelDeclaration] = "TopLevelDeclaration";
    const FunctionScopedDeclaration = TopLevelDeclaration + 1;
    IdentifierRole[IdentifierRole["FunctionScopedDeclaration"] = FunctionScopedDeclaration] = "FunctionScopedDeclaration";
    const BlockScopedDeclaration = FunctionScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["BlockScopedDeclaration"] = BlockScopedDeclaration] = "BlockScopedDeclaration";
    const ObjectShorthandTopLevelDeclaration = BlockScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthandTopLevelDeclaration"] = ObjectShorthandTopLevelDeclaration] = "ObjectShorthandTopLevelDeclaration";
    const ObjectShorthandFunctionScopedDeclaration = ObjectShorthandTopLevelDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthandFunctionScopedDeclaration"] = ObjectShorthandFunctionScopedDeclaration] = "ObjectShorthandFunctionScopedDeclaration";
    const ObjectShorthandBlockScopedDeclaration = ObjectShorthandFunctionScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthandBlockScopedDeclaration"] = ObjectShorthandBlockScopedDeclaration] = "ObjectShorthandBlockScopedDeclaration";
    const ObjectShorthand = ObjectShorthandBlockScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthand"] = ObjectShorthand] = "ObjectShorthand";
    // Any identifier bound in an import statement, e.g. both A and b from
    // `import A, * as b from 'A';`
    const ImportDeclaration = ObjectShorthand + 1;
    IdentifierRole[IdentifierRole["ImportDeclaration"] = ImportDeclaration] = "ImportDeclaration";
    const ObjectKey = ImportDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectKey"] = ObjectKey] = "ObjectKey";
    // The `foo` in `import {foo as bar} from "./abc";`.
    const ImportAccess = ObjectKey + 1;
    IdentifierRole[IdentifierRole["ImportAccess"] = ImportAccess] = "ImportAccess";
})($19e70491d10f11e8$export$99f888ada3c99de3 || ($19e70491d10f11e8$export$99f888ada3c99de3 = {}));
var $19e70491d10f11e8$export$4620c92ad8b511d9;
(function(JSXRole) {
    // The element is self-closing or has a body that resolves to empty. We
    // shouldn't emit children at all in this case.
    const NoChildren = 0;
    JSXRole[JSXRole["NoChildren"] = NoChildren] = "NoChildren";
    // The element has a single explicit child, which might still be an arbitrary
    // expression like an array. We should emit that expression as the children.
    const OneChild = NoChildren + 1;
    JSXRole[JSXRole["OneChild"] = OneChild] = "OneChild";
    // The element has at least two explicitly-specified children or has spread
    // children, so child positions are assumed to be "static". We should wrap
    // these children in an array.
    const StaticChildren = OneChild + 1;
    JSXRole[JSXRole["StaticChildren"] = StaticChildren] = "StaticChildren";
    // The element has a prop named "key" after a prop spread, so we should fall
    // back to the createElement function.
    const KeyAfterPropSpread = StaticChildren + 1;
    JSXRole[JSXRole["KeyAfterPropSpread"] = KeyAfterPropSpread] = "KeyAfterPropSpread";
})($19e70491d10f11e8$export$4620c92ad8b511d9 || ($19e70491d10f11e8$export$4620c92ad8b511d9 = {}));
function $19e70491d10f11e8$export$31dc9881735f7118(token) {
    const role = token.identifierRole;
    return role === $19e70491d10f11e8$export$99f888ada3c99de3.TopLevelDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.FunctionScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.BlockScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration;
}
function $19e70491d10f11e8$export$268f8ae8b035d918(token) {
    const role = token.identifierRole;
    return role === $19e70491d10f11e8$export$99f888ada3c99de3.FunctionScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.BlockScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration;
}
function $19e70491d10f11e8$export$c08b4dec8c3c03d(token) {
    const role = token.identifierRole;
    return role === $19e70491d10f11e8$export$99f888ada3c99de3.TopLevelDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ImportDeclaration;
}
function $19e70491d10f11e8$export$6aae06a56367d123(token) {
    const role = token.identifierRole;
    // Treat top-level declarations as block scope since the distinction doesn't matter here.
    return role === $19e70491d10f11e8$export$99f888ada3c99de3.TopLevelDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.BlockScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration;
}
function $19e70491d10f11e8$export$157aa1605fc4e080(token) {
    const role = token.identifierRole;
    return role === $19e70491d10f11e8$export$99f888ada3c99de3.FunctionScopedDeclaration || role === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration;
}
function $19e70491d10f11e8$export$dea1d79574e9c731(token) {
    return token.identifierRole === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || token.identifierRole === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration || token.identifierRole === $19e70491d10f11e8$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration;
}
class $19e70491d10f11e8$export$50792b0e93539fde {
    constructor(){
        this.type = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type;
        this.contextualKeyword = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword;
        this.start = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
        this.end = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).end;
        this.scopeDepth = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth;
        this.isType = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType;
        this.identifierRole = null;
        this.jsxRole = null;
        this.shadowsGlobal = false;
        this.isAsyncOperation = false;
        this.contextId = null;
        this.rhsEndIndex = null;
        this.isExpression = false;
        this.numNullishCoalesceStarts = 0;
        this.numNullishCoalesceEnds = 0;
        this.isOptionalChainStart = false;
        this.isOptionalChainEnd = false;
        this.subscriptStartIndex = null;
        this.nullishStartIndex = null;
    }
}
function $19e70491d10f11e8$export$48cfd1e771a65c4f() {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.push(new $19e70491d10f11e8$export$50792b0e93539fde());
    $19e70491d10f11e8$export$be17f8ab6696df13();
}
function $19e70491d10f11e8$export$e4355ff2fab571ee() {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.push(new $19e70491d10f11e8$export$50792b0e93539fde());
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    $19e70491d10f11e8$var$readTmplToken();
}
function $19e70491d10f11e8$export$f6864f1ed2347988() {
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign) --(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    $19e70491d10f11e8$var$readRegexp();
}
function $19e70491d10f11e8$export$218282073d8f0a8b(existingTokensInType) {
    for(let i = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - existingTokensInType; i < (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length; i++)(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[i].isType = true;
    const oldIsType = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType = true;
    return oldIsType;
}
function $19e70491d10f11e8$export$89977347ddb984a8(oldIsType) {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType = oldIsType;
}
function $19e70491d10f11e8$export$3106cdec37e36f77(type) {
    if ($19e70491d10f11e8$export$4659b591c19bdf3d(type)) {
        $19e70491d10f11e8$export$48cfd1e771a65c4f();
        return true;
    } else return false;
}
function $19e70491d10f11e8$export$cb3e65614411a57c(tokenType) {
    const oldIsType = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType = true;
    $19e70491d10f11e8$export$3106cdec37e36f77(tokenType);
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType = oldIsType;
}
function $19e70491d10f11e8$export$4659b591c19bdf3d(type) {
    return (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === type;
}
function $19e70491d10f11e8$export$d2a09c60d66edd78() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    $19e70491d10f11e8$export$48cfd1e771a65c4f();
    const type = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return type;
}
class $19e70491d10f11e8$export$1df511c75b9e0d8b {
    constructor(type, contextualKeyword){
        this.type = type;
        this.contextualKeyword = contextualKeyword;
    }
}
function $19e70491d10f11e8$export$ef1b94c514fc060a() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    $19e70491d10f11e8$export$48cfd1e771a65c4f();
    const type = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type;
    const contextualKeyword = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return new $19e70491d10f11e8$export$1df511c75b9e0d8b(type, contextualKeyword);
}
function $19e70491d10f11e8$export$1678d89ce52f4a6() {
    return $19e70491d10f11e8$export$b8d8ba48247ea123((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
}
function $19e70491d10f11e8$export$b8d8ba48247ea123(pos) {
    (0, $9f5f7917291107a0$export$4856bde7911f0623).lastIndex = pos;
    const skip = (0, $9f5f7917291107a0$export$4856bde7911f0623).exec((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e));
    return pos + skip[0].length;
}
function $19e70491d10f11e8$export$847169391b2516b8() {
    return (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt($19e70491d10f11e8$export$1678d89ce52f4a6());
}
function $19e70491d10f11e8$export$be17f8ab6696df13() {
    $19e70491d10f11e8$export$b240c79c2d18160();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
        const tokens = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens;
        // We normally run past the end a bit, but if we're way past the end, avoid an infinite loop.
        // Also check the token positions rather than the types since sometimes we rewrite the token
        // type to something else.
        if (tokens.length >= 2 && tokens[tokens.length - 1].start >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length && tokens[tokens.length - 2].start >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unexpectedly reached the end of input.");
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eof);
        return;
    }
    $19e70491d10f11e8$var$readToken((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos));
}
function $19e70491d10f11e8$var$readToken(code) {
    // Identifier or keyword. '\uXXXX' sequences are allowed in
    // identifiers, so '\' also dispatches to that.
    if ((0, $231ac6b14e19c571$export$dc1d1d7d9fdffb8)[code] || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).backslash || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).atSign && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).atSign) (0, $8d883a7764d8b084$export$2e2bcd8739ae039)();
    else $19e70491d10f11e8$export$e0ebb9fd4c2c4701(code);
}
function $19e70491d10f11e8$var$skipBlockComment() {
    while((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos) !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).asterisk || (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1) !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).slash){
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos > (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unterminated comment", (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos - 2);
            return;
        }
    }
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 2;
}
function $19e70491d10f11e8$export$37e131e7c1112aff(startSkip) {
    let ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += startSkip);
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) while(ch !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed && ch !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).carriageReturn && ch !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineSeparator && ch !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).paragraphSeparator && ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length)ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
}
function $19e70491d10f11e8$export$b240c79c2d18160() {
    while((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length){
        const ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        switch(ch){
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).carriageReturn:
                if ((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed) ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed:
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineSeparator:
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).paragraphSeparator:
                ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
                break;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).slash:
                switch((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1)){
                    case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).asterisk:
                        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 2;
                        $19e70491d10f11e8$var$skipBlockComment();
                        break;
                    case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).slash:
                        $19e70491d10f11e8$export$37e131e7c1112aff(2);
                        break;
                    default:
                        return;
                }
                break;
            default:
                if ((0, $9f5f7917291107a0$export$4347b22d2e0ca480)[ch]) ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
                else return;
        }
    }
}
function $19e70491d10f11e8$export$58122cd1933ef607(type, contextualKeyword = (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc).NONE) {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).end = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type = type;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword = contextualKeyword;
}
// ### Token reading
// This is the function that is called to fetch the next token. It
// is somewhat obscure, because it works in character codes rather
// than characters, and because operator parsing has been inlined
// into it.
//
// All in the name of speed.
function $19e70491d10f11e8$var$readToken_dot() {
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0 && nextChar <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9) {
        $19e70491d10f11e8$var$readNumber(true);
        return;
    }
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dot && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dot) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 3;
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis);
    } else {
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot);
    }
}
function $19e70491d10f11e8$var$readToken_slash() {
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, 2);
    else $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash, 1);
}
function $19e70491d10f11e8$var$readToken_mult_modulo(code) {
    // '%*'
    let tokenType = code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).asterisk ? (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star : (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).modulo;
    let width = 1;
    let nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    // Exponentiation operator **
    if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).asterisk && nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).asterisk) {
        width++;
        nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2);
        tokenType = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).exponent;
    }
    // Match *= or %=, disallowing *=> which can be valid in flow.
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2) !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).greaterThan) {
        width++;
        tokenType = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign;
    }
    $19e70491d10f11e8$var$finishOp(tokenType, width);
}
function $19e70491d10f11e8$var$readToken_pipe_amp(code) {
    // '|&'
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === code) {
        if ((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) // ||= or &&=
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, 3);
        else // || or &&
        $19e70491d10f11e8$var$finishOp(code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).verticalBar ? (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).logicalOR : (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).logicalAND, 2);
        return;
    }
    if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).verticalBar) {
        // '|>'
        if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).greaterThan) {
            $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).pipeline, 2);
            return;
        } else if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).rightCurlyBrace && (0, $e406deb3d43fd58b$export$92e334f8fe49aa94)) {
            // '|}'
            $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceBarR, 2);
            return;
        }
    }
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) {
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, 2);
        return;
    }
    $19e70491d10f11e8$var$finishOp(code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).verticalBar ? (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseOR : (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseAND, 1);
}
function $19e70491d10f11e8$var$readToken_caret() {
    // '^'
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, 2);
    else $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseXOR, 1);
}
function $19e70491d10f11e8$var$readToken_plus_min(code) {
    // '+-'
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === code) {
        // Tentatively call this a prefix operator, but it might be changed to postfix later.
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).preIncDec, 2);
        return;
    }
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, 2);
    else if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).plusSign) $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).plus, 1);
    else $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus, 1);
}
function $19e70491d10f11e8$var$readToken_lt() {
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lessThan) {
        if ((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) {
            $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, 3);
            return;
        }
        // We see <<, but need to be really careful about whether to treat it as a
        // true left-shift or as two < tokens.
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType) // Within a type, << might come up in a snippet like `Array<<T>() => void>`,
        // so treat it as two < tokens. Importantly, this should only override <<
        // rather than other tokens like <= . If we treated <= as < in a type
        // context, then the snippet `a as T <= 1` would incorrectly start parsing
        // a type argument on T. We don't need to worry about `a as T << 1`
        // because TypeScript disallows that syntax.
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan, 1);
        else // Outside a type, this might be a true left-shift operator, or it might
        // still be two open-type-arg tokens, such as in `f<<T>() => void>()`. We
        // look at the token while considering the `f`, so we don't yet know that
        // we're in a type context. In this case, we initially tokenize as a
        // left-shift and correct after-the-fact as necessary in
        // tsParseTypeArgumentsWithPossibleBitshift .
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitShiftL, 2);
        return;
    }
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) // <=
    $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).relationalOrEqual, 2);
    else $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan, 1);
}
function $19e70491d10f11e8$var$readToken_gt() {
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType) {
        // Avoid right-shift for things like `Array<Array<string>>` and
        // greater-than-or-equal for things like `const a: Array<number>=[];`.
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan, 1);
        return;
    }
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).greaterThan) {
        const size = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).greaterThan ? 3 : 2;
        if ((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + size) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) {
            $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, size + 1);
            return;
        }
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitShiftR, size);
        return;
    }
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) // >=
    $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).relationalOrEqual, 2);
    else $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan, 1);
}
function $19e70491d10f11e8$export$4d00b4f4d9d7a9b3() {
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos -= 1;
        $19e70491d10f11e8$var$readToken_gt();
    }
}
function $19e70491d10f11e8$var$readToken_eq_excl(code) {
    // '=!'
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) {
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).equality, (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo ? 3 : 2);
        return;
    }
    if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo && nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).greaterThan) {
        // '=>'
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 2;
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
        return;
    }
    $19e70491d10f11e8$var$finishOp(code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo ? (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq : (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bang, 1);
}
function $19e70491d10f11e8$var$readToken_question() {
    // '?'
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
    const nextChar2 = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 2);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).questionMark && // In Flow (but not TypeScript), ??string is a valid type that should be
    // tokenized as two individual ? tokens.
    !((0, $e406deb3d43fd58b$export$92e334f8fe49aa94) && (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).isType)) {
        if (nextChar2 === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo) // '??='
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign, 3);
        else // '??'
        $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).nullishCoalescing, 2);
    } else if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dot && !(nextChar2 >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0 && nextChar2 <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9)) {
        // '.' not followed by a number
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 2;
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot);
    } else {
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    }
}
function $19e70491d10f11e8$export$e0ebb9fd4c2c4701(code) {
    switch(code){
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).numberSign:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).hash);
            return;
        // The interpretation of a dot depends on whether it is followed
        // by a digit or another two dots.
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dot:
            $19e70491d10f11e8$var$readToken_dot();
            return;
        // Punctuation tokens.
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftParenthesis:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).rightParenthesis:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).semicolon:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).comma:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftSquareBracket:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).rightSquareBracket:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftCurlyBrace:
            if ((0, $e406deb3d43fd58b$export$92e334f8fe49aa94) && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).verticalBar) $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceBarL, 2);
            else {
                ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
                $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
            }
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).rightCurlyBrace:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).colon:
            if ((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).colon) $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).doubleColon, 2);
            else {
                ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
                $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
            }
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).questionMark:
            $19e70491d10f11e8$var$readToken_question();
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).atSign:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).graveAccent:
            ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0:
            {
                const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1);
                // '0x', '0X', '0o', '0O', '0b', '0B'
                if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseX || nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseX || nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseO || nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseO || nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseB || nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseB) {
                    $19e70491d10f11e8$var$readRadixNumber();
                    return;
                }
            }
        // Anything else beginning with a digit is an integer, octal
        // number, or float.
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit1:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit2:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit3:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit4:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit5:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit6:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit7:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit8:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9:
            $19e70491d10f11e8$var$readNumber(false);
            return;
        // Quotes produce strings.
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).quotationMark:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).apostrophe:
            $19e70491d10f11e8$var$readString(code);
            return;
        // Operators are parsed inline in tiny state machines. '=' (charCodes.equalsTo) is
        // often referred to. `finishOp` simply skips the amount of
        // characters it is given as second argument, and returns a token
        // of the type given by its first argument.
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).slash:
            $19e70491d10f11e8$var$readToken_slash();
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).percentSign:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).asterisk:
            $19e70491d10f11e8$var$readToken_mult_modulo(code);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).verticalBar:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).ampersand:
            $19e70491d10f11e8$var$readToken_pipe_amp(code);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).caret:
            $19e70491d10f11e8$var$readToken_caret();
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).plusSign:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dash:
            $19e70491d10f11e8$var$readToken_plus_min(code);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lessThan:
            $19e70491d10f11e8$var$readToken_lt();
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).greaterThan:
            $19e70491d10f11e8$var$readToken_gt();
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo:
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).exclamationMark:
            $19e70491d10f11e8$var$readToken_eq_excl(code);
            return;
        case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).tilde:
            $19e70491d10f11e8$var$finishOp((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).tilde, 1);
            return;
        default:
            break;
    }
    (0, $485552d236f25875$export$4c195bc1a97b6f7f)(`Unexpected character '${String.fromCharCode(code)}'`, (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
}
function $19e70491d10f11e8$var$finishOp(type, size) {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += size;
    $19e70491d10f11e8$export$58122cd1933ef607(type);
}
function $19e70491d10f11e8$var$readRegexp() {
    const start = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    let escaped = false;
    let inClass = false;
    for(;;){
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unterminated regular expression", start);
            return;
        }
        const code = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (escaped) escaped = false;
        else {
            if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftSquareBracket) inClass = true;
            else if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).rightSquareBracket && inClass) inClass = false;
            else if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).slash && !inClass) break;
            escaped = code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).backslash;
        }
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    }
    ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    // Need to use `skipWord` because '\uXXXX' sequences are allowed here (don't ask).
    $19e70491d10f11e8$export$abcfffe72e6e8184();
    $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).regexp);
}
/**
 * Read a decimal integer. Note that this can't be unified with the similar code
 * in readRadixNumber (which also handles hex digits) because "e" needs to be
 * the end of the integer so that we can properly handle scientific notation.
 */ function $19e70491d10f11e8$var$readInt() {
    while(true){
        const code = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0 && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9 || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).underscore) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
        else break;
    }
}
function $19e70491d10f11e8$var$readRadixNumber() {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 2; // 0x
    // Walk to the end of the number, allowing hex digits.
    while(true){
        const code = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0 && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9 || code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseA && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseF || code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseA && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseF || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).underscore) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
        else break;
    }
    const nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseN) {
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bigint);
    } else $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num);
}
// Read an integer, octal integer, or floating-point number.
function $19e70491d10f11e8$var$readNumber(startsWithDot) {
    let isBigInt = false;
    let isDecimal = false;
    if (!startsWithDot) $19e70491d10f11e8$var$readInt();
    let nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dot) {
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        $19e70491d10f11e8$var$readInt();
        nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
    }
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseE || nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseE) {
        nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).plusSign || nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dash) ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        $19e70491d10f11e8$var$readInt();
        nextChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
    }
    if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseN) {
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        isBigInt = true;
    } else if (nextChar === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseM) {
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        isDecimal = true;
    }
    if (isBigInt) {
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bigint);
        return;
    }
    if (isDecimal) {
        $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).decimal);
        return;
    }
    $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num);
}
function $19e70491d10f11e8$var$readString(quote) {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
    for(;;){
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unterminated string constant");
            return;
        }
        const ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).backslash) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
        else if (ch === quote) break;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
    }
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
    $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string);
}
// Reads template string tokens.
function $19e70491d10f11e8$var$readTmplToken() {
    for(;;){
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unterminated template");
            return;
        }
        const ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).graveAccent || ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dollarSign && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos + 1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftCurlyBrace) {
            if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos === (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start && $19e70491d10f11e8$export$4659b591c19bdf3d((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).template)) {
                if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dollarSign) {
                    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 2;
                    $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dollarBraceL);
                    return;
                } else {
                    ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
                    $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote);
                    return;
                }
            }
            $19e70491d10f11e8$export$58122cd1933ef607((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).template);
            return;
        }
        if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).backslash) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
    }
}
function $19e70491d10f11e8$export$abcfffe72e6e8184() {
    while((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length){
        const ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if ((0, $231ac6b14e19c571$export$d19df39e3926cfef)[ch]) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
        else if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).backslash) {
            // \u
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos += 2;
            if ((0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftCurlyBrace) {
                while((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos) !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).rightCurlyBrace)(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
            }
        } else break;
    }
}





function $cdb710e84f40793b$export$2e2bcd8739ae039(tokens, index = tokens.currentIndex()) {
    let endIndex = index + 1;
    if ($cdb710e84f40793b$var$isSpecifierEnd(tokens, endIndex)) {
        // import {A}
        const name = tokens.identifierNameAtIndex(index);
        return {
            isType: false,
            leftName: name,
            rightName: name,
            endIndex: endIndex
        };
    }
    endIndex++;
    if ($cdb710e84f40793b$var$isSpecifierEnd(tokens, endIndex)) // import {type A}
    return {
        isType: true,
        leftName: null,
        rightName: null,
        endIndex: endIndex
    };
    endIndex++;
    if ($cdb710e84f40793b$var$isSpecifierEnd(tokens, endIndex)) // import {A as B}
    return {
        isType: false,
        leftName: tokens.identifierNameAtIndex(index),
        rightName: tokens.identifierNameAtIndex(index + 2),
        endIndex: endIndex
    };
    endIndex++;
    if ($cdb710e84f40793b$var$isSpecifierEnd(tokens, endIndex)) // import {type A as B}
    return {
        isType: true,
        leftName: null,
        rightName: null,
        endIndex: endIndex
    };
    throw new Error(`Unexpected import/export specifier at ${index}`);
}
function $cdb710e84f40793b$var$isSpecifierEnd(tokens, index) {
    const token = tokens.tokens[index];
    return token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR || token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma;
}




// Use a Map rather than object to avoid unexpected __proto__ access.
var $a73e151b913ffd13$export$2e2bcd8739ae039 = new Map([
    [
        "quot",
        "\u0022"
    ],
    [
        "amp",
        "&"
    ],
    [
        "apos",
        "\u0027"
    ],
    [
        "lt",
        "<"
    ],
    [
        "gt",
        ">"
    ],
    [
        "nbsp",
        "\u00A0"
    ],
    [
        "iexcl",
        "\u00A1"
    ],
    [
        "cent",
        "\u00A2"
    ],
    [
        "pound",
        "\u00A3"
    ],
    [
        "curren",
        "\u00A4"
    ],
    [
        "yen",
        "\u00A5"
    ],
    [
        "brvbar",
        "\u00A6"
    ],
    [
        "sect",
        "\u00A7"
    ],
    [
        "uml",
        "\u00A8"
    ],
    [
        "copy",
        "\u00A9"
    ],
    [
        "ordf",
        "\u00AA"
    ],
    [
        "laquo",
        "\u00AB"
    ],
    [
        "not",
        "\u00AC"
    ],
    [
        "shy",
        "\u00AD"
    ],
    [
        "reg",
        "\u00AE"
    ],
    [
        "macr",
        "\u00AF"
    ],
    [
        "deg",
        "\u00B0"
    ],
    [
        "plusmn",
        "\u00B1"
    ],
    [
        "sup2",
        "\u00B2"
    ],
    [
        "sup3",
        "\u00B3"
    ],
    [
        "acute",
        "\u00B4"
    ],
    [
        "micro",
        "\u00B5"
    ],
    [
        "para",
        "\u00B6"
    ],
    [
        "middot",
        "\u00B7"
    ],
    [
        "cedil",
        "\u00B8"
    ],
    [
        "sup1",
        "\u00B9"
    ],
    [
        "ordm",
        "\u00BA"
    ],
    [
        "raquo",
        "\u00BB"
    ],
    [
        "frac14",
        "\u00BC"
    ],
    [
        "frac12",
        "\u00BD"
    ],
    [
        "frac34",
        "\u00BE"
    ],
    [
        "iquest",
        "\u00BF"
    ],
    [
        "Agrave",
        "\u00C0"
    ],
    [
        "Aacute",
        "\u00C1"
    ],
    [
        "Acirc",
        "\u00C2"
    ],
    [
        "Atilde",
        "\u00C3"
    ],
    [
        "Auml",
        "\u00C4"
    ],
    [
        "Aring",
        "\u00C5"
    ],
    [
        "AElig",
        "\u00C6"
    ],
    [
        "Ccedil",
        "\u00C7"
    ],
    [
        "Egrave",
        "\u00C8"
    ],
    [
        "Eacute",
        "\u00C9"
    ],
    [
        "Ecirc",
        "\u00CA"
    ],
    [
        "Euml",
        "\u00CB"
    ],
    [
        "Igrave",
        "\u00CC"
    ],
    [
        "Iacute",
        "\u00CD"
    ],
    [
        "Icirc",
        "\u00CE"
    ],
    [
        "Iuml",
        "\u00CF"
    ],
    [
        "ETH",
        "\u00D0"
    ],
    [
        "Ntilde",
        "\u00D1"
    ],
    [
        "Ograve",
        "\u00D2"
    ],
    [
        "Oacute",
        "\u00D3"
    ],
    [
        "Ocirc",
        "\u00D4"
    ],
    [
        "Otilde",
        "\u00D5"
    ],
    [
        "Ouml",
        "\u00D6"
    ],
    [
        "times",
        "\u00D7"
    ],
    [
        "Oslash",
        "\u00D8"
    ],
    [
        "Ugrave",
        "\u00D9"
    ],
    [
        "Uacute",
        "\u00DA"
    ],
    [
        "Ucirc",
        "\u00DB"
    ],
    [
        "Uuml",
        "\u00DC"
    ],
    [
        "Yacute",
        "\u00DD"
    ],
    [
        "THORN",
        "\u00DE"
    ],
    [
        "szlig",
        "\u00DF"
    ],
    [
        "agrave",
        "\u00E0"
    ],
    [
        "aacute",
        "\u00E1"
    ],
    [
        "acirc",
        "\u00E2"
    ],
    [
        "atilde",
        "\u00E3"
    ],
    [
        "auml",
        "\u00E4"
    ],
    [
        "aring",
        "\u00E5"
    ],
    [
        "aelig",
        "\u00E6"
    ],
    [
        "ccedil",
        "\u00E7"
    ],
    [
        "egrave",
        "\u00E8"
    ],
    [
        "eacute",
        "\u00E9"
    ],
    [
        "ecirc",
        "\u00EA"
    ],
    [
        "euml",
        "\u00EB"
    ],
    [
        "igrave",
        "\u00EC"
    ],
    [
        "iacute",
        "\u00ED"
    ],
    [
        "icirc",
        "\u00EE"
    ],
    [
        "iuml",
        "\u00EF"
    ],
    [
        "eth",
        "\u00F0"
    ],
    [
        "ntilde",
        "\u00F1"
    ],
    [
        "ograve",
        "\u00F2"
    ],
    [
        "oacute",
        "\u00F3"
    ],
    [
        "ocirc",
        "\u00F4"
    ],
    [
        "otilde",
        "\u00F5"
    ],
    [
        "ouml",
        "\u00F6"
    ],
    [
        "divide",
        "\u00F7"
    ],
    [
        "oslash",
        "\u00F8"
    ],
    [
        "ugrave",
        "\u00F9"
    ],
    [
        "uacute",
        "\u00FA"
    ],
    [
        "ucirc",
        "\u00FB"
    ],
    [
        "uuml",
        "\u00FC"
    ],
    [
        "yacute",
        "\u00FD"
    ],
    [
        "thorn",
        "\u00FE"
    ],
    [
        "yuml",
        "\u00FF"
    ],
    [
        "OElig",
        "\u0152"
    ],
    [
        "oelig",
        "\u0153"
    ],
    [
        "Scaron",
        "\u0160"
    ],
    [
        "scaron",
        "\u0161"
    ],
    [
        "Yuml",
        "\u0178"
    ],
    [
        "fnof",
        "\u0192"
    ],
    [
        "circ",
        "\u02C6"
    ],
    [
        "tilde",
        "\u02DC"
    ],
    [
        "Alpha",
        "\u0391"
    ],
    [
        "Beta",
        "\u0392"
    ],
    [
        "Gamma",
        "\u0393"
    ],
    [
        "Delta",
        "\u0394"
    ],
    [
        "Epsilon",
        "\u0395"
    ],
    [
        "Zeta",
        "\u0396"
    ],
    [
        "Eta",
        "\u0397"
    ],
    [
        "Theta",
        "\u0398"
    ],
    [
        "Iota",
        "\u0399"
    ],
    [
        "Kappa",
        "\u039A"
    ],
    [
        "Lambda",
        "\u039B"
    ],
    [
        "Mu",
        "\u039C"
    ],
    [
        "Nu",
        "\u039D"
    ],
    [
        "Xi",
        "\u039E"
    ],
    [
        "Omicron",
        "\u039F"
    ],
    [
        "Pi",
        "\u03A0"
    ],
    [
        "Rho",
        "\u03A1"
    ],
    [
        "Sigma",
        "\u03A3"
    ],
    [
        "Tau",
        "\u03A4"
    ],
    [
        "Upsilon",
        "\u03A5"
    ],
    [
        "Phi",
        "\u03A6"
    ],
    [
        "Chi",
        "\u03A7"
    ],
    [
        "Psi",
        "\u03A8"
    ],
    [
        "Omega",
        "\u03A9"
    ],
    [
        "alpha",
        "\u03B1"
    ],
    [
        "beta",
        "\u03B2"
    ],
    [
        "gamma",
        "\u03B3"
    ],
    [
        "delta",
        "\u03B4"
    ],
    [
        "epsilon",
        "\u03B5"
    ],
    [
        "zeta",
        "\u03B6"
    ],
    [
        "eta",
        "\u03B7"
    ],
    [
        "theta",
        "\u03B8"
    ],
    [
        "iota",
        "\u03B9"
    ],
    [
        "kappa",
        "\u03BA"
    ],
    [
        "lambda",
        "\u03BB"
    ],
    [
        "mu",
        "\u03BC"
    ],
    [
        "nu",
        "\u03BD"
    ],
    [
        "xi",
        "\u03BE"
    ],
    [
        "omicron",
        "\u03BF"
    ],
    [
        "pi",
        "\u03C0"
    ],
    [
        "rho",
        "\u03C1"
    ],
    [
        "sigmaf",
        "\u03C2"
    ],
    [
        "sigma",
        "\u03C3"
    ],
    [
        "tau",
        "\u03C4"
    ],
    [
        "upsilon",
        "\u03C5"
    ],
    [
        "phi",
        "\u03C6"
    ],
    [
        "chi",
        "\u03C7"
    ],
    [
        "psi",
        "\u03C8"
    ],
    [
        "omega",
        "\u03C9"
    ],
    [
        "thetasym",
        "\u03D1"
    ],
    [
        "upsih",
        "\u03D2"
    ],
    [
        "piv",
        "\u03D6"
    ],
    [
        "ensp",
        "\u2002"
    ],
    [
        "emsp",
        "\u2003"
    ],
    [
        "thinsp",
        "\u2009"
    ],
    [
        "zwnj",
        "\u200C"
    ],
    [
        "zwj",
        "\u200D"
    ],
    [
        "lrm",
        "\u200E"
    ],
    [
        "rlm",
        "\u200F"
    ],
    [
        "ndash",
        "\u2013"
    ],
    [
        "mdash",
        "\u2014"
    ],
    [
        "lsquo",
        "\u2018"
    ],
    [
        "rsquo",
        "\u2019"
    ],
    [
        "sbquo",
        "\u201A"
    ],
    [
        "ldquo",
        "\u201C"
    ],
    [
        "rdquo",
        "\u201D"
    ],
    [
        "bdquo",
        "\u201E"
    ],
    [
        "dagger",
        "\u2020"
    ],
    [
        "Dagger",
        "\u2021"
    ],
    [
        "bull",
        "\u2022"
    ],
    [
        "hellip",
        "\u2026"
    ],
    [
        "permil",
        "\u2030"
    ],
    [
        "prime",
        "\u2032"
    ],
    [
        "Prime",
        "\u2033"
    ],
    [
        "lsaquo",
        "\u2039"
    ],
    [
        "rsaquo",
        "\u203A"
    ],
    [
        "oline",
        "\u203E"
    ],
    [
        "frasl",
        "\u2044"
    ],
    [
        "euro",
        "\u20AC"
    ],
    [
        "image",
        "\u2111"
    ],
    [
        "weierp",
        "\u2118"
    ],
    [
        "real",
        "\u211C"
    ],
    [
        "trade",
        "\u2122"
    ],
    [
        "alefsym",
        "\u2135"
    ],
    [
        "larr",
        "\u2190"
    ],
    [
        "uarr",
        "\u2191"
    ],
    [
        "rarr",
        "\u2192"
    ],
    [
        "darr",
        "\u2193"
    ],
    [
        "harr",
        "\u2194"
    ],
    [
        "crarr",
        "\u21B5"
    ],
    [
        "lArr",
        "\u21D0"
    ],
    [
        "uArr",
        "\u21D1"
    ],
    [
        "rArr",
        "\u21D2"
    ],
    [
        "dArr",
        "\u21D3"
    ],
    [
        "hArr",
        "\u21D4"
    ],
    [
        "forall",
        "\u2200"
    ],
    [
        "part",
        "\u2202"
    ],
    [
        "exist",
        "\u2203"
    ],
    [
        "empty",
        "\u2205"
    ],
    [
        "nabla",
        "\u2207"
    ],
    [
        "isin",
        "\u2208"
    ],
    [
        "notin",
        "\u2209"
    ],
    [
        "ni",
        "\u220B"
    ],
    [
        "prod",
        "\u220F"
    ],
    [
        "sum",
        "\u2211"
    ],
    [
        "minus",
        "\u2212"
    ],
    [
        "lowast",
        "\u2217"
    ],
    [
        "radic",
        "\u221A"
    ],
    [
        "prop",
        "\u221D"
    ],
    [
        "infin",
        "\u221E"
    ],
    [
        "ang",
        "\u2220"
    ],
    [
        "and",
        "\u2227"
    ],
    [
        "or",
        "\u2228"
    ],
    [
        "cap",
        "\u2229"
    ],
    [
        "cup",
        "\u222A"
    ],
    [
        "int",
        "\u222B"
    ],
    [
        "there4",
        "\u2234"
    ],
    [
        "sim",
        "\u223C"
    ],
    [
        "cong",
        "\u2245"
    ],
    [
        "asymp",
        "\u2248"
    ],
    [
        "ne",
        "\u2260"
    ],
    [
        "equiv",
        "\u2261"
    ],
    [
        "le",
        "\u2264"
    ],
    [
        "ge",
        "\u2265"
    ],
    [
        "sub",
        "\u2282"
    ],
    [
        "sup",
        "\u2283"
    ],
    [
        "nsub",
        "\u2284"
    ],
    [
        "sube",
        "\u2286"
    ],
    [
        "supe",
        "\u2287"
    ],
    [
        "oplus",
        "\u2295"
    ],
    [
        "otimes",
        "\u2297"
    ],
    [
        "perp",
        "\u22A5"
    ],
    [
        "sdot",
        "\u22C5"
    ],
    [
        "lceil",
        "\u2308"
    ],
    [
        "rceil",
        "\u2309"
    ],
    [
        "lfloor",
        "\u230A"
    ],
    [
        "rfloor",
        "\u230B"
    ],
    [
        "lang",
        "\u2329"
    ],
    [
        "rang",
        "\u232A"
    ],
    [
        "loz",
        "\u25CA"
    ],
    [
        "spades",
        "\u2660"
    ],
    [
        "clubs",
        "\u2663"
    ],
    [
        "hearts",
        "\u2665"
    ],
    [
        "diams",
        "\u2666"
    ]
]);





function $e4116504922add70$export$2e2bcd8739ae039(options) {
    const [base, suffix] = $e4116504922add70$var$splitPragma(options.jsxPragma || "React.createElement");
    const [fragmentBase, fragmentSuffix] = $e4116504922add70$var$splitPragma(options.jsxFragmentPragma || "React.Fragment");
    return {
        base: base,
        suffix: suffix,
        fragmentBase: fragmentBase,
        fragmentSuffix: fragmentSuffix
    };
}
function $e4116504922add70$var$splitPragma(pragma) {
    let dotIndex = pragma.indexOf(".");
    if (dotIndex === -1) dotIndex = pragma.length;
    return [
        pragma.slice(0, dotIndex),
        pragma.slice(dotIndex)
    ];
}


class $12b925d88ed0df69$export$2e2bcd8739ae039 {
    // Return true if anything was processed, false otherwise.
    getPrefixCode() {
        return "";
    }
    getHoistedCode() {
        return "";
    }
    getSuffixCode() {
        return "";
    }
}


class $02817d809bdcb26e$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    // State for calculating the line number of each JSX tag in development.
    __init() {
        this.lastLineNumber = 1;
    }
    __init2() {
        this.lastIndex = 0;
    }
    // In development, variable name holding the name of the current file.
    __init3() {
        this.filenameVarName = null;
    }
    // Mapping of claimed names for imports in the automatic transform, e,g.
    // {jsx: "_jsx"}. This determines which imports to generate in the prefix.
    __init4() {
        this.esmAutomaticImportNameResolutions = {};
    }
    // When automatically adding imports in CJS mode, we store the variable name
    // holding the imported CJS module so we can require it in the prefix.
    __init5() {
        this.cjsAutomaticModuleNameResolutions = {};
    }
    constructor(rootTransformer, tokens, importProcessor, nameManager, options){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.importProcessor = importProcessor;
        this.nameManager = nameManager;
        this.options = options;
        $02817d809bdcb26e$export$2e2bcd8739ae039.prototype.__init.call(this);
        $02817d809bdcb26e$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $02817d809bdcb26e$export$2e2bcd8739ae039.prototype.__init3.call(this);
        $02817d809bdcb26e$export$2e2bcd8739ae039.prototype.__init4.call(this);
        $02817d809bdcb26e$export$2e2bcd8739ae039.prototype.__init5.call(this);
        this.jsxPragmaInfo = (0, $e4116504922add70$export$2e2bcd8739ae039)(options);
        this.isAutomaticRuntime = options.jsxRuntime === "automatic";
        this.jsxImportSource = options.jsxImportSource || "react";
    }
    process() {
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart)) {
            this.processJSXTag();
            return true;
        }
        return false;
    }
    getPrefixCode() {
        let prefix = "";
        if (this.filenameVarName) prefix += `const ${this.filenameVarName} = ${JSON.stringify(this.options.filePath || "")};`;
        if (this.isAutomaticRuntime) {
            if (this.importProcessor) // CJS mode: emit require statements for all modules that were referenced.
            for (const [path, resolvedName] of Object.entries(this.cjsAutomaticModuleNameResolutions))prefix += `var ${resolvedName} = require("${path}");`;
            else {
                // ESM mode: consolidate and emit import statements for referenced names.
                const { createElement: createElementResolution, ...otherResolutions } = this.esmAutomaticImportNameResolutions;
                if (createElementResolution) prefix += `import {createElement as ${createElementResolution}} from "${this.jsxImportSource}";`;
                const importSpecifiers = Object.entries(otherResolutions).map(([name, resolvedName])=>`${name} as ${resolvedName}`).join(", ");
                if (importSpecifiers) {
                    const importPath = this.jsxImportSource + (this.options.production ? "/jsx-runtime" : "/jsx-dev-runtime");
                    prefix += `import {${importSpecifiers}} from "${importPath}";`;
                }
            }
        }
        return prefix;
    }
    processJSXTag() {
        const { jsxRole: jsxRole, start: start } = this.tokens.currentToken();
        // Calculate line number information at the very start (if in development
        // mode) so that the information is guaranteed to be queried in token order.
        const elementLocationCode = this.options.production ? null : this.getElementLocationCode(start);
        if (this.isAutomaticRuntime && jsxRole !== (0, $19e70491d10f11e8$export$4620c92ad8b511d9).KeyAfterPropSpread) this.transformTagToJSXFunc(elementLocationCode, jsxRole);
        else this.transformTagToCreateElement(elementLocationCode);
    }
    getElementLocationCode(firstTokenStart) {
        const lineNumber = this.getLineNumberForIndex(firstTokenStart);
        return `lineNumber: ${lineNumber}`;
    }
    /**
   * Get the line number for this source position. This is calculated lazily and
   * must be called in increasing order by index.
   */ getLineNumberForIndex(index) {
        const code = this.tokens.code;
        while(this.lastIndex < index && this.lastIndex < code.length){
            if (code[this.lastIndex] === "\n") this.lastLineNumber++;
            this.lastIndex++;
        }
        return this.lastLineNumber;
    }
    /**
   * Convert the current JSX element to a call to jsx, jsxs, or jsxDEV. This is
   * the primary transformation for the automatic transform.
   *
   * Example:
   * <div a={1} key={2}>Hello{x}</div>
   * becomes
   * jsxs('div', {a: 1, children: ["Hello", x]}, 2)
   */ transformTagToJSXFunc(elementLocationCode, jsxRole) {
        const isStatic = jsxRole === (0, $19e70491d10f11e8$export$4620c92ad8b511d9).StaticChildren;
        // First tag is always jsxTagStart.
        this.tokens.replaceToken(this.getJSXFuncInvocationCode(isStatic));
        let keyCode = null;
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) {
            // Fragment syntax.
            this.tokens.replaceToken(`${this.getFragmentCode()}, {`);
            this.processAutomaticChildrenAndEndProps(jsxRole);
        } else {
            // Normal open tag or self-closing tag.
            this.processTagIntro();
            this.tokens.appendCode(", {");
            keyCode = this.processProps(true);
            if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) // Self-closing tag, no children to add, so close the props.
            this.tokens.appendCode("}");
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) {
                // Tag with children.
                this.tokens.removeToken();
                this.processAutomaticChildrenAndEndProps(jsxRole);
            } else throw new Error("Expected either /> or > at the end of the tag.");
            // If a key was present, move it to its own arg. Note that moving code
            // like this will cause line numbers to get out of sync within the JSX
            // element if the key expression has a newline in it. This is unfortunate,
            // but hopefully should be rare.
            if (keyCode) this.tokens.appendCode(`, ${keyCode}`);
        }
        if (!this.options.production) {
            // If the key wasn't already added, add it now so we can correctly set
            // positional args for jsxDEV.
            if (keyCode === null) this.tokens.appendCode(", void 0");
            this.tokens.appendCode(`, ${isStatic}, ${this.getDevSource(elementLocationCode)}, this`);
        }
        // We're at the close-tag or the end of a self-closing tag, so remove
        // everything else and close the function call.
        this.tokens.removeInitialToken();
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd))this.tokens.removeToken();
        this.tokens.replaceToken(")");
    }
    /**
   * Convert the current JSX element to a createElement call. In the classic
   * runtime, this is the only case. In the automatic runtime, this is called
   * as a fallback in some situations.
   *
   * Example:
   * <div a={1} key={2}>Hello{x}</div>
   * becomes
   * React.createElement('div', {a: 1, key: 2}, "Hello", x)
   */ transformTagToCreateElement(elementLocationCode) {
        // First tag is always jsxTagStart.
        this.tokens.replaceToken(this.getCreateElementInvocationCode());
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) {
            // Fragment syntax.
            this.tokens.replaceToken(`${this.getFragmentCode()}, null`);
            this.processChildren(true);
        } else {
            // Normal open tag or self-closing tag.
            this.processTagIntro();
            this.processPropsObjectWithDevInfo(elementLocationCode);
            if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) ;
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) {
                // Tag with children and a close-tag; process the children as args.
                this.tokens.removeToken();
                this.processChildren(true);
            } else throw new Error("Expected either /> or > at the end of the tag.");
        }
        // We're at the close-tag or the end of a self-closing tag, so remove
        // everything else and close the function call.
        this.tokens.removeInitialToken();
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd))this.tokens.removeToken();
        this.tokens.replaceToken(")");
    }
    /**
   * Get the code for the relevant function for this context: jsx, jsxs,
   * or jsxDEV. The following open-paren is included as well.
   *
   * These functions are only used for the automatic runtime, so they are always
   * auto-imported, but the auto-import will be either CJS or ESM based on the
   * target module format.
   */ getJSXFuncInvocationCode(isStatic) {
        if (this.options.production) {
            if (isStatic) return this.claimAutoImportedFuncInvocation("jsxs", "/jsx-runtime");
            else return this.claimAutoImportedFuncInvocation("jsx", "/jsx-runtime");
        } else return this.claimAutoImportedFuncInvocation("jsxDEV", "/jsx-dev-runtime");
    }
    /**
   * Return the code to use for the createElement function, e.g.
   * `React.createElement`, including the following open-paren.
   *
   * This is the main function to use for the classic runtime. For the
   * automatic runtime, this function is used as a fallback function to
   * preserve behavior when there is a prop spread followed by an explicit
   * key. In that automatic runtime case, the function should be automatically
   * imported.
   */ getCreateElementInvocationCode() {
        if (this.isAutomaticRuntime) return this.claimAutoImportedFuncInvocation("createElement", "");
        else {
            const { jsxPragmaInfo: jsxPragmaInfo } = this;
            const resolvedPragmaBaseName = this.importProcessor ? this.importProcessor.getIdentifierReplacement(jsxPragmaInfo.base) || jsxPragmaInfo.base : jsxPragmaInfo.base;
            return `${resolvedPragmaBaseName}${jsxPragmaInfo.suffix}(`;
        }
    }
    /**
   * Return the code to use as the component when compiling a shorthand
   * fragment, e.g. `React.Fragment`.
   *
   * This may be called from either the classic or automatic runtime, and
   * the value should be auto-imported for the automatic runtime.
   */ getFragmentCode() {
        if (this.isAutomaticRuntime) return this.claimAutoImportedName("Fragment", this.options.production ? "/jsx-runtime" : "/jsx-dev-runtime");
        else {
            const { jsxPragmaInfo: jsxPragmaInfo } = this;
            const resolvedFragmentPragmaBaseName = this.importProcessor ? this.importProcessor.getIdentifierReplacement(jsxPragmaInfo.fragmentBase) || jsxPragmaInfo.fragmentBase : jsxPragmaInfo.fragmentBase;
            return resolvedFragmentPragmaBaseName + jsxPragmaInfo.fragmentSuffix;
        }
    }
    /**
   * Return code that invokes the given function.
   *
   * When the imports transform is enabled, use the CJSImportTransformer
   * strategy of using `.call(void 0, ...` to avoid passing a `this` value in a
   * situation that would otherwise look like a method call.
   */ claimAutoImportedFuncInvocation(funcName, importPathSuffix) {
        const funcCode = this.claimAutoImportedName(funcName, importPathSuffix);
        if (this.importProcessor) return `${funcCode}.call(void 0, `;
        else return `${funcCode}(`;
    }
    claimAutoImportedName(funcName, importPathSuffix) {
        if (this.importProcessor) {
            // CJS mode: claim a name for the module and mark it for import.
            const path = this.jsxImportSource + importPathSuffix;
            if (!this.cjsAutomaticModuleNameResolutions[path]) this.cjsAutomaticModuleNameResolutions[path] = this.importProcessor.getFreeIdentifierForPath(path);
            return `${this.cjsAutomaticModuleNameResolutions[path]}.${funcName}`;
        } else {
            // ESM mode: claim a name for this function and add it to the names that
            // should be auto-imported when the prefix is generated.
            if (!this.esmAutomaticImportNameResolutions[funcName]) this.esmAutomaticImportNameResolutions[funcName] = this.nameManager.claimFreeName(`_${funcName}`);
            return this.esmAutomaticImportNameResolutions[funcName];
        }
    }
    /**
   * Process the first part of a tag, before any props.
   */ processTagIntro() {
        // Walk forward until we see one of these patterns:
        // jsxName to start the first prop, preceded by another jsxName to end the tag name.
        // jsxName to start the first prop, preceded by greaterThan to end the type argument.
        // [open brace] to start the first prop.
        // [jsxTagEnd] to end the open-tag.
        // [slash, jsxTagEnd] to end the self-closing tag.
        let introEnd = this.tokens.currentIndex() + 1;
        while(this.tokens.tokens[introEnd].isType || !this.tokens.matches2AtIndex(introEnd - 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName) && !this.tokens.matches2AtIndex(introEnd - 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName) && !this.tokens.matches1AtIndex(introEnd, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) && !this.tokens.matches1AtIndex(introEnd, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd) && !this.tokens.matches2AtIndex(introEnd, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd))introEnd++;
        if (introEnd === this.tokens.currentIndex() + 1) {
            const tagName = this.tokens.identifierName();
            if ($02817d809bdcb26e$export$b682d115586a1832(tagName)) this.tokens.replaceToken(`'${tagName}'`);
        }
        while(this.tokens.currentIndex() < introEnd)this.rootTransformer.processToken();
    }
    /**
   * Starting at the beginning of the props, add the props argument to
   * React.createElement, including the comma before it.
   */ processPropsObjectWithDevInfo(elementLocationCode) {
        const devProps = this.options.production ? "" : `__self: this, __source: ${this.getDevSource(elementLocationCode)}`;
        if (!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName) && !this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            if (devProps) this.tokens.appendCode(`, {${devProps}}`);
            else this.tokens.appendCode(`, null`);
            return;
        }
        this.tokens.appendCode(`, {`);
        this.processProps(false);
        if (devProps) this.tokens.appendCode(` ${devProps}}`);
        else this.tokens.appendCode("}");
    }
    /**
   * Transform the core part of the props, assuming that a { has already been
   * inserted before us and that a } will be inserted after us.
   *
   * If extractKeyCode is true (i.e. when using any jsx... function), any prop
   * named "key" has its code captured and returned rather than being emitted to
   * the output code. This shifts line numbers, and emitting the code later will
   * correct line numbers again. If no key is found or if extractKeyCode is
   * false, this function returns null.
   */ processProps(extractKeyCode) {
        let keyCode = null;
        while(true){
            if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
                // This is a regular key={value} or key="value" prop.
                const propName = this.tokens.identifierName();
                if (extractKeyCode && propName === "key") {
                    if (keyCode !== null) // The props list has multiple keys. Different implementations are
                    // inconsistent about what to do here: as of this writing, Babel and
                    // swc keep the *last* key and completely remove the rest, while
                    // TypeScript uses the *first* key and leaves the others as regular
                    // props. The React team collaborated with Babel on the
                    // implementation of this behavior, so presumably the Babel behavior
                    // is the one to use.
                    // Since we won't ever be emitting the previous key code, we need to
                    // at least emit its newlines here so that the line numbers match up
                    // in the long run.
                    this.tokens.appendCode(keyCode.replace(/[^\n]/g, ""));
                    // key
                    this.tokens.removeToken();
                    // =
                    this.tokens.removeToken();
                    const snapshot = this.tokens.snapshot();
                    this.processPropValue();
                    keyCode = this.tokens.dangerouslyGetAndRemoveCodeSinceSnapshot(snapshot);
                    continue;
                } else {
                    this.processPropName(propName);
                    this.tokens.replaceToken(": ");
                    this.processPropValue();
                }
            } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName)) {
                // This is a shorthand prop like <input disabled />.
                const propName = this.tokens.identifierName();
                this.processPropName(propName);
                this.tokens.appendCode(": true");
            } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
                // This is prop spread, like <div {...getProps()}>, which we can pass
                // through fairly directly as an object spread.
                this.tokens.replaceToken("");
                this.rootTransformer.processBalancedCode();
                this.tokens.replaceToken("");
            } else break;
            this.tokens.appendCode(",");
        }
        return keyCode;
    }
    processPropName(propName) {
        if (propName.includes("-")) this.tokens.replaceToken(`'${propName}'`);
        else this.tokens.copyToken();
    }
    processPropValue() {
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            this.tokens.replaceToken("");
            this.rootTransformer.processBalancedCode();
            this.tokens.replaceToken("");
        } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart)) this.processJSXTag();
        else this.processStringPropValue();
    }
    processStringPropValue() {
        const token = this.tokens.currentToken();
        const valueCode = this.tokens.code.slice(token.start + 1, token.end - 1);
        const replacementCode = $02817d809bdcb26e$var$formatJSXTextReplacement(valueCode);
        const literalCode = $02817d809bdcb26e$var$formatJSXStringValueLiteral(valueCode);
        this.tokens.replaceToken(literalCode + replacementCode);
    }
    /**
   * Starting in the middle of the props object literal, produce an additional
   * prop for the children and close the object literal.
   */ processAutomaticChildrenAndEndProps(jsxRole) {
        if (jsxRole === (0, $19e70491d10f11e8$export$4620c92ad8b511d9).StaticChildren) {
            this.tokens.appendCode(" children: [");
            this.processChildren(false);
            this.tokens.appendCode("]}");
        } else {
            // The parser information tells us whether we will see a real child or if
            // all remaining children (if any) will resolve to empty. If there are no
            // non-empty children, don't emit a children prop at all, but still
            // process children so that we properly transform the code into nothing.
            if (jsxRole === (0, $19e70491d10f11e8$export$4620c92ad8b511d9).OneChild) this.tokens.appendCode(" children: ");
            this.processChildren(false);
            this.tokens.appendCode("}");
        }
    }
    /**
   * Transform children into a comma-separated list, which will be either
   * arguments to createElement or array elements of a children prop.
   */ processChildren(needsInitialComma) {
        let needsComma = needsInitialComma;
        while(true){
            if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash)) // Closing tag, so no more children.
            return;
            let didEmitElement = false;
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
                if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                    // Empty interpolations and comment-only interpolations are allowed
                    // and don't create an extra child arg.
                    this.tokens.replaceToken("");
                    this.tokens.replaceToken("");
                } else {
                    // Interpolated expression.
                    this.tokens.replaceToken(needsComma ? ", " : "");
                    this.rootTransformer.processBalancedCode();
                    this.tokens.replaceToken("");
                    didEmitElement = true;
                }
            } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart)) {
                // Child JSX element
                this.tokens.appendCode(needsComma ? ", " : "");
                this.processJSXTag();
                didEmitElement = true;
            } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxText) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxEmptyText)) didEmitElement = this.processChildTextElement(needsComma);
            else throw new Error("Unexpected token when processing JSX children.");
            if (didEmitElement) needsComma = true;
        }
    }
    /**
   * Turn a JSX text element into a string literal, or nothing at all if the JSX
   * text resolves to the empty string.
   *
   * Returns true if a string literal is emitted, false otherwise.
   */ processChildTextElement(needsComma) {
        const token = this.tokens.currentToken();
        const valueCode = this.tokens.code.slice(token.start, token.end);
        const replacementCode = $02817d809bdcb26e$var$formatJSXTextReplacement(valueCode);
        const literalCode = $02817d809bdcb26e$var$formatJSXTextLiteral(valueCode);
        if (literalCode === '""') {
            this.tokens.replaceToken(replacementCode);
            return false;
        } else {
            this.tokens.replaceToken(`${needsComma ? ", " : ""}${literalCode}${replacementCode}`);
            return true;
        }
    }
    getDevSource(elementLocationCode) {
        return `{fileName: ${this.getFilenameVarName()}, ${elementLocationCode}}`;
    }
    getFilenameVarName() {
        if (!this.filenameVarName) this.filenameVarName = this.nameManager.claimFreeName("_jsxFileName");
        return this.filenameVarName;
    }
}
function $02817d809bdcb26e$export$b682d115586a1832(s) {
    const firstChar = s.charCodeAt(0);
    return firstChar >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseA && firstChar <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseZ;
}
/**
 * Turn the given jsxText string into a JS string literal. Leading and trailing
 * whitespace on lines is removed, except immediately after the open-tag and
 * before the close-tag. Empty lines are completely removed, and spaces are
 * added between lines after that.
 *
 * We use JSON.stringify to introduce escape characters as necessary, and trim
 * the start and end of each line and remove blank lines.
 */ function $02817d809bdcb26e$var$formatJSXTextLiteral(text) {
    let result = "";
    let whitespace = "";
    let isInInitialLineWhitespace = false;
    let seenNonWhitespace = false;
    for(let i = 0; i < text.length; i++){
        const c = text[i];
        if (c === " " || c === "\t" || c === "\r") {
            if (!isInInitialLineWhitespace) whitespace += c;
        } else if (c === "\n") {
            whitespace = "";
            isInInitialLineWhitespace = true;
        } else {
            if (seenNonWhitespace && isInInitialLineWhitespace) result += " ";
            result += whitespace;
            whitespace = "";
            if (c === "&") {
                const { entity: entity, newI: newI } = $02817d809bdcb26e$var$processEntity(text, i + 1);
                i = newI - 1;
                result += entity;
            } else result += c;
            seenNonWhitespace = true;
            isInInitialLineWhitespace = false;
        }
    }
    if (!isInInitialLineWhitespace) result += whitespace;
    return JSON.stringify(result);
}
/**
 * Produce the code that should be printed after the JSX text string literal,
 * with most content removed, but all newlines preserved and all spacing at the
 * end preserved.
 */ function $02817d809bdcb26e$var$formatJSXTextReplacement(text) {
    let numNewlines = 0;
    let numSpaces = 0;
    for (const c of text){
        if (c === "\n") {
            numNewlines++;
            numSpaces = 0;
        } else if (c === " ") numSpaces++;
    }
    return "\n".repeat(numNewlines) + " ".repeat(numSpaces);
}
/**
 * Format a string in the value position of a JSX prop.
 *
 * Use the same implementation as convertAttribute from
 * babel-helper-builder-react-jsx.
 */ function $02817d809bdcb26e$var$formatJSXStringValueLiteral(text) {
    let result = "";
    for(let i = 0; i < text.length; i++){
        const c = text[i];
        if (c === "\n") {
            if (/\s/.test(text[i + 1])) {
                result += " ";
                while(i < text.length && /\s/.test(text[i + 1]))i++;
            } else result += "\n";
        } else if (c === "&") {
            const { entity: entity, newI: newI } = $02817d809bdcb26e$var$processEntity(text, i + 1);
            result += entity;
            i = newI - 1;
        } else result += c;
    }
    return JSON.stringify(result);
}
/**
 * Starting at a &, see if there's an HTML entity (specified by name, decimal
 * char code, or hex char code) and return it if so.
 *
 * Modified from jsxReadString in babel-parser.
 */ function $02817d809bdcb26e$var$processEntity(text, indexAfterAmpersand) {
    let str = "";
    let count = 0;
    let entity;
    let i = indexAfterAmpersand;
    if (text[i] === "#") {
        let radix = 10;
        i++;
        let numStart;
        if (text[i] === "x") {
            radix = 16;
            i++;
            numStart = i;
            while(i < text.length && $02817d809bdcb26e$var$isHexDigit(text.charCodeAt(i)))i++;
        } else {
            numStart = i;
            while(i < text.length && $02817d809bdcb26e$var$isDecimalDigit(text.charCodeAt(i)))i++;
        }
        if (text[i] === ";") {
            const numStr = text.slice(numStart, i);
            if (numStr) {
                i++;
                entity = String.fromCodePoint(parseInt(numStr, radix));
            }
        }
    } else while(i < text.length && count++ < 10){
        const ch = text[i];
        i++;
        if (ch === ";") {
            entity = (0, $a73e151b913ffd13$export$2e2bcd8739ae039).get(str);
            break;
        }
        str += ch;
    }
    if (!entity) return {
        entity: "&",
        newI: indexAfterAmpersand
    };
    return {
        entity: entity,
        newI: i
    };
}
function $02817d809bdcb26e$var$isDecimalDigit(code) {
    return code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0 && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9;
}
function $02817d809bdcb26e$var$isHexDigit(code) {
    return code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit0 && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).digit9 || code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseA && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseF || code >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseA && code <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).uppercaseF;
}



function $3aa4b3cf1d42f8c2$export$d0e55db0e89d76b7(tokens, options) {
    const jsxPragmaInfo = (0, $e4116504922add70$export$2e2bcd8739ae039)(options);
    const nonTypeIdentifiers = new Set();
    for(let i = 0; i < tokens.tokens.length; i++){
        const token = tokens.tokens[i];
        if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && !token.isType && (token.identifierRole === (0, $19e70491d10f11e8$export$99f888ada3c99de3).Access || token.identifierRole === (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectShorthand || token.identifierRole === (0, $19e70491d10f11e8$export$99f888ada3c99de3).ExportAccess) && !token.shadowsGlobal) nonTypeIdentifiers.add(tokens.identifierNameForToken(token));
        if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart) nonTypeIdentifiers.add(jsxPragmaInfo.base);
        if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart && i + 1 < tokens.tokens.length && tokens.tokens[i + 1].type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd) {
            nonTypeIdentifiers.add(jsxPragmaInfo.base);
            nonTypeIdentifiers.add(jsxPragmaInfo.fragmentBase);
        }
        if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName && token.identifierRole === (0, $19e70491d10f11e8$export$99f888ada3c99de3).Access) {
            const identifierName = tokens.identifierNameForToken(token);
            // Lower-case single-component tag names like "div" don't count.
            if (!(0, $02817d809bdcb26e$export$b682d115586a1832)(identifierName) || tokens.tokens[i + 1].type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot) nonTypeIdentifiers.add(tokens.identifierNameForToken(token));
        }
    }
    return nonTypeIdentifiers;
}


class $cbf8fee06b97a5bb$export$2e2bcd8739ae039 {
    __init() {
        this.nonTypeIdentifiers = new Set();
    }
    __init2() {
        this.importInfoByPath = new Map();
    }
    __init3() {
        this.importsToReplace = new Map();
    }
    __init4() {
        this.identifierReplacements = new Map();
    }
    __init5() {
        this.exportBindingsByLocalName = new Map();
    }
    constructor(nameManager, tokens, enableLegacyTypeScriptModuleInterop, options, isTypeScriptTransformEnabled, keepUnusedImports, helperManager){
        this.nameManager = nameManager;
        this.tokens = tokens;
        this.enableLegacyTypeScriptModuleInterop = enableLegacyTypeScriptModuleInterop;
        this.options = options;
        this.isTypeScriptTransformEnabled = isTypeScriptTransformEnabled;
        this.keepUnusedImports = keepUnusedImports;
        this.helperManager = helperManager;
        $cbf8fee06b97a5bb$export$2e2bcd8739ae039.prototype.__init.call(this);
        $cbf8fee06b97a5bb$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $cbf8fee06b97a5bb$export$2e2bcd8739ae039.prototype.__init3.call(this);
        $cbf8fee06b97a5bb$export$2e2bcd8739ae039.prototype.__init4.call(this);
        $cbf8fee06b97a5bb$export$2e2bcd8739ae039.prototype.__init5.call(this);
    }
    preprocessTokens() {
        for(let i = 0; i < this.tokens.tokens.length; i++){
            if (this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import) && !this.tokens.matches3AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) this.preprocessImportAtIndex(i);
            if (this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export) && !this.tokens.matches2AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) this.preprocessExportAtIndex(i);
        }
        this.generateImportReplacements();
    }
    /**
   * In TypeScript, import statements that only import types should be removed.
   * This includes `import {} from 'foo';`, but not `import 'foo';`.
   */ pruneTypeOnlyImports() {
        this.nonTypeIdentifiers = (0, $3aa4b3cf1d42f8c2$export$d0e55db0e89d76b7)(this.tokens, this.options);
        for (const [path, importInfo] of this.importInfoByPath.entries()){
            if (importInfo.hasBareImport || importInfo.hasStarExport || importInfo.exportStarNames.length > 0 || importInfo.namedExports.length > 0) continue;
            const names = [
                ...importInfo.defaultNames,
                ...importInfo.wildcardNames,
                ...importInfo.namedImports.map(({ localName: localName })=>localName)
            ];
            if (names.every((name)=>this.shouldAutomaticallyElideImportedName(name))) this.importsToReplace.set(path, "");
        }
    }
    shouldAutomaticallyElideImportedName(name) {
        return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.nonTypeIdentifiers.has(name);
    }
    generateImportReplacements() {
        for (const [path, importInfo] of this.importInfoByPath.entries()){
            const { defaultNames: defaultNames, wildcardNames: wildcardNames, namedImports: namedImports, namedExports: namedExports, exportStarNames: exportStarNames, hasStarExport: hasStarExport } = importInfo;
            if (defaultNames.length === 0 && wildcardNames.length === 0 && namedImports.length === 0 && namedExports.length === 0 && exportStarNames.length === 0 && !hasStarExport) {
                // Import is never used, so don't even assign a name.
                this.importsToReplace.set(path, `require('${path}');`);
                continue;
            }
            const primaryImportName = this.getFreeIdentifierForPath(path);
            let secondaryImportName;
            if (this.enableLegacyTypeScriptModuleInterop) secondaryImportName = primaryImportName;
            else secondaryImportName = wildcardNames.length > 0 ? wildcardNames[0] : this.getFreeIdentifierForPath(path);
            let requireCode = `var ${primaryImportName} = require('${path}');`;
            if (wildcardNames.length > 0) for (const wildcardName of wildcardNames){
                const moduleExpr = this.enableLegacyTypeScriptModuleInterop ? primaryImportName : `${this.helperManager.getHelperName("interopRequireWildcard")}(${primaryImportName})`;
                requireCode += ` var ${wildcardName} = ${moduleExpr};`;
            }
            else if (exportStarNames.length > 0 && secondaryImportName !== primaryImportName) requireCode += ` var ${secondaryImportName} = ${this.helperManager.getHelperName("interopRequireWildcard")}(${primaryImportName});`;
            else if (defaultNames.length > 0 && secondaryImportName !== primaryImportName) requireCode += ` var ${secondaryImportName} = ${this.helperManager.getHelperName("interopRequireDefault")}(${primaryImportName});`;
            for (const { importedName: importedName, localName: localName } of namedExports)requireCode += ` ${this.helperManager.getHelperName("createNamedExportFrom")}(${primaryImportName}, '${localName}', '${importedName}');`;
            for (const exportStarName of exportStarNames)requireCode += ` exports.${exportStarName} = ${secondaryImportName};`;
            if (hasStarExport) requireCode += ` ${this.helperManager.getHelperName("createStarExport")}(${primaryImportName});`;
            this.importsToReplace.set(path, requireCode);
            for (const defaultName of defaultNames)this.identifierReplacements.set(defaultName, `${secondaryImportName}.default`);
            for (const { importedName: importedName, localName: localName } of namedImports)this.identifierReplacements.set(localName, `${primaryImportName}.${importedName}`);
        }
    }
    getFreeIdentifierForPath(path) {
        const components = path.split("/");
        const lastComponent = components[components.length - 1];
        const baseName = lastComponent.replace(/\W/g, "");
        return this.nameManager.claimFreeName(`_${baseName}`);
    }
    preprocessImportAtIndex(index) {
        const defaultNames = [];
        const wildcardNames = [];
        const namedImports = [];
        index++;
        if ((this.tokens.matchesContextualAtIndex(index, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) || this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof)) && !this.tokens.matches1AtIndex(index + 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) && !this.tokens.matchesContextualAtIndex(index + 1, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) // import type declaration, so no need to process anything.
        return;
        if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) // Dynamic import, so nothing to do
        return;
        if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
            defaultNames.push(this.tokens.identifierNameAtIndex(index));
            index++;
            if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) index++;
        }
        if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
            // * as
            index += 2;
            wildcardNames.push(this.tokens.identifierNameAtIndex(index));
            index++;
        }
        if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            const result = this.getNamedImports(index + 1);
            index = result.newIndex;
            for (const namedImport of result.namedImports)// Treat {default as X} as a default import to ensure usage of require interop helper
            if (namedImport.importedName === "default") defaultNames.push(namedImport.localName);
            else namedImports.push(namedImport);
        }
        if (this.tokens.matchesContextualAtIndex(index, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) index++;
        if (!this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) throw new Error("Expected string token at the end of import statement.");
        const path = this.tokens.stringValueAtIndex(index);
        const importInfo = this.getImportInfo(path);
        importInfo.defaultNames.push(...defaultNames);
        importInfo.wildcardNames.push(...wildcardNames);
        importInfo.namedImports.push(...namedImports);
        if (defaultNames.length === 0 && wildcardNames.length === 0 && namedImports.length === 0) importInfo.hasBareImport = true;
    }
    preprocessExportAtIndex(index) {
        if (this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var) || this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let) || this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const)) this.preprocessVarExportAtIndex(index);
        else if (this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) || this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class)) {
            const exportName = this.tokens.identifierNameAtIndex(index + 2);
            this.addExportBinding(exportName, exportName);
        } else if (this.tokens.matches3AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function)) {
            const exportName = this.tokens.identifierNameAtIndex(index + 3);
            this.addExportBinding(exportName, exportName);
        } else if (this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) this.preprocessNamedExportAtIndex(index);
        else if (this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) this.preprocessExportStarAtIndex(index);
    }
    preprocessVarExportAtIndex(index) {
        let depth = 0;
        // Handle cases like `export let {x} = y;`, starting at the open-brace in that case.
        for(let i = index + 2;; i++){
            if (this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dollarBraceL) || this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) depth++;
            else if (this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) || this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR)) depth--;
            else if (depth === 0 && !this.tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) break;
            else if (this.tokens.matches1AtIndex(1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
                const endIndex = this.tokens.currentToken().rhsEndIndex;
                if (endIndex == null) throw new Error("Expected = token with an end index.");
                i = endIndex - 1;
            } else {
                const token = this.tokens.tokens[i];
                if ((0, $19e70491d10f11e8$export$31dc9881735f7118)(token)) {
                    const exportName = this.tokens.identifierNameAtIndex(i);
                    this.identifierReplacements.set(exportName, `exports.${exportName}`);
                }
            }
        }
    }
    /**
   * Walk this export statement just in case it's an export...from statement.
   * If it is, combine it into the import info for that path. Otherwise, just
   * bail out; it'll be handled later.
   */ preprocessNamedExportAtIndex(index) {
        // export {
        index += 2;
        const { newIndex: newIndex, namedImports: namedImports } = this.getNamedImports(index);
        index = newIndex;
        if (this.tokens.matchesContextualAtIndex(index, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) index++;
        else {
            // Reinterpret "a as b" to be local/exported rather than imported/local.
            for (const { importedName: localName, localName: exportedName } of namedImports)this.addExportBinding(localName, exportedName);
            return;
        }
        if (!this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) throw new Error("Expected string token at the end of import statement.");
        const path = this.tokens.stringValueAtIndex(index);
        const importInfo = this.getImportInfo(path);
        importInfo.namedExports.push(...namedImports);
    }
    preprocessExportStarAtIndex(index) {
        let exportedName = null;
        if (this.tokens.matches3AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._as)) {
            // export * as
            index += 3;
            exportedName = this.tokens.identifierNameAtIndex(index);
            // foo from
            index += 2;
        } else // export * from
        index += 3;
        if (!this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) throw new Error("Expected string token at the end of star export statement.");
        const path = this.tokens.stringValueAtIndex(index);
        const importInfo = this.getImportInfo(path);
        if (exportedName !== null) importInfo.exportStarNames.push(exportedName);
        else importInfo.hasStarExport = true;
    }
    getNamedImports(index) {
        const namedImports = [];
        while(true){
            if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                index++;
                break;
            }
            const specifierInfo = (0, $cdb710e84f40793b$export$2e2bcd8739ae039)(this.tokens, index);
            index = specifierInfo.endIndex;
            if (!specifierInfo.isType) namedImports.push({
                importedName: specifierInfo.leftName,
                localName: specifierInfo.rightName
            });
            if (this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                index += 2;
                break;
            } else if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                index++;
                break;
            } else if (this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) index++;
            else throw new Error(`Unexpected token: ${JSON.stringify(this.tokens.tokens[index])}`);
        }
        return {
            newIndex: index,
            namedImports: namedImports
        };
    }
    /**
   * Get a mutable import info object for this path, creating one if it doesn't
   * exist yet.
   */ getImportInfo(path) {
        const existingInfo = this.importInfoByPath.get(path);
        if (existingInfo) return existingInfo;
        const newInfo = {
            defaultNames: [],
            wildcardNames: [],
            namedImports: [],
            namedExports: [],
            hasBareImport: false,
            exportStarNames: [],
            hasStarExport: false
        };
        this.importInfoByPath.set(path, newInfo);
        return newInfo;
    }
    addExportBinding(localName, exportedName) {
        if (!this.exportBindingsByLocalName.has(localName)) this.exportBindingsByLocalName.set(localName, []);
        this.exportBindingsByLocalName.get(localName).push(exportedName);
    }
    /**
   * Return the code to use for the import for this path, or the empty string if
   * the code has already been "claimed" by a previous import.
   */ claimImportCode(importPath) {
        const result = this.importsToReplace.get(importPath);
        this.importsToReplace.set(importPath, "");
        return result || "";
    }
    getIdentifierReplacement(identifierName) {
        return this.identifierReplacements.get(identifierName) || null;
    }
    /**
   * Return a string like `exports.foo = exports.bar`.
   */ resolveExportBinding(assignedName) {
        const exportedNames = this.exportBindingsByLocalName.get(assignedName);
        if (!exportedNames || exportedNames.length === 0) return null;
        return exportedNames.map((exportedName)=>`exports.${exportedName}`).join(" = ");
    }
    /**
   * Return all imported/exported names where we might be interested in whether usages of those
   * names are shadowed.
   */ getGlobalNames() {
        return new Set([
            ...this.identifierReplacements.keys(),
            ...this.exportBindingsByLocalName.keys()
        ]);
    }
}


// src/set-array.ts
// src/vlq.ts

var $cbQCu = parcelRequire("cbQCu");
var $54b0cd2d5db5deb6$require$Buffer = $cbQCu.Buffer;
var $54b0cd2d5db5deb6$var$comma = ",".charCodeAt(0);
var $54b0cd2d5db5deb6$var$semicolon = ";".charCodeAt(0);
var $54b0cd2d5db5deb6$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $54b0cd2d5db5deb6$var$intToChar = new Uint8Array(64);
var $54b0cd2d5db5deb6$var$charToInt = new Uint8Array(128);
for(let i = 0; i < $54b0cd2d5db5deb6$var$chars.length; i++){
    const c = $54b0cd2d5db5deb6$var$chars.charCodeAt(i);
    $54b0cd2d5db5deb6$var$intToChar[i] = c;
    $54b0cd2d5db5deb6$var$charToInt[c] = i;
}
function $54b0cd2d5db5deb6$var$decodeInteger(reader, relative) {
    let value = 0;
    let shift = 0;
    let integer = 0;
    do {
        const c = reader.next();
        integer = $54b0cd2d5db5deb6$var$charToInt[c];
        value |= (integer & 31) << shift;
        shift += 5;
    }while (integer & 32);
    const shouldNegate = value & 1;
    value >>>= 1;
    if (shouldNegate) value = -2147483648 | -value;
    return relative + value;
}
function $54b0cd2d5db5deb6$var$encodeInteger(builder, num, relative) {
    let delta = num - relative;
    delta = delta < 0 ? -delta << 1 | 1 : delta << 1;
    do {
        let clamped = delta & 31;
        delta >>>= 5;
        if (delta > 0) clamped |= 32;
        builder.write($54b0cd2d5db5deb6$var$intToChar[clamped]);
    }while (delta > 0);
    return num;
}
function $54b0cd2d5db5deb6$var$hasMoreVlq(reader, max) {
    if (reader.pos >= max) return false;
    return reader.peek() !== $54b0cd2d5db5deb6$var$comma;
}
// src/strings.ts
var $54b0cd2d5db5deb6$var$bufLength = 16384;
var $54b0cd2d5db5deb6$var$td = typeof TextDecoder !== "undefined" ? /* @__PURE__ */ new TextDecoder() : typeof $54b0cd2d5db5deb6$require$Buffer !== "undefined" ? {
    decode (buf) {
        const out = $54b0cd2d5db5deb6$require$Buffer.from(buf.buffer, buf.byteOffset, buf.byteLength);
        return out.toString();
    }
} : {
    decode (buf) {
        let out = "";
        for(let i = 0; i < buf.length; i++)out += String.fromCharCode(buf[i]);
        return out;
    }
};
var $54b0cd2d5db5deb6$var$StringWriter = class {
    constructor(){
        this.pos = 0;
        this.out = "";
        this.buffer = new Uint8Array($54b0cd2d5db5deb6$var$bufLength);
    }
    write(v) {
        const { buffer: buffer } = this;
        buffer[this.pos++] = v;
        if (this.pos === $54b0cd2d5db5deb6$var$bufLength) {
            this.out += $54b0cd2d5db5deb6$var$td.decode(buffer);
            this.pos = 0;
        }
    }
    flush() {
        const { buffer: buffer, out: out, pos: pos } = this;
        return pos > 0 ? out + $54b0cd2d5db5deb6$var$td.decode(buffer.subarray(0, pos)) : out;
    }
};
var $54b0cd2d5db5deb6$var$StringReader = class {
    constructor(buffer){
        this.pos = 0;
        this.buffer = buffer;
    }
    next() {
        return this.buffer.charCodeAt(this.pos++);
    }
    peek() {
        return this.buffer.charCodeAt(this.pos);
    }
    indexOf(char) {
        const { buffer: buffer, pos: pos } = this;
        const idx = buffer.indexOf(char, pos);
        return idx === -1 ? buffer.length : idx;
    }
};
// src/scopes.ts
var $54b0cd2d5db5deb6$var$EMPTY = [];
function $54b0cd2d5db5deb6$export$b644ec5c290d956e(input) {
    const { length: length } = input;
    const reader = new $54b0cd2d5db5deb6$var$StringReader(input);
    const scopes = [];
    const stack = [];
    let line = 0;
    for(; reader.pos < length; reader.pos++){
        line = $54b0cd2d5db5deb6$var$decodeInteger(reader, line);
        const column = $54b0cd2d5db5deb6$var$decodeInteger(reader, 0);
        if (!$54b0cd2d5db5deb6$var$hasMoreVlq(reader, length)) {
            const last = stack.pop();
            last[2] = line;
            last[3] = column;
            continue;
        }
        const kind = $54b0cd2d5db5deb6$var$decodeInteger(reader, 0);
        const fields = $54b0cd2d5db5deb6$var$decodeInteger(reader, 0);
        const hasName = fields & 1;
        const scope = hasName ? [
            line,
            column,
            0,
            0,
            kind,
            $54b0cd2d5db5deb6$var$decodeInteger(reader, 0)
        ] : [
            line,
            column,
            0,
            0,
            kind
        ];
        let vars = $54b0cd2d5db5deb6$var$EMPTY;
        if ($54b0cd2d5db5deb6$var$hasMoreVlq(reader, length)) {
            vars = [];
            do {
                const varsIndex = $54b0cd2d5db5deb6$var$decodeInteger(reader, 0);
                vars.push(varsIndex);
            }while ($54b0cd2d5db5deb6$var$hasMoreVlq(reader, length));
        }
        scope.vars = vars;
        scopes.push(scope);
        stack.push(scope);
    }
    return scopes;
}
function $54b0cd2d5db5deb6$export$b8cf1ed92d4ce741(scopes) {
    const writer = new $54b0cd2d5db5deb6$var$StringWriter();
    for(let i = 0; i < scopes.length;)i = $54b0cd2d5db5deb6$var$_encodeOriginalScopes(scopes, i, writer, [
        0
    ]);
    return writer.flush();
}
function $54b0cd2d5db5deb6$var$_encodeOriginalScopes(scopes, index, writer, state) {
    const scope = scopes[index];
    const { 0: startLine, 1: startColumn, 2: endLine, 3: endColumn, 4: kind, vars: vars } = scope;
    if (index > 0) writer.write($54b0cd2d5db5deb6$var$comma);
    state[0] = $54b0cd2d5db5deb6$var$encodeInteger(writer, startLine, state[0]);
    $54b0cd2d5db5deb6$var$encodeInteger(writer, startColumn, 0);
    $54b0cd2d5db5deb6$var$encodeInteger(writer, kind, 0);
    const fields = scope.length === 6 ? 1 : 0;
    $54b0cd2d5db5deb6$var$encodeInteger(writer, fields, 0);
    if (scope.length === 6) $54b0cd2d5db5deb6$var$encodeInteger(writer, scope[5], 0);
    for (const v of vars)$54b0cd2d5db5deb6$var$encodeInteger(writer, v, 0);
    for(index++; index < scopes.length;){
        const next = scopes[index];
        const { 0: l, 1: c } = next;
        if (l > endLine || l === endLine && c >= endColumn) break;
        index = $54b0cd2d5db5deb6$var$_encodeOriginalScopes(scopes, index, writer, state);
    }
    writer.write($54b0cd2d5db5deb6$var$comma);
    state[0] = $54b0cd2d5db5deb6$var$encodeInteger(writer, endLine, state[0]);
    $54b0cd2d5db5deb6$var$encodeInteger(writer, endColumn, 0);
    return index;
}
function $54b0cd2d5db5deb6$export$dadc7b4b4811a4cd(input) {
    const { length: length } = input;
    const reader = new $54b0cd2d5db5deb6$var$StringReader(input);
    const ranges = [];
    const stack = [];
    let genLine = 0;
    let definitionSourcesIndex = 0;
    let definitionScopeIndex = 0;
    let callsiteSourcesIndex = 0;
    let callsiteLine = 0;
    let callsiteColumn = 0;
    let bindingLine = 0;
    let bindingColumn = 0;
    do {
        const semi = reader.indexOf(";");
        let genColumn = 0;
        for(; reader.pos < semi; reader.pos++){
            genColumn = $54b0cd2d5db5deb6$var$decodeInteger(reader, genColumn);
            if (!$54b0cd2d5db5deb6$var$hasMoreVlq(reader, semi)) {
                const last = stack.pop();
                last[2] = genLine;
                last[3] = genColumn;
                continue;
            }
            const fields = $54b0cd2d5db5deb6$var$decodeInteger(reader, 0);
            const hasDefinition = fields & 1;
            const hasCallsite = fields & 2;
            const hasScope = fields & 4;
            let callsite = null;
            let bindings = $54b0cd2d5db5deb6$var$EMPTY;
            let range;
            if (hasDefinition) {
                const defSourcesIndex = $54b0cd2d5db5deb6$var$decodeInteger(reader, definitionSourcesIndex);
                definitionScopeIndex = $54b0cd2d5db5deb6$var$decodeInteger(reader, definitionSourcesIndex === defSourcesIndex ? definitionScopeIndex : 0);
                definitionSourcesIndex = defSourcesIndex;
                range = [
                    genLine,
                    genColumn,
                    0,
                    0,
                    defSourcesIndex,
                    definitionScopeIndex
                ];
            } else range = [
                genLine,
                genColumn,
                0,
                0
            ];
            range.isScope = !!hasScope;
            if (hasCallsite) {
                const prevCsi = callsiteSourcesIndex;
                const prevLine = callsiteLine;
                callsiteSourcesIndex = $54b0cd2d5db5deb6$var$decodeInteger(reader, callsiteSourcesIndex);
                const sameSource = prevCsi === callsiteSourcesIndex;
                callsiteLine = $54b0cd2d5db5deb6$var$decodeInteger(reader, sameSource ? callsiteLine : 0);
                callsiteColumn = $54b0cd2d5db5deb6$var$decodeInteger(reader, sameSource && prevLine === callsiteLine ? callsiteColumn : 0);
                callsite = [
                    callsiteSourcesIndex,
                    callsiteLine,
                    callsiteColumn
                ];
            }
            range.callsite = callsite;
            if ($54b0cd2d5db5deb6$var$hasMoreVlq(reader, semi)) {
                bindings = [];
                do {
                    bindingLine = genLine;
                    bindingColumn = genColumn;
                    const expressionsCount = $54b0cd2d5db5deb6$var$decodeInteger(reader, 0);
                    let expressionRanges;
                    if (expressionsCount < -1) {
                        expressionRanges = [
                            [
                                $54b0cd2d5db5deb6$var$decodeInteger(reader, 0)
                            ]
                        ];
                        for(let i = -1; i > expressionsCount; i--){
                            const prevBl = bindingLine;
                            bindingLine = $54b0cd2d5db5deb6$var$decodeInteger(reader, bindingLine);
                            bindingColumn = $54b0cd2d5db5deb6$var$decodeInteger(reader, bindingLine === prevBl ? bindingColumn : 0);
                            const expression = $54b0cd2d5db5deb6$var$decodeInteger(reader, 0);
                            expressionRanges.push([
                                expression,
                                bindingLine,
                                bindingColumn
                            ]);
                        }
                    } else expressionRanges = [
                        [
                            expressionsCount
                        ]
                    ];
                    bindings.push(expressionRanges);
                }while ($54b0cd2d5db5deb6$var$hasMoreVlq(reader, semi));
            }
            range.bindings = bindings;
            ranges.push(range);
            stack.push(range);
        }
        genLine++;
        reader.pos = semi + 1;
    }while (reader.pos < length);
    return ranges;
}
function $54b0cd2d5db5deb6$export$8e469a859d564769(ranges) {
    if (ranges.length === 0) return "";
    const writer = new $54b0cd2d5db5deb6$var$StringWriter();
    for(let i = 0; i < ranges.length;)i = $54b0cd2d5db5deb6$var$_encodeGeneratedRanges(ranges, i, writer, [
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ]);
    return writer.flush();
}
function $54b0cd2d5db5deb6$var$_encodeGeneratedRanges(ranges, index, writer, state) {
    const range = ranges[index];
    const { 0: startLine, 1: startColumn, 2: endLine, 3: endColumn, isScope: isScope, callsite: callsite, bindings: bindings } = range;
    if (state[0] < startLine) {
        $54b0cd2d5db5deb6$var$catchupLine(writer, state[0], startLine);
        state[0] = startLine;
        state[1] = 0;
    } else if (index > 0) writer.write($54b0cd2d5db5deb6$var$comma);
    state[1] = $54b0cd2d5db5deb6$var$encodeInteger(writer, range[1], state[1]);
    const fields = (range.length === 6 ? 1 : 0) | (callsite ? 2 : 0) | (isScope ? 4 : 0);
    $54b0cd2d5db5deb6$var$encodeInteger(writer, fields, 0);
    if (range.length === 6) {
        const { 4: sourcesIndex, 5: scopesIndex } = range;
        if (sourcesIndex !== state[2]) state[3] = 0;
        state[2] = $54b0cd2d5db5deb6$var$encodeInteger(writer, sourcesIndex, state[2]);
        state[3] = $54b0cd2d5db5deb6$var$encodeInteger(writer, scopesIndex, state[3]);
    }
    if (callsite) {
        const { 0: sourcesIndex, 1: callLine, 2: callColumn } = range.callsite;
        if (sourcesIndex !== state[4]) {
            state[5] = 0;
            state[6] = 0;
        } else if (callLine !== state[5]) state[6] = 0;
        state[4] = $54b0cd2d5db5deb6$var$encodeInteger(writer, sourcesIndex, state[4]);
        state[5] = $54b0cd2d5db5deb6$var$encodeInteger(writer, callLine, state[5]);
        state[6] = $54b0cd2d5db5deb6$var$encodeInteger(writer, callColumn, state[6]);
    }
    if (bindings) for (const binding of bindings){
        if (binding.length > 1) $54b0cd2d5db5deb6$var$encodeInteger(writer, -binding.length, 0);
        const expression = binding[0][0];
        $54b0cd2d5db5deb6$var$encodeInteger(writer, expression, 0);
        let bindingStartLine = startLine;
        let bindingStartColumn = startColumn;
        for(let i = 1; i < binding.length; i++){
            const expRange = binding[i];
            bindingStartLine = $54b0cd2d5db5deb6$var$encodeInteger(writer, expRange[1], bindingStartLine);
            bindingStartColumn = $54b0cd2d5db5deb6$var$encodeInteger(writer, expRange[2], bindingStartColumn);
            $54b0cd2d5db5deb6$var$encodeInteger(writer, expRange[0], 0);
        }
    }
    for(index++; index < ranges.length;){
        const next = ranges[index];
        const { 0: l, 1: c } = next;
        if (l > endLine || l === endLine && c >= endColumn) break;
        index = $54b0cd2d5db5deb6$var$_encodeGeneratedRanges(ranges, index, writer, state);
    }
    if (state[0] < endLine) {
        $54b0cd2d5db5deb6$var$catchupLine(writer, state[0], endLine);
        state[0] = endLine;
        state[1] = 0;
    } else writer.write($54b0cd2d5db5deb6$var$comma);
    state[1] = $54b0cd2d5db5deb6$var$encodeInteger(writer, endColumn, state[1]);
    return index;
}
function $54b0cd2d5db5deb6$var$catchupLine(writer, lastLine, line) {
    do writer.write($54b0cd2d5db5deb6$var$semicolon);
    while (++lastLine < line);
}
// src/sourcemap-codec.ts
function $54b0cd2d5db5deb6$export$2f872c0f2117be69(mappings) {
    const { length: length } = mappings;
    const reader = new $54b0cd2d5db5deb6$var$StringReader(mappings);
    const decoded = [];
    let genColumn = 0;
    let sourcesIndex = 0;
    let sourceLine = 0;
    let sourceColumn = 0;
    let namesIndex = 0;
    do {
        const semi = reader.indexOf(";");
        const line = [];
        let sorted = true;
        let lastCol = 0;
        genColumn = 0;
        while(reader.pos < semi){
            let seg;
            genColumn = $54b0cd2d5db5deb6$var$decodeInteger(reader, genColumn);
            if (genColumn < lastCol) sorted = false;
            lastCol = genColumn;
            if ($54b0cd2d5db5deb6$var$hasMoreVlq(reader, semi)) {
                sourcesIndex = $54b0cd2d5db5deb6$var$decodeInteger(reader, sourcesIndex);
                sourceLine = $54b0cd2d5db5deb6$var$decodeInteger(reader, sourceLine);
                sourceColumn = $54b0cd2d5db5deb6$var$decodeInteger(reader, sourceColumn);
                if ($54b0cd2d5db5deb6$var$hasMoreVlq(reader, semi)) {
                    namesIndex = $54b0cd2d5db5deb6$var$decodeInteger(reader, namesIndex);
                    seg = [
                        genColumn,
                        sourcesIndex,
                        sourceLine,
                        sourceColumn,
                        namesIndex
                    ];
                } else seg = [
                    genColumn,
                    sourcesIndex,
                    sourceLine,
                    sourceColumn
                ];
            } else seg = [
                genColumn
            ];
            line.push(seg);
            reader.pos++;
        }
        if (!sorted) $54b0cd2d5db5deb6$var$sort(line);
        decoded.push(line);
        reader.pos = semi + 1;
    }while (reader.pos <= length);
    return decoded;
}
function $54b0cd2d5db5deb6$var$sort(line) {
    line.sort($54b0cd2d5db5deb6$var$sortComparator);
}
function $54b0cd2d5db5deb6$var$sortComparator(a, b) {
    return a[0] - b[0];
}
function $54b0cd2d5db5deb6$export$c564cdbbe6da493(decoded) {
    const writer = new $54b0cd2d5db5deb6$var$StringWriter();
    let sourcesIndex = 0;
    let sourceLine = 0;
    let sourceColumn = 0;
    let namesIndex = 0;
    for(let i = 0; i < decoded.length; i++){
        const line = decoded[i];
        if (i > 0) writer.write($54b0cd2d5db5deb6$var$semicolon);
        if (line.length === 0) continue;
        let genColumn = 0;
        for(let j = 0; j < line.length; j++){
            const segment = line[j];
            if (j > 0) writer.write($54b0cd2d5db5deb6$var$comma);
            genColumn = $54b0cd2d5db5deb6$var$encodeInteger(writer, segment[0], genColumn);
            if (segment.length === 1) continue;
            sourcesIndex = $54b0cd2d5db5deb6$var$encodeInteger(writer, segment[1], sourcesIndex);
            sourceLine = $54b0cd2d5db5deb6$var$encodeInteger(writer, segment[2], sourceLine);
            sourceColumn = $54b0cd2d5db5deb6$var$encodeInteger(writer, segment[3], sourceColumn);
            if (segment.length === 4) continue;
            namesIndex = $54b0cd2d5db5deb6$var$encodeInteger(writer, segment[4], namesIndex);
        }
    }
    return writer.flush();
}


// src/trace-mapping.ts

var $26d1c6a7751473b9$exports = {};
(function(global, factory) {
    $26d1c6a7751473b9$exports = factory();
})($26d1c6a7751473b9$exports, function() {
    'use strict';
    // Matches the scheme of a URL, eg "http://"
    const schemeRegex = /^[\w+.-]+:\/\//;
    /**
     * Matches the parts of a URL:
     * 1. Scheme, including ":", guaranteed.
     * 2. User/password, including "@", optional.
     * 3. Host, guaranteed.
     * 4. Port, including ":", optional.
     * 5. Path, including "/", optional.
     * 6. Query, including "?", optional.
     * 7. Hash, including "#", optional.
     */ const urlRegex = /^([\w+.-]+:)\/\/([^@/#?]*@)?([^:/#?]*)(:\d+)?(\/[^#?]*)?(\?[^#]*)?(#.*)?/;
    /**
     * File URLs are weird. They dont' need the regular `//` in the scheme, they may or may not start
     * with a leading `/`, they can have a domain (but only if they don't start with a Windows drive).
     *
     * 1. Host, optional.
     * 2. Path, which may include "/", guaranteed.
     * 3. Query, including "?", optional.
     * 4. Hash, including "#", optional.
     */ const fileRegex = /^file:(?:\/\/((?![a-z]:)[^/#?]*)?)?(\/?[^#?]*)(\?[^#]*)?(#.*)?/i;
    function isAbsoluteUrl(input) {
        return schemeRegex.test(input);
    }
    function isSchemeRelativeUrl(input) {
        return input.startsWith('//');
    }
    function isAbsolutePath(input) {
        return input.startsWith('/');
    }
    function isFileUrl(input) {
        return input.startsWith('file:');
    }
    function isRelative(input) {
        return /^[.?#]/.test(input);
    }
    function parseAbsoluteUrl(input) {
        const match = urlRegex.exec(input);
        return makeUrl(match[1], match[2] || '', match[3], match[4] || '', match[5] || '/', match[6] || '', match[7] || '');
    }
    function parseFileUrl(input) {
        const match = fileRegex.exec(input);
        const path = match[2];
        return makeUrl('file:', '', match[1] || '', '', isAbsolutePath(path) ? path : '/' + path, match[3] || '', match[4] || '');
    }
    function makeUrl(scheme, user, host, port, path, query, hash) {
        return {
            scheme: scheme,
            user: user,
            host: host,
            port: port,
            path: path,
            query: query,
            hash: hash,
            type: 7 /* Absolute */ 
        };
    }
    function parseUrl(input) {
        if (isSchemeRelativeUrl(input)) {
            const url = parseAbsoluteUrl('http:' + input);
            url.scheme = '';
            url.type = 6 /* SchemeRelative */ ;
            return url;
        }
        if (isAbsolutePath(input)) {
            const url = parseAbsoluteUrl('http://foo.com' + input);
            url.scheme = '';
            url.host = '';
            url.type = 5 /* AbsolutePath */ ;
            return url;
        }
        if (isFileUrl(input)) return parseFileUrl(input);
        if (isAbsoluteUrl(input)) return parseAbsoluteUrl(input);
        const url = parseAbsoluteUrl('http://foo.com/' + input);
        url.scheme = '';
        url.host = '';
        url.type = input ? input.startsWith('?') ? 3 /* Query */  : input.startsWith('#') ? 2 /* Hash */  : 4 /* RelativePath */  : 1 /* Empty */ ;
        return url;
    }
    function stripPathFilename(path) {
        // If a path ends with a parent directory "..", then it's a relative path with excess parent
        // paths. It's not a file, so we can't strip it.
        if (path.endsWith('/..')) return path;
        const index = path.lastIndexOf('/');
        return path.slice(0, index + 1);
    }
    function mergePaths(url, base) {
        normalizePath(base, base.type);
        // If the path is just a "/", then it was an empty path to begin with (remember, we're a relative
        // path).
        if (url.path === '/') url.path = base.path;
        else // Resolution happens relative to the base path's directory, not the file.
        url.path = stripPathFilename(base.path) + url.path;
    }
    /**
     * The path can have empty directories "//", unneeded parents "foo/..", or current directory
     * "foo/.". We need to normalize to a standard representation.
     */ function normalizePath(url, type) {
        const rel = type <= 4 /* RelativePath */ ;
        const pieces = url.path.split('/');
        // We need to preserve the first piece always, so that we output a leading slash. The item at
        // pieces[0] is an empty string.
        let pointer = 1;
        // Positive is the number of real directories we've output, used for popping a parent directory.
        // Eg, "foo/bar/.." will have a positive 2, and we can decrement to be left with just "foo".
        let positive = 0;
        // We need to keep a trailing slash if we encounter an empty directory (eg, splitting "foo/" will
        // generate `["foo", ""]` pieces). And, if we pop a parent directory. But once we encounter a
        // real directory, we won't need to append, unless the other conditions happen again.
        let addTrailingSlash = false;
        for(let i = 1; i < pieces.length; i++){
            const piece = pieces[i];
            // An empty directory, could be a trailing slash, or just a double "//" in the path.
            if (!piece) {
                addTrailingSlash = true;
                continue;
            }
            // If we encounter a real directory, then we don't need to append anymore.
            addTrailingSlash = false;
            // A current directory, which we can always drop.
            if (piece === '.') continue;
            // A parent directory, we need to see if there are any real directories we can pop. Else, we
            // have an excess of parents, and we'll need to keep the "..".
            if (piece === '..') {
                if (positive) {
                    addTrailingSlash = true;
                    positive--;
                    pointer--;
                } else if (rel) // If we're in a relativePath, then we need to keep the excess parents. Else, in an absolute
                // URL, protocol relative URL, or an absolute path, we don't need to keep excess.
                pieces[pointer++] = piece;
                continue;
            }
            // We've encountered a real directory. Move it to the next insertion pointer, which accounts for
            // any popped or dropped directories.
            pieces[pointer++] = piece;
            positive++;
        }
        let path = '';
        for(let i = 1; i < pointer; i++)path += '/' + pieces[i];
        if (!path || addTrailingSlash && !path.endsWith('/..')) path += '/';
        url.path = path;
    }
    /**
     * Attempts to resolve `input` URL/path relative to `base`.
     */ function resolve(input, base) {
        if (!input && !base) return '';
        const url = parseUrl(input);
        let inputType = url.type;
        if (base && inputType !== 7 /* Absolute */ ) {
            const baseUrl = parseUrl(base);
            const baseType = baseUrl.type;
            switch(inputType){
                case 1 /* Empty */ :
                    url.hash = baseUrl.hash;
                // fall through
                case 2 /* Hash */ :
                    url.query = baseUrl.query;
                // fall through
                case 3 /* Query */ :
                case 4 /* RelativePath */ :
                    mergePaths(url, baseUrl);
                // fall through
                case 5 /* AbsolutePath */ :
                    // The host, user, and port are joined, you can't copy one without the others.
                    url.user = baseUrl.user;
                    url.host = baseUrl.host;
                    url.port = baseUrl.port;
                // fall through
                case 6 /* SchemeRelative */ :
                    // The input doesn't have a schema at least, so we need to copy at least that over.
                    url.scheme = baseUrl.scheme;
            }
            if (baseType > inputType) inputType = baseType;
        }
        normalizePath(url, inputType);
        const queryHash = url.query + url.hash;
        switch(inputType){
            // This is impossible, because of the empty checks at the start of the function.
            // case UrlType.Empty:
            case 2 /* Hash */ :
            case 3 /* Query */ :
                return queryHash;
            case 4 /* RelativePath */ :
                {
                    // The first char is always a "/", and we need it to be relative.
                    const path = url.path.slice(1);
                    if (!path) return queryHash || '.';
                    if (isRelative(base || input) && !isRelative(path)) // If base started with a leading ".", or there is no base and input started with a ".",
                    // then we need to ensure that the relative path starts with a ".". We don't know if
                    // relative starts with a "..", though, so check before prepending.
                    return './' + path + queryHash;
                    return path + queryHash;
                }
            case 5 /* AbsolutePath */ :
                return url.path + queryHash;
            default:
                return url.scheme + '//' + url.user + url.host + url.port + url.path + queryHash;
        }
    }
    return resolve;
});


// src/strip-filename.ts
function $74992569aad6589c$var$stripFilename(path) {
    if (!path) return "";
    const index = path.lastIndexOf("/");
    return path.slice(0, index + 1);
}
// src/resolve.ts
function $74992569aad6589c$var$resolver(mapUrl, sourceRoot) {
    const from = $74992569aad6589c$var$stripFilename(mapUrl);
    const prefix = sourceRoot ? sourceRoot + "/" : "";
    return (source)=>(0, (/*@__PURE__*/$parcel$interopDefault($26d1c6a7751473b9$exports)))(prefix + (source || ""), from);
}
// src/sourcemap-segment.ts
var $74992569aad6589c$var$COLUMN = 0;
var $74992569aad6589c$var$SOURCES_INDEX = 1;
var $74992569aad6589c$var$SOURCE_LINE = 2;
var $74992569aad6589c$var$SOURCE_COLUMN = 3;
var $74992569aad6589c$var$NAMES_INDEX = 4;
var $74992569aad6589c$var$REV_GENERATED_LINE = 1;
var $74992569aad6589c$var$REV_GENERATED_COLUMN = 2;
// src/sort.ts
function $74992569aad6589c$var$maybeSort(mappings, owned) {
    const unsortedIndex = $74992569aad6589c$var$nextUnsortedSegmentLine(mappings, 0);
    if (unsortedIndex === mappings.length) return mappings;
    if (!owned) mappings = mappings.slice();
    for(let i = unsortedIndex; i < mappings.length; i = $74992569aad6589c$var$nextUnsortedSegmentLine(mappings, i + 1))mappings[i] = $74992569aad6589c$var$sortSegments(mappings[i], owned);
    return mappings;
}
function $74992569aad6589c$var$nextUnsortedSegmentLine(mappings, start) {
    for(let i = start; i < mappings.length; i++){
        if (!$74992569aad6589c$var$isSorted(mappings[i])) return i;
    }
    return mappings.length;
}
function $74992569aad6589c$var$isSorted(line) {
    for(let j = 1; j < line.length; j++){
        if (line[j][$74992569aad6589c$var$COLUMN] < line[j - 1][$74992569aad6589c$var$COLUMN]) return false;
    }
    return true;
}
function $74992569aad6589c$var$sortSegments(line, owned) {
    if (!owned) line = line.slice();
    return line.sort($74992569aad6589c$var$sortComparator);
}
function $74992569aad6589c$var$sortComparator(a, b) {
    return a[$74992569aad6589c$var$COLUMN] - b[$74992569aad6589c$var$COLUMN];
}
// src/by-source.ts
function $74992569aad6589c$var$buildBySources(decoded, memos) {
    const sources = memos.map(()=>[]);
    for(let i = 0; i < decoded.length; i++){
        const line = decoded[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            if (seg.length === 1) continue;
            const sourceIndex2 = seg[$74992569aad6589c$var$SOURCES_INDEX];
            const sourceLine = seg[$74992569aad6589c$var$SOURCE_LINE];
            const sourceColumn = seg[$74992569aad6589c$var$SOURCE_COLUMN];
            const source = sources[sourceIndex2];
            const segs = source[sourceLine] || (source[sourceLine] = []);
            segs.push([
                sourceColumn,
                i,
                seg[$74992569aad6589c$var$COLUMN]
            ]);
        }
    }
    for(let i = 0; i < sources.length; i++){
        const source = sources[i];
        for(let j = 0; j < source.length; j++){
            const line = source[j];
            if (line) line.sort($74992569aad6589c$var$sortComparator);
        }
    }
    return sources;
}
// src/binary-search.ts
var $74992569aad6589c$var$found = false;
function $74992569aad6589c$var$binarySearch(haystack, needle, low, high) {
    while(low <= high){
        const mid = low + (high - low >> 1);
        const cmp = haystack[mid][$74992569aad6589c$var$COLUMN] - needle;
        if (cmp === 0) {
            $74992569aad6589c$var$found = true;
            return mid;
        }
        if (cmp < 0) low = mid + 1;
        else high = mid - 1;
    }
    $74992569aad6589c$var$found = false;
    return low - 1;
}
function $74992569aad6589c$var$upperBound(haystack, needle, index) {
    for(let i = index + 1; i < haystack.length; index = i++){
        if (haystack[i][$74992569aad6589c$var$COLUMN] !== needle) break;
    }
    return index;
}
function $74992569aad6589c$var$lowerBound(haystack, needle, index) {
    for(let i = index - 1; i >= 0; index = i--){
        if (haystack[i][$74992569aad6589c$var$COLUMN] !== needle) break;
    }
    return index;
}
function $74992569aad6589c$var$memoizedState() {
    return {
        lastKey: -1,
        lastNeedle: -1,
        lastIndex: -1
    };
}
function $74992569aad6589c$var$memoizedBinarySearch(haystack, needle, state, key) {
    const { lastKey: lastKey, lastNeedle: lastNeedle, lastIndex: lastIndex } = state;
    let low = 0;
    let high = haystack.length - 1;
    if (key === lastKey) {
        if (needle === lastNeedle) {
            $74992569aad6589c$var$found = lastIndex !== -1 && haystack[lastIndex][$74992569aad6589c$var$COLUMN] === needle;
            return lastIndex;
        }
        if (needle >= lastNeedle) low = lastIndex === -1 ? 0 : lastIndex;
        else high = lastIndex;
    }
    state.lastKey = key;
    state.lastNeedle = needle;
    return state.lastIndex = $74992569aad6589c$var$binarySearch(haystack, needle, low, high);
}
// src/types.ts
function $74992569aad6589c$var$parse(map) {
    return typeof map === "string" ? JSON.parse(map) : map;
}
// src/flatten-map.ts
var $74992569aad6589c$export$cfb1ea40164567c5 = function(map, mapUrl) {
    const parsed = $74992569aad6589c$var$parse(map);
    if (!("sections" in parsed)) return new $74992569aad6589c$export$6fc8edf86512ec85(parsed, mapUrl);
    const mappings = [];
    const sources = [];
    const sourcesContent = [];
    const names = [];
    const ignoreList = [];
    $74992569aad6589c$var$recurse(parsed, mapUrl, mappings, sources, sourcesContent, names, ignoreList, 0, 0, Infinity, Infinity);
    const joined = {
        version: 3,
        file: parsed.file,
        names: names,
        sources: sources,
        sourcesContent: sourcesContent,
        mappings: mappings,
        ignoreList: ignoreList
    };
    return $74992569aad6589c$export$20ee0c4a5619bf3d(joined);
};
function $74992569aad6589c$var$recurse(input, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset, columnOffset, stopLine, stopColumn) {
    const { sections: sections } = input;
    for(let i = 0; i < sections.length; i++){
        const { map: map, offset: offset } = sections[i];
        let sl = stopLine;
        let sc = stopColumn;
        if (i + 1 < sections.length) {
            const nextOffset = sections[i + 1].offset;
            sl = Math.min(stopLine, lineOffset + nextOffset.line);
            if (sl === stopLine) sc = Math.min(stopColumn, columnOffset + nextOffset.column);
            else if (sl < stopLine) sc = columnOffset + nextOffset.column;
        }
        $74992569aad6589c$var$addSection(map, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset + offset.line, columnOffset + offset.column, sl, sc);
    }
}
function $74992569aad6589c$var$addSection(input, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset, columnOffset, stopLine, stopColumn) {
    const parsed = $74992569aad6589c$var$parse(input);
    if ("sections" in parsed) return $74992569aad6589c$var$recurse(...arguments);
    const map = new $74992569aad6589c$export$6fc8edf86512ec85(parsed, mapUrl);
    const sourcesOffset = sources.length;
    const namesOffset = names.length;
    const decoded = $74992569aad6589c$export$ecd113d4f34af700(map);
    const { resolvedSources: resolvedSources, sourcesContent: contents, ignoreList: ignores } = map;
    $74992569aad6589c$var$append(sources, resolvedSources);
    $74992569aad6589c$var$append(names, map.names);
    if (contents) $74992569aad6589c$var$append(sourcesContent, contents);
    else for(let i = 0; i < resolvedSources.length; i++)sourcesContent.push(null);
    if (ignores) for(let i = 0; i < ignores.length; i++)ignoreList.push(ignores[i] + sourcesOffset);
    for(let i = 0; i < decoded.length; i++){
        const lineI = lineOffset + i;
        if (lineI > stopLine) return;
        const out = $74992569aad6589c$var$getLine(mappings, lineI);
        const cOffset = i === 0 ? columnOffset : 0;
        const line = decoded[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            const column = cOffset + seg[$74992569aad6589c$var$COLUMN];
            if (lineI === stopLine && column >= stopColumn) return;
            if (seg.length === 1) {
                out.push([
                    column
                ]);
                continue;
            }
            const sourcesIndex = sourcesOffset + seg[$74992569aad6589c$var$SOURCES_INDEX];
            const sourceLine = seg[$74992569aad6589c$var$SOURCE_LINE];
            const sourceColumn = seg[$74992569aad6589c$var$SOURCE_COLUMN];
            out.push(seg.length === 4 ? [
                column,
                sourcesIndex,
                sourceLine,
                sourceColumn
            ] : [
                column,
                sourcesIndex,
                sourceLine,
                sourceColumn,
                namesOffset + seg[$74992569aad6589c$var$NAMES_INDEX]
            ]);
        }
    }
}
function $74992569aad6589c$var$append(arr, other) {
    for(let i = 0; i < other.length; i++)arr.push(other[i]);
}
function $74992569aad6589c$var$getLine(arr, index) {
    for(let i = arr.length; i <= index; i++)arr[i] = [];
    return arr[index];
}
// src/trace-mapping.ts
var $74992569aad6589c$var$LINE_GTR_ZERO = "`line` must be greater than 0 (lines start at line 1)";
var $74992569aad6589c$var$COL_GTR_EQ_ZERO = "`column` must be greater than or equal to 0 (columns start at column 0)";
var $74992569aad6589c$export$b99fbecff261243 = -1;
var $74992569aad6589c$export$4ecd616dce182dff = 1;
var $74992569aad6589c$export$6fc8edf86512ec85 = class {
    constructor(map, mapUrl){
        const isString = typeof map === "string";
        if (!isString && map._decodedMemo) return map;
        const parsed = $74992569aad6589c$var$parse(map);
        const { version: version, file: file, names: names, sourceRoot: sourceRoot, sources: sources, sourcesContent: sourcesContent } = parsed;
        this.version = version;
        this.file = file;
        this.names = names || [];
        this.sourceRoot = sourceRoot;
        this.sources = sources;
        this.sourcesContent = sourcesContent;
        this.ignoreList = parsed.ignoreList || parsed.x_google_ignoreList || void 0;
        const resolve = $74992569aad6589c$var$resolver(mapUrl, sourceRoot);
        this.resolvedSources = sources.map(resolve);
        const { mappings: mappings } = parsed;
        if (typeof mappings === "string") {
            this._encoded = mappings;
            this._decoded = void 0;
        } else if (Array.isArray(mappings)) {
            this._encoded = void 0;
            this._decoded = $74992569aad6589c$var$maybeSort(mappings, isString);
        } else if (parsed.sections) throw new Error(`TraceMap passed sectioned source map, please use FlattenMap export instead`);
        else throw new Error(`invalid source map: ${JSON.stringify(parsed)}`);
        this._decodedMemo = $74992569aad6589c$var$memoizedState();
        this._bySources = void 0;
        this._bySourceMemos = void 0;
    }
};
function $74992569aad6589c$var$cast(map) {
    return map;
}
function $74992569aad6589c$export$59408758bba4b625(map) {
    var _a, _b;
    return (_b = (_a = $74992569aad6589c$var$cast(map))._encoded) != null ? _b : _a._encoded = (0, $54b0cd2d5db5deb6$export$c564cdbbe6da493)($74992569aad6589c$var$cast(map)._decoded);
}
function $74992569aad6589c$export$ecd113d4f34af700(map) {
    var _a;
    return (_a = $74992569aad6589c$var$cast(map))._decoded || (_a._decoded = (0, $54b0cd2d5db5deb6$export$2f872c0f2117be69)($74992569aad6589c$var$cast(map)._encoded));
}
function $74992569aad6589c$export$6d863e58cd035563(map, line, column) {
    const decoded = $74992569aad6589c$export$ecd113d4f34af700(map);
    if (line >= decoded.length) return null;
    const segments = decoded[line];
    const index = $74992569aad6589c$var$traceSegmentInternal(segments, $74992569aad6589c$var$cast(map)._decodedMemo, line, column, $74992569aad6589c$export$4ecd616dce182dff);
    return index === -1 ? null : segments[index];
}
function $74992569aad6589c$export$56d62ac80d274c78(map, needle) {
    let { line: line, column: column, bias: bias } = needle;
    line--;
    if (line < 0) throw new Error($74992569aad6589c$var$LINE_GTR_ZERO);
    if (column < 0) throw new Error($74992569aad6589c$var$COL_GTR_EQ_ZERO);
    const decoded = $74992569aad6589c$export$ecd113d4f34af700(map);
    if (line >= decoded.length) return $74992569aad6589c$var$OMapping(null, null, null, null);
    const segments = decoded[line];
    const index = $74992569aad6589c$var$traceSegmentInternal(segments, $74992569aad6589c$var$cast(map)._decodedMemo, line, column, bias || $74992569aad6589c$export$4ecd616dce182dff);
    if (index === -1) return $74992569aad6589c$var$OMapping(null, null, null, null);
    const segment = segments[index];
    if (segment.length === 1) return $74992569aad6589c$var$OMapping(null, null, null, null);
    const { names: names, resolvedSources: resolvedSources } = map;
    return $74992569aad6589c$var$OMapping(resolvedSources[segment[$74992569aad6589c$var$SOURCES_INDEX]], segment[$74992569aad6589c$var$SOURCE_LINE] + 1, segment[$74992569aad6589c$var$SOURCE_COLUMN], segment.length === 5 ? names[segment[$74992569aad6589c$var$NAMES_INDEX]] : null);
}
function $74992569aad6589c$export$5bf80d5312a8ff17(map, needle) {
    const { source: source, line: line, column: column, bias: bias } = needle;
    return $74992569aad6589c$var$generatedPosition(map, source, line, column, bias || $74992569aad6589c$export$4ecd616dce182dff, false);
}
function $74992569aad6589c$export$69d37f329d319dca(map, needle) {
    const { source: source, line: line, column: column, bias: bias } = needle;
    return $74992569aad6589c$var$generatedPosition(map, source, line, column, bias || $74992569aad6589c$export$b99fbecff261243, true);
}
function $74992569aad6589c$export$78c99866f56beaa4(map, cb) {
    const decoded = $74992569aad6589c$export$ecd113d4f34af700(map);
    const { names: names, resolvedSources: resolvedSources } = map;
    for(let i = 0; i < decoded.length; i++){
        const line = decoded[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            const generatedLine = i + 1;
            const generatedColumn = seg[0];
            let source = null;
            let originalLine = null;
            let originalColumn = null;
            let name = null;
            if (seg.length !== 1) {
                source = resolvedSources[seg[1]];
                originalLine = seg[2] + 1;
                originalColumn = seg[3];
            }
            if (seg.length === 5) name = names[seg[4]];
            cb({
                generatedLine: generatedLine,
                generatedColumn: generatedColumn,
                source: source,
                originalLine: originalLine,
                originalColumn: originalColumn,
                name: name
            });
        }
    }
}
function $74992569aad6589c$var$sourceIndex(map, source) {
    const { sources: sources, resolvedSources: resolvedSources } = map;
    let index = sources.indexOf(source);
    if (index === -1) index = resolvedSources.indexOf(source);
    return index;
}
function $74992569aad6589c$export$a685fd8184719fc9(map, source) {
    const { sourcesContent: sourcesContent } = map;
    if (sourcesContent == null) return null;
    const index = $74992569aad6589c$var$sourceIndex(map, source);
    return index === -1 ? null : sourcesContent[index];
}
function $74992569aad6589c$export$ac3f691269cd6d9b(map, source) {
    const { ignoreList: ignoreList } = map;
    if (ignoreList == null) return false;
    const index = $74992569aad6589c$var$sourceIndex(map, source);
    return index === -1 ? false : ignoreList.includes(index);
}
function $74992569aad6589c$export$20ee0c4a5619bf3d(map, mapUrl) {
    const tracer = new $74992569aad6589c$export$6fc8edf86512ec85($74992569aad6589c$var$clone(map, []), mapUrl);
    $74992569aad6589c$var$cast(tracer)._decoded = map.mappings;
    return tracer;
}
function $74992569aad6589c$export$f6477d963c19e792(map) {
    return $74992569aad6589c$var$clone(map, $74992569aad6589c$export$ecd113d4f34af700(map));
}
function $74992569aad6589c$export$f859692979919a94(map) {
    return $74992569aad6589c$var$clone(map, $74992569aad6589c$export$59408758bba4b625(map));
}
function $74992569aad6589c$var$clone(map, mappings) {
    return {
        version: map.version,
        file: map.file,
        names: map.names,
        sourceRoot: map.sourceRoot,
        sources: map.sources,
        sourcesContent: map.sourcesContent,
        mappings: mappings,
        ignoreList: map.ignoreList || map.x_google_ignoreList
    };
}
function $74992569aad6589c$var$OMapping(source, line, column, name) {
    return {
        source: source,
        line: line,
        column: column,
        name: name
    };
}
function $74992569aad6589c$var$GMapping(line, column) {
    return {
        line: line,
        column: column
    };
}
function $74992569aad6589c$var$traceSegmentInternal(segments, memo, line, column, bias) {
    let index = $74992569aad6589c$var$memoizedBinarySearch(segments, column, memo, line);
    if ($74992569aad6589c$var$found) index = (bias === $74992569aad6589c$export$b99fbecff261243 ? $74992569aad6589c$var$upperBound : $74992569aad6589c$var$lowerBound)(segments, column, index);
    else if (bias === $74992569aad6589c$export$b99fbecff261243) index++;
    if (index === -1 || index === segments.length) return -1;
    return index;
}
function $74992569aad6589c$var$sliceGeneratedPositions(segments, memo, line, column, bias) {
    let min = $74992569aad6589c$var$traceSegmentInternal(segments, memo, line, column, $74992569aad6589c$export$4ecd616dce182dff);
    if (!$74992569aad6589c$var$found && bias === $74992569aad6589c$export$b99fbecff261243) min++;
    if (min === -1 || min === segments.length) return [];
    const matchedColumn = $74992569aad6589c$var$found ? column : segments[min][$74992569aad6589c$var$COLUMN];
    if (!$74992569aad6589c$var$found) min = $74992569aad6589c$var$lowerBound(segments, matchedColumn, min);
    const max = $74992569aad6589c$var$upperBound(segments, matchedColumn, min);
    const result = [];
    for(; min <= max; min++){
        const segment = segments[min];
        result.push($74992569aad6589c$var$GMapping(segment[$74992569aad6589c$var$REV_GENERATED_LINE] + 1, segment[$74992569aad6589c$var$REV_GENERATED_COLUMN]));
    }
    return result;
}
function $74992569aad6589c$var$generatedPosition(map, source, line, column, bias, all) {
    var _a, _b;
    line--;
    if (line < 0) throw new Error($74992569aad6589c$var$LINE_GTR_ZERO);
    if (column < 0) throw new Error($74992569aad6589c$var$COL_GTR_EQ_ZERO);
    const { sources: sources, resolvedSources: resolvedSources } = map;
    let sourceIndex2 = sources.indexOf(source);
    if (sourceIndex2 === -1) sourceIndex2 = resolvedSources.indexOf(source);
    if (sourceIndex2 === -1) return all ? [] : $74992569aad6589c$var$GMapping(null, null);
    const bySourceMemos = (_a = $74992569aad6589c$var$cast(map))._bySourceMemos || (_a._bySourceMemos = sources.map($74992569aad6589c$var$memoizedState));
    const generated = (_b = $74992569aad6589c$var$cast(map))._bySources || (_b._bySources = $74992569aad6589c$var$buildBySources($74992569aad6589c$export$ecd113d4f34af700(map), bySourceMemos));
    const segments = generated[sourceIndex2][line];
    if (segments == null) return all ? [] : $74992569aad6589c$var$GMapping(null, null);
    const memo = bySourceMemos[sourceIndex2];
    if (all) return $74992569aad6589c$var$sliceGeneratedPositions(segments, memo, line, column, bias);
    const index = $74992569aad6589c$var$traceSegmentInternal(segments, memo, line, column, bias);
    if (index === -1) return $74992569aad6589c$var$GMapping(null, null);
    const segment = segments[index];
    return $74992569aad6589c$var$GMapping(segment[$74992569aad6589c$var$REV_GENERATED_LINE] + 1, segment[$74992569aad6589c$var$REV_GENERATED_COLUMN]);
}


var $73f253113ca9cfeb$var$SetArray = class {
    constructor(){
        this._indexes = {
            __proto__: null
        };
        this.array = [];
    }
};
function $73f253113ca9cfeb$var$cast(set) {
    return set;
}
function $73f253113ca9cfeb$var$get(setarr, key) {
    return $73f253113ca9cfeb$var$cast(setarr)._indexes[key];
}
function $73f253113ca9cfeb$var$put(setarr, key) {
    const index = $73f253113ca9cfeb$var$get(setarr, key);
    if (index !== void 0) return index;
    const { array: array, _indexes: indexes } = $73f253113ca9cfeb$var$cast(setarr);
    const length = array.push(key);
    return indexes[key] = length - 1;
}
function $73f253113ca9cfeb$var$remove(setarr, key) {
    const index = $73f253113ca9cfeb$var$get(setarr, key);
    if (index === void 0) return;
    const { array: array, _indexes: indexes } = $73f253113ca9cfeb$var$cast(setarr);
    for(let i = index + 1; i < array.length; i++){
        const k = array[i];
        array[i - 1] = k;
        indexes[k]--;
    }
    indexes[key] = void 0;
    array.pop();
}
// src/sourcemap-segment.ts
var $73f253113ca9cfeb$var$COLUMN = 0;
var $73f253113ca9cfeb$var$SOURCES_INDEX = 1;
var $73f253113ca9cfeb$var$SOURCE_LINE = 2;
var $73f253113ca9cfeb$var$SOURCE_COLUMN = 3;
var $73f253113ca9cfeb$var$NAMES_INDEX = 4;
// src/gen-mapping.ts
var $73f253113ca9cfeb$var$NO_NAME = -1;
var $73f253113ca9cfeb$export$92fb4a3d57ca7ec = class {
    constructor({ file: file, sourceRoot: sourceRoot } = {}){
        this._names = new $73f253113ca9cfeb$var$SetArray();
        this._sources = new $73f253113ca9cfeb$var$SetArray();
        this._sourcesContent = [];
        this._mappings = [];
        this.file = file;
        this.sourceRoot = sourceRoot;
        this._ignoreList = new $73f253113ca9cfeb$var$SetArray();
    }
};
function $73f253113ca9cfeb$var$cast2(map) {
    return map;
}
function $73f253113ca9cfeb$export$1c43f9ac826b6462(map, genLine, genColumn, source, sourceLine, sourceColumn, name, content) {
    return $73f253113ca9cfeb$var$addSegmentInternal(false, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content);
}
function $73f253113ca9cfeb$export$2d9a54e47969bead(map, mapping) {
    return $73f253113ca9cfeb$var$addMappingInternal(false, map, mapping);
}
var $73f253113ca9cfeb$export$bffbcf5bdbbd3679 = (map, genLine, genColumn, source, sourceLine, sourceColumn, name, content)=>{
    return $73f253113ca9cfeb$var$addSegmentInternal(true, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content);
};
var $73f253113ca9cfeb$export$6623d26b0c62901b = (map, mapping)=>{
    return $73f253113ca9cfeb$var$addMappingInternal(true, map, mapping);
};
function $73f253113ca9cfeb$export$c6155c9e474ba16b(map, source, content) {
    const { _sources: sources, _sourcesContent: sourcesContent } = $73f253113ca9cfeb$var$cast2(map);
    const index = $73f253113ca9cfeb$var$put(sources, source);
    sourcesContent[index] = content;
}
function $73f253113ca9cfeb$export$6db5baaf5ada6795(map, source, ignore = true) {
    const { _sources: sources, _sourcesContent: sourcesContent, _ignoreList: ignoreList } = $73f253113ca9cfeb$var$cast2(map);
    const index = $73f253113ca9cfeb$var$put(sources, source);
    if (index === sourcesContent.length) sourcesContent[index] = null;
    if (ignore) $73f253113ca9cfeb$var$put(ignoreList, index);
    else $73f253113ca9cfeb$var$remove(ignoreList, index);
}
function $73f253113ca9cfeb$export$74ae13ad22f29c85(map) {
    const { _mappings: mappings, _sources: sources, _sourcesContent: sourcesContent, _names: names, _ignoreList: ignoreList } = $73f253113ca9cfeb$var$cast2(map);
    $73f253113ca9cfeb$var$removeEmptyFinalLines(mappings);
    return {
        version: 3,
        file: map.file || void 0,
        names: names.array,
        sourceRoot: map.sourceRoot || void 0,
        sources: sources.array,
        sourcesContent: sourcesContent,
        mappings: mappings,
        // originalScopes,
        // generatedRanges,
        ignoreList: ignoreList.array
    };
}
function $73f253113ca9cfeb$export$da8de8cfd71f671a(map) {
    const decoded = $73f253113ca9cfeb$export$74ae13ad22f29c85(map);
    return Object.assign({}, decoded, {
        // originalScopes: decoded.originalScopes.map((os) => encodeOriginalScopes(os)),
        // generatedRanges: encodeGeneratedRanges(decoded.generatedRanges as GeneratedRange[]),
        mappings: (0, $54b0cd2d5db5deb6$export$c564cdbbe6da493)(decoded.mappings)
    });
}
function $73f253113ca9cfeb$export$d81aa96f14f987cc(input) {
    const map = new (0, $74992569aad6589c$export$6fc8edf86512ec85)(input);
    const gen = new $73f253113ca9cfeb$export$92fb4a3d57ca7ec({
        file: map.file,
        sourceRoot: map.sourceRoot
    });
    $73f253113ca9cfeb$var$putAll($73f253113ca9cfeb$var$cast2(gen)._names, map.names);
    $73f253113ca9cfeb$var$putAll($73f253113ca9cfeb$var$cast2(gen)._sources, map.sources);
    $73f253113ca9cfeb$var$cast2(gen)._sourcesContent = map.sourcesContent || map.sources.map(()=>null);
    $73f253113ca9cfeb$var$cast2(gen)._mappings = (0, $74992569aad6589c$export$ecd113d4f34af700)(map);
    if (map.ignoreList) $73f253113ca9cfeb$var$putAll($73f253113ca9cfeb$var$cast2(gen)._ignoreList, map.ignoreList);
    return gen;
}
function $73f253113ca9cfeb$export$f06617c6577f8fbd(map) {
    const out = [];
    const { _mappings: mappings, _sources: sources, _names: names } = $73f253113ca9cfeb$var$cast2(map);
    for(let i = 0; i < mappings.length; i++){
        const line = mappings[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            const generated = {
                line: i + 1,
                column: seg[$73f253113ca9cfeb$var$COLUMN]
            };
            let source = void 0;
            let original = void 0;
            let name = void 0;
            if (seg.length !== 1) {
                source = sources.array[seg[$73f253113ca9cfeb$var$SOURCES_INDEX]];
                original = {
                    line: seg[$73f253113ca9cfeb$var$SOURCE_LINE] + 1,
                    column: seg[$73f253113ca9cfeb$var$SOURCE_COLUMN]
                };
                if (seg.length === 5) name = names.array[seg[$73f253113ca9cfeb$var$NAMES_INDEX]];
            }
            out.push({
                generated: generated,
                source: source,
                original: original,
                name: name
            });
        }
    }
    return out;
}
function $73f253113ca9cfeb$var$addSegmentInternal(skipable, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content) {
    const { _mappings: mappings, _sources: sources, _sourcesContent: sourcesContent, _names: names } = $73f253113ca9cfeb$var$cast2(map);
    const line = $73f253113ca9cfeb$var$getIndex(mappings, genLine);
    const index = $73f253113ca9cfeb$var$getColumnIndex(line, genColumn);
    if (!source) {
        if (skipable && $73f253113ca9cfeb$var$skipSourceless(line, index)) return;
        return $73f253113ca9cfeb$var$insert(line, index, [
            genColumn
        ]);
    }
    $73f253113ca9cfeb$var$assert(sourceLine);
    $73f253113ca9cfeb$var$assert(sourceColumn);
    const sourcesIndex = $73f253113ca9cfeb$var$put(sources, source);
    const namesIndex = name ? $73f253113ca9cfeb$var$put(names, name) : $73f253113ca9cfeb$var$NO_NAME;
    if (sourcesIndex === sourcesContent.length) sourcesContent[sourcesIndex] = content != null ? content : null;
    if (skipable && $73f253113ca9cfeb$var$skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex)) return;
    return $73f253113ca9cfeb$var$insert(line, index, name ? [
        genColumn,
        sourcesIndex,
        sourceLine,
        sourceColumn,
        namesIndex
    ] : [
        genColumn,
        sourcesIndex,
        sourceLine,
        sourceColumn
    ]);
}
function $73f253113ca9cfeb$var$assert(_val) {}
function $73f253113ca9cfeb$var$getIndex(arr, index) {
    for(let i = arr.length; i <= index; i++)arr[i] = [];
    return arr[index];
}
function $73f253113ca9cfeb$var$getColumnIndex(line, genColumn) {
    let index = line.length;
    for(let i = index - 1; i >= 0; index = i--){
        const current = line[i];
        if (genColumn >= current[$73f253113ca9cfeb$var$COLUMN]) break;
    }
    return index;
}
function $73f253113ca9cfeb$var$insert(array, index, value) {
    for(let i = array.length; i > index; i--)array[i] = array[i - 1];
    array[index] = value;
}
function $73f253113ca9cfeb$var$removeEmptyFinalLines(mappings) {
    const { length: length } = mappings;
    let len = length;
    for(let i = len - 1; i >= 0; len = i, i--){
        if (mappings[i].length > 0) break;
    }
    if (len < length) mappings.length = len;
}
function $73f253113ca9cfeb$var$putAll(setarr, array) {
    for(let i = 0; i < array.length; i++)$73f253113ca9cfeb$var$put(setarr, array[i]);
}
function $73f253113ca9cfeb$var$skipSourceless(line, index) {
    if (index === 0) return true;
    const prev = line[index - 1];
    return prev.length === 1;
}
function $73f253113ca9cfeb$var$skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex) {
    if (index === 0) return false;
    const prev = line[index - 1];
    if (prev.length === 1) return false;
    return sourcesIndex === prev[$73f253113ca9cfeb$var$SOURCES_INDEX] && sourceLine === prev[$73f253113ca9cfeb$var$SOURCE_LINE] && sourceColumn === prev[$73f253113ca9cfeb$var$SOURCE_COLUMN] && namesIndex === (prev.length === 5 ? prev[$73f253113ca9cfeb$var$NAMES_INDEX] : $73f253113ca9cfeb$var$NO_NAME);
}
function $73f253113ca9cfeb$var$addMappingInternal(skipable, map, mapping) {
    const { generated: generated, source: source, original: original, name: name, content: content } = mapping;
    if (!source) return $73f253113ca9cfeb$var$addSegmentInternal(skipable, map, generated.line - 1, generated.column, null, null, null, null, null);
    $73f253113ca9cfeb$var$assert(original);
    return $73f253113ca9cfeb$var$addSegmentInternal(skipable, map, generated.line - 1, generated.column, source, original.line - 1, original.column, name, content);
}



function $983df390ff0493b7$export$2e2bcd8739ae039({ code: generatedCode, mappings: rawMappings }, filePath, options, source, tokens) {
    const sourceColumns = $983df390ff0493b7$var$computeSourceColumns(source, tokens);
    const map = new (0, $73f253113ca9cfeb$export$92fb4a3d57ca7ec)({
        file: options.compiledFilename
    });
    let tokenIndex = 0;
    // currentMapping is the output source index for the current input token being
    // considered.
    let currentMapping = rawMappings[0];
    while(currentMapping === undefined && tokenIndex < rawMappings.length - 1){
        tokenIndex++;
        currentMapping = rawMappings[tokenIndex];
    }
    let line = 0;
    let lineStart = 0;
    if (currentMapping !== lineStart) (0, $73f253113ca9cfeb$export$bffbcf5bdbbd3679)(map, line, 0, filePath, line, 0);
    for(let i = 0; i < generatedCode.length; i++){
        if (i === currentMapping) {
            const genColumn = currentMapping - lineStart;
            const sourceColumn = sourceColumns[tokenIndex];
            (0, $73f253113ca9cfeb$export$bffbcf5bdbbd3679)(map, line, genColumn, filePath, line, sourceColumn);
            while((currentMapping === i || currentMapping === undefined) && tokenIndex < rawMappings.length - 1){
                tokenIndex++;
                currentMapping = rawMappings[tokenIndex];
            }
        }
        if (generatedCode.charCodeAt(i) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed) {
            line++;
            lineStart = i + 1;
            if (currentMapping !== lineStart) (0, $73f253113ca9cfeb$export$bffbcf5bdbbd3679)(map, line, 0, filePath, line, 0);
        }
    }
    const { sourceRoot: sourceRoot, sourcesContent: sourcesContent, ...sourceMap } = (0, $73f253113ca9cfeb$export$da8de8cfd71f671a)(map);
    return sourceMap;
}
/**
 * Create an array mapping each token index to the 0-based column of the start
 * position of the token.
 */ function $983df390ff0493b7$var$computeSourceColumns(code, tokens) {
    const sourceColumns = new Array(tokens.length);
    let tokenIndex = 0;
    let currentMapping = tokens[tokenIndex].start;
    let lineStart = 0;
    for(let i = 0; i < code.length; i++){
        if (i === currentMapping) {
            sourceColumns[tokenIndex] = currentMapping - lineStart;
            tokenIndex++;
            currentMapping = tokens[tokenIndex].start;
        }
        if (code.charCodeAt(i) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed) lineStart = i + 1;
    }
    return sourceColumns;
}


const $1425b7397a2936d9$var$HELPERS = {
    require: `
    import {createRequire as CREATE_REQUIRE_NAME} from "module";
    const require = CREATE_REQUIRE_NAME(import.meta.url);
  `,
    interopRequireWildcard: `
    function interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};
        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
              newObj[key] = obj[key];
            }
          }
        }
        newObj.default = obj;
        return newObj;
      }
    }
  `,
    interopRequireDefault: `
    function interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
  `,
    createNamedExportFrom: `
    function createNamedExportFrom(obj, localName, importedName) {
      Object.defineProperty(exports, localName, {enumerable: true, configurable: true, get: () => obj[importedName]});
    }
  `,
    // Note that TypeScript and Babel do this differently; TypeScript does a simple existence
    // check in the exports object and does a plain assignment, whereas Babel uses
    // defineProperty and builds an object of explicitly-exported names so that star exports can
    // always take lower precedence. For now, we do the easier TypeScript thing.
    createStarExport: `
    function createStarExport(obj) {
      Object.keys(obj)
        .filter((key) => key !== "default" && key !== "__esModule")
        .forEach((key) => {
          if (exports.hasOwnProperty(key)) {
            return;
          }
          Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]});
        });
    }
  `,
    nullishCoalesce: `
    function nullishCoalesce(lhs, rhsFn) {
      if (lhs != null) {
        return lhs;
      } else {
        return rhsFn();
      }
    }
  `,
    asyncNullishCoalesce: `
    async function asyncNullishCoalesce(lhs, rhsFn) {
      if (lhs != null) {
        return lhs;
      } else {
        return await rhsFn();
      }
    }
  `,
    optionalChain: `
    function optionalChain(ops) {
      let lastAccessLHS = undefined;
      let value = ops[0];
      let i = 1;
      while (i < ops.length) {
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
          return undefined;
        }
        if (op === 'access' || op === 'optionalAccess') {
          lastAccessLHS = value;
          value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
          value = fn((...args) => value.call(lastAccessLHS, ...args));
          lastAccessLHS = undefined;
        }
      }
      return value;
    }
  `,
    asyncOptionalChain: `
    async function asyncOptionalChain(ops) {
      let lastAccessLHS = undefined;
      let value = ops[0];
      let i = 1;
      while (i < ops.length) {
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
          return undefined;
        }
        if (op === 'access' || op === 'optionalAccess') {
          lastAccessLHS = value;
          value = await fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
          value = await fn((...args) => value.call(lastAccessLHS, ...args));
          lastAccessLHS = undefined;
        }
      }
      return value;
    }
  `,
    optionalChainDelete: `
    function optionalChainDelete(ops) {
      const result = OPTIONAL_CHAIN_NAME(ops);
      return result == null ? true : result;
    }
  `,
    asyncOptionalChainDelete: `
    async function asyncOptionalChainDelete(ops) {
      const result = await ASYNC_OPTIONAL_CHAIN_NAME(ops);
      return result == null ? true : result;
    }
  `
};
class $1425b7397a2936d9$export$b203ad16abdeb845 {
    __init() {
        this.helperNames = {};
    }
    __init2() {
        this.createRequireName = null;
    }
    constructor(nameManager){
        this.nameManager = nameManager;
        $1425b7397a2936d9$export$b203ad16abdeb845.prototype.__init.call(this);
        $1425b7397a2936d9$export$b203ad16abdeb845.prototype.__init2.call(this);
    }
    getHelperName(baseName) {
        let helperName = this.helperNames[baseName];
        if (helperName) return helperName;
        helperName = this.nameManager.claimFreeName(`_${baseName}`);
        this.helperNames[baseName] = helperName;
        return helperName;
    }
    emitHelpers() {
        let resultCode = "";
        if (this.helperNames.optionalChainDelete) this.getHelperName("optionalChain");
        if (this.helperNames.asyncOptionalChainDelete) this.getHelperName("asyncOptionalChain");
        for (const [baseName, helperCodeTemplate] of Object.entries($1425b7397a2936d9$var$HELPERS)){
            const helperName = this.helperNames[baseName];
            let helperCode = helperCodeTemplate;
            if (baseName === "optionalChainDelete") helperCode = helperCode.replace("OPTIONAL_CHAIN_NAME", this.helperNames.optionalChain);
            else if (baseName === "asyncOptionalChainDelete") helperCode = helperCode.replace("ASYNC_OPTIONAL_CHAIN_NAME", this.helperNames.asyncOptionalChain);
            else if (baseName === "require") {
                if (this.createRequireName === null) this.createRequireName = this.nameManager.claimFreeName("_createRequire");
                helperCode = helperCode.replace(/CREATE_REQUIRE_NAME/g, this.createRequireName);
            }
            if (helperName) {
                resultCode += " ";
                resultCode += helperCode.replace(baseName, helperName).replace(/\s+/g, " ").trim();
            }
        }
        return resultCode;
    }
}




function $e17888755afee10f$export$2e2bcd8739ae039(tokens, scopes, globalNames) {
    if (!$e17888755afee10f$export$c1aa0d0852b733f5(tokens, globalNames)) return;
    $e17888755afee10f$var$markShadowedGlobals(tokens, scopes, globalNames);
}
function $e17888755afee10f$export$c1aa0d0852b733f5(tokens, globalNames) {
    for (const token of tokens.tokens){
        if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && !token.isType && (0, $19e70491d10f11e8$export$268f8ae8b035d918)(token) && globalNames.has(tokens.identifierNameForToken(token))) return true;
    }
    return false;
}
function $e17888755afee10f$var$markShadowedGlobals(tokens, scopes, globalNames) {
    const scopeStack = [];
    let scopeIndex = scopes.length - 1;
    // Scopes were generated at completion time, so they're sorted by end index, so we can maintain a
    // good stack by going backwards through them.
    for(let i = tokens.tokens.length - 1;; i--){
        while(scopeStack.length > 0 && scopeStack[scopeStack.length - 1].startTokenIndex === i + 1)scopeStack.pop();
        while(scopeIndex >= 0 && scopes[scopeIndex].endTokenIndex === i + 1){
            scopeStack.push(scopes[scopeIndex]);
            scopeIndex--;
        }
        // Process scopes after the last iteration so we can make sure we pop all of them.
        if (i < 0) break;
        const token = tokens.tokens[i];
        const name = tokens.identifierNameForToken(token);
        if (scopeStack.length > 1 && !token.isType && token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && globalNames.has(name)) {
            if ((0, $19e70491d10f11e8$export$6aae06a56367d123)(token)) $e17888755afee10f$var$markShadowedForScope(scopeStack[scopeStack.length - 1], tokens, name);
            else if ((0, $19e70491d10f11e8$export$157aa1605fc4e080)(token)) {
                let stackIndex = scopeStack.length - 1;
                while(stackIndex > 0 && !scopeStack[stackIndex].isFunctionScope)stackIndex--;
                if (stackIndex < 0) throw new Error("Did not find parent function scope.");
                $e17888755afee10f$var$markShadowedForScope(scopeStack[stackIndex], tokens, name);
            }
        }
    }
    if (scopeStack.length > 0) throw new Error("Expected empty scope stack after processing file.");
}
function $e17888755afee10f$var$markShadowedForScope(scope, tokens, name) {
    for(let i = scope.startTokenIndex; i < scope.endTokenIndex; i++){
        const token = tokens.tokens[i];
        if ((token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name || token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName) && tokens.identifierNameForToken(token) === name) token.shadowsGlobal = true;
    }
}



function $9e197115f5256153$export$2e2bcd8739ae039(code, tokens) {
    const names = [];
    for (const token of tokens)if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) names.push(code.slice(token.start, token.end));
    return names;
}


class $98ad476c234688bb$export$2e2bcd8739ae039 {
    __init() {
        this.usedNames = new Set();
    }
    constructor(code, tokens){
        $98ad476c234688bb$export$2e2bcd8739ae039.prototype.__init.call(this);
        this.usedNames = new Set((0, $9e197115f5256153$export$2e2bcd8739ae039)(code, tokens));
    }
    claimFreeName(name) {
        const newName = this.findFreeName(name);
        this.usedNames.add(newName);
        return newName;
    }
    findFreeName(name) {
        if (!this.usedNames.has(name)) return name;
        let suffixNum = 2;
        while(this.usedNames.has(name + String(suffixNum)))suffixNum++;
        return name + String(suffixNum);
    }
}


var $f5315ec19a67585e$exports = {};
"use strict";
var $f5315ec19a67585e$var$__spreadArrays = $f5315ec19a67585e$exports && $f5315ec19a67585e$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($f5315ec19a67585e$exports, "__esModule", {
    value: true
});
$f5315ec19a67585e$exports.Checker = $f5315ec19a67585e$exports.createCheckers = void 0;

var $i143t = parcelRequire("i143t");

var $d3AJN = parcelRequire("d3AJN");

var $i143t = parcelRequire("i143t");
Object.defineProperty($f5315ec19a67585e$exports, "TArray", {
    enumerable: true,
    get: function() {
        return $i143t.TArray;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TEnumType", {
    enumerable: true,
    get: function() {
        return $i143t.TEnumType;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TEnumLiteral", {
    enumerable: true,
    get: function() {
        return $i143t.TEnumLiteral;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TFunc", {
    enumerable: true,
    get: function() {
        return $i143t.TFunc;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TIface", {
    enumerable: true,
    get: function() {
        return $i143t.TIface;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TLiteral", {
    enumerable: true,
    get: function() {
        return $i143t.TLiteral;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TName", {
    enumerable: true,
    get: function() {
        return $i143t.TName;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TOptional", {
    enumerable: true,
    get: function() {
        return $i143t.TOptional;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TParam", {
    enumerable: true,
    get: function() {
        return $i143t.TParam;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TParamList", {
    enumerable: true,
    get: function() {
        return $i143t.TParamList;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TProp", {
    enumerable: true,
    get: function() {
        return $i143t.TProp;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TTuple", {
    enumerable: true,
    get: function() {
        return $i143t.TTuple;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TType", {
    enumerable: true,
    get: function() {
        return $i143t.TType;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TUnion", {
    enumerable: true,
    get: function() {
        return $i143t.TUnion;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "TIntersection", {
    enumerable: true,
    get: function() {
        return $i143t.TIntersection;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "array", {
    enumerable: true,
    get: function() {
        return $i143t.array;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "enumlit", {
    enumerable: true,
    get: function() {
        return $i143t.enumlit;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "enumtype", {
    enumerable: true,
    get: function() {
        return $i143t.enumtype;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "func", {
    enumerable: true,
    get: function() {
        return $i143t.func;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "iface", {
    enumerable: true,
    get: function() {
        return $i143t.iface;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "lit", {
    enumerable: true,
    get: function() {
        return $i143t.lit;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "name", {
    enumerable: true,
    get: function() {
        return $i143t.name;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "opt", {
    enumerable: true,
    get: function() {
        return $i143t.opt;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "param", {
    enumerable: true,
    get: function() {
        return $i143t.param;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "tuple", {
    enumerable: true,
    get: function() {
        return $i143t.tuple;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "union", {
    enumerable: true,
    get: function() {
        return $i143t.union;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "intersection", {
    enumerable: true,
    get: function() {
        return $i143t.intersection;
    }
});
Object.defineProperty($f5315ec19a67585e$exports, "BasicType", {
    enumerable: true,
    get: function() {
        return $i143t.BasicType;
    }
});

var $d3AJN = parcelRequire("d3AJN");
Object.defineProperty($f5315ec19a67585e$exports, "VError", {
    enumerable: true,
    get: function() {
        return $d3AJN.VError;
    }
});
/**
 * Takes one of more type suites (e.g. a module generated by `ts-interface-builder`), and combines
 * them into a suite of interface checkers. If a type is used by name, that name should be present
 * among the passed-in type suites.
 *
 * The returned object maps type names to Checker objects.
 */ function $f5315ec19a67585e$var$createCheckers() {
    var typeSuite = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSuite[_i] = arguments[_i];
    var fullSuite = Object.assign.apply(Object, $f5315ec19a67585e$var$__spreadArrays([
        {},
        $i143t.basicTypes
    ], typeSuite));
    var checkers = {};
    for(var _a = 0, typeSuite_1 = typeSuite; _a < typeSuite_1.length; _a++){
        var suite_1 = typeSuite_1[_a];
        for(var _b = 0, _c = Object.keys(suite_1); _b < _c.length; _b++){
            var name = _c[_b];
            checkers[name] = new $f5315ec19a67585e$var$Checker(fullSuite, suite_1[name]);
        }
    }
    return checkers;
}
$f5315ec19a67585e$exports.createCheckers = $f5315ec19a67585e$var$createCheckers;
/**
 * Checker implements validation of objects, and also includes accessors to validate method calls.
 * Checkers should be created using `createCheckers()`.
 */ var $f5315ec19a67585e$var$Checker = /** @class */ function() {
    // Create checkers by using `createCheckers()` function.
    function Checker(suite, ttype, _path) {
        if (_path === void 0) _path = 'value';
        this.suite = suite;
        this.ttype = ttype;
        this._path = _path;
        this.props = new Map();
        if (ttype instanceof $i143t.TIface) for(var _i = 0, _a = ttype.props; _i < _a.length; _i++){
            var p = _a[_i];
            this.props.set(p.name, p.ttype);
        }
        this.checkerPlain = this.ttype.getChecker(suite, false);
        this.checkerStrict = this.ttype.getChecker(suite, true);
    }
    /**
     * Set the path to report in errors, instead of the default "value". (E.g. if the Checker is for
     * a "person" interface, set path to "person" to report e.g. "person.name is not a string".)
     */ Checker.prototype.setReportedPath = function(path) {
        this._path = path;
    };
    /**
     * Check that the given value satisfies this checker's type, or throw Error.
     */ Checker.prototype.check = function(value) {
        return this._doCheck(this.checkerPlain, value);
    };
    /**
     * A fast check for whether or not the given value satisfies this Checker's type. This returns
     * true or false, does not produce an error message, and is fast both on success and on failure.
     */ Checker.prototype.test = function(value) {
        return this.checkerPlain(value, new $d3AJN.NoopContext());
    };
    /**
     * Returns an error object describing the errors if the given value does not satisfy this
     * Checker's type, or null if it does.
     */ Checker.prototype.validate = function(value) {
        return this._doValidate(this.checkerPlain, value);
    };
    /**
     * Check that the given value satisfies this checker's type strictly. This checks that objects
     * and tuples have no extra members. Note that this prevents backward compatibility, so usually
     * a plain check() is more appropriate.
     */ Checker.prototype.strictCheck = function(value) {
        return this._doCheck(this.checkerStrict, value);
    };
    /**
     * A fast strict check for whether or not the given value satisfies this Checker's type. Returns
     * true or false, does not produce an error message, and is fast both on success and on failure.
     */ Checker.prototype.strictTest = function(value) {
        return this.checkerStrict(value, new $d3AJN.NoopContext());
    };
    /**
     * Returns an error object describing the errors if the given value does not satisfy this
     * Checker's type strictly, or null if it does.
     */ Checker.prototype.strictValidate = function(value) {
        return this._doValidate(this.checkerStrict, value);
    };
    /**
     * If this checker is for an interface, returns a Checker for the type required for the given
     * property of this interface.
     */ Checker.prototype.getProp = function(prop) {
        var ttype = this.props.get(prop);
        if (!ttype) throw new Error("Type has no property " + prop);
        return new Checker(this.suite, ttype, this._path + "." + prop);
    };
    /**
     * If this checker is for an interface, returns a Checker for the argument-list required to call
     * the given method of this interface. E.g. if this Checker is for the interface:
     *    interface Foo {
     *      find(s: string, pos?: number): number;
     *    }
     * Then methodArgs("find").check(...) will succeed for ["foo"] and ["foo", 3], but not for [17].
     */ Checker.prototype.methodArgs = function(methodName) {
        var tfunc = this._getMethod(methodName);
        return new Checker(this.suite, tfunc.paramList);
    };
    /**
     * If this checker is for an interface, returns a Checker for the return value of the given
     * method of this interface.
     */ Checker.prototype.methodResult = function(methodName) {
        var tfunc = this._getMethod(methodName);
        return new Checker(this.suite, tfunc.result);
    };
    /**
     * If this checker is for a function, returns a Checker for its argument-list.
     */ Checker.prototype.getArgs = function() {
        if (!(this.ttype instanceof $i143t.TFunc)) throw new Error("getArgs() applied to non-function");
        return new Checker(this.suite, this.ttype.paramList);
    };
    /**
     * If this checker is for a function, returns a Checker for its result.
     */ Checker.prototype.getResult = function() {
        if (!(this.ttype instanceof $i143t.TFunc)) throw new Error("getResult() applied to non-function");
        return new Checker(this.suite, this.ttype.result);
    };
    /**
     * Return the type for which this is a checker.
     */ Checker.prototype.getType = function() {
        return this.ttype;
    };
    /**
     * Actual implementation of check() and strictCheck().
     */ Checker.prototype._doCheck = function(checkerFunc, value) {
        var noopCtx = new $d3AJN.NoopContext();
        if (!checkerFunc(value, noopCtx)) {
            var detailCtx = new $d3AJN.DetailContext();
            checkerFunc(value, detailCtx);
            throw detailCtx.getError(this._path);
        }
    };
    Checker.prototype._doValidate = function(checkerFunc, value) {
        var noopCtx = new $d3AJN.NoopContext();
        if (checkerFunc(value, noopCtx)) return null;
        var detailCtx = new $d3AJN.DetailContext();
        checkerFunc(value, detailCtx);
        return detailCtx.getErrorDetail(this._path);
    };
    Checker.prototype._getMethod = function(methodName) {
        var ttype = this.props.get(methodName);
        if (!ttype) throw new Error("Type has no property " + methodName);
        if (!(ttype instanceof $i143t.TFunc)) throw new Error("Property " + methodName + " is not a method");
        return ttype;
    };
    return Checker;
}();
$f5315ec19a67585e$exports.Checker = $f5315ec19a67585e$var$Checker;


/**
 * This module was automatically generated by `ts-interface-builder`
 */ 
const $0afa6f86b9b32f01$export$563a914cafbdc389 = $f5315ec19a67585e$exports.union($f5315ec19a67585e$exports.lit("jsx"), $f5315ec19a67585e$exports.lit("typescript"), $f5315ec19a67585e$exports.lit("flow"), $f5315ec19a67585e$exports.lit("imports"), $f5315ec19a67585e$exports.lit("react-hot-loader"), $f5315ec19a67585e$exports.lit("jest"));
const $0afa6f86b9b32f01$export$6314eb8a2e5cb73e = $f5315ec19a67585e$exports.iface([], {
    compiledFilename: "string"
});
const $0afa6f86b9b32f01$export$c019608e5b5bb4cb = $f5315ec19a67585e$exports.iface([], {
    transforms: $f5315ec19a67585e$exports.array("Transform"),
    disableESTransforms: $f5315ec19a67585e$exports.opt("boolean"),
    jsxRuntime: $f5315ec19a67585e$exports.opt($f5315ec19a67585e$exports.union($f5315ec19a67585e$exports.lit("classic"), $f5315ec19a67585e$exports.lit("automatic"), $f5315ec19a67585e$exports.lit("preserve"))),
    production: $f5315ec19a67585e$exports.opt("boolean"),
    jsxImportSource: $f5315ec19a67585e$exports.opt("string"),
    jsxPragma: $f5315ec19a67585e$exports.opt("string"),
    jsxFragmentPragma: $f5315ec19a67585e$exports.opt("string"),
    keepUnusedImports: $f5315ec19a67585e$exports.opt("boolean"),
    preserveDynamicImport: $f5315ec19a67585e$exports.opt("boolean"),
    injectCreateRequireForImportRequire: $f5315ec19a67585e$exports.opt("boolean"),
    enableLegacyTypeScriptModuleInterop: $f5315ec19a67585e$exports.opt("boolean"),
    enableLegacyBabel5ModuleInterop: $f5315ec19a67585e$exports.opt("boolean"),
    sourceMapOptions: $f5315ec19a67585e$exports.opt("SourceMapOptions"),
    filePath: $f5315ec19a67585e$exports.opt("string")
});
const $0afa6f86b9b32f01$var$exportedTypeSuite = {
    Transform: $0afa6f86b9b32f01$export$563a914cafbdc389,
    SourceMapOptions: $0afa6f86b9b32f01$export$6314eb8a2e5cb73e,
    Options: $0afa6f86b9b32f01$export$c019608e5b5bb4cb
};
var $0afa6f86b9b32f01$export$2e2bcd8739ae039 = $0afa6f86b9b32f01$var$exportedTypeSuite;


const { Options: $10bb70de42713567$var$OptionsChecker } = (0, $f5315ec19a67585e$exports.createCheckers)((0, $0afa6f86b9b32f01$export$2e2bcd8739ae039));
function $10bb70de42713567$export$1dd09873c1bdd0fc(options) {
    $10bb70de42713567$var$OptionsChecker.strictCheck(options);
}






/* eslint max-len: 0 */ 
/* eslint max-len: 0 */ 



/* eslint max-len: 0 */ // A recursive descent parser operates by defining functions for all
// syntactic elements, and recursively calling those, each function
// advancing the input stream and returning an AST node. Precedence
// of constructs (for example, the fact that `!x[1]` means `!(x[1])`
// instead of `(!x)[1]` is handled by the fact that the parser
// function that parses unary prefix operators is called first, and
// in turn calls the function that parses `[]` subscripts — that
// way, it'll receive the node for `x[1]` already parsed, and wraps
// *that* in the unary operator node.
//
// Acorn uses an [operator precedence parser][opp] to handle binary
// operator precedence, because it is much more compact than using
// the technique outlined above, which uses different, nesting
// functions to specify precedence, for all of the ten binary
// precedence levels that JavaScript defines.
//
// [opp]: http://en.wikipedia.org/wiki/Operator-precedence_parser





















function $90ed52daec368086$export$83bfd0877be8807a() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $ac0b98ed31ddbb15$export$b97bbe8a7805284f)(false);
}
function $90ed52daec368086$export$9504bd2748b5750c(isBlockScope) {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $90ed52daec368086$export$e1f90e6766854abd(isBlockScope);
}
function $90ed52daec368086$export$7538cb03fa894c83(isBlockScope) {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    $90ed52daec368086$export$80e4117797ed03a6(isBlockScope);
}
function $90ed52daec368086$export$cba413304e86fc0d() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportDeclaration;
}
function $90ed52daec368086$export$80e4117797ed03a6(isBlockScope) {
    let identifierRole;
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth === 0) identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).TopLevelDeclaration;
    else if (isBlockScope) identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).BlockScopedDeclaration;
    else identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).FunctionScopedDeclaration;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = identifierRole;
}
function $90ed52daec368086$export$e1f90e6766854abd(isBlockScope) {
    switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type){
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this:
            {
                // In TypeScript, "this" may be the name of a parameter, so allow it.
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return;
            }
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._yield:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name:
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name;
            $90ed52daec368086$export$7538cb03fa894c83(isBlockScope);
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            $90ed52daec368086$export$befa6d966a25698e((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR, isBlockScope, true);
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL:
            (0, $ac0b98ed31ddbb15$export$908e61e44ae774e)(true, isBlockScope);
            return;
        default:
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    }
}
function $90ed52daec368086$export$befa6d966a25698e(close, isBlockScope, allowEmpty = false, allowModifiers = false, contextId = 0) {
    let first = true;
    let hasRemovedComma = false;
    const firstItemTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)(close) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
            // After a "this" type in TypeScript, we need to set the following comma (if any) to also be
            // a type token so that it will be removed.
            if (!hasRemovedComma && (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[firstItemTokenIndex].isType) {
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
                hasRemovedComma = true;
            }
        }
        if (allowEmpty && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) ;
        else if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)(close)) break;
        else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
            $90ed52daec368086$export$9504bd2748b5750c(isBlockScope);
            $90ed52daec368086$var$parseAssignableListItemTypes();
            // Support rest element trailing commas allowed by TypeScript <2.9.
            (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            (0, $485552d236f25875$export$3570f33b1a1f3329)(close);
            break;
        } else $90ed52daec368086$var$parseAssignableListItem(allowModifiers, isBlockScope);
    }
}
function $90ed52daec368086$var$parseAssignableListItem(allowModifiers, isBlockScope) {
    if (allowModifiers) (0, $6ae90c8fc78a4682$export$77616e6d401f584a)([
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._public,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._protected,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._private,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._override
    ]);
    $90ed52daec368086$export$867fe1bcec5186c9(isBlockScope);
    $90ed52daec368086$var$parseAssignableListItemTypes();
    $90ed52daec368086$export$867fe1bcec5186c9(isBlockScope, true);
}
function $90ed52daec368086$var$parseAssignableListItemTypes() {
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$a9031cdcb39989e3)();
    else if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$9b46e2c9fd90d888)();
}
function $90ed52daec368086$export$867fe1bcec5186c9(isBlockScope, leftAlreadyParsed = false) {
    if (!leftAlreadyParsed) $90ed52daec368086$export$e1f90e6766854abd(isBlockScope);
    if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) return;
    const eqIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1;
    (0, $ac0b98ed31ddbb15$export$b97bbe8a7805284f)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[eqIndex].rhsEndIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
}





function $6ae90c8fc78a4682$var$tsIsIdentifier() {
    // TODO: actually a bit more complex in TypeScript, but shouldn't matter.
    // See https://github.com/Microsoft/TypeScript/issues/15008
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
}
function $6ae90c8fc78a4682$var$isLiteralPropertyName() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || Boolean((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_KEYWORD) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bigint) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).decimal);
}
function $6ae90c8fc78a4682$var$tsNextTokenCanFollowModifier() {
    // Note: TypeScript's implementation is much more complicated because
    // more things are considered modifiers there.
    // This implementation only handles modifiers not handled by babylon itself. And "static".
    // TODO: Would be nice to avoid lookahead. Want a hasLineBreakUpNext() method...
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    const canFollowModifier = ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).hash) || $6ae90c8fc78a4682$var$isLiteralPropertyName()) && !(0, $485552d236f25875$export$942fa35f3a7c108c)();
    if (canFollowModifier) return true;
    else {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
}
function $6ae90c8fc78a4682$export$77616e6d401f584a(allowedModifiers) {
    while(true){
        const modifier = $6ae90c8fc78a4682$export$a90a97ddca783020(allowedModifiers);
        if (modifier === null) break;
    }
}
function $6ae90c8fc78a4682$export$a90a97ddca783020(allowedModifiers) {
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) return null;
    const modifier = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword;
    if (allowedModifiers.indexOf(modifier) !== -1 && $6ae90c8fc78a4682$var$tsNextTokenCanFollowModifier()) {
        switch(modifier){
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._readonly;
                break;
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract;
                break;
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._static:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._static;
                break;
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._public:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._public;
                break;
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._private:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._private;
                break;
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._protected:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._protected;
                break;
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._override:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._override;
                break;
            case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare:
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._declare;
                break;
            default:
                break;
        }
        return modifier;
    }
    return null;
}
function $6ae90c8fc78a4682$var$tsParseEntityName() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot))(0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
}
function $6ae90c8fc78a4682$var$tsParseTypeReference() {
    $6ae90c8fc78a4682$var$tsParseEntityName();
    if (!(0, $485552d236f25875$export$942fa35f3a7c108c)() && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $6ae90c8fc78a4682$var$tsParseTypeArguments();
}
function $6ae90c8fc78a4682$var$tsParseThisTypePredicate() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $6ae90c8fc78a4682$export$728a3256ac690042();
}
function $6ae90c8fc78a4682$var$tsParseThisTypeNode() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
}
function $6ae90c8fc78a4682$var$tsParseTypeQuery() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import)) $6ae90c8fc78a4682$var$tsParseImportType();
    else $6ae90c8fc78a4682$var$tsParseEntityName();
    if (!(0, $485552d236f25875$export$942fa35f3a7c108c)() && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $6ae90c8fc78a4682$var$tsParseTypeArguments();
}
function $6ae90c8fc78a4682$var$tsParseImportType() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) $6ae90c8fc78a4682$var$tsParseEntityName();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $6ae90c8fc78a4682$var$tsParseTypeArguments();
}
function $6ae90c8fc78a4682$var$tsParseTypeParameter() {
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const);
    const hadIn = (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in);
    const hadOut = (0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._out);
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const);
    if ((hadIn || hadOut) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) // The "in" or "out" keyword must have actually been the type parameter
    // name, so set it as the name.
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name;
    else (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends)) $6ae90c8fc78a4682$export$13a289e680c077c1();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) $6ae90c8fc78a4682$export$13a289e680c077c1();
}
function $6ae90c8fc78a4682$export$827faab4e65d5897() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $6ae90c8fc78a4682$var$tsParseTypeParameters();
}
function $6ae90c8fc78a4682$var$tsParseTypeParameters() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).typeParameterStart)) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    else (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        $6ae90c8fc78a4682$var$tsParseTypeParameter();
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
// Note: In TypeScript implementation we must provide `yieldContext` and `awaitContext`,
// but here it's always false, because this is only used for types.
function $6ae90c8fc78a4682$var$tsFillSignature(returnToken) {
    // Arrow fns *must* have return token (`=>`). Normal functions can omit it.
    const returnTokenRequired = returnToken === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow;
    $6ae90c8fc78a4682$export$827faab4e65d5897();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    // Create a scope even though we're doing type parsing so we don't accidentally
    // treat params as top-level bindings.
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    $6ae90c8fc78a4682$var$tsParseBindingListForSignature(false);
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
    if (returnTokenRequired) $6ae90c8fc78a4682$var$tsParseTypeOrTypePredicateAnnotation(returnToken);
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)(returnToken)) $6ae90c8fc78a4682$var$tsParseTypeOrTypePredicateAnnotation(returnToken);
}
function $6ae90c8fc78a4682$var$tsParseBindingListForSignature(isBlockScope) {
    (0, $90ed52daec368086$export$befa6d966a25698e)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR, isBlockScope);
}
function $6ae90c8fc78a4682$var$tsParseTypeMemberSemicolon() {
    if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $6ae90c8fc78a4682$var$tsParseSignatureMember() {
    $6ae90c8fc78a4682$var$tsFillSignature((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    $6ae90c8fc78a4682$var$tsParseTypeMemberSemicolon();
}
function $6ae90c8fc78a4682$var$tsIsUnambiguouslyIndexSignature() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)(); // Skip '{'
    const isIndexSignature = (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return isIndexSignature;
}
function $6ae90c8fc78a4682$var$tsTryParseIndexSignature() {
    if (!((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL) && $6ae90c8fc78a4682$var$tsIsUnambiguouslyIndexSignature())) return false;
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL);
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    $6ae90c8fc78a4682$export$728a3256ac690042();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
    $6ae90c8fc78a4682$export$e4623eb563192e0f();
    $6ae90c8fc78a4682$var$tsParseTypeMemberSemicolon();
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    return true;
}
function $6ae90c8fc78a4682$var$tsParsePropertyOrMethodSignature(isReadonly) {
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    if (!isReadonly && ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan))) {
        $6ae90c8fc78a4682$var$tsFillSignature((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
        $6ae90c8fc78a4682$var$tsParseTypeMemberSemicolon();
    } else {
        $6ae90c8fc78a4682$export$e4623eb563192e0f();
        $6ae90c8fc78a4682$var$tsParseTypeMemberSemicolon();
    }
}
function $6ae90c8fc78a4682$var$tsParseTypeMember() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        // call signature
        $6ae90c8fc78a4682$var$tsParseSignatureMember();
        return;
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) // constructor signature
        $6ae90c8fc78a4682$var$tsParseSignatureMember();
        else $6ae90c8fc78a4682$var$tsParsePropertyOrMethodSignature(false);
        return;
    }
    const readonly = !!$6ae90c8fc78a4682$export$a90a97ddca783020([
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly
    ]);
    const found = $6ae90c8fc78a4682$var$tsTryParseIndexSignature();
    if (found) return;
    ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._get) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._set)) && $6ae90c8fc78a4682$var$tsNextTokenCanFollowModifier();
    (0, $ac0b98ed31ddbb15$export$ab65037f9c8fb3d3)(-1 /* Types don't need context IDs. */ );
    $6ae90c8fc78a4682$var$tsParsePropertyOrMethodSignature(readonly);
}
function $6ae90c8fc78a4682$var$tsParseTypeLiteral() {
    $6ae90c8fc78a4682$var$tsParseObjectTypeMembers();
}
function $6ae90c8fc78a4682$var$tsParseObjectTypeMembers() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error)$6ae90c8fc78a4682$var$tsParseTypeMember();
}
function $6ae90c8fc78a4682$var$tsLookaheadIsStartOfMappedType() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    const isStartOfMappedType = $6ae90c8fc78a4682$var$tsIsStartOfMappedType();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return isStartOfMappedType;
}
function $6ae90c8fc78a4682$var$tsIsStartOfMappedType() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).plus) || (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus)) return (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly);
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly)) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) return false;
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if (!$6ae90c8fc78a4682$var$tsIsIdentifier()) return false;
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in);
}
function $6ae90c8fc78a4682$var$tsParseMappedTypeParameter() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in);
    $6ae90c8fc78a4682$export$13a289e680c077c1();
}
function $6ae90c8fc78a4682$var$tsParseMappedType() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).plus) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly);
    } else (0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL);
    $6ae90c8fc78a4682$var$tsParseMappedTypeParameter();
    if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as)) $6ae90c8fc78a4682$export$13a289e680c077c1();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).plus) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    } else (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    $6ae90c8fc78a4682$var$tsTryParseType();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
}
function $6ae90c8fc78a4682$var$tsParseTupleType() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL);
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        // Do not validate presence of either none or only labeled elements
        $6ae90c8fc78a4682$var$tsParseTupleElementType();
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
}
function $6ae90c8fc78a4682$var$tsParseTupleElementType() {
    // parses `...TsType[]`
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) $6ae90c8fc78a4682$export$13a289e680c077c1();
    else {
        // parses `TsType?`
        $6ae90c8fc78a4682$export$13a289e680c077c1();
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    }
    // The type we parsed above was actually a label
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) // Labeled tuple types must affix the label with `...` or `?`, so no need to handle those here
    $6ae90c8fc78a4682$export$13a289e680c077c1();
}
function $6ae90c8fc78a4682$var$tsParseParenthesizedType() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    $6ae90c8fc78a4682$export$13a289e680c077c1();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
}
function $6ae90c8fc78a4682$var$tsParseTemplateLiteralType() {
    // Finish `, read quasi
    (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
    // Finish quasi, read ${
    (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dollarBraceL);
        $6ae90c8fc78a4682$export$13a289e680c077c1();
        // Finish }, read quasi
        (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
        // Finish quasi, read either ${ or `
        (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
    }
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
}
var $6ae90c8fc78a4682$var$FunctionType;
(function(FunctionType) {
    const TSFunctionType = 0;
    FunctionType[FunctionType["TSFunctionType"] = TSFunctionType] = "TSFunctionType";
    const TSConstructorType = TSFunctionType + 1;
    FunctionType[FunctionType["TSConstructorType"] = TSConstructorType] = "TSConstructorType";
    const TSAbstractConstructorType = TSConstructorType + 1;
    FunctionType[FunctionType["TSAbstractConstructorType"] = TSAbstractConstructorType] = "TSAbstractConstructorType";
})($6ae90c8fc78a4682$var$FunctionType || ($6ae90c8fc78a4682$var$FunctionType = {}));
function $6ae90c8fc78a4682$var$tsParseFunctionOrConstructorType(type) {
    if (type === $6ae90c8fc78a4682$var$FunctionType.TSAbstractConstructorType) (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract);
    if (type === $6ae90c8fc78a4682$var$FunctionType.TSConstructorType || type === $6ae90c8fc78a4682$var$FunctionType.TSAbstractConstructorType) (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new);
    const oldInDisallowConditionalTypesContext = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = false;
    $6ae90c8fc78a4682$var$tsFillSignature((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
}
function $6ae90c8fc78a4682$var$tsParseNonArrayType() {
    switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type){
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name:
            $6ae90c8fc78a4682$var$tsParseTypeReference();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._void:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._null:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bigint:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).decimal:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._true:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._false:
            (0, $ac0b98ed31ddbb15$export$d1b3e78ad34a47ef)();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            (0, $ac0b98ed31ddbb15$export$d1b3e78ad34a47ef)();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this:
            $6ae90c8fc78a4682$var$tsParseThisTypeNode();
            if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._is) && !(0, $485552d236f25875$export$942fa35f3a7c108c)()) $6ae90c8fc78a4682$var$tsParseThisTypePredicate();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof:
            $6ae90c8fc78a4682$var$tsParseTypeQuery();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import:
            $6ae90c8fc78a4682$var$tsParseImportType();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL:
            if ($6ae90c8fc78a4682$var$tsLookaheadIsStartOfMappedType()) $6ae90c8fc78a4682$var$tsParseMappedType();
            else $6ae90c8fc78a4682$var$tsParseTypeLiteral();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL:
            $6ae90c8fc78a4682$var$tsParseTupleType();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL:
            $6ae90c8fc78a4682$var$tsParseParenthesizedType();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote:
            $6ae90c8fc78a4682$var$tsParseTemplateLiteralType();
            return;
        default:
            if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_KEYWORD) {
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name;
                return;
            }
            break;
    }
    (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
}
function $6ae90c8fc78a4682$var$tsParseArrayTypeOrHigher() {
    $6ae90c8fc78a4682$var$tsParseNonArrayType();
    while(!(0, $485552d236f25875$export$942fa35f3a7c108c)() && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL))if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR)) {
        // If we hit ] immediately, this is an array type, otherwise it's an indexed access type.
        $6ae90c8fc78a4682$export$13a289e680c077c1();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
    }
}
function $6ae90c8fc78a4682$var$tsParseInferType() {
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._infer);
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends)) {
        // Infer type constraints introduce an ambiguity about whether the "extends"
        // is a constraint for this infer type or is another conditional type.
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends);
        const oldInDisallowConditionalTypesContext = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = true;
        $6ae90c8fc78a4682$export$13a289e680c077c1();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error || !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question)) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
}
function $6ae90c8fc78a4682$var$tsParseTypeOperatorOrHigher() {
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._keyof) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._unique) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        $6ae90c8fc78a4682$var$tsParseTypeOperatorOrHigher();
    } else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._infer)) $6ae90c8fc78a4682$var$tsParseInferType();
    else {
        const oldInDisallowConditionalTypesContext = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = false;
        $6ae90c8fc78a4682$var$tsParseArrayTypeOrHigher();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
    }
}
function $6ae90c8fc78a4682$var$tsParseIntersectionTypeOrHigher() {
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseAND);
    $6ae90c8fc78a4682$var$tsParseTypeOperatorOrHigher();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseAND)) while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseAND))$6ae90c8fc78a4682$var$tsParseTypeOperatorOrHigher();
}
function $6ae90c8fc78a4682$var$tsParseUnionTypeOrHigher() {
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseOR);
    $6ae90c8fc78a4682$var$tsParseIntersectionTypeOrHigher();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseOR)) while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseOR))$6ae90c8fc78a4682$var$tsParseIntersectionTypeOrHigher();
}
function $6ae90c8fc78a4682$var$tsIsStartOfFunctionType() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) return true;
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) && $6ae90c8fc78a4682$var$tsLookaheadIsUnambiguouslyStartOfFunctionType();
}
function $6ae90c8fc78a4682$var$tsSkipParameterStart() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        return true;
    }
    // If this is a possible array/object destructure, walk to the matching bracket/brace.
    // The next token after will tell us definitively whether this is a function param.
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) {
        let depth = 1;
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        while(depth > 0 && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) depth++;
            else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR)) depth--;
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        }
        return true;
    }
    return false;
}
function $6ae90c8fc78a4682$var$tsLookaheadIsUnambiguouslyStartOfFunctionType() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    const isUnambiguouslyStartOfFunctionType = $6ae90c8fc78a4682$var$tsIsUnambiguouslyStartOfFunctionType();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return isUnambiguouslyStartOfFunctionType;
}
function $6ae90c8fc78a4682$var$tsIsUnambiguouslyStartOfFunctionType() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) // ( )
    // ( ...
    return true;
    if ($6ae90c8fc78a4682$var$tsSkipParameterStart()) {
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) // ( xxx :
        // ( xxx ,
        // ( xxx ?
        // ( xxx =
        return true;
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)) {
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow)) // ( xxx ) =>
            return true;
        }
    }
    return false;
}
function $6ae90c8fc78a4682$var$tsParseTypeOrTypePredicateAnnotation(returnToken) {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $485552d236f25875$export$3570f33b1a1f3329)(returnToken);
    const finishedReturn = $6ae90c8fc78a4682$var$tsParseTypePredicateOrAssertsPrefix();
    if (!finishedReturn) $6ae90c8fc78a4682$export$13a289e680c077c1();
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $6ae90c8fc78a4682$var$tsTryParseTypeOrTypePredicateAnnotation() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $6ae90c8fc78a4682$var$tsParseTypeOrTypePredicateAnnotation((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
}
function $6ae90c8fc78a4682$export$e4623eb563192e0f() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $6ae90c8fc78a4682$export$728a3256ac690042();
}
function $6ae90c8fc78a4682$var$tsTryParseType() {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $6ae90c8fc78a4682$export$13a289e680c077c1();
}
/**
 * Detect a few special return syntax cases: `x is T`, `asserts x`, `asserts x is T`,
 * `asserts this is T`.
 *
 * Returns true if we parsed the return type, false if there's still a type to be parsed.
 */ function $6ae90c8fc78a4682$var$tsParseTypePredicateOrAssertsPrefix() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._asserts)) {
        // Normally this is `asserts x is T`, but at this point, it might be `asserts is T` (a user-
        // defined type guard on the `asserts` variable) or just a type called `asserts`.
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._is)) {
            // If we see `asserts is`, then this must be of the form `asserts is T`, since
            // `asserts is is T` isn't valid.
            $6ae90c8fc78a4682$export$13a289e680c077c1();
            return true;
        } else if ($6ae90c8fc78a4682$var$tsIsIdentifier() || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this)) {
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._is)) // If we see `is`, then this is `asserts x is T`. Otherwise, it's `asserts x`.
            $6ae90c8fc78a4682$export$13a289e680c077c1();
            return true;
        } else {
            // Regular type, so bail out and start type parsing from scratch.
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return false;
        }
    } else if ($6ae90c8fc78a4682$var$tsIsIdentifier() || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this)) {
        // This is a regular identifier, which may or may not have "is" after it.
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._is) && !(0, $485552d236f25875$export$942fa35f3a7c108c)()) {
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            $6ae90c8fc78a4682$export$13a289e680c077c1();
            return true;
        } else {
            // Regular type, so bail out and start type parsing from scratch.
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return false;
        }
    }
    return false;
}
function $6ae90c8fc78a4682$export$728a3256ac690042() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    $6ae90c8fc78a4682$export$13a289e680c077c1();
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $6ae90c8fc78a4682$export$13a289e680c077c1() {
    $6ae90c8fc78a4682$export$817427f5f29c80bc();
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext || (0, $485552d236f25875$export$942fa35f3a7c108c)() || !(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends)) return;
    // extends type
    const oldInDisallowConditionalTypesContext = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = true;
    $6ae90c8fc78a4682$export$817427f5f29c80bc();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    // true type
    $6ae90c8fc78a4682$export$13a289e680c077c1();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    // false type
    $6ae90c8fc78a4682$export$13a289e680c077c1();
}
function $6ae90c8fc78a4682$var$isAbstractConstructorSignature() {
    return (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new;
}
function $6ae90c8fc78a4682$export$817427f5f29c80bc() {
    if ($6ae90c8fc78a4682$var$tsIsStartOfFunctionType()) {
        $6ae90c8fc78a4682$var$tsParseFunctionOrConstructorType($6ae90c8fc78a4682$var$FunctionType.TSFunctionType);
        return;
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new)) {
        // As in `new () => Date`
        $6ae90c8fc78a4682$var$tsParseFunctionOrConstructorType($6ae90c8fc78a4682$var$FunctionType.TSConstructorType);
        return;
    } else if ($6ae90c8fc78a4682$var$isAbstractConstructorSignature()) {
        // As in `abstract new () => Date`
        $6ae90c8fc78a4682$var$tsParseFunctionOrConstructorType($6ae90c8fc78a4682$var$FunctionType.TSAbstractConstructorType);
        return;
    }
    $6ae90c8fc78a4682$var$tsParseUnionTypeOrHigher();
}
function $6ae90c8fc78a4682$export$ecfac1712a900e29() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
    $6ae90c8fc78a4682$export$13a289e680c077c1();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan);
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    (0, $ac0b98ed31ddbb15$export$165911d2b803e372)();
}
function $6ae90c8fc78a4682$export$382de4b7ab7e7990() {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).typeParameterStart;
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
        while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
            $6ae90c8fc78a4682$export$13a289e680c077c1();
            (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
        }
        // Process >, but the one after needs to be parsed JSX-style.
        (0, $6da7dec74ffdbf22$export$a1b2c368381052e6)();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    }
}
function $6ae90c8fc78a4682$var$tsParseHeritageClause() {
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        $6ae90c8fc78a4682$var$tsParseExpressionWithTypeArguments();
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
}
function $6ae90c8fc78a4682$var$tsParseExpressionWithTypeArguments() {
    // Note: TS uses parseLeftHandSideExpressionOrHigher,
    // then has grammar errors later if it's not an EntityName.
    $6ae90c8fc78a4682$var$tsParseEntityName();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $6ae90c8fc78a4682$var$tsParseTypeArguments();
}
function $6ae90c8fc78a4682$var$tsParseInterfaceDeclaration() {
    (0, $90ed52daec368086$export$7538cb03fa894c83)(false);
    $6ae90c8fc78a4682$export$827faab4e65d5897();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends)) $6ae90c8fc78a4682$var$tsParseHeritageClause();
    $6ae90c8fc78a4682$var$tsParseObjectTypeMembers();
}
function $6ae90c8fc78a4682$var$tsParseTypeAliasDeclaration() {
    (0, $90ed52daec368086$export$7538cb03fa894c83)(false);
    $6ae90c8fc78a4682$export$827faab4e65d5897();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq);
    $6ae90c8fc78a4682$export$13a289e680c077c1();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $6ae90c8fc78a4682$var$tsParseEnumMember() {
    // Computed property names are grammar errors in an enum, so accept just string literal or identifier.
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) (0, $ac0b98ed31ddbb15$export$d1b3e78ad34a47ef)();
    else (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
        const eqIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1;
        (0, $ac0b98ed31ddbb15$export$b97bbe8a7805284f)();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[eqIndex].rhsEndIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    }
}
function $6ae90c8fc78a4682$var$tsParseEnumDeclaration() {
    (0, $90ed52daec368086$export$7538cb03fa894c83)(false);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        $6ae90c8fc78a4682$var$tsParseEnumMember();
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
}
function $6ae90c8fc78a4682$var$tsParseModuleBlock() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    (0, $8a4e0068a7ab0607$export$e5110a9b2ab486ee)(/* end */ (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
}
function $6ae90c8fc78a4682$var$tsParseModuleOrNamespaceDeclaration() {
    (0, $90ed52daec368086$export$7538cb03fa894c83)(false);
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) $6ae90c8fc78a4682$var$tsParseModuleOrNamespaceDeclaration();
    else $6ae90c8fc78a4682$var$tsParseModuleBlock();
}
function $6ae90c8fc78a4682$var$tsParseAmbientExternalModuleDeclaration() {
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._global)) (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) (0, $ac0b98ed31ddbb15$export$fa61731cf32bc243)();
    else (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) $6ae90c8fc78a4682$var$tsParseModuleBlock();
    else (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $6ae90c8fc78a4682$export$bb14276cd4f56f44() {
    (0, $90ed52daec368086$export$cba413304e86fc0d)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq);
    $6ae90c8fc78a4682$var$tsParseModuleReference();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $6ae90c8fc78a4682$var$tsIsExternalModuleReference() {
    return (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._require) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL;
}
function $6ae90c8fc78a4682$var$tsParseModuleReference() {
    if ($6ae90c8fc78a4682$var$tsIsExternalModuleReference()) $6ae90c8fc78a4682$var$tsParseExternalModuleReference();
    else $6ae90c8fc78a4682$var$tsParseEntityName();
}
function $6ae90c8fc78a4682$var$tsParseExternalModuleReference() {
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._require);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    (0, $ac0b98ed31ddbb15$export$d1b3e78ad34a47ef)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
}
// Utilities
// Returns true if a statement matched.
function $6ae90c8fc78a4682$var$tsTryParseDeclare() {
    if ((0, $485552d236f25875$export$12d132b6e81066e4)()) return false;
    switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type){
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function:
            {
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                // We don't need to precisely get the function start here, since it's only used to mark
                // the function as a type if it's bodiless, and it's already a type here.
                const functionStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
                (0, $8a4e0068a7ab0607$export$ba3dc2bd7c065219)(functionStart, /* isStatement */ true);
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return true;
            }
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class:
            {
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
                (0, $8a4e0068a7ab0607$export$542081d93172af)(/* isStatement */ true, /* optionalId */ false);
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return true;
            }
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const:
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const) && (0, $485552d236f25875$export$d1b5391c35999eba)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum)) {
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
                // `const enum = 0;` not allowed because "enum" is a strict mode reserved word.
                (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const);
                (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum);
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum;
                $6ae90c8fc78a4682$var$tsParseEnumDeclaration();
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return true;
            }
        // falls through
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let:
            {
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
                (0, $8a4e0068a7ab0607$export$73f0614724a3919a)((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var);
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return true;
            }
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name:
            {
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
                const contextualKeyword = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword;
                let matched = false;
                if (contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._global) {
                    $6ae90c8fc78a4682$var$tsParseAmbientExternalModuleDeclaration();
                    matched = true;
                } else matched = $6ae90c8fc78a4682$var$tsParseDeclaration(contextualKeyword, /* isBeforeToken */ true);
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return matched;
            }
        default:
            return false;
    }
}
// Note: this won't be called unless the keyword is allowed in `shouldParseExportDeclaration`.
// Returns true if it matched a declaration.
function $6ae90c8fc78a4682$var$tsTryParseExportDeclaration() {
    return $6ae90c8fc78a4682$var$tsParseDeclaration((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword, /* isBeforeToken */ true);
}
// Returns true if it matched a statement.
function $6ae90c8fc78a4682$var$tsParseExpressionStatement(contextualKeyword) {
    switch(contextualKeyword){
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare:
            {
                const declareTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1;
                const matched = $6ae90c8fc78a4682$var$tsTryParseDeclare();
                if (matched) {
                    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[declareTokenIndex].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._declare;
                    return true;
                }
                break;
            }
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._global:
            // `global { }` (with no `declare`) may appear inside an ambient module declaration.
            // Would like to use tsParseAmbientExternalModuleDeclaration here, but already ran past "global".
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
                $6ae90c8fc78a4682$var$tsParseModuleBlock();
                return true;
            }
            break;
        default:
            return $6ae90c8fc78a4682$var$tsParseDeclaration(contextualKeyword, /* isBeforeToken */ false);
    }
    return false;
}
/**
 * Common code for parsing a declaration.
 *
 * isBeforeToken indicates that the current parser state is at the contextual
 * keyword (and that it is not yet emitted) rather than reading the token after
 * it. When isBeforeToken is true, we may be preceded by an `export` token and
 * should include that token in a type context we create, e.g. to handle
 * `export interface` or `export type`. (This is a bit of a hack and should be
 * cleaned up at some point.)
 *
 * Returns true if it matched a declaration.
 */ function $6ae90c8fc78a4682$var$tsParseDeclaration(contextualKeyword, isBeforeToken) {
    switch(contextualKeyword){
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract:
            if ($6ae90c8fc78a4682$var$tsCheckLineTerminator(isBeforeToken) && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class)) {
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract;
                (0, $8a4e0068a7ab0607$export$542081d93172af)(/* isStatement */ true, /* optionalId */ false);
                return true;
            }
            break;
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum:
            if ($6ae90c8fc78a4682$var$tsCheckLineTerminator(isBeforeToken) && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum;
                $6ae90c8fc78a4682$var$tsParseEnumDeclaration();
                return true;
            }
            break;
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface:
            if ($6ae90c8fc78a4682$var$tsCheckLineTerminator(isBeforeToken) && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
                // `next` is true in "export" and "declare" contexts, so we want to remove that token
                // as well.
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                $6ae90c8fc78a4682$var$tsParseInterfaceDeclaration();
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return true;
            }
            break;
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module:
            if ($6ae90c8fc78a4682$var$tsCheckLineTerminator(isBeforeToken)) {
                if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) {
                    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                    $6ae90c8fc78a4682$var$tsParseAmbientExternalModuleDeclaration();
                    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                    return true;
                } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
                    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                    $6ae90c8fc78a4682$var$tsParseModuleOrNamespaceDeclaration();
                    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                    return true;
                }
            }
            break;
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._namespace:
            if ($6ae90c8fc78a4682$var$tsCheckLineTerminator(isBeforeToken) && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                $6ae90c8fc78a4682$var$tsParseModuleOrNamespaceDeclaration();
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return true;
            }
            break;
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type:
            if ($6ae90c8fc78a4682$var$tsCheckLineTerminator(isBeforeToken) && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
                const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                $6ae90c8fc78a4682$var$tsParseTypeAliasDeclaration();
                (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
                return true;
            }
            break;
        default:
            break;
    }
    return false;
}
function $6ae90c8fc78a4682$var$tsCheckLineTerminator(isBeforeToken) {
    if (isBeforeToken) {
        // Babel checks hasFollowingLineBreak here and returns false, but this
        // doesn't actually come up, e.g. `export interface` can never be on its own
        // line in valid code.
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        return true;
    } else return !(0, $485552d236f25875$export$12d132b6e81066e4)();
}
// Returns true if there was a generic async arrow function.
function $6ae90c8fc78a4682$var$tsTryParseGenericAsyncArrowFunction() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    $6ae90c8fc78a4682$var$tsParseTypeParameters();
    (0, $8a4e0068a7ab0607$export$dd0fc1c64275f2c4)();
    $6ae90c8fc78a4682$var$tsTryParseTypeOrTypePredicateAnnotation();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
    (0, $ac0b98ed31ddbb15$export$50f85c246417e18)(true);
    return true;
}
/**
 * If necessary, hack the tokenizer state so that this bitshift was actually a
 * less-than token, then keep parsing. This should only be used in situations
 * where we restore from snapshot on error (which reverts this change) or
 * where bitshift would be illegal anyway (e.g. in a class "extends" clause).
 *
 * This hack is useful to handle situations like foo<<T>() => void>() where
 * there can legitimately be two open-angle-brackets in a row in TS.
 */ function $6ae90c8fc78a4682$var$tsParseTypeArgumentsWithPossibleBitshift() {
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitShiftL) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos -= 1;
        (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan);
    }
    $6ae90c8fc78a4682$var$tsParseTypeArguments();
}
function $6ae90c8fc78a4682$var$tsParseTypeArguments() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan);
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        $6ae90c8fc78a4682$export$13a289e680c077c1();
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
    if (!oldIsType) {
        // If the type arguments are present in an expression context, e.g.
        // f<number>(), then the > sign should be tokenized as a non-type token.
        // In particular, f(a < b, c >= d) should parse the >= as a single token,
        // resulting in a syntax error and fallback to the non-type-args
        // interpretation. In the success case, even though the > is tokenized as a
        // non-type token, it still must be marked as a type token so that it is
        // erased.
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        (0, $19e70491d10f11e8$export$4d00b4f4d9d7a9b3)();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan);
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
    } else {
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan);
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    }
}
function $6ae90c8fc78a4682$export$5df75dadb7a629b6() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword){
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract:
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare:
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum:
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface:
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module:
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._namespace:
        case (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type:
            return true;
        default:
            break;
    }
    return false;
}
function $6ae90c8fc78a4682$export$3c36bc5140dd8c64(functionStart, funcContextId) {
    // For arrow functions, `parseArrow` handles the return type itself.
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $6ae90c8fc78a4682$var$tsParseTypeOrTypePredicateAnnotation((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    // The original code checked the node type to make sure this function type allows a missing
    // body, but we skip that to avoid sending around the node type. We instead just use the
    // allowExpressionBody boolean to make sure it's not an arrow function.
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) && (0, $485552d236f25875$export$12d132b6e81066e4)()) {
        // Retroactively mark the function declaration as a type.
        let i = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1;
        while(i >= 0 && ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[i].start >= functionStart || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[i].type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[i].type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export)){
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[i].isType = true;
            i--;
        }
        return;
    }
    (0, $ac0b98ed31ddbb15$export$50f85c246417e18)(false, funcContextId);
}
function $6ae90c8fc78a4682$export$f6cd10065188a17f(startTokenIndex, noCalls, stopState) {
    if (!(0, $485552d236f25875$export$942fa35f3a7c108c)() && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bang)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).nonNullAssertion;
        return;
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitShiftL)) {
        // There are number of things we are going to "maybe" parse, like type arguments on
        // tagged template expressions. If any of them fail, walk it back and continue.
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        if (!noCalls && (0, $ac0b98ed31ddbb15$export$960e7b0728d0d49e)()) {
            // Almost certainly this is a generic async function `async <T>() => ...
            // But it might be a call with a type argument `async<T>();`
            const asyncArrowFn = $6ae90c8fc78a4682$var$tsTryParseGenericAsyncArrowFunction();
            if (asyncArrowFn) return;
        }
        $6ae90c8fc78a4682$var$tsParseTypeArgumentsWithPossibleBitshift();
        if (!noCalls && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
            // With f<T>(), the subscriptStartIndex marker is on the ( token.
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
            (0, $ac0b98ed31ddbb15$export$970763873d9efa73)();
        } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote)) // Tagged template with a type argument.
        (0, $ac0b98ed31ddbb15$export$2e2dbd43b49fd373)();
        else if (// The remaining possible case is an instantiation expression, e.g.
        // Array<number> . Check for a few cases that would disqualify it and
        // cause us to bail out.
        // a<b>>c is not (a<b>)>c, but a<(b>>c)
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan || // a<b>c is (a<b)>c
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL && Boolean((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_EXPRESSION_START) && !(0, $485552d236f25875$export$942fa35f3a7c108c)()) // Bail out. We have something like a<b>c, which is not an expression with
        // type arguments but an (a < b) > c comparison.
        (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        else return;
    } else if (!noCalls && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) {
        // If we see f?.<, then this must be an optional call with a type argument.
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[startTokenIndex].isOptionalChainStart = true;
        // With f?.<T>(), the subscriptStartIndex marker is on the ?. token.
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        $6ae90c8fc78a4682$var$tsParseTypeArguments();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
        (0, $ac0b98ed31ddbb15$export$970763873d9efa73)();
    }
    (0, $ac0b98ed31ddbb15$export$31dc8e486c1a1be6)(startTokenIndex, noCalls, stopState);
}
function $6ae90c8fc78a4682$export$6714566ca8db2f39() {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import)) {
        // One of these cases:
        // export import A = B;
        // export import type A = require("A");
        if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq) // Eat a `type` token, unless it's actually an identifier name.
        (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type);
        $6ae90c8fc78a4682$export$bb14276cd4f56f44();
        return true;
    } else if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
        // `export = x;`
        (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
        (0, $485552d236f25875$export$62fa27d385e555f3)();
        return true;
    } else if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as)) {
        // `export as namespace A;`
        // See `parseNamespaceExportDeclaration` in TypeScript's own parser
        (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._namespace);
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        (0, $485552d236f25875$export$62fa27d385e555f3)();
        return true;
    } else {
        if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
            const nextType = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
            // export type {foo} from 'a';
            // export type * from 'a';'
            // export type * as ns from 'a';'
            if (nextType === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL || nextType === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        }
        return false;
    }
}
function $6ae90c8fc78a4682$export$718ece2f88417ffd() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
        // import {foo}
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportDeclaration;
        return;
    }
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
        // import {type foo}
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportDeclaration;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
        return;
    }
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
        // import {foo as bar}
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportAccess;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportDeclaration;
        return;
    }
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    // import {type foo as bar}
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportAccess;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportDeclaration;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 4].isType = true;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 3].isType = true;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
}
function $6ae90c8fc78a4682$export$7994f3b86b6c7d1e() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
        // export {foo}
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ExportAccess;
        return;
    }
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
        // export {type foo}
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ExportAccess;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
        return;
    }
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
        // export {foo as bar}
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ExportAccess;
        return;
    }
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    // export {type foo as bar}
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ExportAccess;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 4].isType = true;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 3].isType = true;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
}
function $6ae90c8fc78a4682$export$95d54e02ae7a0197() {
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract;
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)(); // Skip "abstract"
        (0, $8a4e0068a7ab0607$export$542081d93172af)(true, true);
        return true;
    }
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface)) {
        // Make sure "export default" are considered type tokens so the whole thing is removed.
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(2);
        $6ae90c8fc78a4682$var$tsParseDeclaration((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface, true);
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        return true;
    }
    return false;
}
function $6ae90c8fc78a4682$export$bd8d07f8ee509b14() {
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const) {
        const ahead = (0, $19e70491d10f11e8$export$ef1b94c514fc060a)();
        if (ahead.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && ahead.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum) {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const);
            (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum);
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum;
            $6ae90c8fc78a4682$var$tsParseEnumDeclaration();
            return true;
        }
    }
    return false;
}
function $6ae90c8fc78a4682$export$9d02a6e20851f734(isStatic) {
    const memberStartIndexAfterStatic = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    $6ae90c8fc78a4682$export$77616e6d401f584a([
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._abstract,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._readonly,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._static,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._override
    ]);
    const modifiersEndIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    const found = $6ae90c8fc78a4682$var$tsTryParseIndexSignature();
    if (found) {
        // Index signatures are type declarations, so set the modifier tokens as
        // type tokens. Most tokens could be assumed to be type tokens, but `static`
        // is ambiguous unless we set it explicitly here.
        const memberStartIndex = isStatic ? memberStartIndexAfterStatic - 1 : memberStartIndexAfterStatic;
        for(let i = memberStartIndex; i < modifiersEndIndex; i++)(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[i].isType = true;
        return true;
    }
    return false;
}
function $6ae90c8fc78a4682$export$a642c15f5070c816(contextualKeyword) {
    const matched = $6ae90c8fc78a4682$var$tsParseExpressionStatement(contextualKeyword);
    if (!matched) (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $6ae90c8fc78a4682$export$b29e6741ccf6da0a() {
    // "export declare" is equivalent to just "export".
    const isDeclare = (0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare);
    if (isDeclare) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._declare;
    let matchedDeclaration = false;
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
        if (isDeclare) {
            const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(2);
            matchedDeclaration = $6ae90c8fc78a4682$var$tsTryParseExportDeclaration();
            (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        } else matchedDeclaration = $6ae90c8fc78a4682$var$tsTryParseExportDeclaration();
    }
    if (!matchedDeclaration) {
        if (isDeclare) {
            const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(2);
            (0, $8a4e0068a7ab0607$export$68b986de0b252bc8)(true);
            (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        } else (0, $8a4e0068a7ab0607$export$68b986de0b252bc8)(true);
    }
}
function $6ae90c8fc78a4682$export$ea9d02c53bf69095(hasSuper) {
    if (hasSuper && ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitShiftL))) $6ae90c8fc78a4682$var$tsParseTypeArgumentsWithPossibleBitshift();
    if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._implements)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._implements;
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
        $6ae90c8fc78a4682$var$tsParseHeritageClause();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    }
}
function $6ae90c8fc78a4682$export$f7c2ce498525881a() {
    $6ae90c8fc78a4682$export$827faab4e65d5897();
}
function $6ae90c8fc78a4682$export$ba34d58430377f94() {
    $6ae90c8fc78a4682$export$827faab4e65d5897();
}
function $6ae90c8fc78a4682$export$41c8703baf1bbf07() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    if (!(0, $485552d236f25875$export$942fa35f3a7c108c)()) (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bang);
    $6ae90c8fc78a4682$export$e4623eb563192e0f();
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $6ae90c8fc78a4682$export$490a9bc22f3cab3f() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $6ae90c8fc78a4682$export$728a3256ac690042();
}
function $6ae90c8fc78a4682$export$daa24143ef798a56(noIn, isWithinParens) {
    // Note: When the JSX plugin is on, type assertions (`<T> x`) aren't valid syntax.
    if (0, $e406deb3d43fd58b$export$43bb667a94af025a) return $6ae90c8fc78a4682$export$fbbf4e3ed219417f(noIn, isWithinParens);
    else return $6ae90c8fc78a4682$export$9606be81aa771b16(noIn, isWithinParens);
}
function $6ae90c8fc78a4682$export$fbbf4e3ed219417f(noIn, isWithinParens) {
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) return (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    // Prefer to parse JSX if possible. But may be an arrow fn.
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    let wasArrow = (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    else return wasArrow;
    // Otherwise, try as type-parameterized arrow function.
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).typeParameterStart;
    // This is similar to TypeScript's `tryParseParenthesizedArrowFunctionExpression`.
    $6ae90c8fc78a4682$var$tsParseTypeParameters();
    wasArrow = (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    if (!wasArrow) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    return wasArrow;
}
function $6ae90c8fc78a4682$export$9606be81aa771b16(noIn, isWithinParens) {
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) return (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    // This is similar to TypeScript's `tryParseParenthesizedArrowFunctionExpression`.
    $6ae90c8fc78a4682$var$tsParseTypeParameters();
    const wasArrow = (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    if (!wasArrow) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    else return wasArrow;
    // Try parsing a type cast instead of an arrow function.
    // This will start with a type assertion (via parseMaybeUnary).
    // But don't directly call `tsParseTypeAssertion` because we want to handle any binary after it.
    return (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
}
function $6ae90c8fc78a4682$export$e20067ab7c70da1d() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) {
        // This is different from how the TS parser does it.
        // TS uses lookahead. Babylon parses it as a parenthesized expression and converts.
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        $6ae90c8fc78a4682$var$tsParseTypeOrTypePredicateAnnotation((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
        if ((0, $485552d236f25875$export$1c0919cee6560c3)()) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow)) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
    return (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
}
function $6ae90c8fc78a4682$export$9b46e2c9fd90d888() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    $6ae90c8fc78a4682$export$e4623eb563192e0f();
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $6ae90c8fc78a4682$export$fd0439ea9a1ac1ea() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitShiftL)) $6ae90c8fc78a4682$var$tsParseTypeArgumentsWithPossibleBitshift();
    (0, $8a4e0068a7ab0607$export$50c128b10ac5ea5b)();
}


/**
 * Read token with JSX contents.
 *
 * In addition to detecting jsxTagStart and also regular tokens that might be
 * part of an expression, this code detects the start and end of text ranges
 * within JSX children. In order to properly count the number of children, we
 * distinguish jsxText from jsxEmptyText, which is a text range that simplifies
 * to the empty string after JSX whitespace trimming.
 *
 * It turns out that a JSX text range will simplify to the empty string if and
 * only if both of these conditions hold:
 * - The range consists entirely of whitespace characters (only counting space,
 *   tab, \r, and \n).
 * - The range has at least one newline.
 * This can be proven by analyzing any implementation of whitespace trimming,
 * e.g. formatJSXTextLiteral in Sucrase or cleanJSXElementLiteralChild in Babel.
 */ function $6da7dec74ffdbf22$var$jsxReadToken() {
    let sawNewline = false;
    let sawNonWhitespace = false;
    while(true){
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unterminated JSX contents");
            return;
        }
        const ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lessThan || ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftCurlyBrace) {
            if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos === (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start) {
                if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lessThan) {
                    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
                    (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart);
                    return;
                }
                (0, $19e70491d10f11e8$export$e0ebb9fd4c2c4701)(ch);
                return;
            }
            if (sawNewline && !sawNonWhitespace) (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxEmptyText);
            else (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxText);
            return;
        }
        // This is part of JSX text.
        if (ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lineFeed) sawNewline = true;
        else if (ch !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).space && ch !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).carriageReturn && ch !== (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).tab) sawNonWhitespace = true;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
    }
}
function $6da7dec74ffdbf22$var$jsxReadString(quote) {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
    for(;;){
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos >= (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unterminated string constant");
            return;
        }
        const ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
        if (ch === quote) {
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
            break;
        }
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos++;
    }
    (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string);
}
// Read a JSX identifier (valid tag or attribute name).
//
// Optimized version since JSX identifiers can't contain
// escape characters and so can be read as single slice.
// Also assumes that first character was already checked
// by isIdentifierStart in readToken.
function $6da7dec74ffdbf22$var$jsxReadWord() {
    let ch;
    do {
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos > (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length) {
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("Unexpectedly reached the end of input.");
            return;
        }
        ch = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
    }while ((0, $231ac6b14e19c571$export$d19df39e3926cfef)[ch] || ch === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dash);
    (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName);
}
// Parse next token as JSX identifier
function $6da7dec74ffdbf22$var$jsxParseIdentifier() {
    $6da7dec74ffdbf22$export$a1b2c368381052e6();
}
// Parse namespaced identifier.
function $6da7dec74ffdbf22$var$jsxParseNamespacedName(identifierRole) {
    $6da7dec74ffdbf22$var$jsxParseIdentifier();
    if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) {
        // Plain identifier, so this is an access.
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = identifierRole;
        return;
    }
    // Process the second half of the namespaced name.
    $6da7dec74ffdbf22$var$jsxParseIdentifier();
}
// Parses element name in any form - namespaced, member
// or single identifier.
function $6da7dec74ffdbf22$var$jsxParseElementName() {
    const firstTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    $6da7dec74ffdbf22$var$jsxParseNamespacedName((0, $19e70491d10f11e8$export$99f888ada3c99de3).Access);
    let hadDot = false;
    while((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)){
        hadDot = true;
        $6da7dec74ffdbf22$export$a1b2c368381052e6();
        $6da7dec74ffdbf22$var$jsxParseIdentifier();
    }
    // For tags like <div> with a lowercase letter and no dots, the name is
    // actually *not* an identifier access, since it's referring to a built-in
    // tag name. Remove the identifier role in this case so that it's not
    // accidentally transformed by the imports transform when preserving JSX.
    if (!hadDot) {
        const firstToken = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[firstTokenIndex];
        const firstChar = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(firstToken.start);
        if (firstChar >= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseA && firstChar <= (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseZ) firstToken.identifierRole = null;
    }
}
// Parses any type of JSX attribute value.
function $6da7dec74ffdbf22$var$jsxParseAttributeValue() {
    switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type){
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
            $6da7dec74ffdbf22$export$a1b2c368381052e6();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart:
            $6da7dec74ffdbf22$export$7cbe8c53d909e342();
            $6da7dec74ffdbf22$export$a1b2c368381052e6();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string:
            $6da7dec74ffdbf22$export$a1b2c368381052e6();
            return;
        default:
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)("JSX value should be either an expression or a quoted JSX text");
    }
}
// Parse JSX spread child, after already processing the {
// Does not parse the closing }
function $6da7dec74ffdbf22$var$jsxParseSpreadChild() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis);
    (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
}
// Parses JSX opening tag starting after "<".
// Returns true if the tag was self-closing.
// Does not parse the last token.
function $6da7dec74ffdbf22$var$jsxParseOpeningElement(initialTokenIndex) {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) // This is an open-fragment.
    return false;
    $6da7dec74ffdbf22$var$jsxParseElementName();
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$382de4b7ab7e7990)();
    let hasSeenPropSpread = false;
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            hasSeenPropSpread = true;
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis);
            (0, $ac0b98ed31ddbb15$export$b97bbe8a7805284f)();
            // }
            $6da7dec74ffdbf22$export$a1b2c368381052e6();
            continue;
        }
        if (hasSeenPropSpread && (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).end - (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start === 3 && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseK && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start + 1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseE && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start + 2) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lowercaseY) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $19e70491d10f11e8$export$4620c92ad8b511d9).KeyAfterPropSpread;
        $6da7dec74ffdbf22$var$jsxParseNamespacedName((0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectKey);
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
            $6da7dec74ffdbf22$export$a1b2c368381052e6();
            $6da7dec74ffdbf22$var$jsxParseAttributeValue();
        }
    }
    const isSelfClosing = (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash);
    if (isSelfClosing) // /
    $6da7dec74ffdbf22$export$a1b2c368381052e6();
    return isSelfClosing;
}
// Parses JSX closing tag starting after "</".
// Does not parse the last token.
function $6da7dec74ffdbf22$var$jsxParseClosingElement() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd)) // Fragment syntax, so we immediately have a tag end.
    return;
    $6da7dec74ffdbf22$var$jsxParseElementName();
}
// Parses entire JSX element, including its opening tag
// (starting after "<"), attributes, contents and closing tag.
// Does not parse the last token.
function $6da7dec74ffdbf22$var$jsxParseElementAt() {
    const initialTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $19e70491d10f11e8$export$4620c92ad8b511d9).NoChildren;
    let numExplicitChildren = 0;
    const isSelfClosing = $6da7dec74ffdbf22$var$jsxParseOpeningElement(initialTokenIndex);
    if (!isSelfClosing) {
        $6da7dec74ffdbf22$var$nextJSXExprToken();
        while(true)switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type){
            case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart:
                $6da7dec74ffdbf22$export$a1b2c368381052e6();
                if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash)) {
                    $6da7dec74ffdbf22$export$a1b2c368381052e6();
                    $6da7dec74ffdbf22$var$jsxParseClosingElement();
                    // Key after prop spread takes precedence over number of children,
                    // since it means we switch to createElement, which doesn't care
                    // about number of children.
                    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole !== (0, $19e70491d10f11e8$export$4620c92ad8b511d9).KeyAfterPropSpread) {
                        if (numExplicitChildren === 1) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $19e70491d10f11e8$export$4620c92ad8b511d9).OneChild;
                        else if (numExplicitChildren > 1) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $19e70491d10f11e8$export$4620c92ad8b511d9).StaticChildren;
                    }
                    return;
                }
                numExplicitChildren++;
                $6da7dec74ffdbf22$var$jsxParseElementAt();
                $6da7dec74ffdbf22$var$nextJSXExprToken();
                break;
            case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxText:
                numExplicitChildren++;
                $6da7dec74ffdbf22$var$nextJSXExprToken();
                break;
            case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxEmptyText:
                $6da7dec74ffdbf22$var$nextJSXExprToken();
                break;
            case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL:
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
                    $6da7dec74ffdbf22$var$jsxParseSpreadChild();
                    $6da7dec74ffdbf22$var$nextJSXExprToken();
                    // Spread children are a mechanism to explicitly mark children as
                    // static, so count it as 2 children to satisfy the "more than one
                    // child" condition.
                    numExplicitChildren += 2;
                } else {
                    // If we see {}, this is an empty pseudo-expression that doesn't
                    // count as a child.
                    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                        numExplicitChildren++;
                        (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
                    }
                    $6da7dec74ffdbf22$var$nextJSXExprToken();
                }
                break;
            // istanbul ignore next - should never happen
            default:
                (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
                return;
        }
    }
}
function $6da7dec74ffdbf22$export$7cbe8c53d909e342() {
    $6da7dec74ffdbf22$export$a1b2c368381052e6();
    $6da7dec74ffdbf22$var$jsxParseElementAt();
}
function $6da7dec74ffdbf22$export$a1b2c368381052e6() {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.push(new (0, $19e70491d10f11e8$export$50792b0e93539fde)());
    (0, $19e70491d10f11e8$export$b240c79c2d18160)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    const code = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos);
    if ((0, $231ac6b14e19c571$export$dc1d1d7d9fdffb8)[code]) $6da7dec74ffdbf22$var$jsxReadWord();
    else if (code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).quotationMark || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).apostrophe) $6da7dec74ffdbf22$var$jsxReadString(code);
    else {
        // The following tokens are just one character each.
        ++(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
        switch(code){
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).greaterThan:
                (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagEnd);
                break;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).lessThan:
                (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart);
                break;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).slash:
                (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash);
                break;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).equalsTo:
                (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq);
                break;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftCurlyBrace:
                (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
                break;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).dot:
                (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot);
                break;
            case (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).colon:
                (0, $19e70491d10f11e8$export$58122cd1933ef607)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
                break;
            default:
                (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        }
    }
}
function $6da7dec74ffdbf22$var$nextJSXExprToken() {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.push(new (0, $19e70491d10f11e8$export$50792b0e93539fde)());
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos;
    $6da7dec74ffdbf22$var$jsxReadToken();
}








function $fa72ea6780427093$export$a1aa0436beedb1fa(noIn) {
    // If we see ?:, this can't possibly be a valid conditional. typedParseParenItem will be called
    // later to finish off the arrow parameter. We also need to handle bare ? tokens for optional
    // parameters without type annotations, i.e. ?, and ?) .
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question)) {
        const nextType = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
        if (nextType === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon || nextType === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma || nextType === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) return;
    }
    (0, $ac0b98ed31ddbb15$export$a3d1b6cb707072ce)(noIn);
}
function $fa72ea6780427093$export$72bae99899f77e0f() {
    (0, $19e70491d10f11e8$export$cb3e65614411a57c)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) {
        if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$728a3256ac690042)();
        else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$6c833037db1a1e96)();
    }
}













class $ac0b98ed31ddbb15$export$8cd93656cd4760 {
    constructor(stop){
        this.stop = stop;
    }
}
function $ac0b98ed31ddbb15$export$ed9c825e502c46c8(noIn = false) {
    $ac0b98ed31ddbb15$export$b97bbe8a7805284f(noIn);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma))$ac0b98ed31ddbb15$export$b97bbe8a7805284f(noIn);
}
function $ac0b98ed31ddbb15$export$b97bbe8a7805284f(noIn = false, isWithinParens = false) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) return (0, $6ae90c8fc78a4682$export$daa24143ef798a56)(noIn, isWithinParens);
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) return (0, $406735a56f0f5eb4$export$abad2599830a7c66)(noIn, isWithinParens);
    else return $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd(noIn, isWithinParens);
}
function $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd(noIn, isWithinParens) {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._yield)) {
        $ac0b98ed31ddbb15$var$parseYield();
        return false;
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._yield)) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).potentialArrowAt = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
    const wasArrow = $ac0b98ed31ddbb15$var$parseMaybeConditional(noIn);
    if (isWithinParens) $ac0b98ed31ddbb15$var$parseParenItem();
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_ASSIGN) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        $ac0b98ed31ddbb15$export$b97bbe8a7805284f(noIn);
        return false;
    }
    return wasArrow;
}
// Parse a ternary conditional (`?:`) operator.
// Returns true if the expression was an arrow function.
function $ac0b98ed31ddbb15$var$parseMaybeConditional(noIn) {
    const wasArrow = $ac0b98ed31ddbb15$var$parseExprOps(noIn);
    if (wasArrow) return true;
    $ac0b98ed31ddbb15$var$parseConditional(noIn);
    return false;
}
function $ac0b98ed31ddbb15$var$parseConditional(noIn) {
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) || (0, $e406deb3d43fd58b$export$92e334f8fe49aa94)) (0, $fa72ea6780427093$export$a1aa0436beedb1fa)(noIn);
    else $ac0b98ed31ddbb15$export$a3d1b6cb707072ce(noIn);
}
function $ac0b98ed31ddbb15$export$a3d1b6cb707072ce(noIn) {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question)) {
        $ac0b98ed31ddbb15$export$b97bbe8a7805284f();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
        $ac0b98ed31ddbb15$export$b97bbe8a7805284f(noIn);
    }
}
// Start the precedence parser.
// Returns true if this was an arrow function
function $ac0b98ed31ddbb15$var$parseExprOps(noIn) {
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    const wasArrow = $ac0b98ed31ddbb15$export$165911d2b803e372();
    if (wasArrow) return true;
    $ac0b98ed31ddbb15$var$parseExprOp(startTokenIndex, -1, noIn);
    return false;
}
// Parse binary operators with the operator precedence parsing
// algorithm. `left` is the left-hand side of the operator.
// `minPrec` provides context that allows the function to stop and
// defer further parser to one of its callers when it encounters an
// operator that has a lower precedence than the set it is parsing.
function $ac0b98ed31ddbb15$var$parseExprOp(startTokenIndex, minPrec, noIn) {
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) && ((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).PRECEDENCE_MASK) > minPrec && !(0, $485552d236f25875$export$942fa35f3a7c108c)() && ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as) || (0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._satisfies))) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
        (0, $6ae90c8fc78a4682$export$13a289e680c077c1)();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        (0, $19e70491d10f11e8$export$4d00b4f4d9d7a9b3)();
        $ac0b98ed31ddbb15$var$parseExprOp(startTokenIndex, minPrec, noIn);
        return;
    }
    const prec = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).PRECEDENCE_MASK;
    if (prec > 0 && (!noIn || !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in))) {
        if (prec > minPrec) {
            const op = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type;
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            if (op === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).nullishCoalescing) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].nullishStartIndex = startTokenIndex;
            const rhsStartTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
            $ac0b98ed31ddbb15$export$165911d2b803e372();
            // Extend the right operand of this operator if possible.
            $ac0b98ed31ddbb15$var$parseExprOp(rhsStartTokenIndex, op & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_RIGHT_ASSOCIATIVE ? prec - 1 : prec, noIn);
            if (op === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).nullishCoalescing) {
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[startTokenIndex].numNullishCoalesceStarts++;
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].numNullishCoalesceEnds++;
            }
            // Continue with any future operator holding this expression as the left operand.
            $ac0b98ed31ddbb15$var$parseExprOp(startTokenIndex, minPrec, noIn);
        }
    }
}
function $ac0b98ed31ddbb15$export$165911d2b803e372() {
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) && !(0, $e406deb3d43fd58b$export$43bb667a94af025a) && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        (0, $6ae90c8fc78a4682$export$ecfac1712a900e29)();
        return false;
    }
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module) && (0, $19e70491d10f11e8$export$847169391b2516b8)() === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).leftCurlyBrace && !(0, $485552d236f25875$export$a4f1ee8cbd9b31ba)()) {
        $ac0b98ed31ddbb15$var$parseModuleExpression();
        return false;
    }
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_PREFIX) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        $ac0b98ed31ddbb15$export$165911d2b803e372();
        return false;
    }
    const wasArrow = $ac0b98ed31ddbb15$export$dba7f678c228244a();
    if (wasArrow) return true;
    while((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_POSTFIX && !(0, $485552d236f25875$export$1c0919cee6560c3)()){
        // The tokenizer calls everything a preincrement, so make it a postincrement when
        // we see it in that context.
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).preIncDec) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).postIncDec;
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    }
    return false;
}
function $ac0b98ed31ddbb15$export$dba7f678c228244a() {
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    const wasArrow = $ac0b98ed31ddbb15$export$fa61731cf32bc243();
    if (wasArrow) return true;
    $ac0b98ed31ddbb15$var$parseSubscripts(startTokenIndex);
    // If there was any optional chain operation, the start token would be marked
    // as such, so also mark the end now.
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length > startTokenIndex && (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[startTokenIndex].isOptionalChainStart) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isOptionalChainEnd = true;
    return false;
}
function $ac0b98ed31ddbb15$var$parseSubscripts(startTokenIndex, noCalls = false) {
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$7c7ba3c0c5ae1f67)(startTokenIndex, noCalls);
    else $ac0b98ed31ddbb15$export$c2cc03eea353aa42(startTokenIndex, noCalls);
}
function $ac0b98ed31ddbb15$export$c2cc03eea353aa42(startTokenIndex, noCalls = false) {
    const stopState = new $ac0b98ed31ddbb15$export$8cd93656cd4760(false);
    do $ac0b98ed31ddbb15$var$parseSubscript(startTokenIndex, noCalls, stopState);
    while (!stopState.stop && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error);
}
function $ac0b98ed31ddbb15$var$parseSubscript(startTokenIndex, noCalls, stopState) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$f6cd10065188a17f)(startTokenIndex, noCalls, stopState);
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$4eb11794b3b71235)(startTokenIndex, noCalls, stopState);
    else $ac0b98ed31ddbb15$export$31dc8e486c1a1be6(startTokenIndex, noCalls, stopState);
}
function $ac0b98ed31ddbb15$export$31dc8e486c1a1be6(startTokenIndex, noCalls, stopState) {
    if (!noCalls && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).doubleColon)) {
        $ac0b98ed31ddbb15$var$parseNoCallExpr();
        stopState.stop = true;
        // Propagate startTokenIndex so that `a::b?.()` will keep `a` as the first token. We may want
        // to revisit this in the future when fully supporting bind syntax.
        $ac0b98ed31ddbb15$var$parseSubscripts(startTokenIndex, noCalls);
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[startTokenIndex].isOptionalChainStart = true;
        if (noCalls && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) {
            stopState.stop = true;
            return;
        }
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) {
            $ac0b98ed31ddbb15$export$ed9c825e502c46c8();
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
        } else if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) $ac0b98ed31ddbb15$export$970763873d9efa73();
        else $ac0b98ed31ddbb15$var$parseMaybePrivateName();
    } else if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        $ac0b98ed31ddbb15$var$parseMaybePrivateName();
    } else if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        $ac0b98ed31ddbb15$export$ed9c825e502c46c8();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
    } else if (!noCalls && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
        if ($ac0b98ed31ddbb15$export$960e7b0728d0d49e()) {
            // We see "async", but it's possible it's a usage of the name "async". Parse as if it's a
            // function call, and if we see an arrow later, backtrack and re-parse as a parameter list.
            const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
            const asyncStartTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
            const callContextId = (0, $e406deb3d43fd58b$export$d0c215ddd78b3d24)();
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId;
            $ac0b98ed31ddbb15$export$970763873d9efa73();
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId;
            if ($ac0b98ed31ddbb15$var$shouldParseAsyncArrow()) {
                // We hit an arrow, so backtrack and start again parsing function parameters.
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
                stopState.stop = true;
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
                (0, $8a4e0068a7ab0607$export$dd0fc1c64275f2c4)();
                $ac0b98ed31ddbb15$var$parseAsyncArrowFromCallExpression(asyncStartTokenIndex);
            }
        } else {
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
            const callContextId = (0, $e406deb3d43fd58b$export$d0c215ddd78b3d24)();
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId;
            $ac0b98ed31ddbb15$export$970763873d9efa73();
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId;
        }
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote)) // Tagged template expression.
    $ac0b98ed31ddbb15$export$2e2dbd43b49fd373();
    else stopState.stop = true;
}
function $ac0b98ed31ddbb15$export$960e7b0728d0d49e() {
    // This was made less strict than the original version to avoid passing around nodes, but it
    // should be safe to have rare false positives here.
    return (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async && !(0, $485552d236f25875$export$1c0919cee6560c3)();
}
function $ac0b98ed31ddbb15$export$970763873d9efa73() {
    let first = true;
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)) break;
        }
        $ac0b98ed31ddbb15$var$parseExprListItem(false);
    }
}
function $ac0b98ed31ddbb15$var$shouldParseAsyncArrow() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
}
function $ac0b98ed31ddbb15$var$parseAsyncArrowFromCallExpression(startTokenIndex) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$490a9bc22f3cab3f)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$6c11d14a2632a0dc)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
    $ac0b98ed31ddbb15$export$9286d8f9fb90b029(startTokenIndex);
}
// Parse a no-call expression (like argument of `new` or `::` operators).
function $ac0b98ed31ddbb15$var$parseNoCallExpr() {
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    $ac0b98ed31ddbb15$export$fa61731cf32bc243();
    $ac0b98ed31ddbb15$var$parseSubscripts(startTokenIndex, true);
}
function $ac0b98ed31ddbb15$export$fa61731cf32bc243() {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).modulo)) {
        // V8 intrinsic expression. Just parse the identifier, and the function invocation is parsed
        // naturally.
        $ac0b98ed31ddbb15$export$321543c11f6250ad();
        return false;
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxText) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxEmptyText)) {
        $ac0b98ed31ddbb15$export$d1b3e78ad34a47ef();
        return false;
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) && (0, $e406deb3d43fd58b$export$43bb667a94af025a)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxTagStart;
        (0, $6da7dec74ffdbf22$export$7cbe8c53d909e342)();
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        return false;
    }
    const canBeArrow = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).potentialArrowAt === (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
    switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type){
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).slash:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign:
            (0, $19e70491d10f11e8$export$f6864f1ed2347988)();
        // Fall through.
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._super:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).regexp:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bigint:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).decimal:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._null:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._true:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._false:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) {
                // import.meta
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name;
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                $ac0b98ed31ddbb15$export$321543c11f6250ad();
            }
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name:
            {
                const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
                const functionStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
                const contextualKeyword = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword;
                $ac0b98ed31ddbb15$export$321543c11f6250ad();
                if (contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._await) {
                    $ac0b98ed31ddbb15$var$parseAwait();
                    return false;
                } else if (contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) && !(0, $485552d236f25875$export$1c0919cee6560c3)()) {
                    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                    (0, $8a4e0068a7ab0607$export$ba3dc2bd7c065219)(functionStart, false);
                    return false;
                } else if (canBeArrow && contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async && !(0, $485552d236f25875$export$1c0919cee6560c3)() && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
                    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
                    (0, $90ed52daec368086$export$7538cb03fa894c83)(false);
                    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
                    // let foo = async bar => {};
                    $ac0b98ed31ddbb15$export$9286d8f9fb90b029(startTokenIndex);
                    return true;
                } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._do) && !(0, $485552d236f25875$export$1c0919cee6560c3)()) {
                    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                    (0, $8a4e0068a7ab0607$export$4aed668c47d45036)();
                    return false;
                }
                if (canBeArrow && !(0, $485552d236f25875$export$1c0919cee6560c3)() && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow)) {
                    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
                    (0, $90ed52daec368086$export$80e4117797ed03a6)(false);
                    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
                    $ac0b98ed31ddbb15$export$9286d8f9fb90b029(startTokenIndex);
                    return true;
                }
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).Access;
                return false;
            }
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._do:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            (0, $8a4e0068a7ab0607$export$4aed668c47d45036)();
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL:
            {
                const wasArrow = $ac0b98ed31ddbb15$var$parseParenAndDistinguishExpression(canBeArrow);
                return wasArrow;
            }
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            $ac0b98ed31ddbb15$var$parseExprList((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR, true);
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL:
            $ac0b98ed31ddbb15$export$908e61e44ae774e(false, false);
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function:
            $ac0b98ed31ddbb15$var$parseFunctionExpression();
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at:
            (0, $8a4e0068a7ab0607$export$3f4d9519f687227a)();
        // Fall through.
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class:
            (0, $8a4e0068a7ab0607$export$542081d93172af)(false);
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new:
            $ac0b98ed31ddbb15$var$parseNew();
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote:
            $ac0b98ed31ddbb15$export$2e2dbd43b49fd373();
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).doubleColon:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            $ac0b98ed31ddbb15$var$parseNoCallExpr();
            return false;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).hash:
            {
                const code = (0, $19e70491d10f11e8$export$847169391b2516b8)();
                if ((0, $231ac6b14e19c571$export$dc1d1d7d9fdffb8)[code] || code === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).backslash) $ac0b98ed31ddbb15$var$parseMaybePrivateName();
                else (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                // Smart pipeline topic reference.
                return false;
            }
        default:
            (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
            return false;
    }
}
function $ac0b98ed31ddbb15$var$parseMaybePrivateName() {
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).hash);
    $ac0b98ed31ddbb15$export$321543c11f6250ad();
}
function $ac0b98ed31ddbb15$var$parseFunctionExpression() {
    const functionStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
    $ac0b98ed31ddbb15$export$321543c11f6250ad();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) // function.sent
    $ac0b98ed31ddbb15$export$321543c11f6250ad();
    (0, $8a4e0068a7ab0607$export$ba3dc2bd7c065219)(functionStart, false);
}
function $ac0b98ed31ddbb15$export$d1b3e78ad34a47ef() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
}
function $ac0b98ed31ddbb15$export$d5ddb48bead5eb08() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    $ac0b98ed31ddbb15$export$ed9c825e502c46c8();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
}
// Returns true if this was an arrow expression.
function $ac0b98ed31ddbb15$var$parseParenAndDistinguishExpression(canBeArrow) {
    // Assume this is a normal parenthesized expression, but if we see an arrow, we'll bail and
    // start over as a parameter list.
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    let first = true;
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)) break;
        }
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
            (0, $90ed52daec368086$export$9504bd2748b5750c)(false);
            $ac0b98ed31ddbb15$var$parseParenItem();
            break;
        } else $ac0b98ed31ddbb15$export$b97bbe8a7805284f(false, true);
    }
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    if (canBeArrow && $ac0b98ed31ddbb15$var$shouldParseArrow()) {
        const wasArrow = $ac0b98ed31ddbb15$export$92291a002e3a40fe();
        if (wasArrow) {
            // It was an arrow function this whole time, so start over and parse it as params so that we
            // get proper token annotations.
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
            // Don't specify a context ID because arrow functions don't need a context ID.
            (0, $8a4e0068a7ab0607$export$dd0fc1c64275f2c4)();
            $ac0b98ed31ddbb15$export$92291a002e3a40fe();
            $ac0b98ed31ddbb15$export$9286d8f9fb90b029(startTokenIndex);
            if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) {
                // Nevermind! This must have been something that looks very much like an
                // arrow function but where its "parameter list" isn't actually a valid
                // parameter list. Force non-arrow parsing.
                // See https://github.com/alangpierce/sucrase/issues/666 for an example.
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
                $ac0b98ed31ddbb15$var$parseParenAndDistinguishExpression(false);
                return false;
            }
            return true;
        }
    }
    return false;
}
function $ac0b98ed31ddbb15$var$shouldParseArrow() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon) || !(0, $485552d236f25875$export$1c0919cee6560c3)();
}
function $ac0b98ed31ddbb15$export$92291a002e3a40fe() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) return (0, $6ae90c8fc78a4682$export$e20067ab7c70da1d)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) return (0, $406735a56f0f5eb4$export$1ee5238ec4961bad)();
    else return (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
}
function $ac0b98ed31ddbb15$var$parseParenItem() {
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) || (0, $e406deb3d43fd58b$export$92e334f8fe49aa94)) (0, $fa72ea6780427093$export$72bae99899f77e0f)();
}
// New's precedence is slightly tricky. It must allow its argument to
// be a `[]` or dot subscript expression, but not a call — at least,
// not without wrapping it in parentheses. Thus, it uses the noCalls
// argument to parseSubscripts to prevent it from consuming the
// argument list.
function $ac0b98ed31ddbb15$var$parseNew() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new);
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) {
        // new.target
        $ac0b98ed31ddbb15$export$321543c11f6250ad();
        return;
    }
    $ac0b98ed31ddbb15$var$parseNewCallee();
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$3d50348827f45b9a)();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) $ac0b98ed31ddbb15$var$parseExprList((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
}
function $ac0b98ed31ddbb15$var$parseNewCallee() {
    $ac0b98ed31ddbb15$var$parseNoCallExpr();
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot);
}
function $ac0b98ed31ddbb15$export$2e2dbd43b49fd373() {
    // Finish `, read quasi
    (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
    // Finish quasi, read ${
    (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).backQuote) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dollarBraceL);
        $ac0b98ed31ddbb15$export$ed9c825e502c46c8();
        // Finish }, read quasi
        (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
        // Finish quasi, read either ${ or `
        (0, $19e70491d10f11e8$export$e4355ff2fab571ee)();
    }
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
}
function $ac0b98ed31ddbb15$export$908e61e44ae774e(isPattern, isBlockScope) {
    // Attach a context ID to the object open and close brace and each object key.
    const contextId = (0, $e406deb3d43fd58b$export$d0c215ddd78b3d24)();
    let first = true;
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) break;
        }
        let isGenerator = false;
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
            const previousIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
            (0, $90ed52daec368086$export$83bfd0877be8807a)();
            if (isPattern) {
                // Mark role when the only thing being spread over is an identifier.
                if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length === previousIndex + 2) (0, $90ed52daec368086$export$80e4117797ed03a6)(isBlockScope);
                if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) break;
            }
            continue;
        }
        if (!isPattern) isGenerator = (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star);
        if (!isPattern && (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async)) {
            if (isGenerator) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
            $ac0b98ed31ddbb15$export$321543c11f6250ad();
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) ;
            else {
                if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
                    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                    isGenerator = true;
                }
                $ac0b98ed31ddbb15$export$ab65037f9c8fb3d3(contextId);
            }
        } else $ac0b98ed31ddbb15$export$ab65037f9c8fb3d3(contextId);
        $ac0b98ed31ddbb15$var$parseObjPropValue(isPattern, isBlockScope, contextId);
    }
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
}
function $ac0b98ed31ddbb15$var$isGetterOrSetterMethod(isPattern) {
    // We go off of the next and don't bother checking if the node key is actually "get" or "set".
    // This lets us avoid generating a node, and should only make the validation worse.
    return !isPattern && ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string) || // get "string"() {}
    (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num) || // get 1() {}
    (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL) || // get ["string"]() {}
    (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || // get foo() {}
    !!((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_KEYWORD) // get debugger() {}
    );
}
// Returns true if this was a method.
function $ac0b98ed31ddbb15$var$parseObjectMethod(isPattern, objectContextId) {
    // We don't need to worry about modifiers because object methods can't have optional bodies, so
    // the start will never be used.
    const functionStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
        if (isPattern) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        $ac0b98ed31ddbb15$export$9b0b57f9abc43790(functionStart, /* isConstructor */ false);
        return true;
    }
    if ($ac0b98ed31ddbb15$var$isGetterOrSetterMethod(isPattern)) {
        $ac0b98ed31ddbb15$export$ab65037f9c8fb3d3(objectContextId);
        $ac0b98ed31ddbb15$export$9b0b57f9abc43790(functionStart, /* isConstructor */ false);
        return true;
    }
    return false;
}
function $ac0b98ed31ddbb15$var$parseObjectProperty(isPattern, isBlockScope) {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) {
        if (isPattern) (0, $90ed52daec368086$export$867fe1bcec5186c9)(isBlockScope);
        else $ac0b98ed31ddbb15$export$b97bbe8a7805284f(false);
        return;
    }
    // Since there's no colon, we assume this is an object shorthand.
    // If we're in a destructuring, we've now discovered that the key was actually an assignee, so
    // we need to tag it as a declaration with the appropriate scope. Otherwise, we might need to
    // transform it on access, so mark it as a normal object shorthand.
    let identifierRole;
    if (isPattern) {
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth === 0) identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectShorthandTopLevelDeclaration;
        else if (isBlockScope) identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectShorthandBlockScopedDeclaration;
        else identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectShorthandFunctionScopedDeclaration;
    } else identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectShorthand;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = identifierRole;
    // Regardless of whether we know this to be a pattern or if we're in an ambiguous context, allow
    // parsing as if there's a default value.
    (0, $90ed52daec368086$export$867fe1bcec5186c9)(isBlockScope, true);
}
function $ac0b98ed31ddbb15$var$parseObjPropValue(isPattern, isBlockScope, objectContextId) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$f7c2ce498525881a)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$73c225682ce16be1)();
    const wasMethod = $ac0b98ed31ddbb15$var$parseObjectMethod(isPattern, objectContextId);
    if (!wasMethod) $ac0b98ed31ddbb15$var$parseObjectProperty(isPattern, isBlockScope);
}
function $ac0b98ed31ddbb15$export$ab65037f9c8fb3d3(objectContextId) {
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$addd776ef798f4b2)();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = objectContextId;
        $ac0b98ed31ddbb15$export$b97bbe8a7805284f();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = objectContextId;
    } else {
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bigint) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).decimal)) $ac0b98ed31ddbb15$export$fa61731cf32bc243();
        else $ac0b98ed31ddbb15$var$parseMaybePrivateName();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectKey;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = objectContextId;
    }
}
function $ac0b98ed31ddbb15$export$9b0b57f9abc43790(functionStart, isConstructor) {
    const funcContextId = (0, $e406deb3d43fd58b$export$d0c215ddd78b3d24)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    const allowModifiers = isConstructor; // For TypeScript parameter properties
    (0, $8a4e0068a7ab0607$export$dd0fc1c64275f2c4)(allowModifiers, funcContextId);
    $ac0b98ed31ddbb15$export$85b927192bdce5b9(functionStart, funcContextId);
    const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, true));
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
}
function $ac0b98ed31ddbb15$export$9286d8f9fb90b029(startTokenIndex) {
    $ac0b98ed31ddbb15$export$50f85c246417e18(true);
    const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, true));
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
}
function $ac0b98ed31ddbb15$export$85b927192bdce5b9(functionStart, funcContextId = 0) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$3c36bc5140dd8c64)(functionStart, funcContextId);
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$8dd4098a83322b31)(funcContextId);
    else $ac0b98ed31ddbb15$export$50f85c246417e18(false, funcContextId);
}
function $ac0b98ed31ddbb15$export$50f85c246417e18(allowExpression, funcContextId = 0) {
    const isExpression = allowExpression && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    if (isExpression) $ac0b98ed31ddbb15$export$b97bbe8a7805284f();
    else (0, $8a4e0068a7ab0607$export$4aed668c47d45036)(true, funcContextId);
}
// Parses a comma-separated list of expressions, and returns them as
// an array. `close` is the token type that ends the list, and
// `allowEmpty` can be turned on to allow subsequent commas with
// nothing in between them to be parsed as `null` (which is needed
// for array literals).
function $ac0b98ed31ddbb15$var$parseExprList(close, allowEmpty = false) {
    let first = true;
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)(close) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)(close)) break;
        }
        $ac0b98ed31ddbb15$var$parseExprListItem(allowEmpty);
    }
}
function $ac0b98ed31ddbb15$var$parseExprListItem(allowEmpty) {
    if (allowEmpty && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) ;
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
        (0, $90ed52daec368086$export$83bfd0877be8807a)();
        $ac0b98ed31ddbb15$var$parseParenItem();
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question)) // Partial function application proposal.
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    else $ac0b98ed31ddbb15$export$b97bbe8a7805284f(false, true);
}
function $ac0b98ed31ddbb15$export$321543c11f6250ad() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name;
}
// Parses await expression inside async function.
function $ac0b98ed31ddbb15$var$parseAwait() {
    $ac0b98ed31ddbb15$export$165911d2b803e372();
}
// Parses yield expression inside generator.
function $ac0b98ed31ddbb15$var$parseYield() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi) && !(0, $485552d236f25875$export$1c0919cee6560c3)()) {
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star);
        $ac0b98ed31ddbb15$export$b97bbe8a7805284f();
    }
}
// https://github.com/tc39/proposal-js-module-blocks
function $ac0b98ed31ddbb15$var$parseModuleExpression() {
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    // For now, just call parseBlockBody to parse the block. In the future when we
    // implement full support, we'll want to emit scopes and possibly other
    // information.
    (0, $8a4e0068a7ab0607$export$e5110a9b2ab486ee)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
}




function $406735a56f0f5eb4$var$isMaybeDefaultImport(lookahead) {
    return (lookahead.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name || !!(lookahead.type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_KEYWORD)) && lookahead.contextualKeyword !== (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from;
}
function $406735a56f0f5eb4$var$flowParseTypeInitialiser(tok) {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $485552d236f25875$export$3570f33b1a1f3329)(tok || (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    $406735a56f0f5eb4$var$flowParseType();
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $406735a56f0f5eb4$var$flowParsePredicate() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).modulo);
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._checks);
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
        (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    }
}
function $406735a56f0f5eb4$var$flowParseTypeAndPredicateInitialiser() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).modulo)) $406735a56f0f5eb4$var$flowParsePredicate();
    else {
        $406735a56f0f5eb4$var$flowParseType();
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).modulo)) $406735a56f0f5eb4$var$flowParsePredicate();
    }
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $406735a56f0f5eb4$var$flowParseDeclareClass() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $406735a56f0f5eb4$var$flowParseInterfaceish(/* isClass */ true);
}
function $406735a56f0f5eb4$var$flowParseDeclareFunction() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$export$d1d23833c686097a();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    $406735a56f0f5eb4$var$flowParseFunctionTypeParams();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    $406735a56f0f5eb4$var$flowParseTypeAndPredicateInitialiser();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $406735a56f0f5eb4$var$flowParseDeclare() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class)) $406735a56f0f5eb4$var$flowParseDeclareClass();
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function)) $406735a56f0f5eb4$var$flowParseDeclareFunction();
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var)) $406735a56f0f5eb4$var$flowParseDeclareVariable();
    else if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module)) {
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) $406735a56f0f5eb4$var$flowParseDeclareModuleExports();
        else $406735a56f0f5eb4$var$flowParseDeclareModule();
    } else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) $406735a56f0f5eb4$var$flowParseDeclareTypeAlias();
    else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque)) $406735a56f0f5eb4$var$flowParseDeclareOpaqueType();
    else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface)) $406735a56f0f5eb4$var$flowParseDeclareInterface();
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export)) $406735a56f0f5eb4$var$flowParseDeclareExportDeclaration();
    else (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
}
function $406735a56f0f5eb4$var$flowParseDeclareVariable() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $406735a56f0f5eb4$var$flowParseTypeAnnotatableIdentifier();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $406735a56f0f5eb4$var$flowParseDeclareModule() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) (0, $ac0b98ed31ddbb15$export$fa61731cf32bc243)();
    else (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error)if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $8a4e0068a7ab0607$export$532df1d0416e9789)();
    } else (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
}
function $406735a56f0f5eb4$var$flowParseDeclareExportDeclaration() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export);
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default)) {
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class)) // declare export default class ...
        // declare export default function ...
        $406735a56f0f5eb4$var$flowParseDeclare();
        else {
            // declare export default [type];
            $406735a56f0f5eb4$var$flowParseType();
            (0, $485552d236f25875$export$62fa27d385e555f3)();
        }
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var) || // declare export var ...
    (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) || // declare export function ...
    (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class) || // declare export class ...
    (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque) // declare export opaque ..
    ) $406735a56f0f5eb4$var$flowParseDeclare();
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star) || // declare export * from ''
    (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || // declare export {} ...
    (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface) || // declare export interface ...
    (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) || // declare export type ...
    (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque) // declare export opaque type ...
    ) (0, $8a4e0068a7ab0607$export$3d6d7ef9486a61c3)();
    else (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
}
function $406735a56f0f5eb4$var$flowParseDeclareModuleExports() {
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._exports);
    $406735a56f0f5eb4$export$6c833037db1a1e96();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $406735a56f0f5eb4$var$flowParseDeclareTypeAlias() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $406735a56f0f5eb4$var$flowParseTypeAlias();
}
function $406735a56f0f5eb4$var$flowParseDeclareOpaqueType() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $406735a56f0f5eb4$var$flowParseOpaqueType(true);
}
function $406735a56f0f5eb4$var$flowParseDeclareInterface() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $406735a56f0f5eb4$var$flowParseInterfaceish();
}
// Interfaces
function $406735a56f0f5eb4$var$flowParseInterfaceish(isClass = false) {
    $406735a56f0f5eb4$var$flowParseRestrictedIdentifier();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$export$d1d23833c686097a();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends)) do $406735a56f0f5eb4$var$flowParseInterfaceExtends();
    while (!isClass && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma));
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._mixins)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        do $406735a56f0f5eb4$var$flowParseInterfaceExtends();
        while ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma));
    }
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._implements)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        do $406735a56f0f5eb4$var$flowParseInterfaceExtends();
        while ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma));
    }
    $406735a56f0f5eb4$var$flowParseObjectType(isClass, false, isClass);
}
function $406735a56f0f5eb4$var$flowParseInterfaceExtends() {
    $406735a56f0f5eb4$var$flowParseQualifiedTypeIdentifier(false);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation();
}
function $406735a56f0f5eb4$var$flowParseInterface() {
    $406735a56f0f5eb4$var$flowParseInterfaceish();
}
function $406735a56f0f5eb4$var$flowParseRestrictedIdentifier() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
}
function $406735a56f0f5eb4$var$flowParseTypeAlias() {
    $406735a56f0f5eb4$var$flowParseRestrictedIdentifier();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$export$d1d23833c686097a();
    $406735a56f0f5eb4$var$flowParseTypeInitialiser((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq);
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $406735a56f0f5eb4$var$flowParseOpaqueType(declare) {
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type);
    $406735a56f0f5eb4$var$flowParseRestrictedIdentifier();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$export$d1d23833c686097a();
    // Parse the supertype
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $406735a56f0f5eb4$var$flowParseTypeInitialiser((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    if (!declare) $406735a56f0f5eb4$var$flowParseTypeInitialiser((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq);
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $406735a56f0f5eb4$var$flowParseTypeParameter() {
    $406735a56f0f5eb4$export$addd776ef798f4b2();
    $406735a56f0f5eb4$var$flowParseTypeAnnotatableIdentifier();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) $406735a56f0f5eb4$var$flowParseType();
}
function $406735a56f0f5eb4$export$d1d23833c686097a() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    // istanbul ignore else: this condition is already checked at all call sites
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).typeParameterStart)) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    else (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    do {
        $406735a56f0f5eb4$var$flowParseTypeParameter();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan)) (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }while (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan);
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan);
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        $406735a56f0f5eb4$var$flowParseType();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan)) (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).greaterThan);
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $406735a56f0f5eb4$var$flowParseInterfaceType() {
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface);
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends)) do $406735a56f0f5eb4$var$flowParseInterfaceExtends();
    while ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma));
    $406735a56f0f5eb4$var$flowParseObjectType(false, false, false);
}
function $406735a56f0f5eb4$var$flowParseObjectPropertyKey() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) (0, $ac0b98ed31ddbb15$export$fa61731cf32bc243)();
    else (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
}
function $406735a56f0f5eb4$var$flowParseObjectTypeIndexer() {
    // Note: bracketL has already been consumed
    if ((0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon) {
        $406735a56f0f5eb4$var$flowParseObjectPropertyKey();
        $406735a56f0f5eb4$var$flowParseTypeInitialiser();
    } else $406735a56f0f5eb4$var$flowParseType();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
    $406735a56f0f5eb4$var$flowParseTypeInitialiser();
}
function $406735a56f0f5eb4$var$flowParseObjectTypeInternalSlot() {
    // Note: both bracketL have already been consumed
    $406735a56f0f5eb4$var$flowParseObjectPropertyKey();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) $406735a56f0f5eb4$var$flowParseObjectTypeMethodish();
    else {
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
        $406735a56f0f5eb4$var$flowParseTypeInitialiser();
    }
}
function $406735a56f0f5eb4$var$flowParseObjectTypeMethodish() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$export$d1d23833c686097a();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        $406735a56f0f5eb4$var$flowParseFunctionTypeParam();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)) (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) $406735a56f0f5eb4$var$flowParseFunctionTypeParam();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    $406735a56f0f5eb4$var$flowParseTypeInitialiser();
}
function $406735a56f0f5eb4$var$flowParseObjectTypeCallProperty() {
    $406735a56f0f5eb4$var$flowParseObjectTypeMethodish();
}
function $406735a56f0f5eb4$var$flowParseObjectType(allowStatic, allowExact, allowProto) {
    let endDelim;
    if (allowExact && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceBarL)) {
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceBarL);
        endDelim = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceBarR;
    } else {
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
        endDelim = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR;
    }
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)(endDelim) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (allowProto && (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._proto)) {
            const lookahead = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
            if (lookahead !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon && lookahead !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question) {
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                allowStatic = false;
            }
        }
        if (allowStatic && (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._static)) {
            const lookahead = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
            if (lookahead !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon && lookahead !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        }
        $406735a56f0f5eb4$export$addd776ef798f4b2();
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) {
            if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) $406735a56f0f5eb4$var$flowParseObjectTypeInternalSlot();
            else $406735a56f0f5eb4$var$flowParseObjectTypeIndexer();
        } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$var$flowParseObjectTypeCallProperty();
        else {
            if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._get) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._set)) {
                const lookahead = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
                if (lookahead === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name || lookahead === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string || lookahead === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            }
            $406735a56f0f5eb4$var$flowParseObjectTypeProperty();
        }
        $406735a56f0f5eb4$var$flowObjectTypeSemicolon();
    }
    (0, $485552d236f25875$export$3570f33b1a1f3329)(endDelim);
}
function $406735a56f0f5eb4$var$flowParseObjectTypeProperty() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis);
        if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi);
        // Explicit inexact object syntax.
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) return;
        $406735a56f0f5eb4$var$flowParseType();
    } else {
        $406735a56f0f5eb4$var$flowParseObjectPropertyKey();
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) // This is a method property
        $406735a56f0f5eb4$var$flowParseObjectTypeMethodish();
        else {
            (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
            $406735a56f0f5eb4$var$flowParseTypeInitialiser();
        }
    }
}
function $406735a56f0f5eb4$var$flowObjectTypeSemicolon() {
    if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi) && !(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceBarR)) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
}
function $406735a56f0f5eb4$var$flowParseQualifiedTypeIdentifier(initialIdAlreadyParsed) {
    if (!initialIdAlreadyParsed) (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot))(0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
}
function $406735a56f0f5eb4$var$flowParseGenericType() {
    $406735a56f0f5eb4$var$flowParseQualifiedTypeIdentifier(true);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation();
}
function $406735a56f0f5eb4$var$flowParseTypeofType() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof);
    $406735a56f0f5eb4$var$flowParsePrimaryType();
}
function $406735a56f0f5eb4$var$flowParseTupleType() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL);
    // We allow trailing commas
    while((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos < (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).length && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR)){
        $406735a56f0f5eb4$var$flowParseType();
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR)) break;
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
}
function $406735a56f0f5eb4$var$flowParseFunctionTypeParam() {
    const lookahead = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
    if (lookahead === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon || lookahead === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question) {
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
        $406735a56f0f5eb4$var$flowParseTypeInitialiser();
    } else $406735a56f0f5eb4$var$flowParseType();
}
function $406735a56f0f5eb4$var$flowParseFunctionTypeParams() {
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        $406735a56f0f5eb4$var$flowParseFunctionTypeParam();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)) (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) $406735a56f0f5eb4$var$flowParseFunctionTypeParam();
}
// The parsing of types roughly parallels the parsing of expressions, and
// primary types are kind of like primary expressions...they're the
// primitives with which other types are constructed.
function $406735a56f0f5eb4$var$flowParsePrimaryType() {
    let isGroupedType = false;
    const oldNoAnonFunctionType = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType;
    switch((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type){
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name:
            if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface)) {
                $406735a56f0f5eb4$var$flowParseInterfaceType();
                return;
            }
            (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
            $406735a56f0f5eb4$var$flowParseGenericType();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL:
            $406735a56f0f5eb4$var$flowParseObjectType(false, false, false);
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceBarL:
            $406735a56f0f5eb4$var$flowParseObjectType(false, true, false);
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL:
            $406735a56f0f5eb4$var$flowParseTupleType();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan:
            $406735a56f0f5eb4$export$d1d23833c686097a();
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
            $406735a56f0f5eb4$var$flowParseFunctionTypeParams();
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
            $406735a56f0f5eb4$var$flowParseType();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            // Check to see if this is actually a grouped type
            if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
                if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
                    const token = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
                    isGroupedType = token !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question && token !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon;
                } else isGroupedType = true;
            }
            if (isGroupedType) {
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType = false;
                $406735a56f0f5eb4$var$flowParseType();
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType = oldNoAnonFunctionType;
                // A `,` or a `) =>` means this is an anonymous function type
                if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType || !((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow)) {
                    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
                    return;
                } else // Eat a comma if there is one
                (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            }
            $406735a56f0f5eb4$var$flowParseFunctionTypeParams();
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
            $406735a56f0f5eb4$var$flowParseType();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            (0, $ac0b98ed31ddbb15$export$d1b3e78ad34a47ef)();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._true:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._false:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._null:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._this:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._void:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star:
            (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
            return;
        default:
            if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof) {
                $406735a56f0f5eb4$var$flowParseTypeofType();
                return;
            } else if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_KEYWORD) {
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name;
                return;
            }
    }
    (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
}
function $406735a56f0f5eb4$var$flowParsePostfixType() {
    $406735a56f0f5eb4$var$flowParsePrimaryType();
    while(!(0, $485552d236f25875$export$1c0919cee6560c3)() && ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot))){
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot);
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL);
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR)) ;
        else {
            // Indexed access type
            $406735a56f0f5eb4$var$flowParseType();
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR);
        }
    }
}
function $406735a56f0f5eb4$var$flowParsePrefixType() {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question)) $406735a56f0f5eb4$var$flowParsePrefixType();
    else $406735a56f0f5eb4$var$flowParsePostfixType();
}
function $406735a56f0f5eb4$var$flowParseAnonFunctionWithoutParens() {
    $406735a56f0f5eb4$var$flowParsePrefixType();
    if (!(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType && (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow)) $406735a56f0f5eb4$var$flowParseType();
}
function $406735a56f0f5eb4$var$flowParseIntersectionType() {
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseAND);
    $406735a56f0f5eb4$var$flowParseAnonFunctionWithoutParens();
    while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseAND))$406735a56f0f5eb4$var$flowParseAnonFunctionWithoutParens();
}
function $406735a56f0f5eb4$var$flowParseUnionType() {
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseOR);
    $406735a56f0f5eb4$var$flowParseIntersectionType();
    while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bitwiseOR))$406735a56f0f5eb4$var$flowParseIntersectionType();
}
function $406735a56f0f5eb4$var$flowParseType() {
    $406735a56f0f5eb4$var$flowParseUnionType();
}
function $406735a56f0f5eb4$export$6c833037db1a1e96() {
    $406735a56f0f5eb4$var$flowParseTypeInitialiser();
}
function $406735a56f0f5eb4$var$flowParseTypeAnnotatableIdentifier() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $406735a56f0f5eb4$export$6c833037db1a1e96();
}
function $406735a56f0f5eb4$export$addd776ef798f4b2() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).plus) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
    }
}
function $406735a56f0f5eb4$export$8dd4098a83322b31(funcContextId) {
    // For arrow functions, `parseArrow` handles the return type itself.
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $406735a56f0f5eb4$var$flowParseTypeAndPredicateInitialiser();
    (0, $ac0b98ed31ddbb15$export$50f85c246417e18)(false, funcContextId);
}
function $406735a56f0f5eb4$export$4eb11794b3b71235(startTokenIndex, noCalls, stopState) {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) {
        if (noCalls) {
            stopState.stop = true;
            return;
        }
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
        (0, $ac0b98ed31ddbb15$export$970763873d9efa73)();
        return;
    } else if (!noCalls && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
        (0, $ac0b98ed31ddbb15$export$970763873d9efa73)();
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        else return;
    }
    (0, $ac0b98ed31ddbb15$export$31dc8e486c1a1be6)(startTokenIndex, noCalls, stopState);
}
function $406735a56f0f5eb4$export$3d50348827f45b9a() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation();
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
}
function $406735a56f0f5eb4$export$d29f5a1d65cdba9d() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        $406735a56f0f5eb4$var$flowParseInterface();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        return true;
    } else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum)) {
        $406735a56f0f5eb4$var$flowParseEnumDeclaration();
        return true;
    }
    return false;
}
function $406735a56f0f5eb4$export$c6f815d203f26c4f() {
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum)) {
        $406735a56f0f5eb4$var$flowParseEnumDeclaration();
        return true;
    }
    return false;
}
function $406735a56f0f5eb4$export$3b5c354482eb1586(contextualKeyword) {
    if (contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare) {
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export)) {
            const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
            $406735a56f0f5eb4$var$flowParseDeclare();
            (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        }
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
        if (contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface) {
            const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
            $406735a56f0f5eb4$var$flowParseInterface();
            (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        } else if (contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) {
            const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
            $406735a56f0f5eb4$var$flowParseTypeAlias();
            (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        } else if (contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque) {
            const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
            $406735a56f0f5eb4$var$flowParseOpaqueType(false);
            (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        }
    }
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $406735a56f0f5eb4$export$74061750bc0f2203() {
    return (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum);
}
function $406735a56f0f5eb4$export$8a047f67d2009628() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum);
}
function $406735a56f0f5eb4$export$64e87490a40a8a82() {
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            // export type { foo, bar };
            (0, $8a4e0068a7ab0607$export$909d3b50f7924101)();
            (0, $8a4e0068a7ab0607$export$49b6f13e189abea3)();
        } else // export type Foo = Bar;
        $406735a56f0f5eb4$var$flowParseTypeAlias();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    } else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._opaque)) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        // export opaque type Foo = Bar;
        $406735a56f0f5eb4$var$flowParseOpaqueType(false);
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    } else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._interface)) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(1);
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        $406735a56f0f5eb4$var$flowParseInterface();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    } else (0, $8a4e0068a7ab0607$export$68b986de0b252bc8)(true);
}
function $406735a56f0f5eb4$export$563bbc61583bd08() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star;
}
function $406735a56f0f5eb4$export$dc2ba80ebf42d8d6() {
    if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(2);
        (0, $8a4e0068a7ab0607$export$18fb3cb64b956ba0)();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    } else (0, $8a4e0068a7ab0607$export$18fb3cb64b956ba0)();
}
function $406735a56f0f5eb4$export$131557296be11580(hasSuper) {
    if (hasSuper && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation();
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._implements)) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._implements;
        do {
            $406735a56f0f5eb4$var$flowParseRestrictedIdentifier();
            if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) $406735a56f0f5eb4$var$flowParseTypeParameterInstantiation();
        }while ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma));
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    }
}
function $406735a56f0f5eb4$export$73c225682ce16be1() {
    // method shorthand
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        $406735a56f0f5eb4$export$d1d23833c686097a();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    }
}
function $406735a56f0f5eb4$export$a9031cdcb39989e3() {
    const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $406735a56f0f5eb4$export$6c833037db1a1e96();
    (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
}
function $406735a56f0f5eb4$export$2ca2c81ecd0ec221() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
        const lh = (0, $19e70491d10f11e8$export$ef1b94c514fc060a)();
        if ($406735a56f0f5eb4$var$isMaybeDefaultImport(lh) || lh.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL || lh.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    }
}
function $406735a56f0f5eb4$export$217da275bf556fe8() {
    const isTypeKeyword = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._typeof;
    if (isTypeKeyword) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    else (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as) && !(0, $485552d236f25875$export$d1b5391c35999eba)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as)) {
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        if (isTypeKeyword && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && !((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_KEYWORD)) ;
        else // `import {type as foo`
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    } else {
        if (isTypeKeyword && ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || !!((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type & (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).IS_KEYWORD))) // `import {type foo`
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as)) (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    }
}
function $406735a56f0f5eb4$export$e3b9ccf4c3c69613() {
    // Originally this checked if the method is a getter/setter, but if it was, we'd crash soon
    // anyway, so don't try to propagate that information.
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
        $406735a56f0f5eb4$export$d1d23833c686097a();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    }
}
function $406735a56f0f5eb4$export$273b459834534d69() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $406735a56f0f5eb4$export$6c833037db1a1e96();
}
function $406735a56f0f5eb4$export$6c11d14a2632a0dc() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) {
        const oldNoAnonFunctionType = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType = true;
        $406735a56f0f5eb4$export$6c833037db1a1e96();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType = oldNoAnonFunctionType;
    }
}
function $406735a56f0f5eb4$export$abad2599830a7c66(noIn, isWithinParens) {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        let wasArrow = (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) {
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).typeParameterStart;
        } else return wasArrow;
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
        $406735a56f0f5eb4$export$d1d23833c686097a();
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
        wasArrow = (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
        if (wasArrow) return true;
        (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    }
    return (0, $ac0b98ed31ddbb15$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
}
function $406735a56f0f5eb4$export$1ee5238ec4961bad() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        const oldNoAnonFunctionType = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType = true;
        $406735a56f0f5eb4$var$flowParseTypeAndPredicateInitialiser();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).noAnonFunctionType = oldNoAnonFunctionType;
        if ((0, $485552d236f25875$export$1c0919cee6560c3)()) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow)) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    }
    return (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow);
}
function $406735a56f0f5eb4$export$7c7ba3c0c5ae1f67(startTokenIndex, noCalls = false) {
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
        const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
        const wasArrow = $406735a56f0f5eb4$var$parseAsyncArrowWithTypeParameters();
        if (wasArrow && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) return;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
    (0, $ac0b98ed31ddbb15$export$c2cc03eea353aa42)(startTokenIndex, noCalls);
}
// Returns true if there was an arrow function here.
function $406735a56f0f5eb4$var$parseAsyncArrowWithTypeParameters() {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $8a4e0068a7ab0607$export$dd0fc1c64275f2c4)();
    if (!(0, $ac0b98ed31ddbb15$export$92291a002e3a40fe)()) return false;
    (0, $ac0b98ed31ddbb15$export$9286d8f9fb90b029)(startTokenIndex);
    return true;
}
function $406735a56f0f5eb4$var$flowParseEnumDeclaration() {
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._enum);
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum;
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    $406735a56f0f5eb4$var$flowParseEnumBody();
}
function $406735a56f0f5eb4$var$flowParseEnumBody() {
    if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._of)) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    $406735a56f0f5eb4$var$flowParseEnumMembers();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
}
function $406735a56f0f5eb4$var$flowParseEnumMembers() {
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) break;
        $406735a56f0f5eb4$var$flowParseEnumMember();
        if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
    }
}
function $406735a56f0f5eb4$var$flowParseEnumMember() {
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) // Flow enum values are always just one token (a string, number, or boolean literal).
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
}












function $8a4e0068a7ab0607$export$cb09d803724ddba2() {
    $8a4e0068a7ab0607$export$e5110a9b2ab486ee((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eof);
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(0, (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length, true));
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth !== 0) throw new Error(`Invalid scope depth at end of file: ${(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth}`);
    return new (0, $201427b598292105$export$b6afa8811b7e644e)((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens, (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes);
}
function $8a4e0068a7ab0607$export$68b986de0b252bc8(declaration) {
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) {
        if ((0, $406735a56f0f5eb4$export$d29f5a1d65cdba9d)()) return;
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at)) $8a4e0068a7ab0607$export$3f4d9519f687227a();
    $8a4e0068a7ab0607$var$parseStatementContent(declaration);
}
function $8a4e0068a7ab0607$var$parseStatementContent(declaration) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        if ((0, $6ae90c8fc78a4682$export$bd8d07f8ee509b14)()) return;
    }
    const starttype = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type;
    // Most types of statements are recognized by the keyword they
    // start with. Many are trivial to parse, some require a bit of
    // complexity.
    switch(starttype){
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._break:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._continue:
            $8a4e0068a7ab0607$var$parseBreakContinueStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._debugger:
            $8a4e0068a7ab0607$var$parseDebuggerStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._do:
            $8a4e0068a7ab0607$var$parseDoStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._for:
            $8a4e0068a7ab0607$var$parseForStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function:
            if ((0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot) break;
            if (!declaration) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
            $8a4e0068a7ab0607$var$parseFunctionStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class:
            if (!declaration) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
            $8a4e0068a7ab0607$export$542081d93172af(true);
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._if:
            $8a4e0068a7ab0607$var$parseIfStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._return:
            $8a4e0068a7ab0607$var$parseReturnStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._switch:
            $8a4e0068a7ab0607$var$parseSwitchStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._throw:
            $8a4e0068a7ab0607$var$parseThrowStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._try:
            $8a4e0068a7ab0607$var$parseTryStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const:
            if (!declaration) (0, $485552d236f25875$export$4c195bc1a97b6f7f)(); // NOTE: falls through to _var
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var:
            $8a4e0068a7ab0607$export$73f0614724a3919a(starttype !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var);
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._while:
            $8a4e0068a7ab0607$var$parseWhileStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL:
            $8a4e0068a7ab0607$export$4aed668c47d45036();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi:
            $8a4e0068a7ab0607$var$parseEmptyStatement();
            return;
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export:
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import:
            {
                const nextType = (0, $19e70491d10f11e8$export$d2a09c60d66edd78)();
                if (nextType === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL || nextType === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot) break;
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                if (starttype === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import) $8a4e0068a7ab0607$export$532df1d0416e9789();
                else $8a4e0068a7ab0607$export$3d6d7ef9486a61c3();
                return;
            }
        case (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name:
            if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async) {
                const functionStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
                // peek ahead and see if next token is a function
                const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
                (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
                if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) && !(0, $485552d236f25875$export$1c0919cee6560c3)()) {
                    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function);
                    $8a4e0068a7ab0607$export$ba3dc2bd7c065219(functionStart, true);
                    return;
                } else (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            } else if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._using && !(0, $485552d236f25875$export$a4f1ee8cbd9b31ba)() && // Statements like `using[0]` and `using in foo` aren't actual using
            // declarations.
            (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) {
                $8a4e0068a7ab0607$export$73f0614724a3919a(true);
                return;
            } else if ($8a4e0068a7ab0607$var$startsAwaitUsing()) {
                (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._await);
                $8a4e0068a7ab0607$export$73f0614724a3919a(true);
                return;
            }
        default:
            break;
    }
    // If the statement does not start with a statement keyword or a
    // brace, it's an ExpressionStatement or LabeledStatement. We
    // simply start parsing an expression, and afterwards, if the
    // next token is a colon and the expression was a simple
    // Identifier node, we switch to interpreting it as a label.
    const initialTokensLength = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
    let simpleName = null;
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length === initialTokensLength + 1) {
        const token = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1];
        if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) simpleName = token.contextualKeyword;
    }
    if (simpleName == null) {
        (0, $485552d236f25875$export$62fa27d385e555f3)();
        return;
    }
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) $8a4e0068a7ab0607$var$parseLabeledStatement();
    else // This was an identifier, so we might want to handle flow/typescript-specific cases.
    $8a4e0068a7ab0607$var$parseIdentifierStatement(simpleName);
}
/**
 * Determine if we're positioned at an `await using` declaration.
 *
 * Note that this can happen either in place of a regular variable declaration
 * or in a loop body, and in both places, there are similar-looking cases where
 * we need to return false.
 *
 * Examples returning true:
 * await using foo = bar();
 * for (await using a of b) {}
 *
 * Examples returning false:
 * await using
 * await using + 1
 * await using instanceof T
 * for (await using;;) {}
 *
 * For now, we early return if we don't see `await`, then do a simple
 * backtracking-based lookahead for the `using` and identifier tokens. In the
 * future, this could be optimized with a character-based approach.
 */ function $8a4e0068a7ab0607$var$startsAwaitUsing() {
    if (!(0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._await)) return false;
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    // await
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if (!(0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._using) || (0, $485552d236f25875$export$942fa35f3a7c108c)()) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
    // using
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || (0, $485552d236f25875$export$942fa35f3a7c108c)()) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return true;
}
function $8a4e0068a7ab0607$export$3f4d9519f687227a() {
    while((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at))$8a4e0068a7ab0607$var$parseDecorator();
}
function $8a4e0068a7ab0607$var$parseDecorator() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
        (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    } else {
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        while((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot))(0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        $8a4e0068a7ab0607$var$parseMaybeDecoratorArguments();
    }
}
function $8a4e0068a7ab0607$var$parseMaybeDecoratorArguments() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$fd0439ea9a1ac1ea)();
    else $8a4e0068a7ab0607$export$50c128b10ac5ea5b();
}
function $8a4e0068a7ab0607$export$50c128b10ac5ea5b() {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) (0, $ac0b98ed31ddbb15$export$970763873d9efa73)();
}
function $8a4e0068a7ab0607$var$parseBreakContinueStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if (!(0, $485552d236f25875$export$12d132b6e81066e4)()) {
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        (0, $485552d236f25875$export$62fa27d385e555f3)();
    }
}
function $8a4e0068a7ab0607$var$parseDebuggerStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $8a4e0068a7ab0607$var$parseDoStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $8a4e0068a7ab0607$export$68b986de0b252bc8(false);
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._while);
    (0, $ac0b98ed31ddbb15$export$d5ddb48bead5eb08)();
    (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi);
}
function $8a4e0068a7ab0607$var$parseForStatement() {
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    $8a4e0068a7ab0607$var$parseAmbiguousForStatement();
    const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, false));
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
}
/**
 * Determine if this token is a `using` declaration (explicit resource
 * management) as part of a loop.
 * https://github.com/tc39/proposal-explicit-resource-management
 */ function $8a4e0068a7ab0607$var$isUsingInLoop() {
    if (!(0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._using)) return false;
    // This must be `for (using of`, where `using` is the name of the loop
    // variable.
    if ((0, $485552d236f25875$export$d1b5391c35999eba)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._of)) return false;
    return true;
}
// Disambiguating between a `for` and a `for`/`in` or `for`/`of`
// loop is non-trivial. Basically, we have to parse the init `var`
// statement or expression, disallowing the `in` operator (see
// the second parameter to `parseExpression`), and then check
// whether the next token is `in` or `of`. When there is no init
// part (semicolon immediately after the opening parenthesis), it
// is a regular `for` loop.
function $8a4e0068a7ab0607$var$parseAmbiguousForStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    let forAwait = false;
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._await)) {
        forAwait = true;
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    }
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) {
        if (forAwait) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
        $8a4e0068a7ab0607$var$parseFor();
        return;
    }
    const isAwaitUsing = $8a4e0068a7ab0607$var$startsAwaitUsing();
    if (isAwaitUsing || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const) || $8a4e0068a7ab0607$var$isUsingInLoop()) {
        if (isAwaitUsing) (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._await);
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        $8a4e0068a7ab0607$var$parseVar(true, (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var);
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._of)) {
            $8a4e0068a7ab0607$var$parseForIn(forAwait);
            return;
        }
        $8a4e0068a7ab0607$var$parseFor();
        return;
    }
    (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)(true);
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._in) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._of)) {
        $8a4e0068a7ab0607$var$parseForIn(forAwait);
        return;
    }
    if (forAwait) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    $8a4e0068a7ab0607$var$parseFor();
}
function $8a4e0068a7ab0607$var$parseFunctionStatement() {
    const functionStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $8a4e0068a7ab0607$export$ba3dc2bd7c065219(functionStart, true);
}
function $8a4e0068a7ab0607$var$parseIfStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $ac0b98ed31ddbb15$export$d5ddb48bead5eb08)();
    $8a4e0068a7ab0607$export$68b986de0b252bc8(false);
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._else)) $8a4e0068a7ab0607$export$68b986de0b252bc8(false);
}
function $8a4e0068a7ab0607$var$parseReturnStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    // In `return` (and `break`/`continue`), the keywords with
    // optional arguments, we eagerly look for a semicolon or the
    // possibility to insert one.
    if (!(0, $485552d236f25875$export$12d132b6e81066e4)()) {
        (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
        (0, $485552d236f25875$export$62fa27d385e555f3)();
    }
}
function $8a4e0068a7ab0607$var$parseSwitchStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $ac0b98ed31ddbb15$export$d5ddb48bead5eb08)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    // Don't bother validation; just go through any sequence of cases, defaults, and statements.
    while(!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error)if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._case) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default)) {
        const isCase = (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._case);
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        if (isCase) (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
        (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
    } else $8a4e0068a7ab0607$export$68b986de0b252bc8(true);
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)(); // Closing brace
    const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, false));
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
}
function $8a4e0068a7ab0607$var$parseThrowStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $8a4e0068a7ab0607$var$parseCatchClauseParam() {
    (0, $90ed52daec368086$export$e1f90e6766854abd)(true);
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$e4623eb563192e0f)();
}
function $8a4e0068a7ab0607$var$parseTryStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $8a4e0068a7ab0607$export$4aed668c47d45036();
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._catch)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        let catchBindingStartTokenIndex = null;
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
            catchBindingStartTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
            $8a4e0068a7ab0607$var$parseCatchClauseParam();
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
        }
        $8a4e0068a7ab0607$export$4aed668c47d45036();
        if (catchBindingStartTokenIndex != null) {
            // We need a special scope for the catch binding which includes the binding itself and the
            // catch block.
            const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(catchBindingStartTokenIndex, endTokenIndex, false));
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
        }
    }
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._finally)) $8a4e0068a7ab0607$export$4aed668c47d45036();
}
function $8a4e0068a7ab0607$export$73f0614724a3919a(isBlockScope) {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    $8a4e0068a7ab0607$var$parseVar(false, isBlockScope);
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $8a4e0068a7ab0607$var$parseWhileStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $ac0b98ed31ddbb15$export$d5ddb48bead5eb08)();
    $8a4e0068a7ab0607$export$68b986de0b252bc8(false);
}
function $8a4e0068a7ab0607$var$parseEmptyStatement() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
}
function $8a4e0068a7ab0607$var$parseLabeledStatement() {
    $8a4e0068a7ab0607$export$68b986de0b252bc8(true);
}
/**
 * Parse a statement starting with an identifier of the given name. Subclasses match on the name
 * to handle statements like "declare".
 */ function $8a4e0068a7ab0607$var$parseIdentifierStatement(contextualKeyword) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$a642c15f5070c816)(contextualKeyword);
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$3b5c354482eb1586)(contextualKeyword);
    else (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $8a4e0068a7ab0607$export$4aed668c47d45036(isFunctionScope = false, contextId = 0) {
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    if (contextId) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    $8a4e0068a7ab0607$export$e5110a9b2ab486ee((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
    if (contextId) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, isFunctionScope));
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
}
function $8a4e0068a7ab0607$export$e5110a9b2ab486ee(end) {
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)(end) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error)$8a4e0068a7ab0607$export$68b986de0b252bc8(true);
}
// Parse a regular `for` loop. The disambiguation code in
// `parseStatement` will already have parsed the init statement or
// expression.
function $8a4e0068a7ab0607$var$parseFor() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi);
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi);
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)) (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    $8a4e0068a7ab0607$export$68b986de0b252bc8(false);
}
// Parse a `for`/`in` and `for`/`of` loop, which are almost
// same from parser's perspective.
function $8a4e0068a7ab0607$var$parseForIn(forAwait) {
    if (forAwait) (0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._of);
    else (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $ac0b98ed31ddbb15$export$ed9c825e502c46c8)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    $8a4e0068a7ab0607$export$68b986de0b252bc8(false);
}
// Parse a list of variable declarations.
function $8a4e0068a7ab0607$var$parseVar(isFor, isBlockScope) {
    while(true){
        $8a4e0068a7ab0607$var$parseVarHead(isBlockScope);
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
            const eqIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1;
            (0, $ac0b98ed31ddbb15$export$b97bbe8a7805284f)(isFor);
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[eqIndex].rhsEndIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
        }
        if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) break;
    }
}
function $8a4e0068a7ab0607$var$parseVarHead(isBlockScope) {
    (0, $90ed52daec368086$export$e1f90e6766854abd)(isBlockScope);
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$41c8703baf1bbf07)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$273b459834534d69)();
}
function $8a4e0068a7ab0607$export$ba3dc2bd7c065219(functionStart, isStatement, optionalId = false) {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    if (isStatement && !optionalId && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && !(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._yield)) (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
    let nameScopeStartTokenIndex = null;
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
        // Expression-style functions should limit their name's scope to the function body, so we make
        // a new function scope to enforce that.
        if (!isStatement) {
            nameScopeStartTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
        }
        (0, $90ed52daec368086$export$7538cb03fa894c83)(false);
    }
    const startTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    $8a4e0068a7ab0607$export$dd0fc1c64275f2c4();
    (0, $ac0b98ed31ddbb15$export$85b927192bdce5b9)(functionStart);
    const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    // In addition to the block scope of the function body, we need a separate function-style scope
    // that includes the params.
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, true));
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
    if (nameScopeStartTokenIndex !== null) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(nameScopeStartTokenIndex, endTokenIndex, true));
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
    }
}
function $8a4e0068a7ab0607$export$dd0fc1c64275f2c4(allowModifiers = false, funcContextId = 0) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$ba34d58430377f94)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$e3b9ccf4c3c69613)();
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
    if (funcContextId) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = funcContextId;
    (0, $90ed52daec368086$export$befa6d966a25698e)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR, false, false, allowModifiers, funcContextId);
    if (funcContextId) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = funcContextId;
}
function $8a4e0068a7ab0607$export$542081d93172af(isStatement, optionalId = false) {
    // Put a context ID on the class keyword, the open-brace, and the close-brace, so that later
    // code can easily navigate to meaningful points on the class.
    const contextId = (0, $e406deb3d43fd58b$export$d0c215ddd78b3d24)();
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].isExpression = !isStatement;
    // Like with functions, we declare a special "name scope" from the start of the name to the end
    // of the class, but only with expression-style classes, to represent the fact that the name is
    // available to the body of the class but not an outer declaration.
    let nameScopeStartTokenIndex = null;
    if (!isStatement) {
        nameScopeStartTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth++;
    }
    $8a4e0068a7ab0607$var$parseClassId(isStatement, optionalId);
    $8a4e0068a7ab0607$var$parseClassSuper();
    const openBraceIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    $8a4e0068a7ab0607$var$parseClassBody(contextId);
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) return;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[openBraceIndex].contextId = contextId;
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    if (nameScopeStartTokenIndex !== null) {
        const endTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopes.push(new (0, $93c505350c167057$export$775b6bb06e53a214)(nameScopeStartTokenIndex, endTokenIndex, false));
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).scopeDepth--;
    }
}
function $8a4e0068a7ab0607$var$isClassProperty() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bang) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon);
}
function $8a4e0068a7ab0607$var$isClassMethod() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan);
}
function $8a4e0068a7ab0607$var$parseClassBody(classContextId) {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) continue;
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at)) {
            $8a4e0068a7ab0607$var$parseDecorator();
            continue;
        }
        const memberStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
        $8a4e0068a7ab0607$var$parseClassMember(memberStart, classContextId);
    }
}
function $8a4e0068a7ab0607$var$parseClassMember(memberStart, classContextId) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$77616e6d401f584a)([
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._declare,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._public,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._protected,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._private,
        (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._override
    ]);
    let isStatic = false;
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._static) {
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)(); // eats 'static'
        if ($8a4e0068a7ab0607$var$isClassMethod()) {
            $8a4e0068a7ab0607$var$parseClassMethod(memberStart, /* isConstructor */ false);
            return;
        } else if ($8a4e0068a7ab0607$var$isClassProperty()) {
            $8a4e0068a7ab0607$export$8c8d5281ed4948bc();
            return;
        }
        // otherwise something static
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._static;
        isStatic = true;
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            // This is a static block. Mark the word "static" with the class context ID for class element
            // detection and parse as a regular block.
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].contextId = classContextId;
            $8a4e0068a7ab0607$export$4aed668c47d45036();
            return;
        }
    }
    $8a4e0068a7ab0607$var$parseClassMemberWithIsStatic(memberStart, isStatic, classContextId);
}
function $8a4e0068a7ab0607$var$parseClassMemberWithIsStatic(memberStart, isStatic, classContextId) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        if ((0, $6ae90c8fc78a4682$export$9d02a6e20851f734)(isStatic)) return;
    }
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
        // a generator
        $8a4e0068a7ab0607$export$763528f37ffee534(classContextId);
        $8a4e0068a7ab0607$var$parseClassMethod(memberStart, /* isConstructor */ false);
        return;
    }
    // Get the identifier name so we can tell if it's actually a keyword like "async", "get", or
    // "set".
    $8a4e0068a7ab0607$export$763528f37ffee534(classContextId);
    let isConstructor = false;
    const token = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1];
    // We allow "constructor" as either an identifier or a string.
    if (token.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._constructor) isConstructor = true;
    $8a4e0068a7ab0607$export$be741144f2438eed();
    if ($8a4e0068a7ab0607$var$isClassMethod()) $8a4e0068a7ab0607$var$parseClassMethod(memberStart, isConstructor);
    else if ($8a4e0068a7ab0607$var$isClassProperty()) $8a4e0068a7ab0607$export$8c8d5281ed4948bc();
    else if (token.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async && !(0, $485552d236f25875$export$12d132b6e81066e4)()) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._async;
        // an async method
        const isGenerator = (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star);
        if (isGenerator) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        // The so-called parsed name would have been "async": get the real name.
        $8a4e0068a7ab0607$export$763528f37ffee534(classContextId);
        $8a4e0068a7ab0607$export$be741144f2438eed();
        $8a4e0068a7ab0607$var$parseClassMethod(memberStart, false);
    } else if ((token.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._get || token.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._set) && !((0, $485552d236f25875$export$12d132b6e81066e4)() && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star))) {
        if (token.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._get) (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._get;
        else (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._set;
        // `get\n*` is an uninitialized property named 'get' followed by a generator.
        // a getter or setter
        // The so-called parsed name would have been "get/set": get the real name.
        $8a4e0068a7ab0607$export$763528f37ffee534(classContextId);
        $8a4e0068a7ab0607$var$parseClassMethod(memberStart, /* isConstructor */ false);
    } else if (token.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._accessor && !(0, $485552d236f25875$export$12d132b6e81066e4)()) {
        $8a4e0068a7ab0607$export$763528f37ffee534(classContextId);
        $8a4e0068a7ab0607$export$8c8d5281ed4948bc();
    } else if ((0, $485552d236f25875$export$12d132b6e81066e4)()) // an uninitialized class property (due to ASI, since we don't otherwise recognize the next token)
    $8a4e0068a7ab0607$export$8c8d5281ed4948bc();
    else (0, $485552d236f25875$export$4c195bc1a97b6f7f)();
}
function $8a4e0068a7ab0607$var$parseClassMethod(functionStart, isConstructor) {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$827faab4e65d5897)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) {
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) (0, $406735a56f0f5eb4$export$d1d23833c686097a)();
    }
    (0, $ac0b98ed31ddbb15$export$9b0b57f9abc43790)(functionStart, isConstructor);
}
function $8a4e0068a7ab0607$export$763528f37ffee534(classContextId) {
    (0, $ac0b98ed31ddbb15$export$ab65037f9c8fb3d3)(classContextId);
}
function $8a4e0068a7ab0607$export$be741144f2438eed() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        const oldIsType = (0, $19e70491d10f11e8$export$218282073d8f0a8b)(0);
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).question);
        (0, $19e70491d10f11e8$export$89977347ddb984a8)(oldIsType);
    }
}
function $8a4e0068a7ab0607$export$8c8d5281ed4948bc() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        (0, $19e70491d10f11e8$export$cb3e65614411a57c)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bang);
        (0, $6ae90c8fc78a4682$export$e4623eb563192e0f)();
    } else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) {
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) (0, $406735a56f0f5eb4$export$6c833037db1a1e96)();
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
        const equalsTokenIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $ac0b98ed31ddbb15$export$b97bbe8a7805284f)();
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[equalsTokenIndex].rhsEndIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
    }
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $8a4e0068a7ab0607$var$parseClassId(isStatement, optionalId = false) {
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) && (!isStatement || optionalId) && (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._implements)) return;
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) (0, $90ed52daec368086$export$7538cb03fa894c83)(true);
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$827faab4e65d5897)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) {
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) (0, $406735a56f0f5eb4$export$d1d23833c686097a)();
    }
}
// Returns true if there was a superclass.
function $8a4e0068a7ab0607$var$parseClassSuper() {
    let hasSuper = false;
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends)) {
        (0, $ac0b98ed31ddbb15$export$dba7f678c228244a)();
        hasSuper = true;
    } else hasSuper = false;
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$ea9d02c53bf69095)(hasSuper);
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$131557296be11580)(hasSuper);
}
function $8a4e0068a7ab0607$export$3d6d7ef9486a61c3() {
    const exportIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1;
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        if ((0, $6ae90c8fc78a4682$export$6714566ca8db2f39)()) return;
    }
    // export * from '...'
    if ($8a4e0068a7ab0607$var$shouldParseExportStar()) $8a4e0068a7ab0607$var$parseExportStar();
    else if ($8a4e0068a7ab0607$var$isExportDefaultSpecifier()) {
        // export default from
        (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star) {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star);
            (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as);
            (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
        } else $8a4e0068a7ab0607$var$parseExportSpecifiersMaybe();
        $8a4e0068a7ab0607$export$49b6f13e189abea3();
    } else if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default)) // export default ...
    $8a4e0068a7ab0607$var$parseExportDefaultExpression();
    else if ($8a4e0068a7ab0607$var$shouldParseExportDeclaration()) $8a4e0068a7ab0607$var$parseExportDeclaration();
    else {
        // export { x, y as z } [from '...']
        $8a4e0068a7ab0607$export$909d3b50f7924101();
        $8a4e0068a7ab0607$export$49b6f13e189abea3();
    }
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[exportIndex].rhsEndIndex = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length;
}
function $8a4e0068a7ab0607$var$parseExportDefaultExpression() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        if ((0, $6ae90c8fc78a4682$export$95d54e02ae7a0197)()) return;
    }
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) {
        if ((0, $406735a56f0f5eb4$export$c6f815d203f26c4f)()) return;
    }
    const functionStart = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).start;
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function)) $8a4e0068a7ab0607$export$ba3dc2bd7c065219(functionStart, true, true);
    else if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) {
        // async function declaration
        (0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async);
        (0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function);
        $8a4e0068a7ab0607$export$ba3dc2bd7c065219(functionStart, true, true);
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class)) $8a4e0068a7ab0607$export$542081d93172af(true, true);
    else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at)) {
        $8a4e0068a7ab0607$export$3f4d9519f687227a();
        $8a4e0068a7ab0607$export$542081d93172af(true, true);
    } else {
        (0, $ac0b98ed31ddbb15$export$b97bbe8a7805284f)();
        (0, $485552d236f25875$export$62fa27d385e555f3)();
    }
}
function $8a4e0068a7ab0607$var$parseExportDeclaration() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) (0, $6ae90c8fc78a4682$export$b29e6741ccf6da0a)();
    else if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$64e87490a40a8a82)();
    else $8a4e0068a7ab0607$export$68b986de0b252bc8(true);
}
function $8a4e0068a7ab0607$var$isExportDefaultSpecifier() {
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) && (0, $6ae90c8fc78a4682$export$5df75dadb7a629b6)()) return false;
    else if ((0, $e406deb3d43fd58b$export$92e334f8fe49aa94) && (0, $406735a56f0f5eb4$export$8a047f67d2009628)()) return false;
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) return (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).contextualKeyword !== (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async;
    if (!(0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default)) return false;
    const _next = (0, $19e70491d10f11e8$export$1678d89ce52f4a6)();
    const lookahead = (0, $19e70491d10f11e8$export$ef1b94c514fc060a)();
    const hasFrom = lookahead.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && lookahead.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from;
    if (lookahead.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) return true;
    // lookahead again when `export default from` is seen
    if (hasFrom) {
        const nextAfterFrom = (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt((0, $19e70491d10f11e8$export$b8d8ba48247ea123)(_next + 4));
        return nextAfterFrom === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).quotationMark || nextAfterFrom === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).apostrophe;
    }
    return false;
}
function $8a4e0068a7ab0607$var$parseExportSpecifiersMaybe() {
    if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) $8a4e0068a7ab0607$export$909d3b50f7924101();
}
function $8a4e0068a7ab0607$export$49b6f13e189abea3() {
    if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) {
        (0, $ac0b98ed31ddbb15$export$fa61731cf32bc243)();
        $8a4e0068a7ab0607$var$maybeParseImportAttributes();
    }
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
function $8a4e0068a7ab0607$var$shouldParseExportStar() {
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) return (0, $406735a56f0f5eb4$export$563bbc61583bd08)();
    else return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star);
}
function $8a4e0068a7ab0607$var$parseExportStar() {
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$dc2ba80ebf42d8d6)();
    else $8a4e0068a7ab0607$export$18fb3cb64b956ba0();
}
function $8a4e0068a7ab0607$export$18fb3cb64b956ba0() {
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star);
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as)) $8a4e0068a7ab0607$var$parseExportNamespace();
    else $8a4e0068a7ab0607$export$49b6f13e189abea3();
}
function $8a4e0068a7ab0607$var$parseExportNamespace() {
    (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._as;
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    $8a4e0068a7ab0607$var$parseExportSpecifiersMaybe();
    $8a4e0068a7ab0607$export$49b6f13e189abea3();
}
function $8a4e0068a7ab0607$var$shouldParseExportDeclaration() {
    return (0, $e406deb3d43fd58b$export$757c2735689d2de8) && (0, $6ae90c8fc78a4682$export$5df75dadb7a629b6)() || (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) && (0, $406735a56f0f5eb4$export$74061750bc0f2203)() || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function || (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async) || (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at);
}
function $8a4e0068a7ab0607$export$909d3b50f7924101() {
    let first = true;
    // export { x, y as z } [from '...']
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) break;
        }
        $8a4e0068a7ab0607$var$parseExportSpecifier();
    }
}
function $8a4e0068a7ab0607$var$parseExportSpecifier() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        (0, $6ae90c8fc78a4682$export$7994f3b86b6c7d1e)();
        return;
    }
    (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
    (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ExportAccess;
    if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as)) (0, $ac0b98ed31ddbb15$export$321543c11f6250ad)();
}
/**
 * Starting at the `module` token in an import, determine if it was truly an
 * import reflection token or just looks like one.
 *
 * Returns true for:
 * import module foo from "foo";
 * import module from from "foo";
 *
 * Returns false for:
 * import module from "foo";
 * import module, {bar} from "foo";
 */ function $8a4e0068a7ab0607$var$isImportReflection() {
    const snapshot = (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).snapshot();
    (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module);
    if ((0, $485552d236f25875$export$b8f8f7fffeb6fb36)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) {
        if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) {
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return true;
        } else {
            (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return false;
        }
    } else if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    } else {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return true;
    }
}
/**
 * Eat the "module" token from the import reflection proposal.
 * https://github.com/tc39/proposal-import-reflection
 */ function $8a4e0068a7ab0607$var$parseMaybeImportReflection() {
    // isImportReflection does snapshot/restore, so only run it if we see the word
    // "module".
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module) && $8a4e0068a7ab0607$var$isImportReflection()) (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
}
function $8a4e0068a7ab0607$export$532df1d0416e9789() {
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) && (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && (0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq) {
        (0, $6ae90c8fc78a4682$export$bb14276cd4f56f44)();
        return;
    }
    if ((0, $e406deb3d43fd58b$export$757c2735689d2de8) && (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
        const lookahead = (0, $19e70491d10f11e8$export$ef1b94c514fc060a)();
        if (lookahead.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && lookahead.contextualKeyword !== (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from) {
            // One of these `import type` cases:
            // import type T = require('T');
            // import type A from 'A';
            (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type);
            if ((0, $19e70491d10f11e8$export$d2a09c60d66edd78)() === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq) {
                (0, $6ae90c8fc78a4682$export$bb14276cd4f56f44)();
                return;
            }
        // If this is an `import type...from` statement, then we already ate the
        // type token, so proceed to the regular import parser.
        } else if (lookahead.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star || lookahead.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) // One of these `import type` cases, in which case we can eat the type token
        // and proceed as normal:
        // import type * as A from 'A';
        // import type {a} from 'A';
        (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type);
    // Otherwise, we are importing the name "type".
    }
    // import '...'
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) (0, $ac0b98ed31ddbb15$export$fa61731cf32bc243)();
    else {
        $8a4e0068a7ab0607$var$parseMaybeImportReflection();
        $8a4e0068a7ab0607$var$parseImportSpecifiers();
        (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from);
        (0, $ac0b98ed31ddbb15$export$fa61731cf32bc243)();
    }
    $8a4e0068a7ab0607$var$maybeParseImportAttributes();
    (0, $485552d236f25875$export$62fa27d385e555f3)();
}
// eslint-disable-next-line no-unused-vars
function $8a4e0068a7ab0607$var$shouldParseDefaultImport() {
    return (0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
}
function $8a4e0068a7ab0607$var$parseImportSpecifierLocal() {
    (0, $90ed52daec368086$export$cba413304e86fc0d)();
}
// Parses a comma-separated list of module imports.
function $8a4e0068a7ab0607$var$parseImportSpecifiers() {
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) (0, $406735a56f0f5eb4$export$2ca2c81ecd0ec221)();
    let first = true;
    if ($8a4e0068a7ab0607$var$shouldParseDefaultImport()) {
        // import defaultObj, { x, y as z } from '...'
        $8a4e0068a7ab0607$var$parseImportSpecifierLocal();
        if (!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) return;
    }
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $485552d236f25875$export$b8ead11dfed96f19)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as);
        $8a4e0068a7ab0607$var$parseImportSpecifierLocal();
        return;
    }
    (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
    while(!(0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) && !(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            // Detect an attempt to deep destructure
            if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon)) (0, $485552d236f25875$export$4c195bc1a97b6f7f)("ES2015 named imports do not destructure. Use another statement for destructuring after the import.");
            (0, $485552d236f25875$export$3570f33b1a1f3329)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma);
            if ((0, $19e70491d10f11e8$export$3106cdec37e36f77)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) break;
        }
        $8a4e0068a7ab0607$var$parseImportSpecifier();
    }
}
function $8a4e0068a7ab0607$var$parseImportSpecifier() {
    if (0, $e406deb3d43fd58b$export$757c2735689d2de8) {
        (0, $6ae90c8fc78a4682$export$718ece2f88417ffd)();
        return;
    }
    if (0, $e406deb3d43fd58b$export$92e334f8fe49aa94) {
        (0, $406735a56f0f5eb4$export$217da275bf556fe8)();
        return;
    }
    (0, $90ed52daec368086$export$cba413304e86fc0d)();
    if ((0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._as)) {
        (0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens[(0, $e406deb3d43fd58b$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportAccess;
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $90ed52daec368086$export$cba413304e86fc0d)();
    }
}
/**
 * Parse import attributes like `with {type: "json"}`, or the legacy form
 * `assert {type: "json"}`.
 *
 * Import attributes technically have their own syntax, but are always parseable
 * as a plain JS object, so just do that for simplicity.
 */ function $8a4e0068a7ab0607$var$maybeParseImportAttributes() {
    if ((0, $19e70491d10f11e8$export$4659b591c19bdf3d)((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._with) || (0, $485552d236f25875$export$d382681f238736f1)((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._assert) && !(0, $485552d236f25875$export$942fa35f3a7c108c)()) {
        (0, $19e70491d10f11e8$export$48cfd1e771a65c4f)();
        (0, $ac0b98ed31ddbb15$export$908e61e44ae774e)(false, false);
    }
}


function $5185ae49f7d9981e$export$f1c553d4f1a2351() {
    // If enabled, skip leading hashbang line.
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).pos === 0 && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(0) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).numberSign && (0, $e406deb3d43fd58b$export$b7e3ae3d7c15e42e).charCodeAt(1) === (0, $bc8ae66faf70da33$export$dbe39bbf2ade60d5).exclamationMark) (0, $19e70491d10f11e8$export$37e131e7c1112aff)(2);
    (0, $19e70491d10f11e8$export$be17f8ab6696df13)();
    return (0, $8a4e0068a7ab0607$export$cb09d803724ddba2)();
}


class $201427b598292105$export$b6afa8811b7e644e {
    constructor(tokens, scopes){
        this.tokens = tokens;
        this.scopes = scopes;
    }
}
function $201427b598292105$export$98e6a39c04603d36(input, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled) {
    if (isFlowEnabled && isTypeScriptEnabled) throw new Error("Cannot combine flow and typescript plugins.");
    (0, $e406deb3d43fd58b$export$84bb9899435eeb61)(input, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled);
    const result = (0, $5185ae49f7d9981e$export$f1c553d4f1a2351)();
    if ((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error) throw (0, $e406deb3d43fd58b$export$2ca6ff5cad32970a)((0, $e406deb3d43fd58b$export$ca000e230c0caa3e).error);
    return result;
}




function $a55849c89b8d74ae$export$2e2bcd8739ae039(tokens) {
    let index = tokens.currentIndex();
    let depth = 0;
    const startToken = tokens.currentToken();
    do {
        const token = tokens.tokens[index];
        if (token.isOptionalChainStart) depth++;
        if (token.isOptionalChainEnd) depth--;
        depth += token.numNullishCoalesceStarts;
        depth -= token.numNullishCoalesceEnds;
        if (token.contextualKeyword === (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._await && token.identifierRole == null && token.scopeDepth === startToken.scopeDepth) return true;
        index += 1;
    }while (depth > 0 && index < tokens.tokens.length);
    return false;
}


class $8e1a59465c201e5d$export$2e2bcd8739ae039 {
    __init() {
        this.resultCode = "";
    }
    // Array mapping input token index to optional string index position in the
    // output code.
    __init2() {
        this.resultMappings = new Array(this.tokens.length);
    }
    __init3() {
        this.tokenIndex = 0;
    }
    constructor(code, tokens, isFlowEnabled, disableESTransforms, helperManager){
        this.code = code;
        this.tokens = tokens;
        this.isFlowEnabled = isFlowEnabled;
        this.disableESTransforms = disableESTransforms;
        this.helperManager = helperManager;
        $8e1a59465c201e5d$export$2e2bcd8739ae039.prototype.__init.call(this);
        $8e1a59465c201e5d$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $8e1a59465c201e5d$export$2e2bcd8739ae039.prototype.__init3.call(this);
    }
    /**
   * Snapshot the token state in a way that can be restored later, useful for
   * things like lookahead.
   *
   * resultMappings do not need to be copied since in all use cases, they will
   * be overwritten anyway after restore.
   */ snapshot() {
        return {
            resultCode: this.resultCode,
            tokenIndex: this.tokenIndex
        };
    }
    restoreToSnapshot(snapshot) {
        this.resultCode = snapshot.resultCode;
        this.tokenIndex = snapshot.tokenIndex;
    }
    /**
   * Remove and return the code generated since the snapshot, leaving the
   * current token position in-place. Unlike most TokenProcessor operations,
   * this operation can result in input/output line number mismatches because
   * the removed code may contain newlines, so this operation should be used
   * sparingly.
   */ dangerouslyGetAndRemoveCodeSinceSnapshot(snapshot) {
        const result = this.resultCode.slice(snapshot.resultCode.length);
        this.resultCode = snapshot.resultCode;
        return result;
    }
    reset() {
        this.resultCode = "";
        this.resultMappings = new Array(this.tokens.length);
        this.tokenIndex = 0;
    }
    matchesContextualAtIndex(index, contextualKeyword) {
        return this.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && this.tokens[index].contextualKeyword === contextualKeyword;
    }
    identifierNameAtIndex(index) {
        // TODO: We need to process escapes since technically you can have unicode escapes in variable
        // names.
        return this.identifierNameForToken(this.tokens[index]);
    }
    identifierNameAtRelativeIndex(relativeIndex) {
        return this.identifierNameForToken(this.tokenAtRelativeIndex(relativeIndex));
    }
    identifierName() {
        return this.identifierNameForToken(this.currentToken());
    }
    identifierNameForToken(token) {
        return this.code.slice(token.start, token.end);
    }
    rawCodeForToken(token) {
        return this.code.slice(token.start, token.end);
    }
    stringValueAtIndex(index) {
        return this.stringValueForToken(this.tokens[index]);
    }
    stringValue() {
        return this.stringValueForToken(this.currentToken());
    }
    stringValueForToken(token) {
        // This is used to identify when two imports are the same and to resolve TypeScript enum keys.
        // Ideally we'd process escapes within the strings, but for now we pretty much take the raw
        // code.
        return this.code.slice(token.start + 1, token.end - 1);
    }
    matches1AtIndex(index, t1) {
        return this.tokens[index].type === t1;
    }
    matches2AtIndex(index, t1, t2) {
        return this.tokens[index].type === t1 && this.tokens[index + 1].type === t2;
    }
    matches3AtIndex(index, t1, t2, t3) {
        return this.tokens[index].type === t1 && this.tokens[index + 1].type === t2 && this.tokens[index + 2].type === t3;
    }
    matches1(t1) {
        return this.tokens[this.tokenIndex].type === t1;
    }
    matches2(t1, t2) {
        return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2;
    }
    matches3(t1, t2, t3) {
        return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2 && this.tokens[this.tokenIndex + 2].type === t3;
    }
    matches4(t1, t2, t3, t4) {
        return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2 && this.tokens[this.tokenIndex + 2].type === t3 && this.tokens[this.tokenIndex + 3].type === t4;
    }
    matches5(t1, t2, t3, t4, t5) {
        return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2 && this.tokens[this.tokenIndex + 2].type === t3 && this.tokens[this.tokenIndex + 3].type === t4 && this.tokens[this.tokenIndex + 4].type === t5;
    }
    matchesContextual(contextualKeyword) {
        return this.matchesContextualAtIndex(this.tokenIndex, contextualKeyword);
    }
    matchesContextIdAndLabel(type, contextId) {
        return this.matches1(type) && this.currentToken().contextId === contextId;
    }
    previousWhitespaceAndComments() {
        let whitespaceAndComments = this.code.slice(this.tokenIndex > 0 ? this.tokens[this.tokenIndex - 1].end : 0, this.tokenIndex < this.tokens.length ? this.tokens[this.tokenIndex].start : this.code.length);
        if (this.isFlowEnabled) whitespaceAndComments = whitespaceAndComments.replace(/@flow/g, "");
        return whitespaceAndComments;
    }
    replaceToken(newCode) {
        this.resultCode += this.previousWhitespaceAndComments();
        this.appendTokenPrefix();
        this.resultMappings[this.tokenIndex] = this.resultCode.length;
        this.resultCode += newCode;
        this.appendTokenSuffix();
        this.tokenIndex++;
    }
    replaceTokenTrimmingLeftWhitespace(newCode) {
        this.resultCode += this.previousWhitespaceAndComments().replace(/[^\r\n]/g, "");
        this.appendTokenPrefix();
        this.resultMappings[this.tokenIndex] = this.resultCode.length;
        this.resultCode += newCode;
        this.appendTokenSuffix();
        this.tokenIndex++;
    }
    removeInitialToken() {
        this.replaceToken("");
    }
    removeToken() {
        this.replaceTokenTrimmingLeftWhitespace("");
    }
    /**
   * Remove all code until the next }, accounting for balanced braces.
   */ removeBalancedCode() {
        let braceDepth = 0;
        while(!this.isAtEnd()){
            if (this.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) braceDepth++;
            else if (this.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                if (braceDepth === 0) return;
                braceDepth--;
            }
            this.removeToken();
        }
    }
    copyExpectedToken(tokenType) {
        if (this.tokens[this.tokenIndex].type !== tokenType) throw new Error(`Expected token ${tokenType}`);
        this.copyToken();
    }
    copyToken() {
        this.resultCode += this.previousWhitespaceAndComments();
        this.appendTokenPrefix();
        this.resultMappings[this.tokenIndex] = this.resultCode.length;
        this.resultCode += this.code.slice(this.tokens[this.tokenIndex].start, this.tokens[this.tokenIndex].end);
        this.appendTokenSuffix();
        this.tokenIndex++;
    }
    copyTokenWithPrefix(prefix) {
        this.resultCode += this.previousWhitespaceAndComments();
        this.appendTokenPrefix();
        this.resultCode += prefix;
        this.resultMappings[this.tokenIndex] = this.resultCode.length;
        this.resultCode += this.code.slice(this.tokens[this.tokenIndex].start, this.tokens[this.tokenIndex].end);
        this.appendTokenSuffix();
        this.tokenIndex++;
    }
    appendTokenPrefix() {
        const token = this.currentToken();
        if (token.numNullishCoalesceStarts || token.isOptionalChainStart) token.isAsyncOperation = (0, $a55849c89b8d74ae$export$2e2bcd8739ae039)(this);
        if (this.disableESTransforms) return;
        if (token.numNullishCoalesceStarts) for(let i = 0; i < token.numNullishCoalesceStarts; i++){
            if (token.isAsyncOperation) {
                this.resultCode += "await ";
                this.resultCode += this.helperManager.getHelperName("asyncNullishCoalesce");
            } else this.resultCode += this.helperManager.getHelperName("nullishCoalesce");
            this.resultCode += "(";
        }
        if (token.isOptionalChainStart) {
            if (token.isAsyncOperation) this.resultCode += "await ";
            if (this.tokenIndex > 0 && this.tokenAtRelativeIndex(-1).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._delete) {
                if (token.isAsyncOperation) this.resultCode += this.helperManager.getHelperName("asyncOptionalChainDelete");
                else this.resultCode += this.helperManager.getHelperName("optionalChainDelete");
            } else if (token.isAsyncOperation) this.resultCode += this.helperManager.getHelperName("asyncOptionalChain");
            else this.resultCode += this.helperManager.getHelperName("optionalChain");
            this.resultCode += "([";
        }
    }
    appendTokenSuffix() {
        const token = this.currentToken();
        if (token.isOptionalChainEnd && !this.disableESTransforms) this.resultCode += "])";
        if (token.numNullishCoalesceEnds && !this.disableESTransforms) for(let i = 0; i < token.numNullishCoalesceEnds; i++)this.resultCode += "))";
    }
    appendCode(code) {
        this.resultCode += code;
    }
    currentToken() {
        return this.tokens[this.tokenIndex];
    }
    currentTokenCode() {
        const token = this.currentToken();
        return this.code.slice(token.start, token.end);
    }
    tokenAtRelativeIndex(relativeIndex) {
        return this.tokens[this.tokenIndex + relativeIndex];
    }
    currentIndex() {
        return this.tokenIndex;
    }
    /**
   * Move to the next token. Only suitable in preprocessing steps. When
   * generating new code, you should use copyToken or removeToken.
   */ nextToken() {
        if (this.tokenIndex === this.tokens.length) throw new Error("Unexpectedly reached end of input.");
        this.tokenIndex++;
    }
    previousToken() {
        this.tokenIndex--;
    }
    finish() {
        if (this.tokenIndex !== this.tokens.length) throw new Error("Tried to finish processing tokens before reaching the end.");
        this.resultCode += this.previousWhitespaceAndComments();
        return {
            code: this.resultCode,
            mappings: this.resultMappings
        };
    }
    isAtEnd() {
        return this.tokenIndex === this.tokens.length;
    }
}






function $e3f8f159d7f2a3fc$export$2e2bcd8739ae039(rootTransformer, tokens, nameManager, disableESTransforms) {
    const snapshot = tokens.snapshot();
    const headerInfo = $e3f8f159d7f2a3fc$var$processClassHeader(tokens);
    let constructorInitializerStatements = [];
    const instanceInitializerNames = [];
    const staticInitializerNames = [];
    let constructorInsertPos = null;
    const fields = [];
    const rangesToRemove = [];
    const classContextId = tokens.currentToken().contextId;
    if (classContextId == null) throw new Error("Expected non-null class context ID on class open-brace.");
    tokens.nextToken();
    while(!tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR, classContextId)){
        if (tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._constructor) && !tokens.currentToken().isType) ({ constructorInitializerStatements: constructorInitializerStatements, constructorInsertPos: constructorInsertPos } = $e3f8f159d7f2a3fc$var$processConstructor(tokens));
        else if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) {
            if (!disableESTransforms) rangesToRemove.push({
                start: tokens.currentIndex(),
                end: tokens.currentIndex() + 1
            });
            tokens.nextToken();
        } else if (tokens.currentToken().isType) tokens.nextToken();
        else {
            // Either a method or a field. Skip to the identifier part.
            const statementStartIndex = tokens.currentIndex();
            let isStatic = false;
            let isESPrivate = false;
            let isDeclareOrAbstract = false;
            while($e3f8f159d7f2a3fc$var$isAccessModifier(tokens.currentToken())){
                if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._static)) isStatic = true;
                if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).hash)) isESPrivate = true;
                if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._declare) || tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract)) isDeclareOrAbstract = true;
                tokens.nextToken();
            }
            if (isStatic && tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
                // This is a static block, so don't process it in any special way.
                $e3f8f159d7f2a3fc$var$skipToNextClassElement(tokens, classContextId);
                continue;
            }
            if (isESPrivate) {
                // Sucrase doesn't attempt to transpile private fields; just leave them as-is.
                $e3f8f159d7f2a3fc$var$skipToNextClassElement(tokens, classContextId);
                continue;
            }
            if (tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._constructor) && !tokens.currentToken().isType) {
                ({ constructorInitializerStatements: constructorInitializerStatements, constructorInsertPos: constructorInsertPos } = $e3f8f159d7f2a3fc$var$processConstructor(tokens));
                continue;
            }
            const nameStartIndex = tokens.currentIndex();
            $e3f8f159d7f2a3fc$var$skipFieldName(tokens);
            if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan) || tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
                // This is a method, so nothing to process.
                $e3f8f159d7f2a3fc$var$skipToNextClassElement(tokens, classContextId);
                continue;
            }
            // There might be a type annotation that we need to skip.
            while(tokens.currentToken().isType)tokens.nextToken();
            if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
                const equalsIndex = tokens.currentIndex();
                // This is an initializer, so we need to wrap in an initializer method.
                const valueEnd = tokens.currentToken().rhsEndIndex;
                if (valueEnd == null) throw new Error("Expected rhsEndIndex on class field assignment.");
                tokens.nextToken();
                while(tokens.currentIndex() < valueEnd)rootTransformer.processToken();
                let initializerName;
                if (isStatic) {
                    initializerName = nameManager.claimFreeName("__initStatic");
                    staticInitializerNames.push(initializerName);
                } else {
                    initializerName = nameManager.claimFreeName("__init");
                    instanceInitializerNames.push(initializerName);
                }
                // Fields start at the name, so `static x = 1;` has a field range of `x = 1;`.
                fields.push({
                    initializerName: initializerName,
                    equalsIndex: equalsIndex,
                    start: nameStartIndex,
                    end: tokens.currentIndex()
                });
            } else if (!disableESTransforms || isDeclareOrAbstract) // This is a regular field declaration, like `x;`. With the class transform enabled, we just
            // remove the line so that no output is produced. With the class transform disabled, we
            // usually want to preserve the declaration (but still strip types), but if the `declare`
            // or `abstract` keyword is specified, we should remove the line to avoid initializing the
            // value to undefined.
            rangesToRemove.push({
                start: statementStartIndex,
                end: tokens.currentIndex()
            });
        }
    }
    tokens.restoreToSnapshot(snapshot);
    if (disableESTransforms) // With ES transforms disabled, we don't want to transform regular class
    // field declarations, and we don't need to do any additional tricks to
    // reference the constructor for static init, but we still need to transform
    // TypeScript field initializers defined as constructor parameters and we
    // still need to remove `declare` fields. For now, we run the same code
    // path but omit any field information, as if the class had no field
    // declarations. In the future, when we fully drop the class fields
    // transform, we can simplify this code significantly.
    return {
        headerInfo: headerInfo,
        constructorInitializerStatements: constructorInitializerStatements,
        instanceInitializerNames: [],
        staticInitializerNames: [],
        constructorInsertPos: constructorInsertPos,
        fields: [],
        rangesToRemove: rangesToRemove
    };
    else return {
        headerInfo: headerInfo,
        constructorInitializerStatements: constructorInitializerStatements,
        instanceInitializerNames: instanceInitializerNames,
        staticInitializerNames: staticInitializerNames,
        constructorInsertPos: constructorInsertPos,
        fields: fields,
        rangesToRemove: rangesToRemove
    };
}
/**
 * Move the token processor to the next method/field in the class.
 *
 * To do that, we seek forward to the next start of a class name (either an open
 * bracket or an identifier, or the closing curly brace), then seek backward to
 * include any access modifiers.
 */ function $e3f8f159d7f2a3fc$var$skipToNextClassElement(tokens, classContextId) {
    tokens.nextToken();
    while(tokens.currentToken().contextId !== classContextId)tokens.nextToken();
    while($e3f8f159d7f2a3fc$var$isAccessModifier(tokens.tokenAtRelativeIndex(-1)))tokens.previousToken();
}
function $e3f8f159d7f2a3fc$var$processClassHeader(tokens) {
    const classToken = tokens.currentToken();
    const contextId = classToken.contextId;
    if (contextId == null) throw new Error("Expected context ID on class token.");
    const isExpression = classToken.isExpression;
    if (isExpression == null) throw new Error("Expected isExpression on class token.");
    let className = null;
    let hasSuperclass = false;
    tokens.nextToken();
    if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) className = tokens.identifierName();
    while(!tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL, contextId)){
        // If this has a superclass, there will always be an `extends` token. If it doesn't have a
        // superclass, only type parameters and `implements` clauses can show up here, all of which
        // consist only of type tokens. A declaration like `class A<B extends C> {` should *not* count
        // as having a superclass.
        if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._extends) && !tokens.currentToken().isType) hasSuperclass = true;
        tokens.nextToken();
    }
    return {
        isExpression: isExpression,
        className: className,
        hasSuperclass: hasSuperclass
    };
}
/**
 * Extract useful information out of a constructor, starting at the "constructor" name.
 */ function $e3f8f159d7f2a3fc$var$processConstructor(tokens) {
    const constructorInitializerStatements = [];
    tokens.nextToken();
    const constructorContextId = tokens.currentToken().contextId;
    if (constructorContextId == null) throw new Error("Expected context ID on open-paren starting constructor params.");
    // Advance through parameters looking for access modifiers.
    while(!tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR, constructorContextId))if (tokens.currentToken().contextId === constructorContextId) {
        // Current token is an open paren or comma just before a param, so check
        // that param for access modifiers.
        tokens.nextToken();
        if ($e3f8f159d7f2a3fc$var$isAccessModifier(tokens.currentToken())) {
            tokens.nextToken();
            while($e3f8f159d7f2a3fc$var$isAccessModifier(tokens.currentToken()))tokens.nextToken();
            const token = tokens.currentToken();
            if (token.type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) throw new Error("Expected identifier after access modifiers in constructor arg.");
            const name = tokens.identifierNameForToken(token);
            constructorInitializerStatements.push(`this.${name} = ${name}`);
        }
    } else tokens.nextToken();
    // )
    tokens.nextToken();
    // Constructor type annotations are invalid, but skip them anyway since
    // they're easy to skip.
    while(tokens.currentToken().isType)tokens.nextToken();
    let constructorInsertPos = tokens.currentIndex();
    // Advance through body looking for a super call.
    let foundSuperCall = false;
    while(!tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR, constructorContextId)){
        if (!foundSuperCall && tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._super, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
            tokens.nextToken();
            const superCallContextId = tokens.currentToken().contextId;
            if (superCallContextId == null) throw new Error("Expected a context ID on the super call");
            while(!tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR, superCallContextId))tokens.nextToken();
            constructorInsertPos = tokens.currentIndex();
            foundSuperCall = true;
        }
        tokens.nextToken();
    }
    // }
    tokens.nextToken();
    return {
        constructorInitializerStatements: constructorInitializerStatements,
        constructorInsertPos: constructorInsertPos
    };
}
/**
 * Determine if this is any token that can go before the name in a method/field.
 */ function $e3f8f159d7f2a3fc$var$isAccessModifier(token) {
    return [
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._async,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._get,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._set,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).plus,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).minus,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._readonly,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._static,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._public,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._private,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._protected,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._override,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._declare,
        (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).hash
    ].includes(token.type);
}
/**
 * The next token or set of tokens is either an identifier or an expression in square brackets, for
 * a method or field name.
 */ function $e3f8f159d7f2a3fc$var$skipFieldName(tokens) {
    if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) {
        const startToken = tokens.currentToken();
        const classContextId = startToken.contextId;
        if (classContextId == null) throw new Error("Expected class context ID on computed name open bracket.");
        while(!tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR, classContextId))tokens.nextToken();
        tokens.nextToken();
    } else tokens.nextToken();
}






function $f3fd7f90efbef058$export$2e2bcd8739ae039(tokens) {
    // import
    tokens.removeInitialToken();
    // name
    tokens.removeToken();
    // =
    tokens.removeToken();
    // name or require
    tokens.removeToken();
    // Handle either `import A = require('A')` or `import A = B.C.D`.
    if (tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
        // (
        tokens.removeToken();
        // path string
        tokens.removeToken();
        // )
        tokens.removeToken();
    } else while(tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)){
        // .
        tokens.removeToken();
        // name
        tokens.removeToken();
    }
}




const $2755147e218a1b7a$export$cab8fec5d7ea8d7 = {
    typeDeclarations: new Set(),
    valueDeclarations: new Set()
};
function $2755147e218a1b7a$export$2e2bcd8739ae039(tokens) {
    const typeDeclarations = new Set();
    const valueDeclarations = new Set();
    for(let i = 0; i < tokens.tokens.length; i++){
        const token = tokens.tokens[i];
        if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name && (0, $19e70491d10f11e8$export$c08b4dec8c3c03d)(token)) {
            if (token.isType) typeDeclarations.add(tokens.identifierNameForToken(token));
            else valueDeclarations.add(tokens.identifierNameForToken(token));
        }
    }
    return {
        typeDeclarations: typeDeclarations,
        valueDeclarations: valueDeclarations
    };
}





function $b54a2e36959b8789$export$2e2bcd8739ae039(tokens) {
    let closeBraceIndex = tokens.currentIndex();
    while(!tokens.matches1AtIndex(closeBraceIndex, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR))closeBraceIndex++;
    return tokens.matchesContextualAtIndex(closeBraceIndex + 1, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from) && tokens.matches1AtIndex(closeBraceIndex + 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string);
}




function $e01375f4457fb7f5$export$7e9be594554aa1b0(tokens) {
    if (tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._with, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) && tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._assert)) {
        // assert
        tokens.removeToken();
        // {
        tokens.removeToken();
        tokens.removeBalancedCode();
        // }
        tokens.removeToken();
    }
}



function $affb60ffa9c51f41$export$2e2bcd8739ae039(isTypeScriptTransformEnabled, keepUnusedImports, tokens, declarationInfo) {
    if (!isTypeScriptTransformEnabled || keepUnusedImports) return false;
    const exportToken = tokens.currentToken();
    if (exportToken.rhsEndIndex == null) throw new Error("Expected non-null rhsEndIndex on export token.");
    // The export must be of the form `export default a` or `export default a;`.
    const numTokens = exportToken.rhsEndIndex - tokens.currentIndex();
    if (numTokens !== 3 && !(numTokens === 4 && tokens.matches1AtIndex(exportToken.rhsEndIndex - 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi))) return false;
    const identifierToken = tokens.tokenAtRelativeIndex(2);
    if (identifierToken.type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) return false;
    const exportedName = tokens.identifierNameForToken(identifierToken);
    return declarationInfo.typeDeclarations.has(exportedName) && !declarationInfo.valueDeclarations.has(exportedName);
}



class $384b44440831876e$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    __init() {
        this.hadExport = false;
    }
    __init2() {
        this.hadNamedExport = false;
    }
    __init3() {
        this.hadDefaultExport = false;
    }
    constructor(rootTransformer, tokens, importProcessor, nameManager, helperManager, reactHotLoaderTransformer, enableLegacyBabel5ModuleInterop, enableLegacyTypeScriptModuleInterop, isTypeScriptTransformEnabled, isFlowTransformEnabled, preserveDynamicImport, keepUnusedImports){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.importProcessor = importProcessor;
        this.nameManager = nameManager;
        this.helperManager = helperManager;
        this.reactHotLoaderTransformer = reactHotLoaderTransformer;
        this.enableLegacyBabel5ModuleInterop = enableLegacyBabel5ModuleInterop;
        this.enableLegacyTypeScriptModuleInterop = enableLegacyTypeScriptModuleInterop;
        this.isTypeScriptTransformEnabled = isTypeScriptTransformEnabled;
        this.isFlowTransformEnabled = isFlowTransformEnabled;
        this.preserveDynamicImport = preserveDynamicImport;
        this.keepUnusedImports = keepUnusedImports;
        $384b44440831876e$export$2e2bcd8739ae039.prototype.__init.call(this);
        $384b44440831876e$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $384b44440831876e$export$2e2bcd8739ae039.prototype.__init3.call(this);
        this.declarationInfo = isTypeScriptTransformEnabled ? (0, $2755147e218a1b7a$export$2e2bcd8739ae039)(tokens) : (0, $2755147e218a1b7a$export$cab8fec5d7ea8d7);
    }
    getPrefixCode() {
        let prefix = "";
        if (this.hadExport) prefix += 'Object.defineProperty(exports, "__esModule", {value: true});';
        return prefix;
    }
    getSuffixCode() {
        if (this.enableLegacyBabel5ModuleInterop && this.hadDefaultExport && !this.hadNamedExport) return "\nmodule.exports = exports.default;\n";
        return "";
    }
    process() {
        // TypeScript `import foo = require('foo');` should always just be translated to plain require.
        if (this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) return this.processImportEquals();
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import)) {
            this.processImport();
            return true;
        }
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
            this.tokens.replaceToken("module.exports");
            return true;
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export) && !this.tokens.currentToken().isType) {
            this.hadExport = true;
            return this.processExport();
        }
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).postIncDec)) {
            // Fall through to normal identifier matching if this doesn't apply.
            if (this.processPostIncDec()) return true;
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).jsxName)) return this.processIdentifier();
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) return this.processAssignment();
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).assign)) return this.processComplexAssignment();
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).preIncDec)) return this.processPreIncDec();
        return false;
    }
    processImportEquals() {
        const importName = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
        if (this.importProcessor.shouldAutomaticallyElideImportedName(importName)) // If this name is only used as a type, elide the whole import.
        (0, $f3fd7f90efbef058$export$2e2bcd8739ae039)(this.tokens);
        else // Otherwise, switch `import` to `const`.
        this.tokens.replaceToken("const");
        return true;
    }
    /**
   * Transform this:
   * import foo, {bar} from 'baz';
   * into
   * var _baz = require('baz'); var _baz2 = _interopRequireDefault(_baz);
   *
   * The import code was already generated in the import preprocessing step, so
   * we just need to look it up.
   */ processImport() {
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
            if (this.preserveDynamicImport) {
                // Bail out, only making progress for this one token.
                this.tokens.copyToken();
                return;
            }
            const requireWrapper = this.enableLegacyTypeScriptModuleInterop ? "" : `${this.helperManager.getHelperName("interopRequireWildcard")}(`;
            this.tokens.replaceToken(`Promise.resolve().then(() => ${requireWrapper}require`);
            const contextId = this.tokens.currentToken().contextId;
            if (contextId == null) throw new Error("Expected context ID on dynamic import invocation.");
            this.tokens.copyToken();
            while(!this.tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR, contextId))this.rootTransformer.processToken();
            this.tokens.replaceToken(requireWrapper ? ")))" : "))");
            return;
        }
        const shouldElideImport = this.removeImportAndDetectIfShouldElide();
        if (shouldElideImport) this.tokens.removeToken();
        else {
            const path = this.tokens.stringValue();
            this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(path));
            this.tokens.appendCode(this.importProcessor.claimImportCode(path));
        }
        (0, $e01375f4457fb7f5$export$7e9be594554aa1b0)(this.tokens);
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
    }
    /**
   * Erase this import (since any CJS output would be completely different), and
   * return true if this import is should be elided due to being a type-only
   * import. Such imports will not be emitted at all to avoid side effects.
   *
   * Import elision only happens with the TypeScript or Flow transforms enabled.
   *
   * TODO: This function has some awkward overlap with
   *  CJSImportProcessor.pruneTypeOnlyImports , and the two should be unified.
   *  That function handles TypeScript implicit import name elision, and removes
   *  an import if all typical imported names (without `type`) are removed due
   *  to being type-only imports. This function handles Flow import removal and
   *  properly distinguishes `import 'foo'` from `import {} from 'foo'` for TS
   *  purposes.
   *
   * The position should end at the import string.
   */ removeImportAndDetectIfShouldElide() {
        this.tokens.removeInitialToken();
        if (this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) && !this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) && !this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) {
            // This is an "import type" statement, so exit early.
            this.removeRemainingImport();
            return true;
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
            // We have a default import or namespace import, so there must be some
            // non-type import.
            this.removeRemainingImport();
            return false;
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) // This is a bare import, so we should proceed with the import.
        return false;
        let foundNonTypeImport = false;
        let foundAnyNamedImport = false;
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)){
            // Check if any named imports are of the form "foo" or "foo as bar", with
            // no leading "type".
            if (!foundNonTypeImport && this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) {
                this.tokens.removeToken();
                if (!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) foundAnyNamedImport = true;
                if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) || this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) foundNonTypeImport = true;
            }
            this.tokens.removeToken();
        }
        if (this.keepUnusedImports) return false;
        if (this.isTypeScriptTransformEnabled) return !foundNonTypeImport;
        else if (this.isFlowTransformEnabled) // In Flow, unlike TS, `import {} from 'foo';` preserves the import.
        return foundAnyNamedImport && !foundNonTypeImport;
        else return false;
    }
    removeRemainingImport() {
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string))this.tokens.removeToken();
    }
    processIdentifier() {
        const token = this.tokens.currentToken();
        if (token.shadowsGlobal) return false;
        if (token.identifierRole === (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectShorthand) return this.processObjectShorthand();
        if (token.identifierRole !== (0, $19e70491d10f11e8$export$99f888ada3c99de3).Access) return false;
        const replacement = this.importProcessor.getIdentifierReplacement(this.tokens.identifierNameForToken(token));
        if (!replacement) return false;
        // Tolerate any number of closing parens while looking for an opening paren
        // that indicates a function call.
        let possibleOpenParenIndex = this.tokens.currentIndex() + 1;
        while(possibleOpenParenIndex < this.tokens.tokens.length && this.tokens.tokens[possibleOpenParenIndex].type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)possibleOpenParenIndex++;
        // Avoid treating imported functions as methods of their `exports` object
        // by using `(0, f)` when the identifier is in a paren expression. Else
        // use `Function.prototype.call` when the identifier is a guaranteed
        // function call. When using `call`, pass undefined as the context.
        if (this.tokens.tokens[possibleOpenParenIndex].type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) {
            if (this.tokens.tokenAtRelativeIndex(1).type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL && this.tokens.tokenAtRelativeIndex(-1).type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._new) {
                this.tokens.replaceToken(`${replacement}.call(void 0, `);
                // Remove the old paren.
                this.tokens.removeToken();
                // Balance out the new paren.
                this.rootTransformer.processBalancedCode();
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
            } else // See here: http://2ality.com/2015/12/references.html
            this.tokens.replaceToken(`(0, ${replacement})`);
        } else this.tokens.replaceToken(replacement);
        return true;
    }
    processObjectShorthand() {
        const identifier = this.tokens.identifierName();
        const replacement = this.importProcessor.getIdentifierReplacement(identifier);
        if (!replacement) return false;
        this.tokens.replaceToken(`${identifier}: ${replacement}`);
        return true;
    }
    processExport() {
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum) || this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum)) {
            this.hadNamedExport = true;
            // Let the TypeScript transform handle it.
            return false;
        }
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default)) {
            if (this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum)) {
                this.hadDefaultExport = true;
                // Flow export default enums need some special handling, so handle them
                // in that tranform rather than this one.
                return false;
            }
            this.processExportDefault();
            return true;
        } else if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            this.processExportBindings();
            return true;
        } else if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
            // export type {a};
            // export type {a as b};
            // export type {a} from './b';
            // export type * from './b';
            // export type * as ns from './b';
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
                while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR))this.tokens.removeToken();
                this.tokens.removeToken();
            } else {
                // *
                this.tokens.removeToken();
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._as)) {
                    // as
                    this.tokens.removeToken();
                    // ns
                    this.tokens.removeToken();
                }
            }
            // Remove type re-export `... } from './T'`
            if (this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from) && this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) {
                this.tokens.removeToken();
                this.tokens.removeToken();
                (0, $e01375f4457fb7f5$export$7e9be594554aa1b0)(this.tokens);
            }
            return true;
        }
        this.hadNamedExport = true;
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var) || this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let) || this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const)) {
            this.processExportVar();
            return true;
        } else if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function) || // export async function
        this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function)) {
            this.processExportFunction();
            return true;
        } else if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class) || this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class) || this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at)) {
            this.processExportClass();
            return true;
        } else if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
            this.processExportStar();
            return true;
        } else throw new Error("Unrecognized export syntax.");
    }
    processAssignment() {
        const index = this.tokens.currentIndex();
        const identifierToken = this.tokens.tokens[index - 1];
        // If the LHS is a type identifier, this must be a declaration like `let a: b = c;`,
        // with `b` as the identifier, so nothing needs to be done in that case.
        if (identifierToken.isType || identifierToken.type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) return false;
        if (identifierToken.shadowsGlobal) return false;
        if (index >= 2 && this.tokens.matches1AtIndex(index - 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) return false;
        if (index >= 2 && [
            (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._var,
            (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._let,
            (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const
        ].includes(this.tokens.tokens[index - 2].type)) // Declarations don't need an extra assignment. This doesn't avoid the
        // assignment for comma-separated declarations, but it's still correct
        // since the assignment is just redundant.
        return false;
        const assignmentSnippet = this.importProcessor.resolveExportBinding(this.tokens.identifierNameForToken(identifierToken));
        if (!assignmentSnippet) return false;
        this.tokens.copyToken();
        this.tokens.appendCode(` ${assignmentSnippet} =`);
        return true;
    }
    /**
   * Process something like `a += 3`, where `a` might be an exported value.
   */ processComplexAssignment() {
        const index = this.tokens.currentIndex();
        const identifierToken = this.tokens.tokens[index - 1];
        if (identifierToken.type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) return false;
        if (identifierToken.shadowsGlobal) return false;
        if (index >= 2 && this.tokens.matches1AtIndex(index - 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) return false;
        const assignmentSnippet = this.importProcessor.resolveExportBinding(this.tokens.identifierNameForToken(identifierToken));
        if (!assignmentSnippet) return false;
        this.tokens.appendCode(` = ${assignmentSnippet}`);
        this.tokens.copyToken();
        return true;
    }
    /**
   * Process something like `++a`, where `a` might be an exported value.
   */ processPreIncDec() {
        const index = this.tokens.currentIndex();
        const identifierToken = this.tokens.tokens[index + 1];
        if (identifierToken.type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) return false;
        if (identifierToken.shadowsGlobal) return false;
        // Ignore things like ++a.b and ++a[b] and ++a().b.
        if (index + 2 < this.tokens.tokens.length && (this.tokens.matches1AtIndex(index + 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot) || this.tokens.matches1AtIndex(index + 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL) || this.tokens.matches1AtIndex(index + 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL))) return false;
        const identifierName = this.tokens.identifierNameForToken(identifierToken);
        const assignmentSnippet = this.importProcessor.resolveExportBinding(identifierName);
        if (!assignmentSnippet) return false;
        this.tokens.appendCode(`${assignmentSnippet} = `);
        this.tokens.copyToken();
        return true;
    }
    /**
   * Process something like `a++`, where `a` might be an exported value.
   * This starts at the `a`, not at the `++`.
   */ processPostIncDec() {
        const index = this.tokens.currentIndex();
        const identifierToken = this.tokens.tokens[index];
        const operatorToken = this.tokens.tokens[index + 1];
        if (identifierToken.type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) return false;
        if (identifierToken.shadowsGlobal) return false;
        if (index >= 1 && this.tokens.matches1AtIndex(index - 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) return false;
        const identifierName = this.tokens.identifierNameForToken(identifierToken);
        const assignmentSnippet = this.importProcessor.resolveExportBinding(identifierName);
        if (!assignmentSnippet) return false;
        const operatorCode = this.tokens.rawCodeForToken(operatorToken);
        // We might also replace the identifier with something like exports.x, so
        // do that replacement here as well.
        const base = this.importProcessor.getIdentifierReplacement(identifierName) || identifierName;
        if (operatorCode === "++") this.tokens.replaceToken(`(${base} = ${assignmentSnippet} = ${base} + 1, ${base} - 1)`);
        else if (operatorCode === "--") this.tokens.replaceToken(`(${base} = ${assignmentSnippet} = ${base} - 1, ${base} + 1)`);
        else throw new Error(`Unexpected operator: ${operatorCode}`);
        this.tokens.removeToken();
        return true;
    }
    processExportDefault() {
        let exportedRuntimeValue = true;
        if (this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || // export default async function
        this.tokens.matches5((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async)) {
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            // Named function export case: change it to a top-level function
            // declaration followed by exports statement.
            const name = this.processNamedFunction();
            this.tokens.appendCode(` exports.default = ${name};`);
        } else if (this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || this.tokens.matches5((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at)) {
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            this.copyDecorators();
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract)) this.tokens.removeToken();
            const name = this.rootTransformer.processNamedClass();
            this.tokens.appendCode(` exports.default = ${name};`);
        // After this point, this is a plain "export default E" statement.
        } else if ((0, $affb60ffa9c51f41$export$2e2bcd8739ae039)(this.isTypeScriptTransformEnabled, this.keepUnusedImports, this.tokens, this.declarationInfo)) {
            // If the exported value is just an identifier and should be elided by TypeScript
            // rules, then remove it entirely. It will always have the form `export default e`,
            // where `e` is an identifier.
            exportedRuntimeValue = false;
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            this.tokens.removeToken();
        } else if (this.reactHotLoaderTransformer) {
            // We need to assign E to a variable. Change "export default E" to
            // "let _default; exports.default = _default = E"
            const defaultVarName = this.nameManager.claimFreeName("_default");
            this.tokens.replaceToken(`let ${defaultVarName}; exports.`);
            this.tokens.copyToken();
            this.tokens.appendCode(` = ${defaultVarName} =`);
            this.reactHotLoaderTransformer.setExtractedDefaultExportName(defaultVarName);
        } else {
            // Change "export default E" to "exports.default = E"
            this.tokens.replaceToken("exports.");
            this.tokens.copyToken();
            this.tokens.appendCode(" =");
        }
        if (exportedRuntimeValue) this.hadDefaultExport = true;
    }
    copyDecorators() {
        while(this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).at)){
            this.tokens.copyToken();
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
                this.rootTransformer.processBalancedCode();
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
            } else {
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
                while(this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)){
                    this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot);
                    this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
                }
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
                    this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
                    this.rootTransformer.processBalancedCode();
                    this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
                }
            }
        }
    }
    /**
   * Transform a declaration like `export var`, `export let`, or `export const`.
   */ processExportVar() {
        if (this.isSimpleExportVar()) this.processSimpleExportVar();
        else this.processComplexExportVar();
    }
    /**
   * Determine if the export is of the form:
   * export var/let/const [varName] = [expr];
   * In other words, determine if function name inference might apply.
   */ isSimpleExportVar() {
        let tokenIndex = this.tokens.currentIndex();
        // export
        tokenIndex++;
        // var/let/const
        tokenIndex++;
        if (!this.tokens.matches1AtIndex(tokenIndex, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) return false;
        tokenIndex++;
        while(tokenIndex < this.tokens.tokens.length && this.tokens.tokens[tokenIndex].isType)tokenIndex++;
        if (!this.tokens.matches1AtIndex(tokenIndex, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) return false;
        return true;
    }
    /**
   * Transform an `export var` declaration initializing a single variable.
   *
   * For example, this:
   * export const f = () => {};
   * becomes this:
   * const f = () => {}; exports.f = f;
   *
   * The variable is unused (e.g. exports.f has the true value of the export).
   * We need to produce an assignment of this form so that the function will
   * have an inferred name of "f", which wouldn't happen in the more general
   * case below.
   */ processSimpleExportVar() {
        // export
        this.tokens.removeInitialToken();
        // var/let/const
        this.tokens.copyToken();
        const varName = this.tokens.identifierName();
        // x: number  ->  x
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq))this.rootTransformer.processToken();
        const endIndex = this.tokens.currentToken().rhsEndIndex;
        if (endIndex == null) throw new Error("Expected = token with an end index.");
        while(this.tokens.currentIndex() < endIndex)this.rootTransformer.processToken();
        this.tokens.appendCode(`; exports.${varName} = ${varName}`);
    }
    /**
   * Transform normal declaration exports, including handling destructuring.
   * For example, this:
   * export const {x: [a = 2, b], c} = d;
   * becomes this:
   * ({x: [exports.a = 2, exports.b], c: exports.c} = d;)
   */ processComplexExportVar() {
        this.tokens.removeInitialToken();
        this.tokens.removeToken();
        const needsParens = this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
        if (needsParens) this.tokens.appendCode("(");
        let depth = 0;
        while(true){
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dollarBraceL) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) {
                depth++;
                this.tokens.copyToken();
            } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketR)) {
                depth--;
                this.tokens.copyToken();
            } else if (depth === 0 && !this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && !this.tokens.currentToken().isType) break;
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
                // Default values might have assignments in the RHS that we want to ignore, so skip past
                // them.
                const endIndex = this.tokens.currentToken().rhsEndIndex;
                if (endIndex == null) throw new Error("Expected = token with an end index.");
                while(this.tokens.currentIndex() < endIndex)this.rootTransformer.processToken();
            } else {
                const token = this.tokens.currentToken();
                if ((0, $19e70491d10f11e8$export$31dc9881735f7118)(token)) {
                    const name = this.tokens.identifierName();
                    let replacement = this.importProcessor.getIdentifierReplacement(name);
                    if (replacement === null) throw new Error(`Expected a replacement for ${name} in \`export var\` syntax.`);
                    if ((0, $19e70491d10f11e8$export$dea1d79574e9c731)(token)) replacement = `${name}: ${replacement}`;
                    this.tokens.replaceToken(replacement);
                } else this.rootTransformer.processToken();
            }
        }
        if (needsParens) {
            // Seek to the end of the RHS.
            const endIndex = this.tokens.currentToken().rhsEndIndex;
            if (endIndex == null) throw new Error("Expected = token with an end index.");
            while(this.tokens.currentIndex() < endIndex)this.rootTransformer.processToken();
            this.tokens.appendCode(")");
        }
    }
    /**
   * Transform this:
   * export function foo() {}
   * into this:
   * function foo() {} exports.foo = foo;
   */ processExportFunction() {
        this.tokens.replaceToken("");
        const name = this.processNamedFunction();
        this.tokens.appendCode(` exports.${name} = ${name};`);
    }
    /**
   * Skip past a function with a name and return that name.
   */ processNamedFunction() {
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function)) this.tokens.copyToken();
        else if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function)) {
            if (!this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async)) throw new Error("Expected async keyword in function export.");
            this.tokens.copyToken();
            this.tokens.copyToken();
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) this.tokens.copyToken();
        if (!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) throw new Error("Expected identifier for exported function name.");
        const name = this.tokens.identifierName();
        this.tokens.copyToken();
        if (this.tokens.currentToken().isType) {
            this.tokens.removeInitialToken();
            while(this.tokens.currentToken().isType)this.tokens.removeToken();
        }
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
        this.rootTransformer.processBalancedCode();
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
        this.rootTransformer.processPossibleTypeRange();
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
        this.rootTransformer.processBalancedCode();
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
        return name;
    }
    /**
   * Transform this:
   * export class A {}
   * into this:
   * class A {} exports.A = A;
   */ processExportClass() {
        this.tokens.removeInitialToken();
        this.copyDecorators();
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract)) this.tokens.removeToken();
        const name = this.rootTransformer.processNamedClass();
        this.tokens.appendCode(` exports.${name} = ${name};`);
    }
    /**
   * Transform this:
   * export {a, b as c};
   * into this:
   * exports.a = a; exports.c = b;
   *
   * OR
   *
   * Transform this:
   * export {a, b as c} from './foo';
   * into the pre-generated Object.defineProperty code from the ImportProcessor.
   *
   * For the first case, if the TypeScript transform is enabled, we need to skip
   * exports that are only defined as types.
   */ processExportBindings() {
        this.tokens.removeInitialToken();
        this.tokens.removeToken();
        const isReExport = (0, $b54a2e36959b8789$export$2e2bcd8739ae039)(this.tokens);
        const exportStatements = [];
        while(true){
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                this.tokens.removeToken();
                break;
            }
            const specifierInfo = (0, $cdb710e84f40793b$export$2e2bcd8739ae039)(this.tokens);
            while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.removeToken();
            const shouldRemoveExport = specifierInfo.isType || !isReExport && this.shouldElideExportedIdentifier(specifierInfo.leftName);
            if (!shouldRemoveExport) {
                const exportedName = specifierInfo.rightName;
                if (exportedName === "default") this.hadDefaultExport = true;
                else this.hadNamedExport = true;
                const localName = specifierInfo.leftName;
                const newLocalName = this.importProcessor.getIdentifierReplacement(localName);
                exportStatements.push(`exports.${exportedName} = ${newLocalName || localName};`);
            }
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                this.tokens.removeToken();
                break;
            }
            if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                this.tokens.removeToken();
                this.tokens.removeToken();
                break;
            } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
            else throw new Error(`Unexpected token: ${JSON.stringify(this.tokens.currentToken())}`);
        }
        if (this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) {
            // This is an export...from, so throw away the normal named export code
            // and use the Object.defineProperty code from ImportProcessor.
            this.tokens.removeToken();
            const path = this.tokens.stringValue();
            this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(path));
            (0, $e01375f4457fb7f5$export$7e9be594554aa1b0)(this.tokens);
        } else // This is a normal named export, so use that.
        this.tokens.appendCode(exportStatements.join(" "));
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
    }
    processExportStar() {
        this.tokens.removeInitialToken();
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string))this.tokens.removeToken();
        const path = this.tokens.stringValue();
        this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(path));
        (0, $e01375f4457fb7f5$export$7e9be594554aa1b0)(this.tokens);
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
    }
    shouldElideExportedIdentifier(name) {
        return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.declarationInfo.valueDeclarations.has(name);
    }
}












class $6b5deed831f29708$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    constructor(tokens, nameManager, helperManager, reactHotLoaderTransformer, isTypeScriptTransformEnabled, isFlowTransformEnabled, keepUnusedImports, options){
        super();
        this.tokens = tokens;
        this.nameManager = nameManager;
        this.helperManager = helperManager;
        this.reactHotLoaderTransformer = reactHotLoaderTransformer;
        this.isTypeScriptTransformEnabled = isTypeScriptTransformEnabled;
        this.isFlowTransformEnabled = isFlowTransformEnabled;
        this.keepUnusedImports = keepUnusedImports;
        this.nonTypeIdentifiers = isTypeScriptTransformEnabled && !keepUnusedImports ? (0, $3aa4b3cf1d42f8c2$export$d0e55db0e89d76b7)(tokens, options) : new Set();
        this.declarationInfo = isTypeScriptTransformEnabled && !keepUnusedImports ? (0, $2755147e218a1b7a$export$2e2bcd8739ae039)(tokens) : (0, $2755147e218a1b7a$export$cab8fec5d7ea8d7);
        this.injectCreateRequireForImportRequire = Boolean(options.injectCreateRequireForImportRequire);
    }
    process() {
        // TypeScript `import foo = require('foo');` should always just be translated to plain require.
        if (this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) return this.processImportEquals();
        if (this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
            // import type T = require('T')
            this.tokens.removeInitialToken();
            // This construct is always exactly 8 tokens long, so remove the 7 remaining tokens.
            for(let i = 0; i < 7; i++)this.tokens.removeToken();
            return true;
        }
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) {
            this.tokens.replaceToken("module.exports");
            return true;
        }
        if (this.tokens.matches5((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
            // export import type T = require('T')
            this.tokens.removeInitialToken();
            // This construct is always exactly 9 tokens long, so remove the 8 remaining tokens.
            for(let i = 0; i < 8; i++)this.tokens.removeToken();
            return true;
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import)) return this.processImport();
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default)) return this.processExportDefault();
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) return this.processNamedExports();
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type)) {
            // export type {a};
            // export type {a as b};
            // export type {a} from './b';
            // export type * from './b';
            // export type * as ns from './b';
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
                while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR))this.tokens.removeToken();
                this.tokens.removeToken();
            } else {
                // *
                this.tokens.removeToken();
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._as)) {
                    // as
                    this.tokens.removeToken();
                    // ns
                    this.tokens.removeToken();
                }
            }
            // Remove type re-export `... } from './T'`
            if (this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from) && this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) {
                this.tokens.removeToken();
                this.tokens.removeToken();
                (0, $e01375f4457fb7f5$export$7e9be594554aa1b0)(this.tokens);
            }
            return true;
        }
        return false;
    }
    processImportEquals() {
        const importName = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
        if (this.shouldAutomaticallyElideImportedName(importName)) // If this name is only used as a type, elide the whole import.
        (0, $f3fd7f90efbef058$export$2e2bcd8739ae039)(this.tokens);
        else if (this.injectCreateRequireForImportRequire) {
            // We're using require in an environment (Node ESM) that doesn't provide
            // it as a global, so generate a helper to import it.
            // import -> const
            this.tokens.replaceToken("const");
            // Foo
            this.tokens.copyToken();
            // =
            this.tokens.copyToken();
            // require
            this.tokens.replaceToken(this.helperManager.getHelperName("require"));
        } else // Otherwise, just switch `import` to `const`.
        this.tokens.replaceToken("const");
        return true;
    }
    processImport() {
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) // Dynamic imports don't need to be transformed.
        return false;
        const snapshot = this.tokens.snapshot();
        const allImportsRemoved = this.removeImportTypeBindings();
        if (allImportsRemoved) {
            this.tokens.restoreToSnapshot(snapshot);
            while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string))this.tokens.removeToken();
            this.tokens.removeToken();
            (0, $e01375f4457fb7f5$export$7e9be594554aa1b0)(this.tokens);
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
        }
        return true;
    }
    /**
   * Remove type bindings from this import, leaving the rest of the import intact.
   *
   * Return true if this import was ONLY types, and thus is eligible for removal. This will bail out
   * of the replacement operation, so we can return early here.
   */ removeImportTypeBindings() {
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import);
        if (this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._type) && !this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) && !this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) // This is an "import type" statement, so exit early.
        return true;
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string)) {
            // This is a bare import, so we should proceed with the import.
            this.tokens.copyToken();
            return false;
        }
        // Skip the "module" token in import reflection.
        if (this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._module) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._from)) this.tokens.copyToken();
        let foundNonTypeImport = false;
        let foundAnyNamedImport = false;
        let needsComma = false;
        // Handle default import.
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
            if (this.shouldAutomaticallyElideImportedName(this.tokens.identifierName())) {
                this.tokens.removeToken();
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
            } else {
                foundNonTypeImport = true;
                this.tokens.copyToken();
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) {
                    // We're in a statement like:
                    // import A, * as B from './A';
                    // or
                    // import A, {foo} from './A';
                    // where the `A` is being kept. The comma should be removed if an only
                    // if the next part of the import statement is elided, but that's hard
                    // to determine at this point in the code. Instead, always remove it
                    // and set a flag to add it back if necessary.
                    needsComma = true;
                    this.tokens.removeToken();
                }
            }
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
            if (this.shouldAutomaticallyElideImportedName(this.tokens.identifierNameAtRelativeIndex(2))) {
                this.tokens.removeToken();
                this.tokens.removeToken();
                this.tokens.removeToken();
            } else {
                if (needsComma) this.tokens.appendCode(",");
                foundNonTypeImport = true;
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star);
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
            }
        } else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            if (needsComma) this.tokens.appendCode(",");
            this.tokens.copyToken();
            while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)){
                foundAnyNamedImport = true;
                const specifierInfo = (0, $cdb710e84f40793b$export$2e2bcd8739ae039)(this.tokens);
                if (specifierInfo.isType || this.shouldAutomaticallyElideImportedName(specifierInfo.rightName)) {
                    while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.removeToken();
                    if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
                } else {
                    foundNonTypeImport = true;
                    while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.copyToken();
                    if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.copyToken();
                }
            }
            this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
        }
        if (this.keepUnusedImports) return false;
        if (this.isTypeScriptTransformEnabled) return !foundNonTypeImport;
        else if (this.isFlowTransformEnabled) // In Flow, unlike TS, `import {} from 'foo';` preserves the import.
        return foundAnyNamedImport && !foundNonTypeImport;
        else return false;
    }
    shouldAutomaticallyElideImportedName(name) {
        return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.nonTypeIdentifiers.has(name);
    }
    processExportDefault() {
        if ((0, $affb60ffa9c51f41$export$2e2bcd8739ae039)(this.isTypeScriptTransformEnabled, this.keepUnusedImports, this.tokens, this.declarationInfo)) {
            // If the exported value is just an identifier and should be elided by TypeScript
            // rules, then remove it entirely. It will always have the form `export default e`,
            // where `e` is an identifier.
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            this.tokens.removeToken();
            return true;
        }
        const alreadyHasName = this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || // export default async function
        this.tokens.matches5((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._function, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async) || this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) || this.tokens.matches5((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
        if (!alreadyHasName && this.reactHotLoaderTransformer) {
            // This is a plain "export default E" statement and we need to assign E to a variable.
            // Change "export default E" to "let _default; export default _default = E"
            const defaultVarName = this.nameManager.claimFreeName("_default");
            this.tokens.replaceToken(`let ${defaultVarName}; export`);
            this.tokens.copyToken();
            this.tokens.appendCode(` ${defaultVarName} =`);
            this.reactHotLoaderTransformer.setExtractedDefaultExportName(defaultVarName);
            return true;
        }
        return false;
    }
    /**
   * Handle a statement with one of these forms:
   * export {a, type b};
   * export {c, type d} from 'foo';
   *
   * In both cases, any explicit type exports should be removed. In the first
   * case, we also need to handle implicit export elision for names declared as
   * types. In the second case, we must NOT do implicit named export elision,
   * but we must remove the runtime import if all exports are type exports.
   */ processNamedExports() {
        if (!this.isTypeScriptTransformEnabled) return false;
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export);
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
        const isReExport = (0, $b54a2e36959b8789$export$2e2bcd8739ae039)(this.tokens);
        let foundNonTypeExport = false;
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)){
            const specifierInfo = (0, $cdb710e84f40793b$export$2e2bcd8739ae039)(this.tokens);
            if (specifierInfo.isType || !isReExport && this.shouldElideExportedName(specifierInfo.leftName)) {
                // Type export, so remove all tokens, including any comma.
                while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.removeToken();
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
            } else {
                // Non-type export, so copy all tokens, including any comma.
                foundNonTypeExport = true;
                while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.copyToken();
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.copyToken();
            }
        }
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
        if (!this.keepUnusedImports && isReExport && !foundNonTypeExport) {
            // This is a type-only re-export, so skip evaluating the other module. Technically this
            // leaves the statement as `export {}`, but that's ok since that's a no-op.
            this.tokens.removeToken();
            this.tokens.removeToken();
            (0, $e01375f4457fb7f5$export$7e9be594554aa1b0)(this.tokens);
        }
        return true;
    }
    /**
   * ESM elides all imports with the rule that we only elide if we see that it's
   * a type and never see it as a value. This is in contrast to CJS, which
   * elides imports that are completely unknown.
   */ shouldElideExportedName(name) {
        return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && this.declarationInfo.typeDeclarations.has(name) && !this.declarationInfo.valueDeclarations.has(name);
    }
}





class $764d21a88b0aec2e$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    constructor(rootTransformer, tokens, isImportsTransformEnabled){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.isImportsTransformEnabled = isImportsTransformEnabled;
    }
    process() {
        if (this.rootTransformer.processPossibleArrowParamEnd() || this.rootTransformer.processPossibleAsyncArrowWithTypeParams() || this.rootTransformer.processPossibleTypeRange()) return true;
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum)) {
            this.processEnum();
            return true;
        }
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum)) {
            this.processNamedExportEnum();
            return true;
        }
        if (this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum)) {
            this.processDefaultExportEnum();
            return true;
        }
        return false;
    }
    /**
   * Handle a declaration like:
   * export enum E ...
   *
   * With this imports transform, this becomes:
   * const E = [[enum]]; exports.E = E;
   *
   * otherwise, it becomes:
   * export const E = [[enum]];
   */ processNamedExportEnum() {
        if (this.isImportsTransformEnabled) {
            // export
            this.tokens.removeInitialToken();
            const enumName = this.tokens.identifierNameAtRelativeIndex(1);
            this.processEnum();
            this.tokens.appendCode(` exports.${enumName} = ${enumName};`);
        } else {
            this.tokens.copyToken();
            this.processEnum();
        }
    }
    /**
   * Handle a declaration like:
   * export default enum E
   *
   * With the imports transform, this becomes:
   * const E = [[enum]]; exports.default = E;
   *
   * otherwise, it becomes:
   * const E = [[enum]]; export default E;
   */ processDefaultExportEnum() {
        // export
        this.tokens.removeInitialToken();
        // default
        this.tokens.removeToken();
        const enumName = this.tokens.identifierNameAtRelativeIndex(1);
        this.processEnum();
        if (this.isImportsTransformEnabled) this.tokens.appendCode(` exports.default = ${enumName};`);
        else this.tokens.appendCode(` export default ${enumName};`);
    }
    /**
   * Transpile flow enums to invoke the "flow-enums-runtime" library.
   *
   * Currently, the transpiled code always uses `require("flow-enums-runtime")`,
   * but if future flexibility is needed, we could expose a config option for
   * this string (similar to configurable JSX). Even when targeting ESM, the
   * default behavior of babel-plugin-transform-flow-enums is to use require
   * rather than injecting an import.
   *
   * Flow enums are quite a bit simpler than TS enums and have some convenient
   * constraints:
   * - Element initializers must be either always present or always absent. That
   *   means that we can use fixed lookahead on the first element (if any) and
   *   assume that all elements are like that.
   * - The right-hand side of an element initializer must be a literal value,
   *   not a complex expression and not referencing other elements. That means
   *   we can simply copy a single token.
   *
   * Enums can be broken up into three basic cases:
   *
   * Mirrored enums:
   * enum E {A, B}
   *   ->
   * const E = require("flow-enums-runtime").Mirrored(["A", "B"]);
   *
   * Initializer enums:
   * enum E {A = 1, B = 2}
   *   ->
   * const E = require("flow-enums-runtime")({A: 1, B: 2});
   *
   * Symbol enums:
   * enum E of symbol {A, B}
   *   ->
   * const E = require("flow-enums-runtime")({A: Symbol("A"), B: Symbol("B")});
   *
   * We can statically detect which of the three cases this is by looking at the
   * "of" declaration (if any) and seeing if the first element has an initializer.
   * Since the other transform details are so similar between the three cases, we
   * use a single implementation and vary the transform within processEnumElement
   * based on case.
   */ processEnum() {
        // enum E -> const E
        this.tokens.replaceToken("const");
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name);
        let isSymbolEnum = false;
        if (this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._of)) {
            this.tokens.removeToken();
            isSymbolEnum = this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._symbol);
            this.tokens.removeToken();
        }
        const hasInitializers = this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq);
        this.tokens.appendCode(' = require("flow-enums-runtime")');
        const isMirrored = !isSymbolEnum && !hasInitializers;
        this.tokens.replaceTokenTrimmingLeftWhitespace(isMirrored ? ".Mirrored([" : "({");
        while(!this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)){
            // ... is allowed at the end and has no runtime behavior.
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).ellipsis)) {
                this.tokens.removeToken();
                break;
            }
            this.processEnumElement(isSymbolEnum, hasInitializers);
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.copyToken();
        }
        this.tokens.replaceToken(isMirrored ? "]);" : "});");
    }
    /**
   * Process an individual enum element, producing either an array element or an
   * object element based on what type of enum this is.
   */ processEnumElement(isSymbolEnum, hasInitializers) {
        if (isSymbolEnum) {
            // Symbol enums never have initializers and are expanded to object elements.
            // A, -> A: Symbol("A"),
            const elementName = this.tokens.identifierName();
            this.tokens.copyToken();
            this.tokens.appendCode(`: Symbol("${elementName}")`);
        } else if (hasInitializers) {
            // Initializers are expanded to object elements.
            // A = 1, -> A: 1,
            this.tokens.copyToken();
            this.tokens.replaceTokenTrimmingLeftWhitespace(":");
            this.tokens.copyToken();
        } else // Enum elements without initializers become string literal array elements.
        // A, -> "A",
        this.tokens.replaceToken(`"${this.tokens.identifierName()}"`);
    }
}




function $bc343969ef153cfd$var$_optionalChain(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $bc343969ef153cfd$var$JEST_GLOBAL_NAME = "jest";
const $bc343969ef153cfd$var$HOISTED_METHODS = [
    "mock",
    "unmock",
    "enableAutomock",
    "disableAutomock"
];
class $bc343969ef153cfd$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    __init() {
        this.hoistedFunctionNames = [];
    }
    constructor(rootTransformer, tokens, nameManager, importProcessor){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.nameManager = nameManager;
        this.importProcessor = importProcessor;
        $bc343969ef153cfd$export$2e2bcd8739ae039.prototype.__init.call(this);
    }
    process() {
        if (this.tokens.currentToken().scopeDepth === 0 && this.tokens.matches4((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) && this.tokens.identifierName() === $bc343969ef153cfd$var$JEST_GLOBAL_NAME) {
            // TODO: This only works if imports transform is active, which it will be for jest.
            //       But if jest adds module support and we no longer need the import transform, this needs fixing.
            if ($bc343969ef153cfd$var$_optionalChain([
                this,
                'access',
                (_)=>_.importProcessor,
                'optionalAccess',
                (_2)=>_2.getGlobalNames,
                'call',
                (_3)=>_3(),
                'optionalAccess',
                (_4)=>_4.has,
                'call',
                (_5)=>_5($bc343969ef153cfd$var$JEST_GLOBAL_NAME)
            ])) return false;
            return this.extractHoistedCalls();
        }
        return false;
    }
    getHoistedCode() {
        if (this.hoistedFunctionNames.length > 0) // This will be placed before module interop code, but that's fine since
        // imports aren't allowed in module mock factories.
        return this.hoistedFunctionNames.map((name)=>`${name}();`).join("");
        return "";
    }
    /**
   * Extracts any methods calls on the jest-object that should be hoisted.
   *
   * According to the jest docs, https://jestjs.io/docs/en/jest-object#jestmockmodulename-factory-options,
   * mock, unmock, enableAutomock, disableAutomock, are the methods that should be hoisted.
   *
   * We do not apply the same checks of the arguments as babel-plugin-jest-hoist does.
   */ extractHoistedCalls() {
        // We're handling a chain of calls where `jest` may or may not need to be inserted for each call
        // in the chain, so remove the initial `jest` to make the loop implementation cleaner.
        this.tokens.removeToken();
        // Track some state so that multiple non-hoisted chained calls in a row keep their chaining
        // syntax.
        let followsNonHoistedJestCall = false;
        // Iterate through all chained calls on the jest object.
        while(this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)){
            const methodName = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
            const shouldHoist = $bc343969ef153cfd$var$HOISTED_METHODS.includes(methodName);
            if (shouldHoist) {
                // We've matched e.g. `.mock(...)` or similar call.
                // Replace the initial `.` with `function __jestHoist(){jest.`
                const hoistedFunctionName = this.nameManager.claimFreeName("__jestHoist");
                this.hoistedFunctionNames.push(hoistedFunctionName);
                this.tokens.replaceToken(`function ${hoistedFunctionName}(){${$bc343969ef153cfd$var$JEST_GLOBAL_NAME}.`);
                this.tokens.copyToken();
                this.tokens.copyToken();
                this.rootTransformer.processBalancedCode();
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
                this.tokens.appendCode(";}");
                followsNonHoistedJestCall = false;
            } else {
                // This is a non-hoisted method, so just transform the code as usual.
                if (followsNonHoistedJestCall) // If we didn't hoist the previous call, we can leave the code as-is to chain off of the
                // previous method call. It's important to preserve the code here because we don't know
                // for sure that the method actually returned the jest object for chaining.
                this.tokens.copyToken();
                else // If we hoisted the previous call, we know it returns the jest object back, so we insert
                // the identifier `jest` to continue the chain.
                this.tokens.replaceToken(`${$bc343969ef153cfd$var$JEST_GLOBAL_NAME}.`);
                this.tokens.copyToken();
                this.tokens.copyToken();
                this.rootTransformer.processBalancedCode();
                this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
                followsNonHoistedJestCall = true;
            }
        }
        return true;
    }
}





class $53c4c3289533904f$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    constructor(tokens){
        super();
        this.tokens = tokens;
    }
    process() {
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num)) {
            const code = this.tokens.currentTokenCode();
            if (code.includes("_")) {
                this.tokens.replaceToken(code.replace(/_/g, ""));
                return true;
            }
        }
        return false;
    }
}




class $651f878a41d91535$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    constructor(tokens, nameManager){
        super();
        this.tokens = tokens;
        this.nameManager = nameManager;
    }
    process() {
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._catch, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
            this.tokens.copyToken();
            this.tokens.appendCode(` (${this.nameManager.claimFreeName("e")})`);
            return true;
        }
        return false;
    }
}




class $edb110213a8d1cb5$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    constructor(tokens, nameManager){
        super();
        this.tokens = tokens;
        this.nameManager = nameManager;
    }
    process() {
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).nullishCoalescing)) {
            const token = this.tokens.currentToken();
            if (this.tokens.tokens[token.nullishStartIndex].isAsyncOperation) this.tokens.replaceTokenTrimmingLeftWhitespace(", async () => (");
            else this.tokens.replaceTokenTrimmingLeftWhitespace(", () => (");
            return true;
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._delete)) {
            const nextToken = this.tokens.tokenAtRelativeIndex(1);
            if (nextToken.isOptionalChainStart) {
                this.tokens.removeInitialToken();
                return true;
            }
        }
        const token = this.tokens.currentToken();
        const chainStart = token.subscriptStartIndex;
        if (chainStart != null && this.tokens.tokens[chainStart].isOptionalChainStart && // Super subscripts can't be optional (since super is never null/undefined), and the syntax
        // relies on the subscript being intact, so leave this token alone.
        this.tokens.tokenAtRelativeIndex(-1).type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._super) {
            const param = this.nameManager.claimFreeName("_");
            let arrowStartSnippet;
            if (chainStart > 0 && this.tokens.matches1AtIndex(chainStart - 1, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._delete) && this.isLastSubscriptInChain()) // Delete operations are special: we already removed the delete keyword, and to still
            // perform a delete, we need to insert a delete in the very last part of the chain, which
            // in correct code will always be a property access.
            arrowStartSnippet = `${param} => delete ${param}`;
            else arrowStartSnippet = `${param} => ${param}`;
            if (this.tokens.tokens[chainStart].isAsyncOperation) arrowStartSnippet = `async ${arrowStartSnippet}`;
            if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL) || this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan)) {
                if (this.justSkippedSuper()) this.tokens.appendCode(".bind(this)");
                this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalCall', ${arrowStartSnippet}`);
            } else if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalAccess', ${arrowStartSnippet}`);
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).questionDot)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalAccess', ${arrowStartSnippet}.`);
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'access', ${arrowStartSnippet}.`);
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'access', ${arrowStartSnippet}[`);
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
                if (this.justSkippedSuper()) this.tokens.appendCode(".bind(this)");
                this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'call', ${arrowStartSnippet}(`);
            } else throw new Error("Unexpected subscript operator in optional chain.");
            return true;
        }
        return false;
    }
    /**
   * Determine if the current token is the last of its chain, so that we know whether it's eligible
   * to have a delete op inserted.
   *
   * We can do this by walking forward until we determine one way or another. Each
   * isOptionalChainStart token must be paired with exactly one isOptionalChainEnd token after it in
   * a nesting way, so we can track depth and walk to the end of the chain (the point where the
   * depth goes negative) and see if any other subscript token is after us in the chain.
   */ isLastSubscriptInChain() {
        let depth = 0;
        for(let i = this.tokens.currentIndex() + 1;; i++){
            if (i >= this.tokens.tokens.length) throw new Error("Reached the end of the code while finding the end of the access chain.");
            if (this.tokens.tokens[i].isOptionalChainStart) depth++;
            else if (this.tokens.tokens[i].isOptionalChainEnd) depth--;
            if (depth < 0) return true;
            // This subscript token is a later one in the same chain.
            if (depth === 0 && this.tokens.tokens[i].subscriptStartIndex != null) return false;
        }
    }
    /**
   * Determine if we are the open-paren in an expression like super.a()?.b.
   *
   * We can do this by walking backward to find the previous subscript. If that subscript was
   * preceded by a super, then we must be the subscript after it, so if this is a call expression,
   * we'll need to attach the right context.
   */ justSkippedSuper() {
        let depth = 0;
        let index = this.tokens.currentIndex() - 1;
        while(true){
            if (index < 0) throw new Error("Reached the start of the code while finding the start of the access chain.");
            if (this.tokens.tokens[index].isOptionalChainStart) depth--;
            else if (this.tokens.tokens[index].isOptionalChainEnd) depth++;
            if (depth < 0) return false;
            // This subscript token is a later one in the same chain.
            if (depth === 0 && this.tokens.tokens[index].subscriptStartIndex != null) return this.tokens.tokens[index - 1].type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._super;
            index--;
        }
    }
}





class $422c837f2180b524$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    constructor(rootTransformer, tokens, importProcessor, options){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.importProcessor = importProcessor;
        this.options = options;
    }
    process() {
        const startIndex = this.tokens.currentIndex();
        if (this.tokens.identifierName() === "createReactClass") {
            const newName = this.importProcessor && this.importProcessor.getIdentifierReplacement("createReactClass");
            if (newName) this.tokens.replaceToken(`(0, ${newName})`);
            else this.tokens.copyToken();
            this.tryProcessCreateClassCall(startIndex);
            return true;
        }
        if (this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dot, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) && this.tokens.identifierName() === "React" && this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 2) === "createClass") {
            const newName = this.importProcessor ? this.importProcessor.getIdentifierReplacement("React") || "React" : "React";
            if (newName) {
                this.tokens.replaceToken(newName);
                this.tokens.copyToken();
                this.tokens.copyToken();
            } else {
                this.tokens.copyToken();
                this.tokens.copyToken();
                this.tokens.copyToken();
            }
            this.tryProcessCreateClassCall(startIndex);
            return true;
        }
        return false;
    }
    /**
   * This is called with the token position at the open-paren.
   */ tryProcessCreateClassCall(startIndex) {
        const displayName = this.findDisplayName(startIndex);
        if (!displayName) return;
        if (this.classNeedsDisplayName()) {
            this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL);
            this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
            this.tokens.appendCode(`displayName: '${displayName}',`);
            this.rootTransformer.processBalancedCode();
            this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
            this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
        }
    }
    findDisplayName(startIndex) {
        if (startIndex < 2) return null;
        if (this.tokens.matches2AtIndex(startIndex - 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) // This is an assignment (or declaration) and the LHS is either an identifier or a member
        // expression ending in an identifier, so use that identifier name.
        return this.tokens.identifierNameAtIndex(startIndex - 2);
        if (startIndex >= 2 && this.tokens.tokens[startIndex - 2].identifierRole === (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectKey) // This is an object literal value.
        return this.tokens.identifierNameAtIndex(startIndex - 2);
        if (this.tokens.matches2AtIndex(startIndex - 2, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._default)) return this.getDisplayNameFromFilename();
        return null;
    }
    getDisplayNameFromFilename() {
        const filePath = this.options.filePath || "unknown";
        const pathSegments = filePath.split("/");
        const filename = pathSegments[pathSegments.length - 1];
        const dotIndex = filename.lastIndexOf(".");
        const baseFilename = dotIndex === -1 ? filename : filename.slice(0, dotIndex);
        if (baseFilename === "index" && pathSegments[pathSegments.length - 2]) return pathSegments[pathSegments.length - 2];
        else return baseFilename;
    }
    /**
   * We only want to add a display name when this is a function call containing
   * one argument, which is an object literal without `displayName` as an
   * existing key.
   */ classNeedsDisplayName() {
        let index = this.tokens.currentIndex();
        if (!this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) return false;
        // The block starts on the {, and we expect any displayName key to be in
        // that context. We need to ignore other other contexts to avoid matching
        // nested displayName keys.
        const objectStartIndex = index + 1;
        const objectContextId = this.tokens.tokens[objectStartIndex].contextId;
        if (objectContextId == null) throw new Error("Expected non-null context ID on object open-brace.");
        for(; index < this.tokens.tokens.length; index++){
            const token = this.tokens.tokens[index];
            if (token.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR && token.contextId === objectContextId) {
                index++;
                break;
            }
            if (this.tokens.identifierNameAtIndex(index) === "displayName" && this.tokens.tokens[index].identifierRole === (0, $19e70491d10f11e8$export$99f888ada3c99de3).ObjectKey && token.contextId === objectContextId) // We found a displayName key, so bail out.
            return false;
        }
        if (index === this.tokens.tokens.length) throw new Error("Unexpected end of input when processing React class.");
        // If we got this far, we know we have createClass with an object with no
        // display name, so we want to proceed as long as that was the only argument.
        return this.tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR) || this.tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR);
    }
}




class $24f0573b6e9a1e84$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    __init() {
        this.extractedDefaultExportName = null;
    }
    constructor(tokens, filePath){
        super();
        this.tokens = tokens;
        this.filePath = filePath;
        $24f0573b6e9a1e84$export$2e2bcd8739ae039.prototype.__init.call(this);
    }
    setExtractedDefaultExportName(extractedDefaultExportName) {
        this.extractedDefaultExportName = extractedDefaultExportName;
    }
    getPrefixCode() {
        return `
      (function () {
        var enterModule = require('react-hot-loader').enterModule;
        enterModule && enterModule(module);
      })();`.replace(/\s+/g, " ").trim();
    }
    getSuffixCode() {
        const topLevelNames = new Set();
        for (const token of this.tokens.tokens)if (!token.isType && (0, $19e70491d10f11e8$export$c08b4dec8c3c03d)(token) && token.identifierRole !== (0, $19e70491d10f11e8$export$99f888ada3c99de3).ImportDeclaration) topLevelNames.add(this.tokens.identifierNameForToken(token));
        const namesToRegister = Array.from(topLevelNames).map((name)=>({
                variableName: name,
                uniqueLocalName: name
            }));
        if (this.extractedDefaultExportName) namesToRegister.push({
            variableName: this.extractedDefaultExportName,
            uniqueLocalName: "default"
        });
        return `
;(function () {
  var reactHotLoader = require('react-hot-loader').default;
  var leaveModule = require('react-hot-loader').leaveModule;
  if (!reactHotLoader) {
    return;
  }
${namesToRegister.map(({ variableName: variableName, uniqueLocalName: uniqueLocalName })=>`  reactHotLoader.register(${variableName}, "${uniqueLocalName}", ${JSON.stringify(this.filePath || "")});`).join("\n")}
  leaveModule(module);
})();`;
    }
    process() {
        return false;
    }
}




// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Lexical_grammar
// Hard-code a list of reserved words rather than trying to use keywords or contextual keywords
// from the parser, since currently there are various exceptions, like `package` being reserved
// but unused and various contextual keywords being reserved. Note that we assume that all code
// compiled by Sucrase is in a module, so strict mode words and await are all considered reserved
// here.
const $acf87c2056b5efeb$var$RESERVED_WORDS = new Set([
    // Reserved keywords as of ECMAScript 2015
    "break",
    "case",
    "catch",
    "class",
    "const",
    "continue",
    "debugger",
    "default",
    "delete",
    "do",
    "else",
    "export",
    "extends",
    "finally",
    "for",
    "function",
    "if",
    "import",
    "in",
    "instanceof",
    "new",
    "return",
    "super",
    "switch",
    "this",
    "throw",
    "try",
    "typeof",
    "var",
    "void",
    "while",
    "with",
    "yield",
    // Future reserved keywords
    "enum",
    "implements",
    "interface",
    "let",
    "package",
    "private",
    "protected",
    "public",
    "static",
    "await",
    // Literals that cannot be used as identifiers
    "false",
    "null",
    "true"
]);
function $acf87c2056b5efeb$export$2e2bcd8739ae039(name) {
    if (name.length === 0) return false;
    if (!(0, $231ac6b14e19c571$export$dc1d1d7d9fdffb8)[name.charCodeAt(0)]) return false;
    for(let i = 1; i < name.length; i++){
        if (!(0, $231ac6b14e19c571$export$d19df39e3926cfef)[name.charCodeAt(i)]) return false;
    }
    return !$acf87c2056b5efeb$var$RESERVED_WORDS.has(name);
}



class $1996d8fdc2196ced$export$2e2bcd8739ae039 extends (0, $12b925d88ed0df69$export$2e2bcd8739ae039) {
    constructor(rootTransformer, tokens, isImportsTransformEnabled){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.isImportsTransformEnabled = isImportsTransformEnabled;
    }
    process() {
        if (this.rootTransformer.processPossibleArrowParamEnd() || this.rootTransformer.processPossibleAsyncArrowWithTypeParams() || this.rootTransformer.processPossibleTypeRange()) return true;
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._public) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._protected) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._private) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._abstract) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._readonly) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._override) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).nonNullAssertion)) {
            this.tokens.removeInitialToken();
            return true;
        }
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum) || this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum)) {
            this.processEnum();
            return true;
        }
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum) || this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._export, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum)) {
            this.processEnum(true);
            return true;
        }
        return false;
    }
    processEnum(isExport = false) {
        // We might have "export const enum", so just remove all relevant tokens.
        this.tokens.removeInitialToken();
        while(this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._const) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._enum))this.tokens.removeToken();
        const enumName = this.tokens.identifierName();
        this.tokens.removeToken();
        if (isExport && !this.isImportsTransformEnabled) this.tokens.appendCode("export ");
        this.tokens.appendCode(`var ${enumName}; (function (${enumName})`);
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
        this.processEnumBody(enumName);
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
        if (isExport && this.isImportsTransformEnabled) this.tokens.appendCode(`)(${enumName} || (exports.${enumName} = ${enumName} = {}));`);
        else this.tokens.appendCode(`)(${enumName} || (${enumName} = {}));`);
    }
    /**
   * Transform an enum into equivalent JS. This has complexity in a few places:
   * - TS allows string enums, numeric enums, and a mix of the two styles within an enum.
   * - Enum keys are allowed to be referenced in later enum values.
   * - Enum keys are allowed to be strings.
   * - When enum values are omitted, they should follow an auto-increment behavior.
   */ processEnumBody(enumName) {
        // Code that can be used to reference the previous enum member, or null if this is the first
        // enum member.
        let previousValueCode = null;
        while(true){
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) break;
            const { nameStringCode: nameStringCode, variableName: variableName } = this.extractEnumKeyInfo(this.tokens.currentToken());
            this.tokens.removeInitialToken();
            if (this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma) || this.tokens.matches3((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) this.processStringLiteralEnumMember(enumName, nameStringCode, variableName);
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) this.processExplicitValueEnumMember(enumName, nameStringCode, variableName);
            else this.processImplicitValueEnumMember(enumName, nameStringCode, variableName, previousValueCode);
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
            if (variableName != null) previousValueCode = variableName;
            else previousValueCode = `${enumName}[${nameStringCode}]`;
        }
    }
    /**
   * Detect name information about this enum key, which will be used to determine which code to emit
   * and whether we should declare a variable as part of this declaration.
   *
   * Some cases to keep in mind:
   * - Enum keys can be implicitly referenced later, e.g. `X = 1, Y = X`. In Sucrase, we implement
   *   this by declaring a variable `X` so that later expressions can use it.
   * - In addition to the usual identifier key syntax, enum keys are allowed to be string literals,
   *   e.g. `"hello world" = 3,`. Template literal syntax is NOT allowed.
   * - Even if the enum key is defined as a string literal, it may still be referenced by identifier
   *   later, e.g. `"X" = 1, Y = X`. That means that we need to detect whether or not a string
   *   literal is identifier-like and emit a variable if so, even if the declaration did not use an
   *   identifier.
   * - Reserved keywords like `break` are valid enum keys, but are not valid to be referenced later
   *   and would be a syntax error if we emitted a variable, so we need to skip the variable
   *   declaration in those cases.
   *
   * The variableName return value captures these nuances: if non-null, we can and must emit a
   * variable declaration, and if null, we can't and shouldn't.
   */ extractEnumKeyInfo(nameToken) {
        if (nameToken.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name) {
            const name = this.tokens.identifierNameForToken(nameToken);
            return {
                nameStringCode: `"${name}"`,
                variableName: (0, $acf87c2056b5efeb$export$2e2bcd8739ae039)(name) ? name : null
            };
        } else if (nameToken.type === (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string) {
            const name = this.tokens.stringValueForToken(nameToken);
            return {
                nameStringCode: this.tokens.code.slice(nameToken.start, nameToken.end),
                variableName: (0, $acf87c2056b5efeb$export$2e2bcd8739ae039)(name) ? name : null
            };
        } else throw new Error("Expected name or string at beginning of enum element.");
    }
    /**
   * Handle an enum member where the RHS is just a string literal (not omitted, not a number, and
   * not a complex expression). This is the typical form for TS string enums, and in this case, we
   * do *not* create a reverse mapping.
   *
   * This is called after deleting the key token, when the token processor is at the equals sign.
   *
   * Example 1:
   * someKey = "some value"
   * ->
   * const someKey = "some value"; MyEnum["someKey"] = someKey;
   *
   * Example 2:
   * "some key" = "some value"
   * ->
   * MyEnum["some key"] = "some value";
   */ processStringLiteralEnumMember(enumName, nameStringCode, variableName) {
        if (variableName != null) {
            this.tokens.appendCode(`const ${variableName}`);
            // =
            this.tokens.copyToken();
            // value string
            this.tokens.copyToken();
            this.tokens.appendCode(`; ${enumName}[${nameStringCode}] = ${variableName};`);
        } else {
            this.tokens.appendCode(`${enumName}[${nameStringCode}]`);
            // =
            this.tokens.copyToken();
            // value string
            this.tokens.copyToken();
            this.tokens.appendCode(";");
        }
    }
    /**
   * Handle an enum member initialized with an expression on the right-hand side (other than a
   * string literal). In these cases, we should transform the expression and emit code that sets up
   * a reverse mapping.
   *
   * The TypeScript implementation of this operation distinguishes between expressions that can be
   * "constant folded" at compile time (i.e. consist of number literals and simple math operations
   * on those numbers) and ones that are dynamic. For constant expressions, it emits the resolved
   * numeric value, and auto-incrementing is only allowed in that case. Evaluating expressions at
   * compile time would add significant complexity to Sucrase, so Sucrase instead leaves the
   * expression as-is, and will later emit something like `MyEnum["previousKey"] + 1` to implement
   * auto-incrementing.
   *
   * This is called after deleting the key token, when the token processor is at the equals sign.
   *
   * Example 1:
   * someKey = 1 + 1
   * ->
   * const someKey = 1 + 1; MyEnum[MyEnum["someKey"] = someKey] = "someKey";
   *
   * Example 2:
   * "some key" = 1 + 1
   * ->
   * MyEnum[MyEnum["some key"] = 1 + 1] = "some key";
   */ processExplicitValueEnumMember(enumName, nameStringCode, variableName) {
        const rhsEndIndex = this.tokens.currentToken().rhsEndIndex;
        if (rhsEndIndex == null) throw new Error("Expected rhsEndIndex on enum assign.");
        if (variableName != null) {
            this.tokens.appendCode(`const ${variableName}`);
            this.tokens.copyToken();
            while(this.tokens.currentIndex() < rhsEndIndex)this.rootTransformer.processToken();
            this.tokens.appendCode(`; ${enumName}[${enumName}[${nameStringCode}] = ${variableName}] = ${nameStringCode};`);
        } else {
            this.tokens.appendCode(`${enumName}[${enumName}[${nameStringCode}]`);
            this.tokens.copyToken();
            while(this.tokens.currentIndex() < rhsEndIndex)this.rootTransformer.processToken();
            this.tokens.appendCode(`] = ${nameStringCode};`);
        }
    }
    /**
   * Handle an enum member with no right-hand side expression. In this case, the value is the
   * previous value plus 1, or 0 if there was no previous value. We should also always emit a
   * reverse mapping.
   *
   * Example 1:
   * someKey2
   * ->
   * const someKey2 = someKey1 + 1; MyEnum[MyEnum["someKey2"] = someKey2] = "someKey2";
   *
   * Example 2:
   * "some key 2"
   * ->
   * MyEnum[MyEnum["some key 2"] = someKey1 + 1] = "some key 2";
   */ processImplicitValueEnumMember(enumName, nameStringCode, variableName, previousValueCode) {
        let valueCode = previousValueCode != null ? `${previousValueCode} + 1` : "0";
        if (variableName != null) {
            this.tokens.appendCode(`const ${variableName} = ${valueCode}; `);
            valueCode = variableName;
        }
        this.tokens.appendCode(`${enumName}[${enumName}[${nameStringCode}] = ${valueCode}] = ${nameStringCode};`);
    }
}


class $a5e6d2638cd84d71$export$2e2bcd8739ae039 {
    __init() {
        this.transformers = [];
    }
    __init2() {
        this.generatedVariables = [];
    }
    constructor(sucraseContext, transforms, enableLegacyBabel5ModuleInterop, options){
        $a5e6d2638cd84d71$export$2e2bcd8739ae039.prototype.__init.call(this);
        $a5e6d2638cd84d71$export$2e2bcd8739ae039.prototype.__init2.call(this);
        this.nameManager = sucraseContext.nameManager;
        this.helperManager = sucraseContext.helperManager;
        const { tokenProcessor: tokenProcessor, importProcessor: importProcessor } = sucraseContext;
        this.tokens = tokenProcessor;
        this.isImportsTransformEnabled = transforms.includes("imports");
        this.isReactHotLoaderTransformEnabled = transforms.includes("react-hot-loader");
        this.disableESTransforms = Boolean(options.disableESTransforms);
        if (!options.disableESTransforms) {
            this.transformers.push(new (0, $edb110213a8d1cb5$export$2e2bcd8739ae039)(tokenProcessor, this.nameManager));
            this.transformers.push(new (0, $53c4c3289533904f$export$2e2bcd8739ae039)(tokenProcessor));
            this.transformers.push(new (0, $651f878a41d91535$export$2e2bcd8739ae039)(tokenProcessor, this.nameManager));
        }
        if (transforms.includes("jsx")) {
            if (options.jsxRuntime !== "preserve") this.transformers.push(new (0, $02817d809bdcb26e$export$2e2bcd8739ae039)(this, tokenProcessor, importProcessor, this.nameManager, options));
            this.transformers.push(new (0, $422c837f2180b524$export$2e2bcd8739ae039)(this, tokenProcessor, importProcessor, options));
        }
        let reactHotLoaderTransformer = null;
        if (transforms.includes("react-hot-loader")) {
            if (!options.filePath) throw new Error("filePath is required when using the react-hot-loader transform.");
            reactHotLoaderTransformer = new (0, $24f0573b6e9a1e84$export$2e2bcd8739ae039)(tokenProcessor, options.filePath);
            this.transformers.push(reactHotLoaderTransformer);
        }
        // Note that we always want to enable the imports transformer, even when the import transform
        // itself isn't enabled, since we need to do type-only import pruning for both Flow and
        // TypeScript.
        if (transforms.includes("imports")) {
            if (importProcessor === null) throw new Error("Expected non-null importProcessor with imports transform enabled.");
            this.transformers.push(new (0, $384b44440831876e$export$2e2bcd8739ae039)(this, tokenProcessor, importProcessor, this.nameManager, this.helperManager, reactHotLoaderTransformer, enableLegacyBabel5ModuleInterop, Boolean(options.enableLegacyTypeScriptModuleInterop), transforms.includes("typescript"), transforms.includes("flow"), Boolean(options.preserveDynamicImport), Boolean(options.keepUnusedImports)));
        } else this.transformers.push(new (0, $6b5deed831f29708$export$2e2bcd8739ae039)(tokenProcessor, this.nameManager, this.helperManager, reactHotLoaderTransformer, transforms.includes("typescript"), transforms.includes("flow"), Boolean(options.keepUnusedImports), options));
        if (transforms.includes("flow")) this.transformers.push(new (0, $764d21a88b0aec2e$export$2e2bcd8739ae039)(this, tokenProcessor, transforms.includes("imports")));
        if (transforms.includes("typescript")) this.transformers.push(new (0, $1996d8fdc2196ced$export$2e2bcd8739ae039)(this, tokenProcessor, transforms.includes("imports")));
        if (transforms.includes("jest")) this.transformers.push(new (0, $bc343969ef153cfd$export$2e2bcd8739ae039)(this, tokenProcessor, this.nameManager, importProcessor));
    }
    transform() {
        this.tokens.reset();
        this.processBalancedCode();
        const shouldAddUseStrict = this.isImportsTransformEnabled;
        // "use strict" always needs to be first, so override the normal transformer order.
        let prefix = shouldAddUseStrict ? '"use strict";' : "";
        for (const transformer of this.transformers)prefix += transformer.getPrefixCode();
        prefix += this.helperManager.emitHelpers();
        prefix += this.generatedVariables.map((v)=>` var ${v};`).join("");
        for (const transformer of this.transformers)prefix += transformer.getHoistedCode();
        let suffix = "";
        for (const transformer of this.transformers)suffix += transformer.getSuffixCode();
        const result = this.tokens.finish();
        let { code: code } = result;
        if (code.startsWith("#!")) {
            let newlineIndex = code.indexOf("\n");
            if (newlineIndex === -1) {
                newlineIndex = code.length;
                code += "\n";
            }
            return {
                code: code.slice(0, newlineIndex + 1) + prefix + code.slice(newlineIndex + 1) + suffix,
                // The hashbang line has no tokens, so shifting the tokens to account
                // for prefix can happen normally.
                mappings: this.shiftMappings(result.mappings, prefix.length)
            };
        } else return {
            code: prefix + code + suffix,
            mappings: this.shiftMappings(result.mappings, prefix.length)
        };
    }
    processBalancedCode() {
        let braceDepth = 0;
        let parenDepth = 0;
        while(!this.tokens.isAtEnd()){
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).dollarBraceL)) braceDepth++;
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) {
                if (braceDepth === 0) return;
                braceDepth--;
            }
            if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) parenDepth++;
            else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR)) {
                if (parenDepth === 0) return;
                parenDepth--;
            }
            this.processToken();
        }
    }
    processToken() {
        if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class)) {
            this.processClass();
            return;
        }
        for (const transformer of this.transformers){
            const wasProcessed = transformer.process();
            if (wasProcessed) return;
        }
        this.tokens.copyToken();
    }
    /**
   * Skip past a class with a name and return that name.
   */ processNamedClass() {
        if (!this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) throw new Error("Expected identifier for exported class name.");
        const name = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
        this.processClass();
        return name;
    }
    processClass() {
        const classInfo = (0, $e3f8f159d7f2a3fc$export$2e2bcd8739ae039)(this, this.tokens, this.nameManager, this.disableESTransforms);
        // Both static and instance initializers need a class name to use to invoke the initializer, so
        // assign to one if necessary.
        const needsCommaExpression = (classInfo.headerInfo.isExpression || !classInfo.headerInfo.className) && classInfo.staticInitializerNames.length + classInfo.instanceInitializerNames.length > 0;
        let className = classInfo.headerInfo.className;
        if (needsCommaExpression) {
            className = this.nameManager.claimFreeName("_class");
            this.generatedVariables.push(className);
            this.tokens.appendCode(` (${className} =`);
        }
        const classToken = this.tokens.currentToken();
        const contextId = classToken.contextId;
        if (contextId == null) throw new Error("Expected class to have a context ID.");
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._class);
        while(!this.tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL, contextId))this.processToken();
        this.processClassBody(classInfo, className);
        const staticInitializerStatements = classInfo.staticInitializerNames.map((name)=>`${className}.${name}()`);
        if (needsCommaExpression) this.tokens.appendCode(`, ${staticInitializerStatements.map((s)=>`${s}, `).join("")}${className})`);
        else if (classInfo.staticInitializerNames.length > 0) this.tokens.appendCode(` ${staticInitializerStatements.map((s)=>`${s};`).join(" ")}`);
    }
    /**
   * We want to just handle class fields in all contexts, since TypeScript supports them. Later,
   * when some JS implementations support class fields, this should be made optional.
   */ processClassBody(classInfo, className) {
        const { headerInfo: headerInfo, constructorInsertPos: constructorInsertPos, constructorInitializerStatements: constructorInitializerStatements, fields: fields, instanceInitializerNames: instanceInitializerNames, rangesToRemove: rangesToRemove } = classInfo;
        let fieldIndex = 0;
        let rangeToRemoveIndex = 0;
        const classContextId = this.tokens.currentToken().contextId;
        if (classContextId == null) throw new Error("Expected non-null context ID on class.");
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL);
        if (this.isReactHotLoaderTransformEnabled) this.tokens.appendCode("__reactstandin__regenerateByEval(key, code) {this[key] = eval(code);}");
        const needsConstructorInit = constructorInitializerStatements.length + instanceInitializerNames.length > 0;
        if (constructorInsertPos === null && needsConstructorInit) {
            const constructorInitializersCode = this.makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className);
            if (headerInfo.hasSuperclass) {
                const argsName = this.nameManager.claimFreeName("args");
                this.tokens.appendCode(`constructor(...${argsName}) { super(...${argsName}); ${constructorInitializersCode}; }`);
            } else this.tokens.appendCode(`constructor() { ${constructorInitializersCode}; }`);
        }
        while(!this.tokens.matchesContextIdAndLabel((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR, classContextId)){
            if (fieldIndex < fields.length && this.tokens.currentIndex() === fields[fieldIndex].start) {
                let needsCloseBrace = false;
                if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).bracketL)) this.tokens.copyTokenWithPrefix(`${fields[fieldIndex].initializerName}() {this`);
                else if (this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).string) || this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).num)) {
                    this.tokens.copyTokenWithPrefix(`${fields[fieldIndex].initializerName}() {this[`);
                    needsCloseBrace = true;
                } else this.tokens.copyTokenWithPrefix(`${fields[fieldIndex].initializerName}() {this.`);
                while(this.tokens.currentIndex() < fields[fieldIndex].end){
                    if (needsCloseBrace && this.tokens.currentIndex() === fields[fieldIndex].equalsIndex) this.tokens.appendCode("]");
                    this.processToken();
                }
                this.tokens.appendCode("}");
                fieldIndex++;
            } else if (rangeToRemoveIndex < rangesToRemove.length && this.tokens.currentIndex() >= rangesToRemove[rangeToRemoveIndex].start) {
                if (this.tokens.currentIndex() < rangesToRemove[rangeToRemoveIndex].end) this.tokens.removeInitialToken();
                while(this.tokens.currentIndex() < rangesToRemove[rangeToRemoveIndex].end)this.tokens.removeToken();
                rangeToRemoveIndex++;
            } else if (this.tokens.currentIndex() === constructorInsertPos) {
                this.tokens.copyToken();
                if (needsConstructorInit) this.tokens.appendCode(`;${this.makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className)};`);
                this.processToken();
            } else this.processToken();
        }
        this.tokens.copyExpectedToken((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR);
    }
    makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className) {
        return [
            ...constructorInitializerStatements,
            ...instanceInitializerNames.map((name)=>`${className}.prototype.${name}.call(this)`)
        ].join(";");
    }
    /**
   * Normally it's ok to simply remove type tokens, but we need to be more careful when dealing with
   * arrow function return types since they can confuse the parser. In that case, we want to move
   * the close-paren to the same line as the arrow.
   *
   * See https://github.com/alangpierce/sucrase/issues/391 for more details.
   */ processPossibleArrowParamEnd() {
        if (this.tokens.matches2((0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenR, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).colon) && this.tokens.tokenAtRelativeIndex(1).isType) {
            let nextNonTypeIndex = this.tokens.currentIndex() + 1;
            // Look ahead to see if this is an arrow function or something else.
            while(this.tokens.tokens[nextNonTypeIndex].isType)nextNonTypeIndex++;
            if (this.tokens.matches1AtIndex(nextNonTypeIndex, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).arrow)) {
                this.tokens.removeInitialToken();
                while(this.tokens.currentIndex() < nextNonTypeIndex)this.tokens.removeToken();
                this.tokens.replaceTokenTrimmingLeftWhitespace(") =>");
                return true;
            }
        }
        return false;
    }
    /**
   * An async arrow function might be of the form:
   *
   * async <
   *   T
   * >() => {}
   *
   * in which case, removing the type parameters will cause a syntax error. Detect this case and
   * move the open-paren earlier.
   */ processPossibleAsyncArrowWithTypeParams() {
        if (!this.tokens.matchesContextual((0, $67eb7b9d79b9f423$export$ee633ab6cd0138cc)._async) && !this.tokens.matches1((0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._async)) return false;
        const nextToken = this.tokens.tokenAtRelativeIndex(1);
        if (nextToken.type !== (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).lessThan || !nextToken.isType) return false;
        let nextNonTypeIndex = this.tokens.currentIndex() + 1;
        // Look ahead to see if this is an arrow function or something else.
        while(this.tokens.tokens[nextNonTypeIndex].isType)nextNonTypeIndex++;
        if (this.tokens.matches1AtIndex(nextNonTypeIndex, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) {
            this.tokens.replaceToken("async (");
            this.tokens.removeInitialToken();
            while(this.tokens.currentIndex() < nextNonTypeIndex)this.tokens.removeToken();
            this.tokens.removeToken();
            // We ate a ( token, so we need to process the tokens in between and then the ) token so that
            // we remain balanced.
            this.processBalancedCode();
            this.processToken();
            return true;
        }
        return false;
    }
    processPossibleTypeRange() {
        if (this.tokens.currentToken().isType) {
            this.tokens.removeInitialToken();
            while(this.tokens.currentToken().isType)this.tokens.removeToken();
            return true;
        }
        return false;
    }
    shiftMappings(mappings, prefixLength) {
        for(let i = 0; i < mappings.length; i++){
            const mapping = mappings[i];
            if (mapping !== undefined) mappings[i] = mapping + prefixLength;
        }
        return mappings;
    }
}


var $33c28e9842968610$export$1e511d4a378977f5;
var $33c28e9842968610$export$f2e513d2bc4a3b5a;
var $33c28e9842968610$export$2e2bcd8739ae039;
"use strict";
$33c28e9842968610$export$1e511d4a378977f5 = true;
$33c28e9842968610$export$f2e513d2bc4a3b5a = void 0;
var $33c28e9842968610$var$LF = '\n';
var $33c28e9842968610$var$CR = '\r';
var $33c28e9842968610$var$LinesAndColumns = /** @class */ function() {
    function LinesAndColumns(string) {
        this.string = string;
        var offsets = [
            0
        ];
        for(var offset = 0; offset < string.length;)switch(string[offset]){
            case $33c28e9842968610$var$LF:
                offset += $33c28e9842968610$var$LF.length;
                offsets.push(offset);
                break;
            case $33c28e9842968610$var$CR:
                offset += $33c28e9842968610$var$CR.length;
                if (string[offset] === $33c28e9842968610$var$LF) offset += $33c28e9842968610$var$LF.length;
                offsets.push(offset);
                break;
            default:
                offset++;
                break;
        }
        this.offsets = offsets;
    }
    LinesAndColumns.prototype.locationForIndex = function(index) {
        if (index < 0 || index > this.string.length) return null;
        var line = 0;
        var offsets = this.offsets;
        while(offsets[line + 1] <= index)line++;
        var column = index - offsets[line];
        return {
            line: line,
            column: column
        };
    };
    LinesAndColumns.prototype.indexForLocation = function(location) {
        var line = location.line, column = location.column;
        if (line < 0 || line >= this.offsets.length) return null;
        if (column < 0 || column > this.lengthOfLine(line)) return null;
        return this.offsets[line] + column;
    };
    LinesAndColumns.prototype.lengthOfLine = function(line) {
        var offset = this.offsets[line];
        var nextOffset = line === this.offsets.length - 1 ? this.string.length : this.offsets[line + 1];
        return nextOffset - offset;
    };
    return LinesAndColumns;
}();
$33c28e9842968610$export$f2e513d2bc4a3b5a = $33c28e9842968610$var$LinesAndColumns;
$33c28e9842968610$export$2e2bcd8739ae039 = $33c28e9842968610$var$LinesAndColumns;



function $9a57e5e064b612ba$export$2e2bcd8739ae039(code, tokens) {
    if (tokens.length === 0) return "";
    const tokenKeys = Object.keys(tokens[0]).filter((k)=>k !== "type" && k !== "value" && k !== "start" && k !== "end" && k !== "loc");
    const typeKeys = Object.keys(tokens[0].type).filter((k)=>k !== "label" && k !== "keyword");
    const headings = [
        "Location",
        "Label",
        "Raw",
        ...tokenKeys,
        ...typeKeys
    ];
    const lines = new (0, $33c28e9842968610$export$2e2bcd8739ae039)(code);
    const rows = [
        headings,
        ...tokens.map(getTokenComponents)
    ];
    const padding = headings.map(()=>0);
    for (const components of rows)for(let i = 0; i < components.length; i++)padding[i] = Math.max(padding[i], components[i].length);
    return rows.map((components)=>components.map((component, i)=>component.padEnd(padding[i])).join(" ")).join("\n");
    function getTokenComponents(token) {
        const raw = code.slice(token.start, token.end);
        return [
            formatRange(token.start, token.end),
            (0, $f33b9d3e01f21be3$export$b78065ce79336a93)(token.type),
            $9a57e5e064b612ba$var$truncate(String(raw), 14),
            // @ts-ignore: Intentional dynamic access by key.
            ...tokenKeys.map((key)=>formatValue(token[key], key)),
            // @ts-ignore: Intentional dynamic access by key.
            ...typeKeys.map((key)=>formatValue(token.type[key], key))
        ];
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function formatValue(value, key) {
        if (value === true) return key;
        else if (value === false || value === null) return "";
        else return String(value);
    }
    function formatRange(start, end) {
        return `${formatPos(start)}-${formatPos(end)}`;
    }
    function formatPos(pos) {
        const location = lines.locationForIndex(pos);
        if (!location) return "Unknown";
        else return `${location.line + 1}:${location.column + 1}`;
    }
}
function $9a57e5e064b612ba$var$truncate(s, length) {
    if (s.length > length) return `${s.slice(0, length - 3)}...`;
    else return s;
}




function $73c2dfebe4b62df2$export$2e2bcd8739ae039(tokens) {
    const importedNames = new Set();
    for(let i = 0; i < tokens.tokens.length; i++)if (tokens.matches1AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import) && !tokens.matches3AtIndex(i, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f)._import, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).eq)) $73c2dfebe4b62df2$var$collectNamesForImport(tokens, i, importedNames);
    return importedNames;
}
function $73c2dfebe4b62df2$var$collectNamesForImport(tokens, index, importedNames) {
    index++;
    if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).parenL)) // Dynamic import, so nothing to do
    return;
    if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).name)) {
        importedNames.add(tokens.identifierNameAtIndex(index));
        index++;
        if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) index++;
    }
    if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).star)) {
        // * as
        index += 2;
        importedNames.add(tokens.identifierNameAtIndex(index));
        index++;
    }
    if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceL)) {
        index++;
        $73c2dfebe4b62df2$var$collectNamesForNamedImport(tokens, index, importedNames);
    }
}
function $73c2dfebe4b62df2$var$collectNamesForNamedImport(tokens, index, importedNames) {
    while(true){
        if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) return;
        const specifierInfo = (0, $cdb710e84f40793b$export$2e2bcd8739ae039)(tokens, index);
        index = specifierInfo.endIndex;
        if (!specifierInfo.isType) importedNames.add(specifierInfo.rightName);
        if (tokens.matches2AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) return;
        else if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).braceR)) return;
        else if (tokens.matches1AtIndex(index, (0, $f33b9d3e01f21be3$export$f435f793048e7a0f).comma)) index++;
        else throw new Error(`Unexpected token: ${JSON.stringify(tokens.tokens[index])}`);
    }
}


function $7a5ccb00366653d1$export$c506eb22e615ba4a() {
    /* istanbul ignore next */ return "3.35.1";
}
function $7a5ccb00366653d1$export$51186ad6e864892a(code, options) {
    (0, $10bb70de42713567$export$1dd09873c1bdd0fc)(options);
    try {
        const sucraseContext = $7a5ccb00366653d1$var$getSucraseContext(code, options);
        const transformer = new (0, $a5e6d2638cd84d71$export$2e2bcd8739ae039)(sucraseContext, options.transforms, Boolean(options.enableLegacyBabel5ModuleInterop), options);
        const transformerResult = transformer.transform();
        let result = {
            code: transformerResult.code
        };
        if (options.sourceMapOptions) {
            if (!options.filePath) throw new Error("filePath must be specified when generating a source map.");
            result = {
                ...result,
                sourceMap: (0, $983df390ff0493b7$export$2e2bcd8739ae039)(transformerResult, options.filePath, options.sourceMapOptions, code, sucraseContext.tokenProcessor.tokens)
            };
        }
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        if (options.filePath) e.message = `Error transforming ${options.filePath}: ${e.message}`;
        throw e;
    }
}
function $7a5ccb00366653d1$export$fd97d3ecabd3e6b7(code, options) {
    const tokens = $7a5ccb00366653d1$var$getSucraseContext(code, options).tokenProcessor.tokens;
    return (0, $9a57e5e064b612ba$export$2e2bcd8739ae039)(code, tokens);
}
/**
 * Call into the parser/tokenizer and do some further preprocessing:
 * - Come up with a set of used names so that we can assign new names.
 * - Preprocess all import/export statements so we know which globals we are interested in.
 * - Compute situations where any of those globals are shadowed.
 *
 * In the future, some of these preprocessing steps can be skipped based on what actual work is
 * being done.
 */ function $7a5ccb00366653d1$var$getSucraseContext(code, options) {
    const isJSXEnabled = options.transforms.includes("jsx");
    const isTypeScriptEnabled = options.transforms.includes("typescript");
    const isFlowEnabled = options.transforms.includes("flow");
    const disableESTransforms = options.disableESTransforms === true;
    const file = (0, $201427b598292105$export$98e6a39c04603d36)(code, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled);
    const tokens = file.tokens;
    const scopes = file.scopes;
    const nameManager = new (0, $98ad476c234688bb$export$2e2bcd8739ae039)(code, tokens);
    const helperManager = new (0, $1425b7397a2936d9$export$b203ad16abdeb845)(nameManager);
    const tokenProcessor = new (0, $8e1a59465c201e5d$export$2e2bcd8739ae039)(code, tokens, isFlowEnabled, disableESTransforms, helperManager);
    const enableLegacyTypeScriptModuleInterop = Boolean(options.enableLegacyTypeScriptModuleInterop);
    let importProcessor = null;
    if (options.transforms.includes("imports")) {
        importProcessor = new (0, $cbf8fee06b97a5bb$export$2e2bcd8739ae039)(nameManager, tokenProcessor, enableLegacyTypeScriptModuleInterop, options, options.transforms.includes("typescript"), Boolean(options.keepUnusedImports), helperManager);
        importProcessor.preprocessTokens();
        // We need to mark shadowed globals after processing imports so we know that the globals are,
        // but before type-only import pruning, since that relies on shadowing information.
        (0, $e17888755afee10f$export$2e2bcd8739ae039)(tokenProcessor, scopes, importProcessor.getGlobalNames());
        if (options.transforms.includes("typescript") && !options.keepUnusedImports) importProcessor.pruneTypeOnlyImports();
    } else if (options.transforms.includes("typescript") && !options.keepUnusedImports) // Shadowed global detection is needed for TS implicit elision of imported names.
    (0, $e17888755afee10f$export$2e2bcd8739ae039)(tokenProcessor, scopes, (0, $73c2dfebe4b62df2$export$2e2bcd8739ae039)(tokenProcessor));
    return {
        tokenProcessor: tokenProcessor,
        scopes: scopes,
        nameManager: nameManager,
        importProcessor: importProcessor,
        helperManager: helperManager
    };
}


var $6bb879f8d8001cb0$var$__defProp = Object.defineProperty;
var $6bb879f8d8001cb0$var$__defProps = Object.defineProperties;
var $6bb879f8d8001cb0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $6bb879f8d8001cb0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6bb879f8d8001cb0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6bb879f8d8001cb0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6bb879f8d8001cb0$var$__defNormalProp = (obj, key, value)=>key in obj ? $6bb879f8d8001cb0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6bb879f8d8001cb0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6bb879f8d8001cb0$var$__hasOwnProp.call(b, prop)) $6bb879f8d8001cb0$var$__defNormalProp(a, prop, b[prop]);
    if ($6bb879f8d8001cb0$var$__getOwnPropSymbols) {
        for (var prop of $6bb879f8d8001cb0$var$__getOwnPropSymbols(b))if ($6bb879f8d8001cb0$var$__propIsEnum.call(b, prop)) $6bb879f8d8001cb0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6bb879f8d8001cb0$var$__spreadProps = (a, b)=>$6bb879f8d8001cb0$var$__defProps(a, $6bb879f8d8001cb0$var$__getOwnPropDescs(b));
var $6bb879f8d8001cb0$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($6bb879f8d8001cb0$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $6bb879f8d8001cb0$var$__getOwnPropSymbols) {
        for (var prop of $6bb879f8d8001cb0$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $6bb879f8d8001cb0$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $6bb879f8d8001cb0$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $6bb879f8d8001cb0$var$CodeEditor = (props)=>{
    const { tabMode: tabMode = "indentation" } = props;
    const editorRef = (0, $7DB8U.useRef)(null);
    const [code, setCode] = (0, $7DB8U.useState)(props.code || "");
    const { theme: theme } = props;
    (0, $7DB8U.useEffect)(()=>{
        setCode(props.code);
    }, [
        props.code
    ]);
    (0, $5712f090dbad2673$export$52a148af2bad544)(editorRef, (text)=>{
        const t = text.slice(0, -1);
        setCode(t);
        if (props.onChange) props.onChange(t);
    }, {
        disabled: props.disabled,
        indentation: tabMode === "indentation" ? 2 : void 0
    });
    return /* @__PURE__ */ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
        className: props.className,
        style: props.style,
        children: /* @__PURE__ */ (0, $e830bf8f8acfe41d$exports.jsx)((0, $62601dcfdc5761fa$export$39dbc3f558091353), {
            code: code,
            theme: props.theme || (0, $62601dcfdc5761fa$export$d9a33280f07116d9).nightOwl,
            language: props.language,
            children: ({ className: _className, tokens: tokens, getLineProps: getLineProps, getTokenProps: getTokenProps, style: _style })=>/* @__PURE__ */ (0, $e830bf8f8acfe41d$exports.jsx)("pre", {
                    className: _className,
                    style: $6bb879f8d8001cb0$var$__spreadValues($6bb879f8d8001cb0$var$__spreadValues({
                        margin: 0,
                        outline: "none",
                        padding: 10,
                        fontFamily: "inherit"
                    }, theme && typeof theme.plain === "object" ? theme.plain : {}), _style),
                    ref: editorRef,
                    spellCheck: "false",
                    children: tokens.map((line, lineIndex)=>/* @__PURE__ */ (0, $e830bf8f8acfe41d$exports.jsxs)("span", $6bb879f8d8001cb0$var$__spreadProps($6bb879f8d8001cb0$var$__spreadValues({}, getLineProps({
                            line: line
                        })), {
                            children: [
                                line.filter((token)=>!token.empty).map((token, tokenIndex)=>/* @__PURE__ */ (0, $e830bf8f8acfe41d$exports.jsx)("span", $6bb879f8d8001cb0$var$__spreadValues({}, getTokenProps({
                                        token: token
                                    })), `token-${tokenIndex}`)),
                                "\n"
                            ]
                        }), `line-${lineIndex}`))
                })
        })
    });
};
var $6bb879f8d8001cb0$export$7cda8d932e2f33c0 = $6bb879f8d8001cb0$var$CodeEditor;
var $6bb879f8d8001cb0$var$LiveContext = (0, $7DB8U.createContext)({});
var $6bb879f8d8001cb0$export$5a6106fef69bde7b = $6bb879f8d8001cb0$var$LiveContext;
var $6bb879f8d8001cb0$var$defaultTransforms = [
    "jsx",
    "imports"
];
function $6bb879f8d8001cb0$var$transform(opts = {}) {
    const transforms = Array.isArray(opts.transforms) ? opts.transforms.filter(Boolean) : $6bb879f8d8001cb0$var$defaultTransforms;
    return (code)=>(0, $7a5ccb00366653d1$export$51186ad6e864892a)(code, {
            transforms: transforms
        }).code;
}
var $6bb879f8d8001cb0$var$errorBoundary = (Element, errorCallback)=>{
    return class ErrorBoundary extends (0, $7DB8U.Component) {
        componentDidCatch(error) {
            errorCallback(error);
        }
        render() {
            return typeof Element === "function" ? /* @__PURE__ */ (0, $e830bf8f8acfe41d$exports.jsx)(Element, {}) : (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).isValidElement(Element) ? Element : null;
        }
    };
};
var $6bb879f8d8001cb0$var$errorBoundary_default = $6bb879f8d8001cb0$var$errorBoundary;
// src/utils/transpile/evalCode.ts
var $6bb879f8d8001cb0$var$evalCode = (code, scope)=>{
    const scopeKeys = Object.keys(scope);
    const scopeValues = scopeKeys.map((key)=>scope[key]);
    return new Function(...scopeKeys, code)(...scopeValues);
};
var $6bb879f8d8001cb0$var$evalCode_default = $6bb879f8d8001cb0$var$evalCode;
// src/utils/transpile/compose.ts
function $6bb879f8d8001cb0$var$compose(...functions) {
    return functions.reduce((acc, currentFn)=>(...args)=>acc(currentFn(...args)));
}
// src/utils/transpile/index.ts
var $6bb879f8d8001cb0$var$jsxConst = 'const _jsxFileName = "";';
var $6bb879f8d8001cb0$var$trimCode = (code)=>code.trim().replace(/;$/, "");
var $6bb879f8d8001cb0$var$spliceJsxConst = (code)=>code.replace($6bb879f8d8001cb0$var$jsxConst, "").trim();
var $6bb879f8d8001cb0$var$addJsxConst = (code)=>$6bb879f8d8001cb0$var$jsxConst + code;
var $6bb879f8d8001cb0$var$wrapReturn = (code)=>`return (${code})`;
var $6bb879f8d8001cb0$export$129b3480f9fbae0c = ({ code: code = "", scope: scope = {}, enableTypeScript: enableTypeScript = true }, errorCallback)=>{
    const firstPassTransforms = [
        "jsx"
    ];
    enableTypeScript && firstPassTransforms.push("typescript");
    const transformed = $6bb879f8d8001cb0$var$compose($6bb879f8d8001cb0$var$addJsxConst, $6bb879f8d8001cb0$var$transform({
        transforms: [
            "imports"
        ]
    }), $6bb879f8d8001cb0$var$spliceJsxConst, $6bb879f8d8001cb0$var$trimCode, $6bb879f8d8001cb0$var$transform({
        transforms: firstPassTransforms
    }), $6bb879f8d8001cb0$var$wrapReturn, $6bb879f8d8001cb0$var$trimCode)(code);
    return $6bb879f8d8001cb0$var$errorBoundary_default($6bb879f8d8001cb0$var$evalCode_default(transformed, $6bb879f8d8001cb0$var$__spreadValues({
        React: (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U)))
    }, scope)), errorCallback);
};
var $6bb879f8d8001cb0$export$f4350c01fab98156 = ({ code: code = "", scope: scope = {}, enableTypeScript: enableTypeScript = true }, resultCallback, errorCallback)=>{
    const render = (element)=>{
        if (typeof element === "undefined") errorCallback(new SyntaxError("`render` must be called with valid JSX."));
        else resultCallback($6bb879f8d8001cb0$var$errorBoundary_default(element, errorCallback));
    };
    if (!/render\s*\(/.test(code)) return errorCallback(new SyntaxError("No-Inline evaluations must call `render`."));
    const transforms = [
        "jsx",
        "imports"
    ];
    enableTypeScript && transforms.splice(1, 0, "typescript");
    $6bb879f8d8001cb0$var$evalCode_default($6bb879f8d8001cb0$var$transform({
        transforms: transforms
    })(code), $6bb879f8d8001cb0$var$__spreadProps($6bb879f8d8001cb0$var$__spreadValues({
        React: (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U)))
    }, scope), {
        render: render
    }));
};
function $6bb879f8d8001cb0$var$LiveProvider({ children: children, code: code = "", language: language = "tsx", theme: theme, enableTypeScript: enableTypeScript = true, disabled: disabled = false, scope: scope, transformCode: transformCode, noInline: noInline = false }) {
    const [state, setState] = (0, $7DB8U.useState)({
        error: void 0,
        element: void 0
    });
    function transpileAsync(newCode) {
        return $6bb879f8d8001cb0$var$__async(this, null, function*() {
            const errorCallback = (error)=>{
                setState((previousState)=>$6bb879f8d8001cb0$var$__spreadProps($6bb879f8d8001cb0$var$__spreadValues({}, previousState), {
                        error: error.toString(),
                        element: void 0
                    }));
            };
            try {
                const transformResult = transformCode ? transformCode(newCode) : newCode;
                try {
                    const transformedCode = yield Promise.resolve(transformResult);
                    const renderElement = (element)=>setState({
                            error: void 0,
                            element: element,
                            newCode: newCode
                        });
                    if (typeof transformedCode !== "string") throw new Error("Code failed to transform");
                    const input = {
                        code: transformedCode,
                        scope: scope,
                        enableTypeScript: enableTypeScript
                    };
                    if (noInline) {
                        setState((previousState)=>$6bb879f8d8001cb0$var$__spreadProps($6bb879f8d8001cb0$var$__spreadValues({}, previousState), {
                                error: void 0,
                                element: null
                            }));
                        $6bb879f8d8001cb0$export$f4350c01fab98156(input, renderElement, errorCallback);
                    } else renderElement($6bb879f8d8001cb0$export$129b3480f9fbae0c(input, errorCallback));
                } catch (error) {
                    return errorCallback(error);
                }
            } catch (e) {
                errorCallback(e);
                return Promise.resolve();
            }
        });
    }
    const onError = (error)=>setState({
            error: error.toString()
        });
    (0, $7DB8U.useEffect)(()=>{
        transpileAsync(code).catch(onError);
    }, [
        code,
        scope,
        noInline,
        transformCode
    ]);
    const onChange = (newCode)=>{
        transpileAsync(newCode).catch(onError);
    };
    return /* @__PURE__ */ (0, $e830bf8f8acfe41d$exports.jsx)($6bb879f8d8001cb0$export$5a6106fef69bde7b.Provider, {
        value: $6bb879f8d8001cb0$var$__spreadProps($6bb879f8d8001cb0$var$__spreadValues({}, state), {
            code: code,
            language: language,
            theme: theme,
            disabled: disabled,
            onError: onError,
            onChange: onChange
        }),
        children: children
    });
}
var $6bb879f8d8001cb0$export$7f6f1b77ca3c3ed3 = $6bb879f8d8001cb0$var$LiveProvider;
function $6bb879f8d8001cb0$export$f8f60579bb81d0e5(props) {
    const { code: code, language: language, theme: theme, disabled: disabled, onChange: onChange } = (0, $7DB8U.useContext)($6bb879f8d8001cb0$export$5a6106fef69bde7b);
    return /* @__PURE__ */ (0, $e830bf8f8acfe41d$exports.jsx)($6bb879f8d8001cb0$export$7cda8d932e2f33c0, $6bb879f8d8001cb0$var$__spreadValues({
        theme: theme,
        code: code,
        language: language,
        disabled: disabled,
        onChange: onChange
    }, props));
}
function $6bb879f8d8001cb0$export$1991b613205b2adc(props) {
    const { error: error } = (0, $7DB8U.useContext)($6bb879f8d8001cb0$export$5a6106fef69bde7b);
    return error ? /* @__PURE__ */ (0, $e830bf8f8acfe41d$exports.jsx)("pre", $6bb879f8d8001cb0$var$__spreadProps($6bb879f8d8001cb0$var$__spreadValues({}, props), {
        children: error
    })) : null;
}
var $6bb879f8d8001cb0$var$ErrorBoundary = class extends (0, $7DB8U.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(err) {
        var _a, _b;
        (_b = (_a = this.props).onError) == null || _b.call(_a, err);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
};
function $6bb879f8d8001cb0$var$LivePreview(_a) {
    var _b = _a, { Component: Component3 = "div" } = _b, rest = $6bb879f8d8001cb0$var$__objRest(_b, [
        "Component"
    ]);
    const { element: Element, onError: onError, newCode: newCode } = (0, $7DB8U.useContext)($6bb879f8d8001cb0$export$5a6106fef69bde7b);
    return /* @__PURE__ */ (0, $e830bf8f8acfe41d$exports.jsx)($6bb879f8d8001cb0$var$ErrorBoundary, {
        onError: onError,
        children: /* @__PURE__ */ (0, $e830bf8f8acfe41d$exports.jsx)(Component3, $6bb879f8d8001cb0$var$__spreadProps($6bb879f8d8001cb0$var$__spreadValues({}, rest), {
            children: Element ? /* @__PURE__ */ (0, $e830bf8f8acfe41d$exports.jsx)(Element, {}) : null
        }))
    }, newCode);
}
var $6bb879f8d8001cb0$export$ba3ca6901d2e4f5f = $6bb879f8d8001cb0$var$LivePreview;
function $6bb879f8d8001cb0$export$3039ad97e9f7b4e0(WrappedComponent) {
    const WithLive = (props)=>/* @__PURE__ */ (0, $e830bf8f8acfe41d$exports.jsx)($6bb879f8d8001cb0$export$5a6106fef69bde7b.Consumer, {
            children: (live)=>/* @__PURE__ */ (0, $e830bf8f8acfe41d$exports.jsx)(WrappedComponent, $6bb879f8d8001cb0$var$__spreadValues({
                    live: live
                }, props))
        });
    WithLive.displayName = "WithLive";
    return WithLive;
}


const $e5a57d506e25a9c5$export$965592ed152e8e7f = ({ scope: scope, children: children })=>{
    const element = /*#__PURE__*/ (0, $7DB8U.isValidElement)(children) ? children : (0, $e830bf8f8acfe41d$exports.jsx)((0, $e830bf8f8acfe41d$exports.Fragment), {
        children: children
    });
    const code = typeof children === 'string' ? children : (0, (/*@__PURE__*/$parcel$interopDefault($b1e7891750e609f8$exports)))(element);
    return (0, $e830bf8f8acfe41d$exports.jsxs)((0, $6bb879f8d8001cb0$export$7f6f1b77ca3c3ed3), {
        code: code,
        scope: scope,
        language: "tsx",
        children: [
            (0, $e830bf8f8acfe41d$exports.jsx)((0, $6bb879f8d8001cb0$export$ba3ca6901d2e4f5f), {
                className: "mb-3"
            }),
            (0, $e830bf8f8acfe41d$exports.jsx)((0, $6bb879f8d8001cb0$export$f8f60579bb81d0e5), {}),
            (0, $e830bf8f8acfe41d$exports.jsx)((0, $6bb879f8d8001cb0$export$1991b613205b2adc), {
                className: "text-danger small p-2"
            })
        ]
    });
};


var $819e3941170a1790$exports = {};

$parcel$export($819e3941170a1790$exports, "Loading", () => $819e3941170a1790$export$669f6ea7d267feaf);



var $7DB8U = parcelRequire("7DB8U");


"use client";
const $3a47f5a8134d38e5$var$Spinner = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$3a47f5a8134d38e5$var$Spinner.displayName = 'Spinner';
var $3a47f5a8134d38e5$export$2e2bcd8739ae039 = $3a47f5a8134d38e5$var$Spinner;


var $819e3941170a1790$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $819e3941170a1790$export$669f6ea7d267feaf = (_a)=>{
    var { className: className = '', children: children = 'Loading...' } = _a, props = $819e3941170a1790$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $e830bf8f8acfe41d$exports.jsxs)("div", Object.assign({
        className: `fixed-top h-100 w-100 d-flex justify-content-center align-items-center opacity-25 bg-black ${className}`
    }, props, {
        children: [
            (0, $e830bf8f8acfe41d$exports.jsx)((0, $3a47f5a8134d38e5$export$2e2bcd8739ae039), {
                animation: "border",
                variant: "success"
            }),
            (0, $e830bf8f8acfe41d$exports.jsx)("span", {
                className: "ml-3 text-white",
                children: children
            })
        ]
    }));
};
$819e3941170a1790$export$669f6ea7d267feaf.displayName = 'Loading';


var $e3aad0f6e5ad05e1$exports = {};

$parcel$export($e3aad0f6e5ad05e1$exports, "MonthCalendar", () => $e3aad0f6e5ad05e1$export$d7a7c85c0f5afc4a);







var $7DB8U = parcelRequire("7DB8U");


"use client";
const $5056c1721372f116$var$Badge = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, bg: bg = 'primary', pill: pill = false, text: text, className: className, as: Component = 'span', ...props }, ref)=>{
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$5056c1721372f116$var$Badge.displayName = 'Badge';
var $5056c1721372f116$export$2e2bcd8739ae039 = $5056c1721372f116$var$Badge;



var $7DB8U = parcelRequire("7DB8U");


"use client";
const $72916eeed8431ee6$var$Table = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, striped: striped, bordered: bordered, borderless: borderless, hover: hover, size: size, variant: variant, responsive: responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'table');
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === 'string' ? `striped-${striped}` : 'striped'}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === 'string') responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
$72916eeed8431ee6$var$Table.displayName = 'Table';
var $72916eeed8431ee6$export$2e2bcd8739ae039 = $72916eeed8431ee6$var$Table;




var $0053152b16d9815b$exports = {};

$parcel$export($0053152b16d9815b$exports, "OverlayBox", () => $0053152b16d9815b$export$5169ff31790bf260);

/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $97c75dca58f4c376$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}


var $38b29c2dc0019b47$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38b29c2dc0019b47$var$ReactIs, $38b29c2dc0019b47$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$38b29c2dc0019b47$exports = (parcelRequire("dflA0"))();



var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");
function $f8f5abfe1156ae0b$export$2e2bcd8739ae039() {
    const mounted = (0, $7DB8U.useRef)(true);
    const isMounted = (0, $7DB8U.useRef)(()=>mounted.current);
    (0, $7DB8U.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $7DB8U = parcelRequire("7DB8U");
function $9c1902cbf401b305$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $7DB8U.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $7DB8U = parcelRequire("7DB8U");
function $d6e9a857bdf29c15$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $9c1902cbf401b305$export$2e2bcd8739ae039)(fn);
    (0, $7DB8U.useEffect)(()=>()=>onUnmount.current(), []);
}


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $c26ada26dd336b02$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $c26ada26dd336b02$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $c26ada26dd336b02$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$c26ada26dd336b02$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $c26ada26dd336b02$var$MAX_DELAY_MS);
}
function $c26ada26dd336b02$export$2e2bcd8739ae039() {
    const isMounted = (0, $f8f5abfe1156ae0b$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $7DB8U.useRef)();
    (0, $d6e9a857bdf29c15$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $7DB8U.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $c26ada26dd336b02$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $c26ada26dd336b02$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}


var $9abc3dc86fc6eb1f$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $9abc3dc86fc6eb1f$var$__DEV__ = false;
var $9abc3dc86fc6eb1f$var$warning = function() {};
if ($9abc3dc86fc6eb1f$var$__DEV__) {
    var $9abc3dc86fc6eb1f$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $9abc3dc86fc6eb1f$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $9abc3dc86fc6eb1f$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$9abc3dc86fc6eb1f$exports = $9abc3dc86fc6eb1f$var$warning;


function $d09db7fb44cd38da$export$2e2bcd8739ae039() {
    return $d09db7fb44cd38da$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d09db7fb44cd38da$export$2e2bcd8739ae039.apply(null, arguments);
}




var $7DB8U = parcelRequire("7DB8U");
var $0e34bdc1602f642d$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $0e34bdc1602f642d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$0e34bdc1602f642d$exports = $0e34bdc1602f642d$var$invariant;


var $deb8f4c073feaf52$var$noop = function noop() {};
function $deb8f4c073feaf52$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $deb8f4c073feaf52$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $deb8f4c073feaf52$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$deb8f4c073feaf52$export$26cbf8c37e721e67(prop)] = $deb8f4c073feaf52$var$noop;
        var handler;
    });
    return propTypes;
}
function $deb8f4c073feaf52$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $deb8f4c073feaf52$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $deb8f4c073feaf52$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $be0af947f6d59f9f$var$_toPropertyKey(arg) {
    var key = $be0af947f6d59f9f$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $be0af947f6d59f9f$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $be0af947f6d59f9f$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $7DB8U.useRef)(propValue !== undefined);
    var _useState = (0, $7DB8U.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $7DB8U.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $be0af947f6d59f9f$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$deb8f4c073feaf52$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $00f30e90ee9941ee$export$2e2bcd8739ae039)(_ref, [
            $deb8f4c073feaf52$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($be0af947f6d59f9f$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $be0af947f6d59f9f$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $d09db7fb44cd38da$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}






var $7DB8U = parcelRequire("7DB8U");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $51cb67738c4a415e$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $51cb67738c4a415e$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $51cb67738c4a415e$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$51cb67738c4a415e$var$componentWillMount.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $51cb67738c4a415e$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $51cb67738c4a415e$var$componentWillMount;
        prototype.componentWillReceiveProps = $51cb67738c4a415e$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $51cb67738c4a415e$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $198c125905926bc2$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $198c125905926bc2$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $deb8f4c073feaf52$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($deb8f4c073feaf52$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($0e34bdc1602f642d$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $92d77d83ed66349d$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $d09db7fb44cd38da$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$deb8f4c073feaf52$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $d09db7fb44cd38da$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$deb8f4c073feaf52$export$12ae2baa35bd9b8b(props, key) && $deb8f4c073feaf52$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$deb8f4c073feaf52$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $00f30e90ee9941ee$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).createElement(Component, (0, $d09db7fb44cd38da$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).Component);
    (0, $51cb67738c4a415e$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $d09db7fb44cd38da$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $deb8f4c073feaf52$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).createElement(UncontrolledComponent, (0, $d09db7fb44cd38da$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $198c125905926bc2$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $198c125905926bc2$export$2e2bcd8739ae039(newComponent, (0, $d09db7fb44cd38da$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}







var $7DB8U = parcelRequire("7DB8U");


var $7DB8U = parcelRequire("7DB8U");

var $9lImh = parcelRequire("9lImh");

var $7DB8U = parcelRequire("7DB8U");
function $ef5fbefb53d1c0cc$export$2e2bcd8739ae039() {
    return (0, $7DB8U.useState)(null);
}



var $7DB8U = parcelRequire("7DB8U");
const $c1a0fd2af677389b$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $c1a0fd2af677389b$export$c9058316764c140e(refA, refB) {
    const a = $c1a0fd2af677389b$var$toFnRef(refA);
    const b = $c1a0fd2af677389b$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $c1a0fd2af677389b$var$useMergedRefs(refA, refB) {
    return (0, $7DB8U.useMemo)(()=>$c1a0fd2af677389b$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $c1a0fd2af677389b$export$2e2bcd8739ae039 = $c1a0fd2af677389b$var$useMergedRefs;



var $7DB8U = parcelRequire("7DB8U");
var $9b8288c93dde0611$var$has = Object.prototype.hasOwnProperty;
function $9b8288c93dde0611$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($9b8288c93dde0611$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $9b8288c93dde0611$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $9b8288c93dde0611$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $9b8288c93dde0611$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $9b8288c93dde0611$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$9b8288c93dde0611$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($9b8288c93dde0611$var$has.call(foo, ctor) && ++len && !$9b8288c93dde0611$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$9b8288c93dde0611$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");
function $84a01fe90a97ff84$export$2e2bcd8739ae039() {
    const mounted = (0, $7DB8U.useRef)(true);
    const isMounted = (0, $7DB8U.useRef)(()=>mounted.current);
    (0, $7DB8U.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $5390f073d3d5fc4e$var$useSafeState(state) {
    const isMounted = (0, $84a01fe90a97ff84$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $7DB8U.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $5390f073d3d5fc4e$export$2e2bcd8739ae039 = $5390f073d3d5fc4e$var$useSafeState;



function $3b8fe2dc5ff68c07$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $d73e6687a1d925d1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b2a82a0945aa8fd0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b2a82a0945aa8fd0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $049d14be9b4f15bb$export$8960430cfd85939f = Math.max;
var $049d14be9b4f15bb$export$96ec731ed4dcb222 = Math.min;
var $049d14be9b4f15bb$export$2077e0241d6afd3c = Math.round;



function $17847447eb3676eb$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $3822c5a08263882b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
}


function $28398e533bd4cb4a$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $3822c5a08263882b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $0c96e22a9b1659c4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $edb26c5020cedcb8$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $37108a593d5d5f50$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $d62284b4ca370c21$export$2e2bcd8739ae039(element) {
    return (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $94c820df5d403ed2$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(element)) >= 0;
}




function $939c0e8e0ce2cee6$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $f85bc6099bdeb764$export$2e2bcd8739ae039(element) {
    if ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $8debf15f2d350881$var$getTrueOffsetParent(element) {
    if (!(0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $8debf15f2d350881$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
    if (isIE && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(element);
    if ((0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $8debf15f2d350881$export$2e2bcd8739ae039(element) {
    var window = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element);
    var offsetParent = $8debf15f2d350881$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $94c820df5d403ed2$export$2e2bcd8739ae039)(offsetParent) && (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $8debf15f2d350881$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $8debf15f2d350881$var$getContainingBlock(element) || window;
}


function $f69c37e7bc9eb348$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $32a9692ec37d141e$export$f28d906d67a997f3(min, value, max) {
    return (0, $049d14be9b4f15bb$export$8960430cfd85939f)(min, (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(value, max));
}
function $32a9692ec37d141e$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $32a9692ec37d141e$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $559cca984964a2c1$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $4e3f355f6e420d75$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $559cca984964a2c1$export$2e2bcd8739ae039)(), paddingObject);
}


function $868fda9c4887b436$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $961d5315ffabf519$export$1e95b668f3b82d = 'top';
var $961d5315ffabf519$export$40e543e69a8b3fbb = 'bottom';
var $961d5315ffabf519$export$79ffe56a765070d2 = 'right';
var $961d5315ffabf519$export$eabcd2c8791e7bf4 = 'left';
var $961d5315ffabf519$export$dfb5619354ba860 = 'auto';
var $961d5315ffabf519$export$aec2ce47c367b8c3 = [
    $961d5315ffabf519$export$1e95b668f3b82d,
    $961d5315ffabf519$export$40e543e69a8b3fbb,
    $961d5315ffabf519$export$79ffe56a765070d2,
    $961d5315ffabf519$export$eabcd2c8791e7bf4
];
var $961d5315ffabf519$export$b3571188c770cc5a = 'start';
var $961d5315ffabf519$export$bd5df0f255a350f8 = 'end';
var $961d5315ffabf519$export$390fd549c5303b4d = 'clippingParents';
var $961d5315ffabf519$export$d7b7311ec04a3e8f = 'viewport';
var $961d5315ffabf519$export$ae5ab1c730825774 = 'popper';
var $961d5315ffabf519$export$ca50aac9f3ba507f = 'reference';
var $961d5315ffabf519$export$368f9a87e87fa4e1 = /*#__PURE__*/ $961d5315ffabf519$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $961d5315ffabf519$export$b3571188c770cc5a,
        placement + "-" + $961d5315ffabf519$export$bd5df0f255a350f8
    ]);
}, []);
var $961d5315ffabf519$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($961d5315ffabf519$export$aec2ce47c367b8c3, [
    $961d5315ffabf519$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $961d5315ffabf519$export$b3571188c770cc5a,
        placement + "-" + $961d5315ffabf519$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $961d5315ffabf519$export$421679a7c3d56e = 'beforeRead';
var $961d5315ffabf519$export$aafa59e2e03f2942 = 'read';
var $961d5315ffabf519$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $961d5315ffabf519$export$c65e99957a05207c = 'beforeMain';
var $961d5315ffabf519$export$f22da7240b7add18 = 'main';
var $961d5315ffabf519$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $961d5315ffabf519$export$8d4d2d70e7d46032 = 'beforeWrite';
var $961d5315ffabf519$export$68d8715fc104d294 = 'write';
var $961d5315ffabf519$export$70a6e5159acce2e6 = 'afterWrite';
var $961d5315ffabf519$export$d087d3878fdf71d5 = [
    $961d5315ffabf519$export$421679a7c3d56e,
    $961d5315ffabf519$export$aafa59e2e03f2942,
    $961d5315ffabf519$export$6964f6c886723980,
    $961d5315ffabf519$export$c65e99957a05207c,
    $961d5315ffabf519$export$f22da7240b7add18,
    $961d5315ffabf519$export$bab79516f2d662fe,
    $961d5315ffabf519$export$8d4d2d70e7d46032,
    $961d5315ffabf519$export$68d8715fc104d294,
    $961d5315ffabf519$export$70a6e5159acce2e6
];


var $48ddd81393695a53$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $4e3f355f6e420d75$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $868fda9c4887b436$export$2e2bcd8739ae039)(padding, (0, $961d5315ffabf519$export$aec2ce47c367b8c3)));
};
function $48ddd81393695a53$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $48ddd81393695a53$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $8debf15f2d350881$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $48ddd81393695a53$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $edb26c5020cedcb8$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $48ddd81393695a53$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $48ddd81393695a53$var$arrow,
    effect: $48ddd81393695a53$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $41cccd7fabe05f63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $bbe366718497d634$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $bbe366718497d634$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $bbe366718497d634$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
    var sideY = (0, $961d5315ffabf519$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $8debf15f2d350881$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(popper);
            if ((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $961d5315ffabf519$export$1e95b668f3b82d) || (placement === (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) || placement === (0, $961d5315ffabf519$export$79ffe56a765070d2)) && variation === (0, $961d5315ffabf519$export$bd5df0f255a350f8)) {
            sideY = (0, $961d5315ffabf519$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) || (placement === (0, $961d5315ffabf519$export$1e95b668f3b82d) || placement === (0, $961d5315ffabf519$export$40e543e69a8b3fbb)) && variation === (0, $961d5315ffabf519$export$bd5df0f255a350f8)) {
            sideX = (0, $961d5315ffabf519$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $bbe366718497d634$var$unsetSides);
    var _ref4 = roundOffsets === true ? $bbe366718497d634$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $bbe366718497d634$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $bbe366718497d634$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $bbe366718497d634$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $bbe366718497d634$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $bbe366718497d634$var$computeStyles,
    data: {}
};



var $7bec2a6e2c97de64$var$passive = {
    passive: true
};
function $7bec2a6e2c97de64$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $7bec2a6e2c97de64$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $7bec2a6e2c97de64$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $7bec2a6e2c97de64$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $7bec2a6e2c97de64$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $7bec2a6e2c97de64$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $7bec2a6e2c97de64$var$effect,
    data: {}
};


var $895264d7f1285abd$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $895264d7f1285abd$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $895264d7f1285abd$var$hash[matched];
    });
}



var $3190ee6894c64586$var$hash = {
    start: 'end',
    end: 'start'
};
function $3190ee6894c64586$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $3190ee6894c64586$var$hash[matched];
    });
}








function $e826853427a61d24$export$2e2bcd8739ae039(node) {
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $53712d9fbfe608a5$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)((0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element)).left + (0, $e826853427a61d24$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $4c6294ad0a5a884e$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element);
    var html = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $3822c5a08263882b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $32cb83235cf6af6b$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $e826853427a61d24$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $c3a6bf84ff18f738$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $a31d6136541392dc$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(node) && (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(node)) return node;
    return $a31d6136541392dc$export$2e2bcd8739ae039((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(node));
}





function $c6fcb9ddb0a619f3$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $a31d6136541392dc$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($c6fcb9ddb0a619f3$export$2e2bcd8739ae039((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(target)));
}










function $2f76e9cca25369aa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $3ed34baa7075c065$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $3ed34baa7075c065$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $961d5315ffabf519$export$d7b7311ec04a3e8f) ? (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)((0, $4c6294ad0a5a884e$export$2e2bcd8739ae039)(element, strategy)) : (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clippingParent) ? $3ed34baa7075c065$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)((0, $32cb83235cf6af6b$export$2e2bcd8739ae039)((0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $3ed34baa7075c065$var$getClippingParents(element) {
    var clippingParents = (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element) ? (0, $8debf15f2d350881$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $edb26c5020cedcb8$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $37108a593d5d5f50$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $3ed34baa7075c065$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $3ed34baa7075c065$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $3ed34baa7075c065$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $3ed34baa7075c065$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5abf2ff6da597e22$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $961d5315ffabf519$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $961d5315ffabf519$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $961d5315ffabf519$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $961d5315ffabf519$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $961d5315ffabf519$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $961d5315ffabf519$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $f4983c2f7b82930e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $961d5315ffabf519$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $961d5315ffabf519$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $961d5315ffabf519$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $4e3f355f6e420d75$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $868fda9c4887b436$export$2e2bcd8739ae039)(padding, (0, $961d5315ffabf519$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) ? (0, $961d5315ffabf519$export$ca50aac9f3ba507f) : (0, $961d5315ffabf519$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $3ed34baa7075c065$export$2e2bcd8739ae039)((0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $5abf2ff6da597e22$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $961d5315ffabf519$export$79ffe56a765070d2),
                (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $961d5315ffabf519$export$1e95b668f3b82d),
                (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $5f0f7fd33e6df374$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $961d5315ffabf519$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $961d5315ffabf519$export$368f9a87e87fa4e1) : (0, $961d5315ffabf519$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $961d5315ffabf519$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $7261bb7a28c6c261$var$getExpandedFallbackPlacements(placement) {
    if ((0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(placement);
    return [
        (0, $3190ee6894c64586$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $3190ee6894c64586$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $7261bb7a28c6c261$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $895264d7f1285abd$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $7261bb7a28c6c261$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$dfb5619354ba860) ? (0, $5f0f7fd33e6df374$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$b3571188c770cc5a);
        var isVertical = [
            (0, $961d5315ffabf519$export$1e95b668f3b82d),
            (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $961d5315ffabf519$export$79ffe56a765070d2) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $7261bb7a28c6c261$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $7261bb7a28c6c261$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $d7d2695ea28b2aa6$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d7d2695ea28b2aa6$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $961d5315ffabf519$export$1e95b668f3b82d),
        (0, $961d5315ffabf519$export$79ffe56a765070d2),
        (0, $961d5315ffabf519$export$40e543e69a8b3fbb),
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d7d2695ea28b2aa6$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d7d2695ea28b2aa6$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d7d2695ea28b2aa6$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d7d2695ea28b2aa6$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d7d2695ea28b2aa6$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d7d2695ea28b2aa6$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $d7d2695ea28b2aa6$var$hide
};




function $6137a161b4896709$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $6137a161b4896709$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $961d5315ffabf519$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $6137a161b4896709$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $6137a161b4896709$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $6137a161b4896709$var$offset
};



function $fd3370820cf4bcb1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $5abf2ff6da597e22$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $fd3370820cf4bcb1$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $fd3370820cf4bcb1$var$popperOffsets,
    data: {}
};





function $45abdfcc61968a12$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $9d3c739e2059661f$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $45abdfcc61968a12$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $961d5315ffabf519$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $961d5315ffabf519$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $559cca984964a2c1$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $8debf15f2d350881$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(tether ? (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $049d14be9b4f15bb$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $961d5315ffabf519$export$1e95b668f3b82d),
            (0, $961d5315ffabf519$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $32a9692ec37d141e$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $32a9692ec37d141e$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9d3c739e2059661f$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $9d3c739e2059661f$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $9f852250855e3d87$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b434581b465cb432$export$2e2bcd8739ae039(node) {
    if (node === (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node) || !(0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(node)) return (0, $e826853427a61d24$export$2e2bcd8739ae039)(node);
    else return (0, $9f852250855e3d87$export$2e2bcd8739ae039)(node);
}








function $dbf000ff4b3c4664$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $dbf000ff4b3c4664$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent) && $dbf000ff4b3c4664$var$isElementScaled(offsetParent);
    var documentElement = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b434581b465cb432$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $7fa7d91227c213a7$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $7fa7d91227c213a7$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $7fa7d91227c213a7$var$order(modifiers); // order based on phase
    return (0, $961d5315ffabf519$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $348b53990a67b9f2$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $79e2fb482cad3d90$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b0054ad10f2e8753$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b0054ad10f2e8753$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b0054ad10f2e8753$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b0054ad10f2e8753$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b0054ad10f2e8753$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(reference) ? (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $7fa7d91227c213a7$export$2e2bcd8739ae039)((0, $79e2fb482cad3d90$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b0054ad10f2e8753$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $dbf000ff4b3c4664$export$2e2bcd8739ae039)(reference, (0, $8debf15f2d350881$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $348b53990a67b9f2$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b0054ad10f2e8753$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b0054ad10f2e8753$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b0054ad10f2e8753$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $12876877c063deab$export$8f7491d57c8f97a9 = (0, $b0054ad10f2e8753$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $d7d2695ea28b2aa6$export$2e2bcd8739ae039),
        (0, $fd3370820cf4bcb1$export$2e2bcd8739ae039),
        (0, $bbe366718497d634$export$2e2bcd8739ae039),
        (0, $7bec2a6e2c97de64$export$2e2bcd8739ae039),
        (0, $6137a161b4896709$export$2e2bcd8739ae039),
        (0, $7261bb7a28c6c261$export$2e2bcd8739ae039),
        (0, $9d3c739e2059661f$export$2e2bcd8739ae039),
        (0, $48ddd81393695a53$export$2e2bcd8739ae039)
    ]
});


const $23847a85f7f32bdf$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $23847a85f7f32bdf$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $23847a85f7f32bdf$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const $23847a85f7f32bdf$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $23847a85f7f32bdf$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $23847a85f7f32bdf$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = 'bottom', strategy: strategy = 'absolute', modifiers: modifiers = $23847a85f7f32bdf$var$EMPTY_MODIFIERS } = _ref, config = $23847a85f7f32bdf$var$_objectWithoutPropertiesLoose(_ref, $23847a85f7f32bdf$var$_excluded);
    const prevModifiers = (0, $7DB8U.useRef)(modifiers);
    const popperInstanceRef = (0, $7DB8U.useRef)();
    const update = (0, $7DB8U.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $7DB8U.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $5390f073d3d5fc4e$export$2e2bcd8739ae039)((0, $7DB8U.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $7DB8U.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $7DB8U.useMemo)(()=>{
        if (!(0, $9b8288c93dde0611$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $7DB8U.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $23847a85f7f32bdf$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $7DB8U.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $12876877c063deab$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $23847a85f7f32bdf$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $23847a85f7f32bdf$export$2e2bcd8739ae039 = $23847a85f7f32bdf$var$usePopper;





var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $df39a2f1ff98cc55$var$useCommittedRef(value) {
    const ref = (0, $7DB8U.useRef)(value);
    (0, $7DB8U.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $df39a2f1ff98cc55$export$2e2bcd8739ae039 = $df39a2f1ff98cc55$var$useCommittedRef;


function $42a6230204cf5cc4$export$2e2bcd8739ae039(fn) {
    const ref = (0, $df39a2f1ff98cc55$export$2e2bcd8739ae039)(fn);
    return (0, $7DB8U.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}






var $7DB8U = parcelRequire("7DB8U");


const $77e2067be7ecd5d8$var$noop = ()=>{};
function $77e2067be7ecd5d8$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $77e2067be7ecd5d8$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $77e2067be7ecd5d8$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $77e2067be7ecd5d8$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $77e2067be7ecd5d8$var$useClickOutside(ref, onClickOutside = $77e2067be7ecd5d8$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $7DB8U.useRef)(false);
    const waitingForTrigger = (0, $7DB8U.useRef)(false);
    const handleMouseCapture = (0, $7DB8U.useCallback)((e)=>{
        const currentTarget = $77e2067be7ecd5d8$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($9abc3dc86fc6eb1f$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $77e2067be7ecd5d8$var$isModifiedEvent(e) || !$77e2067be7ecd5d8$var$isLeftClickEvent(e) || !!(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $77e2067be7ecd5d8$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $97c75dca58f4c376$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $7DB8U.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)($77e2067be7ecd5d8$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($77e2067be7ecd5d8$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, $77e2067be7ecd5d8$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(el, 'mousemove', $77e2067be7ecd5d8$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $77e2067be7ecd5d8$export$2e2bcd8739ae039 = $77e2067be7ecd5d8$var$useClickOutside;



const $0bac9d3ea021e7fe$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $0bac9d3ea021e7fe$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $0bac9d3ea021e7fe$var$noop;
    (0, $77e2067be7ecd5d8$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)((e)=>{
        if ((0, $36a3340f9542756b$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $7DB8U.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)((0, $77e2067be7ecd5d8$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $0bac9d3ea021e7fe$export$2e2bcd8739ae039 = $0bac9d3ea021e7fe$var$useRootClose;





var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");

const $6e5a5ef831ae81c7$var$Context = /*#__PURE__*/ (0, $7DB8U.createContext)((0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) ? window : undefined);
const $6e5a5ef831ae81c7$export$f7d306aeb1cf5fbc = $6e5a5ef831ae81c7$var$Context.Provider;
function $6e5a5ef831ae81c7$export$2e2bcd8739ae039() {
    return (0, $7DB8U.useContext)($6e5a5ef831ae81c7$var$Context);
}


const $765e7881ef71d12d$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $c36f36ded4bef1c0$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $765e7881ef71d12d$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $6e5a5ef831ae81c7$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $7DB8U.useState)(()=>$765e7881ef71d12d$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $765e7881ef71d12d$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $7DB8U.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $7DB8U.useEffect)(()=>{
        const nextRef = $765e7881ef71d12d$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}


function $81347f664366abcb$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $81347f664366abcb$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $81347f664366abcb$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $81347f664366abcb$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $81347f664366abcb$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}





var $7DB8U = parcelRequire("7DB8U");
const $09949f22cdacc772$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $09949f22cdacc772$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $09949f22cdacc772$export$2e2bcd8739ae039 = $09949f22cdacc772$var$isDOM || $09949f22cdacc772$var$isReactNative ? (0, $7DB8U.useLayoutEffect) : (0, $7DB8U.useEffect);



var $7DB8U = parcelRequire("7DB8U");



var $7DB8U = parcelRequire("7DB8U");

function $a760d026a627c09f$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $7DB8U.useRef)(null);
    const hasEnteredRef = (0, $7DB8U.useRef)(inProp);
    const handleExited = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)(onExited);
    (0, $7DB8U.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $c1a0fd2af677389b$export$2e2bcd8739ae039)(ref, (0, $36a3340f9542756b$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $7DB8U.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $a760d026a627c09f$export$2e2bcd8739ae039 = $a760d026a627c09f$var$NoopTransition;



var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");


const $e95716e9a0c8fc6a$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $e95716e9a0c8fc6a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $e95716e9a0c8fc6a$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $e95716e9a0c8fc6a$var$_objectWithoutPropertiesLoose(_ref, $e95716e9a0c8fc6a$var$_excluded);
    const nodeRef = (0, $7DB8U.useRef)(null);
    const mergedRef = (0, $c1a0fd2af677389b$export$2e2bcd8739ae039)(nodeRef, (0, $36a3340f9542756b$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $7DB8U.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $7DB8U.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $7DB8U.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $7DB8U.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $7DB8U.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $7DB8U.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $7DB8U.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $7DB8U.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $e24de2096da89af4$var$_excluded = [
    "component"
];
function $e24de2096da89af4$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $e24de2096da89af4$var$RTGTransition = /*#__PURE__*/ $7DB8U.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $e24de2096da89af4$var$_objectWithoutPropertiesLoose(_ref, $e24de2096da89af4$var$_excluded);
    const transitionProps = (0, $e95716e9a0c8fc6a$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $e24de2096da89af4$export$2e2bcd8739ae039 = $e24de2096da89af4$var$RTGTransition;




function $456a71d209592b13$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $7DB8U.useRef)(null);
    const isInitialRef = (0, $7DB8U.useRef)(true);
    const handleTransition = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)(onTransition);
    (0, $09949f22cdacc772$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $09949f22cdacc772$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $456a71d209592b13$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $7DB8U.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $456a71d209592b13$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $c1a0fd2af677389b$export$2e2bcd8739ae039)(ref, (0, $36a3340f9542756b$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $7DB8U.cloneElement)(children, {
        ref: combinedRef
    });
}
function $456a71d209592b13$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $e24de2096da89af4$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)($456a71d209592b13$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $a760d026a627c09f$export$2e2bcd8739ae039), Object.assign({}, props));
}


/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $038ae31b4bb8cd18$var$Overlay = /*#__PURE__*/ $7DB8U.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $ef5fbefb53d1c0cc$export$2e2bcd8739ae039)();
    const [arrowElement, attachArrowRef] = (0, $ef5fbefb53d1c0cc$export$2e2bcd8739ae039)();
    const mergedRef = (0, $c1a0fd2af677389b$export$2e2bcd8739ae039)(attachRef, outerRef);
    const container = (0, $765e7881ef71d12d$export$2e2bcd8739ae039)(props.container);
    const target = (0, $765e7881ef71d12d$export$2e2bcd8739ae039)(props.target);
    const [exited, setExited] = (0, $7DB8U.useState)(!props.show);
    const popper = (0, $23847a85f7f32bdf$export$2e2bcd8739ae039)(target, rootElement, (0, $81347f664366abcb$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $0bac9d3ea021e7fe$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $456a71d209592b13$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9lImh))).createPortal(child, container) : null;
});
$038ae31b4bb8cd18$var$Overlay.displayName = 'Overlay';
var $038ae31b4bb8cd18$export$2e2bcd8739ae039 = $038ae31b4bb8cd18$var$Overlay;



var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $65c5e9844671b1e6$var$useCommittedRef(value) {
    const ref = (0, $7DB8U.useRef)(value);
    (0, $7DB8U.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $65c5e9844671b1e6$export$2e2bcd8739ae039 = $65c5e9844671b1e6$var$useCommittedRef;


function $297288d717742377$export$2e2bcd8739ae039(fn) {
    const ref = (0, $65c5e9844671b1e6$export$2e2bcd8739ae039)(fn);
    return (0, $7DB8U.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



var $7DB8U = parcelRequire("7DB8U");
const $5d10a2d054265037$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $5d10a2d054265037$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $5d10a2d054265037$export$2e2bcd8739ae039 = $5d10a2d054265037$var$isDOM || $5d10a2d054265037$var$isReactNative ? (0, $7DB8U.useLayoutEffect) : (0, $7DB8U.useEffect);




var $7DB8U = parcelRequire("7DB8U");
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $bb7f18969320ba30$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}





var $7DB8U = parcelRequire("7DB8U");


var $7DB8U = parcelRequire("7DB8U");



"use client";
const $b939f9944691b130$var$PopoverHeader = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$b939f9944691b130$var$PopoverHeader.displayName = 'PopoverHeader';
var $b939f9944691b130$export$2e2bcd8739ae039 = $b939f9944691b130$var$PopoverHeader;



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $c64c11eca1b55c35$var$PopoverBody = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$c64c11eca1b55c35$var$PopoverBody.displayName = 'PopoverBody';
var $c64c11eca1b55c35$export$2e2bcd8739ae039 = $c64c11eca1b55c35$var$PopoverBody;



var $7DB8U = parcelRequire("7DB8U");
class $436f0fae5f9ee517$export$34582a676b91ff07 extends $7DB8U.Component {
}
function $436f0fae5f9ee517$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}


function $d01785dd698a2254$export$2e2bcd8739ae039(position = 'absolute') {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}



"use client";
const $97d9b36cc775c811$var$Popover = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'popover');
    const isRTL = (0, $d36baff69136067a$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $436f0fae5f9ee517$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $d01785dd698a2254$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $c64c11eca1b55c35$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    });
});
$97d9b36cc775c811$var$Popover.displayName = 'Popover';
var $97d9b36cc775c811$export$2e2bcd8739ae039 = Object.assign($97d9b36cc775c811$var$Popover, {
    Header: (0, $b939f9944691b130$export$2e2bcd8739ae039),
    Body: (0, $c64c11eca1b55c35$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});




var $7DB8U = parcelRequire("7DB8U");




"use client";
const $2d6947a60393ae7d$var$Tooltip = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'tooltip');
    const isRTL = (0, $d36baff69136067a$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $436f0fae5f9ee517$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $d01785dd698a2254$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$2d6947a60393ae7d$var$Tooltip.displayName = 'Tooltip';
var $2d6947a60393ae7d$export$2e2bcd8739ae039 = Object.assign($2d6947a60393ae7d$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


"use client";
function $1f0632245157e296$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $7DB8U.useRef)(null);
    const popoverClass = (0, $d36baff69136067a$export$7f387860ebffb32c)(undefined, 'popover');
    const tooltipClass = (0, $d36baff69136067a$export$7f387860ebffb32c)(undefined, 'tooltip');
    const offset = (0, $7DB8U.useMemo)(()=>({
            name: 'offset',
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $bb7f18969320ba30$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $97d9b36cc775c811$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $bb7f18969320ba30$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $2d6947a60393ae7d$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}




var $7DB8U = parcelRequire("7DB8U");






const $722140d134b37da6$var$fadeStyles = {
    [(0, $6d8a24823bc267eb$export$df38205c966be359)]: 'show',
    [(0, $6d8a24823bc267eb$export$78e9e6e3e014d60a)]: 'show'
};
const $722140d134b37da6$var$Fade = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $7DB8U.useCallback)((node, isAppearing)=>{
        (0, $772cecf998cebdd5$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $2fc98acac168f363$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $3d830b57987dc180$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $36a3340f9542756b$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $7DB8U.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('fade', className, children.props.className, $722140d134b37da6$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$722140d134b37da6$var$Fade.displayName = 'Fade';
var $722140d134b37da6$export$2e2bcd8739ae039 = $722140d134b37da6$var$Fade;




"use client";
function $c4adc9f01c3da970$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $ed8c95812e06aea0$export$2e2bcd8739ae039)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $ed8c95812e06aea0$export$2e2bcd8739ae039)(r)));
}
const $c4adc9f01c3da970$var$Overlay = /*#__PURE__*/ $7DB8U.forwardRef(({ children: overlay, transition: transition = (0, $722140d134b37da6$export$2e2bcd8739ae039), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = 'top', show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $7DB8U.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $7DB8U.useState)(null);
    const [ref, modifiers] = (0, $1f0632245157e296$export$2e2bcd8739ae039)(outerProps.offset);
    const mergedRef = (0, $1e2b613deffe4140$export$2e2bcd8739ae039)(outerRef, ref);
    const actualTransition = transition === true ? (0, $722140d134b37da6$export$2e2bcd8739ae039) : transition || undefined;
    const handleFirstUpdate = (0, $297288d717742377$export$2e2bcd8739ae039)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $5d10a2d054265037$export$2e2bcd8739ae039)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $7DB8U.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $038ae31b4bb8cd18$export$2e2bcd8739ae039), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state;
            $c4adc9f01c3da970$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: 'show'
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $7DB8U.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(overlay.props.className, !transition && show && 'show'),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$c4adc9f01c3da970$var$Overlay.displayName = 'Overlay';
var $c4adc9f01c3da970$export$2e2bcd8739ae039 = $c4adc9f01c3da970$var$Overlay;




"use client";
function $213b714c6cf5496e$var$normalizeDelay(delay) {
    return delay && typeof delay === 'object' ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $213b714c6cf5496e$var$handleMouseOverOut(handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(target, related)) handler(...args);
}
const $213b714c6cf5496e$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
    'click',
    'hover',
    'focus'
]);
const $213b714c6cf5496e$var$OverlayTrigger = ({ trigger: trigger = [
    'hover',
    'focus'
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf('auto') !== -1, ...props })=>{
    const triggerNodeRef = (0, $7DB8U.useRef)(null);
    const mergedRef = (0, $1e2b613deffe4140$export$2e2bcd8739ae039)(triggerNodeRef, (0, $36a3340f9542756b$export$87943f2672146d57)(children));
    const timeout = (0, $c26ada26dd336b02$export$2e2bcd8739ae039)();
    const hoverStateRef = (0, $7DB8U.useRef)('');
    const [show, setShow] = (0, $be0af947f6d59f9f$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle);
    const delay = $213b714c6cf5496e$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== 'function' ? $7DB8U.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $ed8c95812e06aea0$export$2e2bcd8739ae039)(r));
    };
    const handleShow = (0, $7DB8U.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $7DB8U.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $7DB8U.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $7DB8U.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $7DB8U.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $7DB8U.useCallback)((...args)=>{
        $213b714c6cf5496e$var$handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $7DB8U.useCallback)((...args)=>{
        $213b714c6cf5496e$var$handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf('click') !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)((0, $e830bf8f8acfe41d$exports.Fragment), {
        children: [
            typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/ (0, $7DB8U.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $c4adc9f01c3da970$export$2e2bcd8739ae039), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
var $213b714c6cf5496e$export$2e2bcd8739ae039 = $213b714c6cf5496e$var$OverlayTrigger;


var $0053152b16d9815b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $0053152b16d9815b$export$5169ff31790bf260 = (_a)=>{
    var { title: title, detail: detail, children: children } = _a, props = $0053152b16d9815b$var$__rest(_a, [
        "title",
        "detail",
        "children"
    ]);
    return (0, $e830bf8f8acfe41d$exports.jsx)((0, $213b714c6cf5496e$export$2e2bcd8739ae039), Object.assign({}, props, {
        overlay: detail ? (0, $e830bf8f8acfe41d$exports.jsxs)((0, $97d9b36cc775c811$export$2e2bcd8739ae039), {
            children: [
                (0, $e830bf8f8acfe41d$exports.jsx)((0, $97d9b36cc775c811$export$2e2bcd8739ae039).Header, {
                    children: title
                }),
                (0, $e830bf8f8acfe41d$exports.jsx)((0, $97d9b36cc775c811$export$2e2bcd8739ae039).Body, {
                    children: detail
                })
            ]
        }) : (0, $e830bf8f8acfe41d$exports.jsx)((0, $2d6947a60393ae7d$export$2e2bcd8739ae039), {
            children: title
        }),
        children: children
    }));
};
$0053152b16d9815b$export$5169ff31790bf260.displayName = 'OverlayBox';


var $e3aad0f6e5ad05e1$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $e3aad0f6e5ad05e1$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $e3aad0f6e5ad05e1$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $e3aad0f6e5ad05e1$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $e3aad0f6e5ad05e1$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $e3aad0f6e5ad05e1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * Re-implement from https://github.com/EasyWebApp/BootCell/blob/3d30027a97fe0a8c4ab8fabc8dfef22aede04de7/source/Calendar/MonthCalendar.tsx
 */ let $e3aad0f6e5ad05e1$export$d7a7c85c0f5afc4a = (()=>{
    var _MonthCalendar_currentDate_accessor_storage;
    let _classDecorators = [
        (0, $2c52cd3eacadeaca$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $4d5bac995c3494f7$export$bf180ef329d1efd8);
    let _instanceExtraInitializers = [];
    let _get_weekFormatter_decorators;
    let _currentDate_decorators;
    let _currentDate_initializers = [];
    let _currentDate_extraInitializers = [];
    let _get_dateGrid_decorators;
    var MonthCalendar = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _MonthCalendar_currentDate_accessor_storage.set(this, ($e3aad0f6e5ad05e1$var$__runInitializers(this, _instanceExtraInitializers), $e3aad0f6e5ad05e1$var$__runInitializers(this, _currentDate_initializers, new Date())));
            Object.defineProperty(this, "renderDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($e3aad0f6e5ad05e1$var$__runInitializers(this, _currentDate_extraInitializers), (date)=>{
                    const { variant: variant = 'primary', value: value, onSelect: onSelect } = this.observedProps, dateText = (0, $1ec569b22aebf9e3$export$3ae94a2503e890a1)(date, 'YYYY-MM-DD');
                    const list = value === null || value === void 0 ? void 0 : value.filter(({ date: date })=>(0, $1ec569b22aebf9e3$export$3ae94a2503e890a1)(date, 'YYYY-MM-DD') === dateText);
                    return (0, $e830bf8f8acfe41d$exports.jsxs)("td", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))({
                            'opacity-50': date.getMonth() !== this.currentDate.getMonth(),
                            'fw-bold': dateText === (0, $1ec569b22aebf9e3$export$3ae94a2503e890a1)(new Date(), 'YYYY-MM-DD')
                        }),
                        children: [
                            (0, $e830bf8f8acfe41d$exports.jsx)("time", {
                                className: "d-block",
                                dateTime: date.toJSON(),
                                children: date.getDate()
                            }),
                            list === null || list === void 0 ? void 0 : list.map((item)=>typeof item.content === 'object' ? item.content : (0, $e830bf8f8acfe41d$exports.jsx)((0, $0053152b16d9815b$export$5169ff31790bf260), {
                                    title: item.content,
                                    children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $5056c1721372f116$export$2e2bcd8739ae039), {
                                        as: "a",
                                        className: "d-inline-block text-decoration-none w-100 text-truncate",
                                        bg: (0, $49d7ea4d7974a6fe$export$b480d00b75c9ac2d)(item.content + '', [
                                            'light'
                                        ]),
                                        href: item.link,
                                        onClick: ()=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(item),
                                        children: item.content
                                    })
                                }, item.date + ''))
                        ]
                    }, date + '');
                })
            });
        }
        get weekFormatter() {
            var _a;
            const { locale: locale = (_a = globalThis.navigator) === null || _a === void 0 ? void 0 : _a.language } = this.observedProps;
            return new Intl.DateTimeFormat(locale, {
                weekday: 'long'
            });
        }
        get currentDate() {
            return $e3aad0f6e5ad05e1$var$__classPrivateFieldGet(this, _MonthCalendar_currentDate_accessor_storage, "f");
        }
        set currentDate(value) {
            $e3aad0f6e5ad05e1$var$__classPrivateFieldSet(this, _MonthCalendar_currentDate_accessor_storage, value, "f");
        }
        get dateGrid() {
            let startDate = new Date(this.currentDate);
            startDate.setDate(1);
            startDate = new Date(+startDate - startDate.getDay() * (0, $1ec569b22aebf9e3$export$7a9a31a911eb9a20));
            const dateList = Array.from(new Array(42), (_, index)=>new Date(+startDate + index * (0, $1ec569b22aebf9e3$export$7a9a31a911eb9a20)));
            return (0, $1ec569b22aebf9e3$export$697c3df919c0e61a)(dateList, 7);
        }
        changeMonth(delta) {
            var _a, _b;
            this.currentDate = (0, $1ec569b22aebf9e3$export$62ad822b3a5fd9a0)(this.currentDate, delta);
            (_b = (_a = this.props).onChange) === null || _b === void 0 || _b.call(_a, this.currentDate);
        }
        render() {
            const { weekFormatter: weekFormatter, currentDate: currentDate, dateGrid: dateGrid } = this, _a = this.observedProps, { style: style, variant: variant = 'primary', onChange: onChange, onSelect: onSelect } = _a, props = $e3aad0f6e5ad05e1$var$__rest(_a, [
                "style",
                "variant",
                "onChange",
                "onSelect"
            ]);
            return (0, $e830bf8f8acfe41d$exports.jsxs)((0, $72916eeed8431ee6$export$2e2bcd8739ae039), Object.assign({}, props, {
                style: Object.assign({
                    tableLayout: 'fixed'
                }, style),
                children: [
                    (0, $e830bf8f8acfe41d$exports.jsx)("caption", {
                        children: (0, $e830bf8f8acfe41d$exports.jsxs)("div", {
                            className: "d-flex justify-content-between align-items-center",
                            children: [
                                (0, $e830bf8f8acfe41d$exports.jsx)((0, $e4f2607df5423ec3$export$2e2bcd8739ae039), {
                                    variant: variant,
                                    onClick: ()=>this.changeMonth(-1),
                                    children: "<"
                                }),
                                (0, $1ec569b22aebf9e3$export$3ae94a2503e890a1)(currentDate, 'YYYY-MM'),
                                (0, $e830bf8f8acfe41d$exports.jsx)((0, $e4f2607df5423ec3$export$2e2bcd8739ae039), {
                                    variant: variant,
                                    onClick: ()=>this.changeMonth(1),
                                    children: ">"
                                })
                            ]
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)("thead", {
                        children: (0, $e830bf8f8acfe41d$exports.jsx)("tr", {
                            children: dateGrid[0].map((date, index, { length: length })=>(0, $e830bf8f8acfe41d$exports.jsx)("td", {
                                    className: `bg-${variant} text-white`,
                                    style: {
                                        width: `calc(100% / ${length})`
                                    },
                                    children: weekFormatter.format(date)
                                }, index))
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)("tbody", {
                        children: dateGrid.map((days)=>(0, $e830bf8f8acfe41d$exports.jsx)("tr", {
                                children: days.map(this.renderDate)
                            }, days[0] + ''))
                    })
                ]
            }));
        }
    };
    _MonthCalendar_currentDate_accessor_storage = new WeakMap();
    $e3aad0f6e5ad05e1$var$__setFunctionName(_classThis, "MonthCalendar");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _get_weekFormatter_decorators = [
            (0, $fecbc4a33bb0f224$export$2983e091f1a1e8e2)
        ];
        _currentDate_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        _get_dateGrid_decorators = [
            (0, $fecbc4a33bb0f224$export$2983e091f1a1e8e2)
        ];
        $e3aad0f6e5ad05e1$var$__esDecorate(_classThis, null, _get_weekFormatter_decorators, {
            kind: "getter",
            name: "weekFormatter",
            static: false,
            private: false,
            access: {
                has: (obj)=>"weekFormatter" in obj,
                get: (obj)=>obj.weekFormatter
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $e3aad0f6e5ad05e1$var$__esDecorate(_classThis, null, _currentDate_decorators, {
            kind: "accessor",
            name: "currentDate",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentDate" in obj,
                get: (obj)=>obj.currentDate,
                set: (obj, value)=>{
                    obj.currentDate = value;
                }
            },
            metadata: _metadata
        }, _currentDate_initializers, _currentDate_extraInitializers);
        $e3aad0f6e5ad05e1$var$__esDecorate(_classThis, null, _get_dateGrid_decorators, {
            kind: "getter",
            name: "dateGrid",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dateGrid" in obj,
                get: (obj)=>obj.dateGrid
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $e3aad0f6e5ad05e1$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        MonthCalendar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'MonthCalendar'
    });
    (()=>{
        $e3aad0f6e5ad05e1$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return MonthCalendar = _classThis;
})();


var $49a38e2a3ce732bb$exports = {};

$parcel$export($49a38e2a3ce732bb$exports, "Nameplate", () => $49a38e2a3ce732bb$export$caa4d5435e8fb601);


const $49a38e2a3ce732bb$export$caa4d5435e8fb601 = ({ avatar: avatar, name: name })=>(0, $e830bf8f8acfe41d$exports.jsxs)((0, $e830bf8f8acfe41d$exports.Fragment), {
        children: [
            (0, $e830bf8f8acfe41d$exports.jsx)((0, $bbe3314f1df38781$export$e2255cf6045e8d47), {
                size: 2,
                style: {
                    marginRight: '0.5rem'
                },
                src: avatar
            }),
            (0, $e830bf8f8acfe41d$exports.jsx)("span", {
                className: "align-middle",
                children: name
            })
        ]
    });
$49a38e2a3ce732bb$export$caa4d5435e8fb601.displayName = 'Nameplate';



var $7f4b319848d3c701$exports = {};

$parcel$export($7f4b319848d3c701$exports, "PageNav", () => $7f4b319848d3c701$export$f24150b9675a2c65);




var $7DB8U = parcelRequire("7DB8U");


var $7DB8U = parcelRequire("7DB8U");

var $e756898da11911b9$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $e756898da11911b9$export$2e2bcd8739ae039(element, selector) {
    return $e756898da11911b9$var$toArray(element.querySelectorAll(selector));
}



var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");
function $f36de207fe884169$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $7DB8U.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}




var $7DB8U = parcelRequire("7DB8U");
const $1a2f134684370479$var$NavContext = /*#__PURE__*/ $7DB8U.createContext(null);
$1a2f134684370479$var$NavContext.displayName = 'NavContext';
var $1a2f134684370479$export$2e2bcd8739ae039 = $1a2f134684370479$var$NavContext;



var $7DB8U = parcelRequire("7DB8U");
const $988f4de41e5b7681$var$SelectableContext = /*#__PURE__*/ $7DB8U.createContext(null);
const $988f4de41e5b7681$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $988f4de41e5b7681$export$2e2bcd8739ae039 = $988f4de41e5b7681$var$SelectableContext;



var $7DB8U = parcelRequire("7DB8U");
const $a2a0365b556cd2b2$var$TabContext = /*#__PURE__*/ $7DB8U.createContext(null);
var $a2a0365b556cd2b2$export$2e2bcd8739ae039 = $a2a0365b556cd2b2$var$TabContext;


const $bec69d0ef4577e78$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $bec69d0ef4577e78$export$635202801f9383a0 = `rrUi`;
function $bec69d0ef4577e78$export$5cc3b7b83e34ade7(property) {
    return `${$bec69d0ef4577e78$export$fd7bcb7e9bef4e8a}${property}`;
}
function $bec69d0ef4577e78$export$7776c0a7cd2eb3e0(property) {
    return `${$bec69d0ef4577e78$export$635202801f9383a0}${property}`;
}



var $7DB8U = parcelRequire("7DB8U");







const $2b9a552046f98f3a$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $2b9a552046f98f3a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $2b9a552046f98f3a$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $7DB8U.useContext)((0, $988f4de41e5b7681$export$2e2bcd8739ae039));
    const navContext = (0, $7DB8U.useContext)((0, $1a2f134684370479$export$2e2bcd8739ae039));
    const tabContext = (0, $7DB8U.useContext)((0, $a2a0365b556cd2b2$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $bec69d0ef4577e78$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $2b9a552046f98f3a$var$NavItem = /*#__PURE__*/ $7DB8U.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $ca03a707c779611a$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $2b9a552046f98f3a$var$_objectWithoutPropertiesLoose(_ref, $2b9a552046f98f3a$var$_excluded);
    const [props, meta] = $2b9a552046f98f3a$export$d7a68693710982a(Object.assign({
        key: (0, $988f4de41e5b7681$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $bec69d0ef4577e78$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$2b9a552046f98f3a$var$NavItem.displayName = 'NavItem';
var $2b9a552046f98f3a$export$2e2bcd8739ae039 = $2b9a552046f98f3a$var$NavItem;



const $c6da089809cb1066$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $c6da089809cb1066$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $c6da089809cb1066$var$noop = ()=>{};
const $c6da089809cb1066$var$EVENT_KEY_ATTR = (0, $bec69d0ef4577e78$export$5cc3b7b83e34ade7)('event-key');
const $c6da089809cb1066$var$Nav = /*#__PURE__*/ $7DB8U.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $c6da089809cb1066$var$_objectWithoutPropertiesLoose(_ref, $c6da089809cb1066$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $f36de207fe884169$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $7DB8U.useRef)(false);
    const parentOnSelect = (0, $7DB8U.useContext)((0, $988f4de41e5b7681$export$2e2bcd8739ae039));
    const tabContext = (0, $7DB8U.useContext)((0, $a2a0365b556cd2b2$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $7DB8U.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $e756898da11911b9$export$2e2bcd8739ae039)(currentListNode, `[${$c6da089809cb1066$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $bec69d0ef4577e78$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $7DB8U.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$c6da089809cb1066$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $c1a0fd2af677389b$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $988f4de41e5b7681$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $1a2f134684370479$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $988f4de41e5b7681$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $c6da089809cb1066$var$noop,
                getControllerId: getControllerId || $c6da089809cb1066$var$noop
            },
            children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$c6da089809cb1066$var$Nav.displayName = 'Nav';
var $c6da089809cb1066$export$2e2bcd8739ae039 = Object.assign($c6da089809cb1066$var$Nav, {
    Item: (0, $2b9a552046f98f3a$export$2e2bcd8739ae039)
});




var $7DB8U = parcelRequire("7DB8U");
"use client";
// TODO: check
const $62bc15095c841559$var$context = /*#__PURE__*/ $7DB8U.createContext(null);
$62bc15095c841559$var$context.displayName = 'NavbarContext';
var $62bc15095c841559$export$2e2bcd8739ae039 = $62bc15095c841559$var$context;



var $7DB8U = parcelRequire("7DB8U");
"use client";
const $76117b817e14270b$var$context = /*#__PURE__*/ $7DB8U.createContext(null);
$76117b817e14270b$var$context.displayName = 'CardHeaderContext';
var $76117b817e14270b$export$2e2bcd8739ae039 = $76117b817e14270b$var$context;



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $522c1bf80aa094bc$var$NavItem = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$522c1bf80aa094bc$var$NavItem.displayName = 'NavItem';
var $522c1bf80aa094bc$export$2e2bcd8739ae039 = $522c1bf80aa094bc$var$NavItem;




var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");




var $7DB8U = parcelRequire("7DB8U");

function $d38ba8f6ff2b729d$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)(listener);
    (0, $7DB8U.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $7DB8U = parcelRequire("7DB8U");
function $7cd192ae6e8a5fff$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $7DB8U.useCallback)(()=>document, []);
    return (0, $d38ba8f6ff2b729d$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $7DB8U = parcelRequire("7DB8U");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $6a8610a182ae1bea$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $df39a2f1ff98cc55$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $df39a2f1ff98cc55$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $7DB8U.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $6a8610a182ae1bea$export$2e2bcd8739ae039 = $6a8610a182ae1bea$var$useInterval;



var $7DB8U = parcelRequire("7DB8U");

function $d46af6a5c771c413$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $df39a2f1ff98cc55$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $df39a2f1ff98cc55$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $7DB8U.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $d46af6a5c771c413$export$2e2bcd8739ae039 = $d46af6a5c771c413$var$useRafInterval;



var $7DB8U = parcelRequire("7DB8U");
function $4d41fd525dacb629$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $7DB8U.useState)(initialState);
    const updater = (0, $7DB8U.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $e6ca160d714dbe50$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $4d41fd525dacb629$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}




var $7DB8U = parcelRequire("7DB8U");
function $fb71ae22f6c1c147$export$2e2bcd8739ae039(value) {
    const ref = (0, $7DB8U.useRef)(null);
    (0, $7DB8U.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $7DB8U = parcelRequire("7DB8U");
function $7f8671eb3fb1587f$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $7DB8U.useState)({
        image: null,
        error: null
    });
    (0, $7DB8U.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $7DB8U = parcelRequire("7DB8U");

const $96c5a148c2c98d84$var$targetMap = new WeakMap();
let $96c5a148c2c98d84$var$resizeObserver;
function $96c5a148c2c98d84$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $96c5a148c2c98d84$var$resizeObserver = $96c5a148c2c98d84$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $96c5a148c2c98d84$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $96c5a148c2c98d84$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $7DB8U.useState)(null);
    (0, $09949f22cdacc772$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $96c5a148c2c98d84$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $96c5a148c2c98d84$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $96c5a148c2c98d84$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $ba3423761edfecbc$var$_excluded = [
    "onKeyDown"
];
function $ba3423761edfecbc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $ba3423761edfecbc$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $ba3423761edfecbc$var$Anchor = /*#__PURE__*/ $7DB8U.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $ba3423761edfecbc$var$_objectWithoutPropertiesLoose(_ref, $ba3423761edfecbc$var$_excluded);
    const [buttonProps] = (0, $ca03a707c779611a$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($ba3423761edfecbc$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$ba3423761edfecbc$var$Anchor.displayName = 'Anchor';
var $ba3423761edfecbc$export$2e2bcd8739ae039 = $ba3423761edfecbc$var$Anchor;






"use client";
const $1f1b2d0a7d8ef4d4$var$NavLink = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $ba3423761edfecbc$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $2b9a552046f98f3a$export$d7a68693710982a)({
        key: (0, $988f4de41e5b7681$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$1f1b2d0a7d8ef4d4$var$NavLink.displayName = 'NavLink';
var $1f1b2d0a7d8ef4d4$export$2e2bcd8739ae039 = $1f1b2d0a7d8ef4d4$var$NavLink;



"use client";
const $a036a87711fc9297$var$Nav = /*#__PURE__*/ $7DB8U.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $be0af947f6d59f9f$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $7DB8U.useContext)((0, $62bc15095c841559$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $7DB8U.useContext)((0, $76117b817e14270b$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $c6da089809cb1066$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$a036a87711fc9297$var$Nav.displayName = 'Nav';
var $a036a87711fc9297$export$2e2bcd8739ae039 = Object.assign($a036a87711fc9297$var$Nav, {
    Item: (0, $522c1bf80aa094bc$export$2e2bcd8739ae039),
    Link: (0, $1f1b2d0a7d8ef4d4$export$2e2bcd8739ae039)
});



var $7f4b319848d3c701$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $7f4b319848d3c701$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $7f4b319848d3c701$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $7f4b319848d3c701$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $7f4b319848d3c701$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $7f4b319848d3c701$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $7f4b319848d3c701$var$HeadingSelector = Array.from(new Array(6), (_, index)=>`h${++index}`) + '';
let $7f4b319848d3c701$export$f24150b9675a2c65 = (()=>{
    var _PageNav_list_accessor_storage, _PageNav_scrollY_accessor_storage;
    let _classDecorators = [
        (0, $2c52cd3eacadeaca$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $7DB8U.Component);
    let _instanceExtraInitializers = [];
    let _list_decorators;
    let _list_initializers = [];
    let _list_extraInitializers = [];
    let _scrollY_decorators;
    let _scrollY_initializers = [];
    let _scrollY_extraInitializers = [];
    let _get_currentActiveId_decorators;
    var PageNav = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _PageNav_list_accessor_storage.set(this, ($7f4b319848d3c701$var$__runInitializers(this, _instanceExtraInitializers), $7f4b319848d3c701$var$__runInitializers(this, _list_initializers, [])));
            _PageNav_scrollY_accessor_storage.set(this, ($7f4b319848d3c701$var$__runInitializers(this, _list_extraInitializers), $7f4b319848d3c701$var$__runInitializers(this, _scrollY_initializers, 0)));
            Object.defineProperty(this, "updateScrollY", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($7f4b319848d3c701$var$__runInitializers(this, _scrollY_extraInitializers), ()=>this.scrollY = window.scrollY)
            });
            Object.defineProperty(this, "scrollTo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (meta)=>()=>{
                        var _a, _b;
                        setTimeout(()=>(0, $1ec569b22aebf9e3$export$3f99968195accfaf)(`[id="${meta.id}"]`));
                        (_b = (_a = this.props).onItemClick) === null || _b === void 0 || _b.call(_a, meta);
                    }
            });
            Object.defineProperty(this, "renderLink", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ({ id: id, level: level, text: text, top: top })=>{
                    const { currentActiveId: currentActiveId } = this, { depth: depth = Infinity } = this.props;
                    return level <= depth && (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039).Item, {
                        style: {
                            textIndent: `${level - 1}rem`
                        },
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039).Link, {
                            href: `#${id}`,
                            active: currentActiveId === id,
                            onClick: this.scrollTo({
                                id: id,
                                level: level,
                                text: text,
                                top: top
                            }),
                            children: text
                        })
                    }, id);
                }
            });
        }
        get list() {
            return $7f4b319848d3c701$var$__classPrivateFieldGet(this, _PageNav_list_accessor_storage, "f");
        }
        set list(value) {
            $7f4b319848d3c701$var$__classPrivateFieldSet(this, _PageNav_list_accessor_storage, value, "f");
        }
        get scrollY() {
            return $7f4b319848d3c701$var$__classPrivateFieldGet(this, _PageNav_scrollY_accessor_storage, "f");
        }
        set scrollY(value) {
            $7f4b319848d3c701$var$__classPrivateFieldSet(this, _PageNav_scrollY_accessor_storage, value, "f");
        }
        get currentActiveId() {
            var _a;
            const { list: list, scrollY: scrollY } = this;
            const index = list.findIndex(({ top: top })=>top > scrollY);
            return (_a = list[index - 1]) === null || _a === void 0 ? void 0 : _a.id;
        }
        componentDidMount() {
            if (!globalThis.document) return;
            window.addEventListener('scroll', this.updateScrollY);
            this.list = Array.from(document.querySelectorAll($7f4b319848d3c701$var$HeadingSelector), (element)=>{
                element.id || (element.id = (0, $1ec569b22aebf9e3$export$89912e019eef22aa)());
                const { id: id, tagName: tagName, textContent: textContent, offsetTop: offsetTop } = element;
                return {
                    id: id,
                    level: +tagName[1],
                    text: textContent.trim(),
                    top: offsetTop
                };
            });
        }
        componentWillUnmount() {
            var _a;
            (_a = globalThis.removeEventListener) === null || _a === void 0 || _a.call(globalThis, 'scroll', this.updateScrollY);
        }
        render() {
            const { list: list } = this, _a = this.props, { style: style, variant: variant = 'underline' } = _a, props = $7f4b319848d3c701$var$__rest(_a, [
                "style",
                "variant"
            ]);
            return (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039), Object.assign({}, props, {
                variant: variant,
                style: Object.assign({
                    flexDirection: 'column'
                }, style),
                children: list.map(this.renderLink)
            }));
        }
    };
    _PageNav_list_accessor_storage = new WeakMap();
    _PageNav_scrollY_accessor_storage = new WeakMap();
    $7f4b319848d3c701$var$__setFunctionName(_classThis, "PageNav");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _list_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        _scrollY_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        _get_currentActiveId_decorators = [
            (0, $fecbc4a33bb0f224$export$2983e091f1a1e8e2)
        ];
        $7f4b319848d3c701$var$__esDecorate(_classThis, null, _list_decorators, {
            kind: "accessor",
            name: "list",
            static: false,
            private: false,
            access: {
                has: (obj)=>"list" in obj,
                get: (obj)=>obj.list,
                set: (obj, value)=>{
                    obj.list = value;
                }
            },
            metadata: _metadata
        }, _list_initializers, _list_extraInitializers);
        $7f4b319848d3c701$var$__esDecorate(_classThis, null, _scrollY_decorators, {
            kind: "accessor",
            name: "scrollY",
            static: false,
            private: false,
            access: {
                has: (obj)=>"scrollY" in obj,
                get: (obj)=>obj.scrollY,
                set: (obj, value)=>{
                    obj.scrollY = value;
                }
            },
            metadata: _metadata
        }, _scrollY_initializers, _scrollY_extraInitializers);
        $7f4b319848d3c701$var$__esDecorate(_classThis, null, _get_currentActiveId_decorators, {
            kind: "getter",
            name: "currentActiveId",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentActiveId" in obj,
                get: (obj)=>obj.currentActiveId
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $7f4b319848d3c701$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        PageNav = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'PageNav'
    });
    (()=>{
        $7f4b319848d3c701$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return PageNav = _classThis;
})();


var $839f5d21a5a9dff5$exports = {};

$parcel$export($839f5d21a5a9dff5$exports, "ScrollNav", () => $839f5d21a5a9dff5$export$c57977d1ebb6ef1d);




var $7DB8U = parcelRequire("7DB8U");


var $7b22e524364c5120$export$70443d1bfecdb242;
var $7b22e524364c5120$export$a025291d1676ce41;
var $7b22e524364c5120$export$2585081e06ef4cbf;
$7b22e524364c5120$export$70443d1bfecdb242 = `_1MZNfG_scrollButtonLeft`;
$7b22e524364c5120$export$a025291d1676ce41 = `_1MZNfG_scrollButtonRight`;
$7b22e524364c5120$export$2585081e06ef4cbf = `_1MZNfG_scrollerInner`;


var $839f5d21a5a9dff5$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $839f5d21a5a9dff5$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $839f5d21a5a9dff5$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $839f5d21a5a9dff5$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $839f5d21a5a9dff5$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $839f5d21a5a9dff5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * A horizontal scrolling navigation bar based on Bootstrap's `nav-scroller` pattern.
 * Automatically shows scroll arrow buttons when nav items overflow the container width.
 *
 * @see {@link https://github.com/twbs/bootstrap/blob/main/site/src/assets/examples/offcanvas-navbar/index.astro#L50-L65}
 */ let $839f5d21a5a9dff5$export$c57977d1ebb6ef1d = (()=>{
    var _ScrollNav_scrollLeft_accessor_storage, _ScrollNav_scrollWidth_accessor_storage, _ScrollNav_clientWidth_accessor_storage;
    let _classDecorators = [
        (0, $2c52cd3eacadeaca$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $7DB8U.Component);
    let _instanceExtraInitializers = [];
    let _scrollLeft_decorators;
    let _scrollLeft_initializers = [];
    let _scrollLeft_extraInitializers = [];
    let _scrollWidth_decorators;
    let _scrollWidth_initializers = [];
    let _scrollWidth_extraInitializers = [];
    let _clientWidth_decorators;
    let _clientWidth_initializers = [];
    let _clientWidth_extraInitializers = [];
    let _get_canScrollLeft_decorators;
    let _get_canScrollRight_decorators;
    var ScrollNav = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "scrollerRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($839f5d21a5a9dff5$var$__runInitializers(this, _instanceExtraInitializers), /*#__PURE__*/ (0, $7DB8U.createRef)())
            });
            _ScrollNav_scrollLeft_accessor_storage.set(this, $839f5d21a5a9dff5$var$__runInitializers(this, _scrollLeft_initializers, 0));
            _ScrollNav_scrollWidth_accessor_storage.set(this, ($839f5d21a5a9dff5$var$__runInitializers(this, _scrollLeft_extraInitializers), $839f5d21a5a9dff5$var$__runInitializers(this, _scrollWidth_initializers, 0)));
            _ScrollNav_clientWidth_accessor_storage.set(this, ($839f5d21a5a9dff5$var$__runInitializers(this, _scrollWidth_extraInitializers), $839f5d21a5a9dff5$var$__runInitializers(this, _clientWidth_initializers, 0)));
            Object.defineProperty(this, "updateScroll", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($839f5d21a5a9dff5$var$__runInitializers(this, _clientWidth_extraInitializers), ()=>{
                    const scroller = this.scrollerRef.current;
                    if (scroller) {
                        this.scrollLeft = scroller.scrollLeft;
                        this.scrollWidth = scroller.scrollWidth;
                        this.clientWidth = scroller.clientWidth;
                    }
                    return scroller;
                })
            });
            Object.defineProperty(this, "resizeObserver", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "scrollBy", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (direction)=>()=>{
                        const scroller = this.scrollerRef.current;
                        if (!scroller) return;
                        scroller.scrollBy({
                            left: direction * scroller.clientWidth * 0.8,
                            behavior: 'smooth'
                        });
                    }
            });
        }
        get scrollLeft() {
            return $839f5d21a5a9dff5$var$__classPrivateFieldGet(this, _ScrollNav_scrollLeft_accessor_storage, "f");
        }
        set scrollLeft(value) {
            $839f5d21a5a9dff5$var$__classPrivateFieldSet(this, _ScrollNav_scrollLeft_accessor_storage, value, "f");
        }
        get scrollWidth() {
            return $839f5d21a5a9dff5$var$__classPrivateFieldGet(this, _ScrollNav_scrollWidth_accessor_storage, "f");
        }
        set scrollWidth(value) {
            $839f5d21a5a9dff5$var$__classPrivateFieldSet(this, _ScrollNav_scrollWidth_accessor_storage, value, "f");
        }
        get clientWidth() {
            return $839f5d21a5a9dff5$var$__classPrivateFieldGet(this, _ScrollNav_clientWidth_accessor_storage, "f");
        }
        set clientWidth(value) {
            $839f5d21a5a9dff5$var$__classPrivateFieldSet(this, _ScrollNav_clientWidth_accessor_storage, value, "f");
        }
        get canScrollLeft() {
            return this.scrollLeft > 0;
        }
        get canScrollRight() {
            return this.scrollLeft + this.clientWidth < this.scrollWidth;
        }
        componentDidMount() {
            const scroller = this.updateScroll();
            if (!scroller) return;
            scroller.addEventListener('scroll', this.updateScroll);
            this.resizeObserver = new ResizeObserver(this.updateScroll);
            this.resizeObserver.observe(scroller);
        }
        componentWillUnmount() {
            var _a, _b;
            (_a = this.resizeObserver) === null || _a === void 0 || _a.disconnect();
            (_b = this.scrollerRef.current) === null || _b === void 0 || _b.removeEventListener('scroll', this.updateScroll);
        }
        render() {
            const { canScrollLeft: canScrollLeft, canScrollRight: canScrollRight } = this;
            const _a = this.props, { className: className = '', children: children } = _a, props = $839f5d21a5a9dff5$var$__rest(_a, [
                "className",
                "children"
            ]);
            return (0, $e830bf8f8acfe41d$exports.jsxs)("div", {
                className: `position-relative overflow-y-hidden ${className}`,
                children: [
                    canScrollLeft && (0, $e830bf8f8acfe41d$exports.jsx)("button", {
                        type: "button",
                        className: `position-absolute top-0 bottom-0 start-0 z-1 border-0 px-2 ${$7b22e524364c5120$export$70443d1bfecdb242}`,
                        "aria-label": "Scroll left",
                        onClick: this.scrollBy(-1),
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $a9e058be8650f0e1$export$f04a61298a47a40f), {
                            name: "caret-left-fill"
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                        ref: this.scrollerRef,
                        className: `overflow-x-auto ${$7b22e524364c5120$export$2585081e06ef4cbf}`,
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039), Object.assign({}, props, {
                            className: "flex-nowrap",
                            children: children
                        }))
                    }),
                    canScrollRight && (0, $e830bf8f8acfe41d$exports.jsx)("button", {
                        type: "button",
                        className: `position-absolute top-0 bottom-0 end-0 z-1 border-0 px-2 ${$7b22e524364c5120$export$a025291d1676ce41}`,
                        "aria-label": "Scroll right",
                        onClick: this.scrollBy(1),
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $a9e058be8650f0e1$export$f04a61298a47a40f), {
                            name: "caret-right-fill"
                        })
                    })
                ]
            });
        }
    };
    _ScrollNav_scrollLeft_accessor_storage = new WeakMap();
    _ScrollNav_scrollWidth_accessor_storage = new WeakMap();
    _ScrollNav_clientWidth_accessor_storage = new WeakMap();
    $839f5d21a5a9dff5$var$__setFunctionName(_classThis, "ScrollNav");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _scrollLeft_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        _scrollWidth_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        _clientWidth_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        _get_canScrollLeft_decorators = [
            (0, $fecbc4a33bb0f224$export$2983e091f1a1e8e2)
        ];
        _get_canScrollRight_decorators = [
            (0, $fecbc4a33bb0f224$export$2983e091f1a1e8e2)
        ];
        $839f5d21a5a9dff5$var$__esDecorate(_classThis, null, _scrollLeft_decorators, {
            kind: "accessor",
            name: "scrollLeft",
            static: false,
            private: false,
            access: {
                has: (obj)=>"scrollLeft" in obj,
                get: (obj)=>obj.scrollLeft,
                set: (obj, value)=>{
                    obj.scrollLeft = value;
                }
            },
            metadata: _metadata
        }, _scrollLeft_initializers, _scrollLeft_extraInitializers);
        $839f5d21a5a9dff5$var$__esDecorate(_classThis, null, _scrollWidth_decorators, {
            kind: "accessor",
            name: "scrollWidth",
            static: false,
            private: false,
            access: {
                has: (obj)=>"scrollWidth" in obj,
                get: (obj)=>obj.scrollWidth,
                set: (obj, value)=>{
                    obj.scrollWidth = value;
                }
            },
            metadata: _metadata
        }, _scrollWidth_initializers, _scrollWidth_extraInitializers);
        $839f5d21a5a9dff5$var$__esDecorate(_classThis, null, _clientWidth_decorators, {
            kind: "accessor",
            name: "clientWidth",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clientWidth" in obj,
                get: (obj)=>obj.clientWidth,
                set: (obj, value)=>{
                    obj.clientWidth = value;
                }
            },
            metadata: _metadata
        }, _clientWidth_initializers, _clientWidth_extraInitializers);
        $839f5d21a5a9dff5$var$__esDecorate(_classThis, null, _get_canScrollLeft_decorators, {
            kind: "getter",
            name: "canScrollLeft",
            static: false,
            private: false,
            access: {
                has: (obj)=>"canScrollLeft" in obj,
                get: (obj)=>obj.canScrollLeft
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $839f5d21a5a9dff5$var$__esDecorate(_classThis, null, _get_canScrollRight_decorators, {
            kind: "getter",
            name: "canScrollRight",
            static: false,
            private: false,
            access: {
                has: (obj)=>"canScrollRight" in obj,
                get: (obj)=>obj.canScrollRight
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $839f5d21a5a9dff5$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        ScrollNav = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'ScrollNav'
    });
    (()=>{
        $839f5d21a5a9dff5$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return ScrollNav = _classThis;
})();


var $7a4511f8af51cbbb$exports = {};

$parcel$export($7a4511f8af51cbbb$exports, "Option", () => $7a4511f8af51cbbb$export$36d18380658d5d20);
$parcel$export($7a4511f8af51cbbb$exports, "Select", () => $7a4511f8af51cbbb$export$ef9b1a59e592288f);



var $7DB8U = parcelRequire("7DB8U");


var $7DB8U = parcelRequire("7DB8U");



var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");
function $424274a7cd447a98$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $424274a7cd447a98$var$_toPropertyKey(arg) {
    var key = $424274a7cd447a98$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $424274a7cd447a98$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $424274a7cd447a98$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $424274a7cd447a98$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $7DB8U.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $7DB8U.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $7DB8U.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $424274a7cd447a98$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $424274a7cd447a98$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $424274a7cd447a98$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($424274a7cd447a98$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $424274a7cd447a98$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}







var $7DB8U = parcelRequire("7DB8U");
const $066bdebc2a11ac5d$var$DropdownContext = /*#__PURE__*/ $7DB8U.createContext(null);
var $066bdebc2a11ac5d$export$2e2bcd8739ae039 = $066bdebc2a11ac5d$var$DropdownContext;



var $7DB8U = parcelRequire("7DB8U");






const $22c6f25b7eedf8de$var$_excluded = [
    "children",
    "usePopper"
];
function $22c6f25b7eedf8de$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $22c6f25b7eedf8de$var$noop = ()=>{};
function $22c6f25b7eedf8de$export$133c4d08f3775d64(options = {}) {
    const context = (0, $7DB8U.useContext)((0, $066bdebc2a11ac5d$export$2e2bcd8739ae039));
    const [arrowElement, attachArrowRef] = (0, $ef5fbefb53d1c0cc$export$2e2bcd8739ae039)();
    const hasShownRef = (0, $7DB8U.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $23847a85f7f32bdf$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $81347f664366abcb$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $22c6f25b7eedf8de$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $77e2067be7ecd5d8$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $22c6f25b7eedf8de$var$DropdownMenu(_ref) {
    let { children: children, usePopper: usePopperProp = true } = _ref, options = $22c6f25b7eedf8de$var$_objectWithoutPropertiesLoose(_ref, $22c6f25b7eedf8de$var$_excluded);
    const [props, meta] = $22c6f25b7eedf8de$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $e830bf8f8acfe41d$exports.Fragment), {
        children: children(props, meta)
    });
}
$22c6f25b7eedf8de$var$DropdownMenu.displayName = 'DropdownMenu';
var /** @component */ $22c6f25b7eedf8de$export$2e2bcd8739ae039 = $22c6f25b7eedf8de$var$DropdownMenu;



var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rsp-rules/use-layout-effect-rule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).createContext($305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$defaultContext);
const $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).createContext(false);
// This is only used in React < 18.
function $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$LegacySSRProvider(props) {
    let cur = (0, $7DB8U.useContext)($305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$SSRContext);
    let counter = $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$useCounter(cur === $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $7DB8U.useState)(true);
    let value = (0, $7DB8U.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $7DB8U.useLayoutEffect)(()=>{
        // oxlint-disable-next-line react/react-compiler
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).createElement($305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).createElement($305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$warnedAboutSSRProvider = false;
function $305f118f0e8bc1b9$export$9f8ac96af4b1b2ae(props) {
    // oxlint-disable-next-line react/react-compiler
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).createElement($305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$LegacySSRProvider, props);
}
let $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$componentIds = new WeakMap();
function $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$useCounter(isDisabled = false) {
    let ctx = (0, $7DB8U.useContext)($305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$SSRContext);
    let ref = (0, $7DB8U.useRef)(null);
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    if (ref.current === null && !isDisabled) {
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        let currentOwner = (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED?.ReactCurrentOwner?.current;
        if (currentOwner) {
            let prevComponentValue = $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                // oxlint-disable-next-line react/react-compiler
                ctx.current = prevComponentValue.id;
                $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rsp-rules/pure-render
        // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    return ref.current;
}
function $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $7DB8U.useContext)($305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$defaultContext && $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$canUseDOM;
    let counter = $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U))).useId();
    let [didSSR] = (0, $7DB8U.useState)($305f118f0e8bc1b9$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $305f118f0e8bc1b9$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U)))['useId'] === 'function' ? $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$useModernSSRSafeId : $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$useLegacySSRSafeId;
function $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$getSnapshot() {
    return false;
}
function $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $305f118f0e8bc1b9$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    // oxlint-disable-next-line react/react-compiler
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($7DB8U)))['useSyncExternalStore']($305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$subscribe, $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$getSnapshot, $305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$getServerSnapshot);
    // oxlint-disable-next-line react/react-compiler, react-hooks/rules-of-hooks
    return (0, $7DB8U.useContext)($305f118f0e8bc1b9$var$$c7eafbbe1ea5834e$var$IsSSRContext);
}




const $4bfc6006dc2646cb$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const $4bfc6006dc2646cb$var$noop = ()=>{};
function $4bfc6006dc2646cb$export$96df6c7c5036b9a2() {
    const id = (0, $305f118f0e8bc1b9$export$619500959fc48b26)();
    const { show: show = false, toggle: toggle = $4bfc6006dc2646cb$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $7DB8U.useContext)((0, $066bdebc2a11ac5d$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $7DB8U.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $4bfc6006dc2646cb$var$noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $4bfc6006dc2646cb$export$386b1213cf9779d8(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $4bfc6006dc2646cb$var$DropdownToggle({ children: children }) {
    const [props, meta] = $4bfc6006dc2646cb$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $e830bf8f8acfe41d$exports.Fragment), {
        children: children(props, meta)
    });
}
$4bfc6006dc2646cb$var$DropdownToggle.displayName = 'DropdownToggle';
var /** @component */ $4bfc6006dc2646cb$export$2e2bcd8739ae039 = $4bfc6006dc2646cb$var$DropdownToggle;



var $7DB8U = parcelRequire("7DB8U");






const $d4ce85ad3264c276$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $d4ce85ad3264c276$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $d4ce85ad3264c276$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $7DB8U.useContext)((0, $988f4de41e5b7681$export$2e2bcd8739ae039));
    const navContext = (0, $7DB8U.useContext)((0, $1a2f134684370479$export$2e2bcd8739ae039));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $988f4de41e5b7681$export$eef49b42fde998a3)(key, href);
    const isActive = active == null && key != null ? (0, $988f4de41e5b7681$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    const handleClick = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, $bec69d0ef4577e78$export$5cc3b7b83e34ade7)('dropdown-item')]: ''
        },
        {
            isActive: isActive
        }
    ];
}
const $d4ce85ad3264c276$var$DropdownItem = /*#__PURE__*/ $7DB8U.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $ca03a707c779611a$export$2e2bcd8739ae039) } = _ref, props = $d4ce85ad3264c276$var$_objectWithoutPropertiesLoose(_ref, $d4ce85ad3264c276$var$_excluded);
    const [dropdownItemProps] = $d4ce85ad3264c276$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$d4ce85ad3264c276$var$DropdownItem.displayName = 'DropdownItem';
var $d4ce85ad3264c276$export$2e2bcd8739ae039 = $d4ce85ad3264c276$var$DropdownItem;






function $33454fe181830f5c$var$useRefWithUpdate() {
    const forceUpdate = (0, $f36de207fe884169$export$2e2bcd8739ae039)();
    const ref = (0, $7DB8U.useRef)(null);
    const attachRef = (0, $7DB8U.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $33454fe181830f5c$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $bec69d0ef4577e78$export$5cc3b7b83e34ade7)('dropdown-item')}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = 'bottom-start', children: children }) {
    const window = (0, $6e5a5ef831ae81c7$export$2e2bcd8739ae039)();
    const [show, onToggle] = (0, $424274a7cd447a98$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $33454fe181830f5c$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $33454fe181830f5c$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $fb71ae22f6c1c147$export$2e2bcd8739ae039)(show);
    const lastSourceEvent = (0, $7DB8U.useRef)(null);
    const focusInDropdown = (0, $7DB8U.useRef)(false);
    const onSelectCtx = (0, $7DB8U.useContext)((0, $988f4de41e5b7681$export$2e2bcd8739ae039));
    const toggle = (0, $7DB8U.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $7DB8U.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $4bfc6006dc2646cb$export$386b1213cf9779d8)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, $e756898da11911b9$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $7DB8U.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $7DB8U.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $e756898da11911b9$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $d38ba8f6ff2b729d$export$2e2bcd8739ae039)((0, $7DB8U.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $988f4de41e5b7681$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $066bdebc2a11ac5d$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$33454fe181830f5c$var$Dropdown.displayName = 'Dropdown';
$33454fe181830f5c$var$Dropdown.Menu = (0, $22c6f25b7eedf8de$export$2e2bcd8739ae039);
$33454fe181830f5c$var$Dropdown.Toggle = (0, $4bfc6006dc2646cb$export$2e2bcd8739ae039);
$33454fe181830f5c$var$Dropdown.Item = (0, $d4ce85ad3264c276$export$2e2bcd8739ae039);
var $33454fe181830f5c$export$2e2bcd8739ae039 = $33454fe181830f5c$var$Dropdown;





var $7DB8U = parcelRequire("7DB8U");
"use client";
const $ad28cc97f31ddbd5$var$DropdownContext = /*#__PURE__*/ $7DB8U.createContext({});
$ad28cc97f31ddbd5$var$DropdownContext.displayName = 'DropdownContext';
var $ad28cc97f31ddbd5$export$2e2bcd8739ae039 = $ad28cc97f31ddbd5$var$DropdownContext;



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $b56b5ef19c345092$var$DropdownDivider = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'hr', role: role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$b56b5ef19c345092$var$DropdownDivider.displayName = 'DropdownDivider';
var $b56b5ef19c345092$export$2e2bcd8739ae039 = $b56b5ef19c345092$var$DropdownDivider;



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $8eae0940ae5aa244$var$DropdownHeader = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', role: role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$8eae0940ae5aa244$var$DropdownHeader.displayName = 'DropdownHeader';
var $8eae0940ae5aa244$export$2e2bcd8739ae039 = $8eae0940ae5aa244$var$DropdownHeader;




var $7DB8U = parcelRequire("7DB8U");




"use client";
const $bd31e2ff088dfc95$var$DropdownItem = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $ba3423761edfecbc$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, $d4ce85ad3264c276$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
$bd31e2ff088dfc95$var$DropdownItem.displayName = 'DropdownItem';
var $bd31e2ff088dfc95$export$2e2bcd8739ae039 = $bd31e2ff088dfc95$var$DropdownItem;



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $457c869c3eab109b$var$DropdownItemText = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$457c869c3eab109b$var$DropdownItemText.displayName = 'DropdownItemText';
var $457c869c3eab109b$export$2e2bcd8739ae039 = $457c869c3eab109b$var$DropdownItemText;




var $7DB8U = parcelRequire("7DB8U");






var $7DB8U = parcelRequire("7DB8U");
"use client";
const $5f9abe7800bfcf37$var$context = /*#__PURE__*/ $7DB8U.createContext(null);
$5f9abe7800bfcf37$var$context.displayName = 'InputGroupContext';
var $5f9abe7800bfcf37$export$2e2bcd8739ae039 = $5f9abe7800bfcf37$var$context;





parcelRequire("7DB8U");

function $1697a79e27664fdb$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $c821abc4a903c10a$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const $c821abc4a903c10a$var$DropdownMenu = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $7DB8U.useContext)((0, $62bc15095c841559$export$2e2bcd8739ae039));
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $7DB8U.useContext)((0, $ad28cc97f31ddbd5$export$2e2bcd8739ae039));
    align = align || contextAlign;
    const isInputGroup = (0, $7DB8U.useContext)((0, $5f9abe7800bfcf37$export$2e2bcd8739ae039));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = $c821abc4a903c10a$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $22c6f25b7eedf8de$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $1e2b613deffe4140$export$2e2bcd8739ae039)((0, $1697a79e27664fdb$export$2e2bcd8739ae039)(ref, 'DropdownMenu'), menuProps.ref);
    (0, $5d10a2d054265037$export$2e2bcd8739ae039)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$c821abc4a903c10a$var$DropdownMenu.displayName = 'DropdownMenu';
var $c821abc4a903c10a$export$2e2bcd8739ae039 = $c821abc4a903c10a$var$DropdownMenu;







var $7DB8U = parcelRequire("7DB8U");




"use client";
const $b0516b4bf7aaf778$var$DropdownToggle = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $e4f2607df5423ec3$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, $7DB8U.useContext)((0, $066bdebc2a11ac5d$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $4bfc6006dc2646cb$export$96df6c7c5036b9a2)();
    toggleProps.ref = (0, $1e2b613deffe4140$export$2e2bcd8739ae039)(toggleProps.ref, (0, $1697a79e27664fdb$export$2e2bcd8739ae039)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
$b0516b4bf7aaf778$var$DropdownToggle.displayName = 'DropdownToggle';
var $b0516b4bf7aaf778$export$2e2bcd8739ae039 = $b0516b4bf7aaf778$var$DropdownToggle;






"use client";
const $ecb5bcf98c9fe309$var$Dropdown = /*#__PURE__*/ $7DB8U.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = 'down', show: show, className: className, align: align = 'start', onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose: autoClose = true, ...props } = (0, $be0af947f6d59f9f$export$2e2bcd8739ae039)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, $7DB8U.useContext)((0, $5f9abe7800bfcf37$export$2e2bcd8739ae039));
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'dropdown');
    const isRTL = (0, $d36baff69136067a$export$35e511eefa30ac5a)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, $297288d717742377$export$2e2bcd8739ae039)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, $c821abc4a903c10a$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    const contextValue = (0, $7DB8U.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $ad28cc97f31ddbd5$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $33454fe181830f5c$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
$ecb5bcf98c9fe309$var$Dropdown.displayName = 'Dropdown';
var $ecb5bcf98c9fe309$export$2e2bcd8739ae039 = Object.assign($ecb5bcf98c9fe309$var$Dropdown, {
    Toggle: (0, $b0516b4bf7aaf778$export$2e2bcd8739ae039),
    Menu: (0, $c821abc4a903c10a$export$2e2bcd8739ae039),
    Item: (0, $bd31e2ff088dfc95$export$2e2bcd8739ae039),
    ItemText: (0, $457c869c3eab109b$export$2e2bcd8739ae039),
    Divider: (0, $b56b5ef19c345092$export$2e2bcd8739ae039),
    Header: (0, $8eae0940ae5aa244$export$2e2bcd8739ae039)
});



var $7a4511f8af51cbbb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $7a4511f8af51cbbb$export$36d18380658d5d20 = (_a)=>{
    var { value: value, children: children } = _a, props = $7a4511f8af51cbbb$var$__rest(_a, [
        "value",
        "children"
    ]);
    return (0, $e830bf8f8acfe41d$exports.jsx)((0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039).Item, Object.assign({}, props, {
        "data-value": value,
        children: children
    }));
};
$7a4511f8af51cbbb$export$36d18380658d5d20.displayName = 'Option';
const $7a4511f8af51cbbb$export$ef9b1a59e592288f = ({ className: className, style: style, variant: variant, menuVariant: menuVariant, children: children, value: value, onChange: onChange, valueRender: valueRender })=>{
    const current = (0, $1ec569b22aebf9e3$export$7b85fd78dd236198)(children).flat(Infinity).find((node)=>/*#__PURE__*/ (0, $7DB8U.isValidElement)(node) && node.type === $7a4511f8af51cbbb$export$36d18380658d5d20 && node.props.value === value);
    return (0, $e830bf8f8acfe41d$exports.jsxs)((0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039), {
        onClick: ({ target: target })=>{
            const option = target.closest('.dropdown-item');
            if (!option) return;
            const { value: value } = option.dataset;
            onChange === null || onChange === void 0 || onChange(value);
        },
        children: [
            (0, $e830bf8f8acfe41d$exports.jsx)((0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039).Toggle, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('w-100', 'd-flex', 'justify-content-between', 'align-items-center', !variant && 'bg-white text-dark', className),
                style: style,
                variant: variant,
                children: (valueRender === null || valueRender === void 0 ? void 0 : valueRender(value)) || (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                    className: current === null || current === void 0 ? void 0 : current.props.className,
                    children: current === null || current === void 0 ? void 0 : current.props.children
                })
            }),
            (0, $e830bf8f8acfe41d$exports.jsx)((0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039).Menu, {
                variant: menuVariant,
                children: children
            })
        ]
    });
};
$7a4511f8af51cbbb$export$ef9b1a59e592288f.displayName = 'Select';


var $b68896d3a4d7fbf1$exports = {};

$parcel$export($b68896d3a4d7fbf1$exports, "elementToImage", () => $b68896d3a4d7fbf1$export$fefa3387c33a1dfc);
$parcel$export($b68896d3a4d7fbf1$exports, "ShareBox", () => $b68896d3a4d7fbf1$export$e15a265ebbd5ca8c);

var $799264a770627072$exports = {};
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $799264a770627072$exports = factory();
})($799264a770627072$exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});





var $7DB8U = parcelRequire("7DB8U");


var $7DB8U = parcelRequire("7DB8U");



"use client";
const $facf438de9c933e7$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool
};
const $facf438de9c933e7$var$Image = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, fluid: fluid = false, rounded: rounded = false, roundedCircle: roundedCircle = false, thumbnail: thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("img", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
$facf438de9c933e7$var$Image.displayName = 'Image';
var $facf438de9c933e7$export$2e2bcd8739ae039 = $facf438de9c933e7$var$Image;




var $b68896d3a4d7fbf1$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $b68896d3a4d7fbf1$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $b68896d3a4d7fbf1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b68896d3a4d7fbf1$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $b68896d3a4d7fbf1$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $b68896d3a4d7fbf1$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $b68896d3a4d7fbf1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $b68896d3a4d7fbf1$export$fefa3387c33a1dfc(element, type, quality) {
    return $b68896d3a4d7fbf1$var$__awaiter(this, void 0, void 0, function*() {
        const canvas = yield (0, (/*@__PURE__*/$parcel$interopDefault($799264a770627072$exports)))(element, {
            useCORS: true
        });
        return new Promise((resolve, reject)=>canvas.toBlob((blob)=>blob ? resolve(URL.createObjectURL(blob)) : reject(), type, quality));
    });
}
let $b68896d3a4d7fbf1$export$e15a265ebbd5ca8c = (()=>{
    var _ShareBox_loading_accessor_storage, _ShareBox_imageURI_accessor_storage;
    let _classDecorators = [
        (0, $2c52cd3eacadeaca$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $7DB8U.Component);
    let _loading_decorators;
    let _loading_initializers = [];
    let _loading_extraInitializers = [];
    let _imageURI_decorators;
    let _imageURI_initializers = [];
    let _imageURI_extraInitializers = [];
    var ShareBox = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "root", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: /*#__PURE__*/ (0, $7DB8U.createRef)()
            });
            _ShareBox_loading_accessor_storage.set(this, $b68896d3a4d7fbf1$var$__runInitializers(this, _loading_initializers, false));
            _ShareBox_imageURI_accessor_storage.set(this, ($b68896d3a4d7fbf1$var$__runInitializers(this, _loading_extraInitializers), $b68896d3a4d7fbf1$var$__runInitializers(this, _imageURI_initializers, '')));
            Object.defineProperty(this, "generateImage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($b68896d3a4d7fbf1$var$__runInitializers(this, _imageURI_extraInitializers), ()=>$b68896d3a4d7fbf1$var$__awaiter(this, void 0, void 0, function*() {
                        if (this.imageURI) {
                            URL.revokeObjectURL(this.imageURI);
                            this.imageURI = '';
                        }
                        this.loading = true;
                        this.imageURI = yield $b68896d3a4d7fbf1$export$fefa3387c33a1dfc(this.root.current);
                        this.loading = false;
                    }))
            });
            Object.defineProperty(this, "share", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (event)=>$b68896d3a4d7fbf1$var$__awaiter(this, void 0, void 0, function*() {
                        var _a;
                        event.stopPropagation();
                        const image = yield (0, $1ec569b22aebf9e3$export$fd89523fba250fa4)(this.imageURI);
                        const file = new File([
                            image
                        ], `${this.props.title}.png`, {
                            type: image.type
                        });
                        yield (_a = navigator.share) === null || _a === void 0 ? void 0 : _a.call(navigator, Object.assign({
                            files: [
                                file
                            ]
                        }, this.props));
                    })
            });
        }
        get loading() {
            return $b68896d3a4d7fbf1$var$__classPrivateFieldGet(this, _ShareBox_loading_accessor_storage, "f");
        }
        set loading(value) {
            $b68896d3a4d7fbf1$var$__classPrivateFieldSet(this, _ShareBox_loading_accessor_storage, value, "f");
        }
        get imageURI() {
            return $b68896d3a4d7fbf1$var$__classPrivateFieldGet(this, _ShareBox_imageURI_accessor_storage, "f");
        }
        set imageURI(value) {
            $b68896d3a4d7fbf1$var$__classPrivateFieldSet(this, _ShareBox_imageURI_accessor_storage, value, "f");
        }
        componentDidMount() {
            var _a;
            (_a = globalThis.addEventListener) === null || _a === void 0 || _a.call(globalThis, 'resize', this.generateImage);
        }
        componentWillUnmount() {
            var _a;
            (_a = globalThis.removeEventListener) === null || _a === void 0 || _a.call(globalThis, 'resize', this.generateImage);
        }
        render() {
            const _a = this.props, { className: className = '', children: children } = _a, props = $b68896d3a4d7fbf1$var$__rest(_a, [
                "className",
                "children"
            ]), { loading: loading, imageURI: imageURI } = this;
            return (0, $e830bf8f8acfe41d$exports.jsxs)((0, $e830bf8f8acfe41d$exports.Fragment), {
                children: [
                    loading && (0, $e830bf8f8acfe41d$exports.jsx)((0, $819e3941170a1790$export$669f6ea7d267feaf), {}),
                    (0, $e830bf8f8acfe41d$exports.jsxs)("div", Object.assign({}, props, {
                        ref: this.root,
                        className: `position-relative ${className}`,
                        onMouseEnter: imageURI ? undefined : this.generateImage,
                        onTouchStart: imageURI ? undefined : this.generateImage,
                        children: [
                            children,
                            imageURI && (0, $e830bf8f8acfe41d$exports.jsx)((0, $facf438de9c933e7$export$2e2bcd8739ae039), {
                                className: "position-absolute start-0 top-0 w-100 h-100",
                                src: imageURI,
                                alt: "Share Image",
                                fluid: true,
                                onClick: this.share
                            })
                        ]
                    }))
                ]
            });
        }
    };
    _ShareBox_loading_accessor_storage = new WeakMap();
    _ShareBox_imageURI_accessor_storage = new WeakMap();
    $b68896d3a4d7fbf1$var$__setFunctionName(_classThis, "ShareBox");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _loading_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        _imageURI_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        $b68896d3a4d7fbf1$var$__esDecorate(_classThis, null, _loading_decorators, {
            kind: "accessor",
            name: "loading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loading" in obj,
                get: (obj)=>obj.loading,
                set: (obj, value)=>{
                    obj.loading = value;
                }
            },
            metadata: _metadata
        }, _loading_initializers, _loading_extraInitializers);
        $b68896d3a4d7fbf1$var$__esDecorate(_classThis, null, _imageURI_decorators, {
            kind: "accessor",
            name: "imageURI",
            static: false,
            private: false,
            access: {
                has: (obj)=>"imageURI" in obj,
                get: (obj)=>obj.imageURI,
                set: (obj, value)=>{
                    obj.imageURI = value;
                }
            },
            metadata: _metadata
        }, _imageURI_initializers, _imageURI_extraInitializers);
        $b68896d3a4d7fbf1$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        ShareBox = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'ShareBox'
    });
    (()=>{
        $b68896d3a4d7fbf1$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return ShareBox = _classThis;
})();


var $51c976be9e7826ec$exports = {};

$parcel$export($51c976be9e7826ec$exports, "SpinnerButton", () => $51c976be9e7826ec$export$4cfabf47f4311ebb);


var $51c976be9e7826ec$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $51c976be9e7826ec$export$4cfabf47f4311ebb = (_a)=>{
    var { animation: animation, loading: loading, disabled: disabled, children: children } = _a, props = $51c976be9e7826ec$var$__rest(_a, [
        "animation",
        "loading",
        "disabled",
        "children"
    ]);
    return (0, $e830bf8f8acfe41d$exports.jsxs)((0, $e4f2607df5423ec3$export$2e2bcd8739ae039), Object.assign({}, props, {
        disabled: loading || disabled,
        children: [
            loading && (0, $e830bf8f8acfe41d$exports.jsxs)((0, $e830bf8f8acfe41d$exports.Fragment), {
                children: [
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $3a47f5a8134d38e5$export$2e2bcd8739ae039), {
                        as: "span",
                        className: children ? 'me-2' : '',
                        size: "sm",
                        animation: animation,
                        role: "status",
                        "aria-hidden": "true"
                    }),
                    !children && (0, $e830bf8f8acfe41d$exports.jsx)("span", {
                        className: "visually-hidden",
                        children: "Loading..."
                    })
                ]
            }),
            children
        ]
    }));
};
$51c976be9e7826ec$export$4cfabf47f4311ebb.displayName = 'SpinnerButton';


var $f4f71328f0a19468$exports = {};

$parcel$export($f4f71328f0a19468$exports, "TableSpinner", () => $f4f71328f0a19468$export$4706ba151aa92b7e);


var $f4f71328f0a19468$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f4f71328f0a19468$export$4706ba151aa92b7e = (_a)=>{
    var { animation: animation = 'border', variant: variant = 'primary', size: size, colSpan: colSpan } = _a, props = $f4f71328f0a19468$var$__rest(_a, [
        "animation",
        "variant",
        "size",
        "colSpan"
    ]);
    return (0, $e830bf8f8acfe41d$exports.jsx)("tr", Object.assign({}, props, {
        children: (0, $e830bf8f8acfe41d$exports.jsx)("td", {
            className: "text-center p-4",
            colSpan: colSpan,
            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $3a47f5a8134d38e5$export$2e2bcd8739ae039), {
                animation: animation,
                variant: variant,
                size: size
            })
        })
    }));
};
$f4f71328f0a19468$export$4706ba151aa92b7e.displayName = 'TableSpinner';


var $9933903675cc8cbf$exports = {};

$parcel$export($9933903675cc8cbf$exports, "TextTruncate", () => $9933903675cc8cbf$export$ee6221c372f955f);




var $7DB8U = parcelRequire("7DB8U");
var $9933903675cc8cbf$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $9933903675cc8cbf$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $9933903675cc8cbf$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $9933903675cc8cbf$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9933903675cc8cbf$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $9933903675cc8cbf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $9933903675cc8cbf$export$ee6221c372f955f = (()=>{
    var _TextTruncate_expanded_accessor_storage, _TextTruncate_overflowed_accessor_storage;
    let _classDecorators = [
        (0, $2c52cd3eacadeaca$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $7DB8U.Component);
    let _expanded_decorators;
    let _expanded_initializers = [];
    let _expanded_extraInitializers = [];
    let _overflowed_decorators;
    let _overflowed_initializers = [];
    let _overflowed_extraInitializers = [];
    var TextTruncate = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _TextTruncate_expanded_accessor_storage.set(this, $9933903675cc8cbf$var$__runInitializers(this, _expanded_initializers, false));
            _TextTruncate_overflowed_accessor_storage.set(this, ($9933903675cc8cbf$var$__runInitializers(this, _expanded_extraInitializers), $9933903675cc8cbf$var$__runInitializers(this, _overflowed_initializers, false)));
            Object.defineProperty(this, "contentRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($9933903675cc8cbf$var$__runInitializers(this, _overflowed_extraInitializers), /*#__PURE__*/ (0, $7DB8U.createRef)())
            });
            Object.defineProperty(this, "checkOverflow", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    const { current: current } = this.contentRef;
                    if (current) this.overflowed = current.scrollHeight > current.clientHeight;
                }
            });
            Object.defineProperty(this, "toggle", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    this.expanded = !this.expanded;
                    if (!this.expanded) requestAnimationFrame(this.checkOverflow);
                }
            });
        }
        get expanded() {
            return $9933903675cc8cbf$var$__classPrivateFieldGet(this, _TextTruncate_expanded_accessor_storage, "f");
        }
        set expanded(value) {
            $9933903675cc8cbf$var$__classPrivateFieldSet(this, _TextTruncate_expanded_accessor_storage, value, "f");
        }
        get overflowed() {
            return $9933903675cc8cbf$var$__classPrivateFieldGet(this, _TextTruncate_overflowed_accessor_storage, "f");
        }
        set overflowed(value) {
            $9933903675cc8cbf$var$__classPrivateFieldSet(this, _TextTruncate_overflowed_accessor_storage, value, "f");
        }
        componentDidMount() {
            this.checkOverflow();
            window.addEventListener('resize', this.checkOverflow);
        }
        componentDidUpdate({ rows: rows, children: children }) {
            if (!this.expanded && (children !== this.props.children || rows !== this.props.rows)) this.checkOverflow();
        }
        componentWillUnmount() {
            window.removeEventListener('resize', this.checkOverflow);
        }
        render() {
            const _a = this.props, { children: children, rows: rows = 3, expandText: expandText = "\u23EC", collapseText: collapseText = "\u23EB" } = _a, props = $9933903675cc8cbf$var$__rest(_a, [
                "children",
                "rows",
                "expandText",
                "collapseText"
            ]);
            const { expanded: expanded, overflowed: overflowed } = this;
            const style = {
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: rows
            };
            return (0, $e830bf8f8acfe41d$exports.jsxs)("div", Object.assign({}, props, {
                children: [
                    (0, $e830bf8f8acfe41d$exports.jsx)("p", {
                        ref: this.contentRef,
                        style: expanded ? undefined : style,
                        children: children
                    }),
                    (overflowed || expanded) && (0, $e830bf8f8acfe41d$exports.jsx)("button", {
                        type: "button",
                        className: "bg-transparent border-0 p-0",
                        "aria-expanded": expanded,
                        onClick: this.toggle,
                        children: expanded ? collapseText : expandText
                    })
                ]
            }));
        }
    };
    _TextTruncate_expanded_accessor_storage = new WeakMap();
    _TextTruncate_overflowed_accessor_storage = new WeakMap();
    $9933903675cc8cbf$var$__setFunctionName(_classThis, "TextTruncate");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _expanded_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        _overflowed_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        $9933903675cc8cbf$var$__esDecorate(_classThis, null, _expanded_decorators, {
            kind: "accessor",
            name: "expanded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"expanded" in obj,
                get: (obj)=>obj.expanded,
                set: (obj, value)=>{
                    obj.expanded = value;
                }
            },
            metadata: _metadata
        }, _expanded_initializers, _expanded_extraInitializers);
        $9933903675cc8cbf$var$__esDecorate(_classThis, null, _overflowed_decorators, {
            kind: "accessor",
            name: "overflowed",
            static: false,
            private: false,
            access: {
                has: (obj)=>"overflowed" in obj,
                get: (obj)=>obj.overflowed,
                set: (obj, value)=>{
                    obj.overflowed = value;
                }
            },
            metadata: _metadata
        }, _overflowed_initializers, _overflowed_extraInitializers);
        $9933903675cc8cbf$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        TextTruncate = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'TextTruncate'
    });
    (()=>{
        $9933903675cc8cbf$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return TextTruncate = _classThis;
})();


var $e27c07fe54f21598$exports = {};

$parcel$export($e27c07fe54f21598$exports, "Time", () => $e27c07fe54f21598$export$680ea196effce5f);





var $e27c07fe54f21598$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $e27c07fe54f21598$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $e27c07fe54f21598$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $e27c07fe54f21598$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $e27c07fe54f21598$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $e27c07fe54f21598$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $e27c07fe54f21598$export$680ea196effce5f = (()=>{
    var _Time_timeText_accessor_storage;
    let _classDecorators = [
        (0, $2c52cd3eacadeaca$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $4d5bac995c3494f7$export$bf180ef329d1efd8);
    let _instanceExtraInitializers = [];
    let _updateText_decorators;
    let _timeText_decorators;
    let _timeText_initializers = [];
    let _timeText_extraInitializers = [];
    var Time = _classThis = class extends _classSuper {
        updateText() {
            const { dateTime: dateTime, format: format } = this.props;
            return (0, $1ec569b22aebf9e3$export$3ae94a2503e890a1)(dateTime, format);
        }
        get timeText() {
            return $e27c07fe54f21598$var$__classPrivateFieldGet(this, _Time_timeText_accessor_storage, "f");
        }
        set timeText(value) {
            $e27c07fe54f21598$var$__classPrivateFieldSet(this, _Time_timeText_accessor_storage, value, "f");
        }
        componentDidMount() {
            super.componentDidMount();
            this.timeText = this.updateText();
        }
        render() {
            const _a = this.props, { dateTime: dateTime } = _a, props = $e27c07fe54f21598$var$__rest(_a, [
                "dateTime"
            ]);
            return (0, $e830bf8f8acfe41d$exports.jsx)("time", Object.assign({
                dateTime: new Date(dateTime).toJSON()
            }, props, {
                children: this.timeText
            }));
        }
        constructor(){
            super(...arguments);
            _Time_timeText_accessor_storage.set(this, ($e27c07fe54f21598$var$__runInitializers(this, _instanceExtraInitializers), $e27c07fe54f21598$var$__runInitializers(this, _timeText_initializers, this.updateText())));
            $e27c07fe54f21598$var$__runInitializers(this, _timeText_extraInitializers);
        }
    };
    _Time_timeText_accessor_storage = new WeakMap();
    $e27c07fe54f21598$var$__setFunctionName(_classThis, "Time");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _updateText_decorators = [
            (0, $4d5bac995c3494f7$export$7203b476385689ae)(({ observedProps: { dateTime: dateTime, format: format } })=>dateTime + format)
        ];
        _timeText_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        $e27c07fe54f21598$var$__esDecorate(_classThis, null, _updateText_decorators, {
            kind: "method",
            name: "updateText",
            static: false,
            private: false,
            access: {
                has: (obj)=>"updateText" in obj,
                get: (obj)=>obj.updateText
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $e27c07fe54f21598$var$__esDecorate(_classThis, null, _timeText_decorators, {
            kind: "accessor",
            name: "timeText",
            static: false,
            private: false,
            access: {
                has: (obj)=>"timeText" in obj,
                get: (obj)=>obj.timeText,
                set: (obj, value)=>{
                    obj.timeText = value;
                }
            },
            metadata: _metadata
        }, _timeText_initializers, _timeText_extraInitializers);
        $e27c07fe54f21598$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Time = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'Time'
    });
    (()=>{
        $e27c07fe54f21598$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Time = _classThis;
})();


var $fd4fe5cf447dc272$exports = {};

$parcel$export($fd4fe5cf447dc272$exports, "TimeDistance", () => $fd4fe5cf447dc272$export$db3f63f9e19e5969);


var $fd4fe5cf447dc272$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $fd4fe5cf447dc272$var$UnitWords = {
    ms: 'millisecond(s)',
    s: 'second(s)',
    m: 'minute(s)',
    H: 'hour(s)',
    D: 'day(s)',
    W: 'week(s)',
    M: 'month(s)',
    Y: 'year(s)'
};
const $fd4fe5cf447dc272$export$db3f63f9e19e5969 = (_a)=>{
    var { date: date, unitWords: unitWords = $fd4fe5cf447dc272$var$UnitWords, beforeWord: beforeWord = ' before', afterWord: afterWord = ' after' } = _a, props = $fd4fe5cf447dc272$var$__rest(_a, [
        "date",
        "unitWords",
        "beforeWord",
        "afterWord"
    ]);
    date = new Date(date);
    const { distance: distance, unit: unit } = (0, $1ec569b22aebf9e3$export$506c8e8f8c8edda)(date);
    return (0, $e830bf8f8acfe41d$exports.jsxs)("time", Object.assign({}, props, {
        dateTime: date.toJSON(),
        title: date.toLocaleString(),
        children: [
            Math.abs(distance),
            " ",
            unitWords[unit],
            distance < 0 ? beforeWord : afterWord
        ]
    }));
};
$fd4fe5cf447dc272$export$db3f63f9e19e5969.displayName = 'TimeDistance';


var $159e4f94d50f7644$exports = {};

$parcel$export($159e4f94d50f7644$exports, "Timeline", () => $159e4f94d50f7644$export$e6a97ba2cae5bb94);



var $7DB8U = parcelRequire("7DB8U");


var $7DB8U = parcelRequire("7DB8U");



"use client";
const $b05427aba15d074f$var$CardBody = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$b05427aba15d074f$var$CardBody.displayName = 'CardBody';
var $b05427aba15d074f$export$2e2bcd8739ae039 = $b05427aba15d074f$var$CardBody;



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $4724fe9f2e308903$var$CardFooter = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$4724fe9f2e308903$var$CardFooter.displayName = 'CardFooter';
var $4724fe9f2e308903$export$2e2bcd8739ae039 = $4724fe9f2e308903$var$CardFooter;




var $7DB8U = parcelRequire("7DB8U");



"use client";
const $a172c7c0d6c528df$var$CardHeader = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'card-header');
    const contextValue = (0, $7DB8U.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $76117b817e14270b$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix)
        })
    });
});
$a172c7c0d6c528df$var$CardHeader.displayName = 'CardHeader';
var $a172c7c0d6c528df$export$2e2bcd8739ae039 = $a172c7c0d6c528df$var$CardHeader;




var $7DB8U = parcelRequire("7DB8U");


"use client";
const $f74994f0f1a31cbc$var$CardImg = /*#__PURE__*/ $7DB8U.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = 'img', ...props }, ref)=>{
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$f74994f0f1a31cbc$var$CardImg.displayName = 'CardImg';
var $f74994f0f1a31cbc$export$2e2bcd8739ae039 = $f74994f0f1a31cbc$var$CardImg;



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $6d284df247300524$var$CardImgOverlay = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$6d284df247300524$var$CardImgOverlay.displayName = 'CardImgOverlay';
var $6d284df247300524$export$2e2bcd8739ae039 = $6d284df247300524$var$CardImgOverlay;



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $57d4066cc2a5f004$var$CardLink = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'a', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$57d4066cc2a5f004$var$CardLink.displayName = 'CardLink';
var $57d4066cc2a5f004$export$2e2bcd8739ae039 = $57d4066cc2a5f004$var$CardLink;



var $7DB8U = parcelRequire("7DB8U");



var $7DB8U = parcelRequire("7DB8U");


var $500199e796627cf1$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $7DB8U.forwardRef((p, ref)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(p.className, className)
        }));



"use client";
const $6f127ffbd6f9eae8$var$DivStyledAsH6 = (0, $500199e796627cf1$export$2e2bcd8739ae039)('h6');
const $6f127ffbd6f9eae8$var$CardSubtitle = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $6f127ffbd6f9eae8$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$6f127ffbd6f9eae8$var$CardSubtitle.displayName = 'CardSubtitle';
var $6f127ffbd6f9eae8$export$2e2bcd8739ae039 = $6f127ffbd6f9eae8$var$CardSubtitle;



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $71d149d0886ec3d8$var$CardText = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'p', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$71d149d0886ec3d8$var$CardText.displayName = 'CardText';
var $71d149d0886ec3d8$export$2e2bcd8739ae039 = $71d149d0886ec3d8$var$CardText;



var $7DB8U = parcelRequire("7DB8U");




"use client";
const $debda5d1fc4956df$var$DivStyledAsH5 = (0, $500199e796627cf1$export$2e2bcd8739ae039)('h5');
const $debda5d1fc4956df$var$CardTitle = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $debda5d1fc4956df$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$debda5d1fc4956df$var$CardTitle.displayName = 'CardTitle';
var $debda5d1fc4956df$export$2e2bcd8739ae039 = $debda5d1fc4956df$var$CardTitle;



"use client";
const $8221a3ef7285f739$var$Card = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $b05427aba15d074f$export$2e2bcd8739ae039), {
            children: children
        }) : children
    });
});
$8221a3ef7285f739$var$Card.displayName = 'Card';
var $8221a3ef7285f739$export$2e2bcd8739ae039 = Object.assign($8221a3ef7285f739$var$Card, {
    Img: (0, $f74994f0f1a31cbc$export$2e2bcd8739ae039),
    Title: (0, $debda5d1fc4956df$export$2e2bcd8739ae039),
    Subtitle: (0, $6f127ffbd6f9eae8$export$2e2bcd8739ae039),
    Body: (0, $b05427aba15d074f$export$2e2bcd8739ae039),
    Link: (0, $57d4066cc2a5f004$export$2e2bcd8739ae039),
    Text: (0, $71d149d0886ec3d8$export$2e2bcd8739ae039),
    Header: (0, $a172c7c0d6c528df$export$2e2bcd8739ae039),
    Footer: (0, $4724fe9f2e308903$export$2e2bcd8739ae039),
    ImgOverlay: (0, $6d284df247300524$export$2e2bcd8739ae039)
});




var $74d3ee0cb08bb808$export$79ffe56a765070d2;
var $74d3ee0cb08bb808$export$cddc5598d4bb8461;
var $74d3ee0cb08bb808$export$73b7b5b52b6662d7;
$74d3ee0cb08bb808$export$79ffe56a765070d2 = `TOztta_right`;
$74d3ee0cb08bb808$export$cddc5598d4bb8461 = `TOztta_timeline`;
$74d3ee0cb08bb808$export$73b7b5b52b6662d7 = `TOztta_timelineItem`;


var $159e4f94d50f7644$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $159e4f94d50f7644$export$e6a97ba2cae5bb94 = (_a)=>{
    var { className: className, events: events, timeFormat: timeFormat } = _a, props = $159e4f94d50f7644$var$__rest(_a, [
        "className",
        "events",
        "timeFormat"
    ]);
    return (0, $e830bf8f8acfe41d$exports.jsx)("ol", Object.assign({
        className: `list-unstyled ${$74d3ee0cb08bb808$export$cddc5598d4bb8461} ${className}`
    }, props, {
        children: events.map(({ title: title, summary: summary, time: time, link: link, people: people })=>(0, $e830bf8f8acfe41d$exports.jsx)("li", {
                className: `position-relative ${$74d3ee0cb08bb808$export$73b7b5b52b6662d7} ${$74d3ee0cb08bb808$export$79ffe56a765070d2}`,
                children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $8221a3ef7285f739$export$2e2bcd8739ae039), {
                    children: (0, $e830bf8f8acfe41d$exports.jsxs)((0, $8221a3ef7285f739$export$2e2bcd8739ae039).Body, {
                        className: "p-4 d-flex flex-column gap-3 align-items-center",
                        children: [
                            (0, $e830bf8f8acfe41d$exports.jsx)("h3", {
                                className: "h5 m-0",
                                children: (0, $e830bf8f8acfe41d$exports.jsx)("a", {
                                    className: "text-decoration-none stretched-link",
                                    href: link,
                                    children: title
                                })
                            }),
                            (0, $e830bf8f8acfe41d$exports.jsxs)("div", {
                                className: "small text-muted d-flex gap-2",
                                children: [
                                    "\u23F2\uFE0F",
                                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $e27c07fe54f21598$export$680ea196effce5f), {
                                        dateTime: time[0],
                                        format: timeFormat
                                    }),
                                    time[1] && '~',
                                    time[1] && (0, $e830bf8f8acfe41d$exports.jsx)((0, $e27c07fe54f21598$export$680ea196effce5f), {
                                        dateTime: time[1],
                                        format: timeFormat
                                    })
                                ]
                            }),
                            (0, $e830bf8f8acfe41d$exports.jsx)("ul", {
                                className: "list-unstyled m-0 d-flex gap-2 flex-wrap justify-content-around",
                                children: people === null || people === void 0 ? void 0 : people.map((person)=>(0, $e830bf8f8acfe41d$exports.jsx)("li", {
                                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $49a38e2a3ce732bb$export$caa4d5435e8fb601), Object.assign({}, person))
                                    }, person.name))
                            }),
                            (0, $e830bf8f8acfe41d$exports.jsx)("p", {
                                className: "m-0",
                                children: summary
                            })
                        ]
                    })
                })
            }, title))
    }));
};
$159e4f94d50f7644$export$e6a97ba2cae5bb94.displayName = 'Timeline';


var $ad55f28c37e4135a$exports = {};

$parcel$export($ad55f28c37e4135a$exports, "Toast", () => $ad55f28c37e4135a$export$8d8dc7d5f743331b);




var $7DB8U = parcelRequire("7DB8U");



var $7DB8U = parcelRequire("7DB8U");



const $5dff16a9df63aa2b$var$fadeStyles = {
    [(0, $6d8a24823bc267eb$export$df38205c966be359)]: 'showing',
    [(0, $6d8a24823bc267eb$export$4aacc83d4d59139f)]: 'showing show'
};
const $5dff16a9df63aa2b$var$ToastFade = /*#__PURE__*/ $7DB8U.forwardRef((props, ref)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $722140d134b37da6$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        transitionClasses: $5dff16a9df63aa2b$var$fadeStyles
    }));
$5dff16a9df63aa2b$var$ToastFade.displayName = 'ToastFade';
var $5dff16a9df63aa2b$export$2e2bcd8739ae039 = $5dff16a9df63aa2b$var$ToastFade;




var $7DB8U = parcelRequire("7DB8U");




var $7DB8U = parcelRequire("7DB8U");


const $062ab6ef4a3114b0$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        'white'
    ])
};
const $062ab6ef4a3114b0$var$CloseButton = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$062ab6ef4a3114b0$var$CloseButton.displayName = 'CloseButton';
$062ab6ef4a3114b0$var$CloseButton.propTypes = $062ab6ef4a3114b0$var$propTypes;
var $062ab6ef4a3114b0$export$2e2bcd8739ae039 = $062ab6ef4a3114b0$var$CloseButton;



var $7DB8U = parcelRequire("7DB8U");
"use client";
const $6d51aa1504d24d73$var$ToastContext = /*#__PURE__*/ $7DB8U.createContext({
    onClose () {}
});
var $6d51aa1504d24d73$export$2e2bcd8739ae039 = $6d51aa1504d24d73$var$ToastContext;



"use client";
const $6d051be57fb61659$var$ToastHeader = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = true, className: className, children: children, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'toast-header');
    const context = (0, $7DB8U.useContext)((0, $6d51aa1504d24d73$export$2e2bcd8739ae039));
    const handleClick = (0, $297288d717742377$export$2e2bcd8739ae039)((e)=>{
        context == null || context.onClose == null || context.onClose(e);
    });
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)("div", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(bsPrefix, className),
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $062ab6ef4a3114b0$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick,
                "data-dismiss": "toast"
            })
        ]
    });
});
$6d051be57fb61659$var$ToastHeader.displayName = 'ToastHeader';
var $6d051be57fb61659$export$2e2bcd8739ae039 = $6d051be57fb61659$var$ToastHeader;



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $1796a9111d78a43c$var$ToastBody = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'toast-body');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$1796a9111d78a43c$var$ToastBody.displayName = 'ToastBody';
var $1796a9111d78a43c$export$2e2bcd8739ae039 = $1796a9111d78a43c$var$ToastBody;





"use client";
const $c7611ce2e776cb7d$var$Toast = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, transition: Transition = (0, $5dff16a9df63aa2b$export$2e2bcd8739ae039), show: show = true, animation: animation = true, delay: delay = 5000, autohide: autohide = false, onClose: onClose, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, bg: bg, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'toast');
    // We use refs for these, because we don't want to restart the autohide
    // timer in case these values change.
    const delayRef = (0, $7DB8U.useRef)(delay);
    const onCloseRef = (0, $7DB8U.useRef)(onClose);
    (0, $7DB8U.useEffect)(()=>{
        delayRef.current = delay;
        onCloseRef.current = onClose;
    }, [
        delay,
        onClose
    ]);
    const autohideTimeout = (0, $c26ada26dd336b02$export$2e2bcd8739ae039)();
    const autohideToast = !!(autohide && show);
    const autohideFunc = (0, $7DB8U.useCallback)(()=>{
        if (autohideToast) onCloseRef.current == null || onCloseRef.current();
    }, [
        autohideToast
    ]);
    (0, $7DB8U.useEffect)(()=>{
        // Only reset timer if show or autohide changes.
        autohideTimeout.set(autohideFunc, delayRef.current);
    }, [
        autohideTimeout,
        autohideFunc
    ]);
    const toastContext = (0, $7DB8U.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    const hasAnimation = !!(Transition && animation);
    const toast = /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(bsPrefix, className, bg && `bg-${bg}`, !hasAnimation && (show ? 'show' : 'hide')),
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
    });
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $6d51aa1504d24d73$export$2e2bcd8739ae039).Provider, {
        value: toastContext,
        children: hasAnimation && Transition ? /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Transition, {
            in: show,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited,
            unmountOnExit: true,
            children: toast
        }) : toast
    });
});
$c7611ce2e776cb7d$var$Toast.displayName = 'Toast';
var $c7611ce2e776cb7d$export$2e2bcd8739ae039 = Object.assign($c7611ce2e776cb7d$var$Toast, {
    Body: (0, $1796a9111d78a43c$export$2e2bcd8739ae039),
    Header: (0, $6d051be57fb61659$export$2e2bcd8739ae039)
});



var $7DB8U = parcelRequire("7DB8U");


"use client";
const $47347b1b06c20d01$var$positionClasses = {
    'top-start': 'top-0 start-0',
    'top-center': 'top-0 start-50 translate-middle-x',
    'top-end': 'top-0 end-0',
    'middle-start': 'top-50 start-0 translate-middle-y',
    'middle-center': 'top-50 start-50 translate-middle',
    'middle-end': 'top-50 end-0 translate-middle-y',
    'bottom-start': 'bottom-0 start-0',
    'bottom-center': 'bottom-0 start-50 translate-middle-x',
    'bottom-end': 'bottom-0 end-0'
};
const $47347b1b06c20d01$var$ToastContainer = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, position: position, containerPosition: containerPosition, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'toast-container');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(bsPrefix, position && $47347b1b06c20d01$var$positionClasses[position], containerPosition && `position-${containerPosition}`, className)
    });
});
$47347b1b06c20d01$var$ToastContainer.displayName = 'ToastContainer';
var $47347b1b06c20d01$export$2e2bcd8739ae039 = $47347b1b06c20d01$var$ToastContainer;



var $ad55f28c37e4135a$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ad55f28c37e4135a$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ad55f28c37e4135a$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ad55f28c37e4135a$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $ad55f28c37e4135a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ad55f28c37e4135a$var$LIGHT_TEXT_VARIANTS = new Set([
    'warning',
    'info',
    'light'
]);
let $ad55f28c37e4135a$export$8d8dc7d5f743331b = (()=>{
    var _a, _Toast_messages_accessor_storage;
    let _messages_decorators;
    let _messages_initializers = [];
    let _messages_extraInitializers = [];
    return _a = class Toast {
        get messages() {
            return $ad55f28c37e4135a$var$__classPrivateFieldGet(this, _Toast_messages_accessor_storage, "f");
        }
        set messages(value) {
            $ad55f28c37e4135a$var$__classPrivateFieldSet(this, _Toast_messages_accessor_storage, value, "f");
        }
        constructor(TimeScalar = (0, $1ec569b22aebf9e3$export$d9bcbd5e1ff81430)){
            Object.defineProperty(this, "TimeScalar", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: TimeScalar
            });
            _Toast_messages_accessor_storage.set(this, $ad55f28c37e4135a$var$__runInitializers(this, _messages_initializers, []));
            Object.defineProperty(this, "Component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ad55f28c37e4135a$var$__runInitializers(this, _messages_extraInitializers), (0, $2c52cd3eacadeaca$export$b6ae1bc530f4c149)(({ position: position = 'top-end' })=>(0, $e830bf8f8acfe41d$exports.jsx)((0, $47347b1b06c20d01$export$2e2bcd8739ae039), {
                        position: position,
                        className: "position-fixed p-3",
                        children: this.messages.map(this.renderMessage)
                    })))
            });
            Object.defineProperty(this, "renderMessage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ({ id: id, openedAt: openedAt, title: title, body: body, variant: variant, delay: delay = 3000 })=>{
                    const bodyClassName = variant && !$ad55f28c37e4135a$var$LIGHT_TEXT_VARIANTS.has(variant) ? 'text-white' : undefined;
                    const showHeader = !!title || delay === 0;
                    const elapsed = this.TimeScalar.distanceOf(Date.now(), openedAt).toShortString();
                    return (0, $e830bf8f8acfe41d$exports.jsxs)((0, $c7611ce2e776cb7d$export$2e2bcd8739ae039), {
                        bg: variant,
                        delay: delay,
                        autohide: delay !== 0,
                        onClose: ()=>this.close(id),
                        children: [
                            showHeader && (0, $e830bf8f8acfe41d$exports.jsxs)((0, $c7611ce2e776cb7d$export$2e2bcd8739ae039).Header, {
                                children: [
                                    (0, $e830bf8f8acfe41d$exports.jsx)("strong", {
                                        className: "me-auto",
                                        children: title
                                    }),
                                    (0, $e830bf8f8acfe41d$exports.jsx)("small", {
                                        children: elapsed
                                    })
                                ]
                            }),
                            (0, $e830bf8f8acfe41d$exports.jsx)((0, $c7611ce2e776cb7d$export$2e2bcd8739ae039).Body, {
                                className: bodyClassName,
                                children: body
                            })
                        ]
                    }, id);
                }
            });
            this.Component.displayName = 'ToastComponent';
        }
        open(message) {
            const id = (0, $1ec569b22aebf9e3$export$89912e019eef22aa)();
            const openedAt = Date.now();
            const { promise: promise, resolve: resolve } = Promise.withResolvers();
            this.messages = [
                ...this.messages,
                Object.assign(Object.assign({
                    id: id
                }, message), {
                    openedAt: openedAt,
                    resolve: resolve
                })
            ];
            return promise;
        }
        close(id) {
            const _b = this.messages.find((message)=>message.id === id) || {}, { resolve: resolve } = _b, item = $ad55f28c37e4135a$var$__rest(_b, [
                "resolve"
            ]);
            resolve === null || resolve === void 0 || resolve(Object.assign(Object.assign({}, item), {
                closedAt: Date.now()
            }));
            this.messages = this.messages.filter((message)=>message.id !== id);
        }
    }, _Toast_messages_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _messages_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        $ad55f28c37e4135a$var$__esDecorate(_a, null, _messages_decorators, {
            kind: "accessor",
            name: "messages",
            static: false,
            private: false,
            access: {
                has: (obj)=>"messages" in obj,
                get: (obj)=>obj.messages,
                set: (obj, value)=>{
                    obj.messages = value;
                }
            },
            metadata: _metadata
        }, _messages_initializers, _messages_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();


var $e7d3cd5a5ac19af3$exports = {};

$parcel$export($e7d3cd5a5ac19af3$exports, "TypeEcho", () => $e7d3cd5a5ac19af3$export$2fe61c915a9818e6);





var $7DB8U = parcelRequire("7DB8U");

var $e7d3cd5a5ac19af3$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $e7d3cd5a5ac19af3$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $e7d3cd5a5ac19af3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e7d3cd5a5ac19af3$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $e7d3cd5a5ac19af3$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $e7d3cd5a5ac19af3$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $e7d3cd5a5ac19af3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $e7d3cd5a5ac19af3$export$2fe61c915a9818e6 = (()=>{
    var _TypeEcho_echoed_accessor_storage;
    let _classDecorators = [
        (0, $2c52cd3eacadeaca$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $7DB8U.Component);
    let _echoed_decorators;
    let _echoed_initializers = [];
    let _echoed_extraInitializers = [];
    var TypeEcho = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _TypeEcho_echoed_accessor_storage.set(this, $e7d3cd5a5ac19af3$var$__runInitializers(this, _echoed_initializers, ''));
            Object.defineProperty(this, "init", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($e7d3cd5a5ac19af3$var$__runInitializers(this, _echoed_extraInitializers), (node)=>node && new IntersectionObserver((_a, observer_1)=>$e7d3cd5a5ac19af3$var$__awaiter(this, [
                            _a,
                            observer_1
                        ], void 0, function*([{ isIntersecting: isIntersecting }], observer) {
                            if (!isIntersecting) return;
                            observer.disconnect();
                            const { text: text, intervals: intervals = 150 } = this.props;
                            for (const char of text){
                                yield (0, $1ec569b22aebf9e3$export$e772c8ff12451969)(intervals / 1000);
                                this.echoed += char;
                            }
                        })).observe(node))
            });
        }
        get echoed() {
            return $e7d3cd5a5ac19af3$var$__classPrivateFieldGet(this, _TypeEcho_echoed_accessor_storage, "f");
        }
        set echoed(value) {
            $e7d3cd5a5ac19af3$var$__classPrivateFieldSet(this, _TypeEcho_echoed_accessor_storage, value, "f");
        }
        render() {
            const _a = this.props, { className: className, text: text } = _a, props = $e7d3cd5a5ac19af3$var$__rest(_a, [
                "className",
                "text"
            ]), { echoed: echoed } = this;
            return (0, $e830bf8f8acfe41d$exports.jsx)("pre", Object.assign({}, props, {
                ref: this.init,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('text-wrap', className),
                children: echoed + (echoed === text ? '' : '_')
            }));
        }
    };
    _TypeEcho_echoed_accessor_storage = new WeakMap();
    $e7d3cd5a5ac19af3$var$__setFunctionName(_classThis, "TypeEcho");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _echoed_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        $e7d3cd5a5ac19af3$var$__esDecorate(_classThis, null, _echoed_decorators, {
            kind: "accessor",
            name: "echoed",
            static: false,
            private: false,
            access: {
                has: (obj)=>"echoed" in obj,
                get: (obj)=>obj.echoed,
                set: (obj, value)=>{
                    obj.echoed = value;
                }
            },
            metadata: _metadata
        }, _echoed_initializers, _echoed_extraInitializers);
        $e7d3cd5a5ac19af3$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        TypeEcho = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'TypeEcho'
    });
    (()=>{
        $e7d3cd5a5ac19af3$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return TypeEcho = _classThis;
})();


var $39fc78bea9266790$exports = {};

$parcel$export($39fc78bea9266790$exports, "UserRankView", () => $39fc78bea9266790$export$4ed039229ec81818);


var $7DB8U = parcelRequire("7DB8U");



const $b7d4a5f4b94ceeb2$export$5f821f795e2d2901 = ({ email: email, website: website })=>(0, $e830bf8f8acfe41d$exports.jsxs)("address", {
        className: "mb-0 d-flex justify-content-around gap-2",
        children: [
            email && (0, $e830bf8f8acfe41d$exports.jsx)("a", {
                rel: "noreferrer",
                target: "_blank",
                href: 'mailto:' + email,
                children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $a9e058be8650f0e1$export$f04a61298a47a40f), {
                    name: "envelope"
                })
            }),
            website && (0, $e830bf8f8acfe41d$exports.jsx)("a", {
                rel: "noreferrer",
                target: "_blank",
                href: website,
                children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $a9e058be8650f0e1$export$f04a61298a47a40f), {
                    name: "globe2"
                })
            })
        ]
    });


var $ae56654af8c2cde0$export$5c452ff88e35e47d;
var $ae56654af8c2cde0$export$30d389775d7a0f3c;
var $ae56654af8c2cde0$export$a8ff84c12d48cfa6;
var $ae56654af8c2cde0$export$896c314ae37c4db9;
var $ae56654af8c2cde0$export$717db1a952ac2d26;
var $ae56654af8c2cde0$export$74fdf2685172213b;
var $ae56654af8c2cde0$export$fb184b623420d9be;
var $ae56654af8c2cde0$export$ec176431609ba4c9;
var $ae56654af8c2cde0$export$ea7c3e02973c1d5b;
$ae56654af8c2cde0$export$5c452ff88e35e47d = `WavURG_image`;
$ae56654af8c2cde0$export$30d389775d7a0f3c = `WavURG_medal`;
$ae56654af8c2cde0$export$a8ff84c12d48cfa6 = `WavURG_name`;
$ae56654af8c2cde0$export$896c314ae37c4db9 = `WavURG_rankBox`;
$ae56654af8c2cde0$export$717db1a952ac2d26 = `WavURG_restUsers`;
$ae56654af8c2cde0$export$74fdf2685172213b = `WavURG_suspension`;
$ae56654af8c2cde0$export$74fdf2685172213b;
$ae56654af8c2cde0$export$fb184b623420d9be = `WavURG_title`;
$ae56654af8c2cde0$export$ec176431609ba4c9 = `WavURG_topUser`;
$ae56654af8c2cde0$export$ea7c3e02973c1d5b = `WavURG_topUsers`;


var $39fc78bea9266790$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $39fc78bea9266790$export$4ed039229ec81818 extends (0, $7DB8U.PureComponent) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "renderMedal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (user)=>{
                var _a, _b;
                return (0, $e830bf8f8acfe41d$exports.jsxs)((0, $51362f0aeeaa849e$export$2e2bcd8739ae039), {
                    as: "li",
                    children: [
                        (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                            className: `shadow-lg overflow-hidden rounded-circle m-auto ${$ae56654af8c2cde0$export$5c452ff88e35e47d}`,
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $facf438de9c933e7$export$2e2bcd8739ae039), {
                                src: user.avatar,
                                alt: user.name,
                                loading: "lazy",
                                fluid: true
                            })
                        }),
                        (0, $e830bf8f8acfe41d$exports.jsxs)("div", {
                            className: `position-relative overflow-hidden ${$ae56654af8c2cde0$export$ec176431609ba4c9}`,
                            children: [
                                (0, $e830bf8f8acfe41d$exports.jsxs)("div", {
                                    className: "position-relative",
                                    children: [
                                        (0, $e830bf8f8acfe41d$exports.jsx)("i", {
                                            className: "d-block overflow-hidden m-auto mb-1 rounded-circle"
                                        }),
                                        (0, $e830bf8f8acfe41d$exports.jsx)("a", {
                                            className: "d-block mb-0 stretched-link",
                                            href: ((_b = (_a = this.props).linkOf) === null || _b === void 0 ? void 0 : _b.call(_a, user)) || '#',
                                            children: user.name
                                        }),
                                        (0, $e830bf8f8acfe41d$exports.jsx)("strong", {
                                            children: user.score
                                        })
                                    ]
                                }),
                                (0, $e830bf8f8acfe41d$exports.jsx)((0, $b7d4a5f4b94ceeb2$export$5f821f795e2d2901), Object.assign({}, user))
                            ]
                        })
                    ]
                }, user.id);
            }
        });
        Object.defineProperty(this, "renderRow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (user, index, { length: length })=>{
                var _a, _b;
                return (0, $e830bf8f8acfe41d$exports.jsxs)("tr", {
                    className: "position-relative",
                    children: [
                        (0, $e830bf8f8acfe41d$exports.jsx)("td", {
                            className: "align-middle",
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $5056c1721372f116$export$2e2bcd8739ae039), {
                                className: "fw-bold fst-italic",
                                children: (index + 4 + '').padStart((length + '').length, '0')
                            })
                        }),
                        (0, $e830bf8f8acfe41d$exports.jsxs)("td", {
                            className: `position-relative mw-50 text-truncate ${$ae56654af8c2cde0$export$a8ff84c12d48cfa6}`,
                            children: [
                                (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                                    className: `d-inline-block overflow-hidden align-middle rounded-circle ${$ae56654af8c2cde0$export$5c452ff88e35e47d}`,
                                    children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $facf438de9c933e7$export$2e2bcd8739ae039), {
                                        src: user.avatar,
                                        alt: user.name,
                                        loading: "lazy",
                                        fluid: true
                                    })
                                }),
                                (0, $e830bf8f8acfe41d$exports.jsx)("a", {
                                    className: "ms-2 d-inline-block align-middle stretched-link",
                                    style: {
                                        color: `rgb(248, ${(index + 2) * 15}, ${(index + 2) * 35})`
                                    },
                                    href: ((_b = (_a = this.props).linkOf) === null || _b === void 0 ? void 0 : _b.call(_a, user)) || '#',
                                    children: user.name
                                })
                            ]
                        }),
                        (0, $e830bf8f8acfe41d$exports.jsx)("td", {
                            className: "align-middle",
                            children: user.score
                        }),
                        (0, $e830bf8f8acfe41d$exports.jsx)("td", {
                            className: "align-middle",
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $b7d4a5f4b94ceeb2$export$5f821f795e2d2901), Object.assign({}, user))
                        })
                    ]
                }, user.id);
            }
        });
    }
    render() {
        const _a = this.props, { className: className = '', title: title, rank: rank = [], linkOf: linkOf } = _a, props = $39fc78bea9266790$var$__rest(_a, [
            "className",
            "title",
            "rank",
            "linkOf"
        ]);
        return (0, $e830bf8f8acfe41d$exports.jsxs)((0, $e2e7a3888803d0e1$export$2e2bcd8739ae039), Object.assign({
            className: `${$ae56654af8c2cde0$export$896c314ae37c4db9} ${className}`
        }, props, {
            children: [
                (0, $e830bf8f8acfe41d$exports.jsxs)((0, $51362f0aeeaa849e$export$2e2bcd8739ae039), {
                    sm: 12,
                    xs: 12,
                    lg: 7,
                    children: [
                        (0, $e830bf8f8acfe41d$exports.jsxs)("div", {
                            className: `shadow rounded-3 ${$ae56654af8c2cde0$export$fb184b623420d9be}`,
                            children: [
                                (0, $e830bf8f8acfe41d$exports.jsxs)("div", {
                                    className: $ae56654af8c2cde0$export$30d389775d7a0f3c,
                                    children: [
                                        (0, $e830bf8f8acfe41d$exports.jsx)("i", {
                                            className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                        }),
                                        (0, $e830bf8f8acfe41d$exports.jsx)("i", {
                                            className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                        }),
                                        (0, $e830bf8f8acfe41d$exports.jsx)("i", {
                                            className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                        })
                                    ]
                                }),
                                (0, $e830bf8f8acfe41d$exports.jsx)("h3", {
                                    "data-text": title,
                                    className: "position-relative m-auto mb-0 fw-bold text-center",
                                    children: title
                                })
                            ]
                        }),
                        (0, $e830bf8f8acfe41d$exports.jsx)((0, $e2e7a3888803d0e1$export$2e2bcd8739ae039), {
                            as: "ul",
                            className: `mt-2 g-0 align-items-end text-center ps-0 pt-2 list-unstyled ${$ae56654af8c2cde0$export$ea7c3e02973c1d5b}`,
                            children: rank.slice(0, 3).map(this.renderMedal)
                        })
                    ]
                }),
                (0, $e830bf8f8acfe41d$exports.jsx)((0, $51362f0aeeaa849e$export$2e2bcd8739ae039), {
                    xs: 12,
                    sm: 12,
                    lg: 5,
                    children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $72916eeed8431ee6$export$2e2bcd8739ae039), {
                        className: `my-3 pt-2 ${$ae56654af8c2cde0$export$717db1a952ac2d26}`,
                        responsive: true,
                        children: (0, $e830bf8f8acfe41d$exports.jsx)("tbody", {
                            children: rank.slice(3, 10).map(this.renderRow)
                        })
                    })
                })
            ]
        }));
    }
}
Object.defineProperty($39fc78bea9266790$export$4ed039229ec81818, "displayName", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'UserRankView'
});


var $104fe1d69b5cc790$exports = {};

$parcel$export($104fe1d69b5cc790$exports, "VerticalMarquee", () => $104fe1d69b5cc790$export$125576d08e40b98f);

var $c0a4310f3d200de9$export$1a22ace05a045e3f;
var $c0a4310f3d200de9$export$c7aa240077ad8340;
$c0a4310f3d200de9$export$1a22ace05a045e3f = `QSMqAq_scrollItem`;
$c0a4310f3d200de9$export$1a22ace05a045e3f;
$c0a4310f3d200de9$export$c7aa240077ad8340 = `QSMqAq_scrollWrap`;
$c0a4310f3d200de9$export$c7aa240077ad8340;


var $104fe1d69b5cc790$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $104fe1d69b5cc790$export$125576d08e40b98f = (_a)=>{
    var { className: className = '', children: children, duration: duration } = _a, props = $104fe1d69b5cc790$var$__rest(_a, [
        "className",
        "children",
        "duration"
    ]);
    return (0, $e830bf8f8acfe41d$exports.jsx)("div", Object.assign({
        className: `overflow-hidden ${className}`
    }, props, {
        children: (0, $e830bf8f8acfe41d$exports.jsx)("div", {
            className: `d-inline-block mw-100 mh-100 ${$c0a4310f3d200de9$export$c7aa240077ad8340}`,
            // @ts-expect-error remove after React 19 released
            style: {
                '--duration': duration
            },
            children: (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                className: `d-inline-block ${$c0a4310f3d200de9$export$1a22ace05a045e3f}`,
                children: children
            })
        })
    }));
};
$104fe1d69b5cc790$export$125576d08e40b98f.displayName = 'VerticalMarquee';


var $30c60bd3cdeb9d66$exports = {};

$parcel$export($30c60bd3cdeb9d66$exports, "ZodiacSigns", () => $30c60bd3cdeb9d66$export$c0efdd35897a499c);
$parcel$export($30c60bd3cdeb9d66$exports, "zodiacOf", () => $30c60bd3cdeb9d66$export$1ace452aebce17cb);
$parcel$export($30c60bd3cdeb9d66$exports, "ZodiacBar", () => $30c60bd3cdeb9d66$export$de26cde43ba4c348);

var $30c60bd3cdeb9d66$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $30c60bd3cdeb9d66$export$c0efdd35897a499c = [
    "\uD83D\uDC35",
    "\uD83D\uDC14",
    "\uD83D\uDC36",
    "\uD83D\uDC37",
    "\uD83D\uDC2D",
    "\uD83D\uDC2E",
    "\uD83D\uDC2F",
    "\uD83D\uDC30",
    "\uD83D\uDC32",
    "\uD83D\uDC0D",
    "\uD83D\uDC34",
    "\uD83D\uDC10"
];
const $30c60bd3cdeb9d66$export$1ace452aebce17cb = (year)=>{
    // Historical year numbering has no year 0: 1 BCE is represented as year -1.
    const astronomicalYear = year < 0 ? year + 1 : year;
    return $30c60bd3cdeb9d66$export$c0efdd35897a499c[(astronomicalYear % 12 + 12) % 12];
};
const $30c60bd3cdeb9d66$export$de26cde43ba4c348 = (_a)=>{
    var { className: className = '', itemClassName: itemClassName = 'border rounded px-4 py-3 d-flex flex-column justify-content-center align-items-center', startYear: startYear, endYear: endYear = new Date().getFullYear(), itemOf: itemOf } = _a, props = $30c60bd3cdeb9d66$var$__rest(_a, [
        "className",
        "itemClassName",
        "startYear",
        "endYear",
        "itemOf"
    ]);
    return (0, $e830bf8f8acfe41d$exports.jsx)("ol", Object.assign({
        className: `list-unstyled m-0 d-flex flex-wrap justify-content-center gap-3 ${className}`
    }, props, {
        children: Array.from({
            length: endYear - startYear + 1
        }, (_, index)=>{
            const year = endYear - index;
            if (year === 0) return null;
            const zodiac = $30c60bd3cdeb9d66$export$1ace452aebce17cb(year);
            const { link: link = '#', title: title } = (itemOf === null || itemOf === void 0 ? void 0 : itemOf(year, zodiac)) || {};
            return (0, $e830bf8f8acfe41d$exports.jsx)("li", {
                className: itemClassName,
                children: (0, $e830bf8f8acfe41d$exports.jsxs)("a", {
                    className: "d-inline-block p-3 text-decoration-none text-center",
                    href: link,
                    children: [
                        (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                            className: "fs-1",
                            children: zodiac
                        }),
                        title
                    ]
                })
            }, year);
        })
    }));
};
$30c60bd3cdeb9d66$export$de26cde43ba4c348.displayName = 'ZodiacBar';


$parcel$exportWildcard($5b9516050fe8824f$exports, $3f00cc594615b3bc$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $bbe3314f1df38781$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $b5fd569e8732cd5e$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $f3be3fdd0ed40ade$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $49d7ea4d7974a6fe$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $6dcd5678f67c6b02$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $5f36cffaa267c314$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $bc1896828996898b$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $f3dbfd93bcb031cd$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $cfdbb1e29b9af572$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $a9e058be8650f0e1$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $e5a57d506e25a9c5$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $819e3941170a1790$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $e3aad0f6e5ad05e1$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $49a38e2a3ce732bb$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $0053152b16d9815b$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $7f4b319848d3c701$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $839f5d21a5a9dff5$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $7a4511f8af51cbbb$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $b68896d3a4d7fbf1$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $51c976be9e7826ec$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $f4f71328f0a19468$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $9933903675cc8cbf$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $e27c07fe54f21598$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $fd4fe5cf447dc272$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $159e4f94d50f7644$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $ad55f28c37e4135a$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $e7d3cd5a5ac19af3$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $39fc78bea9266790$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $104fe1d69b5cc790$exports);
$parcel$exportWildcard($5b9516050fe8824f$exports, $30c60bd3cdeb9d66$exports);






var $7DB8U = parcelRequire("7DB8U");



var $7DB8U = parcelRequire("7DB8U");


var $7DB8U = parcelRequire("7DB8U");


var $7DB8U = parcelRequire("7DB8U");


const $4328943a923734eb$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).elementType
};
const $4328943a923734eb$var$Feedback = /*#__PURE__*/ $7DB8U.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$4328943a923734eb$var$Feedback.displayName = 'Feedback';
$4328943a923734eb$var$Feedback.propTypes = $4328943a923734eb$var$propTypes;
var $4328943a923734eb$export$2e2bcd8739ae039 = $4328943a923734eb$var$Feedback;




var $7DB8U = parcelRequire("7DB8U");

var $7DB8U = parcelRequire("7DB8U");
"use client";
// TODO
const $4b6cb7c7c6f03b0c$var$FormContext = /*#__PURE__*/ $7DB8U.createContext({});
var $4b6cb7c7c6f03b0c$export$2e2bcd8739ae039 = $4b6cb7c7c6f03b0c$var$FormContext;




"use client";
const $ad9056b1c9f01fc5$var$FormCheckInput = /*#__PURE__*/ $7DB8U.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $7DB8U.useContext)((0, $4b6cb7c7c6f03b0c$export$2e2bcd8739ae039));
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$ad9056b1c9f01fc5$var$FormCheckInput.displayName = 'FormCheckInput';
var $ad9056b1c9f01fc5$export$2e2bcd8739ae039 = $ad9056b1c9f01fc5$var$FormCheckInput;




var $7DB8U = parcelRequire("7DB8U");



"use client";
const $1c191b699ca625d1$var$FormCheckLabel = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $7DB8U.useContext)((0, $4b6cb7c7c6f03b0c$export$2e2bcd8739ae039));
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix)
    });
});
$1c191b699ca625d1$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $1c191b699ca625d1$export$2e2bcd8739ae039 = $1c191b699ca625d1$var$FormCheckLabel;





var $7DB8U = parcelRequire("7DB8U");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $1eee8657d780bdd9$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $7DB8U.Children.map(children, (child)=>/*#__PURE__*/ $7DB8U.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $1eee8657d780bdd9$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $7DB8U.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $7DB8U.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $1eee8657d780bdd9$export$500fd6099226ffae(children, type) {
    return $7DB8U.Children.toArray(children).some((child)=>/*#__PURE__*/ $7DB8U.isValidElement(child) && child.type === type);
}



"use client";
const $20338c017b31be9d$var$FormCheck = /*#__PURE__*/ $7DB8U.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $7DB8U.useContext)((0, $4b6cb7c7c6f03b0c$export$2e2bcd8739ae039));
    const innerFormContext = (0, $7DB8U.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $1eee8657d780bdd9$export$500fd6099226ffae)(children, (0, $1c191b699ca625d1$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $ad9056b1c9f01fc5$export$2e2bcd8739ae039), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $4b6cb7c7c6f03b0c$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)((0, $e830bf8f8acfe41d$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $1c191b699ca625d1$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $4328943a923734eb$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$20338c017b31be9d$var$FormCheck.displayName = 'FormCheck';
var $20338c017b31be9d$export$2e2bcd8739ae039 = Object.assign($20338c017b31be9d$var$FormCheck, {
    Input: (0, $ad9056b1c9f01fc5$export$2e2bcd8739ae039),
    Label: (0, $1c191b699ca625d1$export$2e2bcd8739ae039)
});




var $7DB8U = parcelRequire("7DB8U");





"use client";
const $18a01555bd274c57$var$FormControl = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $7DB8U.useContext)((0, $4b6cb7c7c6f03b0c$export$2e2bcd8739ae039));
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$18a01555bd274c57$var$FormControl.displayName = 'FormControl';
var $18a01555bd274c57$export$2e2bcd8739ae039 = Object.assign($18a01555bd274c57$var$FormControl, {
    Feedback: $4328943a923734eb$export$2e2bcd8739ae039
});



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $966f30e7479e8be8$var$FormFloating = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$966f30e7479e8be8$var$FormFloating.displayName = 'FormFloating';
var $966f30e7479e8be8$export$2e2bcd8739ae039 = $966f30e7479e8be8$var$FormFloating;



var $7DB8U = parcelRequire("7DB8U");


const $83631a438daf8e3b$var$FormGroup = /*#__PURE__*/ $7DB8U.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $7DB8U.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $4b6cb7c7c6f03b0c$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$83631a438daf8e3b$var$FormGroup.displayName = 'FormGroup';
var $83631a438daf8e3b$export$2e2bcd8739ae039 = $83631a438daf8e3b$var$FormGroup;




var $7DB8U = parcelRequire("7DB8U");





"use client";
const $e5bc9e1735196ab5$var$FormLabel = /*#__PURE__*/ $7DB8U.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $7DB8U.useContext)((0, $4b6cb7c7c6f03b0c$export$2e2bcd8739ae039));
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $51362f0aeeaa849e$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
});
$e5bc9e1735196ab5$var$FormLabel.displayName = 'FormLabel';
var $e5bc9e1735196ab5$export$2e2bcd8739ae039 = $e5bc9e1735196ab5$var$FormLabel;




var $7DB8U = parcelRequire("7DB8U");



"use client";
const $d8f6a12b49694739$var$FormRange = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $7DB8U.useContext)((0, $4b6cb7c7c6f03b0c$export$2e2bcd8739ae039));
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$d8f6a12b49694739$var$FormRange.displayName = 'FormRange';
var $d8f6a12b49694739$export$2e2bcd8739ae039 = $d8f6a12b49694739$var$FormRange;




var $7DB8U = parcelRequire("7DB8U");



"use client";
const $06078852dc5d9eec$var$FormSelect = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $7DB8U.useContext)((0, $4b6cb7c7c6f03b0c$export$2e2bcd8739ae039));
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$06078852dc5d9eec$var$FormSelect.displayName = 'FormSelect';
var $06078852dc5d9eec$export$2e2bcd8739ae039 = $06078852dc5d9eec$var$FormSelect;




var $7DB8U = parcelRequire("7DB8U");


"use client";
const $afcc8920c4131aa0$var$FormText = /*#__PURE__*/ $7DB8U.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, muted && 'text-muted')
    });
});
$afcc8920c4131aa0$var$FormText.displayName = 'FormText';
var $afcc8920c4131aa0$export$2e2bcd8739ae039 = $afcc8920c4131aa0$var$FormText;



var $7DB8U = parcelRequire("7DB8U");


const $75bfcf0f3bde4bec$var$Switch = /*#__PURE__*/ $7DB8U.forwardRef((props, ref)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $20338c017b31be9d$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$75bfcf0f3bde4bec$var$Switch.displayName = 'Switch';
var $75bfcf0f3bde4bec$export$2e2bcd8739ae039 = Object.assign($75bfcf0f3bde4bec$var$Switch, {
    Input: (0, $20338c017b31be9d$export$2e2bcd8739ae039).Input,
    Label: (0, $20338c017b31be9d$export$2e2bcd8739ae039).Label
});




var $7DB8U = parcelRequire("7DB8U");



"use client";
const $1109ead3dfcadd0d$var$FloatingLabel = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)((0, $83631a438daf8e3b$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$1109ead3dfcadd0d$var$FloatingLabel.displayName = 'FloatingLabel';
var $1109ead3dfcadd0d$export$2e2bcd8739ae039 = $1109ead3dfcadd0d$var$FloatingLabel;



const $3a20a8d9839af258$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).elementType
};
const $3a20a8d9839af258$var$Form = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, validated && 'was-validated')
    }));
$3a20a8d9839af258$var$Form.displayName = 'Form';
$3a20a8d9839af258$var$Form.propTypes = $3a20a8d9839af258$var$propTypes;
var $3a20a8d9839af258$export$2e2bcd8739ae039 = Object.assign($3a20a8d9839af258$var$Form, {
    Group: (0, $83631a438daf8e3b$export$2e2bcd8739ae039),
    Control: (0, $18a01555bd274c57$export$2e2bcd8739ae039),
    Floating: (0, $966f30e7479e8be8$export$2e2bcd8739ae039),
    Check: (0, $20338c017b31be9d$export$2e2bcd8739ae039),
    Switch: $75bfcf0f3bde4bec$export$2e2bcd8739ae039,
    Label: (0, $e5bc9e1735196ab5$export$2e2bcd8739ae039),
    Text: (0, $afcc8920c4131aa0$export$2e2bcd8739ae039),
    Range: (0, $d8f6a12b49694739$export$2e2bcd8739ae039),
    Select: (0, $06078852dc5d9eec$export$2e2bcd8739ae039),
    FloatingLabel: $1109ead3dfcadd0d$export$2e2bcd8739ae039
});







var $9c19bd5bfd1a1a58$var$size;
function $9c19bd5bfd1a1a58$export$2e2bcd8739ae039(recalc) {
    if (!$9c19bd5bfd1a1a58$var$size && $9c19bd5bfd1a1a58$var$size !== 0 || recalc) {
        if (0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $9c19bd5bfd1a1a58$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $9c19bd5bfd1a1a58$var$size;
}



var $7DB8U = parcelRequire("7DB8U");
function $b046ce93c08d61b0$export$2e2bcd8739ae039() {
    return (0, $7DB8U.useState)(null);
}







var $7DB8U = parcelRequire("7DB8U");

function $7928c6e4d5223063$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}






var $7DB8U = parcelRequire("7DB8U");

var $9lImh = parcelRequire("9lImh");


var $7DB8U = parcelRequire("7DB8U");
function $6b5c32558e99f0d5$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $7DB8U.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $7DB8U = parcelRequire("7DB8U");
function $7278e898656c8354$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $6b5c32558e99f0d5$export$2e2bcd8739ae039)(fn);
    (0, $7DB8U.useEffect)(()=>()=>onUnmount.current(), []);
}






/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $4772dc7076cd2c72$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $ad7f3abcb142df7c$export$1a88c12b8b979fa0 = (0, $bec69d0ef4577e78$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $ad7f3abcb142df7c$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $4772dc7076cd2c72$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($ad7f3abcb142df7c$export$1a88c12b8b979fa0, '');
        (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($ad7f3abcb142df7c$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $ad7f3abcb142df7c$export$2e2bcd8739ae039 = $ad7f3abcb142df7c$var$ModalManager;







const $882430142e8347e0$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $882430142e8347e0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $882430142e8347e0$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $882430142e8347e0$var$getManager(window) {
    if (!$882430142e8347e0$var$manager) $882430142e8347e0$var$manager = new (0, $ad7f3abcb142df7c$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $882430142e8347e0$var$manager;
}
function $882430142e8347e0$var$useModalManager(provided) {
    const window = (0, $6e5a5ef831ae81c7$export$2e2bcd8739ae039)();
    const modalManager = provided || $882430142e8347e0$var$getManager(window);
    const modal = (0, $7DB8U.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $7DB8U.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $7DB8U.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $882430142e8347e0$var$Modal = /*#__PURE__*/ (0, $7DB8U.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $882430142e8347e0$var$_objectWithoutPropertiesLoose(_ref, $882430142e8347e0$var$_excluded);
    const ownerWindow = (0, $6e5a5ef831ae81c7$export$2e2bcd8739ae039)();
    const container = (0, $765e7881ef71d12d$export$2e2bcd8739ae039)(containerRef);
    const modal = $882430142e8347e0$var$useModalManager(providedManager);
    const isMounted = (0, $84a01fe90a97ff84$export$2e2bcd8739ae039)();
    const prevShow = (0, $fb71ae22f6c1c147$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $7DB8U.useState)(!show);
    const lastFocusRef = (0, $7DB8U.useRef)(null);
    (0, $7DB8U.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $7DB8U.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $7DB8U.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $7278e898656c8354$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $42a6230204cf5cc4$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $36a3340f9542756b$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $7DB8U.useRef)();
    const removeKeydownListenerRef = (0, $7DB8U.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $7DB8U.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $456a71d209592b13$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $456a71d209592b13$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $e830bf8f8acfe41d$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9lImh))).createPortal(/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)((0, $e830bf8f8acfe41d$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$882430142e8347e0$var$Modal.displayName = 'Modal';
var $882430142e8347e0$export$2e2bcd8739ae039 = Object.assign($882430142e8347e0$var$Modal, {
    Manager: (0, $ad7f3abcb142df7c$export$2e2bcd8739ae039)
});



function $da42d038f708cdd8$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $bb7f18969320ba30$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}




function $9bb1922ade4b5d1d$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $9bb1922ade4b5d1d$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $9bb1922ade4b5d1d$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $9bb1922ade4b5d1d$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $028ffbe3fb667958$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $028ffbe3fb667958$var$BootstrapModalManager extends (0, $ad7f3abcb142df7c$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $da42d038f708cdd8$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $028ffbe3fb667958$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $028ffbe3fb667958$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $028ffbe3fb667958$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $9bb1922ade4b5d1d$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $028ffbe3fb667958$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $028ffbe3fb667958$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $028ffbe3fb667958$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $028ffbe3fb667958$var$sharedManager;
function $028ffbe3fb667958$export$a03641438014b436(options) {
    if (!$028ffbe3fb667958$var$sharedManager) $028ffbe3fb667958$var$sharedManager = new $028ffbe3fb667958$var$BootstrapModalManager(options);
    return $028ffbe3fb667958$var$sharedManager;
}
var $028ffbe3fb667958$export$2e2bcd8739ae039 = $028ffbe3fb667958$var$BootstrapModalManager;




var $7DB8U = parcelRequire("7DB8U");



"use client";
const $6bbc906c24f9fdbc$var$ModalBody = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$6bbc906c24f9fdbc$var$ModalBody.displayName = 'ModalBody';
var $6bbc906c24f9fdbc$export$2e2bcd8739ae039 = $6bbc906c24f9fdbc$var$ModalBody;



var $7DB8U = parcelRequire("7DB8U");
"use client";
const $b5845834466d1c56$var$ModalContext = /*#__PURE__*/ $7DB8U.createContext({
    onHide () {}
});
var $b5845834466d1c56$export$2e2bcd8739ae039 = $b5845834466d1c56$var$ModalContext;




var $7DB8U = parcelRequire("7DB8U");


"use client";
const $e47f48f89d32c0f8$var$ModalDialog = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$e47f48f89d32c0f8$var$ModalDialog.displayName = 'ModalDialog';
var $e47f48f89d32c0f8$export$2e2bcd8739ae039 = $e47f48f89d32c0f8$var$ModalDialog;



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $26a565f4ea2670e0$var$ModalFooter = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$26a565f4ea2670e0$var$ModalFooter.displayName = 'ModalFooter';
var $26a565f4ea2670e0$export$2e2bcd8739ae039 = $26a565f4ea2670e0$var$ModalFooter;




var $7DB8U = parcelRequire("7DB8U");


var $7DB8U = parcelRequire("7DB8U");




"use client";
const $6b1c35348353eda8$var$AbstractModalHeader = /*#__PURE__*/ $7DB8U.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $7DB8U.useContext)((0, $b5845834466d1c56$export$2e2bcd8739ae039));
    const handleClick = (0, $297288d717742377$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $062ab6ef4a3114b0$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
$6b1c35348353eda8$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $6b1c35348353eda8$export$2e2bcd8739ae039 = $6b1c35348353eda8$var$AbstractModalHeader;



"use client";
const $760e79d53fb2f026$var$ModalHeader = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $6b1c35348353eda8$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$760e79d53fb2f026$var$ModalHeader.displayName = 'ModalHeader';
var $760e79d53fb2f026$export$2e2bcd8739ae039 = $760e79d53fb2f026$var$ModalHeader;



var $7DB8U = parcelRequire("7DB8U");




"use client";
const $ea54f4d6d90e1c63$var$DivStyledAsH4 = (0, $500199e796627cf1$export$2e2bcd8739ae039)('h4');
const $ea54f4d6d90e1c63$var$ModalTitle = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $ea54f4d6d90e1c63$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$ea54f4d6d90e1c63$var$ModalTitle.displayName = 'ModalTitle';
var $ea54f4d6d90e1c63$export$2e2bcd8739ae039 = $ea54f4d6d90e1c63$var$ModalTitle;




"use client";
function $e8d7441a43b85bf3$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $722140d134b37da6$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
function $e8d7441a43b85bf3$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $722140d134b37da6$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
const $e8d7441a43b85bf3$var$Modal = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $e47f48f89d32c0f8$export$2e2bcd8739ae039), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $7DB8U.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $7DB8U.useState)(false);
    const waitingForMouseUpRef = (0, $7DB8U.useRef)(false);
    const ignoreBackdropClickRef = (0, $7DB8U.useRef)(false);
    const removeStaticModalAnimationRef = (0, $7DB8U.useRef)(null);
    const [modal, setModalRef] = (0, $b046ce93c08d61b0$export$2e2bcd8739ae039)();
    const mergedRef = (0, $1e2b613deffe4140$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $297288d717742377$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $d36baff69136067a$export$35e511eefa30ac5a)();
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const modalContext = (0, $7DB8U.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $028ffbe3fb667958$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $c36f36ded4bef1c0$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $9c19bd5bfd1a1a58$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $9c19bd5bfd1a1a58$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $297288d717742377$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $d6e9a857bdf29c15$export$2e2bcd8739ae039)(()=>{
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $d247f6e7f04e903f$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, $7DB8U.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $b5845834466d1c56$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $882430142e8347e0$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $e8d7441a43b85bf3$var$DialogTransition : undefined,
            backdropTransition: animation ? $e8d7441a43b85bf3$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$e8d7441a43b85bf3$var$Modal.displayName = 'Modal';
var $e8d7441a43b85bf3$export$2e2bcd8739ae039 = Object.assign($e8d7441a43b85bf3$var$Modal, {
    Body: (0, $6bbc906c24f9fdbc$export$2e2bcd8739ae039),
    Header: (0, $760e79d53fb2f026$export$2e2bcd8739ae039),
    Title: (0, $ea54f4d6d90e1c63$export$2e2bcd8739ae039),
    Footer: (0, $26a565f4ea2670e0$export$2e2bcd8739ae039),
    Dialog: (0, $e47f48f89d32c0f8$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});





var $32af1264c325659e$exports = {};

$parcel$export($32af1264c325659e$exports, "Accordion", () => $336923e2f6747b70$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "AccordionContext", () => $d7bad6025fa7e80e$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "AccordionCollapse", () => $3c8bf39f4a6c3f2e$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "AccordionButton", () => $7366b6f7186324ad$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "useAccordionButton", () => $7366b6f7186324ad$export$1361ce4b8f883f3e);
$parcel$export($32af1264c325659e$exports, "AccordionBody", () => $f4a07a3bfee7314e$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "AccordionHeader", () => $9a7a31f9f233099b$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "AccordionItem", () => $897cf96e39fd9318$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Alert", () => $9d2ef84f819e1805$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "AlertHeading", () => $d851b54930e17acf$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "AlertLink", () => $c96d5e6234a1a09f$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Anchor", () => $d91fd4118acfebb3$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Badge", () => $5056c1721372f116$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Breadcrumb", () => $ea7cec3dbae026a3$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "BreadcrumbItem", () => $a593a0067d21419d$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Button", () => $e4f2607df5423ec3$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ButtonGroup", () => $dbb879efc36c7062$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ButtonToolbar", () => $941ce81eb68b9dbd$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Card", () => $8221a3ef7285f739$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "CardBody", () => $b05427aba15d074f$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "CardFooter", () => $4724fe9f2e308903$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "CardGroup", () => $8de77174d9be8541$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "CardHeader", () => $a172c7c0d6c528df$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "CardImg", () => $f74994f0f1a31cbc$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "CardImgOverlay", () => $6d284df247300524$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "CardLink", () => $57d4066cc2a5f004$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "CardSubtitle", () => $6f127ffbd6f9eae8$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "CardText", () => $71d149d0886ec3d8$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "CardTitle", () => $debda5d1fc4956df$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Carousel", () => $8894fb7edfdcf11d$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "CarouselCaption", () => $b102f1027c49ac0d$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "CarouselItem", () => $c137a0844cb0c156$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "CloseButton", () => $062ab6ef4a3114b0$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Col", () => $51362f0aeeaa849e$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Collapse", () => $7476d4e4f4ba1c12$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Container", () => $6d27f416cee9d181$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Dropdown", () => $ecb5bcf98c9fe309$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "DropdownButton", () => $131d35592815e9c6$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "DropdownDivider", () => $b56b5ef19c345092$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "DropdownHeader", () => $8eae0940ae5aa244$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "DropdownItem", () => $bd31e2ff088dfc95$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "DropdownItemText", () => $457c869c3eab109b$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "DropdownMenu", () => $c821abc4a903c10a$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "DropdownToggle", () => $b0516b4bf7aaf778$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Fade", () => $722140d134b37da6$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Figure", () => $6d3ea74e4e4e2412$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "FigureCaption", () => $74a472321c3ee4fb$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "FigureImage", () => $0aebde5847988fc1$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Form", () => $3a20a8d9839af258$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "FormControl", () => $18a01555bd274c57$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "FormCheck", () => $20338c017b31be9d$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "FormFloating", () => $966f30e7479e8be8$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "FloatingLabel", () => $1109ead3dfcadd0d$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "FormGroup", () => $83631a438daf8e3b$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "FormLabel", () => $e5bc9e1735196ab5$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "FormText", () => $afcc8920c4131aa0$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "FormSelect", () => $06078852dc5d9eec$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Image", () => $facf438de9c933e7$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "InputGroup", () => $57a9e8ff5b04b6eb$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ListGroup", () => $50d5573d45f88780$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ListGroupItem", () => $e5f4fd37799c5a36$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Modal", () => $e8d7441a43b85bf3$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ModalBody", () => $6bbc906c24f9fdbc$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ModalDialog", () => $e47f48f89d32c0f8$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ModalFooter", () => $26a565f4ea2670e0$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ModalHeader", () => $760e79d53fb2f026$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ModalTitle", () => $ea54f4d6d90e1c63$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Nav", () => $a036a87711fc9297$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Navbar", () => $2e01f258a0c6c8d6$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "NavbarBrand", () => $b5deecc49fda798d$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "NavbarCollapse", () => $97362b55fdc15beb$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "NavbarOffcanvas", () => $76037aecb4d24ba9$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "NavbarText", () => $33c1c76655d8a898$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "NavbarToggle", () => $3c790fcb9fb4a590$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "NavDropdown", () => $e36e74acb2656ab9$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "NavItem", () => $522c1bf80aa094bc$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "NavLink", () => $1f1b2d0a7d8ef4d4$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Offcanvas", () => $c895dcd8cc58e4b8$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "OffcanvasBody", () => $1e440b1f939556f6$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "OffcanvasHeader", () => $6e97541bbb8e01f6$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "OffcanvasTitle", () => $5bcd325dd9b71a5f$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "OffcanvasToggling", () => $893cf2306a072a43$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Overlay", () => $c4adc9f01c3da970$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "OverlayTrigger", () => $213b714c6cf5496e$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "PageItem", () => $a5762485f09fbf3a$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Pagination", () => $93556c1ea6cf0bb9$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Placeholder", () => $c080c8fc94f5a99d$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "PlaceholderButton", () => $c382bed23255f9df$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Popover", () => $97d9b36cc775c811$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "PopoverBody", () => $c64c11eca1b55c35$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "PopoverHeader", () => $b939f9944691b130$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ProgressBar", () => $ef28b81a914ae897$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Ratio", () => $ff1d9079246ae266$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Row", () => $e2e7a3888803d0e1$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Spinner", () => $3a47f5a8134d38e5$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "SplitButton", () => $8d5b5ce2f99956b9$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "SSRProvider", () => $e66ffa995fd5a977$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Stack", () => $f39d3f10a82d617d$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Tab", () => $8743ca8519f92be1$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "TabContainer", () => $17e9aecf2ab4c86d$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "TabContent", () => $0c04e2da1b8aa27e$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Table", () => $72916eeed8431ee6$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "TabPane", () => $1d9f27906d53a5cb$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Tabs", () => $d7c68af8f1828f4e$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ThemeProvider", () => $d36baff69136067a$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Toast", () => $c7611ce2e776cb7d$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ToastBody", () => $1796a9111d78a43c$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ToastContainer", () => $47347b1b06c20d01$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ToastHeader", () => $6d051be57fb61659$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ToggleButton", () => $1d55f2b3b5693b8e$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "ToggleButtonGroup", () => $aa603085706342e7$export$2e2bcd8739ae039);
$parcel$export($32af1264c325659e$exports, "Tooltip", () => $2d6947a60393ae7d$export$2e2bcd8739ae039);


var $7DB8U = parcelRequire("7DB8U");




var $7DB8U = parcelRequire("7DB8U");



var $7DB8U = parcelRequire("7DB8U");



var $7DB8U = parcelRequire("7DB8U");
"use client";
function $d7bad6025fa7e80e$export$15e4e2f40b49cd81(activeEventKey, eventKey) {
    return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const $d7bad6025fa7e80e$var$context = /*#__PURE__*/ $7DB8U.createContext({});
$d7bad6025fa7e80e$var$context.displayName = 'AccordionContext';
var $d7bad6025fa7e80e$export$2e2bcd8739ae039 = $d7bad6025fa7e80e$var$context;



"use client";
/**
 * This component accepts all of [`Collapse`'s props](/docs/utilities/transitions#collapse-1).
 */ const $3c8bf39f4a6c3f2e$var$AccordionCollapse = /*#__PURE__*/ $7DB8U.forwardRef(({ as: Component = 'div', bsPrefix: bsPrefix, className: className, children: children, eventKey: eventKey, ...props }, ref)=>{
    const { activeEventKey: activeEventKey } = (0, $7DB8U.useContext)((0, $d7bad6025fa7e80e$export$2e2bcd8739ae039));
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'accordion-collapse');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $7476d4e4f4ba1c12$export$2e2bcd8739ae039), {
        ref: ref,
        in: (0, $d7bad6025fa7e80e$export$15e4e2f40b49cd81)(activeEventKey, eventKey),
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
            children: $7DB8U.Children.only(children)
        })
    });
});
$3c8bf39f4a6c3f2e$var$AccordionCollapse.displayName = 'AccordionCollapse';
var $3c8bf39f4a6c3f2e$export$2e2bcd8739ae039 = $3c8bf39f4a6c3f2e$var$AccordionCollapse;



var $7DB8U = parcelRequire("7DB8U");
"use client";
const $f42c3d60d93b5acb$var$context = /*#__PURE__*/ $7DB8U.createContext({
    eventKey: ''
});
$f42c3d60d93b5acb$var$context.displayName = 'AccordionItemContext';
var $f42c3d60d93b5acb$export$2e2bcd8739ae039 = $f42c3d60d93b5acb$var$context;



"use client";
const $f4a07a3bfee7314e$var$AccordionBody = /*#__PURE__*/ $7DB8U.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', bsPrefix: bsPrefix, className: className, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'accordion-body');
    const { eventKey: eventKey } = (0, $7DB8U.useContext)((0, $f42c3d60d93b5acb$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $3c8bf39f4a6c3f2e$export$2e2bcd8739ae039), {
        eventKey: eventKey,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix)
        })
    });
});
$f4a07a3bfee7314e$var$AccordionBody.displayName = 'AccordionBody';
var $f4a07a3bfee7314e$export$2e2bcd8739ae039 = $f4a07a3bfee7314e$var$AccordionBody;



var $7DB8U = parcelRequire("7DB8U");





"use client";
function $7366b6f7186324ad$export$1361ce4b8f883f3e(eventKey, onClick) {
    const { activeEventKey: activeEventKey, onSelect: onSelect, alwaysOpen: alwaysOpen } = (0, $7DB8U.useContext)((0, $d7bad6025fa7e80e$export$2e2bcd8739ae039));
    return (e)=>{
        /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */ let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;
        if (alwaysOpen) {
            if (Array.isArray(activeEventKey)) {
                if (activeEventKey.includes(eventKey)) eventKeyPassed = activeEventKey.filter((k)=>k !== eventKey);
                else eventKeyPassed = [
                    ...activeEventKey,
                    eventKey
                ];
            } else // activeEventKey is undefined.
            eventKeyPassed = [
                eventKey
            ];
        }
        onSelect == null || onSelect(eventKeyPassed, e);
        onClick == null || onClick(e);
    };
}
const $7366b6f7186324ad$var$AccordionButton = /*#__PURE__*/ $7DB8U.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', bsPrefix: bsPrefix, className: className, onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'accordion-button');
    const { eventKey: eventKey } = (0, $7DB8U.useContext)((0, $f42c3d60d93b5acb$export$2e2bcd8739ae039));
    const accordionOnClick = $7366b6f7186324ad$export$1361ce4b8f883f3e(eventKey, onClick);
    const { activeEventKey: activeEventKey } = (0, $7DB8U.useContext)((0, $d7bad6025fa7e80e$export$2e2bcd8739ae039));
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        onClick: accordionOnClick,
        ...props,
        "aria-expanded": Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : eventKey === activeEventKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, !(0, $d7bad6025fa7e80e$export$15e4e2f40b49cd81)(activeEventKey, eventKey) && 'collapsed')
    });
});
$7366b6f7186324ad$var$AccordionButton.displayName = 'AccordionButton';
var $7366b6f7186324ad$export$2e2bcd8739ae039 = $7366b6f7186324ad$var$AccordionButton;






var $7DB8U = parcelRequire("7DB8U");



"use client";
const $9a7a31f9f233099b$var$AccordionHeader = /*#__PURE__*/ $7DB8U.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'h2', 'aria-controls': ariaControls, bsPrefix: bsPrefix, className: className, children: children, onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'accordion-header');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $7366b6f7186324ad$export$2e2bcd8739ae039), {
            onClick: onClick,
            "aria-controls": ariaControls,
            children: children
        })
    });
});
$9a7a31f9f233099b$var$AccordionHeader.displayName = 'AccordionHeader';
var $9a7a31f9f233099b$export$2e2bcd8739ae039 = $9a7a31f9f233099b$var$AccordionHeader;




var $7DB8U = parcelRequire("7DB8U");



"use client";
const $897cf96e39fd9318$var$AccordionItem = /*#__PURE__*/ $7DB8U.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', bsPrefix: bsPrefix, className: className, eventKey: eventKey, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'accordion-item');
    const contextValue = (0, $7DB8U.useMemo)(()=>({
            eventKey: eventKey
        }), [
        eventKey
    ]);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $f42c3d60d93b5acb$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix)
        })
    });
});
$897cf96e39fd9318$var$AccordionItem.displayName = 'AccordionItem';
var $897cf96e39fd9318$export$2e2bcd8739ae039 = $897cf96e39fd9318$var$AccordionItem;



"use client";
const $336923e2f6747b70$var$Accordion = /*#__PURE__*/ $7DB8U.forwardRef((props, ref)=>{
    const { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', activeKey: activeKey, bsPrefix: bsPrefix, className: className, onSelect: onSelect, flush: flush, alwaysOpen: alwaysOpen, ...controlledProps } = (0, $be0af947f6d59f9f$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    });
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'accordion');
    const contextValue = (0, $7DB8U.useMemo)(()=>({
            activeEventKey: activeKey,
            onSelect: onSelect,
            alwaysOpen: alwaysOpen
        }), [
        activeKey,
        onSelect,
        alwaysOpen
    ]);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $d7bad6025fa7e80e$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
            ref: ref,
            ...controlledProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, flush && `${prefix}-flush`)
        })
    });
});
$336923e2f6747b70$var$Accordion.displayName = 'Accordion';
var $336923e2f6747b70$export$2e2bcd8739ae039 = Object.assign($336923e2f6747b70$var$Accordion, {
    Button: (0, $7366b6f7186324ad$export$2e2bcd8739ae039),
    Collapse: (0, $3c8bf39f4a6c3f2e$export$2e2bcd8739ae039),
    Item: (0, $897cf96e39fd9318$export$2e2bcd8739ae039),
    Header: (0, $9a7a31f9f233099b$export$2e2bcd8739ae039),
    Body: (0, $f4a07a3bfee7314e$export$2e2bcd8739ae039)
});










var $7DB8U = parcelRequire("7DB8U");




var $7DB8U = parcelRequire("7DB8U");




"use client";
const $d851b54930e17acf$var$DivStyledAsH4 = (0, $500199e796627cf1$export$2e2bcd8739ae039)('h4');
$d851b54930e17acf$var$DivStyledAsH4.displayName = 'DivStyledAsH4';
const $d851b54930e17acf$var$AlertHeading = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $d851b54930e17acf$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'alert-heading');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$d851b54930e17acf$var$AlertHeading.displayName = 'AlertHeading';
var $d851b54930e17acf$export$2e2bcd8739ae039 = $d851b54930e17acf$var$AlertHeading;



var $7DB8U = parcelRequire("7DB8U");




"use client";
const $c96d5e6234a1a09f$var$AlertLink = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = (0, $ba3423761edfecbc$export$2e2bcd8739ae039), ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'alert-link');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$c96d5e6234a1a09f$var$AlertLink.displayName = 'AlertLink';
var $c96d5e6234a1a09f$export$2e2bcd8739ae039 = $c96d5e6234a1a09f$var$AlertLink;





"use client";
const $9d2ef84f819e1805$var$Alert = /*#__PURE__*/ $7DB8U.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = 'Close alert', closeVariant: closeVariant, className: className, children: children, variant: variant = 'primary', onClose: onClose, dismissible: dismissible, transition: transition = (0, $722140d134b37da6$export$2e2bcd8739ae039), ...props } = (0, $be0af947f6d59f9f$export$2e2bcd8739ae039)(uncontrolledProps, {
        show: 'onClose'
    });
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'alert');
    const handleClose = (0, $297288d717742377$export$2e2bcd8739ae039)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $722140d134b37da6$export$2e2bcd8739ae039) : transition;
    const alert = /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $062ab6ef4a3114b0$export$2e2bcd8739ae039), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
$9d2ef84f819e1805$var$Alert.displayName = 'Alert';
var $9d2ef84f819e1805$export$2e2bcd8739ae039 = Object.assign($9d2ef84f819e1805$var$Alert, {
    Link: (0, $c96d5e6234a1a09f$export$2e2bcd8739ae039),
    Heading: (0, $d851b54930e17acf$export$2e2bcd8739ae039)
});





var $d91fd4118acfebb3$export$2e2bcd8739ae039 = (0, $ba3423761edfecbc$export$2e2bcd8739ae039);





var $7DB8U = parcelRequire("7DB8U");



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $a593a0067d21419d$var$BreadcrumbItem = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, active: active = false, children: children, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'li', linkAs: LinkComponent = (0, $ba3423761edfecbc$export$2e2bcd8739ae039), linkProps: linkProps = {}, href: href, title: title, target: target, ...props }, ref)=>{
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'breadcrumb-item');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(prefix, className, {
            active: active
        }),
        "aria-current": active ? 'page' : undefined,
        children: active ? children : /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(LinkComponent, {
            ...linkProps,
            href: href,
            title: title,
            target: target,
            children: children
        })
    });
});
$a593a0067d21419d$var$BreadcrumbItem.displayName = 'BreadcrumbItem';
var $a593a0067d21419d$export$2e2bcd8739ae039 = $a593a0067d21419d$var$BreadcrumbItem;



"use client";
const $ea7cec3dbae026a3$var$Breadcrumb = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, listProps: listProps = {}, children: children, label: label = 'breadcrumb', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'nav', ...props }, ref)=>{
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'breadcrumb');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        "aria-label": label,
        className: className,
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("ol", {
            ...listProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(prefix, listProps == null ? void 0 : listProps.className),
            children: children
        })
    });
});
$ea7cec3dbae026a3$var$Breadcrumb.displayName = 'Breadcrumb';
var $ea7cec3dbae026a3$export$2e2bcd8739ae039 = Object.assign($ea7cec3dbae026a3$var$Breadcrumb, {
    Item: (0, $a593a0067d21419d$export$2e2bcd8739ae039)
});






var $7DB8U = parcelRequire("7DB8U");


"use client";
const $dbb879efc36c7062$var$ButtonGroup = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, size: size, vertical: vertical = false, className: className, role: role = 'group', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...rest }, ref)=>{
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'btn-group');
    let baseClass = prefix;
    if (vertical) baseClass = `${prefix}-vertical`;
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...rest,
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, baseClass, size && `${prefix}-${size}`)
    });
});
$dbb879efc36c7062$var$ButtonGroup.displayName = 'ButtonGroup';
var $dbb879efc36c7062$export$2e2bcd8739ae039 = $dbb879efc36c7062$var$ButtonGroup;




var $7DB8U = parcelRequire("7DB8U");


"use client";
const $941ce81eb68b9dbd$var$ButtonToolbar = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, role: role = 'toolbar', ...props }, ref)=>{
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'btn-toolbar');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix),
        role: role
    });
});
$941ce81eb68b9dbd$var$ButtonToolbar.displayName = 'ButtonToolbar';
var $941ce81eb68b9dbd$export$2e2bcd8739ae039 = $941ce81eb68b9dbd$var$ButtonToolbar;






var $7DB8U = parcelRequire("7DB8U");



"use client";
const $8de77174d9be8541$var$CardGroup = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'card-group');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$8de77174d9be8541$var$CardGroup.displayName = 'CardGroup';
var $8de77174d9be8541$export$2e2bcd8739ae039 = $8de77174d9be8541$var$CardGroup;











var $7DB8U = parcelRequire("7DB8U");
/**
 * Runs an effect only when the dependencies have changed, skipping the
 * initial "on mount" run. Caution, if the dependency list never changes,
 * the effect is **never run**
 *
 * ```ts
 *  const ref = useRef<HTMLInput>(null);
 *
 *  // focuses an element only if the focus changes, and not on mount
 *  useUpdateEffect(() => {
 *    const element = ref.current?.children[focusedIdx] as HTMLElement
 *
 *    element?.focus()
 *
 *  }, [focusedIndex])
 * ```
 * @param effect An effect to run on mount
 *
 * @category effects
 */ function $6fa6648cc5c0e3cd$var$useUpdateEffect(fn, deps) {
    const isFirst = (0, $7DB8U.useRef)(true);
    (0, $7DB8U.useEffect)(()=>{
        if (isFirst.current) {
            isFirst.current = false;
            return;
        }
        return fn();
    }, deps);
}
var $6fa6648cc5c0e3cd$export$2e2bcd8739ae039 = $6fa6648cc5c0e3cd$var$useUpdateEffect;







var $7DB8U = parcelRequire("7DB8U");


var $7DB8U = parcelRequire("7DB8U");



"use client";
const $b102f1027c49ac0d$var$CarouselCaption = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'carousel-caption');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$b102f1027c49ac0d$var$CarouselCaption.displayName = 'CarouselCaption';
var $b102f1027c49ac0d$export$2e2bcd8739ae039 = $b102f1027c49ac0d$var$CarouselCaption;




var $7DB8U = parcelRequire("7DB8U");


"use client";
const $c137a0844cb0c156$var$CarouselItem = /*#__PURE__*/ $7DB8U.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', bsPrefix: bsPrefix, className: className, ...props }, ref)=>{
    const finalClassName = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'carousel-item'));
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: finalClassName
    });
});
$c137a0844cb0c156$var$CarouselItem.displayName = 'CarouselItem';
var $c137a0844cb0c156$export$2e2bcd8739ae039 = $c137a0844cb0c156$var$CarouselItem;








"use client";
const $8894fb7edfdcf11d$var$SWIPE_THRESHOLD = 40;
function $8894fb7edfdcf11d$var$isVisible(element) {
    if (!element || !element.style || !element.parentNode || !element.parentNode.style) return false;
    const elementStyle = getComputedStyle(element);
    return elementStyle.display !== 'none' && elementStyle.visibility !== 'hidden' && getComputedStyle(element.parentNode).display !== 'none';
}
const $8894fb7edfdcf11d$var$Carousel = /*#__PURE__*/ // eslint-disable-next-line react/display-name
$7DB8U.forwardRef(({ defaultActiveIndex: defaultActiveIndex = 0, ...uncontrolledProps }, ref)=>{
    const { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', bsPrefix: bsPrefix, slide: slide = true, fade: fade = false, controls: controls = true, indicators: indicators = true, indicatorLabels: indicatorLabels = [], activeIndex: activeIndex, onSelect: onSelect, onSlide: onSlide, onSlid: onSlid, interval: interval = 5000, keyboard: keyboard = true, onKeyDown: onKeyDown, pause: pause = 'hover', onMouseOver: onMouseOver, onMouseOut: onMouseOut, wrap: wrap = true, touch: touch = true, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, prevIcon: prevIcon = /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("span", {
        "aria-hidden": "true",
        className: "carousel-control-prev-icon"
    }), prevLabel: prevLabel = 'Previous', nextIcon: nextIcon = /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("span", {
        "aria-hidden": "true",
        className: "carousel-control-next-icon"
    }), nextLabel: nextLabel = 'Next', variant: variant, className: className, children: children, ...props } = (0, $be0af947f6d59f9f$export$2e2bcd8739ae039)({
        defaultActiveIndex: defaultActiveIndex,
        ...uncontrolledProps
    }, {
        activeIndex: 'onSelect'
    });
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'carousel');
    const isRTL = (0, $d36baff69136067a$export$35e511eefa30ac5a)();
    const nextDirectionRef = (0, $7DB8U.useRef)(null);
    const [direction, setDirection] = (0, $7DB8U.useState)('next');
    const [paused, setPaused] = (0, $7DB8U.useState)(false);
    const [isSliding, setIsSliding] = (0, $7DB8U.useState)(false);
    const [renderedActiveIndex, setRenderedActiveIndex] = (0, $7DB8U.useState)(activeIndex || 0);
    (0, $7DB8U.useEffect)(()=>{
        if (!isSliding && activeIndex !== renderedActiveIndex) {
            if (nextDirectionRef.current) setDirection(nextDirectionRef.current);
            else setDirection((activeIndex || 0) > renderedActiveIndex ? 'next' : 'prev');
            if (slide) setIsSliding(true);
            setRenderedActiveIndex(activeIndex || 0);
        }
    }, [
        activeIndex,
        isSliding,
        renderedActiveIndex,
        slide
    ]);
    (0, $7DB8U.useEffect)(()=>{
        if (nextDirectionRef.current) nextDirectionRef.current = null;
    });
    let numChildren = 0;
    let activeChildInterval;
    // Iterate to grab all of the children's interval values
    // (and count them, too)
    (0, $1eee8657d780bdd9$export$4b80e395e36b5a56)(children, (child, index)=>{
        ++numChildren;
        if (index === activeIndex) activeChildInterval = child.props.interval;
    });
    const activeChildIntervalRef = (0, $65c5e9844671b1e6$export$2e2bcd8739ae039)(activeChildInterval);
    const prev = (0, $7DB8U.useCallback)((event)=>{
        if (isSliding) return;
        let nextActiveIndex = renderedActiveIndex - 1;
        if (nextActiveIndex < 0) {
            if (!wrap) return;
            nextActiveIndex = numChildren - 1;
        }
        nextDirectionRef.current = 'prev';
        onSelect == null || onSelect(nextActiveIndex, event);
    }, [
        isSliding,
        renderedActiveIndex,
        onSelect,
        wrap,
        numChildren
    ]);
    // This is used in the setInterval, so it should not invalidate.
    const next = (0, $297288d717742377$export$2e2bcd8739ae039)((event)=>{
        if (isSliding) return;
        let nextActiveIndex = renderedActiveIndex + 1;
        if (nextActiveIndex >= numChildren) {
            if (!wrap) return;
            nextActiveIndex = 0;
        }
        nextDirectionRef.current = 'next';
        onSelect == null || onSelect(nextActiveIndex, event);
    });
    const elementRef = (0, $7DB8U.useRef)();
    (0, $7DB8U.useImperativeHandle)(ref, ()=>({
            element: elementRef.current,
            prev: prev,
            next: next
        }));
    // This is used in the setInterval, so it should not invalidate.
    const nextWhenVisible = (0, $297288d717742377$export$2e2bcd8739ae039)(()=>{
        if (!document.hidden && $8894fb7edfdcf11d$var$isVisible(elementRef.current)) {
            if (isRTL) prev();
            else next();
        }
    });
    const slideDirection = direction === 'next' ? 'start' : 'end';
    (0, $6fa6648cc5c0e3cd$export$2e2bcd8739ae039)(()=>{
        if (slide) // These callbacks will be handled by the <Transition> callbacks.
        return;
        onSlide == null || onSlide(renderedActiveIndex, slideDirection);
        onSlid == null || onSlid(renderedActiveIndex, slideDirection);
    }, [
        renderedActiveIndex
    ]);
    const orderClassName = `${prefix}-item-${direction}`;
    const directionalClassName = `${prefix}-item-${slideDirection}`;
    const handleEnter = (0, $7DB8U.useCallback)((node)=>{
        (0, $772cecf998cebdd5$export$2e2bcd8739ae039)(node);
        onSlide == null || onSlide(renderedActiveIndex, slideDirection);
    }, [
        onSlide,
        renderedActiveIndex,
        slideDirection
    ]);
    const handleEntered = (0, $7DB8U.useCallback)(()=>{
        setIsSliding(false);
        onSlid == null || onSlid(renderedActiveIndex, slideDirection);
    }, [
        onSlid,
        renderedActiveIndex,
        slideDirection
    ]);
    const handleKeyDown = (0, $7DB8U.useCallback)((event)=>{
        if (keyboard && !/input|textarea/i.test(event.target.tagName)) switch(event.key){
            case 'ArrowLeft':
                event.preventDefault();
                if (isRTL) next(event);
                else prev(event);
                return;
            case 'ArrowRight':
                event.preventDefault();
                if (isRTL) prev(event);
                else next(event);
                return;
            default:
        }
        onKeyDown == null || onKeyDown(event);
    }, [
        keyboard,
        onKeyDown,
        prev,
        next,
        isRTL
    ]);
    const handleMouseOver = (0, $7DB8U.useCallback)((event)=>{
        if (pause === 'hover') setPaused(true);
        onMouseOver == null || onMouseOver(event);
    }, [
        pause,
        onMouseOver
    ]);
    const handleMouseOut = (0, $7DB8U.useCallback)((event)=>{
        setPaused(false);
        onMouseOut == null || onMouseOut(event);
    }, [
        onMouseOut
    ]);
    const touchStartXRef = (0, $7DB8U.useRef)(0);
    const touchDeltaXRef = (0, $7DB8U.useRef)(0);
    const touchUnpauseTimeout = (0, $c26ada26dd336b02$export$2e2bcd8739ae039)();
    const handleTouchStart = (0, $7DB8U.useCallback)((event)=>{
        touchStartXRef.current = event.touches[0].clientX;
        touchDeltaXRef.current = 0;
        if (pause === 'hover') setPaused(true);
        onTouchStart == null || onTouchStart(event);
    }, [
        pause,
        onTouchStart
    ]);
    const handleTouchMove = (0, $7DB8U.useCallback)((event)=>{
        if (event.touches && event.touches.length > 1) touchDeltaXRef.current = 0;
        else touchDeltaXRef.current = event.touches[0].clientX - touchStartXRef.current;
        onTouchMove == null || onTouchMove(event);
    }, [
        onTouchMove
    ]);
    const handleTouchEnd = (0, $7DB8U.useCallback)((event)=>{
        if (touch) {
            const touchDeltaX = touchDeltaXRef.current;
            if (Math.abs(touchDeltaX) > $8894fb7edfdcf11d$var$SWIPE_THRESHOLD) {
                if (touchDeltaX > 0) prev(event);
                else next(event);
            }
        }
        if (pause === 'hover') touchUnpauseTimeout.set(()=>{
            setPaused(false);
        }, interval || undefined);
        onTouchEnd == null || onTouchEnd(event);
    }, [
        touch,
        pause,
        prev,
        next,
        touchUnpauseTimeout,
        interval,
        onTouchEnd
    ]);
    const shouldPlay = interval != null && !paused && !isSliding;
    const intervalHandleRef = (0, $7DB8U.useRef)();
    (0, $7DB8U.useEffect)(()=>{
        var _ref, _activeChildIntervalR;
        if (!shouldPlay) return undefined;
        const nextFunc = isRTL ? prev : next;
        intervalHandleRef.current = window.setInterval(document.visibilityState ? nextWhenVisible : nextFunc, (_ref = (_activeChildIntervalR = activeChildIntervalRef.current) != null ? _activeChildIntervalR : interval) != null ? _ref : undefined);
        return ()=>{
            if (intervalHandleRef.current !== null) clearInterval(intervalHandleRef.current);
        };
    }, [
        shouldPlay,
        prev,
        next,
        activeChildIntervalRef,
        interval,
        nextWhenVisible,
        isRTL
    ]);
    const indicatorOnClicks = (0, $7DB8U.useMemo)(()=>indicators && Array.from({
            length: numChildren
        }, (_, index)=>(event)=>{
                onSelect == null || onSelect(index, event);
            }), [
        indicators,
        numChildren,
        onSelect
    ]);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)(Component, {
        ref: elementRef,
        ...props,
        onKeyDown: handleKeyDown,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, slide && 'slide', fade && `${prefix}-fade`, variant && `${prefix}-${variant}`),
        children: [
            indicators && /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                className: `${prefix}-indicators`,
                children: (0, $1eee8657d780bdd9$export$871de8747c9eaa88)(children, (_, index)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("button", {
                        type: "button",
                        "data-bs-target": "" // Bootstrap requires this in their css.
                        ,
                        "aria-label": indicatorLabels != null && indicatorLabels.length ? indicatorLabels[index] : `Slide ${index + 1}`,
                        className: index === renderedActiveIndex ? 'active' : undefined,
                        onClick: indicatorOnClicks ? indicatorOnClicks[index] : undefined,
                        "aria-current": index === renderedActiveIndex
                    }, index))
            }),
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                className: `${prefix}-inner`,
                children: (0, $1eee8657d780bdd9$export$871de8747c9eaa88)(children, (child, index)=>{
                    const isActive = index === renderedActiveIndex;
                    return slide ? /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $2fc98acac168f363$export$2e2bcd8739ae039), {
                        in: isActive,
                        onEnter: isActive ? handleEnter : undefined,
                        onEntered: isActive ? handleEntered : undefined,
                        addEndListener: (0, $3d830b57987dc180$export$2e2bcd8739ae039),
                        children: (status, innerProps)=>/*#__PURE__*/ $7DB8U.cloneElement(child, {
                                ...innerProps,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(child.props.className, isActive && status !== 'entered' && orderClassName, (status === 'entered' || status === 'exiting') && 'active', (status === 'entering' || status === 'exiting') && directionalClassName)
                            })
                    }) : /*#__PURE__*/ $7DB8U.cloneElement(child, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(child.props.className, isActive && 'active')
                    });
                })
            }),
            controls && /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)((0, $e830bf8f8acfe41d$exports.Fragment), {
                children: [
                    (wrap || activeIndex !== 0) && /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)((0, $ba3423761edfecbc$export$2e2bcd8739ae039), {
                        className: `${prefix}-control-prev`,
                        onClick: prev,
                        children: [
                            prevIcon,
                            prevLabel && /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("span", {
                                className: "visually-hidden",
                                children: prevLabel
                            })
                        ]
                    }),
                    (wrap || activeIndex !== numChildren - 1) && /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)((0, $ba3423761edfecbc$export$2e2bcd8739ae039), {
                        className: `${prefix}-control-next`,
                        onClick: next,
                        children: [
                            nextIcon,
                            nextLabel && /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("span", {
                                className: "visually-hidden",
                                children: nextLabel
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
$8894fb7edfdcf11d$var$Carousel.displayName = 'Carousel';
var $8894fb7edfdcf11d$export$2e2bcd8739ae039 = Object.assign($8894fb7edfdcf11d$var$Carousel, {
    Caption: (0, $b102f1027c49ac0d$export$2e2bcd8739ae039),
    Item: (0, $c137a0844cb0c156$export$2e2bcd8739ae039)
});










var $7DB8U = parcelRequire("7DB8U");





const $185fb49570e012e7$var$alignDirection = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
    'start',
    'end'
]);
const $185fb49570e012e7$export$5dd51d61a30477bc = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
    $185fb49570e012e7$var$alignDirection,
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).shape({
        sm: $185fb49570e012e7$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).shape({
        md: $185fb49570e012e7$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).shape({
        lg: $185fb49570e012e7$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).shape({
        xl: $185fb49570e012e7$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).shape({
        xxl: $185fb49570e012e7$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object
]);



const $131d35592815e9c6$var$propTypes = {
    /**
   * An html id attribute for the Toggle button, necessary for assistive technologies, such as screen readers.
   * @type {string}
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** An `href` passed to the Toggle component */ href: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** An `onClick` handler passed to the Toggle component */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    /** The content of the non-toggle Button.  */ title: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).node.isRequired,
    /** Disables both Buttons  */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Aligns the dropdown menu.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   *
   * @type {"start"|"end"|{ sm: "start"|"end" }|{ md: "start"|"end" }|{ lg: "start"|"end" }|{ xl: "start"|"end"}|{ xxl: "start"|"end"} }
   */ align: (0, $185fb49570e012e7$export$5dd51d61a30477bc),
    /** An ARIA accessible role applied to the Menu component. When set to 'menu', The dropdown */ menuRole: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** Whether to render the dropdown menu in the DOM before the first time it is shown */ renderMenuOnMount: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   *  Which event when fired outside the component will cause it to be closed.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   */ rootCloseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /**
   * Menu color variant.
   *
   * Omitting this will use the default light color.
   */ menuVariant: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
        'dark'
    ]),
    /**
   * Allow Dropdown to flip in case of an overlapping on the reference element. For more information refer to
   * Popper.js's flip [docs](https://popper.js.org/docs/v2/modifiers/flip/).
   *
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /** @ignore */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** @ignore */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** @ignore */ size: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string
};
/**
 * A convenience component for simple or general use dropdowns. Renders a `Button` toggle and all `children`
 * are passed directly to the default `Dropdown.Menu`. This component accepts all of
 * [`Dropdown`'s props](#dropdown-props).
 *
 * _All unknown props are passed through to the `Dropdown` component._ Only
 * the Button `variant`, `size` and `bsPrefix` props are passed to the toggle,
 * along with menu-related props are passed to the `Dropdown.Menu`
 */ const $131d35592815e9c6$var$DropdownButton = /*#__PURE__*/ $7DB8U.forwardRef(({ title: title, children: children, bsPrefix: bsPrefix, rootCloseEvent: rootCloseEvent, variant: variant, size: size, menuRole: menuRole, renderMenuOnMount: renderMenuOnMount, disabled: disabled, href: href, id: id, menuVariant: menuVariant, flip: flip, ...props }, ref)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)((0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $b0516b4bf7aaf778$export$2e2bcd8739ae039), {
                id: id,
                href: href,
                size: size,
                variant: variant,
                disabled: disabled,
                childBsPrefix: bsPrefix,
                children: title
            }),
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $c821abc4a903c10a$export$2e2bcd8739ae039), {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                variant: menuVariant,
                flip: flip,
                children: children
            })
        ]
    }));
$131d35592815e9c6$var$DropdownButton.displayName = 'DropdownButton';
$131d35592815e9c6$var$DropdownButton.propTypes = $131d35592815e9c6$var$propTypes;
var $131d35592815e9c6$export$2e2bcd8739ae039 = $131d35592815e9c6$var$DropdownButton;










var $7DB8U = parcelRequire("7DB8U");



var $7DB8U = parcelRequire("7DB8U");


const $0aebde5847988fc1$var$FigureImage = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, fluid: fluid = true, ...props }, ref)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $facf438de9c933e7$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        fluid: fluid,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, 'figure-img')
    }));
$0aebde5847988fc1$var$FigureImage.displayName = 'FigureImage';
$0aebde5847988fc1$var$FigureImage.propTypes = (0, $facf438de9c933e7$export$513805011eaa4892);
var $0aebde5847988fc1$export$2e2bcd8739ae039 = $0aebde5847988fc1$var$FigureImage;



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $74a472321c3ee4fb$var$FigureCaption = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'figcaption', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'figure-caption');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$74a472321c3ee4fb$var$FigureCaption.displayName = 'FigureCaption';
var $74a472321c3ee4fb$export$2e2bcd8739ae039 = $74a472321c3ee4fb$var$FigureCaption;




"use client";
const $6d3ea74e4e4e2412$var$Figure = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'figure', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'figure');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$6d3ea74e4e4e2412$var$Figure.displayName = 'Figure';
var $6d3ea74e4e4e2412$export$2e2bcd8739ae039 = Object.assign($6d3ea74e4e4e2412$var$Figure, {
    Image: (0, $0aebde5847988fc1$export$2e2bcd8739ae039),
    Caption: (0, $74a472321c3ee4fb$export$2e2bcd8739ae039)
});
















var $7DB8U = parcelRequire("7DB8U");




var $7DB8U = parcelRequire("7DB8U");



"use client";
const $a0eb8caa3677cbc5$var$InputGroupText = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'input-group-text');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$a0eb8caa3677cbc5$var$InputGroupText.displayName = 'InputGroupText';
var $a0eb8caa3677cbc5$export$2e2bcd8739ae039 = $a0eb8caa3677cbc5$var$InputGroupText;



"use client";
const $57a9e8ff5b04b6eb$var$InputGroupCheckbox = (props)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $a0eb8caa3677cbc5$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $ad9056b1c9f01fc5$export$2e2bcd8739ae039), {
            type: "checkbox",
            ...props
        })
    });
const $57a9e8ff5b04b6eb$var$InputGroupRadio = (props)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $a0eb8caa3677cbc5$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $ad9056b1c9f01fc5$export$2e2bcd8739ae039), {
            type: "radio",
            ...props
        })
    });
const $57a9e8ff5b04b6eb$var$InputGroup = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, size: size, hasValidation: hasValidation, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'input-group');
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    const contextValue = (0, $7DB8U.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $5f9abe7800bfcf37$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, hasValidation && 'has-validation')
        })
    });
});
$57a9e8ff5b04b6eb$var$InputGroup.displayName = 'InputGroup';
var $57a9e8ff5b04b6eb$export$2e2bcd8739ae039 = Object.assign($57a9e8ff5b04b6eb$var$InputGroup, {
    Text: (0, $a0eb8caa3677cbc5$export$2e2bcd8739ae039),
    Radio: $57a9e8ff5b04b6eb$var$InputGroupRadio,
    Checkbox: $57a9e8ff5b04b6eb$var$InputGroupCheckbox
});




var $7DB8U = parcelRequire("7DB8U");






var $7DB8U = parcelRequire("7DB8U");






"use client";
const $e5f4fd37799c5a36$var$ListGroupItem = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, active: active, disabled: disabled, eventKey: eventKey, className: className, variant: variant, action: action, as: as, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'list-group-item');
    const [navItemProps, meta] = (0, $2b9a552046f98f3a$export$d7a68693710982a)({
        key: (0, $988f4de41e5b7681$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        ...props
    });
    const handleClick = (0, $297288d717742377$export$2e2bcd8739ae039)((event)=>{
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        navItemProps.onClick(event);
    });
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    const Component = as || (action ? props.href ? 'a' : 'button' : 'div');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        ...props,
        ...navItemProps,
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && `${bsPrefix}-${variant}`, action && `${bsPrefix}-action`)
    });
});
$e5f4fd37799c5a36$var$ListGroupItem.displayName = 'ListGroupItem';
var $e5f4fd37799c5a36$export$2e2bcd8739ae039 = $e5f4fd37799c5a36$var$ListGroupItem;



"use client";
const $50d5573d45f88780$var$ListGroup = /*#__PURE__*/ $7DB8U.forwardRef((props, ref)=>{
    const { className: className, bsPrefix: initialBsPrefix, variant: variant, horizontal: horizontal, numbered: numbered, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as = 'div', ...controlledProps } = (0, $be0af947f6d59f9f$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(initialBsPrefix, 'list-group');
    let horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : `horizontal-${horizontal}`;
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $c6da089809cb1066$export$2e2bcd8739ae039), {
        ref: ref,
        ...controlledProps,
        as: as,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, variant && `${bsPrefix}-${variant}`, horizontalVariant && `${bsPrefix}-${horizontalVariant}`, numbered && `${bsPrefix}-numbered`)
    });
});
$50d5573d45f88780$var$ListGroup.displayName = 'ListGroup';
var $50d5573d45f88780$export$2e2bcd8739ae039 = Object.assign($50d5573d45f88780$var$ListGroup, {
    Item: (0, $e5f4fd37799c5a36$export$2e2bcd8739ae039)
});












var $7DB8U = parcelRequire("7DB8U");




var $7DB8U = parcelRequire("7DB8U");


"use client";
const $b5deecc49fda798d$var$NavbarBrand = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix)
    });
});
$b5deecc49fda798d$var$NavbarBrand.displayName = 'NavbarBrand';
var $b5deecc49fda798d$export$2e2bcd8739ae039 = $b5deecc49fda798d$var$NavbarBrand;



var $7DB8U = parcelRequire("7DB8U");




"use client";
const $97362b55fdc15beb$var$NavbarCollapse = /*#__PURE__*/ $7DB8U.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'navbar-collapse');
    const context = (0, $7DB8U.useContext)((0, $62bc15095c841559$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $7476d4e4f4ba1c12$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$97362b55fdc15beb$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $97362b55fdc15beb$export$2e2bcd8739ae039 = $97362b55fdc15beb$var$NavbarCollapse;




var $7DB8U = parcelRequire("7DB8U");




"use client";
const $3c790fcb9fb4a590$var$NavbarToggle = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'navbar-toggler');
    const { onToggle: onToggle, expanded: expanded } = (0, $7DB8U.useContext)((0, $62bc15095c841559$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $297288d717742377$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$3c790fcb9fb4a590$var$NavbarToggle.displayName = 'NavbarToggle';
var $3c790fcb9fb4a590$export$2e2bcd8739ae039 = $3c790fcb9fb4a590$var$NavbarToggle;



var $7DB8U = parcelRequire("7DB8U");




var $7DB8U = parcelRequire("7DB8U");
const $738d61f0dee33083$var$matchersByWindow = new WeakMap();
const $738d61f0dee33083$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $738d61f0dee33083$var$matchersByWindow.get(targetWindow) || new Map();
    $738d61f0dee33083$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $738d61f0dee33083$export$2e2bcd8739ae039(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = $738d61f0dee33083$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $7DB8U.useState)(()=>mql ? mql.matches : false);
    (0, $5d10a2d054265037$export$2e2bcd8739ae039)(()=>{
        let mql = $738d61f0dee33083$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $738d61f0dee33083$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $7DB8U = parcelRequire("7DB8U");
function $eaa3368f3059f97a$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $7DB8U.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $738d61f0dee33083$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $eaa3368f3059f97a$var$useBreakpoint = $eaa3368f3059f97a$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $eaa3368f3059f97a$export$2e2bcd8739ae039 = $eaa3368f3059f97a$var$useBreakpoint;




var $7DB8U = parcelRequire("7DB8U");



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $1e440b1f939556f6$var$OffcanvasBody = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$1e440b1f939556f6$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $1e440b1f939556f6$export$2e2bcd8739ae039 = $1e440b1f939556f6$var$OffcanvasBody;




var $7DB8U = parcelRequire("7DB8U");






"use client";
const $893cf2306a072a43$var$transitionStyles = {
    [(0, $6d8a24823bc267eb$export$df38205c966be359)]: 'show',
    [(0, $6d8a24823bc267eb$export$78e9e6e3e014d60a)]: 'show'
};
const $893cf2306a072a43$var$OffcanvasToggling = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $2fc98acac168f363$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $3d830b57987dc180$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: (0, $36a3340f9542756b$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $7DB8U.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, children.props.className, (status === (0, $6d8a24823bc267eb$export$df38205c966be359) || status === (0, $6d8a24823bc267eb$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $893cf2306a072a43$var$transitionStyles[status])
            })
    });
});
$893cf2306a072a43$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $893cf2306a072a43$export$2e2bcd8739ae039 = $893cf2306a072a43$var$OffcanvasToggling;





var $7DB8U = parcelRequire("7DB8U");



"use client";
const $6e97541bbb8e01f6$var$OffcanvasHeader = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $6b1c35348353eda8$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$6e97541bbb8e01f6$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $6e97541bbb8e01f6$export$2e2bcd8739ae039 = $6e97541bbb8e01f6$var$OffcanvasHeader;



var $7DB8U = parcelRequire("7DB8U");




"use client";
const $5bcd325dd9b71a5f$var$DivStyledAsH5 = (0, $500199e796627cf1$export$2e2bcd8739ae039)('h5');
const $5bcd325dd9b71a5f$var$OffcanvasTitle = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $5bcd325dd9b71a5f$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$5bcd325dd9b71a5f$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $5bcd325dd9b71a5f$export$2e2bcd8739ae039 = $5bcd325dd9b71a5f$var$OffcanvasTitle;





"use client";
function $c895dcd8cc58e4b8$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $893cf2306a072a43$export$2e2bcd8739ae039), {
        ...props
    });
}
function $c895dcd8cc58e4b8$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $722140d134b37da6$export$2e2bcd8739ae039), {
        ...props
    });
}
const $c895dcd8cc58e4b8$var$Offcanvas = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, 'aria-labelledby': ariaLabelledby, placement: placement = 'start', responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $7DB8U.useRef)();
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, $7DB8U.useState)(false);
    const handleHide = (0, $297288d717742377$export$2e2bcd8739ae039)(onHide);
    const hideResponsiveOffcanvas = (0, $eaa3368f3059f97a$export$2e2bcd8739ae039)(responsive || 'xs', 'up');
    (0, $7DB8U.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $7DB8U.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $028ffbe3fb667958$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $028ffbe3fb667958$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $7DB8U.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)((0, $e830bf8f8acfe41d$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $b5845834466d1c56$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $882430142e8347e0$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $c895dcd8cc58e4b8$var$DialogTransition,
                    backdropTransition: $c895dcd8cc58e4b8$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$c895dcd8cc58e4b8$var$Offcanvas.displayName = 'Offcanvas';
var $c895dcd8cc58e4b8$export$2e2bcd8739ae039 = Object.assign($c895dcd8cc58e4b8$var$Offcanvas, {
    Body: (0, $1e440b1f939556f6$export$2e2bcd8739ae039),
    Header: (0, $6e97541bbb8e01f6$export$2e2bcd8739ae039),
    Title: (0, $5bcd325dd9b71a5f$export$2e2bcd8739ae039)
});




"use client";
const $76037aecb4d24ba9$var$NavbarOffcanvas = /*#__PURE__*/ $7DB8U.forwardRef(({ onHide: onHide, ...props }, ref)=>{
    const context = (0, $7DB8U.useContext)((0, $62bc15095c841559$export$2e2bcd8739ae039));
    const handleHide = (0, $297288d717742377$export$2e2bcd8739ae039)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $c895dcd8cc58e4b8$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true,
        onHide: handleHide
    });
});
$76037aecb4d24ba9$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $76037aecb4d24ba9$export$2e2bcd8739ae039 = $76037aecb4d24ba9$var$NavbarOffcanvas;





var $7DB8U = parcelRequire("7DB8U");



"use client";
const $33c1c76655d8a898$var$NavbarText = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$33c1c76655d8a898$var$NavbarText.displayName = 'NavbarText';
var $33c1c76655d8a898$export$2e2bcd8739ae039 = $33c1c76655d8a898$var$NavbarText;



"use client";
const $2e01f258a0c6c8d6$var$Navbar = /*#__PURE__*/ $7DB8U.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = 'light', bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $be0af947f6d59f9f$export$2e2bcd8739ae039)(props, {
        expanded: 'onToggle'
    });
    const bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, $7DB8U.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $7DB8U.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $62bc15095c841559$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $988f4de41e5b7681$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$2e01f258a0c6c8d6$var$Navbar.displayName = 'Navbar';
var $2e01f258a0c6c8d6$export$2e2bcd8739ae039 = Object.assign($2e01f258a0c6c8d6$var$Navbar, {
    Brand: (0, $b5deecc49fda798d$export$2e2bcd8739ae039),
    Collapse: (0, $97362b55fdc15beb$export$2e2bcd8739ae039),
    Offcanvas: (0, $76037aecb4d24ba9$export$2e2bcd8739ae039),
    Text: (0, $33c1c76655d8a898$export$2e2bcd8739ae039),
    Toggle: (0, $3c790fcb9fb4a590$export$2e2bcd8739ae039)
});









var $7DB8U = parcelRequire("7DB8U");




"use client";
const $e36e74acb2656ab9$var$NavDropdown = /*#__PURE__*/ $7DB8U.forwardRef(({ id: id, title: title, children: children, bsPrefix: bsPrefix, className: className, rootCloseEvent: rootCloseEvent, menuRole: menuRole, disabled: disabled, active: active, renderMenuOnMount: renderMenuOnMount, menuVariant: menuVariant, ...props }, ref)=>{
    /* NavItem has no additional logic, it's purely presentational. Can set nav item class here to support "as" */ const navItemPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(undefined, 'nav-item');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)((0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, navItemPrefix),
        children: [
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039).Toggle, {
                id: id,
                eventKey: null,
                active: active,
                disabled: disabled,
                childBsPrefix: bsPrefix,
                as: (0, $1f1b2d0a7d8ef4d4$export$2e2bcd8739ae039),
                children: title
            }),
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039).Menu, {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                variant: menuVariant,
                children: children
            })
        ]
    });
});
$e36e74acb2656ab9$var$NavDropdown.displayName = 'NavDropdown';
var $e36e74acb2656ab9$export$2e2bcd8739ae039 = Object.assign($e36e74acb2656ab9$var$NavDropdown, {
    Item: (0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039).Item,
    ItemText: (0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039).ItemText,
    Divider: (0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039).Divider,
    Header: (0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039).Header
});













var $7DB8U = parcelRequire("7DB8U");


const $a5762485f09fbf3a$var$PageItem = /*#__PURE__*/ $7DB8U.forwardRef(({ active: active = false, disabled: disabled = false, className: className, style: style, activeLabel: activeLabel = '(current)', children: children, linkStyle: linkStyle, linkClassName: linkClassName, as: as = (0, $ba3423761edfecbc$export$2e2bcd8739ae039), ...props }, ref)=>{
    const Component = active || disabled ? 'span' : as;
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("li", {
        ref: ref,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, 'page-item', {
            active: active,
            disabled: disabled
        }),
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)(Component, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('page-link', linkClassName),
            style: linkStyle,
            ...props,
            children: [
                children,
                active && activeLabel && /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("span", {
                    className: "visually-hidden",
                    children: activeLabel
                })
            ]
        })
    });
});
$a5762485f09fbf3a$var$PageItem.displayName = 'PageItem';
var $a5762485f09fbf3a$export$2e2bcd8739ae039 = $a5762485f09fbf3a$var$PageItem;
function $a5762485f09fbf3a$var$createButton(name, defaultValue, label = name) {
    const Button = /*#__PURE__*/ $7DB8U.forwardRef(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)($a5762485f09fbf3a$var$PageItem, {
            ...props,
            ref: ref,
            children: [
                /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("span", {
                    "aria-hidden": "true",
                    children: children || defaultValue
                }),
                /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("span", {
                    className: "visually-hidden",
                    children: label
                })
            ]
        }));
    Button.displayName = name;
    return Button;
}
const $a5762485f09fbf3a$export$b25abba66f7be210 = $a5762485f09fbf3a$var$createButton('First', "\xab");
const $a5762485f09fbf3a$export$1b265216817111b9 = $a5762485f09fbf3a$var$createButton('Prev', "\u2039", 'Previous');
const $a5762485f09fbf3a$export$1297970233533a7d = $a5762485f09fbf3a$var$createButton('Ellipsis', "\u2026", 'More');
const $a5762485f09fbf3a$export$b820fc49f2736e85 = $a5762485f09fbf3a$var$createButton('Next', "\u203A");
const $a5762485f09fbf3a$export$bed9238d8933c9a8 = $a5762485f09fbf3a$var$createButton('Last', "\xbb");




var $7DB8U = parcelRequire("7DB8U");



"use client";
const $93556c1ea6cf0bb9$var$Pagination = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, size: size, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'pagination');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("ul", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, size && `${decoratedBsPrefix}-${size}`)
    });
});
$93556c1ea6cf0bb9$var$Pagination.displayName = 'Pagination';
var $93556c1ea6cf0bb9$export$2e2bcd8739ae039 = Object.assign($93556c1ea6cf0bb9$var$Pagination, {
    First: $a5762485f09fbf3a$export$b25abba66f7be210,
    Prev: $a5762485f09fbf3a$export$1b265216817111b9,
    Ellipsis: $a5762485f09fbf3a$export$1297970233533a7d,
    Item: (0, $a5762485f09fbf3a$export$2e2bcd8739ae039),
    Next: $a5762485f09fbf3a$export$b820fc49f2736e85,
    Last: $a5762485f09fbf3a$export$bed9238d8933c9a8
});



var $7DB8U = parcelRequire("7DB8U");



"use client";
function $e2581871648d4124$export$2e2bcd8739ae039({ animation: animation, bg: bg, bsPrefix: bsPrefix, size: size, ...props }) {
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'placeholder');
    const [{ className: className, ...colProps }] = (0, $51362f0aeeaa849e$export$2ed43d61a0a9f5a3)(props);
    return {
        ...colProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, animation ? `${bsPrefix}-${animation}` : bsPrefix, size && `${bsPrefix}-${size}`, bg && `bg-${bg}`)
    };
}



var $7DB8U = parcelRequire("7DB8U");



const $c382bed23255f9df$var$PlaceholderButton = /*#__PURE__*/ $7DB8U.forwardRef((props, ref)=>{
    const placeholderProps = (0, $e2581871648d4124$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $e4f2607df5423ec3$export$2e2bcd8739ae039), {
        ...placeholderProps,
        ref: ref,
        disabled: true,
        tabIndex: -1
    });
});
$c382bed23255f9df$var$PlaceholderButton.displayName = 'PlaceholderButton';
var $c382bed23255f9df$export$2e2bcd8739ae039 = $c382bed23255f9df$var$PlaceholderButton;



const $c080c8fc94f5a99d$var$Placeholder = /*#__PURE__*/ $7DB8U.forwardRef(({ as: Component = 'span', ...props }, ref)=>{
    const placeholderProps = (0, $e2581871648d4124$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...placeholderProps,
        ref: ref
    });
});
$c080c8fc94f5a99d$var$Placeholder.displayName = 'Placeholder';
var $c080c8fc94f5a99d$export$2e2bcd8739ae039 = Object.assign($c080c8fc94f5a99d$var$Placeholder, {
    Button: (0, $c382bed23255f9df$export$2e2bcd8739ae039)
});








var $7DB8U = parcelRequire("7DB8U");



"use client";
const $ef28b81a914ae897$var$ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `ProgressBar`.
 */ function $ef28b81a914ae897$var$onlyProgressBar(props, propName, componentName) {
    const children = props[propName];
    if (!children) return null;
    let error = null;
    $7DB8U.Children.forEach(children, (child)=>{
        if (error) return;
        /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */ const element = /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)($ef28b81a914ae897$var$ProgressBar, {});
        if (child.type === element.type) return;
        const childType = child.type;
        const childIdentifier = /*#__PURE__*/ $7DB8U.isValidElement(child) ? childType.displayName || childType.name || childType : child;
        error = new Error(`Children of ${componentName} can contain only ProgressBar ` + `components. Found ${childIdentifier}.`);
    });
    return error;
}
function $ef28b81a914ae897$var$getPercentage(now, min, max) {
    const percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * $ef28b81a914ae897$var$ROUND_PRECISION) / $ef28b81a914ae897$var$ROUND_PRECISION;
}
function $ef28b81a914ae897$var$renderProgressBar({ min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, className: className, style: style, variant: variant, bsPrefix: bsPrefix, ...props }, ref) {
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
        ref: ref,
        ...props,
        role: "progressbar",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, `${bsPrefix}-bar`, {
            [`bg-${variant}`]: variant,
            [`${bsPrefix}-bar-animated`]: animated,
            [`${bsPrefix}-bar-striped`]: animated || striped
        }),
        style: {
            width: `${$ef28b81a914ae897$var$getPercentage(now, min, max)}%`,
            ...style
        },
        "aria-valuenow": now,
        "aria-valuemin": min,
        "aria-valuemax": max,
        children: visuallyHidden ? /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("span", {
            className: "visually-hidden",
            children: label
        }) : label
    });
}
const $ef28b81a914ae897$var$ProgressBar = /*#__PURE__*/ $7DB8U.forwardRef(({ isChild: isChild = false, ...rest }, ref)=>{
    const props = {
        min: 0,
        max: 100,
        animated: false,
        visuallyHidden: false,
        striped: false,
        ...rest
    };
    props.bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(props.bsPrefix, 'progress');
    if (isChild) return $ef28b81a914ae897$var$renderProgressBar(props, ref);
    const { min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, bsPrefix: bsPrefix, variant: variant, className: className, children: children, ...wrapperProps } = props;
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
        ref: ref,
        ...wrapperProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        children: children ? (0, $1eee8657d780bdd9$export$871de8747c9eaa88)(children, (child)=>/*#__PURE__*/ (0, $7DB8U.cloneElement)(child, {
                isChild: true
            })) : $ef28b81a914ae897$var$renderProgressBar({
            min: min,
            now: now,
            max: max,
            label: label,
            visuallyHidden: visuallyHidden,
            striped: striped,
            animated: animated,
            bsPrefix: bsPrefix,
            variant: variant
        }, ref)
    });
});
$ef28b81a914ae897$var$ProgressBar.displayName = 'ProgressBar';
var $ef28b81a914ae897$export$2e2bcd8739ae039 = $ef28b81a914ae897$var$ProgressBar;




var $7DB8U = parcelRequire("7DB8U");


"use client";
function $ff1d9079246ae266$var$toPercent(num) {
    if (num <= 0) return '100%';
    if (num < 1) return `${num * 100}%`;
    return `${num}%`;
}
const $ff1d9079246ae266$var$Ratio = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, aspectRatio: aspectRatio = '1x1', style: style, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'ratio');
    const isCustomRatio = typeof aspectRatio === 'number';
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("div", {
        ref: ref,
        ...props,
        style: {
            ...style,
            ...isCustomRatio && {
                '--bs-aspect-ratio': $ff1d9079246ae266$var$toPercent(aspectRatio)
            }
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(bsPrefix, className, !isCustomRatio && `${bsPrefix}-${aspectRatio}`),
        children: $7DB8U.Children.only(children)
    });
});
$ff1d9079246ae266$var$Ratio.displayName = 'Ratio';
var $ff1d9079246ae266$export$2e2bcd8739ae039 = $ff1d9079246ae266$var$Ratio;





var $7DB8U = parcelRequire("7DB8U");






const $8d5b5ce2f99956b9$var$propTypes = {
    /**
   * An html id attribute for the Toggle button, necessary for assistive technologies, such as screen readers.
   * @type {string}
   * @required
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */ toggleLabel: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** An `href` passed to the non-toggle Button */ href: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** An anchor `target` passed to the non-toggle Button */ target: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** An `onClick` handler passed to the non-toggle Button */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).func,
    /** The content of the non-toggle Button.  */ title: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).node.isRequired,
    /** A `type` passed to the non-toggle Button */ type: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** Disables both Buttons  */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Aligns the dropdown menu.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   *
   * @type {"start"|"end"|{ sm: "start"|"end" }|{ md: "start"|"end" }|{ lg: "start"|"end" }|{ xl: "start"|"end"}|{ xxl: "start"|"end"} }
   */ align: (0, $185fb49570e012e7$export$5dd51d61a30477bc),
    /** An ARIA accessible role applied to the Menu component. When set to 'menu', The dropdown */ menuRole: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** Whether to render the dropdown menu in the DOM before the first time it is shown */ renderMenuOnMount: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   *  Which event when fired outside the component will cause it to be closed.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   */ rootCloseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /**
   * Allow Dropdown to flip in case of an overlapping on the reference element. For more information refer to
   * Popper.js's flip [docs](https://popper.js.org/docs/v2/modifiers/flip/).
   *
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /** @ignore */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** @ignore */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /** @ignore */ size: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string
};
/**
 * A convenience component for simple or general use split button dropdowns. Renders a
 * `ButtonGroup` containing a `Button` and a `Button` toggle for the `Dropdown`. All `children`
 * are passed directly to the default `Dropdown.Menu`. This component accepts all of [`Dropdown`'s
 * props](#dropdown-props).
 *
 * _All unknown props are passed through to the `Dropdown` component._
 * The Button `variant`, `size` and `bsPrefix` props are passed to the button and toggle,
 * and menu-related props are passed to the `Dropdown.Menu`
 */ const $8d5b5ce2f99956b9$var$SplitButton = /*#__PURE__*/ $7DB8U.forwardRef(({ id: id, bsPrefix: bsPrefix, size: size, variant: variant, title: title, type: type = 'button', toggleLabel: toggleLabel = 'Toggle dropdown', children: children, onClick: onClick, href: href, target: target, menuRole: menuRole, renderMenuOnMount: renderMenuOnMount, rootCloseEvent: rootCloseEvent, flip: flip, ...props }, ref)=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)((0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        as: (0, $dbb879efc36c7062$export$2e2bcd8739ae039),
        children: [
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $e4f2607df5423ec3$export$2e2bcd8739ae039), {
                size: size,
                variant: variant,
                disabled: props.disabled,
                bsPrefix: bsPrefix,
                href: href,
                target: target,
                onClick: onClick,
                type: type,
                children: title
            }),
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039).Toggle, {
                split: true,
                id: id,
                size: size,
                variant: variant,
                disabled: props.disabled,
                childBsPrefix: bsPrefix,
                children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("span", {
                    className: "visually-hidden",
                    children: toggleLabel
                })
            }),
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $ecb5bcf98c9fe309$export$2e2bcd8739ae039).Menu, {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                flip: flip,
                children: children
            })
        ]
    }));
$8d5b5ce2f99956b9$var$SplitButton.propTypes = $8d5b5ce2f99956b9$var$propTypes;
$8d5b5ce2f99956b9$var$SplitButton.displayName = 'SplitButton';
var $8d5b5ce2f99956b9$export$2e2bcd8739ae039 = $8d5b5ce2f99956b9$var$SplitButton;



var $e66ffa995fd5a977$export$2e2bcd8739ae039 = (0, $305f118f0e8bc1b9$export$9f8ac96af4b1b2ae);




var $7DB8U = parcelRequire("7DB8U");



function $fc686d0044cde742$export$3d03cefad97f5c33(propType) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        propType,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).shape({
            xs: propType,
            sm: propType,
            md: propType,
            lg: propType,
            xl: propType,
            xxl: propType
        })
    ]);
}
function $fc686d0044cde742$export$2e2bcd8739ae039(utilityValues, breakpoints = (0, $d36baff69136067a$export$666ad80b5007f835), minBreakpoint = (0, $d36baff69136067a$export$ff817e17bad2e091)) {
    const classes = [];
    Object.entries(utilityValues).forEach(([utilName, utilValue])=>{
        if (utilValue != null) {
            if (typeof utilValue === 'object') breakpoints.forEach((brkPoint)=>{
                const bpValue = utilValue[brkPoint];
                if (bpValue != null) {
                    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
                    classes.push(`${utilName}${infix}-${bpValue}`);
                }
            });
            else classes.push(`${utilName}-${utilValue}`);
        }
    });
    return classes;
}



"use client";
const $f39d3f10a82d617d$var$Stack = /*#__PURE__*/ $7DB8U.forwardRef(({ as: Component = 'div', bsPrefix: bsPrefix, className: className, direction: direction, gap: gap, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, direction === 'horizontal' ? 'hstack' : 'vstack');
    const breakpoints = (0, $d36baff69136067a$export$8970c8db816a5863)();
    const minBreakpoint = (0, $d36baff69136067a$export$d926d6ef38f3fd32)();
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, ...(0, $fc686d0044cde742$export$2e2bcd8739ae039)({
            gap: gap
        }, breakpoints, minBreakpoint))
    });
});
$f39d3f10a82d617d$var$Stack.displayName = 'Stack';
var $f39d3f10a82d617d$export$2e2bcd8739ae039 = $f39d3f10a82d617d$var$Stack;




var $7DB8U = parcelRequire("7DB8U");





var $7DB8U = parcelRequire("7DB8U");




const $7f93da6fcba920e2$var$_excluded = [
    "active",
    "eventKey",
    "mountOnEnter",
    "transition",
    "unmountOnExit",
    "role",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
], $7f93da6fcba920e2$var$_excluded2 = [
    "activeKey",
    "getControlledId",
    "getControllerId"
], $7f93da6fcba920e2$var$_excluded3 = [
    "as"
];
function $7f93da6fcba920e2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $7f93da6fcba920e2$export$fae0121b5afe572d(_ref) {
    let { active: active, eventKey: eventKey, mountOnEnter: mountOnEnter, transition: transition, unmountOnExit: unmountOnExit, role: role = 'tabpanel', onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited } = _ref, props = $7f93da6fcba920e2$var$_objectWithoutPropertiesLoose(_ref, $7f93da6fcba920e2$var$_excluded);
    const context = (0, $7DB8U.useContext)((0, $a2a0365b556cd2b2$export$2e2bcd8739ae039));
    if (!context) return [
        Object.assign({}, props, {
            role: role
        }),
        {
            eventKey: eventKey,
            isActive: active,
            mountOnEnter: mountOnEnter,
            transition: transition,
            unmountOnExit: unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
    const { activeKey: activeKey, getControlledId: getControlledId, getControllerId: getControllerId } = context, rest = $7f93da6fcba920e2$var$_objectWithoutPropertiesLoose(context, $7f93da6fcba920e2$var$_excluded2);
    const key = (0, $988f4de41e5b7681$export$eef49b42fde998a3)(eventKey);
    return [
        Object.assign({}, props, {
            role: role,
            id: getControlledId(eventKey),
            'aria-labelledby': getControllerId(eventKey)
        }),
        {
            eventKey: eventKey,
            isActive: active == null && key != null ? (0, $988f4de41e5b7681$export$eef49b42fde998a3)(activeKey) === key : active,
            transition: transition || rest.transition,
            mountOnEnter: mountOnEnter != null ? mountOnEnter : rest.mountOnEnter,
            unmountOnExit: unmountOnExit != null ? unmountOnExit : rest.unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
}
const $7f93da6fcba920e2$var$TabPanel = /*#__PURE__*/ $7DB8U.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_ref2, ref)=>{
    let { as: Component = 'div' } = _ref2, props = $7f93da6fcba920e2$var$_objectWithoutPropertiesLoose(_ref2, $7f93da6fcba920e2$var$_excluded3);
    const [tabPanelProps, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $a760d026a627c09f$export$2e2bcd8739ae039) }] = $7f93da6fcba920e2$export$fae0121b5afe572d(props);
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $a2a0365b556cd2b2$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $988f4de41e5b7681$export$2e2bcd8739ae039).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, Object.assign({}, tabPanelProps, {
                    ref: ref,
                    hidden: !isActive,
                    "aria-hidden": !isActive
                }))
            })
        })
    });
});
$7f93da6fcba920e2$var$TabPanel.displayName = 'TabPanel';
var $7f93da6fcba920e2$export$2e2bcd8739ae039 = $7f93da6fcba920e2$var$TabPanel;



const $a431f5dc1b2bc3db$var$Tabs = (props)=>{
    const { id: userId, generateChildId: generateCustomChildId, onSelect: propsOnSelect, activeKey: propsActiveKey, defaultActiveKey: defaultActiveKey, transition: transition, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, children: children } = props;
    const [activeKey, onSelect] = (0, $424274a7cd447a98$export$2ee51287a16ca325)(propsActiveKey, defaultActiveKey, propsOnSelect);
    const id = (0, $305f118f0e8bc1b9$export$619500959fc48b26)(userId);
    const generateChildId = (0, $7DB8U.useMemo)(()=>generateCustomChildId || ((key, type)=>id ? `${id}-${type}-${key}` : null), [
        id,
        generateCustomChildId
    ]);
    const tabContext = (0, $7DB8U.useMemo)(()=>({
            onSelect: onSelect,
            activeKey: activeKey,
            transition: transition,
            mountOnEnter: mountOnEnter || false,
            unmountOnExit: unmountOnExit || false,
            getControlledId: (key)=>generateChildId(key, 'tabpane'),
            getControllerId: (key)=>generateChildId(key, 'tab')
        }), [
        onSelect,
        activeKey,
        transition,
        mountOnEnter,
        unmountOnExit,
        generateChildId
    ]);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $a2a0365b556cd2b2$export$2e2bcd8739ae039).Provider, {
        value: tabContext,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $988f4de41e5b7681$export$2e2bcd8739ae039).Provider, {
            value: onSelect || null,
            children: children
        })
    });
};
$a431f5dc1b2bc3db$var$Tabs.Panel = (0, $7f93da6fcba920e2$export$2e2bcd8739ae039);
var $a431f5dc1b2bc3db$export$2e2bcd8739ae039 = $a431f5dc1b2bc3db$var$Tabs;




function $3048a09db8982f3f$export$2e2bcd8739ae039(transition) {
    if (typeof transition === 'boolean') return transition ? (0, $722140d134b37da6$export$2e2bcd8739ae039) : (0, $a760d026a627c09f$export$2e2bcd8739ae039);
    return transition;
}



const $17e9aecf2ab4c86d$var$TabContainer = ({ transition: transition, ...props })=>/*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $a431f5dc1b2bc3db$export$2e2bcd8739ae039), {
        ...props,
        transition: (0, $3048a09db8982f3f$export$2e2bcd8739ae039)(transition)
    });
$17e9aecf2ab4c86d$var$TabContainer.displayName = 'TabContainer';
var $17e9aecf2ab4c86d$export$2e2bcd8739ae039 = $17e9aecf2ab4c86d$var$TabContainer;



var $7DB8U = parcelRequire("7DB8U");



"use client";
const $0c04e2da1b8aa27e$var$TabContent = /*#__PURE__*/ $7DB8U.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'tab-content');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$0c04e2da1b8aa27e$var$TabContent.displayName = 'TabContent';
var $0c04e2da1b8aa27e$export$2e2bcd8739ae039 = $0c04e2da1b8aa27e$var$TabContent;




var $7DB8U = parcelRequire("7DB8U");







"use client";
const $1d9f27906d53a5cb$var$TabPane = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, transition: transition, ...props }, ref)=>{
    const [{ className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', ...rest }, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $722140d134b37da6$export$2e2bcd8739ae039) }] = (0, $7f93da6fcba920e2$export$fae0121b5afe572d)({
        ...props,
        transition: (0, $3048a09db8982f3f$export$2e2bcd8739ae039)(transition)
    });
    const prefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'tab-pane');
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $a2a0365b556cd2b2$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $988f4de41e5b7681$export$2e2bcd8739ae039).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)(Component, {
                    ...rest,
                    ref: ref,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, isActive && 'active')
                })
            })
        })
    });
});
$1d9f27906d53a5cb$var$TabPane.displayName = 'TabPane';
var $1d9f27906d53a5cb$export$2e2bcd8739ae039 = $1d9f27906d53a5cb$var$TabPane;


const $8743ca8519f92be1$var$propTypes = {
    eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).number
    ]),
    /**
   * Content for the tab title.
   */ title: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).node.isRequired,
    /**
   * The disabled state of the tab.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Class to pass to the underlying nav link.
   */ tabClassName: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /**
   * Object containing attributes to pass to underlying nav link.
   */ tabAttrs: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).object
};
const $8743ca8519f92be1$var$Tab = ()=>{
    throw new Error("ReactBootstrap: The `Tab` component is not meant to be rendered! It's an abstract component that is only valid as a direct Child of the `Tabs` Component. For custom tabs components use TabPane and TabsContainer directly");
};
$8743ca8519f92be1$var$Tab.propTypes = $8743ca8519f92be1$var$propTypes;
var $8743ca8519f92be1$export$2e2bcd8739ae039 = Object.assign($8743ca8519f92be1$var$Tab, {
    Container: (0, $17e9aecf2ab4c86d$export$2e2bcd8739ae039),
    Content: (0, $0c04e2da1b8aa27e$export$2e2bcd8739ae039),
    Pane: (0, $1d9f27906d53a5cb$export$2e2bcd8739ae039)
});






parcelRequire("7DB8U");










function $d7c68af8f1828f4e$var$getDefaultActiveKey(children) {
    let defaultActiveKey;
    (0, $1eee8657d780bdd9$export$4b80e395e36b5a56)(children, (child)=>{
        if (defaultActiveKey == null) defaultActiveKey = child.props.eventKey;
    });
    return defaultActiveKey;
}
function $d7c68af8f1828f4e$var$renderTab(child) {
    const { title: title, eventKey: eventKey, disabled: disabled, tabClassName: tabClassName, tabAttrs: tabAttrs, id: id } = child.props;
    if (title == null) return null;
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $522c1bf80aa094bc$export$2e2bcd8739ae039), {
        as: "li",
        role: "presentation",
        children: /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $1f1b2d0a7d8ef4d4$export$2e2bcd8739ae039), {
            as: "button",
            type: "button",
            eventKey: eventKey,
            disabled: disabled,
            id: id,
            className: tabClassName,
            ...tabAttrs,
            children: title
        })
    });
}
const $d7c68af8f1828f4e$var$Tabs = (props)=>{
    const { id: id, onSelect: onSelect, transition: transition, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, variant: variant = 'tabs', children: children, activeKey: activeKey = $d7c68af8f1828f4e$var$getDefaultActiveKey(children), ...controlledProps } = (0, $be0af947f6d59f9f$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    });
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)((0, $a431f5dc1b2bc3db$export$2e2bcd8739ae039), {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        transition: (0, $3048a09db8982f3f$export$2e2bcd8739ae039)(transition),
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        children: [
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039), {
                id: id,
                ...controlledProps,
                role: "tablist",
                as: "ul",
                variant: variant,
                children: (0, $1eee8657d780bdd9$export$871de8747c9eaa88)(children, $d7c68af8f1828f4e$var$renderTab)
            }),
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $0c04e2da1b8aa27e$export$2e2bcd8739ae039), {
                children: (0, $1eee8657d780bdd9$export$871de8747c9eaa88)(children, (child)=>{
                    const childProps = {
                        ...child.props
                    };
                    delete childProps.title;
                    delete childProps.disabled;
                    delete childProps.tabClassName;
                    delete childProps.tabAttrs;
                    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $1d9f27906d53a5cb$export$2e2bcd8739ae039), {
                        ...childProps
                    });
                })
            })
        ]
    });
};
$d7c68af8f1828f4e$var$Tabs.displayName = 'Tabs';
var $d7c68af8f1828f4e$export$2e2bcd8739ae039 = $d7c68af8f1828f4e$var$Tabs;









var $7DB8U = parcelRequire("7DB8U");



"use client";
const $1d55f2b3b5693b8e$var$noop = ()=>undefined;
const $1d55f2b3b5693b8e$var$ToggleButton = /*#__PURE__*/ $7DB8U.forwardRef(({ bsPrefix: bsPrefix, name: name, className: className, checked: checked, type: type, onChange: onChange, value: value, disabled: disabled, id: id, inputRef: inputRef, ...props }, ref)=>{
    bsPrefix = (0, $d36baff69136067a$export$7f387860ebffb32c)(bsPrefix, 'btn-check');
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsxs)((0, $e830bf8f8acfe41d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)("input", {
                className: bsPrefix,
                name: name,
                type: type,
                value: value,
                ref: inputRef,
                autoComplete: "off",
                checked: !!checked,
                disabled: !!disabled,
                onChange: onChange || $1d55f2b3b5693b8e$var$noop,
                id: id
            }),
            /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $e4f2607df5423ec3$export$2e2bcd8739ae039), {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, disabled && 'disabled'),
                type: undefined,
                role: undefined,
                as: "label",
                htmlFor: id
            })
        ]
    });
});
$1d55f2b3b5693b8e$var$ToggleButton.displayName = 'ToggleButton';
var $1d55f2b3b5693b8e$export$2e2bcd8739ae039 = $1d55f2b3b5693b8e$var$ToggleButton;



var $7DB8U = parcelRequire("7DB8U");







const $aa603085706342e7$var$ToggleButtonGroup = /*#__PURE__*/ $7DB8U.forwardRef((props, ref)=>{
    const { children: children, type: type = 'radio', name: name, value: value, onChange: onChange, vertical: vertical = false, ...controlledProps } = (0, $be0af947f6d59f9f$export$2e2bcd8739ae039)(props, {
        value: 'onChange'
    });
    const getValues = ()=>value == null ? [] : [].concat(value);
    const handleToggle = (inputVal, event)=>{
        if (!onChange) return;
        const values = getValues();
        const isActive = values.indexOf(inputVal) !== -1;
        if (type === 'radio') {
            if (!isActive) onChange(inputVal, event);
            return;
        }
        if (isActive) onChange(values.filter((n)=>n !== inputVal), event);
        else onChange([
            ...values,
            inputVal
        ], event);
    };
    !(type !== 'radio' || !!name) && (0, (/*@__PURE__*/$parcel$interopDefault($0e34bdc1602f642d$exports)))(false);
    return /*#__PURE__*/ (0, $e830bf8f8acfe41d$exports.jsx)((0, $dbb879efc36c7062$export$2e2bcd8739ae039), {
        ...controlledProps,
        ref: ref,
        vertical: vertical,
        children: (0, $1eee8657d780bdd9$export$871de8747c9eaa88)(children, (child)=>{
            const values = getValues();
            const { value: childVal, onChange: childOnChange } = child.props;
            const handler = (e)=>handleToggle(childVal, e);
            return /*#__PURE__*/ $7DB8U.cloneElement(child, {
                type: type,
                name: child.name || name,
                checked: values.indexOf(childVal) !== -1,
                onChange: (0, $e8368103dfe16a7d$export$2e2bcd8739ae039)(childOnChange, handler)
            });
        })
    });
});
$aa603085706342e7$var$ToggleButtonGroup.displayName = 'ToggleButtonGroup';
var $aa603085706342e7$export$2e2bcd8739ae039 = Object.assign($aa603085706342e7$var$ToggleButtonGroup, {
    Button: (0, $1d55f2b3b5693b8e$export$2e2bcd8739ae039)
});






const $fa7c601e62a95bd3$export$ccc3521a8747c592 = ({ children: children })=>(0, $e830bf8f8acfe41d$exports.jsx)($32af1264c325659e$exports.Card, {
        className: "mt-3",
        body: true,
        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $f3be3fdd0ed40ade$export$6c415d1fdae3dfdb), {
            language: "tsx",
            children: children
        })
    });
const $fa7c601e62a95bd3$export$5a24d46f71fcd15f = ({ children: children })=>(0, $e830bf8f8acfe41d$exports.jsxs)((0, $e830bf8f8acfe41d$exports.Fragment), {
        children: [
            children,
            (0, $e830bf8f8acfe41d$exports.jsx)($fa7c601e62a95bd3$export$ccc3521a8747c592, {
                children: children
            })
        ]
    });
const $fa7c601e62a95bd3$export$41199f9ac14d8c08 = ({ children: children })=>(0, $e830bf8f8acfe41d$exports.jsx)((0, $e5a57d506e25a9c5$export$965592ed152e8e7f), {
        scope: Object.assign(Object.assign({}, $32af1264c325659e$exports), $5b9516050fe8824f$exports),
        children: children
    });
const $fa7c601e62a95bd3$export$6e2c8f0811a474ce = ({ className: className = '', title: title, children: children })=>(0, $e830bf8f8acfe41d$exports.jsxs)("section", {
        className: `border bg-white mt-3 p-3 ${className}`,
        children: [
            (0, $e830bf8f8acfe41d$exports.jsx)("h2", {
                className: "h3",
                id: title,
                children: title
            }),
            children
        ]
    });


var $ef44f23880698556$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $ef44f23880698556$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $ef44f23880698556$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ef44f23880698556$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $ef44f23880698556$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ef44f23880698556$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $ef44f23880698556$export$7c6e2c02157bb7d2 = (()=>{
    var _Content_pageIndex_accessor_storage, _Content_selectValue_accessor_storage, _Content_showLoading_accessor_storage;
    let _classDecorators = [
        (0, $2c52cd3eacadeaca$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $7DB8U.Component);
    let _pageIndex_decorators;
    let _pageIndex_initializers = [];
    let _pageIndex_extraInitializers = [];
    let _selectValue_decorators;
    let _selectValue_initializers = [];
    let _selectValue_extraInitializers = [];
    let _showLoading_decorators;
    let _showLoading_initializers = [];
    let _showLoading_extraInitializers = [];
    var Content = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _Content_pageIndex_accessor_storage.set(this, $ef44f23880698556$var$__runInitializers(this, _pageIndex_initializers, 1));
            _Content_selectValue_accessor_storage.set(this, ($ef44f23880698556$var$__runInitializers(this, _pageIndex_extraInitializers), $ef44f23880698556$var$__runInitializers(this, _selectValue_initializers, '0')));
            _Content_showLoading_accessor_storage.set(this, ($ef44f23880698556$var$__runInitializers(this, _selectValue_extraInitializers), $ef44f23880698556$var$__runInitializers(this, _showLoading_initializers, false)));
            Object.defineProperty(this, "toast", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($ef44f23880698556$var$__runInitializers(this, _showLoading_extraInitializers), new (0, $ad55f28c37e4135a$export$8d8dc7d5f743331b)())
            });
            Object.defineProperty(this, "inputDialog", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new (0, $5f36cffaa267c314$export$3ddf2d174ce01153)(({ defer: defer })=>(0, $e830bf8f8acfe41d$exports.jsxs)((0, $e8d7441a43b85bf3$export$2e2bcd8739ae039), {
                        show: !!defer,
                        onHide: ()=>defer === null || defer === void 0 ? void 0 : defer.reject(new (0, $5f36cffaa267c314$export$fba2fb7cd781b7ac)()),
                        children: [
                            (0, $e830bf8f8acfe41d$exports.jsx)((0, $e8d7441a43b85bf3$export$2e2bcd8739ae039).Header, {
                                children: "Dialog"
                            }),
                            (0, $e830bf8f8acfe41d$exports.jsx)((0, $e8d7441a43b85bf3$export$2e2bcd8739ae039).Body, {
                                children: (0, $e830bf8f8acfe41d$exports.jsxs)((0, $3a20a8d9839af258$export$2e2bcd8739ae039), {
                                    id: "input-dialog",
                                    onSubmit: (event)=>{
                                        event.preventDefault();
                                        defer === null || defer === void 0 || defer.resolve((0, $1ec569b22aebf9e3$export$86d7c59254d6a2c9)(event.currentTarget));
                                    },
                                    onReset: ()=>defer === null || defer === void 0 ? void 0 : defer.reject(new (0, $5f36cffaa267c314$export$fba2fb7cd781b7ac)()),
                                    children: [
                                        (0, $e830bf8f8acfe41d$exports.jsxs)((0, $3a20a8d9839af258$export$2e2bcd8739ae039).Group, {
                                            children: [
                                                (0, $e830bf8f8acfe41d$exports.jsx)((0, $3a20a8d9839af258$export$2e2bcd8739ae039).Label, {
                                                    children: "A"
                                                }),
                                                (0, $e830bf8f8acfe41d$exports.jsx)((0, $3a20a8d9839af258$export$2e2bcd8739ae039).Control, {
                                                    type: "number",
                                                    name: "a"
                                                })
                                            ]
                                        }),
                                        (0, $e830bf8f8acfe41d$exports.jsxs)((0, $3a20a8d9839af258$export$2e2bcd8739ae039).Group, {
                                            children: [
                                                (0, $e830bf8f8acfe41d$exports.jsx)((0, $3a20a8d9839af258$export$2e2bcd8739ae039).Label, {
                                                    children: "B"
                                                }),
                                                (0, $e830bf8f8acfe41d$exports.jsx)((0, $3a20a8d9839af258$export$2e2bcd8739ae039).Control, {
                                                    type: "number",
                                                    name: "b"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            (0, $e830bf8f8acfe41d$exports.jsxs)((0, $e8d7441a43b85bf3$export$2e2bcd8739ae039).Footer, {
                                className: "d-flex justify-content-end gap-3",
                                children: [
                                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $e4f2607df5423ec3$export$2e2bcd8739ae039), {
                                        form: "input-dialog",
                                        type: "submit",
                                        children: "\u221A"
                                    }),
                                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $e4f2607df5423ec3$export$2e2bcd8739ae039), {
                                        form: "input-dialog",
                                        type: "reset",
                                        variant: "danger",
                                        children: "\u00D7"
                                    })
                                ]
                            })
                        ]
                    }))
            });
            Object.defineProperty(this, "someLogic", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>$ef44f23880698556$var$__awaiter(this, void 0, void 0, function*() {
                        try {
                            const data = yield this.inputDialog.open();
                            alert(JSON.stringify(data, null, 4));
                        } catch (error) {
                            if (error instanceof (0, $5f36cffaa267c314$export$fba2fb7cd781b7ac)) console.warn(error.message);
                        }
                    })
            });
        }
        get pageIndex() {
            return $ef44f23880698556$var$__classPrivateFieldGet(this, _Content_pageIndex_accessor_storage, "f");
        }
        set pageIndex(value) {
            $ef44f23880698556$var$__classPrivateFieldSet(this, _Content_pageIndex_accessor_storage, value, "f");
        }
        get selectValue() {
            return $ef44f23880698556$var$__classPrivateFieldGet(this, _Content_selectValue_accessor_storage, "f");
        }
        set selectValue(value) {
            $ef44f23880698556$var$__classPrivateFieldSet(this, _Content_selectValue_accessor_storage, value, "f");
        }
        get showLoading() {
            return $ef44f23880698556$var$__classPrivateFieldGet(this, _Content_showLoading_accessor_storage, "f");
        }
        set showLoading(value) {
            $ef44f23880698556$var$__classPrivateFieldSet(this, _Content_showLoading_accessor_storage, value, "f");
        }
        render() {
            const { selectValue: selectValue, showLoading: showLoading } = this;
            return (0, $e830bf8f8acfe41d$exports.jsxs)((0, $e830bf8f8acfe41d$exports.Fragment), {
                children: [
                    (0, $e830bf8f8acfe41d$exports.jsx)("h1", {
                        id: "top",
                        children: "Idea React components"
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "TypeEcho",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $e7d3cd5a5ac19af3$export$2fe61c915a9818e6), {
                                text: "Hello, Idea React!"
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Text Truncate",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $9933903675cc8cbf$export$ee6221c372f955f), {
                                rows: 2,
                                children: "Idea React is a React advanced components library based on TypeScript & Bootstrap, built by idea2app remote developers team. It provides a set of reusable, well-designed components that help developers build modern Web applications quickly and efficiently. The library includes components for common UI patterns such as dialogs, forms, navigation, and more."
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Horizontal Marquee",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $cfdbb1e29b9af572$export$4eb895ecfe5a67d5), {
                                children: 'idea2app '.repeat(15).trim()
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Vertical Marquee",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $104fe1d69b5cc790$export$125576d08e40b98f), {
                                style: {
                                    height: '10rem'
                                },
                                children: (0, $e830bf8f8acfe41d$exports.jsx)("img", {
                                    src: "https://tech-query.me/medias/featureimages/22.jpg"
                                })
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Time",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $e27c07fe54f21598$export$680ea196effce5f), {
                                dateTime: "2022-11-27",
                                format: "YYYY \u5E74 MM \u6708 DD \u65E5 HH:mm"
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Time Distance",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fd4fe5cf447dc272$export$db3f63f9e19e5969), {
                                date: "1989-06-04"
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Countdown",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $6dcd5678f67c6b02$export$53819c0e58f98d49), {
                                className: "d-flex gap-3",
                                units: [
                                    {
                                        scale: 24,
                                        label: "\u5929"
                                    },
                                    {
                                        scale: 60,
                                        label: "\u65F6"
                                    },
                                    {
                                        scale: 60,
                                        label: "\u5206"
                                    },
                                    {
                                        scale: 1000,
                                        label: "\u79D2"
                                    }
                                ],
                                endTime: Date.now() + 3 * (0, $1ec569b22aebf9e3$export$7a9a31a911eb9a20)
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Timeline",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                                style: {
                                    background: 'linear-gradient(to right, rgba(235, 187, 167, 1), rgba(207, 199, 248, 1))'
                                },
                                children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $159e4f94d50f7644$export$e6a97ba2cae5bb94), {
                                    events: [
                                        {
                                            title: 'Discover',
                                            time: [
                                                '2019-12-01'
                                            ]
                                        },
                                        {
                                            title: 'Deny',
                                            time: [
                                                '2020-01-02'
                                            ]
                                        },
                                        {
                                            title: 'Lock down',
                                            time: [
                                                '2020-01-23'
                                            ]
                                        },
                                        {
                                            title: 'Open',
                                            time: [
                                                '2022-12-01'
                                            ]
                                        }
                                    ],
                                    timeFormat: "YYYY-MM-DD"
                                })
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Icon",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $a9e058be8650f0e1$export$f04a61298a47a40f), {
                                name: "trash",
                                size: 2,
                                className: "text-danger"
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Avatar",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $bbe3314f1df38781$export$e2255cf6045e8d47), {
                                src: "https://github.com/idea2app.png"
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Nameplate",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $49a38e2a3ce732bb$export$caa4d5435e8fb601), {
                                name: "idea2app",
                                avatar: "https://github.com/idea2app.png"
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Spinner Button",
                        children: (0, $e830bf8f8acfe41d$exports.jsxs)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: [
                                (0, $e830bf8f8acfe41d$exports.jsx)((0, $51c976be9e7826ec$export$4cfabf47f4311ebb), {
                                    className: "me-3",
                                    animation: "border",
                                    loading: true
                                }),
                                (0, $e830bf8f8acfe41d$exports.jsx)((0, $51c976be9e7826ec$export$4cfabf47f4311ebb), {
                                    animation: "grow",
                                    type: "submit",
                                    loading: true,
                                    children: "Submit"
                                })
                            ]
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Select",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                            children: (0, $e830bf8f8acfe41d$exports.jsxs)((0, $7a4511f8af51cbbb$export$ef9b1a59e592288f), {
                                value: selectValue,
                                onChange: (value)=>this.selectValue = value,
                                children: [
                                    (0, $e830bf8f8acfe41d$exports.jsxs)((0, $7a4511f8af51cbbb$export$36d18380658d5d20), {
                                        value: "0",
                                        children: [
                                            (0, $e830bf8f8acfe41d$exports.jsx)((0, $a9e058be8650f0e1$export$f04a61298a47a40f), {
                                                className: "me-2",
                                                name: "heart"
                                            }),
                                            "idea2app"
                                        ]
                                    }),
                                    (0, $e830bf8f8acfe41d$exports.jsxs)((0, $7a4511f8af51cbbb$export$36d18380658d5d20), {
                                        value: "1",
                                        children: [
                                            (0, $e830bf8f8acfe41d$exports.jsx)((0, $a9e058be8650f0e1$export$f04a61298a47a40f), {
                                                className: "me-2",
                                                name: "bootstrap"
                                            }),
                                            "freeCodeCamp"
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Month Calendar",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $e3aad0f6e5ad05e1$export$d7a7c85c0f5afc4a), {
                                value: [
                                    {
                                        date: new Date(),
                                        content: 'Hello!'
                                    }
                                ],
                                onSelect: console.log,
                                onChange: console.log
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "IdeaDialog",
                        children: (0, $e830bf8f8acfe41d$exports.jsxs)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                            children: [
                                (0, $e830bf8f8acfe41d$exports.jsx)((0, $e4f2607df5423ec3$export$2e2bcd8739ae039), {
                                    onClick: this.someLogic,
                                    children: "\u663E\u793A\u5F39\u7A97"
                                }),
                                (0, $e830bf8f8acfe41d$exports.jsx)(this.inputDialog.Component, {})
                            ]
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsxs)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Toast",
                        children: [
                            (0, $e830bf8f8acfe41d$exports.jsx)((0, $e4f2607df5423ec3$export$2e2bcd8739ae039), {
                                onClick: ()=>this.toast.open({
                                        body: 'Hello, Idea React!',
                                        variant: 'success',
                                        delay: 0
                                    }).then(({ id: id })=>console.log(`Toast ${id} closed`)),
                                children: "\u663E\u793A Toast"
                            }),
                            (0, $e830bf8f8acfe41d$exports.jsx)(this.toast.Component, {})
                        ]
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Share Box",
                        children: (0, $e830bf8f8acfe41d$exports.jsxs)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: [
                                (0, $e830bf8f8acfe41d$exports.jsx)((0, $b68896d3a4d7fbf1$export$e15a265ebbd5ca8c), {
                                    title: "idea2app",
                                    text: "Every idea of yours is worth our efforts to realize",
                                    url: "https://idea2app.cn",
                                    children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $49a38e2a3ce732bb$export$caa4d5435e8fb601), {
                                        name: "idea2app",
                                        avatar: "https://github.com/idea2app.png"
                                    })
                                }),
                                "click to share"
                            ]
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Overlay Box",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $0053152b16d9815b$export$5169ff31790bf260), {
                                trigger: "click",
                                title: "view info",
                                detail: (0, $e830bf8f8acfe41d$exports.jsx)((0, $facf438de9c933e7$export$2e2bcd8739ae039), {
                                    src: "https://github.com/idea2app.png"
                                }),
                                children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $e4f2607df5423ec3$export$2e2bcd8739ae039), {
                                    children: "\u67E5\u770B"
                                })
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Scroll Nav",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                            children: (0, $e830bf8f8acfe41d$exports.jsxs)((0, $839f5d21a5a9dff5$export$c57977d1ebb6ef1d), {
                                variant: "underline",
                                children: [
                                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039).Link, {
                                        href: "#",
                                        active: true,
                                        children: "Dashboard"
                                    }),
                                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039).Link, {
                                        href: "#",
                                        children: "Friends"
                                    }),
                                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039).Link, {
                                        href: "#",
                                        children: "Explore"
                                    }),
                                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039).Link, {
                                        href: "#",
                                        children: "Suggestions"
                                    }),
                                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039).Link, {
                                        href: "#",
                                        children: "Messages"
                                    }),
                                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039).Link, {
                                        href: "#",
                                        children: "Notifications"
                                    }),
                                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039).Link, {
                                        href: "#",
                                        children: "Profile"
                                    }),
                                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039).Link, {
                                        href: "#",
                                        children: "Settings"
                                    }),
                                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039).Link, {
                                        href: "#",
                                        children: "Help"
                                    }),
                                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $a036a87711fc9297$export$2e2bcd8739ae039).Link, {
                                        href: "#",
                                        children: "Logout"
                                    })
                                ]
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Page Nav",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$ccc3521a8747c592), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $7f4b319848d3c701$export$f24150b9675a2c65), {})
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Loading",
                        children: (0, $e830bf8f8acfe41d$exports.jsxs)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                            children: [
                                (0, $e830bf8f8acfe41d$exports.jsx)((0, $e4f2607df5423ec3$export$2e2bcd8739ae039), {
                                    style: {
                                        zIndex: '1040'
                                    },
                                    onClick: ()=>$ef44f23880698556$var$__awaiter(this, void 0, void 0, function*() {
                                            this.showLoading = true;
                                            yield (0, $1ec569b22aebf9e3$export$e772c8ff12451969)(1);
                                            this.showLoading = false;
                                        }),
                                    children: "\u663E\u793A"
                                }),
                                showLoading && (0, $e830bf8f8acfe41d$exports.jsx)((0, $819e3941170a1790$export$669f6ea7d267feaf), {
                                    children: "\u52A0\u8F7D\u4E2D..."
                                })
                            ]
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "User Rank",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$41199f9ac14d8c08), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $39fc78bea9266790$export$4ed039229ec81818), {
                                title: "GitHub",
                                rank: [
                                    'Five-great',
                                    'TechQuery',
                                    'stevending1st',
                                    'wangrunlin'
                                ].map((name, index)=>({
                                        id: index + 1,
                                        name: name,
                                        avatar: `https://github.com/${name}.png`,
                                        website: `https://github.com/${name}`,
                                        score: 100 - index
                                    })),
                                linkOf: ({ id: id })=>`/user/${id}`
                            })
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$6e2c8f0811a474ce), {
                        title: "Zodiac Bar",
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $fa7c601e62a95bd3$export$5a24d46f71fcd15f), {
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $30c60bd3cdeb9d66$export$de26cde43ba4c348), {
                                startYear: 2020,
                                endYear: 2022,
                                itemOf: (title)=>({
                                        title: title
                                    })
                            })
                        })
                    })
                ]
            });
        }
    };
    _Content_pageIndex_accessor_storage = new WeakMap();
    _Content_selectValue_accessor_storage = new WeakMap();
    _Content_showLoading_accessor_storage = new WeakMap();
    $ef44f23880698556$var$__setFunctionName(_classThis, "Content");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _pageIndex_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        _selectValue_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        _showLoading_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        $ef44f23880698556$var$__esDecorate(_classThis, null, _pageIndex_decorators, {
            kind: "accessor",
            name: "pageIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageIndex" in obj,
                get: (obj)=>obj.pageIndex,
                set: (obj, value)=>{
                    obj.pageIndex = value;
                }
            },
            metadata: _metadata
        }, _pageIndex_initializers, _pageIndex_extraInitializers);
        $ef44f23880698556$var$__esDecorate(_classThis, null, _selectValue_decorators, {
            kind: "accessor",
            name: "selectValue",
            static: false,
            private: false,
            access: {
                has: (obj)=>"selectValue" in obj,
                get: (obj)=>obj.selectValue,
                set: (obj, value)=>{
                    obj.selectValue = value;
                }
            },
            metadata: _metadata
        }, _selectValue_initializers, _selectValue_extraInitializers);
        $ef44f23880698556$var$__esDecorate(_classThis, null, _showLoading_decorators, {
            kind: "accessor",
            name: "showLoading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"showLoading" in obj,
                get: (obj)=>obj.showLoading,
                set: (obj, value)=>{
                    obj.showLoading = value;
                }
            },
            metadata: _metadata
        }, _showLoading_initializers, _showLoading_extraInitializers);
        $ef44f23880698556$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Content = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $ef44f23880698556$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Content = _classThis;
})();


var $23547c5d26526fed$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $23547c5d26526fed$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $23547c5d26526fed$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $23547c5d26526fed$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $23547c5d26526fed$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
(0, $fecbc4a33bb0f224$export$8d21e34596265fa2)({
    enforceActions: 'never'
});
let $23547c5d26526fed$export$86fbec116b87613f = (()=>{
    var _App_screenPortrait_accessor_storage, _App_menuOpen_accessor_storage;
    let _classDecorators = [
        (0, $2c52cd3eacadeaca$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $7DB8U.Component);
    let _screenPortrait_decorators;
    let _screenPortrait_initializers = [];
    let _screenPortrait_extraInitializers = [];
    let _menuOpen_decorators;
    let _menuOpen_initializers = [];
    let _menuOpen_extraInitializers = [];
    var App = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _App_screenPortrait_accessor_storage.set(this, $23547c5d26526fed$var$__runInitializers(this, _screenPortrait_initializers, false));
            _App_menuOpen_accessor_storage.set(this, ($23547c5d26526fed$var$__runInitializers(this, _screenPortrait_extraInitializers), $23547c5d26526fed$var$__runInitializers(this, _menuOpen_initializers, false)));
            Object.defineProperty(this, "updateMeta", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($23547c5d26526fed$var$__runInitializers(this, _menuOpen_extraInitializers), ()=>this.screenPortrait = window.innerWidth < 768)
            });
        }
        componentDidMount() {
            this.updateMeta();
            window.addEventListener('resize', this.updateMeta);
        }
        get screenPortrait() {
            return $23547c5d26526fed$var$__classPrivateFieldGet(this, _App_screenPortrait_accessor_storage, "f");
        }
        set screenPortrait(value) {
            $23547c5d26526fed$var$__classPrivateFieldSet(this, _App_screenPortrait_accessor_storage, value, "f");
        }
        get menuOpen() {
            return $23547c5d26526fed$var$__classPrivateFieldGet(this, _App_menuOpen_accessor_storage, "f");
        }
        set menuOpen(value) {
            $23547c5d26526fed$var$__classPrivateFieldSet(this, _App_menuOpen_accessor_storage, value, "f");
        }
        renderMenu() {
            const { screenPortrait: screenPortrait, menuOpen: menuOpen } = this;
            return (0, $e830bf8f8acfe41d$exports.jsxs)((0, $e830bf8f8acfe41d$exports.Fragment), {
                children: [
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $e4f2607df5423ec3$export$2e2bcd8739ae039), {
                        className: "my-3 d-md-none",
                        onClick: ()=>this.menuOpen = !menuOpen,
                        children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $a9e058be8650f0e1$export$f04a61298a47a40f), {
                            name: "list"
                        })
                    }),
                    (0, $e830bf8f8acfe41d$exports.jsx)((0, $7476d4e4f4ba1c12$export$2e2bcd8739ae039), {
                        in: screenPortrait ? menuOpen : true,
                        children: (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                            className: "sticky-top",
                            children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $7f4b319848d3c701$export$f24150b9675a2c65), {
                                onClick: ()=>screenPortrait && (this.menuOpen = false)
                            })
                        })
                    })
                ]
            });
        }
        render() {
            return (0, $e830bf8f8acfe41d$exports.jsx)("div", {
                className: "bg-light",
                children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $6d27f416cee9d181$export$2e2bcd8739ae039), {
                    className: "pb-3 py-md-5",
                    fluid: "md",
                    children: (0, $e830bf8f8acfe41d$exports.jsxs)((0, $e2e7a3888803d0e1$export$2e2bcd8739ae039), {
                        children: [
                            (0, $e830bf8f8acfe41d$exports.jsx)((0, $51362f0aeeaa849e$export$2e2bcd8739ae039), {
                                xs: 12,
                                md: 3,
                                className: "sticky-top bg-light",
                                children: this.renderMenu()
                            }),
                            (0, $e830bf8f8acfe41d$exports.jsx)((0, $51362f0aeeaa849e$export$2e2bcd8739ae039), {
                                xs: 12,
                                md: 9,
                                children: (0, $e830bf8f8acfe41d$exports.jsx)((0, $ef44f23880698556$export$7c6e2c02157bb7d2), {})
                            })
                        ]
                    })
                })
            });
        }
    };
    _App_screenPortrait_accessor_storage = new WeakMap();
    _App_menuOpen_accessor_storage = new WeakMap();
    $23547c5d26526fed$var$__setFunctionName(_classThis, "App");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _screenPortrait_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        _menuOpen_decorators = [
            (0, $fecbc4a33bb0f224$export$5ab46cbf6120b33a)
        ];
        $23547c5d26526fed$var$__esDecorate(_classThis, null, _screenPortrait_decorators, {
            kind: "accessor",
            name: "screenPortrait",
            static: false,
            private: false,
            access: {
                has: (obj)=>"screenPortrait" in obj,
                get: (obj)=>obj.screenPortrait,
                set: (obj, value)=>{
                    obj.screenPortrait = value;
                }
            },
            metadata: _metadata
        }, _screenPortrait_initializers, _screenPortrait_extraInitializers);
        $23547c5d26526fed$var$__esDecorate(_classThis, null, _menuOpen_decorators, {
            kind: "accessor",
            name: "menuOpen",
            static: false,
            private: false,
            access: {
                has: (obj)=>"menuOpen" in obj,
                get: (obj)=>obj.menuOpen,
                set: (obj, value)=>{
                    obj.menuOpen = value;
                }
            },
            metadata: _metadata
        }, _menuOpen_initializers, _menuOpen_extraInitializers);
        $23547c5d26526fed$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        App = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $23547c5d26526fed$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return App = _classThis;
})();
(0, $1be8aacc786f9a64$exports.createRoot)(document.querySelector('#app')).render((0, $e830bf8f8acfe41d$exports.jsx)($23547c5d26526fed$export$86fbec116b87613f, {}));


//# sourceMappingURL=preview.aeae2f7d.js.map
